import { c as e } from "react/compiler-runtime";
import t, { Fragment as n, createContext as r, useCallback as i, useContext as a, useEffect as o, useId as s, useLayoutEffect as c, useMemo as l, useRef as u, useState as d } from "react";
import f from "clsx";
import { Fragment as p, jsx as m, jsxs as h } from "react/jsx-runtime";
import { PartnershipDetailsPartnershipLevel as g } from "@urbanx/agx.rex.client";
import _ from "react-modal";
import { useGetAgentsInAgency as v, useGetAllAgencies as y, useGetAllUsersInformation as b } from "@urbanx/agx.agencies.client";
import x from "react-dom";
import { v4 as S } from "uuid";
import { AuthContext as C } from "@urbanx/agx.auth.client";
import { AddNoteRequestCatalogueType as w, DeleteNoteRequestCatalogueType as T, StaffNoteModelCatalogueType as E, ToggleNotePinRequestCatalogueType as D, useInvalidateUseStaffGetNotes as O, useStaffAddNote as k, useStaffDeleteNote as A, useStaffGetNotes as j, useStaffToggleNotePin as M } from "@urbanx/agx.staff.client";
import { isEmpty as N, isEqual as P } from "lodash-es";
import { downloadZip as F } from "client-zip";
import { BuiltOnOrVacantLandType as I, CampaignSearchResultStage as L, CommissionDetailsChangeInfoChangeType as R, Condition as z, ContractDatesConditionConfigContractDateType as B, DayType as V, DepositPayable as H, EditScope as U, EditScope as W, EmploymentStatus as G, ExternalConjunctionConjunctionFeeType as K, FlatCommissionType as q, IdentityVerificationDocumentSighted as J, LandAreaType as Y, LaunchDateDetailsStatus as X, PlaceOfIssue as Z, ReasonForTransaction as ee, RenderedSpecialConditionConditionType as te, RuralType as ne, ServiceFeeDetailsChangeInfoChangeType as re, SpecialConditionDataConditionType as ie, StakeholderType as ae, StakeholderType as oe, TieredSystemType as se, ValueType as ce, VendorBuyerType as le, VendorBuyerTypes as ue, VerificationMethod as de, useConstructConditionClauseText as fe, useGetSpecialConditionBank as pe, useStaffSearchForCampaign as me } from "@urbanx/agx.campaigns.client";
import { DotLottieReact as he } from "@lottiefiles/dotlottie-react";
//#region \0rolldown/runtime.js
var ge = Object.create, _e = Object.defineProperty, ve = Object.getOwnPropertyDescriptor, ye = Object.getOwnPropertyNames, be = Object.getPrototypeOf, xe = Object.prototype.hasOwnProperty, Se = (e, t) => () => (e && (t = e(e = 0)), t), Ce = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), we = (e, t) => {
	let n = {};
	for (var r in e) _e(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || _e(n, Symbol.toStringTag, { value: "Module" }), n;
}, Te = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = ye(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !xe.call(e, s) && s !== n && _e(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = ve(t, s)) || r.enumerable
	});
	return e;
}, Ee = (e, t, n) => (n = e == null ? {} : ge(be(e)), Te(t || !e || !e.__esModule ? _e(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), De = [
	"3xs",
	"2xs",
	"xs",
	"sm",
	"md",
	"lg",
	"xl",
	"2xl",
	"3xl",
	"4xl",
	"5xl",
	"6xl",
	"7xl"
], Oe = [
	"spacing-xxs",
	"spacing-xs",
	"spacing-sm",
	"spacing-md",
	"spacing-ml",
	"spacing-lg",
	"spacing-xl",
	"spacing-2xl",
	"spacing-3xl",
	"spacing-4xl",
	"spacing-5xl",
	"spacing-6xl",
	"spacing-7xl",
	"spacing-8xl",
	"spacing-9xl",
	"spacing-10xl",
	"spacing-11xl"
], ke = (e) => {
	if (!e) return [];
	let t, n, r, i;
	typeof e == "string" ? (De.includes(e) && (t = n = r = i = e), Oe.includes(e) && (t = n = r = i = e)) : (t = e.top, n = e.bottom, r = e.left, i = e.right);
	let a = [];
	return t && a.push(`paddingTop-${t}`), n && a.push(`paddingBottom-${n}`), r && a.push(`paddingLeft-${r}`), i && a.push(`paddingRight-${i}`), a;
}, Ae = (e) => e ? [`gap-${e}`] : [], je = (e, t) => {
	if (!e && !t) return [];
	let n = ke(e), r = Ae(t);
	return [...n, ...r];
}, Me = (t) => {
	let n = e(16), { children: r, id: i, datatestId: a, gap: o, padding: s, alignItems: c, justifyContent: l, fill: u, scrollable: d, onClick: p, flexShrink: h } = t, g = c === void 0 ? "flex-start" : c, _ = u === void 0 ? !1 : u, v = d === void 0 ? !1 : d, y = p === void 0 ? void 0 : p, b = h === void 0 ? 1 : h, x;
	if (n[0] !== g || n[1] !== _ || n[2] !== o || n[3] !== l || n[4] !== s || n[5] !== v) {
		let e = je(s);
		x = f("column", `gap-${o}`, ...e, g, l, _ && "fill", v && "scrollable"), n[0] = g, n[1] = _, n[2] = o, n[3] = l, n[4] = s, n[5] = v, n[6] = x;
	} else x = n[6];
	let S = x, C;
	n[7] === b ? C = n[8] : (C = { flexShrink: b }, n[7] = b, n[8] = C);
	let w;
	return n[9] !== r || n[10] !== S || n[11] !== a || n[12] !== i || n[13] !== y || n[14] !== C ? (w = /* @__PURE__ */ m("div", {
		id: i,
		"data-version": "v2",
		className: S,
		onClick: y,
		"data-testid": a,
		style: C,
		children: r
	}), n[9] = r, n[10] = S, n[11] = a, n[12] = i, n[13] = y, n[14] = C, n[15] = w) : w = n[15], w;
}, Ne = (t) => {
	let n = e(17), { id: r, datatestId: i, children: a, gap: o, padding: s, fill: c, wrap: l, scrollable: u, justifyContent: d, alignItems: p, onClick: h, flexShrink: g } = t, _ = i === void 0 ? r : i, v = c === void 0 ? !1 : c, y = l === void 0 ? !1 : l, b = u === void 0 ? !1 : u, x = d === void 0 ? "left" : d, S = p === void 0 ? "flex-start" : p, C = h === void 0 ? void 0 : h, w = g === void 0 ? 1 : g, T;
	if (n[0] !== S || n[1] !== v || n[2] !== o || n[3] !== x || n[4] !== s || n[5] !== b || n[6] !== y) {
		let e = je(s);
		T = f("row", `gap-${o}`, ...e, x, S, v && "fill", y && "wrap", b && "scrollable"), n[0] = S, n[1] = v, n[2] = o, n[3] = x, n[4] = s, n[5] = b, n[6] = y, n[7] = T;
	} else T = n[7];
	let E = T, D;
	n[8] === w ? D = n[9] : (D = { flexShrink: w }, n[8] = w, n[9] = D);
	let O;
	return n[10] !== a || n[11] !== E || n[12] !== _ || n[13] !== r || n[14] !== C || n[15] !== D ? (O = /* @__PURE__ */ m("div", {
		id: r,
		"data-version": "v2",
		className: E,
		onClick: C,
		"data-testid": _,
		style: D,
		children: a
	}), n[10] = a, n[11] = E, n[12] = _, n[13] = r, n[14] = C, n[15] = D, n[16] = O) : O = n[16], O;
}, Pe = {
	display: "h1",
	heading: "h2",
	title: "h3",
	body: "span",
	body_ui: "span",
	body_ui_strong: "span",
	hyperlink: "span",
	caption: "span",
	tag: "span",
	label: "label",
	form_error: "span"
};
function Q(e) {
	let { id: n, type: r, dataTestId: i, size: a, children: o, color: s = r === "form_error" ? void 0 : "var(--text-primary)", opacityPercent: c, strikethrough: l, overflowEllipsis: u, flexShrink: d, noWrap: p, ...m } = e, h = Pe[r], g = f(a), _ = {
		...c ? { opacity: `${c}%` } : {},
		...s ? { color: s } : {},
		...l ? { textDecoration: "line-through" } : {},
		...d === void 0 ? {} : { flexShrink: d },
		...p ? { whiteSpace: "nowrap" } : {},
		...u ? {
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis",
			minWidth: 0,
			maxWidth: "100%"
		} : {}
	};
	return t.createElement(h, {
		id: n,
		"data-version": "v2",
		"data-type": r,
		"data-testid": i ?? n,
		className: g,
		style: _,
		...m
	}, o);
}
//#endregion
//#region src/utils/clamp.ts
var Fe = (e, t, n) => Math.min(Math.max(e, t), n), Ie = (t) => {
	let n = e(4), { percentage: r, colour: i, type: a } = t, o;
	return n[0] !== i || n[1] !== r || n[2] !== a ? (o = /* @__PURE__ */ h(Q, {
		type: a,
		size: "medium",
		id: "progress-indicator-number",
		color: i,
		children: [r, "%"]
	}), n[0] = i, n[1] = r, n[2] = a, n[3] = o) : o = n[3], o;
}, Le = (e, t) => t === "dark" ? e ? "var(--fg-white)" : "var(--text-primary)" : t === "light" ? e ? "var(--text-brand-accent)" : "var(--text-white)" : "", Re = (t) => {
	let n = e(35), { id: r, progress: i, mode: a, variant: o, percentageProgressPosition: s } = t, c;
	n[0] !== a || n[1] !== o ? (c = f("progressBar", a, o), n[0] = a, n[1] = o, n[2] = c) : c = n[2];
	let l = c, u = Fe(i, 0, 100), d = u >= 25, p;
	n[3] !== d || n[4] !== a ? (p = Le(d, a), n[3] = d, n[4] = a, n[5] = p) : p = n[5];
	let g = p, _ = s ? `indicator-${s}` : void 0, v;
	n[6] === _ ? v = n[7] : (v = f("progressBarContainer", _), n[6] = _, n[7] = v);
	let y = `${u}%`, b;
	n[8] === y ? b = n[9] : (b = { width: y }, n[8] = y, n[9] = b);
	let x;
	n[10] !== u || n[11] !== g || n[12] !== d || n[13] !== o ? (x = o === "thick" && d && /* @__PURE__ */ m(Ie, {
		percentage: u,
		colour: g,
		type: "body_ui_strong"
	}), n[10] = u, n[11] = g, n[12] = d, n[13] = o, n[14] = x) : x = n[14];
	let S;
	n[15] !== b || n[16] !== x ? (S = /* @__PURE__ */ m("div", {
		className: "progressIndicator",
		style: b,
		children: x
	}), n[15] = b, n[16] = x, n[17] = S) : S = n[17];
	let C;
	n[18] !== u || n[19] !== g || n[20] !== d || n[21] !== o ? (C = o === "thick" && !d && /* @__PURE__ */ m(Ie, {
		type: "body_ui_strong",
		percentage: u,
		colour: g
	}), n[18] = u, n[19] = g, n[20] = d, n[21] = o, n[22] = C) : C = n[22];
	let w;
	n[23] !== l || n[24] !== r || n[25] !== S || n[26] !== C ? (w = /* @__PURE__ */ h("div", {
		id: r,
		"data-testid": r,
		className: l,
		children: [S, C]
	}), n[23] = l, n[24] = r, n[25] = S, n[26] = C, n[27] = w) : w = n[27];
	let T;
	n[28] !== u || n[29] !== o ? (T = o === "slim" && /* @__PURE__ */ m(Ie, {
		percentage: u,
		colour: "var(--text-secondary)",
		type: "caption"
	}), n[28] = u, n[29] = o, n[30] = T) : T = n[30];
	let E;
	return n[31] !== v || n[32] !== w || n[33] !== T ? (E = /* @__PURE__ */ h("div", {
		className: v,
		children: [w, T]
	}), n[31] = v, n[32] = w, n[33] = T, n[34] = E) : E = n[34], E;
}, ze = /* @__PURE__ */ we({ default: () => Be }), Be, Ve = Se((() => {
	Be = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M33.7125 26.2342C33.7125 30.1492 32.3709 32.8997 30.2166 34.1804L25.6724 36.8856C27.8324 35.6049 29.1663 32.8524 29.1663 28.9375C29.1663 21.1095 23.8228 11.599 17.2278 7.67817C13.9313 5.71578 10.9414 5.53057 8.78333 6.81322L13.3314 4.11591C15.4933 2.83326 18.4775 3.0165 21.7721 4.96707C28.3671 8.88792 33.7125 18.4063 33.7125 26.2342Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.1663 28.9315C29.1663 32.8465 27.8247 35.597 25.6705 36.8777C25.3341 37.0773 24.979 37.2416 24.6106 37.3683C23.4483 34.756 21.7412 32.4387 19.6102 30.5807V28.7404C20.6586 28.5828 21.4137 27.7553 21.6475 26.3978C22.4142 26.8253 23.0428 26.4372 23.0428 25.5092C23.0157 25.0033 22.8757 24.5106 22.6338 24.0692C22.3918 23.6278 22.0544 23.2495 21.6475 22.9636C21.6017 22.6363 21.5377 22.312 21.4559 21.9922C22.2934 22.1124 22.9546 21.5844 22.9546 20.3175C22.9546 18.2191 21.0553 15.7859 19.5297 15.8725L16.6318 14.1466C14.4871 12.8738 12.5245 13.79 12.5514 16.3513L12.5648 17.5768C12.4943 17.5224 12.4207 17.4724 12.3444 17.4271C11.5471 16.9503 10.8973 17.3365 10.8973 18.2861C10.9236 18.8032 11.0684 19.3065 11.3198 19.755C11.5713 20.2036 11.9224 20.5847 12.3444 20.8672C12.4811 20.9521 12.6308 21.0127 12.7871 21.0465C13.0658 22.8165 13.7744 24.4857 14.8475 25.8993V27.7376C12.7622 27.0618 11.0488 27.3612 9.84897 28.6025C7.06991 24.3625 5.28748 19.2792 5.28748 14.7574C5.28748 10.8444 6.62909 8.09587 8.78334 6.81321C10.9376 5.53056 13.9313 5.71577 17.2279 7.67226C23.8229 11.5852 29.1663 21.1036 29.1663 28.9315Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.6106 37.3683C22.5771 38.0677 20.0146 37.6737 17.2279 36.0186C14.4411 34.3636 11.8767 31.7096 9.84705 28.6104C11.0468 27.3691 12.7603 27.0696 14.8455 27.7454V27.7711C14.8455 29.9088 19.6102 32.348 19.6102 30.6004V30.5807C21.7412 32.4387 23.4483 34.756 24.6106 37.3683Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M21.6476 22.9537C22.0544 23.2397 22.3919 23.618 22.6338 24.0594C22.8758 24.5008 23.0157 24.9935 23.0429 25.4993C23.0429 26.4273 22.4219 26.8155 21.6476 26.3879C21.6982 26.0813 21.7232 25.7709 21.7223 25.4599V23.9704C21.7208 23.6301 21.6959 23.2904 21.6476 22.9537Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.9489 20.3076C22.9489 21.5745 22.2877 22.1025 21.4502 21.9823C20.5705 21.8523 19.4991 20.9972 18.8053 19.5333C17.686 20.0318 16.0032 19.0112 14.905 17.1591C14.6348 18.5619 14.0195 20.5578 12.7335 19.7717H12.6722V19.7441C12.6722 19.4111 12.6722 19.0703 12.6913 18.7215C12.7124 18.4161 12.7488 18.1068 12.7948 17.7916C12.7222 17.7211 12.6454 17.6553 12.5648 17.5945L12.5514 16.3631C12.5246 13.8018 14.4872 12.8856 16.6318 14.1584L19.524 15.8627C21.0496 15.776 22.9489 18.2093 22.9489 20.3076Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M12.7871 21.0465C12.722 20.6259 12.6836 20.2014 12.6721 19.7757H12.7335C14.0195 20.5638 14.6347 18.5561 14.905 17.1631C16.0032 19.0112 17.6859 20.0318 18.7995 19.5333C19.4933 21.0032 20.5647 21.8523 21.4444 21.9824C21.5262 22.3022 21.5902 22.6265 21.636 22.9537C21.6843 23.2904 21.7093 23.6301 21.7108 23.9704V25.458C21.7116 25.7689 21.6866 26.0794 21.636 26.386C21.4022 27.7435 20.6471 28.571 19.5987 28.7286C18.9087 28.8311 18.0923 28.6439 17.2164 28.1237C16.2945 27.5419 15.4875 26.7866 14.8379 25.8973C13.768 24.4836 13.0626 22.8151 12.7871 21.0465Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.6102 30.5806V30.6043C19.6102 32.3519 14.8456 29.9127 14.8456 27.775V25.9111C15.4947 26.8008 16.3017 27.5562 17.2241 28.1375C18.1 28.6576 18.9164 28.8448 19.6064 28.7424L19.6102 30.5806Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M12.6913 18.7136C12.6664 19.0624 12.6664 19.4032 12.6664 19.7441V19.7835C12.6779 20.2092 12.7163 20.6337 12.7814 21.0543C12.625 21.0205 12.4754 20.9599 12.3386 20.875C11.9174 20.5931 11.5668 20.2129 11.3154 19.7655C11.0639 19.318 10.9187 18.8159 10.8916 18.2999C10.8916 17.3502 11.5413 16.964 12.3386 17.4408C12.415 17.4861 12.4886 17.5362 12.559 17.5906C12.6396 17.6514 12.7164 17.7172 12.789 17.7876C12.7488 18.0989 12.7124 18.4083 12.6913 18.7136Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.5483 37.9968C20.8598 37.9968 19.0065 37.4175 17.0841 36.2748C14.3415 34.6473 11.756 32.0525 9.60941 28.77C6.67894 24.2935 5 19.1866 5 14.7574C5 10.8621 6.2937 7.95008 8.64153 6.55709C10.9894 5.1641 14.0885 5.4695 17.3716 7.41613C24.0337 11.3705 29.4462 21.0209 29.4462 28.9316C29.4462 32.8229 28.1544 35.7349 25.8046 37.1318C25.4515 37.3425 25.0784 37.5155 24.6911 37.6481C23.9997 37.8819 23.2762 37.9996 22.5483 37.9968ZM11.8997 6.28716C10.8603 6.27445 9.83623 6.54647 8.93285 7.07527C6.76518 8.35201 5.57498 11.0749 5.57498 14.7574C5.57498 19.0723 7.21942 24.0591 10.0847 28.439C12.1834 31.6486 14.7037 34.1804 17.3678 35.7625C20.0031 37.3269 22.4755 37.786 24.5148 37.0885C24.865 36.9674 25.2027 36.811 25.5229 36.6215C27.6848 35.335 28.875 32.6042 28.875 28.9375C28.875 21.216 23.5852 11.7961 17.0803 7.93431C15.248 6.83884 13.4809 6.28716 11.8997 6.28716Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M9.84709 28.9C9.80946 28.9005 9.77211 28.8932 9.73723 28.8787C9.70235 28.8641 9.67064 28.8426 9.64394 28.8153C9.58998 28.7595 9.55969 28.6841 9.55969 28.6055C9.55969 28.5268 9.58998 28.4514 9.64394 28.3956C10.9204 27.0736 12.7507 26.7504 14.9337 27.4578C14.9709 27.4684 15.0056 27.4866 15.0358 27.5113C15.066 27.536 15.091 27.5666 15.1094 27.6015C15.1279 27.6363 15.1393 27.6746 15.143 27.7141C15.1467 27.7536 15.1426 27.7934 15.131 27.8313C15.1195 27.8691 15.1006 27.9041 15.0756 27.9343C15.0505 27.9645 15.0199 27.9892 14.9854 28.0069C14.9508 28.0246 14.9132 28.035 14.8747 28.0375C14.8362 28.04 14.7976 28.0345 14.7612 28.0213C12.7967 27.3849 11.1676 27.6587 10.0522 28.8094C10.0255 28.8377 9.99368 28.8603 9.95847 28.8758C9.92327 28.8914 9.88541 28.8996 9.84709 28.9Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.6107 37.6737C24.5558 37.6739 24.502 37.6578 24.4558 37.6274C24.4096 37.597 24.3728 37.5536 24.35 37.5023C23.2053 34.9259 21.5245 32.6391 19.4263 30.8033C19.3973 30.7783 19.3734 30.7478 19.356 30.7133C19.3385 30.6789 19.3279 30.6412 19.3246 30.6025C19.3213 30.5638 19.3254 30.5248 19.3368 30.4878C19.3482 30.4507 19.3665 30.4164 19.3908 30.3866C19.4151 30.3568 19.4448 30.3323 19.4784 30.3144C19.5119 30.2964 19.5485 30.2855 19.5861 30.2821C19.6238 30.2787 19.6617 30.283 19.6977 30.2946C19.7338 30.3063 19.7672 30.3252 19.7962 30.3501C21.9571 32.2405 23.6894 34.5943 24.8713 37.2461C24.8874 37.2814 24.8966 37.3196 24.8983 37.3586C24.9 37.3975 24.8942 37.4365 24.8812 37.4731C24.8681 37.5097 24.8482 37.5433 24.8225 37.572C24.7968 37.6007 24.7658 37.6239 24.7314 37.6402C24.6938 37.6597 24.6527 37.6711 24.6107 37.6737Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M18.9222 31.487C17.5499 31.487 14.5581 29.6192 14.5581 27.7651V25.9013C14.5581 25.8229 14.5884 25.7477 14.6423 25.6923C14.6962 25.6368 14.7693 25.6057 14.8456 25.6057C14.9218 25.6057 14.995 25.6368 15.0489 25.6923C15.1028 25.7477 15.1331 25.8229 15.1331 25.9013V27.7651C15.1331 29.1739 17.6687 30.8959 18.9222 30.8959C19.0349 30.9049 19.1475 30.8773 19.2442 30.8171C19.2653 30.7994 19.3228 30.754 19.3228 30.5945V28.7306C19.3228 28.6522 19.3531 28.577 19.407 28.5216C19.4609 28.4662 19.534 28.435 19.6103 28.435C19.6865 28.435 19.7596 28.4662 19.8135 28.5216C19.8675 28.577 19.8977 28.6522 19.8977 28.7306V30.5945C19.9041 30.7252 19.8803 30.8556 19.8283 30.9751C19.7764 31.0946 19.6977 31.1997 19.5988 31.2821C19.4022 31.4269 19.1637 31.4991 18.9222 31.487Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.2384 29.0537C18.4756 29.0264 17.733 28.7948 17.0841 28.3818C16.1302 27.7801 15.2947 26.9995 14.6213 26.0805C13.5578 24.6787 12.8415 23.0323 12.5341 21.2829C12.4187 21.2396 12.3071 21.1862 12.2006 21.1233C11.7348 20.8162 11.3474 20.3989 11.0706 19.9064C10.7938 19.4138 10.6359 18.8602 10.6099 18.292C10.6099 17.7226 10.813 17.2891 11.1848 17.0704C11.5567 16.8517 12.0166 16.8911 12.4939 17.1768C12.5798 17.2287 12.663 17.2853 12.743 17.3463C12.831 17.418 12.9149 17.495 12.9941 17.5768C13.0272 17.6098 13.0523 17.6504 13.0673 17.6952C13.0823 17.7401 13.0867 17.7879 13.0804 17.8349C13.0305 18.158 12.9979 18.4536 12.9788 18.7412C12.9539 19.1116 12.9558 19.4683 12.9596 19.7382V19.7737C12.97 20.1656 13.0039 20.5564 13.0612 20.944C13.0788 20.9869 13.0861 21.0335 13.0823 21.08C13.3637 22.7739 14.0485 24.37 15.0755 25.7259C15.7046 26.584 16.4847 27.3132 17.3754 27.8754C18.1651 28.3444 18.9241 28.5414 19.5738 28.4448C20.5321 28.303 21.1588 27.5563 21.3677 26.3426C21.4155 26.0529 21.4392 25.7596 21.4386 25.4658V23.9763C21.4371 23.6504 21.4128 23.3252 21.3658 23.0029C21.3197 22.6861 21.2557 22.3723 21.1741 22.0631C21.1644 22.0256 21.162 21.9865 21.1671 21.948C21.1721 21.9095 21.1844 21.8725 21.2034 21.8389C21.2223 21.8053 21.2475 21.7759 21.2775 21.7524C21.3075 21.7288 21.3418 21.7115 21.3783 21.7016C21.4147 21.6916 21.4528 21.6891 21.4902 21.6943C21.5276 21.6994 21.5637 21.7121 21.5964 21.7316C21.629 21.7511 21.6576 21.777 21.6806 21.8079C21.7035 21.8387 21.7203 21.8739 21.7299 21.9114C21.8163 22.2428 21.8841 22.5789 21.9331 22.9182C21.984 23.2685 22.0102 23.6221 22.0117 23.9763V25.4579C22.0133 25.7881 21.9863 26.1178 21.9312 26.443C21.6801 27.907 20.8502 28.8488 19.6543 29.0261C19.5166 29.0464 19.3775 29.0556 19.2384 29.0537ZM11.7081 17.5256C11.6272 17.5229 11.5471 17.5427 11.4762 17.5827C11.2979 17.6891 11.1944 17.9472 11.1944 18.292C11.2212 18.7447 11.3468 19.1853 11.5618 19.5813C11.7768 19.9772 12.0757 20.3184 12.4364 20.5795C12.4095 20.3155 12.3923 20.0534 12.3865 19.7914C12.3856 19.7743 12.3856 19.7572 12.3865 19.7402C12.3865 19.4564 12.3865 19.0841 12.4076 18.692C12.4249 18.4378 12.4517 18.1758 12.49 17.9039L12.3942 17.8251C12.3326 17.7777 12.2686 17.7336 12.2026 17.693C12.054 17.5955 11.8839 17.5379 11.7081 17.5256Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M11.7081 19.0723C11.682 19.075 11.6556 19.075 11.6295 19.0723C11.557 19.0495 11.4962 18.9982 11.4603 18.9296C11.4244 18.8609 11.4163 18.7805 11.4378 18.7058C11.4648 18.5942 11.5165 18.4906 11.589 18.403C11.6615 18.3155 11.7528 18.2465 11.8557 18.2014C11.9822 18.1566 12.117 18.142 12.2498 18.1588C12.3826 18.1755 12.51 18.2231 12.6223 18.2979C12.7206 18.3574 12.8125 18.4274 12.8964 18.5068C12.9301 18.5307 12.9585 18.5618 12.9796 18.5979C13.0007 18.6341 13.014 18.6744 13.0187 18.7163C13.0234 18.7581 13.0193 18.8005 13.0067 18.8407C12.9941 18.8808 12.9734 18.9176 12.9458 18.9488C12.9182 18.98 12.8845 19.0048 12.8468 19.0214C12.8092 19.0381 12.7685 19.0463 12.7275 19.0455C12.6865 19.0447 12.6462 19.0349 12.6092 19.0167C12.5722 18.9986 12.5394 18.9725 12.513 18.9402C12.4608 18.8914 12.4036 18.8485 12.3425 18.8122C12.3039 18.7833 12.2602 18.7627 12.2138 18.7515C12.1673 18.7404 12.1192 18.7389 12.0722 18.7472C12.0512 18.7603 12.033 18.7777 12.0188 18.7984C12.0046 18.8191 11.9947 18.8425 11.9898 18.8673C11.971 18.9284 11.9333 18.9815 11.8825 19.0185C11.8316 19.0555 11.7704 19.0744 11.7081 19.0723Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.2493 26.8568C21.9895 26.8495 21.7357 26.775 21.5114 26.6401C21.4766 26.6226 21.4456 26.5982 21.4203 26.5681C21.3949 26.538 21.3757 26.503 21.3639 26.4651C21.352 26.4272 21.3477 26.3873 21.3512 26.3477C21.3547 26.308 21.366 26.2695 21.3843 26.2345C21.4027 26.1995 21.4277 26.1686 21.4579 26.1437C21.4881 26.1189 21.5229 26.1005 21.5602 26.0898C21.5975 26.0791 21.6365 26.0763 21.6749 26.0815C21.7133 26.0866 21.7502 26.0997 21.7836 26.1199C22.0615 26.2736 22.3087 26.2992 22.4793 26.1948C22.6499 26.0904 22.7553 25.8303 22.7553 25.4914C22.7287 25.0359 22.6015 24.5926 22.3833 24.1952C22.1651 23.7979 21.8617 23.4568 21.4961 23.198C21.4591 23.1805 21.4262 23.155 21.3995 23.1234C21.3729 23.0918 21.353 23.0547 21.3413 23.0146C21.3296 22.9745 21.3264 22.9323 21.3317 22.8908C21.3371 22.8493 21.351 22.8095 21.3724 22.7739C21.3939 22.7384 21.4225 22.7079 21.4563 22.6845C21.4901 22.6612 21.5283 22.6454 21.5684 22.6384C21.6086 22.6314 21.6497 22.6332 21.6891 22.6437C21.7285 22.6543 21.7653 22.6733 21.797 22.6995C22.2455 23.0119 22.6175 23.4269 22.8835 23.9121C23.1496 24.3972 23.3025 24.9392 23.3303 25.4954C23.3303 26.0569 23.1386 26.4805 22.7745 26.7071C22.6159 26.8052 22.4343 26.8569 22.2493 26.8568Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M21.6743 22.2937C21.5833 22.2937 21.4923 22.2872 21.4022 22.274C20.396 22.1282 19.338 21.2041 18.6557 19.8939C17.5613 20.1815 16.1162 19.3757 15.0391 17.8901C14.7228 19.1333 14.2839 19.8919 13.7262 20.148C13.5417 20.2273 13.3407 20.2577 13.1418 20.2363C12.9429 20.215 12.7524 20.1426 12.5877 20.0259C12.5546 20.0064 12.5255 19.9804 12.5022 19.9493C12.479 19.9182 12.4619 19.8827 12.4522 19.8447C12.4424 19.8068 12.4401 19.7672 12.4453 19.7284C12.4506 19.6895 12.4633 19.6521 12.4828 19.6183C12.5023 19.5846 12.5281 19.5552 12.5587 19.5318C12.5894 19.5084 12.6243 19.4915 12.6613 19.4821C12.6984 19.4727 12.7369 19.471 12.7746 19.4771C12.8123 19.4832 12.8485 19.4969 12.881 19.5175C12.9675 19.5838 13.0687 19.6268 13.1755 19.6426C13.2823 19.6584 13.3912 19.6466 13.4924 19.6082C13.9428 19.4111 14.3548 18.4871 14.6232 17.102C14.6328 17.0414 14.6605 16.9855 14.7024 16.9419C14.7443 16.8982 14.7984 16.8691 14.8572 16.8585C14.9159 16.8479 14.9765 16.8563 15.0303 16.8826C15.0842 16.909 15.1288 16.9519 15.1579 17.0054C16.1679 18.7058 17.7223 19.6968 18.6998 19.2614C18.7676 19.2314 18.8441 19.2295 18.9133 19.2559C18.9825 19.2823 19.0392 19.3351 19.0716 19.4033C19.7865 20.9263 20.8234 21.5922 21.4827 21.6888C21.6188 21.7159 21.7591 21.7124 21.8937 21.6783C22.0284 21.6443 22.1543 21.5807 22.2627 21.4918C22.5176 21.2632 22.646 20.8534 22.646 20.3096C22.646 19.1865 22.0308 17.833 21.1128 16.9424C20.5646 16.4104 19.9973 16.1287 19.5201 16.1543C19.4646 16.1555 19.4098 16.142 19.361 16.1149L16.488 14.4027C15.4856 13.8116 14.512 13.7072 13.8048 14.1288C13.1646 14.5111 12.8197 15.311 12.8312 16.3474L12.858 17.5768C12.858 17.6552 12.8277 17.7304 12.7738 17.7858C12.7199 17.8412 12.6467 17.8724 12.5705 17.8724C12.4943 17.8724 12.4211 17.8412 12.3672 17.7858C12.3133 17.7304 12.283 17.6552 12.283 17.5768L12.2638 16.3552C12.2504 15.0844 12.697 14.1131 13.5211 13.6166C14.4047 13.0866 15.5891 13.187 16.7793 13.8904L19.6006 15.5652C20.2158 15.5652 20.8962 15.8981 21.5172 16.5129C22.556 17.5217 23.2268 19.0112 23.2268 20.3076C23.2268 21.2218 22.9067 21.7006 22.6384 21.941C22.3696 22.1755 22.0268 22.3009 21.6743 22.2937Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.5532 22.6089C16.477 22.6089 16.4039 22.5778 16.35 22.5224C16.296 22.4669 16.2657 22.3918 16.2657 22.3134V21.3854C16.2657 21.307 16.296 21.2318 16.35 21.1764C16.4039 21.121 16.477 21.0898 16.5532 21.0898C16.6295 21.0898 16.7026 21.121 16.7565 21.1764C16.8104 21.2318 16.8407 21.307 16.8407 21.3854V22.3055C16.8417 22.345 16.8351 22.3843 16.8211 22.421C16.8071 22.4578 16.7861 22.4913 16.7593 22.5196C16.7325 22.5479 16.7004 22.5704 16.6651 22.5857C16.6297 22.601 16.5916 22.6089 16.5532 22.6089Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M18.9126 24.0098C18.8364 24.0098 18.7632 23.9787 18.7093 23.9232C18.6554 23.8678 18.6251 23.7926 18.6251 23.7143V22.7863C18.6251 22.7079 18.6554 22.6327 18.7093 22.5773C18.7632 22.5219 18.8364 22.4907 18.9126 22.4907C18.9889 22.4907 19.062 22.5219 19.1159 22.5773C19.1698 22.6327 19.2001 22.7079 19.2001 22.7863V23.7143C19.2001 23.7926 19.1698 23.8678 19.1159 23.9232C19.062 23.9787 18.9889 24.0098 18.9126 24.0098Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.4388 24.4334C17.3129 24.4291 17.1905 24.3903 17.0842 24.3211C17.0488 24.3032 17.0174 24.2781 16.9919 24.2472C16.9664 24.2164 16.9473 24.1804 16.9358 24.1417C16.9244 24.1029 16.9208 24.0621 16.9254 24.0219C16.9299 23.9816 16.9424 23.9428 16.9622 23.9077C16.9819 23.8727 17.0085 23.8422 17.0402 23.8181C17.0719 23.794 17.108 23.7769 17.1464 23.7678C17.1848 23.7588 17.2247 23.7579 17.2634 23.7653C17.3021 23.7727 17.339 23.7882 17.3717 23.8108H17.3908C17.4349 23.6768 17.4905 23.267 17.364 22.0376C17.3601 21.9987 17.3637 21.9595 17.3745 21.9221C17.3854 21.8847 17.4033 21.8499 17.4272 21.8196C17.4511 21.7894 17.4806 21.7642 17.514 21.7457C17.5474 21.7271 17.584 21.7155 17.6218 21.7115C17.6595 21.7075 17.6977 21.7111 17.7341 21.7223C17.7704 21.7334 17.8043 21.7518 17.8338 21.7764C17.8632 21.801 17.8877 21.8314 17.9057 21.8657C17.9238 21.9 17.9351 21.9377 17.939 21.9765C18.1172 23.7123 17.985 24.1635 17.6994 24.3546C17.6221 24.407 17.5313 24.4345 17.4388 24.4334Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.283 20.7017C16.036 20.6903 15.7959 20.6144 15.5854 20.481C15.5526 20.4618 15.5237 20.4362 15.5005 20.4056C15.4773 20.375 15.4601 20.34 15.4501 20.3026C15.44 20.2652 15.4372 20.2261 15.4419 20.1876C15.4465 20.149 15.4585 20.1118 15.4771 20.0781C15.4957 20.0443 15.5206 20.0146 15.5504 19.9908C15.5802 19.9669 15.6143 19.9493 15.6507 19.939C15.6871 19.9286 15.7251 19.9258 15.7625 19.9305C15.8 19.9353 15.8362 19.9476 15.8691 19.9667C16.003 20.0645 16.165 20.113 16.329 20.1047C16.3721 20.0407 16.438 19.9969 16.5123 19.9829C16.5867 19.9689 16.6635 19.9857 16.7258 20.0298C16.788 20.0754 16.8304 20.1443 16.8436 20.2217C16.8569 20.2992 16.84 20.3788 16.7967 20.4436C16.7393 20.5278 16.6621 20.5956 16.5723 20.6408C16.4824 20.6859 16.3829 20.7069 16.283 20.7017Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.7577 22.9143C19.7071 22.9137 19.6575 22.8995 19.614 22.8729C19.1913 22.6256 18.8558 22.2469 18.6557 21.7912C18.6404 21.7546 18.6324 21.7152 18.6323 21.6754C18.6322 21.6356 18.6399 21.5961 18.655 21.5594C18.6701 21.5228 18.6922 21.4896 18.7201 21.4619C18.748 21.4342 18.781 21.4127 18.8172 21.3984C18.8534 21.3842 18.892 21.3777 18.9307 21.3792C18.9694 21.3807 19.0075 21.3902 19.0425 21.4072C19.0775 21.4242 19.1089 21.4483 19.1346 21.4781C19.1604 21.5078 19.18 21.5427 19.1923 21.5804C19.3445 21.9117 19.592 22.1868 19.9015 22.3685C19.9565 22.4011 19.9995 22.4515 20.0238 22.5118C20.048 22.5722 20.0522 22.6391 20.0355 22.7021C20.0189 22.7651 19.9824 22.8207 19.9318 22.8601C19.8812 22.8996 19.8193 22.9207 19.7558 22.9202L19.7577 22.9143Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M8.78525 7.10874C8.7219 7.10881 8.66031 7.08738 8.61003 7.04776C8.55976 7.00814 8.52362 6.95257 8.50723 6.88967C8.49084 6.82676 8.49511 6.76006 8.5194 6.69991C8.54368 6.63977 8.5866 6.58955 8.6415 6.55706L13.1359 3.88931C13.1685 3.86926 13.2046 3.856 13.2422 3.8503C13.2798 3.84459 13.3181 3.84655 13.3549 3.85607C13.3918 3.86558 13.4264 3.88246 13.4569 3.90574C13.4874 3.92903 13.5131 3.95826 13.5327 3.99176C13.5522 4.02527 13.5651 4.0624 13.5706 4.10103C13.5761 4.13966 13.5742 4.17903 13.565 4.21691C13.5557 4.25478 13.5393 4.2904 13.5167 4.32175C13.494 4.3531 13.4656 4.37956 13.433 4.39961L8.92899 7.06934C8.88534 7.09538 8.83572 7.10899 8.78525 7.10874Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M25.6723 37.1752C25.609 37.1752 25.5474 37.1538 25.4971 37.1142C25.4469 37.0746 25.4107 37.019 25.3943 36.9561C25.3779 36.8932 25.3822 36.8265 25.4065 36.7663C25.4308 36.7062 25.4737 36.656 25.5286 36.6235L30.0728 33.9301C32.2348 32.6455 33.425 29.9147 33.425 26.246C33.425 18.5245 28.1333 9.10463 21.6283 5.24289C18.5349 3.39083 15.639 3.0874 13.4751 4.37596L13.433 4.39764C13.4006 4.41769 13.3648 4.431 13.3274 4.4368C13.2901 4.4426 13.252 4.44079 13.2153 4.43145C13.1787 4.42212 13.1441 4.40546 13.1137 4.38242C13.0833 4.35937 13.0577 4.3304 13.0382 4.29715C13.0186 4.2639 13.0057 4.22703 13.0001 4.18864C12.9944 4.15025 12.9962 4.11109 13.0053 4.0734C13.0143 4.03571 13.0305 4.00023 13.053 3.96898C13.0754 3.93773 13.1036 3.91133 13.1359 3.89128L13.2049 3.85187C15.5412 2.47268 18.6423 2.77216 21.9197 4.71879C28.5741 8.67314 34 18.3255 34 26.2342C34 30.1314 32.7082 33.0435 30.3584 34.4365L25.8142 37.1338C25.7712 37.16 25.7223 37.1743 25.6723 37.1752Z",
				fill: "#3D3D3D"
			})
		]
	});
})), He = /* @__PURE__ */ we({ default: () => Ue }), Ue, We = Se((() => {
	Ue = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M34.7107 26.2389C34.7107 30.1495 33.3334 32.9045 31.0923 34.1872L26.3898 36.8835C28.6249 35.6048 30.0082 32.8537 30.0082 28.9352C30.0082 21.114 24.4792 11.5877 17.6556 7.67321C14.2438 5.7179 11.1625 5.52237 8.91943 6.81287L13.6181 4.11455C15.8533 2.83187 18.9404 3.01762 22.3522 4.97489C29.1759 8.88941 34.7107 18.4098 34.7107 26.2389Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M30.0023 28.9352C30.0023 32.8458 28.625 35.6028 26.3839 36.8816C26.0364 37.0824 25.6692 37.2475 25.288 37.3743C23.9839 34.5264 22.0084 32.0327 19.5288 30.1045V29.469C20.7605 29.3419 21.4531 28.0846 21.762 26.5497C22.5491 27.0855 23.1964 26.7609 23.1964 25.8888C23.162 25.2364 22.9036 24.6153 22.4644 24.1291C22.4979 23.8697 22.5137 23.6084 22.5117 23.3469C22.5117 20.0757 20.1997 16.1006 17.3467 14.4581C14.0156 12.5478 11.4203 14.6791 12.3864 19.2291C10.8694 18.3883 9.6475 19.1098 9.6475 20.8598C9.6475 20.9986 9.6475 21.1394 9.66914 21.2802C8.3174 20.8187 7.24506 21.4073 6.94205 22.776C5.89332 20.0972 5.29517 17.3363 5.29517 14.7612C5.29517 10.8506 6.67249 8.09553 8.91358 6.81285C11.1547 5.53017 14.2477 5.71593 17.6497 7.67319C24.4793 11.5877 30.0023 21.1081 30.0023 28.9352Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M25.2879 37.3743C23.1846 38.0684 20.5322 37.6793 17.6497 36.0251C14.7672 34.3709 12.1129 31.7137 10.0095 28.6145C11.3652 27.2653 13.3544 27.0268 15.7707 27.9556V28.11C15.7707 30.2491 19.5288 32.0206 19.5288 30.2609V30.1044C22.0084 32.0327 23.9839 34.5263 25.2879 37.3743Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.4644 24.1271C22.9036 24.6133 23.1619 25.2344 23.1963 25.8869C23.1963 26.7589 22.5411 27.0835 21.762 26.5478C21.9428 25.6029 22.0043 24.6393 21.9449 23.6793C22.1396 23.8019 22.3147 23.9529 22.4644 24.1271Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.5116 23.3489C22.5137 23.6104 22.4979 23.8717 22.4644 24.131C22.3146 23.9575 22.1395 23.8072 21.945 23.6852C20.544 22.2754 19.2749 19.933 19.0408 18.0911C17.8209 20.0464 16.3767 21.2078 15.1292 21.6908C13.9349 22.1542 13.8857 24.2327 15.0092 26.1059C15.2386 26.4939 15.493 26.8668 15.7706 27.2224V27.9497C13.3485 27.021 11.3652 27.2595 10.0095 28.6087C8.77473 26.7843 7.74603 24.8302 6.94202 22.7818C7.24503 21.4131 8.31934 20.8265 9.66911 21.286C9.65534 21.1453 9.64747 21.0045 9.64747 20.8656C9.64747 19.1059 10.8693 18.3941 12.3864 19.2349C11.4203 14.6791 14.0155 12.5478 17.3467 14.4581C20.1997 16.1006 22.5116 20.0757 22.5116 23.3489Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M21.945 23.6813C22.0043 24.6413 21.9428 25.6049 21.762 26.5497C21.4531 28.0846 20.7605 29.3419 19.5288 29.469C19.0034 29.5237 18.3817 29.3732 17.6497 28.9548C16.9198 28.4992 16.2824 27.9116 15.7706 27.2223C15.493 26.8668 15.2386 26.4939 15.0092 26.1059C13.8857 24.2268 13.9349 22.1542 15.1292 21.6908C16.3767 21.2078 17.8209 20.0542 19.0408 18.0911C19.2749 19.933 20.544 22.2754 21.945 23.6813Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.5287 30.1045V30.2609C19.5287 32.0089 15.7706 30.2433 15.7706 28.1101V27.2282C16.2824 27.9174 16.9198 28.5051 17.6497 28.9606C18.3816 29.379 19.0034 29.5296 19.5287 29.4749V30.1045Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.4782 27.1031C22.1586 27.0904 21.8504 26.9813 21.5947 26.7902C21.5306 26.7456 21.4868 26.6777 21.4728 26.6012C21.4588 26.5247 21.4758 26.4457 21.52 26.3816C21.5418 26.3498 21.5698 26.3227 21.6023 26.3019C21.6348 26.281 21.6712 26.2668 21.7093 26.26C21.7474 26.2533 21.7865 26.2542 21.8243 26.2626C21.862 26.2711 21.8977 26.2869 21.9292 26.3092C22.2126 26.5048 22.4841 26.5654 22.6553 26.4774C22.8265 26.3894 22.9012 26.1821 22.9012 25.8908C22.8661 25.3102 22.6337 24.7587 22.2421 24.3265C22.112 24.1742 21.9594 24.0423 21.7895 23.9355C21.7239 23.8941 21.6774 23.8286 21.6601 23.7534C21.6427 23.6781 21.6559 23.5991 21.6969 23.5334C21.7378 23.4678 21.8031 23.4208 21.8787 23.4027C21.9542 23.3847 22.0339 23.3969 22.1004 23.4369C22.3211 23.5745 22.52 23.7438 22.6907 23.9394C23.1781 24.4792 23.4625 25.1701 23.4954 25.8947C23.4954 26.4129 23.2987 26.8157 22.9327 27.0014C22.7921 27.0724 22.6359 27.1074 22.4782 27.1031Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.1531 38C21.4078 38 19.4933 37.4134 17.5021 36.2793C14.6589 34.6466 11.9929 32.0519 9.76553 28.7709C8.51658 26.9298 7.47722 24.9565 6.66656 22.8874C5.57651 20.0933 5 17.2835 5 14.7612C5 10.8642 6.33797 7.95277 8.76599 6.55864C11.194 5.1645 14.4012 5.47149 17.7894 7.41897C24.676 11.3746 30.2896 21.026 30.2896 28.9274C30.2896 32.8125 28.9516 35.726 26.5236 37.1279C26.1591 37.3382 25.7741 37.5111 25.3745 37.6441C24.6581 37.8806 23.908 38.0008 23.1531 38ZM10.2555 28.4444C12.4238 31.6491 15.0348 34.1832 17.7894 35.7709C20.5185 37.3352 23.0763 37.7947 25.1876 37.0947C25.5492 36.9758 25.8974 36.8199 26.2265 36.6293C28.4656 35.3349 29.6993 32.6033 29.6993 28.9352C29.6993 21.2137 24.2254 11.7891 17.5002 7.92735C14.2949 6.08741 11.2963 5.77652 9.05916 7.06702C6.822 8.35752 5.59028 11.0832 5.59028 14.7612C5.59028 17.2112 6.15301 19.9466 7.21749 22.6743C8.01175 24.7036 9.03067 26.6389 10.2555 28.4444Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M10.0095 28.9019C9.93057 28.8997 9.85566 28.8667 9.80096 28.81C9.74617 28.7548 9.71545 28.6804 9.71545 28.6028C9.71545 28.5252 9.74617 28.4508 9.80096 28.3955C11.2511 26.9525 13.3525 26.7022 15.8769 27.6701C15.9508 27.6981 16.0104 27.7541 16.0427 27.8258C16.075 27.8975 16.0773 27.979 16.0491 28.0524C16.0209 28.1257 15.9645 28.185 15.8924 28.2171C15.8203 28.2492 15.7383 28.2515 15.6644 28.2235C13.3741 27.3455 11.4911 27.5489 10.2181 28.81C10.1913 28.8384 10.159 28.8612 10.1232 28.877C10.0874 28.8928 10.0487 28.9013 10.0095 28.9019Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M25.2879 37.6676C25.2316 37.6676 25.1766 37.6515 25.1291 37.6214C25.0817 37.5912 25.044 37.5483 25.0203 37.4975C23.7346 34.6932 21.789 32.2374 19.3477 30.3372C19.2856 30.2897 19.2451 30.2197 19.2349 30.1425C19.2248 30.0653 19.2459 29.9873 19.2936 29.9256C19.3414 29.8639 19.4118 29.8235 19.4895 29.8134C19.5672 29.8034 19.6457 29.8244 19.7078 29.8718C22.2247 31.8296 24.2304 34.3607 25.5555 37.2511C25.5721 37.2862 25.5815 37.3241 25.5832 37.3628C25.585 37.4014 25.579 37.44 25.5656 37.4764C25.5523 37.5127 25.5318 37.5461 25.5054 37.5746C25.479 37.603 25.4473 37.626 25.4119 37.6422C25.3728 37.6591 25.3306 37.6678 25.2879 37.6676Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M18.7869 31.2659C17.5395 31.2659 15.4755 29.7877 15.4755 28.1042V27.2224C15.4755 27.1446 15.5066 27.07 15.5619 27.015C15.6173 26.96 15.6923 26.9291 15.7706 26.9291C15.8489 26.9291 15.9239 26.96 15.9793 27.015C16.0346 27.07 16.0657 27.1446 16.0657 27.2224V28.1042C16.0657 29.4886 17.8917 30.6794 18.7869 30.6794C18.9072 30.6876 19.0267 30.6545 19.1254 30.5855C19.1652 30.5419 19.1954 30.4905 19.214 30.4346C19.2326 30.3787 19.2393 30.3195 19.2336 30.2609V29.4788C19.2336 29.401 19.2647 29.3264 19.32 29.2714C19.3754 29.2164 19.4504 29.1855 19.5287 29.1855C19.607 29.1855 19.6821 29.2164 19.7374 29.2714C19.7928 29.3264 19.8239 29.401 19.8239 29.4788V30.2609C19.8314 30.4025 19.8079 30.5441 19.7549 30.6758C19.7019 30.8075 19.6207 30.9261 19.5169 31.0235C19.3124 31.1918 19.0521 31.2782 18.7869 31.2659Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.3202 29.772C18.6745 29.742 18.0479 29.5452 17.5021 29.2011C16.7384 28.7264 16.071 28.1136 15.5345 27.3944C15.2475 27.0298 14.9847 26.647 14.7475 26.2486C13.9605 24.9366 13.6948 23.4916 14.0451 22.4768C14.1164 22.2385 14.2403 22.019 14.4078 21.8344C14.5752 21.6497 14.782 21.5044 15.0131 21.4092C15.8002 21.1042 17.3428 20.236 18.7811 17.9287C18.8133 17.8775 18.8606 17.8373 18.9167 17.8138C18.9727 17.7903 19.0347 17.7846 19.0942 17.7974C19.1536 17.8102 19.2076 17.841 19.2488 17.8855C19.2899 17.9301 19.3163 17.9861 19.3241 18.0461C19.5602 19.7863 20.7408 22.0642 22.1535 23.474C22.2064 23.5258 22.2374 23.5958 22.2401 23.6695C22.2971 24.6515 22.231 25.6367 22.0434 26.6025C21.6498 28.5089 20.7723 29.6293 19.5524 29.7564C19.4815 29.7681 19.4009 29.772 19.3202 29.772ZM16.0048 27.0503C16.4913 27.7058 17.0965 28.2655 17.7894 28.7005C18.4308 29.0662 19.0014 29.2265 19.4894 29.1776C20.6995 29.0505 21.2307 27.6466 21.457 26.491C21.6252 25.6066 21.6866 24.7053 21.64 23.8064C20.3271 22.4063 19.3811 20.7067 18.8854 18.8575C17.8248 20.3651 16.5459 21.4561 15.2315 21.9665C15.0808 22.0309 14.9465 22.1281 14.8386 22.251C14.7306 22.3738 14.6518 22.5191 14.6078 22.6762C14.3146 23.5209 14.5704 24.8095 15.2591 25.9592C15.4841 26.3382 15.7332 26.7027 16.0048 27.0503Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.4644 24.4204H22.425C22.3476 24.4102 22.2774 24.3698 22.2298 24.3083C22.1822 24.2467 22.1612 24.1689 22.1712 24.0919C22.2025 23.8468 22.2176 23.5999 22.2165 23.3528C22.2165 20.1735 19.9655 16.2961 17.1991 14.7123C15.8218 13.9302 14.535 13.8402 13.6574 14.4757C12.5851 15.2578 12.2191 17.0059 12.6736 19.1684C12.6845 19.2234 12.6795 19.2803 12.659 19.3325C12.6386 19.3847 12.6037 19.43 12.5583 19.4633C12.5129 19.4965 12.4589 19.5162 12.4027 19.52C12.3465 19.5239 12.2903 19.5118 12.2407 19.4852C11.6072 19.1332 11.0248 19.0746 10.6057 19.3209C10.1866 19.5673 9.94062 20.1168 9.94062 20.8598C9.94102 20.9904 9.94824 21.1209 9.96226 21.2508C9.9672 21.2999 9.9597 21.3494 9.94046 21.3948C9.92121 21.4402 9.89083 21.4801 9.85208 21.5109C9.81329 21.5415 9.76732 21.5619 9.71846 21.5701C9.6696 21.5783 9.61945 21.5741 9.57268 21.5578C8.9824 21.3623 8.45705 21.374 8.04385 21.6028C7.63066 21.8316 7.35716 22.2559 7.22927 22.8385C7.21231 22.9145 7.16567 22.9807 7.09962 23.0225C7.03357 23.0643 6.95352 23.0783 6.87707 23.0615C6.80062 23.0446 6.73404 22.9983 6.69197 22.9326C6.64991 22.867 6.6358 22.7874 6.65276 22.7114C6.81804 21.9626 7.19975 21.4014 7.75462 21.0925C8.24456 20.8355 8.81227 20.766 9.35034 20.8969V20.8676C9.35034 19.9075 9.69074 19.1821 10.3066 18.8223C10.7808 18.5447 11.3652 18.5193 11.9928 18.7383C11.6524 16.5659 12.1188 14.8589 13.3052 14.0025C14.3854 13.2204 15.9103 13.2986 17.4923 14.198C20.422 15.8796 22.8048 19.9818 22.8048 23.343C22.8066 23.6156 22.7901 23.888 22.7556 24.1584C22.7475 24.2298 22.7134 24.2958 22.6598 24.344C22.6062 24.3923 22.5367 24.4194 22.4644 24.4204Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.264 23.2218C17.1857 23.2218 17.1107 23.1909 17.0553 23.1359C17 23.0809 16.9689 23.0063 16.9689 22.9285V22.1034C16.9689 22.0256 17 21.951 17.0553 21.896C17.1107 21.841 17.1857 21.8101 17.264 21.8101C17.3423 21.8101 17.4174 21.841 17.4727 21.896C17.5281 21.951 17.5592 22.0256 17.5592 22.1034V22.9285C17.5592 23.0063 17.5281 23.0809 17.4727 23.1359C17.4174 23.1909 17.3423 23.2218 17.264 23.2218Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.3478 24.4184C19.2695 24.4184 19.1944 24.3875 19.1391 24.3325C19.0837 24.2775 19.0526 24.2029 19.0526 24.1251V23.3C19.0526 23.2222 19.0837 23.1476 19.1391 23.0926C19.1944 23.0376 19.2695 23.0067 19.3478 23.0067C19.426 23.0067 19.5011 23.0376 19.5564 23.0926C19.6118 23.1476 19.6429 23.2222 19.6429 23.3V24.1173C19.6439 24.1565 19.6371 24.1955 19.6227 24.232C19.6084 24.2685 19.5868 24.3017 19.5593 24.3298C19.5318 24.3579 19.4989 24.3802 19.4625 24.3954C19.4262 24.4106 19.3872 24.4185 19.3478 24.4184Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.4785 21.6458C17.4505 21.6458 17.4227 21.6418 17.3959 21.6341L16.3924 21.3467C16.3162 21.3501 16.2416 21.3244 16.1839 21.275C16.1261 21.2256 16.0895 21.1561 16.0815 21.0807C16.0738 21.0035 16.0972 20.9264 16.1467 20.8663C16.1961 20.8062 16.2675 20.768 16.3452 20.7601C16.3714 20.7581 16.3977 20.7581 16.4239 20.7601C16.4551 20.7601 16.4861 20.7641 16.5164 20.7718L17.5592 21.071C17.6272 21.0907 17.6859 21.1341 17.7244 21.1932C17.7629 21.2524 17.7787 21.3233 17.7689 21.393C17.7591 21.4628 17.7244 21.5267 17.671 21.5732C17.6177 21.6196 17.5494 21.6454 17.4785 21.6458Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.9852 23.2022C19.918 23.202 19.8529 23.1793 19.8003 23.1377L18.9011 22.4279C18.8395 22.3794 18.7998 22.3086 18.7908 22.2311C18.7817 22.1535 18.8041 22.0756 18.8529 22.0144C18.9017 21.9532 18.9729 21.9138 19.051 21.9048C19.129 21.8958 19.2074 21.918 19.269 21.9665L20.1682 22.6782C20.1988 22.7019 20.2243 22.7313 20.2432 22.7649C20.2622 22.7985 20.2742 22.8354 20.2786 22.8737C20.283 22.9119 20.2797 22.9506 20.2688 22.9876C20.258 23.0245 20.2398 23.0589 20.2154 23.0888C20.1886 23.1242 20.1538 23.1529 20.1138 23.1725C20.0738 23.1922 20.0298 23.2024 19.9852 23.2022Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.8721 25.1126C17.8256 25.1153 17.7789 25.1153 17.7324 25.1126C17.6936 25.1076 17.6563 25.095 17.6224 25.0756C17.5885 25.0563 17.5588 25.0305 17.5349 24.9997C17.4868 24.9375 17.4655 24.8589 17.4756 24.7811C17.4858 24.7034 17.5267 24.6328 17.5892 24.5849C17.6517 24.5371 17.7309 24.5159 17.8091 24.526C17.8898 24.5377 17.9351 24.526 17.9488 24.5142C17.9626 24.5025 18.0177 24.4419 18.0177 24.1564C18.0177 23.9609 17.941 23.0908 17.9075 22.8737C17.9013 22.8352 17.9028 22.7959 17.9119 22.7579C17.921 22.72 17.9376 22.6842 17.9606 22.6526C17.9836 22.621 18.0126 22.5942 18.0461 22.5738C18.0795 22.5534 18.1167 22.5397 18.1554 22.5335C18.1942 22.5274 18.2338 22.5288 18.272 22.5379C18.3102 22.5469 18.3462 22.5634 18.378 22.5862C18.4098 22.6091 18.4367 22.638 18.4573 22.6712C18.4778 22.7044 18.4916 22.7414 18.4978 22.7799C18.5332 23.0067 18.6159 23.9218 18.6159 24.1486C18.6159 24.3754 18.5883 24.7352 18.3463 24.9483C18.2149 25.0608 18.0454 25.1195 17.8721 25.1126Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M26.3859 37.1768C26.3339 37.1775 26.2827 37.1642 26.2377 37.1384C26.1927 37.1126 26.1555 37.0752 26.1301 37.0302C26.0933 36.964 26.0838 36.8863 26.1036 36.8133C26.1235 36.7403 26.171 36.6779 26.2363 36.6391L30.9389 33.9408C33.178 32.6562 34.4098 29.9226 34.4098 26.2467C34.4098 18.5232 28.9339 9.09862 22.2106 5.23689C18.9995 3.39108 16.0029 3.08605 13.7657 4.36873L9.06116 7.06706C9.02757 7.08632 8.99049 7.09881 8.95204 7.10383C8.91359 7.10885 8.87452 7.10629 8.83707 7.0963C8.79961 7.08632 8.7645 7.0691 8.73375 7.04563C8.70299 7.02216 8.67718 6.9929 8.6578 6.95952C8.61866 6.8921 8.60808 6.812 8.62837 6.73683C8.64867 6.66165 8.69818 6.59757 8.76602 6.55868L13.4706 3.86035C15.8986 2.46818 19.1038 2.7732 22.4999 4.72069C29.3983 8.67041 35 18.3296 35 26.2388C35 30.1338 33.6621 33.0472 31.234 34.4394L26.5315 37.1377C26.4875 37.1638 26.4371 37.1773 26.3859 37.1768Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Ge = /* @__PURE__ */ we({ default: () => Ke }), Ke, qe = Se((() => {
	Ke = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M33.7078 30.5174C33.4785 30.4297 33.2352 30.3854 32.9901 30.3868C29.8653 30.3868 30.9621 35.624 28.9052 35.624C27.3293 35.624 26.7405 33.5931 24.6836 33.5931C21.9898 33.5931 21.4414 37.7076 19.5423 37.7076C17.0833 37.7076 17.4258 33.6808 14.8724 33.6808C12.9983 33.6808 12.1498 35.5617 10.8933 35.5617C8.19955 35.5617 10.2103 29.8547 7.28366 29.8547C6.93324 29.8596 6.58974 29.9542 6.28503 30.1295C8.30922 24.8884 9.07888 21.0272 9.53297 17.9126C9.73541 18.2512 10.0169 18.5344 10.3527 18.737C11.1512 19.2048 11.9227 18.8969 12.0709 18.0509C12.2191 17.205 11.6976 16.1369 10.8991 15.6691C10.7454 15.5681 10.5724 15.501 10.3914 15.4721C10.2104 15.4433 10.0255 15.4533 9.84853 15.5015C10.0967 13.4901 10.3084 11.7826 10.8433 10.1357C12.1902 5.99771 15.9211 3.3138 19.9271 3.29236C23.9351 3.3177 27.6699 5.99771 29.0148 10.1357C30.4983 14.7102 29.4747 19.7408 33.7078 30.5174ZM18.9728 22.0856C19.1229 21.2377 18.5879 20.1735 17.7971 19.7057C17.0063 19.238 16.229 19.544 16.077 20.3938C15.9249 21.2436 16.4618 22.3039 17.2507 22.7717C18.0396 23.2395 18.8227 22.9334 18.9728 22.0856ZM13.6583 23.2706C13.6602 23.2356 13.6602 23.2004 13.6583 23.1654C13.6491 22.9365 13.5849 22.7134 13.4712 22.5153C13.3575 22.3173 13.1978 22.1504 13.006 22.0291C12.5981 21.7913 12.2364 21.9589 12.1787 22.4189L11.9997 24.0055C11.994 24.248 12.0512 24.4878 12.1657 24.7009C12.2802 24.914 12.4479 25.0929 12.652 25.2197C13.0599 25.4595 13.4216 25.288 13.4813 24.8416L13.6583 23.2706Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.7972 19.7057C18.5976 20.1735 19.1229 21.2377 18.9728 22.0856C18.8227 22.9334 18.0512 23.2394 17.2411 22.7717C16.431 22.3039 15.9173 21.2397 16.0674 20.3938C16.2175 19.5478 16.9987 19.2379 17.7972 19.7057Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M13.6641 23.1557C13.666 23.1907 13.666 23.2259 13.6641 23.2609L13.487 24.8475C13.437 25.2938 13.0657 25.4654 12.6577 25.2256C12.4509 25.0959 12.282 24.9126 12.1683 24.6947C12.0547 24.4768 12.0005 24.2322 12.0112 23.986L12.1902 22.3994C12.2402 21.9492 12.6096 21.7816 13.0176 22.0096C13.2096 22.1325 13.369 22.3013 13.4817 22.5011C13.5944 22.7009 13.657 22.9257 13.6641 23.1557Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M10.8991 15.6692C11.6976 16.137 12.2229 17.2051 12.0709 18.051C11.9189 18.8969 11.1512 19.2048 10.3526 18.7371C10.0169 18.5344 9.7354 18.2513 9.53296 17.9126C9.6561 17.0569 9.75231 16.2539 9.84852 15.5015C10.0254 15.4533 10.2104 15.4433 10.3914 15.4722C10.5724 15.5011 10.7454 15.5682 10.8991 15.6692Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.546 38C18.1568 38 17.5468 36.8656 17.0081 35.856C16.4693 34.8464 15.9921 33.9654 14.8761 33.9654C13.9449 33.9654 13.2887 34.4838 12.6538 34.9847C12.0919 35.4272 11.5609 35.8462 10.897 35.8462C9.32885 35.8462 9.10373 34.2441 8.90747 32.831C8.67272 31.1567 8.4476 30.1393 7.28735 30.1393C6.98528 30.1444 6.68941 30.2269 6.42726 30.379C6.37522 30.4075 6.31583 30.4192 6.25703 30.4126C6.19823 30.406 6.14283 30.3814 6.09823 30.342C6.05379 30.302 6.02243 30.2492 6.00834 30.1907C5.99425 30.1322 5.99808 30.0708 6.01934 30.0145C8.11665 24.6038 8.84205 20.6822 9.24612 17.8697C9.36349 17.0569 9.55975 15.4742 9.55975 15.4742C9.80604 13.4628 10.0196 11.7281 10.5661 10.0518C11.9245 5.85933 15.6862 3.02729 19.9212 3C24.1639 3.02729 27.9352 5.85933 29.2821 10.046C29.8267 11.7222 30.0422 13.4608 30.2904 15.4742C30.7348 19.0742 31.2871 23.5533 33.977 30.4083C34.0003 30.4614 34.0074 30.5204 33.9974 30.5777C33.9874 30.635 33.9607 30.6879 33.9208 30.7298C33.881 30.7716 33.8297 30.8005 33.7735 30.8126C33.7174 30.8248 33.6589 30.8197 33.6057 30.7981C33.4098 30.7223 33.2015 30.6846 32.9919 30.687C31.4853 30.687 31.0927 32.1157 30.7137 33.4995C30.3866 34.6924 30.0479 35.9242 28.9069 35.9242C28.0661 35.9242 27.4792 35.4252 26.9116 34.9497C26.3036 34.4331 25.6763 33.901 24.6854 33.901C23.3693 33.901 22.6054 35.0198 21.8684 36.1016C21.2008 37.0703 20.5639 38 19.546 38ZM14.8761 33.3884C16.3366 33.3884 16.9619 34.5579 17.516 35.5831C18.0433 36.5674 18.5012 37.4153 19.546 37.4153C20.2618 37.4153 20.7871 36.6454 21.3951 35.7546C22.1782 34.6047 23.0672 33.3007 24.6873 33.3007C25.8899 33.3007 26.6307 33.9303 27.2829 34.4858C27.8179 34.9399 28.2777 35.3317 28.9088 35.3317C29.54 35.3317 29.817 34.5774 30.1595 33.3339C30.5559 31.8915 31.0485 30.0944 32.9938 30.0944C33.0784 30.0944 33.1593 30.0944 33.242 30.1061C30.6964 23.4792 30.1634 19.0879 29.7189 15.5464C29.4745 13.5641 29.2629 11.8431 28.7357 10.2273C27.4542 6.28034 23.9119 3.61007 19.9212 3.58473C15.9363 3.61007 12.3959 6.28034 11.1145 10.2273C10.5853 11.8489 10.3756 13.5583 10.1312 15.5386C10.1312 15.5386 9.93881 17.1349 9.81758 17.9554C9.43276 20.6842 8.7266 24.4615 6.79092 29.6208C6.95365 29.5822 7.12021 29.5625 7.28735 29.5623C9.03254 29.5623 9.26921 31.26 9.47894 32.7569C9.69636 34.3162 9.90225 35.2693 10.897 35.2693C11.3627 35.2693 11.7975 34.9263 12.2997 34.5306C12.977 33.9907 13.7467 33.3884 14.8761 33.3884Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M11.0877 19.2477C10.7768 19.2389 10.4735 19.1474 10.2084 18.9826C9.83101 18.7559 9.51449 18.4386 9.28673 18.0587C9.24742 17.9928 9.23535 17.9139 9.25313 17.8391C9.27092 17.7642 9.31712 17.6995 9.38172 17.659C9.44632 17.6184 9.5241 17.6053 9.59818 17.6225C9.67225 17.6397 9.73665 17.6858 9.77738 17.7508C9.95511 18.0478 10.2014 18.2966 10.4951 18.4758C10.624 18.5659 10.7722 18.6235 10.9275 18.6439C11.0828 18.6642 11.2406 18.6467 11.3879 18.5928C11.4963 18.5354 11.5894 18.4522 11.6591 18.3503C11.7288 18.2485 11.7731 18.131 11.7881 18.008C11.917 17.2869 11.4437 16.3357 10.7548 15.9323C10.6361 15.8516 10.5019 15.7972 10.361 15.7727C10.22 15.7482 10.0756 15.7541 9.93709 15.79C9.90108 15.8021 9.86306 15.807 9.8252 15.8043C9.78734 15.8015 9.75039 15.7913 9.71644 15.7741C9.68249 15.7569 9.65222 15.7331 9.62735 15.704C9.60248 15.675 9.5835 15.6413 9.5715 15.6048C9.5595 15.5683 9.55471 15.5298 9.5574 15.4915C9.56009 15.4531 9.57021 15.4157 9.58718 15.3813C9.60416 15.3469 9.62765 15.3162 9.65632 15.291C9.685 15.2659 9.71829 15.2466 9.7543 15.2345C9.97053 15.1724 10.1973 15.1577 10.4196 15.1913C10.6419 15.2249 10.8545 15.3061 11.0435 15.4294C11.9536 15.9634 12.5308 17.1426 12.3557 18.1172C12.3272 18.3355 12.2459 18.5434 12.119 18.7222C11.9922 18.9011 11.8236 19.0454 11.6284 19.1424C11.458 19.2174 11.2734 19.2534 11.0877 19.2477Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.9877 23.2824C17.6773 23.2769 17.3738 23.1881 17.1084 23.0251C16.1982 22.491 15.621 21.3216 15.7922 20.347C15.8215 20.1279 15.9035 19.9195 16.031 19.74C16.1585 19.5605 16.3276 19.4156 16.5234 19.3179C16.7535 19.2238 17.0025 19.1874 17.2495 19.2119C17.4964 19.2363 17.7338 19.3208 17.9415 19.4582C18.8516 19.9903 19.4289 21.1695 19.2576 22.1441C19.2284 22.363 19.1464 22.5712 19.0188 22.7503C18.8913 22.9295 18.7222 23.074 18.5264 23.1713C18.357 23.2477 18.1731 23.2856 17.9877 23.2824ZM17.0641 19.774C16.9614 19.7732 16.8598 19.7944 16.7659 19.8364C16.6548 19.8956 16.5598 19.9815 16.4891 20.0864C16.4183 20.1914 16.3739 20.3123 16.3599 20.4386C16.2329 21.1598 16.7062 22.111 17.397 22.5125C17.5248 22.6024 17.6721 22.6599 17.8264 22.6802C17.9808 22.7006 18.1377 22.6832 18.284 22.6294C18.395 22.5709 18.4901 22.4855 18.5606 22.3807C18.6311 22.276 18.6749 22.1552 18.6881 22.0291C18.817 21.306 18.3417 20.3568 17.6529 19.9533C17.4749 19.8446 17.2719 19.7848 17.0641 19.7798V19.774Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M13.0099 25.6271C12.8326 25.6231 12.6594 25.572 12.5077 25.479C12.2524 25.3204 12.0443 25.0948 11.9054 24.8261C11.7665 24.5574 11.702 24.2557 11.7188 23.9528L11.8977 22.3663C11.9063 22.228 11.9492 22.0942 12.0225 21.9773C12.0959 21.8604 12.1973 21.7642 12.3172 21.6977C12.4515 21.6373 12.5987 21.6119 12.7452 21.6238C12.8917 21.6357 13.033 21.6846 13.1561 21.7659C13.3917 21.9131 13.5878 22.1169 13.7268 22.3594C13.8658 22.6019 13.9434 22.8754 13.9527 23.1557C13.9527 23.1998 13.9527 23.2447 13.9527 23.2901L13.7738 24.8806C13.7642 25.0186 13.7206 25.1519 13.647 25.2683C13.5734 25.3848 13.4721 25.4807 13.3524 25.5472C13.2461 25.6011 13.1287 25.6285 13.0099 25.6271ZM12.6539 22.2045C12.6274 22.2034 12.601 22.2088 12.5769 22.2201C12.5444 22.2445 12.518 22.2762 12.4996 22.3127C12.4812 22.3493 12.4715 22.3896 12.4711 22.4306L12.2922 24.0191C12.288 24.2088 12.3323 24.3963 12.4206 24.5636C12.5089 24.7309 12.6383 24.8723 12.7963 24.9742C12.8375 25.0049 12.8852 25.0255 12.9357 25.0343C12.9861 25.0431 13.0379 25.0399 13.0868 25.0248C13.1195 25.0004 13.1462 24.9688 13.1648 24.9323C13.1835 24.8958 13.1937 24.8554 13.1946 24.8143L13.3716 23.2278C13.3716 23.2063 13.3716 23.181 13.3716 23.1557C13.3615 22.9786 13.3105 22.8064 13.2226 22.653C13.1347 22.4996 13.0124 22.3694 12.8656 22.2727C12.8015 22.2329 12.7289 22.2095 12.6539 22.2045Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Je = /* @__PURE__ */ we({ default: () => Ye }), Ye, Xe = Se((() => {
	Ye = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M36.0235 9.63104C36.468 9.63104 36.8943 9.80492 37.2086 10.1145C37.523 10.424 37.6995 10.8438 37.6995 11.2815C37.6995 11.7193 37.523 12.1391 37.2086 12.4486C36.8943 12.7581 36.468 12.932 36.0235 12.932C35.9604 12.932 35.8953 12.932 35.8263 12.9223C35.4183 12.8739 35.0424 12.6801 34.7696 12.3774C34.4967 12.0748 34.3459 11.6843 34.3455 11.2796C34.3457 11.0628 34.3893 10.8483 34.4738 10.6481C34.5583 10.448 34.6819 10.2662 34.8378 10.1131C34.9936 9.96 35.1785 9.83864 35.3819 9.75593C35.5854 9.67322 35.8034 9.63078 36.0235 9.63104Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M35.8322 12.9184L34.1857 23.1378C34.1956 23.2563 34.1995 23.3747 34.1995 23.4951C34.1995 25.4873 32.8626 27.4796 30.1829 29C27.5032 30.5204 24.0012 31.2835 20.4953 31.2835C18.7601 31.2874 17.03 31.0959 15.339 30.7126C13.7506 30.3624 12.2227 29.7854 10.8038 29C8.12011 27.4796 6.78912 25.4873 6.78912 23.4951C6.78912 23.3747 6.78912 23.2563 6.80095 23.1378L5.16236 12.9184C5.26536 12.9062 5.36701 12.8848 5.46602 12.8543L8.10236 21.398L9.08828 18.7495C9.31547 18.8588 9.565 18.9156 9.81785 18.9156C10.0707 18.9156 10.3202 18.8588 10.5474 18.7495L15.5263 29.5825L19.6711 21.2524C19.9218 21.3924 20.2051 21.466 20.4933 21.466C20.7816 21.4666 21.0651 21.3929 21.3156 21.2524L25.4722 29.5844L30.455 18.7514C30.6819 18.8607 30.9311 18.9175 31.1836 18.9175C31.4362 18.9175 31.6854 18.8607 31.9122 18.7514L32.8981 21.4L35.5364 12.8563C35.633 12.8856 35.7319 12.9064 35.8322 12.9184Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M35.5286 12.8543L32.8902 21.398L31.9043 18.7495C32.2777 18.5692 32.5695 18.2583 32.7226 17.8776C32.8831 17.4845 32.8831 17.0455 32.7226 16.6524C32.6554 16.4904 32.563 16.3397 32.4486 16.2058L35.5286 12.8543Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M34.1995 23.4951L34.1995 27.9184C34.1995 29.9106 32.8626 31.9048 30.1829 33.4271C27.5032 34.9495 24.0012 35.7087 20.4953 35.7087C18.7601 35.7127 17.03 35.5211 15.339 35.1378C13.7501 34.7901 12.2219 34.2137 10.8038 33.4271C8.12011 31.9048 6.78912 29.9106 6.78912 27.9184L6.78912 23.4951C6.78912 25.4873 8.12799 27.4796 10.8057 29C12.2246 29.7854 13.7525 30.3624 15.341 30.7126C17.032 31.0959 18.762 31.2874 20.4973 31.2835C24.0032 31.2835 27.5091 30.5242 30.1849 29C32.8607 27.4757 34.1995 25.4873 34.1995 23.4951Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M34.3455 7.35531C34.3457 7.78341 34.1766 8.19475 33.874 8.50214C33.5714 8.80953 33.1591 8.98878 32.7246 9.00191H32.6714C32.3402 9.00191 32.0164 8.90517 31.7411 8.72394C31.4658 8.54271 31.2512 8.28513 31.1245 7.98379C30.9979 7.68244 30.9648 7.35087 31.0296 7.03104C31.0944 6.7112 31.254 6.41746 31.4883 6.18698C31.7226 5.95651 32.0211 5.79965 32.346 5.73626C32.6709 5.67287 33.0075 5.7058 33.3134 5.83087C33.6193 5.95594 33.8806 6.16754 34.0643 6.4389C34.248 6.71025 34.3459 7.02917 34.3455 7.35531Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.8508 17.264C32.8512 17.4716 32.811 17.6773 32.7325 17.8699C32.5793 18.2506 32.2876 18.5614 31.9142 18.7417C31.6873 18.851 31.4381 18.9078 31.1856 18.9078C30.9331 18.9078 30.6839 18.851 30.457 18.7417C30.1198 18.5784 29.8483 18.3078 29.6866 17.9737C29.5248 17.6396 29.4823 17.2616 29.5657 16.9007C29.6492 16.5398 29.8538 16.2172 30.1465 15.9851C30.4392 15.7529 30.8029 15.6248 31.1787 15.6213C31.3597 15.6208 31.5396 15.6497 31.7111 15.7068C32.0003 15.8026 32.2574 15.9745 32.4545 16.2039C32.5689 16.3378 32.6614 16.4884 32.7286 16.6505C32.8097 16.8451 32.8512 17.0536 32.8508 17.264Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.7266 9.01938L31.7111 15.699C31.5396 15.6419 31.3597 15.613 31.1787 15.6136C30.7984 15.6115 30.4289 15.7374 30.1311 15.9702C29.8333 16.2031 29.6251 16.5291 29.541 16.8943C29.4568 17.2594 29.5017 17.642 29.6683 17.9786C29.8349 18.3152 30.1131 18.5858 30.457 18.7456L29.0412 21.8349C26.9984 20.9068 24.5948 20.3572 22.126 20.1903C22.154 20.0718 22.1678 19.9507 22.1674 19.8291C22.1677 19.6127 22.1246 19.3984 22.0407 19.1984C21.9568 18.9984 21.8337 18.8166 21.6784 18.6635C21.5231 18.5104 21.3387 18.3889 21.1357 18.3061C20.9327 18.2232 20.7151 18.1805 20.4953 18.1805C20.0513 18.1805 19.6255 18.3542 19.3116 18.6634C18.9976 18.9726 18.8212 19.3919 18.8212 19.8291C18.8208 19.9507 18.8347 20.0718 18.8626 20.1903C16.4018 20.3475 13.9902 20.8971 11.9474 21.8349L10.5336 18.7514C10.8748 18.5896 11.15 18.3186 11.3144 17.9827C11.4787 17.6468 11.5225 17.266 11.4384 16.9024C11.3544 16.5389 11.1475 16.2142 10.8517 15.9814C10.5559 15.7487 10.1886 15.6218 9.80997 15.6213C9.62893 15.6206 9.44903 15.6495 9.27757 15.7068L8.25814 9.00385H8.31729C8.54208 9.00376 8.76456 8.9592 8.97152 8.87281C9.17848 8.78642 9.36571 8.65996 9.52208 8.50094L15.5125 14.9184L19.7539 6.42133C19.9834 6.53453 20.2367 6.59306 20.4933 6.5922C20.7494 6.59348 21.0022 6.53492 21.2308 6.42133L25.4722 14.9184L31.4705 8.50094C31.6266 8.65981 31.8135 8.78619 32.0201 8.87258C32.2267 8.95897 32.4489 9.00361 32.6733 9.00385L32.7266 9.01938Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.1674 19.8194C22.1658 19.9412 22.1499 20.0624 22.1201 20.1805C22.0692 20.4045 21.9713 20.6155 21.8328 20.8001C21.6942 20.9847 21.5181 21.1387 21.3156 21.2524C21.0657 21.3926 20.783 21.4662 20.4953 21.466C20.1153 21.4655 19.7467 21.3378 19.45 21.1039C19.1534 20.8699 18.9463 20.5437 18.8626 20.1786C18.8358 20.06 18.8219 19.9389 18.8212 19.8174C18.8212 19.3802 18.9976 18.9609 19.3116 18.6517C19.6255 18.3426 20.0513 18.1689 20.4953 18.1689C20.7152 18.1689 20.933 18.2116 21.1361 18.2946C21.3392 18.3776 21.5238 18.4992 21.6791 18.6525C21.8344 18.8059 21.9575 18.9878 22.0413 19.1881C22.1251 19.3883 22.1679 19.6028 22.1674 19.8194Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.1674 4.94171C22.1673 5.24913 22.0796 5.55035 21.9144 5.81119C21.7492 6.07204 21.5131 6.28206 21.2328 6.41744C21.0041 6.53104 20.7514 6.5896 20.4953 6.58832C20.238 6.58948 19.984 6.53094 19.7539 6.41744C19.4155 6.25263 19.1437 5.98004 18.9824 5.64391C18.8212 5.30778 18.78 4.92786 18.8657 4.5658C18.9513 4.20375 19.1587 3.88083 19.4542 3.64946C19.7496 3.41808 20.1158 3.29184 20.4933 3.29123C20.7134 3.29097 20.9314 3.3335 21.1348 3.41638C21.3381 3.49926 21.5229 3.62085 21.6784 3.77419C21.8339 3.92753 21.9572 4.1096 22.0411 4.30995C22.125 4.5103 22.1679 4.72499 22.1674 4.94171Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M11.4841 17.264C11.4849 17.5746 11.396 17.8791 11.2277 18.1417C11.0594 18.4044 10.8187 18.6145 10.5336 18.7475C10.3064 18.8568 10.0569 18.9136 9.80405 18.9136C9.5512 18.9136 9.30167 18.8568 9.07447 18.7475C8.70013 18.5679 8.40753 18.2569 8.25419 17.8757C8.17565 17.6831 8.13548 17.4774 8.13588 17.2699C8.13662 17.0577 8.1781 16.8475 8.25814 16.6505C8.32536 16.4876 8.41929 16.3367 8.53616 16.2038C8.73267 15.9743 8.98899 15.8017 9.27757 15.7048C9.44903 15.6476 9.62893 15.6187 9.80997 15.6194C10.0296 15.6191 10.247 15.6615 10.45 15.744C10.653 15.8265 10.8375 15.9476 10.9929 16.1003C11.1484 16.253 11.2717 16.4344 11.356 16.6341C11.4403 16.8337 11.4838 17.0478 11.4841 17.264Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M9.98546 7.35531C9.98598 7.79168 9.81059 8.21041 9.4978 8.51951C9.18501 8.82862 8.76042 9.00282 8.31729 9.00385H8.25814C7.92942 8.99355 7.61106 8.88813 7.34281 8.70076C7.07456 8.51338 6.8683 8.25235 6.74978 7.95024C6.63126 7.64814 6.60572 7.31835 6.67637 7.00204C6.74701 6.68574 6.9107 6.39693 7.147 6.17167C7.3833 5.94641 7.68174 5.79468 8.00508 5.73543C8.32841 5.67617 8.6623 5.71201 8.96508 5.83847C9.26785 5.96494 9.52609 6.17642 9.70756 6.44652C9.88902 6.71663 9.98568 7.03338 9.98546 7.35725V7.35531Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M9.07447 18.7417L8.08856 21.3903L5.45222 12.8466L8.53616 16.2038C8.41886 16.335 8.32486 16.4846 8.25814 16.6466C8.1781 16.8436 8.13662 17.0538 8.13588 17.266C8.13548 17.4735 8.17565 17.6792 8.25419 17.8718C8.40795 18.2523 8.70049 18.5626 9.07447 18.7417Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M6.63729 11.2796C6.63651 11.6828 6.48619 12.0719 6.21458 12.3737C5.94298 12.6755 5.5688 12.8692 5.16236 12.9184C5.09691 12.9257 5.03105 12.929 4.96518 12.9281C4.63408 12.9281 4.31041 12.8314 4.03511 12.6503C3.7598 12.4691 3.54523 12.2117 3.41853 11.9104C3.29182 11.6092 3.25867 11.2778 3.32326 10.958C3.38786 10.6382 3.5473 10.3444 3.78142 10.1139C4.01555 9.88333 4.31384 9.72632 4.63858 9.66271C4.96332 9.5991 5.29992 9.63175 5.60582 9.75652C5.91172 9.8813 6.17318 10.0926 6.35713 10.3637C6.54108 10.6348 6.63926 10.9535 6.63926 11.2796H6.63729Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M15.5125 29.8757C15.4563 29.8749 15.4014 29.8584 15.3543 29.8281C15.3072 29.7979 15.2698 29.7551 15.2463 29.7048L10.2635 18.8699C10.2313 18.7993 10.2289 18.7191 10.2569 18.6468C10.2848 18.5745 10.3407 18.5161 10.4124 18.4844C10.484 18.4528 10.5655 18.4504 10.6389 18.4779C10.7123 18.5054 10.7716 18.5605 10.8038 18.631L15.5243 28.9029L19.4069 21.1262C19.4436 21.0607 19.5045 21.0117 19.577 20.9893C19.6494 20.9668 19.7278 20.9727 19.796 21.0056C19.8642 21.0386 19.9169 21.0961 19.9432 21.1662C19.9695 21.2364 19.9674 21.3138 19.9373 21.3825L15.7787 29.7126C15.7541 29.7615 15.7162 29.8026 15.6692 29.8314C15.6221 29.8603 15.5679 29.8756 15.5125 29.8757Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M25.4722 29.8757C25.417 29.8759 25.3629 29.8607 25.3161 29.8318C25.2694 29.8029 25.2319 29.7616 25.208 29.7126L21.0514 21.3825C21.0213 21.3138 21.0192 21.2364 21.0455 21.1662C21.0718 21.0961 21.1245 21.0386 21.1927 21.0056C21.2608 20.9727 21.3393 20.9668 21.4117 20.9893C21.4841 21.0117 21.545 21.0607 21.5818 21.1262L25.4722 28.9029L30.2046 18.631C30.2198 18.595 30.2423 18.5623 30.2705 18.535C30.2988 18.5076 30.3324 18.4861 30.3693 18.4718C30.4062 18.4575 30.4457 18.4506 30.4853 18.4516C30.5249 18.4526 30.564 18.4615 30.6001 18.4776C30.6362 18.4938 30.6686 18.5169 30.6954 18.5456C30.7223 18.5744 30.743 18.6081 30.7563 18.6449C30.7696 18.6817 30.7753 18.7207 30.773 18.7597C30.7707 18.7987 30.7605 18.8368 30.7429 18.8718L25.7621 29.7048C25.739 29.755 25.7019 29.7977 25.6551 29.8279C25.6083 29.8582 25.5538 29.8747 25.4979 29.8757H25.4722Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M8.09645 21.6815C8.06208 21.6823 8.02789 21.6764 7.99588 21.664C7.92216 21.6378 7.86206 21.5837 7.82879 21.5138C7.79551 21.4439 7.79178 21.3638 7.81842 21.2912L8.80433 18.6427C8.8151 18.6041 8.83383 18.5681 8.85936 18.5369C8.88488 18.5058 8.91666 18.4801 8.9527 18.4616C8.98874 18.4431 9.02827 18.4321 9.06883 18.4293C9.10938 18.4265 9.15009 18.4319 9.1884 18.4453C9.22672 18.4587 9.26182 18.4797 9.29152 18.507C9.32122 18.5344 9.34488 18.5674 9.36102 18.6042C9.37716 18.6409 9.38543 18.6806 9.38532 18.7206C9.38522 18.7606 9.37673 18.8002 9.36039 18.8369L8.37447 21.4873C8.35464 21.5443 8.31713 21.5937 8.26724 21.6286C8.21735 21.6634 8.15761 21.6819 8.09645 21.6815Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.8902 21.6815C32.8292 21.6816 32.7695 21.663 32.7197 21.6282C32.6699 21.5934 32.6323 21.5442 32.6122 21.4873L31.6263 18.8369C31.6128 18.8009 31.6068 18.7627 31.6084 18.7244C31.6101 18.6862 31.6194 18.6486 31.6359 18.6139C31.6524 18.5793 31.6758 18.5481 31.7046 18.5224C31.7334 18.4967 31.7671 18.4768 31.8038 18.464C31.8775 18.4383 31.9586 18.4423 32.0295 18.475C32.1003 18.5077 32.1552 18.5665 32.1824 18.6388L33.1624 21.2912C33.189 21.3638 33.1853 21.4439 33.152 21.5138C33.1187 21.5837 33.0586 21.6378 32.9849 21.664C32.9547 21.6757 32.9226 21.6816 32.8902 21.6815Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M8.09645 21.6815C8.03321 21.6817 7.97162 21.6617 7.92082 21.6246C7.87002 21.5875 7.83272 21.5353 7.81447 21.4757L5.17616 12.932C5.15658 12.8686 5.15953 12.8005 5.18454 12.739C5.20954 12.6775 5.2551 12.6262 5.3137 12.5936C5.37229 12.561 5.44042 12.5491 5.50683 12.5598C5.57324 12.5705 5.63396 12.6031 5.67898 12.6524L8.75307 16.0097C8.78435 16.0368 8.80947 16.0701 8.82678 16.1074C8.84408 16.1448 8.85317 16.1853 8.85347 16.2263C8.85376 16.2674 8.84524 16.308 8.82847 16.3456C8.81171 16.3831 8.78706 16.4168 8.75617 16.4443C8.72527 16.4719 8.68881 16.4926 8.64917 16.5053C8.60954 16.518 8.56764 16.5223 8.5262 16.518C8.48476 16.5136 8.44473 16.5006 8.40873 16.48C8.37273 16.4593 8.34157 16.4314 8.31729 16.398L6.12659 14.0136L8.38039 21.3068C8.40311 21.3807 8.3951 21.4604 8.35813 21.5285C8.32115 21.5966 8.25824 21.6474 8.18321 21.6699C8.15494 21.6775 8.12576 21.6815 8.09645 21.6815Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.8902 21.6815C32.8609 21.6813 32.8318 21.6774 32.8035 21.6699C32.7285 21.6474 32.6655 21.5966 32.6286 21.5285C32.5916 21.4604 32.5836 21.3807 32.6063 21.3068L34.8581 14.0136L32.6733 16.398C32.6487 16.4304 32.6175 16.4573 32.5817 16.4771C32.5459 16.4969 32.5063 16.5091 32.4654 16.5131C32.4245 16.517 32.3833 16.5124 32.3443 16.4998C32.3053 16.4871 32.2694 16.4666 32.2388 16.4395C32.2083 16.4125 32.1839 16.3795 32.167 16.3426C32.1502 16.3057 32.1414 16.2658 32.141 16.2253C32.1407 16.1849 32.149 16.1448 32.1653 16.1077C32.1815 16.0706 32.2055 16.0372 32.2356 16.0097L35.3077 12.666C35.3527 12.6167 35.4135 12.5841 35.4799 12.5734C35.5463 12.5627 35.6144 12.5746 35.673 12.6072C35.7316 12.6398 35.7771 12.6911 35.8022 12.7526C35.8272 12.8141 35.8301 12.8822 35.8105 12.9456L33.1742 21.4893C33.1529 21.5464 33.1142 21.5955 33.0633 21.63C33.0125 21.6644 32.952 21.6824 32.8902 21.6815Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M9.27757 15.9903C9.20655 15.9901 9.1379 15.965 9.08402 15.9195C9.03014 15.8739 8.99459 15.8108 8.98377 15.7417L7.9663 9.04657C7.9548 8.96932 7.97493 8.89074 8.02226 8.8281C8.06959 8.76547 8.14025 8.72392 8.2187 8.71259C8.29714 8.70126 8.37695 8.72108 8.44055 8.76769C8.50415 8.8143 8.54635 8.88388 8.55785 8.96113L9.57532 15.6563C9.58118 15.694 9.5794 15.7326 9.57006 15.7696C9.56073 15.8067 9.54403 15.8416 9.52093 15.8723C9.49783 15.903 9.46879 15.9289 9.43548 15.9484C9.40218 15.968 9.36526 15.9809 9.32687 15.9864L9.27757 15.9903Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M31.7111 15.9903H31.6657C31.6273 15.9848 31.5904 15.9719 31.5571 15.9523C31.5238 15.9328 31.4948 15.9069 31.4717 15.8762C31.4486 15.8455 31.4319 15.8106 31.4225 15.7735C31.4132 15.7365 31.4114 15.6979 31.4173 15.6602L32.4348 8.97084C32.4368 8.95427 32.4408 8.93799 32.4466 8.9223C32.4693 8.84992 32.5198 8.7891 32.5872 8.75275C32.6547 8.7164 32.7339 8.70737 32.8081 8.72758C32.8822 8.74779 32.9454 8.79565 32.9844 8.861C33.0233 8.92636 33.0348 9.00406 33.0164 9.07764L32.0029 15.7456C31.9921 15.814 31.9566 15.8763 31.9031 15.9212C31.8495 15.9661 31.7814 15.9906 31.7111 15.9903Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M15.5125 15.2097C15.4717 15.2099 15.4314 15.2017 15.394 15.1857C15.3567 15.1696 15.3231 15.1461 15.2956 15.1165L9.30321 8.699C9.27192 8.67189 9.2468 8.63858 9.2295 8.60124C9.21219 8.56391 9.2031 8.5234 9.2028 8.48236C9.20251 8.44132 9.21103 8.40069 9.2278 8.36312C9.24457 8.32555 9.26921 8.29189 9.30011 8.26436C9.33101 8.23682 9.36747 8.21602 9.4071 8.20333C9.44673 8.19064 9.48863 8.18634 9.53007 8.19071C9.57151 8.19508 9.61154 8.20802 9.64754 8.22869C9.68354 8.24936 9.7147 8.27729 9.73898 8.31065L15.4376 14.4077L19.4897 6.30094C19.5069 6.26664 19.5308 6.23602 19.5601 6.21082C19.5893 6.18563 19.6233 6.16635 19.6601 6.15409C19.6969 6.14183 19.7358 6.13682 19.7745 6.13936C19.8133 6.14191 19.8512 6.15194 19.886 6.1689C19.9209 6.18586 19.9519 6.2094 19.9775 6.23819C20.0031 6.26698 20.0227 6.30046 20.0352 6.3367C20.0476 6.37294 20.0527 6.41124 20.0501 6.44942C20.0475 6.48759 20.0373 6.52489 20.0201 6.55919L15.7787 15.0388C15.7576 15.0814 15.7262 15.1183 15.6874 15.1464C15.6486 15.1745 15.6035 15.1928 15.5559 15.2L15.5125 15.2097Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M25.4722 15.2097H25.4308C25.3831 15.2029 25.3378 15.1846 25.299 15.1565C25.2601 15.1284 25.2289 15.0913 25.208 15.0485L20.9666 6.54948C20.941 6.48123 20.9423 6.40602 20.9702 6.33866C20.9981 6.2713 21.0506 6.21666 21.1174 6.1855C21.1841 6.15434 21.2603 6.1489 21.3309 6.17026C21.4016 6.19163 21.4615 6.23824 21.499 6.30094L25.5491 14.4174L31.2556 8.31453C31.2796 8.28035 31.3107 8.25161 31.3468 8.23024C31.383 8.20887 31.4234 8.19536 31.4653 8.19061C31.5071 8.18587 31.5496 8.19001 31.5897 8.20274C31.6299 8.21548 31.6668 8.23652 31.698 8.26445C31.7292 8.29239 31.754 8.32657 31.7707 8.36471C31.7873 8.40285 31.7956 8.44406 31.7947 8.48559C31.7939 8.52711 31.7841 8.56798 31.7659 8.60545C31.7478 8.64293 31.7217 8.67615 31.6894 8.70288L25.6931 15.1165C25.6648 15.1463 25.6306 15.1699 25.5926 15.186C25.5546 15.202 25.5136 15.2101 25.4722 15.2097Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M20.4953 31.5747C18.7366 31.5785 16.9833 31.3831 15.27 30.9922C13.6539 30.6355 12.0999 30.0467 10.6579 29.2446C7.97222 27.7204 6.49335 25.6757 6.49335 23.4873C6.49335 23.3708 6.49335 23.2582 6.50518 23.1437L4.86461 12.9631C4.85853 12.9248 4.86015 12.8858 4.8694 12.8481C4.87864 12.8105 4.89532 12.775 4.91848 12.7438C4.94164 12.7125 4.97083 12.686 5.00439 12.6658C5.03795 12.6456 5.07521 12.6322 5.11405 12.6262C5.1925 12.6141 5.27261 12.6332 5.33677 12.6792C5.40093 12.7253 5.44387 12.7946 5.45616 12.8718L7.10067 23.0912C7.10261 23.1119 7.10261 23.1327 7.10067 23.1534C7.10067 23.2679 7.08884 23.3806 7.08884 23.4951C7.08884 25.466 8.46912 27.332 10.9576 28.7475C12.3494 29.5196 13.8489 30.0862 15.408 30.4291C17.077 30.8075 18.7846 30.9964 20.4973 30.9922C24.1097 30.9922 27.4973 30.1941 30.039 28.7475C32.5353 27.332 33.9077 25.466 33.9077 23.5048C33.9077 23.3922 33.9077 23.2815 33.8959 23.1689C33.893 23.1463 33.893 23.1235 33.8959 23.1009L35.5424 12.8815C35.5546 12.8043 35.5976 12.735 35.6618 12.6889C35.6935 12.6661 35.7295 12.6497 35.7678 12.6406C35.806 12.6315 35.8456 12.6299 35.8845 12.6359C35.9233 12.6419 35.9606 12.6554 35.9941 12.6755C36.0277 12.6957 36.0569 12.7222 36.08 12.7535C36.1032 12.7847 36.1199 12.8202 36.1291 12.8578C36.1384 12.8955 36.14 12.9345 36.1339 12.9728L34.4933 23.1592C34.4933 23.2757 34.5052 23.3883 34.5052 23.5048C34.5052 25.6932 33.0263 27.7378 30.3407 29.2621C27.7004 30.7495 24.2083 31.5747 20.4953 31.5747Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M11.9474 22.1165C11.8801 22.1163 11.8149 22.0936 11.7625 22.0521C11.7101 22.0105 11.6736 21.9526 11.6591 21.8879C11.6447 21.8232 11.653 21.7555 11.6828 21.6961C11.7127 21.6367 11.7622 21.5891 11.8232 21.5611C14.0418 20.5948 16.419 20.0298 18.841 19.8932C18.88 19.8894 18.9195 19.8935 18.9569 19.905C18.9944 19.9165 19.0291 19.9354 19.0591 19.9603C19.0891 19.9853 19.1136 20.016 19.1314 20.0504C19.1491 20.0849 19.1596 20.1226 19.1624 20.1611C19.1672 20.2383 19.141 20.3142 19.0893 20.3724C19.0376 20.4306 18.9646 20.4663 18.8863 20.4718C16.5319 20.6027 14.2207 21.1506 12.0638 22.0893C12.0274 22.1064 11.9877 22.1156 11.9474 22.1165Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.0412 22.1165C28.9982 22.117 28.9557 22.1077 28.917 22.0893C26.7636 21.1529 24.4565 20.6063 22.1063 20.4757C22.0675 20.4732 22.0296 20.4632 21.9948 20.4462C21.9599 20.4292 21.9289 20.4056 21.9034 20.3767C21.8779 20.3478 21.8585 20.3142 21.8463 20.2779C21.834 20.2415 21.8293 20.2032 21.8322 20.165C21.8342 20.1267 21.844 20.0892 21.8609 20.0547C21.8778 20.0202 21.9016 19.9894 21.9308 19.964C21.96 19.9387 21.9941 19.9194 22.031 19.9072C22.0679 19.895 22.1069 19.8903 22.1457 19.8932C24.5684 20.0306 26.9462 20.5963 29.1655 21.5631C29.2265 21.591 29.276 21.6386 29.3058 21.698C29.3356 21.7574 29.344 21.8251 29.3295 21.8898C29.3151 21.9545 29.2786 22.0124 29.2262 22.054C29.1738 22.0956 29.1085 22.1183 29.0412 22.1184V22.1165Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M20.4953 36.0097C18.7366 36.0135 16.9833 35.818 15.27 35.4272C13.6536 35.0713 12.0995 34.4825 10.6579 33.6796C7.97222 32.1534 6.49335 30.1068 6.49335 27.9184V23.4951C6.49335 23.4179 6.52451 23.3438 6.57998 23.2892C6.63545 23.2345 6.71068 23.2038 6.78912 23.2038C6.86757 23.2038 6.9428 23.2345 6.99827 23.2892C7.05373 23.3438 7.0849 23.4179 7.0849 23.4951V27.9184C7.0849 29.8893 8.46518 31.7572 10.9536 33.1767C12.3461 33.9466 13.8455 34.5118 15.4041 34.8543C17.0727 35.236 18.7803 35.4282 20.4933 35.4272C24.1038 35.4272 27.4933 34.631 30.035 33.1864C32.5294 31.767 33.9038 29.899 33.9038 27.9281V23.4951C33.9038 23.4179 33.9349 23.3438 33.9904 23.2892C34.0459 23.2345 34.1211 23.2038 34.1995 23.2038C34.278 23.2038 34.3532 23.2345 34.4087 23.2892C34.4642 23.3438 34.4953 23.4179 34.4953 23.4951V27.9184C34.4953 30.1068 33.0164 32.1534 30.3308 33.6796C27.7004 35.1767 24.2063 36.0097 20.4953 36.0097Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M20.4953 6.88346C20.1936 6.88486 19.8955 6.81845 19.6238 6.68929C19.1882 6.48151 18.8454 6.12321 18.6607 5.68262C18.476 5.24204 18.4623 4.74996 18.6223 4.30009C18.7822 3.85023 19.1046 3.47401 19.5281 3.2431C19.9515 3.01218 20.4464 2.94269 20.9185 3.04787C21.3906 3.15305 21.8069 3.42554 22.0881 3.81346C22.3694 4.20138 22.4959 4.67761 22.4436 5.15146C22.3914 5.62532 22.1639 6.06368 21.8046 6.38307C21.4454 6.70247 20.9793 6.88057 20.4953 6.88346ZM20.4953 3.58249C20.2223 3.58249 19.9555 3.66221 19.7285 3.81156C19.5015 3.96092 19.3246 4.1732 19.2201 4.42156C19.1156 4.66993 19.0883 4.94322 19.1416 5.20689C19.1948 5.47055 19.3263 5.71274 19.5193 5.90283C19.7123 6.09292 19.9583 6.22238 20.226 6.27482C20.4938 6.32727 20.7713 6.30035 21.0235 6.19747C21.2757 6.0946 21.4913 5.92038 21.643 5.69686C21.7946 5.47334 21.8756 5.21054 21.8756 4.94172C21.8756 4.58123 21.7302 4.2355 21.4713 3.9806C21.2125 3.7257 20.8614 3.58249 20.4953 3.58249Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M8.31729 9.29511H8.23842C7.72864 9.28564 7.24328 9.07836 6.88788 8.71835C6.53249 8.35833 6.33581 7.8747 6.34062 7.37264C6.34542 6.87057 6.55133 6.39068 6.91356 6.03733C7.27578 5.68397 7.76503 5.48574 8.2749 5.48574C8.78476 5.48574 9.27401 5.68397 9.63624 6.03733C9.99846 6.39068 10.2044 6.87057 10.2092 7.37264C10.214 7.8747 10.0173 8.35833 9.66191 8.71835C9.30651 9.07836 8.82115 9.28564 8.31137 9.29511H8.31729ZM8.31729 5.99414C7.95122 5.98848 7.59785 6.12625 7.33493 6.37715C7.07201 6.62804 6.92107 6.97152 6.91532 7.33201C6.90957 7.69249 7.04947 8.04047 7.30426 8.29938C7.55904 8.55829 7.90784 8.70692 8.27391 8.71259H8.30152C8.48821 8.71394 8.67324 8.67799 8.84541 8.6069C9.01758 8.53581 9.17332 8.43106 9.30321 8.299C9.49018 8.10738 9.61602 7.866 9.66516 7.6047C9.71429 7.3434 9.68457 7.07365 9.57966 6.82882C9.47475 6.58398 9.29927 6.37479 9.0749 6.22714C8.85054 6.07948 8.58714 5.99982 8.31729 5.99803V5.99414Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.6753 9.29511C32.152 9.28539 31.6538 9.07261 31.289 8.70305C30.9242 8.33349 30.7223 7.83704 30.7272 7.32167C30.7322 6.8063 30.9435 6.31369 31.3154 5.95098C31.6872 5.58827 32.1894 5.38478 32.7128 5.38478C33.2362 5.38478 33.7384 5.58827 34.1102 5.95098C34.482 6.31369 34.6934 6.8063 34.6983 7.32167C34.7033 7.83704 34.5014 8.33349 34.1366 8.70305C33.7718 9.07261 33.2735 9.28539 32.7502 9.29511H32.6753ZM31.6894 8.299C31.8174 8.42918 31.9706 8.53283 32.1399 8.60386C32.3093 8.67489 32.4913 8.71186 32.6753 8.71259H32.7187C33.0352 8.70287 33.3386 8.58631 33.5782 8.38244C33.8177 8.17858 33.9788 7.89981 34.0345 7.59287C34.0901 7.28593 34.0369 6.96949 33.8838 6.6966C33.7306 6.4237 33.4869 6.21095 33.1934 6.09402C32.8998 5.97708 32.5744 5.96307 32.2717 6.05433C31.9689 6.14559 31.7072 6.33657 31.5305 6.59526C31.3537 6.85394 31.2727 7.1646 31.3009 7.47515C31.3291 7.7857 31.4649 8.07726 31.6855 8.30094L31.6894 8.299Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M9.80997 19.2019C9.50937 19.2045 9.21231 19.138 8.94236 19.0077C8.61086 18.8473 8.33178 18.5985 8.1369 18.2895C7.94202 17.9805 7.83919 17.6239 7.84011 17.2602C7.84062 17.0177 7.88675 16.7774 7.97616 16.5514C7.97701 16.5437 7.97701 16.5359 7.97616 16.5281C8.08736 16.2714 8.25232 16.0406 8.46027 15.8509C8.66821 15.6611 8.91446 15.5168 9.18292 15.4272C9.38482 15.3596 9.59672 15.3254 9.80997 15.3262C10.0689 15.3262 10.3253 15.3764 10.5646 15.474C10.8038 15.5716 11.0212 15.7146 11.2043 15.8949C11.3874 16.0752 11.5326 16.2893 11.6317 16.5249C11.7308 16.7604 11.7818 17.0129 11.7818 17.2679C11.7818 17.5229 11.7308 17.7754 11.6317 18.011C11.5326 18.2466 11.3874 18.4606 11.2043 18.641C11.0212 18.8213 10.8038 18.9643 10.5646 19.0619C10.3253 19.1595 10.0689 19.2097 9.80997 19.2097V19.2019ZM8.54011 16.7359C8.54085 16.7417 8.54085 16.7476 8.54011 16.7534C8.47351 16.9156 8.43937 17.089 8.43954 17.264C8.43816 17.4324 8.46824 17.5996 8.52828 17.7572C8.62724 18.0046 8.79773 18.218 9.01861 18.371C9.2395 18.5239 9.50109 18.6097 9.77099 18.6177C10.0409 18.6257 10.3072 18.5555 10.5371 18.416C10.7669 18.2764 10.9501 18.0735 11.064 17.8324C11.1779 17.5913 11.2175 17.3226 11.1778 17.0596C11.1382 16.7966 11.0211 16.5508 10.841 16.3526C10.661 16.1545 10.4258 16.0127 10.1648 15.9448C9.90369 15.877 9.62813 15.886 9.37222 15.9708C9.13273 16.0557 8.92135 16.2034 8.76095 16.398C8.67075 16.4993 8.59632 16.6131 8.54011 16.7359Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M31.1787 19.2019C30.8835 19.2012 30.5923 19.1349 30.3269 19.0077C29.9258 18.8164 29.6023 18.497 29.4092 18.1014C29.2161 17.7059 29.1648 17.2576 29.2636 16.8296C29.3624 16.4017 29.6055 16.0193 29.9533 15.7449C30.3011 15.4704 30.733 15.3201 31.1787 15.3184C31.4648 15.3195 31.7472 15.382 32.0063 15.5013C32.2654 15.6207 32.495 15.7942 32.6793 16.0097C32.8144 16.1666 32.9235 16.3435 33.0026 16.5339C33.0034 16.5404 33.0034 16.5469 33.0026 16.5534C33.094 16.7794 33.1402 17.0207 33.1387 17.264C33.1413 17.6281 33.0391 17.9854 32.844 18.2947C32.649 18.6039 32.369 18.8525 32.0364 19.0116C31.7692 19.1391 31.4757 19.2042 31.1787 19.2019ZM30.5872 18.4854C30.797 18.5834 31.0286 18.6277 31.2605 18.6142C31.4924 18.6006 31.717 18.5297 31.9136 18.4079C32.1102 18.2861 32.2725 18.1174 32.3853 17.9175C32.4981 17.7175 32.5578 17.4928 32.559 17.264C32.5602 17.0904 32.5267 16.9182 32.4604 16.7572V16.7339C32.384 16.5569 32.2703 16.3979 32.1269 16.2674C31.9834 16.1368 31.8135 16.0377 31.6283 15.9767C31.4879 15.9301 31.3407 15.9064 31.1925 15.9068C30.8824 15.9107 30.5827 16.0174 30.3417 16.2097C30.1007 16.4019 29.9324 16.6685 29.8641 16.9664C29.7957 17.2643 29.8313 17.5762 29.965 17.8517C30.0986 18.1273 30.3227 18.3505 30.601 18.4854H30.5872Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M4.96518 13.2194C4.46818 13.2177 3.99015 13.0313 3.62674 12.6975C3.26333 12.3636 3.04135 11.9069 3.00522 11.4188C2.96909 10.9307 3.12148 10.4471 3.43189 10.0649C3.7423 9.68268 4.18783 9.42998 4.67933 9.35738C5.17083 9.28478 5.67205 9.39763 6.08268 9.67335C6.49331 9.94906 6.78306 10.3673 6.89395 10.8444C7.00485 11.3215 6.92871 11.8222 6.68076 12.2464C6.43282 12.6705 6.03136 12.9868 5.55673 13.132C5.43967 13.1679 5.31956 13.1932 5.19785 13.2077C5.12056 13.2157 5.04289 13.2196 4.96518 13.2194ZM4.96518 9.91841C4.5991 9.91841 4.24802 10.0616 3.98917 10.3165C3.73032 10.5714 3.5849 10.9171 3.5849 11.2776C3.5849 11.6381 3.73032 11.9838 3.98917 12.2388C4.24802 12.4937 4.5991 12.6369 4.96518 12.6369C5.01838 12.6398 5.0717 12.6398 5.1249 12.6369C5.2084 12.6262 5.29085 12.6087 5.37137 12.5844C5.69041 12.4911 5.96448 12.2874 6.14309 12.0109C6.32169 11.7344 6.39282 11.4036 6.34337 11.0795C6.29392 10.7554 6.12722 10.4598 5.87397 10.2472C5.62072 10.0345 5.29797 9.91916 4.96518 9.9223V9.91841Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M36.0235 13.2194C35.9477 13.2194 35.8721 13.2155 35.7967 13.2077C35.6751 13.1929 35.555 13.1676 35.4379 13.132C34.9632 12.9868 34.5618 12.6705 34.3138 12.2464C34.0659 11.8222 33.9897 11.3215 34.1006 10.8444C34.2115 10.3673 34.5013 9.94906 34.9119 9.67335C35.3225 9.39763 35.8237 9.28478 36.3153 9.35738C36.8068 9.42998 37.2523 9.68268 37.5627 10.0649C37.8731 10.4471 38.0255 10.9307 37.9894 11.4188C37.9532 11.9069 37.7313 12.3636 37.3678 12.6975C37.0044 13.0313 36.5264 13.2177 36.0294 13.2194H36.0235ZM35.6173 12.5767C35.6991 12.6013 35.7829 12.6188 35.8677 12.6291C36.2203 12.6698 36.5752 12.5751 36.8588 12.3648C37.1423 12.1545 37.3327 11.8447 37.3903 11.4997C37.4479 11.1548 37.3683 10.8013 37.1682 10.5126C36.968 10.2239 36.6625 10.0223 36.3153 9.94959C35.9681 9.8769 35.6058 9.93873 35.3037 10.1223C35.0015 10.3058 34.7828 10.5969 34.693 10.935C34.6031 11.2732 34.649 11.6325 34.8212 11.9382C34.9933 12.2439 35.2784 12.4726 35.6173 12.5767Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M20.4953 21.7592C20.0478 21.7595 19.6136 21.6099 19.2638 21.3351C18.9141 21.0602 18.6697 20.6763 18.5708 20.2466C18.5378 20.1065 18.5212 19.9632 18.5215 19.8194C18.5215 19.3044 18.7293 18.8105 19.0991 18.4464C19.4688 18.0822 19.9704 17.8776 20.4933 17.8776C21.0163 17.8776 21.5179 18.0822 21.8876 18.4464C22.2574 18.8105 22.4652 19.3044 22.4652 19.8194C22.4655 19.9632 22.4489 20.1065 22.4159 20.2466C22.3172 20.6754 22.0737 21.0585 21.7252 21.3332C21.3767 21.608 20.9438 21.7582 20.4973 21.7592H20.4953ZM20.4953 18.4582C20.1292 18.4582 19.7782 18.6014 19.5193 18.8563C19.2605 19.1112 19.115 19.457 19.115 19.8174C19.1154 19.9174 19.1266 20.017 19.1486 20.1145C19.1919 20.2995 19.2737 20.4737 19.3888 20.6261C19.5038 20.7785 19.6496 20.9058 19.817 21C20.0235 21.1143 20.2564 21.1743 20.4933 21.1743C20.7303 21.1743 20.9632 21.1143 21.1697 21C21.3372 20.9059 21.4832 20.7787 21.5982 20.6263C21.7133 20.4739 21.795 20.2996 21.8381 20.1145C21.8601 20.017 21.8713 19.9174 21.8717 19.8174C21.8706 19.4583 21.7253 19.1142 21.4674 18.8602C21.2095 18.6063 20.86 18.4631 20.4953 18.4621V18.4582Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Ze = /* @__PURE__ */ we({ default: () => Qe }), Qe, $e = Se((() => {
	Qe = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M26.6894 7.78676C26.0537 6.18659 25.7421 4.20469 23.9612 3.18257C23.1198 2.69956 22.1912 2.48299 21.5664 2.42534C20.7406 2.34899 19.3928 2.40197 18.3084 3.04858L16.6926 2.07788L15.4196 2.72761V5.8999C14.6951 6.95006 14.1342 8.12176 13.6372 9.54742C12.3159 13.3352 12.3268 17.3333 13.444 20.0459L12.2146 21.3594C12.0479 21.2737 11.8781 21.2083 11.7098 21.1693C11.3172 21.0774 11.0055 21.1428 10.8092 21.322C10.8061 21.3189 4.53943 28.0125 4.53943 28.0125C4.36024 28.2774 4.43347 28.7978 4.43347 28.7978C4.10004 28.9785 4.03616 29.4615 4.4101 30.0707C4.62045 30.4135 4.92428 30.6955 5.27952 30.8841C5.9199 31.2206 6.39824 31.1162 6.54938 30.7594C6.87346 30.8139 7.13678 30.7563 7.3144 30.613L13.4938 24.0128C13.7291 23.815 13.8101 23.4613 13.6746 23.0125C13.6232 22.8443 13.5453 22.676 13.4471 22.5139L14.3118 21.5978C14.6562 22.0543 15.0519 22.436 15.496 22.7243V29.3478L30.4538 37.9173L31.7003 37.2863V10.6583L26.6878 7.78676H26.6894Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.6147 2.07788L15.4197 2.72761L17.3081 3.7061L18.2383 3.00807L16.6147 2.07788Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M26.6115 7.78674L26.828 9.29187L30.3774 11.3252L31.6239 10.6583L26.6115 7.78674Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M30.4553 11.3252L30.3774 37.9142L31.6239 37.2816L31.7018 10.6583L30.4553 11.3252Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.5059 2.84763C19.4925 1.04024 15.4789 4.04737 13.5593 9.54903C11.6397 15.0507 12.5294 20.9964 15.5443 22.8038C18.5577 24.6112 22.5713 21.6041 24.4909 16.1024C26.4105 10.6007 25.5208 4.65503 22.5059 2.84763ZM23.1463 15.2953C21.6988 19.443 18.6917 21.763 16.4184 20.4012C14.1467 19.0394 13.4564 14.5022 14.9039 10.353C16.3514 6.20534 19.3772 3.9383 21.6505 5.30009C23.9222 6.66187 24.5937 11.1461 23.1463 15.2937V15.2953Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M6.48233 30.7378C6.37637 31.0198 6.07254 31.1522 5.6503 31.0541C5.00369 30.9029 4.3228 30.2657 4.12959 29.63C4.00962 29.2327 4.10778 28.9304 4.35708 28.7964L6.48233 30.7378Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M12.5357 24.1454C11.699 23.9506 10.8187 23.1264 10.5694 22.3037C10.4369 21.8675 10.5102 21.5216 10.7314 21.3206C10.7283 21.3174 4.46162 28.011 4.46162 28.011C4.31515 28.2183 4.28711 28.5268 4.39773 28.8945C4.64703 29.7156 5.52736 30.5398 6.36406 30.7362C6.738 30.8234 7.03872 30.7689 7.23659 30.61L7.24594 30.6006C7.2849 30.5679 7.31917 30.5305 7.35034 30.49L13.4176 24.0098C13.2213 24.175 12.9159 24.2342 12.5357 24.1454Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M13.4051 20.0056L11.4761 22.0654C11.3935 22.1589 11.3686 22.3053 11.4247 22.4861C11.5353 22.8506 11.9249 23.2152 12.2957 23.3025C12.4889 23.3477 12.6385 23.3056 12.721 23.2059L14.2168 21.6088L13.4051 20.0056Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.8849 3.18259C23.5966 3.00964 23.2881 2.88344 22.9671 2.79774C22.361 2.51417 21.4901 2.42535 21.4901 2.42535C21.8375 2.51261 22.1787 2.64972 22.5075 2.84604C25.5209 4.65344 26.4106 10.5992 24.4925 16.1008C22.816 20.9044 19.544 23.8056 16.7347 23.2603L17.7522 23.5065C20.6362 24.3868 24.1217 21.4482 25.8699 16.4374C27.7895 10.9357 26.8998 4.98999 23.8849 3.18259Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M30.5287 38L30.4508 37.8645L31.5461 37.2365V10.7036L26.6802 7.91619L26.7581 7.78064L31.663 10.5915C31.6879 10.6055 31.7019 10.6304 31.7019 10.6585V37.2817C31.7019 37.3098 31.6864 37.3347 31.663 37.3487L30.5271 37.9985L30.5287 38Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M18.1994 3.07509L16.6148 2.16672L15.4587 2.79619L15.3839 2.65908L16.5774 2.00935C16.6008 1.99688 16.6304 1.99688 16.6538 2.00935L18.2757 2.93954L18.1978 3.07509H18.1994Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M15.4975 5.20349H15.3417V2.72766C15.3417 2.69962 15.3557 2.67469 15.3806 2.66066C15.4056 2.64664 15.4336 2.64664 15.4585 2.66066L17.2379 3.67966L17.16 3.81522L15.4975 2.86322V5.20349Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M30.3774 37.9921C30.3633 37.9921 30.3509 37.989 30.3384 37.9812L15.3806 29.4117C15.3557 29.3976 15.3417 29.3727 15.3417 29.3447V23.1216H15.4975V29.2995L30.2994 37.7802V11.3704L26.7672 9.34643L26.8451 9.21088L30.4163 11.2567C30.4412 11.2707 30.4553 11.2956 30.4553 11.3237V37.9127C30.4553 37.9407 30.4412 37.9656 30.4163 37.9797C30.4038 37.9859 30.3914 37.9906 30.3774 37.9906V37.9921Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M31.5558 10.5919L30.3409 11.2573L30.4158 11.3939L31.6307 10.7285L31.5558 10.5919Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M26.7249 14.7505L26.6472 14.8856L28.2183 15.7886L28.2959 15.6536L26.7249 14.7505Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.1741 9.11333L17.0964 9.24841L22.5714 12.3954L22.6491 12.2603L17.1741 9.11333Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M25.8174 17.6794L25.7407 17.8151L28.2191 19.2155L28.2957 19.0799L25.8174 17.6794Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.1741 12.6443L17.0974 12.7799L21.7462 15.4068L21.8228 15.2712L17.1741 12.6443Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.3988 20.409L24.3203 20.5436L28.1288 22.7629L28.2072 22.6283L24.3988 20.409Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.1759 16.0568L17.0974 16.1914L20.3176 18.0678L20.396 17.9332L17.1759 16.0568Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M28.2195 30.5414L19.6312 25.596L19.7091 25.462L28.2974 30.4075L28.2195 30.5414Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.5376 26.3303L17.4611 26.4659L28.22 32.5382L28.2965 32.4025L17.5376 26.3303Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M5.90902 31.163C5.82177 31.163 5.72984 31.1521 5.63168 31.1287C4.96169 30.9729 4.25432 30.3107 4.05488 29.6516C3.92711 29.231 4.02527 28.8851 4.31976 28.7261L4.39299 28.8632C4.17018 28.9832 4.09851 29.2606 4.20446 29.6065C4.38987 30.2172 5.04583 30.8327 5.66751 30.9776C6.03678 31.0633 6.31257 30.9636 6.40917 30.7096L6.55563 30.7641C6.45903 31.0212 6.2222 31.163 5.91058 31.163H5.90902Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M6.70053 30.8546C6.5899 30.8546 6.47149 30.8405 6.3484 30.8109C5.48988 30.6099 4.58151 29.7608 4.32442 28.9163C4.20912 28.5345 4.23561 28.1964 4.39921 27.9643L10.6721 21.2629L10.7859 21.3688L4.51918 28.064C4.38986 28.2478 4.37116 28.5377 4.474 28.8726C4.71551 29.6688 5.57246 30.4713 6.38267 30.6598C6.71767 30.7377 7.0028 30.6987 7.18821 30.5492C7.2334 30.5102 7.263 30.479 7.28793 30.4448L13.4471 23.8649L13.5608 23.9709L7.4079 30.5429C7.37986 30.5819 7.34091 30.624 7.29728 30.6598C7.29416 30.6629 7.28949 30.666 7.28481 30.6691C7.13524 30.7922 6.93268 30.8546 6.69897 30.8546H6.70053Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M12.8768 24.2653C12.7646 24.2653 12.6447 24.2513 12.5184 24.2217C11.6584 24.0207 10.7516 23.1715 10.496 22.327C10.3667 21.9017 10.4166 21.5371 10.6378 21.3018C10.8591 21.0665 11.219 20.9917 11.6506 21.093C11.8313 21.1351 12.0183 21.2068 12.2053 21.3049L12.132 21.442C11.9575 21.3501 11.783 21.2831 11.6147 21.2442C11.2377 21.1553 10.9307 21.2146 10.75 21.4078C10.5693 21.601 10.5319 21.911 10.6441 22.2803C10.8856 23.0765 11.7425 23.8789 12.5527 24.0674C12.9298 24.1547 13.2352 24.097 13.4175 23.9038C13.5982 23.7106 13.6356 23.4006 13.5234 23.0313C13.4736 22.8646 13.3941 22.6947 13.2897 22.5249L13.4221 22.4423C13.5343 22.6231 13.6185 22.8054 13.6714 22.9846C13.8008 23.4099 13.7509 23.773 13.5297 24.0098C13.3738 24.1765 13.1464 24.2622 12.8737 24.2622L12.8768 24.2653Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M12.4421 23.3991C12.3907 23.3991 12.3346 23.3929 12.2769 23.3788C11.8765 23.2854 11.4683 22.9036 11.3483 22.5094C11.2875 22.3084 11.3109 22.1324 11.4169 22.0139L13.3473 19.9526L13.4611 20.0585L11.5322 22.1183C11.4652 22.1931 11.4527 22.3162 11.4979 22.4642C11.6007 22.8039 11.9669 23.1467 12.3128 23.2261C12.4686 23.262 12.5932 23.2371 12.6602 23.156L14.1591 21.5543L14.2729 21.6603L12.7771 23.2573C12.7023 23.3477 12.5839 23.396 12.4421 23.396V23.3991Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M18.7867 23.7387C18.4283 23.7387 18.0746 23.6873 17.7272 23.5813L16.4261 23.2681L16.462 23.117L17.7677 23.4317C20.6424 24.3089 24.092 21.2909 25.7935 16.4125C27.7021 10.9435 26.8265 5.0399 23.8427 3.2512C23.5669 3.08604 23.2647 2.95983 22.9452 2.87569C22.9421 2.87569 22.9375 2.87414 22.9343 2.87258C22.8611 2.85077 22.0228 2.64042 21.4697 2.50331L21.5071 2.35217C22.5105 2.59991 22.8611 2.68716 22.9811 2.73858L22.9842 2.72612C23.3176 2.81337 23.6339 2.94581 23.9222 3.11876C26.9667 4.9433 27.8704 10.9311 25.9399 16.4655C24.413 20.8422 21.4822 23.7402 18.7851 23.7402L18.7867 23.7387Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.4203 23.4037C16.7456 23.4037 16.0974 23.2246 15.5038 22.8678C12.4593 21.0432 11.5556 15.0554 13.486 9.52107C14.7247 5.97327 16.8484 3.35254 19.1684 2.51273C20.3651 2.07958 21.5336 2.1715 22.5464 2.77916C25.5894 4.6037 26.4946 10.5915 24.5641 16.1259C23.3255 19.6737 21.2018 22.2944 18.8833 23.1342C18.3878 23.3134 17.8986 23.4022 17.4218 23.4022L17.4203 23.4037ZM20.6299 2.40054C20.1719 2.40054 19.6998 2.48624 19.2214 2.65919C16.9793 3.47096 14.8385 6.11973 13.6341 9.57248C11.7254 15.0414 12.601 20.9451 15.5848 22.7338C16.5571 23.3165 17.6789 23.4053 18.8303 22.9877C21.0724 22.176 23.2133 19.5272 24.4177 16.0744C26.3264 10.6055 25.4507 4.70186 22.4669 2.91316C21.8982 2.57194 21.2766 2.40054 20.6299 2.40054Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.8129 20.8687C17.3081 20.8687 16.8235 20.7347 16.3779 20.4683C14.0595 19.0784 13.3646 14.5288 14.8307 10.3281C15.7656 7.64664 17.372 5.66785 19.1264 5.03214C20.0332 4.70339 20.9198 4.7735 21.6895 5.2347C23.9924 6.61518 24.6779 11.1399 23.2195 15.3218C22.2878 17.994 20.6331 20.0429 18.9036 20.6692C18.5343 20.8032 18.1682 20.8702 17.8129 20.8702V20.8687ZM14.904 10.3531L14.9772 10.378C13.5344 14.5132 14.1997 18.9787 16.4574 20.3327C17.1741 20.7627 18.0015 20.8282 18.8506 20.5197C20.5381 19.9089 22.1554 17.8958 23.0715 15.2673C24.5065 11.1524 23.8506 6.71022 21.6085 5.36558C20.8808 4.92931 20.0395 4.86387 19.1778 5.17549C17.492 5.78627 15.8824 7.77908 14.9756 10.3764L14.9024 10.3515L14.904 10.3531Z",
				fill: "#3D3D3D"
			})
		]
	});
})), et = /* @__PURE__ */ we({ default: () => tt }), tt, nt = Se((() => {
	tt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.7812 5.15424V3.90424L30.7812 13.9042L32.0312 13.2792L33.2812 15.1542L32.0312 15.7792V33.2792L30.7812 33.9042L28.9062 32.9667V33.5917L27.0312 32.6542V35.7792L25.7812 36.4042L7.075 27.0511C6.2125 26.6199 5.78125 26.0542 5.78125 25.4886V5.48861L7.075 7.05111L8.28125 7.65424V5.77924L8.90625 6.09174V5.46674L9.53125 5.77924V5.15424L10.1562 5.46674V4.84174L10.7812 5.15424Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M33.2812 20.1542V21.4042L27.0312 24.5292L23.2812 22.6542L22.0312 23.2792L25.7812 25.1542H28.2812L34.5312 22.0292V20.7792L33.2812 20.1542ZM7.075 7.05111C5.35 6.18861 5.35 4.78861 7.075 3.92611C8.8 3.06361 11.6 3.06361 13.325 3.92611L32.0312 13.2792L30.7812 13.9042L12.075 4.55111C11.0406 4.03392 9.35938 4.03392 8.325 4.55111C7.29063 5.06986 7.29063 5.90892 8.325 6.42611L27.0312 15.7792L25.7812 16.4042L7.075 7.05111Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.625 5.4886C5.625 4.87766 6.07345 4.25266 7.0047 3.78704C8.76876 2.90579 11.6312 2.90579 13.3953 3.78704L32.1 13.1402C32.1219 13.1495 32.1406 13.1652 32.1563 13.187L32.1578 13.1886L32.1594 13.1917L32.1609 13.1933L33.4109 15.0683L33.4141 15.073L33.4156 15.0761L33.4172 15.0777V15.0792L33.4187 15.0808L33.4219 15.0855V15.0886L33.4234 15.0902L33.425 15.0917L33.4266 15.0964V15.0995L33.4281 15.1042L33.4297 15.1089L33.4312 15.1136L33.4328 15.1152C33.4328 15.1167 33.4328 15.1167 33.4328 15.1183L33.4344 15.123V15.1245C33.4344 15.1261 33.4344 15.1261 33.4344 15.1277L33.4359 15.1323V15.137L33.4375 15.1417V15.1464V15.148V15.1527V15.1542V20.0589L34.6016 20.6402C34.6547 20.6667 34.6875 20.7214 34.6875 20.7792V27.0292C34.6875 27.0886 34.6547 27.1433 34.6016 27.1699L33.4375 27.7511V32.6542C33.4375 32.7136 33.4047 32.7683 33.3516 32.7949L30.8516 34.0449C30.8078 34.0667 30.7547 34.0667 30.7109 34.0449L29.5312 33.4542V33.4355C29.5078 33.4355 29.4828 33.4308 29.4609 33.4199L29.0625 33.2198V33.5917C29.0625 33.6464 29.0344 33.6964 28.9891 33.7261C28.9422 33.7542 28.8844 33.7558 28.8359 33.7324L28.4375 33.5323V35.1542C28.4375 35.2136 28.4047 35.2683 28.3516 35.2949L25.8516 36.5449C25.8078 36.5667 25.7547 36.5667 25.7109 36.5449L7.0047 27.1917C6.07345 26.7261 5.625 26.0995 5.625 25.4886V5.4886ZM5.9375 6.3589V25.4886C5.9375 26.0089 6.35156 26.5152 7.14531 26.912L25.7812 36.2308L26.875 35.6839V30.3105H25.7812H25.7766C25.7516 30.3105 25.7281 30.3042 25.7078 30.2933L21.9609 28.4199C21.9375 28.4074 21.9156 28.3886 21.9016 28.3667L20.6516 26.4917C20.6344 26.4667 20.625 26.4355 20.625 26.4042V23.9042C20.625 23.8464 20.6578 23.7917 20.7109 23.7652L23.2109 22.5152C23.2547 22.4933 23.3078 22.4933 23.3516 22.5152L26.875 24.2777V18.3277L25.675 16.5261L7.0047 7.19173C6.51876 6.94954 6.16562 6.66359 5.9375 6.3589ZM31.875 28.5323V33.1839L30.7812 33.7308L29.6875 33.1839V32.9073L30.0859 33.1074C30.1344 33.1308 30.1922 33.1292 30.2391 33.1011C30.2844 33.0714 30.3125 33.0214 30.3125 32.9667V32.5948L30.7109 32.7949C30.7594 32.8183 30.8172 32.8167 30.8641 32.7886C30.9094 32.7589 30.9375 32.7089 30.9375 32.6542V29.0011L31.875 28.5323ZM28.75 30.0948L28.4375 30.2511V33.1839L28.75 33.3402V30.0948ZM29.375 29.7823V33.0277L29.0625 32.8714V29.9386L29.375 29.7823ZM30 29.4698V32.7152L29.6875 32.5589V29.6261L30 29.4698ZM30.625 29.1573V32.4027L30.3125 32.2464V29.3136L30.625 29.1573ZM28.125 25.3105V29.998H25.9375V25.3105H27.1047H28.125ZM25.625 25.2511V29.9027L22.1375 28.1589L20.9375 26.3573V24.0011L22.0312 23.4542L25.625 25.2511ZM23.3516 25.6402C23.125 25.5261 22.9187 25.5277 22.7687 25.6027C22.6094 25.6823 22.5 25.848 22.5 26.0917C22.5 26.487 22.8156 26.9714 23.2109 27.1699C23.4375 27.2824 23.6438 27.2824 23.7938 27.2073C23.9531 27.1277 24.0625 26.962 24.0625 26.7167C24.0625 26.323 23.7469 25.8386 23.3516 25.6402ZM28.2438 24.998H25.8187L22.3812 23.2792L23.2812 22.8292L26.9609 24.6699C27.0047 24.6917 27.0578 24.6917 27.1016 24.6699L33.3516 21.5449C33.4047 21.5183 33.4375 21.4636 33.4375 21.4042V20.4073L34.375 20.8761V21.9339L28.2438 24.998ZM8.4375 6.30891L27.1 15.6402C27.1219 15.6495 27.1406 15.6652 27.1563 15.687L27.1578 15.6886L27.1594 15.6917L27.1609 15.6933L28.4109 17.5683L28.4141 17.573L28.4156 17.5761L28.4172 17.5777V17.5792L28.4187 17.5808L28.4219 17.5855V17.5886L28.4234 17.5902L28.425 17.5917L28.4266 17.5964V17.5995L28.4281 17.6042L28.4297 17.6089L28.4312 17.6136L28.4328 17.6152C28.4328 17.6167 28.4328 17.6167 28.4328 17.6183L28.4344 17.623V17.6245C28.4344 17.6261 28.4344 17.6261 28.4344 17.6277L28.4359 17.6323V17.637L28.4375 17.6417V17.6464V17.648V17.6527V17.6542V23.6527L28.75 23.4964V16.1886L8.4375 6.03235V6.30891ZM29.375 23.1839L29.0625 23.3402V16.0917C29.0625 16.0339 29.0297 15.9792 28.9766 15.9527L9.0625 5.99641V5.71985L29.375 15.8761V23.1839ZM30 22.8714L29.6875 23.0277V15.7792C29.6875 15.7214 29.6547 15.6667 29.6016 15.6402L9.6875 5.68391V5.40735L30 15.5636V22.8714ZM30.625 22.5589L30.3125 22.7152V15.4667C30.3125 15.4089 30.2797 15.3542 30.2266 15.3277L10.3125 5.37141V5.09485L30.625 15.2511V22.5589ZM10.9375 4.37141V5.05891L30.8516 15.0152C30.9047 15.0417 30.9375 15.0964 30.9375 15.1542V22.4027L31.875 21.9339V15.8277L30.675 14.0261L12.0047 4.69173C11.6969 4.53704 11.3281 4.43078 10.9375 4.37141ZM26.0094 16.4652L27.0844 18.0792L28.0531 17.5948L26.9781 15.9808L26.0094 16.4652ZM31.6813 13.2792L30.7812 13.7308L12.1453 4.41204C11.0719 3.87454 9.32814 3.87454 8.2547 4.41204C7.66876 4.70579 7.3922 5.10423 7.3922 5.4886C7.3922 5.87454 7.66876 6.27298 8.2547 6.56673L26.6813 15.7792L25.7812 16.2308L7.14531 6.91204C6.35156 6.51516 5.9375 6.00891 5.9375 5.4886C5.9375 4.96829 6.35156 4.4636 7.14531 4.06673C8.83125 3.22298 11.5688 3.22298 13.2547 4.06673L31.6813 13.2792ZM31.0094 13.9652L32.0844 15.5792L33.0531 15.0948L31.9781 13.4808L31.0094 13.9652Z",
				fill: "#3D3D3D"
			})
		]
	});
})), rt = /* @__PURE__ */ we({ default: () => it }), it, at = Se((() => {
	it = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.9166 2.55157L11.6666 2.96877L6.66663 30.4688L7.91663 31.0938L8.54163 27.6563L21.0416 33.9063L20.4166 37.3438L21.6666 37.9688L23.7441 26.5422L30.3818 29.861L30.7985 32.1531L32.0485 32.7781L27.9166 10.0516L12.9166 2.55157Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.3369 32.2828L9.375 26.3016L8.75 26.5109L21.25 32.7609L21.3369 32.2828ZM29.7917 17.6562L25.4167 19.8438L26.0417 20.1562L30.4167 17.9688L29.7917 17.6562ZM26.6667 10.4688L11.6667 2.96875L12.9167 2.55156L14.1667 1.71875L29.1667 9.21875L27.9167 10.0516L26.6667 10.4688Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.8473 2.41095L14.08 1.58907C14.1267 1.55782 14.1864 1.55312 14.2365 1.57969L29.2365 9.07969C29.2381 9.07969 29.2397 9.08125 29.2411 9.08125L29.2439 9.08281L29.2479 9.08594L29.2514 9.08751L29.2554 9.09063L29.2593 9.09218L29.2632 9.09531L29.2668 9.09844L29.2673 9.1C29.2701 9.10156 29.2729 9.10469 29.2756 9.10626L29.2778 9.10938L29.2814 9.11249L29.2847 9.11719L29.2879 9.12031L29.2901 9.12344L29.2929 9.12657L29.2957 9.13124L29.2972 9.13281L29.2982 9.13437C29.2996 9.1375 29.3009 9.13906 29.3022 9.14063L29.3037 9.14375L29.3059 9.14845L29.3081 9.15312L29.3096 9.15625L29.3115 9.16094L29.3132 9.16407L29.315 9.16876L29.3164 9.17343L29.3172 9.17656C29.3184 9.18125 29.3195 9.18593 29.3204 9.19062L33.487 32.1078C33.4995 32.175 33.4653 32.2438 33.4032 32.275L32.1193 32.9172C32.1164 32.9188 32.1132 32.9203 32.1103 32.9219L32.1067 32.9234H32.1056C32.1031 32.925 32.1004 32.925 32.0979 32.9266L32.094 32.9281H32.0907H32.0887L32.0857 32.9297L32.0811 32.9313H32.0776H32.0757L32.0706 32.9328H32.0665H32.062L32.06 32.9344H32.0567H32.052H32.0486H32.0464H32.0412H32.0359L32.0332 32.9328C32.0323 32.9328 32.0315 32.9328 32.0306 32.9328H32.0279L32.0226 32.9313H32.0214C32.0187 32.9313 32.0159 32.9313 32.0132 32.9297H32.0093L32.0062 32.9281H32.0042L32.0015 32.9266L31.9964 32.925L31.9934 32.9234H31.9906L31.9862 32.9203L31.9828 32.9188H31.9807L31.9787 32.9172L30.7287 32.2922C30.6847 32.2703 30.6537 32.2297 30.6448 32.1812L30.2421 29.9656L24.9282 27.3094L23.0953 37.3594C23.0865 37.4078 23.0554 37.4485 23.0115 37.4703L21.7365 38.1078L21.7323 38.1109L21.7282 38.1125H21.7261L21.7214 38.1156L21.7162 38.1172H21.7128L21.7111 38.1187H21.7084L21.7032 38.1203H21.702C21.6992 38.1219 21.6965 38.1219 21.6939 38.1234H21.69H21.6865H21.6846C21.6837 38.1234 21.6829 38.125 21.682 38.125H21.6767H21.6734H21.6707H21.6659H21.6622H21.6578H21.655H21.6509L21.6465 38.1234H21.6445H21.6393L21.6354 38.1219L21.6309 38.1203H21.6289L21.6237 38.1187L21.6186 38.1172H21.6173C21.6147 38.1156 21.6122 38.1156 21.6095 38.1141L21.6059 38.1125H21.605C21.602 38.111 21.5989 38.1094 21.5959 38.1078L20.3467 37.4828C20.2847 37.4531 20.2504 37.3844 20.2629 37.3156L20.867 33.9938L9.69981 28.4094L9.32043 30.4969C9.31153 30.5453 9.28044 30.5859 9.23653 30.6078L7.98653 31.2328L7.98231 31.2359L7.97824 31.2375H7.97606L7.97138 31.2406L7.96622 31.2422H7.96277L7.96106 31.2437H7.95841L7.95325 31.2453H7.952C7.94918 31.2469 7.94653 31.2469 7.94387 31.2484H7.93996H7.93653H7.93465C7.93371 31.2484 7.93294 31.25 7.932 31.25H7.92669H7.92341H7.92075H7.9159H7.91215H7.90778H7.90496H7.9009L7.89653 31.2484H7.8945H7.88934L7.88543 31.2469L7.8809 31.2453H7.87887L7.87372 31.2437L7.86856 31.2422H7.86731C7.86465 31.2406 7.86216 31.2406 7.8595 31.2391L7.85591 31.2375H7.85496C7.85199 31.2359 7.84887 31.2344 7.8459 31.2328L6.59668 30.6078C6.53465 30.5781 6.50043 30.5094 6.51293 30.4406L11.5129 2.94062L11.5136 2.93751L11.5139 2.93594C11.5145 2.93282 11.5151 2.92969 11.5159 2.92812C11.517 2.92344 11.5181 2.92032 11.5193 2.9172V2.91563C11.5204 2.91407 11.5214 2.91094 11.5225 2.90781L11.5242 2.90468L11.5254 2.90156L11.5267 2.90001L11.5284 2.89532L11.5306 2.89219L11.5328 2.8875L11.5351 2.88437L11.5368 2.88124L11.539 2.87813L11.5415 2.875L11.5436 2.87188L11.5457 2.87031L11.5471 2.86875L11.5487 2.86562L11.5517 2.86249L11.5548 2.85938L11.5568 2.85782L11.5604 2.85469L11.5634 2.85156L11.5668 2.84844L11.5701 2.84531C11.5723 2.84374 11.5747 2.8422 11.577 2.84063C11.5801 2.83907 11.5834 2.83594 11.5867 2.83438C11.5893 2.83282 11.592 2.83125 11.5947 2.82969L11.5982 2.82812L11.6009 2.82656H11.6036L11.6072 2.82499L11.6092 2.82343L11.6118 2.82189H11.6157L11.6179 2.82032L12.8473 2.41095ZM11.7831 3.20156L26.492 10.5563L21.5501 37.7359L20.5914 37.2562L21.1954 33.9344C21.2078 33.8656 21.1736 33.7969 21.1115 33.7672L8.61153 27.5172L8.60731 27.5141L8.60324 27.5125L8.59887 27.5109L8.59465 27.5094L8.59043 27.5078L8.58606 27.5063L8.58168 27.5047H8.57731L8.57293 27.5031H8.5684L8.56403 27.5016H8.5595L8.55512 27.5H8.55059H8.54606H8.54168H8.53715H8.53262H8.52825L8.52372 27.5016H8.51919L8.51481 27.5031H8.51043L8.5059 27.5047H8.50152L8.49716 27.5063L8.49293 27.5078L8.48856 27.5094L8.48434 27.5109L8.48012 27.5125L8.4759 27.5141L8.47168 27.5172L8.46762 27.5188L8.46372 27.5203L8.45981 27.5234L8.4559 27.525L8.45215 27.5281L8.4484 27.5312L8.44481 27.5344L8.44138 27.5359L8.43793 27.5391L8.43465 27.5422L8.43137 27.5453L8.42824 27.5485L8.42512 27.5516L8.42215 27.5563L8.41934 27.5594L8.41668 27.5625L8.41402 27.5656L8.41153 27.5703L8.40903 27.5734L8.40668 27.5781L8.4045 27.5813L8.40247 27.5859L8.40043 27.5891L8.39856 27.5938L8.39684 27.5969L8.39512 27.6016L8.39356 27.6063L8.39216 27.6109L8.39091 27.6156L8.38981 27.6188L8.38871 27.6234L8.38825 27.6266L8.38793 27.6281L7.80012 30.8609L6.84137 30.3812L11.7831 3.20156ZM12.5545 4.71094L8.59638 26.4813L8.59575 26.4859L8.59528 26.4891L8.59465 26.4922C8.59246 26.5125 8.59403 26.5328 8.59903 26.5516L8.59996 26.5547L8.60074 26.5562L8.60169 26.5594L8.60294 26.5641L8.60449 26.5672L8.60575 26.5703L8.60793 26.575L8.6095 26.5797L8.61168 26.5828L8.61293 26.5859L8.61575 26.5906L8.61794 26.5937L8.61934 26.5969L8.62074 26.5984L8.62356 26.6016C8.63527 26.6188 8.65044 26.6328 8.66809 26.6438L8.67153 26.6453L8.67481 26.6469L8.677 26.6484L8.68012 26.65L21.1801 32.9C21.224 32.9219 21.2759 32.9219 21.3198 32.9C21.3639 32.8781 21.395 32.8359 21.4037 32.7891L25.362 11.0172C25.3745 10.95 25.3403 10.8812 25.2782 10.85L12.7782 4.59999C12.7342 4.57812 12.6825 4.57812 12.6384 4.59999C12.5945 4.62187 12.5634 4.66407 12.5545 4.71094ZM9.36293 26.4703L21.1622 32.3703L21.1336 32.5281L9.22231 26.5719L9.15731 26.5391L9.36293 26.4703ZM26.1115 20.9203L29.4322 19.2609L31.8389 32.4984L30.9384 32.0484L30.5356 29.8328C30.5268 29.7844 30.4957 29.7437 30.4518 29.7219L24.9867 26.9891L26.0917 20.9297L26.0959 20.9281L26.1 20.9266L26.1037 20.925L26.1082 20.9219L26.1115 20.9203ZM13.3629 5.2422L9.54965 26.2141L21.2203 32.05L25.0336 11.0766L13.3629 5.2422ZM25.8854 20.2531V20.5281L25.5729 20.3719V20.0969L25.8854 20.2531ZM30.0673 17.9688L26.0417 19.9813L25.7661 19.8438L29.7917 17.8313L30.0673 17.9688ZM26.4123 19.1719L29.1656 17.7938L27.9164 10.9234L26.4123 19.1719ZM12.0739 2.99688L26.6786 10.3L27.5093 10.0234L12.9047 2.72032L12.0739 2.99688ZM13.2273 2.53281L27.9054 9.87189L28.8559 9.2375L14.1779 1.89844L13.2273 2.53281Z",
				fill: "#3D3D3D"
			})
		]
	});
})), ot = /* @__PURE__ */ we({ default: () => st }), st, ct = Se((() => {
	st = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.0312 9.84375L21.4062 9.53125L23.9062 8.28125L32.6562 12.6562L31.4062 13.2812L36.4062 15.7812V16.4062L25.1562 22.0312L33.6984 26.3016L33.2812 28.5938L17.0312 36.7188L7.03125 31.7188L6.61406 29.4266L15.1562 25.1562L3.90625 19.5312V18.9062L9.12813 16.2953C9.17969 15.8797 9.52344 15.4734 10.1562 15.1562C10.7891 14.8391 11.6047 14.6687 12.4344 14.6422L22.0312 9.84375ZM23.2812 10.4688L34.5312 16.0938L23.9062 21.4062L23.2812 21.0938L16.4062 24.5312L5.78125 19.2188L9.61094 17.3047C9.75781 17.4297 9.94063 17.5484 10.1562 17.6562C11.5359 18.3453 13.7766 18.3453 15.1562 17.6562C16.5359 16.9672 16.5359 15.8453 15.1562 15.1562C14.9406 15.0484 14.7031 14.9578 14.4531 14.8828L23.2812 10.4688ZM21.4062 15.7812L15.1562 18.9062L20.1562 21.4062L26.4062 18.2812L21.4062 15.7812ZM17.0312 2.96875L15.7812 3.59375L24.5312 7.96875L25.7812 7.34375L17.0312 2.96875Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.0312 27.6562H17.6562L20.1562 28.9062V24.5312L17.6562 25.7812H16.4062L3.90625 19.5312V21.4062L5.28126 22.0938L7.03125 31.7188L17.0312 36.7188V27.6562ZM14.9313 30.2594C14.5656 30.4125 14.1531 30.5234 13.7203 30.5922L13.8328 33.3422C13.8453 33.6734 14.0391 33.9719 14.3359 34.1219C14.4969 34.2016 14.6875 34.1906 14.8375 34.0937C14.9891 33.9969 15.0766 33.8266 15.0687 33.6484L14.9313 30.2594ZM11.1687 30.5109L11.3109 32.1453C11.3375 32.4469 11.5187 32.7125 11.7891 32.8484C11.9547 32.9312 12.1516 32.9172 12.3047 32.8141C12.4563 32.7094 12.5406 32.5313 12.525 32.3484L12.3766 30.6688C11.9625 30.6516 11.5531 30.6 11.1687 30.5109ZM9.12188 25.3672C9.04375 25.2609 8.94062 25.1734 8.8203 25.1125H8.81874C8.65312 25.0297 8.45313 25.0453 8.30156 25.1531C8.14844 25.2609 8.06876 25.4453 8.09376 25.6313C8.28751 27.0953 8.65313 29.8625 8.79532 30.9375C8.83282 31.2141 9.00312 31.4547 9.25312 31.5797C9.42031 31.6625 9.62032 31.6484 9.77188 31.5391C9.92344 31.4312 10.0047 31.2469 9.97969 31.0625L9.83437 29.9719C9.35937 29.6578 9.12188 29.2812 9.12188 28.9062V25.3672ZM30.1562 27.6562L22.0312 23.5938L30.1562 19.5312V27.6562ZM16.1906 19.4234L20.1562 21.4062V23.2812L17.0312 24.8438L9.12188 20.8891V16.4062C9.12188 16.8594 9.46719 17.3109 10.1562 17.6562C11.5359 18.3453 13.7766 18.3453 15.1562 17.6562C15.8453 17.3109 16.1906 16.8594 16.1906 16.4062V19.4234ZM25.7812 11.7188V9.84375L27.0312 9.21875L25.7812 7.34375L24.5312 7.96875L15.7812 3.59375L14.5312 4.21875V14.8438L15.1562 15.1562V4.53125L15.7812 4.21875L24.2188 8.4375L25.1562 9.84375V11.4062L21.4062 9.53125V15.7812L25.1562 17.6562V18.9062L21.4062 20.7812V22.6562L30.1562 18.2812V13.9062L25.7812 11.7188ZM25.7812 17.9688V18.5938L26.4062 18.2812L25.7812 17.9688ZM34.5312 16.0938L32.5656 15.1109L32.5844 17.0672L34.5312 16.0938Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.4609 4.07965L16.9609 2.82965C17.0047 2.80621 17.0578 2.80621 17.1016 2.82965L25.85 7.20309C25.8719 7.21402 25.8906 7.22966 25.9063 7.24997L25.9078 7.2531L25.9094 7.25466L25.9109 7.25777L27.1609 9.13121L27.1641 9.1359L27.1656 9.13903L27.1672 9.14059V9.14215L27.1688 9.14528L27.1719 9.14997V9.15152L27.1734 9.15308L27.175 9.15621L27.1766 9.1609V9.16403L27.1781 9.16716L27.1797 9.17183L27.1812 9.17809L27.1828 9.17965V9.18122L27.1844 9.18591V9.18904V9.19058L27.1859 9.19684V9.20153L27.1875 9.20622V9.20933V9.2109V9.21715V9.21872V9.74684L32.7266 12.5172L32.7297 12.5187L32.7344 12.5203L32.7375 12.5218C32.7406 12.525 32.7437 12.5265 32.7469 12.5281L32.75 12.5312L32.7516 12.5328L32.7563 12.5359L32.7594 12.539L32.7625 12.5422L32.7641 12.5437L32.7656 12.5453C32.7672 12.5453 32.7672 12.5468 32.7672 12.5468L32.7719 12.55L32.775 12.5546L32.7781 12.5578L32.7813 12.5609L32.7828 12.564L32.7844 12.5656V12.5672L32.7859 12.5703L32.7875 12.5718L32.7906 12.5765L32.7938 12.5812L32.7953 12.5843L32.7969 12.589L32.7984 12.5937L32.8 12.5953C32.8 12.5968 32.8016 12.5968 32.8016 12.5984V12.6L32.8031 12.6031L32.8047 12.6047L32.8062 12.6109L32.8078 12.6156V12.6203L32.8094 12.6218C32.8094 12.625 32.8094 12.6281 32.8109 12.6312V12.6343V12.639L32.8125 12.6437V12.6484V12.6515V12.6531V12.6562V13.8093L36.4766 15.6422C36.5297 15.6687 36.5625 15.7218 36.5625 15.7812V18.2812C36.5625 18.3406 36.5297 18.3953 36.4766 18.4203L35.1703 19.0734L33.4344 28.6218C33.4266 28.6703 33.3953 28.7109 33.3516 28.7328L17.1016 36.8578L17.0984 36.8593L17.0938 36.8625L17.0891 36.864L17.0844 36.8656L17.0797 36.8671L17.075 36.8687L17.0703 36.8703L17.0656 36.8718H17.0609L17.0547 36.8734H17.05L17.0453 36.875H17.0406H17.0359H17.0312H17.0266H17.0203H17.0156L17.0109 36.8734H17.0062L17.0016 36.8718H16.9969L16.9922 36.8703L16.9875 36.8687L16.9828 36.8671L16.9781 36.8656L16.9734 36.864L16.9687 36.8625L16.9641 36.8593L16.9609 36.8578L6.96095 31.8578C6.9172 31.8359 6.88594 31.7953 6.87813 31.7468L5.14219 22.1984L3.83595 21.5453C3.78282 21.5203 3.75 21.4656 3.75 21.4062V18.9062C3.75 18.8468 3.78282 18.7937 3.83595 18.7672L8.9875 16.1906C9.07813 15.764 9.43595 15.3406 10.0859 15.0172C10.7281 14.6953 11.55 14.5203 12.3906 14.489L14.375 13.4968V4.21872C14.375 4.15934 14.4078 4.10621 14.4609 4.07965ZM5.49063 22.3734L7.17031 31.614L16.875 36.4656V27.8125H16.4062H16.4016H16.4C16.3766 27.8109 16.3531 27.8047 16.3344 27.7953L5.49063 22.3734ZM15.0219 28.6562C15.0063 28.2672 14.7797 27.9187 14.4312 27.7437C14.2219 27.639 13.9719 27.6531 13.775 27.7797C13.5781 27.9078 13.4625 28.1297 13.4734 28.364C13.5266 29.7 13.6313 32.2406 13.6766 33.3484C13.6922 33.7375 13.9188 34.0875 14.2656 34.2609H14.2672C14.4766 34.3656 14.7266 34.3515 14.9234 34.225C15.1203 34.0968 15.2344 33.875 15.225 33.6406C15.1703 32.3047 15.0672 29.764 15.0219 28.6562ZM14.7844 30.4843L14.9125 33.6547C14.9187 33.7781 14.8578 33.8953 14.7531 33.9625C14.65 34.0297 14.5172 34.0375 14.4062 33.9812C14.1594 33.8578 14 33.6109 13.9891 33.3359L13.8812 30.7234C14.1984 30.6672 14.5031 30.5875 14.7844 30.4843ZM19.6875 28.8468L20.0859 29.0453L20.0891 29.0468L20.0937 29.05L20.0984 29.0515L20.1031 29.0531L20.1078 29.0546L20.1125 29.0562L20.1172 29.0578L20.1219 29.0593H20.1266L20.1328 29.0609H20.1375L20.1422 29.0625H20.1469H20.1516H20.1562H20.1609H20.1672H20.1719L20.1766 29.0609H20.1813L20.1859 29.0593H20.1906L20.1953 29.0578L20.2 29.0562L20.2047 29.0546L20.2094 29.0531L20.2141 29.0515L20.2188 29.05L20.2234 29.0468L20.2266 29.0453L20.625 28.8468V32.9843C20.625 33.2984 20.4469 33.5859 20.1656 33.7265C20.0625 33.7781 19.9422 33.7718 19.8438 33.7125C19.7469 33.6531 19.6875 33.5453 19.6875 33.4312V28.8468ZM12.2297 27.1906C12.1984 26.8343 11.9844 26.5203 11.6656 26.3609C11.45 26.2531 11.1922 26.2703 10.9937 26.4062C10.7937 26.5422 10.6844 26.775 10.7047 27.014C10.8281 28.4187 11.0609 31.0703 11.1563 32.1593C11.1875 32.514 11.4 32.8281 11.7203 32.9875C11.9359 33.0953 12.1922 33.0781 12.3922 32.9421C12.5906 32.8078 12.7016 32.575 12.6797 32.3343L12.2297 27.1906ZM11.3422 30.7062C11.6312 30.7609 11.9297 30.7984 12.2328 30.8156L12.3688 32.3625C12.3797 32.489 12.3219 32.6125 12.2156 32.6843C12.1109 32.7562 11.9734 32.7656 11.8594 32.7078C11.6375 32.5968 11.4891 32.3797 11.4672 32.1312L11.3422 30.7062ZM23.3625 27.4781L23.1516 31.8078C23.1375 32.0781 22.9797 32.3203 22.7375 32.4406C22.6266 32.4968 22.4938 32.489 22.3891 32.4203C22.2844 32.3531 22.2234 32.2343 22.2297 32.1093L22.4328 27.9421L23.3625 27.4781ZM9.43281 25.7343C9.38906 25.4062 9.18594 25.1218 8.88906 24.9734C8.67031 24.864 8.40938 24.8843 8.21095 25.0265C8.01095 25.1687 7.90626 25.4078 7.93907 25.6515C8.13282 27.1172 8.49845 29.8843 8.64063 30.9578C8.68438 31.2859 8.8875 31.5718 9.18282 31.7203C9.40157 31.8281 9.66406 31.8093 9.8625 31.6672C10.0625 31.525 10.1672 31.2843 10.1344 31.0422C9.94062 29.5765 9.575 26.8093 9.43281 25.7343ZM8.96563 28.4265V28.9062C8.96563 29.3078 9.2 29.7187 9.68906 30.0609L9.825 31.0828C9.84219 31.2109 9.78593 31.3375 9.68124 31.4125C9.57656 31.4875 9.43907 31.4984 9.32344 31.4406C9.12032 31.339 8.97969 31.1422 8.95 30.9172L8.6422 28.5875L8.96563 28.4265ZM26.0984 26.1093L25.6719 30.6015C25.6484 30.8453 25.5016 31.0593 25.2828 31.1687C25.1672 31.2265 25.0313 31.2171 24.925 31.1437C24.8203 31.0718 24.7625 30.9468 24.7734 30.8203L25.1781 26.5703L26.0984 26.1093ZM12.2062 30.5047C11.9016 30.4843 11.6016 30.4437 11.3141 30.3828L11.0172 26.9875C11.0047 26.8593 11.0641 26.7359 11.1687 26.664C11.275 26.5922 11.4109 26.5828 11.525 26.6406H11.5266C11.7484 26.7515 11.8969 26.9703 11.9188 27.2171L12.2062 30.5047ZM27.7266 26.6156L28.5188 27.0125L28.1875 29.389C28.1563 29.6093 28.0188 29.8 27.8203 29.9C27.7031 29.9578 27.5656 29.9468 27.4609 29.8718C27.3547 29.7953 27.3016 29.6687 27.3187 29.5406L27.7266 26.6156ZM9.27813 26.95L9.62969 29.6156C9.39844 29.3937 9.27813 29.1531 9.27813 28.9062V26.95ZM30.2266 27.7953L30.8219 27.4984L30.6984 28.1718C30.6625 28.3718 30.5344 28.5422 30.3531 28.6328C30.2375 28.6906 30.0984 28.6781 29.9953 28.6C29.8906 28.5234 29.8406 28.3922 29.8641 28.2656L29.9609 27.7328L30.0859 27.7953L30.0891 27.7968L30.0937 27.8L30.0984 27.8015L30.1031 27.8031L30.1078 27.8046L30.1125 27.8062L30.1172 27.8078L30.1219 27.8093H30.1266L30.1328 27.8109H30.1375L30.1422 27.8125H30.1469H30.1516H30.1562H30.1609H30.1672H30.1719L30.1766 27.8109H30.1813L30.1859 27.8093H30.1906L30.1953 27.8078L30.2 27.8062L30.2047 27.8046L30.2094 27.8031L30.2141 27.8015L30.2188 27.8L30.2234 27.7968L30.2266 27.7953ZM20 27.9297V28.6531L19.6906 28.4984C19.7125 28.2734 19.825 28.0687 20 27.9297ZM17.2359 25.9375H17.5V27.5H16.5625V25.9375H17.2359ZM4.0625 19.7843L16.25 25.8781V27.4031L4.0625 21.3093V19.7843ZM28.5641 26.6859L27.7719 26.289L28.0625 24.2047C28.0937 23.9843 28.2312 23.7937 28.4297 23.6937C28.5469 23.6359 28.6844 23.6468 28.7891 23.7218C28.8953 23.7984 28.95 23.925 28.9313 24.0531L28.5641 26.6859ZM36.25 16.3093L17.6188 25.625H16.4437L4.0625 19.4343V19.0031L8.96563 16.5515V17.4515L5.71095 19.0797C5.65782 19.1062 5.625 19.1593 5.625 19.2187C5.625 19.2781 5.65782 19.3328 5.71095 19.3578L16.9609 24.9828C17.0047 25.0062 17.0578 25.0062 17.1016 24.9828L34.6016 16.2328C34.6547 16.2078 34.6875 16.1531 34.6875 16.0937C34.6875 16.0343 34.6547 15.9812 34.6016 15.9547L32.8125 15.0593V14.1593L36.25 15.8781V16.3093ZM20 23.1843V21.5031L17.0375 20.0218L16.3469 19.6765V24.3265L17.0312 24.6687L20 23.1843ZM9.27813 17.1906V20.7921L12.5 22.4031V18.3265C11.6219 18.3078 10.7563 18.1312 10.0859 17.7953C9.73126 17.6187 9.4625 17.4109 9.27813 17.1906ZM16.3469 18.4859V19.3265L20.1562 21.2312L25 18.8093V17.7531L21.4062 15.9562L16.3469 18.4859ZM19.9375 5.84685L24.425 8.0906L25.625 9.8906V20.3718L25.3125 20.5281V9.84372C25.3125 9.81247 25.3031 9.78277 25.2859 9.75621L24.3484 8.34996C24.3344 8.32808 24.3125 8.30934 24.2891 8.2984L15.8516 4.07965C15.8078 4.05621 15.7547 4.05621 15.7109 4.07965L15.0859 4.39215C15.0328 4.41871 15 4.47184 15 4.53122V14.4343L14.6875 14.5906V4.31559L15.7812 3.76871L19.9375 5.84685ZM27.1875 19.5906L30 18.1843V14.0031L27.1875 12.5968V19.5906ZM10.2266 15.2953C11.5672 14.625 13.7453 14.625 15.0859 15.2953C15.7078 15.6062 16.0344 15.9984 16.0344 16.4062C16.0344 16.814 15.7078 17.2062 15.0859 17.5172C13.7453 18.1875 11.5672 18.1875 10.2266 17.5172C9.60468 17.2062 9.27813 16.814 9.27813 16.4062C9.27813 15.9984 9.60468 15.6062 10.2266 15.2953ZM18.4953 17.0625L17.55 17.5343L17.5281 17.1218C17.5141 16.839 17.6687 16.575 17.9219 16.4484C18.0391 16.389 18.1766 16.3937 18.2891 16.4593C18.4016 16.525 18.4734 16.6437 18.4797 16.7734L18.4953 17.0625ZM21.5625 15.6843L25 17.4031V11.5031L21.5625 9.78434V15.6843ZM32.8125 15.4093V16.7781L34.1813 16.0937L32.8125 15.4093ZM21.25 15.6843L20.3125 16.1531V15.6609C20.3125 15.4109 20.4531 15.1812 20.6781 15.0703C20.8 15.0093 20.9453 15.0156 21.0625 15.0875C21.1797 15.1594 21.25 15.2875 21.25 15.4234V15.6843ZM14.375 14.7V13.8468L13.075 14.4968C13.525 14.5218 13.9656 14.5906 14.375 14.7ZM27.1875 10.0968V12.2468L30.1562 13.7312L32.3063 12.6562L27.1875 10.0968ZM16.5625 12.7531V13.6531L21.25 11.3093V10.4093L16.5625 12.7531ZM23.5563 8.28122L21.3359 9.39215L21.3328 9.39371L21.3281 9.39528L21.325 9.39684C21.3219 9.39997 21.3188 9.40154 21.3156 9.4031L21.3125 9.40621L21.3109 9.40777L21.3062 9.4109L21.3031 9.41403L21.3 9.41716L21.2984 9.41872L21.2969 9.42028C21.2953 9.42028 21.2953 9.42185 21.2953 9.42185L21.2906 9.42496L21.2875 9.42965L21.2844 9.43278L21.2812 9.43591L21.2797 9.43903L21.2781 9.4406V9.44216L21.2766 9.44527L21.275 9.44683L21.2719 9.45153L21.2687 9.45622L21.2672 9.45935L21.2656 9.46402L21.2641 9.46871L21.2625 9.47028C21.2625 9.47184 21.2609 9.47184 21.2609 9.4734V9.47497L21.2594 9.4781L21.2578 9.47966L21.2563 9.4859L21.2547 9.49059V9.49528L21.2531 9.49685C21.2531 9.49997 21.2531 9.50309 21.2516 9.50621V9.50934V9.51403L21.25 9.51872V9.5234V9.52652V9.52809C21.25 9.52965 21.25 9.52965 21.25 9.53122V10.0593L16.5625 12.4031V4.78434L23.5563 8.28122ZM24.1125 8.55935L23.9062 8.45621L21.7562 9.53122L25 11.1531V9.8906L24.1125 8.55935ZM24.7594 8.02966L25.8344 9.64215L26.8031 9.15778L25.7281 7.54528L24.7594 8.02966ZM24.5312 7.79372L16.1312 3.59372L17.0312 3.14371L25.4313 7.34372L24.5312 7.79372Z",
				fill: "#3D3D3D"
			})
		]
	});
})), lt = /* @__PURE__ */ we({ default: () => ut }), ut, dt = Se((() => {
	ut = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.1562 25.1565L6.61453 29.4273L7.03125 31.719L17.0312 36.719L33.2812 28.594L33.698 26.3023L25.1562 22.0315L36.4062 16.4065V15.7815L23.9062 9.53149H22.6562L3.90625 18.9065V19.5315L15.1562 25.1565ZM23.9062 21.4065L34.5312 16.094L23.2812 10.469L5.78125 19.219L16.4062 24.5315L23.2812 21.094L23.9062 21.4065ZM17.0312 2.96899L15.7812 3.59399L24.5312 7.96899L25.7812 7.34399L17.0312 2.96899Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.28125 22.094L7.03125 31.719L17.0312 36.719V27.6565H17.6562V25.7815H16.4062L3.90625 19.5315V21.4065L5.28125 22.094ZM14.8658 28.6635C14.8522 28.3315 14.6592 28.0329 14.3619 27.8843C14.3617 27.8843 14.3616 27.8841 14.3614 27.8841C14.2011 27.804 14.0103 27.8145 13.8598 27.9118C13.7094 28.0091 13.6214 28.1787 13.6287 28.3579C13.6833 29.6942 13.787 32.2349 13.8322 33.3421C13.8458 33.6743 14.0387 33.9727 14.3361 34.1213C14.3362 34.1215 14.3364 34.1215 14.3364 34.1217C14.4969 34.2018 14.6875 34.1912 14.8381 34.0938C14.9886 33.9966 15.0764 33.827 15.0692 33.6479C15.0147 32.3115 14.9109 29.7707 14.8658 28.6635ZM12.0737 27.204C12.0473 26.9026 11.8664 26.6365 11.5958 26.5013C11.5958 26.5012 11.5956 26.5012 11.5955 26.5012C11.4306 26.4187 11.2341 26.4318 11.0816 26.5356C10.9291 26.6391 10.8447 26.8173 10.8608 27.0009C10.9837 28.4051 11.2163 31.057 11.3117 32.1454C11.3381 32.4468 11.5191 32.7129 11.7895 32.8482C11.7897 32.8482 11.7898 32.8482 11.7898 32.8484C11.9548 32.9307 12.1514 32.9176 12.3039 32.814C12.4562 32.7102 12.5408 32.5323 12.5247 32.3485C12.4016 30.9443 12.1692 28.2924 12.0737 27.204ZM9.27734 25.7551C9.24062 25.4785 9.06922 25.2381 8.81968 25.1132C8.65265 25.0296 8.45297 25.0452 8.30093 25.1535C8.14875 25.262 8.06906 25.4456 8.09343 25.6307C8.28734 27.0962 8.65344 29.8635 8.79562 30.9381C8.83219 31.2148 9.00359 31.4552 9.25328 31.5799C9.25328 31.5801 9.25328 31.5801 9.25344 31.5801C9.42047 31.6635 9.62 31.6481 9.77203 31.5396C9.92407 31.4312 10.0039 31.2476 9.97937 31.0624C9.78547 29.597 9.41937 26.8296 9.27734 25.7551ZM32.0312 25.469L34.1466 17.5363L32.2886 18.4652L31.5794 22.8392C31.5389 23.0887 31.382 23.3041 31.1569 23.4195C30.9317 23.5348 30.6653 23.536 30.4391 23.4229C30.2708 23.3388 30.1767 23.1551 30.2069 22.9695L30.818 19.2006L29.1841 20.0176L29.0223 21.5542C28.9959 21.8048 28.8483 22.0263 28.6273 22.1474C28.4064 22.2685 28.1402 22.2735 27.9148 22.1609C27.9148 22.1607 27.9147 22.1607 27.9147 22.1607C27.7592 22.0831 27.6683 21.917 27.6866 21.7442L27.7952 20.7121L25.1562 22.0315L32.0312 25.469ZM24.5312 7.96899L15.7812 3.59399L14.5312 4.21899V15.469L15.1562 15.7815V4.53149L15.7812 4.21899L24.2188 8.43774L25.1562 9.84399V11.4065L23.2812 10.469V21.094L23.9062 21.4065L27.9341 19.3926L28.1652 17.1963C28.1916 16.9457 28.3392 16.7241 28.5602 16.6031C28.7811 16.482 29.0473 16.477 29.2727 16.5896C29.2727 16.5898 29.2728 16.5898 29.2728 16.5898C29.4283 16.6674 29.5192 16.8335 29.5009 17.0063L29.323 18.6982L34.5312 16.094L25.7812 11.719V9.84399L27.0312 9.21899L25.7812 7.34399L24.5312 7.96899Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.4614 4.07933L16.9614 2.82933C17.0053 2.8073 17.0572 2.8073 17.1011 2.82933L25.8497 7.20355C25.8716 7.21417 25.8913 7.23011 25.9066 7.25073L25.9112 7.25745L27.1642 9.13698L27.177 9.16292L27.185 9.19151L27.1875 9.21901V10.9975L36.4761 15.6418C36.5291 15.6682 36.5625 15.7223 36.5625 15.7815V18.2815C36.5625 18.3407 36.5291 18.3948 36.4761 18.4212L35.1709 19.0739L33.435 28.622C33.4263 28.6704 33.3952 28.7118 33.3511 28.7337L17.1011 36.8587L17.0731 36.8696L17.0439 36.8748L17.0144 36.8743L16.9855 36.8684L16.9614 36.8587L6.9614 31.8587C6.91734 31.8368 6.88625 31.7954 6.8775 31.747L5.14156 22.1989L3.8364 21.5462C3.78343 21.5198 3.75 21.4657 3.75 21.4065V18.9065C3.75 18.8473 3.78343 18.7932 3.8364 18.7668L14.375 13.4975V4.21901C14.375 4.15979 14.4084 4.10573 14.4614 4.07933ZM7.17093 31.6142L16.875 36.4662V27.8128L16.4008 27.8126C16.3766 27.8118 16.3537 27.8056 16.3336 27.7949L5.49094 22.3735L7.17093 31.6142ZM15.0219 28.6571C15.0059 28.2682 14.78 27.9187 14.4317 27.7446L14.4312 27.7443C14.2216 27.6395 13.972 27.6532 13.775 27.7806C13.5781 27.9079 13.4631 28.1299 13.4727 28.3642C13.5272 29.7006 13.6309 32.2414 13.6761 33.3485C13.6919 33.7375 13.918 34.0871 14.2661 34.2612L14.2666 34.2614C14.4764 34.3662 14.7259 34.3524 14.923 34.2251C15.1198 34.0978 15.2348 33.8759 15.2253 33.6415C15.1708 32.3051 15.067 29.7645 15.0219 28.6571ZM14.7095 28.67C14.7548 29.7771 14.8584 32.3179 14.913 33.6543C14.9181 33.7781 14.8573 33.8954 14.7533 33.9628C14.6492 34.0299 14.5172 34.0373 14.4064 33.9818L14.4059 33.9817C14.1595 33.8584 13.9995 33.611 13.9883 33.3359C13.9431 32.2285 13.8394 29.6879 13.7848 28.3515C13.7798 28.2276 13.8406 28.1103 13.9447 28.0431C14.0487 27.9757 14.1806 27.9684 14.2916 28.0239L14.292 28.024C14.5384 28.1473 14.6984 28.3946 14.7095 28.67ZM20.625 28.1314V32.9843C20.625 33.2989 20.4473 33.5864 20.1659 33.727L20.1655 33.7271C20.0631 33.7784 19.9416 33.7729 19.8442 33.7128C19.7467 33.6526 19.6875 33.5462 19.6875 33.4317C19.6875 32.1692 19.6875 29.7182 19.6875 28.5787C19.6875 28.2642 19.8652 27.9767 20.1466 27.836L20.147 27.8359C20.2494 27.7846 20.3709 27.7901 20.4683 27.8503C20.5658 27.9104 20.625 28.0168 20.625 28.1314ZM12.2294 27.1904C12.1983 26.835 11.9848 26.521 11.6656 26.3615L11.6655 26.3614C11.4498 26.2537 11.193 26.2709 10.9937 26.4064C10.7944 26.5418 10.6841 26.7745 10.7052 27.0145C10.8281 28.4187 11.0606 31.0706 11.1559 32.1592C11.1872 32.5146 11.4006 32.8284 11.7197 32.9879L11.72 32.9881C11.9355 33.0959 12.1925 33.0787 12.3917 32.9431C12.5909 32.8076 12.7014 32.575 12.6803 32.335L12.2294 27.1904ZM11.8555 26.9815C11.8894 27.0549 11.9108 27.1346 11.9181 27.2176L12.3691 32.3621C12.3802 32.4895 12.3216 32.6129 12.2159 32.6848C12.1103 32.7567 11.9741 32.7657 11.8598 32.7085L11.8595 32.7084C11.6375 32.5974 11.4891 32.3792 11.4673 32.1318L11.0511 27.3837L11.8555 26.9815ZM23.3953 26.7975L23.1509 31.8079C23.1378 32.0779 22.98 32.3199 22.7381 32.4409C22.6264 32.4968 22.4933 32.4892 22.3888 32.421C22.2841 32.3528 22.2236 32.2342 22.2297 32.1093C22.2955 30.761 22.4202 28.2025 22.4741 27.0989C22.4872 26.8289 22.645 26.5868 22.8869 26.4659C22.9986 26.41 23.1317 26.4176 23.2362 26.4857C23.3409 26.554 23.4014 26.6726 23.3953 26.7975ZM9.43219 25.7346C9.38875 25.4065 9.18547 25.1215 8.88953 24.9735L8.88938 24.9734C8.67063 24.864 8.40937 24.8843 8.21015 25.0264C8.01093 25.1684 7.90656 25.4087 7.93859 25.6512C8.1325 27.1167 8.4986 29.884 8.64079 30.9587C8.68422 31.2867 8.88734 31.5718 9.18344 31.7198C9.40234 31.8292 9.6636 31.8089 9.86281 31.6668C10.0619 31.5248 10.1664 31.2845 10.1344 31.042C9.94047 29.5765 9.57438 26.8092 9.43219 25.7346ZM9.44157 28.1885L9.82453 31.0829C9.84141 31.2109 9.78641 31.3376 9.68141 31.4125C9.57641 31.4873 9.43859 31.4979 9.32328 31.4403C9.12 31.3387 8.98031 31.1429 8.95062 30.9176L8.64234 28.5881L9.44157 28.1885ZM26.1637 25.4304L25.6711 30.6023C25.648 30.8453 25.5012 31.0593 25.2828 31.1685L25.2823 31.1687C25.1678 31.226 25.0311 31.2167 24.9255 31.1442C24.8197 31.0717 24.7617 30.9476 24.7738 30.8201L25.2664 25.6482C25.2895 25.4053 25.4363 25.1912 25.6547 25.082L25.6552 25.0818C25.7697 25.0245 25.9064 25.0339 26.012 25.1064C26.1178 25.1789 26.1758 25.3029 26.1637 25.4304ZM28.3009 23.7785L28.9262 24.0912L28.187 29.3889C28.1562 29.6093 28.0189 29.8004 27.8198 29.9001L27.8195 29.9003C27.7037 29.9581 27.5655 29.947 27.4605 29.8715C27.3553 29.796 27.3008 29.6685 27.3186 29.5404L28.063 24.2054C28.0866 24.0367 28.1725 23.885 28.3009 23.7785ZM30.4811 24.8685L31.2316 25.2439L30.6991 28.1726C30.6628 28.372 30.5348 28.5424 30.3537 28.6331L30.3536 28.6332C30.2375 28.6912 30.0987 28.6787 29.9948 28.6009C29.8911 28.5229 29.8402 28.3932 29.8634 28.2656L30.4811 24.8685ZM17.5 25.9378V27.5003H16.5625V25.9378H17.5ZM4.0625 19.7843L16.25 25.8781V27.4037L4.0625 21.31V19.7843ZM27.1875 11.3468L36.25 15.8781V16.31L17.6194 25.6253H16.4431L4.0625 19.435V19.0031L14.375 13.8468V14.7475L5.7114 19.0793C5.65843 19.1057 5.625 19.1598 5.625 19.219C5.625 19.2782 5.65843 19.3323 5.7114 19.3587L16.9614 24.9837C17.0053 25.0057 17.0572 25.0057 17.1011 24.9837L34.6011 16.2337C34.6541 16.2073 34.6875 16.1532 34.6875 16.094C34.6875 16.0348 34.6541 15.9807 34.6011 15.9543L27.1875 12.2475V11.3468ZM31.5998 23.2182L31.2898 24.9235L30.5392 24.5484L30.7011 23.6585C30.8805 23.6762 31.0634 23.6429 31.2281 23.5585C31.3825 23.4795 31.51 23.3612 31.5998 23.2182ZM23.5569 21.4065L23.2812 21.2687L16.7556 24.5315L17.0312 24.6693L23.5569 21.4065ZM15.6989 18.0546L16.1777 22.6024C16.2148 22.956 16.0289 23.2956 15.7109 23.4545C15.7108 23.4545 15.7108 23.4545 15.7108 23.4546C15.6147 23.5026 15.5011 23.5004 15.4069 23.4489C15.3127 23.3973 15.2498 23.3028 15.2386 23.1959L14.7598 18.6481C14.7227 18.2945 14.9086 17.955 15.2266 17.796C15.2267 17.796 15.2267 17.796 15.2267 17.7959C15.3228 17.7479 15.4364 17.7501 15.5306 17.8017C15.6248 17.8532 15.6877 17.9478 15.6989 18.0546ZM31.5083 22.3014L31.4252 22.814C31.3927 23.0146 31.2666 23.1878 31.0856 23.2804C30.983 23.3331 30.8694 23.356 30.7572 23.3495L30.8634 22.7654C30.8997 22.566 31.0277 22.3956 31.2088 22.305L31.2089 22.3048C31.3041 22.2573 31.4144 22.2571 31.5083 22.3014ZM13.4825 22.895L12.3566 22.332L11.9852 20.0421C11.9294 19.6979 12.1038 19.3575 12.4156 19.2015L12.4159 19.2014C12.517 19.1507 12.6363 19.1514 12.737 19.2029C12.8377 19.2545 12.9078 19.3509 12.9259 19.4626L13.4825 22.895ZM18.4802 16.7732L18.7211 21.4717C18.7356 21.7546 18.5812 22.0193 18.3278 22.146C18.3277 22.146 18.3275 22.1462 18.3275 22.1462C18.2111 22.2045 18.0731 22.2 17.9608 22.1345C17.8483 22.0689 17.7766 21.951 17.7698 21.821C17.7053 20.5637 17.5844 18.2042 17.5289 17.1226C17.5144 16.8396 17.6688 16.575 17.9222 16.4482C17.9223 16.4482 17.9225 16.4481 17.9225 16.4481C18.0389 16.3898 18.1769 16.3943 18.2892 16.4598C18.4017 16.5254 18.4734 16.6432 18.4802 16.7732ZM10.245 21.2762L9.34218 20.8248C9.40937 20.7356 9.49734 20.6606 9.6025 20.6081L9.60281 20.6079C9.70969 20.5545 9.83516 20.5532 9.94297 20.6046C10.0508 20.6559 10.1289 20.754 10.1548 20.8706L10.245 21.2762ZM25 11.5031V20.685L23.9062 21.2318L23.4375 20.9975V10.7218L25 11.5031ZM21.25 15.424V20.2765C21.25 20.5268 21.1086 20.7557 20.8847 20.8676C20.7622 20.9289 20.6166 20.9223 20.5 20.8503C20.3834 20.7784 20.3125 20.651 20.3125 20.514V15.6615C20.3125 15.4112 20.4539 15.1823 20.6778 15.0704C20.8003 15.0092 20.9459 15.0157 21.0625 15.0878C21.1791 15.1596 21.25 15.287 21.25 15.424ZM15.7812 3.7687L24.4242 8.09026L25.625 9.89135V20.3725L25.3125 20.5287V9.84401C25.3125 9.81323 25.3034 9.78308 25.2862 9.7573L24.3487 8.35105C24.3337 8.32855 24.313 8.31011 24.2886 8.29808L15.7812 4.04433L15.0864 4.39183C15.0334 4.41823 15 4.47229 15 4.53151V15.5287L14.6875 15.3725V4.31557L15.7812 3.7687ZM27.8531 12.9296L34.1819 16.094L29.5081 18.4309L29.6564 17.0226C29.6814 16.7851 29.5564 16.5568 29.3427 16.4501C29.3427 16.4499 29.3427 16.45 29.3425 16.45C29.0714 16.3143 28.7509 16.3204 28.485 16.466C28.2191 16.6117 28.0416 16.8784 28.0098 17.18L27.7877 19.2912L27.1875 19.5912V12.5968L27.8531 12.9296ZM29.1766 18.5967L28.1192 19.1253L28.3206 17.2128C28.3416 17.0131 28.4592 16.8365 28.6352 16.7401C28.8111 16.6437 29.0233 16.6396 29.2028 16.7295L29.203 16.7296C29.3002 16.7782 29.357 16.882 29.3456 16.99L29.1766 18.5967ZM25 10.2531L23.8694 9.68776H22.6931L16.5625 12.7531V13.6537L23.2114 10.3293C23.2553 10.3073 23.3072 10.3073 23.3511 10.3293L25 11.1537V10.2531ZM16.5625 4.78432V12.4037L22.5864 9.39183C22.6081 9.38089 22.632 9.37526 22.6562 9.37526H23.9062C23.9305 9.37526 23.9544 9.38089 23.9761 9.39183L25 9.9037V9.89135L24.1117 8.55901L16.5625 4.78432ZM24.7594 8.02964L25.8347 9.64261L26.8031 9.15839L25.7278 7.54542L24.7594 8.02964ZM24.5312 7.79433L16.1306 3.59401L17.0312 3.1437L25.4319 7.34401L24.5312 7.79433Z",
				fill: "#3D3D3D"
			})
		]
	});
})), ft = /* @__PURE__ */ we({ default: () => pt }), pt, mt = Se((() => {
	pt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.1562 35.1562V22.6562L32.6562 28.9062V13.9062L20.1562 7.65625V20.1562L13.9062 23.2812L7.65625 20.1562V28.9062L20.1562 35.1562Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M32.6562 13.9062L20.1562 20.1562L26.4062 23.2812L38.9062 17.0312L32.6562 13.9062ZM7.65625 13.9062L1.40625 17.0312L13.9062 23.2812L20.1562 20.1562L7.65625 13.9062ZM13.9062 4.53125L1.40625 10.7812L7.65625 13.9062L20.1562 7.65625L13.9062 4.53125ZM26.4062 4.53125L20.1562 7.65625L32.6562 13.9062L38.9062 10.7812L26.4062 4.53125Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.1562 7.48158L26.3359 4.39158C26.3797 4.36955 26.4328 4.36955 26.4766 4.39158L38.9766 10.6416C39.0297 10.668 39.0625 10.7221 39.0625 10.7813C39.0625 10.8405 39.0297 10.8945 38.9766 10.921L33.0062 13.9063L38.9766 16.8916C39.0297 16.918 39.0625 16.9721 39.0625 17.0313C39.0625 17.0905 39.0297 17.1445 38.9766 17.171L32.8125 20.2528V28.9063C32.8125 28.9655 32.7797 29.0195 32.7266 29.046L20.2266 35.296L20.2234 35.2975L20.2188 35.2997L20.2141 35.3016L20.2094 35.3033L20.2047 35.3049L20.2 35.3064L20.1953 35.3077L20.1906 35.3088L20.1859 35.3099L20.1797 35.3106L20.175 35.3113L20.1703 35.3119L20.1656 35.3122L20.1609 35.3125H20.1562L20.1516 35.3124L20.1453 35.3122L20.1406 35.3117L20.1359 35.3113L20.1312 35.3105L20.1266 35.3097L20.1219 35.3086L20.1172 35.3075L20.1125 35.3061L20.1078 35.3047L20.1031 35.3033L20.0984 35.3016L20.0937 35.2997L20.0891 35.2975L20.0859 35.296L7.58595 29.046C7.53282 29.0195 7.5 28.9655 7.5 28.9063V20.2528L1.33595 17.171C1.28282 17.1445 1.25 17.0905 1.25 17.0313C1.25 16.9721 1.28282 16.918 1.33595 16.8916L7.30625 13.9063L1.33595 10.921C1.28282 10.8945 1.25 10.8405 1.25 10.7813C1.25 10.7221 1.28282 10.668 1.33595 10.6416L13.8359 4.39158C13.8797 4.36955 13.9328 4.36955 13.9766 4.39158L20.1562 7.48158ZM20 20.4091L13.9766 23.421C13.9328 23.443 13.8797 23.443 13.8359 23.421L7.8125 20.4091V28.8097L20 34.9035V20.4091ZM17.8938 32.2595C17.9422 32.2856 18.0016 32.2844 18.0484 32.2563C18.0969 32.2281 18.125 32.177 18.125 32.122V30.8033L18.2125 30.8461C18.2703 30.8742 18.3406 30.8638 18.3875 30.8199C18.4344 30.776 18.45 30.7075 18.4266 30.6475L17.9578 29.4733C17.9359 29.4199 17.8875 29.3825 17.8297 29.376C17.7734 29.3695 17.7172 29.395 17.6844 29.4424L17.2156 30.1191C17.1891 30.1563 17.1813 30.2028 17.1922 30.2467C17.2031 30.2906 17.2328 30.3275 17.2734 30.3478L17.5 30.4608V31.9531C17.5 32.0105 17.5313 32.0633 17.5813 32.0906L17.8938 32.2595ZM16.3313 31.4783C16.3797 31.5044 16.4391 31.5031 16.4859 31.475C16.5344 31.4469 16.5625 31.3958 16.5625 31.3408V30.022L16.65 30.0649C16.7078 30.093 16.7781 30.0825 16.825 30.0386C16.8719 29.9947 16.8875 29.9263 16.8641 29.8663L16.3953 28.6921C16.3734 28.6386 16.325 28.6013 16.2672 28.5947C16.2109 28.5883 16.1547 28.6138 16.1219 28.6611L15.6531 29.3378C15.6266 29.375 15.6188 29.4216 15.6297 29.4655C15.6406 29.5094 15.6703 29.5463 15.7109 29.5666L15.9375 29.6795V31.1719C15.9375 31.2292 15.9688 31.2821 16.0188 31.3094L16.3313 31.4783ZM32.6562 14.081L38.5563 17.0313L26.4062 23.1066L20.5062 20.1563L32.6562 14.081ZM7.65625 14.081L19.8063 20.1563L13.9062 23.1066L1.75625 17.0313L7.65625 14.081ZM20.3125 19.9035L32.3063 13.9063L20.3125 7.90908V19.9035ZM19.8063 7.65627L7.65625 13.7316L1.75625 10.7813L13.9062 4.70595L19.8063 7.65627ZM20.5062 7.65627L26.4062 4.70595L38.5563 10.7813L32.6562 13.7316L20.5062 7.65627Z",
				fill: "#3D3D3D"
			})
		]
	});
})), ht = /* @__PURE__ */ we({ default: () => gt }), gt, _t = Se((() => {
	gt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.1562 18.5938L5.15625 11.0938V28.5938L20.1562 36.0938V18.5938ZM28.9062 14.2188L26.4062 15.4688V19.2188L28.9062 17.9688V14.2188Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.4062 15.4688L6.40625 12.9688V16.7188L11.4062 19.2188V15.4688ZM20.1562 3.59375L5.15625 11.0938L20.1562 18.5938L35.1562 11.0938L20.1562 3.59375Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.08595 10.9541L5.08282 10.9558L5.07812 10.9583L5.075 10.9599C5.07187 10.9619 5.06876 10.9641 5.06563 10.9663L5.0625 10.9683L5.06094 10.97L5.05625 10.9733L5.05312 10.9761L5.04999 10.9791L5.04845 10.9813L5.04688 10.9824L5.04532 10.9842L5.04063 10.9881L5.0375 10.9922L5.03437 10.9953L5.03124 10.9992L5.02968 11.0011L5.02813 11.0031V11.0052L5.02657 11.0072L5.02501 11.0097L5.02188 11.0139L5.01875 11.0186L5.01719 11.0221L5.01562 11.0264L5.01406 11.031L5.01249 11.033L5.01093 11.0355V11.038L5.00938 11.0405L5.00782 11.043L5.00626 11.0481L5.00469 11.0533V11.0572L5.00313 11.0596C5.00313 11.0624 5.00313 11.0652 5.00156 11.068V11.0719V11.0772L5 11.0811V11.0861V11.0888V11.0911V11.0938V28.5938C5 28.653 5.03282 28.707 5.08595 28.7335L20.0859 36.2335L20.0891 36.235L20.0937 36.2372L20.0984 36.2391L20.1031 36.2408L20.1078 36.2424L20.1125 36.2439L20.1172 36.2452L20.1219 36.2463L20.1266 36.2474L20.1328 36.2481L20.1375 36.2488L20.1422 36.2494L20.1469 36.2497L20.1516 36.25H20.1562L20.1609 36.2499L20.1672 36.2497L20.1719 36.2492L20.1766 36.2488L20.1813 36.248L20.1859 36.2472L20.1906 36.2461L20.1953 36.245L20.2 36.2436L20.2047 36.2422L20.2094 36.2408L20.2141 36.2391L20.2188 36.2372L20.2234 36.235L20.2266 36.2335L35.2266 28.7335C35.2797 28.707 35.3125 28.653 35.3125 28.5938V11.0938V11.0902V11.0855V11.0811L35.3109 11.0772V11.0736V11.0688C35.3094 11.066 35.3094 11.0624 35.3094 11.0596L35.3078 11.056L35.3062 11.0506L35.3047 11.0455L35.3031 11.0417L35.3016 11.0375V11.0355L35.3 11.033L35.2984 11.0305L35.2969 11.0256L35.2953 11.0221L35.2922 11.0177L35.2906 11.0135L35.2891 11.0113L35.2875 11.0094L35.2859 11.0071L35.2844 11.0044L35.2813 11.0006L35.2797 10.9972L35.2766 10.9935L35.2734 10.9897L35.2687 10.986L35.2672 10.9842L35.2656 10.9824L35.2641 10.9805L35.2625 10.9788L35.2594 10.9769L35.2578 10.9752L35.2531 10.9717L35.25 10.9692L35.2469 10.9663C35.2437 10.9641 35.2406 10.9619 35.2375 10.9599L35.2328 10.958L35.2297 10.9558L35.2266 10.9541L20.2266 3.45408C20.1828 3.43205 20.1297 3.43205 20.0859 3.45408L5.08595 10.9541ZM5.3125 11.3466L8.89063 13.136L20 18.6903V35.841L5.3125 28.4972V11.3466ZM17.8938 33.197C17.9422 33.2231 18.0016 33.2219 18.0484 33.1938C18.0969 33.1656 18.125 33.1145 18.125 33.0595V31.7408L18.2125 31.7836C18.2703 31.8117 18.3406 31.8013 18.3875 31.7574C18.4344 31.7135 18.45 31.645 18.4266 31.585L17.9578 30.4108C17.9359 30.3574 17.8875 30.32 17.8297 30.3135C17.7734 30.307 17.7172 30.3325 17.6844 30.3799L17.2156 31.0566C17.1891 31.0938 17.1813 31.1403 17.1922 31.1842C17.2031 31.2281 17.2328 31.265 17.2734 31.2853L17.5 31.3983V32.8906C17.5 32.948 17.5313 33.0008 17.5813 33.0281L17.8938 33.197ZM16.3313 32.4158C16.3797 32.4419 16.4391 32.4406 16.4859 32.4125C16.5344 32.3844 16.5625 32.3333 16.5625 32.2783V30.9595L16.65 31.0024C16.7078 31.0305 16.7781 31.02 16.825 30.9761C16.8719 30.9322 16.8875 30.8638 16.8641 30.8038L16.3953 29.6296C16.3734 29.5761 16.325 29.5388 16.2672 29.5322C16.2109 29.5258 16.1547 29.5513 16.1219 29.5986L15.6531 30.2753C15.6266 30.3125 15.6188 30.3591 15.6297 30.403C15.6406 30.4469 15.6703 30.4838 15.7109 30.5041L15.9375 30.617V32.1094C15.9375 32.1667 15.9688 32.2196 16.0188 32.2469L16.3313 32.4158ZM28.75 14.4716V17.8722L26.5625 18.966V15.5653L28.75 14.4716ZM20.1562 18.4191L26.0563 15.4688L11.4062 8.14345L5.50625 11.0938L20.1562 18.4191ZM12.8312 7.43112L11.7562 7.96877L26.4062 15.2941L28.5563 14.2188L13.9062 6.89345L12.8312 7.43112ZM14.2562 6.71877L28.9062 14.0441L34.8063 11.0938L20.1562 3.76845L14.2562 6.71877Z",
				fill: "#3D3D3D"
			})
		]
	});
})), vt = /* @__PURE__ */ we({ default: () => yt }), yt, bt = Se((() => {
	yt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.1562 27.3438L23.9062 31.7188V36.7188L15.1562 32.3438V27.3438ZM10.7812 22.0312L1.40625 17.3438V27.9688L10.7812 32.6562V22.0312ZM26.4062 27.6562L22.0312 29.8438L23.9062 30.7812L28.2812 28.5938L26.4062 27.6562ZM21.4062 10.4688L13.9062 6.71875V22.9688L21.4062 26.7188V10.4688ZM28.2812 7.65625L25.7812 8.90625V10.7812L28.2812 9.53125V7.65625Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23.9062 31.7188L15.1562 27.3438L30.1562 19.8438L38.9062 24.2188L23.9062 31.7188ZM26.4062 27.6562L22.0312 29.8438L23.9062 30.7812L28.2812 28.5938L26.4062 27.6562ZM6.40625 21.0938L2.65625 19.2188V21.7188L6.40625 23.5938V21.0938ZM10.7812 12.6562L1.40625 17.3438L10.7812 22.0312L20.1562 17.3438L10.7812 12.6562ZM13.9062 6.71875L21.4062 10.4688L28.9062 6.71875L21.4062 2.96875L13.9062 6.71875Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.8328 6.5808L13.8359 6.57908L21.3359 2.82908C21.3797 2.80705 21.4328 2.80705 21.4766 2.82908L28.9766 6.57908L28.9797 6.5808L28.9844 6.5833L28.9875 6.58486C28.9906 6.58689 28.9938 6.58908 28.9969 6.59127L29 6.5933L29.0016 6.59502L29.0062 6.5983L29.0094 6.60111L29.0125 6.60408L29.0141 6.60627L29.0156 6.60736C29.0172 6.60799 29.0172 6.60861 29.0172 6.60924L29.0219 6.61314L29.025 6.6172L29.0281 6.62033L29.0313 6.62424V6.62611L29.0344 6.62814V6.63017L29.0359 6.6322L29.0375 6.6347L29.0406 6.63893L29.0437 6.64361L29.0453 6.64705L29.0469 6.65142L29.0484 6.65596L29.05 6.65799C29.05 6.65877 29.0516 6.65955 29.0516 6.66049V6.66299L29.0531 6.66549L29.0547 6.66799L29.0562 6.67315L29.0578 6.6783V6.68221L29.0594 6.68455C29.0594 6.68736 29.0594 6.69018 29.0609 6.69299V6.69689V6.7022L29.0625 6.70611V6.71111V6.71377V6.71611C29.0625 6.71705 29.0625 6.71783 29.0625 6.71877V20.216L30.0859 19.7041C30.1297 19.6821 30.1828 19.6821 30.2266 19.7041L38.9766 24.0791L38.9797 24.0808L38.9844 24.0833L38.9875 24.0849C38.9906 24.0869 38.9938 24.0891 38.9969 24.0913L39 24.0933L39.0016 24.095L39.0062 24.0983L39.0094 24.1011L39.0125 24.1041L39.0141 24.1063L39.0156 24.1074C39.0172 24.108 39.0172 24.1086 39.0172 24.1092L39.0219 24.1131L39.025 24.1172L39.0281 24.1203L39.0313 24.1242V24.1261L39.0344 24.1281V24.1302L39.0359 24.1322L39.0375 24.1347L39.0406 24.1389L39.0437 24.1436L39.0453 24.1471L39.0469 24.1514L39.0484 24.156L39.05 24.158C39.05 24.1588 39.0516 24.1596 39.0516 24.1605V24.163L39.0531 24.1655L39.0547 24.168L39.0562 24.1731L39.0578 24.1783V24.1822L39.0594 24.1846C39.0594 24.1874 39.0594 24.1902 39.0609 24.193V24.1969V24.2022L39.0625 24.2061V24.2111V24.2138V24.2161C39.0625 24.217 39.0625 24.2178 39.0625 24.2188V29.2188C39.0625 29.278 39.0297 29.332 38.9766 29.3585L23.9766 36.8585L23.9734 36.86L23.9687 36.8622L23.9641 36.8641L23.9594 36.8658L23.9547 36.8674L23.95 36.8689L23.9453 36.8702L23.9406 36.8713L23.9359 36.8724L23.9312 36.8731L23.925 36.8738L23.9203 36.8744L23.9156 36.8747L23.9109 36.875H23.9062L23.9016 36.8749L23.8953 36.8747L23.8906 36.8742L23.886 36.8738L23.8813 36.873L23.8766 36.8722L23.8719 36.8711L23.8672 36.87L23.8625 36.8686L23.8578 36.8672L23.8531 36.8658L23.8484 36.8641L23.8438 36.8622L23.8391 36.86L23.8359 36.8585L15.0859 32.4835C15.0328 32.457 15 32.403 15 32.3438V30.7216L10.8516 32.796L10.8484 32.7975L10.8437 32.7997L10.8391 32.8016L10.8344 32.8033L10.8297 32.8049L10.825 32.8064L10.8203 32.8077L10.8156 32.8088L10.8109 32.8099L10.8062 32.8106L10.8 32.8113L10.7953 32.8119L10.7906 32.8122L10.7859 32.8125H10.7812L10.7766 32.8124L10.7703 32.8122L10.7656 32.8117L10.761 32.8113L10.7563 32.8105L10.7516 32.8097L10.7469 32.8086L10.7422 32.8075L10.7375 32.8061L10.7328 32.8047L10.7281 32.8033L10.7234 32.8016L10.7188 32.7997L10.7141 32.7975L10.7109 32.796L1.33595 28.1085C1.28282 28.082 1.25 28.028 1.25 27.9688V17.3438V17.3402V17.3355V17.3311L1.25156 17.3272V17.3236V17.3188V17.318C1.25313 17.3152 1.25313 17.3124 1.25313 17.3096L1.25469 17.306L1.25626 17.3006L1.25782 17.2955L1.25938 17.2917L1.26095 17.2875V17.2855C1.26095 17.2846 1.26251 17.2838 1.26251 17.283L1.26408 17.2805L1.26564 17.2756L1.2672 17.2721L1.27029 17.2677L1.27186 17.2635L1.27342 17.2613L1.27499 17.2594L1.27655 17.2571L1.27811 17.2544L1.28124 17.2506L1.28281 17.2472L1.28593 17.2435L1.28906 17.2397L1.29375 17.236L1.29532 17.2342C1.29532 17.2336 1.29532 17.233 1.29688 17.2324L1.29845 17.2305L1.30001 17.2288L1.30314 17.2269L1.3047 17.2252L1.30936 17.2217L1.31248 17.2192L1.31561 17.2163C1.31874 17.2141 1.32187 17.2119 1.325 17.2099L1.32969 17.208L1.33282 17.2058L1.33595 17.2041L10.7109 12.5166C10.7547 12.4946 10.8078 12.4946 10.8516 12.5166L13.75 13.966V6.71877V6.71517V6.71049V6.70611L13.7516 6.7022V6.69861V6.69377V6.69299C13.7531 6.69018 13.7531 6.68736 13.7531 6.68455L13.7547 6.68096L13.7563 6.67564L13.7578 6.67048L13.7594 6.66674L13.7609 6.66252V6.66049C13.7609 6.65955 13.7625 6.65877 13.7625 6.65799L13.7641 6.65548L13.7656 6.65065L13.7672 6.64705L13.7703 6.64268L13.7719 6.63846L13.7734 6.63627L13.775 6.6344L13.7766 6.63205L13.7781 6.62939L13.7812 6.62564L13.7828 6.62221L13.7859 6.61845L13.7891 6.6147L13.7938 6.61096L13.7953 6.60924C13.7953 6.60861 13.7953 6.60799 13.7969 6.60736L13.7984 6.60549L13.8 6.60377L13.8031 6.6019L13.8047 6.60018L13.8094 6.59674L13.8125 6.59424L13.8156 6.59127C13.8187 6.58908 13.8219 6.58689 13.825 6.58486L13.8297 6.58298L13.8328 6.5808ZM15.3125 32.2472L18.75 33.966V32.9688C18.75 32.9145 18.7781 32.8644 18.8234 32.8358C18.8703 32.8074 18.9281 32.8049 18.9766 32.8291L20.2266 33.4541C20.2797 33.4805 20.3125 33.5345 20.3125 33.5938V34.7472L23.75 36.466V31.8153L20.3125 30.0966V31.0938C20.3125 31.148 20.2844 31.1981 20.2391 31.2267C20.1922 31.2552 20.1344 31.2577 20.0859 31.2335L18.8359 30.6085C18.7828 30.582 18.75 30.528 18.75 30.4688V29.3153L15.3125 27.5966V32.2472ZM19.0625 33.2216L20 33.6903V34.591L19.0625 34.1222V33.2216ZM10.625 22.1278V32.4035L1.5625 27.8722V17.5966L10.625 22.1278ZM35.1562 22.5185L38.5563 24.2188L23.9062 31.5441L20.5062 29.8438L35.1562 22.5185ZM19.0625 29.4716L20 29.9403V30.841L19.0625 30.3722V29.4716ZM9.14375 30.7625C9.19219 30.7886 9.25156 30.7874 9.29844 30.7592C9.34688 30.7311 9.375 30.68 9.375 30.625V29.6291L9.46251 29.6719C9.52345 29.7014 9.59687 29.6883 9.64375 29.6391C9.69062 29.5899 9.70154 29.5161 9.66873 29.4564L9.19998 28.597C9.17811 28.5569 9.13906 28.5283 9.09531 28.5189C9.04999 28.5095 9.00311 28.5203 8.96717 28.5481L8.49842 28.9102C8.45623 28.943 8.43281 28.9955 8.43906 29.0489C8.44375 29.1025 8.47501 29.1495 8.52345 29.1736L8.75 29.2866V30.4561C8.75 30.5135 8.78125 30.5663 8.83125 30.5936L9.14375 30.7625ZM19.2562 29.2188L33.9062 21.8935L34.8063 22.3438L20.1562 29.6691L19.7063 29.4439L19.2562 29.2188ZM33.5563 21.7188L18.9062 29.0441L15.5062 27.3438L30.1562 20.0185L33.5563 21.7188ZM16.875 8.37783L14.0625 6.97158V14.1222L20.2266 17.2041L20.2297 17.2058L20.2344 17.2083L20.2375 17.2099C20.2406 17.2119 20.2438 17.2141 20.2469 17.2163L20.25 17.2183L20.2516 17.22L20.2562 17.2233L20.2594 17.2261L20.2625 17.2291L20.2641 17.2313L20.2656 17.2324C20.2672 17.233 20.2672 17.2336 20.2672 17.2342L20.2719 17.2381L20.275 17.2422L20.2781 17.2453L20.2813 17.2492V17.2511L20.2844 17.2531V17.2552L20.2859 17.2572L20.2875 17.2597L20.2906 17.2639L20.2937 17.2686L20.2953 17.2721L20.2969 17.2764L20.2984 17.281L20.3 17.283C20.3 17.2838 20.3016 17.2846 20.3016 17.2855V17.288L20.3031 17.2905L20.3047 17.293L20.3062 17.2981L20.3078 17.3033V17.3072L20.3094 17.3096C20.3094 17.3124 20.3094 17.3152 20.3109 17.318V17.3219V17.3272L20.3125 17.3311V17.3361V17.3388V17.3413V17.3438V24.591L21.25 24.1222V10.5653L18.4375 9.15908V10.7813C18.4375 10.8355 18.4094 10.8856 18.3641 10.9142C18.3172 10.9427 18.2594 10.9452 18.2109 10.921L16.9609 10.296C16.9078 10.2695 16.875 10.2155 16.875 10.1563V8.37783ZM15.9375 19.6278V21.7785L15 22.2472V20.0966L15.1844 20.0047L15.9375 19.6278ZM1.75625 17.3438L10.7812 21.8566L14.4938 20L5.46875 15.4872L1.75625 17.3438ZM6.71875 14.8622L6.26877 15.0874L5.81875 15.3125L14.8438 19.8253L15.2937 19.6002L15.7438 19.375L6.71875 14.8622ZM7.06875 14.6875L10.7812 12.831L19.8063 17.3438L16.0938 19.2003L7.06875 14.6875ZM28.2812 7.65627L25.7812 8.90627V10.7813L28.2812 9.53127V7.65627ZM17.1875 8.53408L17.4078 8.64439L18.125 9.00283V10.5285L17.1875 10.0597V8.53408ZM18.6312 8.90627L21.4062 10.2941L28.5563 6.71877L25.7812 5.33095L18.6312 8.90627ZM17.3812 8.28127L18.2812 8.73158L25.4313 5.15627L24.5312 4.70595L17.3812 8.28127ZM24.1813 4.53127L17.0312 8.10658L14.2562 6.71877L21.4062 3.14345L24.1813 4.53127Z",
				fill: "#3D3D3D"
			})
		]
	});
})), xt = /* @__PURE__ */ we({ default: () => St }), St, Ct = Se((() => {
	St = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.4062 8.59375L16.4062 13.5938L1.40625 21.0938V22.3438L16.4062 29.8438H18.9062L33.9062 22.3438L38.9062 17.3438V16.0938L23.2812 8.28125L21.4062 8.59375Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.9062 29.8438H16.4062V31.7188H18.9062V29.8438ZM16.4062 29.8438L1.40625 22.3438V24.2188L16.4062 31.7188V29.8438ZM20.1562 24.8438L15.7812 27.0312L18.2812 28.2812L22.6562 26.0938L20.1562 24.8438ZM13.9062 24.2188L12.0312 25.1562L14.5312 26.4062L16.4062 25.4688L13.9062 24.2188ZM22.6562 23.5938L20.7812 24.5312L23.2812 25.7812L25.1562 24.8438L22.6562 23.5938ZM16.4062 22.9688L14.5312 23.9062L17.0312 25.1562L18.9062 24.2188L16.4062 22.9688ZM25.1562 22.3438L23.2812 23.2812L25.7812 24.5312L27.6562 23.5938L25.1562 22.3438ZM10.1562 22.3438L8.28125 23.2812L10.7812 24.5312L12.6562 23.5938L10.1562 22.3438ZM18.9062 21.7188L17.0312 22.6562L19.5312 23.9062L21.4062 22.9688L18.9062 21.7188ZM27.6562 21.0938L25.7812 22.0312L28.2812 23.2812L30.1562 22.3438L27.6562 21.0938ZM12.6562 21.0938L10.7812 22.0312L13.2812 23.2812L15.1562 22.3438L12.6562 21.0938ZM6.40625 20.4688L4.53125 21.4062L7.03125 22.6562L8.90625 21.7188L6.40625 20.4688ZM21.4062 20.4688L19.5312 21.4062L22.0312 22.6562L23.9062 21.7188L21.4062 20.4688ZM21.4062 8.59375L16.4062 13.5938L33.9062 22.3438L38.9062 17.3438V16.0938L23.2812 8.28125L21.4062 8.59375ZM15.1562 19.8438L13.2812 20.7812L15.7812 22.0312L17.6562 21.0938L15.1562 19.8438ZM8.90625 19.2188L7.03125 20.1562L9.53125 21.4062L11.4062 20.4688L8.90625 19.2188ZM23.9062 19.2188L22.0312 20.1562L24.5312 21.4062L26.4062 20.4688L23.9062 19.2188ZM21.8234 10.0516L18.4891 13.3859L33.4891 20.8859L36.8234 17.5516L21.8234 10.0516ZM17.6562 18.5938L15.7812 19.5312L18.2812 20.7812L20.1562 19.8438L17.6562 18.5938ZM11.4062 17.9688L9.53125 18.9062L12.0312 20.1562L13.9062 19.2188L11.4062 17.9688ZM20.1562 17.3438L18.2812 18.2812L20.7812 19.5312L22.6562 18.5938L20.1562 17.3438ZM13.9062 16.7188L12.0312 17.6562L14.5312 18.9062L16.4062 17.9688L13.9062 16.7188ZM16.4062 15.4688L14.5312 16.4062L17.0312 17.6562L18.9062 16.7188L16.4062 15.4688Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.25 21.0937V24.2187C1.25 24.2781 1.28282 24.3328 1.33595 24.3578L16.3344 31.8578C16.3531 31.8672 16.3734 31.8734 16.3953 31.875H16.3984H16.4031H16.4062H18.9062H18.9109H18.9141H18.9172C18.9391 31.8734 18.9594 31.8672 18.9781 31.8578L33.9766 24.3578C33.9906 24.3516 34.0047 24.3406 34.0172 24.3297L39.0172 19.3297C39.0453 19.3 39.0625 19.2609 39.0625 19.2187V16.0937C39.0625 16.0344 39.0297 15.9812 38.9766 15.9547L23.3516 8.14217C23.3219 8.12655 23.2875 8.12186 23.2563 8.12655L21.3813 8.43905C21.3485 8.4453 21.3188 8.46093 21.2953 8.48281L16.314 13.4656L1.33595 20.9547C1.28282 20.9812 1.25 21.0344 1.25 21.0937ZM18.75 30V31.5625H16.5625V30H18.1328H18.75ZM1.5625 22.5969L16.25 29.9406V31.4656L1.5625 24.1219V22.5969ZM16.4437 29.6875L1.5625 22.2469V21.1906L16.4766 13.7328C16.4906 13.7266 16.5047 13.7156 16.5172 13.7047L21.4812 8.73906L23.2563 8.44374L38.75 16.1906V17.2797L33.814 22.2156L18.8688 29.6875H16.4437Z",
				fill: "#3D3D3D"
			})
		]
	});
})), wt = /* @__PURE__ */ we({ default: () => Tt }), Tt, Et = Se((() => {
	Tt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.0225 38.2098C17.7962 38.0973 17.6562 37.8551 17.6562 37.5098C17.6562 36.8191 18.2163 35.9801 18.9062 35.6348C19.2511 35.4613 19.5636 35.4457 19.79 35.5582L20.415 35.8707L20.1562 36.2598C20.1562 36.9488 19.5961 37.7895 18.9062 38.1348L18.6475 38.5223L18.0225 38.2098ZM8.0225 31.4426C8.24875 31.1035 8.56125 30.8066 8.90625 30.6348C9.25109 30.4613 9.56359 30.4457 9.79 30.5582L10.415 30.8707L10.1562 31.2598C10.1562 31.6051 10.0163 31.9863 9.79 32.3269L17.0312 35.9473V36.5723L9.42062 32.766C9.26359 32.916 9.08953 33.0426 8.90625 33.1348L8.6475 33.5223L8.0225 33.2098C7.79625 33.0973 7.65625 32.8551 7.65625 32.5098C7.65625 32.3254 7.69578 32.1316 7.76672 31.9394L7.03125 31.5723V30.9473L8.0225 31.4426ZM29.2725 32.5848C29.0462 32.4723 28.9062 32.2301 28.9062 31.8848C28.9062 31.1941 29.4662 30.3551 30.1562 30.0098C30.5011 29.8363 30.8136 29.8207 31.04 29.9332L31.665 30.2457L31.4062 30.6348C31.4062 31.3238 30.8461 32.1645 30.1562 32.5098L29.8975 32.8973L29.2725 32.5848ZM30.7812 10.3223L30.1562 10.0098V22.5098L31.4062 24.3848V28.1348L32.0312 28.4473V24.6973L30.7812 22.8223V10.3223ZM19.2725 27.5848C19.0462 27.4723 18.9062 27.2301 18.9062 26.8848C18.9062 26.1941 19.4663 25.3551 20.1562 25.0098C20.5011 24.8363 20.8136 24.8207 21.04 24.9332L21.665 25.2457L21.4062 25.6348C21.4062 26.3238 20.8461 27.1645 20.1562 27.5098L19.8975 27.8973L19.2725 27.5848ZM21.4062 5.63477L20.7812 5.32227V17.8223L22.0312 19.6973V23.4473L22.6562 23.7598V20.0098L21.4062 18.1348V5.63477ZM33.2812 6.57227L24.5312 2.19727V2.82227L32.6562 6.88477L33.2812 6.57227Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.0312 23.4473L7.03125 30.9473L17.0312 35.9473L32.0312 28.4473L31.4062 28.1348L17.0312 35.3223L8.28125 30.9473L22.6562 23.7598L22.0312 23.4473ZM24.5312 1.57227L22.6562 2.50977L20.7812 5.32227L21.4062 5.63477L23.2812 2.82227L24.5312 2.19727L33.2812 6.57227L32.0312 7.19727L30.1562 10.0098L30.7812 10.3223L32.6562 7.50977L34.5312 6.57227L24.5312 1.57227Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.625 6.45663V5.32069L20.628 5.29256L20.6363 5.26288L20.6498 5.23788L20.6513 5.23475L22.5263 2.42225C22.5413 2.40037 22.562 2.38163 22.5864 2.36913L24.4614 1.43163C24.5053 1.40975 24.5572 1.40975 24.6011 1.43163L34.6023 6.43319L34.6266 6.44881L34.6478 6.46756L34.6653 6.491L34.6781 6.51912L34.6856 6.54725L34.6875 6.57226V7.19726C34.6875 7.25663 34.6541 7.30976 34.6011 7.33632L32.7633 8.25507L31.5625 10.0566V22.4629L32.7862 24.2972C32.8034 24.3238 32.8125 24.3535 32.8125 24.3848V28.7598C32.8125 28.8191 32.7791 28.8723 32.7261 28.8988L31.0155 29.7551C31.0483 29.766 31.0797 29.7785 31.1098 29.7941L31.7348 30.1066C32.008 30.2426 32.1875 30.5301 32.1875 30.9473C32.1875 31.6879 31.5913 32.591 30.8511 32.9613C30.452 33.1613 30.0895 33.1676 29.8277 33.0379L29.2027 32.7254C28.9295 32.5879 28.75 32.3004 28.75 31.8848C28.75 31.491 28.9191 31.0488 29.1887 30.6676L19.7655 35.3801C19.7983 35.391 19.8297 35.4035 19.8598 35.4191L20.4848 35.7316C20.758 35.8676 20.9375 36.1551 20.9375 36.5723C20.9375 37.3129 20.3413 38.216 19.6011 38.5863C19.202 38.7863 18.8395 38.7926 18.5777 38.6629L17.9527 38.3504C17.6795 38.2129 17.5 37.9254 17.5 37.5098C17.5 37.116 17.6691 36.6738 17.9387 36.2926L17.0933 36.7144L17.0658 36.7238L17.0366 36.7285L17.007 36.7269L16.9784 36.7191L16.9614 36.7113L10.0706 33.266C9.92469 33.3941 9.76657 33.5035 9.6011 33.5863C9.20203 33.7863 8.83953 33.7926 8.57765 33.6629L7.95265 33.3504C7.67953 33.2129 7.5 32.9254 7.5 32.5098C7.5 32.3519 7.52719 32.1863 7.57719 32.0191L6.9614 31.7113C6.90843 31.6848 6.875 31.6316 6.875 31.5723L6.87578 30.9316L6.88109 30.9035L6.89187 30.8769L6.9075 30.8519L6.9275 30.8301L6.95172 30.8129L6.9614 30.8066L16.3875 26.0941L7.01312 21.4066L5.81922 21.7051C5.7725 21.7176 5.72297 21.7066 5.68516 21.6769C5.64719 21.6472 5.625 21.6019 5.625 21.5535V14.0535C5.625 13.9941 5.65843 13.941 5.7114 13.9144L20.625 6.45663ZM19.7202 35.6988C19.6989 35.6879 19.6773 35.6785 19.655 35.6723C19.5208 35.6269 19.3741 35.6379 19.2391 35.6723C19.2155 35.6785 19.192 35.6863 19.1689 35.6941C19.1402 35.7035 19.1117 35.7144 19.0837 35.7254C19.0495 35.7394 19.0161 35.7551 18.983 35.7707L18.9761 35.7738C18.3366 36.0941 17.8125 36.8691 17.8125 37.5098C17.8125 37.7832 17.913 37.9801 18.0923 38.0707L18.1555 38.1019C18.1355 38.016 18.125 37.9223 18.125 37.8223C18.125 37.0816 18.7212 36.1769 19.4614 35.8066C19.5512 35.7629 19.6394 35.7269 19.7248 35.7004L19.7202 35.6988ZM16.875 36.0441V36.3191L7.1875 31.4754V31.2004L16.875 36.0441ZM16.7369 26.2691L7.38063 30.9473L17.0312 35.7723L31.6819 28.4473L31.4062 28.3098L17.1011 35.4613C17.0572 35.4832 17.0053 35.4832 16.9614 35.4613L8.2114 31.0863L8.18594 31.0707L8.16422 31.0504L8.14688 31.0269L8.13437 31.0004L8.12688 30.9707L8.12515 30.941L8.12906 30.9113L8.13844 30.8832L8.15266 30.8582L8.17172 30.8363L8.19468 30.816L8.2114 30.8066L17.0306 26.3973C17.0072 26.3973 16.9836 26.3926 16.9614 26.3816L16.7369 26.2691ZM23.0945 19.1348L23.4112 19.6097C23.4284 19.6363 23.4375 19.666 23.4375 19.6973V22.7066L25.8511 23.9144C25.9283 23.9519 25.9595 24.0472 25.9209 24.1238C25.8825 24.2004 25.7884 24.2316 25.7114 24.1941L23.4375 23.0566V23.6441L24.6011 24.2269C24.6783 24.2644 24.7095 24.3597 24.6709 24.4363C24.6325 24.5129 24.5384 24.5441 24.4614 24.5066L23.4375 23.9941V24.0723C23.4375 24.1316 23.4041 24.1848 23.3511 24.2113L23.0237 24.3754L23.3511 24.5394C23.4283 24.5769 23.4595 24.6722 23.4209 24.7488C23.3825 24.8254 23.2884 24.8566 23.2114 24.8191L22.6744 24.5504L22.0862 24.8441L22.1011 24.8519C22.1783 24.8894 22.2095 24.9847 22.1709 25.0613C22.1325 25.1379 22.0384 25.1691 21.9614 25.1316L21.7369 25.0191L21.6481 25.0629L21.7348 25.1066C22.008 25.2426 22.1875 25.5301 22.1875 25.9473C22.1875 26.6879 21.5913 27.591 20.8511 27.9613C20.452 28.1613 20.0895 28.1676 19.8277 28.0379L19.2027 27.7254C18.9295 27.5879 18.75 27.3004 18.75 26.8848C18.75 26.7551 18.7681 26.6222 18.8019 26.4863L10.3981 30.6879L10.4848 30.7316C10.758 30.8676 10.9375 31.1551 10.9375 31.5723C10.9375 31.7301 10.9103 31.8957 10.8603 32.0613L17.0312 35.1473L31.25 28.0379V24.4316L30.0313 22.6035L23.0945 19.1348ZM7.85937 32.1613L8.20219 32.3316C8.15219 32.4988 8.125 32.6644 8.125 32.8223C8.125 32.9223 8.13547 33.016 8.15547 33.1019L8.09235 33.0707C7.91297 32.9801 7.8125 32.7832 7.8125 32.5098C7.8125 32.3957 7.8289 32.2785 7.85937 32.1613ZM30.9702 30.0738C30.9489 30.0629 30.9273 30.0535 30.905 30.0473C30.7708 30.0019 30.6241 30.0129 30.4891 30.0473C30.4655 30.0535 30.442 30.0613 30.4189 30.0691C30.3902 30.0785 30.3617 30.0894 30.3337 30.1004C30.2995 30.1144 30.2661 30.1301 30.233 30.1457L30.2261 30.1488C29.5866 30.4691 29.0625 31.2441 29.0625 31.8848C29.0625 32.1582 29.163 32.3551 29.3423 32.4457L29.4055 32.4769C29.3855 32.391 29.375 32.2973 29.375 32.1973C29.375 31.4566 29.9712 30.5519 30.7114 30.1816C30.8012 30.1379 30.8894 30.1019 30.9748 30.0754L30.9702 30.0738ZM30.5945 22.8848L31.5362 24.2972C31.5534 24.3238 31.5625 24.3535 31.5625 24.3848V28.0379L31.875 28.1941V24.7441L30.6563 22.916L30.5945 22.8848ZM19.8137 25.9801L19.1916 26.291C19.1091 26.491 19.0625 26.6941 19.0625 26.8848C19.0625 27.1582 19.163 27.3551 19.3423 27.4457L19.4055 27.4769C19.3855 27.391 19.375 27.2973 19.375 27.1973C19.375 26.8035 19.5441 26.3613 19.8137 25.9801ZM17.1566 26.3348L17.95 25.9379L17.6744 25.8004L17.0862 26.0941L17.1011 26.1019C17.1783 26.1394 17.2095 26.2347 17.1709 26.3113C17.1669 26.3191 17.162 26.3269 17.1566 26.3348ZM7.4789 21.291L16.7369 25.9191L17.325 25.6254L13.5423 23.7347C13.4652 23.6957 13.4339 23.6019 13.4725 23.5238C13.5109 23.4473 13.605 23.416 13.682 23.4551L17.6744 25.4504L18.2625 25.1566L14.4614 23.2566C14.3842 23.2176 14.353 23.1238 14.3916 23.0457C14.43 22.9691 14.5241 22.9379 14.6011 22.9769L18.6119 24.9816L19.4067 24.5848C19.4364 24.5457 19.4827 24.5223 19.5305 24.5223L20.1727 24.2019C20.1516 24.1597 20.15 24.1082 20.1728 24.0613C20.2113 23.9847 20.3053 23.9535 20.3823 23.9926L20.4869 24.0441L21.2817 23.6473C21.3114 23.6082 21.3577 23.5848 21.4055 23.5848L21.875 23.3504V19.7441L20.702 17.9847L7.4789 21.291ZM18.0237 25.6254L18.2994 25.7629L18.8875 25.4691L18.6119 25.3316L18.0237 25.6254ZM18.9612 25.1566L19.2369 25.2941L19.825 25.0004L19.5494 24.8629L18.9612 25.1566ZM19.8987 24.6879L20.1744 24.8254L20.7625 24.5316L20.4869 24.3941L19.8987 24.6879ZM20.8362 24.2191L21.1119 24.3566L21.7 24.0629L21.4244 23.9254L20.8362 24.2191ZM24.1489 22.4754L26.9614 23.8816C27.0384 23.9191 27.1325 23.8879 27.1709 23.8113C27.2095 23.7347 27.1783 23.6394 27.1011 23.6019L24.2886 22.1957C24.2116 22.1566 24.1175 22.1879 24.0791 22.2644C24.0405 22.3426 24.0717 22.4363 24.1489 22.4754ZM21.7737 23.7504L22.0494 23.8879L22.3069 23.7598L22.0312 23.6223L21.7737 23.7504ZM26.9614 22.9441L28.2114 23.5691C28.2884 23.6066 28.3825 23.5754 28.4209 23.4988C28.4595 23.4222 28.4283 23.3269 28.3511 23.2894L27.1011 22.6644C27.0241 22.6254 26.93 22.6566 26.8916 22.7332C26.853 22.8113 26.8842 22.9051 26.9614 22.9441ZM22.1875 23.3504L22.2184 23.366C22.198 23.3379 22.187 23.3051 22.1875 23.2707V23.3504ZM28.8364 22.9441L29.4614 23.2566C29.5384 23.2941 29.6325 23.2629 29.6709 23.1863C29.7095 23.1097 29.6783 23.0144 29.6011 22.9769L28.9761 22.6644C28.8991 22.6254 28.805 22.6566 28.7666 22.7332C28.728 22.8113 28.7592 22.9051 28.8364 22.9441ZM21.2195 18.1973L22.1612 19.6097C22.1784 19.6363 22.1875 19.666 22.1875 19.6973V23.2707C22.1878 23.2473 22.1931 23.2238 22.2041 23.2019C22.2425 23.1254 22.3366 23.0941 22.4136 23.1332L22.5 23.1754V20.0566L21.2813 18.2285L21.2195 18.1973ZM30.625 19.1504L30.3125 18.9941V22.3941L30.625 22.5504V19.1504ZM22.1875 17.7754L22.7452 18.6113L30 22.2379V18.8379L22.1875 14.9316V17.7754ZM6.875 21.1191V18.8535L5.9375 19.166V21.3535L6.875 21.1191ZM20.625 14.2707L7.1875 18.7504V21.041L20.625 17.6816V14.2707ZM5.9375 16.6582V18.8363L6.875 18.5238V16.2676L5.9375 16.6582ZM30.625 15.4004L30.3125 15.2441V18.6441L30.625 18.8004V15.4004ZM22.1875 14.5816L30 18.4879V15.0879L22.1875 11.1816V14.5816ZM15.625 12.6223L7.1875 16.1379V18.4207L20.625 13.941V10.5379L17.1875 11.9707V14.6785C17.1875 14.7644 17.1175 14.8348 17.0312 14.8348C16.945 14.8348 16.875 14.7644 16.875 14.6785V12.1004L15.9375 12.491V15.3035C15.9375 15.3894 15.8675 15.4598 15.7812 15.4598C15.695 15.4598 15.625 15.3894 15.625 15.3035V12.6223ZM21.25 14.4629V17.8629L20.9375 17.7066V14.3066L21.25 14.4629ZM5.9375 14.1504V16.3191L6.875 15.9285V13.6816L5.9375 14.1504ZM7.1875 13.5254V15.7988L15.625 12.2832V9.30663L7.1875 13.5254ZM30.625 11.6504L30.3125 11.4941V14.8941L30.625 15.0504V11.6504ZM22.1875 10.8316L30 14.7379V11.3379L22.1875 7.43163V10.8316ZM21.25 10.7129L20.9375 10.5566V13.9566L21.25 14.1129V10.7129ZM15.9375 9.15038V12.1535L16.875 11.7629V8.68163L15.9375 9.15038ZM17.1875 8.52538V11.6316L20.625 10.2004V6.80663L17.1875 8.52538ZM30.3125 11.1441L30.625 11.3004V10.4191L30.3125 10.2629V11.1441ZM30 10.9879V10.0082L30.003 9.98006L30.0113 9.95038L30.0248 9.92537L30.0263 9.92225L31.9013 7.10975L31.9614 7.05663L32.3069 6.88476L24.5312 2.99726L23.3883 3.56757L22.1875 5.36912V7.08163L30 10.9879ZM21.25 10.3629V6.96288L20.9375 6.80663V10.2066L21.25 10.3629ZM34.1819 6.57226L24.5312 1.74726L22.7633 2.63007L21.0094 5.26132L21.3528 5.43319L23.1513 2.73475C23.1663 2.71287 23.187 2.69413 23.2114 2.68163L24.4708 2.0535L24.4991 2.04414L24.5284 2.04101L24.5586 2.04257L24.5864 2.05037L24.6011 2.05663L33.3511 6.43163C33.3698 6.441 33.3861 6.45506 33.3994 6.46913L33.4169 6.49413L33.4192 6.49882C33.4244 6.5082 33.4286 6.51913 33.4316 6.5285C33.4325 6.53319 33.4333 6.53631 33.4341 6.53943C33.4363 6.55037 33.4375 6.56132 33.4375 6.57226C33.4375 6.63163 33.4041 6.68476 33.3511 6.71132L32.1383 7.31757L30.3844 9.94882L30.7278 10.1207L32.5263 7.42225L32.5306 7.41601C32.5453 7.39726 32.5644 7.38007 32.5864 7.36913L34.1819 6.57226ZM24.6875 2.72538L32.6562 6.70976L32.9319 6.57226L24.6875 2.45038V2.72538ZM20.9375 6.45663L21.25 6.61288V5.73163L20.9375 5.57538V6.45663Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.2812 17.8035V6.55353L27.0312 10.9285V23.741L19.5312 19.991V24.6785L15.2312 22.5285C15.0762 22.8192 14.7712 23.0941 14.3161 23.3207C12.9362 24.0113 10.6959 24.0113 9.31609 23.3207C8.62625 22.977 8.28125 22.5238 8.28125 22.0707V9.57071C8.28125 10.0238 8.62625 10.477 9.31609 10.8207C10.6959 11.5113 12.9362 11.5113 14.3161 10.8207C15.0059 10.477 15.3509 10.0238 15.3509 9.57071V16.3395L18.2812 17.8035Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.5313 13.4285L14.5313 15.9285L19.5313 18.4285L24.5313 15.9285L19.5313 13.4285ZM9.31613 8.32071C10.696 7.63164 12.9363 7.63164 14.3161 8.32071C15.696 9.01133 15.696 10.1316 14.3161 10.8207C12.9363 11.5113 10.696 11.5113 9.31613 10.8207C7.93629 10.1316 7.93629 9.01133 9.31613 8.32071ZM20.7813 5.30353L18.2813 6.55353L27.0313 10.9285L29.5313 9.67853L20.7813 5.30353Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.125 15.0504V9.57066C8.125 9.07378 8.48704 8.56128 9.24625 8.18159C10.6645 7.47222 12.9677 7.47222 14.3859 8.18159C15.1452 8.56128 15.5072 9.07378 15.5072 9.57066V15.266L18.125 13.9566V6.55348L18.1272 6.52848L18.1344 6.50034L18.1469 6.47379L18.1642 6.45035L18.1859 6.43004L18.2109 6.41442L20.7114 5.16442C20.7553 5.14254 20.8072 5.14254 20.8511 5.16442L29.6023 9.53942L29.6266 9.55504L29.6478 9.57535L29.6653 9.59879L29.6781 9.62534L29.6856 9.65348L29.6875 9.67848V11.9254L30.7114 11.4144C30.7598 11.3894 30.8173 11.3925 30.8634 11.4207C30.9095 11.4488 30.9375 11.5004 30.9375 11.5535V22.8035C30.9375 22.8754 30.8887 22.9379 30.8192 22.955L15.82 26.705L15.8048 26.7082L15.7748 26.7097H15.7683C15.7541 26.7082 15.7402 26.705 15.7267 26.7003L15.7109 26.6941L7.04016 22.3582C7.03719 22.3582 7.03422 22.3582 7.03125 22.3582C6.97703 22.3582 6.92922 22.33 6.90109 22.2878L5.7114 21.6941C5.65843 21.6675 5.625 21.6129 5.625 21.5535V14.0535C5.625 14.0004 5.65297 13.9488 5.69906 13.9207C5.74516 13.8925 5.80266 13.8894 5.8511 13.9144L8.125 15.0504ZM16.875 26.1191V23.8535L15.9375 24.166V26.3535L16.875 26.1191ZM15.625 24.1504L14.6875 23.6816V25.8316L15.625 26.3004V24.1504ZM17.2692 23.7222L17.1875 23.7503V26.041L18.125 25.8066V24.1504L17.2692 23.7222ZM18.4375 24.3066V25.7285L19.375 25.4941V24.7754L18.4375 24.3066ZM14.3152 23.4957C14.048 23.6222 13.7517 23.7254 13.4375 23.8035V25.2066L14.375 25.6754V23.5254L14.3152 23.4957ZM20.625 24.3066L19.6875 24.7754V25.416L20.625 25.1816V24.3066ZM21.875 23.6816L20.9375 24.1504V25.1035L21.875 24.8691V23.6816ZM13.125 23.8722C12.822 23.9316 12.5066 23.9691 12.1875 23.9847V24.5816L13.125 25.0504V23.8722ZM23.125 23.0566L22.1875 23.5254V24.791L23.125 24.5566V23.0566ZM23.4375 22.9004V24.4785L24.375 24.2441V22.5879L24.2188 22.5097L23.4375 22.9004ZM19.375 23.0207L18.4375 23.3332V23.9566L19.375 24.4254V23.0207ZM10.9375 23.9394V23.9566L11.875 24.4254V23.9941C11.8553 23.9941 11.8358 23.9957 11.8161 23.9957C11.8073 23.9957 11.7989 23.9941 11.7906 23.9925C11.5039 23.9925 11.2175 23.9738 10.9375 23.9394ZM24.6875 22.7441V24.166L25.625 23.9316V23.2129L24.6875 22.7441ZM25.9375 23.8535L26.5836 23.6925L25.9375 23.3691V23.8535ZM15.9375 23.8363L16.8739 23.5254L15.9375 23.0566V23.8363ZM15.625 22.9004L15.2886 22.7316C15.153 22.93 14.9534 23.1191 14.6875 23.291V23.3316L15.625 23.8004V22.9004ZM17.6886 23.5832L18.125 23.8004V23.4378L17.6886 23.5832ZM10.9375 23.6269C11.1744 23.6582 11.4166 23.6769 11.6598 23.6832V22.1675L10.9375 21.8066V23.6269ZM9.6875 23.316C9.97609 23.43 10.293 23.5175 10.625 23.5785V21.6504L9.6875 21.1816V23.316ZM25.9375 20.8332V23.0191L26.875 23.4879V20.5207L25.9375 20.8332ZM17.2933 23.3847L18.125 23.1082V20.7472L17.1875 21.1379V23.3316L17.2933 23.3847ZM29.375 22.7441L28.4375 23.2129V23.2285L29.375 22.9941V22.7441ZM16.875 23.1754V21.2675L15.9375 21.6582V22.7066L16.875 23.1754ZM8.4375 20.5566V22.0707C8.4375 22.4753 8.76125 22.866 9.375 23.1754V21.0254L8.4375 20.5566ZM19.375 20.2254L18.4375 20.616V23.0035L19.375 22.691V20.2254ZM30.625 19.2707L29.6875 19.5832V22.916L30.625 22.6816V19.2707ZM25.625 22.8629V20.9378L24.6875 21.2503V22.3941L25.625 22.8629ZM15.5072 21.591L15.625 21.6504V22.5504L15.4347 22.455C15.4833 22.3285 15.5072 22.1988 15.5072 22.0707V21.591ZM7.1875 22.0816L8.125 22.5504V20.4004L7.1875 19.9316V22.0816ZM5.9375 21.4566L6.875 21.9254V19.7754L5.9375 19.3066V21.4566ZM11.6598 19.6675L10.9375 19.3066V21.4566L11.6598 21.8191V19.6675ZM15.9375 19.1504V21.3191L16.875 20.9285V18.6816L15.9375 19.1504ZM9.6875 20.8316L10.625 21.3004V19.1504L9.6875 18.6816V20.8316ZM15.5072 19.091V21.2425L15.625 21.3004V19.1504L15.5072 19.091ZM24.6875 18.0129V20.9207L25.625 20.6082V17.6222L24.6875 18.0129ZM17.1875 18.5254V20.7988L18.125 20.4082V18.0566L17.1875 18.5254ZM8.4375 20.2066L9.375 20.6754V18.5254L8.4375 18.0566V20.2066ZM26.875 17.1004L25.9375 17.491V20.5035L26.875 20.191V17.1004ZM18.4375 20.2785L19.375 19.8879V18.5254L18.4375 18.0566V20.2785ZM7.1875 19.5816L8.125 20.0504V17.9004L7.1875 17.4316V19.5816ZM5.9375 18.9566L6.875 19.4254V17.2754L5.9375 16.8066V18.9566ZM11.6598 17.1675L10.9375 16.8066V18.9566L11.6598 19.3191V17.1675ZM29.6875 15.9285V19.2535L30.625 18.941V15.5379L29.6875 15.9285ZM15.5072 18.7425L15.7812 18.8785L17.9319 17.8035L15.5072 16.591V18.7425ZM9.6875 18.3316L10.625 18.8004V16.6504L9.6875 16.1816V18.3316ZM20.625 17.7066V16.8066L19.6875 17.2754V18.1754L20.625 17.7066ZM8.4375 15.5566V17.7066L9.375 18.1754V16.0254L8.4375 15.5566ZM18.6306 17.8035L19.375 18.1754V17.4316L18.6306 17.8035ZM24.6875 14.7754V17.6738L25.625 17.2832V14.3066L24.6875 14.7754ZM22.9319 15.3035L18.2812 17.6285L15.5072 16.2425V15.616L19.5312 13.6035L22.9319 15.3035ZM7.1875 17.0816L8.125 17.5504V15.4004L7.1875 14.9316V17.0816ZM21.875 17.0816V16.1816L20.9375 16.6504V17.5504L21.875 17.0816ZM26.875 13.6816L25.9375 14.1504V17.1535L26.875 16.7629V13.6816ZM5.9375 16.4566L6.875 16.9254V14.7754L5.9375 14.3066V16.4566ZM23.125 16.4566V15.5566L22.1875 16.0254V16.9254L23.125 16.4566ZM8.4375 15.2066L11.6598 16.8191V11.491C10.7822 11.4722 9.91563 11.2957 9.24625 10.9613C8.89079 10.7832 8.62234 10.5769 8.4375 10.355V15.2066ZM23.4375 15.5566V16.3004L24.1819 15.9285L23.4375 15.5566ZM23.6306 15.3035L24.375 15.6754V14.9316L23.6306 15.3035ZM29.6875 12.2754V15.591L30.625 15.2004V11.8066L29.6875 12.2754ZM26.875 13.3316V11.0254L18.4375 6.80661V13.8004L19.4614 13.2894C19.5053 13.2675 19.5572 13.2675 19.6011 13.2894L23.2812 15.1285L26.875 13.3316ZM9.38594 8.46129C10.7272 7.79098 12.905 7.79098 14.2463 8.46129C14.867 8.77066 15.1947 9.16441 15.1947 9.57066C15.1947 9.97847 14.867 10.3707 14.2463 10.6816C12.905 11.3519 10.7272 11.3519 9.38594 10.6816C8.76516 10.3707 8.4375 9.97847 8.4375 9.57066C8.4375 9.16441 8.76516 8.77066 9.38594 8.46129ZM18.6306 6.55348L20.7812 5.47848L29.1819 9.67848L27.0312 10.7535L18.6306 6.55348Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Dt = /* @__PURE__ */ we({ default: () => Ot }), Ot, kt = Se((() => {
	Ot = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.0225 38.2091C17.7962 38.0966 17.6562 37.8544 17.6562 37.5091C17.6562 36.8185 18.2163 35.9794 18.9062 35.6341C19.2511 35.4607 19.5636 35.445 19.79 35.5575L20.415 35.87L20.1562 36.2591C20.1562 36.9482 19.5961 37.7888 18.9062 38.1341L18.6475 38.5216L18.0225 38.2091ZM8.0225 31.4419C8.24875 31.1028 8.56125 30.806 8.90625 30.6341C9.25109 30.4607 9.56359 30.445 9.79 30.5575L10.415 30.87L10.1562 31.2591C10.1562 31.6044 10.0163 31.9856 9.79 32.3263L17.0312 35.9466V36.5716L9.42062 32.7653C9.26359 32.9153 9.08953 33.0419 8.90625 33.1341L8.6475 33.5216L8.0225 33.2091C7.79625 33.0966 7.65625 32.8544 7.65625 32.5091C7.65625 32.3247 7.69578 32.131 7.76672 31.9388L7.03125 31.5716V30.9466L8.0225 31.4419ZM29.2725 32.5841C29.0462 32.4716 28.9062 32.2294 28.9062 31.8841C28.9062 31.1935 29.4662 30.3544 30.1562 30.0091C30.5011 29.8357 30.8136 29.82 31.04 29.9325L31.665 30.245L31.4062 30.6341C31.4062 31.3232 30.8461 32.1638 30.1562 32.5091L29.8975 32.8966L29.2725 32.5841ZM30.7812 10.3216L30.1562 10.0091V22.5091L31.4062 24.3841V28.1341L32.0312 28.4466V24.6966L30.7812 22.8216V10.3216ZM19.2725 27.5841C19.0462 27.4716 18.9062 27.2294 18.9062 26.8841C18.9062 26.1935 19.4663 25.3544 20.1562 25.0091C20.5011 24.8357 20.8136 24.82 21.04 24.9325L21.665 25.245L21.4062 25.6341C21.4062 26.3232 20.8461 27.1638 20.1562 27.5091L19.8975 27.8966L19.2725 27.5841ZM21.4062 5.63409L20.7812 5.32159V17.8216L22.0312 19.6966V23.4466L22.6562 23.7591V20.0091L21.4062 18.1341V5.63409ZM33.2812 6.57159L24.5312 2.19659V2.82159L32.6562 6.88409L33.2812 6.57159Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.0312 23.4466L7.03125 30.9466L17.0312 35.9466L32.0312 28.4466L31.4062 28.1341L17.0312 35.3216L8.28125 30.9466L22.6562 23.7591L22.0312 23.4466ZM24.5312 1.57159L22.6562 2.50909L20.7812 5.32159L21.4062 5.63409L23.2812 2.82159L24.5312 2.19659L33.2812 6.57159L32.0312 7.19659L30.1562 10.0091L30.7812 10.3216L32.6562 7.50909L34.5312 6.57159L24.5312 1.57159Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.6489 5.23877L20.6512 5.23408L22.5262 2.42158C22.5413 2.3997 22.562 2.38096 22.5864 2.36846L24.4614 1.43096C24.5053 1.40908 24.557 1.40908 24.6011 1.43096L34.6011 6.43096L34.6045 6.43252L34.6091 6.43565L34.6119 6.43721C34.6152 6.43878 34.6184 6.44189 34.6216 6.44345L34.6244 6.44658L34.6266 6.44814L34.6308 6.45127L34.6341 6.45283L34.6373 6.45596L34.6397 6.45909L34.6408 6.46063C34.6414 6.46063 34.642 6.46064 34.6427 6.4622L34.6464 6.46533L34.65 6.47002L34.6525 6.47315L34.6556 6.47627L34.657 6.47784L34.6584 6.48095L34.6598 6.48251L34.6613 6.48408L34.663 6.4872L34.6655 6.4919L34.6681 6.49659L34.67 6.4997L34.6722 6.50439L34.6742 6.50752L34.6752 6.51065C34.6755 6.51065 34.6758 6.51221 34.6762 6.51221L34.6772 6.51534L34.6781 6.51845L34.6791 6.52001L34.6806 6.52627L34.6822 6.53096L34.6831 6.53409L34.6836 6.53721C34.6842 6.54034 34.6848 6.54189 34.6853 6.54502L34.6859 6.54971L34.6866 6.5544L34.687 6.55907L34.6873 6.56377V6.56689L34.6875 6.56846V6.57159V7.19659C34.6875 7.25596 34.6541 7.30909 34.6011 7.33565C34.6011 7.33565 32.7633 8.2544 32.7631 8.2544L31.5625 10.0559V22.4622L32.7863 24.2966C32.8033 24.3231 32.8125 24.3528 32.8125 24.3841V28.7591C32.8125 28.8185 32.7791 28.8716 32.7261 28.8981L31.0155 29.7544C31.0481 29.7653 31.0797 29.7778 31.1098 29.7935L31.7348 30.106C32.008 30.2419 32.1875 30.5294 32.1875 30.9466C32.1875 31.6872 31.5912 32.5903 30.8511 32.9606C30.452 33.1606 30.0894 33.1669 29.8277 33.0372L29.2027 32.7247C28.9294 32.5872 28.75 32.2997 28.75 31.8841C28.75 31.4903 28.9189 31.0481 29.1887 30.6669L19.7655 35.3794C19.7981 35.3903 19.8297 35.4028 19.8598 35.4185L20.4848 35.731C20.758 35.8669 20.9375 36.1544 20.9375 36.5716C20.9375 37.3122 20.3412 38.2153 19.6011 38.5856C19.202 38.7856 18.8394 38.7919 18.5777 38.6622L17.9527 38.3497C17.6794 38.2122 17.5 37.9247 17.5 37.5091C17.5 37.1153 17.6689 36.6731 17.9387 36.2919L17.1011 36.7106L17.0978 36.7122L17.0933 36.7138L17.0887 36.7169L17.0841 36.7184L17.0794 36.72L17.0747 36.7216L17.0698 36.7231H17.065L17.0602 36.7247L17.0553 36.7263H17.0505H17.0456L17.0406 36.7278H17.0358H17.0309H17.0259H17.0211L17.0161 36.7263H17.0112H17.0064L17.0014 36.7247L16.9966 36.7231H16.9919L16.987 36.7216L16.9822 36.72L16.9784 36.7184L16.9737 36.7169L16.9691 36.7138L16.9645 36.7122L16.9614 36.7106L10.0706 33.2653C9.92469 33.3935 9.7664 33.5028 9.60109 33.5856C9.20203 33.7856 8.83938 33.7919 8.57766 33.6622L7.95266 33.3497C7.67938 33.2122 7.5 32.9247 7.5 32.5091C7.5 32.3513 7.52719 32.1856 7.57719 32.0185L6.9614 31.7106C6.90843 31.6841 6.875 31.631 6.875 31.5716V30.9466V30.9435L6.87516 30.9372L6.87547 30.9341L6.87578 30.9294L6.87625 30.9263L6.87703 30.9216V30.92C6.87766 30.9169 6.87812 30.9153 6.87875 30.9122L6.87969 30.9091L6.88094 30.9028L6.88265 30.8981L6.88391 30.8934L6.88547 30.8903L6.88625 30.8872C6.88656 30.8872 6.88687 30.8856 6.88734 30.8856L6.88828 30.8825L6.89063 30.8778L6.89234 30.8747L6.89469 30.87L6.89719 30.8653L6.89844 30.8638L6.89969 30.8622L6.90125 30.8591L6.90297 30.8575L6.90578 30.8528L6.90844 30.8497L6.91141 30.845L6.91469 30.8419L6.91813 30.8388L6.91968 30.8372C6.92031 30.8356 6.92094 30.8356 6.92156 30.8356L6.92359 30.8325L6.92547 30.831L6.9275 30.8294L6.92953 30.8278L6.93375 30.8247L6.93687 30.8216L6.94078 30.8184C6.9439 30.8169 6.94718 30.8138 6.95062 30.8122L6.95406 30.8106L6.95781 30.8075L6.9614 30.806L21.875 23.3497V19.7434L20.6512 17.9075C20.6341 17.8825 20.625 17.8528 20.625 17.8216V5.32159V5.31846L20.6252 5.31377L20.6255 5.30907L20.6258 5.3044L20.6262 5.30127L20.627 5.29658L20.6273 5.29345C20.6275 5.29345 20.6277 5.29189 20.6278 5.29189L20.6289 5.28721L20.6295 5.28409C20.6297 5.28252 20.6298 5.28252 20.63 5.28096L20.6314 5.27627L20.633 5.27157L20.6345 5.2669L20.6366 5.26221L20.6373 5.26065L20.6381 5.25752L20.6402 5.25439L20.6417 5.25126L20.6436 5.24659L20.6448 5.24502L20.6472 5.24033L20.6489 5.23877ZM19.72 35.6981C19.6989 35.6872 19.6772 35.6778 19.655 35.6716C19.5208 35.6263 19.3741 35.6372 19.2391 35.6716C19.2155 35.6778 19.192 35.6856 19.1689 35.6935C19.1402 35.7028 19.1117 35.7138 19.0837 35.7247C19.0495 35.7388 19.0159 35.7544 18.983 35.77L18.9761 35.7731C18.3364 36.0935 17.8125 36.8685 17.8125 37.5091C17.8125 37.7825 17.913 37.9794 18.0923 38.07L18.1553 38.1013C18.1355 38.0153 18.125 37.9216 18.125 37.8216C18.125 37.081 18.7211 36.1763 19.4614 35.806C19.5512 35.7622 19.6394 35.7263 19.7248 35.6997L19.72 35.6981ZM16.875 36.0435V36.3185L7.1875 31.4747V31.1997L16.875 36.0435ZM7.38062 30.9466L17.0312 35.7716L31.6819 28.4466L31.4062 28.3091L17.1011 35.4606C17.057 35.4825 17.0053 35.4825 16.9614 35.4606L8.2114 31.0856L8.2089 31.0841H8.20641L8.20406 31.0825L8.20172 31.081L8.19922 31.0794L8.19703 31.0778L8.19468 31.0763L8.1925 31.0747L8.19016 31.0731L8.18797 31.0716L8.18578 31.07L8.18375 31.0685L8.18156 31.0669L8.17953 31.0653L8.1775 31.0638L8.17547 31.0606L8.17359 31.0591L8.17156 31.0575L8.16968 31.056L8.16781 31.0544L8.16609 31.0513L8.16422 31.0497L8.1625 31.0481L8.16078 31.045L8.15906 31.0435L8.15734 31.0419L8.15578 31.0388L8.15422 31.0372L8.15266 31.0356L8.15125 31.0325L8.14969 31.0309L8.14828 31.0278L8.14687 31.0263L8.14562 31.0231L8.14422 31.0216L8.14297 31.0185L8.14172 31.0169L8.14063 31.0138L8.13937 31.0122L8.13828 31.0091L8.13734 31.0075L8.13625 31.0044L8.13531 31.0013L8.13437 30.9997L8.13344 30.9966L8.13265 30.995L8.13172 30.9919L8.13094 30.9888L8.13031 30.9872L8.12969 30.9841L8.12906 30.981L8.12844 30.9794L8.12781 30.9763L8.12734 30.9731L8.12687 30.97L8.12656 30.9685L8.12609 30.9653L8.12578 30.9622L8.12562 30.9606L8.12531 30.9575L8.12516 30.9544L8.125 30.9513V30.9497V30.9466V30.9435V30.9403L8.12516 30.9372L8.12531 30.9356L8.12562 30.9325L8.12578 30.9294L8.12609 30.9263L8.12656 30.9247L8.12687 30.9216L8.12734 30.9184L8.12781 30.9169L8.12844 30.9138L8.12906 30.9106L8.12969 30.9091L8.13031 30.906L8.13094 30.9028L8.13172 30.9013L8.13265 30.8981L8.13344 30.895L8.13437 30.8934L8.13531 30.8903L8.13625 30.8872L8.13734 30.8856L8.13828 30.8825L8.13937 30.881L8.14063 30.8778L8.14172 30.8763L8.14297 30.8731L8.14422 30.8716L8.14562 30.8685L8.14687 30.8669L8.14828 30.8638L8.14969 30.8622L8.15125 30.8591L8.15266 30.8575L8.15422 30.8544L8.15578 30.8528L8.15734 30.8513L8.15906 30.8481L8.16078 30.8466L8.1625 30.845L8.16422 30.8435L8.16609 30.8403L8.16781 30.8388L8.16968 30.8372L8.17156 30.8356L8.17359 30.8325L8.17547 30.831L8.1775 30.8294L8.17953 30.8278L8.18156 30.8263L8.18375 30.8247L8.18578 30.8231L8.18797 30.8216L8.19016 30.8184L8.1925 30.8169L8.19468 30.8153L8.19703 30.8138H8.19922L8.20172 30.8122L8.20406 30.8106L8.20641 30.8091L8.2089 30.8075L8.2114 30.806L22.3069 23.7591L22.0312 23.6216L7.38062 30.9466ZM24.5312 2.99658L23.3883 3.5669L22.1875 5.36845V17.7747L23.4113 19.6091C23.4283 19.6356 23.4375 19.6653 23.4375 19.6966V24.0716C23.4375 24.131 23.4041 24.1841 23.3511 24.2106L21.648 25.0622L21.7348 25.106C22.008 25.2419 22.1875 25.5294 22.1875 25.9466C22.1875 26.6872 21.5912 27.5903 20.8511 27.9606C20.452 28.1606 20.0894 28.1669 19.8277 28.0372L19.2027 27.7247C18.9294 27.5872 18.75 27.2997 18.75 26.8841C18.75 26.7544 18.7681 26.6216 18.8019 26.4856L10.398 30.6872L10.4848 30.731C10.758 30.8669 10.9375 31.1544 10.9375 31.5716C10.9375 31.7294 10.9103 31.895 10.8603 32.0606L17.0312 35.1466L31.25 28.0372V24.4309L30.0262 22.595C30.0091 22.57 30 22.5403 30 22.5091V10.0091V10.006L30.0002 10.0013L30.0005 9.99657L30.0008 9.9919L30.0012 9.98877L30.002 9.98408L30.0023 9.98095C30.0025 9.98095 30.0027 9.97939 30.0028 9.97939L30.0039 9.97471L30.0045 9.97159C30.0047 9.97002 30.0048 9.97002 30.005 9.96846L30.0064 9.96377L30.008 9.95907L30.0095 9.9544L30.0116 9.94971L30.0123 9.94814L30.0131 9.94502L30.0152 9.94189L30.0167 9.93876L30.0186 9.93409L30.0198 9.93252L30.0222 9.92783L30.0239 9.92627L30.0262 9.92158L31.9012 7.10908L31.9614 7.05596L32.3069 6.88409L24.5312 2.99658ZM7.85937 32.1606L8.20219 32.331C8.15219 32.4981 8.125 32.6638 8.125 32.8216C8.125 32.9216 8.13547 33.0153 8.15531 33.1013L8.09234 33.07C7.91297 32.9794 7.8125 32.7825 7.8125 32.5091C7.8125 32.395 7.8289 32.2778 7.85937 32.1606ZM30.97 30.0731C30.9489 30.0622 30.9272 30.0528 30.905 30.0466C30.7708 30.0013 30.6241 30.0122 30.4891 30.0466C30.4655 30.0528 30.442 30.0606 30.4189 30.0685C30.3902 30.0778 30.3617 30.0888 30.3337 30.0997C30.2995 30.1138 30.2659 30.1294 30.233 30.145L30.2261 30.1481C29.5864 30.4685 29.0625 31.2435 29.0625 31.8841C29.0625 32.1575 29.163 32.3544 29.3423 32.445L29.4053 32.4763C29.3855 32.3903 29.375 32.2966 29.375 32.1966C29.375 31.456 29.9712 30.5513 30.7114 30.181C30.8012 30.1372 30.8894 30.1013 30.9748 30.0747L30.97 30.0731ZM30.625 22.8216V10.4185L30.3125 10.2622V22.4622L31.5363 24.2966C31.5533 24.3231 31.5625 24.3528 31.5625 24.3841V28.0372L31.875 28.1935V24.7434L30.6512 22.9075C30.6341 22.8825 30.625 22.8528 30.625 22.8216ZM19.8137 25.9794L19.1914 26.2903C19.1091 26.4903 19.0625 26.6935 19.0625 26.8841C19.0625 27.1575 19.163 27.3544 19.3423 27.445L19.4053 27.4763C19.3855 27.3903 19.375 27.2966 19.375 27.1966C19.375 26.8028 19.5439 26.3606 19.8137 25.9794ZM21.25 5.73096L20.9375 5.57471V17.7747L22.1613 19.6091C22.1783 19.6356 22.1875 19.6653 22.1875 19.6966V23.3497L22.5 23.506V20.0559L21.2762 18.22C21.27 18.2106 21.2648 18.2013 21.2608 18.1903L21.2602 18.1888C21.2589 18.1856 21.2577 18.1825 21.2566 18.1794C21.2522 18.1638 21.25 18.1497 21.25 18.1341V5.73096ZM34.1819 6.57159L24.5312 1.74659L22.7633 2.6294L21.0094 5.26065L21.3527 5.43252L23.1512 2.73408C23.1663 2.7122 23.187 2.69346 23.2114 2.68096L24.4614 2.05596L24.4662 2.05439L24.4714 2.05126L24.4761 2.0497L24.4808 2.04814L24.4855 2.04657L24.4902 2.04503L24.4955 2.04346H24.5L24.5047 2.0419H24.5095L24.5144 2.04034H24.52H24.5245H24.5291H24.5341H24.5389H24.5439H24.5491L24.5536 2.0419H24.5586L24.5634 2.04346L24.5683 2.04503L24.5734 2.04657H24.5778L24.5825 2.04814L24.5864 2.0497L24.5909 2.05126L24.5956 2.05439L24.6002 2.05596H24.6011L33.3511 6.43096C33.3698 6.44033 33.3861 6.45439 33.3994 6.46845L33.4017 6.47158C33.4053 6.47627 33.4086 6.48095 33.4117 6.48564L33.4128 6.4872L33.4141 6.48877C33.4145 6.49033 33.415 6.49033 33.4155 6.4919L33.4169 6.49346L33.4181 6.49659L33.4192 6.49815C33.4244 6.50753 33.4284 6.51846 33.4316 6.52783C33.4325 6.53252 33.4333 6.53563 33.4341 6.53876C33.4362 6.5497 33.4375 6.56065 33.4375 6.57159C33.4375 6.63096 33.4041 6.68409 33.3511 6.71065L32.1383 7.3169L30.3844 9.94814L30.7277 10.12L32.5262 7.42158C32.527 7.42001 32.528 7.42001 32.5287 7.41845C32.5294 7.41689 32.53 7.4169 32.5306 7.41534C32.5452 7.39659 32.5642 7.37939 32.5864 7.36846L34.1819 6.57159ZM24.6875 2.72471L32.6562 6.70909L32.9319 6.57159L28.2408 4.22627L24.6875 2.44971V2.72471Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.7819 6.41534H20.7759H20.7705H20.7669C20.7603 6.41691 20.7537 6.41691 20.7473 6.41847L20.7425 6.42004L20.7366 6.42158L20.7319 6.42315H20.7298C20.7234 6.42627 20.7172 6.42784 20.7109 6.43097L5.71156 13.931L5.7075 13.9325L5.70281 13.9357H5.70219C5.68953 13.9435 5.67813 13.9528 5.66813 13.9638L5.66391 13.9685L5.66141 13.97L5.65906 13.9732L5.65531 13.9778L5.6525 13.9825L5.65187 13.9841L5.64969 13.9872L5.64594 13.9935L5.64343 13.9982L5.64172 14.0013L5.63937 14.006L5.63859 14.0075C5.63281 14.02 5.62875 14.0341 5.62656 14.0482L5.62609 14.0528C5.62578 14.0544 5.62562 14.056 5.62547 14.0575L5.62516 14.0653L5.625 14.07V14.0716V16.5716V19.0716V21.5716V21.5763L5.62531 21.581L5.62562 21.5857C5.62734 21.6044 5.63234 21.6216 5.64031 21.6388L5.64234 21.6435L5.64437 21.6466L5.64656 21.6497L5.64938 21.6544L5.65047 21.6575L5.65297 21.6606L5.65594 21.6638L5.65828 21.6669L5.66203 21.6716L5.66469 21.6747C5.67453 21.6856 5.68594 21.6966 5.69875 21.7044L5.70172 21.706L5.70531 21.7075C5.70734 21.7091 5.70953 21.7107 5.71172 21.7107L15.7109 26.7107C15.7144 26.7122 15.718 26.7138 15.7216 26.7153L15.7266 26.7169C15.7402 26.7231 15.7541 26.7263 15.7681 26.7263L15.7739 26.7278H15.7747C15.7838 26.7278 15.7927 26.7278 15.8017 26.7263L15.8083 26.7247C15.8122 26.7247 15.8161 26.7232 15.8198 26.7232L17.0662 26.4107C17.0683 26.4107 17.0702 26.4107 17.072 26.4091L18.3162 26.0982C18.3183 26.0982 18.3202 26.0982 18.322 26.0966L19.5662 25.7857C19.5683 25.7857 19.5702 25.7857 19.572 25.7841L20.8162 25.4732C20.8183 25.4732 20.8202 25.4732 20.822 25.4716L22.0662 25.1607C22.0683 25.1607 22.0702 25.1607 22.072 25.1591L23.3162 24.8482C23.3183 24.8482 23.3202 24.8482 23.322 24.8466L24.5662 24.5357C24.5683 24.5357 24.5702 24.5357 24.572 24.5341L25.8162 24.2232C25.8183 24.2232 25.8202 24.2232 25.822 24.2216L27.0662 23.9107C27.0683 23.9107 27.0702 23.9107 27.072 23.9091L28.3162 23.5982C28.3183 23.5982 28.3202 23.5982 28.322 23.5966L29.5662 23.2857C29.5683 23.2857 29.5702 23.2857 29.572 23.2841L30.8184 22.9732C30.8219 22.9716 30.8253 22.9716 30.8286 22.97L30.8319 22.9685H30.833C30.8542 22.9606 30.8733 22.9497 30.8891 22.9341L30.8917 22.931L30.8941 22.9294C30.8987 22.9247 30.9033 22.9185 30.9072 22.9138L30.9091 22.9106L30.912 22.9075C30.9266 22.8841 30.9356 22.8575 30.9372 22.831L30.9373 22.8263L30.9375 22.8232C30.9375 22.8216 30.9375 22.8216 30.9375 22.8216V19.0716V15.3216V11.5716L30.9373 11.5638L30.937 11.5591L30.9369 11.5575C30.9367 11.556 30.9366 11.5544 30.9364 11.5528L30.9358 11.5482C30.9337 11.5341 30.9297 11.52 30.9237 11.5075L30.9216 11.5028L30.92 11.4997L30.9175 11.495L30.9145 11.4903L30.9127 11.4872L30.9105 11.4825L30.907 11.4778L30.9041 11.4747L30.9016 11.4716L30.8973 11.4669L30.8942 11.4638C30.8844 11.4528 30.873 11.4435 30.8602 11.4357L30.8556 11.4341L30.8547 11.4325C30.8534 11.4325 30.8522 11.4325 30.8508 11.431L20.8514 6.43097C20.8453 6.42784 20.8391 6.42627 20.8325 6.42315L20.8266 6.42158L20.8219 6.42004L20.817 6.41847H20.815C20.8086 6.41691 20.8022 6.41691 20.7956 6.41534H20.7902H20.7841H20.7819ZM15.9375 26.3716L16.5836 26.2091L15.9375 25.8872V26.3716ZM15.625 25.731L14.6875 25.2622V25.8497L15.625 26.3185V25.731ZM17.1875 26.0591L17.8336 25.8966L17.1875 25.5747V26.0591ZM15.9375 25.5372L16.875 26.006V25.4185L15.9375 24.9497V25.5372ZM18.4375 25.7466L19.0836 25.5841L18.4375 25.2622V25.7466ZM17.1875 25.2247L18.125 25.6935V25.106L17.1875 24.6372V25.2247ZM13.4375 25.2247L14.375 25.6935V25.106L13.4375 24.6372V25.2247ZM19.6875 25.4341L20.3336 25.2716L19.6875 24.9497V25.4341ZM14.6875 24.9122L15.625 25.381V24.7935L14.6875 24.3247V24.9122ZM18.4375 24.9122L19.375 25.381V24.7935L18.4375 24.3247V24.9122ZM20.9375 25.1216L21.5836 24.9591L20.9375 24.6372V25.1216ZM15.9375 24.1841V24.5997L16.875 25.0685V24.481L16.1442 24.1153L15.9375 24.1841ZM19.6875 24.5997L20.625 25.0685V24.481L19.6875 24.0122V24.5997ZM12.1875 24.5997L13.125 25.0685V24.481L12.1875 24.0122V24.5997ZM22.1875 24.8091L22.8336 24.6466L22.1875 24.3247V24.8091ZM13.4375 24.2872L14.375 24.756V24.1685L13.4375 23.6997V24.2872ZM17.1875 23.7669V24.2872L18.125 24.756V24.1685L17.2692 23.7403L17.1875 23.7669ZM20.9375 24.2872L21.875 24.756V24.1685L20.9375 23.6997V24.2872ZM23.4375 24.4966L24.0836 24.3341L23.4375 24.0122V24.4966ZM18.4375 23.9747L19.375 24.4435V23.856L18.4375 23.3872V23.9747ZM22.1875 23.9747L23.125 24.4435V23.856L22.1875 23.3872V23.9747ZM14.6875 23.9747L15.625 24.4435V24.1685L14.6875 23.6997V23.9747ZM10.9375 23.9747L11.875 24.4435V23.856L10.9375 23.3872V23.9747ZM24.6875 24.1841L25.3336 24.0216L24.6875 23.6997V24.1841ZM12.1875 23.6622L13.125 24.131V23.5435L12.1875 23.0747V23.6622ZM19.6875 23.6622L20.625 24.131V23.5435L19.6875 23.0747V23.6622ZM23.4375 23.6622L24.375 24.131V23.5435L23.4375 23.0747V23.6622ZM16.5634 23.9747L16.875 24.131V23.8716L16.5634 23.9747ZM25.9375 23.8716L26.5836 23.7091L25.9375 23.3872V23.8716ZM17.6884 23.5997L18.125 23.8185V23.4544L17.6884 23.5997ZM13.4375 23.3497L14.375 23.8185V23.5435L13.4375 23.0747V23.3497ZM24.6875 23.3497L25.625 23.8185V23.231L24.6875 22.7622V23.3497ZM20.9375 23.3497L21.875 23.8185V23.231L20.9375 22.7622V23.3497ZM9.6875 23.3497L10.625 23.8185V23.231L9.6875 22.7622V23.3497ZM15.9375 23.6622L16.1681 23.7778L16.8739 23.5419L15.9375 23.0747V23.6622ZM27.1875 23.5591L27.8336 23.3966L27.1875 23.0747V23.5591ZM22.1875 23.0372L23.125 23.506V22.9185L22.1875 22.4497V23.0372ZM25.9375 23.0372L26.875 23.506V22.9185L25.9375 22.4497V23.0372ZM10.9375 23.0372L11.875 23.506V22.9185L10.9375 22.4497V23.0372ZM18.8134 23.2247L19.375 23.506V23.0372L18.8134 23.2247ZM14.6875 23.0372L15.625 23.506V22.9185L14.6875 22.4497V23.0372ZM17.1875 23.3497L17.2931 23.4028L17.9989 23.1669L17.1875 22.7622V23.3497ZM28.4375 23.2466L29.0836 23.0841L28.4375 22.7622V23.2466ZM15.9375 22.7247L16.875 23.1935V22.606L15.9375 22.1372V22.7247ZM19.9384 22.8497L20.625 23.1935V22.6216L19.9384 22.8497ZM12.1875 22.7247L13.125 23.1935V22.9185L12.1875 22.4497V22.7247ZM23.4375 22.7247L24.375 23.1935V22.606L23.4375 22.1372V22.7247ZM27.1875 22.7247L28.125 23.1935V22.606L27.1875 22.1372V22.7247ZM8.4375 22.7247L9.375 23.1935V22.606L8.4375 22.1372V22.7247ZM18.4375 23.0216L19.1239 22.7919L18.4375 22.4497V23.0216ZM29.6875 22.9341L30.3336 22.7716L29.6875 22.4497V22.9341ZM28.4375 22.4122L29.375 22.881V22.2935L28.4375 21.8247V22.4122ZM24.6875 22.4122L25.625 22.881V22.2935L24.6875 21.8247V22.4122ZM9.6875 22.4122L10.625 22.881V22.2935L9.6875 21.8247V22.4122ZM17.1875 22.4122L18.125 22.881V22.2935L17.1875 21.8247V22.4122ZM13.4375 22.4122L14.375 22.881V22.2935L13.4375 21.8247V22.4122ZM21.0634 22.4747L21.875 22.881V22.2935L21.7692 22.2403L21.0634 22.4747ZM19.6875 22.6044L20.2489 22.4169L19.6875 22.1372V22.6044ZM18.4375 22.0997L19.375 22.5685V21.981L18.4375 21.5122V22.0997ZM10.9375 22.0997L11.875 22.5685V22.2935L10.9375 21.8247V22.0997ZM25.9375 22.0997L26.875 22.5685V21.981L25.9375 21.5122V22.0997ZM22.1884 22.0997L23.125 22.5685V21.981L22.8942 21.8653L22.1884 22.0997ZM14.6875 22.0997L15.625 22.5685V21.981L14.6875 21.5122V22.0997ZM7.1875 22.0997L8.125 22.5685V21.981L7.1875 21.5122V22.0997ZM29.6875 19.5997V22.0997L30.625 22.5685V19.2872L29.6875 19.5997ZM8.4375 21.7872L9.375 22.256V21.6685L8.4375 21.1997V21.7872ZM27.1875 21.7872L28.125 22.256V21.6685L27.1875 21.1997V21.7872ZM23.4375 21.6841V21.7872L24.375 22.256V21.6685L24.0192 21.4903L23.4375 21.6841ZM12.1875 21.7872L13.125 22.256V21.6685L12.1875 21.1997V21.7872ZM19.6875 21.7872L20.625 22.256V21.6685L19.6875 21.1997V21.7872ZM15.9375 21.6747V21.7872L16.875 22.256V21.6685L16.4572 21.4591L15.9375 21.6747ZM20.9375 22.1872L21.3739 22.0419L20.9375 21.8247V22.1872ZM13.4375 21.4747L14.375 21.9435V21.356L13.4375 20.8872V21.4747ZM24.6875 21.2669V21.4747L25.625 21.9435V21.356L25.1442 21.1153L24.6875 21.2669ZM17.1875 21.1544V21.4747L18.125 21.9435V21.356L17.4798 21.0325L17.1875 21.1544ZM9.6875 21.4747L10.625 21.9435V21.6685L9.6875 21.1997V21.4747ZM6.2289 21.62L6.875 21.9435V21.4591L6.2289 21.62ZM28.4375 20.0169V21.4747L29.375 21.9435V19.7044L28.4375 20.0169ZM20.9375 21.4747L21.7931 21.9028L21.875 21.8747V21.356L20.9375 20.8872V21.4747ZM22.1875 21.7716L22.4989 21.6669L22.1875 21.5122V21.7716ZM7.4789 21.3075L8.125 21.631V21.1466L7.4789 21.3075ZM25.9375 20.8497V21.1622L26.875 21.631V21.0435L26.2692 20.7403L25.9375 20.8497ZM18.4375 20.6341V21.1622L19.375 21.631V21.0435L18.5025 20.606L18.4375 20.6341ZM10.9375 21.1622L11.875 21.631V21.0435L10.9375 20.5747V21.1622ZM22.1875 21.1622L22.9181 21.5278L23.125 21.4591V21.0435L22.1875 20.5747V21.1622ZM5.9375 21.3716L6.875 21.1372V19.7935L5.9375 19.3247V21.3716ZM23.4375 21.3544L23.6239 21.2919L23.4375 21.1997V21.3544ZM15.9375 21.3372L16.0878 21.2747L15.9375 21.1997V21.3372ZM14.6875 20.8497L15.625 21.3185V21.0435L14.6875 20.5747V20.8497ZM12.1875 20.8497L13.125 21.3185V20.731L12.1875 20.2622V20.8497ZM8.7289 20.995L9.375 21.3185V21.0435L9.0964 20.9028L8.7289 20.995ZM19.6875 20.8497L20.625 21.3185V20.731L19.6875 20.2622V20.8497ZM16.8383 21.2997L16.875 21.3185V21.2841L16.8383 21.2997ZM27.1875 20.4341V20.8497L28.125 21.3185V20.1216L27.1875 20.4341ZM23.4375 20.8497L24.0431 21.1528L24.375 21.0419V20.731L23.4375 20.2622V20.8497ZM15.9375 20.8497L16.4689 21.1153L16.875 20.9466V20.731L15.9375 20.2622V20.8497ZM7.1875 21.0591L8.125 20.8247V20.4185L7.1875 19.9497V21.0591ZM25.5634 20.9747L25.625 21.006V20.9544L25.5634 20.9747ZM9.9789 20.6825L10.625 21.006V20.5216L9.9789 20.6825ZM17.8609 20.8747L18.125 21.006V20.7638L17.8609 20.8747ZM20.9375 20.5372L21.875 21.006V20.4185L20.9375 19.9497V20.5372ZM24.6875 20.9372L24.7489 20.9169L24.6875 20.8872V20.9372ZM24.6875 20.5372L25.1681 20.7778L25.625 20.6247V20.4185L24.6875 19.9497V20.5372ZM8.4375 20.7466L8.66687 20.6888L8.4375 20.5747V20.7466ZM13.4375 20.2247L14.375 20.6935V20.4185L13.4375 19.9497V20.2247ZM11.2289 20.37L11.875 20.6935V20.2091L11.2289 20.37ZM22.1875 20.2247L23.125 20.6935V20.106L22.1875 19.6372V20.2247ZM14.6875 20.2247L15.625 20.6935V20.106L14.6875 19.6372V20.2247ZM18.8837 20.4481L19.375 20.6935V20.2435L18.8837 20.4481ZM26.6884 20.5997L26.875 20.6935V20.5372L26.6884 20.5997ZM17.1875 20.5372L17.4917 20.6888L18.125 20.4247V20.4185L17.1875 19.9497V20.5372ZM8.4375 18.3497V20.2247L9.13266 20.5716L9.375 20.5122V18.5435L8.76922 18.2403L8.4375 18.3497ZM9.6875 20.4341L10.625 20.1997V19.1685L9.6875 18.6997V20.4341ZM25.9375 17.5091V20.2247L26.2931 20.4028L26.875 20.2091V17.2935L26.6844 17.1982L25.9375 17.5091ZM19.9064 20.0216L20.625 20.381V19.7935L20.548 19.7544L19.9064 20.0216ZM15.9375 19.9122L16.875 20.381V19.7935L15.9375 19.3247V19.9122ZM23.4375 19.9122L24.375 20.381V19.7935L23.4375 19.3247V19.9122ZM18.4375 20.2247L18.5144 20.2638L19.1559 19.995L18.4375 19.6372V20.2247ZM10.9375 20.1216L11.875 19.8872V19.7935L10.9375 19.3247V20.1216ZM27.1875 20.1044L28.125 19.7919V17.9169L27.1875 17.4497V20.1044ZM12.8956 19.9528L13.125 20.0685V19.8966L12.8956 19.9528ZM17.1875 19.5997L18.125 20.0685V19.481L17.1875 19.0122V19.5997ZM20.9375 19.5919V19.5997L21.875 20.0685V19.481L21.5708 19.3278L20.9375 19.5919ZM13.7289 19.745L14.375 20.0685V19.5841L13.7289 19.745ZM24.6875 18.0294V19.5997L25.625 20.0685V17.6388L24.6875 18.0294ZM7.1875 18.7669V19.5997L8.125 20.0685V18.4544L7.1875 18.7669ZM19.6875 19.7747L20.1787 19.57L19.6875 19.3247V19.7747ZM22.1875 19.0716V19.2872L23.125 19.756V19.1685L22.5934 18.9013L22.1875 19.0716ZM18.4375 19.2872L19.375 19.756V19.1685L18.4375 18.6997V19.2872ZM14.9789 19.4325L15.625 19.756V19.2716L14.9789 19.4325ZM12.1875 19.5997L12.4661 19.7388L13.125 19.5747V17.9185L12.1875 17.4497V19.5997ZM28.4375 19.6872L29.375 19.3747V18.5419L28.4375 18.0732V19.6872ZM13.4375 19.4966L14.375 19.2622V18.5435L13.4375 18.0747V19.4966ZM10.9375 17.5169V18.9747L11.875 19.4435V17.2935L11.7692 17.2403L10.9375 17.5169ZM16.2289 19.12L16.875 19.4435V18.9591L16.2289 19.12ZM23.4375 18.5497V18.9747L24.375 19.4435V18.1591L23.4375 18.5497ZM6.18844 19.0997L6.875 19.4435V18.8716L6.18844 19.0997ZM19.6875 18.9747L20.5598 19.4106L20.625 19.3841V18.856L19.6875 18.3872V18.9747ZM29.6875 18.6982V19.2716L30.3739 19.0419L29.6875 18.6982ZM20.9375 19.2528L21.2014 19.1435L20.9375 19.0122V19.2528ZM14.6875 19.1841L15.3336 19.0216L14.6875 18.6997V19.1841ZM17.4789 18.8075L18.125 19.131V18.6466L17.4789 18.8075ZM20.9375 18.6622L21.5827 18.9841L21.875 18.8622V18.5435L20.9375 18.0747V18.6622ZM5.9375 18.8544L6.875 18.5419V17.2935L5.9375 16.8247V18.8544ZM9.6875 17.9341V18.3497L10.625 18.8185V17.6216L9.6875 17.9341ZM14.6875 16.2669V18.3497L15.625 18.8185V15.9544L14.6875 16.2669ZM29.6875 15.9466V18.3497L30.625 18.8185V15.556L29.6875 15.9466ZM18.7289 18.495L19.375 18.8185V18.3341L18.7289 18.495ZM15.9375 15.8497V18.8185L16.875 18.3497V15.5372L15.9375 15.8497ZM22.9747 18.7435L23.125 18.8185V18.681L22.9747 18.7435ZM22.1875 18.7325L22.2242 18.7169L22.1875 18.6997V18.7325ZM17.1875 18.5435V18.5591L18.125 18.3247V18.0747L17.1875 18.5435ZM22.1875 16.0435V18.3497L22.6053 18.5591L23.125 18.3419V15.5747L22.1875 16.0435ZM19.9789 18.1825L20.625 18.506V18.0216L19.9789 18.1825ZM7.1875 18.4372L8.125 18.1247V17.9185L7.1875 17.4497V18.4372ZM18.4375 17.9185V18.2466L19.375 18.0122V17.4497L18.4375 17.9185ZM23.4375 18.2122L24.375 17.8216V16.0435L23.4375 15.5747V18.2122ZM9.18844 18.0997L9.375 18.1935V18.0372L9.18844 18.0997ZM13.4375 16.6841V17.7247L14.375 18.1935V16.3716L13.4375 16.6841ZM28.4375 16.4669V17.7247L29.375 18.1935V16.0763L28.4375 16.4669ZM17.1875 15.4341V18.1935L18.125 17.7247V15.1216L17.1875 15.4341ZM21.875 18.1935V16.1997L20.9375 16.6685V17.7247L21.875 18.1935ZM20.625 16.8247L19.6875 17.2935V17.9341L20.625 17.6997V16.8247ZM8.4375 15.6341V17.7247L8.79313 17.9028L9.375 17.7091V16.0435L8.5025 15.606L8.4375 15.6341ZM24.6875 17.6903L25.625 17.2997V16.6685L24.6875 16.1997V17.6903ZM9.6875 17.6044L10.625 17.2919V16.6685L9.6875 16.1997V17.6044ZM7.1875 16.1544V17.0997L8.125 17.5685V15.7638L7.1875 16.1544ZM12.1884 17.0997L13.125 17.5685V16.7872L12.1884 17.0997ZM27.1875 16.9872V17.0997L28.125 17.5685V16.5966L27.1875 16.9872ZM18.4375 15.0169V17.5685L19.375 17.0997V14.7044L18.4375 15.0169ZM10.9375 17.1872L11.3739 17.0419L10.9375 16.8247V17.1872ZM25.9375 17.17L26.315 17.0122L25.9375 16.8247V17.17ZM6.15641 16.5841L6.875 16.9435V16.2841L6.15641 16.5841ZM19.6875 14.5997V16.9435L20.625 16.4747V14.2872L19.6875 14.5997ZM10.9375 14.5919V16.4747L11.7931 16.9028L11.875 16.8747V14.2013L10.9375 14.5919ZM25.9375 14.1685V16.4747L26.6962 16.8544L26.875 16.7794V13.6997L25.9375 14.1685ZM12.1875 14.0716V16.7716L13.125 16.4591V13.681L12.1875 14.0716ZM27.1875 16.6497L28.125 16.2591V14.1685L27.1875 13.6997V16.6497ZM13.4375 13.5497V16.3544L14.375 16.0419V13.1591L13.4375 13.5497ZM5.9375 16.3372L6.875 15.9466V14.7935L5.9375 14.3247V16.3372ZM9.6875 15.1122V15.8497L10.625 16.3185V14.7216L9.6875 15.1122ZM24.6875 14.7935V15.8497L25.625 16.3185V14.3247L24.6875 14.7935ZM20.9375 16.3185L21.875 15.8497V14.7935L20.9375 14.3247V16.3185ZM28.4375 16.1278L29.375 15.7372V14.7935L28.4375 14.3247V16.1278ZM14.6875 13.0294V15.9372L15.625 15.6247V12.6388L14.6875 13.0294ZM7.1875 15.8153L8.125 15.4247V15.4185L7.1875 14.9497V15.8153ZM8.88375 15.4481L9.375 15.6935V15.2435L8.88375 15.4481ZM22.1875 15.6935L22.9319 15.3216L22.1875 14.9497V15.6935ZM23.6306 15.3216L24.375 15.6935V14.9497L23.6306 15.3216ZM29.6875 14.9497V15.6075L30.4059 15.3075L29.6875 14.9497ZM15.9375 12.5091V15.5216L16.875 15.2091V12.1185L15.9375 12.5091ZM8.4375 12.9185V15.2247L8.51438 15.2638L9.375 14.9044V12.4497L8.4375 12.9185ZM17.1875 11.9872V15.1044L18.125 14.7919V11.5966L17.1875 11.9872ZM7.1875 13.5435V14.5997L8.125 15.0685V13.0747L7.1875 13.5435ZM29.6875 12.2935V14.5997L30.625 15.0685V11.8247L29.6875 12.2935ZM23.4375 15.0685L24.375 14.5997V12.2935L23.4375 11.8247V15.0685ZM22.1875 14.5997L23.125 15.0685V11.6685L22.1875 11.1997V14.5997ZM9.6875 12.2935V14.7747L10.625 14.3841V11.8247L9.6875 12.2935ZM18.4375 11.4669V14.6872L19.375 14.3747V11.0763L18.4375 11.4669ZM6.13062 14.0716L6.875 14.4435V13.6997L6.13062 14.0716ZM24.6875 14.4435L25.625 13.9747V12.9185L24.6875 12.4497V14.4435ZM20.9375 13.9747L21.875 14.4435V11.0435L20.9375 10.5747V13.9747ZM28.4375 12.9185V13.9747L29.375 14.4435V12.4497L28.4375 12.9185ZM19.6875 10.9466V14.2716L20.625 13.9591V10.556L19.6875 10.9466ZM10.9375 11.6685V14.2528L11.875 13.8622V11.1997L10.9375 11.6685ZM25.9375 13.8185L26.6819 13.4466L25.9375 13.0747V13.8185ZM27.3806 13.4466L28.125 13.8185V13.0747L27.3806 13.4466ZM12.1875 11.0435V13.7325L13.125 13.3419V10.5747L12.1875 11.0435ZM13.4375 10.4185V13.2122L14.375 12.8216V9.94972L13.4375 10.4185ZM27.1875 13.1935L28.125 12.7247V10.4185L27.1875 9.94972V13.1935ZM25.9375 12.7247L26.875 13.1935V9.79347L25.9375 9.32472V12.7247ZM14.6875 9.79347V12.6903L15.625 12.2997V9.32472L14.6875 9.79347ZM28.4375 12.5685L29.375 12.0997V11.0435L28.4375 10.5747V12.5685ZM24.6875 12.0997L25.625 12.5685V9.16847L24.6875 8.69972V12.0997ZM15.9375 9.16847V12.17L16.875 11.7794V8.69972L15.9375 9.16847ZM29.6875 11.9435L30.4319 11.5716L29.6875 11.1997V11.9435ZM23.4375 11.4747L24.375 11.9435V8.54347L23.4375 8.07472V11.4747ZM17.1875 8.54347V11.6497L18.125 11.2591V8.07472L17.1875 8.54347ZM22.1875 10.8497L23.125 11.3185V7.91847L22.1875 7.44972V10.8497ZM18.4375 7.91847V11.1278L19.375 10.7372V7.44972L18.4375 7.91847ZM20.9375 10.2247L21.875 10.6935V7.29347L20.9375 6.82472V10.2247ZM19.6875 7.29347V10.6075L20.625 10.2169V6.82472L19.6875 7.29347Z",
				fill: "#3D3D3D"
			})
		]
	});
})), At = /* @__PURE__ */ we({ default: () => jt }), jt, Mt = Se((() => {
	jt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M27.6562 2.34375L26.4062 2.96875V6.71875L20.7812 3.90625H19.5312L17.6562 4.84375L15.1562 11.0938L5.78125 18.2812V18.9062L6.40625 19.2188L2.65625 21.0938L10.1562 24.8438L9.53125 30.3125L12.9688 32.0312L12.6562 26.0938L20.1562 29.8438L37.6562 21.0938L30.5734 17.5516L32.6562 12.3438L34.5312 11.4062V10.7812L32.6562 9.84375V6.09375L33.9062 5.46875L27.6562 2.34375Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.1562 29.8438L2.65625 21.0938V28.5938L20.1562 37.3438V29.8438ZM11.4062 27.9688C12.0953 28.3141 12.6562 29.1547 12.6562 29.8438C12.6562 30.5328 12.0953 30.8141 11.4062 30.4688C10.7172 30.1234 10.1562 29.2828 10.1562 28.5938C10.1562 27.9047 10.7172 27.6234 11.4062 27.9688ZM5.78125 21.4062L19.5312 28.2812H20.7812V25.7812H19.5312L5.78125 18.9062V21.4062ZM19.4062 21.3437L18.4063 22.0938L19.6563 22.7188L20.6562 21.9687L19.4062 21.3437ZM17.5312 20.4062L16.5313 21.1563L17.7813 21.7813L18.7812 21.0312L17.5312 20.4062ZM20.9063 20.2188L19.9063 20.9687L21.1563 21.5937L22.1563 20.8438L20.9063 20.2188ZM15.6562 19.4687L14.6563 20.2188L15.9063 20.8438L16.9062 20.0937L15.6562 19.4687ZM19.0313 19.2813L18.0313 20.0312L19.2813 20.6562L20.2813 19.9063L19.0313 19.2813ZM22.4063 19.0937L21.4062 19.8438L22.6562 20.4688L23.6563 19.7187L22.4063 19.0937ZM17.1563 18.3438L16.1563 19.0937L17.4063 19.7187L18.4063 18.9688L17.1563 18.3438ZM20.5313 18.1562L19.5312 18.9062L20.7812 19.5312L21.7813 18.7812L20.5313 18.1562ZM23.9062 17.9688L22.9062 18.7188L24.1562 19.3438L25.1562 18.5938L23.9062 17.9688ZM12.5312 17.9062L11.5313 18.6563L12.7813 19.2813L13.7812 18.5312L12.5312 17.9062ZM18.6563 17.2187L17.6562 17.9688L18.9062 18.5938L19.9063 17.8437L18.6563 17.2187ZM17.6562 4.84375L15.1562 11.0938L30.1562 18.5938L32.6562 12.3438L17.6562 4.84375ZM22.0312 17.0312L21.0312 17.7813L22.2812 18.4063L23.2812 17.6562L22.0312 17.0312ZM10.6562 16.9687L9.65626 17.7188L10.9063 18.3438L11.9062 17.5937L10.6562 16.9687ZM14.0313 16.7813L13.0313 17.5312L14.2813 18.1562L15.2813 17.4063L14.0313 16.7813ZM20.1562 16.0938L19.1562 16.8438L20.4062 17.4688L21.4062 16.7188L20.1562 16.0938ZM12.1563 15.8438L11.1563 16.5937L12.4063 17.2187L13.4063 16.4688L12.1563 15.8438ZM15.5313 15.6562L14.5312 16.4062L15.7812 17.0312L16.7813 16.2812L15.5313 15.6562ZM13.6563 14.7187L12.6562 15.4688L13.9062 16.0938L14.9063 15.3437L13.6563 14.7187ZM30.1562 12.9688L23.9062 9.84375L22.6562 12.9688L28.9062 16.0938L30.1562 12.9688ZM17.0312 14.5312L16.0312 15.2813L17.2812 15.9063L18.2812 15.1562L17.0312 14.5312ZM15.1562 13.5938L14.1562 14.3438L15.4062 14.9688L16.4062 14.2188L15.1562 13.5938ZM18.2812 7.65625C18.2812 7.02344 18.5172 6.56251 18.9062 6.31563L22.0312 7.87813C21.6422 8.12501 21.4062 8.58594 21.4062 9.21875V10.4688L18.2812 8.90625V7.65625ZM26.4062 6.71875L28.9062 7.96875V9.21875L30.1562 9.84375V8.59375L32.6562 9.84375V6.09375L26.4062 2.96875V6.71875ZM32.0312 6.40625L27.0312 3.90625V6.40625L32.0312 8.90625V6.40625Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M34.6875 10.7813V19.4344L37.725 20.9547L37.7297 20.9563L37.7344 20.9578L37.7359 20.9594C37.7484 20.9656 37.7594 20.975 37.7687 20.986L37.7734 20.9906L37.7766 20.9938L37.7781 20.9969L37.7828 21.0016L37.7844 21.0047L37.7859 21.0063L37.7875 21.0094L37.7922 21.0156L37.7938 21.0203L37.7953 21.0235L37.7984 21.0281V21.0297C37.8047 21.0422 37.8094 21.0563 37.8109 21.0719V21.075C37.8109 21.0766 37.8125 21.0781 37.8125 21.0813V21.0875V21.0922V21.0938V28.5938C37.8125 28.6531 37.7797 28.7078 37.7266 28.7328L20.2266 37.4828C20.2203 37.486 20.2141 37.4891 20.2078 37.4906L20.2016 37.4938L20.1969 37.4953H20.1922L20.1906 37.4969C20.1828 37.4984 20.1766 37.4985 20.1703 37.5H20.1656H20.1594H20.1531H20.1469H20.1422C20.1359 37.4985 20.1297 37.4984 20.1219 37.4969L20.1172 37.4953L20.1109 37.4938L20.1063 37.4922L20.1047 37.4906C20.0984 37.4891 20.0922 37.486 20.0859 37.4828L2.58595 28.7328C2.53282 28.7078 2.5 28.6531 2.5 28.5938V21.0938V21.0875V21.0813C2.5 21.0781 2.50156 21.0766 2.50156 21.075V21.0719C2.50313 21.0563 2.50781 21.0422 2.51406 21.0297L2.51562 21.025L2.51719 21.0219L2.52031 21.0172L2.52344 21.0125L2.52501 21.0094L2.52657 21.0063L2.52968 21.0016L2.53281 20.9969L2.53593 20.9938L2.54063 20.9891L2.54375 20.986C2.55313 20.975 2.56406 20.9656 2.57812 20.9594L2.58125 20.9563H2.58282C2.58438 20.9547 2.58595 20.9547 2.58751 20.9547L5.625 19.4344V18.2813C5.625 18.2328 5.64688 18.1875 5.68594 18.1578L15.0266 10.9953L17.5109 4.78595C17.525 4.75002 17.5516 4.72189 17.5859 4.7047L19.4609 3.7672C19.4828 3.75626 19.5078 3.75001 19.5312 3.75001H20.7812C20.8047 3.75001 20.8297 3.75626 20.8516 3.7672L26.25 6.46564V2.96876V2.96251V2.95627C26.25 2.95315 26.2516 2.95158 26.2516 2.95002V2.94689C26.2531 2.93126 26.2578 2.9172 26.2641 2.9047L26.2656 2.90002L26.2672 2.8969L26.2703 2.8922L26.2734 2.88751L26.275 2.88438L26.2766 2.88126L26.2797 2.87658L26.2828 2.87189L26.2859 2.86876L26.2906 2.86407L26.2938 2.86096C26.3031 2.85002 26.3141 2.84064 26.3281 2.83439L26.3313 2.83126H26.3328C26.3344 2.8297 26.3359 2.8297 26.3375 2.8297L27.5859 2.2047C27.6297 2.18282 27.6828 2.18282 27.7266 2.2047L33.975 5.3297L33.9797 5.33126L33.9844 5.33283L33.9859 5.33439C33.9984 5.34064 34.0094 5.35002 34.0187 5.36096L34.0234 5.36563L34.0266 5.36876L34.0281 5.37189L34.0328 5.37658L34.0344 5.37971L34.0359 5.38126L34.0375 5.38438L34.0422 5.39064L34.0438 5.39533L34.0453 5.39846L34.0484 5.40313V5.4047C34.0547 5.4172 34.0594 5.43126 34.0609 5.44689V5.45002C34.0609 5.45158 34.0625 5.45315 34.0625 5.45627V5.46251V5.4672V5.46876V9.21876C34.0625 9.27814 34.0297 9.33283 33.9766 9.35783L33.0062 9.84376L34.6016 10.6422C34.6547 10.6688 34.6875 10.7219 34.6875 10.7813ZM9.14532 24.5125L20 29.9406V37.0906L2.8125 28.4969V21.3469L9.14532 24.5125ZM19.6875 30.1563C19.6875 30.0969 19.6547 30.0438 19.6016 30.0172L3.35155 21.8922C3.30312 21.8672 3.24531 21.8703 3.19843 21.8985C3.15312 21.9266 3.125 21.9766 3.125 22.0313V28.2813C3.125 28.3406 3.15782 28.3953 3.21095 28.4203L19.4609 36.5453C19.5094 36.5703 19.5672 36.5672 19.6141 36.5391C19.6594 36.5109 19.6875 36.461 19.6875 36.4063V30.1563ZM19.375 30.2531V36.1531L3.4375 28.1844V22.2844L19.375 30.2531ZM11.25 28.5938V29.8438C11.25 29.9297 11.3203 30 11.4062 30C11.4922 30 11.5625 29.9297 11.5625 29.8438V28.5938C11.5625 28.5078 11.4922 28.4375 11.4062 28.4375C11.3203 28.4375 11.25 28.5078 11.25 28.5938ZM34.6875 19.7844V21.4063C34.6875 21.4656 34.6547 21.5203 34.6016 21.5453L20.8531 28.4188C20.8328 28.4313 20.8094 28.4375 20.7844 28.4375H20.7812H19.5312H19.5281C19.5031 28.4375 19.4797 28.4313 19.4594 28.4188L5.71095 21.5453C5.65782 21.5203 5.625 21.4656 5.625 21.4063V19.7844L3.00625 21.0938L20.1562 29.6688L37.3063 21.0938L34.6875 19.7844ZM20.625 25.9375V28.125H19.6875V25.9375H19.8906H20.625ZM5.9375 19.1594L19.375 25.8781V28.0281L5.9375 21.3094V19.1594ZM28.75 8.06564L20.7438 4.06251H19.5687L17.7797 4.95626L15.3016 11.1516C15.2906 11.1781 15.2734 11.2 15.2516 11.2172L5.9375 18.3578V18.8094L19.5687 25.625H20.7281L30.0266 18.4953L32.5109 12.286C32.525 12.25 32.5516 12.2219 32.5859 12.2047L34.375 11.3094V10.8781L32.5859 9.98283L31.4062 9.39376L30.2266 9.98283C30.2203 9.98595 30.2141 9.98907 30.2078 9.99063L30.2016 9.99376L30.1969 9.99532H30.1922L30.1906 9.99689C30.1828 9.99845 30.1766 9.99845 30.1703 10H30.1656H30.1594H30.1531H30.1469H30.1422C30.1359 9.99845 30.1297 9.99845 30.1219 9.99689L30.1172 9.99532L30.1109 9.99376L30.1063 9.99219L30.1047 9.99063C30.0984 9.98907 30.0922 9.98595 30.0859 9.98283L28.8359 9.35783C28.7828 9.33283 28.75 9.27814 28.75 9.21876V8.06564ZM18.125 8.63595C18.0734 8.66564 18.0297 8.70939 18.0016 8.7672C17.925 8.92032 17.9875 9.1094 18.1422 9.18596L21.2672 10.7485C21.4203 10.825 21.6094 10.7625 21.6859 10.6078C21.7609 10.4594 21.7047 10.2797 21.5625 10.1985V9.21876C21.5625 8.65001 21.7656 8.23127 22.1156 8.01095C22.1625 7.9797 22.1906 7.92658 22.1875 7.87033C22.1844 7.81408 22.1516 7.76408 22.1016 7.73908L18.9766 6.17658C18.9266 6.15158 18.8687 6.1547 18.8219 6.18438C18.3937 6.4547 18.125 6.95783 18.125 7.65626V8.63595ZM21.25 10.0406L18.4375 8.63439V7.65626C18.4375 7.12658 18.6125 6.72813 18.9187 6.49688L21.7406 7.90782C21.4344 8.19689 21.25 8.6422 21.25 9.21876V10.0406ZM26.9422 3.41095L32.5 6.19064V9.59064L26.5625 6.62189V3.22189L26.9422 3.41095ZM29.3875 8.38439L30 8.69064V9.59064L29.0625 9.12189V8.22189L29.3875 8.38439ZM33.5563 5.46876L32.6562 5.91877L26.7562 2.96876L27.6562 2.51876L33.5563 5.46876Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Nt = /* @__PURE__ */ we({ default: () => Pt }), Pt, Ft = Se((() => {
	Pt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.9062 8.12498C25.8052 11.5745 31.4062 19.9761 31.4062 26.875C31.4062 33.7739 25.8052 36.5745 18.9062 33.125C12.0073 29.6754 6.40625 21.2739 6.40625 14.375C6.40625 7.47607 12.0073 4.67545 18.9062 8.12498Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.9547 20.7325L15.8922 20.2637C16.4299 20.8628 17.0319 21.4284 17.6986 21.9611C18.3653 22.4936 19.005 22.9131 19.618 23.2195C19.7778 23.2995 19.9238 23.3675 20.056 23.4236C20.1175 23.5425 20.1481 23.659 20.1481 23.7732C20.1481 23.9895 20.0353 24.0953 19.8096 24.0906C19.5836 24.0859 19.2074 23.9517 18.6805 23.6883C18.0675 23.3818 17.4278 22.9623 16.7611 22.4298C16.1152 21.9139 15.5299 21.3667 15.0052 20.7886L14.9547 20.7325ZM18.24 18.4581L19.1841 17.995C19.4788 18.2457 19.9083 18.5701 20.4728 18.9679C21.333 19.5689 22.0588 20.1281 22.6502 20.6459C23.0771 21.0195 23.4633 21.4454 23.8088 21.9237L22.8713 22.3925C22.5258 21.9142 22.1396 21.4882 21.7127 21.1147C21.1213 20.5968 20.3955 20.0376 19.5353 19.4367C18.9666 19.0359 18.5347 18.7097 18.24 18.4581ZM20.1563 15.049L21.0938 14.5803C21.5283 14.8407 21.9583 15.1276 22.3841 15.4411C23.1314 15.9912 23.79 16.5795 24.3599 17.2059L23.4224 17.6747C22.8525 17.0483 22.1939 16.46 21.4466 15.9098C21.0208 15.5964 20.5908 15.3095 20.1563 15.049ZM9.98299 7.41341L9.98206 7.41294L12.4821 6.16294L12.483 6.16325C14.7519 4.98419 17.9127 5.12809 21.4063 6.87497C25.1736 8.75856 28.5538 12.1189 30.8464 15.905L28.3464 17.155C26.0542 13.3693 22.6738 10.0087 18.9063 8.12497C15.4127 6.37809 12.2519 6.23419 9.98299 7.41341ZM15.0106 13.7934L15.0097 13.7931L15.9555 13.3201L15.9566 13.3207C16.2999 13.1636 16.7219 13.0984 17.2228 13.1251C17.3621 13.1326 17.5066 13.1481 17.6563 13.1718V13.8718C17.1535 13.7086 16.6964 13.6159 16.2853 13.5939C15.7803 13.5668 15.3553 13.6334 15.0106 13.7934ZM18.5938 12.0312L17.6563 12.5L20.1563 13.75L21.0938 13.2812L18.5938 12.0312Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.412 6.30247C12.3725 6.28232 12.3422 6.24576 12.3311 6.20044C12.3141 6.13044 12.347 6.05794 12.4108 6.02466C14.7156 4.82685 17.9273 4.96075 21.4761 6.73528C25.2684 8.63138 28.6722 12.0129 30.98 15.824C32.9016 18.997 34.0625 22.4675 34.0625 25.625C34.0625 29.1008 32.6594 31.552 30.4017 32.7253L30.3308 32.7426L30.3305 32.7434L30.4003 32.7268L27.7441 34.055C27.7398 34.0572 27.7355 34.059 27.7309 34.0608C25.4395 35.1656 22.2983 34.9958 18.8364 33.2647C11.8872 29.7901 6.25 21.3242 6.25 14.375C6.25 10.9065 7.64719 8.4581 9.89656 7.28216C9.90156 7.27888 9.90672 7.27591 9.91219 7.2731L12.4122 6.0231C12.3473 6.0556 12.3133 6.12825 12.33 6.19872C12.3405 6.24357 12.3697 6.27997 12.4083 6.3006L12.412 6.30247ZM18.8364 8.26482C25.685 11.689 31.25 20.0264 31.25 26.875C31.25 30.2529 29.8892 32.6329 27.6734 33.7409C25.4464 34.8545 22.3714 34.6829 18.9761 32.9853C12.1275 29.5609 6.5625 21.2237 6.5625 14.375C6.5625 10.997 7.92328 8.61701 10.1391 7.50904C12.3661 6.3956 15.4411 6.56716 18.8364 8.26482ZM14.073 9.29763C13.2234 9.34201 12.4472 9.54044 11.7667 9.88075C9.90969 10.8092 8.75 12.7939 8.75 15.625C8.75 21.1943 13.267 27.98 18.8364 30.7647C20.5969 31.645 22.2542 32.0217 23.7005 31.9542C23.7533 31.9522 23.8059 31.9492 23.8583 31.9456C23.8627 31.9453 23.867 31.9448 23.8714 31.9442C24.6697 31.8868 25.4008 31.6918 26.0458 31.3692C27.9028 30.4408 29.0625 28.4561 29.0625 25.625C29.0625 20.0556 24.5456 13.27 18.9761 10.4853C17.5505 9.77232 16.1923 9.38982 14.9595 9.30591C14.9548 9.30513 14.9503 9.30466 14.9456 9.30435C14.643 9.28419 14.3523 9.28216 14.073 9.29763ZM14.9409 9.61653C12.0039 9.82419 10.0325 12.0037 10.0325 15.625C10.0325 21.0939 14.4773 27.7508 19.9463 30.4853C21.3336 31.1789 22.6541 31.5531 23.8519 31.6334C24.6052 31.5787 25.2956 31.395 25.9061 31.0898C27.6692 30.2081 28.75 28.3131 28.75 25.625C28.75 20.1561 24.3053 13.4992 18.8364 10.7648C17.4523 10.0728 16.135 9.69825 14.9409 9.61653ZM17.5828 12.362L17.5864 12.3603L18.5239 11.8915C18.5678 11.8695 18.6197 11.8695 18.6636 11.8915L21.1636 13.1415L21.1672 13.1433L21.1716 13.1458L21.1744 13.1473C21.1777 13.1493 21.1809 13.1515 21.1842 13.1537L21.187 13.1558L21.1891 13.1575L21.1933 13.1609L21.1966 13.1636L21.1998 13.1665L21.2022 13.1687L21.2033 13.1698C21.2041 13.1704 21.2047 13.1711 21.2053 13.1717L21.2089 13.1756L21.2125 13.1797L21.215 13.1828L21.2181 13.1867L21.2195 13.1886L21.2211 13.1906L21.2225 13.1926L21.2238 13.1947L21.2255 13.1973L21.2281 13.2014L21.2306 13.2061L21.2325 13.2095L21.2347 13.2139L21.2367 13.2184L21.2377 13.2204C21.238 13.2212 21.2384 13.2222 21.2388 13.2229L21.2397 13.2254L21.2406 13.2279L21.2416 13.2304L21.2431 13.2356L21.2447 13.2408L21.2456 13.2447L21.2463 13.247C21.2469 13.2498 21.2473 13.2526 21.2478 13.2554L21.2484 13.2593L21.2491 13.2648L21.2495 13.2686L21.2498 13.2736V13.2762L21.25 13.2787V13.2812V14.492C21.6628 14.7428 22.0717 15.0172 22.4767 15.3153C23.2327 15.8719 23.8989 16.467 24.4755 17.1008C24.5186 17.1481 24.5284 17.217 24.5003 17.2745L23.3552 19.622C23.3402 19.6528 23.3153 19.6779 23.2845 19.6933L22.347 20.162L22.3442 20.1634L22.34 20.1653L22.3384 20.1659C22.3356 20.1672 22.3327 20.1683 22.3297 20.1694C22.4778 20.2912 22.6189 20.4108 22.7531 20.5283C23.3562 21.0562 23.88 21.6865 24.3242 22.4194C24.7745 23.1626 25 23.9814 25 24.8762C25 25.6754 24.7823 26.2909 24.3591 26.7272C24.2102 26.8808 24.0362 27.0058 23.8369 27.102L23.8378 27.1018L22.8823 27.5795C22.8767 27.5823 22.8709 27.5848 22.865 27.5868C22.5002 27.7545 22.0523 27.8283 21.52 27.8036C21.432 27.7995 21.342 27.7923 21.25 27.782V28.2812C21.25 28.3404 21.2166 28.3945 21.1636 28.4209L20.2261 28.8897L20.2231 28.8912L20.2198 28.8926L20.2161 28.8944L20.2138 28.8953L20.2112 28.8962L20.2083 28.8973L20.2052 28.8984L20.2042 28.8987C20.1878 28.904 20.1708 28.9065 20.1539 28.9062L20.1492 28.9061L20.1461 28.9059L20.1411 28.9054L20.1388 28.9053L20.1367 28.905C20.1347 28.9048 20.1327 28.9045 20.1308 28.9042L20.1273 28.9036C20.1244 28.9029 20.1216 28.9023 20.1186 28.9017L20.1144 28.9006L20.1123 28.9L20.1089 28.8989L20.105 28.8976L20.1019 28.8965C20.0963 28.8943 20.0908 28.892 20.0853 28.8892L17.5864 27.6397C17.5334 27.6133 17.5 27.5592 17.5 27.5V26.2968C16.9309 25.9593 16.3711 25.584 15.8205 25.1711C14.9244 24.4987 14.4062 24.0778 13.9319 23.5854C13.8916 23.5436 13.8778 23.4829 13.8961 23.4278L14.8063 20.6836C14.8069 20.6818 14.8073 20.6803 14.808 20.6786L14.8092 20.6753L14.8112 20.6703L14.813 20.6665L14.8153 20.6618L14.8164 20.6595L14.8177 20.6573L14.8189 20.6551L14.8198 20.6534C14.823 20.6481 14.8266 20.6428 14.8303 20.6379L14.8338 20.6336L14.8372 20.6294L14.8402 20.6262L14.8428 20.6234L14.8434 20.6226C14.8487 20.6175 14.8544 20.6125 14.8603 20.6079L14.8634 20.6056L14.867 20.6031L14.8708 20.6006L14.873 20.5993L14.875 20.5981C14.8773 20.5967 14.8798 20.5953 14.8822 20.594L14.8847 20.5928L15.8217 20.1243C15.2888 19.6281 14.8205 19.0418 14.4172 18.3653C13.9727 17.6193 13.75 16.7993 13.75 15.905C13.75 15.1064 13.9673 14.4883 14.3902 14.0462C14.5431 13.8862 14.723 13.7568 14.9297 13.6587C14.933 13.6568 14.9364 13.655 14.9398 13.6533L15.8855 13.1804C15.8206 13.2128 15.7867 13.2856 15.8033 13.3561C15.8111 13.389 15.8289 13.4173 15.8531 13.4383H15.8536C15.8291 13.4168 15.8112 13.3878 15.8039 13.354C15.7883 13.2823 15.8247 13.2093 15.8916 13.1787C16.2547 13.0123 16.7011 12.9408 17.2311 12.969C17.3187 12.9737 17.4084 12.9815 17.5 12.9925V12.5V12.4964L17.5002 12.4917L17.5005 12.4873L17.5009 12.4836L17.5012 12.4798L17.502 12.475L17.5022 12.4742C17.5027 12.4714 17.5031 12.4686 17.5037 12.4658L17.5047 12.4622L17.5061 12.4568L17.5077 12.4517L17.5089 12.4479L17.5105 12.4437L17.5112 12.4417C17.5116 12.4409 17.512 12.44 17.5123 12.4392L17.5134 12.4367L17.5156 12.4318L17.5175 12.4283L17.5198 12.4239L17.5222 12.4197L17.5236 12.4175L17.5248 12.4156L17.5262 12.4133L17.5281 12.4106L17.5308 12.4068L17.5334 12.4034L17.5366 12.3997L17.5397 12.3959L17.5431 12.3922L17.5447 12.3904C17.5453 12.3898 17.5459 12.3892 17.5467 12.3886L17.5486 12.3867L17.5505 12.385L17.5525 12.3831L17.5545 12.3814L17.5588 12.3779L17.5619 12.3754L17.5658 12.3725C17.5691 12.3703 17.5723 12.3681 17.5756 12.3661L17.5791 12.3642L17.5828 12.362ZM17.608 14.0204C17.6555 14.0359 17.7077 14.0276 17.7481 13.9983C17.7886 13.9689 17.8125 13.9218 17.8125 13.8718V12.7528L20 13.8465V15.049C20 15.1039 20.0287 15.1548 20.0759 15.1829C20.5062 15.4411 20.9322 15.7253 21.3539 16.0356C22.0614 16.5565 22.6886 17.1118 23.2352 17.7018C23.2353 17.702 22.2341 19.7545 22.2341 19.7545C21.1691 18.6765 20.1578 17.8998 19.2019 17.4218C18.6817 17.1618 18.2895 17.0398 18.0294 17.0428C17.8567 17.045 17.73 17.0984 17.6436 17.1878C17.5584 17.2761 17.5081 17.4047 17.5081 17.5792C17.5081 17.8526 17.6623 18.1475 17.9945 18.4503C18.288 18.7178 18.7714 19.0895 19.4453 19.5645C19.4455 19.5647 19.4456 19.5647 19.4458 19.5648C20.3006 20.162 21.022 20.7176 21.6098 21.2322C22.1895 21.7397 22.6925 22.3458 23.1194 23.0501C23.54 23.7442 23.75 24.5092 23.75 25.345C23.75 26.0484 23.5698 26.5943 23.1973 26.9784C22.8267 27.3604 22.2706 27.5256 21.5344 27.4915C21.1355 27.4729 20.6922 27.3845 20.2042 27.2275C20.1566 27.2122 20.1045 27.2204 20.0642 27.2498C20.0239 27.2793 20 27.3262 20 27.3762V28.4972L17.8125 27.4034V26.2076C17.8125 26.1522 17.7831 26.1009 17.7353 26.0728C17.1497 25.7295 16.5739 25.3456 16.0081 24.9211C15.1712 24.2933 14.6702 23.89 14.2227 23.4361C14.2227 23.4359 15.0191 21.0345 15.0191 21.0345C15.5156 21.5669 16.0638 22.0726 16.6636 22.5518C17.3397 23.092 17.9889 23.5172 18.6106 23.8281C19.1675 24.1065 19.5675 24.2418 19.8063 24.2468C19.9692 24.2503 20.0887 24.2053 20.1703 24.1289C20.2542 24.0503 20.3044 23.9339 20.3044 23.7733C20.3044 23.4883 20.1472 23.184 19.8106 22.8733C19.5119 22.5973 19.0206 22.2133 18.3364 21.7215C17.4702 21.0961 16.7483 20.5286 16.1709 20.0192C15.602 19.5172 15.107 18.9125 14.6856 18.2053C14.27 17.5079 14.0625 16.7411 14.0625 15.905C14.0625 15.2009 14.2431 14.652 14.6159 14.2623C14.9861 13.8754 15.5416 13.7106 16.2769 13.75C16.6761 13.7712 17.1197 13.8618 17.608 14.0204ZM23.7884 27.1134L23.768 27.1181V27.1183L23.7884 27.1134ZM15.2092 20.78C15.7056 21.3167 16.2555 21.8259 16.8586 22.3078C17.5158 22.8326 18.1463 23.2465 18.7503 23.5486C19.2472 23.797 19.5998 23.93 19.8128 23.9343C19.8758 23.9358 19.9252 23.9303 19.9567 23.9008C19.9859 23.8734 19.9919 23.8292 19.9919 23.7733C19.9919 23.6975 19.9748 23.6211 19.9416 23.5437C19.8205 23.4914 19.6894 23.43 19.5481 23.3594C18.9264 23.0484 18.2772 22.6233 17.6011 22.0831C16.9603 21.5712 16.3786 21.029 15.8559 20.4565L15.2092 20.78ZM16.6706 20.8481C17.0225 21.1903 17.3977 21.5206 17.7961 21.839C18.3506 22.282 18.8862 22.6458 19.403 22.9301C19.1081 22.6798 18.6917 22.3617 18.1537 21.9751C18.1537 21.9751 18.1536 21.975 18.1534 21.975C17.6011 21.5761 17.1067 21.2003 16.6706 20.8481ZM19.0314 18.0698L18.3931 18.3829C18.6828 18.6258 19.0936 18.9342 19.6252 19.3089C20.4905 19.9134 21.2206 20.4762 21.8156 20.997C22.2573 21.3837 22.6564 21.8251 23.0128 22.3217L23.6672 21.9945C23.3325 21.5344 22.9592 21.124 22.5473 20.7634C21.9595 20.2489 21.2381 19.6933 20.3833 19.0961C20.3831 19.0959 20.383 19.0959 20.3828 19.0958C19.7802 18.6709 19.3298 18.3287 19.0314 18.0698ZM19.1222 17.7319C19.1289 17.7381 19.1356 17.7443 19.1425 17.7506C19.4297 18.0125 19.9033 18.3754 20.5627 18.8401C20.9805 19.132 21.3669 19.4142 21.7217 19.6867C20.8134 18.8067 19.9475 18.1545 19.1222 17.7319ZM20.9541 14.6501L20.3216 14.9664C20.7314 15.2156 21.1372 15.4881 21.5392 15.784C22.2952 16.3406 22.9614 16.9358 23.538 17.5695C23.5478 17.5803 23.5558 17.5922 23.5622 17.6048L24.1298 17.3209L24.1727 17.2331C23.6261 16.6431 22.9989 16.0878 22.2914 15.5668C21.8697 15.2565 21.4437 14.9723 21.0134 14.7142C20.9875 14.6987 20.967 14.6764 20.9541 14.6501ZM28.4028 16.952L30.6245 15.8412C28.3491 12.1395 25.0306 8.86185 21.3364 7.01466C17.898 5.29544 14.7881 5.14138 12.555 6.30201C12.5497 6.30466 12.5444 6.30716 12.5389 6.30919L11.9481 6.60451C13.9609 6.26638 16.3781 6.68622 18.9761 7.98528C22.7273 9.86075 26.0963 13.1908 28.4028 16.952ZM17.5 13.3073C17.4023 13.2948 17.3072 13.2861 17.2144 13.2812C16.7772 13.2578 16.4033 13.3067 16.0936 13.4318C16.1589 13.4322 16.2256 13.4342 16.2936 13.4378C16.6603 13.4575 17.0623 13.5312 17.5 13.6598V13.3073ZM18.0056 12.5L20.1562 13.5753L20.7444 13.2812L18.5938 12.2059L18.0056 12.5Z",
				fill: "#3D3D3D"
			})
		]
	});
})), It = /* @__PURE__ */ we({ default: () => Lt }), Lt, Rt = Se((() => {
	Lt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.20673 13.124C6.85595 10.9912 7.87048 8.56385 11.25 6.87401C16.0792 4.45948 23.9208 4.45948 28.75 6.87401C32.1295 8.56385 33.1441 10.9912 31.7933 13.124C32.5647 14.3421 32.5647 15.6564 31.7933 16.874C32.5647 18.0921 32.5647 19.4064 31.7933 20.624C32.5647 21.8421 32.5647 23.1564 31.7933 24.374C33.1441 26.507 32.1295 28.9343 28.75 30.624C23.9208 33.0387 16.0792 33.0387 11.25 30.624C7.87048 28.9343 6.85595 26.507 8.20673 24.374C7.43533 23.1559 7.43533 21.8418 8.20673 20.624C7.43533 19.4059 7.43533 18.0918 8.20673 16.874C7.43533 15.6559 7.43533 14.3418 8.20673 13.124Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.62879 26.313C7.66067 27.8752 8.8677 29.4329 11.25 30.624C13.6647 31.8313 16.8324 32.4349 20 32.4349V34.9349C16.8324 34.9349 13.6647 34.3313 11.25 33.124C8.83536 31.9166 7.62817 30.3329 7.62817 28.749V26.313H7.62879ZM7.62879 22.563C7.66067 24.1252 8.8677 25.6829 11.25 26.874C13.6647 28.0813 16.8324 28.6849 20 28.6849V31.1849C16.8324 31.1849 13.6647 30.5813 11.25 29.374C8.83536 28.1666 7.62817 26.5829 7.62817 24.999V22.563H7.62879ZM7.62879 18.813C7.66067 20.3752 8.8677 21.9329 11.25 23.124C13.6647 24.3313 16.8324 24.9349 20 24.9349V27.4349C16.8324 27.4349 13.6647 26.8313 11.25 25.624C8.83536 24.4166 7.62817 22.8329 7.62817 21.249V18.813H7.62879ZM7.62879 15.063C7.66067 16.6252 8.8677 18.1829 11.25 19.374C13.6647 20.5813 16.8324 21.1849 20 21.1849V23.6849C16.8324 23.6849 13.6647 23.0813 11.25 21.874C8.83536 20.6666 7.62817 19.0829 7.62817 17.499V15.063H7.62879ZM7.62879 11.313C7.66067 12.8752 8.8677 14.4329 11.25 15.624C13.6647 16.8313 16.8324 17.4349 20 17.4349V19.9349C16.8324 19.9349 13.6647 19.3313 11.25 18.124C8.83536 16.9166 7.62817 15.3329 7.62817 13.749V11.313H7.62879ZM23.0315 14.0147L24.375 14.6865V15.3115L23.0315 14.6397V14.0147ZM20.6261 14.5818L18.993 13.2108V13.8358L20.6261 15.2068V14.5818ZM14.1486 10.6985C14.1504 10.8444 14.1888 10.9879 14.2641 11.1287C14.4458 11.468 14.7996 11.7693 15.3255 12.0322C15.9311 12.3351 16.5457 12.508 17.1691 12.5508C17.2811 12.5587 17.3915 12.564 17.5 12.5669V13.1919C17.3915 13.189 17.2811 13.1837 17.1691 13.1758C16.5457 13.133 15.9311 12.9601 15.3255 12.6572C14.7996 12.3943 14.4458 12.093 14.2641 11.7537C14.1854 11.6065 14.1469 11.4565 14.1486 11.3035V10.6985ZM14.2546 10.2513L13.125 9.68646V9.06146L14.5857 9.79193C14.4972 9.88193 14.4227 9.97256 14.3619 10.0637C14.3199 10.1266 14.2841 10.1893 14.2546 10.2513Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.47224 11.3013C7.47193 11.2838 7.47192 11.2665 7.47192 11.249C7.47192 9.61977 8.69629 7.97618 11.1802 6.7343C16.048 4.3004 23.9521 4.3004 28.8199 6.7343C31.3038 7.97618 32.5282 9.61977 32.5282 11.249C32.5282 11.2665 32.5282 11.2838 32.5279 11.3013C32.5282 11.3052 32.5282 11.3091 32.5282 11.3131V13.749C32.5282 13.9574 32.5082 14.166 32.468 14.374C32.5082 14.582 32.5282 14.7907 32.5282 14.999C32.5282 15.0165 32.5282 15.0338 32.5279 15.0513C32.5282 15.0552 32.5282 15.0591 32.5282 15.0631V17.499C32.5282 17.7074 32.5082 17.916 32.468 18.124C32.5082 18.332 32.5282 18.5407 32.5282 18.749C32.5282 18.7665 32.5282 18.7838 32.5279 18.8013C32.5282 18.8052 32.5282 18.8091 32.5282 18.8131V21.249C32.5282 21.4574 32.5082 21.666 32.468 21.874C32.5082 22.082 32.5282 22.2907 32.5282 22.499C32.5282 22.5165 32.5282 22.5338 32.5279 22.5513C32.5282 22.5552 32.5282 22.5591 32.5282 22.5631V24.999C32.5282 25.2074 32.5082 25.416 32.468 25.624C32.5082 25.832 32.5282 26.0407 32.5282 26.249C32.5282 26.2665 32.5282 26.2838 32.5279 26.3013C32.5282 26.3052 32.5282 26.3091 32.5282 26.3131V28.749C32.5282 30.3782 31.3038 32.0218 28.8199 33.2638C26.3858 34.4809 23.1932 35.0912 20 35.0912C16.8069 35.0912 13.6143 34.4809 11.1802 33.2638C8.69629 32.0218 7.47192 30.3782 7.47192 28.749V26.3131C7.47192 26.3091 7.47193 26.3052 7.47224 26.3013C7.47193 26.2838 7.47192 26.2665 7.47192 26.249C7.47192 26.0407 7.49193 25.8321 7.53208 25.624C7.49193 25.416 7.47192 25.2074 7.47192 24.999V22.5631C7.47192 22.5591 7.47193 22.5552 7.47224 22.5513C7.47193 22.5338 7.47192 22.5165 7.47192 22.499C7.47192 22.2907 7.49193 22.0821 7.53208 21.874C7.49193 21.666 7.47192 21.4574 7.47192 21.249V18.8131C7.47192 18.8091 7.47193 18.8052 7.47224 18.8013C7.47193 18.7838 7.47192 18.7665 7.47192 18.749C7.47192 18.5407 7.49193 18.3321 7.53208 18.124C7.49193 17.916 7.47192 17.7074 7.47192 17.499V15.0631C7.47192 15.0591 7.47193 15.0552 7.47224 15.0513C7.47193 15.0338 7.47192 15.0165 7.47192 14.999C7.47192 14.7907 7.49193 14.5821 7.53208 14.374C7.49193 14.166 7.47192 13.9574 7.47192 13.749V11.3131C7.47192 11.3091 7.47193 11.3052 7.47224 11.3013ZM7.78442 27.666C8.29208 28.8018 9.41989 29.8837 11.1802 30.7638C13.5741 31.9607 16.7025 32.5691 19.8438 32.5887V34.7782C16.7538 34.7588 13.6755 34.162 11.3199 32.9843C8.97443 31.8115 7.78442 30.2874 7.78442 28.749V27.666ZM7.78974 26.4279C8.30005 27.5593 9.42614 28.6368 11.1802 29.5138C13.6143 30.7309 16.8069 31.3412 20 31.3412C23.1932 31.3412 26.3858 30.7309 28.8199 29.5138C30.574 28.6368 31.7 27.5593 32.2104 26.4279C32.1216 27.9052 30.9346 29.3571 28.6802 30.4843C23.8894 32.8796 16.1107 32.8796 11.3199 30.4843C9.06552 29.3571 7.87849 27.9052 7.78974 26.4279ZM7.78442 23.916C8.29208 25.0518 9.41989 26.1337 11.1802 27.0138C13.5741 28.2107 16.7025 28.8191 19.8438 28.8387V31.0282C16.7538 31.0088 13.6755 30.412 11.3199 29.2343C8.97443 28.0615 7.78442 26.5374 7.78442 24.999V23.916ZM7.78974 22.6779C8.30005 23.8093 9.42614 24.8868 11.1802 25.7638C13.6143 26.9809 16.8069 27.5912 20 27.5912C23.1932 27.5912 26.3858 26.9809 28.8199 25.7638C30.574 24.8868 31.7 23.8093 32.2104 22.6779C32.1216 24.1552 30.9346 25.6071 28.6802 26.7343C23.8894 29.1296 16.1107 29.1296 11.3199 26.7343C9.06552 25.6071 7.87849 24.1552 7.78974 22.6779ZM7.78442 20.166C8.29208 21.3018 9.41989 22.3837 11.1802 23.2638C13.5741 24.4607 16.7025 25.0691 19.8438 25.0887V27.2782C16.7538 27.2588 13.6755 26.662 11.3199 25.4843C8.97443 24.3115 7.78442 22.7874 7.78442 21.249V20.166ZM7.78974 18.9279C8.30005 20.0593 9.42614 21.1368 11.1802 22.0138C13.6143 23.2309 16.8069 23.8412 20 23.8412C23.1932 23.8412 26.3858 23.2309 28.8199 22.0138C30.574 21.1368 31.7 20.0593 32.2104 18.9279C32.1216 20.4052 30.9346 21.8571 28.6802 22.9843C23.8894 25.3796 16.1107 25.3796 11.3199 22.9843C9.06552 21.8571 7.87849 20.4052 7.78974 18.9279ZM7.78442 16.416C8.29208 17.5518 9.41989 18.6337 11.1802 19.5138C13.5741 20.7107 16.7025 21.3191 19.8438 21.3387V23.5282C16.7538 23.5088 13.6755 22.912 11.3199 21.7343C8.97443 20.5615 7.78442 19.0374 7.78442 17.499V16.416ZM7.78974 15.1779C8.30005 16.3093 9.42614 17.3868 11.1802 18.2638C13.6143 19.4809 16.8069 20.0912 20 20.0912C23.1932 20.0912 26.3858 19.4809 28.8199 18.2638C30.574 17.3868 31.7 16.3093 32.2104 15.1779C32.1216 16.6552 30.9346 18.1071 28.6802 19.2343C23.8894 21.6296 16.1107 21.6296 11.3199 19.2343C9.06552 18.1071 7.87849 16.6552 7.78974 15.1779ZM7.78442 12.666V13.749C7.78442 15.2874 8.97443 16.8115 11.3199 17.9843C13.6755 19.162 16.7538 19.7588 19.8438 19.7782V17.5887C16.7025 17.5691 13.5741 16.9607 11.1802 15.7638C9.41989 14.8837 8.29208 13.8018 7.78442 12.666ZM11.3199 7.01383C16.1107 4.61836 23.8894 4.61836 28.6802 7.01383C31.0257 8.18649 32.2157 9.71055 32.2157 11.249C32.2157 12.7874 31.0257 14.3115 28.6802 15.4843C23.8894 17.8796 16.1107 17.8796 11.3199 15.4843C8.97443 14.3115 7.78442 12.7874 7.78442 11.249C7.78442 9.71055 8.97443 8.18649 11.3199 7.01383ZM10.1233 11.2237C10.1365 9.94071 11.1024 8.64821 13.0552 7.6718C16.8882 5.75524 23.1119 5.75524 26.9449 7.6718C28.8977 8.64821 29.8636 9.94071 29.8768 11.2237L29.8771 11.249C29.8771 11.3099 29.8749 11.3709 29.8707 11.4316C29.8672 11.4815 29.8622 11.5315 29.8558 11.5813C29.8555 11.5835 29.8552 11.5857 29.8549 11.5877C29.7005 12.7646 28.7393 13.9291 26.9449 14.8263C23.1119 16.7427 16.8882 16.7427 13.0552 14.8263C11.2608 13.9291 10.2996 12.7646 10.1452 11.5877C10.1449 11.5857 10.1446 11.5835 10.1443 11.5813C10.1379 11.5315 10.1329 11.4815 10.1294 11.4316C10.1252 11.3709 10.123 11.3099 10.123 11.249L10.1233 11.2237ZM15.3922 7.75321C14.6038 7.96821 13.8624 8.24258 13.1949 8.57633C11.5265 9.41055 10.6054 10.4702 10.4568 11.5624C10.6049 12.6529 11.5265 13.7126 13.1949 14.5468C16.1982 16.0484 20.6991 16.3493 24.3019 15.4496L23.0205 14.809C22.7938 14.8873 22.5597 14.9604 22.3188 15.0282C21.7113 15.1988 20.6657 15.3588 20.6499 15.3613L20.6454 15.3618L20.6439 15.3621L20.641 15.3624L20.6385 15.3626L20.6368 15.3627L20.6327 15.3629L20.6275 15.3631H20.6238L20.6196 15.3629L20.6154 15.3627L20.6111 15.3623C20.6094 15.3621 20.6079 15.362 20.6061 15.3618L20.6026 15.3613L20.5983 15.3605L20.5946 15.3598L20.5896 15.3587L20.586 15.3577L20.5819 15.3566L20.579 15.3559L20.5779 15.3554L20.5738 15.354L20.5697 15.3526L20.5658 15.351L20.5636 15.3499L20.5619 15.3493L20.5582 15.3476L20.5536 15.3452L20.5505 15.3435L20.5486 15.3426L20.5468 15.3415L20.544 15.3396L20.5393 15.3366L20.536 15.3345L20.5326 15.332L20.5297 15.3298C20.5283 15.3287 20.5271 15.3276 20.5257 15.3265L18.8925 13.9556C18.8572 13.9259 18.8368 13.882 18.8368 13.8359V13.2524C18.4224 13.3291 17.976 13.3612 17.4972 13.3482L17.4958 13.3481L17.4896 13.3479L17.4829 13.3477L17.4593 13.347L17.4541 13.3468H17.4505L17.4246 13.3459L17.4179 13.3456L17.4124 13.3454L17.4057 13.3451L17.3954 13.3448L17.3772 13.344L17.3705 13.3437L17.3682 13.3435C17.3561 13.3431 17.3441 13.3426 17.3319 13.342L17.3283 13.3418L17.3218 13.3415L17.3071 13.3407L17.2927 13.3399L17.2861 13.3396L17.2825 13.3395C17.2702 13.3387 17.2579 13.338 17.2455 13.3373L17.2182 13.3357L17.2069 13.3349L17.2011 13.3346L17.1965 13.3343C17.1838 13.3335 17.1711 13.3327 17.1585 13.3318C16.5151 13.2876 15.8807 13.1096 15.2557 12.7971C14.6941 12.5163 14.3204 12.1898 14.1263 11.8273C14.0347 11.656 13.9905 11.4812 13.9924 11.3032V10.7445C13.9846 10.607 14.005 10.4674 14.0544 10.3259L13.0552 9.82633C13.0022 9.79977 12.9688 9.74571 12.9688 9.68649V9.06149C12.9688 9.05977 12.9688 9.05805 12.969 9.05618L12.9691 9.05149L12.9696 9.04634L12.9697 9.04508L12.97 9.04149L12.9704 9.03962L12.9708 9.03649L12.9711 9.0343L12.9718 9.03164L12.9722 9.02899L12.9727 9.0268L12.9735 9.02368L12.974 9.02196L12.9749 9.01836L12.9752 9.01711L12.9765 9.01337L12.9782 9.00821L12.9801 9.00321L12.9822 8.99821L12.9841 8.99415L12.9863 8.98977L12.9886 8.9854L12.9894 8.98399L12.991 8.98118L12.9921 8.9793L12.9936 8.97696L12.9951 8.97493L12.9963 8.9729L12.998 8.97055L12.9993 8.96883L13.0013 8.96618L13.0022 8.96492L13.0046 8.96196L13.0054 8.96118L13.0085 8.95743L13.0118 8.95383L13.0155 8.95009L13.0193 8.94649L13.0227 8.94352L13.0265 8.94024L13.0275 8.93946L13.0304 8.93712L13.0318 8.93618L13.0344 8.93414L13.0363 8.9329L13.0386 8.93133L13.0408 8.92992L13.0429 8.92868L13.0455 8.92712L13.0472 8.92602L13.0502 8.9243L13.0516 8.92352L13.0552 8.9218L15.3922 7.75321ZM29.5433 11.5624C29.3947 10.4702 28.4736 9.41055 26.8052 8.57633C23.8019 7.07461 19.301 6.77383 15.6982 7.67336L16.9933 8.32102C17.1129 8.2818 17.2347 8.24414 17.3588 8.20805C17.9588 8.03352 18.5611 7.91664 19.166 7.85711C19.2135 7.85243 19.2607 7.86977 19.2938 7.9043L20.6221 9.28415L20.6233 9.2854L20.6258 9.28821L20.6268 9.28915L20.6296 9.29227L20.63 9.29305L20.6333 9.29696L20.6361 9.30102C20.6372 9.30242 20.6383 9.30399 20.6393 9.3054L20.6422 9.30993L20.645 9.31461L20.6477 9.3193L20.6494 9.3229L20.65 9.32415L20.6516 9.32743L20.6524 9.32899L20.6536 9.33211L20.6544 9.33399L20.6555 9.3368L20.6563 9.33883L20.6574 9.34165L20.6582 9.34399L20.659 9.34649L20.6597 9.34899L20.6604 9.35149L20.6611 9.35415L20.6616 9.35649L20.6622 9.35946L20.6627 9.36149L20.6633 9.36461L20.6636 9.36649L20.6641 9.36993L20.6644 9.37165L20.6649 9.37524L20.665 9.3768L20.6654 9.38055L20.6655 9.38196L20.6657 9.38586L20.6658 9.39118V9.39243V9.99055C20.8108 9.95587 20.9516 9.92477 21.0877 9.89696C21.6254 9.78727 22.2129 9.75211 22.8505 9.79227C23.4936 9.83274 24.128 10.0088 24.7533 10.3215C25.3155 10.6026 25.6872 10.9285 25.8772 11.2891C25.974 11.473 26.018 11.6616 26.0077 11.8546V12.4085V12.4118C26.0091 12.5376 25.9879 12.6657 25.9427 12.7957L26.9425 13.2956C26.9532 13.3007 26.9632 13.307 26.9722 13.3141L26.9729 13.3146L26.9768 13.3179L26.9793 13.3201L26.9813 13.322L26.9846 13.3251L26.9869 13.3274L26.989 13.3295L26.9921 13.3329L26.9943 13.3354L26.9958 13.3374L26.9988 13.3412L27.0008 13.3438L27.0022 13.3457C27.0176 13.3671 27.0275 13.3924 27.0304 13.4199L27.0305 13.4201C27.0307 13.422 27.0308 13.4237 27.031 13.4256L27.0311 13.4288L27.0313 13.4327V13.4365V14.0615C27.0313 14.1207 26.9979 14.1748 26.9449 14.2013L24.6079 15.3698C25.3963 15.1549 26.1377 14.8806 26.8052 14.5468C28.4736 13.7126 29.3952 12.6529 29.5433 11.5624ZM24.1799 14.7637L24.2188 14.7831V15.0587L23.1877 14.5432V14.2676L24.1799 14.7637ZM20.4699 14.6546V14.8716L19.1493 13.7631V13.546L20.4699 14.6546ZM16.9113 8.6293C16.9485 8.6479 16.9915 8.65102 17.0308 8.63774C17.1661 8.59258 17.3046 8.5493 17.4461 8.50805C18.0024 8.34633 18.5608 8.23555 19.1213 8.17586C19.1215 8.17586 20.1835 9.27899 20.1835 9.27899C19.2013 9.42243 18.4246 9.63868 17.8524 9.92477C17.5841 10.059 17.4022 10.1848 17.3029 10.296C17.189 10.4235 17.1639 10.5465 17.195 10.6541C17.2227 10.7499 17.3044 10.8477 17.461 10.926C17.6538 11.0224 17.9024 11.0484 18.2079 10.9921C18.4772 10.9424 18.8721 10.8363 19.3924 10.6734C19.3927 10.6734 19.3929 10.6732 19.393 10.6732C20.0443 10.466 20.6301 10.3093 21.1502 10.2031C21.6627 10.0985 22.223 10.0659 22.831 10.1041C23.4335 10.1421 24.0277 10.3081 24.6136 10.601C25.1033 10.8459 25.4352 11.1206 25.6007 11.4348C25.7521 11.7224 25.7172 12.0241 25.5102 12.3416C25.4543 12.4273 25.3849 12.5123 25.3022 12.5968C25.2674 12.6324 25.2516 12.6827 25.2599 12.732C25.2682 12.7812 25.2994 12.8234 25.3441 12.8457L26.5257 13.4365L24.375 14.5118L23.1013 13.8749C23.0635 13.856 23.0196 13.8532 22.9796 13.8673C22.7394 13.9518 22.491 14.0301 22.2341 14.1023C21.7291 14.2443 20.9141 14.3782 20.6724 14.4165C20.6722 14.4165 19.374 13.3265 19.374 13.3265C19.8247 13.2701 20.2719 13.1865 20.7157 13.0759C21.2846 12.9341 21.7647 12.7648 22.1566 12.5688C22.5254 12.3845 22.7393 12.2216 22.8125 12.1002C22.863 12.0165 22.8743 11.9366 22.8577 11.8631C22.8372 11.771 22.766 11.6766 22.6197 11.6035C22.4188 11.5031 22.1629 11.4751 21.8507 11.5309C21.5743 11.5801 21.1685 11.6856 20.6338 11.8477C19.9594 12.0506 19.3652 12.2035 18.8511 12.3065C18.3454 12.4077 17.7882 12.437 17.1799 12.3951C16.5765 12.3535 15.9816 12.1857 15.3954 11.8926C14.9051 11.6474 14.5711 11.3713 14.4019 11.0549C14.2474 10.7663 14.2821 10.4652 14.4919 10.1502C14.5475 10.0668 14.6161 9.98399 14.6972 9.90133C14.7322 9.86571 14.7482 9.8154 14.7399 9.76618C14.7316 9.7168 14.7004 9.67446 14.6557 9.65211L13.4744 9.06149L15.625 7.98618L16.9113 8.6293ZM14.3282 11.4938C14.3443 11.5565 14.369 11.6185 14.4019 11.6799C14.5711 11.9963 14.9051 12.2724 15.3954 12.5176C15.9816 12.8107 16.5765 12.9785 17.1799 13.0201C17.2349 13.0238 17.2896 13.027 17.3438 13.0296C17.3438 13.0296 17.3438 12.852 17.3438 12.7174C17.2824 12.7146 17.2207 12.711 17.1585 12.7068C16.5151 12.6626 15.8807 12.4846 15.2557 12.1721C14.849 11.9687 14.5408 11.7415 14.3282 11.4938ZM19.1588 10.4187C18.9604 10.4679 18.7746 10.5216 18.6016 10.5798C18.7646 10.5363 18.9502 10.4826 19.1588 10.4187ZM13.2813 9.58992L14.1893 10.044C14.2029 10.0216 14.2171 9.9993 14.2319 9.97696C14.2624 9.93133 14.296 9.88571 14.3329 9.84008L13.2813 9.3143V9.58992Z",
				fill: "#3D3D3D"
			})
		]
	});
})), zt = /* @__PURE__ */ we({ default: () => Bt }), Bt, Vt = Se((() => {
	Bt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M31.3273 11.651L14.7219 2.07446V3.69719L13.2259 2.83502V13.5023C13.1585 13.5337 13.0927 13.5666 13.0299 13.6039C12.1921 14.0985 11.7299 15.0757 11.7299 16.3563V16.936L11.6626 16.8972L9.03711 18.4512V22.892C9.03711 25.8237 11.1076 29.3934 13.6597 30.8667L14.4361 31.306C15.772 32.077 16.9763 32.1189 17.82 31.5645C17.9532 31.4883 18.1357 31.3837 18.3481 31.2627L18.3721 31.3179L29.8298 37.9254V36.3027L31.3258 37.1648V11.651H31.3273ZM13.2259 16.2845C13.1511 16.0425 13.178 15.8243 13.0763 15.6316V17.7339L13.2259 17.6906V16.2845Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.0616 24.2382L9.11182 18.472L11.7298 16.9359L21.8277 22.6887L19.0616 24.2382Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.135 24.2517V28.6717C19.135 30.0688 18.6638 31.0669 17.8964 31.572C18.4319 31.2656 19.8022 30.4812 20.4695 30.1001C21.3087 29.6205 21.8293 28.588 21.8293 27.1162V22.6978L19.1365 24.2532L19.135 24.2517Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M15.1108 25.595C15.1108 24.9092 14.6276 24.0754 14.0307 23.7317C13.4338 23.388 12.9506 23.6645 12.9506 24.3488C12.9506 24.7553 13.1226 25.214 13.3859 25.5935L13.1151 27.285L14.9462 28.3414L14.6754 26.3376C14.9387 26.2629 15.1108 26.0029 15.1108 25.595Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M13.8752 26.983L14.146 25.2915C13.8827 24.9135 13.7107 24.4547 13.7107 24.0468C13.7107 23.881 13.7391 23.739 13.7915 23.624C13.3098 23.4715 12.9492 23.7569 12.9492 24.3472C12.9492 24.7536 13.1213 25.2123 13.3846 25.5919L13.1138 27.2833L14.9449 28.3397L14.8372 27.5373L13.8737 26.9815L13.8752 26.983Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M13.1152 27.2833L13.8752 26.983L14.146 25.2915L13.3845 25.5918L13.1152 27.2833Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M15.8932 13.8893C14.8535 13.2751 13.8393 13.1974 13.0404 13.6696C12.2445 14.1388 11.8062 15.0682 11.8062 16.2845V18.7291C11.8062 18.7291 11.7688 18.9592 12.1443 19.0907C12.3388 19.1594 12.5572 19.1489 12.7547 19.0907C13.0165 19.013 13.1496 18.871 13.1526 18.7291V16.2845C13.1526 15.6046 13.3531 15.0966 13.7031 14.8934C14.0562 14.6887 14.6007 14.7679 15.1946 15.113C16.6816 15.9782 17.9397 18.1612 17.9397 19.8811V22.2778C17.9397 22.2778 17.9338 22.4736 18.1387 22.5767C18.411 22.7112 18.8284 22.7291 19.0917 22.5767C19.2338 22.4945 19.2966 22.3854 19.2846 22.2778L19.2891 19.8811C19.2891 17.6442 17.7976 15.0129 15.8932 13.8893Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.9061 36.3893L29.8942 12.4085L14.6471 3.6284V2.08337L31.2406 11.6389L31.2525 37.1424L29.9061 36.3893Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M31.2524 37.217C31.2389 37.217 31.2269 37.214 31.215 37.2066L30.1813 36.6104L30.2561 36.4804L31.1776 37.0108V11.6927L14.7217 2.20434V3.26524H14.5721V2.07434C14.5721 2.04744 14.5871 2.02353 14.6095 2.01009C14.632 1.99664 14.6619 1.99664 14.6843 2.01009L31.2898 11.5866C31.3122 11.6 31.3272 11.6239 31.3272 11.6508V37.1438C31.3272 37.1707 31.3122 37.1946 31.2898 37.2081C31.2778 37.214 31.2658 37.2185 31.2524 37.2185V37.217Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.9061 37.9986C29.8926 37.9986 29.8806 37.9956 29.8687 37.9881L18.4109 31.3807L18.4857 31.2507L29.8313 37.7939V12.4742L13.3754 2.9844V13.4246H13.2258V2.85589C13.2258 2.829 13.2408 2.80509 13.2632 2.79164C13.2857 2.77819 13.3156 2.77819 13.338 2.79164L29.9435 12.3681C29.9659 12.3816 29.9809 12.4055 29.9809 12.4324V37.9254C29.9809 37.9523 29.9659 37.9762 29.9435 37.9896C29.9315 37.9956 29.9195 38.0001 29.9061 38.0001V37.9986Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.7133 19.2011L19.6379 19.3302L27.3252 23.8062L27.4006 23.6771L19.7133 19.2011Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.3546 23.6358L23.2793 23.7649L27.3253 26.1207L27.4006 25.9916L23.3546 23.6358Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.7439 17.0246L19.6686 17.1537L27.3261 21.6124L27.4015 21.4833L19.7439 17.0246Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.1725 11.446L23.0972 11.5751L27.3262 14.0375L27.4015 13.9084L23.1725 11.446Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.5113 12.1023L19.4359 12.2314L27.326 16.8255L27.4014 16.6964L19.5113 12.1023Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.4978 14.1855L19.4225 14.3146L27.3262 18.9167L27.4015 18.7876L19.4978 14.1855Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.3874 28.5184L22.312 28.6475L27.3266 31.5673L27.4019 31.4382L22.3874 28.5184Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.3866 26.3267L22.3113 26.4557L27.3259 29.3756L27.4012 29.2465L22.3866 26.3267Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.7109 31.7558L17.6361 31.6258C17.6361 31.6258 19.5914 30.5066 20.4306 30.027C21.2833 29.5399 21.7531 28.5029 21.7531 27.1073V22.6888H21.9027V27.1073C21.9027 28.5582 21.406 29.6415 20.5054 30.157C19.6647 30.6366 17.7109 31.7558 17.7109 31.7558Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.5842 32.0156C15.9365 32.0156 15.2184 31.7989 14.4749 31.3701L13.6985 30.9308C11.1284 29.4485 9.03699 25.8414 9.03699 22.8918V18.4719C9.03699 18.445 9.05195 18.4211 9.07439 18.4077C9.09683 18.3942 9.12675 18.3942 9.14919 18.4077L19.1723 24.1799C19.1947 24.1933 19.2097 24.2172 19.2097 24.2441V28.664C19.2097 30.1045 18.7175 31.1818 17.8259 31.6973C17.4564 31.911 17.0375 32.0156 16.5842 32.0156ZM9.18659 18.6019V22.8918C9.18659 25.7951 11.2436 29.3424 13.7733 30.8008L14.5497 31.2401C15.7644 31.9409 16.9014 32.0574 17.7526 31.5673C18.5963 31.0802 19.0616 30.0492 19.0616 28.664V24.2874L9.18659 18.6019Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M13.4411 17.7727L13.3663 17.9022L17.6417 20.3647L17.7164 20.2352L13.4411 17.7727Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M11.6988 16.8106L9 18.408L9.07626 18.5365L11.7751 16.9391L11.6988 16.8106Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.0991 24.304L19.0243 24.1755L21.6049 22.6723L19.3758 21.3634L19.4521 21.2349L21.7904 22.6081C21.8128 22.6215 21.8278 22.6454 21.8278 22.6723C21.8278 22.6992 21.8143 22.7231 21.7904 22.7366L19.0991 24.304Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M14.9463 28.4145C14.9328 28.4145 14.9208 28.4115 14.9089 28.404L13.0778 27.3476C13.0509 27.3327 13.0359 27.3013 13.0419 27.2714L13.3082 25.6098C13.0344 25.2064 12.8773 24.7492 12.8773 24.3487C12.8773 23.9901 13.003 23.7211 13.2289 23.5896C13.4578 23.4582 13.7555 23.485 14.0696 23.6658C14.686 24.0215 15.1871 24.8866 15.1871 25.5934C15.1871 25.9879 15.0285 26.2778 14.7593 26.3868L15.0211 28.3293C15.0256 28.3577 15.0121 28.3861 14.9882 28.401C14.9762 28.41 14.9612 28.413 14.9463 28.413V28.4145ZM13.196 27.2445L14.8505 28.1993L14.6007 26.3465C14.5962 26.3091 14.6186 26.2748 14.6545 26.2643C14.8969 26.1971 15.0345 25.952 15.0345 25.5934C15.0345 24.9329 14.5663 24.1261 13.9918 23.7944C13.727 23.6419 13.4817 23.6136 13.3007 23.7181C13.1212 23.8212 13.0239 24.0454 13.0239 24.3472C13.0239 24.7208 13.181 25.169 13.4458 25.5486C13.4563 25.565 13.4608 25.5844 13.4578 25.6024L13.196 27.243V27.2445Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M14.9463 28.4146C14.9328 28.4146 14.9208 28.4116 14.9089 28.4041L13.0778 27.3477C13.0509 27.3328 13.0359 27.3014 13.0419 27.2715L13.3082 25.6099C13.0344 25.2065 12.8773 24.7492 12.8773 24.3488C12.8773 24.0231 12.9835 23.766 13.1765 23.6256C13.3456 23.5016 13.573 23.4762 13.8168 23.5539C13.8377 23.5598 13.8542 23.5748 13.8617 23.5942C13.8707 23.6136 13.8707 23.636 13.8617 23.6555C13.8123 23.7645 13.7869 23.8975 13.7869 24.0485C13.7869 24.422 13.944 24.8703 14.2087 25.2498C14.2192 25.2662 14.2237 25.2857 14.2207 25.3036L13.9589 26.9443L14.8775 27.4732C14.8969 27.4852 14.9104 27.5046 14.9149 27.5285L15.0226 28.3309C15.027 28.3593 15.0136 28.3877 14.9897 28.4026C14.9777 28.4116 14.9627 28.4146 14.9478 28.4146H14.9463ZM13.196 27.2446L14.8505 28.1994L14.7682 27.5853L13.8377 27.0489C13.8108 27.0339 13.7959 27.0025 13.8018 26.9727L14.0681 25.3111C13.7944 24.9076 13.6373 24.4504 13.6373 24.0499C13.6373 23.9125 13.6552 23.787 13.6926 23.6779C13.5251 23.6405 13.377 23.6644 13.2633 23.7496C13.1107 23.8617 13.0254 24.0753 13.0254 24.3518C13.0254 24.7253 13.1825 25.1736 13.4473 25.5531C13.4578 25.5696 13.4622 25.589 13.4593 25.6069L13.1975 27.2476L13.196 27.2446Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M14.1178 25.2219L13.3567 25.5222L13.4116 25.6611L14.1727 25.3609L14.1178 25.2219Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M13.8467 26.9153L13.0856 27.2155L13.1405 27.3545L13.9016 27.0543L13.8467 26.9153Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M18.6293 22.7591C18.4468 22.7591 18.2598 22.7202 18.1042 22.644C17.8573 22.5215 17.8633 22.2869 17.8633 22.2764V19.8827C17.8633 18.1867 16.6232 16.0321 15.1556 15.1789C14.5856 14.8471 14.068 14.7665 13.7389 14.9592C13.4128 15.149 13.2258 15.6316 13.2258 16.2846V18.7291C13.2213 18.9189 13.0522 19.0803 12.774 19.1625C12.5466 19.2297 12.3132 19.2297 12.1172 19.1625C11.6879 19.0115 11.7283 18.7306 11.7298 18.7187V16.2861C11.7298 15.0414 12.1801 14.0911 12.9999 13.6069C13.8242 13.1213 14.8639 13.199 15.929 13.8266C17.8543 14.9622 19.3623 17.6219 19.3623 19.8827L19.3578 22.2794C19.3728 22.4139 19.289 22.5499 19.1274 22.6425C18.9913 22.7202 18.8118 22.7606 18.6278 22.7606L18.6293 22.7591ZM14.1578 14.7082C14.4734 14.7082 14.8429 14.8232 15.2319 15.0504C16.7398 15.926 18.0129 18.1404 18.0129 19.8827V22.2794C18.0129 22.2869 18.0129 22.4318 18.1715 22.511C18.4393 22.644 18.8267 22.644 19.0541 22.5125C19.1633 22.4498 19.2187 22.3691 19.2112 22.2869L19.2142 19.8827C19.2142 17.6697 17.7392 15.0668 15.8542 13.9551C14.8384 13.3559 13.8526 13.2782 13.0762 13.7354C12.3042 14.1912 11.8794 15.0967 11.8794 16.2861V18.7306C11.8779 18.7486 11.8614 18.9144 12.1666 19.022C12.3327 19.0803 12.5331 19.0803 12.7306 19.022C12.94 18.9593 13.0717 18.8487 13.0747 18.7306V16.2876C13.0747 15.5793 13.2886 15.0489 13.6626 14.8322C13.8032 14.7515 13.9693 14.7112 14.1548 14.7112L14.1578 14.7082Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M15.9213 6.15445C16.1928 6.31754 16.4581 6.57087 16.6838 6.8824C16.9095 7.19393 17.0854 7.54968 17.1892 7.90464C17.2931 8.25961 17.3203 8.59786 17.2673 8.87662C17.2144 9.15538 17.0837 9.36212 16.8917 9.47071C16.6998 9.5793 16.4553 9.58485 16.1891 9.48667C15.9228 9.38849 15.6469 9.19099 15.3961 8.91913C15.1454 8.64727 14.931 8.31327 14.7802 7.95937C14.6294 7.60547 14.5489 7.24756 14.5489 6.9309L14.5503 6.86224C14.5657 6.45927 14.7168 6.16072 14.9723 6.02885C15.2277 5.89698 15.5677 5.94198 15.9213 6.15445Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.4703 10.3268C16.8343 10.5455 17.1833 10.924 17.4407 11.3789C17.6981 11.8338 17.8426 12.3279 17.8426 12.7525V13.0727C17.8426 13.2426 17.7848 13.3707 17.6819 13.4289C17.5789 13.4872 17.4393 13.4708 17.2937 13.3833L14.5489 11.7341C14.4034 11.6466 14.2637 11.4952 14.1608 11.3133C14.0578 11.1313 14 10.9337 14 10.7638V10.4436C14 10.019 14.1446 9.69861 14.402 9.553C14.6593 9.40739 15.0084 9.44845 15.3724 9.66715L16.4703 10.3268Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M15.9213 6.15445C16.1928 6.31754 16.4581 6.57087 16.6838 6.8824C16.9095 7.19393 17.0854 7.54968 17.1892 7.90464C17.2931 8.25961 17.3203 8.59786 17.2673 8.87662C17.2144 9.15538 17.0837 9.36212 16.8917 9.47071C16.6998 9.5793 16.4553 9.58485 16.1891 9.48667C15.9228 9.38849 15.6469 9.19099 15.3961 8.91913C15.1454 8.64727 14.931 8.31327 14.7802 7.95937C14.6294 7.60547 14.5489 7.24756 14.5489 6.9309L14.5503 6.86224C14.5657 6.45927 14.7168 6.16072 14.9723 6.02885C15.2277 5.89698 15.5677 5.94198 15.9213 6.15445Z",
				stroke: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.4703 10.3268C16.8343 10.5455 17.1833 10.924 17.4407 11.3789C17.6981 11.8338 17.8426 12.3279 17.8426 12.7525V13.0727C17.8426 13.2426 17.7848 13.3707 17.6819 13.4289C17.5789 13.4872 17.4393 13.4708 17.2937 13.3833L14.5489 11.7341C14.4034 11.6466 14.2637 11.4952 14.1608 11.3133C14.0578 11.1313 14 10.9337 14 10.7638V10.4436C14 10.019 14.1446 9.69861 14.402 9.553C14.6593 9.40739 15.0084 9.44845 15.3724 9.66715L16.4703 10.3268Z",
				stroke: "white"
			})
		]
	});
})), Ht = /* @__PURE__ */ we({ default: () => Ut }), Ut, Wt = Se((() => {
	Ut = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M35.7812 14.2188L15.1562 3.90625L13.9062 4.53125V14.5312L3.90625 9.53125L2.65625 10.1562V23.9062L3.90625 25.7812L24.5312 36.0938L25.7812 35.4688V25.4688L35.7812 30.4688L37.0312 29.8438V16.0938L37.6562 15.7812L36.4062 13.9062L35.7812 14.2188Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.0312 31.7188L18.2812 29.8438V30.4688L22.0312 32.3438V31.7188ZM22.0312 27.9688L18.9062 26.4062V27.6562L22.0312 29.2188V27.9688ZM17.6562 25.7812L14.5312 24.2188V25.4688L17.6562 27.0312V25.7812ZM10.7812 26.0938L5.78125 23.5938V24.2188L10.7812 26.7188V26.0938ZM13.2812 23.5938L10.1562 22.0312V23.2812L13.2812 24.8438V23.5938ZM34.5312 20.4688L16.4062 11.4062V13.9062L34.5312 22.9688V20.4688ZM8.90625 21.4062L5.78125 19.8438V21.0938L8.90625 22.6562V21.4062ZM4.53125 9.21875L3.90625 9.53125L24.5312 19.8438L25.1562 19.5312L4.53125 9.21875ZM15.7812 3.59375L15.1562 3.90625L35.7812 14.2188L36.4062 13.9062L15.7812 3.59375Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.8359 4.39158L15.7109 3.45408C15.7547 3.43205 15.8078 3.43205 15.8516 3.45408L36.475 13.7658C36.4969 13.7764 36.5156 13.7924 36.5313 13.813L36.5328 13.8152L36.5359 13.8185V13.8197L37.7859 15.6946L37.7875 15.6964L37.7891 15.6983L37.7906 15.7017L37.7938 15.7055L37.7953 15.7092L37.7969 15.7128L37.7984 15.7172L37.8 15.7203L37.8016 15.7224V15.7261L37.8031 15.728C37.8078 15.7407 37.8109 15.7541 37.8125 15.768V15.7722V15.7763V15.7813V29.5313C37.8125 29.5905 37.7797 29.6446 37.7266 29.671L35.8516 30.6085C35.8078 30.6305 35.7547 30.6305 35.7109 30.6085L26.5625 26.0341V35.1563C26.5625 35.2155 26.5297 35.2696 26.4766 35.296L24.6016 36.2335C24.5578 36.2555 24.5047 36.2555 24.4609 36.2335L3.83595 25.921C3.81251 25.9089 3.79063 25.8905 3.77657 25.868L2.52657 23.993C2.50938 23.9672 2.5 23.9371 2.5 23.9063V10.1563C2.5 10.0971 2.53282 10.043 2.58595 10.0166L4.46095 9.07909C4.5047 9.05705 4.5578 9.05705 4.60155 9.07909L13.75 13.6535V4.53127C13.75 4.47206 13.7828 4.41799 13.8359 4.39158ZM25.625 21.7661V35.3722L24.5312 35.9191L4.01251 25.66L2.8125 23.8589V10.2528L3.90625 9.70596L24.425 19.965L25.625 21.7661ZM36.875 19.9403L14.0625 8.53409V13.8097L25.225 19.3908C25.2469 19.4014 25.2656 19.4174 25.2813 19.438L25.2828 19.4402L25.2859 19.4435V19.4447L26.5359 21.3196L26.5375 21.3214L26.5391 21.3233L26.5406 21.3267L26.5438 21.3305L26.5453 21.3342L26.5469 21.3378L26.5484 21.3422L26.55 21.3453L26.5516 21.3474V21.3511L26.5531 21.353C26.5578 21.3657 26.5609 21.3791 26.5625 21.393V21.3972V21.4013V21.4063V25.6847L35.7812 30.2941L36.875 29.7472V19.9403ZM24.7594 19.9044L25.8344 21.5174L26.1781 21.3457L25.1031 19.7327L24.7594 19.9044ZM24.5312 19.6691L4.25625 9.53128L4.53125 9.39346C4.53125 9.39346 22.35 18.303 24.8063 19.5313L24.5312 19.6691ZM9.0625 16.4063C9.0625 16.3471 9.02968 16.293 8.97655 16.2666L5.85155 14.7041C5.80312 14.6799 5.74531 14.6824 5.69843 14.7108C5.65312 14.7394 5.625 14.7896 5.625 14.8438V17.3438C5.625 17.403 5.65782 17.4571 5.71095 17.4835L8.83595 19.046C8.88438 19.0702 8.94219 19.0677 8.98907 19.0392C9.03438 19.0107 9.0625 18.9605 9.0625 18.9063V16.4063ZM15.1562 4.08096L35.675 14.34L36.875 16.1411V16.466L14.0625 5.05971V4.62784L15.1562 4.08096ZM36.0094 14.2794L37.0844 15.8924L37.4281 15.7207L36.3531 14.1077L36.0094 14.2794ZM15.5062 3.90627L15.7812 3.76846L36.0563 13.9063L35.7812 14.0441L15.5062 3.90627Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Gt = /* @__PURE__ */ we({ default: () => Kt }), Kt, qt = Se((() => {
	Kt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24.5312 34.5312L19.5312 37.0312L20.7812 37.6562L25.7812 35.1562L24.5312 34.5312ZM26.3313 33.0812C25.9906 32.9125 25.7812 32.5484 25.7812 32.0312C25.7812 30.9969 26.6219 29.7359 27.6562 29.2188C28.1734 28.9594 28.6422 28.9359 28.9812 29.1063L30.2312 29.7313L29.3484 31.0547C29.1641 31.5344 28.85 32.0047 28.4641 32.3828L27.5813 33.7062L26.3313 33.0812ZM17.0312 23.2812L9.53125 27.0312L17.0312 30.7812L24.5312 27.0312L17.0312 23.2812ZM18.2812 13.9062L13.2812 16.4062L18.2812 18.9062L23.2812 16.4062L18.2812 13.9062Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.0312 30.7812L9.53125 27.0312V34.5312L17.0312 38.2812V30.7812ZM25.1562 21.0938V26.7188L21.875 25.0781V25.7031L24.5312 27.0312L23.2812 27.6562L25.1562 28.5938V34.8438L25.7812 35.1562V11.4062L28.9062 6.71875L28.2812 5.15625L20.7812 1.40625L18.9062 1.71875L15.7812 6.40625V15.1562L16.4062 14.8438V8.59375L25.1562 12.9688V19.2188L23.2812 18.2812V20.1562L25.1562 21.0938ZM28.0219 31.2766C28.2484 30.9375 28.5609 30.6406 28.9062 30.4688C29.5953 30.1234 30.1562 30.4047 30.1562 31.0938C30.1562 31.7828 29.5953 32.6234 28.9062 32.9688C28.5609 33.1406 28.2484 33.1578 28.0219 33.0437L27.5813 33.7062L26.3313 33.0812C25.9906 32.9125 25.7812 32.5484 25.7812 32.0312C25.7812 31.5141 25.9906 30.9406 26.3313 30.4313L28.0219 31.2766ZM18.2812 18.9062L13.2812 16.4062V26.4062L18.2812 28.9062V18.9062ZM16.4062 6.71875L25.1562 11.0938L28.1766 6.5625L27.8125 5.54688L20.625 1.95312L20.9375 2.73438L19.7391 2.96875L19.4266 2.1875L16.4062 6.71875Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.625 15.0594V6.4063C15.625 6.37505 15.6344 6.34535 15.6516 6.32035L18.7766 1.63285C18.8 1.59691 18.8375 1.57192 18.8812 1.56411L20.7562 1.25161C20.7875 1.24692 20.8219 1.25163 20.8516 1.26725L28.3516 5.01725C28.3859 5.03444 28.4125 5.06253 28.4266 5.09846L29.3016 7.28596C29.3203 7.33284 29.3156 7.38443 29.2891 7.42661L26.5625 11.7641V29.8813C26.8609 29.5485 27.2109 29.2673 27.5859 29.0798C28.1578 28.7938 28.6766 28.7782 29.0516 28.9657L30.3016 29.5907C30.6875 29.7844 30.9375 30.1922 30.9375 30.7813C30.9375 31.8672 30.0609 33.1907 28.9766 33.7328C28.4047 34.0188 27.8859 34.0344 27.5109 33.8469L26.5625 33.3735V34.8438C26.5625 34.9032 26.5297 34.9563 26.4766 34.9828L20.8516 37.7953C20.8078 37.8172 20.7547 37.8172 20.7109 37.7953L19.5312 37.2063L17.1016 38.4203L17.0984 38.4219L17.0938 38.425L17.0891 38.4266L17.0844 38.4282L17.0797 38.4297L17.075 38.4313L17.0703 38.4329L17.0656 38.4344H17.0609L17.0547 38.436H17.05L17.0453 38.4375H17.0406H17.0359H17.0312H17.0266H17.0203L17.0156 38.436H17.0109H17.0062L17.0016 38.4344L16.9969 38.4329H16.9922L16.9875 38.4313L16.9828 38.4297L16.9781 38.4282L16.9734 38.4266L16.9687 38.425L16.9641 38.4219L16.9609 38.4203L9.46095 34.6703C9.40782 34.6438 9.375 34.5907 9.375 34.5313V27.0313V27.0282V27.0235V27.0188L9.37656 27.0141V27.011V27.0063C9.37813 27.0032 9.37813 27 9.37813 26.9969L9.37969 26.9938L9.38126 26.9875L9.38282 26.9828L9.38438 26.9797L9.38593 26.975V26.9735C9.38593 26.9719 9.38749 26.9719 9.38749 26.9704L9.38906 26.9688L9.39062 26.9626L9.39219 26.9594L9.39531 26.9547L9.39688 26.9516L9.39844 26.9485L9.40001 26.9469L9.40157 26.9454L9.40313 26.9422L9.40624 26.9375L9.40781 26.9344L9.41093 26.9313L9.41406 26.9266L9.41875 26.9235L9.42032 26.9219C9.42032 26.9219 9.42032 26.9204 9.42188 26.9204L9.42345 26.9188L9.42499 26.9157L9.42812 26.9141L9.42968 26.9125L9.43438 26.9094L9.4375 26.9063L9.44063 26.9032C9.44376 26.9016 9.44687 26.9 9.45 26.8969L9.45469 26.8953L9.45782 26.8938L9.46095 26.8923L13.125 25.0594V16.4063V16.4032V16.3985V16.3938L13.1266 16.3891V16.386V16.3813C13.1281 16.3782 13.1281 16.3751 13.1281 16.3719L13.1297 16.3688L13.1313 16.3625L13.1328 16.3578L13.1344 16.3547L13.1359 16.35V16.3485C13.1359 16.3469 13.1375 16.3469 13.1375 16.3454L13.1391 16.3438L13.1406 16.3376L13.1422 16.3344L13.1453 16.3297L13.1469 16.3266L13.1484 16.3235L13.15 16.3219L13.1516 16.3204L13.1531 16.3172L13.1562 16.3125L13.1578 16.3094L13.1609 16.3063L13.1641 16.3016L13.1688 16.2985L13.1703 16.2969C13.1703 16.2969 13.1703 16.2954 13.1719 16.2954L13.1734 16.2938L13.175 16.2907L13.1781 16.2891L13.1797 16.2875L13.1844 16.2844L13.1875 16.2813L13.1906 16.2782C13.1938 16.2766 13.1969 16.275 13.2 16.2719L13.2047 16.2703L13.2078 16.2688L13.2109 16.2673L15.625 15.0594ZM12.3344 28.6079L9.6875 27.2844V34.4344L16.875 38.0282V30.8782L14.0625 29.4719V30.4688C14.0625 30.5235 14.0344 30.5735 13.9891 30.6016C13.9422 30.6297 13.8844 30.6328 13.8359 30.6078L12.5859 29.9828C12.5328 29.9563 12.5 29.9032 12.5 29.8438V28.6907L12.3344 28.6079ZM24.5312 34.7063L25.4313 35.1563L20.7812 37.4813L19.8812 37.0313L24.5312 34.7063ZM28.7313 6.70003L28.1578 5.26879L20.7562 1.5688L18.9984 1.86097L15.9375 6.45318V14.9032L16.25 14.7469V6.7188V6.71567V6.71098V6.70628L16.2516 6.70316V6.70159C16.2516 6.70003 16.2516 6.6985 16.2516 6.69537V6.69225L16.2531 6.68912V6.68599V6.68443C16.2547 6.6813 16.2547 6.67973 16.2563 6.67661L16.2578 6.67191V6.67035L16.2594 6.66722V6.66566C16.2594 6.66409 16.2609 6.66256 16.2609 6.65944L16.2641 6.65631L16.2656 6.65162V6.65005L16.2672 6.64693L16.2703 6.64223L16.2719 6.63911L16.2734 6.63598L16.275 6.63441L16.2766 6.63285L19.2969 2.1016L19.3 2.09847L19.3016 2.09378L19.3047 2.09065L19.3063 2.08756L19.3109 2.08443L19.3125 2.08131L19.3172 2.07661L19.3203 2.07349L19.3234 2.07036L19.3266 2.06723L19.3297 2.06567L19.3344 2.06254L19.3375 2.05941L19.3422 2.05628L19.3469 2.05315L19.3516 2.05006L19.3563 2.0485L19.3609 2.04694L19.3641 2.04537L19.3687 2.04224L19.3734 2.04068L19.3766 2.03912H19.3797L19.3859 2.03755L19.3906 2.03599H19.3922C19.3937 2.03443 19.3953 2.03442 19.3969 2.03442H19.3984L20.5953 1.80005L20.5984 1.79848H20.6016H20.6063H20.6094L20.6125 1.79692H20.6141C20.6297 1.79692 20.6437 1.79692 20.6578 1.80005L20.6625 1.80161H20.6656L20.6703 1.80318L20.6734 1.80474H20.675L20.6781 1.8063L20.6812 1.80787L20.6844 1.80943H20.6875L20.6906 1.811L20.6953 1.81413L27.8828 5.40788L27.8859 5.40944L27.8891 5.41096L27.8922 5.41253L27.8953 5.41409L27.8984 5.41722L27.9016 5.41879L27.9047 5.42035L27.9078 5.42348L27.9109 5.42504L27.9141 5.42817L27.9156 5.42973L27.9188 5.43286L27.9219 5.43443L27.925 5.43755L27.9266 5.44068L27.9297 5.44381L27.9313 5.44537L27.9344 5.4485L27.9359 5.45159L27.9391 5.45472L27.9406 5.45785L27.9422 5.46098L27.9453 5.4641L27.9469 5.46723L27.9484 5.47036L27.95 5.47349L27.9516 5.47662L27.9531 5.47974L27.9547 5.48444L27.9563 5.48756L27.9578 5.49065L27.9594 5.49378L28.325 6.50941C28.3406 6.55628 28.3344 6.60787 28.3063 6.64849L25.3125 11.1407V34.7469L25.625 34.9032V11.4063C25.625 11.3938 25.6266 11.3813 25.6297 11.3688C25.6344 11.3516 25.6406 11.3344 25.6516 11.3204L28.7313 6.70003ZM24.6875 34.4344L25 34.5907V28.6907L24.6875 28.5344V34.4344ZM29.4203 29.5001L28.9125 29.2453C28.6078 29.0938 28.1891 29.1266 27.7266 29.3578C27.2828 29.5797 26.875 29.9454 26.5625 30.3688V33.0235L26.9687 33.2266C26.9078 33.061 26.875 32.8704 26.875 32.6563C26.875 31.5704 27.7516 30.2469 28.8359 29.7048C29.0391 29.6032 29.2344 29.536 29.4203 29.5001ZM28.9766 30.6078C29.2672 30.4625 29.5297 30.4375 29.7203 30.5328C29.9 30.6235 30 30.8204 30 31.0938C30 31.7329 29.4766 32.5094 28.8359 32.8298C28.5453 32.9751 28.2828 33.0001 28.0922 32.9047C27.9125 32.8141 27.8125 32.6172 27.8125 32.3438C27.8125 31.7047 28.3359 30.9282 28.9766 30.6078ZM18.3516 29.0453L18.3484 29.0469L18.3438 29.05L18.3391 29.0516L18.3344 29.0532L18.3297 29.0547L18.325 29.0563L18.3203 29.0579L18.3156 29.0594H18.3109L18.3047 29.061H18.3L18.2953 29.0625H18.2906H18.2859H18.2812H18.2766H18.2703L18.2656 29.061H18.2609H18.2562L18.2516 29.0594L18.2469 29.0579H18.2422L18.2375 29.0563L18.2328 29.0547L18.2281 29.0532L18.2234 29.0516L18.2187 29.05L18.2141 29.0469L18.2109 29.0453L16.4062 28.1438L14.2562 29.2188L17.0312 30.6063L24.1813 27.0313L23.2812 26.5813L18.3516 29.0453ZM13.3 29.0907L13.75 29.3157V30.2157L12.8125 29.7469V28.8469L13.3 29.0907ZM13.0062 28.5938L13.9062 29.0438L16.0563 27.9688L15.1562 27.5188L13.0062 28.5938ZM15 17.4407L13.4375 16.6594V26.3094L18.125 28.6532V19.0032L16.5625 18.2219V19.2188C16.5625 19.2735 16.5344 19.3235 16.4891 19.3516C16.4422 19.3797 16.3844 19.3828 16.3359 19.3578L15.0859 18.7328C15.0328 18.7063 15 18.6532 15 18.5938V17.4407ZM13.125 25.4094L9.88125 27.0313L12.6562 28.4188L14.8063 27.3438L13.2109 26.5453C13.1578 26.5188 13.125 26.4657 13.125 26.4063V25.4094ZM24.6875 28.1844L25 28.3407V26.8157L23.4375 26.0344V26.3094L24.6016 26.8923L24.6047 26.8938L24.6094 26.8953L24.6125 26.8969C24.6156 26.9 24.6187 26.9016 24.6219 26.9032L24.625 26.9063L24.6266 26.9079L24.6313 26.911L24.6344 26.9141L24.6375 26.9172L24.6391 26.9188L24.6406 26.9204C24.6422 26.9204 24.6422 26.9219 24.6422 26.9219L24.6469 26.9251L24.65 26.9297L24.6531 26.9329L24.6563 26.936L24.6578 26.9391L24.6594 26.9407V26.9422L24.6609 26.9454L24.6625 26.9469L24.6656 26.9516L24.6688 26.9563L24.6703 26.9594L24.6719 26.9641L24.6734 26.9688L24.675 26.9704C24.675 26.9719 24.6766 26.9719 24.6766 26.9735V26.975L24.6781 26.9782L24.6797 26.9813L24.6812 26.986L24.6828 26.9907V26.9954L24.6844 26.9969C24.6844 27 24.6844 27.0032 24.6859 27.0063V27.0094V27.0141L24.6875 27.0188V27.0235V27.0266V27.0282V27.0313V28.1844ZM23.4375 25.6844L25 26.4657V21.1907L23.4375 20.4094V25.6844ZM25 19.3157V20.8407L23.4375 20.0594V18.5344L25 19.3157ZM23.4375 18.1844L25 18.9657V13.0657L17.1875 9.15944V14.2782L18.2109 13.7673C18.2547 13.7454 18.3078 13.7454 18.3516 13.7673L23.3516 16.2673L23.3547 16.2688L23.3594 16.2703L23.3625 16.2719C23.3656 16.275 23.3687 16.2766 23.3719 16.2782L23.375 16.2813L23.3766 16.2829L23.3813 16.286L23.3844 16.2891L23.3875 16.2922L23.3891 16.2938L23.3906 16.2954C23.3922 16.2954 23.3922 16.2969 23.3922 16.2969L23.3969 16.3001L23.4 16.3047L23.4031 16.3079L23.4063 16.311L23.4078 16.3141L23.4094 16.3157V16.3172L23.4109 16.3204L23.4125 16.3219L23.4156 16.3266L23.4188 16.3313L23.4203 16.3344L23.4219 16.3391L23.4234 16.3438L23.425 16.3454C23.425 16.3469 23.4266 16.3469 23.4266 16.3485V16.35L23.4281 16.3532L23.4297 16.3563L23.4312 16.361L23.4328 16.3657V16.3704L23.4344 16.3719C23.4344 16.3751 23.4344 16.3782 23.4359 16.3813V16.3844V16.3891L23.4375 16.3938V16.3985V16.4016V16.4032V16.4063V18.1844ZM15.3125 17.5969L16.25 18.0657V18.9657L15.3125 18.4969V17.5969ZM21.4062 15.6438L22.9313 16.4063L18.2812 18.7313L16.7562 17.9688L21.4062 15.6438ZM15.5062 17.3438L20.1562 15.0188L21.0563 15.4688L16.4062 17.7938L15.9562 17.5688L15.5062 17.3438ZM17.1016 14.6703L15.8516 15.2953L13.6312 16.4063L15.1562 17.1688L19.8063 14.8438L18.2812 14.0813L17.1016 14.6703ZM16.5625 6.97194L25 11.1907V12.7157L16.5625 8.4969V6.97194ZM27.9594 6.42037L20.9156 2.89849L19.8328 3.10941L17.2594 6.97038L25.1031 10.8922L28.0031 6.54069L27.9594 6.42037ZM27.6859 5.65942L27.8078 5.99538L21.0609 2.62193L20.9219 2.27662L27.6859 5.65942ZM20.1547 2.20475L20.5281 2.13128L20.7219 2.61723L19.8359 2.79069L19.6422 2.30473L20.1547 2.20475Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Jt = /* @__PURE__ */ we({ default: () => Yt }), Yt, Xt = Se((() => {
	Yt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.4688 19.375V31.875L14.2188 33.75V21.25L13.9062 21.0938V16.0938L10.1562 14.2188V19.2188L10.4688 19.375ZM20.1562 19.2188L3.90625 11.0938L10.1562 7.96875V7.34375H10.1609V7.33906C10.1609 5.95625 11.2844 4.83437 12.6656 4.83437C14.2188 4.83437 15.3734 5.35938 15.3734 5.35938L20.1562 2.96875L24.9391 5.35938C24.9391 5.35938 26.2641 4.83437 27.6469 4.83437C29.0281 4.83437 30.1516 5.95625 30.1516 7.33906V7.34375H30.1562V7.96875L36.4062 11.0938L20.1562 19.2188Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.2188 21.25V33.75L20.1562 36.7188V19.2188L13.9062 16.0938V21.0938L14.2188 21.25ZM26.4062 21.0938V16.0938L30.1562 14.2188V19.2188L29.8438 19.375V31.875L26.0938 33.75V21.25L26.4062 21.0938ZM3.90625 16.0938L4.53125 16.4063V28.9063L10.4688 31.875V19.375L10.1562 19.2188V14.2188L3.90625 11.0938V16.0938ZM20.1562 12.3438V9.84378C20.1562 9.84378 20.9906 8.1719 22.6562 6.76097V9.26097C20.9906 10.6719 20.1562 12.3438 20.1562 12.3438ZM29.8172 8.58908C30.0297 8.95627 30.1516 9.3844 30.1516 9.83908C30.1516 10.7625 29.65 11.5688 28.9062 12.0031V9.50314C29.2844 9.28283 29.5984 8.96721 29.8172 8.58908ZM11.4062 7.67346V5.17346C10.6625 5.60784 10.1609 6.41565 10.1609 7.33908C10.1609 7.79377 10.2828 8.22033 10.4953 8.58908C10.7141 8.21096 11.0281 7.89377 11.4062 7.67346Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.3656 5.18907L20.0859 2.8297C20.1297 2.80782 20.1828 2.80782 20.2266 2.8297L24.9469 5.18907C25.7484 4.87345 26.6484 4.67813 27.6469 4.67813H27.6547C29.1078 4.68282 30.2891 5.8547 30.3078 7.30314C30.3109 7.31564 30.3125 7.3297 30.3125 7.34376V7.87189L36.475 10.9547L36.4797 10.9563L36.4844 10.9578L36.4859 10.9594C36.4984 10.9656 36.5094 10.975 36.5187 10.986L36.5234 10.9906L36.5266 10.9938L36.5281 10.9969L36.5328 11.0016L36.5344 11.0047L36.5359 11.0063L36.5375 11.0094L36.5422 11.0156L36.5438 11.0203L36.5453 11.0235L36.5484 11.0281V11.0297C36.5547 11.0422 36.5594 11.0563 36.5609 11.0719V11.075C36.5609 11.0766 36.5625 11.0781 36.5625 11.0813V11.0875V11.0922V11.0938V16.0938C36.5625 16.1531 36.5297 16.2078 36.4766 16.2328L35.9375 16.5031V28.9063C35.9375 28.9656 35.9047 29.0203 35.8516 29.0453L20.2266 36.8578C20.2203 36.861 20.2141 36.8641 20.2078 36.8656L20.2016 36.8688L20.1969 36.8703H20.1922L20.1906 36.8719C20.1828 36.8734 20.1766 36.8735 20.1703 36.875H20.1656H20.1594H20.1531H20.1469H20.1422C20.1359 36.8735 20.1297 36.8734 20.1219 36.8719L20.1172 36.8703L20.1125 36.8688L20.1063 36.8672L20.1047 36.8656C20.0984 36.8641 20.0922 36.861 20.0859 36.8578L4.46095 29.0453C4.40782 29.0203 4.375 28.9656 4.375 28.9063V16.5031L3.83595 16.2328C3.78282 16.2078 3.75 16.1531 3.75 16.0938V11.0938V11.0875V11.0813C3.75 11.0781 3.75156 11.0766 3.75156 11.075V11.0719C3.75313 11.0563 3.75781 11.0422 3.76406 11.0297L3.76562 11.025L3.76719 11.0219L3.77031 11.0172L3.77344 11.0125L3.77501 11.0094L3.77657 11.0063L3.77968 11.0016L3.78281 10.9969L3.78593 10.9938L3.79063 10.9891L3.79375 10.986C3.80313 10.975 3.81406 10.9656 3.82812 10.9594L3.83125 10.9563H3.83282C3.83438 10.9547 3.83595 10.9547 3.83751 10.9547L10 7.87189V7.34376C10 7.3297 10.0016 7.31564 10.0047 7.30314C10.0234 5.85158 11.2094 4.67813 12.6656 4.67813H12.6813C13.6719 4.67969 14.5672 4.87501 15.3656 5.18907ZM20 24.3156L14.375 21.5031V33.6531L20 36.4656V24.3156ZM29.6875 19.6281L26.25 21.3469V33.4969L29.6875 31.7781V19.6281ZM10.625 31.7781L14.0625 33.4969V21.3469L10.625 19.6281V31.7781ZM4.6875 28.8094L10.3125 31.6219V19.4719L9.49219 19.061L4.6875 16.6594V28.8094ZM14.0625 16.3469V20.9969L20 23.9656V19.3156L14.0625 16.3469ZM26.5625 20.8406L30 19.1219V14.4719L26.5625 16.1906V20.8406ZM10.3125 19.1219L13.75 20.8406V16.1906L10.3125 14.4719V19.1219ZM18.1266 14.1594L14.2562 16.0938L20.1562 19.0438L26.0563 16.0938L22.1875 14.1594L22.1859 17.0313C22.1859 17.0844 22.1578 17.1344 22.1125 17.1641C22.0656 17.1922 22.0078 17.1953 21.9594 17.1703L20.1562 16.2688L18.3516 17.1703C18.3031 17.1953 18.2453 17.1922 18.1984 17.1641C18.1531 17.1344 18.125 17.0844 18.125 17.0313L18.1266 14.1594ZM4.0625 15.9969L10 18.9656V14.3156L4.0625 11.3469V15.9969ZM19.5328 12.5H21.875L21.8734 16.7781L20.2266 15.9547C20.1828 15.9328 20.1313 15.9328 20.0859 15.9547L18.4375 16.7781L18.4391 12.5H19.5328ZM26.3688 12.5H22.1875V13.8094L26.4062 15.9188L29.8063 14.2188L26.3688 12.5ZM13.9437 12.5L10.5062 14.2188L13.9062 15.9188L18.1266 13.8094V12.5H13.9437ZM10 8.22189L4.25625 11.0938L10.1562 14.0438L13.2438 12.5H12.6656C12.1781 12.5 11.7203 12.3688 11.3266 12.1375L11.3187 12.1328L11.3141 12.1313L11.3062 12.1266C10.6031 11.7078 10.1094 10.9735 10.0203 10.1188C10.0188 10.1141 10.0187 10.1078 10.0187 10.1031V10.1016C10.0172 10.0969 10.0172 10.0906 10.0172 10.086H10.0156C10.0156 10.0797 10.0156 10.075 10.0156 10.0688C10.0141 10.0625 10.0141 10.0578 10.0141 10.0531V10.0516C10.0125 10.0469 10.0125 10.0406 10.0125 10.0359V10.0344C10.0125 10.0297 10.0109 10.0235 10.0109 10.0188V10.0172C10.0109 10.0125 10.0109 10.0078 10.0094 10.0016V10C10.0094 9.99533 10.0094 9.99064 10.0094 9.98439V9.98283C10.0094 9.97814 10.0078 9.97346 10.0078 9.96877V9.96721C10.0078 9.96096 10.0078 9.95626 10.0078 9.95157V9.94846C10.0078 9.94377 10.0063 9.93907 10.0063 9.93438V9.92502V9.91563V9.90783V9.89845V9.89065V9.88439C10.0016 9.87189 10 9.85783 10 9.84376V8.22189ZM30.3125 8.22189V9.84376C30.3125 9.85783 30.3109 9.87189 30.3078 9.88439C30.2828 11.3328 29.1 12.5 27.6469 12.5H27.0687L30.1562 14.0438L36.0563 11.0938L30.3125 8.22189ZM11.5625 9.76095C11.8984 9.91407 12.2734 10 12.6656 10H18.2219C19.1047 10.8969 19.6609 11.7844 19.8922 12.1875H18.2828H18.2812C16.1516 12.1875 12.6656 12.1875 12.6656 12.1875C12.2672 12.1875 11.8922 12.0875 11.5625 11.9125V9.76095ZM27.6469 12.1875H20.4203C20.6516 11.7844 21.2078 10.8969 22.0906 10H27.6469C28.5312 10 29.3156 9.5672 29.8 8.90157C29.925 9.18907 29.9953 9.50626 29.9953 9.83907C29.9953 11.1344 28.9422 12.1875 27.6469 12.1875ZM28.9062 5.35627C28.5422 5.12502 28.1094 4.99063 27.6469 4.99063C22.9797 4.99063 20.5344 9.45783 20.3125 9.88126V11.7578C20.6141 11.2703 21.1484 10.5031 21.9141 9.73283C21.9219 9.72658 21.9297 9.72033 21.9375 9.71408C23.2094 8.44377 25.1141 7.17813 27.6469 7.17813C28.1016 7.17813 28.5312 7.2922 28.9062 7.49532V5.35627ZM10.7719 8.45157C10.7391 8.49532 10.7078 8.5422 10.6781 8.58907L10.6828 8.59689L10.6875 8.60469L10.6922 8.61251L10.6984 8.62033L10.7031 8.62813L10.7094 8.63595L10.7141 8.64376L10.7187 8.65158L10.725 8.6594L10.7297 8.6672L10.7359 8.67502L10.7406 8.68282L10.7469 8.69064L10.7516 8.69846L10.7578 8.70626L10.7625 8.71408L10.7688 8.72188L10.7734 8.7297L10.7797 8.73752L10.7859 8.74532L10.7906 8.75158L10.7969 8.7594L10.8016 8.7672L10.8078 8.77502L10.8141 8.78126L10.8172 8.78595C11.2469 9.33439 11.9156 9.68751 12.6656 9.68751H13.2438L10.7719 8.45157ZM27.6469 7.49063C25.3719 7.49063 23.625 8.55158 22.4063 9.68751H26.3688L29.3328 8.20627C28.9078 7.76564 28.3109 7.49063 27.6516 7.49063H27.6469ZM17.5344 9.35939C16.3422 8.35471 14.7188 7.49063 12.6656 7.49063C12.0047 7.49063 11.4063 7.76408 10.9797 8.20627L13.9437 9.68751H17.9016C17.7906 9.58439 17.675 9.48127 17.5547 9.37971C17.5484 9.37346 17.5406 9.36564 17.5344 9.35939ZM29.5406 8.45157L27.0687 9.68751H27.6469C28.4828 9.68751 29.2188 9.24845 29.6344 8.58907C29.6047 8.54063 29.5734 8.49532 29.5406 8.45157ZM20.2625 9.34064L20.1 9.4219C20.1203 9.45627 20.1391 9.48908 20.1562 9.51877C20.1875 9.46721 20.2219 9.40627 20.2625 9.34064ZM15.7438 5.35001C16.5016 5.69533 17.1641 6.14533 17.7328 6.62345C17.7422 6.6297 17.75 6.63439 17.7578 6.64064C18.6406 7.39064 19.2938 8.21095 19.7156 8.82345L20.1562 9.04377L20.6 8.82188C21.2969 7.81251 22.6172 6.24377 24.5609 5.35314L24.5687 5.35001L20.1562 3.14376L15.7438 5.35001ZM12.6656 4.99063H12.6797C14.7063 4.99376 16.3125 5.84063 17.5 6.8297V8.9344C16.2859 7.97346 14.6781 7.18126 12.6781 7.17813H12.6656C11.7844 7.17813 11.0031 7.60783 10.5187 8.26877L10.5125 8.27657C10.3875 7.98907 10.3172 7.67189 10.3172 7.33907C10.3172 6.0422 11.3703 4.99063 12.6656 4.99063Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Zt = /* @__PURE__ */ we({ default: () => Qt }), Qt, $t = Se((() => {
	Qt = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [/* @__PURE__ */ h("g", {
			clipPath: "url(#clip0_2395_58585)",
			children: [
				/* @__PURE__ */ m("path", {
					d: "M20.8959 37.0286L24.3459 38.857L24.3512 37.0074L20.8959 35.1765V37.0286Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M12.9837 13.7556C12.9837 13.7556 6.21092 16.0609 7.50135 11.1403C6.84951 11.6491 6.46265 12.2532 6.46265 12.9951C6.46265 17.8018 17.1067 14.1584 20.8746 12.9951C17.0749 11.6968 12.9837 13.7556 12.9837 13.7556Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M21.7464 11.7634C21.643 12.0283 21.4814 12.4311 21.2615 12.8762C21.7103 12.7338 22.1691 12.6249 22.634 12.5503C22.634 12.4549 22.634 12.3516 22.634 12.2456C22.6368 10.8349 22.5206 9.4264 22.2869 8.03516C22.3081 9.36003 22.2392 10.5392 21.7464 11.7634Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M11.7012 9.68854L11.5793 9.73888C12.581 10.7749 12.6551 14.0156 13.0023 14.8476C14.555 13.0908 12.997 10.5391 11.7012 9.68854Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M23.1985 31.4086C22.8798 31.9348 22.6489 32.5093 22.5149 33.1097C23.2384 31.8813 24.1303 30.7602 25.1646 29.779C26.0656 28.8807 27.0592 28.0779 27.9866 27.2088C29.0465 26.2151 30.8669 25.089 31.5479 23.8303C29.7911 25.5739 25.4482 27.8261 23.1985 31.4086Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M31.479 23.8855C32.3879 23.6868 33.0079 23.8008 33.6359 23.8299C34.7246 23.9443 35.7983 24.1725 36.8395 24.5109C35.708 23.1383 32.6899 23.0191 31.479 23.8855Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M36.8395 24.5109C36.8733 24.5395 36.8733 24.5395 36.8395 24.5109V24.5109Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M25.4851 29.0289C25.7283 28.9594 25.9751 28.9027 26.2244 28.8593H26.1687C25.6361 28.854 25.1539 29.1296 25.4851 29.0289Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M26.2139 28.8593C26.693 28.9139 27.1676 29.0025 27.6341 29.1243C28.694 29.3151 30.2998 29.2621 31.2193 29.8503C30.3766 29.3654 29.8228 28.8752 28.8106 28.7719C27.9451 28.6832 27.0715 28.7126 26.2139 28.8593Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M16.8417 30.9102C17.4379 31.0718 17.679 31.5064 18.3812 31.8508C18.9986 32.1556 19.9869 31.9489 20.4003 32.5477C20.0717 31.7926 17.149 30.2875 16.8417 30.9102Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M22.332 26.045C22.3108 26.1272 22.332 26.212 22.332 26.2888C21.8922 26.2649 21.8339 26.3471 21.818 26.4531C22.2711 26.5167 25.3581 27.3593 25.9808 27.3195C25.0613 26.5697 23.5032 25.9523 22.332 26.045Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M27.3666 21.84C27.9416 22.468 30.0508 22.831 32.2183 22.7859C31.6207 22.4691 31.0007 22.1964 30.3634 21.9698C29.3115 21.6519 28.3973 21.8903 27.3666 21.84Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M9.91272 30.7379C10.1591 31.4295 13.5588 31.9515 14.3352 31.8349C13.2302 31.1645 11.1104 30.2636 9.91272 30.7379Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M16.9398 25.2636C18.1163 25.8492 19.5313 25.6346 20.933 26.2122C20.0533 25.2451 18.1084 25.2636 16.9398 25.2636Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M22.5891 20.645C23.914 20.3801 24.7089 20.4754 26.8632 20.9259C25.9092 20.4516 23.3946 19.9773 22.5891 20.645Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M8.21688 26.5752L7.9519 26.7713C8.52123 27.0644 9.04149 27.4444 9.49406 27.8974C9.95246 28.3585 10.0744 28.8805 10.4135 29.2753C10.5116 28.1359 9.44636 26.8614 8.21688 26.5752Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M14.7936 21.6176C14.5949 21.7739 14.3988 21.9329 14.1974 22.0893C15.1645 22.3728 15.8667 23.8302 16.6564 24.1402C16.8153 23.2843 15.8058 22.0124 14.7936 21.6176Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M22.3215 19.5478C21.9854 19.0332 21.5392 18.5997 21.0152 18.2785C20.632 18.0442 20.1864 17.9324 19.738 17.9579C19.5903 17.9598 19.4458 18.001 19.3193 18.0772C19.7698 18.1302 20.1699 18.4322 20.5541 18.6575C20.8518 18.8237 21.1254 19.0296 21.3676 19.2695C21.5855 19.4285 21.7893 19.6058 21.977 19.7995C22.1255 20.0376 22.254 20.2875 22.3613 20.5467C22.3613 20.5759 22.393 20.6845 22.4195 20.7004C22.5149 20.7614 22.7614 20.56 22.7958 20.4831C22.7094 20.4608 22.62 20.4519 22.5308 20.4566C22.7004 20.2049 22.454 19.7704 22.3215 19.5478Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M2.35815 28.2337L19.5524 37.794L19.5577 35.9445L2.36345 26.3842L2.35815 28.2337Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M19.5524 37.7941L37.6634 27.2375L37.6687 25.3959L19.5577 35.9525L19.5524 37.7941Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M2.52784 15.9735L2.50134 26.4532L19.5578 35.9446L19.5843 26.3684L11.2429 12.9766L2.52784 15.9735Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M19.6345 36.0774L19.5206 36.0138L2.42175 26.4986V26.4535L2.4509 15.9181L11.2772 12.8842L11.309 12.9372L19.6637 26.3449V26.3687L19.6345 36.0774ZM2.58074 26.4058L19.4808 35.8124L19.5073 26.3899L11.2083 13.0723L2.60458 16.0294L2.58074 26.4058Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M19.6372 36.0797L2.41382 26.5009L2.44032 15.9178L11.2693 12.8812L19.6558 26.3445V26.3684L19.6372 36.0797ZM2.58075 26.4055L19.4782 35.8068L19.5047 26.3896L11.2083 13.0746L2.60725 16.0317L2.58075 26.4055Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M19.5579 35.9448L37.5894 25.4651L37.6159 16.0214L19.5844 26.3686L19.5579 35.9448Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M19.4783 36.0801L19.5074 26.3237L19.5445 26.2999L37.6953 15.8864L37.6662 25.5102L37.6291 25.5341L19.4783 36.0801ZM19.6638 26.4138L19.6373 35.8072L37.5098 25.4201L37.5363 16.146L19.6638 26.4138Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M19.4783 36.0826L19.5048 26.3209L37.6953 15.8835L37.6688 25.5127L19.4783 36.0826ZM19.6638 26.4136L19.6373 35.8043L37.5098 25.42L37.5337 16.1618L19.6638 26.4136Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M20.8959 35.1657L24.3485 37.0178L24.3538 26.2811L20.8959 24.4236V35.1657Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M24.4279 37.1504L20.819 35.2108V24.2938L24.4332 26.2334L24.4279 37.1504ZM20.9833 35.118L24.2795 36.8881V26.3262L20.978 24.5535L20.9833 35.118Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M24.4307 37.1529L20.8164 35.2133V24.2884L24.4333 26.2333L24.4307 37.1529ZM20.986 35.1179L24.2796 36.8853V26.3287L20.9807 24.556L20.986 35.1179Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M0.140503 15.4914L11.2191 11.6599L29.2507 1.1828L18.5006 4.8474L0.140503 15.4914Z",
					fill: "#DCDCDC"
				}),
				/* @__PURE__ */ m("path", {
					d: "M0.16683 15.5734L0.100586 15.4329L18.4634 4.78888L29.224 1.11633L29.2876 1.25677L11.2693 11.7365L0.16683 15.5734ZM28.5192 1.52969L18.5296 4.92137L0.882262 15.152L11.1924 11.5987L28.5192 1.52969Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M0.16683 15.5732L0.100586 15.4275L18.4607 4.78344L29.224 1.10559L29.2902 1.25133L11.2587 11.7284L0.16683 15.5732ZM0.898164 15.1493L11.1924 11.5986L28.5112 1.52955L18.5296 4.92388L0.898164 15.1493Z",
					fill: "#DCDCDC"
				}),
				/* @__PURE__ */ m("path", {
					d: "M0.124535 15.6664L0 15.4014L0.0609431 15.3669L18.4237 4.70965L29.2639 1L29.391 1.26497L29.3301 1.29942L11.3118 11.7792L0.124535 15.6664ZM0.20138 15.4544V15.4703L11.227 11.6546L29.1844 1.21993V1.20403L18.4873 4.85273L0.20138 15.4544ZM0.924761 15.2185L0.874415 15.0702L11.1661 11.5115L27.8038 1.84792L18.5536 4.99847L18.5032 4.85008L28.4848 1.44516L28.5484 1.58559L11.2323 11.6546L0.924761 15.2185Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M11.8258 30.2824L17.5572 33.592V28.1997L11.8258 24.8902V30.2824Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M12.3213 29.9963L15.0214 31.5438V27.2989L12.3213 25.7514V29.9963Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M15.1008 31.684L12.2417 30.0412V25.6108L15.1008 27.2536V31.684ZM12.4007 29.9484L14.9418 31.4058V27.3464L12.4007 25.889V29.9484Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M15.5302 31.864L17.0617 32.7304V28.4855L15.5302 27.6191V31.864Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M17.1412 32.8683L15.448 31.9118V27.4814L17.1412 28.4406V32.8683ZM15.6096 31.8084L16.9796 32.5848V28.5333L15.6149 27.7623L15.6096 31.8084Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M0.140381 15.4916L0.887608 16.7343L10.8586 13.3559L20.7607 28.1282L21.9001 27.7043L11.2561 11.6574L0.140381 15.4916Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M20.7289 28.2234L10.8268 13.4537L0.850492 16.8322L0.0211182 15.449L11.2879 11.5618L22.0247 27.7438L20.7289 28.2234ZM10.8904 13.2577L20.7925 28.0274L21.7782 27.6617L11.2243 11.7632L0.259598 15.5364L0.922036 16.6387L10.8904 13.2577Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M11.219 11.6599L21.9001 27.7041L39.9317 17.227L29.2505 1.1828L11.219 11.6599Z",
					fill: "#DCDCDC"
				}),
				/* @__PURE__ */ m("path", {
					d: "M21.8763 27.8101L21.8365 27.7491L11.1104 11.6334L29.277 1.07678L29.3168 1.13773L40.0456 17.2508L21.8763 27.8101ZM11.3303 11.6864L21.9293 27.6008L39.8231 17.2005L29.224 1.28611L11.3303 11.6864Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M21.8763 27.8125L11.1104 11.6332L29.2797 1.07391L40.0456 17.2533L21.8763 27.8125ZM11.3329 11.6862L21.9319 27.5979L39.8231 17.2003L29.224 1.30179L11.3329 11.6862Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M35.7875 14.124L28.8982 10.8489C28.8982 10.8489 26.0311 13.3529 25.8615 13.4324L24.3591 18.361V38.8647L35.8617 32.1821V14.4287L35.814 14.4552L35.7875 14.124Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M24.2717 39V18.332L25.8006 13.369L25.8324 13.3531C25.9649 13.2842 27.7085 11.7633 28.8505 10.7829L28.8902 10.7484L35.8617 14.0659V14.307L35.9147 14.2752V32.2193L35.8776 32.2405L24.2717 39ZM24.4281 18.3744V38.7297L35.7716 32.1372V14.5535L35.7293 14.5773L35.7134 14.1745L28.9167 10.9418C28.3868 11.4082 26.267 13.2551 25.9331 13.483L24.4281 18.3744Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M23.2938 21.7952L24.2265 21.2573L30.101 11.6678L35.8801 14.5004L36.5664 14.1321L29.9103 10.857L23.2938 21.7952Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M23.0635 22.02L29.8813 10.7533L36.7441 14.1291L35.8803 14.5901L35.8432 14.5716L30.1304 11.7708L24.285 21.3099L23.0635 22.02ZM29.9528 10.96L23.5351 21.559L24.179 21.188L30.08 11.5535L35.8883 14.3993L36.4023 14.1344L29.9528 10.96Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M23.294 21.7951L29.9104 10.8569L21.7227 7.51556L23.294 21.7951Z",
					fill: "#DCDCDC"
				}),
				/* @__PURE__ */ m("path", {
					d: "M23.2411 22.0334L21.63 7.39355L30.0244 10.8197L23.2411 22.0334ZM21.8155 7.63733L23.347 21.5565L29.7965 10.8939L21.8155 7.63733Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M23.2409 22.0387L21.6272 7.39093L30.0269 10.8171L23.2409 22.0387ZM21.8153 7.64001L23.3495 21.5512L29.7937 10.8965L21.8153 7.64001Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M10.4187 16.3685C9.83818 16.0119 9.17353 15.8153 8.49236 15.7988C6.77797 15.7988 5.63593 17.2456 5.57764 19.4846V19.6463L14.7087 24.9193V24.4344C14.6583 21.5647 13.14 17.7596 10.4187 16.3685Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M12.9281 19.9775V19.9616V19.9457V19.9298C12.9267 19.9237 12.9267 19.9174 12.9281 19.9113C12.9271 19.906 12.9271 19.9006 12.9281 19.8954V19.8795C12.9276 19.8742 12.9276 19.8689 12.9281 19.8636C12.9276 19.8583 12.9276 19.853 12.9281 19.8477V19.8318C12.5762 19.2048 12.153 18.6206 11.6668 18.0909H11.6536H11.6403L11.6085 18.0564H11.5953L11.5052 17.9664L11.2402 17.7173C10.985 17.4875 10.7091 17.2817 10.4161 17.1025V21.6522L13.1719 20.2398L13.1162 20.1312C13.0932 20.1391 13.0686 20.1409 13.0447 20.1366C13.0208 20.1323 12.9983 20.122 12.9795 20.1066C12.9607 20.0912 12.9461 20.0713 12.9371 20.0487C12.9281 20.0261 12.925 20.0016 12.9281 19.9775Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M10.1671 21.668L10.1804 16.8455L10.3023 16.9197C10.5979 17.1028 10.8772 17.3111 11.1369 17.5423C11.4019 17.7888 11.4019 17.7914 11.4019 17.8073L11.4946 17.8974L11.4575 17.9769L11.5158 17.9186L11.6324 18.0431C12.1223 18.5761 12.5491 19.1638 12.9043 19.7946L12.846 19.8556L12.9149 19.8158L12.9679 19.9112L12.907 19.9669L12.9785 19.9298L12.9918 19.9563L12.9229 19.9934L13.0023 19.9722L13.1057 20.1709L10.1671 21.668ZM10.3393 17.1343L10.3155 21.403L12.8831 20.0782L12.8275 19.9775L12.8911 19.9245L12.8116 19.9483V19.9298L12.8699 19.8741L12.793 19.898V19.8821L12.8566 19.8264L12.7824 19.8582C12.4323 19.2339 12.0108 18.6523 11.5264 18.1253L11.4814 18.0776L11.5291 18.0113L11.4628 18.059L11.4019 17.9954L11.3012 17.8948L11.0362 17.6483C10.8171 17.4583 10.5841 17.2847 10.3393 17.129V17.1343Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M14.1073 23.7239C14.1085 23.7187 14.1085 23.7133 14.1073 23.708V23.6921V23.6762C14.1086 23.6559 14.1086 23.6356 14.1073 23.6153C14.1073 23.6153 14.1073 23.6153 14.1073 23.5119C14.1073 23.5119 14.1073 23.5119 14.094 23.4007C13.9433 22.3616 13.6294 21.3529 13.1639 20.4117L10.4718 21.7923L14.1126 23.7875C14.1099 23.7637 14.1099 23.7451 14.1073 23.7239Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M14.2053 23.9254L14.0755 23.8671L10.2758 21.7632L13.1746 20.2767L13.209 20.3509C13.6798 21.299 13.9964 22.316 14.147 23.3637V23.475C14.1603 23.573 14.1603 23.5783 14.1603 23.5836V23.687L14.0914 23.7055H14.1603L14.2053 23.9254ZM10.6149 21.7685L14.0252 23.6552V23.5995C14.0252 23.5995 14.0252 23.5863 14.0119 23.5015V23.3849C13.8662 22.3814 13.5668 21.4064 13.1242 20.494L10.6149 21.7685Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M7.54108 16.6838L7.37415 16.7844L9.97885 21.3394L9.95765 16.8348C9.02494 16.334 8.24327 16.2942 7.54108 16.6838Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M10.0505 21.6438L7.26562 16.7576L7.50145 16.6119C8.23808 16.2065 9.0542 16.2595 9.99487 16.7735L10.0373 16.7974L10.0505 21.6438ZM7.47231 16.8133L9.88623 21.0343L9.87563 16.8981C8.99326 16.4264 8.26458 16.3681 7.58094 16.7576L7.47231 16.8133Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M6.22424 18.8036C6.22424 18.8036 6.22424 18.8195 6.22424 18.8301C6.22547 18.8521 6.22547 18.8742 6.22424 18.8963V18.9626C6.22424 18.9891 6.22424 19.0156 6.22424 19.042C6.22424 19.0685 6.22424 19.042 6.22424 19.1374L9.69277 21.1936L7.13576 16.9276C6.6535 17.3409 6.38323 17.9053 6.22424 18.8036Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M9.86495 21.5035L6.07581 19.2671L6.10495 19.0021L6.18709 18.9889H6.1076L6.1341 18.8034C6.29839 17.876 6.57926 17.301 7.06946 16.8797L7.14366 16.8187L9.86495 21.5035ZM6.25599 19.1797L9.41979 21.053L7.11451 17.0546C6.69585 17.4441 6.45207 17.9767 6.30368 18.8166L6.27719 18.9942L6.19504 19.0101H6.27454L6.25599 19.1797Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.2382 16.4506L19.934 15.4649L19.9393 6.06885L18.2435 7.05455L18.2382 16.4506Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.1614 16.5856V7.00939L20.0162 5.93359V15.5098L18.1614 16.5856ZM18.323 7.09948V16.3127L19.8546 15.4197V6.20387L18.323 7.09948Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.1588 16.5883V7.00944L20.0136 5.92834V15.5098L18.1588 16.5883ZM18.3231 7.09423V16.3048L19.86 15.4118V6.20392L18.3231 7.09423Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M16.4152 13.7319L18.2382 16.4505L18.2435 7.05454L16.4205 5.99994L16.4152 13.7319Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.3177 16.7126L16.333 13.7555V5.86188L18.315 7.00657L18.3177 16.7126ZM16.4946 13.7184L18.1587 16.1959V7.10991L16.4946 6.1507V13.7184Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.2435 7.70389L20.2759 6.5221L20.2785 5.83582L18.2435 7.02025V7.70389Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.1639 7.83879V6.97232L20.3553 5.70044V6.56426L18.1639 7.83879ZM18.3229 7.06241V7.56851L20.2016 6.47681V5.97336L18.3229 7.06241Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.1614 7.84411V6.97234L20.358 5.69781V6.56428L18.1614 7.84411ZM18.3257 7.06508V7.56324L20.199 6.47419V5.97604L18.3257 7.06508Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M15.9674 5.60497L18.2435 6.91924L20.2786 5.73481L18.0024 4.42053L15.9674 5.60497Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.2435 7.0122L15.8083 5.60518L17.9997 4.328L20.4375 5.73502L18.2435 7.0122ZM16.1237 5.60253L18.2435 6.82671L20.1195 5.73767L17.9997 4.51348L16.1237 5.60253Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M16.6006 5.62379L18.209 6.55121L19.6452 5.71654L18.0368 4.78912L16.6006 5.62379Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.209 6.64373L16.439 5.62358L18.0288 4.69617L19.7988 5.71632L18.209 6.64373ZM16.7596 5.62358L18.209 6.45825L19.4862 5.71632L18.0368 4.88165L16.7596 5.62358Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M15.9647 6.38935L18.2435 7.70362V7.01999L15.9674 5.70306L15.9647 6.38935Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M18.3228 7.84138L15.8798 6.43436V5.56525L18.3175 6.97226L18.3228 7.84138ZM16.044 6.34162L18.1638 7.56581V7.065L16.044 5.84347V6.34162Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M24.3538 38.862L35.8696 32.1873V30.3405L24.3538 37.0125V38.862Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M32.6079 16.1035C32.5046 15.8711 32.3408 15.6707 32.1335 15.5232C31.9276 15.3825 31.6834 15.3085 31.434 15.3112C31.1045 15.3147 30.7818 15.4052 30.4987 15.5736C29.8408 15.9918 29.3087 16.5806 28.9591 17.2773C28.7768 17.6147 28.6294 17.9699 28.5193 18.3372C28.4142 18.6821 28.3476 19.0376 28.3206 19.3971V20.3934L32.8251 17.794V16.9435C32.8037 16.6527 32.7301 16.3682 32.6079 16.1035Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M31.9056 15.857C31.7495 15.7507 31.5645 15.6952 31.3757 15.698C31.1926 15.7022 31.0122 15.7437 30.8457 15.8199V18.52L32.47 17.582V17.0282C32.4672 16.8036 32.4153 16.5823 32.3177 16.38C32.2202 16.1777 32.0796 15.9991 31.9056 15.857Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M30.7556 18.6578V15.7669L30.806 15.7457C30.9841 15.6528 31.1835 15.608 31.3843 15.6159C31.5851 15.6238 31.7803 15.6841 31.9506 15.7907C32.1327 15.9405 32.2796 16.1286 32.3808 16.3415C32.482 16.5545 32.5351 16.7871 32.5362 17.0229V17.627L30.7556 18.6578ZM30.9172 15.8729V18.3822L32.3826 17.5343V17.0282C32.3815 16.8176 32.3348 16.6097 32.2456 16.4189C32.1564 16.2282 32.0268 16.059 31.8659 15.9232C31.7251 15.8349 31.5641 15.7839 31.3981 15.7751C31.2321 15.7663 31.0666 15.8 30.9172 15.8729Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M29.2612 17.4284C28.9386 18.0155 28.7418 18.6635 28.6836 19.3309V19.7522L30.4695 18.7215V16.0214C29.9614 16.3885 29.5474 16.8707 29.2612 17.4284Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M28.5984 19.8977V19.3386C28.6572 18.6585 28.8566 17.9981 29.184 17.399C29.4785 16.8271 29.9033 16.3325 30.4241 15.9549L30.5486 15.8701V18.7848L28.5984 19.8977ZM29.2608 17.4282L29.3297 17.4679C29.0147 18.0404 28.8216 18.6719 28.7627 19.3227V19.5877L30.3896 18.6497V16.1775C29.9505 16.5324 29.5896 16.9745 29.3297 17.4759L29.2608 17.4282Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M4.28186 25.9683L10.0133 29.2778V23.8882L4.28186 20.5787V25.9683Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M4.77747 25.6823L7.47756 27.2324V22.9875L4.77747 21.4374V25.6823Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M7.55708 27.3701L4.698 25.7299V21.2996L7.55708 22.9424V27.3701ZM4.85698 25.6425L7.3981 27.0999V23.0351L4.85698 21.5778V25.6425Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M7.98364 27.5529L9.5152 28.4194V24.1745L7.98364 23.308V27.5529Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M9.59737 28.5571L7.90417 27.5979V23.1702L9.59737 24.1267V28.5571ZM8.06316 27.4972L9.43573 28.2736V24.2221L8.06316 23.4457V27.4972Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M27.7825 29.4024L33.5139 26.0929V20.7033L27.7825 24.0102V29.4024Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M30.2521 27.5131L32.9522 25.963V21.7181L30.2521 23.2682V27.5131Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M28.2781 28.5439L29.8096 27.6748V23.4299L28.2781 24.299V28.5439Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
			id: "clip0_2395_58585",
			children: /* @__PURE__ */ m("rect", {
				width: 40,
				height: 40,
				fill: "white"
			})
		}) })]
	});
})), en = /* @__PURE__ */ we({ default: () => tn }), tn, nn = Se((() => {
	tn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M37.7264 17.9924V27.3433L17.8307 38.7124V34.0389L23.0082 31.0786V26.4032L37.7264 17.9924Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M37.7265 17.9925L23.0082 26.4032L7.48932 17.5339H7.48157L15.966 12.6954L15.1712 17.6145L19.8117 17.4706L24.4639 22.8981L29.2711 20.2525L28.3737 13.8619L29.4689 13.2556L37.7265 17.9925Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.1205 11.7937L29.4688 13.2556L29.4552 13.2499L32.1205 11.7937Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.1205 11.7937L28.3697 13.8407L28.3736 13.8618L27.3133 14.447L22.1165 10.6291L26.9237 7.97968L32.1205 11.7937Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.4688 13.2556L28.3736 13.8619L28.3698 13.8408L29.4553 13.2499L29.4688 13.2556Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.0986 19.0188L29.2711 20.2524L24.4639 22.8981L23.5625 16.4902L28.3736 13.8619L29.0986 19.0188Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M27.3133 14.447L23.5625 16.4902L24.4638 22.8981L19.8117 17.4706L15.1711 17.6145L16.0454 12.2139L12.2771 5.89428L17.4701 7.98738L19.5965 4.2597L19.9435 4.39784L22.1164 10.6292L27.3133 14.447Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.5879 1.2879L26.9237 7.97968L22.1164 10.6291L19.7826 3.93353L24.5879 1.2879Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.0081 26.4032V31.0786L7.48926 22.2093V17.5339L23.0081 26.4032Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.0082 31.0786L17.8307 34.0388L2.30798 25.1696L7.48933 22.2093L23.0082 31.0786Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.7826 3.93353L19.9435 4.39781L19.5966 4.25968L19.7826 3.93353Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.5965 4.25971L17.4701 7.98739L12.2771 5.89429L17.0843 3.24866L19.5965 4.25971Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.8307 34.0388V38.7123L2.30798 29.8431V25.1696L17.8307 34.0388Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.8307 34.3267C17.7796 34.3269 17.7294 34.3137 17.6853 34.2883L2.16255 25.4171C2.12678 25.3997 2.095 25.3752 2.06919 25.3452C2.04339 25.3151 2.0241 25.2801 2.01253 25.2424C2.00095 25.2046 1.99735 25.1649 2.00193 25.1257C2.00651 25.0866 2.01918 25.0487 2.03915 25.0146C2.05912 24.9805 2.08598 24.9507 2.11804 24.9273C2.1501 24.9039 2.18668 24.8872 2.22552 24.8784C2.26436 24.8695 2.30462 24.8687 2.34381 24.8759C2.38299 24.8831 2.42026 24.8982 2.45331 24.9202L17.976 33.7895C18.0316 33.8211 18.075 33.87 18.0995 33.9286C18.1241 33.9872 18.1284 34.0521 18.1118 34.1134C18.0953 34.1746 18.0587 34.2287 18.0079 34.2673C17.957 34.3059 17.8947 34.3267 17.8307 34.3267Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.0081 31.3664C22.957 31.3671 22.9067 31.3538 22.8628 31.328L7.34391 22.4587C7.31081 22.4398 7.28181 22.4147 7.25854 22.3847C7.23527 22.3547 7.2182 22.3205 7.2083 22.2839C7.1984 22.2474 7.19587 22.2093 7.20084 22.1718C7.20582 22.1343 7.2182 22.0982 7.23729 22.0654C7.25639 22.0327 7.28181 22.004 7.31211 21.9809C7.34241 21.9579 7.377 21.941 7.4139 21.9312C7.4508 21.9214 7.48929 21.9189 7.52717 21.9238C7.56505 21.9288 7.60157 21.941 7.63467 21.9599L23.1458 30.8292C23.2013 30.8608 23.2447 30.9097 23.2693 30.9683C23.2938 31.0269 23.2981 31.0918 23.2816 31.1531C23.265 31.2143 23.2284 31.2684 23.1776 31.307C23.1267 31.3456 23.0644 31.3665 23.0004 31.3664H23.0081Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.0081 26.6909C22.957 26.6917 22.9067 26.6784 22.8628 26.6526L7.35554 17.789C7.30277 17.7627 7.25942 17.721 7.23134 17.6696C7.20327 17.6181 7.19181 17.5594 7.19853 17.5013C7.20213 17.4638 7.21328 17.4274 7.23131 17.3943C7.24934 17.3611 7.2739 17.3319 7.30353 17.3083C7.33315 17.2847 7.36725 17.2672 7.40382 17.2568C7.44038 17.2465 7.47867 17.2435 7.51642 17.248C7.5558 17.2534 7.59387 17.2658 7.62885 17.2845L23.1458 26.1538C23.2013 26.1854 23.2447 26.2343 23.2693 26.2929C23.2938 26.3514 23.2981 26.4164 23.2816 26.4776C23.265 26.5389 23.2284 26.593 23.1776 26.6316C23.1267 26.6701 23.0644 26.691 23.0004 26.6909H23.0081Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.8307 39.0001C17.7796 39.0004 17.7295 38.9871 17.6853 38.9617L2.16259 30.0925C2.11852 30.0675 2.08187 30.0315 2.05634 29.988C2.03082 29.9446 2.01732 29.8952 2.01721 29.845V25.1734C2.01718 25.1228 2.0306 25.0732 2.05612 25.0294C2.08164 24.9856 2.11836 24.9493 2.16259 24.924L7.20244 22.0462V17.5339C7.20244 17.4575 7.23307 17.3844 7.2876 17.3304C7.34213 17.2764 7.41608 17.2461 7.4932 17.2461C7.57031 17.2461 7.64427 17.2764 7.6988 17.3304C7.75332 17.3844 7.78396 17.4575 7.78396 17.5339V22.2093C7.78379 22.2598 7.77029 22.3094 7.74479 22.3531C7.71929 22.3969 7.68267 22.4333 7.63858 22.4587L2.59873 25.3365V29.68L17.9761 38.4649C18.0316 38.4965 18.075 38.5454 18.0996 38.604C18.1241 38.6625 18.1285 38.7275 18.1119 38.7887C18.0953 38.85 18.0588 38.9041 18.0079 38.9427C17.9571 38.9812 17.8948 39.0021 17.8307 39.002V39.0001Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.4639 23.1858C24.4217 23.1861 24.38 23.1771 24.3418 23.1595C24.3036 23.142 24.2698 23.1162 24.2429 23.0841L19.6799 17.7622L15.1809 17.9022C15.138 17.9043 15.0952 17.8965 15.0559 17.8795C15.0166 17.8626 14.9817 17.8368 14.9541 17.8044C14.9253 17.7727 14.9041 17.7351 14.892 17.6943C14.8799 17.6534 14.8773 17.6104 14.8843 17.5684L15.7411 12.2714L12.0271 6.04198C11.9968 5.98995 11.9835 5.92988 11.9892 5.87008C11.9949 5.81027 12.0192 5.7537 12.0588 5.70819C12.0984 5.66267 12.1513 5.63046 12.2102 5.61602C12.2691 5.60158 12.3311 5.60562 12.3876 5.62758L17.3441 7.62475L19.5287 3.78772C19.5561 3.73913 19.5972 3.69945 19.647 3.6735C19.6967 3.64755 19.753 3.63644 19.809 3.64152C19.865 3.6466 19.9184 3.66764 19.9625 3.7021C20.0067 3.73657 20.0398 3.78297 20.0579 3.83569L22.3704 10.4507L27.4936 14.2148C27.5329 14.2434 27.5642 14.2813 27.5849 14.325C27.6055 14.3687 27.6147 14.4168 27.6116 14.465C27.6085 14.5131 27.5932 14.5597 27.5672 14.6005C27.5411 14.6412 27.5052 14.6749 27.4626 14.6983L23.8785 16.6456L24.7527 22.8597C24.7586 22.9004 24.7554 22.942 24.7436 22.9815C24.7317 23.0209 24.7114 23.0574 24.684 23.0884C24.6565 23.1194 24.6227 23.1441 24.5847 23.1609C24.5467 23.1777 24.5055 23.1862 24.4639 23.1858ZM19.8117 17.1828C19.8538 17.1825 19.8955 17.1915 19.9337 17.2091C19.9719 17.2266 20.0057 17.2524 20.0327 17.2845L24.0394 21.956L23.264 16.5286C23.2563 16.4707 23.2665 16.412 23.2931 16.3599C23.3197 16.3079 23.3616 16.265 23.4132 16.237L26.7667 14.4105L21.9439 10.8613C21.896 10.8269 21.8601 10.7786 21.8412 10.7231L19.709 4.63187L17.7182 8.1274C17.6837 8.18855 17.6279 8.23514 17.5611 8.25845C17.4944 8.28176 17.4214 8.28019 17.3557 8.25402L12.9653 6.48323L16.2954 12.068C16.3298 12.1258 16.3428 12.1936 16.3323 12.2599L15.5143 17.3171L19.8117 17.1828Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M12.2771 6.18012C12.2127 6.18009 12.1502 6.15893 12.0993 6.11994C12.0484 6.08096 12.012 6.02636 11.9958 5.9647C11.9796 5.90305 11.9846 5.83782 12.0098 5.77924C12.0351 5.72067 12.0794 5.67205 12.1356 5.64102L16.9428 2.99731C16.9807 2.97646 17.0228 2.96427 17.0661 2.96161C17.1093 2.95896 17.1527 2.96591 17.1929 2.98196L20.052 4.13307C20.1235 4.16182 20.1805 4.21748 20.2105 4.28782C20.2404 4.35816 20.241 4.43741 20.2119 4.50814C20.1829 4.57886 20.1266 4.63527 20.0556 4.66496C19.9845 4.69464 19.9044 4.69516 19.833 4.66642L17.1056 3.56711L12.4186 6.14559C12.3752 6.16905 12.3265 6.18095 12.2771 6.18012Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M27.3133 14.7348C27.249 14.7348 27.1864 14.7136 27.1355 14.6746C27.0846 14.6356 27.0482 14.581 27.032 14.5194C27.0159 14.4577 27.0208 14.3925 27.0461 14.3339C27.0714 14.2753 27.1156 14.2267 27.1718 14.1957L31.9791 11.552C32.0435 11.5306 32.1134 11.5323 32.1767 11.5567C32.24 11.581 32.2927 11.6266 32.3256 11.6854C32.3586 11.7442 32.3697 11.8125 32.357 11.8786C32.3443 11.9446 32.3087 12.0042 32.2563 12.047L27.4548 14.6983C27.4116 14.7222 27.3629 14.7348 27.3133 14.7348Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.1164 10.917C22.0645 10.9176 22.0134 10.9041 21.9687 10.8781C21.9239 10.8521 21.8872 10.8144 21.8625 10.7692C21.8279 10.7032 21.8202 10.6266 21.8412 10.5551C21.8621 10.4837 21.91 10.423 21.9749 10.3855L26.7821 7.73606C26.8155 7.71671 26.8525 7.70416 26.8909 7.69914C26.9292 7.69412 26.9682 7.69673 27.0056 7.70681C27.0429 7.7169 27.0778 7.73426 27.1083 7.75787C27.1388 7.78149 27.1641 7.81089 27.183 7.84435C27.2018 7.87781 27.2137 7.91465 27.218 7.95272C27.2223 7.99079 27.2188 8.02932 27.2078 8.06605C27.1968 8.10277 27.1786 8.13697 27.1541 8.16662C27.1296 8.19626 27.0993 8.22078 27.0651 8.23871L22.2579 10.8805C22.2147 10.9046 22.166 10.9172 22.1164 10.917Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.4639 23.1858C24.3995 23.1858 24.337 23.1646 24.2861 23.1257C24.2352 23.0867 24.1988 23.0321 24.1826 22.9704C24.1664 22.9088 24.1714 22.8435 24.1967 22.785C24.222 22.7264 24.2662 22.6778 24.3224 22.6467L28.961 20.097L28.0887 13.881C28.08 13.8233 28.0895 13.7644 28.1159 13.7122C28.1422 13.66 28.1842 13.6172 28.236 13.5894L31.5895 11.7592L26.7512 8.20992C26.7038 8.17587 26.668 8.12837 26.6485 8.0737L24.4271 1.70616L19.9242 4.1868C19.8577 4.21703 19.7822 4.22136 19.7127 4.19894C19.6431 4.17651 19.5847 4.12898 19.549 4.06581C19.5133 4.00264 19.5029 3.92847 19.52 3.85809C19.5371 3.78771 19.5803 3.72629 19.6412 3.68606L24.4464 1.0366C24.4836 1.01605 24.5248 1.00382 24.5672 1.00076C24.6096 0.997702 24.6522 1.00389 24.692 1.01889C24.7317 1.03389 24.7676 1.05734 24.7972 1.08758C24.8268 1.11782 24.8493 1.15412 24.8632 1.19391L27.1699 7.80128L32.2931 11.5635C32.3322 11.5921 32.3634 11.6298 32.3841 11.6734C32.4047 11.7169 32.4141 11.7649 32.4113 11.8129C32.4077 11.861 32.3921 11.9075 32.3661 11.9483C32.3401 11.9891 32.3044 12.023 32.2621 12.0469L28.6857 13.9981L29.558 20.2121C29.5666 20.2696 29.5573 20.3283 29.5313 20.3804C29.5053 20.4325 29.4639 20.4755 29.4126 20.5038L24.6054 23.1494C24.5622 23.1735 24.5135 23.1861 24.4639 23.1858Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.8307 39.0001C17.7797 38.9999 17.7296 38.9867 17.6853 38.9618C17.6412 38.9363 17.6046 38.9 17.5791 38.8562C17.5536 38.8125 17.5401 38.7629 17.5399 38.7124V34.0389C17.5401 33.9883 17.5536 33.9388 17.5791 33.895C17.6046 33.8513 17.6412 33.8149 17.6853 33.7894L22.7251 30.9117V26.4032C22.7251 26.3526 22.7385 26.303 22.7641 26.2592C22.7896 26.2154 22.8263 26.179 22.8705 26.1538L37.1546 17.9924L29.3099 13.4973C29.2488 13.4566 29.2056 13.3944 29.1891 13.3233C29.1726 13.2522 29.1839 13.1776 29.2208 13.1145C29.2578 13.0514 29.3175 13.0045 29.388 12.9833C29.4585 12.9622 29.5345 12.9683 29.6007 13.0004L37.8776 17.7411C37.8937 17.7495 37.9086 17.7598 37.9222 17.7718C37.9353 17.7818 37.947 17.7934 37.9571 17.8063C38.0037 17.8594 38.0286 17.9278 38.0269 17.9982V27.3528C38.0267 27.4033 38.0132 27.4529 37.9877 27.4967C37.9622 27.5404 37.9256 27.5768 37.8815 27.6022L17.9761 38.9618C17.9317 38.9867 17.8817 38.9999 17.8307 39.0001ZM18.1214 34.2038V38.2193L37.4357 27.1821V18.4912L23.2989 26.5701V31.0786C23.2987 31.1291 23.2852 31.1787 23.2597 31.2224C23.2342 31.2662 23.1976 31.3026 23.1535 31.328L18.1214 34.2038Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M7.48924 17.8217H7.45435C7.39314 17.8149 7.33564 17.7892 7.29005 17.7482C7.24446 17.7072 7.21309 17.653 7.20042 17.5934C7.18753 17.5346 7.1937 17.4733 7.21806 17.4182C7.24243 17.363 7.28374 17.3169 7.33611 17.2864L15.8205 12.446C15.8536 12.4271 15.8901 12.4148 15.928 12.4099C15.9659 12.405 16.0044 12.4075 16.0413 12.4173C16.0782 12.4271 16.1127 12.444 16.1431 12.467C16.1734 12.4901 16.1988 12.5188 16.2179 12.5515C16.237 12.5843 16.2493 12.6204 16.2543 12.6579C16.2593 12.6954 16.2568 12.7335 16.2469 12.77C16.237 12.8065 16.2199 12.8408 16.1966 12.8708C16.1734 12.9008 16.1443 12.9259 16.1113 12.9448L7.66758 17.7603C7.61676 17.7999 7.55396 17.8216 7.48924 17.8217Z",
				fill: "#3D3D3D"
			})
		]
	});
})), rn = /* @__PURE__ */ we({ default: () => an }), an, on = Se((() => {
	an = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.4688 16.5627C14.9514 16.3039 14.5312 15.6738 14.5312 15.1564C14.5312 15.6738 14.1111 15.8839 13.5938 15.6252C13.0764 15.3664 12.6562 14.7363 12.6562 14.2189V14.225C12.653 14.738 12.2342 14.9453 11.7188 14.6877C11.2014 14.4289 10.7812 13.7988 10.7812 13.2814C10.7812 13.7988 10.3611 14.0089 9.84375 13.7502C9.32641 13.4914 8.90625 12.8613 8.90625 12.3439V12.35C8.90297 12.863 8.48422 13.0703 7.96875 12.8127C7.45141 12.5539 7.03125 11.9238 7.03125 11.4064C7.03125 11.9238 6.61109 12.1339 6.09375 11.8752C5.57641 11.6164 5.15625 10.9863 5.15625 10.4689V8.90643L10.1562 3.90643L28.9062 13.2814L23.9062 18.2814C23.9062 18.2814 23.9062 20.3613 23.9062 19.8439C23.9062 20.3613 23.4861 20.5714 22.9688 20.3127L35.1562 26.4064L26.4062 30.7814L5.15625 20.1564L13.9062 15.7814L15.4688 16.5627ZM22.9688 20.3127L21.0938 19.3752C21.6111 19.6339 22.0312 19.4238 22.0312 18.9064C22.0312 19.4238 22.4514 20.0539 22.9688 20.3127ZM21.0938 19.3752L19.2188 18.4377C19.7361 18.6964 20.1562 18.4863 20.1562 17.9689V17.975C20.1595 18.4913 20.5783 19.1175 21.0938 19.3752ZM19.2188 18.4377L17.3438 17.5002C17.8611 17.7589 18.2812 17.5488 18.2812 17.0314C18.2812 17.5488 18.7014 18.1789 19.2188 18.4377ZM17.3438 17.5002L15.4688 16.5627C15.9861 16.8214 16.4062 16.6113 16.4062 16.0939C16.4062 16.6113 16.8264 17.2414 17.3438 17.5002ZM10.7812 1.09393L34.5312 12.9689H29.5312L10.7812 3.59393H14.5312L10.1562 1.40643L10.7812 1.09393Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M7.65625 22.6564V30.1564L25.1562 38.9064V31.4064L26.4062 32.0314V30.7814L5.15625 20.1564V21.4064L7.65625 22.6564ZM28.9062 13.2814L28.2812 13.9064V27.9689L28.9062 28.2814V13.2814ZM22.0312 18.9064V17.3439L27.0312 12.3439L28.9062 13.2814L23.9062 18.2814V19.8439C23.9062 20.3613 23.4861 20.5714 22.9688 20.3127C22.4514 20.0539 22.0312 19.4238 22.0312 18.9064ZM10.7812 13.2814V19.2189L10.1562 18.9064V13.853C10.5202 13.9061 10.7812 13.6892 10.7812 13.2814ZM18.2812 17.0314V15.4689L23.2812 10.4689L25.1562 11.4064L20.1562 16.4064V17.9689C20.1562 18.4863 19.7361 18.6964 19.2188 18.4377C18.7014 18.1789 18.2812 17.5488 18.2812 17.0314ZM14.5312 15.1564V13.5939L19.5312 8.59393L21.4062 9.53143L16.4062 14.5314V16.0939C16.4062 16.6113 15.9861 16.8214 15.4688 16.5627C14.9514 16.3039 14.5312 15.6738 14.5312 15.1564ZM28.9062 12.6564V13.2814L10.1562 3.90643V1.40643L28.9062 10.7814V12.0314H32.6562L34.5312 12.9689V14.5314C34.5312 15.0488 34.1111 15.2589 33.5938 15.0002C33.0764 14.7414 32.6562 14.1113 32.6562 13.5939V12.9689H29.5312L28.9062 12.6564ZM10.7812 13.2814V11.7189L15.7812 6.71893L17.6562 7.65643L12.6562 12.6564V14.2189C12.6562 14.7363 12.2361 14.9464 11.7188 14.6877C11.2014 14.4289 10.7812 13.7988 10.7812 13.2814ZM7.03125 11.4064V9.84393L12.0312 4.84393L13.9062 5.78143L8.90625 10.7814V12.3439C8.90625 12.8613 8.48609 13.0714 7.96875 12.8127C7.45141 12.5539 7.03125 11.9238 7.03125 11.4064ZM29.5312 11.0939V10.4689L30.7812 11.0939H29.5312Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.0867 1.26661L10.7114 0.954268C10.7553 0.932236 10.8072 0.932236 10.8511 0.954268L34.5983 12.8277L34.6234 12.8427C34.6361 12.8521 34.6472 12.863 34.6562 12.8754L34.6572 12.8765C34.6727 12.8975 34.683 12.9227 34.6864 12.9499L34.6875 12.971V14.5315C34.6875 14.8618 34.543 15.0883 34.3264 15.1966C34.1211 15.2993 33.8367 15.2964 33.5239 15.1399C33.1303 14.9432 32.7903 14.5491 32.6188 14.1366C32.5702 14.1871 32.5138 14.228 32.4514 14.2591C32.2461 14.3618 31.9617 14.3589 31.6489 14.2024C31.2553 14.0057 30.9153 13.6115 30.7438 13.1989C30.6952 13.2494 30.6388 13.2905 30.5764 13.3216C30.3711 13.4243 30.0867 13.4214 29.7739 13.2649C29.7448 13.2504 29.7159 13.2347 29.6875 13.2182V23.4974L35.2258 26.2666L35.2352 26.2716C35.248 26.2791 35.2594 26.2882 35.2692 26.2986L35.2884 26.3232L35.2987 26.3425C35.3047 26.3555 35.3088 26.3694 35.3108 26.3838L35.3125 26.4065V27.6565C35.3125 27.7157 35.2791 27.7697 35.2261 27.7961L32.8125 29.003V35.1565C32.8125 35.2157 32.7791 35.2697 32.7261 35.2961L25.2266 39.046L25.1981 39.0571L25.1677 39.0622L25.1419 39.0621L25.112 39.0563L25.0859 39.046L7.58641 30.2961C7.53344 30.2697 7.5 30.2157 7.5 30.1565V22.753L5.08641 21.5461C5.03344 21.5197 5 21.4657 5 21.4065L5.00047 20.1447L5.00172 20.1338C5.00375 20.1194 5.00781 20.1055 5.01375 20.0925L5.02891 20.0658L5.04328 20.0486C5.05313 20.0382 5.06453 20.0291 5.07734 20.0216L5.08672 20.0166L10 17.5599V13.9786C9.92688 13.958 9.85125 13.9286 9.77391 13.8899C9.38031 13.6932 9.04016 13.299 8.86875 12.8864C8.81953 12.9377 8.76219 12.9791 8.69875 13.0105C8.60906 13.0547 8.50437 13.079 8.38891 13.0793H8.38578C8.23813 13.079 8.07297 13.0394 7.89891 12.9524C7.50688 12.7564 7.16797 12.3646 6.99578 11.9538L6.99375 11.9489C6.94516 11.9994 6.88875 12.0405 6.82641 12.0716C6.73656 12.1165 6.63172 12.1413 6.51578 12.1418H6.51266C6.36453 12.1418 6.1986 12.1024 6.02391 12.0149C5.45625 11.7311 5 11.0366 5 10.469V8.90645C5 8.86505 5.01641 8.82521 5.04578 8.79599L10 3.84176L10.0003 1.39754L10.0017 1.38379C10.0037 1.36942 10.0078 1.35552 10.0138 1.34255L10.0289 1.31582L10.0433 1.29864C10.0531 1.28817 10.0645 1.27911 10.0773 1.27161L10.0867 1.26661ZM7.8125 22.9093L25 31.503V38.6536L7.8125 30.0599V22.9093ZM16.1947 25.8504L26.25 30.878V31.7786L5.3125 21.3099V20.4093L16.1947 25.8504ZM11.5625 17.128V18.9065C11.5625 18.9657 11.5291 19.0197 11.4761 19.0461L10.8516 19.3585L10.8231 19.3696L10.7927 19.3747L10.7669 19.3746L10.737 19.3688L10.7109 19.3585L10.0864 19.0461C10.0334 19.0197 10 18.9657 10 18.9065V17.9093L5.50562 20.1565L26.4062 30.6068L34.8069 26.4065L29.6875 23.8468V27.969C29.6875 28.0282 29.6541 28.0822 29.6011 28.1086L28.9766 28.421L28.9481 28.4321L28.9177 28.4372L28.8919 28.4371L28.862 28.4313L28.8359 28.421L28.2114 28.1086C28.1584 28.0822 28.125 28.0282 28.125 27.969V23.0655L13.9062 15.9561L11.5625 17.128ZM28.75 28.0286V13.6586L28.4375 13.9711V27.8724L28.75 28.0286ZM28.125 14.2836V22.7161L23.7062 20.5068C23.7589 20.4799 23.8072 20.4458 23.8502 20.405C23.9062 20.3518 24.0625 20.1565 24.0625 19.8802V18.3461L28.125 14.2836ZM20.3125 17.9713C20.3125 17.9705 20.3125 17.9697 20.3125 17.969C20.3125 17.8827 20.2425 17.8127 20.1562 17.8127C20.07 17.8127 20 17.8827 20 17.969C20 18.1563 19.9345 18.2932 19.8117 18.3546C19.7613 18.3797 19.7039 18.3925 19.6411 18.3932H19.6372C19.5334 18.3935 19.4148 18.3611 19.2886 18.298C18.8214 18.0644 18.4375 17.4986 18.4375 17.0315C18.4375 16.9458 18.3686 16.8763 18.2833 16.8752H18.2812C18.195 16.8752 18.125 16.9452 18.125 17.0315C18.125 17.2188 18.0595 17.3557 17.9367 17.4171C17.8863 17.4422 17.8289 17.455 17.7661 17.4557H17.7622C17.6584 17.456 17.5398 17.4236 17.4136 17.3605C16.9464 17.1269 16.5625 16.5611 16.5625 16.094C16.5625 16.0083 16.4936 15.9388 16.4083 15.9377H16.4062C16.32 15.9377 16.25 16.0077 16.25 16.094C16.25 16.2813 16.1845 16.4182 16.0617 16.4796C16.0113 16.5047 15.9539 16.5176 15.8911 16.5182H15.8872C15.7834 16.5185 15.6648 16.4861 15.5386 16.423C15.0714 16.1894 14.6875 15.6236 14.6875 15.1565C14.6875 15.0702 14.6175 15.0002 14.5312 15.0002C14.445 15.0002 14.375 15.0702 14.375 15.1565C14.375 15.3438 14.3095 15.4807 14.1867 15.5421C14.1363 15.5672 14.0789 15.5801 14.0161 15.5807H14.0122C13.9084 15.581 13.7898 15.5486 13.6636 15.4855C13.1983 15.2529 12.8155 14.6905 12.8125 14.2244H12.8123C12.8125 14.2225 12.8125 14.2208 12.8125 14.219C12.8125 14.1327 12.7425 14.0627 12.6562 14.0627C12.57 14.0627 12.5 14.1327 12.5 14.219C12.5 14.2208 12.5 14.2225 12.5002 14.2244H12.5C12.4988 14.4096 12.4328 14.5447 12.3103 14.6054C12.26 14.6302 12.2028 14.6426 12.14 14.6432H12.1361C12.0327 14.6432 11.9145 14.6108 11.7886 14.548C11.3214 14.3144 10.9375 13.7486 10.9375 13.2815C10.9375 13.1952 10.8675 13.1252 10.7812 13.1252C10.695 13.1252 10.625 13.1952 10.625 13.2815C10.625 13.4688 10.5595 13.6057 10.4367 13.6671C10.3863 13.6922 10.3289 13.7051 10.2661 13.7057H10.2622C10.1584 13.706 10.0398 13.6736 9.91359 13.6105C9.44828 13.3779 9.06547 12.8155 9.0625 12.3494H9.06234C9.0625 12.3475 9.0625 12.3458 9.0625 12.344C9.0625 12.2577 8.9925 12.1877 8.90625 12.1877C8.82 12.1877 8.75 12.2577 8.75 12.344C8.75 12.3458 8.75 12.3475 8.75016 12.3494H8.75C8.74875 12.5346 8.68281 12.6697 8.56031 12.7304C8.51 12.7552 8.45281 12.7676 8.39 12.7682H8.38609C8.28265 12.7682 8.16453 12.7358 8.03859 12.673C7.5714 12.4394 7.1875 11.8736 7.1875 11.4065C7.1875 11.3202 7.1175 11.2502 7.03125 11.2502C6.945 11.2502 6.875 11.3202 6.875 11.4065C6.875 11.5938 6.80953 11.7307 6.68672 11.7921C6.63625 11.8172 6.57891 11.8301 6.51609 11.8307H6.51219C6.40844 11.831 6.28984 11.7986 6.16359 11.7355C5.6964 11.5019 5.3125 10.9361 5.3125 10.469V8.97114L10.187 4.09661L28.6425 13.3243L23.7958 18.171C23.7664 18.2002 23.75 18.24 23.75 18.2815V19.844C23.75 20.0313 23.6845 20.1682 23.5617 20.2296C23.5113 20.2547 23.4539 20.2675 23.3911 20.2682H23.3872C23.2834 20.2685 23.1648 20.2361 23.0386 20.173C22.5714 19.9394 22.1875 19.3736 22.1875 18.9065C22.1875 18.8202 22.1175 18.7502 22.0312 18.7502C21.945 18.7502 21.875 18.8202 21.875 18.9065C21.875 19.0938 21.8095 19.2307 21.6867 19.2921C21.6363 19.3172 21.5789 19.33 21.5161 19.3307H21.5122C21.4084 19.331 21.2898 19.2986 21.1636 19.2355C20.7 19.0036 20.3184 18.4446 20.3125 17.9796V17.9713ZM22.132 19.7196L21.8312 19.5693C21.8916 19.5383 21.9464 19.4982 21.9938 19.4491C22.0319 19.5408 22.0784 19.6316 22.132 19.7196ZM10.625 13.9196V18.9661L10.3125 18.8099V14.0152C10.41 14.0091 10.4987 13.9854 10.5764 13.9466C10.593 13.9383 10.6092 13.9293 10.625 13.9196ZM20.1188 18.5114L20.1208 18.5163C20.1586 18.6065 20.2044 18.6957 20.257 18.7821L19.9563 18.6318C20.0166 18.6008 20.0714 18.5607 20.1188 18.5114ZM18.2438 17.5741L18.2458 17.579C18.2836 17.669 18.3294 17.7582 18.382 17.8446L18.0813 17.6943C18.1416 17.6633 18.1964 17.6232 18.2438 17.5741ZM16.507 16.9071L16.2063 16.7568C16.2666 16.7258 16.3214 16.6857 16.3688 16.6366C16.4069 16.7283 16.4534 16.8191 16.507 16.9071ZM13.5573 15.7811L11.5625 16.7786V14.7807C11.5909 14.7972 11.6198 14.8129 11.6489 14.8274C11.823 14.9144 11.9881 14.954 12.1358 14.9543H12.1389C12.2544 14.954 12.3591 14.9297 12.4487 14.8855C12.5122 14.8541 12.5695 14.8127 12.6188 14.7614C12.7902 15.174 13.1303 15.5682 13.5239 15.7649C13.535 15.7705 13.5462 15.776 13.5573 15.7811ZM14.4938 15.6991L14.4958 15.704C14.5336 15.794 14.5794 15.8832 14.632 15.9696L14.3313 15.8193C14.3916 15.7883 14.4464 15.7482 14.4938 15.6991ZM31.0475 13.1252H34.375V14.5315C34.375 14.7188 34.3095 14.8557 34.1867 14.9171C34.0525 14.9843 33.8683 14.9627 33.6636 14.8605C33.1964 14.6269 32.8125 14.0611 32.8125 13.594C32.8125 13.5077 32.7425 13.4377 32.6562 13.4377C32.57 13.4377 32.5 13.5077 32.5 13.594C32.5 13.7813 32.4345 13.9182 32.3117 13.9796C32.1775 14.0468 31.9933 14.0252 31.7886 13.923C31.4723 13.7647 31.1941 13.4543 31.0475 13.1252ZM10.3125 3.80989L28.75 13.0286V10.878L10.3125 1.65926V3.80989ZM29.6875 10.7218V12.8127H33.8694L29.6875 10.7218ZM10.5056 1.40645L10.7812 1.26864L29.1819 10.469L28.9062 10.6068L10.5056 1.40645Z",
				fill: "#3D3D3D"
			})
		]
	});
})), sn = /* @__PURE__ */ we({ default: () => cn }), cn, ln = Se((() => {
	cn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.6856 11.4352L12.7009 11.543C16.2708 11.9258 19.8755 11.2758 23.0867 9.67112L29.2202 6.60393C30.0345 6.19612 31.1314 6.2133 32.3503 6.73361C33.0375 6.30236 34.0403 6.31487 35.1562 6.87424C37.2259 7.90862 38.9062 10.4289 38.9062 12.4992C38.9062 13.6149 38.4177 14.3727 37.643 14.6727C37.5558 15.8274 37.0405 16.6492 36.2497 17.0649H36.25C36.25 17.0649 33.5683 18.4055 30.8467 19.7664C27.3116 21.5336 24.4284 24.3711 22.6047 27.8696C22.3655 30.1024 21.3098 31.6867 19.7259 32.4774L18.4759 33.1024L18.3653 32.9368C17.6358 33.0805 16.8355 33.0946 15.9823 32.9696C14.6287 33.0524 13.0677 32.7039 11.4062 31.8742C6.23203 29.2867 2.03125 22.9852 2.03125 17.8117C2.03125 16.1492 2.46437 14.8055 3.22375 13.8305C3.52484 13.1289 3.93859 12.5352 4.44719 12.0602L4.33656 11.8946L5.58656 11.2696C7.18187 10.4711 9.31297 10.4774 11.6856 11.4352Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.4062 12.4993C16.9255 15.2586 21.4062 21.9789 21.4062 27.4993C21.4062 33.018 16.9255 35.2586 11.4062 32.4993C5.88703 29.7383 1.40625 23.018 1.40625 17.4993C1.40625 11.9789 5.88703 9.73832 11.4062 12.4993ZM11.4062 13.7493C16.2355 16.1633 20.1562 22.0446 20.1562 26.8743C20.1562 31.7024 16.2355 33.6633 11.4062 31.2493C6.57703 28.8336 2.65625 22.9524 2.65625 18.1243C2.65625 13.2946 6.57703 11.3336 11.4062 13.7493ZM31.4062 17.4993L29.5312 16.5618L28.2812 28.4368L30.1562 29.3743L31.4062 17.4993ZM11.4062 19.9993C12.7861 20.6883 13.9062 22.368 13.9062 23.7493C13.9062 25.1289 12.7861 25.6883 11.4062 24.9993C10.0264 24.3086 8.90625 22.6289 8.90625 21.2493C8.90625 19.868 10.0264 19.3086 11.4062 19.9993Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.7236 11.2821L12.7175 11.3883C16.2577 11.768 19.8323 11.1227 23.0167 9.53051L29.1503 6.46332C29.9819 6.0477 31.0975 6.0477 32.3378 6.55863C32.3697 6.54145 32.4022 6.52427 32.4353 6.50708C33.1495 6.14927 34.1372 6.18988 35.2261 6.73363C36.2761 7.25863 37.2272 8.15863 37.9197 9.18988C37.9261 9.19613 37.932 9.20394 37.9373 9.21176C38.6344 10.2571 39.0625 11.4352 39.0625 12.4993C39.0625 13.6055 38.603 14.3774 37.8772 14.7399C37.8488 14.7539 37.82 14.768 37.7906 14.7805C37.6775 15.9477 37.1338 16.7774 36.3223 17.2024L36.2505 17.2196L36.25 17.2211L36.3198 17.2039L35.1048 17.8118L34.0617 28.7633C34.0552 28.8336 34.0017 28.8914 33.9319 28.9024L30.1825 29.5274L30.1775 29.5289H30.173H30.1684C30.1653 29.5289 30.1623 29.5305 30.1592 29.5305H30.1545H30.1498L30.1452 29.5289H30.1405H30.137L30.1325 29.5274H30.1281L30.1237 29.5258H30.122H30.1194L30.1175 29.5243H30.1152H30.113L30.1108 29.5227H30.1084L30.1066 29.5211H30.1039L30.0995 29.5196L30.095 29.518L30.09 29.5149L30.0859 29.5133L28.2114 28.5758C28.1531 28.5461 28.1191 28.4852 28.1258 28.4196L28.8986 21.079C26.3197 22.8024 24.2042 25.1508 22.7569 27.9149C22.5052 30.1946 21.4159 31.8086 19.7958 32.618L18.5458 33.243C16.7002 34.1649 14.1502 34.0446 11.3364 32.6383C5.76703 29.854 1.25 23.068 1.25 17.4993C1.25 14.668 2.40969 12.6821 4.26672 11.7539L5.51672 11.1289C7.14047 10.318 9.30953 10.3133 11.7236 11.2821ZM11.3364 12.6383C16.8053 15.3727 21.25 22.0305 21.25 27.4993C21.25 30.1868 20.1692 32.0821 18.4061 32.9633C16.6314 33.8508 14.1816 33.7118 11.4761 32.3586C6.00719 29.6243 1.5625 22.968 1.5625 17.4993C1.5625 14.8102 2.64328 12.9149 4.4064 12.0336C6.18109 11.1461 8.63094 11.2852 11.3364 12.6383ZM11.4761 13.6086C9.00734 12.3743 6.76985 12.2696 5.15047 13.0805C3.51969 13.8946 2.5 15.6368 2.5 18.1243C2.5 23.0024 6.45688 28.9493 11.3364 31.3883C13.8052 32.6227 16.0427 32.7274 17.662 31.918C19.2928 31.1024 20.3125 29.3602 20.3125 26.8743C20.3125 21.9946 16.3556 16.0493 11.4761 13.6086ZM19.2158 22.8805L13.1667 25.3258C13.1497 25.3321 13.1327 25.3383 13.1153 25.3461H13.1134C13.1106 25.3477 13.1078 25.3493 13.1052 25.3493C12.6316 25.5258 12.0125 25.4758 11.3364 25.1383C10.618 24.779 9.96859 24.1602 9.50031 23.4524L5.35891 25.5227C6.92672 27.868 9.09 29.9164 11.4761 31.1086C13.8366 32.2883 15.9741 32.4118 17.5223 31.6383C19.0592 30.8696 20 29.2164 20 26.8743C20 25.5883 19.7191 24.2289 19.2158 22.8805ZM31.0002 19.8633L30.0245 29.1336L28.448 28.3446L29.2359 20.8586C29.7772 20.5133 30.3381 20.1946 30.9166 19.9055L31.0002 19.8633ZM11.3364 20.1383C12.6659 20.8024 13.75 22.4196 13.75 23.7493C13.75 24.3665 13.5094 24.8071 13.1038 25.0102C12.6867 25.218 12.1119 25.1758 11.4761 24.8586C10.1466 24.1946 9.0625 22.5774 9.0625 21.2493C9.0625 20.6305 9.30312 20.1899 9.70875 19.9868C10.1258 19.779 10.7006 19.8211 11.3364 20.1383ZM15.1581 16.6852L10.4356 19.5524C10.7559 19.5758 11.1077 19.6743 11.4761 19.8586C12.1773 20.2102 12.8127 20.8071 13.278 21.4946L17.37 19.3508C16.7222 18.3993 15.9764 17.4977 15.1581 16.6852ZM19.4994 18.2774C17.7123 15.6461 15.273 13.3571 12.5864 12.0133C10.1017 10.7711 7.8325 10.5524 6.10391 11.2118C7.66453 11.0196 9.50562 11.3743 11.4761 12.3586C14.2197 13.7305 16.7078 16.0727 18.5267 18.7633L19.4994 18.2774ZM35.9806 10.0368L19.7767 18.1383C17.9578 15.4477 15.4697 13.1055 12.7261 11.7336C12.7003 11.7211 12.6744 11.7086 12.6483 11.6946L12.6842 11.6993C16.2839 12.0852 19.9186 11.429 23.1566 9.81021L29.29 6.74302C30.1491 6.31333 31.3345 6.38676 32.6442 7.04301C33.9352 7.68832 35.1102 8.77895 35.9806 10.0368ZM37.5795 9.23676L36.2584 9.8977C35.3558 8.58051 34.132 7.43677 32.7841 6.76333C32.7592 6.75083 32.7344 6.73833 32.7098 6.72583C33.3395 6.47427 34.1725 6.55708 35.0864 7.01333C36.0483 7.49458 36.9252 8.30395 37.5795 9.23676Z",
				fill: "#3D3D3D"
			})
		]
	});
})), un = /* @__PURE__ */ we({ default: () => dn }), dn, fn = Se((() => {
	dn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.2188 8.32657V2.65625L17.3438 1.09375L28.5938 6.71875L26.7188 7.65625L27.9688 9.53125V38.2812L26.7188 38.9062L15.4688 33.2812L14.2188 31.4062V15.5141C14.2188 16.0313 13.7984 16.2422 13.2812 15.9828C12.7641 15.725 12.3438 15.0938 12.3438 14.5766C12.3438 15.0938 11.9234 15.3047 11.4062 15.0453C10.8891 14.7875 10.4688 14.1563 10.4688 13.6391V12.0766L14.2188 8.32657Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.2188 22.0312L17.3438 21.0938V29.8438L23.5938 32.9688V31.0938L25.4688 32.0312V23.2812L19.2188 20.1562V22.0312ZM19.8438 18.3266V16.7641L24.8438 11.7641L26.7188 12.7016L21.7188 17.7016V19.2641C21.7188 19.7813 21.2984 19.9922 20.7812 19.7328C20.2641 19.475 19.8438 18.8438 19.8438 18.3266ZM16.0938 16.4516V14.8891L21.0938 9.88907L22.9688 10.8266L17.9688 15.8266V17.3891C17.9688 17.9063 17.5484 18.1172 17.0312 17.8578C16.5141 17.6 16.0938 16.9688 16.0938 16.4516ZM14.2188 15.5141C14.2188 15.9781 14.5563 16.5328 15 16.8297V31.5625L15.7812 32.6562L26.4062 37.9688L27.1875 37.6562V9.53125L26.4062 8.28125L24.6875 7.42188L24.2188 7.65625V8.125L23.75 8.35938L18.4375 5.70312L17.9688 5V4.53125L17.6562 3.90625L15.7812 2.96875L15 3.4375V7.54532L14.2188 8.32657V2.65625L15.4688 2.03125L26.7188 7.65625L28.5938 6.71875L29.8438 8.59375L27.9688 9.53125V38.2812L26.7188 38.9062L15.4688 33.2812L14.2188 31.4062V15.5141C14.2188 16.0313 13.7984 16.2422 13.2812 15.9828C12.7641 15.725 12.3438 15.0938 12.3438 14.5766V13.0141L17.3438 8.01407L19.2188 8.95157L14.2188 13.9516V15.5141Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.1484 2.5172L17.2734 0.9547C17.3172 0.932825 17.3703 0.932825 17.4141 0.9547L28.6625 6.57814C28.6859 6.58907 28.7063 6.60623 28.7219 6.62811L28.7234 6.6328L29.9734 8.5078L29.9766 8.51093L29.9797 8.51562V8.51718L29.9828 8.52188L29.9844 8.52657L29.9859 8.52813L29.9891 8.53439L29.9906 8.54061C29.9953 8.55311 29.9984 8.56717 30 8.57967V8.58593V8.59062C30 8.59218 30 8.59375 30 8.59375V37.3437C30 37.4031 29.9672 37.4562 29.9141 37.4828L26.7891 39.0453C26.7453 39.0672 26.6922 39.0672 26.6484 39.0453L15.3984 33.4203C15.375 33.4094 15.3531 33.3906 15.3391 33.3672L14.0891 31.4922C14.0719 31.4672 14.0625 31.4375 14.0625 31.4062V16.1531C14.0469 16.1625 14.0312 16.1703 14.0141 16.1797C13.8094 16.2813 13.5234 16.2797 13.2109 16.1234C12.8172 15.9265 12.4781 15.5312 12.3063 15.1187C12.2578 15.1703 12.2016 15.2109 12.1391 15.2422C11.9344 15.3438 11.6484 15.3422 11.3359 15.1859C10.7688 14.9015 10.3125 14.2063 10.3125 13.6391V12.0766C10.3125 12.0359 10.3297 11.9953 10.3578 11.9656L14.0625 8.26248V2.65625C14.0625 2.59687 14.0953 2.54376 14.1484 2.5172ZM26.6125 7.77812L27.8125 9.57813V38.1844L26.7188 38.7312L15.575 33.1594L14.375 31.3594V16.4141C14.5594 16.6859 14.8094 16.9219 15.0859 17.0609C15.3984 17.2172 15.6844 17.2188 15.8891 17.1172C15.9516 17.0859 16.0078 17.0453 16.0563 16.9937C16.2281 17.4062 16.5672 17.8015 16.9609 17.9984C17.2734 18.1547 17.5594 18.1563 17.7641 18.0547C17.8266 18.0234 17.8828 17.9828 17.9313 17.9312C18.1031 18.3437 18.4422 18.739 18.8359 18.9359C19.1484 19.0922 19.4344 19.0938 19.6391 18.9922C19.7016 18.9609 19.7578 18.9203 19.8063 18.8687C19.9781 19.2812 20.3172 19.6765 20.7109 19.8734C21.0234 20.0297 21.3094 20.0313 21.5141 19.9297C21.5687 19.9016 21.6187 19.8672 21.6625 19.825C21.7062 19.7828 21.875 19.5781 21.875 19.3C21.875 17.7656 21.875 17.7656 21.875 17.7656L26.8297 12.8125C26.8641 12.7766 26.8812 12.7265 26.8734 12.6765C26.8656 12.6265 26.8344 12.5844 26.7891 12.5625L15.5391 6.93748C15.4781 6.90623 15.4063 6.91876 15.3578 6.96563L14.375 7.94998V2.75314L15.4688 2.20626L26.6125 7.77812ZM17.1875 21.0937V21.0906C17.1891 21.0578 17.1984 21.0281 17.2156 21.0047L17.2187 21C17.2234 20.9937 17.2281 20.9875 17.2344 20.9828L17.2375 20.9781C17.2578 20.9609 17.2828 20.9469 17.3109 20.9406H17.3125H17.3156C17.3156 20.9391 17.3172 20.9391 17.3188 20.9391L18.2141 20.7906L19.1188 20.0359C19.1656 19.9969 19.2297 19.9891 19.2844 20.0141L19.2891 20.0172L25.5375 23.1406C25.5406 23.1422 25.5422 23.1437 25.5453 23.1453L25.55 23.1469L25.5516 23.1484C25.5641 23.1562 25.575 23.1656 25.5859 23.1766L25.5891 23.1828L25.5938 23.1875L25.5969 23.1922L25.5984 23.1937L25.6 23.1969L25.6016 23.1984L25.6047 23.2047L25.6078 23.2094L25.6094 23.2125V23.2141C25.6172 23.2297 25.6234 23.2484 25.625 23.2672V23.2734V23.2797V23.2812V32.0312C25.625 32.0906 25.5922 32.1437 25.5391 32.1703L23.6641 33.1078C23.6203 33.1297 23.5688 33.1312 23.5234 33.1078L17.2734 29.9828C17.2203 29.9562 17.1875 29.9031 17.1875 29.8437V21.0937ZM23.4375 24.3156V32.7156L17.5 29.7469V21.3469L23.4375 24.3156ZM19.0625 23.2797V23.9062C19.0625 24.6469 19.6594 25.5515 20.3984 25.9203C20.7984 26.1203 21.161 26.1281 21.4219 25.9969C21.6953 25.8594 21.875 25.5719 21.875 25.1562V24.2969C21.875 24.2187 21.7969 24.1609 21.7188 24.1625C21.6406 24.1609 21.5625 24.2187 21.5625 24.2969V25.1562C21.5625 25.4297 21.4625 25.6266 21.2828 25.7172C21.0922 25.8125 20.8297 25.7875 20.5391 25.6422C19.8984 25.3219 19.375 24.5453 19.375 23.9062V23.2797C19.375 23.1937 19.3047 23.1234 19.2188 23.1234C19.1328 23.1234 19.0625 23.1937 19.0625 23.2797ZM19.375 21.9344L23.5625 24.0281L24.1078 23.4828C24.1281 23.4625 24.1531 23.4484 24.1813 23.4422L25.0219 23.2312L19.375 20.4094V21.9344ZM22.9688 23.125C23.0547 23.125 23.125 23.1953 23.125 23.2812C23.125 23.3672 23.0547 23.4375 22.9688 23.4375C22.8828 23.4375 22.8125 23.3672 22.8125 23.2812C22.8125 23.1953 22.8828 23.125 22.9688 23.125ZM21.0938 22.1875C21.1797 22.1875 21.25 22.2578 21.25 22.3437C21.25 22.4297 21.1797 22.5 21.0938 22.5C21.0078 22.5 20.9375 22.4297 20.9375 22.3437C20.9375 22.2578 21.0078 22.1875 21.0938 22.1875ZM20 18.3266C19.9984 18.2422 19.9281 18.175 19.8438 18.175C19.7594 18.175 19.6891 18.2422 19.6875 18.3266C19.6875 18.5141 19.6219 18.6516 19.5 18.7125C19.3656 18.7797 19.1812 18.7578 18.9766 18.6562C18.5109 18.4234 18.1281 17.8609 18.125 17.3938V17.3922C18.125 17.3063 18.0547 17.2359 17.9688 17.2359C17.8828 17.2359 17.8141 17.3047 17.8125 17.3891C17.8125 17.5766 17.7469 17.7141 17.625 17.775C17.4906 17.8422 17.3062 17.8203 17.1016 17.7187C16.6344 17.4844 16.25 16.9188 16.25 16.4516C16.2484 16.3672 16.1797 16.2984 16.0938 16.2984C16.0078 16.2984 15.9391 16.3672 15.9375 16.4516C15.9375 16.6391 15.8719 16.7766 15.75 16.8375C15.6156 16.9047 15.4312 16.8828 15.2266 16.7812C14.7594 16.5469 14.375 15.9813 14.375 15.5141C14.375 15.4281 14.3047 15.3578 14.2188 15.3578C14.1328 15.3578 14.0625 15.4281 14.0625 15.5141C14.0625 15.7016 13.9969 15.8391 13.875 15.9C13.7406 15.9672 13.5562 15.9453 13.3516 15.8437C12.8844 15.6094 12.5 15.0438 12.5 14.5766C12.5 14.4906 12.4297 14.4203 12.3438 14.4203C12.2578 14.4203 12.1875 14.4906 12.1875 14.5766C12.1875 14.7641 12.1219 14.9016 12 14.9625C11.8656 15.0297 11.6812 15.0078 11.4766 14.9062C11.0094 14.6719 10.625 14.1063 10.625 13.6391V12.1406L15.5 7.26718L26.4547 12.7453L21.6078 17.5906C21.5797 17.6203 21.5625 17.6609 21.5625 17.7016V19.2641C21.5625 19.4516 21.4969 19.5891 21.375 19.65C21.2406 19.7172 21.0562 19.6953 20.8516 19.5937C20.3844 19.3594 20 18.7938 20 18.3266ZM29.6156 8.53282L28.5406 6.92031L26.9469 7.71717L28.0219 9.32968L29.6156 8.53282ZM15.8187 2.03125L17.3438 1.26876L28.2438 6.71875L26.7188 7.48123L15.8187 2.03125Z",
				fill: "#3D3D3D"
			})
		]
	});
})), pn = /* @__PURE__ */ we({ default: () => mn }), mn, hn = Se((() => {
	mn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10.4688 13.75L1.40625 18.2812V28.2812L13.9062 34.5312V24.5312L38.9062 12.0312L26.4062 5.78125L17.0312 10.4688L16.7188 10.3125L10.4688 13.4375V13.75Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.9062 33.75L1.40625 27.5V27.8125L13.9062 34.0625V33.75ZM13.9062 33.125L1.40625 26.875V27.1875L13.9062 33.4375V33.125ZM13.9062 32.5L1.40625 26.25V26.5625L13.9062 32.8125V32.5ZM13.9062 31.875L1.40625 25.625V25.9375L13.9062 32.1875V31.875ZM13.9062 31.25L1.40625 25V25.3125L13.9062 31.5625V31.25ZM13.9062 30.625L1.40625 24.375V24.6875L13.9062 30.9375V30.625ZM13.9062 30L1.40625 23.75V24.0625L13.9062 30.3125V30ZM13.9062 29.375L1.40625 23.125V23.4375L13.9062 29.6875V29.375ZM13.9062 28.75L1.40625 22.5V22.8125L13.9062 29.0625V28.75ZM13.9062 28.125L1.40625 21.875V22.1875L13.9062 28.4375V28.125ZM13.9062 27.5L1.40625 21.25V21.5625L13.9062 27.8125V27.5ZM13.9062 26.875L1.40625 20.625V20.9375L13.9062 27.1875V26.875ZM13.9062 26.25L1.40625 20V20.3125L13.9062 26.5625V26.25ZM13.9062 25.625L1.40625 19.375V19.6875L13.9062 25.9375V25.625ZM13.9062 25L1.40625 18.75V19.0625L13.9062 25.3125V25ZM12.0312 14.2188L14.9594 15.6825C15.1578 16.1769 15.6406 16.6483 16.4062 17.0312C17.1719 17.4142 18.1156 17.6555 19.1031 17.755L22.0312 19.2188L16.4062 22.0312C15.0266 21.3414 12.7859 21.3414 11.4062 22.0312L6.40625 19.5312C7.78594 18.8414 7.78594 17.7211 6.40625 17.0312L12.0312 14.2188ZM15.4688 10.9375L11.7188 12.8125L24.5312 19.2188L28.2812 17.3438L15.4688 10.9375ZM12.6562 17.6562C13.3453 17.3112 14.4672 17.3112 15.1562 17.6562C15.8453 18.0013 15.8453 18.5612 15.1562 18.9062C14.4672 19.2513 13.3453 19.2513 12.6562 18.9062C11.9672 18.5612 11.9672 18.0013 12.6562 17.6562ZM18.2812 11.0938L23.9062 8.28125C25.2859 8.97109 27.5266 8.97109 28.9062 8.28125L33.9062 10.7812C32.5266 11.4711 32.5266 12.5914 33.9062 13.2812L28.2812 16.0938L25.3531 14.63C25.1547 14.1356 24.6719 13.6642 23.9062 13.2812C23.1406 12.8983 22.1969 12.657 21.2094 12.5575L18.2812 11.0938ZM25.1562 11.4062C25.8453 11.0612 26.9672 11.0612 27.6562 11.4062C28.3453 11.7513 28.3453 12.3113 27.6562 12.6562C26.9672 13.0012 25.8453 13.0012 25.1562 12.6562C24.4672 12.3113 24.4672 11.7513 25.1562 11.4062Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17.0312 10.2941L26.3359 5.64158C26.3797 5.61955 26.4328 5.61955 26.4766 5.64158L38.9766 11.8916L38.9797 11.8933L38.9812 11.8941L38.9844 11.8958L38.9859 11.8967L38.9891 11.8983L38.9906 11.8997L38.9922 11.9011L38.9953 11.9027L38.9969 11.9039L39 11.9058L39.0016 11.9069L39.0031 11.9092L39.0047 11.91L39.0078 11.9127L39.0125 11.9163L39.0156 11.92C39.0172 11.9211 39.0187 11.9224 39.0203 11.9236L39.0234 11.9272L39.0266 11.931L39.0297 11.9347V11.936L39.0328 11.9386V11.9402L39.0344 11.9427L39.0359 11.9447L39.0375 11.9467L39.0391 11.9491L39.0406 11.951L39.0422 11.9538V11.9552L39.0438 11.9585L39.0453 11.9596L39.0469 11.9631L39.0484 11.9685L39.0516 11.973L39.0531 11.978L39.0547 11.9822L39.0562 11.9869V11.9881L39.0578 11.9916V11.9935L39.0594 11.9964V11.9986V12.0013L39.0609 12.0039V12.0063V12.0094V12.0111V12.0147L39.0625 12.0161V12.0202V12.0211V12.0263V12.0313V22.0313C39.0625 22.0905 39.0297 22.1446 38.9766 22.171L29.6875 26.8153V27.0313C29.6875 27.0905 29.6547 27.1446 29.6016 27.171L23.3516 30.296C23.3078 30.318 23.2547 30.318 23.2109 30.296L22.9688 30.1747L13.9766 34.671L13.975 34.6716L13.9719 34.6731L13.9703 34.6736L13.9656 34.6756L13.9609 34.6775L13.9562 34.6791L13.9531 34.6805L13.9484 34.6819L13.9437 34.6831L13.9391 34.6842L13.9328 34.6852L13.9281 34.686L13.9234 34.6866L13.9187 34.6871L13.9141 34.6874L13.9094 34.6875H13.9047L13.8984 34.6874L13.8938 34.6871L13.8891 34.6866L13.8844 34.686L13.8797 34.6852L13.8734 34.6842L13.8688 34.6831L13.8641 34.6819L13.8609 34.6806L13.8563 34.6791L13.8516 34.6775L13.8469 34.6756L13.8422 34.6736L13.8375 34.6716L13.8359 34.671L1.33595 28.421C1.28282 28.3946 1.25 28.3405 1.25 28.2813V18.2813C1.25 18.2796 1.25 18.2777 1.25 18.276V18.2711L1.25156 18.2661V18.2647V18.2611V18.2594V18.2563L1.25313 18.2539V18.2513V18.2486L1.25469 18.2464V18.2435V18.2416L1.25626 18.2381V18.2369L1.25782 18.233L1.25938 18.228L1.26093 18.223L1.26406 18.218L1.26562 18.2139L1.26719 18.2096L1.27031 18.2052V18.2038L1.27188 18.201L1.27344 18.1991L1.27501 18.1967L1.27657 18.1947L1.27813 18.1927L1.27968 18.1902V18.1886L1.28281 18.186V18.1847L1.28593 18.1817V18.181L1.28906 18.1772L1.29375 18.1736L1.29688 18.1699L1.29999 18.1663L1.30468 18.1633L1.30781 18.16L1.30938 18.1592L1.31094 18.1569L1.3125 18.1558L1.31563 18.1539L1.3172 18.1527L1.3203 18.1511L1.32187 18.1497L1.32343 18.1483L1.32656 18.1467L1.32812 18.1458L1.33125 18.1441L1.33282 18.1433L1.33595 18.1416L10.3125 13.6535V13.4375C10.3125 13.3783 10.3453 13.3242 10.3984 13.2978L16.6484 10.1728C16.6922 10.1508 16.7453 10.1508 16.7891 10.1728L17.0312 10.2941ZM13.75 24.6278V34.2785L1.5625 28.1847V18.5341L13.75 24.6278ZM22.9313 19.8438L10.7812 13.7685L10.5391 13.8897L1.75625 18.2813L13.9062 24.3566L22.9313 19.8438ZM23.2812 19.6691L10.8516 13.4541C10.8391 13.4477 10.825 13.4433 10.8125 13.4406L16.7188 10.4872L29.1813 16.7188L23.2812 19.6691ZM17.3812 10.4688L29.5312 16.5441L38.5563 12.0313L26.4062 5.95596L17.3812 10.4688Z",
				fill: "#3D3D3D"
			})
		]
	});
})), gn = /* @__PURE__ */ we({ default: () => _n }), _n, vn = Se((() => {
	_n = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.7814 9.42711C16.5472 8.70914 17.3928 8.10054 18.2814 7.65633C20.0061 6.79398 21.5686 6.71273 22.6998 7.27851L36.4498 14.1535C35.3186 13.5877 33.7561 13.669 32.0314 14.5313C31.1422 14.9759 30.2962 15.5849 29.5301 16.3034L15.7814 30.1563H13.2814L2.03137 24.5313V23.2813L15.1467 10.0665C15.3511 9.84555 15.5628 9.63195 15.7812 9.42726L15.7814 9.42711Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.2814 36.4064H15.7814V30.1564H13.2814L2.03137 24.5314V30.7814L13.2814 36.4064ZM13.3684 25.7377L12.1184 26.9877L14.6184 28.2377L15.8684 26.9877L13.3684 25.7377ZM15.0872 24.0971L13.8372 25.3471L16.3372 26.5971L17.5872 25.3471L15.0872 24.0971ZM9.6184 23.8627L8.3684 25.1127L10.8684 26.3627L12.1184 25.1127L9.6184 23.8627ZM16.8059 22.4564L15.5559 23.7064L18.0559 24.9564L19.3059 23.7064L16.8059 22.4564ZM11.3372 22.2221L10.0872 23.4721L12.5872 24.7221L13.8372 23.4721L11.3372 22.2221ZM5.8684 21.9877L4.6184 23.2377L7.1184 24.4877L8.3684 23.2377L5.8684 21.9877ZM18.3684 20.7377L17.1184 21.9877L19.6184 23.2377L20.8684 21.9877L18.3684 20.7377ZM13.0559 20.5814L11.8059 21.8314L14.3059 23.0814L15.5559 21.8314L13.0559 20.5814ZM7.58715 20.3471L6.33715 21.5971L8.83715 22.8471L10.0872 21.5971L7.58715 20.3471ZM14.6184 18.8627L13.3684 20.1127L15.8684 21.3627L17.1184 20.1127L14.6184 18.8627ZM9.3059 18.7064L8.0559 19.9564L10.5559 21.2064L11.8059 19.9564L9.3059 18.7064ZM10.8684 16.9877L9.6184 18.2377L12.1184 19.4877L13.3684 18.2377L10.8684 16.9877ZM15.8684 11.3627V11.9877L26.7018 17.4049L27.1184 16.9877L15.8684 11.3627ZM19.6184 7.40022C19.5954 7.27053 19.5831 7.13301 19.5831 6.98769C19.5831 5.94863 20.0051 4.79553 20.6871 3.77209L30.7225 8.78926C30.0484 9.80176 29.6283 10.9393 29.6187 11.969L29.6184 11.9705V13.8627L19.6184 8.86269V7.40022Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.427 7.02521C19.4268 7.01271 19.4268 7.00022 19.4268 6.98772C19.4268 5.92053 19.857 4.73617 20.5572 3.68617C20.6007 3.62055 20.6865 3.59709 20.757 3.63303L30.7925 8.65024C30.8325 8.67055 30.862 8.70647 30.8736 8.75022C30.8851 8.79241 30.8775 8.83929 30.8525 8.87679C30.4576 9.46898 30.1511 10.1065 29.9676 10.7377L36.5198 14.0143C37.6981 14.6034 38.4376 15.8596 38.4376 17.6565C38.4376 21.1565 35.6011 25.4206 32.1012 27.1706C30.3223 28.0612 28.7098 28.133 27.5429 27.5487C27.5342 27.544 27.5253 27.5393 27.5167 27.5362L15.8779 36.5299C15.8526 36.5487 15.8211 36.5612 15.7865 36.5627H15.7836H15.7809H13.2814H13.2773H13.2759C13.2517 36.5612 13.2289 36.5549 13.2087 36.5456L1.96152 30.9206C1.90856 30.8956 1.87512 30.8408 1.87512 30.7815V23.2815C1.87512 23.2408 1.89137 23.2002 1.92043 23.1705C1.92043 23.1705 15.034 9.95803 15.0328 9.95959C15.2395 9.73616 15.4536 9.52055 15.6743 9.31274C16.4515 8.58461 17.3098 7.96742 18.2115 7.51586C18.6268 7.30961 19.0332 7.14553 19.427 7.02521ZM15.6251 30.3127V36.2502H13.4376V30.3127H15.6251ZM2.18762 24.7846L7.98981 27.6846L13.1251 30.2534V36.1534L2.18762 30.6846V24.7846ZM12.1876 31.094C12.1876 31.0346 12.1542 30.9799 12.1012 30.9534L3.35122 26.5784C3.30278 26.5549 3.24528 26.5581 3.19918 26.5862C3.15309 26.6143 3.12512 26.6643 3.12512 26.719V27.344C3.12512 27.4033 3.15856 27.4581 3.21152 27.4831L11.9615 31.8581C12.01 31.8831 12.0675 31.8799 12.1136 31.8518C12.1597 31.8237 12.1876 31.7737 12.1876 31.719V31.094ZM19.4514 7.34397C19.0945 7.45803 18.7268 7.60805 18.3512 7.79555C17.4757 8.23462 16.6429 8.8346 15.8883 9.54085H15.8881C15.6725 9.74398 15.4634 9.95492 15.2615 10.1721C15.2603 10.1737 15.2589 10.1752 15.2576 10.1768L2.18762 23.3456V24.4346L13.3183 30.0002H15.7164L28.82 16.7971C29.0058 16.5971 29.1976 16.4049 29.3947 16.2174L29.4204 16.1924C29.4267 16.1862 29.4332 16.1799 29.4403 16.1752C30.2131 15.4518 31.0656 14.8393 31.9615 14.3909C32.3592 14.1924 32.7487 14.0346 33.1265 13.9159L29.7747 12.233V13.1409L30.3134 13.4112C30.3662 13.4377 30.3997 13.4908 30.3997 13.5502C30.3997 13.6096 30.3662 13.6643 30.3134 13.6909L29.0634 14.3159C29.0193 14.3377 28.9676 14.3377 28.9236 14.3159L18.9236 9.31586C18.8706 9.2893 18.8372 9.23459 18.8372 9.17522C18.8372 9.11584 18.8706 9.06273 18.9236 9.03617L19.4622 8.76586V7.41427C19.4587 7.3924 19.4553 7.3721 19.4522 7.35023L19.4514 7.34397ZM15.7579 11.2518L12.0079 15.0018C11.9725 15.0377 11.9562 15.0877 11.9642 15.1377C11.9723 15.1877 12.0037 15.2299 12.0486 15.2534L23.2986 20.8784C23.3587 20.9081 23.4314 20.8956 23.479 20.8487L27.229 17.0987C27.2645 17.0627 27.2807 17.0127 27.2728 16.9627C27.2647 16.9127 27.2332 16.8705 27.1884 16.8487L15.9384 11.2237C15.8782 11.1924 15.8056 11.2049 15.7579 11.2518ZM26.4381 17.4471L15.8993 12.1784L12.7989 15.2784L23.3376 20.5471L26.4381 17.4471ZM16.0247 11.6159L26.8547 17.0315L26.6709 17.2143L16.0247 11.8909V11.6159ZM29.4626 11.9565L29.4622 13.6096L19.7747 8.76586V7.40024C19.7747 7.39086 19.7739 7.3815 19.7723 7.37212C19.7507 7.25181 19.7393 7.12365 19.7393 6.98772C19.7393 6.01428 20.122 4.94087 20.7417 3.97368L30.4961 8.85181C29.8636 9.84712 29.475 10.9518 29.4626 11.9565ZM20.7986 7.75336L22.9861 8.84711C23.0632 8.88461 23.1572 8.85337 23.1958 8.77681C23.2343 8.69868 23.2029 8.60492 23.1259 8.56742L20.9384 7.47367C20.8612 7.43461 20.7673 7.46585 20.7287 7.54241C20.6901 7.62054 20.7215 7.7143 20.7986 7.75336ZM20.7986 6.50336L25.1736 8.69086C25.2507 8.72836 25.3447 8.69712 25.3833 8.62056C25.4218 8.54243 25.3904 8.44867 25.3134 8.41117L20.9384 6.22367C20.8612 6.18461 20.7673 6.21585 20.7287 6.29241C20.6901 6.37054 20.7215 6.4643 20.7986 6.50336Z",
				fill: "#3D3D3D"
			})
		]
	});
})), yn = /* @__PURE__ */ we({ default: () => bn }), bn, xn = Se((() => {
	bn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.3438 17.5594V7.34375C22.3438 5.27344 24.0234 2.75312 26.0938 1.71875L36.0938 6.71875C34.0234 7.75313 32.3438 10.2734 32.3438 12.3438V26.0938C32.3438 27.4734 31.2234 29.1547 29.8438 29.8438C29.1547 30.1891 28.5297 30.2203 28.0766 29.9953L22.3438 27.1281V31.0938C22.3438 32.4734 21.2234 34.1547 19.8438 34.8438L13.5938 37.9688L3.59375 32.9688L9.84375 29.8438C11.2234 29.1547 12.3438 27.4734 12.3438 26.0938V18.5938C12.3438 17.2141 13.4641 15.5328 14.8438 14.8438C15.5328 14.4984 16.1578 14.4672 16.6109 14.6922L22.3438 17.5594Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.3438 23.5937V31.0937C22.3438 31.7828 22.0641 32.5484 21.611 33.2281L11.611 28.2281C12.0641 27.5484 12.3438 26.7828 12.3438 26.0937V18.5937C12.3438 17.9047 12.6234 17.1391 13.0766 16.4594L23.0766 21.4594C22.9719 21.6156 22.8766 21.7765 22.7922 21.9406C23.2453 21.0672 23.9953 20.2687 24.8438 19.8437C25.5328 19.4984 26.1578 19.4672 26.611 19.6922L22.3438 17.5593V7.34373C22.3438 6.30936 22.7641 5.16093 23.4422 4.14374L33.4422 9.14374C32.7641 10.1609 32.3438 11.3094 32.3438 12.3437V26.0937C32.3438 26.7828 32.0641 27.5484 31.611 28.2281L22.3438 23.5937Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.1875 17.3062V7.34375C22.1875 5.22343 23.9047 2.63907 26.0234 1.5797C26.0672 1.55782 26.1203 1.55782 26.1641 1.5797L36.1641 6.5797C36.2172 6.60626 36.25 6.65937 36.25 6.71875C36.25 6.77812 36.2172 6.83123 36.1641 6.85779C34.1437 7.86873 32.5 10.325 32.5 12.3437V26.0937C32.5 27.5234 31.3437 29.2687 29.9141 29.9828C29.1687 30.3562 28.4953 30.3781 28.0062 30.1344L22.5 27.3812V31.0937C22.5 32.5234 21.3437 34.2687 19.9141 34.9828L13.6641 38.1078C13.6203 38.1297 13.5672 38.1297 13.5234 38.1078L3.52345 33.1078C3.47032 33.0812 3.4375 33.0281 3.4375 32.9687C3.4375 32.9094 3.47032 32.8563 3.52345 32.8297L9.77345 29.7047C11.1031 29.0391 12.1875 27.4234 12.1875 26.0937V18.5937C12.1875 17.1641 13.3438 15.4188 14.7734 14.7047C15.5188 14.3313 16.1922 14.3094 16.6813 14.5531L22.1875 17.3062ZM25.6969 19.4094C25.4078 19.4469 25.0969 19.5422 24.7734 19.7047C23.3438 20.4188 22.1875 22.1641 22.1875 23.5937V31.0937C22.1875 32.4234 21.1031 34.0391 19.7734 34.7047L13.5938 37.7937L3.94375 32.9687L9.91405 29.9828C11.3437 29.2687 12.5 27.5234 12.5 26.0937V18.5937C12.5 17.2641 13.5844 15.6484 14.9141 14.9828C15.55 14.6656 16.1234 14.6234 16.5406 14.8328L25.6969 19.4094ZM8.52345 33.1078L13.5234 35.6078C13.6016 35.6469 13.6953 35.6156 13.7328 35.5391C13.7719 35.4609 13.7406 35.3672 13.6641 35.3297L8.66405 32.8297C8.58593 32.7906 8.49219 32.8219 8.45469 32.8984C8.41562 32.9766 8.44688 33.0703 8.52345 33.1078ZM11.0234 33.1078L13.5234 34.3578C13.6016 34.3969 13.6953 34.3656 13.7328 34.2891C13.7719 34.2109 13.7406 34.1172 13.6641 34.0797L11.1641 32.8297C11.0859 32.7906 10.9922 32.8219 10.9547 32.8984C10.9156 32.9766 10.9469 33.0703 11.0234 33.1078ZM11.0234 30.6078L18.5234 34.3578C18.6016 34.3969 18.6953 34.3656 18.7328 34.2891C18.7719 34.2109 18.7406 34.1172 18.6641 34.0797L11.1641 30.3297C11.0859 30.2906 10.9922 30.3219 10.9547 30.3984C10.9156 30.4766 10.9469 30.5703 11.0234 30.6078ZM18.1328 31.6625L19.7734 32.4828C19.8516 32.5219 19.9453 32.4906 19.9828 32.414C20.0219 32.3359 19.9906 32.2422 19.9141 32.2047L18.2734 31.3844C18.1953 31.3453 18.1016 31.3766 18.0641 31.4531C18.025 31.5313 18.0563 31.625 18.1328 31.6625ZM13.5234 26.8578L21.0234 30.6078C21.1016 30.6469 21.1953 30.6156 21.2328 30.539C21.2719 30.4609 21.2406 30.3672 21.1641 30.3297L13.6641 26.5797C13.5859 26.5406 13.4922 26.5719 13.4547 26.6484C13.4156 26.7266 13.4469 26.8203 13.5234 26.8578ZM12.9891 29.0906L14.7734 29.9828C14.8516 30.0219 14.9453 29.9906 14.9828 29.914C15.0219 29.8359 14.9906 29.7422 14.9141 29.7047L13.1297 28.8109C13.0516 28.7734 12.9578 28.8047 12.9188 28.8813C12.8813 28.9594 12.9125 29.0531 12.9891 29.0906ZM28.1469 29.8547C27.7406 29.6531 27.5 29.2125 27.5 28.5937V21.0937C27.5 20.3328 27.1797 19.8031 26.6813 19.5531L22.5 17.4625V7.34375C22.5 5.34687 24.1063 2.92501 26.0938 1.89376L35.7531 6.72344C33.7594 7.85938 32.1875 10.3141 32.1875 12.3437V26.0937C32.1875 27.4234 31.1031 29.0391 29.7734 29.7047C29.1375 30.0219 28.5641 30.0641 28.1469 29.8547ZM28.5234 28.1078L29.1484 28.4203C29.2266 28.4594 29.3203 28.4281 29.3578 28.3515C29.3969 28.2734 29.3656 28.1797 29.2891 28.1422L28.6641 27.8297C28.5859 27.7906 28.4922 27.8219 28.4547 27.8984C28.4156 27.9766 28.4469 28.0703 28.5234 28.1078ZM19.1484 27.1703L20.3984 27.7953C20.4766 27.8344 20.5703 27.8031 20.6078 27.7265C20.6469 27.6484 20.6156 27.5547 20.5391 27.5172L19.2891 26.8922C19.2109 26.8531 19.1172 26.8844 19.0797 26.9609C19.0406 27.0391 19.0719 27.1328 19.1484 27.1703ZM29.1484 25.8141L30.3984 26.4391C30.4766 26.4766 30.5703 26.4453 30.6078 26.3687C30.6469 26.2906 30.6156 26.1969 30.5391 26.1594L29.2891 25.5344C29.2109 25.4953 29.1172 25.5266 29.0797 25.6031C29.0406 25.6813 29.0719 25.775 29.1484 25.8141ZM19.1484 24.6703L20.3984 25.2953C20.4766 25.3344 20.5703 25.3031 20.6078 25.2265C20.6469 25.1484 20.6156 25.0547 20.5391 25.0172L19.2891 24.3922C19.2109 24.3531 19.1172 24.3844 19.0797 24.4609C19.0406 24.5391 19.0719 24.6328 19.1484 24.6703ZM14.1484 23.4203L16.3359 24.514C16.4141 24.5531 16.5078 24.5219 16.5453 24.4453C16.5844 24.3672 16.5531 24.2734 16.4766 24.2359L14.2891 23.1422C14.2109 23.1031 14.1172 23.1344 14.0797 23.2109C14.0406 23.2891 14.0719 23.3828 14.1484 23.4203ZM29.6172 23.5484L30.3984 23.9391C30.4766 23.9766 30.5703 23.9453 30.6078 23.8687C30.6469 23.7906 30.6156 23.6969 30.5391 23.6594L29.7578 23.2687C29.6797 23.2297 29.5859 23.2609 29.5484 23.3375C29.5094 23.4156 29.5406 23.5094 29.6172 23.5484ZM19.7734 22.4828L20.3984 22.7953C20.4766 22.8344 20.5703 22.8031 20.6078 22.7265C20.6469 22.6484 20.6156 22.5547 20.5391 22.5172L19.9141 22.2047C19.8359 22.1656 19.7422 22.1969 19.7047 22.2734C19.6656 22.3516 19.6969 22.4453 19.7734 22.4828ZM14.1484 20.9203L17.8984 22.7953C17.9766 22.8344 18.0703 22.8031 18.1078 22.7265C18.1469 22.6484 18.1156 22.5547 18.0391 22.5172L14.2891 20.6422C14.2109 20.6031 14.1172 20.6344 14.0797 20.7109C14.0406 20.7891 14.0719 20.8828 14.1484 20.9203ZM29.1484 20.9203L30.3984 21.5453C30.4766 21.5844 30.5703 21.5531 30.6078 21.4766C30.6469 21.3984 30.6156 21.3047 30.5391 21.2672L29.2891 20.6422C29.2109 20.6031 29.1172 20.6344 29.0797 20.7109C29.0406 20.7891 29.0719 20.8828 29.1484 20.9203ZM19.7734 19.9828L21.0234 20.6078C21.1016 20.6469 21.1953 20.6156 21.2328 20.5391C21.2719 20.4609 21.2406 20.3672 21.1641 20.3297L19.9141 19.7047C19.8359 19.6656 19.7422 19.6969 19.7047 19.7734C19.6656 19.8516 19.6969 19.9453 19.7734 19.9828ZM14.4609 18.5765L17.5859 20.139C17.6641 20.1781 17.7578 20.1469 17.7953 20.0703C17.8344 19.9922 17.8031 19.8985 17.7266 19.861L14.6016 18.2985C14.5234 18.2594 14.4297 18.2906 14.3922 18.3672C14.3531 18.4453 14.3844 18.539 14.4609 18.5765ZM29.1484 18.4203L30.3984 19.0453C30.4766 19.0844 30.5703 19.0531 30.6078 18.9766C30.6469 18.8984 30.6156 18.8047 30.5391 18.7672L29.2891 18.1422C29.2109 18.1031 29.1172 18.1344 29.0797 18.2109C29.0406 18.2891 29.0719 18.3828 29.1484 18.4203ZM24.1484 17.1703L26.6484 18.4203C26.7266 18.4594 26.8203 18.4281 26.8578 18.3516C26.8969 18.2734 26.8656 18.1797 26.7891 18.1422L24.2891 16.8922C24.2109 16.8531 24.1172 16.8844 24.0797 16.9609C24.0406 17.0391 24.0719 17.1328 24.1484 17.1703ZM15.7109 16.7015L18.8359 18.264C18.9141 18.3031 19.0078 18.2719 19.0453 18.1953C19.0844 18.1172 19.0531 18.0235 18.9766 17.986L15.8516 16.4235C15.7734 16.3844 15.6797 16.4156 15.6422 16.4922C15.6031 16.5703 15.6344 16.664 15.7109 16.7015ZM24.1484 14.6703L27.8984 16.5453C27.9766 16.5844 28.0703 16.5531 28.1078 16.4766C28.1469 16.3984 28.1156 16.3047 28.0391 16.2672L24.2891 14.3922C24.2109 14.3531 24.1172 14.3844 24.0797 14.4609C24.0406 14.5391 24.0719 14.6328 24.1484 14.6703ZM29.7734 16.2328L30.3984 16.5453C30.4766 16.5844 30.5703 16.5531 30.6078 16.4766C30.6469 16.3984 30.6156 16.3047 30.5391 16.2672L29.9141 15.9547C29.8359 15.9156 29.7422 15.9469 29.7047 16.0234C29.6656 16.1016 29.6969 16.1953 29.7734 16.2328ZM29.1484 13.4203L30.3984 14.0453C30.4766 14.0844 30.5703 14.0531 30.6078 13.9766C30.6469 13.8984 30.6156 13.8047 30.5391 13.7672L29.2891 13.1422C29.2109 13.1031 29.1172 13.1344 29.0797 13.2109C29.0406 13.2891 29.0719 13.3828 29.1484 13.4203ZM24.1484 12.1703L26.0234 13.1078C26.1016 13.1469 26.1953 13.1156 26.2328 13.0391C26.2719 12.9609 26.2406 12.8672 26.1641 12.8297L24.2891 11.8922C24.2109 11.8531 24.1172 11.8844 24.0797 11.9609C24.0406 12.0391 24.0719 12.1328 24.1484 12.1703ZM24.1484 9.67029L28.5234 11.8578C28.6016 11.8969 28.6953 11.8656 28.7328 11.7891C28.7719 11.7109 28.7406 11.6172 28.6641 11.5797L24.2891 9.3922C24.2109 9.35314 24.1172 9.38438 24.0797 9.46094C24.0406 9.53907 24.0719 9.63279 24.1484 9.67029ZM23.5234 6.85779L31.3359 10.764C31.4141 10.8031 31.5078 10.7719 31.5453 10.6953C31.5844 10.6172 31.5531 10.5234 31.4766 10.4859L23.6641 6.5797C23.5859 6.54064 23.4922 6.57188 23.4547 6.64844C23.4156 6.72657 23.4469 6.82029 23.5234 6.85779ZM27.2469 6.21406L29.1484 7.14374C29.2266 7.18124 29.3203 7.14843 29.3578 7.07187C29.3953 6.99375 29.3641 6.89998 29.2859 6.86248L27.3844 5.9328C27.3078 5.8953 27.2141 5.92655 27.175 6.00467C27.1375 6.08123 27.1703 6.175 27.2469 6.21406ZM27.2469 4.99687L31.05 6.89842C31.1266 6.93748 31.2203 6.90624 31.2594 6.82968C31.2969 6.75155 31.2656 6.65783 31.1891 6.62033L27.3859 4.71717C27.3094 4.67967 27.2141 4.71092 27.1766 4.78748C27.1375 4.8656 27.1688 4.95937 27.2469 4.99687Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Sn = /* @__PURE__ */ we({ default: () => Cn }), Cn, wn = Se((() => {
	Cn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M31.7188 15.7812L19.2188 6.40625L6.71875 3.28125C6.71875 3.28125 6.71875 11.1344 6.71875 17.4313C6.71875 22.1656 9.39375 27.8312 13.6286 32.0656C16.5189 34.9562 19.2188 37.6562 19.2188 37.6562H24.8089C29.0438 37.6562 31.7188 34.6656 31.7188 29.9313C31.7188 23.6344 31.7188 15.7812 31.7188 15.7812Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.2188 8.28125L8.59375 5.71877C8.59375 5.71877 8.59375 12.6297 8.59375 18.1703C8.59375 22.3375 10.8675 27.2828 14.467 30.9453C16.9237 33.4453 19.2188 35.7812 19.2188 35.7812C19.2188 35.7812 21.5138 35.7406 23.9705 35.6969C25.0855 35.6781 26.0734 35.4078 26.9061 34.9203C28.7606 33.8344 29.8438 31.6719 29.8438 28.7953V27.3438L18.5938 21.7188C18.5938 15.4688 19.8438 8.75469 19.8438 8.75469L19.2188 8.28125ZM9.21875 17.0312V17.8578C9.21875 22.025 11.4925 26.9703 15.092 30.6328L19.8438 35.4688L19.8402 35.45C19.767 35.0781 18.5938 28.9844 18.5938 21.7188L9.21875 17.0312ZM19.2188 6.40625L31.7188 15.7812L33.5938 14.8438L21.0938 5.46875L8.59375 2.34375L6.71875 3.28125L19.2188 6.40625Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.64906 3.14219L6.645 3.14376H6.64344L6.64109 3.14528L6.63734 3.14841H6.63562L6.63359 3.14998L6.62984 3.15311C6.61984 3.15935 6.61094 3.16719 6.60297 3.17657C6.60094 3.17813 6.59906 3.18126 6.59734 3.18282L6.59609 3.18435L6.59438 3.18591L6.59187 3.1906L6.59078 3.19217L6.58922 3.19373L6.58688 3.19686L6.58594 3.19842L6.58453 3.20155L6.58235 3.20468L6.58156 3.20624L6.58031 3.20937L6.57828 3.2125L6.5775 3.21406L6.5764 3.21719L6.57469 3.22032L6.57406 3.22188L6.57297 3.22497L6.57141 3.22967C6.57047 3.23123 6.56969 3.23436 6.5689 3.23749C6.56812 3.24061 6.56719 3.24374 6.56656 3.24531C6.56453 3.25468 6.56328 3.26404 6.56281 3.27186C6.56266 3.27498 6.5625 3.27812 6.5625 3.28124C6.5625 3.28124 6.5625 11.1344 6.5625 17.4312C6.5625 22.2 9.25203 27.9109 13.5181 32.1765C16.4083 35.0672 19.1083 37.7672 19.1083 37.7672C19.1375 37.7953 19.1773 37.8125 19.2188 37.8125H24.8089C26.0794 37.8125 27.2122 37.5484 28.1791 37.0531L29.9489 36.1687C30.675 35.8141 31.3103 35.3312 31.8433 34.7359C33.0639 33.3719 33.75 31.4047 33.75 28.9938C33.75 22.6969 33.75 14.8437 33.75 14.8437V14.839L33.7497 14.8344C33.7495 14.8297 33.7491 14.825 33.7483 14.8219L33.7475 14.8156L33.7467 14.8125L33.7456 14.8078L33.7447 14.8031L33.7441 14.8015L33.7434 14.7984L33.742 14.7937L33.7405 14.7906L33.7389 14.7859L33.7372 14.7813L33.7355 14.7781L33.7344 14.7766L33.7334 14.7734L33.7314 14.7703L33.7291 14.7656L33.7269 14.7625L33.7245 14.7578C33.723 14.7562 33.7212 14.7531 33.7195 14.7515L33.7166 14.7468L33.7138 14.7438L33.7108 14.7406L33.7078 14.7375L33.7062 14.7359L33.7047 14.7344L33.7014 14.7312L33.698 14.7281L33.6944 14.725L33.6909 14.7219C33.6898 14.7203 33.6886 14.7203 33.6875 14.7187L21.1883 5.34373C21.1828 5.34061 21.1773 5.33591 21.1714 5.33278L21.1681 5.33126L21.1655 5.32969L21.1614 5.32813L21.1569 5.32657L21.1544 5.325L21.1511 5.32344L21.1484 5.32187L21.1444 5.32031L21.1392 5.31875H21.1367L21.1345 5.31718C21.1334 5.31718 21.1323 5.31718 21.1312 5.31718L8.63172 2.19218C8.59547 2.18281 8.55719 2.18751 8.52391 2.20469L6.64906 3.14219ZM19.1503 6.54998L31.5625 15.8594V29.9313C31.5625 32.2531 30.9111 34.15 29.7355 35.4641C28.5653 36.7734 26.8769 37.5 24.8089 37.5H19.2834L13.7391 31.9562C9.53547 27.7516 6.875 22.1312 6.875 17.4312V3.48125L19.1503 6.54998ZM26.985 35.0547C28.8819 33.9453 30 31.7375 30 28.7953C30 23.2547 30 16.3438 30 16.3438C30 16.2953 29.9772 16.2484 29.9381 16.2187L19.3131 8.15623C19.2961 8.14373 19.2764 8.13437 19.2553 8.12968L8.63031 5.56716C8.58391 5.55622 8.53469 5.56562 8.49703 5.59531C8.45953 5.625 8.4375 5.67032 8.4375 5.71876C8.4375 5.71876 8.4375 12.6297 8.4375 18.1703C8.4375 22.3719 10.7258 27.3609 14.3556 31.0547C16.8123 33.5547 19.1073 35.8906 19.1073 35.8906C19.1373 35.9219 19.1786 35.9391 19.2216 35.9375C19.2216 35.9375 21.5164 35.8969 23.9731 35.8531C25.1173 35.8328 26.1306 35.5547 26.985 35.0547ZM10.8787 24.9515L10.5319 25.125C11.5305 27.1672 12.9117 29.1406 14.5786 30.8359L19.2831 35.6234L19.7886 35.614C19.7794 35.6109 19.7706 35.6078 19.7623 35.6016H19.7602L19.7567 35.5984L19.7536 35.5969L19.7503 35.5938L19.7472 35.5922L19.7441 35.5891L19.7411 35.5859L19.7381 35.5844L19.7353 35.5812C19.7342 35.5797 19.7333 35.5797 19.7323 35.5781C19.7323 35.5781 17.4373 33.2422 14.9806 30.7422C13.2906 29.0234 11.8914 27.0219 10.8787 24.9515ZM9.375 6.06875V17.8578C9.375 21.9891 11.6342 26.8922 15.2036 30.5234L19.9081 35.3109L24.5927 35.2281H24.612H24.6313L24.6505 35.2265H24.6697H24.6889H24.7081L24.7273 35.225H24.7464L24.7655 35.2234H24.7845L24.8036 35.2219L24.8227 35.2203H24.8416L24.8605 35.2187L24.8794 35.2172H24.8983L24.9172 35.2156L24.9359 35.2141L24.9547 35.2125H24.9734L24.9922 35.2109L25.0109 35.2094L25.0295 35.2078L25.0481 35.2063L25.0667 35.2047L25.0853 35.2031C25.7175 35.1469 26.3034 35.0031 26.8366 34.7797C28.643 33.7172 29.6875 31.6 29.6875 28.7953V16.4219L19.1503 8.42498L9.375 6.06875ZM19.5147 6.43279L21.0772 5.65154L33.2978 14.8172L31.7353 15.5984L19.5147 6.43279ZM20.6461 5.51875L20.1027 5.78906L19.2006 6.24061L7.1664 3.23123L8.61187 2.50937L20.6461 5.51875Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Tn = /* @__PURE__ */ we({ default: () => En }), En, Dn = Se((() => {
	En = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M33.2812 34.2188L25.7812 37.9688L27.6562 32.8125L33.2812 34.2188Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.2812 1.71875L12.0312 3.59375L8.28125 4.21875L7.03125 28.5938L25.7812 37.9688L28.2812 34.2188H33.2812L32.0312 11.0938L13.2812 1.71875Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.2468 1.56564C13.2671 1.56252 13.2875 1.56096 13.3078 1.56408L13.3093 1.56564H13.3124L13.3171 1.56721L13.3218 1.56877H13.325L13.3296 1.57034L13.3328 1.5719H13.3343C13.3406 1.57346 13.3468 1.57658 13.3531 1.5797L32.1015 10.9547H32.1031L32.1062 10.9563L32.1109 10.9594L32.1156 10.961L32.1187 10.9641L32.1218 10.9656L32.1249 10.9688C32.1265 10.9688 32.1265 10.9703 32.1281 10.9703L32.1296 10.9719L32.1328 10.975C32.1343 10.9766 32.1343 10.9766 32.1359 10.9766L32.139 10.9813L32.1421 10.9828L32.1453 10.986L32.1468 10.9891L32.15 10.9922L32.1531 10.9953L32.1546 10.9985L32.1562 11L32.1593 11.0031L32.1609 11.0063L32.1624 11.0078L32.164 11.0125L32.1656 11.0156L32.1671 11.0172L32.1703 11.0219V11.025L32.1718 11.0266L32.1734 11.0297L32.175 11.0344L32.1781 11.0391L32.1796 11.0438V11.0453V11.0469L32.1812 11.0516L32.1828 11.0531C32.1828 11.0547 32.1828 11.0563 32.1828 11.0578L32.1843 11.0625L32.1859 11.0672V11.0703V11.075V11.0766L32.1875 11.0813V11.0828C32.1875 11.0844 32.1875 11.0844 32.1875 11.0859L33.4375 34.2109C33.439 34.2359 33.4343 34.261 33.4234 34.2828L33.4218 34.286L33.4203 34.2891L33.4171 34.2953L33.4156 34.3L33.4124 34.3031V34.3047L33.4093 34.3078V34.3094C33.3953 34.3266 33.3781 34.3438 33.3593 34.3547L33.3546 34.3563L33.3515 34.3578L25.8515 38.1078C25.8499 38.1094 25.8484 38.1094 25.8468 38.111L25.8421 38.1125L25.8375 38.1141L25.8359 38.1156C25.8249 38.1188 25.814 38.1219 25.8031 38.1234H25.8C25.7812 38.1266 25.764 38.125 25.7453 38.1203H25.7406L25.739 38.1188H25.7359C25.7281 38.1156 25.7203 38.1125 25.7125 38.1094L25.7093 38.1078L6.9609 28.7328C6.90621 28.7063 6.87183 28.6484 6.87495 28.5859L8.12495 4.21095C8.12495 4.20782 8.12495 4.20471 8.12652 4.20158V4.19533L8.12808 4.19063V4.18596L8.12964 4.1844C8.13433 4.1594 8.14526 4.13908 8.16089 4.12033L8.16401 4.11564L8.16714 4.11251L8.17027 4.1094L8.1734 4.10627L8.17651 4.10314L8.1812 4.09845L8.18276 4.09689L8.18589 4.09532C8.20308 4.08126 8.22183 4.0719 8.2437 4.06721H8.24683L8.25152 4.06564L8.2562 4.06408L11.939 3.45157L13.1515 1.63126L13.1531 1.62815L13.1562 1.62502L13.1578 1.62189L13.1609 1.61876C13.1749 1.60314 13.1906 1.58908 13.2093 1.5797H13.2109L13.214 1.57814L13.2187 1.57657L13.2234 1.57345L13.2281 1.5719L13.2328 1.57034L13.2374 1.56877H13.2406L13.2437 1.56721L13.2468 1.56564ZM26.8703 13.6875L25.6374 37.7219L7.19214 28.5L8.42496 4.46563L26.8703 13.6875ZM28.3656 34.375L26.2375 37.5656L32.6187 34.375H28.3656ZM31.8843 11.2766L33.1156 34.0625H28.4375V11.8516L31.8843 11.2766ZM13.4375 9.68752V12.1875C13.4375 14.3188 15.189 16.9391 17.3609 18.025C18.5015 18.5953 19.5374 18.6344 20.2874 18.2734C21.0624 17.9 21.5625 17.0985 21.5625 15.9375V13.4375C21.5625 13.2656 21.4218 13.125 21.25 13.125C21.0781 13.125 20.9375 13.2656 20.9375 13.4375V15.9375C20.9375 16.8094 20.5984 17.4297 20.0156 17.7094C19.4062 18.0031 18.5687 17.9297 17.639 17.4656C15.6718 16.4813 14.0625 14.1203 14.0625 12.1875V9.68752C14.0625 9.51564 13.9218 9.37502 13.75 9.37502C13.5781 9.37502 13.4375 9.51564 13.4375 9.68752ZM28.2562 11.5641L31.5312 11.0188L13.4531 1.97971L13.7265 6.76721L26.9781 13.3922L28.15 11.6328C28.1515 11.6313 28.1531 11.6297 28.1531 11.6281L28.1562 11.625C28.164 11.6141 28.1734 11.6047 28.1843 11.5953L28.1875 11.5938C28.2031 11.5813 28.2234 11.5719 28.2453 11.5672L28.2484 11.5656C28.2515 11.5656 28.2546 11.5656 28.2562 11.5641ZM25 9.88126C25.2015 9.98126 25.364 10.2266 25.364 10.4281C25.364 10.6281 25.2015 10.711 25 10.6094C24.7984 10.5094 24.6359 10.2641 24.6359 10.0625C24.6359 9.86096 24.7984 9.7797 25 9.88126ZM18.75 6.75626C18.9515 6.85626 19.114 7.10158 19.114 7.30314C19.114 7.50314 18.9515 7.58596 18.75 7.4844C18.5484 7.3844 18.3859 7.13908 18.3859 6.93752C18.3859 6.73596 18.5484 6.6547 18.75 6.75626ZM8.78119 4.29376L11.875 5.84064V3.77815L8.78119 4.29376Z",
				fill: "#3D3D3D"
			})
		]
	});
})), On = /* @__PURE__ */ we({ default: () => kn }), kn, An = Se((() => {
	kn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.9062 17.9688L20.1562 17.3438L38.9062 26.7188L20.1562 36.0938L1.40625 26.7188L7.65625 23.5938V19.8438V19.8478C7.65469 20.1898 7.375 20.3281 7.03125 20.1562C6.68594 19.9837 6.40625 19.5637 6.40625 19.2188C6.40625 19.5637 6.12656 19.7038 5.78125 19.5312C5.43594 19.3587 5.15625 18.9387 5.15625 18.5938V18.5978C5.15469 18.9398 4.875 19.0781 4.53125 18.9062C4.18594 18.7337 3.90625 18.3138 3.90625 17.9688C3.90625 18.3138 3.62656 18.4538 3.28125 18.2812C2.93594 18.1088 2.65625 17.6888 2.65625 17.3438V15.4688L6.40625 11.7188L18.9062 17.9688ZM12.6562 6.09375L10.1562 4.84375L8.90625 5.46875L11.4062 6.71875L6.40625 9.21875L20.1562 16.0938L33.9062 9.21875L20.1562 2.34375L12.6562 6.09375Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.1562 36.0938L1.40625 26.7188V27.9688L20.1562 37.3438V36.0938ZM14.5312 30.7812L6.40625 26.5994V17.3438L10.1562 13.5938L8.90625 12.9688L5.15625 16.7188V18.5938C5.15625 18.9388 4.87656 19.0787 4.53125 18.9062C4.18594 18.7338 3.90625 18.3138 3.90625 17.9688V16.0938L7.65625 12.3438L6.40625 11.7188V9.21875L20.1562 16.0938V33.5938L18.2812 32.6562V22.6562L16.8234 21.927L20.1562 18.5938L18.9062 17.9688L15.1562 21.7188V23.5938C15.1562 23.9387 14.8766 24.0788 14.5312 23.9062V30.7812ZM7.65625 24.2188V17.9688L11.4062 14.2188L12.6562 14.8438L8.90625 18.5938V20.4688C8.90625 20.8137 9.18594 21.2337 9.53125 21.4062C9.87656 21.5788 10.1562 21.4387 10.1562 21.0938V19.2188L13.9062 15.4688L15.1562 16.0938L11.4062 19.8438V21.7188C11.4062 22.0637 11.6859 22.4837 12.0312 22.6562C12.3766 22.8288 12.6562 22.6887 12.6562 22.3438V20.4688L16.4062 16.7188L17.6562 17.3438L13.9062 21.0938V22.9688C13.9062 23.3137 13.6266 23.4538 13.2812 23.2812V27.0312L7.65625 24.2188ZM8.90625 9.21875L10.1562 9.84375V10.4688L10.7812 10.7812V10.1562L15.7812 12.6562V13.2812L16.4062 13.5938V12.9688L17.6562 13.5938V9.84375L8.90625 5.46875V9.21875ZM31.4062 9.21875L20.1562 3.59375V4.84375L30.1562 9.84375L31.4062 9.21875Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.6562 5.91908L20.0859 2.20408C20.1297 2.18205 20.1828 2.18205 20.2266 2.20408L33.9766 9.07893L33.9859 9.08393C33.9984 9.09143 34.0094 9.10049 34.0187 9.11096L34.0391 9.1355L34.0484 9.15487C34.0547 9.16784 34.0594 9.18175 34.0609 9.19612L34.0625 9.21877V24.1222L38.9766 26.5789L38.9859 26.5839C38.9984 26.5914 39.0094 26.6005 39.0187 26.611L39.0391 26.6355L39.0484 26.6549C39.0547 26.6678 39.0594 26.6817 39.0609 26.6961L39.0625 26.7188V27.9688C39.0625 28.028 39.0297 28.0821 38.9766 28.1085L20.2266 37.4833L20.1984 37.4944L20.1672 37.4996L20.1422 37.4994L20.1125 37.4936L20.0859 37.4833L1.33595 28.1085C1.28282 28.0821 1.25 28.028 1.25 27.9688V26.7071L1.25156 26.6961C1.25313 26.6817 1.25783 26.6678 1.26408 26.6549L1.27811 26.6282L1.29375 26.611C1.30313 26.6005 1.31406 26.5914 1.32656 26.5839L1.33595 26.5789L6.25 24.1222V19.7277C6.10625 19.7824 5.9172 19.7738 5.71095 19.671C5.45938 19.545 5.23906 19.3024 5.1125 19.0406C5.09062 19.0575 5.06719 19.0722 5.04063 19.0849C4.89219 19.1582 4.68751 19.1589 4.46095 19.046C4.20938 18.92 3.98906 18.6774 3.8625 18.4156C3.84062 18.4321 3.81719 18.4464 3.79375 18.4588C3.64375 18.5331 3.43751 18.5344 3.21095 18.421C2.81563 18.2235 2.5 17.7389 2.5 17.3438V15.4688C2.5 15.4274 2.51719 15.3875 2.54532 15.3583L6.25 11.6541V9.20987L6.25156 9.19612C6.25313 9.18175 6.25783 9.16784 6.26408 9.15487L6.27811 9.12815L6.29375 9.11096C6.30313 9.10049 6.31406 9.09143 6.32656 9.08393L6.33595 9.07893L8.75 7.87221V5.45987L8.75156 5.44612C8.75313 5.43174 8.75783 5.41784 8.76408 5.40487L8.77811 5.37815L8.79375 5.36096C8.80313 5.35049 8.81406 5.34143 8.82656 5.33393L8.83595 5.32893L10.0859 4.70408C10.1297 4.68205 10.1828 4.68205 10.2266 4.70408L12.6562 5.91908ZM11.1516 31.766L20 36.1903V37.091L1.5625 27.8722V26.9716L11.1516 31.766ZM16.8531 22.1172L16.5625 22.4085V24.2188C16.5625 24.4628 16.4531 24.6288 16.2938 24.7088C16.1438 24.7831 15.9375 24.7844 15.7109 24.671C15.5625 24.5969 15.4266 24.4824 15.3125 24.3474V30.4688C15.3125 30.528 15.2797 30.5821 15.2266 30.6085L14.6016 30.9208L14.5734 30.9317L14.5438 30.9371L14.5203 30.9372C14.5094 30.9363 14.4969 30.9342 14.4859 30.9306L14.4594 30.9202L6.33438 26.7383C6.28282 26.7116 6.25 26.658 6.25 26.5994V24.4716L1.75625 26.7188L20.1562 35.9191L38.5563 26.7188L34.0625 24.4716V26.7188C34.0625 26.778 34.0297 26.8321 33.9766 26.8585L20.2266 33.7333L20.1984 33.7444L20.1672 33.7496L20.1422 33.7494L20.1125 33.7436L20.0859 33.7333L18.2109 32.796C18.1578 32.7696 18.125 32.7155 18.125 32.6563V22.7528L16.8531 22.1172ZM20 18.971V33.341L18.4375 32.5597V22.6563C18.4375 22.5971 18.4047 22.543 18.3516 22.5166L17.0875 21.8842L20 18.971ZM6.5625 19.9724V26.5041L14.375 30.5252V23.9975C14.1594 23.8635 13.975 23.6471 13.8625 23.4156C13.8406 23.4321 13.8172 23.4464 13.7938 23.4588C13.6953 23.5075 13.5734 23.5249 13.4375 23.4992V27.03L13.4359 27.0586C13.4328 27.0689 13.4297 27.0791 13.4266 27.0888L13.4234 27.0946C13.4172 27.1108 13.4062 27.1258 13.3937 27.1391L13.3703 27.1591V27.1594C13.3578 27.1682 13.3453 27.1749 13.3313 27.1796L13.3015 27.1861L13.2812 27.1875C13.2625 27.1875 13.2453 27.1844 13.2281 27.178L13.2109 27.171L7.58595 24.3586L7.56092 24.3425L7.53906 24.3219L7.52186 24.2975L7.50782 24.2696L7.50156 24.2394L7.5 24.2188V20.3527C7.35625 20.4074 7.1672 20.3988 6.96095 20.296C6.81251 20.2219 6.67656 20.1074 6.5625 19.9724ZM8.00625 24.2188L8.28125 24.081L12.9688 26.4246L13.0469 26.7396L8.00625 24.2188ZM13.125 23.3725C12.9094 23.2385 12.725 23.0221 12.6125 22.7906C12.5906 22.8071 12.5672 22.8214 12.5438 22.8338C12.3938 22.9081 12.1875 22.9094 11.9609 22.796C11.7094 22.67 11.4891 22.4274 11.3625 22.1656C11.3406 22.1821 11.3172 22.1964 11.2938 22.2088C11.1438 22.2831 10.9375 22.2844 10.7109 22.171C10.4594 22.045 10.2391 21.8024 10.1125 21.5406C10.0906 21.5571 10.0672 21.5714 10.0438 21.5838C9.89375 21.6581 9.68751 21.6594 9.46095 21.546C9.20938 21.42 8.98906 21.1774 8.8625 20.9156C8.84062 20.9321 8.81719 20.9464 8.79375 20.9588C8.69532 21.0075 8.57344 21.0249 8.4375 20.9992V23.8097L13.125 26.1535V23.3725ZM12.8125 22.3469C12.8125 22.3496 12.8125 22.3421 12.8125 22.3414C12.8109 22.2563 12.7422 22.1875 12.6562 22.1875C12.5703 22.1875 12.5 22.2575 12.5 22.3438C12.5 22.4449 12.4687 22.5211 12.4031 22.5542C12.325 22.5931 12.2187 22.5756 12.1016 22.5166C11.8062 22.3692 11.5625 22.0135 11.5625 21.7188C11.5625 21.6325 11.4922 21.5625 11.4062 21.5625C11.3203 21.5625 11.25 21.6325 11.25 21.7188C11.25 21.8199 11.2187 21.8961 11.1531 21.9292C11.075 21.9681 10.9687 21.9506 10.8516 21.8916C10.5562 21.7442 10.3125 21.3885 10.3125 21.0938C10.3125 21.0075 10.2422 20.9375 10.1562 20.9375C10.0703 20.9375 10 21.0075 10 21.0938C10 21.1949 9.96873 21.2711 9.90311 21.3042C9.82498 21.3431 9.71874 21.3256 9.60155 21.2666C9.30624 21.1192 9.0625 20.7635 9.0625 20.4688C9.0625 20.3825 8.99219 20.3125 8.90625 20.3125C8.82031 20.3125 8.75 20.3825 8.75 20.4688C8.75 20.5699 8.71873 20.6461 8.65311 20.6792C8.57498 20.7181 8.46874 20.7006 8.35155 20.6416C8.05624 20.4942 7.8125 20.1385 7.8125 19.8438C7.8125 19.7575 7.74219 19.6875 7.65625 19.6875C7.57031 19.6875 7.5 19.7574 7.5 19.8433V19.8467C7.5 19.9467 7.46873 20.0221 7.40311 20.0546C7.32498 20.093 7.21874 20.0755 7.10155 20.0166C6.80624 19.8692 6.5625 19.5135 6.5625 19.2188C6.5625 19.1325 6.49219 19.0625 6.40625 19.0625C6.32031 19.0625 6.25 19.1325 6.25 19.2188C6.25 19.3199 6.21873 19.3961 6.15311 19.4292C6.07498 19.4681 5.96874 19.4506 5.85155 19.3916C5.55624 19.2442 5.3125 18.8885 5.3125 18.5938C5.3125 18.5075 5.24219 18.4375 5.15625 18.4375C5.07031 18.4375 5 18.5074 5 18.5933V18.5967C5 18.6967 4.96873 18.7721 4.90311 18.8046C4.82498 18.843 4.71874 18.8255 4.60155 18.7666C4.30624 18.6192 4.0625 18.2635 4.0625 17.9688C4.0625 17.8825 3.99219 17.8125 3.90625 17.8125C3.82031 17.8125 3.75 17.8825 3.75 17.9688C3.75 18.0699 3.71873 18.1461 3.65311 18.1792C3.57498 18.2181 3.46874 18.2006 3.35155 18.1416C3.05624 17.9942 2.8125 17.6385 2.8125 17.3438V15.5335L6.43749 11.9089L19.8922 18.6366L16.2953 22.2333C16.2672 22.2625 16.25 22.3024 16.25 22.3438V24.2188C16.25 24.3199 16.2187 24.3961 16.1531 24.4292C16.075 24.4681 15.9687 24.4506 15.8516 24.3916C15.5562 24.2442 15.3125 23.8885 15.3125 23.5938C15.3125 23.5075 15.2422 23.4375 15.1562 23.4375C15.0703 23.4375 15 23.5075 15 23.5938C15 23.6949 14.9687 23.7711 14.9031 23.8042C14.825 23.8431 14.7187 23.8256 14.6016 23.7666C14.3062 23.6192 14.0625 23.2635 14.0625 22.9688C14.0625 22.8825 13.9922 22.8125 13.9062 22.8125C13.8203 22.8125 13.75 22.8825 13.75 22.9688C13.75 23.0699 13.7187 23.1461 13.6531 23.1792C13.575 23.2181 13.4687 23.2006 13.3516 23.1416C13.0578 22.9947 12.8141 22.641 12.8125 22.3469ZM9.09843 10.7399L6.5625 9.47159V11.6222L20 18.341V16.1903L9.09843 10.7399ZM13.0062 6.09377L13.9062 6.54409L20.0859 3.45424L20.1141 3.44315L20.1453 3.43799L20.1719 3.43831L20.2016 3.44424L20.2266 3.45424L31.4766 9.07909L31.5016 9.09503L31.5234 9.11627L31.5422 9.14127L31.5547 9.16925L31.5609 9.19956L31.5625 9.22987L31.5578 9.25924L31.5469 9.28815L31.5297 9.31409L31.5094 9.33659L31.4844 9.35393L31.4766 9.35846L20.2266 14.9835C20.1828 15.0055 20.1297 15.0055 20.0859 14.9835L17.0312 13.456L16.4766 13.7333L16.4484 13.7444L16.4172 13.7496L16.3922 13.7494L16.3625 13.7436L16.3359 13.7333L15.7109 13.421C15.6578 13.3946 15.625 13.3405 15.625 13.2813V12.7528L11.4062 10.6435L10.8516 10.9208L10.8234 10.9319L10.7922 10.9371L10.7672 10.9369L10.7375 10.9311L10.7109 10.9208L10.0859 10.6085C10.0328 10.5821 10 10.528 10 10.4688V9.94034L8.83595 9.35846C8.78282 9.33206 8.75 9.27799 8.75 9.21877V8.22159L6.75625 9.21877L20.1562 15.9191L33.5563 9.21877L20.1562 2.51846L13.0062 6.09377ZM29.8063 9.84377L20.1562 5.01846L15.5062 7.34377L18.9766 9.07893L18.9859 9.08393C18.9984 9.09143 19.0094 9.10049 19.0187 9.11096L19.0391 9.1355L19.0484 9.15487C19.0547 9.16784 19.0594 9.18175 19.0609 9.19612L19.0625 9.21877V12.9688C19.0625 13.028 19.0297 13.0821 18.9766 13.1085L18.0062 13.5938L20.1562 14.6691L29.8063 9.84377ZM9.60155 5.99081L17.5 9.94034V13.341L9.0625 9.12221V5.72159L9.60155 5.99081ZM16.25 13.0653V13.341L15.9375 13.1847V12.9091L16.25 13.0653ZM10.625 10.2528V10.5285L10.3125 10.3722V10.0966L10.625 10.2528ZM24.7515 6.06596L31.0563 9.21877L30.1562 9.66909L20.3125 4.74721V3.84659L24.7515 6.06596ZM18.5563 9.21877L10.1562 5.01846L9.25625 5.46877L17.6562 9.66909L18.5563 9.21877Z",
				fill: "#3D3D3D"
			})
		]
	});
})), jn = /* @__PURE__ */ we({ default: () => Mn }), Mn, Nn = Se((() => {
	Mn = (e) => /* @__PURE__ */ m("svg", {
		width: 110,
		height: 110,
		viewBox: "0 0 110 110",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: /* @__PURE__ */ m("path", {
			d: "M6 30.6667V18.3333C6 15.0623 7.2994 11.9253 9.61235 9.61235C11.9253 7.2994 15.0623 6 18.3333 6H30.6667M6 80V92.3334C6 95.6044 7.2994 98.7414 9.61235 101.054C11.9253 103.367 15.0623 104.667 18.3333 104.667H30.6667M80 6H92.3334C95.6044 6 98.7414 7.2994 101.054 9.61235C103.367 11.9253 104.667 15.0623 104.667 18.3333V30.6667M80 104.667H92.3334C95.6044 104.667 98.7414 103.367 101.054 101.054C103.367 98.7414 104.667 95.6044 104.667 92.3334V80M43 49.1667V36.8333C43 33.5623 44.2994 30.4253 46.6124 28.1124C48.9253 25.7994 52.0623 24.5 55.3333 24.5C58.6044 24.5 61.7414 25.7994 64.0543 28.1124C66.3673 30.4253 67.6667 33.5623 67.6667 36.8333V49.1667M30.6667 55.3333C30.6667 53.6978 31.3164 52.1293 32.4729 50.9729C33.6293 49.8164 35.1978 49.1667 36.8333 49.1667H73.8334C75.4689 49.1667 77.0374 49.8164 78.1938 50.9729C79.3503 52.1293 80 53.6978 80 55.3333V73.8334C80 75.4689 79.3503 77.0374 78.1938 78.1938C77.0374 79.3503 75.4689 80 73.8334 80H36.8333C35.1978 80 33.6293 79.3503 32.4729 78.1938C31.3164 77.0374 30.6667 75.4689 30.6667 73.8334V55.3333Z",
			stroke: "black",
			strokeOpacity: .1,
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
})), Pn = /* @__PURE__ */ we({ default: () => Fn }), Fn, In = Se((() => {
	Fn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M33.8531 19.5579C33.0265 13.3717 28.7239 6.52865 23.5364 3.52575C20.6069 1.82962 17.9607 1.68591 16.061 2.82224C15.9161 2.90913 12.5383 4.87931 12.395 4.96955C10.7236 4.38134 9.20385 4.44149 8.05404 5.11159C8.02238 5.12997 5.85108 6.41001 4.77126 7.04668C3.11987 7.83709 2.08337 9.7421 2.08337 12.5278C2.08337 17.8016 5.79275 24.2235 10.367 26.8722L27.5274 36.8083C29.5954 38.0048 31.4668 38.1284 32.8282 37.3631C32.8282 37.3631 32.8366 37.3598 32.8466 37.3531C32.8516 37.3497 32.8566 37.3464 32.8616 37.3447C33.1432 37.1826 35.2062 35.9945 36.4793 35.2308C37.8091 34.4354 38.6273 32.766 38.6273 30.4031C38.6273 26.7301 36.6476 22.4455 33.8514 19.5579H33.8531Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M20.1154 26.7819C20.1154 27.7745 19.4221 28.1772 18.5673 27.6826C17.7124 27.188 17.0209 25.9814 17.0209 24.9888C17.0209 23.9962 17.7141 23.5935 18.5689 24.0881C19.4238 24.5828 20.1154 25.7893 20.1154 26.7819Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.4063 22.3569C20.9452 17.1682 16.1993 14.4193 12.7365 15.5941C12.3899 15.711 12.4516 16.4279 12.7365 16.9242C13.0748 17.5141 13.5364 17.7046 13.8814 17.5876C16.5926 16.6669 20.5519 18.9613 23.2614 23.0236C23.6064 23.5416 24.068 23.8842 24.4063 23.687C24.6912 23.5216 24.7529 22.8766 24.4063 22.3569Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M26.411 20.8865C24.1763 17.4758 21.4634 14.7286 18.5723 13.0275C15.7011 11.3364 12.9432 10.9905 10.7319 11.8009C10.3886 11.9262 10.4436 12.6281 10.7319 13.1311C11.0669 13.716 11.5351 13.9198 11.8767 13.7945C15.7294 12.3808 21.4151 15.6744 25.2645 21.5532C25.6061 22.0746 26.0743 22.4122 26.4093 22.2166C26.6976 22.0495 26.7526 21.4095 26.4093 20.8865H26.411Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.2383 23.5836C20.082 20.4787 17.0591 18.7275 14.9028 19.3324C14.5495 19.431 14.3712 19.832 14.6112 20.4503C14.8162 20.975 15.3627 21.5298 15.7194 21.4296C17.4641 20.9399 19.677 22.2233 21.4217 24.7333C21.7767 25.2446 22.3249 25.3248 22.5299 25.0374C22.7715 24.6982 22.5932 24.0916 22.2399 23.5819L22.2383 23.5836Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M33.853 19.5563C33.0265 13.37 28.7239 6.52702 23.5364 3.52412C20.6069 1.82966 17.9607 1.68428 16.061 2.82227C15.916 2.90917 12.8599 4.70723 12.8599 4.70723L12.8365 4.7206C14.7046 3.79316 17.2108 4.01374 19.9687 5.60961C25.1545 8.61251 29.4571 15.4555 30.2853 21.6418C33.0815 24.5294 35.0612 28.814 35.0612 32.487C35.0612 34.8799 34.2213 36.5594 32.8632 37.3448C33.1448 37.1827 35.2078 35.9929 36.4809 35.2309C37.8107 34.4354 38.6289 32.766 38.6289 30.4032C38.6289 26.7302 36.6492 22.4456 33.853 19.558V19.5563Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M10.2037 7.68669C10.7019 6.48018 11.4535 5.56611 12.395 4.97121C10.7236 4.383 9.20383 4.44316 8.05402 5.11325C8.02236 5.13163 5.85106 6.41167 4.77124 7.04834C6.20767 6.36154 8.11068 6.52196 10.2037 7.68669Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.8249 37.4449C32.8066 37.4449 32.7882 37.4383 32.7699 37.4199C32.7516 37.4015 32.7432 37.3748 32.7466 37.3497C32.7499 37.3246 32.7649 37.3012 32.7882 37.2879C32.7882 37.2879 32.7999 37.2812 32.8016 37.2812C32.8416 37.2611 32.8949 37.2745 32.9165 37.3129C32.9382 37.3514 32.9282 37.3998 32.8899 37.4232C32.8849 37.4249 32.8799 37.4299 32.8715 37.4332C32.8599 37.4383 32.8432 37.4449 32.8266 37.4449H32.8249Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M32.8698 37.4349L32.7865 37.2895C32.8098 37.2761 35.0844 35.9677 36.4359 35.1572C37.7956 34.3434 38.5438 32.654 38.5438 30.4014C38.5438 26.8303 36.6792 22.5959 33.7913 19.6147C33.778 19.6013 33.7713 19.5846 33.768 19.5679C32.9264 13.2747 28.6055 6.557 23.493 3.59755C20.6852 1.9716 18.0606 1.72094 16.1043 2.89403C15.9593 2.98092 12.9331 4.7606 12.9031 4.77899L12.4365 5.04301C12.4165 5.05471 12.3916 5.05638 12.3682 5.0497C10.7452 4.4782 9.22708 4.52666 8.09727 5.18505C8.05561 5.21012 4.21792 7.47107 4.21792 7.47107L4.13293 7.32736C4.13293 7.32736 7.97063 5.06474 8.01229 5.03967C9.17709 4.36122 10.7285 4.3044 12.3866 4.87925L12.8198 4.63528C12.8498 4.61856 15.8743 2.83721 16.0176 2.75199C18.0289 1.54715 20.7135 1.79614 23.578 3.45383C28.7238 6.43334 33.0748 13.1861 33.9313 19.5194C36.8358 22.529 38.7105 26.7986 38.7105 30.4031C38.7105 32.7175 37.9339 34.4571 36.5225 35.3026C35.1694 36.1131 32.8931 37.4232 32.8698 37.4349Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M33.8105 19.4837L30.2441 21.571L30.3281 21.7154L33.8945 19.628L33.8105 19.4837Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.2571 27.9784C19.0305 27.9784 18.7822 27.9032 18.5256 27.7544C17.649 27.2464 16.9375 26.0065 16.9375 24.9888C16.9375 24.4775 17.1141 24.0931 17.4341 23.9077C17.7524 23.7238 18.1706 23.7623 18.6106 24.0163C19.4871 24.5243 20.1986 25.7642 20.1986 26.7819C20.1986 27.2932 20.022 27.6776 19.702 27.8631C19.5687 27.9399 19.4188 27.9784 19.2571 27.9784ZM17.879 23.9611C17.7457 23.9611 17.6241 23.9912 17.5174 24.053C17.2508 24.2068 17.1041 24.5393 17.1041 24.9888C17.1041 25.953 17.779 27.1295 18.6089 27.6107C18.9938 27.8346 19.3538 27.8731 19.6187 27.7193C19.8853 27.5656 20.032 27.2331 20.032 26.7836C20.032 25.8193 19.3571 24.6429 18.5272 24.1617C18.2973 24.028 18.0756 23.9611 17.879 23.9611Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.198 23.8257C23.8847 23.8257 23.5147 23.555 23.1915 23.0704C20.4953 19.0298 16.5909 16.7571 13.908 17.6679C13.4814 17.8116 12.9915 17.5375 12.6649 16.9677C12.4383 16.5716 12.3549 16.0687 12.4666 15.7729C12.5149 15.6442 12.5999 15.5556 12.7116 15.5172C16.2393 14.3207 20.9668 17.0512 24.4779 22.3134C24.6929 22.6343 24.7779 23.0403 24.7012 23.3712C24.6596 23.5533 24.5696 23.692 24.4496 23.7622C24.3729 23.8073 24.2896 23.8291 24.1996 23.8291L24.198 23.8257ZM15.1628 17.3019C17.7707 17.3019 21.0018 19.4876 23.3314 22.9768C23.6281 23.4213 24.0613 23.7906 24.3646 23.6152C24.4446 23.5684 24.5062 23.4681 24.5379 23.3311C24.5896 23.1055 24.5646 22.7445 24.3379 22.4053C20.9252 17.2885 16.1643 14.5212 12.7632 15.676C12.6999 15.6977 12.6516 15.7495 12.6216 15.8314C12.5283 16.082 12.6082 16.5349 12.8082 16.8841C13.0948 17.3821 13.5048 17.6294 13.8547 17.5108C14.2663 17.3721 14.7046 17.3036 15.1628 17.3036V17.3019Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M26.1992 22.3569C25.8842 22.3569 25.516 22.0845 25.1977 21.5982C23.343 18.7657 20.975 16.4263 18.5321 15.0109C16.0992 13.6022 13.7479 13.1978 11.9066 13.8729C11.56 13.9999 11.04 13.8328 10.6601 13.1727C10.4368 12.7833 10.3518 12.2854 10.4601 11.9879C10.5085 11.8559 10.5934 11.764 10.7051 11.7222C13.0147 10.8733 15.8242 11.3111 18.6154 12.9555C21.4916 14.6483 24.2112 17.3754 26.4808 20.8412C26.6958 21.1687 26.7807 21.5765 26.7041 21.904C26.6624 22.0828 26.5724 22.2198 26.4525 22.29C26.3741 22.3351 26.2875 22.3585 26.1975 22.3585L26.1992 22.3569ZM13.8212 13.3799C17.5123 13.3799 22.0532 16.4948 25.336 21.5063C25.6826 22.0343 26.1059 22.2967 26.3691 22.143C26.4491 22.0962 26.5108 21.9976 26.5424 21.8639C26.5958 21.64 26.5708 21.279 26.3425 20.9314C24.0862 17.4874 21.385 14.7786 18.5321 13.0992C15.7842 11.4816 13.0264 11.0488 10.7634 11.8793C10.6984 11.9027 10.6484 11.9595 10.6184 12.0447C10.5285 12.2954 10.6084 12.7432 10.8067 13.0891C11.1384 13.6657 11.5683 13.8194 11.8499 13.7158C12.4681 13.4885 13.1297 13.3799 13.8229 13.3799H13.8212Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M22.1782 25.2863C21.8783 25.2847 21.5717 25.0958 21.3534 24.7817C19.642 22.3185 17.439 21.0335 15.7426 21.5097C15.3344 21.6234 14.7578 21.0502 14.5345 20.4804C14.3562 20.0225 14.4145 19.73 14.4962 19.568C14.5745 19.4092 14.7078 19.3006 14.8811 19.2521C17.0774 18.6355 20.1302 20.3985 22.3082 23.5367C22.6265 23.9946 22.8914 24.6747 22.5982 25.0875C22.5065 25.2161 22.3582 25.288 22.1799 25.288L22.1782 25.2863ZM16.4959 21.2407C18.1206 21.2407 19.9669 22.494 21.49 24.6847C21.7116 25.0022 21.9883 25.1176 22.1749 25.1192C22.3015 25.1192 22.4015 25.0724 22.4615 24.9889C22.6598 24.7115 22.5432 24.165 22.1716 23.6303C20.0319 20.5505 17.0541 18.8143 14.9261 19.4109C14.7995 19.446 14.7028 19.5262 14.6462 19.6398C14.5528 19.8286 14.5678 20.1044 14.6912 20.4169C14.8978 20.9483 15.416 21.4262 15.6993 21.346C15.9576 21.2741 16.2259 21.2373 16.4992 21.2373L16.4959 21.2407Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.5671 18.7139L29.5188 18.5551L29.6788 18.505L29.7271 18.6654L29.5671 18.7139Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.4188 18.231C29.3838 18.124 29.3488 18.0171 29.3138 17.9101L29.4721 17.8566C29.5088 17.9636 29.5437 18.0722 29.5787 18.1792L29.4204 18.231H29.4188ZM29.2038 17.5926C29.1671 17.4873 29.1288 17.3804 29.0888 17.2751L29.2455 17.2166C29.2855 17.3236 29.3238 17.4289 29.3604 17.5358L29.2038 17.5909V17.5926ZM28.9688 16.9593C28.9289 16.854 28.8872 16.7504 28.8455 16.6451L29.0005 16.5833C29.0422 16.6886 29.0838 16.7939 29.1255 16.8991L28.9705 16.9593H28.9688ZM28.7172 16.3326C28.6739 16.229 28.6289 16.1254 28.5839 16.0218L28.7372 15.955C28.7822 16.0586 28.8272 16.1639 28.8705 16.2675L28.7172 16.3326ZM28.4473 15.7127C28.4006 15.6107 28.3539 15.5071 28.3056 15.4052L28.4556 15.3333C28.5039 15.4369 28.5506 15.5389 28.5972 15.6425L28.4456 15.711L28.4473 15.7127ZM28.1606 15.1011C28.1123 14.9991 28.0623 14.8989 28.0107 14.7986L28.159 14.7234C28.209 14.8253 28.259 14.9256 28.309 15.0292L28.159 15.1027L28.1606 15.1011ZM27.8574 14.4978C27.8057 14.3975 27.754 14.2973 27.7007 14.1987L27.8474 14.1202C27.9007 14.2204 27.954 14.3207 28.0057 14.4209L27.8574 14.4978ZM27.5391 13.9012C27.4841 13.8026 27.4291 13.7041 27.3741 13.6055L27.5191 13.5236C27.5757 13.6222 27.6307 13.7208 27.6857 13.821L27.5391 13.9012ZM27.2041 13.3147C27.1475 13.2178 27.0892 13.1209 27.0308 13.0239L27.1741 12.937C27.2325 13.034 27.2908 13.1309 27.3475 13.2295L27.2041 13.3147ZM26.8559 12.7348C26.7959 12.6396 26.7359 12.5443 26.6759 12.4491L26.8159 12.3589C26.8775 12.4541 26.9375 12.551 26.9975 12.6463L26.8559 12.7348ZM26.4909 12.1667C26.4293 12.0731 26.3659 11.9795 26.3026 11.8859L26.4409 11.7924C26.5043 11.8859 26.5676 11.9795 26.6309 12.0748L26.4926 12.1667H26.4909ZM26.111 11.6069C26.046 11.515 25.981 11.4231 25.916 11.3311L26.051 11.2342C26.1177 11.3261 26.1826 11.4197 26.2476 11.5116L26.111 11.6069ZM25.7161 11.0571C25.6494 10.9669 25.5811 10.8766 25.5128 10.7864L25.6444 10.6844C25.7127 10.7747 25.781 10.8649 25.8494 10.9568L25.7161 11.0571ZM25.3061 10.519C25.2361 10.4304 25.1661 10.3419 25.0962 10.255L25.2261 10.1497C25.2978 10.2383 25.3678 10.3268 25.4378 10.4171L25.3061 10.5207V10.519ZM24.8812 9.99263C24.8095 9.90573 24.7362 9.81884 24.6629 9.73361L24.7895 9.62499C24.8629 9.71189 24.9362 9.79878 25.0095 9.88568L24.8812 9.99263ZM24.4413 9.47794C24.3663 9.39271 24.2913 9.30916 24.2163 9.22561L24.3396 9.11365C24.4163 9.1972 24.4913 9.28242 24.5662 9.36765L24.4413 9.47794Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.9864 8.9783C23.948 8.93819 23.9114 8.89808 23.873 8.85798L23.993 8.74268C24.0314 8.78278 24.0697 8.82456 24.108 8.86466L23.9864 8.9783Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M30.9035 37.9295C29.8537 37.9295 28.6905 37.5769 27.4857 36.8784L10.3253 26.9423C5.73437 24.2869 2 17.8199 2 12.5277C2 9.97262 2.86152 8.05926 4.42459 7.13516C5.95934 6.22944 7.994 6.38318 10.1636 7.56796C10.8452 5.97878 11.9733 4.87755 13.4298 4.38292C15.3194 3.73956 17.5957 4.13894 20.012 5.53762C21.3901 6.33639 22.7299 7.41423 23.993 8.74272L23.873 8.85802C22.6199 7.54123 21.2934 6.47342 19.9287 5.68301C17.5574 4.30939 15.3294 3.91502 13.4831 4.54167C12.0467 5.02962 10.9402 6.12918 10.2819 7.71836C10.2736 7.74008 10.2553 7.75679 10.232 7.76515C10.2103 7.7735 10.1853 7.77016 10.1636 7.76014C8.01733 6.56533 6.00933 6.39488 4.50791 7.28054C2.99817 8.17122 2.16664 10.0345 2.16664 12.5277C2.16664 17.7665 5.86435 24.1683 10.4086 26.7986L27.5691 36.7347C29.5604 37.8877 31.4267 38.0765 32.8248 37.2678C34.2129 36.464 34.9778 34.7662 34.9778 32.4852C34.9778 28.9141 33.1131 24.6796 30.2253 21.6985C30.2119 21.6851 30.2053 21.6684 30.2019 21.6517C30.0753 20.6975 29.8603 19.7099 29.567 18.714L29.727 18.6672C30.0203 19.6614 30.2353 20.649 30.3636 21.6032C33.2681 24.6128 35.1428 28.8824 35.1428 32.4868C35.1428 34.8297 34.3496 36.5793 32.9065 37.4148C32.3099 37.759 31.6334 37.9312 30.9018 37.9312L30.9035 37.9295Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Ln = /* @__PURE__ */ we({ default: () => Rn }), Rn, zn = Se((() => {
	Rn = (e) => /* @__PURE__ */ h("svg", {
		width: 200,
		height: 200,
		viewBox: "0 0 200 200",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M120.364 135.783C120.643 136.089 120.62 136.563 120.314 136.842C120.008 137.12 119.533 137.098 119.254 136.792L120.364 135.783ZM118.299 134.627C118.586 134.366 119.021 134.369 119.304 134.623L119.358 134.677L120.364 135.783L119.254 136.792L118.249 135.686L118.2 135.627C117.974 135.321 118.012 134.888 118.299 134.627Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M121.008 132.621C121.322 132.392 121.754 132.441 122.008 132.723L122.057 132.783L122.827 133.835C123.072 134.169 122.999 134.638 122.665 134.883C122.331 135.128 121.862 135.055 121.617 134.721L120.847 133.669L120.804 133.605C120.612 133.277 120.695 132.851 121.008 132.621Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M125.337 135.146C125.654 134.896 126.111 134.942 126.372 135.248L126.373 135.249C126.373 135.249 126.374 135.25 126.374 135.251C126.375 135.252 126.377 135.253 126.379 135.255C126.382 135.26 126.387 135.266 126.394 135.274C126.408 135.29 126.428 135.314 126.453 135.344C126.503 135.404 126.576 135.492 126.666 135.605C126.847 135.829 127.101 136.151 127.394 136.543C127.979 137.324 128.731 138.397 129.379 139.545C130.018 140.679 130.594 141.949 130.77 143.113C130.948 144.296 130.726 145.548 129.531 146.291C128.39 146.999 127.141 146.798 126.059 146.282C124.984 145.769 123.946 144.892 123.061 143.998C122.167 143.095 121.388 142.13 120.835 141.396C120.558 141.028 120.335 140.715 120.181 140.493C120.104 140.382 120.044 140.294 120.003 140.233C119.983 140.202 119.967 140.179 119.956 140.162C119.95 140.154 119.946 140.147 119.943 140.143C119.942 140.141 119.94 140.139 119.94 140.137C119.939 140.137 119.939 140.136 119.939 140.136L119.938 140.135C119.938 140.135 119.948 140.129 120.567 139.726L119.938 140.135C119.806 139.933 119.78 139.679 119.867 139.454C119.938 139.273 120.075 139.13 120.247 139.048C120.25 139.046 120.255 139.043 120.262 139.039C120.298 139.016 120.354 138.978 120.43 138.923C120.582 138.816 120.791 138.662 121.041 138.475C121.538 138.101 122.182 137.608 122.819 137.113C123.457 136.62 124.086 136.127 124.557 135.759C124.792 135.575 124.987 135.421 125.124 135.314C125.192 135.26 125.245 135.218 125.282 135.19C125.3 135.175 125.314 135.164 125.323 135.157C125.328 135.153 125.332 135.15 125.334 135.149C125.335 135.148 125.336 135.147 125.337 135.147L125.337 135.146ZM125.482 136.94C125.01 137.31 124.378 137.803 123.738 138.299C123.098 138.794 122.448 139.294 121.941 139.675C121.824 139.763 121.713 139.844 121.612 139.919C121.731 140.085 121.872 140.279 122.033 140.493C122.562 141.196 123.297 142.104 124.127 142.943C124.965 143.79 125.86 144.525 126.705 144.928C127.545 145.329 128.205 145.348 128.739 145.016C129.22 144.718 129.419 144.21 129.287 143.338C129.152 142.447 128.684 141.368 128.072 140.282C127.467 139.211 126.757 138.194 126.193 137.442C126.003 137.187 125.829 136.964 125.684 136.78C125.621 136.83 125.553 136.884 125.482 136.94ZM120.379 139C120.348 139.008 120.321 139.017 120.301 139.025C120.326 139.015 120.353 139.007 120.379 139Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M45.4205 31.5508C45.7725 31.5239 46.0996 31.5535 46.3834 31.6284C46.6538 31.6999 46.9371 31.8269 47.1495 32.0371C47.3484 32.2339 49.1406 34.2585 50.8414 36.1851C51.7013 37.1591 52.5503 38.1222 53.1842 38.8418C53.5011 39.2016 53.7644 39.5005 53.9484 39.7095C54.0404 39.814 54.1125 39.8963 54.1617 39.9522C54.1863 39.98 54.2052 40.0012 54.2179 40.0156C54.2242 40.0228 54.2288 40.0286 54.2321 40.0322L54.2369 40.0371V40.0376L54.2814 40.0933C54.3781 40.2268 54.4288 40.3891 54.4239 40.5552C54.369 42.4107 53.2828 43.6214 52.1442 44.2427C51.5803 44.5503 50.9816 44.7276 50.4489 44.7705C50.1826 44.792 49.9117 44.7817 49.6598 44.7232C49.4144 44.6661 49.1335 44.5503 48.9147 44.3194C48.9075 44.3118 48.9005 44.3038 48.8937 44.2959L41.8697 36.2334C41.7916 36.1437 41.7358 36.0364 41.7072 35.9209L42.4352 35.7407L41.7072 35.9199L41.7067 35.919C41.7065 35.9185 41.7063 35.918 41.7062 35.9175C41.7059 35.9163 41.7055 35.915 41.7052 35.9136C41.7045 35.9108 41.7041 35.9074 41.7032 35.9038C41.7016 35.8966 41.6995 35.8876 41.6974 35.8775C41.6931 35.8571 41.6881 35.8309 41.6827 35.7993C41.672 35.7361 41.66 35.6506 41.652 35.5469C41.6361 35.3402 41.635 35.0547 41.6915 34.7256C41.8067 34.0546 42.1597 33.2226 43.0524 32.5322C43.8831 31.8898 44.7112 31.6051 45.4205 31.5508ZM45.5353 33.0464C45.1382 33.0768 44.5853 33.2428 43.9698 33.7188C43.4163 34.1469 43.2313 34.6228 43.17 34.9795C43.1399 35.1553 43.1394 35.3075 43.1466 35.4155L49.9747 43.2539C49.9813 43.2559 49.9894 43.2594 49.9996 43.2617C50.0655 43.277 50.1753 43.2877 50.3282 43.2754C50.6346 43.2508 51.0309 43.1411 51.4254 42.9258C52.1415 42.5351 52.778 41.8438 52.903 40.792C52.8782 40.7638 52.8512 40.7334 52.8224 40.7007C52.6385 40.4918 52.3755 40.1931 52.0587 39.8335C51.425 39.1142 50.5763 38.1512 49.7169 37.1778C48.8575 36.2043 47.9879 35.2204 47.3112 34.4585C46.9727 34.0775 46.6833 33.7526 46.4679 33.5127C46.3601 33.3926 46.2714 33.2947 46.2052 33.2222C46.1721 33.1859 46.1454 33.157 46.1251 33.1353C46.1181 33.1278 46.1125 33.1219 46.108 33.1172C46.0957 33.1108 46.0622 33.095 46.0001 33.0786C45.8938 33.0506 45.7363 33.031 45.5353 33.0464ZM43.1652 35.5694V35.5689C43.165 35.5681 43.165 35.5668 43.1647 35.5655L43.1642 35.5645C43.1646 35.5668 43.165 35.5685 43.1652 35.5694Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M44.7442 34.5658C45.0547 34.2917 45.5287 34.3209 45.8028 34.6312C46.0769 34.9418 46.0474 35.4157 45.7369 35.6898C44.815 36.5038 43.9272 36.7291 43.2222 36.702C42.8805 36.6889 42.6006 36.617 42.4005 36.5453C42.3003 36.5094 42.219 36.4731 42.1588 36.4433C42.1286 36.4283 42.1033 36.4148 42.0836 36.4037C42.0737 36.3982 42.0649 36.3933 42.0577 36.3891C42.0541 36.387 42.0508 36.385 42.0479 36.3832C42.0465 36.3824 42.0453 36.3815 42.044 36.3808C42.0434 36.3804 42.0427 36.3797 42.0421 36.3793L42.0411 36.3788C42.0417 36.3769 42.0607 36.3452 42.4351 35.7406L42.0401 36.3783C41.6881 36.1602 41.5795 35.6982 41.7974 35.3461C42.0153 34.9943 42.4767 34.8857 42.8287 35.1029L42.8292 35.1024L42.8282 35.1019C42.8278 35.1017 42.8272 35.1012 42.8267 35.101C42.8258 35.1004 42.8246 35.1 42.8238 35.0995C42.8221 35.0985 42.8206 35.0978 42.8194 35.0971C42.8171 35.0957 42.816 35.0944 42.8155 35.0941C42.8163 35.0945 42.8191 35.0965 42.8243 35.099C42.838 35.1058 42.8659 35.1187 42.9063 35.1332C42.9877 35.1624 43.116 35.1967 43.2799 35.203C43.5865 35.2148 44.1014 35.1332 44.7442 34.5658Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M98.2418 95.3462C99.364 95.2221 100.241 95.5404 100.891 96.0478C101.52 96.5395 101.902 97.1792 102.123 97.666C102.235 97.9133 102.311 98.1326 102.359 98.2925C102.37 98.3278 102.378 98.3611 102.386 98.3906C102.391 98.3972 102.397 98.4039 102.402 98.4111C102.472 98.5021 102.575 98.6361 102.706 98.8071C102.968 99.149 103.345 99.6399 103.804 100.235C104.722 101.425 105.966 103.032 107.275 104.699C108.585 106.366 109.957 108.091 111.128 109.519C112.314 110.963 113.259 112.06 113.732 112.505C113.849 112.615 114.153 112.774 114.775 112.959C115.366 113.134 116.127 113.302 117.051 113.494C118.882 113.875 121.28 114.339 123.911 115.135C129.182 116.73 135.453 119.671 140.313 126.031C145.071 132.26 150.12 140.37 153.972 146.908C155.899 150.18 157.531 153.064 158.681 155.131C159.256 156.164 159.71 156.993 160.021 157.564C160.177 157.849 160.296 158.071 160.377 158.221C160.417 158.296 160.448 158.353 160.469 158.391C160.479 158.41 160.487 158.425 160.492 158.435C160.495 158.439 160.497 158.443 160.498 158.446C160.499 158.447 160.499 158.448 160.5 158.449L160.5 158.449C160.5 158.449 160.5 158.45 159.839 158.804L160.587 158.855V158.859C160.587 158.861 160.587 158.863 160.586 158.866C160.586 158.872 160.585 158.878 160.585 158.887C160.583 158.904 160.581 158.926 160.578 158.955C160.572 159.012 160.562 159.093 160.547 159.194C160.516 159.398 160.464 159.687 160.376 160.05C160.199 160.777 159.878 161.797 159.298 163.01C158.137 165.44 155.944 168.625 151.827 171.765C147.708 174.904 143.809 176.328 140.925 176.964C139.485 177.282 138.298 177.403 137.466 177.444C137.05 177.464 136.721 177.465 136.494 177.46C136.38 177.457 136.291 177.454 136.229 177.45C136.198 177.448 136.173 177.447 136.156 177.446C136.147 177.445 136.14 177.445 136.135 177.444C136.132 177.444 136.13 177.444 136.128 177.444C136.127 177.444 136.126 177.443 136.126 177.443H136.125L136.187 176.696L135.667 177.236L135.666 177.235C135.666 177.235 135.665 177.234 135.664 177.233C135.662 177.231 135.658 177.228 135.654 177.225C135.646 177.217 135.634 177.205 135.619 177.19C135.587 177.16 135.541 177.114 135.48 177.055C135.357 176.937 135.177 176.761 134.945 176.534C134.48 176.08 133.806 175.417 132.968 174.583C131.292 172.915 128.959 170.56 126.335 167.816C121.09 162.332 114.656 155.269 109.954 148.998C105.151 142.593 104.025 135.759 103.923 130.252C103.872 127.504 104.077 125.071 104.208 123.205C104.274 122.263 104.32 121.485 104.312 120.869C104.303 120.22 104.233 119.885 104.159 119.742C103.859 119.165 103.06 117.957 101.992 116.424C100.937 114.909 99.6496 113.12 98.4009 111.407C97.1526 109.694 95.9447 108.059 95.0489 106.852C94.6012 106.249 94.2314 105.753 93.9737 105.408C93.8449 105.235 93.744 105.1 93.6754 105.008C93.6733 105.005 93.671 105.003 93.669 105C93.6421 104.985 93.612 104.969 93.5801 104.951C93.4285 104.862 93.2215 104.733 92.9942 104.561C92.5491 104.226 91.9782 103.699 91.6173 102.979C91.242 102.23 91.1102 101.299 91.5279 100.255C91.9322 99.2454 92.824 98.1971 94.3428 97.101C95.8619 96.0048 97.1455 95.4673 98.2418 95.3462ZM136.124 177.443C135.953 177.429 135.791 177.356 135.667 177.236L136.187 176.696L136.124 177.443ZM99.9674 97.2304C99.6171 96.9569 99.1288 96.7571 98.4068 96.8369C97.6588 96.9196 96.6187 97.3082 95.2203 98.3174C93.8217 99.3267 93.1778 100.17 92.9205 100.812C92.6767 101.421 92.7568 101.905 92.9581 102.307C93.1737 102.737 93.5445 103.098 93.8965 103.363C94.0678 103.492 94.2233 103.59 94.3345 103.655C94.3899 103.687 94.4335 103.71 94.4615 103.725C94.4755 103.732 94.4857 103.737 94.4913 103.74L94.4952 103.742H94.4947C94.6034 103.794 94.6982 103.872 94.7706 103.968L94.1705 104.418C94.7374 103.993 94.7688 103.97 94.7706 103.969H94.7711C94.7713 103.969 94.7715 103.97 94.772 103.971C94.7732 103.972 94.7751 103.974 94.7774 103.978C94.7819 103.984 94.7886 103.993 94.7974 104.004C94.8152 104.028 94.8416 104.063 94.876 104.109C94.945 104.201 95.0461 104.337 95.1754 104.51C95.4338 104.856 95.8047 105.353 96.2535 105.958C97.1509 107.167 98.3612 108.805 99.6129 110.523C100.864 112.24 102.159 114.039 103.223 115.567C104.275 117.078 105.136 118.37 105.489 119.05C105.742 119.536 105.803 120.193 105.812 120.849C105.821 121.537 105.77 122.376 105.704 123.311C105.571 125.198 105.374 127.558 105.423 130.225C105.521 135.549 106.607 142.034 111.154 148.098C115.801 154.295 122.184 161.306 127.419 166.779C130.033 169.513 132.357 171.858 134.026 173.52C134.86 174.35 135.531 175.01 135.993 175.461C136.212 175.675 136.384 175.843 136.504 175.959C136.511 175.96 136.519 175.96 136.526 175.96C136.72 175.965 137.013 175.964 137.392 175.945C138.15 175.908 139.252 175.797 140.602 175.499C143.301 174.904 146.994 173.563 150.918 170.572C154.842 167.58 156.884 164.583 157.945 162.363C158.476 161.252 158.764 160.33 158.918 159.696C158.995 159.379 159.039 159.133 159.063 158.972C159.064 158.964 159.065 158.957 159.066 158.95C159.063 158.944 159.06 158.938 159.057 158.933C158.977 158.784 158.858 158.565 158.704 158.281C158.395 157.714 157.942 156.889 157.37 155.86C156.225 153.802 154.6 150.928 152.68 147.669C148.836 141.145 143.823 133.097 139.121 126.942C134.519 120.92 128.573 118.113 123.476 116.571C120.923 115.799 118.599 115.348 116.746 114.962C115.829 114.772 115.008 114.593 114.348 114.397C113.719 114.21 113.103 113.973 112.705 113.598C112.147 113.073 111.137 111.894 109.969 110.471C108.787 109.031 107.408 107.296 106.096 105.625C104.783 103.954 103.535 102.343 102.616 101.151C102.156 100.555 101.778 100.063 101.515 99.7197C101.384 99.5483 101.281 99.4141 101.211 99.3227C101.176 99.2772 101.149 99.2423 101.131 99.2187C101.122 99.207 101.115 99.1979 101.111 99.1919C101.109 99.1889 101.107 99.1866 101.106 99.185C101.105 99.1843 101.105 99.1835 101.105 99.1831H101.104L101.7 98.7275L101.104 99.1826C101.036 99.0933 100.988 98.9899 100.965 98.8799V98.8794C100.964 98.8746 100.962 98.8655 100.959 98.8525C100.952 98.8262 100.941 98.784 100.924 98.7295C100.891 98.6198 100.837 98.4632 100.757 98.2861C100.592 97.924 100.338 97.5197 99.9674 97.2304ZM160.5 158.45C160.566 158.574 160.597 158.714 160.587 158.854L159.839 158.804L160.5 158.45Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M124.805 159.521C125.104 159.235 125.579 159.245 125.866 159.544V159.544L125.866 159.545C125.867 159.545 125.867 159.546 125.868 159.546C125.87 159.548 125.872 159.55 125.875 159.553C125.88 159.559 125.889 159.568 125.901 159.581C125.924 159.605 125.958 159.641 126.003 159.688C126.093 159.781 126.226 159.919 126.394 160.094C126.731 160.445 127.213 160.946 127.794 161.547C128.957 162.751 130.516 164.357 132.099 165.97C133.682 167.583 135.288 169.199 136.545 170.422C137.175 171.035 137.712 171.543 138.113 171.902C138.315 172.083 138.474 172.218 138.588 172.308C138.616 172.33 138.64 172.346 138.659 172.359C138.725 172.365 138.834 172.369 138.992 172.356C139.218 172.339 139.501 172.294 139.823 172.215C140.468 172.059 141.231 171.777 141.959 171.355C142.317 171.147 142.776 171.269 142.984 171.627C143.192 171.986 143.07 172.444 142.712 172.652C141.847 173.154 140.948 173.486 140.177 173.673C139.791 173.767 139.428 173.827 139.109 173.852C138.805 173.875 138.491 173.872 138.225 173.805V173.806C138.224 173.806 138.223 173.805 138.223 173.805V173.805C138.069 173.766 137.944 173.687 137.892 173.654C137.818 173.606 137.741 173.549 137.665 173.489C137.511 173.369 137.323 173.209 137.112 173.02C136.688 172.64 136.134 172.115 135.5 171.498C134.229 170.262 132.614 168.636 131.028 167.021C129.441 165.405 127.88 163.795 126.716 162.589C126.134 161.987 125.65 161.485 125.313 161.134C125.144 160.958 125.012 160.82 124.921 160.726C124.876 160.679 124.842 160.643 124.818 160.619C124.807 160.606 124.797 160.598 124.792 160.591C124.789 160.588 124.787 160.586 124.785 160.584L124.783 160.582C124.496 160.283 124.506 159.808 124.805 159.521Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M98.3887 99.1069C98.6599 98.794 99.1333 98.7601 99.4463 99.0312C99.7594 99.3024 99.7937 99.7762 99.5225 100.089C98.3212 101.476 97.0843 102.065 96.108 102.29C95.6252 102.401 95.2163 102.42 94.92 102.41C94.7718 102.405 94.6512 102.392 94.563 102.38C94.5191 102.374 94.4831 102.368 94.4556 102.363C94.4418 102.36 94.4299 102.358 94.4205 102.356C94.4158 102.355 94.4118 102.354 94.4083 102.353C94.4064 102.353 94.4044 102.352 94.4029 102.352C94.4022 102.352 94.4016 102.352 94.4009 102.352L94.4 102.351C94.3995 102.351 94.3989 102.351 94.5684 101.621C94.5716 101.607 94.5742 101.593 94.5772 101.58L94.399 102.351C93.9955 102.257 93.7443 101.854 93.8379 101.451C93.9313 101.049 94.3315 100.798 94.7335 100.889C94.7329 100.889 94.7324 100.888 94.732 100.888C94.7378 100.889 94.7508 100.892 94.7706 100.894C94.811 100.9 94.8794 100.907 94.9712 100.911C95.1549 100.917 95.4318 100.906 95.7715 100.828C96.4406 100.674 97.3975 100.251 98.3887 99.1069Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M79.4161 42.8183C81.7617 42.1876 83.7218 43.243 85.2535 44.9297C86.7726 46.6024 87.9775 48.9958 88.9117 51.3774C89.8512 53.7727 90.5417 56.2223 91.0054 58.0542C91.1522 58.6339 91.276 59.1535 91.3785 59.5903C92.4419 58.4727 93.7884 57.5856 95.2076 57.0239C97.1086 56.2716 99.2325 56.0695 101.045 56.79C102.904 57.5285 104.301 59.1834 104.785 61.8476C105.263 64.4741 104.861 68.092 103.205 72.8979C101.781 77.0318 100.129 81.4006 99.0362 85.6469C97.9427 89.8968 97.4449 93.9035 98.2569 97.2934C98.3534 97.6963 98.105 98.1012 97.7022 98.1977C97.2994 98.2942 96.8949 98.0458 96.7984 97.643C95.8994 93.8904 96.472 89.5934 97.5836 85.2734C98.696 80.9499 100.384 76.4825 101.787 72.4092C103.403 67.7199 103.721 64.3839 103.309 62.1157C102.904 59.8854 101.802 58.7048 100.492 58.1841C99.1365 57.6454 97.4232 57.7599 95.7593 58.4184C94.1013 59.0746 92.5836 60.2369 91.6383 61.6533C91.6118 61.6929 91.5819 61.7302 91.5484 61.7641C91.4356 61.8784 91.2441 61.994 90.9927 61.9873C90.7683 61.9813 90.6134 61.8793 90.5426 61.8227C90.4146 61.7206 90.3538 61.6012 90.3448 61.5844C90.3078 61.5157 90.2864 61.4504 90.2794 61.4292C90.2592 61.3683 90.239 61.294 90.2213 61.2241C90.184 61.0772 90.1345 60.8624 90.0743 60.602C89.9524 60.0745 89.7792 59.3221 89.5513 58.4219C89.0949 56.619 88.4222 54.2376 87.5152 51.9253C86.6029 49.5994 85.4779 47.4083 84.1431 45.9385C82.8209 44.4825 81.4026 43.8367 79.8057 44.2661L79.8062 44.2666C76.4755 45.1654 74.8638 48.2915 74.1041 51.4643C73.73 53.0265 73.5803 54.5354 73.525 55.6577C73.4974 56.2174 73.4933 56.6777 73.4962 56.9961C73.4976 57.155 73.5008 57.2784 73.5035 57.3608C73.5048 57.402 73.506 57.433 73.5069 57.4531C73.5073 57.4631 73.5077 57.4706 73.5079 57.4751V57.48L73.5089 57.5371C73.5026 57.8206 73.3362 58.0784 73.0762 58.1997C72.8162 58.321 72.5115 58.2829 72.2901 58.1054L72.2471 58.0683C72.2469 58.0681 72.2463 58.0674 72.2457 58.0669C72.2445 58.0657 72.2424 58.0639 72.2398 58.0615C72.2344 58.0565 72.226 58.0488 72.2149 58.0386C72.1926 58.0179 72.1589 57.9868 72.1143 57.9463C72.025 57.865 71.8925 57.7454 71.7213 57.5942C71.3786 57.2917 70.8816 56.863 70.2686 56.3608C69.0408 55.355 67.355 54.0619 65.5123 52.9004C63.6613 51.7337 61.6929 50.7263 59.8946 50.2568C58.088 49.7852 56.6052 49.8918 55.545 50.7192C54.2433 51.7632 53.9301 53.2679 54.3262 55.1465C54.7279 57.0509 55.8423 59.1997 57.2012 61.2553C58.5518 63.2984 60.1048 65.1915 61.3248 66.5781C61.9337 67.2702 62.4576 67.8333 62.8282 68.2226C63.0134 68.4172 63.1603 68.5685 63.2603 68.6704C63.3103 68.7213 63.3486 68.76 63.3741 68.7856L63.4112 68.8227C63.5989 69.0088 63.6747 69.2801 63.6109 69.5366C63.547 69.7931 63.3527 69.9964 63.0997 70.0727L63.1002 70.0732H63.0997C63.0989 70.0734 63.0974 70.074 63.0953 70.0747C63.091 70.076 63.084 70.0785 63.0743 70.0815C63.0547 70.0877 63.0242 70.0971 62.984 70.1103C62.9034 70.1369 62.7833 70.178 62.63 70.2334C62.323 70.3442 61.8842 70.5128 61.3663 70.7427C60.3267 71.2041 58.9862 71.903 57.7486 72.8569C56.508 73.8132 55.4082 74.9975 54.7935 76.4194C54.188 77.8201 54.0295 79.5031 54.7491 81.5327C55.4196 83.4238 57.3787 84.9269 60.3941 86.2378C63.3805 87.5359 67.2006 88.5619 71.3096 89.6235C75.3943 90.6788 79.7489 91.766 83.7125 93.1826C87.5475 94.5532 91.0887 96.2561 93.7071 98.5986L93.9576 98.8271L94.0108 98.8823C94.2613 99.1682 94.2594 99.6031 93.9947 99.8872C93.7123 100.19 93.2376 100.207 92.9346 99.9243C90.5161 97.6705 87.0973 95.9849 83.2076 94.5947C79.3229 93.2063 75.0453 92.1377 70.9346 91.0757C66.8483 90.0199 62.9098 88.9669 59.796 87.6133C56.7113 86.2723 54.228 84.5509 53.3355 82.0337C52.4922 79.655 52.6575 77.5802 53.4166 75.8242C54.1665 74.0894 55.4723 72.7175 56.8326 71.6689C58.1958 70.6181 59.6515 69.8632 60.7579 69.372C61.0426 69.2457 61.3054 69.1359 61.5391 69.0429C61.1792 68.6605 60.7191 68.1607 60.1988 67.5693C58.9533 66.1537 57.3524 64.2035 55.9503 62.0825C54.5565 59.9741 53.3186 57.6374 52.8585 55.456C52.3933 53.2503 52.7079 51.0693 54.6109 49.5459L54.6173 49.5405C56.2142 48.2908 58.2689 48.2823 60.2735 48.8056C62.2883 49.3316 64.4076 50.4309 66.3121 51.6313C68.2248 52.8369 69.9627 54.1712 71.2193 55.2007C71.5115 55.44 71.7779 55.6634 72.0152 55.8652C72.0187 55.7742 72.0222 55.6801 72.0269 55.5835C72.0853 54.401 72.243 52.7946 72.6451 51.1152C73.4377 47.8048 75.252 43.9418 79.4156 42.8183H79.4161Z",
				fill: "#B0B0B0"
			}),
			/* @__PURE__ */ m("path", {
				d: "M92.2025 71.8976C92.9825 70.8576 94.1975 70.823 95.0106 71.3551C95.4088 71.6157 95.7324 72.0239 95.8554 72.5304C95.9741 73.0196 95.8915 73.5421 95.598 74.0241L95.5365 74.1198C94.8199 75.182 93.5431 75.1125 92.7724 74.6633C92.3694 74.4283 92.0003 74.0436 91.8524 73.5275C91.6964 72.9829 91.8197 72.4066 92.202 71.8976H92.2025ZM94.1893 72.61C94.0725 72.5335 93.9356 72.5029 93.8109 72.5212C93.6987 72.5376 93.5505 72.6001 93.4022 72.798L93.4013 72.799C93.2634 72.9826 93.2847 73.0792 93.2948 73.1144C93.3131 73.1781 93.3786 73.2804 93.5277 73.3674C93.6752 73.4533 93.8459 73.4882 93.9862 73.4704C94.11 73.4547 94.2121 73.4007 94.2929 73.2809L94.2933 73.2804C94.4195 73.0934 94.4169 72.9632 94.3978 72.8844C94.375 72.7904 94.3069 72.687 94.1893 72.61Z",
				fill: "#B0B0B0"
			}),
			/* @__PURE__ */ m("path", {
				d: "M66.5825 62.0441C67.8523 61.0778 69.291 61.4372 70.0669 62.3551C70.4479 62.8059 70.68 63.4013 70.6494 64.0397C70.6182 64.6899 70.3173 65.3239 69.7417 65.8414C69.1452 66.3777 68.451 66.577 67.7837 66.4796C67.1385 66.3855 66.5851 66.0245 66.2041 65.5617C65.8232 65.099 65.576 64.4879 65.6025 63.8405C65.63 63.1706 65.9491 62.5261 66.5825 62.0441ZM68.9214 63.3234C68.6176 62.964 68.0728 62.795 67.4907 63.2379C67.1984 63.4605 67.1095 63.6967 67.1011 63.902C67.0917 64.1298 67.1808 64.3886 67.3618 64.6085C67.5428 64.8284 67.7778 64.9628 68.0005 64.9953C68.2008 65.0245 68.4539 64.9818 68.7388 64.7257C69.0446 64.4508 69.1411 64.1819 69.1514 63.9679C69.1622 63.742 69.0802 63.5113 68.9214 63.3234Z",
				fill: "#B0B0B0"
			}),
			/* @__PURE__ */ m("path", {
				d: "M66.8978 22.9705C68.0035 22.2051 69.238 22.5311 69.9125 23.3284C70.2536 23.7317 70.4627 24.2659 70.4349 24.8406C70.4065 25.4272 70.1343 25.9943 69.6229 26.4529C69.0912 26.9297 68.4671 27.1112 67.8641 27.0232C67.2833 26.9384 66.7889 26.6143 66.4501 26.2019C66.1113 25.7896 65.8901 25.243 65.9144 24.6609C65.9396 24.0566 66.2277 23.4778 66.7914 23.0481L66.8978 22.9705ZM68.7674 24.2971C68.5572 24.0486 68.1939 23.919 67.7836 24.1829L67.701 24.241C67.4778 24.4112 67.4188 24.5824 67.4129 24.7234C67.4061 24.8866 67.47 25.0808 67.6087 25.2498C67.7474 25.4185 67.923 25.5163 68.0809 25.5393C68.2167 25.5591 68.4005 25.5343 68.6214 25.3362C68.8627 25.1198 68.9296 24.9179 68.9369 24.7683C68.9447 24.6069 68.8862 24.4376 68.7674 24.2971Z",
				fill: "#B0B0B0"
			}),
			/* @__PURE__ */ m("path", {
				d: "M69.7877 103.583L69.9249 103.6C70.0157 103.616 70.1047 103.64 70.1906 103.673L70.317 103.729L70.4367 103.799C70.514 103.849 70.5862 103.906 70.652 103.971L70.7457 104.072L70.8288 104.183C70.8803 104.259 70.924 104.34 70.9591 104.425L71.0055 104.556L71.0382 104.69C71.0642 104.826 71.0696 104.965 71.0539 105.103C71.0329 105.286 70.9749 105.464 70.8834 105.624C70.8024 105.766 70.6954 105.891 70.57 105.996L70.5705 105.996C70.2569 106.278 69.8664 106.401 69.4772 106.344C69.1103 106.29 68.8095 106.088 68.609 105.844C68.4088 105.6 68.2697 105.268 68.2848 104.902C68.3008 104.513 68.4892 104.151 68.8258 103.895L68.8263 103.896C68.9507 103.793 69.0912 103.711 69.2438 103.658C69.3746 103.612 69.5115 103.586 69.6496 103.582L69.7877 103.583ZM69.694 104.859C69.6634 104.855 69.6302 104.857 69.6002 104.867C69.5949 104.868 69.5902 104.871 69.5861 104.873L69.5802 104.881C69.5758 104.889 69.5723 104.897 69.5695 104.906L69.5636 104.932C69.5616 104.95 69.5633 104.968 69.5685 104.985C69.5737 105.003 69.5819 105.019 69.5934 105.033C69.6049 105.047 69.6194 105.058 69.6354 105.066C69.6514 105.074 69.6691 105.079 69.6872 105.08C69.705 105.081 69.723 105.079 69.7399 105.073C69.7429 105.072 69.7458 105.07 69.7487 105.069C69.7517 105.064 69.7561 105.059 69.7594 105.053C69.7746 105.025 69.7826 104.993 69.7838 104.963C69.7845 104.946 69.7822 104.932 69.7799 104.922L69.6959 104.947L69.7648 104.889C69.7623 104.887 69.7586 104.883 69.7521 104.879C69.7421 104.873 69.7228 104.864 69.694 104.859ZM69.6554 104.98L69.6403 104.963L69.6955 104.947L69.6554 104.98ZM69.6403 104.963L69.6554 104.98L69.6955 104.947L69.6403 104.963ZM69.6959 104.947L69.7799 104.922C69.7786 104.916 69.7778 104.911 69.7765 104.907C69.7731 104.898 69.7694 104.894 69.7677 104.892C69.7672 104.891 69.766 104.89 69.7648 104.889L69.6959 104.947Z",
				fill: "#B0B0B0"
			}),
			/* @__PURE__ */ m("path", {
				d: "M70.9032 77.3778C71.7078 76.7892 72.6493 76.99 73.1698 77.5756C73.4248 77.8625 73.5885 78.2528 73.5672 78.6825C73.5454 79.1236 73.333 79.5302 72.973 79.8446C72.5911 80.1781 72.1331 80.3121 71.6864 80.2518C71.2593 80.1942 70.897 79.9672 70.6483 79.6781C70.4004 79.3898 70.2278 78.9948 70.2459 78.5594C70.2652 78.0999 70.4945 77.6775 70.9027 77.3783L70.9032 77.3778ZM71.9012 78.5306C71.8763 78.5374 71.8381 78.5528 71.7889 78.5887C71.7689 78.6034 71.7569 78.6151 71.7503 78.6224C71.7485 78.6245 71.7471 78.6263 71.7459 78.6278C71.7485 78.6393 71.7565 78.6663 71.7855 78.7001C71.8257 78.7468 71.8683 78.7625 71.8871 78.765C71.894 78.7659 71.9003 78.7659 71.9095 78.7631C71.9189 78.7602 71.9455 78.7502 71.9862 78.7147C72.0355 78.6716 72.0555 78.6397 72.0628 78.6254C72.0666 78.618 72.0681 78.6133 72.0687 78.6112C72.069 78.6101 72.0691 78.6091 72.0692 78.6088V78.6073C72.069 78.6064 72.0684 78.6041 72.0672 78.6009C72.0648 78.5944 72.0593 78.5841 72.0487 78.5721C72.0259 78.5465 71.9938 78.5293 71.9613 78.5253C71.9459 78.5234 71.9262 78.5239 71.9012 78.5306Z",
				fill: "#B0B0B0"
			}),
			/* @__PURE__ */ m("path", {
				d: "M123.395 82.5147C123.259 82.1925 123.363 81.8186 123.647 81.6139C123.931 81.409 124.319 81.4279 124.582 81.6598V81.6602C124.583 81.661 124.585 81.6622 124.587 81.6641C124.592 81.6682 124.599 81.6751 124.61 81.6842C124.631 81.7023 124.664 81.7301 124.707 81.7657C124.793 81.8369 124.921 81.9396 125.083 82.0611C125.407 82.3053 125.86 82.6203 126.375 82.9098C126.895 83.201 127.456 83.4538 128.001 83.5899C128.549 83.7266 129.03 83.7335 129.426 83.5968C129.712 83.4981 130.03 83.581 130.231 83.8072C130.432 84.0335 130.478 84.3587 130.346 84.6314C130.251 84.8287 129.982 85.1815 129.784 85.9752C129.591 86.7506 129.487 87.923 129.88 89.5186C129.959 89.8392 129.819 90.174 129.536 90.3429C129.252 90.5116 128.891 90.4749 128.647 90.2525C127.432 89.1456 126.393 88.8395 125.671 88.7872C124.939 88.7341 124.467 88.9325 124.303 88.9864C124.005 89.0844 123.678 88.9869 123.482 88.7418C123.287 88.4966 123.265 88.1554 123.427 87.8868C124.052 86.849 124.08 85.5474 123.905 84.4185C123.82 83.8659 123.69 83.3835 123.581 83.0396C123.527 82.8684 123.479 82.7332 123.445 82.6427C123.428 82.5974 123.414 82.5631 123.406 82.5416C123.401 82.531 123.398 82.5235 123.396 82.5191C123.396 82.5171 123.396 82.5154 123.395 82.5147ZM125.388 84.1891C125.525 85.0761 125.575 86.1868 125.287 87.2813C125.442 87.2766 125.607 87.2785 125.78 87.2911C126.468 87.341 127.267 87.5454 128.131 88.0289C128.068 87.0583 128.169 86.253 128.329 85.6119C128.367 85.4584 128.409 85.315 128.452 85.1817C128.174 85.1592 127.901 85.1105 127.638 85.045C126.919 84.8655 126.229 84.5474 125.642 84.2179C125.547 84.165 125.455 84.1109 125.366 84.0572C125.373 84.1007 125.381 84.1447 125.388 84.1891Z",
				fill: "#6D6D6D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M39.7837 77.1335C40.0691 76.9304 40.4566 76.952 40.7178 77.1853L40.7188 77.1858C40.7199 77.1868 40.7222 77.1886 40.7251 77.1912C40.7311 77.1964 40.7409 77.2048 40.7539 77.2161C40.78 77.2386 40.8198 77.2726 40.8721 77.3162C40.9769 77.4036 41.1317 77.5294 41.3267 77.678C41.7179 77.9763 42.2641 78.3621 42.8887 78.7175C43.5166 79.0748 44.2015 79.3885 44.8721 79.5598C45.5451 79.7317 46.1533 79.7474 46.666 79.573C46.9556 79.4746 47.276 79.5621 47.4756 79.7937C47.6752 80.0253 47.7142 80.3549 47.5742 80.6267C47.4782 80.8131 47.1323 81.2849 46.8872 82.2502C46.6444 83.2066 46.5124 84.6432 46.981 86.5891C47.0583 86.9103 46.9163 87.2441 46.6314 87.4114C46.3465 87.5786 45.9859 87.5397 45.7432 87.3157C44.2689 85.9548 42.9947 85.5655 42.0948 85.4954C41.1835 85.4244 40.5907 85.6703 40.3897 85.7346C40.0915 85.83 39.7654 85.7302 39.5718 85.4841C39.3782 85.2381 39.3577 84.8975 39.5205 84.6301C40.3047 83.3425 40.3417 81.7349 40.1367 80.3621C40.036 79.6876 39.8813 79.0987 39.7515 78.679C39.6868 78.4698 39.6289 78.304 39.5879 78.1926C39.5675 78.1371 39.5512 78.0951 39.5406 78.0681C39.5352 78.0546 39.5312 78.0446 39.5288 78.0388L39.5264 78.0335L39.5039 77.9724C39.4054 77.6643 39.5161 77.324 39.7837 77.1335ZM41.5366 79.6521C41.5666 79.8094 41.5955 79.9723 41.6206 80.1404C41.7867 81.2526 41.8343 82.6461 41.4282 83.9939C41.6673 83.9788 41.9296 83.9778 42.2115 83.9998C43.0771 84.0672 44.0981 84.345 45.2066 85.0247C45.0978 83.7443 45.2259 82.6973 45.4331 81.8811C45.4975 81.6275 45.5698 81.3976 45.6436 81.1912C45.254 81.1726 44.8696 81.1076 44.501 81.0134C43.6562 80.7976 42.8429 80.4172 42.147 80.0212C41.9337 79.8999 41.7298 79.7751 41.5366 79.6521Z",
				fill: "#B0B0B0"
			})
		]
	});
})), Bn = /* @__PURE__ */ we({ default: () => Vn }), Vn, Hn = Se((() => {
	Vn = (e) => /* @__PURE__ */ h("svg", {
		width: 40,
		height: 40,
		viewBox: "0 0 40 40",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M17.4021 5.50392L21.3268 7.68766L25.2515 9.8714L25.0216 6.85885C24.9956 6.70345 24.8974 6.55052 24.7827 6.48669L23.3271 5.6768C23.2028 5.60765 23.1112 5.41473 23.1352 5.27221L23.412 3.61849C23.4302 3.50951 23.3604 3.36206 23.2652 3.30912L22.1285 2.67657C22.3725 2.58277 22.5375 2.31371 22.5462 1.90896C22.561 1.22402 22.1292 0.419934 21.5837 0.116453C21.0384 -0.187028 20.5826 0.123209 20.5679 0.808227C20.5592 1.21289 20.7087 1.65699 20.9431 2.01698L19.8063 1.38451C19.7113 1.33157 19.6366 1.39866 19.6498 1.52512L19.8498 3.44417C19.8671 3.60958 19.7695 3.69734 19.6452 3.6281L18.1896 2.81821C18.075 2.75438 17.9727 2.7958 17.9405 2.91892L17.4021 5.50392ZM22.1325 1.67885C22.124 2.07716 21.8589 2.25775 21.5416 2.08121C21.2243 1.90467 20.9731 1.43689 20.9817 1.0385C20.9903 0.640192 21.2554 0.459598 21.5727 0.636138C21.89 0.812679 22.1411 1.28054 22.1325 1.67885Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M27.794 39.271L12.6271 30.4409C11.5704 29.829 10.938 28.694 10.9525 27.4335L11.1917 2.90905C11.2039 1.84608 12.3775 1.12704 13.2758 1.63218L28.2071 10.0696C29.2711 10.6694 29.9152 11.7973 29.9145 13.057L29.8898 37.9869C29.8884 39.063 28.6959 39.7937 27.794 39.271Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.9611 13.0538L29.9363 37.9837C29.9355 38.5066 29.6607 38.9868 29.201 39.2681C28.742 39.5489 28.2066 39.565 27.769 39.3114L12.6021 30.4814C11.5253 29.858 10.8917 28.7194 10.9064 27.4361L11.1456 2.91166C11.1514 2.39579 11.4255 1.92189 11.8787 1.64384C12.3327 1.36548 12.8642 1.34577 13.3009 1.59122L28.2321 10.0288C28.7796 10.3372 29.2152 10.7786 29.5124 11.3055C29.8034 11.8213 29.9615 12.4188 29.9611 13.0538ZM12.6526 30.4003L27.8194 39.2303C28.2283 39.4672 28.7283 39.4521 29.157 39.1897C29.5863 38.927 29.8431 38.4785 29.8438 37.99L29.8687 13.0601C29.8694 11.8085 29.239 10.7058 28.1825 10.1105L13.2515 1.67302C12.8436 1.44378 12.3471 1.46214 11.9232 1.72214C11.4998 1.9819 11.2438 2.42456 11.2384 2.90625L10.9991 27.4307C10.992 28.063 11.1461 28.6593 11.4358 29.1729C11.7194 29.6758 12.1332 30.0995 12.6526 30.4003Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M26.9628 39.7802L11.796 30.9501C10.7393 30.3382 10.107 29.2031 10.1215 27.9426L10.3606 3.41827C10.3727 2.35529 11.5464 1.63625 12.4448 2.14139L27.376 10.5788C28.44 11.1787 29.0841 12.3065 29.0834 13.5662L29.0587 38.4961C29.0573 39.5722 27.8648 40.3028 26.9628 39.7802Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M29.1298 13.5631L29.1053 38.4929C29.1046 39.0158 28.8297 39.4959 28.37 39.7772C27.9111 40.0581 27.3756 40.0744 26.9378 39.8207L11.771 30.9907C10.6944 30.3674 10.0607 29.2287 10.0753 27.9454L10.3146 3.42094C10.3204 2.90507 10.5944 2.43117 11.0477 2.15312C11.5016 1.87476 12.0332 1.85505 12.4699 2.1005L27.4009 10.538C27.9484 10.8465 28.3841 11.2878 28.6812 11.8146C28.9722 12.3304 29.1302 12.9282 29.1298 13.5631ZM11.8215 30.9096L26.9881 39.7397C27.3971 39.9765 27.8972 39.9614 28.326 39.6989C28.7552 39.4361 29.012 38.9877 29.0128 38.4991L29.0374 13.5694C29.038 12.3179 28.408 11.2151 27.3513 10.6197L12.4203 2.18229C12.0123 1.95305 11.5159 1.97141 11.092 2.23142C10.6686 2.49118 10.4126 2.93384 10.4072 3.41553L10.1679 27.94C10.1607 28.5723 10.3148 29.1686 10.6046 29.6822C10.8882 30.185 11.302 30.6088 11.8215 30.9096Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M11.6628 2.65692L27.6684 11.6961L27.3812 36.5996L11.2574 27.497L11.6628 2.65692Z",
				fill: "white"
			}),
			/* @__PURE__ */ m("path", {
				d: "M27.42 36.6671L27.3615 36.6341L11.2172 27.5199L11.6241 2.58936L11.6822 2.62218L27.7082 11.673L27.708 11.6965L27.42 36.6671ZM11.2974 27.474L27.3421 36.5319L27.6283 11.7191L11.7013 2.72425L11.2974 27.474Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.1517 10.249L25.6029 9.39377C25.6029 9.39377 24.879 8.42833 24.8773 8.33517C24.8756 8.24201 24.3795 7.21917 24.3691 7.1784C24.3587 7.13762 23.1768 6.87817 23.1768 6.87817C23.1768 6.87817 22.731 7.75952 22.7517 7.80992C22.7723 7.86031 24.1517 10.249 24.1517 10.249Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.9397 3.17437L18.0588 2.79156L18.9571 3.53413L18.6139 1.74949L19.8065 1.38464L21.2277 2.64968L20.8129 4.39974L18.5321 5.08802C18.5321 5.08802 17.7234 4.82317 17.6923 4.75274C17.6611 4.68224 16.9397 3.17437 16.9397 3.17437Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M19.931 0.397992L20.9817 0.0368042L21.8007 0.535267L22.2827 1.35756L22.0262 2.43294L21.1812 1.99123L21.3271 2.43524L20.7302 2.66885L19.8819 1.98686L19.7245 1.2462L19.931 0.397992Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.3024 5.88147L20.2271 8.06521L24.1518 10.249L23.9219 7.23648C23.8958 7.08101 23.7977 6.92815 23.683 6.86433L22.2274 6.05443C22.1031 5.9852 22.0115 5.79237 22.0354 5.64977L22.3123 3.99604C22.3305 3.88707 22.2606 3.73962 22.1655 3.68668L21.0287 3.0542C21.2728 2.96041 21.4378 2.69135 21.4464 2.2866C21.4612 1.60158 21.0295 0.79757 20.484 0.494089C19.9387 0.190609 19.4829 0.500767 19.4682 1.18586C19.4595 1.59053 19.6089 2.03462 19.8434 2.39462L18.7066 1.76214C18.6115 1.70929 18.5369 1.77629 18.5501 1.90284L18.7501 3.82189C18.7674 3.9873 18.6698 4.07505 18.5455 4.00582L17.0899 3.19593C16.9752 3.1321 16.8729 3.17351 16.8409 3.29664L16.3024 5.88147ZM21.0328 2.0564C21.0243 2.45471 20.7592 2.63531 20.4419 2.45885C20.1246 2.28231 19.8735 1.81445 19.882 1.41614C19.8906 1.01783 20.1557 0.837235 20.473 1.01378C20.7903 1.19024 21.0414 1.6581 21.0328 2.0564Z",
				fill: "#DCDCDC"
			}),
			/* @__PURE__ */ m("path", {
				d: "M24.197 10.3196L16.2574 5.90194L16.802 3.28841C16.8208 3.21592 16.8613 3.16409 16.9164 3.14056C16.9733 3.11624 17.0418 3.12363 17.1093 3.16107L18.5649 3.97096C18.6043 3.99298 18.6402 3.99576 18.666 3.97867C18.7014 3.95522 18.7181 3.89815 18.7107 3.82598L18.5107 1.90693C18.502 1.82402 18.5258 1.75749 18.5758 1.72434C18.6178 1.6966 18.6724 1.6978 18.726 1.72744L19.7312 2.28679C19.5302 1.93244 19.4209 1.53827 19.4284 1.18511C19.4363 0.822566 19.5687 0.541262 19.7918 0.413367C19.9914 0.298827 20.2441 0.315201 20.5033 0.45947C21.0603 0.76931 21.5013 1.58938 21.4862 2.28759C21.4782 2.65593 21.3446 2.93119 21.1161 3.05742L22.1848 3.65206C22.2946 3.71318 22.3725 3.87709 22.3515 4.00276L22.0746 5.65648C22.0535 5.78231 22.1372 5.95885 22.2467 6.01981L23.7023 6.82971C23.8267 6.89894 23.9331 7.06356 23.9611 7.23L24.197 10.3196ZM16.3473 5.86092L24.1065 10.1782L23.8823 7.23946C23.8585 7.09877 23.7685 6.95736 23.6638 6.89902L22.2082 6.08913C22.0685 6.01139 21.9695 5.80297 21.9963 5.64321L22.2732 3.98948C22.2887 3.89664 22.2271 3.76636 22.1462 3.72137L20.9353 3.04756L21.0146 3.01704C21.2559 2.92436 21.3988 2.65776 21.4068 2.28568C21.4213 1.61394 20.9987 0.825745 20.4648 0.528782C20.2308 0.398582 20.0059 0.38197 19.8314 0.482124C19.633 0.595869 19.5151 0.852691 19.508 1.18662C19.4997 1.56791 19.6342 2.00024 19.8767 2.3728L19.9642 2.50713L18.6874 1.79668C18.6719 1.78801 18.6424 1.77553 18.6197 1.79048C18.596 1.80622 18.5845 1.84755 18.5897 1.8985L18.7897 3.81755C18.8006 3.92136 18.7715 4.00419 18.7099 4.04488C18.6589 4.07843 18.592 4.07692 18.5262 4.04035L17.0707 3.23046C17.0252 3.20511 16.9815 3.19914 16.9477 3.21353C16.9153 3.22736 16.8917 3.25955 16.8794 3.30645L16.3473 5.86092ZM20.6757 2.56627C20.5956 2.56627 20.5096 2.54187 20.4226 2.49346C20.0937 2.31048 19.8334 1.8268 19.8422 1.41514C19.847 1.1983 19.927 1.02955 20.062 0.952209C20.1835 0.882658 20.3363 0.892038 20.4923 0.978917C20.8211 1.16182 21.0814 1.64557 21.0725 2.05716C21.0678 2.27392 20.9878 2.44267 20.8528 2.52009C20.7991 2.55093 20.7392 2.56627 20.6757 2.56627ZM20.2392 0.985831C20.1892 0.985831 20.1428 0.997596 20.1016 1.0212C19.9913 1.0844 19.9258 1.22858 19.9217 1.41689C19.9134 1.80216 20.1554 2.25389 20.4612 2.42399C20.5919 2.49672 20.7169 2.50642 20.8132 2.45117C20.9235 2.38798 20.989 2.24371 20.993 2.05549C21.0013 1.67021 20.7594 1.21849 20.4536 1.04839C20.3788 1.00682 20.3059 0.985831 20.2392 0.985831Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.8199 22.1522C18.356 22.4427 18.8833 22.9055 19.3702 23.5098C19.8567 24.1136 20.2928 24.8459 20.6546 25.6613C20.6911 25.7436 20.6761 25.8205 20.6211 25.8329C20.5661 25.8454 20.4918 25.7888 20.4553 25.7065C20.1094 24.9272 19.6969 24.2371 19.2438 23.6748C18.7911 23.113 18.3065 22.6891 17.8178 22.4243C17.329 22.1594 16.8419 22.0566 16.3842 22.1251C15.9261 22.1936 15.5061 22.4325 15.151 22.8319C15.1134 22.874 15.0389 22.85 14.9846 22.7783C14.9302 22.7065 14.9166 22.6142 14.9541 22.572C15.3257 22.1541 15.7696 21.8986 16.2615 21.8251C16.7538 21.7515 17.2838 21.8617 17.8199 22.1522Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M16.1811 14.6654C16.2282 14.6376 16.3039 14.6787 16.3502 14.7571C16.3965 14.8356 16.3958 14.9217 16.3487 14.9495L15.1705 15.6445L16.3276 17.6054C16.3739 17.6838 16.3732 17.77 16.3261 17.7978C16.2789 17.8256 16.2032 17.7846 16.1569 17.7061L14.9998 15.7452L13.8218 16.4406C13.7747 16.4684 13.699 16.4274 13.6527 16.349C13.6064 16.2705 13.6071 16.1844 13.6542 16.1566L14.8322 15.4612L13.6753 13.5007C13.629 13.4222 13.6297 13.3361 13.6768 13.3083C13.7239 13.2805 13.7997 13.3215 13.846 13.4L15.0029 15.3605L16.1811 14.6654Z",
				fill: "#3D3D3D"
			}),
			/* @__PURE__ */ m("path", {
				d: "M23.4855 18.2029C23.5326 18.1751 23.6084 18.2162 23.6547 18.2946C23.701 18.373 23.7003 18.4592 23.6531 18.487L22.4749 19.182L23.6321 21.1429C23.6783 21.2213 23.6777 21.3074 23.6305 21.3353C23.5834 21.3631 23.5077 21.322 23.4614 21.2436L22.3042 19.2827L21.1263 19.9781C21.0791 20.0059 21.0034 19.9649 20.9571 19.8864C20.9109 19.808 20.9115 19.7219 20.9586 19.694L22.1366 18.9986L20.9797 17.0381C20.9334 16.9597 20.9341 16.8736 20.9813 16.8458C21.0284 16.8179 21.1041 16.859 21.1504 16.9374L22.3073 18.8979L23.4855 18.2029Z",
				fill: "#3D3D3D"
			})
		]
	});
})), Un = /* @__PURE__ */ we({ default: () => Wn }), Wn, Gn = Se((() => {
	Wn = (e) => /* @__PURE__ */ h("svg", {
		width: 140,
		height: 140,
		viewBox: "0 0 140 140",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [/* @__PURE__ */ h("g", {
			clipPath: "url(#clip0_813_13569)",
			children: [
				/* @__PURE__ */ m("path", {
					d: "M60.9072 19.2637L74.6438 26.9068L88.3802 34.5499L87.5756 24.006C87.4843 23.4621 87.1407 22.9268 86.7393 22.7034L81.6448 19.8688C81.2097 19.6268 80.8892 18.9516 80.973 18.4527L81.942 12.6647C82.0057 12.2833 81.7611 11.7672 81.4281 11.5819L77.4495 9.36798C78.3036 9.0397 78.8812 8.09798 78.9115 6.68137C78.9632 4.28408 77.452 1.46977 75.543 0.407586C73.6342 -0.654598 72.039 0.431231 71.9875 2.82879C71.9572 4.24513 72.4802 5.79946 73.3007 7.05944L69.3218 4.84577C68.9893 4.66049 68.7281 4.8953 68.7743 5.33792L69.4742 12.0546C69.5346 12.6335 69.193 12.9407 68.7581 12.6984L63.6634 9.86374C63.2622 9.64035 62.9042 9.78529 62.7918 10.2162L60.9072 19.2637ZM77.4637 5.87596C77.4339 7.27005 76.5061 7.90213 75.3955 7.28424C74.2849 6.66635 73.4058 5.02911 73.4359 3.63475C73.4659 2.24067 74.3937 1.60859 75.5043 2.22648C76.6149 2.84438 77.4938 4.48188 77.4637 5.87596Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M97.278 137.448L44.1938 106.543C40.4954 104.402 38.282 100.429 38.3329 96.017L39.17 10.1816C39.2126 6.46117 43.3203 3.94454 46.4645 5.71253L98.7241 35.2436C102.448 37.3429 104.702 41.2904 104.7 45.6994L104.613 132.954C104.608 136.721 100.435 139.278 97.278 137.448Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M104.863 45.6884L104.776 132.943C104.774 134.773 103.812 136.454 102.203 137.438C100.597 138.421 98.7226 138.478 97.1908 137.59L44.1067 106.685C40.3381 104.503 38.1203 100.518 38.1718 96.0264L39.0092 10.1909C39.0295 8.38539 39.9887 6.72673 41.575 5.75358C43.1639 4.7793 45.0242 4.71031 46.5527 5.56941L98.8116 35.1008C100.728 36.1805 102.253 37.7253 103.293 39.5693C104.311 41.3746 104.865 43.4658 104.863 45.6884ZM44.2836 106.401L97.3675 137.306C98.7986 138.135 100.548 138.082 102.049 137.164C103.551 136.245 104.45 134.675 104.453 132.965L104.54 45.7106C104.542 41.33 102.336 37.4705 98.6383 35.387L46.3796 5.85568C44.9522 5.05334 43.2142 5.1176 41.7306 6.02761C40.2488 6.93678 39.3527 8.4861 39.3338 10.172L38.4964 96.0074C38.4714 98.2206 39.0108 100.308 40.0249 102.105C41.0172 103.865 42.4656 105.348 44.2836 106.401Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M94.3704 139.231L41.2866 108.325C37.5881 106.183 35.375 102.211 35.4257 97.799L36.2628 11.9638C36.3051 8.2434 40.413 5.72677 43.5573 7.49475L95.8165 37.0258C99.5406 39.1255 101.795 43.0726 101.792 47.4816L101.706 134.736C101.701 138.503 97.5275 141.06 94.3704 139.231Z",
					fill: "#DCDCDC"
				}),
				/* @__PURE__ */ m("path", {
					d: "M101.954 47.4706L101.868 134.725C101.866 136.555 100.904 138.236 99.295 139.22C97.6887 140.203 95.8144 140.26 94.2821 139.372L41.1985 108.467C37.4305 106.286 35.2124 102.3 35.2636 97.8089L36.101 11.9732C36.1213 10.1676 37.0805 8.50896 38.6668 7.5358C40.2557 6.56153 42.116 6.49254 43.6445 7.35163L95.9032 36.883C97.8194 37.9627 99.3443 39.5073 100.384 41.351C101.403 43.1562 101.956 45.2486 101.954 47.4706ZM41.3752 108.183L94.4584 139.089C95.8898 139.918 97.64 139.865 99.1409 138.946C100.643 138.026 101.542 136.457 101.545 134.747L101.631 47.4929C101.633 43.1125 99.428 39.2527 95.7296 37.169L43.4709 7.63791C42.0431 6.83557 40.3055 6.89983 38.8218 7.80984C37.3401 8.71901 36.444 10.2683 36.4251 11.9542L35.5877 97.7899C35.5624 100.003 36.1018 102.09 37.1161 103.888C38.1088 105.648 39.5571 107.131 41.3752 108.183Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M40.8192 9.29883L96.8387 40.9359L95.8335 128.098L39.4004 96.2393L40.8192 9.29883Z",
					fill: "white"
				}),
				/* @__PURE__ */ m("path", {
					d: "M95.9697 128.335L95.765 128.219L39.2598 96.3195L40.6839 9.0625L40.8875 9.1774L96.9785 40.8551L96.9777 40.9375L95.9697 128.335ZM39.5408 96.1587L95.6971 127.861L96.6989 41.0165L40.9543 9.53461L39.5408 96.1587Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M84.5313 35.8715L89.6108 32.8783C89.6108 32.8783 87.0769 29.4993 87.0711 29.1732C87.0652 28.8472 85.3287 25.2672 85.2922 25.1245C85.2561 24.9818 81.1192 24.0737 81.1192 24.0737C81.1192 24.0737 79.559 27.1585 79.6313 27.3348C79.7037 27.5112 84.5313 35.8715 84.5313 35.8715Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M59.2891 11.1102L63.2059 9.7704L66.3499 12.3694L65.1486 6.12315L69.3228 4.84619L74.2971 9.27381L72.8454 15.399L64.8623 17.808C64.8623 17.808 62.0319 16.881 61.9231 16.6345C61.814 16.3878 59.2891 11.1102 59.2891 11.1102Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M69.7589 1.39307L73.4365 0.128906L76.3028 1.87352L77.9899 4.75155L77.0921 8.51537L74.1345 6.96939L74.6453 8.52344L72.556 9.34108L69.587 6.95409L69.0361 4.36178L69.7589 1.39307Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M57.0586 20.5852L70.7952 28.2283L84.5315 35.8714L83.727 25.3278C83.6357 24.7836 83.2921 24.2486 82.891 24.0252L77.7962 21.1906C77.3611 20.9483 77.0406 20.2734 77.1243 19.7743L78.0933 13.9862C78.157 13.6048 77.9125 13.0888 77.5795 12.9035L73.6009 10.6898C74.4553 10.3615 75.0325 9.4198 75.0628 8.00319C75.1146 5.60562 73.6034 2.79159 71.6944 1.7294C69.7859 0.667221 68.1904 1.75277 68.1389 4.15062C68.1086 5.56695 68.6316 7.12128 69.452 8.38126L65.4734 6.1676C65.1407 5.98259 64.8795 6.21712 64.9257 6.66002L65.6256 13.3767C65.6863 13.9556 65.3446 14.2628 64.9095 14.0205L59.815 11.1858C59.4136 10.9624 59.0555 11.1074 58.9434 11.5383L57.0586 20.5852ZM73.6151 7.19751C73.5853 8.59159 72.6575 9.22367 71.5469 8.60605C70.4363 7.98816 69.5575 6.35065 69.5872 4.95657C69.6173 3.56249 70.5451 2.93041 71.656 3.54831C72.7663 4.16592 73.6451 5.80342 73.6151 7.19751Z",
					fill: "#DCDCDC"
				}),
				/* @__PURE__ */ m("path", {
					d: "M84.6898 36.1188L56.9014 20.657L58.8073 11.5097C58.873 11.256 59.0149 11.0746 59.2077 10.9922C59.4069 10.9071 59.6467 10.933 59.8829 11.064L64.9774 13.8986C65.1153 13.9757 65.2411 13.9854 65.3312 13.9256C65.4553 13.8436 65.5137 13.6438 65.4876 13.3912L64.7876 6.67452C64.7573 6.38435 64.8405 6.15149 65.0157 6.03548C65.1626 5.93839 65.3538 5.94256 65.5413 6.04633L69.0595 8.00405C68.3559 6.76382 67.9733 5.3842 67.9998 4.14814C68.0273 2.87925 68.4908 1.89469 69.2714 1.44706C69.9703 1.04617 70.8547 1.10348 71.7619 1.60842C73.7113 2.69286 75.2548 5.56309 75.2019 8.00683C75.1741 9.29603 74.7064 10.2595 73.9066 10.7012L77.647 12.7825C78.0315 12.9964 78.3039 13.5701 78.2304 14.0099L77.2615 19.798C77.1875 20.2384 77.4804 20.8562 77.8638 21.0696L82.9585 23.9042C83.3939 24.1466 83.7661 24.7227 83.8641 25.3053L84.6898 36.1188ZM57.2157 20.5135L84.3732 35.6241L83.5884 25.3384C83.5052 24.846 83.19 24.351 82.8236 24.1468L77.7288 21.3122C77.24 21.0401 76.8937 20.3107 76.9874 19.7515L77.9564 13.9635C78.0107 13.6385 77.7951 13.1825 77.5121 13.0251L73.2737 10.6667L73.5513 10.5599C74.396 10.2355 74.8962 9.30243 74.9243 8.00016C74.9749 5.64906 73.4957 2.89038 71.627 1.85101C70.8082 1.39531 70.0209 1.33717 69.4103 1.68771C68.7159 2.08582 68.3033 2.98469 68.2782 4.15343C68.2493 5.48797 68.72 7.00113 69.5688 8.30507L69.8751 8.77523L65.4063 6.28864C65.3521 6.25832 65.2489 6.21464 65.1693 6.26694C65.0861 6.32203 65.0461 6.4667 65.0644 6.64503L65.7644 13.3617C65.8025 13.725 65.7007 14.0149 65.4851 14.1574C65.3065 14.2748 65.0722 14.2695 64.8422 14.1415L59.7477 11.3069C59.5885 11.2181 59.4355 11.1973 59.3173 11.2476C59.2038 11.296 59.1212 11.4087 59.0783 11.5729L57.2157 20.5135ZM72.3653 8.98222C72.0849 8.98222 71.7839 8.89681 71.4793 8.72738C70.3283 8.08696 69.4172 6.39408 69.4481 4.95326C69.4648 4.19432 69.7447 3.6037 70.2173 3.33301C70.6424 3.08958 71.1774 3.12241 71.7233 3.42648C72.8742 4.06663 73.7853 5.75978 73.7541 7.20032C73.7377 7.95898 73.4576 8.54961 72.9852 8.82058C72.7971 8.92852 72.5876 8.98222 72.3653 8.98222ZM70.8375 3.45068C70.6625 3.45068 70.5 3.49186 70.3559 3.57449C69.97 3.79566 69.7405 4.30032 69.7263 4.95939C69.6974 6.30784 70.5442 7.88887 71.6145 8.48423C72.0718 8.73879 72.5095 8.77273 72.8466 8.57938C73.2325 8.35821 73.4618 7.85326 73.4759 7.19448C73.5049 5.84602 72.6583 4.26499 71.588 3.66963C71.3263 3.52413 71.0709 3.45068 70.8375 3.45068Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M66.048 86.5642C64.1717 85.5474 62.3264 83.9276 60.6222 81.8126C58.9193 79.6993 57.3931 77.1361 56.1267 74.2821C55.9989 73.9942 56.0513 73.7252 56.2439 73.6816C56.4366 73.6381 56.6965 73.8362 56.8243 74.1241C58.0347 76.8518 59.4786 79.2669 61.0645 81.2351C62.6489 83.2013 64.3451 84.6849 66.0556 85.6118C67.7661 86.5388 69.4712 86.8986 71.0731 86.6591C72.6765 86.4193 74.1462 85.5832 75.3894 84.1852C75.5207 84.0377 75.7815 84.1218 75.9718 84.3729C76.162 84.624 76.2098 84.9472 76.0786 85.0948C74.7778 86.5576 73.2242 87.4516 71.5025 87.7091C69.7795 87.9668 67.9243 87.581 66.048 86.5642Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M61.3039 56.0578L60.8242 56.2009L54.6999 57.9925C54.5091 58.0475 54.2305 57.8266 54.08 57.5016C53.9298 57.1766 53.9634 56.8663 54.154 56.8106L59.7962 55.1586L53.4296 46.0457C53.2262 45.7546 53.1692 45.3902 53.3025 45.2344C53.4359 45.0785 53.7104 45.1887 53.9138 45.4798L61.3039 56.0578Z",
					fill: "#3D3D3D"
				}),
				/* @__PURE__ */ m("path", {
					d: "M73.5001 60.5287L73.9798 61.2949L80.1042 71.0409C80.2949 71.3437 80.5735 71.4847 80.7241 71.3552C80.8742 71.2252 80.8406 70.8713 80.65 70.568L75.0078 61.5878L81.3744 60.744C81.5778 60.717 81.6348 60.4267 81.5015 60.0977C81.3681 59.7686 81.0936 59.5223 80.8903 59.5492L73.5001 60.5287Z",
					fill: "#3D3D3D"
				})
			]
		}), /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
			id: "clip0_813_13569",
			children: /* @__PURE__ */ m("rect", {
				width: 140,
				height: 140,
				fill: "white"
			})
		}) })]
	});
})), Kn = {
	man: t.lazy(() => Promise.resolve().then(() => (Ve(), ze))),
	women: t.lazy(() => Promise.resolve().then(() => (We(), He))),
	ghost: t.lazy(() => Promise.resolve().then(() => (qe(), Ge))),
	partner: t.lazy(() => Promise.resolve().then(() => (Xe(), Je))),
	search: t.lazy(() => Promise.resolve().then(() => ($e(), Ze))),
	wallet: t.lazy(() => Promise.resolve().then(() => (nt(), et))),
	aBoard: t.lazy(() => Promise.resolve().then(() => (at(), rt))),
	basketFull: t.lazy(() => Promise.resolve().then(() => (ct(), ot))),
	basket: t.lazy(() => Promise.resolve().then(() => (dt(), lt))),
	boxOpen: t.lazy(() => Promise.resolve().then(() => (mt(), ft))),
	box: t.lazy(() => Promise.resolve().then(() => (_t(), ht))),
	boxes: t.lazy(() => Promise.resolve().then(() => (bt(), vt))),
	calculator: t.lazy(() => Promise.resolve().then(() => (Ct(), xt))),
	cartFull: t.lazy(() => Promise.resolve().then(() => (Et(), wt))),
	cart: t.lazy(() => Promise.resolve().then(() => (kt(), Dt))),
	cashRegister: t.lazy(() => Promise.resolve().then(() => (Mt(), At))),
	coin: t.lazy(() => Promise.resolve().then(() => (Ft(), Nt))),
	coins: t.lazy(() => Promise.resolve().then(() => (Rt(), It))),
	contract: t.lazy(() => Promise.resolve().then(() => (Vt(), zt))),
	creditCard: t.lazy(() => Promise.resolve().then(() => (Wt(), Ht))),
	dolly: t.lazy(() => Promise.resolve().then(() => (qt(), Gt))),
	gift: t.lazy(() => Promise.resolve().then(() => (Xt(), Jt))),
	house: t.lazy(() => Promise.resolve().then(() => ($t(), Zt))),
	levelUp: t.lazy(() => Promise.resolve().then(() => (nn(), en))),
	marketStand: t.lazy(() => Promise.resolve().then(() => (on(), rn))),
	megaphone: t.lazy(() => Promise.resolve().then(() => (ln(), sn))),
	mobileShopping: t.lazy(() => Promise.resolve().then(() => (fn(), un))),
	money: t.lazy(() => Promise.resolve().then(() => (hn(), pn))),
	posMachine: t.lazy(() => Promise.resolve().then(() => (vn(), gn))),
	receipt: t.lazy(() => Promise.resolve().then(() => (xn(), yn))),
	shield: t.lazy(() => Promise.resolve().then(() => (wn(), Sn))),
	shoppingBag: t.lazy(() => Promise.resolve().then(() => (Dn(), Tn))),
	store: t.lazy(() => Promise.resolve().then(() => (An(), On))),
	locked: t.lazy(() => Promise.resolve().then(() => (Nn(), jn))),
	wift: t.lazy(() => Promise.resolve().then(() => (In(), Pn))),
	champagne: t.lazy(() => Promise.resolve().then(() => (zn(), Ln))),
	checklist: t.lazy(() => Promise.resolve().then(() => (Hn(), Bn))),
	checklistSmile: t.lazy(() => Promise.resolve().then(() => (Gn(), Un)))
}, qn = (n) => {
	let r = e(10), { type: i, height: a, width: o } = n, s = a === void 0 ? 15 : a, c = o === void 0 ? 14 : o, l = Kn[i], u;
	r[0] !== s || r[1] !== c ? (u = /* @__PURE__ */ m("div", { style: {
		width: c,
		height: s
	} }), r[0] = s, r[1] = c, r[2] = u) : u = r[2];
	let d;
	r[3] !== l || r[4] !== s || r[5] !== c ? (d = /* @__PURE__ */ m(l, {
		width: c,
		height: s
	}), r[3] = l, r[4] = s, r[5] = c, r[6] = d) : d = r[6];
	let f;
	return r[7] !== u || r[8] !== d ? (f = /* @__PURE__ */ m(t.Suspense, {
		fallback: u,
		children: d
	}), r[7] = u, r[8] = d, r[9] = f) : f = r[9], f;
}, Jn = /* @__PURE__ */ we({ default: () => Yn }), Yn, Xn = Se((() => {
	Yn = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11860)",
				className: "icon-inner",
				children: [/* @__PURE__ */ m("path", {
					d: "M10.855 11.645C10.7608 11.5508 10.6332 11.498 10.5 11.498C10.3669 11.498 10.2392 11.5508 10.145 11.645C10.0508 11.7391 9.99796 11.8668 9.99796 12C9.99796 12.1331 10.0508 12.2608 10.145 12.355L11.645 13.855C11.6917 13.9013 11.7471 13.938 11.808 13.9629C11.869 13.9878 11.9342 14.0004 12 14C12.0685 13.9978 12.1357 13.9816 12.1977 13.9524C12.2596 13.9231 12.3148 13.8815 12.36 13.83L15.86 9.83C15.9408 9.72966 15.9798 9.602 15.9688 9.47364C15.9578 9.34527 15.8976 9.22611 15.8009 9.141C15.7042 9.05589 15.5784 9.0114 15.4496 9.0168C15.3209 9.0222 15.1992 9.07708 15.11 9.17L12 12.77L10.855 11.645Z",
					fill: "black"
				}), /* @__PURE__ */ m("path", {
					d: "M16.5 11.5C16.3674 11.5 16.2402 11.5527 16.1464 11.6464C16.0527 11.7402 16 11.8674 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C11.21 15.9996 10.4379 15.7654 9.78088 15.3268C9.12388 14.8882 8.61146 14.2648 8.30824 13.5354C8.00502 12.8059 7.92457 12.003 8.07704 11.2279C8.22951 10.4528 8.60808 9.74024 9.165 9.18C9.53535 8.80469 9.97684 8.50702 10.4636 8.30441C10.9504 8.10179 11.4727 7.9983 12 8C12.3197 8.002 12.6383 8.03889 12.95 8.11C13.0152 8.13018 13.0839 8.13678 13.1518 8.1294C13.2197 8.12202 13.2853 8.10081 13.3447 8.06709C13.4041 8.03336 13.4559 7.98784 13.497 7.93331C13.5381 7.87879 13.5676 7.81642 13.5837 7.75006C13.5998 7.68369 13.6021 7.61474 13.5905 7.54745C13.5789 7.48016 13.5536 7.41595 13.5163 7.3588C13.4789 7.30164 13.4303 7.25274 13.3733 7.21511C13.3163 7.17748 13.2522 7.15192 13.185 7.14C12.7966 7.04862 12.399 7.00165 12 7C11.0122 7.00513 10.048 7.30276 9.22915 7.85533C8.4103 8.40789 7.77348 9.19063 7.39906 10.1048C7.02463 11.0189 6.92938 12.0235 7.12532 12.9917C7.32125 13.9599 7.7996 14.8484 8.5 15.545C9.42834 16.4738 10.6868 16.9969 12 17C13.3261 17 14.5978 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 11.8674 16.9473 11.7402 16.8536 11.6464C16.7598 11.5527 16.6326 11.5 16.5 11.5Z",
					fill: "black"
				})]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11860",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), Zn = /* @__PURE__ */ we({ default: () => Qn }), Qn, $n = Se((() => {
	Qn = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_8815_191346)",
				className: "icon-inner",
				children: [/* @__PURE__ */ m("path", {
					d: "M12 7C11.0111 7 10.0444 7.29324 9.22215 7.84265C8.39991 8.39206 7.75904 9.17295 7.3806 10.0866C7.00217 11.0002 6.90315 12.0055 7.09608 12.9755C7.289 13.9454 7.76521 14.8363 8.46447 15.5355C9.16373 16.2348 10.0546 16.711 11.0246 16.9039C11.9945 17.0969 12.9998 16.9978 13.9134 16.6194C14.8271 16.241 15.6079 15.6001 16.1573 14.7779C16.7068 13.9556 17 12.9889 17 12C17 11.3434 16.8707 10.6932 16.6194 10.0866C16.3681 9.47995 15.9998 8.92876 15.5355 8.46447C15.0712 8.00017 14.52 7.63188 13.9134 7.3806C13.3068 7.12933 12.6566 7 12 7ZM12 16C11.2089 16 10.4355 15.7654 9.77772 15.3259C9.11992 14.8864 8.60723 14.2616 8.30448 13.5307C8.00173 12.7998 7.92252 11.9956 8.07686 11.2196C8.2312 10.4437 8.61216 9.73098 9.17158 9.17157C9.73099 8.61216 10.4437 8.2312 11.2196 8.07686C11.9956 7.92252 12.7998 8.00173 13.5307 8.30448C14.2616 8.60723 14.8864 9.11992 15.3259 9.77772C15.7654 10.4355 16 11.2089 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16Z",
					fill: "black"
				}), /* @__PURE__ */ m("path", {
					d: "M14 11.5H12.5V10C12.5 9.86739 12.4473 9.74021 12.3536 9.64645C12.2598 9.55268 12.1326 9.5 12 9.5C11.8674 9.5 11.7402 9.55268 11.6464 9.64645C11.5527 9.74021 11.5 9.86739 11.5 10V12C11.5 12.1326 11.5527 12.2598 11.6464 12.3536C11.7402 12.4473 11.8674 12.5 12 12.5H14C14.1326 12.5 14.2598 12.4473 14.3536 12.3536C14.4473 12.2598 14.5 12.1326 14.5 12C14.5 11.8674 14.4473 11.7402 14.3536 11.6464C14.2598 11.5527 14.1326 11.5 14 11.5Z",
					fill: "black"
				})]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_8815_191346",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), er = /* @__PURE__ */ we({ default: () => tr }), tr, nr = Se((() => {
	tr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1382_30111)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						d: "M13.5 14H10.5C10.3674 14 10.2402 14.0527 10.1464 14.1464C10.0527 14.2402 10 14.3674 10 14.5C10 14.6326 10.0527 14.7598 10.1464 14.8536C10.2402 14.9473 10.3674 15 10.5 15H13.5C13.6326 15 13.7598 14.9473 13.8536 14.8536C13.9473 14.7598 14 14.6326 14 14.5C14 14.3674 13.9473 14.2402 13.8536 14.1464C13.7598 14.0527 13.6326 14 13.5 14Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M10.5 13H12C12.1326 13 12.2598 12.9473 12.3536 12.8536C12.4473 12.7598 12.5 12.6326 12.5 12.5C12.5 12.3674 12.4473 12.2402 12.3536 12.1464C12.2598 12.0527 12.1326 12 12 12H10.5C10.3674 12 10.2402 12.0527 10.1464 12.1464C10.0527 12.2402 10 12.3674 10 12.5C10 12.6326 10.0527 12.7598 10.1464 12.8536C10.2402 12.9473 10.3674 13 10.5 13Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M15.87 10.165L13.15 7.165C13.1033 7.1132 13.0462 7.07176 12.9825 7.04335C12.9187 7.01493 12.8498 7.00016 12.78 7H9.28C9.11387 6.99802 8.94899 7.02878 8.79475 7.09053C8.64051 7.15227 8.49995 7.2438 8.38109 7.35988C8.26223 7.47595 8.1674 7.6143 8.10201 7.76703C8.03662 7.91976 8.00196 8.08387 8 8.25V15.75C8.00196 15.9161 8.03662 16.0802 8.10201 16.233C8.1674 16.3857 8.26223 16.524 8.38109 16.6401C8.49995 16.7562 8.64051 16.8477 8.79475 16.9095C8.94899 16.9712 9.11387 17.002 9.28 17H14.72C14.8861 17.002 15.051 16.9712 15.2052 16.9095C15.3595 16.8477 15.5 16.7562 15.6189 16.6401C15.7378 16.524 15.8326 16.3857 15.898 16.233C15.9634 16.0802 15.998 15.9161 16 15.75V10.5C15.9997 10.3761 15.9533 10.2567 15.87 10.165ZM13 8.5L14.37 10H13.37C13.3176 9.99684 13.2664 9.98328 13.2194 9.96011C13.1723 9.93695 13.1303 9.90464 13.0959 9.86508C13.0614 9.82552 13.0352 9.77949 13.0188 9.72969C13.0023 9.67988 12.9959 9.62729 13 9.575V8.5ZM14.72 16H9.28C9.24519 16.002 9.21032 15.9972 9.17739 15.9857C9.14446 15.9742 9.11412 15.9563 9.08811 15.9331C9.06209 15.9099 9.04092 15.8818 9.0258 15.8503C9.01068 15.8189 9.00191 15.7848 9 15.75V8.25C9.00191 8.21518 9.01068 8.18108 9.0258 8.14966C9.04092 8.11823 9.06209 8.0901 9.08811 8.06688C9.11412 8.04365 9.14446 8.02579 9.17739 8.01431C9.21032 8.00284 9.24519 7.99797 9.28 8H12V9.575C11.9919 9.94331 12.1299 10.2999 12.3837 10.5668C12.6376 10.8338 12.9867 10.9895 13.355 11H15V15.75C14.9981 15.7848 14.9893 15.8189 14.9742 15.8503C14.9591 15.8818 14.9379 15.9099 14.9119 15.9331C14.8859 15.9563 14.8555 15.9742 14.8226 15.9857C14.7897 15.9972 14.7548 16.002 14.72 16Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1382_30111",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), rr = /* @__PURE__ */ we({ default: () => ir }), ir, ar = Se((() => {
	ir = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("path", {
				d: "M15 9.5C15 9.36739 14.9473 9.24025 14.8535 9.14648C14.7714 9.06441 14.6638 9.01379 14.5493 9.00244L14.5 9H13.9121C13.8382 9.2087 13.7201 9.40101 13.5605 9.56055C13.2792 9.84185 12.8978 10 12.5 10H11.5C11.1022 10 10.7208 9.84185 10.4395 9.56055C10.2799 9.40101 10.1618 9.2087 10.0879 9H9.5C9.36739 9 9.24025 9.05272 9.14648 9.14648C9.05272 9.24025 9 9.36739 9 9.5V15.5L9.00244 15.5493C9.01379 15.6638 9.06441 15.7714 9.14648 15.8535C9.24025 15.9473 9.36739 16 9.5 16H14.5C14.6326 16 14.7597 15.9473 14.8535 15.8535C14.9473 15.7597 15 15.6326 15 15.5V9.5ZM11.5 15H11C10.7239 15 10.5 14.7761 10.5 14.5C10.5 14.2239 10.7239 14 11 14H12.25C12.3163 14 12.3799 13.9736 12.4268 13.9268C12.4736 13.8799 12.5 13.8163 12.5 13.75C12.5 13.6837 12.4736 13.6201 12.4268 13.5732C12.3799 13.5264 12.3163 13.5 12.25 13.5H11.75C11.4185 13.5 11.1006 13.3682 10.8662 13.1338C10.6318 12.8994 10.5 12.5815 10.5 12.25C10.5 11.9185 10.6318 11.6006 10.8662 11.3662C11.0408 11.1916 11.2616 11.0741 11.5 11.0254V11C11.5 10.7239 11.7239 10.5 12 10.5C12.2761 10.5 12.5 10.7239 12.5 11H13C13.2761 11 13.5 11.2239 13.5 11.5C13.5 11.7761 13.2761 12 13 12H11.75C11.6837 12 11.6201 12.0264 11.5732 12.0732C11.5264 12.1201 11.5 12.1837 11.5 12.25C11.5 12.3163 11.5264 12.3799 11.5732 12.4268C11.6201 12.4736 11.6837 12.5 11.75 12.5H12.25C12.5815 12.5 12.8994 12.6318 13.1338 12.8662C13.3682 13.1006 13.5 13.4185 13.5 13.75C13.5 14.0815 13.3682 14.3994 13.1338 14.6338C12.9592 14.8084 12.7383 14.9254 12.5 14.9741V15C12.5 15.2761 12.2761 15.5 12 15.5C11.7239 15.5 11.5 15.2761 11.5 15ZM11.5 8C11.3674 8 11.2403 8.05272 11.1465 8.14648C11.0527 8.24025 11 8.36739 11 8.5C11 8.63261 11.0527 8.75975 11.1465 8.85352C11.2403 8.94728 11.3674 9 11.5 9H12.5L12.5493 8.99756C12.6638 8.98621 12.7714 8.93559 12.8535 8.85352C12.9473 8.75975 13 8.63261 13 8.5C13 8.36739 12.9473 8.24025 12.8535 8.14648C12.7714 8.06441 12.6638 8.01379 12.5493 8.00244L12.5 8H11.5ZM16 15.5C16 15.8978 15.8419 16.2792 15.5605 16.5605C15.2792 16.8419 14.8978 17 14.5 17H9.5C9.10218 17 8.72076 16.8419 8.43945 16.5605C8.15815 16.2792 8 15.8978 8 15.5V9.5C8 9.10218 8.15815 8.72076 8.43945 8.43945C8.72076 8.15815 9.10218 8 9.5 8H10.0879C10.1618 7.7913 10.2799 7.59899 10.4395 7.43945C10.7208 7.15815 11.1022 7 11.5 7H12.5C12.8978 7 13.2792 7.15815 13.5605 7.43945C13.7201 7.59899 13.8382 7.7913 13.9121 8H14.5C14.8978 8 15.2792 8.15815 15.5605 8.43945C15.8419 8.72076 16 9.10217 16 9.5V15.5Z",
				fill: "black"
			})
		]
	});
})), or = /* @__PURE__ */ we({ default: () => sr }), sr, cr = Se((() => {
	sr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11703)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						d: "M10.5 11.5C10.8956 11.5 11.2822 11.3827 11.6111 11.1629C11.94 10.9432 12.1964 10.6308 12.3478 10.2654C12.4991 9.89992 12.5387 9.49778 12.4616 9.10982C12.3844 8.72186 12.1939 8.36549 11.9142 8.08579C11.6345 7.80608 11.2781 7.6156 10.8902 7.53843C10.5022 7.46126 10.1001 7.50087 9.73463 7.65224C9.36918 7.80362 9.05682 8.05996 8.83706 8.38886C8.6173 8.71776 8.5 9.10444 8.5 9.5C8.5 10.0304 8.71071 10.5391 9.08579 10.9142C9.46086 11.2893 9.96957 11.5 10.5 11.5ZM10.5 8.5C10.6978 8.5 10.8911 8.55865 11.0556 8.66853C11.22 8.77841 11.3482 8.93459 11.4239 9.11732C11.4996 9.30004 11.5194 9.50111 11.4808 9.69509C11.4422 9.88907 11.347 10.0673 11.2071 10.2071C11.0673 10.347 10.8891 10.4422 10.6951 10.4808C10.5011 10.5194 10.3 10.4996 10.1173 10.4239C9.93459 10.3482 9.77841 10.22 9.66853 10.0556C9.55865 9.89112 9.5 9.69778 9.5 9.5C9.5 9.23478 9.60536 8.98043 9.79289 8.79289C9.98043 8.60536 10.2348 8.5 10.5 8.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M14.5 12.5C14.7967 12.5 15.0867 12.412 15.3334 12.2472C15.58 12.0824 15.7723 11.8481 15.8858 11.574C15.9994 11.2999 16.0291 10.9983 15.9712 10.7074C15.9133 10.4164 15.7704 10.1491 15.5607 9.93934C15.3509 9.72956 15.0836 9.5867 14.7926 9.52882C14.5017 9.47094 14.2001 9.50065 13.926 9.61418C13.6519 9.72771 13.4176 9.91997 13.2528 10.1666C13.088 10.4133 13 10.7033 13 11C13 11.3978 13.158 11.7794 13.4393 12.0607C13.7206 12.342 14.1022 12.5 14.5 12.5ZM14.5 10.5C14.5989 10.5 14.6956 10.5293 14.7778 10.5843C14.86 10.6392 14.9241 10.7173 14.9619 10.8087C14.9998 10.9 15.0097 11.0006 14.9904 11.0975C14.9711 11.1945 14.9235 11.2836 14.8536 11.3536C14.7836 11.4235 14.6945 11.4711 14.5975 11.4904C14.5006 11.5097 14.4 11.4998 14.3087 11.4619C14.2173 11.4241 14.1392 11.36 14.0843 11.2778C14.0293 11.1956 14 11.0989 14 11C14 10.8674 14.0527 10.7402 14.1464 10.6464C14.2402 10.5527 14.3674 10.5 14.5 10.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M14.5 13C13.9459 13.0006 13.4077 13.1853 12.97 13.525C12.4803 13.0372 11.857 12.7053 11.1789 12.5712C10.5008 12.4371 9.79816 12.5068 9.15961 12.7716C8.52107 13.0363 7.97521 13.4842 7.59087 14.0587C7.20653 14.6333 7.00094 15.3088 7 16C7 16.1326 7.05268 16.2598 7.14645 16.3536C7.24021 16.4473 7.36739 16.5 7.5 16.5C7.63261 16.5 7.75979 16.4473 7.85355 16.3536C7.94732 16.2598 8 16.1326 8 16C8 15.337 8.26339 14.7011 8.73223 14.2322C9.20107 13.7634 9.83696 13.5 10.5 13.5C11.163 13.5 11.7989 13.7634 12.2678 14.2322C12.7366 14.7011 13 15.337 13 16C13 16.1326 13.0527 16.2598 13.1464 16.3536C13.2402 16.4473 13.3674 16.5 13.5 16.5C13.6326 16.5 13.7598 16.4473 13.8536 16.3536C13.9473 16.2598 14 16.1326 14 16C14.0012 15.4142 13.8532 14.8378 13.57 14.325C13.791 14.1504 14.0566 14.0415 14.3366 14.0108C14.6165 13.9801 14.8994 14.0289 15.153 14.1515C15.4065 14.2741 15.6204 14.4656 15.7702 14.7041C15.92 14.9425 15.9996 15.2184 16 15.5C16 15.6326 16.0527 15.7598 16.1464 15.8536C16.2402 15.9473 16.3674 16 16.5 16C16.6326 16 16.7598 15.9473 16.8536 15.8536C16.9473 15.7598 17 15.6326 17 15.5C17 14.837 16.7366 14.2011 16.2678 13.7322C15.7989 13.2634 15.163 13 14.5 13Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11703",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), lr = /* @__PURE__ */ we({ default: () => ur }), ur, dr = Se((() => {
	ur = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_7538_78396)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						d: "M15 8H14.5V7.5C14.5 7.36739 14.4473 7.24021 14.3536 7.14645C14.2598 7.05268 14.1326 7 14 7C13.8674 7 13.7402 7.05268 13.6464 7.14645C13.5527 7.24021 13.5 7.36739 13.5 7.5V8H10.5V7.5C10.5 7.36739 10.4473 7.24021 10.3536 7.14645C10.2598 7.05268 10.1326 7 10 7C9.86739 7 9.74021 7.05268 9.64645 7.14645C9.55268 7.24021 9.5 7.36739 9.5 7.5V8H9C8.60218 8 8.22064 8.15804 7.93934 8.43934C7.65804 8.72064 7.5 9.10218 7.5 9.5V15.5C7.5 15.8978 7.65804 16.2794 7.93934 16.5607C8.22064 16.842 8.60218 17 9 17H15C15.3978 17 15.7794 16.842 16.0607 16.5607C16.342 16.2794 16.5 15.8978 16.5 15.5V9.5C16.5 9.10218 16.342 8.72064 16.0607 8.43934C15.7794 8.15804 15.3978 8 15 8ZM9 9H9.5V9.5C9.5 9.63261 9.55268 9.75979 9.64645 9.85355C9.74021 9.94732 9.86739 10 10 10C10.1326 10 10.2598 9.94732 10.3536 9.85355C10.4473 9.75979 10.5 9.63261 10.5 9.5V9H13.5V9.5C13.5 9.63261 13.5527 9.75979 13.6464 9.85355C13.7402 9.94732 13.8674 10 14 10C14.1326 10 14.2598 9.94732 14.3536 9.85355C14.4473 9.75979 14.5 9.63261 14.5 9.5V9H15C15.1326 9 15.2598 9.05268 15.3536 9.14645C15.4473 9.24021 15.5 9.36739 15.5 9.5V11.5H8.5V9.5C8.5 9.36739 8.55268 9.24021 8.64645 9.14645C8.74021 9.05268 8.86739 9 9 9ZM15 16H9C8.86739 16 8.74021 15.9473 8.64645 15.8536C8.55268 15.7598 8.5 15.6326 8.5 15.5V12.5H15.5V15.5C15.5 15.6326 15.4473 15.7598 15.3536 15.8536C15.2598 15.9473 15.1326 16 15 16Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M10 14.5C10.2761 14.5 10.5 14.2761 10.5 14C10.5 13.7239 10.2761 13.5 10 13.5C9.72386 13.5 9.5 13.7239 9.5 14C9.5 14.2761 9.72386 14.5 10 14.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M14 13.5H12C11.8674 13.5 11.7402 13.5527 11.6464 13.6464C11.5527 13.7402 11.5 13.8674 11.5 14C11.5 14.1326 11.5527 14.2598 11.6464 14.3536C11.7402 14.4473 11.8674 14.5 12 14.5H14C14.1326 14.5 14.2598 14.4473 14.3536 14.3536C14.4473 14.2598 14.5 14.1326 14.5 14C14.5 13.8674 14.4473 13.7402 14.3536 13.6464C14.2598 13.5527 14.1326 13.5 14 13.5Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_7538_78396",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), fr = /* @__PURE__ */ we({ default: () => pr }), pr, mr = Se((() => {
	pr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("g", {
				clipPath: "url(#clip0_1383_11792)",
				className: "icon-inner",
				children: /* @__PURE__ */ m("path", {
					d: "M15 8.5V8C15 7.73478 14.8946 7.48043 14.7071 7.29289C14.5196 7.10536 14.2652 7 14 7H10C9.73478 7 9.48043 7.10536 9.29289 7.29289C9.10536 7.48043 9 7.73478 9 8V8.5C8.60218 8.5 8.22064 8.65804 7.93934 8.93934C7.65804 9.22064 7.5 9.60218 7.5 10V15.5C7.5 15.8978 7.65804 16.2794 7.93934 16.5607C8.22064 16.842 8.60218 17 9 17H15C15.3978 17 15.7794 16.842 16.0607 16.5607C16.342 16.2794 16.5 15.8978 16.5 15.5V10C16.5 9.60218 16.342 9.22064 16.0607 8.93934C15.7794 8.65804 15.3978 8.5 15 8.5ZM10 8H14V10H10V8ZM15.5 15.5C15.5 15.6326 15.4473 15.7598 15.3536 15.8536C15.2598 15.9473 15.1326 16 15 16H9C8.86739 16 8.74021 15.9473 8.64645 15.8536C8.55268 15.7598 8.5 15.6326 8.5 15.5V10C8.5 9.86739 8.55268 9.74021 8.64645 9.64645C8.74021 9.55268 8.86739 9.5 9 9.5V10C9 10.2652 9.10536 10.5196 9.29289 10.7071C9.48043 10.8946 9.73478 11 10 11H14C14.2652 11 14.5196 10.8946 14.7071 10.7071C14.8946 10.5196 15 10.2652 15 10V9.5C15.1326 9.5 15.2598 9.55268 15.3536 9.64645C15.4473 9.74021 15.5 9.86739 15.5 10V15.5Z",
					fill: "black"
				})
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11792",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), hr = /* @__PURE__ */ we({ default: () => gr }), gr, _r = Se((() => {
	gr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11724)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						d: "M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M14 12.5C14.2761 12.5 14.5 12.2761 14.5 12C14.5 11.7239 14.2761 11.5 14 11.5C13.7239 11.5 13.5 11.7239 13.5 12C13.5 12.2761 13.7239 12.5 14 12.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M10 12.5C10.2761 12.5 10.5 12.2761 10.5 12C10.5 11.7239 10.2761 11.5 10 11.5C9.72386 11.5 9.5 11.7239 9.5 12C9.5 12.2761 9.72386 12.5 10 12.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M15.535 8.465C14.7146 7.63925 13.6318 7.1256 12.4733 7.01262C11.3148 6.89963 10.1532 7.19438 9.18869 7.84606C8.22421 8.49774 7.51732 9.4655 7.18988 10.5825C6.86244 11.6995 6.93499 12.8957 7.395 13.965C7.44294 14.0644 7.45867 14.1762 7.44 14.285L7 16.4C6.98305 16.4811 6.98651 16.5651 7.01007 16.6445C7.03364 16.724 7.07656 16.7963 7.135 16.855C7.1829 16.9026 7.23994 16.9399 7.30267 16.9648C7.3654 16.9898 7.43252 17.0017 7.5 17H7.6L9.74 16.57C9.84876 16.5569 9.95906 16.5724 10.06 16.615C11.1292 17.075 12.3255 17.1475 13.4425 16.8201C14.5595 16.4927 15.5273 15.7858 16.1789 14.8213C16.8306 13.8568 17.1254 12.6952 17.0124 11.5367C16.8994 10.3782 16.3857 9.29539 15.56 8.475L15.535 8.465ZM15.95 12.645C15.8522 13.242 15.6203 13.809 15.2718 14.3034C14.9232 14.7979 14.467 15.2068 13.9376 15.4994C13.4081 15.7921 12.8192 15.9608 12.2151 15.9929C11.611 16.0251 11.0075 15.9198 10.45 15.685C10.2523 15.6009 10.0399 15.5567 9.825 15.555C9.73114 15.5557 9.63749 15.564 9.545 15.58L8.135 15.865L8.42 14.455C8.47676 14.1496 8.44017 13.8343 8.315 13.55C8.08019 12.9925 7.9749 12.389 8.00704 11.7849C8.03919 11.1808 8.20793 10.5919 8.50057 10.0624C8.79321 9.53297 9.20213 9.0768 9.69655 8.72822C10.191 8.37965 10.758 8.14775 11.355 8.05C11.9816 7.94715 12.6238 7.99498 13.2282 8.18953C13.8327 8.38407 14.3822 8.71974 14.8312 9.16876C15.2803 9.61779 15.6159 10.1673 15.8105 10.7718C16.005 11.3762 16.0528 12.0184 15.95 12.645Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11724",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), vr = /* @__PURE__ */ we({ default: () => yr }), yr, br = Se((() => {
	yr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("path", {
				d: "M15 8.5C15 8.36739 14.9473 8.24025 14.8535 8.14648C14.7597 8.05272 14.6326 8 14.5 8H9.5C9.36739 8 9.24025 8.05272 9.14648 8.14648C9.05272 8.24025 9 8.36739 9 8.5V15.5654L9.72266 15.084L9.76074 15.061C9.95375 14.9557 10.1956 14.9885 10.3535 15.1465L11 15.793L11.6465 15.1465L11.6846 15.1123C11.881 14.9521 12.1705 14.9634 12.3535 15.1465L13 15.793L13.6465 15.1465L13.6792 15.1167C13.8478 14.9754 14.0914 14.96 14.2773 15.084L15 15.5654V8.5ZM13.1465 9.64648C13.3417 9.45122 13.6583 9.45122 13.8535 9.64648C14.0488 9.84175 14.0488 10.1583 13.8535 10.3535L10.8535 13.3535C10.6583 13.5488 10.3417 13.5488 10.1465 13.3535C9.95122 13.1583 9.95122 12.8417 10.1465 12.6465L13.1465 9.64648ZM13.25 12.5C13.1119 12.5 13 12.6119 13 12.75C13 12.8881 13.1119 13 13.25 13C13.3881 13 13.5 12.8881 13.5 12.75C13.5 12.6119 13.3881 12.5 13.25 12.5ZM10.75 10C10.6119 10 10.5 10.1119 10.5 10.25C10.5 10.3881 10.6119 10.5 10.75 10.5C10.8881 10.5 11 10.3881 11 10.25C11 10.1119 10.8881 10 10.75 10ZM14 12.75C14 13.1642 13.6642 13.5 13.25 13.5C12.8358 13.5 12.5 13.1642 12.5 12.75C12.5 12.3358 12.8358 12 13.25 12C13.6642 12 14 12.3358 14 12.75ZM11.5 10.25C11.5 10.6642 11.1642 11 10.75 11C10.3358 11 10 10.6642 10 10.25C10 9.83579 10.3358 9.5 10.75 9.5C11.1642 9.5 11.5 9.83579 11.5 10.25ZM16 16.5C16 16.6844 15.8984 16.8539 15.7358 16.9409C15.5733 17.0279 15.3761 17.0183 15.2227 16.916L14.0635 16.1431L13.3535 16.8535C13.1583 17.0488 12.8417 17.0488 12.6465 16.8535L12 16.207L11.3535 16.8535C11.1583 17.0488 10.8417 17.0488 10.6465 16.8535L9.93604 16.1431L8.77734 16.916C8.62395 17.0183 8.42672 17.0279 8.26416 16.9409C8.10158 16.8539 8 16.6844 8 16.5V8.5C8 8.10218 8.15815 7.72076 8.43945 7.43945C8.72076 7.15815 9.10218 7 9.5 7H14.5C14.8978 7 15.2792 7.15815 15.5605 7.43945C15.8419 7.72076 16 8.10218 16 8.5V16.5Z",
				fill: "black"
			})
		]
	});
})), xr = /* @__PURE__ */ we({ default: () => Sr }), Sr, Cr = Se((() => {
	Sr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.86127 7.22063C9.87991 6.92646 11.1201 6.92646 12.1387 7.22063C12.6498 7.36821 13.0963 7.58714 13.4253 7.872C13.754 8.15665 14 8.54133 14 9C14 9.45867 13.754 9.84335 13.4253 10.128C13.0963 10.4129 12.6498 10.6318 12.1387 10.7794C11.1201 11.0735 9.87991 11.0735 8.86127 10.7794C8.54535 10.6881 8.25409 10.5696 8 10.4251V11.5C8 11.5517 8.01315 11.6075 8.10912 11.6962C8.22061 11.7992 8.4093 11.9115 8.70438 12.0437C8.9564 12.1566 9.0692 12.4524 8.95632 12.7044C8.84345 12.9564 8.54764 13.0692 8.29562 12.9563C8.19563 12.9115 8.09638 12.8645 8 12.8143V14C8 14.0517 8.01315 14.1075 8.10912 14.1962C8.22061 14.2992 8.4093 14.4115 8.70438 14.5437C8.9564 14.6566 9.0692 14.9524 8.95632 15.2044C8.84345 15.4564 8.54764 15.5692 8.29562 15.4563C7.9767 15.3135 7.66539 15.1478 7.43038 14.9306C7.17985 14.699 7 14.3923 7 14V9C7 8.54133 7.24595 8.15665 7.57472 7.872C7.90371 7.58714 8.35024 7.36821 8.86127 7.22063ZM8 9C8 9.07733 8.04005 9.20815 8.22928 9.372C8.41829 9.53564 8.72176 9.69821 9.13873 9.81863C9.97609 10.0605 11.0239 10.0605 11.8613 9.81863C12.2782 9.69821 12.5817 9.53564 12.7707 9.372C12.96 9.20815 13 9.07733 13 9C13 8.92267 12.96 8.79185 12.7707 8.628C12.5817 8.46436 12.2782 8.30179 11.8613 8.18137C11.0239 7.93954 9.97609 7.93954 9.13873 8.18137C8.72176 8.30179 8.41829 8.46436 8.22928 8.628C8.04005 8.79185 8 8.92267 8 9ZM11.155 11.4921C11.781 11.1791 12.6107 11 13.5 11C14.3893 11 15.219 11.1791 15.845 11.4921C16.441 11.7901 17 12.2944 17 13V15C17 15.7054 16.441 16.2096 15.845 16.5077C15.2191 16.8207 14.3893 17 13.5 17C12.6107 17 11.7809 16.8207 11.155 16.5077C10.559 16.2096 10 15.7054 10 15V13C10 12.2944 10.559 11.7901 11.155 11.4921ZM11 14.4251V15C11 15.1226 11.1125 15.3684 11.6023 15.6133C12.0621 15.8433 12.7323 16 13.5 16C14.2677 16 14.9379 15.8433 15.3977 15.6133C15.8875 15.3684 16 15.1226 16 15V14.4251C15.9488 14.4543 15.8971 14.4819 15.845 14.5079C15.219 14.8209 14.3893 15 13.5 15C12.6107 15 11.781 14.8209 11.155 14.5079C11.1029 14.4819 11.0512 14.4543 11 14.4251ZM16 13C16 13.1229 15.8875 13.3686 15.3978 13.6135C14.938 13.8434 14.2677 14 13.5 14C12.7323 14 12.062 13.8434 11.6022 13.6135C11.1125 13.3686 11 13.1229 11 13C11 12.8771 11.1125 12.6314 11.6022 12.3865C12.062 12.1566 12.7323 12 13.5 12C14.2677 12 14.938 12.1566 15.3978 12.3865C15.8875 12.6314 16 12.8771 16 13Z",
				fill: "black"
			})
		]
	});
})), wr = /* @__PURE__ */ we({ default: () => Tr }), Tr, Er = Se((() => {
	Tr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_7513_175443)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						d: "M16.54 9.5C16.4536 9.35031 16.3299 9.22557 16.1809 9.13794C16.0319 9.05031 15.8628 9.00279 15.69 9H9.29L9 7.87C8.9707 7.76092 8.90533 7.66498 8.81454 7.59779C8.72375 7.5306 8.61288 7.49614 8.5 7.5H7.5C7.36739 7.5 7.24021 7.55268 7.14645 7.64645C7.05268 7.74022 7 7.8674 7 8C7 8.13261 7.05268 8.25979 7.14645 8.35356C7.24021 8.44732 7.36739 8.5 7.5 8.5H8.12L9.5 13.63C9.5293 13.7391 9.59467 13.835 9.68546 13.9022C9.77625 13.9694 9.88712 14.0039 10 14H14.5C14.5923 13.9997 14.6828 13.9739 14.7613 13.9253C14.8399 13.8768 14.9034 13.8075 14.945 13.725L16.585 10.445C16.6561 10.296 16.6892 10.1317 16.6813 9.96685C16.6735 9.80195 16.6249 9.64157 16.54 9.5ZM14.19 13H10.38L9.565 10H15.69L14.19 13Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M9.75 16.5C10.1642 16.5 10.5 16.1642 10.5 15.75C10.5 15.3358 10.1642 15 9.75 15C9.33579 15 9 15.3358 9 15.75C9 16.1642 9.33579 16.5 9.75 16.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M14.75 16.5C15.1642 16.5 15.5 16.1642 15.5 15.75C15.5 15.3358 15.1642 15 14.75 15C14.3358 15 14 15.3358 14 15.75C14 16.1642 14.3358 16.5 14.75 16.5Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_7513_175443",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), Dr = /* @__PURE__ */ we({ default: () => Or }), Or, kr = Se((() => {
	Or = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("g", {
				clipPath: "url(#clip0_7513_175441)",
				className: "icon-inner",
				children: /* @__PURE__ */ m("path", {
					d: "M15.5 8H8.5C8.10218 8 7.72064 8.15804 7.43934 8.43934C7.15804 8.72064 7 9.10218 7 9.5V14.5C7 14.8978 7.15804 15.2794 7.43934 15.5607C7.72064 15.842 8.10218 16 8.5 16H15.5C15.8978 16 16.2794 15.842 16.5607 15.5607C16.842 15.2794 17 14.8978 17 14.5V9.5C17 9.10218 16.842 8.72064 16.5607 8.43934C16.2794 8.15804 15.8978 8 15.5 8ZM15.165 9L12 11.375L8.835 9H15.165ZM15.5 15H8.5C8.36739 15 8.24021 14.9473 8.14645 14.8536C8.05268 14.7598 8 14.6326 8 14.5V9.625L11.7 12.4C11.7865 12.4649 11.8918 12.5 12 12.5C12.1082 12.5 12.2135 12.4649 12.3 12.4L16 9.625V14.5C16 14.6326 15.9473 14.7598 15.8536 14.8536C15.7598 14.9473 15.6326 15 15.5 15Z",
					fill: "black"
				})
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_7513_175441",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), Ar = /* @__PURE__ */ we({ default: () => jr }), jr, Mr = Se((() => {
	jr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11682)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						d: "M12 9C12.1326 9 12.2598 8.94732 12.3536 8.85355C12.4473 8.75979 12.5 8.63261 12.5 8.5V7.5C12.5 7.36739 12.4473 7.24021 12.3536 7.14645C12.2598 7.05268 12.1326 7 12 7C11.8674 7 11.7402 7.05268 11.6464 7.14645C11.5527 7.24021 11.5 7.36739 11.5 7.5V8.5C11.5 8.63261 11.5527 8.75979 11.6464 8.85355C11.7402 8.94732 11.8674 9 12 9Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M16.5 11.5H15.5C15.3674 11.5 15.2402 11.5527 15.1464 11.6464C15.0527 11.7402 15 11.8674 15 12C15 12.1326 15.0527 12.2598 15.1464 12.3536C15.2402 12.4473 15.3674 12.5 15.5 12.5H16.5C16.6326 12.5 16.7598 12.4473 16.8536 12.3536C16.9473 12.2598 17 12.1326 17 12C17 11.8674 16.9473 11.7402 16.8536 11.6464C16.7598 11.5527 16.6326 11.5 16.5 11.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M9 12C9 11.8674 8.94732 11.7402 8.85355 11.6464C8.75979 11.5527 8.63261 11.5 8.5 11.5H7.5C7.36739 11.5 7.24021 11.5527 7.14645 11.6464C7.05268 11.7402 7 11.8674 7 12C7 12.1326 7.05268 12.2598 7.14645 12.3536C7.24021 12.4473 7.36739 12.5 7.5 12.5H8.5C8.63261 12.5 8.75979 12.4473 8.85355 12.3536C8.94732 12.2598 9 12.1326 9 12Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M9.11 8.5C9.01253 8.40784 8.88245 8.35817 8.74836 8.36192C8.61427 8.36567 8.48716 8.42254 8.395 8.52C8.30284 8.61747 8.25317 8.74756 8.25692 8.88165C8.26067 9.01573 8.31753 9.14284 8.415 9.235L9.135 9.93C9.18332 9.97666 9.24054 10.0131 9.30325 10.0372C9.36596 10.0612 9.43288 10.0724 9.5 10.07C9.56735 10.0697 9.63396 10.0559 9.69582 10.0292C9.75768 10.0026 9.81353 9.96376 9.86 9.915C9.95313 9.82132 10.0054 9.6946 10.0054 9.5625C10.0054 9.43041 9.95313 9.30369 9.86 9.21L9.11 8.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M14.5 10.07C14.6287 10.0695 14.7523 10.0193 14.845 9.93L15.565 9.235C15.6528 9.14322 15.7024 9.02146 15.7038 8.89443C15.7051 8.7674 15.658 8.64464 15.572 8.55108C15.4861 8.45752 15.3678 8.40017 15.2411 8.39068C15.1144 8.38119 14.9889 8.42028 14.89 8.5L14.17 9.21C14.0769 9.30368 14.0246 9.4304 14.0246 9.5625C14.0246 9.69459 14.0769 9.82131 14.17 9.915C14.2566 10.0064 14.3744 10.0617 14.5 10.07Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M12 15C11.8674 15 11.7402 15.0527 11.6464 15.1464C11.5527 15.2402 11.5 15.3674 11.5 15.5V16.5C11.5 16.6326 11.5527 16.7598 11.6464 16.8536C11.7402 16.9473 11.8674 17 12 17C12.1326 17 12.2598 16.9473 12.3536 16.8536C12.4473 16.7598 12.5 16.6326 12.5 16.5V15.5C12.5 15.3674 12.4473 15.2402 12.3536 15.1464C12.2598 15.0527 12.1326 15 12 15Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M14.865 14.07C14.7695 13.9778 14.6413 13.9274 14.5087 13.9297C14.376 13.9321 14.2497 13.987 14.1575 14.0825C14.0653 14.178 14.0149 14.3062 14.0172 14.4388C14.0196 14.5715 14.0745 14.6978 14.17 14.79L14.89 15.5C14.9827 15.5893 15.1063 15.6395 15.235 15.64C15.302 15.6404 15.3684 15.6273 15.4302 15.6015C15.4921 15.5758 15.5481 15.5378 15.595 15.49C15.6419 15.4435 15.6791 15.3882 15.7044 15.3273C15.7298 15.2664 15.7429 15.201 15.7429 15.135C15.7429 15.069 15.7298 15.0036 15.7044 14.9427C15.6791 14.8818 15.6419 14.8265 15.595 14.78L14.865 14.07Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M9.135 14.07L8.415 14.765C8.36813 14.8115 8.33094 14.8668 8.30555 14.9277C8.28017 14.9886 8.2671 15.054 8.2671 15.12C8.2671 15.186 8.28017 15.2514 8.30555 15.3123C8.33094 15.3732 8.36813 15.4285 8.415 15.475C8.46189 15.5228 8.51793 15.5608 8.57977 15.5865C8.64161 15.6123 8.708 15.6254 8.775 15.625C8.89825 15.626 9.01755 15.5815 9.11 15.5L9.83 14.805C9.92547 14.7128 9.98043 14.5865 9.98277 14.4538C9.98512 14.3212 9.93466 14.193 9.8425 14.0975C9.75033 14.002 9.62402 13.9471 9.49134 13.9447C9.35865 13.9424 9.23047 13.9928 9.135 14.085V14.07Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M12 10C11.6044 10 11.2178 10.1173 10.8889 10.3371C10.56 10.5568 10.3036 10.8692 10.1522 11.2346C10.0009 11.6001 9.96126 12.0022 10.0384 12.3902C10.1156 12.7781 10.3061 13.1345 10.5858 13.4142C10.8655 13.6939 11.2219 13.8844 11.6098 13.9616C11.9978 14.0387 12.3999 13.9991 12.7654 13.8478C13.1308 13.6964 13.4432 13.44 13.6629 13.1111C13.8827 12.7822 14 12.3956 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM12 13C11.8022 13 11.6089 12.9414 11.4444 12.8315C11.28 12.7216 11.1518 12.5654 11.0761 12.3827C11.0004 12.2 10.9806 11.9989 11.0192 11.8049C11.0578 11.6109 11.153 11.4327 11.2929 11.2929C11.4327 11.153 11.6109 11.0578 11.8049 11.0192C11.9989 10.9806 12.2 11.0004 12.3827 11.0761C12.5654 11.1518 12.7216 11.28 12.8315 11.4444C12.9414 11.6089 13 11.8022 13 12C13 12.2652 12.8946 12.5196 12.7071 12.7071C12.5196 12.8946 12.2652 13 12 13Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11682",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), Nr = /* @__PURE__ */ we({ default: () => Pr }), Pr, Fr = Se((() => {
	Pr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("path", {
				d: "M15 17H14.5C14.2239 17 14 16.7761 14 16.5C14 16.2239 14.2239 16 14.5 16H15.75C15.8163 16 15.8799 15.9736 15.9268 15.9268C15.9736 15.8799 16 15.8163 16 15.75C16 15.6837 15.9736 15.6201 15.9268 15.5732C15.8799 15.5264 15.8163 15.5 15.75 15.5H15.25C14.9185 15.5 14.6006 15.3682 14.3662 15.1338C14.1318 14.8994 14 14.5815 14 14.25C14 13.9185 14.1318 13.6006 14.3662 13.3662C14.5408 13.1916 14.7617 13.074 15 13.0254V13C15 12.7239 15.2239 12.5 15.5 12.5C15.7761 12.5 16 12.7239 16 13H16.5C16.7761 13 17 13.2239 17 13.5C17 13.7761 16.7761 14 16.5 14H15.25C15.1837 14 15.1201 14.0264 15.0732 14.0732C15.0264 14.1201 15 14.1837 15 14.25C15 14.3163 15.0264 14.3799 15.0732 14.4268C15.1201 14.4736 15.1837 14.5 15.25 14.5H15.75C16.0815 14.5 16.3994 14.6318 16.6338 14.8662C16.8682 15.1006 17 15.4185 17 15.75C17 16.0815 16.8682 16.3994 16.6338 16.6338C16.4592 16.8084 16.2383 16.9254 16 16.9741V17C16 17.2761 15.7761 17.5 15.5 17.5C15.2239 17.5 15 17.2761 15 17ZM10 13.5C10 13.1022 10.1581 12.7208 10.4395 12.4395C10.7208 12.1581 11.1022 12 11.5 12H12.5C12.7895 12 13.0609 12.0826 13.2905 12.2251C13.5251 12.3707 13.5973 12.679 13.4517 12.9136C13.306 13.1482 12.9978 13.2204 12.7632 13.0747C12.6869 13.0274 12.5974 13 12.5 13H11.5C11.3674 13 11.2403 13.0527 11.1465 13.1465C11.0527 13.2403 11 13.3674 11 13.5V16H12.5C12.7761 16 13 16.2239 13 16.5C13 16.7761 12.7761 17 12.5 17H9.5C9.10218 17 8.72076 16.8418 8.43945 16.5605C8.15815 16.2792 8 15.8978 8 15.5V12.5H7.5C7.29779 12.5 7.11549 12.3782 7.03809 12.1914C6.9607 12.0046 7.00349 11.7895 7.14649 11.6465L11.6465 7.14648L11.6846 7.1123C11.881 6.95213 12.1705 6.96342 12.3535 7.14648L15.8535 10.6465C16.0488 10.8417 16.0488 11.1583 15.8535 11.3535C15.6583 11.5488 15.3417 11.5488 15.1465 11.3535L12 8.20703L8.67481 11.5317C8.86468 11.6026 9 11.7854 9 12V15.5L9.00244 15.5493C9.01379 15.6638 9.06441 15.7714 9.14649 15.8535C9.24025 15.9473 9.36739 16 9.5 16H10V13.5Z",
				fill: "black"
			})
		]
	});
})), Ir = /* @__PURE__ */ we({ default: () => Lr }), Lr, Rr = Se((() => {
	Lr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.4728 7.50074C14.4818 7.50025 14.4909 7.5 14.5 7.5C15.0304 7.5 15.5391 7.71071 15.9142 8.08579C16.2893 8.46086 16.5 8.96957 16.5 9.5C16.5 9.50908 16.4997 9.51816 16.4993 9.52722C16.4454 10.5146 16.1 11.4639 15.5067 12.255C14.9793 12.9582 14.2771 13.5083 13.4724 13.8524C13.4105 14.3285 13.2511 14.788 13.0029 15.2017C12.6966 15.7121 12.2653 16.1359 11.7497 16.4332C11.6041 16.5171 11.4261 16.5223 11.2759 16.447C11.1257 16.3716 11.0233 16.2259 11.0035 16.059C10.98 15.8614 10.9398 15.6672 10.8839 15.4783C10.6145 15.7525 10.3003 15.9819 9.95281 16.1556C9.32923 16.4674 8.62674 16.5859 7.9354 16.4958C7.7105 16.4665 7.53349 16.2895 7.50419 16.0646C7.41412 15.3733 7.53257 14.6708 7.84436 14.0472C8.01812 13.6997 8.24752 13.3855 8.52166 13.1161C8.33283 13.0602 8.13864 13.02 7.94099 12.9965C7.77411 12.9767 7.62836 12.8743 7.55303 12.7241C7.47771 12.5739 7.48289 12.3959 7.56683 12.2503C7.86409 11.7347 8.28793 11.3034 8.79828 10.9971C9.21201 10.7489 9.67153 10.5895 10.1476 10.5276C10.4917 9.72292 11.0418 9.02071 11.745 8.49333C12.5361 7.9 13.4854 7.55458 14.4728 7.50074ZM9.50943 13.587C9.18434 13.8222 8.91946 14.133 8.73879 14.4944C8.57792 14.8161 8.48911 15.1673 8.47643 15.5236C8.83274 15.5109 9.18387 15.4221 9.5056 15.2612C9.86695 15.0805 10.1778 14.8157 10.413 14.4906C10.2924 14.3149 10.1552 14.1496 10.0028 13.9972C9.85041 13.8448 9.68514 13.7076 9.50943 13.587ZM14.5126 8.50008C13.728 8.54574 12.974 8.82159 12.345 9.29333C11.7121 9.76799 11.2342 10.4197 10.9717 11.1659C10.9033 11.3604 10.7225 11.4929 10.5165 11.4997C10.0916 11.5138 9.67732 11.6359 9.31278 11.8546C9.1574 11.9479 9.01324 12.0573 8.88253 12.1808C9.56804 12.3972 10.1958 12.776 10.7099 13.2901C11.224 13.8041 11.6028 14.432 11.8192 15.1175C11.9427 14.9868 12.0521 14.8426 12.1454 14.6872C12.3641 14.3227 12.4862 13.9084 12.5003 13.4835C12.5071 13.2775 12.6396 13.0967 12.8341 13.0283C13.5803 12.7658 14.232 12.2879 14.7067 11.655C15.1784 11.026 15.4543 10.272 15.4999 9.48735C15.4966 9.22671 15.3917 8.97745 15.2071 8.79289C15.0226 8.60834 14.7733 8.50337 14.5126 8.50008ZM12.7929 9.79289C12.9804 9.60536 13.2348 9.5 13.5 9.5C13.7652 9.5 14.0196 9.60536 14.2071 9.79289C14.3946 9.98043 14.5 10.2348 14.5 10.5C14.5 10.7652 14.3946 11.0196 14.2071 11.2071C14.0196 11.3946 13.7652 11.5 13.5 11.5C13.2348 11.5 12.9804 11.3946 12.7929 11.2071C12.6054 11.0196 12.5 10.7652 12.5 10.5C12.5 10.2348 12.6054 9.98043 12.7929 9.79289Z",
				fill: "black"
			})
		]
	});
})), zr = /* @__PURE__ */ we({ default: () => Br }), Br, Vr = Se((() => {
	Br = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11778)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						d: "M16.5 9H16V8.5C16 8.36739 15.9473 8.24021 15.8536 8.14645C15.7598 8.05268 15.6326 8 15.5 8C15.3674 8 15.2402 8.05268 15.1464 8.14645C15.0527 8.24021 15 8.36739 15 8.5V9H14.5C14.3674 9 14.2402 9.05268 14.1464 9.14645C14.0527 9.24021 14 9.36739 14 9.5C14 9.63261 14.0527 9.75979 14.1464 9.85355C14.2402 9.94732 14.3674 10 14.5 10H15V10.5C15 10.6326 15.0527 10.7598 15.1464 10.8536C15.2402 10.9473 15.3674 11 15.5 11C15.6326 11 15.7598 10.9473 15.8536 10.8536C15.9473 10.7598 16 10.6326 16 10.5V10H16.5C16.6326 10 16.7598 9.94732 16.8536 9.85355C16.9473 9.75979 17 9.63261 17 9.5C17 9.36739 16.9473 9.24021 16.8536 9.14645C16.7598 9.05268 16.6326 9 16.5 9Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M11 11.5C11.3956 11.5 11.7822 11.3827 12.1111 11.1629C12.44 10.9432 12.6964 10.6308 12.8478 10.2654C12.9991 9.89992 13.0387 9.49778 12.9616 9.10982C12.8844 8.72186 12.6939 8.36549 12.4142 8.08579C12.1345 7.80608 11.7781 7.6156 11.3902 7.53843C11.0022 7.46126 10.6001 7.50087 10.2346 7.65224C9.86918 7.80362 9.55682 8.05996 9.33706 8.38886C9.1173 8.71776 9 9.10444 9 9.5C9 10.0304 9.21071 10.5391 9.58579 10.9142C9.96086 11.2893 10.4696 11.5 11 11.5ZM11 8.5C11.1978 8.5 11.3911 8.55865 11.5556 8.66853C11.72 8.77841 11.8482 8.93459 11.9239 9.11732C11.9996 9.30004 12.0194 9.50111 11.9808 9.69509C11.9422 9.88907 11.847 10.0673 11.7071 10.2071C11.5673 10.347 11.3891 10.4422 11.1951 10.4808C11.0011 10.5194 10.8 10.4996 10.6173 10.4239C10.4346 10.3482 10.2784 10.22 10.1685 10.0556C10.0586 9.89112 10 9.69778 10 9.5C10 9.23478 10.1054 8.98043 10.2929 8.79289C10.4804 8.60536 10.7348 8.5 11 8.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M11 12.5C10.0717 12.5 9.1815 12.8687 8.52513 13.5251C7.86875 14.1815 7.5 15.0717 7.5 16C7.5 16.1326 7.55268 16.2598 7.64645 16.3536C7.74021 16.4473 7.86739 16.5 8 16.5C8.13261 16.5 8.25979 16.4473 8.35355 16.3536C8.44732 16.2598 8.5 16.1326 8.5 16C8.5 15.337 8.76339 14.7011 9.23223 14.2322C9.70107 13.7634 10.337 13.5 11 13.5C11.663 13.5 12.2989 13.7634 12.7678 14.2322C13.2366 14.7011 13.5 15.337 13.5 16C13.5 16.1326 13.5527 16.2598 13.6464 16.3536C13.7402 16.4473 13.8674 16.5 14 16.5C14.1326 16.5 14.2598 16.4473 14.3536 16.3536C14.4473 16.2598 14.5 16.1326 14.5 16C14.5 15.0717 14.1313 14.1815 13.4749 13.5251C12.8185 12.8687 11.9283 12.5 11 12.5Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11778",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), Hr = /* @__PURE__ */ we({ default: () => Ur }), Ur, Wr = Se((() => {
	Ur = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("g", {
				clipPath: "url(#clip0_1382_30110)",
				className: "icon-inner",
				children: /* @__PURE__ */ m("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M14.5025 15.4987H9.50247V12.75C9.50247 12.4739 9.27861 12.25 9.00247 12.25C8.72633 12.25 8.50247 12.4739 8.50247 12.75V15.4987C8.50247 16.051 8.95019 16.4987 9.50247 16.4987H14.5025C15.0536 16.497 15.4995 16.0498 15.4995 15.4987V12.75C15.4995 12.4739 15.2756 12.25 14.9995 12.25C14.7233 12.25 14.4995 12.4739 14.4995 12.75L14.5025 15.4987ZM15.6885 11.8837C15.7896 11.9701 15.9218 12.0112 16.0541 11.9974C16.1864 11.9836 16.3073 11.9161 16.3885 11.8107C16.5627 11.5877 16.532 11.2674 16.3185 11.0817L12.346 7.63169C12.1417 7.4561 11.8398 7.4561 11.6355 7.63169L7.68297 11.0677C7.46956 11.2534 7.43859 11.5735 7.61247 11.7967C7.69371 11.902 7.81455 11.9694 7.94683 11.9832C8.0791 11.997 8.21125 11.956 8.31247 11.8697L11.997 8.67569L15.685 11.8862L15.6885 11.8837ZM12.0115 13.9937C12.5617 13.992 13.0066 13.5449 13.0055 12.9947C13.0044 12.4445 12.5577 11.9991 12.0075 11.9997C11.4572 12.0002 11.0115 12.4465 11.0115 12.9967C11.0131 13.5478 11.4604 13.9937 12.0115 13.9937Z",
					fill: "black"
				})
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1382_30110",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), Gr = /* @__PURE__ */ we({ default: () => Kr }), Kr, qr = Se((() => {
	Kr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11740)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M8.56066 11.8891C8.3654 11.6938 8.3654 11.3772 8.56066 11.182L10.682 9.06063C10.8772 8.86537 11.1938 8.86537 11.3891 9.06063L13.5104 11.182C13.7057 11.3772 13.7057 11.6938 13.5104 11.8891L11.3891 14.0104C11.1938 14.2056 10.8772 14.2056 10.682 14.0104L8.56066 11.8891ZM9.62132 11.5355L11.0355 12.9497L12.4497 11.5355L11.0355 10.1213L9.62132 11.5355Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M7.67678 13.1265C7.18862 12.6383 7.18862 11.8469 7.67678 11.3587C8.16493 10.8706 8.95639 10.8706 9.44454 11.3587L11.2123 13.1265C11.7005 13.6147 11.7005 14.4061 11.2123 14.8943C10.7242 15.3824 9.9327 15.3824 9.44454 14.8943L7.67678 13.1265ZM8.38388 12.0658C8.28625 12.1635 8.28625 12.3218 8.38388 12.4194L10.1516 14.1872C10.2493 14.2848 10.4076 14.2848 10.5052 14.1872C10.6028 14.0895 10.6028 13.9312 10.5052 13.8336L8.73744 12.0658C8.6398 11.9682 8.48151 11.9682 8.38388 12.0658Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M10.8588 9.94452C10.3706 9.45637 10.3706 8.66491 10.8588 8.17675C11.3469 7.6886 12.1384 7.6886 12.6265 8.17675L14.3943 9.94452C14.8824 10.4327 14.8824 11.2241 14.3943 11.7123C13.9061 12.2004 13.1147 12.2004 12.6265 11.7123L10.8588 9.94452ZM11.5659 8.88386C11.4682 8.98149 11.4682 9.13978 11.5659 9.23742L13.3336 11.0052C13.4313 11.1028 13.5895 11.1028 13.6872 11.0052C13.7848 10.9076 13.7848 10.7493 13.6872 10.6516L11.9194 8.88386C11.8218 8.78623 11.6635 8.78623 11.5659 8.88386Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M11.7426 12.2426C11.9379 12.0474 12.2545 12.0474 12.4497 12.2426L15.2782 15.071C15.4734 15.2663 15.4734 15.5829 15.2782 15.7782C15.0829 15.9734 14.7663 15.9734 14.5711 15.7782L11.7426 12.9497C11.5474 12.7545 11.5474 12.4379 11.7426 12.2426Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11740",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), Jr = /* @__PURE__ */ we({ default: () => Yr }), Yr, Xr = Se((() => {
	Yr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("path", {
				d: "M14.1689 15.2471C14.8023 14.9175 15.5969 14.9177 16.2304 15.2471C16.4754 15.3745 16.5707 15.6769 16.4433 15.9219C16.3158 16.1664 16.0142 16.2619 15.7695 16.1348C15.4252 15.9557 14.975 15.9557 14.6308 16.1348C13.9974 16.4642 13.2027 16.4642 12.5693 16.1348C12.225 15.9557 11.7749 15.9557 11.4306 16.1348C10.7971 16.4642 10.0025 16.4643 9.36908 16.1348C9.02483 15.9557 8.57466 15.9557 8.23041 16.1348C7.98563 16.2618 7.68405 16.1664 7.55658 15.9219C7.42914 15.6769 7.5245 15.3745 7.76947 15.2471C8.40296 14.9176 9.19754 14.9175 9.83099 15.2471C10.1752 15.4261 10.6255 15.4261 10.9697 15.2471C11.6031 14.9177 12.3978 14.9176 13.0312 15.2471C13.3753 15.426 13.8248 15.426 14.1689 15.2471ZM14.7499 7.5C15.0261 7.5 15.2499 7.72386 15.2499 8C15.2499 8.27614 15.0261 8.5 14.7499 8.5C14.3541 8.50004 14 8.83944 13.9999 9.2998V13.3154C14.058 13.2962 14.1151 13.275 14.1689 13.2471C14.8023 12.9175 15.5969 12.9177 16.2304 13.2471C16.4754 13.3745 16.5707 13.6769 16.4433 13.9219C16.3158 14.1664 16.0142 14.2619 15.7695 14.1348C15.4252 13.9557 14.975 13.9557 14.6308 14.1348C13.9974 14.4642 13.2027 14.4642 12.5693 14.1348C12.225 13.9557 11.7749 13.9557 11.4306 14.1348C10.7971 14.4642 10.0025 14.4643 9.36908 14.1348C9.02483 13.9557 8.57466 13.9557 8.23041 14.1348C7.98563 14.2618 7.68405 14.1664 7.55658 13.9219C7.42914 13.6769 7.5245 13.3745 7.76947 13.2471C8.29672 12.9729 8.93534 12.9271 9.49994 13.1094V9.2998C9.50004 8.32446 10.2652 7.50003 11.2499 7.5C11.5261 7.5 11.7499 7.72386 11.7499 8C11.7499 8.27614 11.5261 8.5 11.2499 8.5C10.8541 8.50004 10.5 8.83944 10.4999 9.2998V9.5H12.9999V9.2998C13 8.32446 13.7652 7.50003 14.7499 7.5ZM10.4999 12.5V13.375C10.6645 13.3625 10.8265 13.3215 10.9697 13.2471C11.5929 12.923 12.3717 12.9177 12.9999 13.2314V12.5H10.4999ZM10.4999 11.5H12.9999V10.5H10.4999V11.5Z",
				fill: "black"
			})
		]
	});
})), Zr = /* @__PURE__ */ we({ default: () => Qr }), Qr, $r = Se((() => {
	Qr = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11650)",
				className: "icon-inner",
				children: [/* @__PURE__ */ m("path", {
					d: "M16.935 11.75C16.615 11.195 14.855 8.41 11.865 8.5C9.1 8.57 7.5 11 7.065 11.75C7.02112 11.826 6.99802 11.9122 6.99802 12C6.99802 12.0878 7.02112 12.174 7.065 12.25C7.38 12.795 9.065 15.5 12.01 15.5H12.135C14.9 15.43 16.505 13 16.935 12.25C16.9789 12.174 17.002 12.0878 17.002 12C17.002 11.9122 16.9789 11.826 16.935 11.75ZM12.11 14.5C9.955 14.55 8.55 12.705 8.11 12C8.61 11.195 9.915 9.55 11.915 9.5C14.06 9.445 15.47 11.295 15.915 12C15.4 12.805 14.11 14.45 12.11 14.5Z",
					fill: "black"
				}), /* @__PURE__ */ m("path", {
					d: "M12 10.25C11.6539 10.25 11.3155 10.3526 11.0278 10.5449C10.74 10.7372 10.5157 11.0105 10.3832 11.3303C10.2508 11.6501 10.2161 12.0019 10.2836 12.3414C10.3512 12.6809 10.5178 12.9927 10.7626 13.2374C11.0073 13.4822 11.3191 13.6489 11.6586 13.7164C11.9981 13.7839 12.3499 13.7492 12.6697 13.6168C12.9895 13.4843 13.2628 13.26 13.4551 12.9722C13.6474 12.6845 13.75 12.3461 13.75 12C13.75 11.5359 13.5656 11.0908 13.2374 10.7626C12.9092 10.4344 12.4641 10.25 12 10.25ZM12 12.75C11.8517 12.75 11.7067 12.706 11.5833 12.6236C11.46 12.5412 11.3639 12.4241 11.3071 12.287C11.2503 12.15 11.2355 11.9992 11.2644 11.8537C11.2934 11.7082 11.3648 11.5746 11.4697 11.4697C11.5746 11.3648 11.7082 11.2933 11.8537 11.2644C11.9992 11.2355 12.15 11.2503 12.287 11.3071C12.4241 11.3639 12.5412 11.46 12.6236 11.5833C12.706 11.7067 12.75 11.8517 12.75 12C12.75 12.1989 12.671 12.3897 12.5303 12.5303C12.3897 12.671 12.1989 12.75 12 12.75Z",
					fill: "black"
				})]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11650",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), ei = /* @__PURE__ */ we({ default: () => ti }), ti, ni = Se((() => {
	ti = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("g", {
				clipPath: "url(#clip0_8083_103499)",
				className: "icon-inner",
				children: /* @__PURE__ */ m("path", {
					d: "M16.355 15.645L14.655 13.95C15.2035 13.2512 15.5011 12.3883 15.5 11.5C15.5 10.7089 15.2654 9.93552 14.8259 9.27772C14.3864 8.61992 13.7616 8.10723 13.0307 7.80448C12.2998 7.50173 11.4956 7.42252 10.7196 7.57686C9.94372 7.7312 9.23098 8.11216 8.67157 8.67157C8.11216 9.23098 7.7312 9.94372 7.57686 10.7196C7.42252 11.4956 7.50173 12.2998 7.80448 13.0307C8.10723 13.7616 8.61992 14.3864 9.27772 14.8259C9.93552 15.2654 10.7089 15.5 11.5 15.5C12.3883 15.5011 13.2512 15.2035 13.95 14.655L15.645 16.355C15.6915 16.4019 15.7468 16.4391 15.8077 16.4644C15.8686 16.4898 15.934 16.5029 16 16.5029C16.066 16.5029 16.1314 16.4898 16.1923 16.4644C16.2532 16.4391 16.3085 16.4019 16.355 16.355C16.4019 16.3085 16.4391 16.2532 16.4644 16.1923C16.4898 16.1314 16.5029 16.066 16.5029 16C16.5029 15.934 16.4898 15.8686 16.4644 15.8077C16.4391 15.7468 16.4019 15.6915 16.355 15.645ZM8.5 11.5C8.5 10.9067 8.67595 10.3266 9.00559 9.83329C9.33524 9.33994 9.80377 8.95543 10.352 8.72836C10.9001 8.5013 11.5033 8.44189 12.0853 8.55765C12.6672 8.6734 13.2018 8.95912 13.6213 9.37868C14.0409 9.79824 14.3266 10.3328 14.4424 10.9147C14.5581 11.4967 14.4987 12.0999 14.2716 12.6481C14.0446 13.1962 13.6601 13.6648 13.1667 13.9944C12.6734 14.3241 12.0933 14.5 11.5 14.5C10.7044 14.5 9.94129 14.1839 9.37868 13.6213C8.81607 13.0587 8.5 12.2957 8.5 11.5Z",
					fill: "black"
				})
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_8083_103499",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), ri = /* @__PURE__ */ we({ default: () => ii }), ii, ai = Se((() => {
	ii = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 11.5C14.8284 11.5 15.5 10.8284 15.5 10C15.5 9.17157 14.8284 8.5 14 8.5C13.1716 8.5 12.5 9.17157 12.5 10C12.5 10.8284 13.1716 11.5 14 11.5ZM14 12.5C15.3807 12.5 16.5 11.3807 16.5 10C16.5 8.61929 15.3807 7.5 14 7.5C12.6193 7.5 11.5 8.61929 11.5 10C11.5 11.3807 12.6193 12.5 14 12.5Z",
				fill: "black"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.7071 11.5C12.9024 11.6953 12.9024 12.0118 12.7071 12.2071L9.4571 15.4571C9.26184 15.6524 8.94526 15.6524 8.74999 15.4571C8.55473 15.2618 8.55473 14.9453 8.74999 14.75L12 11.5C12.1953 11.3047 12.5118 11.3047 12.7071 11.5Z",
				fill: "black"
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.9749 14.3965C12.1702 14.5917 12.1702 14.9083 11.9749 15.1036L10.9142 16.1642C10.719 16.3595 10.4024 16.3595 10.2071 16.1642L9.14648 15.1036C8.95122 14.9083 8.95122 14.5917 9.14648 14.3965L10.2071 13.3358C10.4024 13.1405 10.719 13.1405 10.9142 13.3358L11.9749 14.3965ZM10.9142 14.75L10.5607 14.3965L10.2071 14.75L10.5607 15.1036L10.9142 14.75Z",
				fill: "black"
			})
		]
	});
})), oi = /* @__PURE__ */ we({ default: () => si }), si, ci = Se((() => {
	si = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ m("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.4965 11.0841C15.4988 11.0564 15.5 11.0283 15.5 11V9.5C15.5 8.67157 14.8284 8 14 8H10C9.17157 8 8.5 8.67157 8.5 9.5V11C8.5 11.0283 8.50118 11.0564 8.50349 11.0841C7.91907 11.2891 7.5 11.8456 7.5 12.5V15C7.5 15.2761 7.72386 15.5 8 15.5C8.27614 15.5 8.5 15.2761 8.5 15V14.5H15.5V15C15.5 15.2761 15.7239 15.5 16 15.5C16.2761 15.5 16.5 15.2761 16.5 15V12.5C16.5 11.8456 16.0809 11.2891 15.4965 11.0841ZM9 12C8.72386 12 8.5 12.2239 8.5 12.5V13.5H15.5V12.5C15.5 12.2239 15.2761 12 15 12H9ZM9.5 9.58535V9.5C9.5 9.22386 9.72386 9 10 9H14C14.2761 9 14.5 9.22386 14.5 9.5V9.58535C14.3436 9.53008 14.1753 9.5 14 9.5H13C12.6158 9.5 12.2654 9.64443 12 9.88195C11.7346 9.64443 11.3842 9.5 11 9.5H10C9.82468 9.5 9.65639 9.53008 9.5 9.58535ZM12.5 11H14.5C14.5 10.7239 14.2761 10.5 14 10.5H13C12.7239 10.5 12.5 10.7239 12.5 11ZM11 10.5C11.2761 10.5 11.5 10.7239 11.5 11H9.5C9.5 10.7239 9.72386 10.5 10 10.5H11Z",
				fill: "black"
			})
		]
	});
})), li = /* @__PURE__ */ we({ default: () => ui }), ui, di = Se((() => {
	ui = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11760)",
				className: "icon-inner",
				children: [/* @__PURE__ */ m("path", {
					d: "M9.5 9C9.63261 9 9.75979 8.94732 9.85355 8.85355C9.94732 8.75979 10 8.63261 10 8.5C10 8.36739 9.94732 8.24021 9.85355 8.14645C9.75979 8.05268 9.63261 8 9.5 8H8.5C8.36739 8 8.24021 8.05268 8.14645 8.14645C8.05268 8.24021 8 8.36739 8 8.5V15.5C8 15.6326 8.05268 15.7598 8.14645 15.8536C8.24021 15.9473 8.36739 16 8.5 16H9.5C9.63261 16 9.75979 15.9473 9.85355 15.8536C9.94732 15.7598 10 15.6326 10 15.5C10 15.3674 9.94732 15.2402 9.85355 15.1464C9.75979 15.0527 9.63261 15 9.5 15H9V9H9.5Z",
					fill: "black"
				}), /* @__PURE__ */ m("path", {
					d: "M16.41 11.71L15 9.71001C14.9235 9.60221 14.8075 9.52908 14.6773 9.50659C14.547 9.4841 14.4132 9.51409 14.305 9.59001C14.2509 9.6279 14.2049 9.67613 14.1696 9.73191C14.1342 9.78769 14.1103 9.84992 14.0991 9.915C14.088 9.98008 14.0898 10.0467 14.1045 10.1111C14.1193 10.1755 14.1466 10.2363 14.185 10.29L15.045 11.5H11C10.8674 11.5 10.7402 11.5527 10.6464 11.6465C10.5527 11.7402 10.5 11.8674 10.5 12C10.5 12.1326 10.5527 12.2598 10.6464 12.3536C10.7402 12.4473 10.8674 12.5 11 12.5H15L14.1 13.7C14.0606 13.7525 14.0319 13.8123 14.0156 13.8759C13.9993 13.9395 13.9957 14.0057 14.005 14.0707C14.0143 14.1357 14.0363 14.1983 14.0698 14.2548C14.1032 14.3113 14.1475 14.3606 14.2 14.4C14.2865 14.4649 14.3918 14.5 14.5 14.5C14.5776 14.5 14.6542 14.4819 14.7236 14.4472C14.793 14.4125 14.8534 14.3621 14.9 14.3L16.4 12.3C16.464 12.2154 16.4995 12.1127 16.5013 12.0066C16.5031 11.9006 16.4711 11.7967 16.41 11.71Z",
					fill: "black"
				})]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11760",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), fi = /* @__PURE__ */ we({ default: () => pi }), pi, mi = Se((() => {
	pi = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_1383_11805)",
				className: "icon-inner",
				children: [
					/* @__PURE__ */ m("path", {
						d: "M16.83 8.125C16.7305 8.0376 16.6004 7.99325 16.4682 8.00169C16.336 8.01012 16.2126 8.07066 16.125 8.17L15.19 9.245L14.875 8.89C14.7868 8.79055 14.6627 8.73019 14.5301 8.72222C14.3974 8.71425 14.267 8.75932 14.1675 8.8475C14.068 8.93569 14.0077 9.05977 13.9997 9.19245C13.9918 9.32513 14.0368 9.45555 14.125 9.555L14.82 10.335C14.8673 10.3874 14.9252 10.4292 14.9898 10.4577C15.0545 10.4861 15.1244 10.5005 15.195 10.5C15.2652 10.4992 15.3343 10.4837 15.3981 10.4544C15.4618 10.4251 15.5187 10.3827 15.565 10.33L16.87 8.83C16.958 8.73113 17.0032 8.60139 16.9957 8.46923C16.9882 8.33708 16.9286 8.21328 16.83 8.125Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M11 11.5C11.3956 11.5 11.7822 11.3827 12.1111 11.1629C12.44 10.9432 12.6964 10.6308 12.8478 10.2654C12.9991 9.89992 13.0387 9.49778 12.9616 9.10982C12.8844 8.72186 12.6939 8.36549 12.4142 8.08579C12.1345 7.80608 11.7781 7.6156 11.3902 7.53843C11.0022 7.46126 10.6001 7.50087 10.2346 7.65224C9.86918 7.80362 9.55682 8.05996 9.33706 8.38886C9.1173 8.71776 9 9.10444 9 9.5C9 10.0304 9.21071 10.5391 9.58579 10.9142C9.96086 11.2893 10.4696 11.5 11 11.5ZM11 8.5C11.1978 8.5 11.3911 8.55865 11.5556 8.66853C11.72 8.77841 11.8482 8.93459 11.9239 9.11732C11.9996 9.30004 12.0194 9.50111 11.9808 9.69509C11.9422 9.88907 11.847 10.0673 11.7071 10.2071C11.5673 10.347 11.3891 10.4422 11.1951 10.4808C11.0011 10.5194 10.8 10.4996 10.6173 10.4239C10.4346 10.3482 10.2784 10.22 10.1685 10.0556C10.0586 9.89112 10 9.69778 10 9.5C10 9.23478 10.1054 8.98043 10.2929 8.79289C10.4804 8.60536 10.7348 8.5 11 8.5Z",
						fill: "black"
					}),
					/* @__PURE__ */ m("path", {
						d: "M11 12.5C10.0717 12.5 9.1815 12.8687 8.52513 13.5251C7.86875 14.1815 7.5 15.0717 7.5 16C7.5 16.1326 7.55268 16.2598 7.64645 16.3536C7.74021 16.4473 7.86739 16.5 8 16.5C8.13261 16.5 8.25979 16.4473 8.35355 16.3536C8.44732 16.2598 8.5 16.1326 8.5 16C8.5 15.337 8.76339 14.7011 9.23223 14.2322C9.70107 13.7634 10.337 13.5 11 13.5C11.663 13.5 12.2989 13.7634 12.7678 14.2322C13.2366 14.7011 13.5 15.337 13.5 16C13.5 16.1326 13.5527 16.2598 13.6464 16.3536C13.7402 16.4473 13.8674 16.5 14 16.5C14.1326 16.5 14.2598 16.4473 14.3536 16.3536C14.4473 16.2598 14.5 16.1326 14.5 16C14.5 15.0717 14.1313 14.1815 13.4749 13.5251C12.8185 12.8687 11.9283 12.5 11 12.5Z",
						fill: "black"
					})
				]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_1383_11805",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), hi = /* @__PURE__ */ we({ default: () => gi }), gi, _i = Se((() => {
	gi = (e) => /* @__PURE__ */ h("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [
			/* @__PURE__ */ m("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "black",
				fillOpacity: .05
			}),
			/* @__PURE__ */ m("path", {
				d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
				stroke: "black",
				strokeOpacity: .03
			}),
			/* @__PURE__ */ h("g", {
				clipPath: "url(#clip0_5812_106380)",
				className: "icon-inner",
				children: [/* @__PURE__ */ m("path", {
					d: "M16.5 9C16.5 8.60218 16.342 8.22064 16.0607 7.93934C15.7794 7.65804 15.3978 7.5 15 7.5H9C8.69799 7.50179 8.40356 7.5947 8.15523 7.76657C7.90689 7.93845 7.71623 8.18128 7.60817 8.4633C7.50012 8.74532 7.47971 9.05339 7.54962 9.3472C7.61953 9.64101 7.77651 9.90687 8 10.11V15C8 15.3978 8.15803 15.7794 8.43934 16.0607C8.72064 16.342 9.10217 16.5 9.5 16.5H14.5C14.8978 16.5 15.2794 16.342 15.5607 16.0607C15.842 15.7794 16 15.3978 16 15V10.11C16.1563 9.97021 16.2816 9.7992 16.3677 9.60801C16.4538 9.41681 16.4989 9.20969 16.5 9ZM9 8.5H15C15.1326 8.5 15.2598 8.55268 15.3536 8.64645C15.4473 8.74021 15.5 8.86739 15.5 9C15.5 9.13261 15.4473 9.25979 15.3536 9.35355C15.2598 9.44732 15.1326 9.5 15 9.5H9C8.86739 9.5 8.74021 9.44732 8.64645 9.35355C8.55268 9.25979 8.5 9.13261 8.5 9C8.5 8.86739 8.55268 8.74021 8.64645 8.64645C8.74021 8.55268 8.86739 8.5 9 8.5ZM15 15C15 15.1326 14.9473 15.2598 14.8536 15.3536C14.7598 15.4473 14.6326 15.5 14.5 15.5H9.5C9.36739 15.5 9.24021 15.4473 9.14645 15.3536C9.05268 15.2598 9 15.1326 9 15V10.5H15V15Z",
					fill: "black"
				}), /* @__PURE__ */ m("path", {
					d: "M13.065 12H10.935C10.6948 12 10.5 12.1948 10.5 12.435V12.565C10.5 12.8052 10.6948 13 10.935 13H13.065C13.3052 13 13.5 12.8052 13.5 12.565V12.435C13.5 12.1948 13.3052 12 13.065 12Z",
					fill: "black"
				})]
			}),
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_5812_106380",
				children: /* @__PURE__ */ m("rect", {
					width: 12,
					height: 12,
					fill: "white",
					transform: "translate(6 6)"
				})
			}) })
		]
	});
})), vi = /* @__PURE__ */ we({ default: () => yi }), yi, bi = Se((() => {
	yi = (e) => /* @__PURE__ */ h("svg", {
		width: 32,
		height: 32,
		viewBox: "0 0 32 32",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [/* @__PURE__ */ m("rect", {
			x: .5,
			y: .5,
			width: 31,
			height: 31,
			rx: 15.5,
			stroke: "black",
			strokeOpacity: .1,
			strokeDasharray: "2 2"
		}), /* @__PURE__ */ h("g", { children: [/* @__PURE__ */ m("path", {
			d: "M15.9999 15.3333C16.5273 15.3333 17.0429 15.1769 17.4814 14.8839C17.92 14.5909 18.2618 14.1744 18.4636 13.6872C18.6654 13.1999 18.7182 12.6637 18.6153 12.1464C18.5125 11.6291 18.2585 11.154 17.8855 10.781C17.5126 10.4081 17.0374 10.1541 16.5202 10.0512C16.0029 9.94835 15.4667 10.0012 14.9794 10.203C14.4922 10.4048 14.0757 10.7466 13.7827 11.1851C13.4896 11.6237 13.3333 12.1393 13.3333 12.6667C13.3333 13.3739 13.6142 14.0522 14.1143 14.5523C14.6144 15.0524 15.2927 15.3333 15.9999 15.3333ZM15.9999 11.3333C16.2636 11.3333 16.5214 11.4115 16.7407 11.558C16.9599 11.7046 17.1308 11.9128 17.2318 12.1564C17.3327 12.4001 17.3591 12.6681 17.3076 12.9268C17.2562 13.1854 17.1292 13.423 16.9427 13.6095C16.7563 13.7959 16.5187 13.9229 16.26 13.9744C16.0014 14.0258 15.7333 13.9994 15.4897 13.8985C15.246 13.7976 15.0378 13.6267 14.8913 13.4074C14.7448 13.1882 14.6666 12.9304 14.6666 12.6667C14.6666 12.313 14.8071 11.9739 15.0571 11.7239C15.3072 11.4738 15.6463 11.3333 15.9999 11.3333Z",
			fill: "black"
		}), /* @__PURE__ */ m("path", {
			d: "M15.9999 16.6666C14.7622 16.6666 13.5753 17.1583 12.7001 18.0335C11.8249 18.9086 11.3333 20.0956 11.3333 21.3333C11.3333 21.5101 11.4035 21.6797 11.5285 21.8047C11.6535 21.9297 11.8231 22 11.9999 22C12.1767 22 12.3463 21.9297 12.4713 21.8047C12.5963 21.6797 12.6666 21.5101 12.6666 21.3333C12.6666 20.4492 13.0178 19.6014 13.6429 18.9763C14.268 18.3511 15.1159 18 15.9999 18C16.884 18 17.7318 18.3511 18.3569 18.9763C18.9821 19.6014 19.3333 20.4492 19.3333 21.3333C19.3333 21.5101 19.4035 21.6797 19.5285 21.8047C19.6535 21.9297 19.8231 22 19.9999 22C20.1767 22 20.3463 21.9297 20.4713 21.8047C20.5963 21.6797 20.6666 21.5101 20.6666 21.3333C20.6666 20.0956 20.1749 18.9086 19.2998 18.0335C18.4246 17.1583 17.2376 16.6666 15.9999 16.6666Z",
			fill: "black"
		})] })]
	});
})), xi = {
	AgreementCompliance: "AgreementCompliance",
	ApproveSettlementTransfers: "ApproveSettlementTransfers",
	AwaitingExchange: "AwaitingExchange",
	BalanceDeposit: "BalanceDeposit",
	BodyCorporate: "BodyCorporate",
	ConditionDue: "ConditionDue",
	Conditions: "Conditions",
	DeceasedEstate: "DeceasedEstate",
	DepositExceeds: "DepositExceeds",
	Deposit: "Deposit",
	FollowupMarketingfunds: "FollowupMarketingfunds",
	FollowupOutstandingContractInformation: "FollowupOutstandingContractInformation",
	HolidayRental: "HolidayRental",
	InitialDeposit: "InitialDeposit",
	Launch: "Launch",
	NewContract: "NewContract",
	NewListing: "NewListing",
	OwnerBuilder: "OwnerBuilder",
	Pool: "Pool",
	Review: "Review",
	SellerDisclosure: "SellerDisclosure",
	Settlement: "Settlement",
	Tenanted: "Tenanted",
	Terminate: "Terminate",
	Unconditional: "Unconditional",
	Withdrawn: "Withdrawn",
	User: "User"
}, Si = {
	ApproveSettlementTransfers: t.lazy(() => Promise.resolve().then(() => (Xn(), Jn))),
	AwaitingExchange: t.lazy(() => Promise.resolve().then(() => ($n(), Zn))),
	AgreementCompliance: t.lazy(() => Promise.resolve().then(() => (nr(), er))),
	BalanceDeposit: t.lazy(() => Promise.resolve().then(() => (ar(), rr))),
	BodyCorporate: t.lazy(() => Promise.resolve().then(() => (cr(), or))),
	ConditionDue: t.lazy(() => Promise.resolve().then(() => (dr(), lr))),
	Conditions: t.lazy(() => Promise.resolve().then(() => (mr(), fr))),
	DeceasedEstate: t.lazy(() => Promise.resolve().then(() => (_r(), hr))),
	DepositExceeds: t.lazy(() => Promise.resolve().then(() => (br(), vr))),
	Deposit: t.lazy(() => Promise.resolve().then(() => (Cr(), xr))),
	FollowupMarketingfunds: t.lazy(() => Promise.resolve().then(() => (Er(), wr))),
	FollowupOutstandingContractInformation: t.lazy(() => Promise.resolve().then(() => (kr(), Dr))),
	HolidayRental: t.lazy(() => Promise.resolve().then(() => (Mr(), Ar))),
	InitialDeposit: t.lazy(() => Promise.resolve().then(() => (Fr(), Nr))),
	Launch: t.lazy(() => Promise.resolve().then(() => (Rr(), Ir))),
	NewContract: t.lazy(() => Promise.resolve().then(() => (Vr(), zr))),
	NewListing: t.lazy(() => Promise.resolve().then(() => (Wr(), Hr))),
	OwnerBuilder: t.lazy(() => Promise.resolve().then(() => (qr(), Gr))),
	Pool: t.lazy(() => Promise.resolve().then(() => (Xr(), Jr))),
	Review: t.lazy(() => Promise.resolve().then(() => ($r(), Zr))),
	SellerDisclosure: t.lazy(() => Promise.resolve().then(() => (ni(), ei))),
	Settlement: t.lazy(() => Promise.resolve().then(() => (ai(), ri))),
	Tenanted: t.lazy(() => Promise.resolve().then(() => (ci(), oi))),
	Terminate: t.lazy(() => Promise.resolve().then(() => (di(), li))),
	Unconditional: t.lazy(() => Promise.resolve().then(() => (mi(), fi))),
	Withdrawn: t.lazy(() => Promise.resolve().then(() => (_i(), hi))),
	User: t.lazy(() => Promise.resolve().then(() => (bi(), vi)))
}, Ci = (n) => {
	let r = e(12), { type: i, iconColor: a, bgColor: o, height: s, width: c } = n, l = o === void 0 ? "white" : o, u = s === void 0 ? 15 : s, d = c === void 0 ? 14 : c, f = Si[i], p;
	r[0] !== u || r[1] !== d ? (p = /* @__PURE__ */ m("div", { style: {
		width: d,
		height: u
	} }), r[0] = u, r[1] = d, r[2] = p) : p = r[2];
	let h = `icon-task-${a}`, g;
	r[3] !== f || r[4] !== l || r[5] !== u || r[6] !== h || r[7] !== d ? (g = /* @__PURE__ */ m(f, {
		width: d,
		height: u,
		fill: l,
		className: h
	}), r[3] = f, r[4] = l, r[5] = u, r[6] = h, r[7] = d, r[8] = g) : g = r[8];
	let _;
	return r[9] !== p || r[10] !== g ? (_ = /* @__PURE__ */ m(t.Suspense, {
		fallback: p,
		children: g
	}), r[9] = p, r[10] = g, r[11] = _) : _ = r[11], _;
}, wi = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ h("div", {
		className: "featuredIcon",
		children: [
			/* @__PURE__ */ m(Bi, {
				width: 40,
				height: 40,
				color: "var(--fg-success)"
			}),
			/* @__PURE__ */ m("span", { className: "featuredIconRing ring-1" }),
			/* @__PURE__ */ m("span", { className: "featuredIconRing ring-2" }),
			/* @__PURE__ */ m("span", { className: "featuredIconRing ring-3" }),
			/* @__PURE__ */ m("span", { className: "featuredIconRing ring-4" })
		]
	}), t[0] = n) : n = t[0], n;
}, Ti = (t) => {
	let n = e(7), { type: r, color: i, height: a, width: o } = t, s = i === void 0 ? "var(--text-black)" : i, c = a === void 0 ? 15 : a, l = o === void 0 ? 14 : o, u = s;
	bb0: switch (r) {
		case "danger":
			u = "var(--fg-error)";
			break bb0;
		case "warning":
			u = "var(--fg-warning)";
			break bb0;
		case "information": u = "var(--fg-action)";
	}
	let d;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (d = { flexShrink: 0 }, n[0] = d) : d = n[0];
	let f;
	n[1] === u ? f = n[2] : (f = /* @__PURE__ */ m("path", {
		d: "M6.99992 0.689453C5.68138 0.689453 4.39245 1.08045 3.29612 1.81299C2.19979 2.54553 1.34531 3.58672 0.840725 4.8049C0.336141 6.02307 0.204118 7.36352 0.461353 8.65672C0.718588 9.94993 1.35353 11.1378 2.28588 12.0702C3.21823 13.0025 4.40611 13.6375 5.69932 13.8947C6.99253 14.1519 8.33297 14.0199 9.55115 13.5153C10.7693 13.0107 11.8105 12.1562 12.5431 11.0599C13.2756 9.96359 13.6666 8.67466 13.6666 7.35612C13.6666 6.48064 13.4942 5.61373 13.1591 4.8049C12.8241 3.99606 12.333 3.26113 11.714 2.64207C11.0949 2.02302 10.36 1.53195 9.55115 1.19692C8.74231 0.861892 7.8754 0.689453 6.99992 0.689453ZM6.99992 10.6895C6.86807 10.6895 6.73917 10.6504 6.62954 10.5771C6.51991 10.5038 6.43446 10.3997 6.384 10.2779C6.33354 10.1561 6.32034 10.022 6.34607 9.89273C6.37179 9.76341 6.43528 9.64462 6.52852 9.55138C6.62175 9.45815 6.74054 9.39465 6.86986 9.36893C6.99918 9.34321 7.13323 9.35641 7.25504 9.40687C7.37686 9.45732 7.48098 9.54277 7.55423 9.65241C7.62749 9.76204 7.66659 9.89093 7.66659 10.0228C7.66659 10.1996 7.59635 10.3692 7.47133 10.4942C7.3463 10.6192 7.17673 10.6895 6.99992 10.6895ZM7.66659 8.02279C7.66659 8.1996 7.59635 8.36917 7.47133 8.49419C7.3463 8.61922 7.17673 8.68945 6.99992 8.68945C6.82311 8.68945 6.65354 8.61922 6.52852 8.49419C6.40349 8.36917 6.33326 8.1996 6.33326 8.02279V4.68945C6.33326 4.51264 6.40349 4.34307 6.52852 4.21805C6.65354 4.09302 6.82311 4.02279 6.99992 4.02279C7.17673 4.02279 7.3463 4.09302 7.47133 4.21805C7.59635 4.34307 7.66659 4.51264 7.66659 4.68945V8.02279Z",
		fill: u
	}), n[1] = u, n[2] = f);
	let p;
	return n[3] !== c || n[4] !== f || n[5] !== l ? (p = /* @__PURE__ */ m("svg", {
		width: l,
		height: c,
		viewBox: "0 0 14 15",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: d,
		children: f
	}), n[3] = c, n[4] = f, n[5] = l, n[6] = p) : p = n[6], p;
}, Ei = (t) => {
	let n = e(8), { direction: r, color: i, height: a, width: o } = t, s = r === void 0 ? "up" : r, c = i === void 0 ? "var(--text-black)" : i, l = a === void 0 ? 24 : a, u = o === void 0 ? 24 : o, d = "";
	bb0: switch (s) {
		case "up":
			d = "M15.9999 14.5C15.8683 14.5008 15.7379 14.4755 15.616 14.4258C15.4942 14.376 15.3834 14.3027 15.2899 14.21L11.9999 10.9L8.69994 14.08C8.51258 14.2663 8.25912 14.3708 7.99494 14.3708C7.73075 14.3708 7.4773 14.2663 7.28994 14.08C7.19621 13.987 7.12182 13.8764 7.07105 13.7546C7.02028 13.6327 6.99414 13.502 6.99414 13.37C6.99414 13.238 7.02028 13.1073 7.07105 12.9854C7.12182 12.8636 7.19621 12.753 7.28994 12.66L11.2899 8.8C11.4769 8.61678 11.7282 8.51414 11.9899 8.51414C12.2517 8.51414 12.503 8.61678 12.6899 8.8L16.6899 12.8C16.7837 12.893 16.8581 13.0036 16.9088 13.1254C16.9596 13.2473 16.9857 13.378 16.9857 13.51C16.9857 13.642 16.9596 13.7727 16.9088 13.8946C16.8581 14.0164 16.7837 14.127 16.6899 14.22C16.5046 14.3987 16.2574 14.499 15.9999 14.5Z";
			break bb0;
		case "down":
			d = "M11.9999 15.5C11.8683 15.5008 11.7379 15.4755 11.616 15.4258C11.4942 15.376 11.3834 15.3027 11.2899 15.21L7.28994 11.21C7.1967 11.1168 7.12274 11.0061 7.07228 10.8843C7.02182 10.7624 6.99585 10.6319 6.99585 10.5C6.99585 10.3681 7.02182 10.2376 7.07228 10.1158C7.12274 9.99393 7.1967 9.88324 7.28994 9.79C7.38318 9.69676 7.49387 9.6228 7.61569 9.57234C7.73751 9.52188 7.86808 9.49591 7.99994 9.49591C8.1318 9.49591 8.26237 9.52188 8.38419 9.57234C8.50601 9.6228 8.6167 9.69676 8.70994 9.79L11.9999 13.1L15.2999 9.92C15.3919 9.81771 15.504 9.7355 15.6293 9.67852C15.7545 9.62153 15.8901 9.59099 16.0276 9.58881C16.1652 9.58664 16.3017 9.61286 16.4287 9.66585C16.5556 9.71884 16.6703 9.79746 16.7655 9.89678C16.8607 9.99611 16.9343 10.114 16.9819 10.2431C17.0294 10.3722 17.0498 10.5097 17.0418 10.647C17.0338 10.7844 16.9975 10.9186 16.9352 11.0413C16.873 11.1639 16.7861 11.2724 16.6799 11.36L12.6799 15.22C12.4971 15.3963 12.2539 15.4964 11.9999 15.5Z";
			break bb0;
		case "left":
			d = "M13.36 17C13.2253 16.9995 13.0921 16.9718 12.9684 16.9185C12.8446 16.8652 12.7329 16.7875 12.64 16.69L8.78 12.69C8.59677 12.5031 8.49414 12.2518 8.49414 11.99C8.49414 11.7282 8.59677 11.4769 8.78 11.29L12.78 7.29C12.8732 7.19676 12.9839 7.1228 13.1057 7.07234C13.2276 7.02188 13.3581 6.99591 13.49 6.99591C13.6219 6.99591 13.7524 7.02188 13.8742 7.07234C13.9961 7.1228 14.1068 7.19676 14.2 7.29C14.2932 7.38324 14.3672 7.49393 14.4177 7.61575C14.4681 7.73758 14.4941 7.86814 14.4941 8C14.4941 8.13186 14.4681 8.26243 14.4177 8.38425C14.3672 8.50607 14.2932 8.61676 14.2 8.71L10.9 12L14.08 15.3C14.2662 15.4874 14.3708 15.7408 14.3708 16.005C14.3708 16.2692 14.2662 16.5226 14.08 16.71C13.9854 16.8039 13.8729 16.8779 13.7493 16.9277C13.6256 16.9775 13.4933 17.0021 13.36 17Z";
			break bb0;
		case "right": d = "M10.4999 17C10.3683 17.0008 10.2379 16.9755 10.116 16.9258C9.9942 16.876 9.88338 16.8027 9.78994 16.71C9.69621 16.617 9.62182 16.5064 9.57105 16.3846C9.52028 16.2627 9.49414 16.132 9.49414 16C9.49414 15.868 9.52028 15.7373 9.57105 15.6154C9.62182 15.4936 9.69621 15.383 9.78994 15.29L13.0999 12L9.91994 8.69C9.73369 8.50263 9.62915 8.24918 9.62915 7.985C9.62915 7.72081 9.73369 7.46736 9.91994 7.28C10.0129 7.18627 10.1235 7.11187 10.2454 7.06111C10.3672 7.01034 10.4979 6.9842 10.6299 6.9842C10.762 6.9842 10.8927 7.01034 11.0145 7.06111C11.1364 7.11187 11.247 7.18627 11.3399 7.28L15.1999 11.28C15.3832 11.4669 15.4858 11.7182 15.4858 11.98C15.4858 12.2417 15.3832 12.4931 15.1999 12.68L11.1999 16.68C11.1102 16.7769 11.0021 16.8551 10.882 16.91C10.7618 16.965 10.632 16.9955 10.4999 17Z";
	}
	let f;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (f = { flexShrink: 0 }, n[0] = f) : f = n[0];
	let p;
	n[1] !== c || n[2] !== d ? (p = /* @__PURE__ */ m("path", {
		d,
		fill: c
	}), n[1] = c, n[2] = d, n[3] = p) : p = n[3];
	let h;
	return n[4] !== l || n[5] !== p || n[6] !== u ? (h = /* @__PURE__ */ m("svg", {
		width: u,
		height: l,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: f,
		children: p
	}), n[4] = l, n[5] = p, n[6] = u, n[7] = h) : h = n[7], h;
}, Di = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M15.2583 14.075L12.425 11.25C13.3392 10.0854 13.8352 8.64721 13.8333 7.16667C13.8333 5.84813 13.4423 4.5592 12.7098 3.46287C11.9773 2.36654 10.9361 1.51206 9.71789 1.00747C8.49972 0.502889 7.15927 0.370866 5.86607 0.628101C4.57286 0.885336 3.38497 1.52027 2.45262 2.45262C1.52027 3.38497 0.885336 4.57286 0.628101 5.86607C0.370866 7.15927 0.502889 8.49972 1.00747 9.71789C1.51206 10.9361 2.36654 11.9773 3.46287 12.7098C4.5592 13.4423 5.84813 13.8333 7.16667 13.8333C8.64721 13.8352 10.0854 13.3392 11.25 12.425L14.075 15.2583C14.1525 15.3364 14.2446 15.3984 14.3462 15.4407C14.4477 15.4831 14.5567 15.5048 14.6667 15.5048C14.7767 15.5048 14.8856 15.4831 14.9871 15.4407C15.0887 15.3984 15.1809 15.3364 15.2583 15.2583C15.3364 15.1809 15.3984 15.0887 15.4407 14.9871C15.4831 14.8856 15.5048 14.7767 15.5048 14.6667C15.5048 14.5567 15.4831 14.4477 15.4407 14.3462C15.3984 14.2446 15.3364 14.1525 15.2583 14.075ZM2.16667 7.16667C2.16667 6.17776 2.45991 5.21106 3.00932 4.38882C3.55873 3.56657 4.33962 2.92571 5.25325 2.54727C6.16688 2.16883 7.17222 2.06982 8.14212 2.26274C9.11203 2.45567 10.0029 2.93187 10.7022 3.63114C11.4015 4.3304 11.8777 5.22131 12.0706 6.19122C12.2635 7.16112 12.1645 8.16646 11.7861 9.08009C11.4076 9.99372 10.7668 10.7746 9.94452 11.324C9.12227 11.8734 8.15558 12.1667 7.16667 12.1667C5.84059 12.1667 4.56882 11.6399 3.63114 10.7022C2.69345 9.76452 2.16667 8.49275 2.16667 7.16667Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 16 16",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Oi = (t) => {
	let n = e(8), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l, u;
	n[0] === o ? (l = n[1], u = n[2]) : (l = /* @__PURE__ */ m("path", {
		d: "M20.9998 6C20.9998 5.20435 20.6837 4.44129 20.1211 3.87868C19.5585 3.31607 18.7955 3 17.9998 3H5.99982C5.3958 3.00358 4.80694 3.1894 4.31027 3.53315C3.8136 3.8769 3.43227 4.36257 3.21616 4.92661C3.00005 5.49065 2.95924 6.10679 3.09906 6.6944C3.23889 7.28202 3.55283 7.81374 3.99982 8.22V18C3.99982 18.7956 4.31589 19.5587 4.8785 20.1213C5.44111 20.6839 6.20417 21 6.99982 21H16.9998C17.7955 21 18.5585 20.6839 19.1211 20.1213C19.6837 19.5587 19.9998 18.7956 19.9998 18V8.22C20.3124 7.94042 20.5629 7.59839 20.7352 7.21601C20.9074 6.83363 20.9976 6.41938 20.9998 6ZM5.99982 5H17.9998C18.265 5 18.5194 5.10536 18.7069 5.29289C18.8945 5.48043 18.9998 5.73478 18.9998 6C18.9998 6.26522 18.8945 6.51957 18.7069 6.70711C18.5194 6.89464 18.265 7 17.9998 7H5.99982C5.7346 7 5.48025 6.89464 5.29271 6.70711C5.10517 6.51957 4.99982 6.26522 4.99982 6C4.99982 5.73478 5.10517 5.48043 5.29271 5.29289C5.48025 5.10536 5.7346 5 5.99982 5ZM17.9998 18C17.9998 18.2652 17.8945 18.5196 17.7069 18.7071C17.5194 18.8946 17.265 19 16.9998 19H6.99982C6.7346 19 6.48025 18.8946 6.29271 18.7071C6.10517 18.5196 5.99982 18.2652 5.99982 18V9H17.9998V18Z",
		fill: o
	}), u = /* @__PURE__ */ m("path", {
		d: "M14.13 12H9.87C9.38951 12 9 12.3895 9 12.87V13.13C9 13.6105 9.38951 14 9.87 14H14.13C14.6105 14 15 13.6105 15 13.13V12.87C15 12.3895 14.6105 12 14.13 12Z",
		fill: o
	}), n[0] = o, n[1] = l, n[2] = u);
	let d;
	return n[3] !== s || n[4] !== l || n[5] !== u || n[6] !== c ? (d = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[3] = s, n[4] = l, n[5] = u, n[6] = c, n[7] = d) : d = n[7], d;
}, ki = (t) => {
	let n = e(10), { type: r, color: i, height: a, width: o } = t, s = i === void 0 ? "var(--text-black)" : i, c = a === void 0 ? 15 : a, l = o === void 0 ? 14 : o, u = s;
	bb0: switch (r) {
		case "Danger":
			u = "var(--text-error)";
			break bb0;
		case "Warning":
			u = "var(--text-warning)";
			break bb0;
		case "Information": u = "var(--text-action)";
	}
	let d, f, p;
	n[0] === u ? (d = n[1], f = n[2], p = n[3]) : (d = /* @__PURE__ */ m("path", {
		d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z",
		fill: u
	}), f = /* @__PURE__ */ m("path", {
		d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
		fill: u
	}), p = /* @__PURE__ */ m("path", {
		d: "M12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7Z",
		fill: u
	}), n[0] = u, n[1] = d, n[2] = f, n[3] = p);
	let g;
	return n[4] !== c || n[5] !== d || n[6] !== f || n[7] !== p || n[8] !== l ? (g = /* @__PURE__ */ h("svg", {
		width: l,
		height: c,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			d,
			f,
			p
		]
	}), n[4] = c, n[5] = d, n[6] = f, n[7] = p, n[8] = l, n[9] = g) : g = n[9], g;
}, Ai = (t) => {
	let n = e(8), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l, u;
	n[0] === o ? (l = n[1], u = n[2]) : (l = /* @__PURE__ */ m("path", {
		d: "M12.7098 11.29C12.5229 11.1068 12.2716 11.0042 12.0098 11.0042C11.7481 11.0042 11.4968 11.1068 11.3098 11.29L8.30983 14.19C8.20372 14.2776 8.11682 14.3861 8.05456 14.5088C7.9923 14.6314 7.95602 14.7656 7.94799 14.903C7.93997 15.0403 7.96036 15.1778 8.0079 15.3069C8.05545 15.436 8.12911 15.5539 8.2243 15.6532C8.31949 15.7526 8.43414 15.8312 8.5611 15.8842C8.68805 15.9371 8.82458 15.9634 8.96213 15.9612C9.09968 15.959 9.23531 15.9285 9.36052 15.8715C9.48573 15.8145 9.59784 15.7323 9.68983 15.63L10.9998 14.36V20C10.9998 20.2652 11.1052 20.5196 11.2927 20.7071C11.4803 20.8947 11.7346 21 11.9998 21C12.265 21 12.5194 20.8947 12.7069 20.7071C12.8945 20.5196 12.9998 20.2652 12.9998 20V14.41L14.2898 15.71C14.3828 15.8037 14.4934 15.8781 14.6153 15.9289C14.7371 15.9797 14.8678 16.0058 14.9998 16.0058C15.1318 16.0058 15.2626 15.9797 15.3844 15.9289C15.5063 15.8781 15.6169 15.8037 15.7098 15.71C15.8036 15.617 15.878 15.5064 15.9287 15.3846C15.9795 15.2627 16.0056 15.132 16.0056 15C16.0056 14.868 15.9795 14.7373 15.9287 14.6154C15.878 14.4936 15.8036 14.383 15.7098 14.29L12.7098 11.29Z",
		fill: o
	}), u = /* @__PURE__ */ m("path", {
		d: "M17.6704 7C17.2623 5.82105 16.497 4.79861 15.4807 4.07496C14.4645 3.3513 13.2479 2.96242 12.0004 2.96242C10.7528 2.96242 9.53628 3.3513 8.52005 4.07496C7.50381 4.79861 6.73842 5.82105 6.33038 7C5.43194 7.12033 4.5831 7.48265 3.87468 8.04819C3.16627 8.61373 2.62492 9.36121 2.30855 10.2107C1.99218 11.0602 1.91269 11.9797 2.07859 12.8708C2.24449 13.762 2.64953 14.5913 3.25038 15.27C3.32296 15.3978 3.42284 15.5081 3.54289 15.5929C3.66295 15.6778 3.80023 15.7351 3.94497 15.7609C4.08971 15.7866 4.23834 15.7801 4.38029 15.7418C4.52223 15.7036 4.65399 15.6345 4.76618 15.5395C4.87838 15.4445 4.96825 15.3259 5.0294 15.1922C5.09055 15.0586 5.12147 14.913 5.11996 14.766C5.11845 14.619 5.08455 14.4742 5.02067 14.3418C4.95679 14.2094 4.86451 14.0927 4.75038 14C4.3635 13.5675 4.11037 13.032 4.02167 12.4585C3.93297 11.885 4.01252 11.2981 4.25066 10.7689C4.4888 10.2397 4.87532 9.79089 5.36338 9.47693C5.85143 9.16296 6.42007 8.99729 7.00038 9H7.10038C7.33433 9.00471 7.56252 8.92724 7.74524 8.78107C7.92796 8.63489 8.05363 8.42927 8.10038 8.2C8.284 7.29576 8.77457 6.48282 9.48898 5.89889C10.2034 5.31497 11.0977 4.99599 12.0204 4.99599C12.9431 4.99599 13.8374 5.31497 14.5518 5.89889C15.2662 6.48282 15.7568 7.29576 15.9404 8.2C15.9871 8.42927 16.1128 8.63489 16.2955 8.78107C16.4782 8.92724 16.7064 9.00471 16.9404 9H17.0004C17.5807 8.99729 18.1493 9.16296 18.6374 9.47693C19.1254 9.79089 19.512 10.2397 19.7501 10.7689C19.9883 11.2981 20.0678 11.885 19.9791 12.4585C19.8904 13.032 19.6373 13.5675 19.2504 14C19.1623 14.0988 19.0947 14.2141 19.0515 14.3392C19.0083 14.4643 18.9904 14.5967 18.9987 14.7288C19.0071 14.8609 19.0416 14.99 19.1003 15.1086C19.1589 15.2273 19.2405 15.3331 19.3404 15.42C19.5227 15.5808 19.7573 15.6696 20.0004 15.67C20.1424 15.6698 20.2827 15.6394 20.412 15.5808C20.5413 15.5222 20.6567 15.4367 20.7504 15.33C21.3679 14.6524 21.7873 13.8182 21.9626 12.9183C22.138 12.0185 22.0625 11.0878 21.7446 10.228C21.4267 9.36812 20.8785 8.61223 20.1599 8.04293C19.4414 7.47363 18.5802 7.11284 17.6704 7Z",
		fill: o
	}), n[0] = o, n[1] = l, n[2] = u);
	let d;
	return n[3] !== s || n[4] !== l || n[5] !== u || n[6] !== c ? (d = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[3] = s, n[4] = l, n[5] = u, n[6] = c, n[7] = d) : d = n[7], d;
}, ji = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M17.3 11.43C17.048 11.3515 16.7752 11.3757 16.5411 11.4975C16.3069 11.6192 16.1304 11.8286 16.05 12.08C15.5776 13.5245 14.6566 14.7805 13.421 15.6654C12.1854 16.5503 10.6997 17.0178 9.18 17C7.30035 17.0214 5.48894 16.2965 4.14297 14.9842C2.79701 13.672 2.02635 11.8796 2 10C2.02635 8.12041 2.79701 6.32798 4.14297 5.01576C5.48894 3.70354 7.30035 2.97863 9.18 3C10.8776 2.9959 12.5229 3.5868 13.83 4.67L11.66 4.31C11.5299 4.2886 11.3969 4.29312 11.2686 4.3233C11.1403 4.35348 11.0193 4.40873 10.9124 4.48586C10.8055 4.563 10.715 4.6605 10.6459 4.77276C10.5768 4.88502 10.5307 5.00982 10.51 5.14C10.4886 5.27005 10.4931 5.40305 10.5233 5.53135C10.5535 5.65965 10.6087 5.78072 10.6859 5.88759C10.763 5.99446 10.8605 6.08503 10.9728 6.15409C11.085 6.22315 11.2098 6.26934 11.34 6.29L15.58 6.99H15.75C15.866 6.98986 15.981 6.96956 16.09 6.93C16.1266 6.91609 16.1605 6.89577 16.19 6.87C16.2617 6.84334 16.3291 6.80627 16.39 6.76L16.48 6.65C16.48 6.6 16.57 6.56 16.61 6.5C16.65 6.44 16.61 6.4 16.66 6.36C16.6876 6.30176 16.711 6.2416 16.73 6.18L17.48 2.18C17.505 2.04867 17.5038 1.91372 17.4766 1.78285C17.4494 1.65198 17.3967 1.52774 17.3215 1.41724C17.2462 1.30674 17.15 1.21213 17.0382 1.13883C16.9264 1.06552 16.8013 1.01495 16.67 0.989997C16.5387 0.965046 16.4037 0.966205 16.2729 0.993408C16.142 1.02061 16.0177 1.07332 15.9072 1.14854C15.6841 1.30044 15.5304 1.53478 15.48 1.8L15.21 3.25C13.536 1.79924 11.3952 1.00043 9.18 0.999997C6.76993 0.978664 4.44984 1.91429 2.7288 3.60158C1.00777 5.28886 0.0263909 7.58998 0 10C0.0263909 12.41 1.00777 14.7111 2.7288 16.3984C4.44984 18.0857 6.76993 19.0213 9.18 19C11.1331 19.03 13.0443 18.4321 14.6321 17.2944C16.2199 16.1566 17.4005 14.5391 18 12.68C18.0379 12.552 18.0498 12.4176 18.035 12.2849C18.0202 12.1522 17.9789 12.0238 17.9137 11.9073C17.8485 11.7908 17.7605 11.6886 17.6551 11.6066C17.5497 11.5246 17.429 11.4646 17.3 11.43Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 19 19",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Mi = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M15 7H9V1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V7H1C0.734784 7 0.48043 7.10536 0.292893 7.29289C0.105357 7.48043 0 7.73478 0 8C0 8.26522 0.105357 8.51957 0.292893 8.70711C0.48043 8.89464 0.734784 9 1 9H7V15C7 15.2652 7.10536 15.5196 7.29289 15.7071C7.48043 15.8946 7.73478 16 8 16C8.26522 16 8.51957 15.8946 8.70711 15.7071C8.89464 15.5196 9 15.2652 9 15V9H15C15.2652 9 15.5196 8.89464 15.7071 8.70711C15.8946 8.51957 16 8.26522 16 8C16 7.73478 15.8946 7.48043 15.7071 7.29289C15.5196 7.10536 15.2652 7 15 7Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 16 16",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Ni = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM16.33 2L10 6.75L3.67 2H16.33ZM17 14H3C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V3.25L9.4 8.8C9.5731 8.92982 9.78363 9 10 9C10.2164 9 10.4269 8.92982 10.6 8.8L18 3.25V13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 20 16",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Pi = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M19.4001 7.34L16.6601 4.6C16.3024 4.26409 15.8338 4.07135 15.3434 4.05845C14.8529 4.04554 14.3748 4.21336 14.0001 4.53L5.00005 13.53C4.67682 13.856 4.47556 14.2832 4.43005 14.74L4.00005 18.91C3.98658 19.0565 4.00559 19.2041 4.05571 19.3424C4.10584 19.4807 4.18585 19.6062 4.29005 19.71C4.38349 19.8027 4.49431 19.876 4.61615 19.9258C4.73798 19.9755 4.86845 20.0008 5.00005 20H5.09005L9.26005 19.62C9.71685 19.5745 10.1441 19.3732 10.4701 19.05L19.4701 10.05C19.8194 9.68096 20.0082 9.1885 19.995 8.68053C19.9819 8.17256 19.768 7.6905 19.4001 7.34ZM9.08005 17.62L6.08005 17.9L6.35005 14.9L12.0001 9.31999L14.7001 12.02L9.08005 17.62ZM16.0001 10.68L13.3201 8L15.2701 6L18.0001 8.72999L16.0001 10.68Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Fi = (t) => {
	let n = e(7), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 14 : i, c = a === void 0 ? 14 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ h("g", {
		clipPath: "url(#clip0_7796_49103)",
		children: [/* @__PURE__ */ m("path", {
			d: "M11.082 11.6665H2.91536C2.76065 11.6665 2.61228 11.728 2.50289 11.8374C2.39349 11.9468 2.33203 12.0951 2.33203 12.2498C2.33203 12.4045 2.39349 12.5529 2.50289 12.6623C2.61228 12.7717 2.76065 12.8332 2.91536 12.8332H11.082C11.2367 12.8332 11.3851 12.7717 11.4945 12.6623C11.6039 12.5529 11.6654 12.4045 11.6654 12.2498C11.6654 12.0951 11.6039 11.9468 11.4945 11.8374C11.3851 11.728 11.2367 11.6665 11.082 11.6665Z",
			fill: o
		}), /* @__PURE__ */ m("path", {
			d: "M2.91782 10.4998H2.97032L5.40282 10.2782C5.66928 10.2516 5.9185 10.1342 6.10865 9.94567L11.3586 4.69567C11.5624 4.4804 11.6725 4.19313 11.6649 3.89681C11.6572 3.6005 11.5324 3.3193 11.3178 3.11484L9.71948 1.5165C9.51088 1.32056 9.23753 1.20813 8.95143 1.2006C8.66533 1.19307 8.38644 1.29097 8.16782 1.47567L2.91782 6.72567C2.72926 6.91581 2.61186 7.16504 2.58532 7.4315L2.33448 9.864C2.32662 9.94944 2.33771 10.0356 2.36695 10.1162C2.39619 10.1969 2.44287 10.2701 2.50365 10.3307C2.55816 10.3847 2.6228 10.4275 2.69387 10.4565C2.76494 10.4856 2.84105 10.5003 2.91782 10.4998ZM8.90865 2.33317L10.5011 3.92567L9.33448 5.06317L7.77115 3.49984L8.90865 2.33317ZM3.71698 7.53067L7.00115 4.26984L8.57615 5.84484L5.30948 9.1115L3.55948 9.27484L3.71698 7.53067Z",
			fill: o
		})]
	}), n[0] = o, n[1] = l);
	let u;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
		id: "clip0_7796_49103",
		children: /* @__PURE__ */ m("rect", {
			width: "14",
			height: "14",
			fill: "white"
		})
	}) }), n[2] = u) : u = n[2];
	let d;
	return n[3] !== s || n[4] !== l || n[5] !== c ? (d = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 14 14",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[3] = s, n[4] = l, n[5] = c, n[6] = d) : d = n[6], d;
}, Ii = (t) => {
	let n = e(8), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l, u;
	n[0] === o ? (l = n[1], u = n[2]) : (l = /* @__PURE__ */ m("path", {
		d: "M6.09 19H18.09L16.79 20.29C16.6017 20.4783 16.4959 20.7337 16.4959 21C16.4959 21.2663 16.6017 21.5217 16.79 21.71C16.9783 21.8983 17.2337 22.0041 17.5 22.0041C17.7663 22.0041 18.0217 21.8983 18.21 21.71L21.21 18.71C21.3037 18.617 21.3781 18.5064 21.4289 18.3846C21.4797 18.2627 21.5058 18.132 21.5058 18C21.5058 17.868 21.4797 17.7373 21.4289 17.6154C21.3781 17.4936 21.3037 17.383 21.21 17.29L18.21 14.29C18.117 14.1963 18.0064 14.1219 17.8846 14.0711C17.7627 14.0203 17.632 13.9942 17.5 13.9942C17.368 13.9942 17.2373 14.0203 17.1154 14.0711C16.9936 14.1219 16.883 14.1963 16.79 14.29C16.6963 14.383 16.6219 14.4936 16.5711 14.6154C16.5203 14.7373 16.4942 14.868 16.4942 15C16.4942 15.132 16.5203 15.2627 16.5711 15.3846C16.6219 15.5064 16.6963 15.617 16.79 15.71L18.09 17H6.09C5.88513 17.004 5.68148 16.9676 5.49069 16.8928C5.29989 16.8181 5.1257 16.7065 4.97804 16.5644C4.83039 16.4223 4.71218 16.2525 4.63015 16.0647C4.54813 15.877 4.5039 15.6749 4.5 15.47V13C4.5 12.7348 4.39464 12.4804 4.20711 12.2929C4.01957 12.1054 3.76522 12 3.5 12C3.23478 12 2.98043 12.1054 2.79289 12.2929C2.60536 12.4804 2.5 12.7348 2.5 13V15.47C2.50392 15.9375 2.59989 16.3997 2.78244 16.8301C2.96498 17.2605 3.23051 17.6508 3.56388 17.9785C3.89724 18.3063 4.29191 18.5653 4.72534 18.7405C5.15878 18.9158 5.62249 19.004 6.09 19Z",
		fill: o
	}), u = /* @__PURE__ */ m("path", {
		d: "M5.78994 9.71C5.97824 9.8983 6.23364 10.0041 6.49994 10.0041C6.76624 10.0041 7.02164 9.8983 7.20994 9.71C7.39824 9.5217 7.50403 9.2663 7.50403 9C7.50403 8.7337 7.39824 8.4783 7.20994 8.29L5.90994 7H17.9099C18.1148 6.99602 18.3185 7.03245 18.5093 7.10719C18.7 7.18193 18.8742 7.29353 19.0219 7.43561C19.1695 7.5777 19.2878 7.74747 19.3698 7.93525C19.4518 8.12303 19.496 8.32513 19.4999 8.53V11C19.4999 11.2652 19.6053 11.5196 19.7928 11.7071C19.9804 11.8946 20.2347 12 20.4999 12C20.7652 12 21.0195 11.8946 21.207 11.7071C21.3946 11.5196 21.4999 11.2652 21.4999 11V8.53C21.496 8.06249 21.4 7.60033 21.2175 7.16991C21.035 6.73949 20.7694 6.34924 20.4361 6.02145C20.1027 5.69366 19.708 5.43474 19.2746 5.25947C18.8412 5.08421 18.3774 4.99604 17.9099 5H5.90994L7.20994 3.71C7.30367 3.61704 7.37806 3.50644 7.42883 3.38458C7.4796 3.26272 7.50574 3.13201 7.50574 3C7.50574 2.86799 7.4796 2.73728 7.42883 2.61542C7.37806 2.49356 7.30367 2.38296 7.20994 2.29C7.11698 2.19627 7.00637 2.12188 6.88452 2.07111C6.76266 2.02034 6.63195 1.9942 6.49994 1.9942C6.36793 1.9942 6.23722 2.02034 6.11536 2.07111C5.9935 2.12188 5.8829 2.19627 5.78994 2.29L2.78994 5.29C2.69621 5.38296 2.62182 5.49356 2.57105 5.61542C2.52028 5.73728 2.49414 5.86799 2.49414 6C2.49414 6.13201 2.52028 6.26272 2.57105 6.38458C2.62182 6.50644 2.69621 6.61704 2.78994 6.71L5.78994 9.71Z",
		fill: o
	}), n[0] = o, n[1] = l, n[2] = u);
	let d;
	return n[3] !== s || n[4] !== l || n[5] !== u || n[6] !== c ? (d = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[3] = s, n[4] = l, n[5] = u, n[6] = c, n[7] = d) : d = n[7], d;
}, Li = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M4 7.5V16.5L12 21V12M4 7.5L12 3L20 7.5M4 7.5L12 12M20 7.5V12M20 7.5L12 12M22 18H15M15 18L18 15M15 18L18 21",
		stroke: o,
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Ri = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M11.6703 19H11.6103C11.3902 18.9867 11.1807 18.9011 11.0143 18.7564C10.8479 18.6117 10.734 18.4161 10.6903 18.2L9.00032 10L0.800316 8.31C0.583786 8.267 0.387573 8.15355 0.24227 7.98735C0.096968 7.82115 0.0107448 7.61155 -0.00295472 7.39121C-0.0166542 7.17088 0.0429403 6.95221 0.166536 6.76929C0.290132 6.58637 0.470781 6.44949 0.680316 6.38L16.6803 1.05C16.8599 0.975842 17.0572 0.955613 17.2481 0.991786C17.439 1.02796 17.6153 1.11896 17.7553 1.25368C17.8953 1.3884 17.9931 1.56099 18.0366 1.75036C18.0801 1.93973 18.0675 2.13767 18.0003 2.32L12.6703 18.32C12.6007 18.527 12.4653 18.7055 12.2847 18.8283C12.1042 18.9511 11.8884 19.0114 11.6703 19ZM4.87032 7.1L10.0603 8.16C10.2543 8.19742 10.4329 8.29148 10.5735 8.4303C10.7141 8.56912 10.8104 8.74648 10.8503 8.94L11.9003 14.13L15.4203 3.58L4.87032 7.1Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 19 19",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, zi = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18 3.25C18.4142 3.25 18.75 3.58579 18.75 4C18.75 4.33152 18.8817 4.64946 19.1161 4.88388C19.3505 5.1183 19.6685 5.25 20 5.25C20.4142 5.25 20.75 5.58579 20.75 6C20.75 6.41421 20.4142 6.75 20 6.75C19.6685 6.75 19.3505 6.8817 19.1161 7.11612C18.8817 7.35054 18.75 7.66848 18.75 8C18.75 8.41421 18.4142 8.75 18 8.75C17.5858 8.75 17.25 8.41421 17.25 8C17.25 7.66848 17.1183 7.35054 16.8839 7.11612C16.6495 6.8817 16.3315 6.75 16 6.75C15.5858 6.75 15.25 6.41421 15.25 6C15.25 5.58579 15.5858 5.25 16 5.25C16.3315 5.25 16.6495 5.1183 16.8839 4.88388C17.1183 4.64946 17.25 4.33152 17.25 4C17.25 3.58579 17.5858 3.25 18 3.25ZM18 5.88746C17.9818 5.90673 17.9633 5.92576 17.9445 5.94454C17.9258 5.96333 17.9067 5.98182 17.8875 6C17.9067 6.01819 17.9258 6.03667 17.9445 6.05546C17.9633 6.07424 17.9818 6.09327 18 6.11254C18.0182 6.09327 18.0367 6.07424 18.0555 6.05546C18.0742 6.03667 18.0933 6.01819 18.1125 6C18.0933 5.98182 18.0742 5.96333 18.0555 5.94454C18.0367 5.92576 18.0182 5.90673 18 5.88746ZM9 5.25C9.41421 5.25 9.75 5.58579 9.75 6C9.75 7.39239 10.3031 8.72774 11.2877 9.71231C12.2723 10.6969 13.6076 11.25 15 11.25C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75C13.6076 12.75 12.2723 13.3031 11.2877 14.2877C10.3031 15.2723 9.75 16.6076 9.75 18C9.75 18.4142 9.41421 18.75 9 18.75C8.58579 18.75 8.25 18.4142 8.25 18C8.25 16.6076 7.69688 15.2723 6.71231 14.2877C5.72774 13.3031 4.39239 12.75 3 12.75C2.58579 12.75 2.25 12.4142 2.25 12C2.25 11.5858 2.58579 11.25 3 11.25C4.39239 11.25 5.72774 10.6969 6.71231 9.71231C7.69688 8.72774 8.25 7.39239 8.25 6C8.25 5.58579 8.58579 5.25 9 5.25ZM9 9.09234C8.68321 9.70704 8.27103 10.2749 7.77297 10.773C7.27491 11.271 6.70704 11.6832 6.09234 12C6.70704 12.3168 7.27491 12.729 7.77297 13.227C8.27103 13.7251 8.68321 14.293 9 14.9077C9.31679 14.293 9.72897 13.7251 10.227 13.227C10.7251 12.729 11.293 12.3168 11.9077 12C11.293 11.6832 10.7251 11.271 10.227 10.773C9.72897 10.2749 9.31679 9.70704 9 9.09234ZM18 15.25C18.4142 15.25 18.75 15.5858 18.75 16C18.75 16.3315 18.8817 16.6495 19.1161 16.8839C19.3505 17.1183 19.6685 17.25 20 17.25C20.4142 17.25 20.75 17.5858 20.75 18C20.75 18.4142 20.4142 18.75 20 18.75C19.6685 18.75 19.3505 18.8817 19.1161 19.1161C18.8817 19.3505 18.75 19.6685 18.75 20C18.75 20.4142 18.4142 20.75 18 20.75C17.5858 20.75 17.25 20.4142 17.25 20C17.25 19.6685 17.1183 19.3505 16.8839 19.1161C16.6495 18.8817 16.3315 18.75 16 18.75C15.5858 18.75 15.25 18.4142 15.25 18C15.25 17.5858 15.5858 17.25 16 17.25C16.3315 17.25 16.6495 17.1183 16.8839 16.8839C17.1183 16.6495 17.25 16.3315 17.25 16C17.25 15.5858 17.5858 15.25 18 15.25ZM18 17.8875C17.9818 17.9067 17.9633 17.9258 17.9445 17.9445C17.9258 17.9633 17.9067 17.9818 17.8875 18C17.9067 18.0182 17.9258 18.0367 17.9445 18.0555C17.9633 18.0742 17.9818 18.0933 18 18.1125C18.0182 18.0933 18.0367 18.0742 18.0555 18.0555C18.0742 18.0367 18.0933 18.0182 18.1125 18C18.0933 17.9818 18.0742 17.9633 18.0555 17.9445C18.0367 17.9258 18.0182 17.9067 18 17.8875Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Bi = (t) => {
	let n = e(9), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (l = { flexShrink: 0 }, n[0] = l) : l = n[0];
	let u, d;
	n[1] === o ? (u = n[2], d = n[3]) : (u = /* @__PURE__ */ m("path", {
		d: "M9.71019 11.29C9.52188 11.1017 9.26649 10.9959 9.00019 10.9959C8.73388 10.9959 8.47849 11.1017 8.29019 11.29C8.10188 11.4783 7.99609 11.7337 7.99609 12C7.99609 12.2663 8.10188 12.5217 8.29019 12.71L11.2902 15.71C11.3836 15.8027 11.4944 15.876 11.6163 15.9258C11.7381 15.9755 11.8686 16.0008 12.0002 16C12.1371 15.9957 12.2716 15.9632 12.3955 15.9047C12.5193 15.8463 12.6299 15.763 12.7202 15.66L19.7202 7.65999C19.8818 7.45932 19.9597 7.204 19.9377 6.94728C19.9157 6.69055 19.7955 6.45223 19.602 6.282C19.4086 6.11178 19.1569 6.02279 18.8995 6.0336C18.642 6.0444 18.3987 6.15416 18.2202 6.33999L12.0002 13.54L9.71019 11.29Z",
		fill: o
	}), d = /* @__PURE__ */ m("path", {
		d: "M20.9998 11C20.7346 11 20.4802 11.1054 20.2927 11.2929C20.1052 11.4804 19.9998 11.7348 19.9998 12C19.9998 14.1217 19.157 16.1566 17.6567 17.6569C16.1564 19.1571 14.1215 20 11.9998 20C10.4199 19.9993 8.87558 19.5308 7.56158 18.6535C6.24757 17.7763 5.22274 16.5297 4.61629 15.0708C4.00985 13.6119 3.84896 12.0061 4.1539 10.4559C4.45885 8.90569 5.21597 7.48048 6.32981 6.36C7.07052 5.60938 7.95349 5.01404 8.92707 4.60881C9.90065 4.20358 10.9453 3.99661 11.9998 4C12.6393 4.004 13.2764 4.07777 13.8998 4.22C14.0303 4.26035 14.1676 4.27356 14.3034 4.2588C14.4392 4.24404 14.5705 4.20163 14.6892 4.13418C14.808 4.06673 14.9116 3.97567 14.9938 3.86662C15.076 3.75757 15.135 3.63284 15.1672 3.50011C15.1994 3.36739 15.204 3.22948 15.1808 3.0949C15.1576 2.96032 15.1071 2.83191 15.0324 2.71759C14.9577 2.60327 14.8604 2.50547 14.7464 2.43021C14.6324 2.35495 14.5043 2.30383 14.3698 2.28C13.593 2.09724 12.7979 2.00331 11.9998 2C10.0242 2.01026 8.0958 2.60552 6.45811 3.71065C4.82042 4.81578 3.54678 6.38126 2.79793 8.20953C2.04908 10.0378 1.85857 12.0469 2.25045 13.9834C2.64232 15.9198 3.59902 17.6968 4.99981 19.09C6.8565 20.9475 9.37347 21.9939 11.9998 22C14.652 22 17.1955 20.9464 19.0709 19.0711C20.9462 17.1957 21.9998 14.6522 21.9998 12C21.9998 11.7348 21.8945 11.4804 21.7069 11.2929C21.5194 11.1054 21.265 11 20.9998 11Z",
		fill: o
	}), n[1] = o, n[2] = u, n[3] = d);
	let f;
	return n[4] !== s || n[5] !== u || n[6] !== d || n[7] !== c ? (f = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: l,
		children: [u, d]
	}), n[4] = s, n[5] = u, n[6] = d, n[7] = c, n[8] = f) : f = n[8], f;
}, Vi = () => {
	let t = e(3), n;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", {
		d: "M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z",
		fill: "#F2FFE5"
	}), t[0] = n) : n = t[0];
	let r;
	t[1] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ h("g", {
		clipPath: "url(#clip0_8601_42302)",
		children: [/* @__PURE__ */ m("path", {
			d: "M32.1849 34.8168C31.8711 34.503 31.4454 34.3267 31.0016 34.3267C30.5578 34.3267 30.1321 34.503 29.8183 34.8168C29.5044 35.1307 29.3281 35.5563 29.3281 36.0002C29.3281 36.444 29.5044 36.8696 29.8183 37.1835L34.8183 42.1835C34.974 42.338 35.1587 42.4602 35.3618 42.5431C35.5648 42.626 35.7823 42.6681 36.0016 42.6668C36.2298 42.6596 36.454 42.6055 36.6604 42.5081C36.8669 42.4106 37.0511 42.2717 37.2016 42.1002L48.8683 28.7668C49.1377 28.4324 49.2675 28.0068 49.2309 27.579C49.1942 27.1511 48.9937 26.7539 48.6713 26.4702C48.3489 26.1865 47.9295 26.0381 47.5004 26.0562C47.0713 26.0742 46.6658 26.2571 46.3683 26.5668L36.0016 38.5668L32.1849 34.8168Z",
			fill: "#54CF09"
		}), /* @__PURE__ */ m("path", {
			d: "M50.9981 34.3335C50.556 34.3335 50.1321 34.5091 49.8195 34.8217C49.507 35.1342 49.3314 35.5581 49.3314 36.0002C49.3314 39.5364 47.9266 42.9278 45.4262 45.4283C42.9257 47.9287 39.5343 49.3335 35.9981 49.3335C33.3649 49.3323 30.791 48.5514 28.601 47.0894C26.411 45.6274 24.7029 43.5496 23.6922 41.1181C22.6815 38.6866 22.4133 36.0103 22.9215 33.4266C23.4298 30.843 24.6917 28.4676 26.5481 26.6002C27.7826 25.3491 29.2542 24.3569 30.8768 23.6815C32.4995 23.0061 34.2405 22.6612 35.9981 22.6668C37.0638 22.6735 38.1257 22.7965 39.1647 23.0335C39.3822 23.1008 39.6111 23.1228 39.8374 23.0982C40.0636 23.0736 40.2825 23.0029 40.4804 22.8905C40.6783 22.778 40.8511 22.6263 40.9881 22.4445C41.1251 22.2628 41.2234 22.0549 41.277 21.8337C41.3306 21.6125 41.3383 21.3826 41.2997 21.1583C41.2611 20.934 41.1769 20.72 41.0524 20.5295C40.9279 20.339 40.7656 20.1759 40.5757 20.0505C40.3858 19.9251 40.1722 19.8399 39.9481 19.8002C38.6533 19.4956 37.3281 19.339 35.9981 19.3335C32.7053 19.3506 29.4914 20.3427 26.7619 22.1846C24.0324 24.0265 21.9097 26.6356 20.6616 29.6827C19.4135 32.7298 19.096 36.0784 19.7491 39.3058C20.4022 42.5331 21.9967 45.4948 24.3314 47.8168C27.4259 50.9127 31.6208 52.6566 35.9981 52.6668C40.4183 52.6668 44.6576 50.9109 47.7832 47.7853C50.9088 44.6597 52.6647 40.4204 52.6647 36.0002C52.6647 35.5581 52.4891 35.1342 52.1766 34.8217C51.864 34.5091 51.4401 34.3335 50.9981 34.3335Z",
			fill: "#54CF09"
		})]
	}), t[1] = r) : r = t[1];
	let i;
	return t[2] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ h("svg", {
		width: "72",
		height: "72",
		viewBox: "0 0 72 72",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			n,
			r,
			/* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
				id: "clip0_8601_42302",
				children: /* @__PURE__ */ m("rect", {
					width: "40",
					height: "40",
					fill: "white",
					transform: "translate(16 16)"
				})
			}) })
		]
	}), t[2] = i) : i = t[2], i;
}, Hi = (e, t, n) => {
	if (n) return n;
	if (t) return e === g.XPartner ? "var(--text-white)" : "var(--text-black)";
	switch (e) {
		case g.Bronze: return "var(--partnership-color-bronze)";
		case g.Silver: return "var(--partnership-color-silver)";
		case g.Gold: return "var(--partnership-color-gold)";
		case g.Platinum: return "var(--partnership-color-platinum)";
		case g.XPartner: return "var(--partnership-color-x-white)";
		default: throw Error("Invalid partnership level");
	}
}, Ui = (t) => {
	let n = e(60), { partnershipLevel: r, height: i, width: a, useBasicColours: o, color: s } = t, c = i === void 0 ? 24 : i, l = a === void 0 ? 24 : a, u;
	n[0] !== s || n[1] !== r || n[2] !== o ? (u = Hi(r, o, s), n[0] = s, n[1] = r, n[2] = o, n[3] = u) : u = n[3];
	let d = u, f, _, v, y, b, x, S, C, w, T, E, D, O, k, A, j, M, N;
	n[4] === d ? (f = n[5], _ = n[6], v = n[7], y = n[8], b = n[9], x = n[10], S = n[11], C = n[12], w = n[13], T = n[14], E = n[15], D = n[16], O = n[17], k = n[18], A = n[19], j = n[20], M = n[21], N = n[22]) : (D = /* @__PURE__ */ m("path", {
		d: "M3.31008 11.9826C3.61022 12.3133 3.84141 12.7225 4.02393 13.045C4.04421 13.0863 4.06449 13.1276 4.08477 13.1648C4.10505 13.202 4.12533 13.2392 4.14155 13.2723C4.17806 13.3385 4.2105 13.4005 4.23484 13.4542C4.28351 13.5575 4.31596 13.6195 4.31596 13.6195C4.31596 13.6195 4.27134 13.6319 4.19428 13.6443C4.11722 13.6567 4.00771 13.6691 3.87386 13.665C3.61428 13.6485 3.24924 13.5617 2.90448 13.2434C2.55972 12.921 2.3042 12.4291 2.17035 12.0116C2.13385 11.9082 2.10951 11.809 2.08518 11.7181C2.0649 11.6272 2.04462 11.5486 2.03245 11.4825C2.00811 11.3461 2 11.2634 2 11.2634C2 11.2634 2.04462 11.2634 2.12168 11.2799C2.19874 11.2965 2.30825 11.3254 2.43399 11.3709C2.55567 11.4205 2.70574 11.4907 2.85581 11.5941C2.92882 11.6437 3.00588 11.7016 3.07889 11.7677C3.15595 11.8297 3.23302 11.9041 3.31008 11.9868V11.9826Z",
		fill: d
	}), O = /* @__PURE__ */ m("path", {
		d: "M4.34834 14.657C4.40107 14.686 4.44974 14.719 4.50247 14.748C4.55519 14.781 4.60386 14.8141 4.65254 14.8472C4.74988 14.9175 4.84317 14.9919 4.93645 15.0621C4.98107 15.0993 5.02569 15.1365 5.0703 15.1737C5.09058 15.1944 5.11492 15.2109 5.1352 15.2316C5.15953 15.2481 5.17981 15.2688 5.20009 15.2853C5.28527 15.3597 5.36233 15.43 5.43534 15.4962C5.58541 15.6284 5.70303 15.7524 5.79226 15.8351C5.88149 15.9178 5.93017 15.9756 5.93017 15.9756C5.93017 15.9756 5.88961 16.0046 5.8166 16.0459C5.74359 16.0873 5.63408 16.1369 5.49618 16.1782C5.35827 16.2195 5.18792 16.2485 4.99729 16.2402C4.80666 16.2319 4.58358 16.1906 4.35645 16.0873C3.89001 15.8764 3.46414 15.4507 3.18833 15.0704C3.11532 14.9753 3.05854 14.8802 3.00581 14.7976C2.95308 14.7108 2.90441 14.6364 2.87196 14.5702C2.80301 14.438 2.76651 14.3594 2.76651 14.3594C2.76651 14.3594 2.81518 14.347 2.90036 14.3346C2.98553 14.3264 3.10721 14.314 3.24917 14.3264C3.32218 14.3264 3.39924 14.3388 3.48442 14.3512C3.56959 14.3636 3.65882 14.3842 3.75211 14.409C3.8454 14.4338 3.94274 14.4669 4.04008 14.5124C4.14148 14.5537 4.24288 14.6033 4.34834 14.6612V14.657Z",
		fill: d
	}), k = /* @__PURE__ */ m("path", {
		d: "M6.1574 16.8767C6.41293 16.9263 6.66034 17.0048 6.89964 17.0834C7.01727 17.1288 7.13489 17.1702 7.2444 17.2115C7.30118 17.2322 7.35391 17.257 7.40664 17.2776C7.45937 17.2983 7.51209 17.319 7.56077 17.3355C7.75545 17.4182 7.9258 17.4843 8.04748 17.5422C8.10427 17.5711 8.15699 17.5877 8.18944 17.6042C8.22189 17.6166 8.23811 17.6249 8.23811 17.6249C8.23811 17.6249 8.20972 17.6703 8.15294 17.7406C8.09615 17.8109 8.00692 17.906 7.88119 18.001C7.75951 18.092 7.60133 18.187 7.40258 18.2532C7.30118 18.2904 7.19167 18.311 7.07405 18.3276C6.95643 18.34 6.82258 18.3482 6.68468 18.3358C6.54677 18.3234 6.40481 18.2986 6.26285 18.2614C6.12495 18.2201 5.98299 18.1705 5.84915 18.1168C5.7153 18.0548 5.58551 17.9886 5.45977 17.9184C5.33809 17.8481 5.22453 17.7695 5.11907 17.6951C5.09068 17.6786 5.06634 17.6579 5.04201 17.6414C5.01767 17.6207 4.99334 17.6042 4.969 17.5835C4.92033 17.5463 4.87977 17.5091 4.83515 17.4761C4.74998 17.4058 4.67697 17.3438 4.62019 17.2859C4.50662 17.1743 4.44172 17.104 4.44172 17.104C4.44172 17.104 4.48634 17.0751 4.57152 17.0338C4.65263 16.9966 4.77431 16.947 4.92844 16.9056C5.0055 16.885 5.08662 16.8684 5.17991 16.856C5.2732 16.8395 5.37054 16.8312 5.47194 16.8271C5.5774 16.823 5.68691 16.8271 5.80047 16.8312C5.9181 16.8395 6.03978 16.8519 6.16551 16.8767H6.1574Z",
		fill: d
	}), A = /* @__PURE__ */ m("path", {
		d: "M8.61936 18.3606C8.75726 18.3317 8.89516 18.3152 9.03307 18.3028C9.17097 18.2862 9.30887 18.2738 9.44272 18.2697C9.57657 18.2573 9.71041 18.2532 9.83615 18.2532C9.96188 18.2449 10.0836 18.2408 10.1971 18.2408C10.4243 18.2284 10.619 18.2325 10.7569 18.2242C10.8948 18.2242 10.9799 18.2242 10.9799 18.2242C10.9799 18.2242 10.9718 18.2821 10.9475 18.3772C10.9191 18.4723 10.8745 18.6004 10.7934 18.7492C10.7528 18.8236 10.7041 18.9021 10.6433 18.9807C10.6149 19.022 10.5784 19.0592 10.5459 19.1006C10.5094 19.1378 10.4729 19.175 10.4283 19.2163C10.3431 19.2907 10.2458 19.3651 10.1322 19.4312C10.0187 19.4974 9.88888 19.5511 9.74286 19.6007C9.59685 19.6503 9.44272 19.6793 9.28048 19.6999C9.11824 19.7247 8.956 19.7247 8.79377 19.7206C8.63153 19.7206 8.46929 19.6999 8.31516 19.6751C8.15698 19.6545 8.01096 19.6173 7.87306 19.5801C7.80411 19.5635 7.73516 19.5429 7.67432 19.5222C7.61348 19.5015 7.55264 19.4808 7.49585 19.4602C7.38229 19.4188 7.28089 19.3816 7.19977 19.3444C7.03753 19.27 6.94424 19.2204 6.94424 19.2204C6.94424 19.2204 6.98075 19.175 7.0497 19.1047C7.11865 19.0344 7.22816 18.9435 7.37012 18.8484C7.51208 18.7575 7.69054 18.6541 7.8974 18.5673C8.10425 18.4847 8.34761 18.4061 8.61936 18.3606Z",
		fill: d
	}), j = /* @__PURE__ */ m("path", {
		d: "M3.96306 9.20065C3.72781 9.5024 3.60208 9.91989 3.56557 10.2547C3.55746 10.3374 3.5453 10.4201 3.5453 10.4903C3.5453 10.5606 3.5453 10.6267 3.5453 10.6763C3.5453 10.7838 3.55337 10.8458 3.55337 10.8458C3.55337 10.8458 3.59397 10.8375 3.66292 10.8086C3.73187 10.7838 3.82516 10.7425 3.92656 10.6805C4.03201 10.6185 4.14558 10.5399 4.25915 10.4407C4.37271 10.3374 4.49034 10.2175 4.58768 10.0687C4.79048 9.77522 4.91216 9.43213 5.00139 9.15518C5.02167 9.08491 5.04195 9.02291 5.05817 8.96504C5.0744 8.90717 5.08656 8.85343 5.09468 8.81209C5.11496 8.72529 5.12712 8.67155 5.12712 8.67155C5.12712 8.67155 4.96083 8.65915 4.72964 8.71289C4.61202 8.74182 4.48628 8.78729 4.35243 8.8617C4.21859 8.9361 4.0888 9.04357 3.96712 9.19652L3.96306 9.20065Z",
		fill: d
	}), M = /* @__PURE__ */ m("path", {
		d: "M4.16183 11.7882C4.01987 12.1809 4.0442 12.6522 4.12532 13.0118C4.13343 13.0573 4.1456 13.1027 4.15371 13.1441C4.16588 13.1854 4.17805 13.2226 4.18616 13.2598C4.2105 13.3342 4.23078 13.4003 4.25106 13.4541C4.27134 13.5078 4.28756 13.5491 4.29973 13.5781C4.3119 13.607 4.32001 13.6236 4.32001 13.6236C4.32001 13.6236 4.35651 13.5988 4.41735 13.5491C4.47819 13.4995 4.55526 13.421 4.64043 13.3218C4.81484 13.1193 5.00141 12.8258 5.10687 12.4496C5.21232 12.0735 5.21638 11.6849 5.21232 11.3832C5.21232 11.3088 5.21232 11.2385 5.20827 11.1723C5.20827 11.1103 5.20015 11.0566 5.1961 11.007C5.1961 10.9161 5.18393 10.8582 5.18393 10.8582C5.18393 10.8582 5.13932 10.8706 5.06631 10.8954C4.9933 10.9202 4.89596 10.9657 4.78239 11.0318C4.66882 11.0979 4.55526 11.1889 4.44169 11.3129C4.3849 11.3749 4.33218 11.441 4.28351 11.5237C4.23483 11.6022 4.19427 11.689 4.16183 11.7882Z",
		fill: d
	}), N = /* @__PURE__ */ m("path", {
		d: "M5.15559 14.1651C5.15559 14.223 5.15559 14.2809 5.15559 14.3346C5.15964 14.3925 5.16775 14.4462 5.17587 14.5041C5.19209 14.6157 5.22048 14.7314 5.25699 14.8389C5.27321 14.8926 5.29349 14.9464 5.31377 15.0001C5.32594 15.0249 5.33405 15.0539 5.34622 15.0787C5.35839 15.1035 5.37055 15.1283 5.37867 15.1531C5.42328 15.2523 5.47195 15.3432 5.52062 15.43C5.62608 15.5954 5.72342 15.74 5.80454 15.831C5.88161 15.926 5.93433 15.9798 5.93433 15.9798C5.93433 15.9798 5.96678 15.9384 6.00734 15.8682C6.05196 15.7938 6.10468 15.6863 6.15741 15.554C6.21014 15.4217 6.25881 15.2647 6.29531 15.0869C6.33182 14.9092 6.34804 14.719 6.33993 14.5082C6.32371 14.0907 6.20203 13.6939 6.10063 13.388C6.07224 13.3136 6.05196 13.2392 6.02762 13.1772C6.00328 13.1152 5.97895 13.0615 5.96273 13.0119C5.92622 12.9209 5.90189 12.8672 5.90189 12.8672C5.90189 12.8672 5.86133 12.892 5.79237 12.9457C5.72342 12.9995 5.63825 13.0739 5.54496 13.1813C5.50034 13.2351 5.45167 13.2929 5.40706 13.3591C5.36244 13.4252 5.32188 13.4996 5.28538 13.5823C5.24887 13.665 5.21643 13.7559 5.19209 13.851C5.17181 13.9461 5.15559 14.0494 5.15153 14.1651H5.15559Z",
		fill: d
	}), f = /* @__PURE__ */ m("path", {
		d: "M6.8145 16.0955C6.87939 16.3229 6.99702 16.5461 7.14303 16.7362C7.21198 16.8354 7.2931 16.9222 7.37422 17.0049C7.41478 17.0462 7.45534 17.0876 7.4959 17.1248C7.53646 17.162 7.58108 17.1951 7.62164 17.2281C7.78387 17.3645 7.938 17.4596 8.05157 17.5257C8.10835 17.5588 8.15702 17.5836 8.18542 17.596C8.21381 17.6084 8.23409 17.6208 8.23409 17.6208C8.23409 17.6208 8.25031 17.5712 8.26248 17.4803C8.2787 17.3893 8.29493 17.2612 8.29493 17.1083C8.29898 16.9553 8.29493 16.7734 8.26248 16.5874C8.24625 16.4965 8.23003 16.3973 8.2057 16.2939C8.18136 16.1947 8.14891 16.0955 8.10835 15.9922C7.95017 15.5871 7.71492 15.2399 7.51618 14.9712C7.50401 14.9547 7.49184 14.9381 7.47968 14.9216C7.46751 14.9051 7.45534 14.8885 7.44723 14.872C7.42289 14.8431 7.40261 14.8141 7.38233 14.7852C7.33772 14.7314 7.29716 14.686 7.26877 14.6446C7.20387 14.5661 7.16331 14.5206 7.16331 14.5206C7.16331 14.5206 7.12681 14.562 7.07814 14.6364C7.02946 14.7108 6.96051 14.8182 6.89967 14.9588C6.87128 15.0291 6.83883 15.1035 6.8145 15.1861C6.79016 15.2688 6.77394 15.3556 6.76177 15.4507C6.7496 15.5458 6.74555 15.6491 6.75366 15.7566C6.76177 15.8599 6.78205 15.9715 6.8145 16.0873V16.0955Z",
		fill: d
	}), _ = /* @__PURE__ */ m("path", {
		d: "M8.97624 17.3272C9.04925 17.4264 9.13848 17.5174 9.23176 17.6083C9.32911 17.6869 9.43456 17.7654 9.54002 17.8315C9.64953 17.8935 9.7631 17.9514 9.87666 18.001C9.99023 18.0465 10.1038 18.0837 10.2093 18.1168C10.4242 18.1705 10.6189 18.2077 10.7568 18.216C10.8947 18.2284 10.9799 18.2284 10.9799 18.2284C10.9799 18.2284 10.9718 18.1705 10.9474 18.0754C10.9231 17.9803 10.8825 17.8481 10.8217 17.6951C10.7893 17.6207 10.7568 17.5381 10.7122 17.4554C10.6919 17.414 10.6716 17.3727 10.6473 17.3314C10.623 17.29 10.5986 17.2446 10.5743 17.1991C10.5216 17.1123 10.4648 17.0255 10.3999 16.9387C10.335 16.856 10.2701 16.7651 10.193 16.6824C9.89289 16.3517 9.55219 16.112 9.27638 15.926C9.24393 15.9053 9.20743 15.8846 9.17498 15.864C9.14253 15.8433 9.11414 15.8226 9.08575 15.8061C9.02896 15.7689 8.97624 15.7399 8.93162 15.711C8.84645 15.6573 8.79372 15.6325 8.79372 15.6325C8.79372 15.6325 8.77344 15.6862 8.74505 15.7771C8.72071 15.8681 8.68826 16.0004 8.67204 16.1616C8.65582 16.3228 8.65987 16.5047 8.70043 16.7031C8.74099 16.9056 8.82617 17.1082 8.97218 17.3148L8.97624 17.3272Z",
		fill: d
	}), v = /* @__PURE__ */ m("path", {
		d: "M20.0046 9.21318C20.2398 9.51079 20.3615 9.92002 20.4021 10.2507C20.4102 10.3334 20.4223 10.4119 20.4223 10.4822C20.4223 10.5525 20.4223 10.6145 20.4223 10.6682C20.4223 10.7715 20.4142 10.8335 20.4142 10.8335C20.4142 10.8335 20.3737 10.8253 20.3047 10.7963C20.2358 10.7715 20.1425 10.7302 20.0411 10.6723C19.9356 10.6145 19.8221 10.5359 19.7085 10.4367C19.5909 10.3375 19.4773 10.2176 19.38 10.073C19.1772 9.78361 19.0555 9.44879 18.9703 9.17597C18.95 9.10984 18.9297 9.0437 18.9135 8.98583C18.8973 8.92796 18.8851 8.87836 18.877 8.83289C18.8567 8.74608 18.8446 8.69648 18.8446 8.69648C18.8446 8.69648 19.0109 8.67994 19.2421 8.73368C19.3597 8.75848 19.4895 8.80395 19.6193 8.88249C19.7531 8.95689 19.8829 9.06437 20.0046 9.20904V9.21318Z",
		fill: d
	}), y = /* @__PURE__ */ m("path", {
		d: "M19.8423 11.7678C19.9843 12.1563 19.964 12.6234 19.8829 12.9789C19.8748 13.0244 19.8667 13.0657 19.8545 13.107C19.8423 13.1484 19.8302 13.1856 19.8221 13.2228C19.8018 13.2972 19.7774 13.3592 19.7612 13.4129C19.745 13.4667 19.7247 13.508 19.7126 13.5369C19.7004 13.5659 19.6923 13.5824 19.6923 13.5824C19.6923 13.5824 19.6558 13.5576 19.5949 13.508C19.5341 13.4584 19.457 13.384 19.3718 13.2806C19.1974 13.0781 19.0109 12.7887 18.9054 12.4167C18.8 12.0447 18.7959 11.6603 18.7959 11.3627C18.7959 11.2883 18.7959 11.218 18.8 11.156C18.8 11.094 18.8081 11.0402 18.8121 10.9948C18.8162 10.9038 18.8243 10.8501 18.8243 10.8501C18.8243 10.8501 18.8689 10.8584 18.9419 10.8873C19.0149 10.9162 19.1123 10.9576 19.2258 11.0196C19.3394 11.0857 19.453 11.1767 19.5665 11.2965C19.6233 11.3585 19.676 11.4247 19.7247 11.5032C19.7693 11.5817 19.814 11.6685 19.8505 11.7636L19.8423 11.7678Z",
		fill: d
	}), b = /* @__PURE__ */ m("path", {
		d: "M18.8811 14.1364C18.8811 14.1901 18.8811 14.248 18.8811 14.3058C18.877 14.3637 18.8689 14.4174 18.8608 14.4753C18.8446 14.5869 18.8202 14.7027 18.7837 14.806C18.7675 14.8597 18.7472 14.9135 18.7269 14.9631C18.7188 14.9879 18.7067 15.0168 18.6986 15.0416C18.6864 15.0664 18.6742 15.0912 18.6661 15.116C18.6215 15.2152 18.5728 15.3062 18.5241 15.393C18.4187 15.5583 18.3254 15.703 18.2443 15.7939C18.1672 15.889 18.1185 15.9386 18.1185 15.9386C18.1185 15.9386 18.0861 15.9014 18.0455 15.827C18.0009 15.7526 17.9441 15.6492 17.8914 15.517C17.8387 15.3847 17.79 15.2276 17.7535 15.0499C17.717 14.8721 17.7008 14.682 17.7048 14.4712C17.7211 14.0578 17.8387 13.6651 17.9401 13.3592C17.9685 13.2848 17.9888 13.2146 18.0131 13.1526C18.0374 13.0906 18.0618 13.0368 18.078 12.9914C18.1145 12.9004 18.1388 12.8467 18.1388 12.8467C18.1388 12.8467 18.1794 12.8715 18.2483 12.9211C18.3132 12.9707 18.4025 13.0492 18.4958 13.1567C18.5404 13.2104 18.589 13.2683 18.6337 13.3344C18.6783 13.4006 18.7188 13.475 18.7553 13.5577C18.7918 13.6403 18.8243 13.7271 18.8486 13.8263C18.873 13.9214 18.8851 14.0247 18.8892 14.1364H18.8811Z",
		fill: d
	}), x = /* @__PURE__ */ m("path", {
		d: "M17.2546 16.0749C17.1897 16.3022 17.0721 16.5254 16.9261 16.7156C16.8571 16.8148 16.776 16.9016 16.6949 16.9842C16.6543 17.0256 16.6137 17.0669 16.5732 17.1041C16.5326 17.1413 16.4921 17.1744 16.4515 17.2075C16.2933 17.3439 16.1351 17.4348 16.0216 17.5051C15.9648 17.5381 15.9202 17.5588 15.8877 17.5754C15.8553 17.5919 15.8391 17.6002 15.8391 17.6002C15.8391 17.6002 15.8228 17.5505 15.8107 17.4596C15.7944 17.3687 15.7782 17.2405 15.7782 17.0876C15.7742 16.9305 15.7782 16.7528 15.8107 16.5668C15.8269 16.4758 15.8431 16.3766 15.8674 16.2733C15.8918 16.1741 15.9242 16.0749 15.9607 15.9715C16.1149 15.5706 16.3542 15.2192 16.5489 14.9505C16.561 14.934 16.5732 14.9175 16.5854 14.9009C16.5975 14.8844 16.6097 14.8679 16.6178 14.8513C16.6421 14.8224 16.6624 14.7935 16.6827 14.7645C16.7233 14.7108 16.7638 14.6653 16.7963 14.624C16.8612 14.5454 16.9017 14.5 16.9017 14.5C16.9017 14.5 16.9382 14.5413 16.9869 14.6157C17.0356 14.6901 17.1045 14.7976 17.1654 14.934C17.1978 15.0043 17.2262 15.0787 17.2505 15.1613C17.2749 15.244 17.2952 15.3308 17.3033 15.4259C17.3154 15.521 17.3195 15.6243 17.3114 15.7318C17.3033 15.8351 17.283 15.9467 17.2546 16.0625V16.0749Z",
		fill: d
	}), S = /* @__PURE__ */ m("path", {
		d: "M15.109 17.3275C15.036 17.4267 14.9467 17.5176 14.8534 17.6086C14.7561 17.6871 14.6506 17.7656 14.5452 17.8318C14.4357 17.8938 14.3221 17.9516 14.2085 18.0012C14.095 18.0467 13.9814 18.0839 13.876 18.117C13.661 18.1707 13.4704 18.2079 13.3284 18.2162C13.1905 18.2286 13.1053 18.2286 13.1053 18.2286C13.1053 18.2286 13.1134 18.1707 13.1378 18.0757C13.1621 17.9806 13.2027 17.8483 13.2635 17.6954C13.2959 17.621 13.3284 17.5383 13.373 17.4556C13.3933 17.4143 13.4136 17.3729 13.4379 17.3316C13.4622 17.2903 13.4866 17.2448 13.5109 17.1993C13.5636 17.1125 13.6204 17.0257 13.6853 16.9389C13.7502 16.8562 13.8151 16.7653 13.8922 16.6826C14.1923 16.3519 14.5371 16.1122 14.8088 15.9262C14.8413 15.9055 14.8778 15.8849 14.9102 15.8642C14.9427 15.8435 14.9711 15.8229 14.9995 15.8063C15.0562 15.7691 15.109 15.7402 15.1536 15.7112C15.2388 15.6575 15.2915 15.6327 15.2915 15.6327C15.2915 15.6327 15.3118 15.6864 15.3402 15.7774C15.3685 15.8683 15.3969 16.0006 15.4132 16.1618C15.4294 16.323 15.4253 16.5049 15.3848 16.7033C15.3442 16.9059 15.259 17.1084 15.113 17.3151L15.109 17.3275Z",
		fill: d
	}), C = /* @__PURE__ */ m("path", {
		d: "M20.6899 11.9621C20.3897 12.2886 20.1626 12.6937 19.9801 13.012C19.9598 13.0534 19.9395 13.0906 19.9193 13.1278C19.899 13.165 19.8787 13.2022 19.8625 13.2352C19.826 13.3014 19.7976 13.3634 19.7692 13.413C19.7205 13.5163 19.6881 13.5742 19.6881 13.5742C19.6881 13.5742 19.7327 13.5907 19.8097 13.6031C19.8868 13.6155 19.9963 13.6279 20.1302 13.6238C20.3897 13.6073 20.7548 13.5246 21.0995 13.2063C21.4443 12.888 21.6958 12.4003 21.8296 11.9869C21.8661 11.8836 21.8905 11.7844 21.9148 11.6975C21.9351 11.6066 21.9554 11.5281 21.9675 11.4619C21.9919 11.3297 22 11.247 22 11.247C22 11.247 21.9553 11.247 21.8783 11.2635C21.8012 11.2801 21.6917 11.3049 21.566 11.3545C21.4443 11.4041 21.2942 11.4743 21.1482 11.5735C21.0752 11.6231 20.9981 11.681 20.9251 11.743C20.8481 11.805 20.771 11.8794 20.698 11.9621H20.6899Z",
		fill: d
	}), w = /* @__PURE__ */ m("path", {
		d: "M19.6881 14.6281C19.6353 14.6571 19.5867 14.6901 19.5339 14.7191C19.4812 14.7522 19.4325 14.7852 19.3839 14.8183C19.2865 14.8886 19.1932 14.9588 19.0999 15.0332C19.0553 15.0704 19.0107 15.1076 18.9661 15.1448C18.9458 15.1655 18.9215 15.182 18.9012 15.2027C18.8809 15.2192 18.8566 15.2399 18.8363 15.2565C18.7511 15.3267 18.6741 15.4011 18.6011 15.4673C18.451 15.5954 18.3334 15.7194 18.2441 15.8021C18.1549 15.8889 18.1062 15.9385 18.1062 15.9385C18.1062 15.9385 18.1468 15.9674 18.2198 16.0088C18.2928 16.0501 18.4023 16.0997 18.5402 16.141C18.6781 16.1824 18.8485 16.2154 19.0391 16.2072C19.2297 16.1989 19.4488 16.1617 19.6799 16.0542C20.1464 15.8476 20.5682 15.4259 20.844 15.0456C20.913 14.9506 20.9738 14.8555 21.0265 14.7728C21.0793 14.6901 21.1279 14.6157 21.1604 14.5496C21.2293 14.4215 21.2658 14.3388 21.2658 14.3388C21.2658 14.3388 21.2172 14.3264 21.132 14.314C21.0468 14.3016 20.9292 14.2933 20.7832 14.3016C20.7102 14.3016 20.6331 14.314 20.5479 14.3264C20.4628 14.3388 20.3735 14.3595 20.2802 14.3843C20.1869 14.4091 20.0896 14.4421 19.9923 14.4835C19.8909 14.5207 19.7895 14.5703 19.6881 14.6281Z",
		fill: d
	}), T = /* @__PURE__ */ m("path", {
		d: "M17.9075 16.8562C17.656 16.9017 17.4046 16.9802 17.1693 17.0629C17.0517 17.1084 16.9341 17.1456 16.8246 17.1911C16.7718 17.2117 16.7151 17.2365 16.6623 17.2572C16.6096 17.2779 16.5569 17.2985 16.5082 17.3151C16.3135 17.3977 16.1432 17.4639 16.0255 17.5217C15.9647 17.5507 15.916 17.5672 15.8836 17.5796C15.8511 17.5961 15.8349 17.6003 15.8349 17.6003C15.8349 17.6003 15.8633 17.6457 15.9201 17.716C15.9769 17.7863 16.0661 17.8814 16.1918 17.9764C16.3135 18.0715 16.4717 18.1624 16.6704 18.2286C16.7718 18.2616 16.8773 18.2864 16.999 18.303C17.1166 18.3154 17.2504 18.3237 17.3883 18.3113C17.5262 18.2989 17.6682 18.274 17.8102 18.2368C17.9481 18.1955 18.086 18.1459 18.2239 18.0922C18.3577 18.0302 18.4875 17.964 18.6092 17.8938C18.7309 17.8235 18.8444 17.745 18.9499 17.6705C18.9742 17.6499 19.0026 17.6333 19.027 17.6168C19.0513 17.5961 19.0756 17.5796 19.1 17.5589C19.1486 17.5217 19.1892 17.4845 19.2338 17.4515C19.3149 17.3812 19.392 17.3192 19.4447 17.2613C19.5583 17.1497 19.6232 17.0794 19.6232 17.0794C19.6232 17.0794 19.5786 17.0505 19.4934 17.0092C19.4082 16.9678 19.2906 16.9224 19.1365 16.881C19.0594 16.8604 18.9783 16.8438 18.885 16.8314C18.7917 16.819 18.6944 16.8066 18.593 16.8025C18.4875 16.7984 18.3821 16.8025 18.2644 16.8066C18.1468 16.8149 18.0251 16.8273 17.9035 16.8521L17.9075 16.8562Z",
		fill: d
	}), E = /* @__PURE__ */ m("path", {
		d: "M15.4659 18.3608C15.328 18.3318 15.1901 18.3153 15.0522 18.3029C14.9142 18.2863 14.7763 18.2739 14.6425 18.2698C14.5087 18.2574 14.3748 18.2533 14.2491 18.2533C14.1233 18.245 14.0017 18.2409 13.8881 18.2409C13.661 18.2285 13.4663 18.2326 13.3284 18.2243C13.1905 18.2243 13.1053 18.2243 13.1053 18.2243C13.1053 18.2243 13.1134 18.2822 13.1377 18.3773C13.1621 18.4724 13.2107 18.6005 13.2878 18.7493C13.3284 18.8237 13.377 18.9023 13.4379 18.9808C13.4663 19.0221 13.5028 19.0593 13.5352 19.1007C13.5717 19.1379 13.6082 19.1751 13.6528 19.2164C13.738 19.2908 13.8354 19.3652 13.9489 19.4313C14.0625 19.4975 14.1923 19.5512 14.3383 19.6008C14.4843 19.6504 14.6384 19.6794 14.8007 19.7C14.9629 19.7248 15.1252 19.7248 15.2874 19.7207C15.4496 19.7207 15.6119 19.7 15.766 19.6752C15.9242 19.6546 16.0702 19.6174 16.2081 19.5802C16.2771 19.5636 16.346 19.543 16.4068 19.5223C16.4677 19.5016 16.5285 19.481 16.5853 19.4603C16.6989 19.4189 16.8003 19.3817 16.8814 19.3445C17.0436 19.2701 17.1369 19.2205 17.1369 19.2205C17.1369 19.2205 17.1045 19.1751 17.0315 19.1048C16.9625 19.0345 16.853 18.9436 16.711 18.8485C16.5691 18.7576 16.3906 18.6542 16.1838 18.5674C15.9769 18.4848 15.7336 18.4062 15.4618 18.3608H15.4659Z",
		fill: d
	}), n[4] = d, n[5] = f, n[6] = _, n[7] = v, n[8] = y, n[9] = b, n[10] = x, n[11] = S, n[12] = C, n[13] = w, n[14] = T, n[15] = E, n[16] = D, n[17] = O, n[18] = k, n[19] = A, n[20] = j, n[21] = M, n[22] = N);
	let P;
	n[23] !== d || n[24] !== r ? (P = r === g.XPartner && /* @__PURE__ */ h(p, { children: [
		/* @__PURE__ */ m("path", {
			d: "M9.30481 6.95617L12.144 8.82666L14.9832 6.95617L13.1478 9.84967L14.9832 12.7432L12.144 10.8727L9.30481 12.7432L11.1402 9.84967L9.30481 6.95617Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M11.5275 20.4606C11.7993 20.0968 11.9169 19.6049 11.9615 19.2122C11.9818 19.0138 11.9899 18.8443 11.9858 18.7203C11.9858 18.5963 11.9777 18.5261 11.9777 18.5261C11.9777 18.5261 11.779 18.5715 11.5235 18.7162C11.272 18.8609 10.9597 19.0965 10.7244 19.4603C10.4892 19.824 10.3553 20.2456 10.2742 20.5805C10.2539 20.6631 10.2377 20.7417 10.2215 20.8078C10.2093 20.8781 10.1931 20.9359 10.185 20.9897C10.1647 21.093 10.1607 21.1509 10.1607 21.1509C10.1607 21.1509 10.3635 21.155 10.6393 21.0765C10.7772 21.0351 10.9353 20.9731 11.0895 20.8781C11.2395 20.7789 11.4018 20.6466 11.5316 20.4606H11.5275Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M12.4198 20.4605C12.1481 20.0968 12.0305 19.6049 11.9858 19.2122C11.9656 19.0138 11.9574 18.8443 11.9656 18.7203C11.9656 18.5963 11.9737 18.526 11.9737 18.526C11.9737 18.526 12.1724 18.5715 12.4279 18.7161C12.6794 18.8608 12.9917 19.0964 13.227 19.4602C13.4582 19.8239 13.5961 20.2456 13.6772 20.5804C13.6975 20.6631 13.7137 20.7416 13.7299 20.8077C13.7421 20.878 13.7583 20.9359 13.7664 20.9896C13.7867 21.093 13.7907 21.1508 13.7907 21.1508C13.7907 21.1508 13.5879 21.155 13.3121 21.0764C13.1742 21.0351 13.0161 20.9731 12.8619 20.878C12.7119 20.7788 12.5496 20.6465 12.4198 20.4605Z",
			fill: d
		})
	] }), n[23] = d, n[24] = r, n[25] = P) : P = n[25];
	let F;
	n[26] !== d || n[27] !== r ? (F = r === g.Platinum && /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m("path", {
		d: "M8.89927 8.03376L9.53671 10.0644H11.5995L9.93066 11.3194L10.5681 13.35L8.89927 12.095L7.23044 13.35L7.86788 11.3194L6.19905 10.0644H8.26183L8.89927 8.03376Z",
		fill: d
	}), /* @__PURE__ */ m("path", {
		d: "M15.3888 8.03376L16.0262 10.0644H18.089L16.4202 11.3194L17.0576 13.35L15.3888 12.095L13.72 13.35L14.3574 11.3194L12.6886 10.0644H14.7514L15.3888 8.03376Z",
		fill: d
	})] }), n[26] = d, n[27] = r, n[28] = F) : F = n[28];
	let I;
	n[29] !== d || n[30] !== r ? (I = r === g.Gold && /* @__PURE__ */ m(p, { children: /* @__PURE__ */ m("path", {
		d: "M12.144 7.61386L12.9636 10.2247H15.6157L13.4701 11.8383L14.2896 14.4491L12.144 12.8355L9.99837 14.4491L10.8179 11.8383L8.67229 10.2247H11.3244L12.144 7.61386Z",
		fill: d
	}) }), n[29] = d, n[30] = r, n[31] = I) : I = n[31];
	let L;
	n[32] !== d || n[33] !== r ? (L = r !== g.Bronze && /* @__PURE__ */ h(p, { children: [
		/* @__PURE__ */ m("path", {
			d: "M5.24481 3.88493C5.20425 4.21975 5.08257 4.56284 4.96901 4.82325C4.91628 4.95553 4.8595 5.063 4.82299 5.14154C4.78649 5.22008 4.7581 5.26555 4.7581 5.26555C4.7581 5.26555 4.64453 5.18288 4.53502 5.0134C4.42145 4.84392 4.31194 4.58351 4.33222 4.23215C4.34844 3.8808 4.51068 3.50878 4.66887 3.23183C4.70943 3.16156 4.74998 3.09955 4.78649 3.04582C4.82299 2.98795 4.8595 2.94248 4.89194 2.90114C4.95278 2.8226 4.99334 2.77713 4.99334 2.77713C4.99334 2.77713 5.08257 2.88874 5.15558 3.08302C5.19209 3.18222 5.22453 3.29796 5.24481 3.43437C5.26509 3.57078 5.26915 3.72372 5.24481 3.8932V3.88493Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M3.86979 6.35678C3.92657 6.72467 3.89007 7.12149 3.84951 7.43151C3.8414 7.51005 3.82923 7.58032 3.81706 7.64646C3.80895 7.7126 3.79678 7.76633 3.78867 7.81594C3.76839 7.91101 3.75622 7.96888 3.75622 7.96888C3.75622 7.96888 3.61426 7.91514 3.44391 7.76633C3.35874 7.69193 3.26951 7.59686 3.18839 7.46871C3.11132 7.34471 3.03832 7.18763 3.00181 6.99335C2.92069 6.61306 2.98153 6.17077 3.07076 5.83595C3.11538 5.66648 3.16405 5.5218 3.20461 5.42259C3.24517 5.31926 3.27356 5.26138 3.27356 5.26138C3.27356 5.26138 3.30601 5.28205 3.35468 5.32752C3.40335 5.37299 3.46825 5.43913 3.5372 5.5342C3.60615 5.62514 3.6751 5.74088 3.73594 5.87729C3.79678 6.0137 3.84951 6.17491 3.87385 6.36092L3.86979 6.35678Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M3.16805 9.10971C3.33029 9.48586 3.41141 9.91575 3.47225 10.2547C3.48848 10.3415 3.49659 10.4201 3.50876 10.4903C3.52092 10.5606 3.52904 10.6226 3.53715 10.6763C3.54932 10.7797 3.55337 10.8458 3.55337 10.8458C3.55337 10.8458 3.51281 10.8458 3.4398 10.8293C3.37085 10.8169 3.27351 10.7921 3.15994 10.7466C3.04637 10.697 2.92064 10.6267 2.79085 10.5193C2.66511 10.4118 2.54749 10.2671 2.43798 10.0728C2.23112 9.68427 2.16623 9.17998 2.17029 8.78729C2.17029 8.68808 2.17029 8.59714 2.1784 8.51447C2.18651 8.4318 2.19057 8.3574 2.19868 8.29953C2.2149 8.17965 2.22707 8.10938 2.22707 8.10938C2.22707 8.10938 2.38525 8.16725 2.57588 8.32433C2.66917 8.40287 2.77868 8.5062 2.88008 8.63435C2.98148 8.76249 3.07882 8.91956 3.15994 9.10971H3.16805Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M5.772 4.29418C5.47592 4.40579 5.21633 4.64967 5.03787 4.86462C4.94864 4.97209 4.87969 5.07129 4.83507 5.1457C4.79046 5.2201 4.76207 5.26557 4.76207 5.26557C4.76207 5.26557 4.89186 5.31518 5.0906 5.32758C5.28934 5.33998 5.55298 5.32344 5.82879 5.19944C6.10459 5.07129 6.34795 4.87288 6.52641 4.70754C6.57103 4.6662 6.61159 4.629 6.64809 4.5918C6.68459 4.5546 6.71704 4.52566 6.74138 4.49673C6.79411 4.44299 6.8225 4.40992 6.8225 4.40992C6.8225 4.40992 6.70893 4.32725 6.52236 4.26938C6.42907 4.24045 6.3155 4.21564 6.18977 4.21564C6.06403 4.21564 5.92207 4.23218 5.77606 4.29005L5.772 4.29418Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M4.55118 6.62966C4.26726 6.84047 4.06041 7.17529 3.93468 7.45637C3.90223 7.52664 3.87384 7.59278 3.85356 7.65478C3.83328 7.71679 3.813 7.77052 3.80083 7.81599C3.77244 7.90693 3.76027 7.9648 3.76027 7.9648C3.76027 7.9648 3.9144 7.9772 4.12936 7.93587C4.23887 7.9152 4.36055 7.878 4.48629 7.82013C4.61608 7.76226 4.74587 7.68372 4.87972 7.58038C5.13524 7.36543 5.33804 7.08022 5.48 6.8446C5.54895 6.72886 5.60979 6.62552 5.64629 6.55112C5.6828 6.47671 5.70713 6.43124 5.70713 6.43124C5.70713 6.43124 5.67063 6.41884 5.60574 6.40644C5.54084 6.39404 5.45161 6.37751 5.3421 6.37751C5.23259 6.37751 5.10685 6.38577 4.973 6.42298C4.8351 6.46018 4.6972 6.52632 4.55118 6.62966Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M6.3318 2.5539C5.98704 2.85978 5.79235 3.24007 5.69095 3.52942C5.66662 3.60383 5.64634 3.66997 5.63011 3.72784C5.61389 3.78984 5.60578 3.84358 5.59767 3.88491C5.58144 3.97172 5.57739 4.02132 5.57739 4.02132C5.57739 4.02132 5.62606 4.00478 5.70312 3.96758C5.74368 3.94691 5.7883 3.92625 5.84508 3.89731C5.89781 3.87251 5.95865 3.83944 6.02354 3.80224C6.28312 3.6617 6.60355 3.45915 6.90369 3.1946C7.19977 2.92592 7.43502 2.63244 7.61348 2.40096C7.6581 2.34309 7.69866 2.28935 7.73111 2.23975C7.76761 2.19014 7.80006 2.14881 7.82439 2.11574C7.87306 2.04134 7.90146 2 7.90146 2C7.90146 2 7.85278 2 7.7595 2C7.71488 2 7.6581 2 7.59726 2.00827C7.53642 2.01653 7.46341 2.0248 7.38635 2.04134C7.30928 2.05374 7.22817 2.0744 7.13893 2.10334C7.09432 2.11574 7.0497 2.13227 7.00509 2.14881C6.96047 2.16948 6.91586 2.18601 6.87124 2.20668C6.82662 2.22735 6.77795 2.25215 6.73334 2.27282C6.68872 2.29762 6.64411 2.32655 6.59543 2.35549C6.55082 2.38442 6.50215 2.41749 6.46159 2.45056C6.41697 2.48363 6.37236 2.52083 6.3318 2.55803V2.5539Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M18.1752 4.40171C18.4673 4.50918 18.7228 4.74893 18.9013 4.95974C18.9864 5.06721 19.0594 5.16229 19.1041 5.23669C19.1487 5.31109 19.173 5.35243 19.173 5.35243C19.173 5.35243 19.0432 5.40203 18.8445 5.41857C18.6457 5.4351 18.3821 5.41857 18.1103 5.29869C17.8386 5.17469 17.5993 4.98454 17.4249 4.82333C17.3803 4.782 17.3397 4.74479 17.3073 4.71173C17.2708 4.67866 17.2424 4.64559 17.214 4.62079C17.1653 4.56705 17.1369 4.53398 17.1369 4.53398C17.1369 4.53398 17.2505 4.45131 17.433 4.39344C17.5263 4.36451 17.6398 4.33557 17.7656 4.33557C17.8873 4.33557 18.0292 4.34797 18.1752 4.40584V4.40171Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M19.4002 6.68754C19.6801 6.89421 19.887 7.22077 20.0127 7.50185C20.0451 7.57212 20.0695 7.63826 20.0938 7.69613C20.1141 7.75813 20.1344 7.81187 20.1465 7.85734C20.1749 7.94828 20.1871 8.00201 20.1871 8.00201C20.1871 8.00201 20.033 8.01855 19.818 7.97308C19.7085 7.95241 19.5868 7.91521 19.4611 7.86147C19.3313 7.80773 19.2015 7.7292 19.0717 7.62586C18.8162 7.41504 18.6174 7.13396 18.4755 6.90662C18.4065 6.79087 18.3497 6.69167 18.3092 6.61726C18.2727 6.54286 18.2524 6.49739 18.2524 6.49739C18.2524 6.49739 18.2889 6.48499 18.3538 6.47259C18.4187 6.46019 18.5079 6.44365 18.6134 6.44365C18.7229 6.44365 18.8486 6.45192 18.9825 6.48912C19.1163 6.52219 19.2583 6.58833 19.4002 6.69167V6.68754Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M18.7026 3.99245C18.7431 4.32314 18.8607 4.65796 18.9662 4.91424C19.0189 5.04238 19.0717 5.14985 19.1082 5.22839C19.1447 5.30693 19.169 5.34826 19.169 5.34826C19.169 5.34826 19.2826 5.26559 19.3961 5.09612C19.5097 4.92664 19.6233 4.67036 19.603 4.32314C19.5868 3.97178 19.4326 3.60803 19.2745 3.33521C19.2339 3.26907 19.1974 3.20294 19.1609 3.1492C19.1244 3.09546 19.0879 3.04586 19.0595 3.00866C18.9986 2.93012 18.9621 2.88465 18.9621 2.88465C18.9621 2.88465 18.8729 2.99626 18.7999 3.19054C18.7634 3.28561 18.731 3.40135 18.7107 3.53776C18.6904 3.67417 18.6863 3.82297 18.7026 3.98832V3.99245Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M20.0816 6.41069C20.0248 6.77444 20.0573 7.16713 20.0978 7.47302C20.1059 7.54742 20.1181 7.62183 20.1303 7.68383C20.1384 7.74997 20.1506 7.8037 20.1587 7.85331C20.1749 7.94838 20.1911 8.00212 20.1911 8.00212C20.1911 8.00212 20.3331 7.94838 20.5034 7.8037C20.5886 7.7293 20.6778 7.63423 20.759 7.50609C20.836 7.38208 20.909 7.225 20.9496 7.03899C21.0307 6.66284 20.9739 6.22468 20.8847 5.89399C20.8441 5.72865 20.7914 5.58397 20.7508 5.48477C20.7143 5.38556 20.686 5.32769 20.686 5.32769C20.686 5.32769 20.6535 5.34836 20.6048 5.39383C20.5562 5.4393 20.4913 5.50544 20.4223 5.59637C20.3534 5.68731 20.2804 5.79892 20.2236 5.93533C20.1627 6.07173 20.11 6.23294 20.0816 6.41069Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M20.7994 9.12223C20.6331 9.49425 20.556 9.92001 20.4952 10.2507C20.479 10.3334 20.4709 10.4119 20.4587 10.4822C20.4465 10.5525 20.4384 10.6145 20.4303 10.6641C20.4181 10.7674 20.4141 10.8294 20.4141 10.8294C20.4141 10.8294 20.4546 10.8294 20.5277 10.8129C20.5966 10.8005 20.698 10.7757 20.8075 10.7302C20.9211 10.6847 21.0468 10.6145 21.1726 10.507C21.2983 10.3995 21.4159 10.259 21.5214 10.0647C21.7282 9.68027 21.7931 9.18424 21.7931 8.79568C21.7931 8.69648 21.7931 8.60554 21.785 8.527C21.781 8.44433 21.7728 8.37406 21.7647 8.31205C21.7485 8.19218 21.7363 8.12191 21.7363 8.12191C21.7363 8.12191 21.5782 8.18391 21.3875 8.33685C21.2902 8.41539 21.1847 8.5146 21.0833 8.64687C20.9819 8.77501 20.8846 8.92795 20.8035 9.11397L20.7994 9.12223Z",
			fill: d
		}),
		/* @__PURE__ */ m("path", {
			d: "M17.0843 3.34767C17.3803 3.59982 17.7008 3.78583 17.9563 3.91811C18.0212 3.95118 18.082 3.98011 18.1348 4.00491C18.1875 4.02972 18.2362 4.05452 18.2727 4.06692C18.3497 4.09999 18.3984 4.11652 18.3984 4.11652C18.3984 4.11652 18.3903 4.06692 18.3741 3.98011C18.3659 3.93464 18.3538 3.88504 18.3376 3.82304C18.3213 3.76103 18.297 3.69903 18.2727 3.62462C18.1672 3.33941 17.9644 2.96739 17.6237 2.6739C17.5831 2.64083 17.5385 2.60363 17.4939 2.57056C17.4493 2.53749 17.4047 2.50856 17.3601 2.48376C17.3154 2.45482 17.2708 2.43002 17.2262 2.40935C17.1816 2.38869 17.1329 2.36802 17.0883 2.34735C17.0437 2.32668 16.9991 2.31015 16.9545 2.29361C16.9099 2.28121 16.8652 2.26468 16.8247 2.25641C16.7841 2.24401 16.7436 2.23161 16.703 2.22334C16.6624 2.21507 16.6219 2.21094 16.5854 2.20267C16.5124 2.19441 16.4434 2.18614 16.3826 2.18201C16.3217 2.18201 16.269 2.18201 16.2284 2.18201C16.1433 2.18201 16.0946 2.19027 16.0946 2.19027C16.0946 2.19027 16.123 2.23574 16.1717 2.30601C16.196 2.33908 16.2284 2.38042 16.2649 2.43002C16.2974 2.47549 16.338 2.53336 16.3826 2.5871C16.557 2.81444 16.7882 3.09553 17.0802 3.34767H17.0843Z",
			fill: d
		})
	] }), n[32] = d, n[33] = r, n[34] = L) : L = n[34];
	let R;
	return n[35] !== c || n[36] !== f || n[37] !== _ || n[38] !== v || n[39] !== y || n[40] !== b || n[41] !== x || n[42] !== S || n[43] !== C || n[44] !== w || n[45] !== T || n[46] !== E || n[47] !== P || n[48] !== F || n[49] !== I || n[50] !== L || n[51] !== D || n[52] !== O || n[53] !== k || n[54] !== A || n[55] !== j || n[56] !== M || n[57] !== N || n[58] !== l ? (R = /* @__PURE__ */ h("svg", {
		width: l,
		height: c,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			D,
			O,
			k,
			A,
			j,
			M,
			N,
			f,
			_,
			v,
			y,
			b,
			x,
			S,
			C,
			w,
			T,
			E,
			P,
			F,
			I,
			L
		]
	}), n[35] = c, n[36] = f, n[37] = _, n[38] = v, n[39] = y, n[40] = b, n[41] = x, n[42] = S, n[43] = C, n[44] = w, n[45] = T, n[46] = E, n[47] = P, n[48] = F, n[49] = I, n[50] = L, n[51] = D, n[52] = O, n[53] = k, n[54] = A, n[55] = j, n[56] = M, n[57] = N, n[58] = l, n[59] = R) : R = n[59], R;
}, Wi = (t) => {
	let n = e(7), { direction: r, color: i, height: a, width: o } = t, s = r === void 0 ? "up" : r, c = i === void 0 ? "var(--text-black)" : i, l = a === void 0 ? 24 : a, u = o === void 0 ? 24 : o, d = "";
	bb0: switch (s) {
		case "up":
			d = "M5.23005 10.64C5.314 10.7413 5.4171 10.825 5.53345 10.8863C5.6498 10.9477 5.7771 10.9855 5.90808 10.9975C6.03906 11.0096 6.17113 10.9957 6.29673 10.9567C6.42234 10.9176 6.539 10.8542 6.64005 10.77L11.0001 7.14001V19C11.0001 19.2652 11.1054 19.5196 11.2929 19.7071C11.4805 19.8947 11.7348 20 12.0001 20C12.2653 20 12.5196 19.8947 12.7072 19.7071C12.8947 19.5196 13.0001 19.2652 13.0001 19V7.14001L17.3601 10.77C17.4612 10.8541 17.5779 10.9174 17.7034 10.9563C17.829 10.9953 17.961 11.0091 18.092 10.997C18.2229 10.985 18.3502 10.9472 18.4665 10.886C18.5829 10.8247 18.686 10.7411 18.7701 10.64C18.8541 10.5389 18.9174 10.4222 18.9564 10.2966C18.9953 10.171 19.0091 10.039 18.9971 9.90808C18.985 9.77715 18.9473 9.64988 18.886 9.53354C18.8247 9.41719 18.7412 9.31405 18.6401 9.23001L12.6401 4.23001L12.4901 4.14001L12.3601 4.07001C12.1284 3.98061 11.8717 3.98061 11.6401 4.07001L11.5101 4.14001L11.3601 4.23001L5.36005 9.23001C5.25879 9.31396 5.17509 9.41706 5.11374 9.5334C5.05239 9.64975 5.01459 9.77706 5.00251 9.90804C4.99044 10.039 5.00432 10.1711 5.04337 10.2967C5.08241 10.4223 5.14585 10.539 5.23005 10.64Z";
			break bb0;
		case "down":
			d = "M18.77 13.36C18.6861 13.2587 18.583 13.175 18.4666 13.1137C18.3503 13.0523 18.223 13.0145 18.092 13.0025C17.961 12.9904 17.829 13.0043 17.7033 13.0433C17.5777 13.0824 17.4611 13.1458 17.36 13.23L13 16.86V5C13 4.73478 12.8947 4.48043 12.7071 4.29289C12.5196 4.10536 12.2652 4 12 4C11.7348 4 11.4805 4.10536 11.2929 4.29289C11.1054 4.48043 11 4.73478 11 5V16.86L6.64003 13.23C6.53891 13.146 6.42223 13.0826 6.29665 13.0437C6.17106 13.0047 6.03904 12.9909 5.90811 13.003C5.77717 13.0151 5.6499 13.0528 5.53356 13.1141C5.41721 13.1753 5.31407 13.2589 5.23003 13.36C5.14598 13.4611 5.08268 13.5778 5.04372 13.7034C5.00477 13.829 4.99094 13.961 5.00301 14.0919C5.01508 14.2229 5.05282 14.3501 5.11408 14.4665C5.17534 14.5828 5.25891 14.686 5.36003 14.77L11.36 19.77L11.51 19.86L11.64 19.93C11.8717 20.0194 12.1284 20.0194 12.36 19.93L12.49 19.86L12.64 19.77L18.64 14.77C18.7413 14.6861 18.825 14.583 18.8863 14.4666C18.9477 14.3503 18.9855 14.2229 18.9976 14.092C19.0096 13.961 18.9958 13.8289 18.9567 13.7033C18.9177 13.5777 18.8542 13.461 18.77 13.36Z";
			break bb0;
		case "left":
			d = "M19 11H7.14L10.77 6.64C10.9397 6.43578 11.0214 6.1725 10.997 5.90808C10.9726 5.64365 10.8442 5.39974 10.64 5.23C10.4358 5.06026 10.1725 4.9786 9.90808 5.00298C9.64365 5.02736 9.39974 5.15578 9.23 5.36L4.23 11.36C4.19636 11.4077 4.16628 11.4579 4.14 11.51C4.14 11.56 4.14 11.59 4.07 11.64C4.02467 11.7547 4.00094 11.8767 4 12C4.00094 12.1233 4.02467 12.2453 4.07 12.36C4.07 12.41 4.07 12.44 4.14 12.49C4.16628 12.5421 4.19636 12.5923 4.23 12.64L9.23 18.64C9.32402 18.7529 9.44176 18.8437 9.57485 18.9059C9.70793 18.9681 9.85309 19.0002 10 19C10.2337 19.0005 10.4601 18.9191 10.64 18.77C10.7413 18.6861 10.825 18.583 10.8863 18.4666C10.9477 18.3503 10.9855 18.2229 10.9975 18.092C11.0096 17.961 10.9957 17.8289 10.9567 17.7033C10.9176 17.5777 10.8542 17.4611 10.77 17.36L7.14 13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11Z";
			break bb0;
		case "right": d = "M5 13H16.86L13.23 17.36C13.146 17.4611 13.0826 17.5778 13.0437 17.7034C13.0047 17.829 12.9909 17.961 13.003 18.0919C13.0274 18.3564 13.1558 18.6003 13.36 18.77C13.5642 18.9397 13.8275 19.0214 14.0919 18.997C14.3563 18.9726 14.6003 18.8442 14.77 18.64L19.77 12.64C19.8036 12.5923 19.8337 12.5421 19.86 12.49C19.86 12.44 19.91 12.41 19.93 12.36C19.9753 12.2453 19.9991 12.1233 20 12C19.9991 11.8767 19.9753 11.7547 19.93 11.64C19.93 11.59 19.88 11.56 19.86 11.51C19.8337 11.4579 19.8036 11.4077 19.77 11.36L14.77 5.36C14.676 5.24712 14.5582 5.15634 14.4252 5.09412C14.2921 5.0319 14.1469 4.99976 14 5C13.7663 4.99955 13.5399 5.08092 13.36 5.23C13.2587 5.31395 13.175 5.41705 13.1137 5.5334C13.0523 5.64975 13.0145 5.77705 13.0025 5.90803C12.9904 6.03901 13.0043 6.17108 13.0433 6.29668C13.0824 6.42229 13.1458 6.53895 13.23 6.64L16.86 11H5C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13Z";
	}
	let f;
	n[0] !== c || n[1] !== d ? (f = /* @__PURE__ */ m("path", {
		d,
		fill: c
	}), n[0] = c, n[1] = d, n[2] = f) : f = n[2];
	let p;
	return n[3] !== l || n[4] !== f || n[5] !== u ? (p = /* @__PURE__ */ m("svg", {
		width: u,
		height: l,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: f
	}), n[3] = l, n[4] = f, n[5] = u, n[6] = p) : p = n[6], p;
}, Gi = (t) => {
	let n = e(7), { color: r, width: i, height: a, onClick: o } = t, s = r === void 0 ? "var(--text-black)" : r, c = i === void 0 ? 24 : i, l = a === void 0 ? 24 : a, u;
	n[0] === s ? u = n[1] : (u = /* @__PURE__ */ m("path", {
		d: "M13.4099 12L17.7099 7.71C17.8982 7.5217 18.004 7.2663 18.004 7C18.004 6.7337 17.8982 6.4783 17.7099 6.29C17.5216 6.1017 17.2662 5.99591 16.9999 5.99591C16.7336 5.99591 16.4782 6.1017 16.2899 6.29L11.9999 10.59L7.70994 6.29C7.52164 6.1017 7.26624 5.99591 6.99994 5.99591C6.73364 5.99591 6.47824 6.1017 6.28994 6.29C6.10164 6.4783 5.99585 6.7337 5.99585 7C5.99585 7.2663 6.10164 7.5217 6.28994 7.71L10.5899 12L6.28994 16.29C6.19621 16.383 6.12182 16.4936 6.07105 16.6154C6.02028 16.7373 5.99414 16.868 5.99414 17C5.99414 17.132 6.02028 17.2627 6.07105 17.3846C6.12182 17.5064 6.19621 17.617 6.28994 17.71C6.3829 17.8037 6.4935 17.8781 6.61536 17.9289C6.73722 17.9797 6.86793 18.0058 6.99994 18.0058C7.13195 18.0058 7.26266 17.9797 7.38452 17.9289C7.50638 17.8781 7.61698 17.8037 7.70994 17.71L11.9999 13.41L16.2899 17.71C16.3829 17.8037 16.4935 17.8781 16.6154 17.9289C16.7372 17.9797 16.8679 18.0058 16.9999 18.0058C17.132 18.0058 17.2627 17.9797 17.3845 17.9289C17.5064 17.8781 17.617 17.8037 17.7099 17.71C17.8037 17.617 17.8781 17.5064 17.9288 17.3846C17.9796 17.2627 18.0057 17.132 18.0057 17C18.0057 16.868 17.9796 16.7373 17.9288 16.6154C17.8781 16.4936 17.8037 16.383 17.7099 16.29L13.4099 12Z",
		fill: s
	}), n[0] = s, n[1] = u);
	let d;
	return n[2] !== l || n[3] !== o || n[4] !== u || n[5] !== c ? (d = /* @__PURE__ */ m("svg", {
		width: c,
		height: l,
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg",
		onClick: o,
		children: u
	}), n[2] = l, n[3] = o, n[4] = u, n[5] = c, n[6] = d) : d = n[6], d;
}, Ki = (t) => {
	let n = e(6), { color: r, width: i, height: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M6.57339 12.0019C6.48198 12.0016 6.39161 11.9825 6.30788 11.9458C6.22416 11.9091 6.14888 11.8556 6.08672 11.7886L2.84672 8.34189C2.72561 8.21282 2.66073 8.04092 2.66635 7.86401C2.67198 7.6871 2.74765 7.51968 2.87672 7.39856C3.0058 7.27744 3.17769 7.21256 3.3546 7.21819C3.53151 7.22382 3.69894 7.29949 3.82006 7.42856L6.56672 10.3552L12.1734 4.22189C12.2303 4.15104 12.3011 4.09257 12.3814 4.05007C12.4617 4.00757 12.5499 3.98194 12.6404 3.97475C12.731 3.96756 12.8221 3.97896 12.9081 4.00826C12.9942 4.03756 13.0733 4.08413 13.1406 4.14512C13.208 4.20611 13.2622 4.28023 13.2999 4.36292C13.3375 4.44561 13.3579 4.53513 13.3597 4.62599C13.3615 4.71684 13.3448 4.8071 13.3104 4.89123C13.2761 4.97537 13.2249 5.05159 13.1601 5.11523L7.06672 11.7819C7.00515 11.8501 6.93013 11.9049 6.84638 11.9428C6.76263 11.9806 6.67196 12.0008 6.58006 12.0019H6.57339Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== c || n[3] !== l || n[4] !== s ? (u = /* @__PURE__ */ m("svg", {
		width: s,
		height: c,
		viewBox: "0 0 16 16",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = c, n[3] = l, n[4] = s, n[5] = u) : u = n[5], u;
}, qi = (t) => {
	let n = e(10), { color: r, width: i, height: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 24 : i, c = a === void 0 ? 24 : a, l, u, d;
	n[0] === o ? (l = n[1], u = n[2], d = n[3]) : (l = /* @__PURE__ */ m("path", {
		d: "M18 4H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V4H9V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V4H6C5.20435 4 4.44129 4.31607 3.87868 4.87868C3.31607 5.44129 3 6.20435 3 7V19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H18C18.7956 22 19.5587 21.6839 20.1213 21.1213C20.6839 20.5587 21 19.7956 21 19V7C21 6.20435 20.6839 5.44129 20.1213 4.87868C19.5587 4.31607 18.7956 4 18 4ZM6 6H7V7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7V6H15V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8C16.2652 8 16.5196 7.89464 16.7071 7.70711C16.8946 7.51957 17 7.26522 17 7V6H18C18.2652 6 18.5196 6.10536 18.7071 6.29289C18.8946 6.48043 19 6.73478 19 7V11H5V7C5 6.73478 5.10536 6.48043 5.29289 6.29289C5.48043 6.10536 5.73478 6 6 6ZM18 20H6C5.73478 20 5.48043 19.8946 5.29289 19.7071C5.10536 19.5196 5 19.2652 5 19V13H19V19C19 19.2652 18.8946 19.5196 18.7071 19.7071C18.5196 19.8946 18.2652 20 18 20Z",
		fill: o
	}), u = /* @__PURE__ */ m("path", {
		d: "M8 17C8.55228 17 9 16.5523 9 16C9 15.4477 8.55228 15 8 15C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17Z",
		fill: o
	}), d = /* @__PURE__ */ m("path", {
		d: "M16 15H12C11.7348 15 11.4804 15.1054 11.2929 15.2929C11.1054 15.4804 11 15.7348 11 16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17H16C16.2652 17 16.5196 16.8946 16.7071 16.7071C16.8946 16.5196 17 16.2652 17 16C17 15.7348 16.8946 15.4804 16.7071 15.2929C16.5196 15.1054 16.2652 15 16 15Z",
		fill: o
	}), n[0] = o, n[1] = l, n[2] = u, n[3] = d);
	let f;
	return n[4] !== c || n[5] !== l || n[6] !== u || n[7] !== d || n[8] !== s ? (f = /* @__PURE__ */ h("svg", {
		width: s,
		height: c,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			l,
			u,
			d
		]
	}), n[4] = c, n[5] = l, n[6] = u, n[7] = d, n[8] = s, n[9] = f) : f = n[9], f;
}, Ji = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-tertiary)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M4.63636 15.4545V0.90909H5.56818V15.4545H4.63636ZM7.77273 5.27273C7.70455 4.69697 7.42803 4.25 6.94318 3.93182C6.45833 3.61364 5.86364 3.45455 5.15909 3.45455C4.64394 3.45455 4.19318 3.53788 3.80682 3.70455C3.42424 3.87121 3.125 4.10038 2.90909 4.39205C2.69697 4.68371 2.59091 5.01515 2.59091 5.38636C2.59091 5.69697 2.66477 5.96401 2.8125 6.1875C2.96402 6.4072 3.1572 6.59091 3.39205 6.73864C3.62689 6.88258 3.87311 7.00189 4.13068 7.09659C4.38826 7.1875 4.625 7.26136 4.84091 7.31818L6.02273 7.63636C6.32576 7.71591 6.66288 7.82576 7.03409 7.96591C7.40909 8.10606 7.76705 8.29735 8.10795 8.53977C8.45265 8.77841 8.73674 9.08523 8.96023 9.46023C9.18371 9.83523 9.29545 10.2955 9.29545 10.8409C9.29545 11.4697 9.13068 12.0379 8.80114 12.5455C8.47538 13.053 7.99811 13.4564 7.36932 13.7557C6.74432 14.0549 5.98485 14.2045 5.09091 14.2045C4.25758 14.2045 3.53598 14.0701 2.92614 13.8011C2.32008 13.5322 1.8428 13.1572 1.49432 12.6761C1.14962 12.1951 0.954545 11.6364 0.909091 11H2.36364C2.40152 11.4394 2.54924 11.803 2.80682 12.0909C3.06818 12.375 3.39773 12.5871 3.79545 12.7273C4.19697 12.8636 4.62879 12.9318 5.09091 12.9318C5.62879 12.9318 6.11174 12.8447 6.53977 12.6705C6.9678 12.4924 7.30682 12.2462 7.55682 11.9318C7.80682 11.6136 7.93182 11.2424 7.93182 10.8182C7.93182 10.4318 7.82386 10.1174 7.60795 9.875C7.39205 9.63258 7.10795 9.43561 6.75568 9.28409C6.40341 9.13258 6.02273 9 5.61364 8.88636L4.18182 8.47727C3.27273 8.21591 2.55303 7.8428 2.02273 7.35795C1.49242 6.87311 1.22727 6.23864 1.22727 5.45455C1.22727 4.80303 1.40341 4.23485 1.75568 3.75C2.11174 3.26136 2.58902 2.88258 3.1875 2.61364C3.78977 2.34091 4.46212 2.20455 5.20455 2.20455C5.95455 2.20455 6.62121 2.33901 7.20455 2.60795C7.78788 2.87311 8.25 3.23674 8.59091 3.69886C8.93561 4.16098 9.11742 4.68561 9.13636 5.27273H7.77273Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 10 16",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Yi = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-tertiary)" : r, s = i === void 0 ? 13 : i, c = a === void 0 ? 13 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M6.13636 9.81818V9.20455C6.13636 8.7803 6.22349 8.39205 6.39773 8.03977C6.57576 7.68371 6.83333 7.39962 7.17045 7.1875C7.51136 6.97159 7.92424 6.86364 8.40909 6.86364C8.90152 6.86364 9.31439 6.97159 9.64773 7.1875C9.98106 7.39962 10.233 7.68371 10.4034 8.03977C10.5739 8.39205 10.6591 8.7803 10.6591 9.20455V9.81818C10.6591 10.2424 10.572 10.6326 10.3977 10.9886C10.2273 11.3409 9.97349 11.625 9.63636 11.8409C9.30303 12.053 8.89394 12.1591 8.40909 12.1591C7.91667 12.1591 7.50189 12.053 7.16477 11.8409C6.82765 11.625 6.57197 11.3409 6.39773 10.9886C6.22349 10.6326 6.13636 10.2424 6.13636 9.81818ZM7.29545 9.20455V9.81818C7.29545 10.1705 7.37879 10.4867 7.54545 10.767C7.71212 11.0436 8 11.1818 8.40909 11.1818C8.80682 11.1818 9.08712 11.0436 9.25 10.767C9.41667 10.4867 9.5 10.1705 9.5 9.81818V9.20455C9.5 8.85227 9.42045 8.53788 9.26136 8.26136C9.10227 7.98106 8.81818 7.84091 8.40909 7.84091C8.01136 7.84091 7.72538 7.98106 7.55114 8.26136C7.38068 8.53788 7.29545 8.85227 7.29545 9.20455ZM0.340909 3.15909V2.54545C0.340909 2.12121 0.42803 1.73295 0.602273 1.38068C0.780303 1.02462 1.03788 0.74053 1.375 0.528409C1.71591 0.3125 2.12879 0.204545 2.61364 0.204545C3.10606 0.204545 3.51894 0.3125 3.85227 0.528409C4.18561 0.74053 4.4375 1.02462 4.60795 1.38068C4.77841 1.73295 4.86364 2.12121 4.86364 2.54545V3.15909C4.86364 3.58333 4.77652 3.97348 4.60227 4.32955C4.43182 4.68182 4.17803 4.96591 3.84091 5.18182C3.50758 5.39394 3.09848 5.5 2.61364 5.5C2.12121 5.5 1.70644 5.39394 1.36932 5.18182C1.0322 4.96591 0.776515 4.68182 0.602273 4.32955C0.42803 3.97348 0.340909 3.58333 0.340909 3.15909ZM1.5 2.54545V3.15909C1.5 3.51136 1.58333 3.82765 1.75 4.10795C1.91667 4.38447 2.20455 4.52273 2.61364 4.52273C3.01136 4.52273 3.29167 4.38447 3.45455 4.10795C3.62121 3.82765 3.70455 3.51136 3.70455 3.15909V2.54545C3.70455 2.19318 3.625 1.87879 3.46591 1.60227C3.30682 1.32197 3.02273 1.18182 2.61364 1.18182C2.21591 1.18182 1.92992 1.32197 1.75568 1.60227C1.58523 1.87879 1.5 2.19318 1.5 2.54545ZM0.772727 12L8.77273 0.363636H10.0682L2.06818 12H0.772727Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 11 13",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Xi = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--fg-tertiary)" : r, s = i === void 0 ? 20 : i, c = a === void 0 ? 20 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M9.99935 1.66602C8.35118 1.66602 6.74001 2.15476 5.3696 3.07044C3.99919 3.98611 2.93109 5.2876 2.30036 6.81032C1.66963 8.33304 1.5046 10.0086 1.82614 11.6251C2.14769 13.2416 2.94136 14.7265 4.1068 15.8919C5.27223 17.0573 6.75709 17.851 8.3736 18.1726C9.99011 18.4941 11.6657 18.3291 13.1884 17.6983C14.7111 17.0676 16.0126 15.9995 16.9283 14.6291C17.8439 13.2587 18.3327 11.6475 18.3327 9.99935C18.3327 8.905 18.1171 7.82137 17.6983 6.81032C17.2796 5.79927 16.6657 4.88061 15.8919 4.10679C15.1181 3.33297 14.1994 2.71914 13.1884 2.30035C12.1773 1.88156 11.0937 1.66602 9.99935 1.66602ZM12.2577 11.0743C12.3358 11.1518 12.3978 11.244 12.4401 11.3455C12.4824 11.4471 12.5042 11.556 12.5042 11.666C12.5042 11.776 12.4824 11.8849 12.4401 11.9865C12.3978 12.088 12.3358 12.1802 12.2577 12.2577C12.1802 12.3358 12.088 12.3978 11.9865 12.4401C11.885 12.4824 11.776 12.5042 11.666 12.5042C11.556 12.5042 11.4471 12.4824 11.3455 12.4401C11.244 12.3978 11.1518 12.3358 11.0744 12.2577L9.99935 11.1743L8.92435 12.2577C8.84688 12.3358 8.75472 12.3978 8.65317 12.4401C8.55162 12.4824 8.4427 12.5042 8.33269 12.5042C8.22268 12.5042 8.11375 12.4824 8.01221 12.4401C7.91066 12.3978 7.81849 12.3358 7.74102 12.2577C7.66291 12.1802 7.60092 12.088 7.55861 11.9865C7.5163 11.8849 7.49452 11.776 7.49452 11.666C7.49452 11.556 7.5163 11.4471 7.55861 11.3455C7.60092 11.244 7.66291 11.1518 7.74102 11.0743L8.82435 9.99935L7.74102 8.92435C7.5841 8.76743 7.49594 8.5546 7.49594 8.33268C7.49594 8.11076 7.5841 7.89794 7.74102 7.74102C7.89794 7.5841 8.11077 7.49594 8.33269 7.49594C8.5546 7.49594 8.76743 7.5841 8.92435 7.74102L9.99935 8.82435L11.0744 7.74102C11.2313 7.5841 11.4441 7.49594 11.666 7.49594C11.8879 7.49594 12.1008 7.5841 12.2577 7.74102C12.4146 7.89794 12.5028 8.11076 12.5028 8.33268C12.5028 8.5546 12.4146 8.76743 12.2577 8.92435L11.1744 9.99935L12.2577 11.0743Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Zi = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--neutral-grey-500)" : r, s = i === void 0 ? 20 : i, c = a === void 0 ? 20 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.1621 5.12265L9.7973 5.545C9.49645 5.89329 8.97021 5.93174 8.62192 5.63089C8.27363 5.33003 8.23518 4.8038 8.53603 4.45551L8.92187 4.00884C8.93513 3.99349 8.94894 3.97863 8.96329 3.96429C9.90108 3.02663 11.173 2.49991 12.4991 2.5C13.8253 2.50009 15.0971 3.02699 16.0347 3.96479C16.9724 4.90259 17.4991 6.17446 17.499 7.50061C17.4989 8.82676 16.972 10.0986 16.0342 11.0362C16.0205 11.05 16.0063 11.0632 15.9916 11.076L15.5466 11.4626C15.1992 11.7645 14.6728 11.7276 14.371 11.3802C14.0691 11.0328 14.106 10.5064 14.4534 10.2045L14.8752 9.83807C15.4883 9.21488 15.8323 8.37543 15.8323 7.50049C15.8324 6.61637 15.4812 5.76843 14.8561 5.14322C14.231 4.51801 13.3831 4.16673 12.499 4.16667C11.6244 4.1666 10.7853 4.51019 10.1621 5.12265ZM13.0893 6.91115C13.4147 7.23659 13.4147 7.76423 13.0893 8.08966L8.08926 13.0897C7.76382 13.4151 7.23618 13.4151 6.91074 13.0897C6.58531 12.7642 6.58531 12.2366 6.91074 11.9112L11.9107 6.91115C12.2362 6.58571 12.7638 6.58571 13.0893 6.91115ZM5.6246 8.61529C5.92934 8.96018 5.89679 9.48681 5.5519 9.79156L5.13374 10.161C4.82977 10.4656 4.58806 10.8266 4.42221 11.2239C4.25352 11.6279 4.16667 12.0613 4.16667 12.4992C4.16667 12.937 4.25352 13.3704 4.42221 13.7745C4.59089 14.1785 4.83805 14.545 5.14938 14.8528L5.1494 14.8529C5.78402 15.4804 6.64053 15.8324 7.53304 15.8324C8.40557 15.8324 9.24369 15.496 9.87372 14.8946L10.1647 14.5032C10.4393 14.1339 10.9613 14.0571 11.3306 14.3316C11.7 14.6062 11.7768 15.1282 11.5022 15.4976L11.1714 15.9426C11.1462 15.9764 11.1185 16.0083 11.0886 16.038C10.1419 16.974 8.86434 17.4991 7.53304 17.4991C6.20174 17.4991 4.92415 16.9741 3.97753 16.038C3.50944 15.5751 3.13783 15.024 2.88421 14.4166C2.63059 13.8092 2.5 13.1574 2.5 12.4992C2.5 11.8409 2.63059 11.1892 2.88421 10.5817C3.13783 9.97427 3.50945 9.42317 3.97753 8.96034C3.98861 8.94938 3.99999 8.93874 4.01167 8.92843L4.44833 8.54259C4.79323 8.23785 5.31986 8.2704 5.6246 8.61529Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, Qi = (t) => {
	let n = e(12), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 24 : i, c = a === void 0 ? 24 : a, l, u, d, f;
	n[0] === o ? (l = n[1], u = n[2], d = n[3], f = n[4]) : (l = /* @__PURE__ */ m("path", {
		d: "M9 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V9C3 9.53043 3.21071 10.0391 3.58579 10.4142C3.96086 10.7893 4.46957 11 5 11H9C9.53043 11 10.0391 10.7893 10.4142 10.4142C10.7893 10.0391 11 9.53043 11 9V5C11 4.46957 10.7893 3.96086 10.4142 3.58579C10.0391 3.21071 9.53043 3 9 3ZM5 9V5H9V9H5Z",
		fill: o
	}), u = /* @__PURE__ */ m("path", {
		d: "M19 3H15C14.4696 3 13.9609 3.21071 13.5858 3.58579C13.2107 3.96086 13 4.46957 13 5V9C13 9.53043 13.2107 10.0391 13.5858 10.4142C13.9609 10.7893 14.4696 11 15 11H19C19.5304 11 20.0391 10.7893 20.4142 10.4142C20.7893 10.0391 21 9.53043 21 9V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3ZM15 9V5H19V9H15Z",
		fill: o
	}), d = /* @__PURE__ */ m("path", {
		d: "M9 13H5C4.46957 13 3.96086 13.2107 3.58579 13.5858C3.21071 13.9609 3 14.4696 3 15V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H9C9.53043 21 10.0391 20.7893 10.4142 20.4142C10.7893 20.0391 11 19.5304 11 19V15C11 14.4696 10.7893 13.9609 10.4142 13.5858C10.0391 13.2107 9.53043 13 9 13ZM5 19V15H9V19H5Z",
		fill: o
	}), f = /* @__PURE__ */ m("path", {
		d: "M19 13H15C14.4696 13 13.9609 13.2107 13.5858 13.5858C13.2107 13.9609 13 14.4696 13 15V19C13 19.5304 13.2107 20.0391 13.5858 20.4142C13.9609 20.7893 14.4696 21 15 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V15C21 14.4696 20.7893 13.9609 20.4142 13.5858C20.0391 13.2107 19.5304 13 19 13ZM15 19V15H19V19H15Z",
		fill: o
	}), n[0] = o, n[1] = l, n[2] = u, n[3] = d, n[4] = f);
	let p;
	return n[5] !== s || n[6] !== l || n[7] !== u || n[8] !== d || n[9] !== f || n[10] !== c ? (p = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			l,
			u,
			d,
			f
		]
	}), n[5] = s, n[6] = l, n[7] = u, n[8] = d, n[9] = f, n[10] = c, n[11] = p) : p = n[11], p;
}, $i = (t) => {
	let n = e(8), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 18 : i, c = a === void 0 ? 18 : a, l, u;
	n[0] === o ? (l = n[1], u = n[2]) : (l = /* @__PURE__ */ m("path", {
		d: "M9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM9 15C7.81332 15 6.65328 14.6481 5.66658 13.9888C4.67989 13.3295 3.91085 12.3925 3.45673 11.2961C3.0026 10.1997 2.88378 8.99334 3.11529 7.82946C3.3468 6.66557 3.91825 5.59647 4.75736 4.75736C5.59648 3.91824 6.66558 3.3468 7.82946 3.11529C8.99335 2.88378 10.1997 3.0026 11.2961 3.45672C12.3925 3.91085 13.3295 4.67988 13.9888 5.66658C14.6481 6.65327 15 7.81331 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z",
		fill: o
	}), u = /* @__PURE__ */ m("path", {
		d: "M11.25 8.25H9.75V6.75C9.75 6.55109 9.67098 6.36032 9.53033 6.21967C9.38968 6.07902 9.19891 6 9 6C8.80109 6 8.61032 6.07902 8.46967 6.21967C8.32902 6.36032 8.25 6.55109 8.25 6.75V8.25H6.75C6.55109 8.25 6.36032 8.32902 6.21967 8.46967C6.07902 8.61032 6 8.80109 6 9C6 9.19891 6.07902 9.38968 6.21967 9.53033C6.36032 9.67098 6.55109 9.75 6.75 9.75H8.25V11.25C8.25 11.4489 8.32902 11.6397 8.46967 11.7803C8.61032 11.921 8.80109 12 9 12C9.19891 12 9.38968 11.921 9.53033 11.7803C9.67098 11.6397 9.75 11.4489 9.75 11.25V9.75H11.25C11.4489 9.75 11.6397 9.67098 11.7803 9.53033C11.921 9.38968 12 9.19891 12 9C12 8.80109 11.921 8.61032 11.7803 8.46967C11.6397 8.32902 11.4489 8.25 11.25 8.25Z",
		fill: o
	}), n[0] = o, n[1] = l, n[2] = u);
	let d;
	return n[3] !== s || n[4] !== l || n[5] !== u || n[6] !== c ? (d = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 18 18",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[3] = s, n[4] = l, n[5] = u, n[6] = c, n[7] = d) : d = n[7], d;
}, ea = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 18 : i, c = a === void 0 ? 18 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("g", {
		id: "Layer 2",
		children: /* @__PURE__ */ h("g", {
			id: "close-circle",
			children: [/* @__PURE__ */ m("path", {
				id: "Vector",
				d: "M9 1.5C7.51664 1.5 6.0666 1.93987 4.83323 2.76398C3.59986 3.58809 2.63856 4.75943 2.07091 6.12987C1.50325 7.50032 1.35472 9.00832 1.64411 10.4632C1.9335 11.918 2.64781 13.2544 3.6967 14.3033C4.7456 15.3522 6.08197 16.0665 7.53683 16.3559C8.99168 16.6453 10.4997 16.4968 11.8701 15.9291C13.2406 15.3614 14.4119 14.4001 15.236 13.1668C16.0601 11.9334 16.5 10.4834 16.5 9C16.5 8.01509 16.306 7.03982 15.9291 6.12987C15.5522 5.21993 14.9997 4.39314 14.3033 3.6967C13.6069 3.00026 12.7801 2.44781 11.8701 2.0709C10.9602 1.69399 9.98492 1.5 9 1.5ZM9 15C7.81332 15 6.65328 14.6481 5.66658 13.9888C4.67989 13.3295 3.91085 12.3925 3.45673 11.2961C3.0026 10.1997 2.88378 8.99334 3.11529 7.82946C3.3468 6.66557 3.91825 5.59647 4.75736 4.75736C5.59648 3.91824 6.66558 3.3468 7.82946 3.11529C8.99335 2.88378 10.1997 3.0026 11.2961 3.45672C12.3925 3.91085 13.3295 4.67988 13.9888 5.66658C14.6481 6.65327 15 7.81331 15 9C15 10.5913 14.3679 12.1174 13.2426 13.2426C12.1174 14.3679 10.5913 15 9 15Z",
				fill: o
			}), /* @__PURE__ */ m("path", {
				id: "Vector_2",
				d: "M11.0325 6.96745C10.9627 6.89716 10.8798 6.84136 10.7884 6.80329C10.697 6.76521 10.599 6.74561 10.5 6.74561C10.4009 6.74561 10.3029 6.76521 10.2115 6.80329C10.1201 6.84136 10.0372 6.89716 9.96745 6.96745L8.99995 7.94245L8.03245 6.96745C7.89123 6.82623 7.69968 6.74689 7.49995 6.74689C7.30023 6.74689 7.10868 6.82623 6.96745 6.96745C6.82623 7.10868 6.74689 7.30023 6.74689 7.49995C6.74689 7.69968 6.82623 7.89123 6.96745 8.03245L7.94245 8.99995L6.96745 9.96745C6.89716 10.0372 6.84136 10.1201 6.80329 10.2115C6.76521 10.3029 6.74561 10.4009 6.74561 10.5C6.74561 10.599 6.76521 10.697 6.80329 10.7884C6.84136 10.8798 6.89716 10.9627 6.96745 11.0325C7.03718 11.1028 7.12013 11.1585 7.21152 11.1966C7.30292 11.2347 7.40095 11.2543 7.49995 11.2543C7.59896 11.2543 7.69699 11.2347 7.78839 11.1966C7.87978 11.1585 7.96273 11.1028 8.03245 11.0325L8.99995 10.0575L9.96745 11.0325C10.0372 11.1028 10.1201 11.1585 10.2115 11.1966C10.3029 11.2347 10.4009 11.2543 10.5 11.2543C10.599 11.2543 10.697 11.2347 10.7884 11.1966C10.8798 11.1585 10.9627 11.1028 11.0325 11.0325C11.1028 10.9627 11.1585 10.8798 11.1966 10.7884C11.2347 10.697 11.2543 10.599 11.2543 10.5C11.2543 10.4009 11.2347 10.3029 11.1966 10.2115C11.1585 10.1201 11.1028 10.0372 11.0325 9.96745L10.0575 8.99995L11.0325 8.03245C11.1028 7.96273 11.1585 7.87978 11.1966 7.78839C11.2347 7.69699 11.2543 7.59896 11.2543 7.49995C11.2543 7.40095 11.2347 7.30292 11.1966 7.21152C11.1585 7.12013 11.1028 7.03718 11.0325 6.96745Z",
				fill: o
			})]
		})
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 18 18",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, ta = (t) => {
	let n = e(9), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--fg-tertiary)" : r, s = i === void 0 ? 20 : i, c = a === void 0 ? 20 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ h("g", {
		clipPath: "url(#clip0_806_5685)",
		children: [
			/* @__PURE__ */ m("path", {
				d: "M10 1.66669C9.77901 1.66669 9.56705 1.75448 9.41076 1.91076C9.25448 2.06704 9.16669 2.27901 9.16669 2.50002V4.16669C9.16669 4.3877 9.25448 4.59966 9.41076 4.75594C9.56705 4.91222 9.77901 5.00002 10 5.00002C10.221 5.00002 10.433 4.91222 10.5893 4.75594C10.7456 4.59966 10.8334 4.3877 10.8334 4.16669V2.50002C10.8334 2.27901 10.7456 2.06704 10.5893 1.91076C10.433 1.75448 10.221 1.66669 10 1.66669Z",
				fill: o
			}),
			/* @__PURE__ */ m("path", {
				d: "M17.5 9.16669H15.8333C15.6123 9.16669 15.4004 9.25448 15.2441 9.41076C15.0878 9.56705 15 9.77901 15 10C15 10.221 15.0878 10.433 15.2441 10.5893C15.4004 10.7456 15.6123 10.8334 15.8333 10.8334H17.5C17.721 10.8334 17.933 10.7456 18.0893 10.5893C18.2455 10.433 18.3333 10.221 18.3333 10C18.3333 9.77901 18.2455 9.56705 18.0893 9.41076C17.933 9.25448 17.721 9.16669 17.5 9.16669Z",
				fill: o
			}),
			/* @__PURE__ */ m("path", {
				d: "M5.00002 10C5.00002 9.77901 4.91222 9.56705 4.75594 9.41076C4.59966 9.25448 4.3877 9.16669 4.16669 9.16669H2.50002C2.27901 9.16669 2.06704 9.25448 1.91076 9.41076C1.75448 9.56705 1.66669 9.77901 1.66669 10C1.66669 10.221 1.75448 10.433 1.91076 10.5893C2.06704 10.7456 2.27901 10.8334 2.50002 10.8334H4.16669C4.3877 10.8334 4.59966 10.7456 4.75594 10.5893C4.91222 10.433 5.00002 10.221 5.00002 10Z",
				fill: o
			}),
			/* @__PURE__ */ m("path", {
				d: "M5.18336 4.16668C5.02092 4.01308 4.80411 3.9303 4.58063 3.93655C4.35714 3.9428 4.1453 4.03757 3.9917 4.20002C3.83809 4.36246 3.75531 4.57927 3.76156 4.80275C3.76781 5.02623 3.86258 5.23808 4.02503 5.39168L5.22503 6.55002C5.30556 6.62778 5.40093 6.68851 5.50545 6.7286C5.60997 6.76869 5.72149 6.78731 5.83336 6.78335C5.94562 6.78292 6.05663 6.75982 6.15973 6.71543C6.26284 6.67103 6.35591 6.60627 6.43336 6.52502C6.58857 6.36888 6.67569 6.15767 6.67569 5.93752C6.67569 5.71736 6.58857 5.50615 6.43336 5.35002L5.18336 4.16668Z",
				fill: o
			}),
			/* @__PURE__ */ m("path", {
				d: "M14.1667 6.78331C14.3812 6.78245 14.5872 6.69887 14.7417 6.54997L15.9417 5.39164C16.088 5.23868 16.1707 5.03574 16.1729 4.82403C16.1751 4.61232 16.0966 4.40772 15.9534 4.25178C15.8102 4.09584 15.613 4.00026 15.4019 3.98445C15.1907 3.96863 14.9815 4.03377 14.8167 4.16664L13.6167 5.34997C13.4614 5.50611 13.3743 5.71732 13.3743 5.93747C13.3743 6.15763 13.4614 6.36884 13.6167 6.52497C13.7609 6.67724 13.9573 6.76949 14.1667 6.78331Z",
				fill: o
			}),
			/* @__PURE__ */ m("path", {
				d: "M10 15C9.77901 15 9.56705 15.0878 9.41076 15.2441C9.25448 15.4004 9.16669 15.6123 9.16669 15.8333V17.5C9.16669 17.721 9.25448 17.933 9.41076 18.0893C9.56705 18.2455 9.77901 18.3333 10 18.3333C10.221 18.3333 10.433 18.2455 10.5893 18.0893C10.7456 17.933 10.8334 17.721 10.8334 17.5V15.8333C10.8334 15.6123 10.7456 15.4004 10.5893 15.2441C10.433 15.0878 10.221 15 10 15Z",
				fill: o
			}),
			/* @__PURE__ */ m("path", {
				d: "M14.775 13.45C14.6158 13.2964 14.4022 13.2123 14.1811 13.2162C13.9599 13.2201 13.7494 13.3117 13.5958 13.4708C13.4422 13.63 13.3581 13.8436 13.362 14.0647C13.3659 14.2859 13.4575 14.4964 13.6166 14.65L14.8166 15.8333C14.9711 15.9822 15.1771 16.0658 15.3916 16.0667C15.5033 16.0673 15.6139 16.0455 15.717 16.0026C15.8201 15.9596 15.9135 15.8964 15.9916 15.8167C16.0697 15.7392 16.1317 15.647 16.174 15.5455C16.2164 15.4439 16.2381 15.335 16.2381 15.225C16.2381 15.115 16.2164 15.0061 16.174 14.9045C16.1317 14.803 16.0697 14.7108 15.9916 14.6333L14.775 13.45Z",
				fill: o
			}),
			/* @__PURE__ */ m("path", {
				d: "M5.225 13.45L4.025 14.6083C3.94689 14.6858 3.8849 14.778 3.84259 14.8795C3.80029 14.9811 3.7785 15.09 3.7785 15.2C3.7785 15.31 3.80029 15.4189 3.84259 15.5205C3.8849 15.622 3.94689 15.7142 4.025 15.7917C4.10316 15.8714 4.19655 15.9346 4.29962 15.9776C4.40269 16.0205 4.51334 16.0423 4.625 16.0417C4.83043 16.0434 5.02927 15.9692 5.18334 15.8333L6.38334 14.675C6.54247 14.5214 6.63406 14.3109 6.63797 14.0897C6.64187 13.8686 6.55777 13.655 6.40417 13.4958C6.25056 13.3367 6.04004 13.2451 5.8189 13.2412C5.59776 13.2373 5.38413 13.3214 5.225 13.475V13.45Z",
				fill: o
			})
		]
	}), n[0] = o, n[1] = l);
	let u;
	n[2] === o ? u = n[3] : (u = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
		id: "clip0_806_5685",
		children: /* @__PURE__ */ m("rect", {
			width: "20",
			height: "20",
			fill: o
		})
	}) }), n[2] = o, n[3] = u);
	let d;
	return n[4] !== s || n[5] !== l || n[6] !== u || n[7] !== c ? (d = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[4] = s, n[5] = l, n[6] = u, n[7] = c, n[8] = d) : d = n[8], d;
}, na = (t) => {
	let n = e(6), { color: r, width: i, height: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 41 : i, c = a === void 0 ? 1 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M0.5 0.5L40.5 0.5",
		stroke: o,
		strokeOpacity: "0.1",
		strokeLinecap: "round",
		strokeDasharray: "2 2"
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== c || n[3] !== l || n[4] !== s ? (u = /* @__PURE__ */ m("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: s,
		height: c,
		viewBox: "0 0 41 1",
		fill: "none",
		children: l
	}), n[2] = c, n[3] = l, n[4] = s, n[5] = u) : u = n[5], u;
}, ra = (t) => {
	let n = e(7), { height: r, width: i, color: a } = t, o = r === void 0 ? 20 : r, s = i === void 0 ? 20 : i, c = a === void 0 ? "var(--fg-tertiary)" : a, l;
	n[0] === c ? l = n[1] : (l = /* @__PURE__ */ h("g", {
		clipPath: "url(#clip0_20374_9174)",
		children: [/* @__PURE__ */ m("path", {
			d: "M9.99992 1.66663C8.2433 1.66654 6.55763 2.35976 5.30929 3.59562C4.06094 4.83148 3.35082 6.51009 3.33325 8.26663C3.33325 12.8333 9.20825 17.9166 9.45825 18.1333C9.6092 18.2624 9.80129 18.3333 9.99992 18.3333C10.1985 18.3333 10.3906 18.2624 10.5416 18.1333C10.8333 17.9166 16.6666 12.8333 16.6666 8.26663C16.649 6.51009 15.9389 4.83148 14.6905 3.59562C13.4422 2.35976 11.7565 1.66654 9.99992 1.66663ZM9.99992 16.375C8.60825 15.05 4.99992 11.375 4.99992 8.26663C4.99992 6.94054 5.5267 5.66877 6.46438 4.73109C7.40207 3.79341 8.67384 3.26663 9.99992 3.26663C11.326 3.26663 12.5978 3.79341 13.5355 4.73109C14.4731 5.66877 14.9999 6.94054 14.9999 8.26663C14.9999 11.35 11.3916 15.05 9.99992 16.375Z",
			fill: c
		}), /* @__PURE__ */ m("circle", {
			cx: "10.0001",
			cy: "7.91671",
			r: "2.08333",
			fill: c
		})]
	}), n[0] = c, n[1] = l);
	let u;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
		id: "clip0_20374_9174",
		children: /* @__PURE__ */ m("rect", {
			width: "20",
			height: "20",
			fill: "white"
		})
	}) }), n[2] = u) : u = n[2];
	let d;
	return n[3] !== o || n[4] !== l || n[5] !== s ? (d = /* @__PURE__ */ h("svg", {
		width: s,
		height: o,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[3] = o, n[4] = l, n[5] = s, n[6] = d) : d = n[6], d;
}, ia = (t) => {
	let n = e(8), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 16 : i, c = a === void 0 ? 16 : a, l, u;
	n[0] === o ? (l = n[1], u = n[2]) : (l = /* @__PURE__ */ m("path", {
		fill: o,
		d: "M7.99968 1.33301C6.68114 1.33301 5.3922 1.724 4.29588 2.45654C3.19955 3.18909 2.34506 4.23028 1.84048 5.44845C1.3359 6.66663 1.20387 8.00707 1.46111 9.30028C1.71834 10.5935 2.35328 11.7814 3.28563 12.7137C4.21798 13.6461 5.40587 14.281 6.69908 14.5382C7.99228 14.7955 9.33273 14.6635 10.5509 14.1589C11.7691 13.6543 12.8103 12.7998 13.5428 11.7035C14.2754 10.6071 14.6663 9.31822 14.6663 7.99967C14.6663 7.1242 14.4939 6.25729 14.1589 5.44845C13.8238 4.63961 13.3328 3.90469 12.7137 3.28563C12.0947 2.66657 11.3597 2.17551 10.5509 1.84048C9.74206 1.50545 8.87516 1.33301 7.99968 1.33301ZM7.99968 13.333C6.94484 13.333 5.9137 13.0202 5.03664 12.4342C4.15957 11.8481 3.47599 11.0152 3.07232 10.0407C2.66865 9.06611 2.56304 7.99376 2.76882 6.95919C2.97461 5.92463 3.48256 4.97432 4.22844 4.22844C4.97432 3.48256 5.92463 2.97461 6.9592 2.76882C7.99376 2.56303 9.06612 2.66865 10.0407 3.07232C11.0152 3.47598 11.8481 4.15957 12.4342 5.03663C13.0202 5.9137 13.333 6.94484 13.333 7.99967C13.333 9.41416 12.7711 10.7707 11.7709 11.7709C10.7707 12.7711 9.41417 13.333 7.99968 13.333Z"
	}), u = /* @__PURE__ */ m("path", {
		fill: o,
		d: "M10.6663 7.33366H8.66634V5.33366C8.66634 5.15685 8.5961 4.98728 8.47108 4.86225C8.34605 4.73723 8.17649 4.66699 7.99967 4.66699C7.82286 4.66699 7.65329 4.73723 7.52827 4.86225C7.40325 4.98728 7.33301 5.15685 7.33301 5.33366V8.00033C7.33301 8.17714 7.40325 8.34671 7.52827 8.47173C7.65329 8.59675 7.82286 8.66699 7.99967 8.66699H10.6663C10.8432 8.66699 11.0127 8.59675 11.1377 8.47173C11.2628 8.34671 11.333 8.17714 11.333 8.00033C11.333 7.82351 11.2628 7.65395 11.1377 7.52892C11.0127 7.4039 10.8432 7.33366 10.6663 7.33366Z"
	}), n[0] = o, n[1] = l, n[2] = u);
	let d;
	return n[3] !== s || n[4] !== l || n[5] !== u || n[6] !== c ? (d = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 16 16",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[3] = s, n[4] = l, n[5] = u, n[6] = c, n[7] = d) : d = n[7], d;
}, aa = (t) => {
	let n = e(7), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 18 : i, c = a === void 0 ? 18 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ h("g", {
		clipPath: "url(#clip0_1051_9395)",
		children: [/* @__PURE__ */ m("path", {
			d: "M6 5.5C6.39556 5.5 6.78224 5.3827 7.11114 5.16294C7.44004 4.94318 7.69638 4.63082 7.84776 4.26537C7.99913 3.89992 8.03874 3.49778 7.96157 3.10982C7.8844 2.72186 7.69392 2.36549 7.41421 2.08579C7.13451 1.80608 6.77814 1.6156 6.39018 1.53843C6.00222 1.46126 5.60009 1.50087 5.23463 1.65224C4.86918 1.80362 4.55682 2.05996 4.33706 2.38886C4.1173 2.71776 4 3.10444 4 3.5C4 4.03043 4.21071 4.53914 4.58579 4.91421C4.96086 5.28929 5.46957 5.5 6 5.5ZM6 2.5C6.19778 2.5 6.39112 2.55865 6.55557 2.66853C6.72002 2.77841 6.84819 2.93459 6.92388 3.11732C6.99957 3.30004 7.01937 3.50111 6.98079 3.69509C6.9422 3.88907 6.84696 4.06726 6.70711 4.20711C6.56725 4.34696 6.38907 4.4422 6.19509 4.48079C6.00111 4.51937 5.80004 4.49957 5.61732 4.42388C5.43459 4.34819 5.27841 4.22002 5.16853 4.05557C5.05865 3.89112 5 3.69778 5 3.5C5 3.23478 5.10536 2.98043 5.29289 2.79289C5.48043 2.60536 5.73478 2.5 6 2.5Z",
			fill: o
		}), /* @__PURE__ */ m("path", {
			d: "M6 6.5C5.07174 6.5 4.1815 6.86875 3.52513 7.52513C2.86875 8.1815 2.5 9.07174 2.5 10C2.5 10.1326 2.55268 10.2598 2.64645 10.3536C2.74021 10.4473 2.86739 10.5 3 10.5C3.13261 10.5 3.25979 10.4473 3.35355 10.3536C3.44732 10.2598 3.5 10.1326 3.5 10C3.5 9.33696 3.76339 8.70107 4.23223 8.23223C4.70107 7.76339 5.33696 7.5 6 7.5C6.66304 7.5 7.29893 7.76339 7.76777 8.23223C8.23661 8.70107 8.5 9.33696 8.5 10C8.5 10.1326 8.55268 10.2598 8.64645 10.3536C8.74021 10.4473 8.86739 10.5 9 10.5C9.13261 10.5 9.25979 10.4473 9.35355 10.3536C9.44732 10.2598 9.5 10.1326 9.5 10C9.5 9.07174 9.13125 8.1815 8.47487 7.52513C7.8185 6.86875 6.92826 6.5 6 6.5V6.5Z",
			fill: o
		})]
	}), n[0] = o, n[1] = l);
	let u;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
		id: "clip0_1051_9395",
		children: /* @__PURE__ */ m("rect", {
			width: "12",
			height: "12",
			fill: "white"
		})
	}) }), n[2] = u) : u = n[2];
	let d;
	return n[3] !== s || n[4] !== l || n[5] !== c ? (d = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 12 12",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [l, u]
	}), n[3] = s, n[4] = l, n[5] = c, n[6] = d) : d = n[6], d;
}, oa = (t) => {
	let n = e(15), { color: r, height: i, width: a, fill: o } = t, s = r === void 0 ? "var(--text-tertiary)" : r, c = i === void 0 ? 13 : i, l = a === void 0 ? 13 : a, u = o ? s : "none", d;
	n[0] === u ? d = n[1] : (d = /* @__PURE__ */ m("path", {
		d: "M15 4.5L11 8.5L7 10L5.5 11.5L12.5 18.5L14 17L15.5 13L19.5 9",
		fill: u
	}), n[0] = u, n[1] = d);
	let f = o ? s : "none", p;
	n[2] === f ? p = n[3] : (p = /* @__PURE__ */ m("path", {
		d: "M9 15L4.5 19.5L9 15Z",
		fill: f
	}), n[2] = f, n[3] = p);
	let g = o ? s : "none", _;
	n[4] === g ? _ = n[5] : (_ = /* @__PURE__ */ m("path", {
		d: "M14.5 4L20 9.5L14.5 4Z",
		fill: g
	}), n[4] = g, n[5] = _);
	let v;
	n[6] === s ? v = n[7] : (v = /* @__PURE__ */ m("path", {
		d: "M13.793 3.29295C14.1835 2.90243 14.8166 2.90243 15.2071 3.29295L20.7071 8.79295C21.0976 9.18348 21.0976 9.81649 20.7071 10.207C20.3884 10.5257 19.9084 10.5842 19.5303 10.3828L16.3604 13.5527L14.9366 17.3515C14.8864 17.4851 14.8079 17.6062 14.7071 17.707L13.2071 19.207C12.8166 19.5975 12.1835 19.5975 11.793 19.207L9.00005 16.414L5.20708 20.207C4.81655 20.5975 4.18354 20.5975 3.79302 20.207C3.40249 19.8165 3.40249 19.1835 3.79302 18.793L7.58598 15L4.79302 12.207C4.40249 11.8165 4.40249 11.1835 4.79302 10.793L6.29302 9.29295L6.37212 9.22167C6.45507 9.15474 6.54828 9.10108 6.64848 9.06346L10.4463 7.63866L13.6163 4.46874C13.4156 4.0908 13.4747 3.61128 13.793 3.29295ZM11.7071 9.20702C11.6062 9.30788 11.4851 9.38638 11.3516 9.43651L7.55278 10.8603L6.91411 11.5L12.5 17.0859L13.1387 16.4463L14.5635 12.6484C14.6137 12.5149 14.6922 12.3938 14.793 12.293L18.086 8.99999L15 5.91405L11.7071 9.20702Z",
		fill: s
	}), n[6] = s, n[7] = v);
	let y;
	return n[8] !== c || n[9] !== d || n[10] !== p || n[11] !== _ || n[12] !== v || n[13] !== l ? (y = /* @__PURE__ */ h("svg", {
		width: l,
		height: c,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			d,
			p,
			_,
			v
		]
	}), n[8] = c, n[9] = d, n[10] = p, n[11] = _, n[12] = v, n[13] = l, n[14] = y) : y = n[14], y;
}, sa = (t) => {
	let n = e(8), { color: r, height: i, width: a, onClick: o } = t, s = r === void 0 ? "var(--text-black)" : r, c = i === void 0 ? 18 : i, l = a === void 0 ? 18 : a, u;
	n[0] === s ? u = n[1] : (u = /* @__PURE__ */ h("g", {
		"clip-path": "url(#clip0_1626_95301)",
		children: [
			/* @__PURE__ */ m("path", {
				d: "M15.75 4.50006H12V3.24756C11.9824 2.76742 11.7752 2.31385 11.4237 1.98628C11.0722 1.6587 10.6052 1.48385 10.125 1.50006H7.875C7.39482 1.48385 6.9278 1.6587 6.57632 1.98628C6.22485 2.31385 6.01759 2.76742 6 3.24756V4.50006H2.25C2.05109 4.50006 1.86032 4.57908 1.71967 4.71973C1.57902 4.86038 1.5 5.05114 1.5 5.25006C1.5 5.44897 1.57902 5.63974 1.71967 5.78039C1.86032 5.92104 2.05109 6.00006 2.25 6.00006H3V14.2501C3 14.8468 3.23705 15.4191 3.65901 15.841C4.08097 16.263 4.65326 16.5001 5.25 16.5001H12.75C13.3467 16.5001 13.919 16.263 14.341 15.841C14.7629 15.4191 15 14.8468 15 14.2501V6.00006H15.75C15.9489 6.00006 16.1397 5.92104 16.2803 5.78039C16.421 5.63974 16.5 5.44897 16.5 5.25006C16.5 5.05114 16.421 4.86038 16.2803 4.71973C16.1397 4.57908 15.9489 4.50006 15.75 4.50006ZM7.5 3.24756C7.5 3.12756 7.6575 3.00006 7.875 3.00006H10.125C10.3425 3.00006 10.5 3.12756 10.5 3.24756V4.50006H7.5V3.24756ZM13.5 14.2501C13.5 14.449 13.421 14.6397 13.2803 14.7804C13.1397 14.921 12.9489 15.0001 12.75 15.0001H5.25C5.05109 15.0001 4.86032 14.921 4.71967 14.7804C4.57902 14.6397 4.5 14.449 4.5 14.2501V6.00006H13.5V14.2501Z",
				fill: s
			}),
			/* @__PURE__ */ m("path", {
				d: "M6.75 12.75C6.94891 12.75 7.13968 12.671 7.28033 12.5303C7.42098 12.3897 7.5 12.1989 7.5 12V9C7.5 8.80109 7.42098 8.61032 7.28033 8.46967C7.13968 8.32902 6.94891 8.25 6.75 8.25C6.55109 8.25 6.36032 8.32902 6.21967 8.46967C6.07902 8.61032 6 8.80109 6 9V12C6 12.1989 6.07902 12.3897 6.21967 12.5303C6.36032 12.671 6.55109 12.75 6.75 12.75Z",
				fill: s
			}),
			/* @__PURE__ */ m("path", {
				d: "M11.25 12.75C11.4489 12.75 11.6397 12.671 11.7803 12.5303C11.921 12.3897 12 12.1989 12 12V9C12 8.80109 11.921 8.61032 11.7803 8.46967C11.6397 8.32902 11.4489 8.25 11.25 8.25C11.0511 8.25 10.8603 8.32902 10.7197 8.46967C10.579 8.61032 10.5 8.80109 10.5 9V12C10.5 12.1989 10.579 12.3897 10.7197 12.5303C10.8603 12.671 11.0511 12.75 11.25 12.75Z",
				fill: s
			})
		]
	}), n[0] = s, n[1] = u);
	let d;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", {
		id: "clip0_1626_95301",
		children: /* @__PURE__ */ m("rect", {
			width: "18",
			height: "18",
			fill: "white"
		})
	}) }), n[2] = d) : d = n[2];
	let f;
	return n[3] !== c || n[4] !== o || n[5] !== u || n[6] !== l ? (f = /* @__PURE__ */ h("svg", {
		width: l,
		height: c,
		viewBox: "0 0 18 18",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		onClick: o,
		children: [u, d]
	}), n[3] = c, n[4] = o, n[5] = u, n[6] = l, n[7] = f) : f = n[7], f;
}, ca = (t) => {
	let n = e(6), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 20 : i, c = a === void 0 ? 20 : a, l;
	n[0] === o ? l = n[1] : (l = /* @__PURE__ */ m("path", {
		d: "M14.1708 15.8311H5.83745V11.25C5.83745 10.7898 5.46436 10.4167 5.00412 10.4167C4.54388 10.4167 4.17079 10.7898 4.17079 11.25V15.8311C4.17079 16.7516 4.91698 17.4978 5.83745 17.4978H14.1708C15.0893 17.4951 15.8325 16.7497 15.8325 15.8311V11.25C15.8325 10.7898 15.4594 10.4167 14.9991 10.4167C14.5389 10.4167 14.1658 10.7898 14.1658 11.25L14.1708 15.8311ZM16.1474 9.80616C16.316 9.95016 16.5364 10.0187 16.7569 9.99566C16.9774 9.97266 17.1788 9.86018 17.3141 9.68449C17.6045 9.31291 17.5533 8.77901 17.1974 8.46949L10.5766 2.71949C10.2361 2.42684 9.73292 2.42684 9.39244 2.71949L2.80494 8.44616C2.44926 8.75565 2.39766 9.28924 2.68744 9.66116C2.82285 9.83664 3.02425 9.94896 3.24471 9.97196C3.46516 9.99495 3.68541 9.92659 3.85411 9.78282L9.99494 4.45949L16.1416 9.81032L16.1474 9.80616ZM10.0191 13.3228C10.9362 13.3201 11.6776 12.5749 11.6758 11.6578C11.6739 10.7408 10.9295 9.99857 10.0125 9.99949C9.0954 10.0004 8.35246 10.7441 8.35246 11.6612C8.35521 12.5797 9.1006 13.3228 10.0191 13.3228V13.3228V13.3228Z",
		fill: o
	}), n[0] = o, n[1] = l);
	let u;
	return n[2] !== s || n[3] !== l || n[4] !== c ? (u = /* @__PURE__ */ m("svg", {
		width: c,
		height: s,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: l
	}), n[2] = s, n[3] = l, n[4] = c, n[5] = u) : u = n[5], u;
}, la = (t) => {
	let n = e(10), { color: r, height: i, width: a } = t, o = r === void 0 ? "var(--text-black)" : r, s = i === void 0 ? 20 : i, c = a === void 0 ? 20 : a, l, u, d;
	n[0] === o ? (l = n[1], u = n[2], d = n[3]) : (l = /* @__PURE__ */ m("path", {
		d: "M12.4993 13.3333H7.49935C7.27834 13.3333 7.06637 13.4211 6.91009 13.5774C6.75381 13.7337 6.66602 13.9456 6.66602 14.1666C6.66602 14.3877 6.75381 14.5996 6.91009 14.7559C7.06637 14.9122 7.27834 15 7.49935 15H12.4993C12.7204 15 12.9323 14.9122 13.0886 14.7559C13.2449 14.5996 13.3327 14.3877 13.3327 14.1666C13.3327 13.9456 13.2449 13.7337 13.0886 13.5774C12.9323 13.4211 12.7204 13.3333 12.4993 13.3333Z",
		fill: o
	}), u = /* @__PURE__ */ m("path", {
		d: "M7.49935 11.6667H9.99935C10.2204 11.6667 10.4323 11.5789 10.5886 11.4226C10.7449 11.2663 10.8327 11.0543 10.8327 10.8333C10.8327 10.6123 10.7449 10.4004 10.5886 10.2441C10.4323 10.0878 10.2204 10 9.99935 10H7.49935C7.27834 10 7.06637 10.0878 6.91009 10.2441C6.75381 10.4004 6.66602 10.6123 6.66602 10.8333C6.66602 11.0543 6.75381 11.2663 6.91009 11.4226C7.06637 11.5789 7.27834 11.6667 7.49935 11.6667Z",
		fill: o
	}), d = /* @__PURE__ */ m("path", {
		d: "M16.4507 6.94165L11.9173 1.94165C11.8394 1.85533 11.7443 1.78626 11.6381 1.7389C11.5319 1.69154 11.4169 1.66693 11.3007 1.66665H5.46732C5.19044 1.66335 4.91563 1.71462 4.65857 1.81753C4.40151 1.92045 4.16724 2.07299 3.96914 2.26645C3.77103 2.45991 3.61298 2.6905 3.504 2.94504C3.39502 3.19959 3.33725 3.47311 3.33398 3.74999V16.25C3.33725 16.5269 3.39502 16.8004 3.504 17.0549C3.61298 17.3095 3.77103 17.5401 3.96914 17.7335C4.16724 17.927 4.40151 18.0795 4.65857 18.1824C4.91563 18.2854 5.19044 18.3366 5.46732 18.3333H14.534C14.8109 18.3366 15.0857 18.2854 15.3427 18.1824C15.5998 18.0795 15.8341 17.927 16.0322 17.7335C16.2303 17.5401 16.3883 17.3095 16.4973 17.0549C16.6063 16.8004 16.6641 16.5269 16.6673 16.25V7.49999C16.6668 7.29346 16.5896 7.09449 16.4507 6.94165ZM11.6673 4.16665L13.9507 6.66665H12.284C12.1967 6.66139 12.1114 6.63879 12.0329 6.60018C11.9545 6.56157 11.8845 6.50773 11.8271 6.44179C11.7697 6.37585 11.726 6.29914 11.6986 6.21613C11.6711 6.13312 11.6605 6.04548 11.6673 5.95832V4.16665ZM14.534 16.6667H5.46732C5.4093 16.67 5.35118 16.6619 5.2963 16.6428C5.24141 16.6237 5.19085 16.5939 5.14749 16.5552C5.10414 16.5165 5.06885 16.4696 5.04365 16.4172C5.01846 16.3649 5.00384 16.308 5.00065 16.25V3.74999C5.00384 3.69196 5.01846 3.63512 5.04365 3.58275C5.06885 3.53038 5.10414 3.48349 5.14749 3.44479C5.19085 3.40608 5.24141 3.37631 5.2963 3.35718C5.35118 3.33805 5.4093 3.32994 5.46732 3.33332H10.0007V5.95832C9.9872 6.57217 10.2171 7.16643 10.6402 7.61138C11.0633 8.05633 11.6452 8.31586 12.259 8.33332H15.0007V16.25C14.9975 16.308 14.9828 16.3649 14.9576 16.4172C14.9324 16.4696 14.8972 16.5165 14.8538 16.5552C14.8105 16.5939 14.7599 16.6237 14.705 16.6428C14.6501 16.6619 14.592 16.67 14.534 16.6667Z",
		fill: o
	}), n[0] = o, n[1] = l, n[2] = u, n[3] = d);
	let f;
	return n[4] !== s || n[5] !== l || n[6] !== u || n[7] !== d || n[8] !== c ? (f = /* @__PURE__ */ h("svg", {
		width: c,
		height: s,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			l,
			u,
			d
		]
	}), n[4] = s, n[5] = l, n[6] = u, n[7] = d, n[8] = c, n[9] = f) : f = n[9], f;
}, ua = (t) => {
	let n = e(12), r, i, a, o;
	n[0] === t ? (r = n[1], i = n[2], a = n[3], o = n[4]) : ({color: i, height: a, width: o, ...r} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o);
	let s = i === void 0 ? "var(--text-primary)" : i, c = a === void 0 ? 20 : a, l = o === void 0 ? 20 : o, u;
	n[5] === s ? u = n[6] : (u = /* @__PURE__ */ m("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.993 10.1683C18.9976 10.1128 19 10.0567 19 10V7C19 5.34315 17.6569 4 16 4H8C6.34315 4 5 5.34315 5 7V10C5 10.0567 5.00236 10.1128 5.00698 10.1682C3.83814 10.5781 3 11.6912 3 13V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V17H19V18C19 18.5523 19.4477 19 20 19C20.5523 19 21 18.5523 21 18V13C21 11.6912 20.1619 10.5781 18.993 10.1683ZM6 12C5.44772 12 5 12.4477 5 13V15H19V13C19 12.4477 18.5523 12 18 12H6ZM7 7.17071V7C7 6.44772 7.44772 6 8 6H16C16.5523 6 17 6.44772 17 7V7.17071C16.6872 7.06015 16.3506 7 16 7H14C13.2316 7 12.5308 7.28885 12 7.7639C11.4692 7.28885 10.7684 7 10 7H8C7.64936 7 7.31278 7.06015 7 7.17071ZM13 10H17C17 9.44772 16.5523 9 16 9H14C13.4477 9 13 9.44772 13 10ZM10 9C10.5523 9 11 9.44772 11 10H7C7 9.44772 7.44772 9 8 9H10Z",
		fill: s
	}), n[5] = s, n[6] = u);
	let d;
	return n[7] !== c || n[8] !== r || n[9] !== u || n[10] !== l ? (d = /* @__PURE__ */ m("svg", {
		width: l,
		height: c,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...r,
		children: u
	}), n[7] = c, n[8] = r, n[9] = u, n[10] = l, n[11] = d) : d = n[11], d;
}, da = (t) => {
	let n = e(12), r, i, a, o;
	n[0] === t ? (r = n[1], i = n[2], a = n[3], o = n[4]) : ({color: i, height: a, width: o, ...r} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o);
	let s = i === void 0 ? "var(--text-primary)" : i, c = a === void 0 ? 20 : a, l = o === void 0 ? 20 : o, u;
	n[5] === s ? u = n[6] : (u = /* @__PURE__ */ m("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.6667 6C15.1144 6 14.6667 6.44772 14.6667 7V7.33333C14.6667 7.88562 14.2189 8.33333 13.6667 8.33333C13.1144 8.33333 12.6667 7.88562 12.6667 7.33333V7C12.6667 5.34315 14.0098 4 15.6667 4C17.3235 4 18.6667 5.34315 18.6667 7V10H20.6667C21.219 10 21.6667 10.4477 21.6667 11C21.6667 11.5523 21.219 12 20.6667 12V13.5C20.6667 14.9826 19.9497 16.2977 18.8435 17.1176L19.5611 18.5528C19.8081 19.0467 19.6079 19.6474 19.1139 19.8944C18.6199 20.1414 18.0193 19.9412 17.7723 19.4472L17.0093 17.9212C16.7363 17.9729 16.4547 18 16.1667 18H9.28471L8.56112 19.4472C8.31413 19.9412 7.71345 20.1414 7.21948 19.8944C6.7255 19.6474 6.52527 19.0467 6.77226 18.5528L7.26 17.5773C5.72788 16.8596 4.66666 15.3037 4.66666 13.5V12C4.11438 12 3.66666 11.5523 3.66666 11C3.66666 10.4477 4.11438 10 4.66666 10H6.66666H16.6667V7C16.6667 6.44772 16.2189 6 15.6667 6ZM6.66666 12V13.5C6.66666 13.6712 6.68388 13.8384 6.71667 14C6.94831 15.1411 7.95719 16 9.16666 16H16.1667C17.3761 16 18.385 15.1411 18.6167 14C18.6494 13.8384 18.6667 13.6712 18.6667 13.5V12H17.6667H6.66666Z",
		fill: s
	}), n[5] = s, n[6] = u);
	let d;
	return n[7] !== c || n[8] !== r || n[9] !== u || n[10] !== l ? (d = /* @__PURE__ */ m("svg", {
		width: l,
		height: c,
		viewBox: "0 0 25 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...r,
		children: u
	}), n[7] = c, n[8] = r, n[9] = u, n[10] = l, n[11] = d) : d = n[11], d;
}, fa = (t) => {
	let n = e(18), r, i, a, o;
	n[0] === t ? (r = n[1], i = n[2], a = n[3], o = n[4]) : ({color: i, height: a, width: o, ...r} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o);
	let s = i === void 0 ? "var(--text-primary)" : i, c = a === void 0 ? 20 : a, l = o === void 0 ? 20 : o, u, d, f, p;
	n[5] === s ? (u = n[6], d = n[7], f = n[8], p = n[9]) : (u = /* @__PURE__ */ m("path", {
		d: "M9.33333 14C9.33333 13.4477 9.78104 13 10.3333 13H14.3333C14.8856 13 15.3333 13.4477 15.3333 14C15.3333 14.5523 14.8856 15 14.3333 15H10.3333C9.78104 15 9.33333 14.5523 9.33333 14Z",
		fill: s
	}), d = /* @__PURE__ */ m("path", {
		d: "M6.33333 14C6.33333 13.4477 6.78104 13 7.33333 13C7.88561 13 8.33333 13.4477 8.33333 14C8.33333 14.5523 7.88561 15 7.33333 15C6.78104 15 6.33333 14.5523 6.33333 14Z",
		fill: s
	}), f = /* @__PURE__ */ m("path", {
		d: "M17.3333 13C16.781 13 16.3333 13.4477 16.3333 14C16.3333 14.5523 16.781 15 17.3333 15C17.8856 15 18.3333 14.5523 18.3333 14C18.3333 13.4477 17.8856 13 17.3333 13Z",
		fill: s
	}), p = /* @__PURE__ */ m("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.42347 9.48453L5.88638 7.40142C6.26096 5.71579 7.67493 4.46081 9.39311 4.289L10.3432 4.19398C11.6667 4.06164 13 4.06164 14.3234 4.19398L15.2735 4.289C16.9917 4.46081 18.4057 5.71579 18.7803 7.40142L19.2432 9.48452C20.4883 10.1624 21.3333 11.4825 21.3333 13V15C21.3333 16.3062 20.4985 17.4175 19.3333 17.8293V18.5C19.3333 19.3284 18.6618 20 17.8333 20H16.8333C16.0049 20 15.3333 19.3284 15.3333 18.5V18H9.33333V18.5C9.33333 19.3284 8.66176 20 7.83333 20H6.83333C6.0049 20 5.33333 19.3284 5.33333 18.5V17.8293C4.16814 17.4175 3.33333 16.3062 3.33333 15V13C3.33333 11.4825 4.17833 10.1624 5.42347 9.48453ZM10.5423 6.18406C11.7333 6.06495 12.9333 6.06495 14.1244 6.18406L15.0745 6.27907C15.9336 6.36498 16.6406 6.99247 16.8279 7.83528L17.0867 9H7.57993L7.83875 7.83528C8.02604 6.99247 8.73303 6.36498 9.59212 6.27907L10.5423 6.18406ZM6.33333 16H18.3333C18.8856 16 19.3333 15.5523 19.3333 15V13C19.3333 11.8954 18.4379 11 17.3333 11H7.33333C6.22876 11 5.33333 11.8954 5.33333 13V15C5.33333 15.5523 5.78104 16 6.33333 16Z",
		fill: s
	}), n[5] = s, n[6] = u, n[7] = d, n[8] = f, n[9] = p);
	let g;
	return n[10] !== c || n[11] !== r || n[12] !== u || n[13] !== d || n[14] !== f || n[15] !== p || n[16] !== l ? (g = /* @__PURE__ */ h("svg", {
		width: l,
		height: c,
		viewBox: "0 0 25 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...r,
		children: [
			u,
			d,
			f,
			p
		]
	}), n[10] = c, n[11] = r, n[12] = u, n[13] = d, n[14] = f, n[15] = p, n[16] = l, n[17] = g) : g = n[17], g;
}, pa = (t) => {
	let n = e(12), r, i, a, o;
	n[0] === t ? (r = n[1], i = n[2], a = n[3], o = n[4]) : ({color: i, height: a, width: o, ...r} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o);
	let s = i === void 0 ? "var(--text-primary)" : i, c = a === void 0 ? 20 : a, l = o === void 0 ? 20 : o, u;
	n[5] === s ? u = n[6] : (u = /* @__PURE__ */ m("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.74416 5.58926C2.41872 5.26382 2.41872 4.73618 2.74416 4.41074L4.41083 2.74408C4.73626 2.41864 5.2639 2.41864 5.58934 2.74408L7.256 4.41074C7.58144 4.73618 7.58144 5.26382 7.256 5.58926C6.93057 5.91469 6.40293 5.91469 6.07749 5.58926L5.83342 5.34518L5.83341 13.3333H13.8216L13.5775 13.0893C13.2521 12.7638 13.2521 12.2362 13.5775 11.9107C13.9029 11.5853 14.4306 11.5853 14.756 11.9107L16.4227 13.5774C16.7481 13.9028 16.7481 14.4305 16.4227 14.7559L14.756 16.4226C14.4306 16.748 13.9029 16.748 13.5775 16.4226C13.2521 16.0972 13.2521 15.5695 13.5775 15.2441L13.8216 15H5.83341V16.6667C5.83341 17.1269 5.46032 17.5 5.00008 17.5C4.53984 17.5 4.16675 17.1269 4.16675 16.6667V15H2.50008C2.03984 15 1.66675 14.6269 1.66675 14.1667C1.66675 13.7064 2.03984 13.3333 2.50008 13.3333H4.16675V5.34518L3.92267 5.58926C3.59723 5.91469 3.0696 5.91469 2.74416 5.58926ZM9.16675 2.5C8.70651 2.5 8.33341 2.8731 8.33341 3.33333C8.33341 3.79357 8.70651 4.16667 9.16675 4.16667H10.8334C11.2937 4.16667 11.6667 3.79357 11.6667 3.33333C11.6667 2.8731 11.2937 2.5 10.8334 2.5H9.16675ZM15.8334 7.5C16.2937 7.5 16.6667 7.8731 16.6667 8.33333V10C16.6667 10.4602 16.2937 10.8333 15.8334 10.8333C15.3732 10.8333 15.0001 10.4602 15.0001 10V8.33333C15.0001 7.8731 15.3732 7.5 15.8334 7.5ZM14.1667 2.5C13.7065 2.5 13.3334 2.8731 13.3334 3.33333C13.3334 3.79357 13.7065 4.16667 14.1667 4.16667C14.627 4.16667 15.0001 4.53976 15.0001 5C15.0001 5.46024 15.3732 5.83333 15.8334 5.83333C16.2937 5.83333 16.6667 5.46024 16.6667 5C16.6667 3.61929 15.5475 2.5 14.1667 2.5Z",
		fill: s
	}), n[5] = s, n[6] = u);
	let d;
	return n[7] !== c || n[8] !== r || n[9] !== u || n[10] !== l ? (d = /* @__PURE__ */ m("svg", {
		width: l,
		height: c,
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...r,
		children: u
	}), n[7] = c, n[8] = r, n[9] = u, n[10] = l, n[11] = d) : d = n[11], d;
}, ma = (t) => {
	let n = e(12), r, i, a, o;
	n[0] === t ? (r = n[1], i = n[2], a = n[3], o = n[4]) : ({color: i, height: a, width: o, ...r} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o);
	let s = i === void 0 ? "var(--text-primary)" : i, c = a === void 0 ? 20 : a, l = o === void 0 ? 20 : o, u;
	n[5] === s ? u = n[6] : (u = /* @__PURE__ */ m("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.5 3C4.96957 3 4.46086 3.21071 4.08579 3.58579C3.71071 3.96086 3.5 4.46957 3.5 5V19C3.5 19.5304 3.71071 20.0391 4.08579 20.4142C4.46086 20.7893 4.96957 21 5.5 21H10.5C11.0304 21 11.5391 20.7893 11.9142 20.4142C12.2893 20.0391 12.5 19.5304 12.5 19V12H19.5C20.0304 12 20.5391 11.7893 20.9142 11.4142C21.2893 11.0391 21.5 10.5304 21.5 10V5C21.5 4.46957 21.2893 3.96086 20.9142 3.58579C20.5391 3.21071 20.0304 3 19.5 3H5.5ZM6.5 9H5.5V11H7.5C8.05228 11 8.5 11.4477 8.5 12C8.5 12.5523 8.05228 13 7.5 13H5.5V15H6.5C7.05228 15 7.5 15.4477 7.5 16C7.5 16.5523 7.05228 17 6.5 17H5.5V19H10.5V12C10.5 11.4696 10.7107 10.9609 11.0858 10.5858C11.4609 10.2107 11.9696 10 12.5 10H19.5V5L17.5 5V6C17.5 6.55228 17.0523 7 16.5 7C15.9477 7 15.5 6.55228 15.5 6V5H13.5V7C13.5 7.55228 13.0523 8 12.5 8C11.9477 8 11.5 7.55228 11.5 7V5H9.5V6C9.5 6.55228 9.05228 7 8.5 7C7.94772 7 7.5 6.55228 7.5 6V5L5.5 5L5.5 7H6.5C7.05228 7 7.5 7.44772 7.5 8C7.5 8.55228 7.05228 9 6.5 9Z",
		fill: s
	}), n[5] = s, n[6] = u);
	let d;
	return n[7] !== c || n[8] !== r || n[9] !== u || n[10] !== l ? (d = /* @__PURE__ */ m("svg", {
		width: l,
		height: c,
		viewBox: "0 0 25 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...r,
		children: u
	}), n[7] = c, n[8] = r, n[9] = u, n[10] = l, n[11] = d) : d = n[11], d;
}, ha = (n) => {
	let r = e(15), { totalLevels: i, currentLevel: a, labels: o, size: s, showLines: c } = n, l = s === void 0 ? "small" : s, u = c === void 0 ? !0 : c, d;
	r[0] !== o || r[1] !== i ? (d = o ?? Array.from({ length: i }, ga), r[0] = o, r[1] = i, r[2] = d) : d = r[2];
	let p = d, g = f(l), _;
	if (r[3] !== a || r[4] !== u || r[5] !== g || r[6] !== p) {
		let e;
		r[8] !== a || r[9] !== u || r[10] !== g || r[11] !== p.length ? (e = (e, n) => {
			let r = n + 1, i = r === a, o = r < a, s = n === p.length - 1;
			return /* @__PURE__ */ h(t.Fragment, { children: [/* @__PURE__ */ m("div", {
				className: f("circle", {
					active: i,
					completed: o,
					[g]: !0
				}),
				children: o ? /* @__PURE__ */ m(Ki, { color: "var(--fg-brand-main)" }) : /* @__PURE__ */ m(Q, {
					id: "index",
					size: "medium",
					type: "caption",
					children: e
				})
			}), !s && /* @__PURE__ */ m("div", {
				className: "connector",
				children: u && /* @__PURE__ */ m(na, {
					width: 80,
					height: 2
				})
			})] }, n);
		}, r[8] = a, r[9] = u, r[10] = g, r[11] = p.length, r[12] = e) : e = r[12], _ = p.map(e), r[3] = a, r[4] = u, r[5] = g, r[6] = p, r[7] = _;
	} else _ = r[7];
	let v;
	return r[13] === _ ? v = r[14] : (v = /* @__PURE__ */ m("div", {
		className: "steps-indicator",
		children: _
	}), r[13] = _, r[14] = v), v;
};
function ga(e, t) {
	return (t + 1).toString();
}
//#endregion
//#region src/components/display/Alerts/InformationAlert/InformationAlert.tsx
var _a = (t) => {
	let n = e(17), { alert: r, dismissAlert: i, hideDismissButton: a } = t, o = a === void 0 ? !1 : a, s;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m(Ti, {
		type: "warning",
		height: 18,
		width: 18
	}), n[0] = s) : s = n[0];
	let c = `action-alert-heading-${r.id}`, l = r.title ? ":" : "", u;
	n[1] !== r.heading || n[2] !== c || n[3] !== l ? (u = /* @__PURE__ */ h(Q, {
		type: "body_ui_strong",
		size: "small",
		id: c,
		color: "var(--text-warning, #ba740b)",
		children: [r.heading, l]
	}), n[1] = r.heading, n[2] = c, n[3] = l, n[4] = u) : u = n[4];
	let d;
	n[5] === r.title ? d = n[6] : (d = r.title && /* @__PURE__ */ h(Q, {
		type: "body_ui",
		size: "small",
		id: `action-alert-title-${r.title}`,
		color: "var(--text-warning, #ba740b)",
		children: [" ", r.title]
	}), n[5] = r.title, n[6] = d);
	let f;
	n[7] !== u || n[8] !== d ? (f = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-md",
		fill: !0,
		className: "information-alert-textContainer",
		children: [s, /* @__PURE__ */ h("span", { children: [u, d] })]
	}), n[7] = u, n[8] = d, n[9] = f) : f = n[9];
	let p;
	n[10] !== r.id || n[11] !== i || n[12] !== o ? (p = !o && /* @__PURE__ */ m(Kl, {
		id: `information-alert-dismiss-${r.id}`,
		text: "Dismiss",
		variant: "white",
		size: "small",
		onClick: () => i(r.id),
		dataTestId: `information-alert-dismiss-${r.id}`
	}), n[10] = r.id, n[11] = i, n[12] = o, n[13] = p) : p = n[13];
	let g;
	return n[14] !== f || n[15] !== p ? (g = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-md",
		padding: "spacing-xl",
		contentJustification: "space-between",
		contentAlignment: "center",
		className: "alerts-informationAlert",
		fill: !0,
		children: [f, p]
	}), n[14] = f, n[15] = p, n[16] = g) : g = n[16], g;
}, va = (t) => {
	let n = e(25), { alert: r } = t, i;
	n[0] === r.solveElementId ? i = n[1] : (i = () => {
		document.getElementById(r.solveElementId)?.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	}, n[0] = r.solveElementId, n[1] = i);
	let a = i, o;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m(Ti, {
		type: "information",
		height: 18,
		width: 18
	}), n[2] = o) : o = n[2];
	let s = `action-alert-heading-${r.id}`, c;
	n[3] !== r.heading || n[4] !== s ? (c = /* @__PURE__ */ m(Q, {
		type: "body_ui_strong",
		size: "small",
		id: s,
		color: "var(--text-action, #1765ad)",
		children: r.heading
	}), n[3] = r.heading, n[4] = s, n[5] = c) : c = n[5];
	let l = `action-alert-title-${r.title}`, u;
	n[6] !== r.title || n[7] !== l ? (u = /* @__PURE__ */ h(Q, {
		type: "body_ui",
		size: "small",
		id: l,
		color: "var(--text-action, #1765ad)",
		children: [" ", r.title]
	}), n[6] = r.title, n[7] = l, n[8] = u) : u = n[8];
	let d;
	n[9] !== c || n[10] !== u ? (d = /* @__PURE__ */ h("span", { children: [c, u] }), n[9] = c, n[10] = u, n[11] = d) : d = n[11];
	let f = `action-alert-desc-${r.id}`, p;
	n[12] !== r.description || n[13] !== f ? (p = /* @__PURE__ */ m(Q, {
		id: f,
		type: "body_ui",
		size: "small",
		color: "var(--text-action, #1765ad)",
		children: r.description
	}), n[12] = r.description, n[13] = f, n[14] = p) : p = n[14];
	let g;
	n[15] !== d || n[16] !== p ? (g = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-sm",
		fill: !0,
		className: "action-alert-textContainer",
		children: [d, p]
	}), n[15] = d, n[16] = p, n[17] = g) : g = n[17];
	let _ = `action-alert-solve-${r.id}`, v = `action-alert-solve-${r.id}`, y;
	n[18] !== a || n[19] !== _ || n[20] !== v ? (y = /* @__PURE__ */ m(Kl, {
		id: _,
		text: "Solve",
		variant: "white",
		size: "small",
		onClick: a,
		dataTestId: v
	}), n[18] = a, n[19] = _, n[20] = v, n[21] = y) : y = n[21];
	let b;
	return n[22] !== g || n[23] !== y ? (b = /* @__PURE__ */ m($, {
		direction: "horizontal",
		gap: "spacing-md",
		padding: "spacing-xl",
		contentJustification: "space-between",
		className: "alerts-actionAlert",
		fill: !0,
		children: /* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "spacing-md",
			fill: !0,
			children: [
				o,
				g,
				y
			]
		})
	}), n[22] = g, n[23] = y, n[24] = b) : b = n[24], b;
}, ya = (t) => {
	let n = e(10), { alert: r } = t, i;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ m(Ti, {
		type: "danger",
		height: 18,
		width: 18
	}), n[0] = i) : i = n[0];
	let a = `action-alert-heading-${r.id}`, o;
	n[1] !== r.heading || n[2] !== a ? (o = /* @__PURE__ */ m(Q, {
		type: "body_ui_strong",
		size: "small",
		id: a,
		color: "var(--text-error)",
		children: r.heading
	}), n[1] = r.heading, n[2] = a, n[3] = o) : o = n[3];
	let s = `action-alert-title-${r.title}`, c;
	n[4] !== r.title || n[5] !== s ? (c = /* @__PURE__ */ h(Q, {
		type: "body_ui",
		size: "small",
		id: s,
		color: "var(--text-error)",
		children: [" ", r.title]
	}), n[4] = r.title, n[5] = s, n[6] = c) : c = n[6];
	let l;
	return n[7] !== o || n[8] !== c ? (l = /* @__PURE__ */ h($, {
		direction: "horizontal",
		padding: "spacing-xl",
		gap: "spacing-md",
		fill: !0,
		className: "error-alert-textContainer",
		children: [i, /* @__PURE__ */ h("span", { children: [o, c] })]
	}), n[7] = o, n[8] = c, n[9] = l) : l = n[9], l;
}, ba = (t) => {
	let n = e(26), { id: r, dismissedAlertIds: i, alerts: a, hideDismissButton: o, onValueChanged: s } = t, c;
	n[0] === i ? c = n[1] : (c = i === void 0 ? [] : i, n[0] = i, n[1] = c);
	let l = c, u, d, f, p, g, _;
	if (n[2] !== l || n[3] !== r || n[4] !== s || n[5] !== a || n[6] !== o) {
		let e = a === void 0 ? [] : a, t = o === void 0 ? !1 : o, i;
		n[13] === l ? i = n[14] : (i = (e) => e.alertType === "Information" && !l.includes(e.id), n[13] = l, n[14] = i);
		let c = e.filter(i), h = e.filter(xa), v = e.filter(Sa), y;
		n[15] !== l || n[16] !== r || n[17] !== s ? (y = (e) => {
			s({
				id: r,
				value: [...l, e]
			});
		}, n[15] = l, n[16] = r, n[17] = s, n[18] = y) : y = n[18];
		let b = y;
		u = $, d = "vertical", f = "spacing-lg", p = c?.map((e) => /* @__PURE__ */ m(_a, {
			alert: e,
			dismissAlert: b,
			hideDismissButton: t
		}, `informationAlert-${e.id}`)), g = h?.map(Ca), _ = v?.map(wa), n[2] = l, n[3] = r, n[4] = s, n[5] = a, n[6] = o, n[7] = u, n[8] = d, n[9] = f, n[10] = p, n[11] = g, n[12] = _;
	} else u = n[7], d = n[8], f = n[9], p = n[10], g = n[11], _ = n[12];
	let v;
	return n[19] !== u || n[20] !== d || n[21] !== f || n[22] !== p || n[23] !== g || n[24] !== _ ? (v = /* @__PURE__ */ h(u, {
		direction: d,
		gap: f,
		children: [
			p,
			g,
			_
		]
	}), n[19] = u, n[20] = d, n[21] = f, n[22] = p, n[23] = g, n[24] = _, n[25] = v) : v = n[25], v;
};
function xa(e) {
	return e.alertType === "Action";
}
function Sa(e) {
	return e.alertType === "Error";
}
function Ca(e) {
	return /* @__PURE__ */ m(va, { alert: e }, `actionAlert-${e.id}`);
}
function wa(e) {
	return /* @__PURE__ */ m(ya, { alert: e }, `errorAlert-${e.id}`);
}
//#endregion
//#region src/utils/stringUtils.ts
var Ta = (e) => !e || e.length === 0 ? e : e.charAt(0).toLowerCase() + e.slice(1), Ea = (e) => !e || e.length === 0 ? e : e.charAt(0).toUpperCase() + e.slice(1).toLowerCase(), Da = (e) => {
	if (!e) return "";
	let t = e.replace(/[_-]/g, " ");
	return t = t.replace(/([a-z])([A-Z])/g, "$1 $2"), t.split(" ").map((e) => /^[A-Z]{2,}$/.test(e) ? e : e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()).join(" ");
}, Oa = (e = "", t) => e.length > t ? `${e.slice(0, t)}...` : e, ka = (t) => {
	let n = e(49), { title: r, customTitle: i, actionContent: a, dividerContent: s, content: c, open: l, variant: g, iconPosition: _, enableToggle: v, headerPadding: y, contentPadding: b, backgroundColor: x, isContentFit: S, maxTitleLegth: C, showBorder: w, smoothTransition: T } = t, E = _ === void 0 ? "right" : _, D = v === void 0 ? !1 : v, O = x === void 0 ? "primary" : x, k = S === void 0 ? !1 : S, A = C === void 0 ? void 0 : C, j = w === void 0 ? !1 : w, M = T === void 0 ? !1 : T, [N, P] = d(!!l), [F, I] = d(N ? "none" : "0px"), L = u(null), R = je(y), z = je(b), B = O ? "bg-" + O : "", V;
	n[0] !== D || n[1] !== N ? (V = () => {
		D && P(!N);
	}, n[0] = D, n[1] = N, n[2] = V) : V = n[2];
	let H = V, U, W;
	n[3] === l ? (U = n[4], W = n[5]) : (W = () => {
		P(!!l);
	}, U = [l], n[3] = l, n[4] = U, n[5] = W), o(W, U);
	let G;
	n[6] !== N || n[7] !== M ? (G = () => {
		if (!M || !L.current) return;
		if (N) {
			I(`${L.current.scrollHeight}px`);
			return;
		}
		I(`${L.current.scrollHeight}px`);
		let e = window.requestAnimationFrame(() => {
			I("0px");
		});
		return () => {
			window.cancelAnimationFrame(e);
		};
	}, n[6] = N, n[7] = M, n[8] = G) : G = n[8];
	let K;
	n[9] !== c || n[10] !== N || n[11] !== M ? (K = [
		N,
		M,
		c
	], n[9] = c, n[10] = N, n[11] = M, n[12] = K) : K = n[12], o(G, K);
	let q = M || N, J = `collapsible ${N ? "open" : ""}`, Y = N ? "open" : "closed", X = M && "collapsible-smooth-transition", Z = j && "withBorder", ee;
	n[13] !== B || n[14] !== Y || n[15] !== X || n[16] !== Z ? (ee = f("collapsible", B, Y, X, Z), n[13] = B, n[14] = Y, n[15] = X, n[16] = Z, n[17] = ee) : ee = n[17];
	let te = `${y ? R.join(" ") : "default-header-padding"}`, ne = `headerdirection-${E}`, re = `header-${g}`, ie = `collapsible-header-${N ? "open" : "closed"}`, ae = `collapsible-header-${D ? "enableToggle" : "disableToggle"}`, oe = `${s ? "collapsible-header-noBorder" : ""}`, se;
	n[18] !== te || n[19] !== ne || n[20] !== re || n[21] !== ie || n[22] !== ae || n[23] !== oe ? (se = f("collapsible-header", te, ne, re, ie, ae, oe), n[18] = te, n[19] = ne, n[20] = re, n[21] = ie, n[22] = ae, n[23] = oe, n[24] = se) : se = n[24];
	let ce;
	n[25] === H ? ce = n[26] : (ce = () => H(), n[25] = H, n[26] = ce);
	let le;
	n[27] !== i || n[28] !== A || n[29] !== r ? (le = r && !i && /* @__PURE__ */ m(Q, {
		id: "agx-collapsible-title",
		size: "small",
		type: "body_ui_strong",
		color: "var(--text-primary)",
		children: A ? Oa(r, A) : r
	}), n[27] = i, n[28] = A, n[29] = r, n[30] = le) : le = n[30];
	let ue = i && i, de = a && a, fe;
	n[31] !== le || n[32] !== ue || n[33] !== de ? (fe = /* @__PURE__ */ h($, {
		id: "headerContent",
		contentJustification: "space-between",
		contentAlignment: "center",
		fill: !0,
		direction: "horizontal",
		children: [
			le,
			ue,
			de
		]
	}), n[31] = le, n[32] = ue, n[33] = de, n[34] = fe) : fe = n[34];
	let pe;
	n[35] !== E || n[36] !== N ? (pe = E === "none" ? /* @__PURE__ */ m(p, {}) : N ? /* @__PURE__ */ m(Ei, { direction: "up" }) : /* @__PURE__ */ m(Ei, { direction: "down" }), n[35] = E, n[36] = N, n[37] = pe) : pe = n[37];
	let me;
	n[38] !== se || n[39] !== ce || n[40] !== fe || n[41] !== pe ? (me = /* @__PURE__ */ h("div", {
		"data-testid": "collapsible-header",
		className: se,
		onClick: ce,
		children: [fe, pe]
	}), n[38] = se, n[39] = ce, n[40] = fe, n[41] = pe, n[42] = me) : me = n[42];
	let he = q ? s : void 0, ge = q && /* @__PURE__ */ m("div", {
		ref: L,
		className: f("collapsible-content", `${b ? z.join(" ") : "default-content-padding"}`, `collapsible-content-${N ? "open" : "closed"}`, `collapsible-content-${k ? "no-padding" : g}`),
		style: M ? { maxHeight: F } : void 0,
		children: c
	}), _e;
	return n[43] !== J || n[44] !== ee || n[45] !== me || n[46] !== he || n[47] !== ge ? (_e = /* @__PURE__ */ h("div", {
		"data-testid": J,
		className: ee,
		children: [
			me,
			he,
			ge
		]
	}), n[43] = J, n[44] = ee, n[45] = me, n[46] = he, n[47] = ge, n[48] = _e) : _e = n[48], _e;
}, Aa = /* @__PURE__ */ function(e) {
	return e.Mobile = "Mobile", e.Tablet_Landscape = "Tablet_Landscape", e.Tablet_Portrait = "Tablet_Portrait", e.Laptop = "Laptop", e.Desktop = "Desktop", e;
}({}), ja = {
	[Aa.Mobile]: 0,
	[Aa.Tablet_Portrait]: 1,
	[Aa.Tablet_Landscape]: 2,
	[Aa.Laptop]: 3,
	[Aa.Desktop]: 4
}, Ma = (e) => e <= Pa.Mobile ? Aa.Mobile : e <= Pa.Tablet_Portrait ? Aa.Tablet_Portrait : e <= Pa.Tablet_Landscape ? Aa.Tablet_Landscape : e <= Pa.Laptop ? Aa.Laptop : Aa.Desktop;
function Na() {
	let t = e(3), n;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = Ma(window.innerWidth), t[0] = n) : n = t[0];
	let [r, i] = d(n), a, s;
	return t[1] === Symbol.for("react.memo_cache_sentinel") ? (a = () => {
		let e = () => i(Ma(window.innerWidth));
		return window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
	}, s = [], t[1] = a, t[2] = s) : (a = t[1], s = t[2]), o(a, s), r;
}
var Pa = {
	Mobile: 699,
	Tablet_Portrait: 919,
	Tablet_Landscape: 1299,
	Laptop: 1439
}, Fa = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e?.forEach((e) => {
		e.userId && t.set(e.userId, e);
	}), t;
}, Ia = () => {
	let t = e(4), { data: n } = b(), r;
	t[0] === n ? r = t[1] : (r = Fa(n), t[0] = n, t[1] = r);
	let i = r, a;
	return t[2] === i ? a = t[3] : (a = (e) => {
		if (e) return i.get(e);
	}, t[2] = i, t[3] = a), a;
}, La = (e) => {
	let t = e.replace(", Australia", "");
	return t = t.replace(",Australia", ""), t = t.replace("Australia", ""), t;
}, Ra = (e, t) => {
	let n = e.addressComponents;
	if (!n) return e.formattedAddress ?? "";
	let r = [], i = n.find((e) => e.types.includes("subpremise"))?.shortText, a = n.find((e) => e.types.includes("street_number"))?.shortText, o = n.find((e) => e.types.includes("route"))?.longText, s = n.find((e) => e.types.includes("locality"))?.shortText, c = n.find((e) => e.types.includes("administrative_area_level_1"))?.shortText, l = t ? void 0 : n.find((e) => e.types.includes("country"))?.shortText, u = n.find((e) => e.types.includes("postal_code"))?.shortText;
	i && r.push(`Unit ${i}`), a && r.push(a), o && r.push(o);
	let d = r.join(" ");
	return s && (d += `, ${s}`), c && (d += ` ${c}`), l && (d += ` ${l}`), u && (d += ` ${u}`), d.trim();
}, za = (e) => {
	if (!e) return;
	let t = [];
	e.unitNumber && t.push(e.unitNumber), e.streetAddress && t.push(e.streetAddress);
	let n = t.join(" / "), r = [];
	return e.suburb && r.push(e.suburb), e.state && r.push(e.state), e.postalCode && r.push(e.postalCode), e.country && r.push(e.country), [n, r.join(" ")].filter((e) => e !== void 0 && e.length > 0).join(", ");
}, Ba = (e, t = !1) => {
	if (!e) return "Address undefined";
	let { unitNumber: n, streetAddress: r, suburb: i, state: a, country: o, postalCode: s } = e;
	return Va(" ", [Va("/", [n, r]), Va(" ", [
		i,
		a,
		o ? t ? "" : o : "",
		s
	])]);
}, Va = (e, t) => t.filter((e) => e !== void 0 && e.trim() !== "").join(e), Ha = (e, t, n) => {
	let r = n.addressComponents?.find((t) => t.types.includes(e));
	return r ? t === "long" ? r.longText ?? "" : r.shortText ?? "" : "";
}, Ua = (e) => e?.replace(/\s/g, "").replace(/\//g, "")?.replace(/-/g, "") ?? "", Wa = (e, t, n, r) => {
	if (e.location) return {
		placeId: Ua(n),
		name: e.displayName ?? void 0,
		unitNumber: Ha("subpremise", "long", e),
		streetAddress: `${Ha("street_number", "long", e)} ${Ha("route", "long", e)}`,
		suburb: Ha("locality", "long", e),
		state: Ha("administrative_area_level_1", "short", e),
		country: Ha("country", "short", e),
		postCode: Ha("postal_code", "long", e),
		formattedAddress: t ? Ra(e, r !== null) : r === null ? e.formattedAddress ?? void 0 : La(e.formattedAddress ?? ""),
		formattedPhoneNumber: e.nationalPhoneNumber ?? void 0,
		googleMapLink: e.websiteURI ?? void 0,
		latitude: e.location?.lat(),
		longitude: e.location?.lng(),
		types: e.types
	};
}, Ga = null, Ka = async () => typeof window > "u" ? null : (window.google?.maps?.places?.Place && !Ga && (Ga = Promise.resolve(window.google.maps.places)), Ga || (Ga = new Promise((e, t) => {
	(async () => {
		try {
			window.google?.maps?.importLibrary || await new Promise((e) => {
				window.addEventListener("google-maps-loaded", () => e(), { once: !0 });
			}), e(await google.maps.importLibrary("places"));
		} catch (e) {
			console.error("Failed to load Google Places library:", e), t(e);
		}
	})();
}), Ga)), qa = (e) => {
	let [t, n] = d(e);
	o(() => {
		e !== t && n(e);
	}, [e, t]);
	let r = u(void 0), a = async () => {
		try {
			await Ka(), window.google?.maps?.places?.AutocompleteSessionToken && (r.current = new google.maps.places.AutocompleteSessionToken());
		} catch {}
	}, s = i(async (e, n) => {
		r.current || await a();
		let i = e;
		t && !e.includes(t) && (i = `${e}, ${t}`);
		try {
			return await Ka(), window.google?.maps?.places?.AutocompleteSuggestion ? ((await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
				input: i,
				sessionToken: r.current,
				includedRegionCodes: ["AU"],
				includedPrimaryTypes: n ? ["establishment"] : void 0
			}))?.suggestions?.map((e) => e.placePrediction) ?? []).filter((e) => e && (!t || !e.mainText?.text || e.secondaryText?.text.toUpperCase().includes(t.toUpperCase()))).map((e) => e) : [];
		} catch (e) {
			return console.error("Error searching for addresses:", e), [];
		}
	}, [t]), c = async (e, t) => {
		let n = await Ka();
		if (!n?.Place) return;
		let r = new n.Place({ id: e });
		return await r.fetchFields({ fields: [
			"location",
			"displayName",
			"addressComponents",
			"formattedAddress",
			"types",
			"nationalPhoneNumber",
			"websiteURI"
		] }), Wa(r, t ?? !1, e);
	};
	return {
		searchForAddresses: s,
		getDetailsForPlaceId: c,
		getDetailsForPlaceSuggestions: async (e) => {
			let t = e.map((e) => typeof e == "string" ? e : e?.placeId).filter((e) => !!e).map((e) => e);
			return Promise.all(t.map(async (e) => await c(e)));
		}
	};
}, Ja = (t) => {
	let n = e(14), { variant: r, color: i, opacityPercent: a, pushMargin: o, id: s } = t, c = o ? `var(--${o})` : void 0, l;
	n[0] === a ? l = n[1] : (l = a ? { opacity: `${a}%` } : {}, n[0] = a, n[1] = l);
	let u;
	n[2] === i ? u = n[3] : (u = i ? { borderColor: i } : {}, n[2] = i, n[3] = u);
	let d;
	n[4] === c ? d = n[5] : (d = c ? {
		margin: `0 calc(-1 * ${c})`,
		width: `calc(100% + (${c} * 2))`
	} : {}, n[4] = c, n[5] = d);
	let f;
	n[6] !== l || n[7] !== u || n[8] !== d ? (f = {
		...l,
		...u,
		...d
	}, n[6] = l, n[7] = u, n[8] = d, n[9] = f) : f = n[9];
	let p = f, h = r === "horizontal" ? "hDivider" : "vDivider", g;
	return n[10] !== s || n[11] !== p || n[12] !== h ? (g = /* @__PURE__ */ m("div", {
		id: s,
		"data-testid": s,
		className: h,
		style: p
	}), n[10] = s, n[11] = p, n[12] = h, n[13] = g) : g = n[13], g;
}, Ya = (t) => {
	let n = e(56), { title: r, secondaryTitle: i, type: a, variant: o, content: s, actionButtons: c, titleIcon: l, setIsDialogOpen: u, actionButtonContainerStyle: d, minHeight: p, minWidth: g, maxHeight: v, maxWidth: y, isOpen: b, id: x } = t, S = d === void 0 ? "withoutDivider" : d, C = g === void 0 ? "600px" : g, w = y === void 0 ? void 0 : y, T = b === void 0 ? !0 : b, E = x, D = Na() === Aa.Mobile, O;
	n[0] === a ? O = n[1] : (O = f("modal-style", a), n[0] = a, n[1] = O);
	let k, A;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (k = { bottom: "md" }, A = { maxWidth: "90%" }, n[2] = k, n[3] = A) : (k = n[2], A = n[3]);
	let j;
	n[4] === r ? j = n[5] : (j = r && /* @__PURE__ */ m(Q, {
		id: "agx-modal-title",
		size: "medium",
		type: "body_ui_strong",
		dataTestId: `agx-modal-${r}`,
		color: "var(--text-primary)",
		children: r
	}), n[4] = r, n[5] = j);
	let M;
	n[6] !== i || n[7] !== j || n[8] !== l ? (M = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-2xl",
		contentAlignment: "center",
		padding: k,
		style: A,
		children: [
			l,
			j,
			i
		]
	}), n[6] = i, n[7] = j, n[8] = l, n[9] = M) : M = n[9];
	let N;
	n[10] !== u || n[11] !== a ? (N = a !== "dialog" && /* @__PURE__ */ m("div", {
		className: "modal-close-button",
		children: /* @__PURE__ */ m("button", {
			onClick: () => u(!1),
			children: /* @__PURE__ */ m(Gi, {})
		})
	}), n[10] = u, n[11] = a, n[12] = N) : N = n[12];
	let P;
	n[13] === o ? P = n[14] : (P = o === "withDivider" && /* @__PURE__ */ m("div", {
		className: "dividerContainer",
		children: /* @__PURE__ */ m(Ja, { variant: "horizontal" })
	}), n[13] = o, n[14] = P);
	let F;
	n[15] !== N || n[16] !== P || n[17] !== M ? (F = /* @__PURE__ */ m("div", {
		className: "modal-headerV2",
		children: /* @__PURE__ */ h($, {
			direction: "vertical",
			fill: !0,
			children: [
				M,
				N,
				P
			]
		})
	}), n[15] = N, n[16] = P, n[17] = M, n[18] = F) : F = n[18];
	let I;
	n[19] === a ? I = n[20] : (I = f("contentFooterContainer", a), n[19] = a, n[20] = I);
	let L = a === "dialog", R;
	n[21] === L ? R = n[22] : (R = f("modal-contentV2", { "no-scrollbar": L }), n[21] = L, n[22] = R);
	let z = D ? void 0 : C, B;
	n[23] !== v || n[24] !== w || n[25] !== p || n[26] !== z ? (B = {
		minHeight: p,
		minWidth: z,
		maxWidth: w,
		maxHeight: v
	}, n[23] = v, n[24] = w, n[25] = p, n[26] = z, n[27] = B) : B = n[27];
	let V;
	n[28] === s ? V = n[29] : (V = /* @__PURE__ */ m($, {
		direction: "vertical",
		gap: "md",
		children: s
	}), n[28] = s, n[29] = V);
	let H;
	n[30] !== R || n[31] !== B || n[32] !== V ? (H = /* @__PURE__ */ m("div", {
		className: R,
		style: B,
		children: V
	}), n[30] = R, n[31] = B, n[32] = V, n[33] = H) : H = n[33];
	let U;
	n[34] !== S || n[35] !== c ? (U = c && /* @__PURE__ */ m("div", {
		className: `actionButtons ${S}`,
		children: c
	}), n[34] = S, n[35] = c, n[36] = U) : U = n[36];
	let W;
	n[37] !== I || n[38] !== H || n[39] !== U ? (W = /* @__PURE__ */ h("div", {
		className: I,
		children: [H, U]
	}), n[37] = I, n[38] = H, n[39] = U, n[40] = W) : W = n[40];
	let G;
	n[41] !== F || n[42] !== W ? (G = /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		children: [F, W]
	}), n[41] = F, n[42] = W, n[43] = G) : G = n[43];
	let K;
	n[44] !== E || n[45] !== G || n[46] !== O ? (K = /* @__PURE__ */ m("div", {
		"data-testid": E,
		className: O,
		children: G
	}), n[44] = E, n[45] = G, n[46] = O, n[47] = K) : K = n[47];
	let q = K, J;
	n[48] === u ? J = n[49] : (J = () => u(!1), n[48] = u, n[49] = J);
	let Y;
	n[50] === Symbol.for("react.memo_cache_sentinel") ? (Y = {
		base: "modal",
		afterOpen: "modal-open",
		beforeClose: "modal-close"
	}, n[50] = Y) : Y = n[50];
	let X;
	n[51] === Symbol.for("react.memo_cache_sentinel") ? (X = document.getElementById("root"), n[51] = X) : X = n[51];
	let Z;
	return n[52] !== T || n[53] !== q || n[54] !== J ? (Z = /* @__PURE__ */ m(_, {
		isOpen: T,
		onRequestClose: J,
		className: Y,
		bodyOpenClassName: "modal-open-body",
		appElement: X,
		children: q
	}), n[52] = T, n[53] = q, n[54] = J, n[55] = Z) : Z = n[55], Z;
}, Xa = ({ children: e, container: t = typeof document < "u" ? document.body : null }) => t == null ? /* @__PURE__ */ m(p, { children: e }) : x.createPortal(e, t), Za = (t) => {
	let n = e(15), { id: r, sortOrder: i, onClick: a } = t, o = i === 1 ? "var(--fg-primary)" : "var(--fg-tertiary)", s = i === -1 ? "var(--fg-primary)" : "var(--fg-tertiary)", c = i === 1, l = i === -1, u;
	n[0] !== c || n[1] !== l ? (u = f("tableSortButton", {
		sortedAscending: c,
		sortedDescending: l
	}), n[0] = c, n[1] = l, n[2] = u) : u = n[2];
	let d;
	n[3] === o ? d = n[4] : (d = /* @__PURE__ */ m("div", {
		className: "sortButtonChevronUpIconContainer",
		children: /* @__PURE__ */ m(Ei, {
			direction: "up",
			width: 14,
			height: 14,
			color: o
		})
	}), n[3] = o, n[4] = d);
	let p;
	n[5] === s ? p = n[6] : (p = /* @__PURE__ */ m("div", {
		className: "sortButtonChevronDownIconContainer",
		children: /* @__PURE__ */ m(Ei, {
			direction: "down",
			width: 14,
			height: 14,
			color: s
		})
	}), n[5] = s, n[6] = p);
	let g;
	n[7] !== d || n[8] !== p ? (g = /* @__PURE__ */ h("div", {
		className: "sortButtonIconContainer",
		children: [d, p]
	}), n[7] = d, n[8] = p, n[9] = g) : g = n[9];
	let _;
	return n[10] !== r || n[11] !== a || n[12] !== u || n[13] !== g ? (_ = /* @__PURE__ */ m("button", {
		id: r,
		"data-testid": r,
		onClick: a,
		type: "button",
		className: u,
		"aria-label": "Sort column",
		children: g
	}), n[10] = r, n[11] = a, n[12] = u, n[13] = g, n[14] = _) : _ = n[14], _;
}, Qa = (e) => {
	let t = {}, n = {};
	return e.backgroundColor && (n = {
		...n,
		background: e.backgroundColor
	}), e.noHover && (t.className = f(t.className, "noHover")), n && (t.style = n), t;
}, $a = ({ shrink: e, align: t, maxColWidth: n }) => {
	let r = f({ shrink: e }), i = {}, a = {};
	return r && (i.className = r), t && (a = {
		...a,
		textAlign: t
	}), n !== void 0 && (a = {
		...a,
		maxWidth: n
	}), a && (i.style = a), i;
}, eo = (e) => {
	switch (e) {
		case 0: return 1;
		case 1: return -1;
		default: return 0;
	}
}, to = (t) => {
	let n = e(58), { variant: r, tableStyle: i, columns: a, rows: s, onRowClick: c, showLoadingState: l, noDataLabel: g, noDataGlyphType: _, bodyBg: v, headerBg: y } = t, b = r === void 0 ? "default" : r, x = i === void 0 ? "rounded" : i, S = g === void 0 ? "No data to display." : g, C = _ === void 0 ? "checklist" : _, w;
	n[0] === a ? w = n[1] : (w = a.map(no), n[0] = a, n[1] = w);
	let T = w, E;
	n[2] === T ? E = n[3] : (E = T.find(ro), n[2] = T, n[3] = E);
	let D = E, O;
	n[4] !== D?.defaultSortOrder || n[5] !== D?.name ? (O = () => ({
		columnName: D?.name ?? null,
		sortOrder: D?.defaultSortOrder ?? 0
	}), n[4] = D?.defaultSortOrder, n[5] = D?.name, n[6] = O) : O = n[6];
	let [k, A] = d(O), j = u(!1), M, N;
	n[7] === D ? (M = n[8], N = n[9]) : (M = () => {
		j.current || !D || !D.defaultSortOrder || (A({
			columnName: D.name,
			sortOrder: D.defaultSortOrder
		}), D.sortFunction?.(D.defaultSortOrder), j.current = !0);
	}, N = [D], n[7] = D, n[8] = M, n[9] = N), o(M, N);
	let P;
	n[10] !== k || n[11] !== T ? (P = (e) => {
		if (!e.sortable) return;
		let t = k.columnName === e.name, n = t ? eo(k.sortOrder) : 1;
		!t && k.columnName && T.find((e) => e.name === k.columnName)?.sortFunction?.(0), e.sortFunction?.(n), A({
			columnName: n === 0 ? null : e.name,
			sortOrder: n
		});
	}, n[10] = k, n[11] = T, n[12] = P) : P = n[12];
	let F = P, I = b && `variant-${b}`, L = x && `tableStyle-${x}`, R = c && "clickable", z = l && "loading", B;
	n[13] !== I || n[14] !== L || n[15] !== R || n[16] !== z ? (B = f("table", I, L, R, z), n[13] = I, n[14] = L, n[15] = R, n[16] = z, n[17] = B) : B = n[17];
	let V = B, H = y || "none", U;
	n[18] === H ? U = n[19] : (U = { background: H }, n[18] = H, n[19] = U);
	let W = `tableHeader ${b ? `variant-${b}` : ""} ${y ? "withHeaderBg" : ""}`, G;
	if (n[20] !== k || n[21] !== T || n[22] !== F) {
		let e;
		n[24] !== k || n[25] !== F ? (e = (e) => {
			let { name: t, hideHeader: n, align: r } = e, i = r === void 0 ? "left" : r, a = $a(e), o = Da(t), s = k.columnName === t ? k.sortOrder : 0, c = e.sortable ? s === 1 ? "ascending" : s === -1 ? "descending" : "none" : void 0;
			return /* @__PURE__ */ m("th", {
				...a,
				"aria-sort": c,
				children: !n && /* @__PURE__ */ m("div", {
					className: f("tableHeaderContent", `tableHeaderContent-${i}`, e.sortable && "sortable"),
					children: e.sortable ? /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(Q, {
						id: `agx-tableHeader-${t.toLowerCase()}`,
						size: "small",
						type: "body_ui_strong",
						color: "var(--text-primary)",
						children: o
					}), /* @__PURE__ */ m(Za, {
						id: `agx-table-sortButton-${t.toLowerCase()}`,
						sortOrder: s,
						onClick: () => F(e)
					})] }) : /* @__PURE__ */ m(Q, {
						id: `agx-tableHeader-${t.toLowerCase()}`,
						size: "small",
						type: "body_ui_strong",
						color: "var(--text-primary)",
						children: o
					})
				})
			}, t);
		}, n[24] = k, n[25] = F, n[26] = e) : e = n[26], G = T.map(e), n[20] = k, n[21] = T, n[22] = F, n[23] = G;
	} else G = n[23];
	let K;
	n[27] !== W || n[28] !== G ? (K = /* @__PURE__ */ m("tr", {
		className: W,
		children: G
	}), n[27] = W, n[28] = G, n[29] = K) : K = n[29];
	let q;
	n[30] !== U || n[31] !== K ? (q = /* @__PURE__ */ m("thead", {
		style: U,
		children: K
	}), n[30] = U, n[31] = K, n[32] = q) : q = n[32];
	let J = v || "none", Y;
	n[33] === J ? Y = n[34] : (Y = { background: J }, n[33] = J, n[34] = Y);
	let X;
	n[35] !== T || n[36] !== c || n[37] !== s || n[38] !== l ? (X = !l && s.length > 0 && s.map((e, t) => {
		let n = Qa(e);
		return /* @__PURE__ */ m("tr", {
			onClick: c ? () => c(t) : void 0,
			...n,
			children: T.map((t, n) => {
				let { name: r, onClick: i } = t;
				return /* @__PURE__ */ m("td", {
					...$a(t),
					onClick: (e) => i?.(e),
					children: e[r] === void 0 ? void 0 : e[r] ? e[r] : "-"
				}, r);
			})
		}, t);
	}), n[35] = T, n[36] = c, n[37] = s, n[38] = l, n[39] = X) : X = n[39];
	let Z;
	n[40] !== T.length || n[41] !== C || n[42] !== S || n[43] !== s || n[44] !== l ? (Z = !l && s.length === 0 && /* @__PURE__ */ m("tr", {
		className: "emptyStateRow",
		children: /* @__PURE__ */ m("td", {
			colSpan: T.length,
			children: /* @__PURE__ */ m(ao, {
				actionButtons: [],
				glyphType: C,
				variant: "advanced",
				label: S,
				labelStyle: "bodyUI"
			})
		})
	}), n[40] = T.length, n[41] = C, n[42] = S, n[43] = s, n[44] = l, n[45] = Z) : Z = n[45];
	let ee;
	n[46] !== T.length || n[47] !== l ? (ee = l && /* @__PURE__ */ m("tr", {
		className: "emptyStateRow",
		children: /* @__PURE__ */ m("td", {
			colSpan: T.length,
			children: /* @__PURE__ */ m(ao, {
				variant: "minimal",
				label: "Loading..."
			})
		})
	}), n[46] = T.length, n[47] = l, n[48] = ee) : ee = n[48];
	let te;
	n[49] !== Y || n[50] !== X || n[51] !== Z || n[52] !== ee ? (te = /* @__PURE__ */ h("tbody", {
		style: Y,
		children: [
			X,
			Z,
			ee
		]
	}), n[49] = Y, n[50] = X, n[51] = Z, n[52] = ee, n[53] = te) : te = n[53];
	let ne;
	return n[54] !== q || n[55] !== te || n[56] !== V ? (ne = /* @__PURE__ */ m("div", {
		className: "tableContainer",
		children: /* @__PURE__ */ h("table", {
			className: V,
			children: [q, te]
		})
	}), n[54] = q, n[55] = te, n[56] = V, n[57] = ne) : ne = n[57], ne;
};
function no(e) {
	return typeof e == "string" ? { name: e } : e;
}
function ro(e) {
	return e.sortable && e.defaultSortOrder !== void 0 && e.defaultSortOrder !== 0;
}
//#endregion
//#region src/components/display/Table/toRowData.tsx
function io(e) {
	return e.map((e) => {
		let n = {};
		for (let [r, i] of Object.entries(e)) typeof i == "string" || i === void 0 || t.isValidElement(i) ? n[r] = i : n[r] = String(i);
		return n;
	});
}
//#endregion
//#region src/components/display/EmptyState/EmptyState.tsx
var ao = (t) => {
	let n = e(18), { variant: r, label: i, labelStyle: a } = t, o = a === void 0 ? "heading" : a, s = oo, c = `emptyState-${r}`, l;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (l = {
		top: "spacing-6xl",
		bottom: "spacing-6xl"
	}, n[0] = l) : l = n[0];
	let u;
	n[1] !== i || n[2] !== o || n[3] !== t.description || n[4] !== t.glyphType || n[5] !== r ? (u = i && /* @__PURE__ */ h(Me, {
		gap: "spacing-3xl",
		alignItems: "alignCenter",
		justifyContent: "center",
		fill: !0,
		children: [r === "advanced" && /* @__PURE__ */ h(p, { children: [
			t.glyphType && /* @__PURE__ */ m(qn, {
				type: t.glyphType,
				height: 140,
				width: 140
			}),
			o === "heading" && /* @__PURE__ */ m(Q, {
				id: "txtEmptyStateLbl",
				type: "heading",
				size: "x-large",
				color: "var(--text-primary)",
				children: i
			}),
			o === "bodyUI" && /* @__PURE__ */ m(Q, {
				id: "txtEmptyStateLbl",
				type: "body_ui_strong",
				size: "medium",
				color: "var(--text-primary)",
				children: i
			}),
			t.description && /* @__PURE__ */ m(Q, {
				id: "txtEmptyStateLbl",
				type: "body_ui",
				size: "small",
				color: "var(--text-secondary)",
				children: t.description
			})
		] }), r === "minimal" && /* @__PURE__ */ m(Q, {
			id: "txtEmptyStateLbl",
			type: "body",
			size: "small",
			color: "var(--text-tertiary)",
			children: i
		})]
	}), n[1] = i, n[2] = o, n[3] = t.description, n[4] = t.glyphType, n[5] = r, n[6] = u) : u = n[6];
	let d;
	n[7] !== t.actionButtons || n[8] !== r ? (d = r === "advanced" && t.actionButtons.sort(so).map((e) => s(e)), n[7] = t.actionButtons, n[8] = r, n[9] = d) : d = n[9];
	let f;
	n[10] === d ? f = n[11] : (f = /* @__PURE__ */ m(Ne, {
		gap: "spacing-lg",
		children: d
	}), n[10] = d, n[11] = f);
	let g;
	n[12] !== u || n[13] !== f ? (g = /* @__PURE__ */ m(Ne, {
		padding: l,
		fill: !0,
		children: /* @__PURE__ */ h(Me, {
			gap: "spacing-5xl",
			alignItems: "alignCenter",
			justifyContent: "center",
			fill: !0,
			children: [u, f]
		})
	}), n[12] = u, n[13] = f, n[14] = g) : g = n[14];
	let _;
	return n[15] !== c || n[16] !== g ? (_ = /* @__PURE__ */ m("div", {
		className: c,
		children: g
	}), n[15] = c, n[16] = g, n[17] = _) : _ = n[17], _;
};
function oo(e) {
	return /* @__PURE__ */ m(Kl, {
		id: `btnAction-${e.order}`,
		variant: e.isPrimary ? "primary" : "hollow",
		size: "large",
		text: e.label,
		rightIcon: e.rightIcon,
		leftIcon: e.leftIcon,
		onClick: e.onClick
	}, `btnAction-${e.order}`);
}
function so(e, t) {
	return e.order - t.order;
}
//#endregion
//#region src/utils/defaultTheme.ts
var co = {
	main: [
		{
			scalePosition: 50,
			hexValue: "#f3f7fc",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#e7eef7",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#c9dbee",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#99bee0",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#639bcd",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#3f7fb8",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#2e649b",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#26517e",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#234569",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#223b58",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#17263a",
			isBaseColour: !1
		}
	],
	accent: [
		{
			scalePosition: 50,
			hexValue: "#faf5f0",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#efe3d6",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#dec5a9",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#cda57c",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#c18b5e",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#ba7a55",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#a05a3f",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#864437",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#6e3932",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#5c302b",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#331715",
			isBaseColour: !1
		}
	],
	grey: [
		{
			scalePosition: 50,
			hexValue: "#ffffff",
			isBaseColour: !0
		},
		{
			scalePosition: 100,
			hexValue: "#fafafa",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#f5f5f5",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#dfdfdf",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#cdcdcd",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#b9b9b9",
			isBaseColour: !1
		},
		{
			scalePosition: 600,
			hexValue: "#989898",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#6a6a6a",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#5b5b5b",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#444444",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#222222",
			isBaseColour: !1
		}
	],
	teal: [
		{
			scalePosition: 50,
			hexValue: "#EBFFF9",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#CCFFEE",
			isBaseColour: !0
		},
		{
			scalePosition: 200,
			hexValue: "#9EFCE1",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#60F5D3",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#21E6C0",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#00CDAB",
			isBaseColour: !1
		},
		{
			scalePosition: 600,
			hexValue: "#00A78B",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#008674",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#00695D",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#00564E",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#00312D",
			isBaseColour: !1
		}
	],
	error: [
		{
			scalePosition: 50,
			hexValue: "#fff2f1",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#ffe2e0",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#ffcac7",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#ffa6a0",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#ff7269",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#f94a3f",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#e6281c",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#c21d13",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#a01c14",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#851e17",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#480b07",
			isBaseColour: !1
		}
	],
	warning: [
		{
			scalePosition: 50,
			hexValue: "#fffaed",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#fff4d4",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#ffe5a8",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#ffd271",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#ffb338",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#fe9911",
			isBaseColour: !1
		},
		{
			scalePosition: 600,
			hexValue: "#f88208",
			isBaseColour: !0
		},
		{
			scalePosition: 700,
			hexValue: "#c65f08",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#9d4a0f",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#7e3e10",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#441d06",
			isBaseColour: !1
		}
	],
	success: [
		{
			scalePosition: 50,
			hexValue: "#f2ffe5",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#e1ffc8",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#c4ff97",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#9cfc5a",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#79f229",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#54cf09",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#41ad03",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#328407",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#2b680c",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#265710",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#0f3102",
			isBaseColour: !1
		}
	],
	action: [
		{
			scalePosition: 50,
			hexValue: "#f1f7fe",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#e3edfb",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#c0dbf7",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#88bdf1",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#489ce8",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#318ce0",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#1263b7",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#104f94",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#12447a",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#143a66",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#0d2544",
			isBaseColour: !1
		}
	],
	red: [
		{
			scalePosition: 50,
			hexValue: "#fdf3f3",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#fce5e4",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#fad0ce",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#f5b0ac",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#ee817b",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#e25851",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#ce3b34",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#ad2e28",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#8f2a25",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#782824",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#41100e",
			isBaseColour: !1
		}
	],
	purple: [
		{
			scalePosition: 50,
			hexValue: "#f5f3ff",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#ede9fe",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#ded6fe",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#c5b5fd",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#a88bfa",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#8d5cf6",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#7e3aed",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#6f28d9",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#5d21b6",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#4e1d95",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#2f1065",
			isBaseColour: !1
		}
	],
	green: [
		{
			scalePosition: 50,
			hexValue: "#e9fee7",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#cefdca",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#a1fb9b",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#68f561",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#38e932",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#16d413",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#0aa60b",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#0d7e10",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#116313",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#135416",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#042f07",
			isBaseColour: !1
		}
	],
	blue: [
		{
			scalePosition: 50,
			hexValue: "#ecfdff",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#cff8fe",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#a6effb",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#68e2f8",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#24caec",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#08add2",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#0a8ab0",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#0f6e8f",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#165a74",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#174b62",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#093143",
			isBaseColour: !1
		}
	],
	yellow: [
		{
			scalePosition: 50,
			hexValue: "#fdfae9",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#fcf4c5",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#fbe78d",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#f8d24c",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#f4ba1b",
			isBaseColour: !1
		},
		{
			scalePosition: 500,
			hexValue: "#f0ab10",
			isBaseColour: !0
		},
		{
			scalePosition: 600,
			hexValue: "#c47c0a",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#9d580b",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#824611",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#6e3915",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#401c08",
			isBaseColour: !1
		}
	],
	orange: [
		{
			scalePosition: 50,
			hexValue: "#fdf6ef",
			isBaseColour: !1
		},
		{
			scalePosition: 100,
			hexValue: "#fbe8d9",
			isBaseColour: !1
		},
		{
			scalePosition: 200,
			hexValue: "#f6cfb2",
			isBaseColour: !1
		},
		{
			scalePosition: 300,
			hexValue: "#f0ae81",
			isBaseColour: !1
		},
		{
			scalePosition: 400,
			hexValue: "#e9814a",
			isBaseColour: !0
		},
		{
			scalePosition: 500,
			hexValue: "#e4642b",
			isBaseColour: !1
		},
		{
			scalePosition: 600,
			hexValue: "#d64b20",
			isBaseColour: !1
		},
		{
			scalePosition: 700,
			hexValue: "#b1391d",
			isBaseColour: !1
		},
		{
			scalePosition: 800,
			hexValue: "#8d2f1f",
			isBaseColour: !1
		},
		{
			scalePosition: 900,
			hexValue: "#72291c",
			isBaseColour: !1
		},
		{
			scalePosition: 950,
			hexValue: "#3d120d",
			isBaseColour: !1
		}
	]
}, lo = (e) => {
	let t = e.replace("#", "").match(/.{2}/g)?.map((e) => parseInt(e, 16) / 255);
	if (!t || t.length !== 3) throw Error("Invalid hex color format");
	let n = t.map((e) => e <= .03928 ? e / 12.92 : ((e + .055) / 1.055) ** 2.4);
	return .2126 * n[0] + .7152 * n[1] + .0722 * n[2];
}, uo = (e) => lo(e) < .5;
function fo(e) {
	e = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(e, t, n, r) {
		return t + t + n + n + r + r;
	});
	var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
	return t ? `${parseInt(t[1], 16)}, ${parseInt(t[2], 16)}, ${parseInt(t[3], 16)}` : null;
}
var po = (e, t, n = document.documentElement) => {
	let { scalePosition: r, hexValue: i, isBaseColour: a } = t;
	if (i === void 0) {
		console.warn(`Design system colour variable "${e}" is missing a hex value.`);
		return;
	}
	let o = fo(i);
	n.style.setProperty(`--color-${e}-${r}`, o), a && n.style.setProperty(`--color-${e}-base`, o);
}, mo = (e, t = "agent-portal", n = !1, r = document.documentElement) => {
	let i = {
		...co,
		...e
	};
	for (let e of Object.keys(i)) {
		let t = i[e];
		for (let n of t) po(e, n, r);
	}
	let a = i.main.find((e) => e.isBaseColour), o = "light";
	n && a?.hexValue !== void 0 && (o = a && uo(a.hexValue) ? "dark" : "light"), r.setAttribute("data-theme", `${t}-${o}`);
}, ho = (e) => {
	switch (e) {
		case g.Bronze: return ["Bronze Partner", "partnership-bronze"];
		case g.Silver: return ["Silver Partner", "partnership-silver"];
		case g.Gold: return ["Gold Partner", "partnership-gold"];
		case g.Platinum: return ["Platinum Partner", "partnership-platinum"];
		case g.XPartner: return ["X Partner", "partnership-x"];
		default: return [void 0, void 0];
	}
}, go = (e, t) => e === "partnership" && t === g.XPartner ? "var(--text-white)" : "var(--text-black)";
mo(co, "agent-portal", !0);
var _o = (t) => {
	let n = e(43), { size: r, text: i, colour: a, type: o, highlightText: s, partnershipLevel: c, link: l, leftIcon: u, rightIcon: d, showBorder: p, variant: _, onClick: v, hoverBackgroundColor: y, activeBackgroundColor: b } = t, x = _ === void 0 ? "normal" : _, S;
	n[0] === c ? S = n[1] : (S = ho(c), n[0] = c, n[1] = S);
	let [C, w] = S, T = `colour-${o === "partnership" ? w : a}`, E = o === "partnership" ? C : i, D;
	n[2] !== c || n[3] !== o ? (D = go(o, c), n[2] = c, n[3] = o, n[4] = D) : D = n[4];
	let O = D, k = x === "clickable", A;
	n[5] === y ? A = n[6] : (A = y ? { "--badge-hover-bg": y } : {}, n[5] = y, n[6] = A);
	let j;
	n[7] === b ? j = n[8] : (j = b ? { "--badge-active-bg": b } : {}, n[7] = b, n[8] = j);
	let M;
	n[9] !== A || n[10] !== j ? (M = {
		...A,
		...j
	}, n[9] = A, n[10] = j, n[11] = M) : M = n[11];
	let N = M, P = `size-${r}`, F = `type-${o}`, I = !!y, L = !!b, R;
	n[12] !== T || n[13] !== k || n[14] !== p || n[15] !== L || n[16] !== P || n[17] !== F || n[18] !== I ? (R = f("agx-badge-v2", P, T, F, {
		showBorder: p,
		"is-clickable": k,
		"has-hover-bg": I,
		"has-active-bg": L
	}), n[12] = T, n[13] = k, n[14] = p, n[15] = L, n[16] = P, n[17] = F, n[18] = I, n[19] = R) : R = n[19];
	let z = k ? v : void 0, B = k ? "button" : void 0, V = k ? 0 : void 0, H;
	n[20] !== c || n[21] !== o ? (H = o === "partnership" && /* @__PURE__ */ m(Ui, {
		height: 16,
		width: 16,
		partnershipLevel: c ?? g.Bronze,
		useBasicColours: !0
	}), n[20] = c, n[21] = o, n[22] = H) : H = n[22];
	let U;
	n[23] !== E || n[24] !== l || n[25] !== r || n[26] !== O ? (U = l ? /* @__PURE__ */ m("a", {
		href: l,
		target: "_blank",
		rel: "noopener noreferrer",
		className: "hyperlinkStyle",
		children: /* @__PURE__ */ m(Q, {
			id: "badge-text",
			type: "hyperlink",
			size: r === "md" ? "medium" : "small",
			color: O,
			style: { whiteSpace: "nowrap" },
			children: E
		})
	}) : /* @__PURE__ */ m(Q, {
		id: "badge-text",
		type: "tag",
		size: r === "md" ? "medium" : "small",
		color: O,
		style: { whiteSpace: "nowrap" },
		children: E
	}), n[23] = E, n[24] = l, n[25] = r, n[26] = O, n[27] = U) : U = n[27];
	let W;
	n[28] !== s || n[29] !== r || n[30] !== o ? (W = o === "highlighted" && s && /* @__PURE__ */ m("div", {
		className: "badge-highlight",
		children: /* @__PURE__ */ m(Q, {
			id: "badge-highlight-text",
			type: "tag",
			size: r === "md" ? "medium" : "small",
			style: { whiteSpace: "nowrap" },
			children: s
		})
	}), n[28] = s, n[29] = r, n[30] = o, n[31] = W) : W = n[31];
	let G;
	return n[32] !== u || n[33] !== d || n[34] !== N || n[35] !== R || n[36] !== z || n[37] !== B || n[38] !== V || n[39] !== H || n[40] !== U || n[41] !== W ? (G = /* @__PURE__ */ h("div", {
		className: R,
		style: N,
		onClick: z,
		role: B,
		tabIndex: V,
		children: [
			H,
			u,
			U,
			d,
			W
		]
	}), n[32] = u, n[33] = d, n[34] = N, n[35] = R, n[36] = z, n[37] = B, n[38] = V, n[39] = H, n[40] = U, n[41] = W, n[42] = G) : G = n[42], G;
}, vo = /* @__PURE__ */ Ce(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var x = "$isDayjsObject", S = function(e) {
			return e instanceof E || !(!e || !e[x]);
		}, C = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, w = function(e, t) {
			if (S(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new E(n);
		}, T = v;
		T.l = C, T.i = S, T.w = function(e, t) {
			return w(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var E = function() {
			function g(e) {
				this.$L = C(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[x] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (T.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return T;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = w(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return w(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < w(e);
			}, _.$g = function(e, t, n) {
				return T.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!T.u(t) || t, u = T.p(e), p = function(e, t) {
					var i = T.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return T.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = T.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[T.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = T.p(u), h = function(e) {
					var t = w(p);
					return T.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return T.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = T.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return T.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return T.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return T.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return T.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return T.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return T.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return T.s(t.$s, 2, "0");
							case "SSS": return T.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = T.p(f), _ = w(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return T.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : T.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = C(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return T.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), D = E.prototype;
		return w.prototype = D, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			D[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), w.extend = function(e, t) {
			return e.$i ||= (e(t, E, w), !0), w;
		}, w.locale = C, w.isDayjs = S, w.unix = function(e) {
			return w(1e3 * e);
		}, w.en = b[y], w.Ls = b, w.p = {}, w;
	}));
})), yo = /* @__PURE__ */ Ce(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, c = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, l = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], u = function(e) {
			var t = o[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, d = function(e, t) {
			var n, r = o.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, f = {
			A: [a, function(e) {
				this.afternoon = d(e, !1);
			}],
			a: [a, function(e) {
				this.afternoon = d(e, !0);
			}],
			Q: [n, function(e) {
				this.month = 3 * (e - 1) + 1;
			}],
			S: [n, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [r, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [i, c("seconds")],
			ss: [i, c("seconds")],
			m: [i, c("minutes")],
			mm: [i, c("minutes")],
			H: [i, c("hours")],
			h: [i, c("hours")],
			HH: [i, c("hours")],
			hh: [i, c("hours")],
			D: [i, c("day")],
			DD: [r, c("day")],
			Do: [a, function(e) {
				var t = o.ordinal;
				if (this.day = e.match(/\d+/)[0], t) for (var n = 1; n <= 31; n += 1) t(n).replace(/\[|\]/g, "") === e && (this.day = n);
			}],
			w: [i, c("week")],
			ww: [r, c("week")],
			M: [i, c("month")],
			MM: [r, c("month")],
			MMM: [a, function(e) {
				var t = u("months"), n = (u("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [a, function(e) {
				var t = u("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, c("year")],
			YY: [r, function(e) {
				this.year = s(e);
			}],
			YYYY: [/\d{4}/, c("year")],
			Z: l,
			ZZ: l
		};
		function p(n) {
			for (var r = n, i = o && o.formats, a = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = a.length, c = 0; c < s; c += 1) {
				var l = a[c], u = f[l], d = u && u[0], p = u && u[1];
				a[c] = p ? {
					regex: d,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = a[n];
					if (typeof i == "string") r += i.length;
					else {
						var o = i.regex, c = i.parser, l = e.slice(r), u = o.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, a = e.args;
				this.$u = r;
				var s = a[1];
				if (typeof s == "string") {
					var c = !0 === a[2], l = !0 === a[3], u = c || l, d = a[2];
					l && (d = a[2]), o = this.$locale(), !c && d && (o = n.Ls[d]), this.$d = function(e, t, n, r) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var i = p(t)(e), a = i.year, o = i.month, s = i.day, c = i.hours, l = i.minutes, u = i.seconds, d = i.milliseconds, f = i.zone, m = i.week, h = /* @__PURE__ */ new Date(), g = s || (a || o ? 1 : h.getDate()), _ = a || h.getFullYear(), v = 0;
							a && !o || (v = o > 0 ? o - 1 : h.getMonth());
							var y, b = c || 0, x = l || 0, S = u || 0, C = d || 0;
							return f ? new Date(Date.UTC(_, v, g, b, x, S, C + 60 * f.offset * 1e3)) : n ? new Date(Date.UTC(_, v, g, b, x, S, C)) : (y = new Date(_, v, g, b, x, S, C), m && (y = r(y).week(m).toDate()), y);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), o = {};
				} else if (s instanceof Array) for (var f = s.length, m = 1; m <= f; m += 1) {
					a[1] = s[m - 1];
					var h = n.apply(this, a);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === f && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), bo = /* @__PURE__ */ Ce(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_advancedFormat = r();
	})(e, (function() {
		return function(e, t) {
			var n = t.prototype, r = n.format;
			n.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return r.bind(this)(e);
				var i = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, (function(e) {
					switch (e) {
						case "Q": return Math.ceil((t.$M + 1) / 3);
						case "Do": return n.ordinal(t.$D);
						case "gggg": return t.weekYear();
						case "GGGG": return t.isoWeekYear();
						case "wo": return n.ordinal(t.week(), "W");
						case "w":
						case "ww": return i.s(t.week(), e === "w" ? 1 : 2, "0");
						case "W":
						case "WW": return i.s(t.isoWeek(), e === "W" ? 1 : 2, "0");
						case "k":
						case "kk": return i.s(String(t.$H === 0 ? 24 : t.$H), e === "k" ? 1 : 2, "0");
						case "X": return Math.floor(t.$d.getTime() / 1e3);
						case "x": return t.$d.getTime();
						case "z": return "[" + t.offsetName() + "]";
						case "zzz": return "[" + t.offsetName("long") + "]";
						default: return e;
					}
				}));
				return r.bind(this)(a);
			};
		};
	}));
})), xo = /* @__PURE__ */ Ce(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_en = r();
	})(e, (function() {
		return {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		};
	}));
})), So = /* @__PURE__ */ Ee(vo(), 1), Co = /* @__PURE__ */ Ee(yo(), 1), wo = /* @__PURE__ */ Ee(bo(), 1);
xo(), So.default.extend(Co.default), So.default.extend(wo.default), So.default.locale("en");
var To = "YYYY-MM-DD", Eo = (e) => {
	let t = (0, So.default)(e);
	return t.isValid() ? t.isSame((0, So.default)(), "day") ? "Today" : t.isBefore((0, So.default)(), "day") ? "Overdue" : "Future" : "Invalid date";
}, Do = (e, t = !0) => {
	let n = (0, So.default)(e);
	return n.isValid() ? n.format(`Do MMM ${t ? "YYYY" : ""}`) : "Invalid date";
}, Oo = (e) => {
	if (!e) return;
	let t = (0, So.default)(e);
	if (t.isValid()) return t.format(To);
}, ko = (e) => {
	if (!e) return;
	let t = new Date(e);
	return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
}, Ao = (t) => {
	let n = e(59), { id: r, dataTestId: i, title: a, progress: o, iconType: s, customIcon: c, avatarUrl: l, userName: u, dueDate: d, actionText: p, onActionClick: g, cardColor: _ } = t, v = i === void 0 ? r : i, y;
	n[0] === _ ? y = n[1] : (y = f("agx-task-card", _), n[0] = _, n[1] = y);
	let b = y, x = d ?? "", S;
	n[2] === x ? S = n[3] : (S = Eo(x), n[2] = x, n[3] = S);
	let C = S, w = C === "Overdue" ? "red" : "yellow", T;
	n[4] === Symbol.for("react.memo_cache_sentinel") ? (T = ["Today", "Overdue"], n[4] = T) : T = n[4];
	let E = T.includes(C), D;
	n[5] !== C || n[6] !== w || n[7] !== E ? (D = {
		dueDateStatus: C,
		badgeColor: w,
		isHighlighted: E,
		badgeHighlightText: C
	}, n[5] = C, n[6] = w, n[7] = E, n[8] = D) : D = n[8];
	let { dueDateStatus: O, badgeColor: k, isHighlighted: A, badgeHighlightText: j } = D, M;
	n[9] !== _ || n[10] !== c || n[11] !== s ? (M = () => c || (s ? /* @__PURE__ */ m(Ci, {
		type: s,
		height: 48,
		width: 48,
		iconColor: _
	}) : null), n[9] = _, n[10] = c, n[11] = s, n[12] = M) : M = n[12];
	let N = M, P = `${o}%`, F;
	n[13] === P ? F = n[14] : (F = { "--task-card-progress": P }, n[13] = P, n[14] = F);
	let I = F, L;
	n[15] === N ? L = n[16] : (L = N(), n[15] = N, n[16] = L);
	let R;
	n[17] === L ? R = n[18] : (R = /* @__PURE__ */ m("div", {
		className: "task-icon-container",
		children: L
	}), n[17] = L, n[18] = R);
	let z;
	n[19] === a ? z = n[20] : (z = /* @__PURE__ */ m(Q, {
		id: "task-title",
		type: "body_ui_strong",
		size: "medium",
		color: "var(--text-primary)",
		children: a
	}), n[19] = a, n[20] = z);
	let B;
	n[21] === o ? B = n[22] : (B = /* @__PURE__ */ h(Q, {
		id: "task-progress",
		type: "caption",
		size: "medium",
		color: "var(--text-secondary)",
		children: [o, "% complete"]
	}), n[21] = o, n[22] = B);
	let V;
	n[23] !== z || n[24] !== B ? (V = /* @__PURE__ */ h(Me, {
		gap: "spacing-xs",
		children: [z, B]
	}), n[23] = z, n[24] = B, n[25] = V) : V = n[25];
	let H;
	n[26] !== l || n[27] !== u ? (H = l && /* @__PURE__ */ m("div", {
		className: "task-avatar",
		children: /* @__PURE__ */ m("img", {
			src: l,
			alt: u || "User"
		})
	}), n[26] = l, n[27] = u, n[28] = H) : H = n[28];
	let U;
	n[29] !== k || n[30] !== j || n[31] !== d || n[32] !== O || n[33] !== A ? (U = O !== "Invalid date" && A && /* @__PURE__ */ m(_o, {
		type: "highlighted",
		colour: k,
		size: "md",
		text: `Due ${Do(d ?? "", !1)}`,
		highlightText: j
	}), n[29] = k, n[30] = j, n[31] = d, n[32] = O, n[33] = A, n[34] = U) : U = n[34];
	let W;
	n[35] !== k || n[36] !== d || n[37] !== O || n[38] !== A ? (W = O !== "Invalid date" && !A && /* @__PURE__ */ m(_o, {
		type: "colourfill",
		colour: k,
		size: "md",
		text: `Due ${Do(d ?? "", !1)}`
	}), n[35] = k, n[36] = d, n[37] = O, n[38] = A, n[39] = W) : W = n[39];
	let G;
	n[40] !== R || n[41] !== V || n[42] !== H || n[43] !== U || n[44] !== W ? (G = /* @__PURE__ */ h(Ne, {
		gap: "spacing-xl",
		alignItems: "alignCenter",
		fill: !0,
		children: [
			R,
			V,
			H,
			U,
			W
		]
	}), n[40] = R, n[41] = V, n[42] = H, n[43] = U, n[44] = W, n[45] = G) : G = n[45];
	let K;
	n[46] === Symbol.for("react.memo_cache_sentinel") ? (K = /* @__PURE__ */ m(Wi, {
		direction: "right",
		color: "var(--fg-brand-main)",
		height: 16,
		width: 16
	}), n[46] = K) : K = n[46];
	let q;
	n[47] !== p || n[48] !== g ? (q = /* @__PURE__ */ m(Ne, {
		fill: !0,
		justifyContent: "right",
		children: /* @__PURE__ */ m(Kl, {
			id: "task-action-button",
			variant: "primary",
			size: "medium",
			text: p,
			rightIcon: K,
			onClick: g
		})
	}), n[47] = p, n[48] = g, n[49] = q) : q = n[49];
	let J;
	n[50] !== G || n[51] !== q ? (J = /* @__PURE__ */ h(Ne, {
		gap: "spacing-lg",
		alignItems: "alignCenter",
		justifyContent: "space-between",
		fill: !0,
		children: [G, q]
	}), n[50] = G, n[51] = q, n[52] = J) : J = n[52];
	let Y;
	return n[53] !== b || n[54] !== v || n[55] !== r || n[56] !== I || n[57] !== J ? (Y = /* @__PURE__ */ m("div", {
		id: r,
		"data-testid": v,
		className: b,
		style: I,
		children: J
	}), n[53] = b, n[54] = v, n[55] = r, n[56] = I, n[57] = J, n[58] = Y) : Y = n[58], Y;
}, jo = (t) => {
	let n = e(6), { id: r, children: i, color: a, dataTestId: o, size: s } = t, c = s === void 0 ? "small" : s, l;
	return n[0] !== i || n[1] !== a || n[2] !== o || n[3] !== r || n[4] !== c ? (l = /* @__PURE__ */ m("div", {
		className: "agx-tag",
		children: /* @__PURE__ */ m(Q, {
			id: r,
			dataTestId: o,
			type: "tag",
			size: c,
			color: a,
			children: i
		})
	}), n[0] = i, n[1] = a, n[2] = o, n[3] = r, n[4] = c, n[5] = l) : l = n[5], l;
}, Mo = (t) => {
	let n = e(16), { heading: r, body: i, type: a } = t, o;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (o = {
		warning: "var(--text-warning)",
		danger: "var(--text-error)",
		information: "var(--text-action)"
	}, n[0] = o) : o = n[0];
	let s = o, c = `notificationBox ${a}`, l;
	n[1] === a ? l = n[2] : (l = /* @__PURE__ */ m(Ti, { type: a }), n[1] = a, n[2] = l);
	let u;
	n[3] !== r || n[4] !== a ? (u = r && /* @__PURE__ */ m(Q, {
		type: "body_ui_strong",
		size: "small",
		id: "notifheader",
		color: s[a],
		children: r
	}), n[3] = r, n[4] = a, n[5] = u) : u = n[5];
	let d;
	n[6] !== i || n[7] !== a ? (d = i && /* @__PURE__ */ m(Q, {
		type: "body_ui",
		size: "small",
		id: "notifheader",
		color: s[a],
		children: i
	}), n[6] = i, n[7] = a, n[8] = d) : d = n[8];
	let f;
	n[9] !== l || n[10] !== u || n[11] !== d ? (f = /* @__PURE__ */ h(Ne, {
		gap: "spacing-sm",
		alignItems: "flex-start",
		justifyContent: "space-between",
		padding: "spacing-xl",
		children: [
			l,
			u,
			d
		]
	}), n[9] = l, n[10] = u, n[11] = d, n[12] = f) : f = n[12];
	let p;
	return n[13] !== c || n[14] !== f ? (p = /* @__PURE__ */ m(Me, {
		fill: !0,
		children: /* @__PURE__ */ m("div", {
			className: c,
			children: f
		})
	}), n[13] = c, n[14] = f, n[15] = p) : p = n[15], p;
}, No = r(void 0), Po = (e) => {
	switch (e) {
		case "error": return "var(--fg-error)";
		case "info": return "var(--fg-action)";
		case "warning": return "var(--fg-warning)";
		case "success": return "var(--fg-success)";
		default: return e;
	}
}, Fo = 3e3, Io = 300, Lo = ({ children: e }) => {
	let [t, n] = d([]), r = u(null), i = u(null), [a, s] = d(!1), c = Na(), l = (e, t) => {
		n((n) => {
			if (t) {
				let r = n.findIndex((e) => e.id === t);
				if (r !== -1) {
					let t = [...n];
					return t[r] = {
						...t[r],
						...e
					}, t;
				}
			}
			let r = {
				...e,
				id: t ?? S()
			}, i = n.findIndex((e) => e.action);
			return i === -1 ? [...n, r] : [
				...n.slice(0, i),
				r,
				...n.slice(i)
			];
		});
	}, p = (e) => {
		n((t) => t.filter((t) => t.id !== e));
	}, g = () => {
		r.current !== null && (clearTimeout(r.current), r.current = null), i.current === null && (s(!0), i.current = window.setTimeout(() => {
			_(), s(!1), i.current = null;
		}, Io));
	}, _ = () => {
		n((e) => e.length === 0 ? e : e.slice(1));
	};
	return o(() => {
		r.current !== null || i.current !== null || t.length > 0 && !t[0].action && (r.current = window.setTimeout(() => {
			g();
		}, Fo));
	}, [t]), /* @__PURE__ */ h(No.Provider, {
		value: {
			pushToast: l,
			removeToast: p
		},
		children: [t.map((e, t) => /* @__PURE__ */ h($, {
			className: f("agxToast", (t === 0 || t === 1 && a) && "frontToast", t === 0 && a && "fadeOut"),
			style: { zIndex: 999999 - t },
			direction: "horizontal",
			gap: c === Aa.Mobile ? "spacing-md" : "spacing-lg",
			padding: c === Aa.Mobile ? {
				top: "spacing-lg",
				bottom: "spacing-lg",
				left: "spacing-xl",
				right: "spacing-xl"
			} : "spacing-2xl",
			contentAlignment: "center",
			fill: !0,
			children: [
				e.type !== "success" && /* @__PURE__ */ m(Ti, {
					color: Po(e.type || "info"),
					type: "other",
					width: c === Aa.Mobile ? 20 : 27,
					height: c === Aa.Mobile ? 20 : 27
				}),
				e.type === "success" && /* @__PURE__ */ m(Bi, {
					color: Po(e.type || "info"),
					width: c === Aa.Mobile ? 20 : 27,
					height: c === Aa.Mobile ? 20 : 27
				}),
				/* @__PURE__ */ m(Q, {
					id: `toast-message-${e.id}`,
					type: "body_ui",
					size: "medium",
					color: "var(--text-primary)",
					style: t !== 0 && !a ? { maxHeight: "24px" } : void 0,
					children: e.message
				}),
				e.action && /* @__PURE__ */ m(Kl, {
					id: `toast-action-${e.id}`,
					text: e.action.label,
					variant: "primary",
					size: "small",
					onClick: () => {
						_(), e.action.onClick();
					}
				})
			]
		}, e.id)), e]
	});
}, Ro = () => {
	let e = a(No);
	if (!e) throw Error("useToast must be used within a ToastProvider");
	return e;
}, zo = {
	border: "3px solid white",
	boxSizing: "border-box"
}, Bo = (n) => {
	let r = e(20), { avatars: i, maxVisible: a, size: s } = n, c = a === void 0 ? 4 : a, l = s === void 0 ? "small" : s, u;
	bb0: {
		if (!l) {
			u = "sm";
			break bb0;
		}
		switch (l) {
			case "small":
				u = "sm";
				break bb0;
			case "medium":
				u = "md";
				break bb0;
			case "large":
				u = "lg";
				break bb0;
			default: u = "sm";
		}
	}
	let f = u, p;
	r[0] === Symbol.for("react.memo_cache_sentinel") ? (p = [], r[0] = p) : p = r[0];
	let [g, _] = d(p), v;
	r[1] !== g || r[2] !== c ? (v = g.slice(0, c), r[1] = g, r[2] = c, r[3] = v) : v = r[3];
	let y = v, b = i.length - c, x = Vo, S, C;
	r[4] === i ? (S = r[5], C = r[6]) : (S = () => {
		i && _(i.map(Ho));
	}, C = [i], r[4] = i, r[5] = S, r[6] = C), o(S, C);
	let w;
	r[7] === Symbol.for("react.memo_cache_sentinel") ? (w = {
		display: "flex",
		alignItems: "center"
	}, r[7] = w) : w = r[7];
	let T;
	if (r[8] !== f || r[9] !== y) {
		let e;
		r[11] === f ? e = r[12] : (e = (e, n) => /* @__PURE__ */ h(t.Fragment, { children: [x(e) && /* @__PURE__ */ m(Go, {
			type: "image",
			size: f,
			imageUri: e,
			style: {
				transform: `translateX(-${30 * n}%)`,
				...zo
			}
		}), !x(e) && /* @__PURE__ */ m(Go, {
			type: "text-dark",
			size: f,
			text: e.slice(0, 1).toUpperCase(),
			style: {
				transform: `translateX(-${30 * n}%)`,
				...zo
			}
		})] }, `avatar-fragment-${n}`), r[11] = f, r[12] = e), T = y.map(e), r[8] = f, r[9] = y, r[10] = T;
	} else T = r[10];
	let E;
	r[13] !== f || r[14] !== b || r[15] !== y.length ? (E = b > 0 && /* @__PURE__ */ m(Go, {
		type: "number",
		size: f,
		number: b,
		style: {
			transform: `translateX(-${30 * y.length}%)`,
			...zo
		}
	}), r[13] = f, r[14] = b, r[15] = y.length, r[16] = E) : E = r[16];
	let D;
	return r[17] !== T || r[18] !== E ? (D = /* @__PURE__ */ h("div", {
		style: w,
		children: [T, E]
	}), r[17] = T, r[18] = E, r[19] = D) : D = r[19], D;
};
function Vo(e) {
	try {
		return new URL(e), !0;
	} catch {
		return !1;
	}
}
function Ho(e, t) {
	return N(e) ? `https://randomuser.me/api/portraits/${t % 2 ? "men" : "women"}/${t}.jpg` : e;
}
//#endregion
//#region src/components/avatar/avatar/Avatar.tsx
var Uo = (e, t) => {
	let n = {
		id: "",
		color: "var(--text-brand-main)"
	};
	switch (t) {
		case "xs": return /* @__PURE__ */ m(Q, {
			...n,
			type: "caption",
			size: "medium",
			children: e
		});
		case "sm": return /* @__PURE__ */ m(Q, {
			...n,
			type: "heading",
			size: "2x-small",
			children: e
		});
		case "md": return /* @__PURE__ */ m(Q, {
			...n,
			type: "heading",
			size: "x-small",
			children: e
		});
		case "lg": return /* @__PURE__ */ m(Q, {
			...n,
			type: "heading",
			size: "small",
			children: e
		});
		case "xl": return /* @__PURE__ */ m(Q, {
			...n,
			type: "heading",
			size: "x-large",
			children: e
		});
		case "2xl": return /* @__PURE__ */ m(Q, {
			...n,
			type: "heading",
			size: "x-large",
			children: e
		});
		default: return /* @__PURE__ */ m(Q, {
			...n,
			type: "caption",
			size: "medium",
			children: e
		});
	}
}, Wo = (e, t) => {
	let n = {
		id: "",
		color: "var(--text-black)"
	};
	switch (t) {
		case "xs": return /* @__PURE__ */ h(Q, {
			...n,
			type: "tag",
			size: "small",
			children: ["+", e]
		});
		case "sm": return /* @__PURE__ */ h(Q, {
			...n,
			type: "tag",
			size: "medium",
			children: ["+", e]
		});
		case "md": return /* @__PURE__ */ h(Q, {
			...n,
			type: "heading",
			size: "x-small",
			children: ["+", e]
		});
		case "lg": return /* @__PURE__ */ h(Q, {
			...n,
			type: "heading",
			size: "small",
			children: ["+", e]
		});
		case "xl": return /* @__PURE__ */ h(Q, {
			...n,
			type: "heading",
			size: "x-large",
			children: ["+", e]
		});
		case "2xl": return /* @__PURE__ */ h(Q, {
			...n,
			type: "heading",
			size: "x-large",
			children: ["+", e]
		});
		default: return /* @__PURE__ */ h(Q, {
			...n,
			type: "tag",
			size: "small",
			children: ["+", e]
		});
	}
}, Go = (t) => {
	let n = e(31), r, i, a, o, s, c, l, u;
	n[0] === t ? (r = n[1], i = n[2], a = n[3], o = n[4], s = n[5], c = n[6], l = n[7], u = n[8]) : ({size: c, type: u, icon: i, text: l, number: o, imageUri: a, className: r, ...s} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = c, n[7] = l, n[8] = u);
	let d = `size-${c}`, p = `type-${u}`, g;
	n[9] !== r || n[10] !== d || n[11] !== p ? (g = f("avatar", d, p, r), n[9] = r, n[10] = d, n[11] = p, n[12] = g) : g = n[12];
	let _ = g, v = (u === "icon-light" || u === "icon-dark" || u === "agency-brand" || u === "autopilot") && i, y;
	n[13] !== c || n[14] !== l || n[15] !== u ? (y = u === "text-dark" && Uo(l, c), n[13] = c, n[14] = l, n[15] = u, n[16] = y) : y = n[16];
	let b;
	n[17] !== o || n[18] !== c || n[19] !== u ? (b = u === "number" && Wo(o, c), n[17] = o, n[18] = c, n[19] = u, n[20] = b) : b = n[20];
	let x;
	n[21] !== a || n[22] !== u ? (x = u === "image" && /* @__PURE__ */ m("img", {
		src: a,
		alt: "Avatar Image"
	}), n[21] = a, n[22] = u, n[23] = x) : x = n[23];
	let S;
	return n[24] !== _ || n[25] !== s || n[26] !== v || n[27] !== y || n[28] !== b || n[29] !== x ? (S = /* @__PURE__ */ h("div", {
		className: _,
		...s,
		children: [
			v,
			y,
			b,
			x
		]
	}), n[24] = _, n[25] = s, n[26] = v, n[27] = y, n[28] = b, n[29] = x, n[30] = S) : S = n[30], S;
}, $ = (t) => {
	let n = e(28), r, i, a, o, s, c, l, u, d, p, h, g;
	n[0] === t ? (r = n[1], i = n[2], a = n[3], o = n[4], s = n[5], c = n[6], l = n[7], u = n[8], d = n[9], p = n[10], h = n[11], g = n[12]) : ({children: r, padding: u, gap: c, direction: h, fill: g, className: i, ref: d, contentAlignment: a, contentJustification: o, hideOverflow: l, flexShrink: s, ...p} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = c, n[7] = l, n[8] = u, n[9] = d, n[10] = p, n[11] = h, n[12] = g);
	let _ = h === void 0 ? "vertical" : h, v = g === void 0 ? !1 : g, y;
	if (n[13] !== i || n[14] !== a || n[15] !== o || n[16] !== _ || n[17] !== v || n[18] !== s || n[19] !== c || n[20] !== l || n[21] !== u) {
		let e = je(u, c);
		y = f("spacer", _, v && "fill", e, i, a && `align-${a}`, o && `justify-${o}`, l && "hide-overflow", s === void 0 ? "" : `flexShrink-${s}`), n[13] = i, n[14] = a, n[15] = o, n[16] = _, n[17] = v, n[18] = s, n[19] = c, n[20] = l, n[21] = u, n[22] = y;
	} else y = n[22];
	let b = y, x;
	return n[23] !== r || n[24] !== b || n[25] !== d || n[26] !== p ? (x = /* @__PURE__ */ m("div", {
		...p,
		className: b,
		ref: d,
		children: r
	}), n[23] = r, n[24] = b, n[25] = d, n[26] = p, n[27] = x) : x = n[27], x;
}, Ko = {
	xs: 24,
	sm: 32,
	md: 44,
	lg: 48,
	xl: 72,
	"2xl": 80
}, qo = (e) => {
	switch (e) {
		case "x-small": return "xs";
		case "small":
		case "sm": return "sm";
		case "medium":
		case "md": return "md";
		case "large":
		case "lg": return "lg";
		case "xl": return "xl";
		case "2xl": return "2xl";
		default: return "md";
	}
}, Jo = (e) => {
	let t = e.trim().split(/\s+/).filter(Boolean);
	return t.length === 0 ? "" : t.length === 1 ? t[0][0].toUpperCase() : `${t[0][0]}${t[t.length - 1][0]}`.toUpperCase();
}, Yo = (t) => {
	let n = e(32), { id: r, type: i, variant: a, photoWidth: s, photoHeight: c, label1: l, photoUrl: u, imageUrl: f, mode: p, backgroundMode: g, icon: _, size: v, responsiveBreakpoint: y } = t, b = i === void 0 ? "avatar" : i, x = a === void 0 ? "round" : a, S = p === void 0 ? "icon" : p, C = g === void 0 ? "light" : g, w = v === void 0 ? "md" : v, [T, E] = d(!1), D = Na(), O = y && ja[D] <= ja[y], k;
	n[0] === w ? k = n[1] : (k = qo(w), n[0] = w, n[1] = k);
	let A = k, j = Ko[A], M;
	n[2] === l ? M = n[3] : (M = Jo(l), n[2] = l, n[3] = M);
	let N = M, P = f ?? u, F;
	n[4] === Symbol.for("react.memo_cache_sentinel") ? (F = () => {
		E(!1);
	}, n[4] = F) : F = n[4];
	let I;
	n[5] === P ? I = n[6] : (I = [P], n[5] = P, n[6] = I), o(F, I);
	let L = A === "lg" || A === "xl" || A === "2xl" ? "medium" : "small", R = b === "photo" || x === "square" || x === "custom" ? "var(--radius-sm)" : "50%", z = !!P && !T, B;
	n[7] !== j || n[8] !== A || n[9] !== C || n[10] !== R || n[11] !== _ || n[12] !== N || n[13] !== l || n[14] !== S || n[15] !== c || n[16] !== s || n[17] !== P || n[18] !== z || n[19] !== x ? (B = z ? /* @__PURE__ */ m("img", {
		src: P,
		alt: l,
		onError: () => E(!0),
		style: {
			width: x === "custom" ? s : j,
			height: x === "custom" ? c : j,
			borderRadius: R,
			objectFit: "cover"
		}
	}) : S === "letters" ? /* @__PURE__ */ m("div", {
		className: `agx-avatarLabelGroup-defaultLetters agx-avatarLabelGroup-defaultLetters--${C}`,
		style: {
			width: j,
			height: j,
			borderRadius: R
		},
		children: /* @__PURE__ */ m(Q, {
			id: "initials",
			color: "var(--text-secondary)",
			type: "body",
			size: "medium",
			children: N
		})
	}) : /* @__PURE__ */ m(Go, {
		size: A,
		type: C === "dark" ? "icon-dark" : "icon-light",
		icon: _ ?? /* @__PURE__ */ m(aa, {}),
		style: { borderRadius: R }
	}), n[7] = j, n[8] = A, n[9] = C, n[10] = R, n[11] = _, n[12] = N, n[13] = l, n[14] = S, n[15] = c, n[16] = s, n[17] = P, n[18] = z, n[19] = x, n[20] = B) : B = n[20];
	let V;
	n[21] !== A || n[22] !== r || n[23] !== O || n[24] !== l || n[25] !== t || n[26] !== L ? (V = O ? /* @__PURE__ */ m("div", {
		className: "agx-avatarLabelGroup-tooltip",
		children: /* @__PURE__ */ m(Q, {
			id: `${r}-tooltip`,
			type: "caption",
			size: "medium",
			color: "var(--text-brand-main)",
			children: l
		})
	}) : /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: A === "lg" || A === "xl" || A === "2xl" ? "3xs" : void 0,
		children: [
			/* @__PURE__ */ m(Q, {
				type: A === "xs" ? "caption" : "body_ui",
				size: A === "xs" ? "medium" : L,
				color: "var(--text-secondary)",
				id: "lbl1",
				noWrap: !0,
				children: l
			}),
			"label2" in t && /* @__PURE__ */ m(Q, {
				type: A === "xs" ? "caption" : "body_ui",
				size: A === "xs" ? "medium" : L,
				color: "var(--text-secondary)",
				id: "lbl2`",
				noWrap: !0,
				children: t.label2
			}),
			"description" in t && /* @__PURE__ */ m(Q, {
				type: "caption",
				size: L,
				color: "var(--text-tertiary)",
				id: "description",
				children: t.description
			})
		]
	}), n[21] = A, n[22] = r, n[23] = O, n[24] = l, n[25] = t, n[26] = L, n[27] = V) : V = n[27];
	let H;
	return n[28] !== r || n[29] !== V || n[30] !== B ? (H = /* @__PURE__ */ m($, { children: /* @__PURE__ */ h($, {
		gap: "spacing-lg",
		id: r,
		direction: "horizontal",
		contentJustification: "center",
		contentAlignment: "center",
		flexShrink: 0,
		className: "agx-avatarLabelGroup-container",
		children: [B, V]
	}) }), n[28] = r, n[29] = V, n[30] = B, n[31] = H) : H = n[31], H;
}, Xo = (t) => {
	let n = e(24), { id: r, text: i, lines: a, gap: o } = t, s = a === void 0 ? 3 : a, l = u(null), [f, p] = d(!1), [g, _] = d(!1), v;
	n[0] === s ? v = n[1] : (v = () => {
		let e = l.current;
		if (!e) return;
		let t = {
			display: e.style.display,
			overflow: e.style.overflow,
			webkitBoxOrient: e.style.webkitBoxOrient,
			webkitLineClamp: e.style.webkitLineClamp
		};
		e.style.display = "-webkit-box", e.style.overflow = "hidden", e.style.webkitBoxOrient = "vertical", e.style.webkitLineClamp = String(s);
		let n = e.scrollHeight > e.clientHeight + 1;
		e.style.display = t.display, e.style.overflow = t.overflow, e.style.webkitBoxOrient = t.webkitBoxOrient, e.style.webkitLineClamp = t.webkitLineClamp, _(n), n || p(!1);
	}, n[0] = s, n[1] = v);
	let y = v, b;
	n[2] === y ? b = n[3] : (b = () => {
		let e = l.current;
		if (!e) return;
		y();
		let t = typeof ResizeObserver < "u" ? new ResizeObserver(y) : null;
		return t?.observe(e), () => t?.disconnect();
	}, n[2] = y, n[3] = b);
	let x;
	n[4] !== s || n[5] !== i ? (x = [i, s], n[4] = s, n[5] = i, n[6] = x) : x = n[6], c(b, x);
	let S;
	n[7] !== f || n[8] !== s ? (S = f ? { display: "flow" } : {
		display: "-webkit-box",
		overflow: "hidden",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: String(s)
	}, n[7] = f, n[8] = s, n[9] = S) : S = n[9];
	let C = `agx-note-body-${r}`, w;
	n[10] !== C || n[11] !== i ? (w = /* @__PURE__ */ m(Q, {
		id: C,
		type: "body_ui",
		size: "small",
		color: "var(--text-secondary)",
		children: i
	}), n[10] = C, n[11] = i, n[12] = w) : w = n[12];
	let T;
	n[13] !== S || n[14] !== w ? (T = /* @__PURE__ */ m($, {
		ref: l,
		className: "agx-note-expander",
		direction: "vertical",
		fill: !0,
		style: S,
		children: w
	}), n[13] = S, n[14] = w, n[15] = T) : T = n[15];
	let E;
	n[16] !== g || n[17] !== f || n[18] !== r ? (E = g && !f && /* @__PURE__ */ m(Kl, {
		id: `agx-note-expander-button-${r}`,
		variant: "link",
		text: "Expand",
		onClick: () => p(Zo)
	}), n[16] = g, n[17] = f, n[18] = r, n[19] = E) : E = n[19];
	let D;
	return n[20] !== o || n[21] !== T || n[22] !== E ? (D = /* @__PURE__ */ h($, {
		gap: o,
		fill: !0,
		children: [T, E]
	}), n[20] = o, n[21] = T, n[22] = E, n[23] = D) : D = n[23], D;
};
function Zo(e) {
	return !e;
}
//#endregion
//#region src/components/display/Notes/noteUtils.ts
var Qo = (e) => e ? (0, So.default)(e).format("D MMMM YYYY [at] h:mma") : "", $o = (e) => [e?.firstName, e?.lastName].filter(Boolean).join(" ").trim(), es = (e) => e.split(" ").filter(Boolean).map((e) => e[0]?.toUpperCase()).filter(Boolean).slice(0, 2).join("") || "UX", ts = (e, t) => t ? e.createdBy === t : !1, ns = (e) => e.toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, ""), rs = (t) => {
	let n = e(61), { noteIndex: r, currentUserId: i, staffDeleteNotePending: a, staffToggleNotePinPending: o, onTogglePin: s, onRequestDelete: c, note: l } = t, u = l.noteId ?? `note-${r}`, d;
	n[0] !== i || n[1] !== l ? (d = ts(l, i), n[0] = i, n[1] = l, n[2] = d) : d = n[2];
	let p = d, g;
	n[3] === l.name ? g = n[4] : (g = $o(l.name), n[3] = l.name, n[4] = g);
	let _ = g || l.createdBy || "Unknown user", v;
	n[5] === _ ? v = n[6] : (v = es(_), n[5] = _, n[6] = v);
	let y = v, b;
	n[7] === l.photo?.publicPath ? b = n[8] : (b = l.photo?.publicPath?.trim() || "", n[7] = l.photo?.publicPath, n[8] = b);
	let x = b, S;
	n[9] === l.isPinned ? S = n[10] : (S = f("agx-notes__note", { "agx-notes__note--pinned": l.isPinned }), n[9] = l.isPinned, n[10] = S);
	let C = `agx-note-item-${u}`, w;
	n[11] !== x || n[12] !== y ? (w = x ? /* @__PURE__ */ m(Go, {
		type: "image",
		size: "sm",
		imageUri: x
	}) : /* @__PURE__ */ m(Go, {
		type: "text-dark",
		size: "sm",
		text: y
	}), n[11] = x, n[12] = y, n[13] = w) : w = n[13];
	let T = `agx-note-author-${u}`, E;
	n[14] !== _ || n[15] !== T ? (E = /* @__PURE__ */ m(Q, {
		id: T,
		type: "body_ui_strong",
		size: "small",
		color: "var(--text-text-secondary)",
		children: _
	}), n[14] = _, n[15] = T, n[16] = E) : E = n[16];
	let D = `agx-note-timestamp-${u}`, O;
	n[17] === l.createdAt ? O = n[18] : (O = Qo(l.createdAt), n[17] = l.createdAt, n[18] = O);
	let k;
	n[19] !== D || n[20] !== O ? (k = /* @__PURE__ */ m(Q, {
		id: D,
		type: "caption",
		size: "small",
		color: "var(--text-tertiary)",
		children: O
	}), n[19] = D, n[20] = O, n[21] = k) : k = n[21];
	let A;
	n[22] !== k || n[23] !== E ? (A = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-xs",
		contentAlignment: "center",
		contentJustification: "space-between",
		fill: !0,
		children: [E, k]
	}), n[22] = k, n[23] = E, n[24] = A) : A = n[24];
	let j;
	n[25] !== l.text || n[26] !== u ? (j = /* @__PURE__ */ m(Xo, {
		id: u,
		text: l.text,
		lines: 3,
		gap: "spacing-md"
	}), n[25] = l.text, n[26] = u, n[27] = j) : j = n[27];
	let M = `agx-note-pin-${u}`, N = `agx-note-pin-${u}`, P = l.isPinned ? "var(--text-success)" : "var(--text-tertiary)", F;
	n[28] !== l.isPinned || n[29] !== P ? (F = /* @__PURE__ */ m(oa, {
		height: 14,
		width: 14,
		color: P,
		fill: l.isPinned
	}), n[28] = l.isPinned, n[29] = P, n[30] = F) : F = n[30];
	let I;
	n[31] !== l.noteId || n[32] !== s ? (I = () => void s(l.noteId), n[31] = l.noteId, n[32] = s, n[33] = I) : I = n[33];
	let L;
	n[34] !== o || n[35] !== M || n[36] !== N || n[37] !== F || n[38] !== I ? (L = /* @__PURE__ */ m(Kl, {
		id: M,
		dataTestId: N,
		variant: "image",
		text: F,
		disabled: o,
		onClick: I
	}), n[34] = o, n[35] = M, n[36] = N, n[37] = F, n[38] = I, n[39] = L) : L = n[39];
	let R;
	n[40] !== p || n[41] !== l || n[42] !== u || n[43] !== c || n[44] !== a ? (R = p && /* @__PURE__ */ m(Kl, {
		id: `agx-note-delete-${u}`,
		dataTestId: `agx-note-delete-${u}`,
		variant: "image",
		text: /* @__PURE__ */ m(Oi, {
			height: 14,
			width: 14,
			color: "var(--text-tertiary)"
		}),
		disabled: a,
		onClick: () => c(l)
	}), n[40] = p, n[41] = l, n[42] = u, n[43] = c, n[44] = a, n[45] = R) : R = n[45];
	let z;
	n[46] !== L || n[47] !== R ? (z = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "xs",
		contentJustification: "end",
		children: [L, R]
	}), n[46] = L, n[47] = R, n[48] = z) : z = n[48];
	let B;
	n[49] !== j || n[50] !== z ? (B = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "2xs",
		fill: !0,
		children: [j, z]
	}), n[49] = j, n[50] = z, n[51] = B) : B = n[51];
	let V;
	n[52] !== A || n[53] !== B ? (V = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-xl",
		fill: !0,
		children: [A, B]
	}), n[52] = A, n[53] = B, n[54] = V) : V = n[54];
	let H;
	return n[55] !== u || n[56] !== V || n[57] !== S || n[58] !== C || n[59] !== w ? (H = /* @__PURE__ */ h($, {
		className: S,
		"data-testid": C,
		direction: "horizontal",
		fill: !0,
		gap: "2xs",
		padding: "xs",
		children: [w, V]
	}, u), n[55] = u, n[56] = V, n[57] = S, n[58] = C, n[59] = w, n[60] = H) : H = n[60], H;
}, is = (t) => {
	let n = e(24), { titleId: r, closeId: i, onClose: a, currentUserId: o, notes: s, isPending: c, isError: l, staffDeleteNotePending: u, staffToggleNotePinPending: d, onTogglePin: f, onRequestDelete: p } = t, g;
	n[0] === r ? g = n[1] : (g = /* @__PURE__ */ m(Q, {
		id: r,
		type: "body_ui",
		size: "medium",
		color: "var(--text-primary)",
		children: "Notes"
	}), n[0] = r, n[1] = g);
	let _;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ m("span", {
		className: "agx-notes__close",
		"aria-hidden": "true",
		children: /* @__PURE__ */ m(Gi, {
			height: 24,
			width: 24,
			color: "var(--text-primary)"
		})
	}), n[2] = _) : _ = n[2];
	let v;
	n[3] !== i || n[4] !== a ? (v = /* @__PURE__ */ m(Kl, {
		id: i,
		dataTestId: "agx-notes-close",
		variant: "image",
		text: _,
		onClick: a
	}), n[3] = i, n[4] = a, n[5] = v) : v = n[5];
	let y;
	n[6] !== g || n[7] !== v ? (y = /* @__PURE__ */ h($, {
		direction: "horizontal",
		contentAlignment: "center",
		contentJustification: "space-between",
		padding: "md",
		fill: !0,
		children: [g, v]
	}), n[6] = g, n[7] = v, n[8] = y) : y = n[8];
	let b;
	n[9] === Symbol.for("react.memo_cache_sentinel") ? (b = {
		left: "md",
		right: "md",
		bottom: "md"
	}, n[9] = b) : b = n[9];
	let x;
	n[10] !== o || n[11] !== l || n[12] !== c || n[13] !== s || n[14] !== p || n[15] !== f || n[16] !== u || n[17] !== d ? (x = c ? /* @__PURE__ */ m($, {
		"data-testid": "agx-notes-loading",
		direction: "vertical",
		padding: "md",
		fill: !0,
		contentAlignment: "center",
		contentJustification: "start",
		children: /* @__PURE__ */ m(ao, {
			variant: "advanced",
			label: "Loading notes...",
			glyphType: "search",
			actionButtons: []
		})
	}) : l ? /* @__PURE__ */ m($, {
		"data-testid": "agx-notes-error",
		direction: "vertical",
		padding: "md",
		fill: !0,
		contentAlignment: "center",
		contentJustification: "start",
		children: /* @__PURE__ */ m(ao, {
			variant: "advanced",
			label: "Unable to load notes",
			glyphType: "checklist",
			actionButtons: []
		})
	}) : s.length === 0 ? /* @__PURE__ */ m($, {
		"data-testid": "agx-notes-empty",
		direction: "vertical",
		padding: "md",
		fill: !0,
		contentAlignment: "center",
		contentJustification: "start",
		children: /* @__PURE__ */ m(ao, {
			variant: "advanced",
			label: "No notes added",
			glyphType: "search",
			actionButtons: []
		})
	}) : (() => {
		let e = [], t = [];
		for (let n of s) (n.isPinned ? e : t).push(n);
		return [...e, ...t].map((e, t) => /* @__PURE__ */ m(rs, {
			noteIndex: t,
			currentUserId: o,
			staffDeleteNotePending: u,
			staffToggleNotePinPending: d,
			onTogglePin: f,
			onRequestDelete: p,
			note: e
		}, e.noteId ?? `note-${t}`));
	})(), n[10] = o, n[11] = l, n[12] = c, n[13] = s, n[14] = p, n[15] = f, n[16] = u, n[17] = d, n[18] = x) : x = n[18];
	let S;
	n[19] === x ? S = n[20] : (S = /* @__PURE__ */ m($, {
		className: "agx-notes__list",
		direction: "vertical",
		gap: "xs",
		padding: b,
		fill: !0,
		children: x
	}), n[19] = x, n[20] = S);
	let C;
	return n[21] !== y || n[22] !== S ? (C = /* @__PURE__ */ h($, {
		className: "agx-notes__panel-body",
		direction: "vertical",
		fill: !0,
		children: [y, S]
	}), n[21] = y, n[22] = S, n[23] = C) : C = n[23], C;
}, as = (t) => {
	let n = e(6), { id: r, errorText: i } = t, a;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (a = { top: "spacing-sm" }, n[0] = a) : a = n[0];
	let o;
	n[1] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m(ki, {
		type: "Danger",
		width: 16,
		height: 16
	}), n[1] = o) : o = n[1];
	let s = `error-${r}`, c = `${r}-error`, l;
	return n[2] !== i || n[3] !== s || n[4] !== c ? (l = /* @__PURE__ */ m("div", {
		className: "error",
		children: /* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "spacing-sm",
			padding: a,
			contentAlignment: "center",
			children: [o, /* @__PURE__ */ m(Q, {
				dataTestId: s,
				id: c,
				type: "form_error",
				size: "small",
				color: "var(--text-error)",
				children: i
			})]
		})
	}), n[2] = i, n[3] = s, n[4] = c, n[5] = l) : l = n[5], l;
}, os = (t) => {
	let n = e(26), { style: r, fill: i, position: a, expanded: s, hint: c, disabled: l, checked: u, onChange: g, type: _, errorText: v } = t, y = l === void 0 ? !1 : l, b = _ === void 0 ? "checkbox" : _, [x, S] = d(""), C, w;
	if (n[0] === v ? (C = n[1], w = n[2]) : (C = () => {
		S(v || "");
	}, w = [v], n[0] = v, n[1] = C, n[2] = w), o(C, w), r === "row") {
		let e;
		n[3] !== u || n[4] !== y || n[5] !== g || n[6] !== b ? (e = (e) => {
			if (!y && !e.target.closest("label, input")) {
				if (b === "radio") {
					u || g(!0);
					return;
				}
				g(!u);
			}
		}, n[3] = u, n[4] = y, n[5] = g, n[6] = b, n[7] = e) : e = n[7];
		let r = e, o;
		n[8] !== x || n[9] !== t ? (o = /* @__PURE__ */ m(ss, {
			...t,
			errorText: x
		}), n[8] = x, n[9] = t, n[10] = o) : o = n[10];
		let l = o, d = i && "fill", _ = s && "expanded", v;
		n[11] !== y || n[12] !== a || n[13] !== d || n[14] !== _ ? (v = f("checkboxRow", d, a, _, { disabled: y }), n[11] = y, n[12] = a, n[13] = d, n[14] = _, n[15] = v) : v = n[15];
		let S;
		n[16] !== l || n[17] !== c || n[18] !== t.id ? (S = c ? /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m($, {
			contentAlignment: "start",
			fill: !0,
			children: l
		}), /* @__PURE__ */ m($, {
			contentAlignment: "end",
			fill: !0,
			children: /* @__PURE__ */ m(Q, {
				id: `${t.id}-hint`,
				type: "body_ui",
				size: "small",
				color: "var(--text-tertiary)",
				children: c
			})
		})] }) : l, n[16] = l, n[17] = c, n[18] = t.id, n[19] = S) : S = n[19];
		let C;
		return n[20] !== r || n[21] !== v || n[22] !== S ? (C = /* @__PURE__ */ m("div", {
			className: v,
			onClick: r,
			children: S
		}), n[20] = r, n[21] = v, n[22] = S, n[23] = C) : C = n[23], C;
	}
	let T;
	return n[24] === t ? T = n[25] : (T = /* @__PURE__ */ m(ss, { ...t }), n[24] = t, n[25] = T), T;
}, ss = (t) => {
	let n = e(70), { id: r, dataTestId: i, label: a, subLabel: o, checked: s, indeterminate: c, disabled: l, onChange: d, strikethroughOnCheck: p, labelSize: g, errorText: _, required: v, validate: y, type: b } = t, x = i === void 0 ? r : i, S = c === void 0 ? !1 : c, C = l === void 0 ? !1 : l, w = b === void 0 ? "checkbox" : b, T = `checkbox-input-${r}`, E = u(!1), D;
	n[0] !== s || n[1] !== C || n[2] !== d || n[3] !== w ? (D = (e) => {
		if (!C && !(e.target instanceof HTMLInputElement)) {
			if (e.preventDefault(), E.current = !0, setTimeout(() => {
				E.current = !1;
			}, 0), w === "radio") {
				s || d(!0);
				return;
			}
			d(!s);
		}
	}, n[0] = s, n[1] = C, n[2] = d, n[3] = w, n[4] = D) : D = n[4];
	let O = D, k;
	n[5] !== C || n[6] !== w ? (k = f("agxCheckboxV2", { disabled: C }, w), n[5] = C, n[6] = w, n[7] = k) : k = n[7];
	let A = x ?? r, j;
	n[8] === S ? j = n[9] : (j = (e) => {
		e && (e.indeterminate = S);
	}, n[8] = S, n[9] = j);
	let M;
	n[10] === d ? M = n[11] : (M = (e) => {
		E.current || d(e.target.checked);
	}, n[10] = d, n[11] = M);
	let N;
	n[12] !== s || n[13] !== C || n[14] !== T || n[15] !== j || n[16] !== M || n[17] !== w ? (N = /* @__PURE__ */ m("input", {
		type: w,
		checked: s,
		disabled: C,
		ref: j,
		onChange: M,
		id: T,
		name: T,
		"data-testid": T
	}), n[12] = s, n[13] = C, n[14] = T, n[15] = j, n[16] = M, n[17] = w, n[18] = N) : N = n[18];
	let P = s && !S, F;
	n[19] !== S || n[20] !== P ? (F = f("checkbox-icon", {
		checked: P,
		indeterminate: S
	}), n[19] = S, n[20] = P, n[21] = F) : F = n[21];
	let I;
	n[22] !== C || n[23] !== S ? (I = S && /* @__PURE__ */ m(ls, { disabled: C }), n[22] = C, n[23] = S, n[24] = I) : I = n[24];
	let L;
	n[25] !== s || n[26] !== C || n[27] !== S || n[28] !== w ? (L = s && !S && w === "checkbox" && /* @__PURE__ */ m(cs, { disabled: C }), n[25] = s, n[26] = C, n[27] = S, n[28] = w, n[29] = L) : L = n[29];
	let R;
	n[30] !== s || n[31] !== C || n[32] !== S || n[33] !== w ? (R = s && !S && w === "radio" && /* @__PURE__ */ m(us, { disabled: C }), n[30] = s, n[31] = C, n[32] = S, n[33] = w, n[34] = R) : R = n[34];
	let z;
	n[35] !== F || n[36] !== I || n[37] !== L || n[38] !== R ? (z = /* @__PURE__ */ h("span", {
		className: F,
		children: [
			I,
			L,
			R
		]
	}), n[35] = F, n[36] = I, n[37] = L, n[38] = R, n[39] = z) : z = n[39];
	let B;
	n[40] !== s || n[41] !== C || n[42] !== r || n[43] !== a || n[44] !== g || n[45] !== p ? (B = a && /* @__PURE__ */ m(Q, {
		type: "body_ui",
		size: g || "medium",
		id: `${r}-label`,
		color: `${C ? "var(--text-disabled)" : "var(--text-primary)"}`,
		strikethrough: p && s,
		children: a
	}), n[40] = s, n[41] = C, n[42] = r, n[43] = a, n[44] = g, n[45] = p, n[46] = B) : B = n[46];
	let V;
	n[47] !== C || n[48] !== r || n[49] !== o ? (V = o && /* @__PURE__ */ m(Q, {
		type: "caption",
		size: "medium",
		id: `${r}-sublabel`,
		color: `${C ? "var(--text-disabled)" : "var(--text-tertiary)"}`,
		children: o
	}), n[47] = C, n[48] = r, n[49] = o, n[50] = V) : V = n[50];
	let H;
	n[51] !== B || n[52] !== V ? (H = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-xs",
		children: [B, V]
	}), n[51] = B, n[52] = V, n[53] = H) : H = n[53];
	let U;
	n[54] !== O || n[55] !== T || n[56] !== N || n[57] !== z || n[58] !== H || n[59] !== k || n[60] !== A ? (U = /* @__PURE__ */ h("label", {
		className: k,
		"data-testid": A,
		htmlFor: T,
		onClickCapture: O,
		children: [
			N,
			z,
			H
		]
	}), n[54] = O, n[55] = T, n[56] = N, n[57] = z, n[58] = H, n[59] = k, n[60] = A, n[61] = U) : U = n[61];
	let W;
	n[62] !== _ || n[63] !== r || n[64] !== v || n[65] !== y ? (W = _ && y && v && /* @__PURE__ */ m(as, {
		id: r,
		errorText: _
	}), n[62] = _, n[63] = r, n[64] = v, n[65] = y, n[66] = W) : W = n[66];
	let G;
	return n[67] !== U || n[68] !== W ? (G = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-sm",
		children: [U, W]
	}), n[67] = U, n[68] = W, n[69] = G) : G = n[69], G;
}, cs = (t) => {
	let n = e(2), { disabled: r } = t, i = r !== void 0 && r ? "var(--border-disabled, #DFDFDF)" : "var(--border-white, #FFF)", a;
	return n[0] === i ? a = n[1] : (a = /* @__PURE__ */ m("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "10px",
		height: "9px",
		viewBox: "0 0 10 9",
		fill: "none",
		children: /* @__PURE__ */ m("path", {
			d: "M0.928467 4L3.92847 7L9.07132 1",
			stroke: i,
			strokeWidth: "2"
		})
	}), n[0] = i, n[1] = a), a;
}, ls = (t) => {
	let n = e(2), { disabled: r } = t, i = r !== void 0 && r ? "var(--border-disabled, #DFDFDF)" : "var(--border-white, #FFF)", a;
	return n[0] === i ? a = n[1] : (a = /* @__PURE__ */ m("div", { style: {
		width: "10px",
		height: "2px",
		flexShrink: 0,
		background: i
	} }), n[0] = i, n[1] = a), a;
}, us = (t) => {
	let n = e(2), { disabled: r } = t, i = r !== void 0 && r ? "var(--border-disabled, #DFDFDF)" : "var(--fg-white, #FFF)", a;
	return n[0] === i ? a = n[1] : (a = /* @__PURE__ */ m("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "8px",
		height: "8px",
		viewBox: "0 0 8 8",
		fill: "none",
		children: /* @__PURE__ */ m("circle", {
			cx: "4",
			cy: "4",
			r: "4",
			fill: i
		})
	}), n[0] = i, n[1] = a), a;
}, ds = (e) => {
	if (e == null || typeof e == "boolean" || typeof e == "string" && e.trim() === "") return !0;
	if (Array.isArray(e)) return e.every(ds);
	if (t.isValidElement(e)) {
		if (e.type === t.Fragment) {
			let t = e.props.children;
			return t == null ? !0 : ds(t);
		}
		return !1;
	}
	return !1;
}, fs = (e) => {
	if (!e) return !1;
	let n = t.Children.toArray(e);
	return n.length === 0 ? !1 : !n.every(ds);
}, ps = (t) => {
	let n = e(6), { children: r, last: i, variant: a } = t, o = a === void 0 ? "default" : a, s;
	n[0] !== i || n[1] !== o ? (s = f("radio-group-item-expanded-content", o, { last: i }), n[0] = i, n[1] = o, n[2] = s) : s = n[2];
	let c;
	return n[3] !== r || n[4] !== s ? (c = /* @__PURE__ */ m("div", {
		className: s,
		children: r
	}), n[3] = r, n[4] = s, n[5] = c) : c = n[5], c;
}, ms = (t) => {
	let n = e(9), { id: r, label: i, required: a } = t, o = `${r}-label`, s;
	n[0] !== i || n[1] !== o ? (s = /* @__PURE__ */ m(Q, {
		id: o,
		type: "label",
		size: "medium",
		color: "var(--text-primary)",
		children: i
	}), n[0] = i, n[1] = o, n[2] = s) : s = n[2];
	let c;
	n[3] !== r || n[4] !== a ? (c = a && /* @__PURE__ */ m(Q, {
		id: `label-${r}`,
		type: "label",
		size: "medium",
		color: "var(--text-brand-accent)",
		children: "*"
	}), n[3] = r, n[4] = a, n[5] = c) : c = n[5];
	let l;
	return n[6] !== s || n[7] !== c ? (l = /* @__PURE__ */ m($, {
		direction: "horizontal",
		gap: "spacing-2xl",
		contentAlignment: "center",
		contentJustification: "space-between",
		fill: !0,
		children: /* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "spacing-xs",
			contentAlignment: "center",
			contentJustification: "start",
			children: [s, c]
		})
	}), n[6] = s, n[7] = c, n[8] = l) : l = n[8], l;
}, hs = (e, t) => t <= 1 ? "full" : e === 0 ? "top" : e === t - 1 ? "bottom" : "middle", gs = (n) => {
	let r = e(35), { id: i, layout: a, options: o, selectedValues: s, onOptionChange: c, disabled: l, subContent: u, subContentVariant: d, label: p, required: g, validate: _, errorText: v, type: y } = n, b = l === void 0 ? !1 : l, x = u === void 0 ? void 0 : u, S = d === void 0 ? "default" : d, C = p === void 0 ? void 0 : p, w = g === void 0 ? !1 : g, T = _ === void 0 ? !1 : _, E = v === void 0 ? "" : v, D;
	r[0] !== i || r[1] !== C || r[2] !== w ? (D = C && /* @__PURE__ */ m(ms, {
		id: i,
		label: C,
		required: w
	}), r[0] = i, r[1] = C, r[2] = w, r[3] = D) : D = r[3];
	let O;
	r[4] === a ? O = r[5] : (O = f("custom-radio-group", a), r[4] = a, r[5] = O);
	let k;
	if (r[6] !== b || r[7] !== i || r[8] !== c || r[9] !== o || r[10] !== s || r[11] !== x || r[12] !== S || r[13] !== y) {
		let e;
		r[15] !== b || r[16] !== i || r[17] !== c || r[18] !== o.length || r[19] !== s || r[20] !== x || r[21] !== S || r[22] !== y ? (e = (e, n) => {
			let r = s.includes(e.value), a = r && fs(x), l = `${i}-${e.value}`, u = {
				id: l,
				style: "row",
				dataTestId: l,
				label: e.label,
				checked: r,
				onChange: (t) => c(e.value, t),
				disabled: b || e.disabled,
				position: hs(n, o.length),
				expanded: a,
				hint: e.hint,
				labelSize: "medium"
			};
			return /* @__PURE__ */ h(t.Fragment, { children: [y === "radio" ? /* @__PURE__ */ m(os, {
				...u,
				type: "radio",
				indeterminate: !1
			}, l) : /* @__PURE__ */ m(os, {
				...u,
				type: "checkbox",
				indeterminate: !1
			}, l), a && /* @__PURE__ */ m(ps, {
				last: n === o.length - 1,
				variant: S,
				children: x
			})] }, `${i}-option-${e.value}`);
		}, r[15] = b, r[16] = i, r[17] = c, r[18] = o.length, r[19] = s, r[20] = x, r[21] = S, r[22] = y, r[23] = e) : e = r[23], k = o.map(e), r[6] = b, r[7] = i, r[8] = c, r[9] = o, r[10] = s, r[11] = x, r[12] = S, r[13] = y, r[14] = k;
	} else k = r[14];
	let A;
	r[24] !== k || r[25] !== O ? (A = /* @__PURE__ */ m("div", {
		className: O,
		children: k
	}), r[24] = k, r[25] = O, r[26] = A) : A = r[26];
	let j;
	r[27] !== E || r[28] !== i || r[29] !== T ? (j = E && T && /* @__PURE__ */ m(as, {
		id: i,
		errorText: E
	}), r[27] = E, r[28] = i, r[29] = T, r[30] = j) : j = r[30];
	let M;
	return r[31] !== A || r[32] !== j || r[33] !== D ? (M = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-lg",
		fill: !0,
		children: [
			D,
			A,
			j
		]
	}), r[31] = A, r[32] = j, r[33] = D, r[34] = M) : M = r[34], M;
}, _s = (t) => {
	let n = e(18), { id: r, layout: i, options: a, value: o, defaultValue: s, onChange: c, disabled: l, subContent: u, label: f, required: p, validate: h, errorText: g } = t, _ = i === void 0 ? "vertical" : i, v;
	n[0] === s ? v = n[1] : (v = s === void 0 ? [] : s, n[0] = s, n[1] = v);
	let y = v, b = l === void 0 ? !1 : l, x = u === void 0 ? void 0 : u, S = f === void 0 ? void 0 : f, C = p === void 0 ? !1 : p, w = h === void 0 ? !1 : h, T = g === void 0 ? "" : g, [E, D] = d(y), O = o ?? E, k;
	n[2] !== c || n[3] !== O || n[4] !== o ? (k = (e, t) => {
		let n = t ? O.includes(e) ? O : [...O, e] : O.filter((t) => t !== e);
		o === void 0 && D(n), c(n);
	}, n[2] = c, n[3] = O, n[4] = o, n[5] = k) : k = n[5];
	let A;
	return n[6] !== b || n[7] !== T || n[8] !== r || n[9] !== S || n[10] !== _ || n[11] !== a || n[12] !== C || n[13] !== O || n[14] !== x || n[15] !== k || n[16] !== w ? (A = /* @__PURE__ */ m(gs, {
		id: r,
		layout: _,
		options: a,
		selectedValues: O,
		onOptionChange: k,
		disabled: b,
		subContent: x,
		label: S,
		required: C,
		validate: w,
		errorText: T,
		type: "checkbox"
	}), n[6] = b, n[7] = T, n[8] = r, n[9] = S, n[10] = _, n[11] = a, n[12] = C, n[13] = O, n[14] = x, n[15] = k, n[16] = w, n[17] = A) : A = n[17], A;
}, vs = (t) => {
	let n = e(36), { id: r, name: i, value: a, label: o, size: s, checked: c, onChange: l, disabled: u, subContent: d, subContentVariant: p } = t, g = s === void 0 ? "medium" : s, _ = c === void 0 ? !1 : c, v = u === void 0 ? !1 : u, y = d === void 0 ? void 0 : d, b = p === void 0 ? "default" : p, x;
	n[0] !== v || n[1] !== l || n[2] !== a ? (x = () => {
		!l || v || l(a);
	}, n[0] = v, n[1] = l, n[2] = a, n[3] = x) : x = n[3];
	let S = x, C = b === "panel" ? "stretch" : "flex-start", w;
	n[4] === v ? w = n[5] : (w = f("custom-radio-button", { disabled: v }), n[4] = v, n[5] = w);
	let T;
	n[6] !== _ || n[7] !== v || n[8] !== S || n[9] !== r || n[10] !== i || n[11] !== a ? (T = /* @__PURE__ */ m("input", {
		id: r,
		"data-testid": r,
		type: "radio",
		name: i,
		value: a,
		checked: _,
		onChange: S,
		disabled: v
	}, r), n[6] = _, n[7] = v, n[8] = S, n[9] = r, n[10] = i, n[11] = a, n[12] = T) : T = n[12];
	let E;
	n[13] !== v || n[14] !== g ? (E = f("custom-circle", g, { disabled: v }), n[13] = v, n[14] = g, n[15] = E) : E = n[15];
	let D;
	n[16] === E ? D = n[17] : (D = /* @__PURE__ */ m("span", { className: E }), n[16] = E, n[17] = D);
	let O;
	n[18] !== v || n[19] !== r || n[20] !== o || n[21] !== g ? (O = o && /* @__PURE__ */ m(Q, {
		type: "body_ui",
		size: g,
		id: `${r}-label`,
		color: `${v ? "var(--text-disabled)" : "var(--text-primary)"}`,
		children: o
	}), n[18] = v, n[19] = r, n[20] = o, n[21] = g, n[22] = O) : O = n[22];
	let k;
	n[23] !== D || n[24] !== O || n[25] !== w || n[26] !== T ? (k = /* @__PURE__ */ h("label", {
		className: w,
		children: [
			T,
			D,
			O
		]
	}), n[23] = D, n[24] = O, n[25] = w, n[26] = T, n[27] = k) : k = n[27];
	let A;
	n[28] !== r || n[29] !== y || n[30] !== b ? (A = /* @__PURE__ */ m(ys, {
		id: r,
		subContent: y,
		variant: b
	}), n[28] = r, n[29] = y, n[30] = b, n[31] = A) : A = n[31];
	let j;
	return n[32] !== k || n[33] !== A || n[34] !== C ? (j = /* @__PURE__ */ h(Me, {
		gap: "spacing-md",
		alignItems: C,
		children: [k, A]
	}), n[32] = k, n[33] = A, n[34] = C, n[35] = j) : j = n[35], j;
}, ys = (t) => {
	let n = e(6), { id: r, subContent: i, variant: a } = t, o = a === void 0 ? "default" : a;
	if (!i || Array.isArray(i) && i.length === 0) return null;
	let s;
	n[0] === o ? s = n[1] : (s = f("agxRadio-item-expandedContent", o), n[0] = o, n[1] = s);
	let c = `agx-container-${r}`, l;
	return n[2] !== i || n[3] !== s || n[4] !== c ? (l = /* @__PURE__ */ m("div", {
		className: s,
		children: i
	}, c), n[2] = i, n[3] = s, n[4] = c, n[5] = l) : l = n[5], l;
}, bs = (t) => {
	let n = e(24), { id: r, layout: i, options: a, value: s, onChange: c, disabled: l, subContent: u, subContentVariant: f, label: p, required: h, validate: g, errorText: _, type: v } = t, y = i === void 0 ? "vertical" : i, b = l === void 0 ? !1 : l, x = u === void 0 ? void 0 : u, S = f === void 0 ? "default" : f, C = p === void 0 ? void 0 : p, w = h === void 0 ? !1 : h, T = g === void 0 ? !1 : g, E = _ === void 0 ? "" : _, D = v === void 0 ? "radio" : v, O;
	n[0] !== a || n[1] !== s ? (O = a.find((e) => e.value === s)?.value, n[0] = a, n[1] = s, n[2] = O) : O = n[2];
	let [k, A] = d(O), [j, M] = d(""), N, P;
	n[3] === E ? (N = n[4], P = n[5]) : (N = () => {
		M(E || "");
	}, P = [E], n[3] = E, n[4] = N, n[5] = P), o(N, P);
	let F;
	n[6] === k ? F = n[7] : (F = k ? [k] : [], n[6] = k, n[7] = F);
	let I;
	n[8] === c ? I = n[9] : (I = (e, t) => {
		t && A(e), c(e);
	}, n[8] = c, n[9] = I);
	let L;
	return n[10] !== b || n[11] !== r || n[12] !== C || n[13] !== y || n[14] !== j || n[15] !== a || n[16] !== w || n[17] !== x || n[18] !== S || n[19] !== F || n[20] !== I || n[21] !== D || n[22] !== T ? (L = /* @__PURE__ */ m(gs, {
		id: r,
		layout: y,
		options: a,
		selectedValues: F,
		onOptionChange: I,
		disabled: b,
		subContent: x,
		subContentVariant: S,
		label: C,
		required: w,
		validate: T,
		errorText: j,
		type: D
	}), n[10] = b, n[11] = r, n[12] = C, n[13] = y, n[14] = j, n[15] = a, n[16] = w, n[17] = x, n[18] = S, n[19] = F, n[20] = I, n[21] = D, n[22] = T, n[23] = L) : L = n[23], L;
}, xs = (t, n) => {
	let r = e(4), i, a;
	r[0] !== n || r[1] !== t ? (i = () => {
		let e = (e) => {
			(t.current && !t.current.contains(e.target) || e instanceof KeyboardEvent && e.keyCode === 27) && n("outside");
		};
		return document.addEventListener("mousedown", e), document.addEventListener("keydown", e), () => {
			document.removeEventListener("mousedown", e), document.removeEventListener("keydown", e);
		};
	}, a = [t, n], r[0] = n, r[1] = t, r[2] = i, r[3] = a) : (i = r[2], a = r[3]), o(i, a);
}, Ss = (e, t = 0) => e.toLocaleString("en-AU", {
	style: "currency",
	currency: "AUD",
	minimumFractionDigits: t ?? 0,
	maximumFractionDigits: t ?? 0
}), Cs = (e) => String(e).replace(/[^0-9.\-,]+/g, "").replace(/[$% ,]/g, ""), ws = /^\d{11}$/, Ts = /^\d{9}$/, Es = /^\d{1,10}$|^\d+\.\d{0,2}$/, Ds = /^(?:\(\d{2}\)\d{8}|\d{2}\d{8}|\d{8}|\d{6})$/, Os = /^[()\d\s]*$/, ks = (e) => {
	if (!ws.test(e)) return !1;
	let t = [
		10,
		1,
		3,
		5,
		7,
		9,
		11,
		13,
		15,
		17,
		19
	], n = 0;
	for (let r = 0; r < 11; r++) n += (Number(e[r]) - +!r) * t[r];
	return n % 89 == 0;
}, As = (e) => e.replace(/^(\d{2})(\d{3})(\d{3})(\d{3})$/, "$1 $2 $3 $4"), js = (e) => /^\d{0,11}$/.test(e), Ms = (e) => {
	if (e.length !== 9 || !Ts.test(e)) return !1;
	let t = [
		8,
		7,
		6,
		5,
		4,
		3,
		2,
		1
	], n = 0;
	for (let r = 0; r < 8; r++) n += Number(e[r]) * t[r];
	return (10 - n % 10) % 10 === Number(e[8]);
}, Ns = (e) => e.replace(/^(\d{3})(\d{3})(\d{3})$/, "$1 $2 $3"), Ps = (e) => /^\d{0,9}$/.test(e), Fs = (e, t = !1) => {
	if (e == null || e === "") return "";
	let [n, r] = String(e).replace(/,/g, "").split("."), i = n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	if (r !== void 0) {
		let e = r.length > 2 ? r.substring(0, 2) : r;
		return `${i}.${t && e.length < 2 ? e.padEnd(2, "0") : e}`;
	}
	return `${i}${t ? ".00" : ""}`;
}, Is = (e, t, n, r) => {
	let i = e.replace(/,/g, "");
	if (n && i.includes(".")) return e;
	if (!n && (i === "." || i === "0.")) return r("0."), "0.";
	let a = i === "" ? null : parseFloat(i);
	if (i.charAt(0) === "0" && i.length > 1 && i[1] !== "." && !i.includes(".") && (i = i.substring(1)), i.charAt(0) === "." && (i = `0.${i.substring(1)}`), i.match(Es) || i === "") {
		if (i === "" || a === null) return r(""), "";
		t === "percent" && a > 100 ? i = "100" : t === "currency" && i !== "" ? (n && (i = Math.round(a).toString()), i = Fs(i, !1)) : i = n ? Math.round(a).toString() : i, r(i);
	}
	return i;
}, Ls = (e) => e.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", ""), Rs = (e) => Os.test(e), zs = (e) => Ds.test(Ls(e)), Bs = (e) => {
	let t = Ls(e);
	return Ds.test(t) ? t.length === 10 ? t.startsWith("04") || t.startsWith("1300") || t.startsWith("1800") ? t.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3") : t.replace(/(\d{2})(\d{4})(\d{4})/, "$1 $2 $3") : t.length === 8 ? t.replace(/(\d{4})(\d{4})/, "$1 $2") : t.length === 6 ? t.replace(/(\d{2})(\d{2})(\d{2})/, "$1 $2 $3") : e : e;
}, Vs = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/, Hs = (t) => {
	let n = e(7), { value: r, setValue: i, setLocalError: a, inputProps: o } = t, s;
	n[0] !== a || n[1] !== i ? (s = (e) => {
		let t = e.target.value;
		if (js(t)) if (i(t), ks(t)) {
			let e = As(t);
			e && (i(e), a(""));
		} else a("ABN provided is not valid");
	}, n[0] = a, n[1] = i, n[2] = s) : s = n[2];
	let c = s, l;
	return n[3] !== c || n[4] !== o || n[5] !== r ? (l = /* @__PURE__ */ m("input", {
		...o,
		value: r,
		onChange: c
	}), n[3] = c, n[4] = o, n[5] = r, n[6] = l) : l = n[6], l;
}, Us = (t) => {
	let n = e(7), { value: r, setValue: i, setLocalError: a, inputProps: o } = t, s;
	n[0] !== a || n[1] !== i ? (s = (e) => {
		let t = e.target.value;
		if (Ps(t)) if (i(t), Ms(t)) {
			let e = Ns(t);
			e && (i(e), a(""));
		} else a("ACN provided is not valid");
	}, n[0] = a, n[1] = i, n[2] = s) : s = n[2];
	let c = s, l;
	return n[3] !== c || n[4] !== o || n[5] !== r ? (l = /* @__PURE__ */ m("input", {
		...o,
		value: r,
		onChange: c
	}), n[3] = c, n[4] = o, n[5] = r, n[6] = l) : l = n[6], l;
}, Ws = (t) => {
	let n = e(8), { value: r, setValue: i, setLocalError: a, inputProps: o } = t, s;
	n[0] !== o || n[1] !== a || n[2] !== i ? (s = (e) => {
		let t = e.target.value.trim();
		i(t), t === "" && !o.required || Vs.test(t.toLowerCase()) ? a("") : a("Please specify a valid email address");
	}, n[0] = o, n[1] = a, n[2] = i, n[3] = s) : s = n[3];
	let c = s, l;
	return n[4] !== c || n[5] !== o || n[6] !== r ? (l = /* @__PURE__ */ m("input", {
		...o,
		value: r,
		onChange: c
	}), n[4] = c, n[5] = o, n[6] = r, n[7] = l) : l = n[7], l;
}, Gs = (t) => {
	let n = e(8), { value: r, setValue: i, setLocalError: a, inputProps: o } = t, s;
	n[0] !== o || n[1] !== a || n[2] !== i ? (s = (e) => {
		let t = e.target.value;
		if (Rs(t)) {
			if (i(t), t === "" && !o.required) {
				a("");
				return;
			}
			if (!zs(t)) {
				a("Phone / Mobile Number is not valid");
				return;
			}
			a(""), i(Bs(t));
		}
	}, n[0] = o, n[1] = a, n[2] = i, n[3] = s) : s = n[3];
	let c = s, l;
	return n[4] !== c || n[5] !== o || n[6] !== r ? (l = /* @__PURE__ */ m("input", {
		...o,
		value: r,
		onChange: c
	}), n[4] = c, n[5] = o, n[6] = r, n[7] = l) : l = n[7], l;
}, Ks = (t) => {
	let n = e(20), { id: r, value: i, onInputValueChange: a, disabled: s } = t, c = u(null), [l, f] = d(i), p, g;
	n[0] === i ? (p = n[1], g = n[2]) : (p = () => {
		i && f(i);
	}, g = [i], n[0] = i, n[1] = p, n[2] = g), o(p, g);
	let _;
	n[3] !== r || n[4] !== a ? (_ = (e) => {
		let t = e.target.value;
		f(t), a && a({
			id: r,
			value: t
		});
	}, n[3] = r, n[4] = a, n[5] = _) : _ = n[5];
	let v;
	n[6] !== s || n[7] !== r || n[8] !== l || n[9] !== _ ? (v = /* @__PURE__ */ m("input", {
		ref: c,
		id: r,
		type: "date",
		value: l,
		disabled: s,
		onChange: _
	}), n[6] = s, n[7] = r, n[8] = l, n[9] = _, n[10] = v) : v = n[10];
	let y = `agx-calendar-icon ${s ? "disabled" : ""}`, b;
	n[11] === Symbol.for("react.memo_cache_sentinel") ? (b = () => c.current?.showPicker?.() || c.current?.focus(), n[11] = b) : b = n[11];
	let x = s ? "var(--fg-disabled)" : "var(--fg-tertiary)", S;
	n[12] === x ? S = n[13] : (S = /* @__PURE__ */ m(qi, { color: x }), n[12] = x, n[13] = S);
	let C;
	n[14] !== y || n[15] !== S ? (C = /* @__PURE__ */ m("span", {
		className: y,
		onClick: b,
		children: S
	}), n[14] = y, n[15] = S, n[16] = C) : C = n[16];
	let w;
	return n[17] !== v || n[18] !== C ? (w = /* @__PURE__ */ h("div", {
		className: "agx-date-input",
		children: [v, C]
	}), n[17] = v, n[18] = C, n[19] = w) : w = n[19], w;
}, qs = (e) => {
	let { id: t, type: n = "text", variant: r = "normal", selectedOption: a, options: s = [], onOptionChange: c, onIconButtonClick: p, iconButtonIcon: g, style: _ = "normal", label: v, labelHintText: y = "", hintText: b = "", optionalText: x = "Optional", placeholder: S = "", placeholderPosition: C = "left", size: w = "medium", required: T, hideOptionalText: E = !1, noHeader: D = !1, defaultValue: O, minLength: k, maxLength: A, disabled: j = !1, errorText: M = "", hideErrorDescription: N = !1, leftIcon: P, rightIcon: F, stretch: I, readonly: L = !1, noDecimalPoints: R = !1, addTrailingZeros: z = !0, overflowEllipsis: B = !0, autoFocus: V, textFormat: H = "normal", onInputValueChange: U, onChange: W, onKeyDown: G, onKeyUp: K, textAlign: q = "left", postHintText: J, border: Y = "squared", ref: X, minWidth: Z, onClick: ee } = e, [te, ne] = d(""), [re, ie] = d(!1), [ae, oe] = d(""), [se, ce] = d(!1), le = u(null), ue = u(null), de = i((e) => {
		if (!e) return "";
		let t = e, r = "";
		switch (n === "currency" ? t = R ? Fs(e || "0", !1) : Fs(e || "0", z) : n === "phone" && (t = Bs(e)), H) {
			case "titleCase":
				r = Ea(t);
				break;
			case "uppercase":
				r = e.toUpperCase();
				break;
			case "lowerCaseFirstLetter":
				r = Ta(t);
				break;
			default: r = t;
		}
		return ne(r), r;
	}, [
		H,
		n,
		R
	]), fe = l(() => [
		"currency",
		"fractionalNumbers",
		"number",
		"percent"
	], []);
	o(() => {
		if (O != null && !re) if (fe.includes(n)) {
			let e = String(O);
			if (n === "currency") {
				R ? Is(O, "currency", !0, ne) : ne(Fs(e, z));
				return;
			}
			Is(e, n, R, ne);
		} else ne(de(String(O)));
	}, [
		H,
		O,
		de,
		fe,
		n,
		R,
		re
	]), o(() => {
		oe(M || "");
	}, [M]);
	let pe = l(() => {
		switch (n) {
			case "email": return {
				inputMode: "email",
				type: "email"
			};
			case "currency": return {
				inputMode: "decimal",
				type: "text"
			};
			case "fractionalNumbers": return {
				inputMode: "decimal",
				type: "number"
			};
			case "percent": return R ? {
				inputMode: "numeric",
				type: "text"
			} : {
				inputMode: "decimal",
				type: "text"
			};
			case "number":
			case "abn":
			case "acn": return {
				inputMode: "numeric",
				type: "text"
			};
			case "phone": return {
				inputMode: "tel",
				type: "tel"
			};
			default: return {
				inputMode: "text",
				type: "text"
			};
		}
	}, [n, R]), me = f("textInputWrapperV2", w, ae && "error", { stretch: I }, { disabled: j }, { focus: re }, _, Y), he = f("textInputV2", { stretch: I }), ge = f(B && "overflowEllipsis"), _e = (e, t) => {
		let r = e.target.value;
		switch (n) {
			case "currency":
			case "fractionalNumbers":
			case "number":
			case "percent":
				r = Is(r, n, R, ne);
				break;
			default: ne(r);
		}
		if (t) {
			if (fe.includes(n)) {
				let e = Cs(r), n = parseFloat(e);
				t(Number.isNaN(n) ? "" : e);
				return;
			}
			t(r);
		}
	}, ve = (e) => {
		let t = e.target, n = le.current && !le.current.contains(t), r = ue.current && !ue.current.contains(t);
		n && r && ce(!1);
	};
	return o(() => (document.addEventListener("mousedown", ve), () => document.removeEventListener("mousedown", ve)), []), /* @__PURE__ */ m("div", {
		className: he,
		id: t,
		ref: X,
		onClick: (e) => {
			ee && (e.stopPropagation(), e.preventDefault(), ee());
		},
		children: /* @__PURE__ */ h($, {
			direction: "vertical",
			gap: D ? void 0 : "spacing-sm",
			children: [
				!D && /* @__PURE__ */ h(Ne, {
					gap: "spacing-2xl",
					alignItems: "alignCenter",
					justifyContent: "space-between",
					fill: !0,
					children: [/* @__PURE__ */ h(Ne, {
						gap: "spacing-xs",
						alignItems: "alignCenter",
						justifyContent: "left",
						children: [
							/* @__PURE__ */ m(Q, {
								id: `label-${t}`,
								type: "label",
								size: "medium",
								color: "var(--text-primary)",
								children: v
							}),
							T && /* @__PURE__ */ m(Q, {
								id: `label-${t}`,
								type: "label",
								size: "medium",
								color: "var(--text-brand-accent)",
								children: "*"
							}),
							y && /* @__PURE__ */ m(Q, {
								id: `labelHint-${t}`,
								type: "caption",
								size: "medium",
								color: "var(--text-tertiary)",
								children: y
							})
						]
					}), !E && /* @__PURE__ */ m(Q, {
						id: `optionalText-${t}`,
						type: "caption",
						size: "medium",
						color: "var(--text-tertiary)",
						children: x
					})]
				}),
				/* @__PURE__ */ h(Ne, {
					gap: "spacing-lg",
					alignItems: "alignCenter",
					fill: !0,
					children: [/* @__PURE__ */ h("div", {
						"data-version": "v2",
						className: me,
						id: t,
						style: { minWidth: Z },
						children: [
							n === "currency" ? /* @__PURE__ */ m(Ji, {}) : P,
							(() => {
								let e = {
									id: `input-${t}`,
									"data-testid": `agx-${Ta(t)}`,
									placeholder: S,
									required: T,
									minLength: k,
									maxLength: A,
									disabled: j,
									inputMode: pe.inputMode,
									type: pe.type,
									readOnly: L,
									autoFocus: V,
									onChange: (e) => {
										_e(e, W);
									},
									onFocus: () => {
										ie(!0);
									},
									onBlur: () => {
										ie(!1);
										let e = de(te);
										U && U({
											id: t,
											value: e
										});
									},
									className: `${ge} ${C === "right" ? "right-placeholder" : ""}`,
									onKeyDown: G,
									onKeyUp: K,
									style: { textAlign: q }
								};
								switch (n) {
									case "abn": return /* @__PURE__ */ m(Hs, {
										value: te,
										setValue: ne,
										setLocalError: oe,
										inputProps: e
									});
									case "acn": return /* @__PURE__ */ m(Us, {
										value: te,
										setValue: ne,
										setLocalError: oe,
										inputProps: e
									});
									case "email": return /* @__PURE__ */ m(Ws, {
										value: te,
										setValue: ne,
										setLocalError: oe,
										inputProps: e
									});
									case "phone": return /* @__PURE__ */ m(Gs, {
										value: te,
										setValue: ne,
										setLocalError: oe,
										inputProps: e
									});
									case "date": return /* @__PURE__ */ m(Ks, {
										id: t,
										value: te,
										disabled: j,
										onInputValueChange: (e) => {
											ne(e.value), U && U(e);
										}
									});
									default: return /* @__PURE__ */ m("input", {
										...e,
										inputMode: pe.inputMode,
										type: pe.type,
										value: te
									});
								}
							})(),
							n === "percent" ? /* @__PURE__ */ m(Yi, {}) : F,
							r === "withOptions" ? /* @__PURE__ */ m("div", {
								className: "icon-button-container",
								ref: ue,
								onClick: (e) => {
									e.stopPropagation(), ce((e) => !e);
								},
								children: /* @__PURE__ */ m(Ei, {
									height: 20,
									width: 20,
									direction: se ? "up" : "down",
									color: "var(--text-tertiary)"
								})
							}) : null,
							r === "withIconButton" ? /* @__PURE__ */ m("div", {
								className: "icon-button-container",
								onClick: () => p?.(),
								children: g || null
							}) : null,
							se && /* @__PURE__ */ m("div", {
								className: "agx-dropdown-menuV2",
								ref: le,
								"data-version": "v2",
								role: "listbox",
								style: { top: D ? "42px" : "68px" },
								children: /* @__PURE__ */ m(Me, {
									gap: "spacing-xs",
									fill: !0,
									children: s.map((e) => /* @__PURE__ */ h("div", {
										className: `agx-dropdown-optionV2 ${a === e.value ? "selected" : ""}`,
										onClick: () => {
											c?.(e.value), ce(!1);
										},
										children: [/* @__PURE__ */ m(Q, {
											id: "",
											type: "body_ui",
											size: "small",
											children: e.label
										}), a === e.value && /* @__PURE__ */ m(Ki, { color: "#000" })]
									}, e.value))
								})
							})
						]
					}), J && /* @__PURE__ */ m(Q, {
						id: "postHintText",
						type: "body_ui",
						size: "medium",
						color: "var(--text-primary)",
						children: J
					})]
				}),
				b && !ae && /* @__PURE__ */ m(Ne, {
					padding: { top: "spacing-sm" },
					children: /* @__PURE__ */ m(Q, {
						id: `description-${t}`,
						type: "body_ui",
						size: "small",
						color: "var(--text-tertiary)",
						"data-testid": `hintText-${t}`,
						children: b
					})
				}),
				ae && !N && !j && /* @__PURE__ */ h(Ne, {
					gap: "spacing-sm",
					padding: { top: "spacing-sm" },
					alignItems: "alignCenter",
					children: [/* @__PURE__ */ m(ki, {
						type: "Danger",
						width: 16,
						height: 16
					}), /* @__PURE__ */ m(Q, {
						dataTestId: `error-${t}`,
						id: "",
						type: "form_error",
						size: "small",
						children: ae
					})]
				})
			]
		})
	});
}, Js = (t) => {
	let n = e(16), { id: r, addressPredictions: i, selectedPredictionIndex: a, onAddressSelected: o, disabled: s } = t, c = s === void 0 ? !1 : s;
	if (!i || i.length === 0) return null;
	let l = c && "disabled", u;
	n[0] === l ? u = n[1] : (u = f("addressPredictions", l), n[0] = l, n[1] = u);
	let d;
	if (n[2] !== i || n[3] !== c || n[4] !== r || n[5] !== o || n[6] !== a) {
		let e;
		n[8] !== c || n[9] !== r || n[10] !== o || n[11] !== a ? (e = (e, t) => /* @__PURE__ */ h("div", {
			className: f("prediction", a === t && "selected"),
			"data-testid": `${r}-prediction-${t}`,
			onClick: () => {
				c || o(e.placeId);
			},
			children: [/* @__PURE__ */ m(ra, {}), /* @__PURE__ */ h(Q, {
				id: `${r}-prediction-text-${t}`,
				size: "small",
				type: "body_ui",
				color: "var(--text-primary)",
				children: [
					e.addressPartA,
					" ",
					e.addressPartB
				]
			})]
		}, `prediction-${e.placeId}`), n[8] = c, n[9] = r, n[10] = o, n[11] = a, n[12] = e) : e = n[12], d = i.map(e), n[2] = i, n[3] = c, n[4] = r, n[5] = o, n[6] = a, n[7] = d;
	} else d = n[7];
	let p;
	return n[13] !== u || n[14] !== d ? (p = /* @__PURE__ */ m("div", {
		className: u,
		children: d
	}), n[13] = u, n[14] = d, n[15] = p) : p = n[15], p;
}, Ys = (t) => {
	let n = e(53), { id: r, defaultValue: i, onChange: a, disableStateCountry: s, stateToSearch: c, validate: l } = t, f = s === void 0 ? !1 : s, p = c === void 0 ? "" : c, g = l === void 0 ? !1 : l, _ = u(a), v;
	n[0] !== i || n[1] !== p ? (v = () => {
		let e = i ?? {
			unitNumber: "",
			streetAddress: "",
			suburb: "",
			state: "",
			postCode: "",
			country: ""
		};
		return {
			...e,
			state: p === "" ? e.state : p
		};
	}, n[0] = i, n[1] = p, n[2] = v) : v = n[2];
	let [y, b] = d(v), x, S;
	n[3] === a ? (x = n[4], S = n[5]) : (x = () => {
		_.current = a;
	}, S = [a], n[3] = a, n[4] = x, n[5] = S), o(x, S);
	let C, w;
	n[6] === y ? (C = n[7], w = n[8]) : (C = () => {
		_.current(y);
	}, w = [y], n[6] = y, n[7] = C, n[8] = w), o(C, w);
	let T, E;
	n[9] !== y.state || n[10] !== f || n[11] !== p ? (E = () => {
		!f || p === "" || y.state === p || b((e) => ({
			...e,
			state: p
		}));
	}, T = [
		y.state,
		f,
		p
	], n[9] = y.state, n[10] = f, n[11] = p, n[12] = T, n[13] = E) : (T = n[12], E = n[13]), o(E, T);
	let D = `${r}-manual-address-unit-number`, O = y.unitNumber ?? "", k;
	n[14] === Symbol.for("react.memo_cache_sentinel") ? (k = (e) => b((t) => ({
		...t,
		unitNumber: e
	})), n[14] = k) : k = n[14];
	let A;
	n[15] !== D || n[16] !== O ? (A = /* @__PURE__ */ m(qs, {
		id: D,
		type: "text",
		defaultValue: O,
		onChange: k,
		label: "Unit/Lot Number",
		required: !1,
		stretch: !0
	}), n[15] = D, n[16] = O, n[17] = A) : A = n[17];
	let j = `${r}-manual-address-street-address`, M = y.streetAddress ?? "", N;
	n[18] === Symbol.for("react.memo_cache_sentinel") ? (N = (e) => b((t) => ({
		...t,
		streetAddress: e
	})), n[18] = N) : N = n[18];
	let P = g && y.streetAddress === "" ? "Enter street address" : void 0, F;
	n[19] !== j || n[20] !== M || n[21] !== P ? (F = /* @__PURE__ */ m(qs, {
		id: j,
		type: "text",
		defaultValue: M,
		onChange: N,
		label: "Street Address",
		required: !0,
		hideOptionalText: !0,
		stretch: !0,
		errorText: P
	}), n[19] = j, n[20] = M, n[21] = P, n[22] = F) : F = n[22];
	let I = `${r}-manual-address-suburb`, L = y.suburb ?? "", R;
	n[23] === Symbol.for("react.memo_cache_sentinel") ? (R = (e) => b((t) => ({
		...t,
		suburb: e
	})), n[23] = R) : R = n[23];
	let z = g && y.suburb === "" ? "Enter suburb" : void 0, B;
	n[24] !== I || n[25] !== L || n[26] !== z ? (B = /* @__PURE__ */ m(qs, {
		id: I,
		type: "text",
		defaultValue: L,
		onChange: R,
		label: "Suburb/City",
		required: !0,
		hideOptionalText: !0,
		stretch: !0,
		errorText: z
	}), n[24] = I, n[25] = L, n[26] = z, n[27] = B) : B = n[27];
	let V = `${r}-manual-address-state`, H = p === "" ? y.state ?? "" : p, U;
	n[28] === Symbol.for("react.memo_cache_sentinel") ? (U = (e) => b((t) => ({
		...t,
		state: e
	})), n[28] = U) : U = n[28];
	let W = f ? void 0 : g && y.state === "" ? "Enter state" : void 0, G;
	n[29] !== f || n[30] !== V || n[31] !== H || n[32] !== W ? (G = /* @__PURE__ */ m(qs, {
		id: V,
		type: "text",
		defaultValue: H,
		onChange: U,
		label: "State/Province",
		required: !0,
		hideOptionalText: !0,
		stretch: !0,
		disabled: f,
		errorText: W
	}), n[29] = f, n[30] = V, n[31] = H, n[32] = W, n[33] = G) : G = n[33];
	let K = `${r}-manual-address-post-code`, q = y.postCode ?? "", J;
	n[34] === Symbol.for("react.memo_cache_sentinel") ? (J = (e) => b((t) => ({
		...t,
		postCode: e
	})), n[34] = J) : J = n[34];
	let Y = g && y.postCode === "" ? "Enter postcode" : void 0, X;
	n[35] !== K || n[36] !== q || n[37] !== Y ? (X = /* @__PURE__ */ m(qs, {
		id: K,
		type: "text",
		defaultValue: q,
		onChange: J,
		label: "Postcode",
		required: !0,
		hideOptionalText: !0,
		stretch: !0,
		errorText: Y
	}), n[35] = K, n[36] = q, n[37] = Y, n[38] = X) : X = n[38];
	let Z;
	n[39] !== G || n[40] !== X ? (Z = /* @__PURE__ */ h(Ne, {
		fill: !0,
		gap: "spacing-lg",
		children: [G, X]
	}), n[39] = G, n[40] = X, n[41] = Z) : Z = n[41];
	let ee;
	n[42] !== y.country || n[43] !== f || n[44] !== r || n[45] !== g ? (ee = !f && /* @__PURE__ */ m(qs, {
		id: `${r}-manual-address-country`,
		type: "text",
		defaultValue: y.country ?? "",
		onChange: (e) => b((t) => ({
			...t,
			country: e
		})),
		label: "Country",
		required: !0,
		hideOptionalText: !0,
		stretch: !0,
		errorText: g && y.country === "" ? "Enter country" : void 0
	}), n[42] = y.country, n[43] = f, n[44] = r, n[45] = g, n[46] = ee) : ee = n[46];
	let te;
	return n[47] !== A || n[48] !== F || n[49] !== B || n[50] !== Z || n[51] !== ee ? (te = /* @__PURE__ */ h(Me, {
		gap: "spacing-lg",
		fill: !0,
		children: [
			A,
			F,
			B,
			Z,
			ee
		]
	}), n[47] = A, n[48] = F, n[49] = B, n[50] = Z, n[51] = ee, n[52] = te) : te = n[52], te;
}, Xs = ({ id: e, defaultValue: t, onAddressChange: n, label: r, stretch: i, optional: a, errorText: s, onlySearchForBusinessAddresses: c, onlyDisplayBusinessName: l, stateToSearch: f, useLongStreetNameInFormattedAddress: p, allowManualAddressEntry: g = !0, disableStateCountry: _ = !1, placeholderText: v = "", validate: y = !1 }) => {
	let b = u(n);
	b.current = n;
	let [x, S] = d(l ? { name: t } : t), [C, w] = d(() => l ? t || "" : t?.formattedAddress || ""), [T, E] = d(!1), [D, O] = d([]), [k, A] = d(void 0);
	o(() => {
		S(l ? { name: t } : t), w(l ? t || "" : t?.formattedAddress || "");
	}, [t, l]);
	let { searchForAddresses: j, getDetailsForPlaceId: M } = qa(f ?? void 0), N = async (e) => {
		if (!e) return;
		let t = await M(e, p);
		t && (S(t), b.current(t), w(l ? t.name ?? "" : t.formattedAddress ?? ""), O([]), A(void 0));
	}, P = (e) => {
		S(e), b.current(e);
	}, F = (e) => {
		if (!(!D || D.length === 0)) {
			if (e.key === "ArrowDown") e.preventDefault(), k === void 0 || k >= D.length - 1 ? A(0) : A(k + 1);
			else if (e.key === "ArrowUp") e.preventDefault(), A(k === void 0 || k === 0 ? D.length - 1 : k - 1);
			else if (e.key === "Enter") {
				if (e.preventDefault(), k === void 0) {
					O([]), A(void 0);
					return;
				}
				let t = D[k]?.placeId;
				N(t);
			}
		}
	}, I = (e) => {
		e.key === "Escape" && (e.preventDefault(), O([]), A(void 0));
	}, L = u(null);
	return xs(L, (e) => {
		e === "outside" && (O([]), A(void 0));
	}), o(() => {
		if (T && g && !l || !l && C === x?.formattedAddress || l && C === x?.name) return;
		if (!C || C.length < 3) {
			O([]), A(void 0), S(void 0), b.current(void 0);
			return;
		}
		let e = globalThis.setTimeout(() => {
			(async () => {
				let e = C;
				!l && e === x?.formattedAddress || l && e === x?.name || O((await j(e, c)).map((e) => ({
					placeId: e.placeId,
					addressPartA: e.mainText?.text || "",
					addressPartB: e.secondaryText?.text || ""
				})));
			})();
		}, 200);
		return () => {
			globalThis.clearTimeout(e);
		};
	}, [
		C,
		x?.formattedAddress,
		x?.name,
		l,
		g,
		T,
		c,
		j
	]), /* @__PURE__ */ h($, {
		gap: "spacing-lg",
		fill: i,
		id: e,
		"data-testid": `${e}-auto-complete-address-search`,
		children: [
			(!T || !g) && /* @__PURE__ */ h("div", {
				className: "searchWrapper",
				ref: L,
				children: [/* @__PURE__ */ m(qs, {
					id: `${e}-input`,
					type: "text",
					defaultValue: C,
					placeholder: v,
					required: !a,
					leftIcon: l ? /* @__PURE__ */ m(Di, { color: "var(--text-secondary)" }) : /* @__PURE__ */ m(ra, {}),
					onChange: (e) => {
						C !== e && w(e);
					},
					stretch: !0,
					onKeyDown: F,
					onKeyUp: I,
					label: r,
					errorText: s,
					hideOptionalText: !a,
					noHeader: !a && !r
				}), /* @__PURE__ */ m(Js, {
					id: e,
					addressPredictions: D,
					selectedPredictionIndex: k,
					onAddressSelected: N
				})]
			}),
			T && g && !l && /* @__PURE__ */ m(Ys, {
				defaultValue: x,
				onChange: P,
				id: e,
				disableStateCountry: _,
				stateToSearch: f,
				validate: y
			}),
			g && !l && /* @__PURE__ */ m($, {
				contentAlignment: "start",
				children: /* @__PURE__ */ m(Kl, {
					id: `${e}-addManuallyButton`,
					text: T ? "Search for address" : "Enter address manually",
					variant: "link",
					onClick: () => {
						T ? (w(x?.formattedAddress ?? ""), O([]), A(void 0)) : (O([]), A(void 0)), E((e) => !e);
					},
					size: "medium"
				})
			})
		]
	});
}, Zs = "sameAddress", Qs = "alternateAddress", $s = () => ({
	sameAddress: !0,
	alternate: void 0
}), ec = (e) => e ? !!(e.streetAddress?.trim() || e.suburb?.trim() || e.state?.trim() || e.postalCode?.trim() || e.country?.trim()) : !1, tc = (e, t) => {
	if (e) return {
		unitNumber: e.unitNumber,
		streetAddress: e.streetAddress || "",
		suburb: e.suburb || "",
		state: e.state || "",
		postCode: e.postalCode || "",
		country: e.country ?? "",
		formattedAddress: Ba({
			...e,
			country: e.country ?? ""
		}, t)
	};
}, nc = (e) => {
	if (e) return {
		unitNumber: e.unitNumber ?? "",
		streetAddress: e.streetAddress ?? "",
		suburb: e.suburb ?? "",
		state: e.state ?? "",
		postalCode: e.postCode ?? "",
		country: e.country ?? ""
	};
}, rc = (t) => {
	let n = e(58), { id: r, label: i, comparisonAddress: a, comparisonAddressLabel: s, alternateAddressLabel: c, onValueChanged: l, defaultValue: f, subDescription: p, stateToSearch: g, validate: _, required: v, globalAddress: y, placeHolderText: b, disableStateCountry: x } = t, S = _ === void 0 ? !1 : _, C = v === void 0 ? !1 : v, w = y === void 0 ? !1 : y, T = b === void 0 ? "" : b, E = x === void 0 ? !1 : x, D;
	n[0] === f ? D = n[1] : (D = f ?? $s(), n[0] = f, n[1] = D);
	let [O, k] = d(D), A = u(!1), j, M;
	n[2] === f ? (j = n[3], M = n[4]) : (j = () => {
		k(f ?? $s());
	}, M = [f], n[2] = f, n[3] = j, n[4] = M), o(j, M);
	let N, P;
	n[5] !== f || n[6] !== r || n[7] !== l ? (P = () => {
		f !== void 0 || A.current || (A.current = !0, l({
			id: r,
			value: $s()
		}));
	}, N = [
		f,
		r,
		l
	], n[5] = f, n[6] = r, n[7] = l, n[8] = N, n[9] = P) : (N = n[8], P = n[9]), o(P, N);
	let F;
	n[10] !== a || n[11] !== s || n[12] !== w ? (F = s ?? Ba(a, w), n[10] = a, n[11] = s, n[12] = w, n[13] = F) : F = n[13];
	let I = F, L;
	n[14] === I ? L = n[15] : (L = {
		label: I,
		value: Zs
	}, n[14] = I, n[15] = L);
	let R;
	n[16] === c ? R = n[17] : (R = {
		label: c,
		value: Qs
	}, n[16] = c, n[17] = R);
	let z;
	n[18] !== L || n[19] !== R ? (z = [L, R], n[18] = L, n[19] = R, n[20] = z) : z = n[20];
	let B = z, V = !O.sameAddress, H = S && V && !ec(O.alternate) ? "Enter address" : void 0, U;
	n[21] !== O.alternate || n[22] !== w ? (U = tc(O.alternate, w), n[21] = O.alternate, n[22] = w, n[23] = U) : U = n[23];
	let W = U, G;
	n[24] !== r || n[25] !== l ? (G = (e) => {
		k(e), l({
			id: r,
			value: e
		});
	}, n[24] = r, n[25] = l, n[26] = G) : G = n[26];
	let K = G, q;
	n[27] !== O || n[28] !== K ? (q = (e) => {
		K({
			...O,
			sameAddress: e === Zs
		});
	}, n[27] = O, n[28] = K, n[29] = q) : q = n[29];
	let J = q, Y;
	n[30] !== O || n[31] !== K ? (Y = (e) => {
		K({
			...O,
			sameAddress: !1,
			alternate: nc(e)
		});
	}, n[30] = O, n[31] = K, n[32] = Y) : Y = n[32];
	let X = Y, Z = V ? Qs : Zs, ee;
	n[33] !== W || n[34] !== H || n[35] !== E || n[36] !== X || n[37] !== r || n[38] !== T || n[39] !== V || n[40] !== g || n[41] !== S ? (ee = V ? /* @__PURE__ */ m($, {
		direction: "horizontal",
		fill: !0,
		padding: "md",
		children: /* @__PURE__ */ m(Xs, {
			id: `${r}-alternateAddress`,
			label: "Address",
			stretch: !0,
			optional: !1,
			placeholderText: T,
			errorText: H,
			onAddressChange: X,
			defaultValue: W,
			stateToSearch: g || void 0,
			allowManualAddressEntry: !0,
			disableStateCountry: E,
			validate: S
		})
	}) : void 0, n[33] = W, n[34] = H, n[35] = E, n[36] = X, n[37] = r, n[38] = T, n[39] = V, n[40] = g, n[41] = S, n[42] = ee) : ee = n[42];
	let te;
	n[43] !== J || n[44] !== r || n[45] !== i || n[46] !== B || n[47] !== C || n[48] !== Z || n[49] !== ee || n[50] !== S ? (te = /* @__PURE__ */ m(bs, {
		id: r,
		label: i,
		layout: "stacked",
		options: B,
		value: Z,
		onChange: J,
		required: C,
		validate: S,
		subContent: ee
	}), n[43] = J, n[44] = r, n[45] = i, n[46] = B, n[47] = C, n[48] = Z, n[49] = ee, n[50] = S, n[51] = te) : te = n[51];
	let ne;
	n[52] !== r || n[53] !== p ? (ne = p && /* @__PURE__ */ m(Q, {
		id: `${r}-subDescription`,
		type: "caption",
		size: "medium",
		color: "var(--text-secondary)",
		children: p
	}), n[52] = r, n[53] = p, n[54] = ne) : ne = n[54];
	let re;
	return n[55] !== te || n[56] !== ne ? (re = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "xs",
		fill: !0,
		children: [te, ne]
	}), n[55] = te, n[56] = ne, n[57] = re) : re = n[57], re;
}, ic = "Please enter a valid date", ac = 8, oc = 320, sc = "+10:00", cc = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/, lc = (e) => new Date(e.getFullYear(), e.getMonth(), e.getDate()), uc = (e) => {
	if (e instanceof Date && !isNaN(e.getTime())) return lc(e);
	if (typeof e == "string" && e) {
		let t = e.trim(), n = t.match(cc);
		if (n) {
			let [, e, t, r] = n;
			return new Date(Number(e), Number(t) - 1, Number(r));
		}
		let r = new Date(t);
		return isNaN(r.getTime()) ? null : lc(r);
	}
	return null;
}, dc = (e) => `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, "0")}-${String(e.getDate()).padStart(2, "0")}T00:00:00${sc}`, fc = ({ id: e, dataTestId: t = e, value: n, onChange: r, outputFormat: i = "date", placeholder: a = "dd/mm/yyyy", disabled: s = !1, className: c, minDate: g, maxDate: _, variant: v = "compact", showAsBadge: y = !1, noHeader: b = !1, optionalText: x = "Optional", label: S = "Select date", required: C = !1, footer: w, badgePrefix: T = "Due", align: E = "left", stretch: D = !1, showBorder: O = !1, validate: k = !1, errorText: A }) => {
	let j = l(() => g ? lc(g) : void 0, [g]), M = l(() => _ ? lc(_) : void 0, [_]), [N, P] = d(() => uc(n) ?? /* @__PURE__ */ new Date()), [F, I] = d(() => uc(n)), [L, R] = d(v === "calendar"), [z, B] = d(""), [V, H] = d(""), U = u(null), [W, G] = d({}), [K, q] = d(!1), J = N.getFullYear(), Y = N.getMonth(), X = new Date(J, Y, 1), Z = new Date(J, Y + 1, 0).getDate(), ee = (X.getDay() + 6) % 7, te = l(() => {
		let e = [];
		for (let t = 0; t < ee; t++) e.push(null);
		for (let t = 1; t <= Z; t++) {
			let n = new Date(J, Y, t);
			e.push(n);
		}
		return e;
	}, [
		J,
		Y,
		ee,
		Z
	]), ne = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	], re = [
		"Mo",
		"Tu",
		"We",
		"Th",
		"Fr",
		"Sa",
		"Su"
	], ie = (e) => e ? `${e.getDate().toString().padStart(2, "0")}/${(e.getMonth() + 1).toString().padStart(2, "0")}/${e.getFullYear().toString()}` : "", ae = (e) => {
		let t = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/.exec(e);
		if (!t) return !1;
		let n = parseInt(t[1], 10), r = parseInt(t[2], 10), i = parseInt(t[3], 10);
		if (i < 1900 || i > 2100) return !1;
		let a = new Date(i, r - 1, n);
		return a ? a.getFullYear() === i && a.getMonth() === r - 1 && a.getDate() === n : !1;
	}, oe = (e) => {
		if (!e || !ae(e)) return null;
		let t = e.match(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/);
		if (!t) return null;
		let n = parseInt(t[1], 10), r = parseInt(t[2], 10), i = parseInt(t[3], 10);
		return lc(new Date(i, r - 1, n));
	}, se = (e) => {
		if (!e) return { isValid: !0 };
		if (/[^0-9/]/.test(e)) return {
			isValid: !1,
			error: ic
		};
		let t = e.replace(/[^\d/]/g, "");
		return t.includes("//") || t.startsWith("/") || t.endsWith("/") || t.replace(/\//g, "").length === 0 && t.length > 0 || t.indexOf("/") === -1 ? {
			isValid: !1,
			error: ic
		} : e.length < 10 ? /^([0-3]?[0-9]?\/?[0-1]?[0-9]?\/?[0-9]{0,4})?$/.test(t) ? { isValid: !0 } : {
			isValid: !1,
			error: ic
		} : ae(t) ? {
			isValid: !0,
			parsedDate: oe(t) || void 0
		} : {
			isValid: !1,
			error: ic
		};
	}, ce = (e) => {
		if (!e) return "";
		let t = e.replace(/\D/g, "").slice(0, ac);
		return t.length === ac ? `${t.slice(0, 2)}/${t.slice(2, 4)}/${t.slice(4)}` : t;
	}, le = () => {
		let e = U.current?.getBoundingClientRect();
		if (!e) return;
		let t = window.innerHeight - e.bottom - 4 < oc;
		q(t);
		let n = E === "right" ? void 0 : e.left, r = E === "right" ? window.innerWidth - e.right : void 0;
		G({
			position: "fixed",
			...t ? {
				bottom: window.innerHeight - e.top + 4,
				left: n,
				right: r
			} : {
				top: e.bottom + 4,
				left: n,
				right: r
			},
			zIndex: 99999
		});
	}, ue = () => {
		if (s) return;
		let e = !L;
		v === "compact" && e && le(), R(e);
	};
	o(() => {
		B(ie(F)), H("");
	}, [F]), o(() => {
		let e = (e) => {
			let t = e.target, n = U.current?.contains(t), r = t.closest?.("[data-agx-date-picker-portal]");
			v === "compact" && L && !n && !r && R(!1);
		};
		return document.addEventListener("mousedown", e), () => {
			document.removeEventListener("mousedown", e);
		};
	}, [v, L]), o(() => {
		if (v !== "compact" || !L) return;
		let e = () => {
			R(!1);
		};
		return window.addEventListener("scroll", e, !0), () => {
			window.removeEventListener("scroll", e, !0);
		};
	}, [v, L]), o(() => {
		v !== "compact" || !L || le();
	}, [
		v,
		L,
		E
	]);
	let de = () => {
		P(new Date(J, Y - 1, 1));
	}, fe = () => {
		P(new Date(J, Y + 1, 1));
	}, pe = (e) => {
		if (!e || s) return;
		let t = lc(e);
		j && t < j || M && t > M || (I(t), P(t), B(ie(t)), H(""), r?.(i === "datetimeoffset" ? dc(t) : t), v === "compact" && R(!1));
	};
	o(() => {
		k && !z && C && H(ic);
	}, [
		z,
		C,
		k
	]), o(() => {
		k || z || H("");
	}, [z, k]);
	let me = (e) => {
		if (H(""), /[^0-9/]/.test(e)) {
			H(ic);
			return;
		}
		let t = ce(e), n = se(t);
		if (!n.isValid) {
			H(n.error || ic);
			return;
		}
		if (B(t), n.parsedDate) {
			let e = n.parsedDate;
			if (j && e < j) {
				H(`Date must be after ${ie(j)}`);
				return;
			}
			if (M && e > M) {
				H(`Date must be before ${ie(M)}`);
				return;
			}
			I(e), P(e), r?.(i === "datetimeoffset" ? dc(e) : e);
		} else t.length === 0 && (I(null), r?.(null));
	}, he = (e) => {
		me(e.value);
	}, { dateStatus: ge, badgeColor: _e, isHighlighted: ve, badgeHighlightText: ye } = l(() => {
		let e = Eo(F?.toDateString() ?? "");
		return {
			dateStatus: e,
			badgeColor: e === "Overdue" ? "red" : "yellow",
			isHighlighted: ["Today", "Overdue"].includes(e),
			badgeHighlightText: e
		};
	}, [F]), be = (e) => {
		if (!e) return !1;
		let t = lc(e);
		return !!(j && t < j || M && t > M);
	}, xe = f("agx-date-picker", { stretch: D }, c, {
		disabled: s,
		[`variant-${v}`]: !0,
		"calendar-open": L,
		"calendar-closed": !L
	});
	if (o(() => {
		let e = uc(n);
		I(e), e && P(e);
	}, [n]), v === "compact") {
		let n = A || V;
		return /* @__PURE__ */ h("div", {
			id: e,
			"data-testid": t ?? e,
			className: xe,
			ref: U,
			children: [
				y && !F && /* @__PURE__ */ m("div", {
					onClick: ue,
					children: /* @__PURE__ */ m(_o, {
						type: "colourfill",
						colour: "grey",
						size: "md",
						text: `${a}`,
						showBorder: O
					})
				}),
				y && ge !== "Invalid date" && ve && /* @__PURE__ */ m("div", {
					onClick: ue,
					children: /* @__PURE__ */ m(_o, {
						type: "highlighted",
						colour: _e,
						showBorder: O,
						size: "md",
						text: `${T} ${Do(F?.toDateString() ?? "", !1)}`,
						highlightText: ye
					})
				}),
				y && ge !== "Invalid date" && !ve && /* @__PURE__ */ m("div", {
					onClick: ue,
					children: /* @__PURE__ */ m(_o, {
						type: "colourfill",
						colour: _e,
						size: "md",
						showBorder: O,
						text: `${T} ${Do(F?.toDateString() ?? "", !1)}`
					})
				}),
				!y && /* @__PURE__ */ m(qs, {
					id: `${e}-input`,
					label: S,
					optionalText: x,
					noHeader: b,
					type: "text",
					placeholder: a,
					stretch: !0,
					defaultValue: z,
					onInputValueChange: he,
					disabled: s,
					errorText: n,
					required: C,
					hideOptionalText: C,
					rightIcon: /* @__PURE__ */ m("div", {
						className: "calendarIconContainer",
						onClick: ue,
						children: /* @__PURE__ */ m(qi, {
							color: "var(--fg-tertiary)",
							height: 20,
							width: 20
						})
					})
				}),
				L && /* @__PURE__ */ m(Xa, { children: /* @__PURE__ */ m("div", {
					className: "agx-date-picker variant-compact",
					"data-agx-date-picker-portal": !0,
					children: /* @__PURE__ */ h("div", {
						className: f("calendar-container", `align${E}`, { "calendar-opens-above": K }),
						style: W,
						children: [
							/* @__PURE__ */ h($, {
								direction: "horizontal",
								contentJustification: "space-between",
								contentAlignment: "center",
								padding: { bottom: "spacing-md" },
								children: [
									/* @__PURE__ */ m(Kl, {
										id: `${e}-prev-month`,
										text: /* @__PURE__ */ m(Ei, {
											direction: "left",
											color: "var(--text-primary)",
											width: 20,
											height: 20
										}),
										variant: "naked",
										size: "small",
										onClick: de,
										disabled: s
									}),
									/* @__PURE__ */ h(Q, {
										id: `${e}-selected-month`,
										type: "body_ui_strong",
										size: "small",
										children: [
											ne[Y],
											" ",
											J
										]
									}),
									/* @__PURE__ */ m(Kl, {
										id: `${e}-next-month`,
										text: /* @__PURE__ */ m(Ei, {
											direction: "right",
											color: "var(--text-primary)",
											width: 20,
											height: 20
										}),
										variant: "naked",
										size: "small",
										onClick: fe,
										disabled: s
									})
								]
							}),
							/* @__PURE__ */ h("div", {
								className: "calendar-grid",
								children: [/* @__PURE__ */ m("div", {
									className: "week-days",
									children: re.map((e) => /* @__PURE__ */ m("div", {
										className: "week-day",
										children: /* @__PURE__ */ m(Q, {
											id: e,
											type: "body_ui",
											size: "medium",
											children: e
										})
									}, e))
								}), /* @__PURE__ */ m("div", {
									className: "calendar-days",
									children: te.map((t, n) => /* @__PURE__ */ m(Kl, {
										id: `${e}-calendar-day-${n}`,
										text: t?.getDate(),
										variant: "naked",
										size: "small",
										onClick: () => pe(t),
										disabled: s || !t || be(t)
									}, n))
								})]
							}),
							w && /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m("div", {
								className: "datePicker_dividerContainer",
								children: /* @__PURE__ */ m(Ja, { variant: "horizontal" })
							}), /* @__PURE__ */ m("div", {
								className: "date-picker-footer",
								onClick: ue,
								children: w
							})] })
						]
					})
				}) })
			]
		});
	}
	return /* @__PURE__ */ h("div", {
		id: e,
		"data-testid": t,
		className: xe,
		children: [/* @__PURE__ */ h($, {
			direction: "horizontal",
			contentJustification: "space-between",
			contentAlignment: "center",
			padding: { bottom: "spacing-md" },
			children: [
				/* @__PURE__ */ m(Kl, {
					id: `${e}-prev-month`,
					text: /* @__PURE__ */ m(Ei, {
						direction: "left",
						color: "var(--text-primary)",
						width: 20,
						height: 20
					}),
					variant: "naked",
					size: "small",
					onClick: de,
					disabled: s
				}),
				/* @__PURE__ */ h(Q, {
					id: `${e}-selected-month`,
					type: "body_ui_strong",
					size: "small",
					children: [
						ne[Y],
						" ",
						J
					]
				}),
				/* @__PURE__ */ m(Kl, {
					id: `${e}-next-month`,
					text: /* @__PURE__ */ m(Ei, {
						direction: "right",
						color: "var(--text-primary)",
						width: 20,
						height: 20
					}),
					variant: "naked",
					size: "small",
					onClick: fe,
					disabled: s
				})
			]
		}), /* @__PURE__ */ h("div", {
			className: "calendar-grid",
			children: [/* @__PURE__ */ m("div", {
				className: "week-days",
				children: re.map((e) => /* @__PURE__ */ m("div", {
					className: "week-day",
					children: /* @__PURE__ */ m(Q, {
						id: e,
						type: "body_ui",
						size: "medium",
						children: e
					})
				}, e))
			}), /* @__PURE__ */ m("div", {
				className: "calendar-days",
				children: te.map((t, n) => /* @__PURE__ */ m(Kl, {
					id: `${e}-calendar-day-${n}`,
					text: t?.getDate(),
					variant: "naked",
					size: "small",
					onClick: () => pe(t),
					disabled: s || !t || be(t)
				}, n))
			})]
		})]
	});
}, pc = (e) => Oo(e) ?? "", mc = (e) => e === void 0 ? pc(/* @__PURE__ */ new Date()) : e, hc = (t) => {
	let n = e(24), { id: r, defaultStartDate: i, defaultEndDate: a, onChange: o, className: s } = t, c;
	n[0] === i ? c = n[1] : (c = () => mc(i), n[0] = i, n[1] = c);
	let [l, u] = d(c), p;
	n[2] === a ? p = n[3] : (p = () => mc(a), n[2] = a, n[3] = p);
	let [g, _] = d(p), v;
	n[4] !== g || n[5] !== o ? (v = (e) => {
		let t = pc(e);
		u(t), o({
			startDate: t,
			endDate: g
		});
	}, n[4] = g, n[5] = o, n[6] = v) : v = n[6];
	let y = v, b;
	n[7] !== l || n[8] !== o ? (b = (e) => {
		let t = pc(e);
		_(t), o({
			startDate: l,
			endDate: t
		});
	}, n[7] = l, n[8] = o, n[9] = b) : b = n[9];
	let x = b, S;
	n[10] === s ? S = n[11] : (S = f("agx-date-range-selector", s), n[10] = s, n[11] = S);
	let C = `${r}-start-date`, w;
	n[12] !== y || n[13] !== l || n[14] !== C ? (w = /* @__PURE__ */ m(fc, {
		id: C,
		className: "agx-date-range-selector__picker",
		noHeader: !0,
		optionalText: "",
		stretch: !0,
		value: l,
		onChange: y
	}), n[12] = y, n[13] = l, n[14] = C, n[15] = w) : w = n[15];
	let T = `${r}-end-date`, E;
	n[16] !== x || n[17] !== g || n[18] !== T ? (E = /* @__PURE__ */ m(fc, {
		id: T,
		className: "agx-date-range-selector__picker",
		noHeader: !0,
		optionalText: "",
		stretch: !0,
		value: g,
		onChange: x
	}), n[16] = x, n[17] = g, n[18] = T, n[19] = E) : E = n[19];
	let D;
	return n[20] !== S || n[21] !== w || n[22] !== E ? (D = /* @__PURE__ */ h($, {
		className: S,
		direction: "horizontal",
		contentAlignment: "center",
		fill: !0,
		gap: "spacing-2xl",
		children: [w, E]
	}), n[20] = S, n[21] = w, n[22] = E, n[23] = D) : D = n[23], D;
}, gc = (t) => {
	let n = e(4), r;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (r = {
		width: 0,
		height: 0
	}, n[0] = r) : r = n[0];
	let [i, a] = d(r), s, c;
	return n[1] === t ? (s = n[2], c = n[3]) : (s = () => {
		if (!t?.current) return;
		let e = new ResizeObserver((e) => {
			let { width: t, height: n } = e[0].contentRect;
			a({
				width: t,
				height: n
			});
		});
		return e.observe(t.current), () => e.disconnect();
	}, c = [t], n[1] = t, n[2] = s, n[3] = c), o(s, c), i;
}, _c = (t) => {
	let n = e(75), { id: r, options: i, menuRef: a, open: s, disabled: c, menuPosition: l, selected: u, onChange: g, type: _, searchable: v, searchPlaceholder: y } = t, b = v === void 0 ? !1 : v, S = y === void 0 ? "Search" : y, [C, w] = d(""), T;
	n[0] === u ? T = n[1] : (T = u instanceof Array ? u : [], n[0] = u, n[1] = T);
	let E = T, D, O;
	if (n[2] !== s || n[3] !== b ? (D = () => {
		(!s || !b) && w("");
	}, O = [s, b], n[2] = s, n[3] = b, n[4] = D, n[5] = O) : (D = n[4], O = n[5]), o(D, O), !s || typeof window > "u") return null;
	let k;
	n[6] !== c || n[7] !== s ? (k = f("agx-dropdown-menu", { open: s }, { disabled: c }), n[6] = c, n[7] = s, n[8] = k) : k = n[8];
	let A = k, j;
	if (n[9] !== i || n[10] !== C) {
		let e = C.trim().toLocaleLowerCase();
		j = e ? i.filter((t) => `${t.label} ${t.value}`.toLocaleLowerCase().includes(e)) : i, n[9] = i, n[10] = C, n[11] = j;
	} else j = n[11];
	let M = j, N;
	n[12] !== E || n[13] !== M ? (N = M.length > 0 && M.every((e) => E.includes(e.value)), n[12] = E, n[13] = M, n[14] = N) : N = n[14];
	let P = N, F;
	n[15] === Symbol.for("react.memo_cache_sentinel") ? (F = (e) => {
		w(e.target.value);
	}, n[15] = F) : F = n[15];
	let I = F, L;
	n[16] !== P || n[17] !== g || n[18] !== E || n[19] !== M ? (L = () => {
		if (P) {
			let e = M.map(vc);
			g(E.filter((t) => !e.includes(t)));
		} else {
			let e = M.map(yc);
			g([...new Set([...E, ...e])]);
		}
	}, n[16] = P, n[17] = g, n[18] = E, n[19] = M, n[20] = L) : L = n[20];
	let R = L, z;
	n[21] !== g || n[22] !== E ? (z = (e) => {
		E.includes(e) ? g(E.filter((t) => t !== e)) : g([...E, e]);
	}, n[21] = g, n[22] = E, n[23] = z) : z = n[23];
	let B = z, V;
	if (n[24] !== P || n[25] !== A || n[26] !== r || n[27] !== l.left || n[28] !== l.top || n[29] !== l.width || n[30] !== a || n[31] !== g || n[32] !== B || n[33] !== R || n[34] !== S || n[35] !== C || n[36] !== b || n[37] !== u || n[38] !== E || n[39] !== _ || n[40] !== M) {
		let e = `${r}-dropdown-menu`, t = `${l.top}px`, i = `${l.left}px`, o = `${l.width}px`, s;
		n[42] !== t || n[43] !== i || n[44] !== o ? (s = {
			position: "fixed",
			top: t,
			left: i,
			width: o
		}, n[42] = t, n[43] = i, n[44] = o, n[45] = s) : s = n[45];
		let c;
		n[46] !== r || n[47] !== S || n[48] !== C || n[49] !== b ? (c = b && /* @__PURE__ */ h("div", {
			className: "agx-dropdown-search",
			onClick: bc,
			children: [/* @__PURE__ */ m(Di, {
				color: "var(--text-tertiary)",
				height: 16,
				width: 16
			}), /* @__PURE__ */ m("input", {
				"aria-label": `${r} search`,
				autoFocus: !0,
				className: "agx-dropdown-search-input",
				"data-testid": `${r}-dropdown-search`,
				onChange: I,
				placeholder: S,
				type: "search",
				value: C
			})]
		}), n[46] = r, n[47] = S, n[48] = C, n[49] = b, n[50] = c) : c = n[50];
		let d;
		n[51] !== r || n[52] !== g || n[53] !== u || n[54] !== _ || n[55] !== M ? (d = _ === "single" && /* @__PURE__ */ h(Me, {
			gap: "spacing-sm",
			fill: !0,
			children: [M.map((e) => /* @__PURE__ */ h("div", {
				className: f("agx-dropdown-option", { selected: u === e.value }),
				"data-testid": `${r}-option-${e.value}-item`,
				onClick: () => {
					g(e.value);
				},
				children: [/* @__PURE__ */ m(Q, {
					id: `${r}-option-${e.value}`,
					type: "body_ui",
					size: "small",
					children: e.label
				}), u === e.value && /* @__PURE__ */ m(Ki, { color: "#000" })]
			}, e.value)), M.length === 0 && /* @__PURE__ */ m("div", {
				className: "agx-dropdown-no-results",
				"data-testid": `${r}-no-results-item`,
				children: /* @__PURE__ */ m(Q, {
					id: `${r}-no-results`,
					type: "body_ui",
					size: "small",
					children: "No results found"
				})
			})]
		}), n[51] = r, n[52] = g, n[53] = u, n[54] = _, n[55] = M, n[56] = d) : d = n[56];
		let v;
		n[57] !== P || n[58] !== r || n[59] !== B || n[60] !== R || n[61] !== E || n[62] !== _ || n[63] !== M ? (v = _ === "multi" && /* @__PURE__ */ h(Me, {
			gap: "spacing-sm",
			fill: !0,
			children: [M.length === 0 && /* @__PURE__ */ m("div", {
				className: "agx-dropdown-no-results",
				"data-testid": `${r}-no-results-item`,
				children: /* @__PURE__ */ m(Q, {
					id: `${r}-no-results`,
					type: "body_ui",
					size: "small",
					children: "No results found"
				})
			}), M.length > 0 && /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ h(Me, {
				fill: !0,
				children: [/* @__PURE__ */ h("div", {
					className: `${f("agx-dropdown-option", "multi-select", "select-all-option")}`,
					"data-testid": `${r}-select-all-option`,
					onClick: (e) => {
						e.preventDefault(), R();
					},
					children: [/* @__PURE__ */ m(os, {
						id: `${r}-select-all`,
						checked: P,
						onChange: R,
						type: "checkbox"
					}), /* @__PURE__ */ m(Q, {
						id: `${r}-select-all-label`,
						type: "body_ui",
						size: "small",
						color: "var(--text-primary)",
						children: "Select all"
					})]
				}), /* @__PURE__ */ m(Ja, { variant: "horizontal" })]
			}), /* @__PURE__ */ m(Me, {
				gap: "spacing-xs",
				fill: !0,
				children: M.map((e, t) => /* @__PURE__ */ h("div", {
					className: `${f("agx-dropdown-option", "multi-select", "select-all-option")}`,
					"data-testid": `${r}-option-${e.value}-item`,
					onClick: (t) => {
						t.preventDefault(), B(e.value);
					},
					children: [/* @__PURE__ */ m(os, {
						id: `${r}-option-${e.value}-checkbox`,
						checked: E.includes(e.value),
						onChange: () => B(e.value)
					}), /* @__PURE__ */ m(Q, {
						id: `${r}-option-${e.value}-label`,
						type: "body_ui",
						size: "small",
						color: "var(--text-primary)",
						children: e.label
					})]
				}, `dropdownOption-${e.value}-${t}`))
			})] })]
		}), n[57] = P, n[58] = r, n[59] = B, n[60] = R, n[61] = E, n[62] = _, n[63] = M, n[64] = v) : v = n[64];
		let y;
		n[65] !== d || n[66] !== v ? (y = /* @__PURE__ */ h("div", {
			className: "agx-dropdown-options",
			children: [d, v]
		}), n[65] = d, n[66] = v, n[67] = y) : y = n[67];
		let w;
		n[68] !== A || n[69] !== a || n[70] !== e || n[71] !== s || n[72] !== c || n[73] !== y ? (w = /* @__PURE__ */ h("div", {
			ref: a,
			className: A,
			"data-testid": e,
			"data-version": "v2",
			role: "listbox",
			style: s,
			children: [c, y]
		}), n[68] = A, n[69] = a, n[70] = e, n[71] = s, n[72] = c, n[73] = y, n[74] = w) : w = n[74], V = x.createPortal(w, document.body), n[24] = P, n[25] = A, n[26] = r, n[27] = l.left, n[28] = l.top, n[29] = l.width, n[30] = a, n[31] = g, n[32] = B, n[33] = R, n[34] = S, n[35] = C, n[36] = b, n[37] = u, n[38] = E, n[39] = _, n[40] = M, n[41] = V;
	} else V = n[41];
	return V;
};
function vc(e) {
	return e.value;
}
function yc(e) {
	return e.value;
}
function bc(e) {
	return e.stopPropagation();
}
//#endregion
//#region src/components/inputs/Dropdown/ConstrainedVisibilityComponent/ConstrainedVisibilityComponent.tsx
var xc = {
	position: "absolute",
	visibility: "hidden",
	left: -9999
}, Sc = (e, t) => e > t, Cc = ({ children: e, allowableWidth: t, onDisplayChange: n }) => {
	let r = u(null), [i, a] = d(1e5), s = Sc(i, t), c = () => r.current ? r.current.getBoundingClientRect().width : 0;
	return o(() => {
		if (!r.current) return;
		let e = new ResizeObserver(() => {
			a(c());
		});
		return e.observe(r.current), a(c()), () => {
			e.disconnect();
		};
	}, []), o(() => {
		n(i, !s);
	}, [i, s]), /* @__PURE__ */ m("div", {
		ref: r,
		style: s ? xc : void 0,
		children: e
	});
}, wc = (e) => e.map((e) => ({
	option: e,
	width: 1e5,
	allowableWidth: 0,
	isVisible: !1
})), Tc = ({ id: e, selectedOptions: t, onItemRemoveClicked: n, type: r, parentWidth: i, lineHeight: a }) => {
	let s = (e, t) => {
		e.preventDefault(), e.stopPropagation(), n(t);
	}, [c, l] = d(() => wc(t));
	o(() => {
		l(wc(t));
	}, [t]);
	let u = (e, t, n) => {
		l((r) => {
			let a = 0;
			return r.map((r, o) => {
				let s = {
					option: r.option,
					width: o === e ? t : r.width,
					allowableWidth: i - 80 - a,
					isVisible: o === e ? n : r.isVisible
				};
				return a += s.width, s;
			});
		});
	};
	o(() => {
		let e = 0;
		l(c.map((t) => {
			let n = {
				option: t.option,
				width: t.width,
				allowableWidth: i - e,
				isVisible: t.isVisible
			};
			return e += n.width, n;
		}));
	}, [i]);
	let f = c.reduce((e, t) => e + +!t.isVisible, 0);
	if (t.length === 0) return null;
	if (r === "single") return /* @__PURE__ */ m(Q, {
		id: `lbl-${e}-${t[0].value}`,
		type: "body_ui",
		size: "small",
		color: "var(--text-primary)",
		style: {
			whiteSpace: "nowrap",
			flexGrow: 1,
			...a ? { lineHeight: a } : {}
		},
		children: t[0].label
	});
	if (r === "multi") return /* @__PURE__ */ h(Ne, {
		gap: "spacing-sm",
		wrap: !1,
		fill: !0,
		alignItems: "alignCenter",
		children: [c.map(({ option: e, allowableWidth: t }, n) => /* @__PURE__ */ m(Cc, {
			allowableWidth: t,
			onDisplayChange: (e, t) => {
				u(n, e, t);
			},
			children: /* @__PURE__ */ m(_o, {
				type: "colourfill",
				text: e.label,
				colour: "grey",
				showBorder: !0,
				size: "sm",
				rightIcon: /* @__PURE__ */ m(Gi, {
					onClick: (t) => s(t, e.value),
					width: 12,
					height: 12
				})
			}, `multiOption-${n}-${e.value}`)
		}, `constrainedVisibility-${e.value}`)), f > 0 && /* @__PURE__ */ m(_o, {
			"data-overflow-indicator": "true",
			type: "colourfill",
			text: `+${f}`,
			colour: "grey",
			showBorder: !0,
			size: "sm"
		})]
	});
}, Ec = (t) => {
	let n = e(97), { id: r, label: i, options: a, selected: s, onChange: c, chipStyle: l, labelHintText: p, hintText: g, optionalText: _, placeholder: v, hideErrorDescription: y, errorText: b, disabled: x, hideOptionalText: S, noHeader: C, customValueKey: w, custom: T, type: E, minWidth: D, required: O, leftIcon: k, lineHeight: A, searchable: j, searchPlaceholder: M } = t, N = l === void 0 ? !1 : l, P = p === void 0 ? "" : p, F = g === void 0 ? "" : g, I = _ === void 0 ? "Optional" : _, L = v === void 0 ? "" : v, R = y === void 0 ? !1 : y, z = b === void 0 ? "" : b, B = x === void 0 ? !1 : x, V = S === void 0 ? !1 : S, H = C === void 0 ? !1 : C, U = w === void 0 ? "custom" : w, W = E === void 0 ? "single" : E, G = O === void 0 ? !1 : O, K = k === void 0 ? void 0 : k, q = j === void 0 ? !1 : j, J = M === void 0 ? "Search" : M, [Y, X] = d(!1), [Z, ee] = d(""), te;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (te = {
		top: 0,
		left: 0,
		width: 0
	}, n[0] = te) : te = n[0];
	let [ne, re] = d(te), ie = u(null), ae = u(null), { width: oe } = gc(ae), se = u(null), ce;
	n[1] !== N || n[2] !== B || n[3] !== Z || n[4] !== Y ? (ce = f("agx-dropdown-input", Z && "error", { open: Y }, { disabled: B }, { chipStyle: N }), n[1] = N, n[2] = B, n[3] = Z, n[4] = Y, n[5] = ce) : ce = n[5];
	let le = ce, ue;
	if (n[6] !== a || n[7] !== s) {
		let e;
		n[9] === s ? e = n[10] : (e = (e) => s === void 0 ? !1 : s instanceof Array ? s.includes(e.value) : e.value === s, n[9] = s, n[10] = e), ue = a.filter(e), n[6] = a, n[7] = s, n[8] = ue;
	} else ue = n[8];
	let de = ue, fe;
	n[11] === Symbol.for("react.memo_cache_sentinel") ? (fe = () => {
		if (ae.current) {
			let e = ae.current.getBoundingClientRect();
			re({
				top: e.bottom + 4,
				left: e.left,
				width: e.width
			});
		}
	}, n[11] = fe) : fe = n[11];
	let pe = fe, me;
	n[12] === Symbol.for("react.memo_cache_sentinel") ? (me = (e) => {
		let t = ie.current && !ie.current.contains(e.target), n = se.current && !se.current.contains(e.target);
		t && n && X(!1);
	}, n[12] = me) : me = n[12];
	let he = me, ge, _e;
	n[13] === z ? (ge = n[14], _e = n[15]) : (ge = () => {
		ee(z);
	}, _e = [z], n[13] = z, n[14] = ge, n[15] = _e), o(ge, _e);
	let ve, ye;
	n[16] === Symbol.for("react.memo_cache_sentinel") ? (ve = () => (document.addEventListener("mousedown", he), () => document.removeEventListener("mousedown", he)), ye = [], n[16] = ve, n[17] = ye) : (ve = n[16], ye = n[17]), o(ve, ye);
	let be, xe;
	n[18] === Y ? (be = n[19], xe = n[20]) : (be = () => (Y && (pe(), window.addEventListener("scroll", pe, !0), window.addEventListener("resize", pe)), () => {
		window.removeEventListener("scroll", pe, !0), window.removeEventListener("resize", pe);
	}), xe = [Y], n[18] = Y, n[19] = be, n[20] = xe), o(be, xe);
	let Se;
	n[21] !== c || n[22] !== W ? (Se = (e) => {
		W === "multi" ? c(e) : (c(e), X(!1));
	}, n[21] = c, n[22] = W, n[23] = Se) : Se = n[23];
	let Ce = Se, we;
	n[24] !== c || n[25] !== s || n[26] !== W ? (we = (e) => {
		W === "multi" && s instanceof Array && c(s.filter((t) => t !== e));
	}, n[24] = c, n[25] = s, n[26] = W, n[27] = we) : we = n[27];
	let Te = we, Ee;
	n[28] !== V || n[29] !== r || n[30] !== i || n[31] !== P || n[32] !== H || n[33] !== I || n[34] !== G ? (Ee = !H && /* @__PURE__ */ h(Ne, {
		gap: "spacing-2xl",
		alignItems: "alignCenter",
		justifyContent: "space-between",
		fill: !0,
		children: [/* @__PURE__ */ h(Ne, {
			gap: "spacing-xs",
			alignItems: "alignCenter",
			children: [
				/* @__PURE__ */ m(Q, {
					id: `label-${r}`,
					type: "label",
					size: "medium",
					color: "var(--text-primary)",
					children: i
				}),
				G && /* @__PURE__ */ m(Q, {
					id: `label-${r}`,
					type: "label",
					size: "medium",
					color: "var(--text-brand-accent)",
					children: "*"
				}),
				/* @__PURE__ */ m(Q, {
					id: `labelHint-${r}`,
					type: "caption",
					size: "medium",
					color: "var(--text-tertiary)",
					children: P
				})
			]
		}), !V && /* @__PURE__ */ m(Q, {
			id: `optionalText-${r}`,
			type: "caption",
			size: "medium",
			color: "var(--text-tertiary)",
			children: I
		})]
	}), n[28] = V, n[29] = r, n[30] = i, n[31] = P, n[32] = H, n[33] = I, n[34] = G, n[35] = Ee) : Ee = n[35];
	let De;
	n[36] === r ? De = n[37] : (De = Ta(r), n[36] = r, n[37] = De);
	let Oe = `agx-${De}`, ke;
	n[38] === Symbol.for("react.memo_cache_sentinel") ? (ke = () => X(Dc), n[38] = ke) : ke = n[38];
	let Ae;
	n[39] === D ? Ae = n[40] : (Ae = { minWidth: D }, n[39] = D, n[40] = Ae);
	let je;
	n[41] !== r || n[42] !== oe || n[43] !== A || n[44] !== Te || n[45] !== de || n[46] !== W ? (je = /* @__PURE__ */ m(Tc, {
		id: r,
		selectedOptions: de,
		onItemRemoveClicked: Te,
		type: W,
		parentWidth: oe,
		lineHeight: A
	}), n[41] = r, n[42] = oe, n[43] = A, n[44] = Te, n[45] = de, n[46] = W, n[47] = je) : je = n[47];
	let Pe;
	n[48] !== r || n[49] !== A || n[50] !== L || n[51] !== de.length ? (Pe = de.length === 0 && /* @__PURE__ */ m(Q, {
		id: `${r}-placeholder`,
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		style: {
			whiteSpace: "nowrap",
			flexGrow: 1,
			...A ? { lineHeight: A } : {}
		},
		children: L
	}), n[48] = r, n[49] = A, n[50] = L, n[51] = de.length, n[52] = Pe) : Pe = n[52];
	let Fe = Y ? "up" : "down", Ie;
	n[53] === Fe ? Ie = n[54] : (Ie = /* @__PURE__ */ m("div", {
		className: "dropdownRightIconContainer",
		children: /* @__PURE__ */ m(Ei, {
			direction: Fe,
			color: "var(--text-tertiary)",
			height: 20,
			width: 20
		})
	}), n[53] = Fe, n[54] = Ie);
	let Le;
	n[55] !== le || n[56] !== r || n[57] !== K || n[58] !== Oe || n[59] !== Ae || n[60] !== je || n[61] !== Pe || n[62] !== Ie ? (Le = /* @__PURE__ */ h("div", {
		id: r,
		ref: ae,
		"data-testid": Oe,
		"data-version": "v2",
		className: le,
		onClick: ke,
		style: Ae,
		children: [
			K,
			je,
			Pe,
			Ie
		]
	}), n[55] = le, n[56] = r, n[57] = K, n[58] = Oe, n[59] = Ae, n[60] = je, n[61] = Pe, n[62] = Ie, n[63] = Le) : Le = n[63];
	let Re;
	n[64] !== F || n[65] !== r || n[66] !== Z ? (Re = F && !Z && /* @__PURE__ */ m(Q, {
		id: `description-${r}`,
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		"data-testid": `hintText-${r}`,
		children: F
	}), n[64] = F, n[65] = r, n[66] = Z, n[67] = Re) : Re = n[67];
	let ze;
	n[68] !== B || n[69] !== R || n[70] !== r || n[71] !== Z ? (ze = Z && !R && !B && /* @__PURE__ */ h(Ne, {
		gap: "spacing-sm",
		alignItems: "alignCenter",
		children: [/* @__PURE__ */ m(Ti, {
			type: "danger",
			width: 16,
			height: 16
		}), /* @__PURE__ */ m(Q, {
			dataTestId: `error-${r}`,
			id: "",
			type: "form_error",
			size: "small",
			color: "var(--text-error)",
			children: Z
		})]
	}), n[68] = B, n[69] = R, n[70] = r, n[71] = Z, n[72] = ze) : ze = n[72];
	let Be;
	n[73] !== Ee || n[74] !== Le || n[75] !== Re || n[76] !== ze ? (Be = /* @__PURE__ */ h(Me, {
		gap: "spacing-sm",
		fill: !0,
		children: [
			Ee,
			Le,
			Re,
			ze
		]
	}), n[73] = Ee, n[74] = Le, n[75] = Re, n[76] = ze, n[77] = Be) : Be = n[77];
	let Ve;
	n[78] !== B || n[79] !== r || n[80] !== ne || n[81] !== Ce || n[82] !== Y || n[83] !== a || n[84] !== J || n[85] !== q || n[86] !== s || n[87] !== W ? (Ve = /* @__PURE__ */ m(_c, {
		id: r,
		options: a,
		menuRef: se,
		open: Y,
		disabled: B,
		menuPosition: ne,
		onChange: Ce,
		selected: s,
		type: W,
		searchable: q,
		searchPlaceholder: J
	}), n[78] = B, n[79] = r, n[80] = ne, n[81] = Ce, n[82] = Y, n[83] = a, n[84] = J, n[85] = q, n[86] = s, n[87] = W, n[88] = Ve) : Ve = n[88];
	let He;
	n[89] !== T || n[90] !== U || n[91] !== s ? (He = s === U && T && /* @__PURE__ */ m("div", {
		className: "agx-dropdown-custom",
		children: T
	}), n[89] = T, n[90] = U, n[91] = s, n[92] = He) : He = n[92];
	let Ue;
	return n[93] !== Be || n[94] !== Ve || n[95] !== He ? (Ue = /* @__PURE__ */ h("div", {
		className: "agx-dropdown-wrapper",
		ref: ie,
		children: [
			Be,
			Ve,
			He
		]
	}), n[93] = Be, n[94] = Ve, n[95] = He, n[96] = Ue) : Ue = n[96], Ue;
};
function Dc(e) {
	return !e;
}
//#endregion
//#region src/components/inputs/ImageUpload/ImageUpload.tsx
var Oc = (t) => {
	let n = e(96), { id: r, maxImages: i, maxFileSizeMB: a, accept: o, onFilesChange: s, onImageRemove: c, onDownloadAll: l, onUpload: p, initialImages: g, dataTestId: _ } = t, v = i === void 0 ? 35 : i, y = a === void 0 ? 15 : a, b = o === void 0 ? "image/*" : o, x;
	n[0] === g ? x = n[1] : (x = g === void 0 ? [] : g, n[0] = g, n[1] = x);
	let S = x, C;
	n[2] === S ? C = n[3] : (C = () => S.map(kc), n[2] = S, n[3] = C);
	let [w, T] = d(C), [E, D] = d(!1), [O, k] = d(null), [A, j] = d(null), M = u(null), N = w.length < v, P = Ac, I;
	n[4] === s ? I = n[5] : (I = (e, t) => {
		T((n) => {
			let r = n.map((n) => n.id === e ? {
				...n,
				...t
			} : n);
			return s?.(r), r;
		});
	}, n[4] = s, n[5] = I);
	let L = I, R;
	n[6] !== p || n[7] !== L ? (R = async (e) => {
		if (e.status === "uploading") {
			if (!p) {
				L(e.id, {
					status: "uploaded",
					progress: 100,
					error: void 0
				});
				return;
			}
			try {
				await p(e, (t) => {
					let n = Number.isFinite(t) ? Math.min(Math.max(t, 0), 100) : 0;
					L(e.id, {
						status: "uploading",
						progress: n,
						error: void 0
					});
				}), L(e.id, {
					status: "uploaded",
					progress: 100,
					error: void 0
				});
			} catch (t) {
				let n = t;
				L(e.id, {
					status: "failed",
					progress: void 0,
					error: n instanceof Error ? n.message : "Upload failed"
				});
			}
		}
	}, n[6] = p, n[7] = L, n[8] = R) : R = n[8];
	let z = R, B;
	n[9] === y ? B = n[10] : (B = (e) => e.type.startsWith("image/") ? e.size > y * 1024 * 1024 ? `File size must be less than ${y}MB` : null : "File must be an image", n[9] = y, n[10] = B);
	let V = B, H;
	n[11] !== z || n[12] !== w || n[13] !== v || n[14] !== s || n[15] !== V ? (H = (e) => {
		if (!e) return;
		let t = Array.from(e), n = [], r = [];
		if (t.forEach((e) => {
			let t = V(e);
			if (t) {
				let n = P(e, "failed", w.length + r.length);
				n.error = t, r.push(n);
			} else w.length + n.length < v && n.push(e);
		}), n.forEach((e) => {
			let t = P(e, "uploading", w.length + r.length);
			r.push(t);
		}), r.length > 0) {
			let e = [...w, ...r].map(jc);
			T(e), s?.(e), r.filter(Mc).forEach((e) => {
				z(e);
			});
		}
	}, n[11] = z, n[12] = w, n[13] = v, n[14] = s, n[15] = V, n[16] = H) : H = n[16];
	let U = H, W;
	n[17] === Symbol.for("react.memo_cache_sentinel") ? (W = (e) => {
		e.preventDefault(), e.stopPropagation(), e.dataTransfer.types.includes("Files") && D(!0);
	}, n[17] = W) : W = n[17];
	let G = W, K;
	n[18] === Symbol.for("react.memo_cache_sentinel") ? (K = (e) => {
		e.preventDefault(), e.stopPropagation(), e.currentTarget.contains(e.relatedTarget) || D(!1);
	}, n[18] = K) : K = n[18];
	let q = K, J;
	n[19] !== U || n[20] !== w.length || n[21] !== v ? (J = (e) => {
		if (e.preventDefault(), e.stopPropagation(), D(!1), w.length >= v) return;
		let t = e.dataTransfer.files;
		t.length > 0 && U(t);
	}, n[19] = U, n[20] = w.length, n[21] = v, n[22] = J) : J = n[22];
	let Y = J, X;
	n[23] === w ? X = n[24] : (X = (e, t) => {
		let n = w.find((e) => e.id === t);
		n && n.status === "uploaded" ? (k(t), e.dataTransfer.effectAllowed = "move", e.dataTransfer.setData("text/plain", t)) : e.preventDefault();
	}, n[23] = w, n[24] = X);
	let Z = X, ee;
	n[25] !== O || n[26] !== w ? (ee = (e, t) => {
		if (O && O !== t) {
			let n = w.find((e) => e.id === O), r = w.find((e) => e.id === t);
			n?.status === "uploaded" && r?.status === "uploaded" && (e.preventDefault(), e.stopPropagation(), e.dataTransfer.dropEffect = "move", j(t));
		}
	}, n[25] = O, n[26] = w, n[27] = ee) : ee = n[27];
	let te = ee, ne;
	n[28] === Symbol.for("react.memo_cache_sentinel") ? (ne = (e) => {
		e.currentTarget.contains(e.relatedTarget) || j(null);
	}, n[28] = ne) : ne = n[28];
	let re = ne, ie;
	n[29] !== O || n[30] !== w || n[31] !== s ? (ie = (e, t) => {
		if (e.preventDefault(), e.stopPropagation(), O && O !== t) {
			let e = w.findIndex((e) => e.id === O), n = w.findIndex((e) => e.id === t);
			if (e !== -1 && n !== -1) {
				let t = [...w], [r] = t.splice(e, 1);
				t.splice(n, 0, r);
				let i = t.map(Nc);
				T(i), s?.(i);
			}
		}
		k(null), j(null);
	}, n[29] = O, n[30] = w, n[31] = s, n[32] = ie) : ie = n[32];
	let ae = ie, oe;
	n[33] === Symbol.for("react.memo_cache_sentinel") ? (oe = () => {
		k(null), j(null);
	}, n[33] = oe) : oe = n[33];
	let se = oe, ce;
	n[34] === U ? ce = n[35] : (ce = (e) => {
		U(e.target.files), M.current && (M.current.value = "");
	}, n[34] = U, n[35] = ce);
	let le = ce, ue;
	n[36] !== s || n[37] !== c ? (ue = (e) => {
		T((t) => {
			let n = t.filter((t) => t.id === e ? (URL.revokeObjectURL(t?.fileName ?? t?.preview ?? ""), !1) : !0).map(Pc);
			return s?.(n), c?.(e), n;
		});
	}, n[36] = s, n[37] = c, n[38] = ue) : ue = n[38];
	let de = ue, fe;
	n[39] === N ? fe = n[40] : (fe = () => {
		N && M.current?.click();
	}, n[39] = N, n[40] = fe);
	let pe = fe, me;
	n[41] !== w || n[42] !== l ? (me = async () => {
		if (l) {
			l();
			return;
		}
		let e = w.filter(Fc);
		if (e.length === 0) return;
		let t = (await Promise.all(e.map(Ic))).filter(Lc);
		if (t.length === 0) return;
		let n = await F(t).blob(), r = document.createElement("a");
		r.href = URL.createObjectURL(n), r.download = "images.zip", document.body.appendChild(r), r.click(), document.body.removeChild(r), URL.revokeObjectURL(r.href);
	}, n[41] = w, n[42] = l, n[43] = me) : me = n[43];
	let he = me, ge = _ ?? r, _e = `${r}-limit-max`, ve;
	n[44] !== v || n[45] !== _e ? (ve = /* @__PURE__ */ m("li", { children: /* @__PURE__ */ h(Q, {
		id: _e,
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: [
			"Maximum of ",
			v,
			" images"
		]
	}) }), n[44] = v, n[45] = _e, n[46] = ve) : ve = n[46];
	let ye = `${r}-limit-size`, be;
	n[47] !== y || n[48] !== ye ? (be = /* @__PURE__ */ m("li", { children: /* @__PURE__ */ h(Q, {
		id: ye,
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: [
			"Maximum file size: ",
			y,
			"MB"
		]
	}) }), n[47] = y, n[48] = ye, n[49] = be) : be = n[49];
	let xe;
	n[50] !== ve || n[51] !== be ? (xe = /* @__PURE__ */ h("ul", {
		className: "agx-image-upload__limits",
		children: [ve, be]
	}), n[50] = ve, n[51] = be, n[52] = xe) : xe = n[52];
	let Se;
	n[53] !== he || n[54] !== r || n[55] !== w.length ? (Se = w.length > 0 && /* @__PURE__ */ m(Kl, {
		id: `${r}-download-all`,
		text: "Download all",
		variant: "hollow",
		size: "small",
		onClick: he
	}), n[53] = he, n[54] = r, n[55] = w.length, n[56] = Se) : Se = n[56];
	let Ce;
	n[57] !== xe || n[58] !== Se ? (Ce = /* @__PURE__ */ h(Me, {
		gap: "spacing-lg",
		children: [xe, Se]
	}), n[57] = xe, n[58] = Se, n[59] = Ce) : Ce = n[59];
	let we;
	n[60] !== A || n[61] !== O || n[62] !== te || n[63] !== Z || n[64] !== ae || n[65] !== de || n[66] !== r || n[67] !== w ? (we = w.length > 0 && /* @__PURE__ */ m("div", {
		className: "agx-image-upload__grid",
		children: w.map((e) => /* @__PURE__ */ h("div", {
			style: { position: "relative" },
			children: [/* @__PURE__ */ m("div", {
				className: f("agx-image-upload__image-item", O === e.id && "agx-image-upload__image-item--dragging", A === e.id && "agx-image-upload__image-item--drag-over"),
				draggable: e.status === "uploaded",
				onDragStart: (t) => Z(t, e.id),
				onDragOver: (t) => te(t, e.id),
				onDragLeave: re,
				onDrop: (t) => ae(t, e.id),
				onDragEnd: se,
				children: /* @__PURE__ */ h("div", {
					className: "agx-image-upload__image-wrapper",
					children: [
						/* @__PURE__ */ m("img", {
							src: e?.preview ?? e.publicPath,
							alt: e?.file?.name ?? e.fileName,
							className: "agx-image-upload__image"
						}),
						e.status === "uploading" && /* @__PURE__ */ h("div", {
							className: "agx-image-upload__overlay",
							children: [/* @__PURE__ */ m("div", {
								className: "agx-image-upload__progress-bar",
								children: /* @__PURE__ */ m("div", {
									className: "agx-image-upload__progress-fill",
									style: { width: `${e.progress ?? 0}%` }
								})
							}), /* @__PURE__ */ h(Q, {
								id: `${r}-progress-${e.id}`,
								type: "caption",
								size: "small",
								color: "var(--text-white)",
								children: [Math.round(e.progress ?? 0), "%"]
							})]
						}),
						e.status === "failed" && /* @__PURE__ */ m("div", {
							className: "agx-image-upload__overlay agx-image-upload__overlay--error",
							children: /* @__PURE__ */ m(Q, {
								id: `${r}-error-${e.id}`,
								type: "form_error",
								size: "small",
								color: "var(--text-error)",
								children: "Upload failed"
							})
						})
					]
				})
			}, e.id), /* @__PURE__ */ m("button", {
				className: "agx-image-upload__remove-button",
				onClick: (t) => {
					t.stopPropagation(), de(e.id);
				},
				onMouseDown: Rc,
				"aria-label": "Remove image",
				children: /* @__PURE__ */ m(Gi, {
					width: 16,
					height: 16,
					color: "rgba(var(--color-white-main))"
				})
			})]
		}))
	}), n[60] = A, n[61] = O, n[62] = te, n[63] = Z, n[64] = ae, n[65] = de, n[66] = r, n[67] = w, n[68] = we) : we = n[68];
	let Te = E && "agx-image-upload__dropzone--dragging", Ee;
	n[69] === Te ? Ee = n[70] : (Ee = f("agx-image-upload__dropzone", Te), n[69] = Te, n[70] = Ee);
	let De;
	n[71] !== b || n[72] !== le ? (De = /* @__PURE__ */ m("input", {
		ref: M,
		type: "file",
		accept: b,
		multiple: !0,
		onChange: le,
		className: "agx-image-upload__file-input",
		"aria-label": "Upload images"
	}), n[71] = b, n[72] = le, n[73] = De) : De = n[73];
	let Oe;
	n[74] === Symbol.for("react.memo_cache_sentinel") ? (Oe = /* @__PURE__ */ m(Ai, {
		width: 48,
		height: 48,
		color: "var(--text-tertiary)"
	}), n[74] = Oe) : Oe = n[74];
	let ke;
	n[75] !== N || n[76] !== r ? (ke = !N && /* @__PURE__ */ m(Q, {
		id: `${r}-dropzone-text`,
		type: "body",
		size: "small",
		color: "var(--text-error)",
		children: "File limit reached"
	}), n[75] = N, n[76] = r, n[77] = ke) : ke = n[77];
	let Ae;
	n[78] !== N || n[79] !== r ? (Ae = N && /* @__PURE__ */ h(Q, {
		id: `${r}-dropzone-text`,
		type: "body",
		size: "small",
		children: [
			"Drag and drop or ",
			/* @__PURE__ */ m("span", {
				className: "agx-image-upload__link",
				children: "Choose file"
			}),
			" to upload"
		]
	}), n[78] = N, n[79] = r, n[80] = Ae) : Ae = n[80];
	let je;
	n[81] !== ke || n[82] !== Ae ? (je = /* @__PURE__ */ h("div", {
		className: "agx-image-upload__dropzone-content",
		children: [
			Oe,
			ke,
			Ae
		]
	}), n[81] = ke, n[82] = Ae, n[83] = je) : je = n[83];
	let Ne;
	n[84] !== pe || n[85] !== Y || n[86] !== Ee || n[87] !== De || n[88] !== je ? (Ne = /* @__PURE__ */ h("div", {
		className: Ee,
		onDragOver: G,
		onDragLeave: q,
		onDrop: Y,
		onClick: pe,
		children: [De, je]
	}), n[84] = pe, n[85] = Y, n[86] = Ee, n[87] = De, n[88] = je, n[89] = Ne) : Ne = n[89];
	let Pe;
	return n[90] !== r || n[91] !== ge || n[92] !== Ce || n[93] !== we || n[94] !== Ne ? (Pe = /* @__PURE__ */ h("div", {
		id: r,
		"data-testid": ge,
		className: "agx-image-upload",
		children: [
			Ce,
			we,
			Ne
		]
	}), n[90] = r, n[91] = ge, n[92] = Ce, n[93] = we, n[94] = Ne, n[95] = Pe) : Pe = n[95], Pe;
};
function kc(e, t) {
	return {
		...e,
		order: e.order ?? t
	};
}
function Ac(e, t, n) {
	let r = t === void 0 ? "uploading" : t;
	return {
		id: S(),
		file: e,
		preview: URL.createObjectURL(e),
		status: r,
		order: n,
		progress: r === "uploading" ? 0 : void 0
	};
}
function jc(e, t) {
	return {
		...e,
		order: t
	};
}
function Mc(e) {
	return e.status === "uploading";
}
function Nc(e, t) {
	return {
		...e,
		order: t
	};
}
function Pc(e, t) {
	return {
		...e,
		order: t
	};
}
function Fc(e) {
	return e.status === "uploaded";
}
async function Ic(e, t) {
	let n = e?.preview ?? e?.publicPath ?? "", r = e?.file?.name ?? e.fileName ?? `image-${t + 1}.jpg`;
	try {
		return {
			name: r,
			input: await (await globalThis.fetch(n)).blob()
		};
	} catch (e) {
		let t = e;
		return console.error(`Failed to add ${r} to zip:`, t), null;
	}
}
function Lc(e) {
	return e !== null;
}
function Rc(e) {
	return e.stopPropagation();
}
//#endregion
//#region src/components/inputs/TimePicker/TimePicker.tsx
var zc = (t) => {
	let n = e(40), { id: r, dataTestId: i, value: a, onChange: s, label: c, required: l, disabled: u, stretch: p, errorText: g, optionalText: _, noHeader: v } = t, y = i === void 0 ? r : i, b = c === void 0 ? "Select time" : c, x = l === void 0 ? !1 : l, S = u === void 0 ? !1 : u, C = p === void 0 ? !1 : p, w = g === void 0 ? "" : g, T = _ === void 0 ? "Optional" : _, E = v === void 0 ? !1 : v, [D, O] = d(a ?? ""), [k, A] = d(!1), j, M;
	n[0] === a ? (j = n[1], M = n[2]) : (M = () => {
		O(a ?? "");
	}, j = [a], n[0] = a, n[1] = j, n[2] = M), o(M, j);
	let N = C && "stretch", P = w && "error", F = S && "disabled", I = k && "focus", L;
	n[3] !== N || n[4] !== P || n[5] !== F || n[6] !== I ? (L = f("agx-time-picker-input-wrapper", N, P, F, I), n[3] = N, n[4] = P, n[5] = F, n[6] = I, n[7] = L) : L = n[7];
	let R = L, z = C && "stretch", B;
	n[8] === z ? B = n[9] : (B = f("agx-time-picker", z), n[8] = z, n[9] = B);
	let V;
	n[10] !== r || n[11] !== b || n[12] !== E || n[13] !== T || n[14] !== x ? (V = !E && /* @__PURE__ */ h("div", {
		className: "agx-time-picker-header",
		children: [/* @__PURE__ */ h("div", {
			className: "agx-time-picker-label",
			children: [/* @__PURE__ */ m(Q, {
				id: `label-${r}`,
				type: "label",
				size: "medium",
				color: "var(--text-primary)",
				children: b
			}), x && /* @__PURE__ */ m(Q, {
				id: `label-required-${r}`,
				type: "label",
				size: "medium",
				color: "var(--text-brand-accent)",
				children: "*"
			})]
		}), !x && /* @__PURE__ */ m(Q, {
			id: `optionalText-${r}`,
			type: "caption",
			size: "medium",
			color: "var(--text-tertiary)",
			children: T
		})]
	}), n[10] = r, n[11] = b, n[12] = E, n[13] = T, n[14] = x, n[15] = V) : V = n[15];
	let H = `input-${r}`, U;
	n[16] === s ? U = n[17] : (U = (e) => {
		let t = e.target.value;
		O(t), s?.(t || null);
	}, n[16] = s, n[17] = U);
	let W, G;
	n[18] === Symbol.for("react.memo_cache_sentinel") ? (W = () => {
		A(!0);
	}, G = () => {
		A(!1);
	}, n[18] = W, n[19] = G) : (W = n[18], G = n[19]);
	let K;
	n[20] !== y || n[21] !== S || n[22] !== D || n[23] !== x || n[24] !== H || n[25] !== U ? (K = /* @__PURE__ */ m("input", {
		id: H,
		"data-testid": y,
		type: "time",
		value: D,
		required: x,
		disabled: S,
		onChange: U,
		onFocus: W,
		onBlur: G
	}), n[20] = y, n[21] = S, n[22] = D, n[23] = x, n[24] = H, n[25] = U, n[26] = K) : K = n[26];
	let q;
	n[27] !== K || n[28] !== R ? (q = /* @__PURE__ */ m("div", {
		className: "agx-time-picker-input-row",
		children: /* @__PURE__ */ m("div", {
			className: R,
			"data-version": "v2",
			children: K
		})
	}), n[27] = K, n[28] = R, n[29] = q) : q = n[29];
	let J;
	n[30] !== S || n[31] !== w || n[32] !== r ? (J = w && !S && /* @__PURE__ */ h("div", {
		className: "agx-time-picker-error",
		children: [/* @__PURE__ */ m(ki, {
			type: "Danger",
			width: 16,
			height: 16
		}), /* @__PURE__ */ m(Q, {
			dataTestId: `error-${r}`,
			id: `error-${r}`,
			type: "form_error",
			size: "small",
			children: w
		})]
	}), n[30] = S, n[31] = w, n[32] = r, n[33] = J) : J = n[33];
	let Y;
	return n[34] !== r || n[35] !== B || n[36] !== V || n[37] !== q || n[38] !== J ? (Y = /* @__PURE__ */ h("div", {
		className: B,
		id: r,
		children: [
			V,
			q,
			J
		]
	}), n[34] = r, n[35] = B, n[36] = V, n[37] = q, n[38] = J, n[39] = Y) : Y = n[39], Y;
}, Bc = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}({}), Vc = (t) => {
	let n = e(41), { id: r, onValueChanged: i, defaultValue: a, label: s, subDescription: c, yesLabel: l, noLabel: u, yesSubContent: f, noSubContent: p, required: g, errorText: _, showOptionalLabel: v, validate: y, reverseLabelOrder: b } = t, x = c === void 0 ? "" : c, S = l === void 0 ? "Yes" : l, C = u === void 0 ? "No" : u, w = g === void 0 ? !1 : g, T = _ === void 0 ? "Select an option" : _, E = v === void 0 ? !1 : v, D = y === void 0 ? !1 : y, O = b === void 0 ? !1 : b, [k, A] = d(a ?? ""), j, M;
	n[0] === a ? (j = n[1], M = n[2]) : (M = () => {
		A(a ?? "");
	}, j = [a], n[0] = a, n[1] = j, n[2] = M), o(M, j);
	let N;
	if (n[3] !== C || n[4] !== O || n[5] !== S) {
		let e = [{
			label: S,
			value: Bc.Yes
		}, {
			label: C,
			value: Bc.No
		}];
		N = O ? [...e].reverse() : e, n[3] = C, n[4] = O, n[5] = S, n[6] = N;
	} else N = n[6];
	let P = N, F = w && D && !k ? T : "", I = `${r}-label`, L;
	n[7] !== r || n[8] !== w ? (L = w && /* @__PURE__ */ m(Q, {
		id: `${r}-required`,
		type: "label",
		size: "medium",
		color: "var(--text-brand-accent)",
		children: "*"
	}), n[7] = r, n[8] = w, n[9] = L) : L = n[9];
	let R;
	n[10] !== s || n[11] !== I || n[12] !== L ? (R = /* @__PURE__ */ h(Q, {
		id: I,
		type: "label",
		size: "medium",
		color: "var(--text-primary)",
		children: [s, L]
	}), n[10] = s, n[11] = I, n[12] = L, n[13] = R) : R = n[13];
	let z;
	n[14] !== r || n[15] !== x ? (z = x && /* @__PURE__ */ m(Q, {
		id: `${r}-subDescription`,
		dataTestId: `agx-yesNoQuestion-${r}SubDescription`,
		type: "caption",
		size: "medium",
		color: "var(--text-tertiary)",
		children: x
	}), n[14] = r, n[15] = x, n[16] = z) : z = n[16];
	let B;
	n[17] !== R || n[18] !== z ? (B = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "2xs",
		children: [R, z]
	}), n[17] = R, n[18] = z, n[19] = B) : B = n[19];
	let V;
	n[20] !== r || n[21] !== E ? (V = E && /* @__PURE__ */ m(Q, {
		id: `${r}-optional`,
		type: "caption",
		size: "medium",
		color: "var(--text-tertiary)",
		children: "optional"
	}), n[20] = r, n[21] = E, n[22] = V) : V = n[22];
	let H;
	n[23] !== B || n[24] !== V ? (H = /* @__PURE__ */ m($, {
		direction: "vertical",
		gap: "sm",
		fill: !0,
		children: /* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "3xs",
			contentJustification: "space-between",
			contentAlignment: "end",
			children: [B, V]
		})
	}), n[23] = B, n[24] = V, n[25] = H) : H = n[25];
	let U;
	n[26] !== r || n[27] !== i ? (U = (e) => {
		A(e), i({
			id: r,
			value: e
		});
	}, n[26] = r, n[27] = i, n[28] = U) : U = n[28];
	let W = k === Bc.Yes ? f : k === Bc.No ? p : void 0, G;
	n[29] !== r || n[30] !== P || n[31] !== w || n[32] !== U || n[33] !== W || n[34] !== D || n[35] !== F || n[36] !== k ? (G = /* @__PURE__ */ m(bs, {
		id: r,
		layout: "vertical",
		options: P,
		value: k,
		onChange: U,
		required: w,
		validate: D,
		errorText: F,
		subContent: W
	}), n[29] = r, n[30] = P, n[31] = w, n[32] = U, n[33] = W, n[34] = D, n[35] = F, n[36] = k, n[37] = G) : G = n[37];
	let K;
	return n[38] !== H || n[39] !== G ? (K = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "xs",
		fill: !0,
		children: [H, G]
	}), n[38] = H, n[39] = G, n[40] = K) : K = n[40], K;
}, Hc = (t) => {
	let n = e(76), { id: r, label: i, labelHintText: a, hintText: s, optionalText: l, placeholder: p, required: g, validate: _, hideOptionalText: v, noHeader: y, defaultValue: b, onInputValueChange: x, minLength: S, maxLength: C, disabled: w, stretch: T, noResize: E, verticalResizeOnly: D, rows: O, error: k, flexibleHeight: A, variant: j } = t, M = a === void 0 ? "" : a, N = s === void 0 ? "" : s, P = l === void 0 ? "Optional" : l, F = p === void 0 ? "" : p, I = g === void 0 ? !1 : g, L = _ === void 0 ? !1 : _, R = v === void 0 ? !1 : v, z = y === void 0 ? !1 : y, B = b === void 0 ? "" : b, V = x === void 0 ? null : x, H = T === void 0 ? !1 : T, U = E === void 0 ? !1 : E, W = D === void 0 ? !1 : D, G = O === void 0 ? 1 : O, K = k === void 0 ? "" : k, q = A === void 0 ? !1 : A, J = j === void 0 ? "default" : j, [Y, X] = d(K), [Z, ee] = d(!1), [te, ne] = d(""), re;
	n[0] !== Y || n[1] !== H || n[2] !== J ? (re = f("textAreaV2", { stretch: H }, Y && "error", `textAreaV2--${J}`), n[0] = Y, n[1] = H, n[2] = J, n[3] = re) : re = n[3];
	let ie = re, ae;
	n[4] !== w || n[5] !== Z || n[6] !== Y || n[7] !== H || n[8] !== J ? (ae = f("textAreaWrapperV2", Y && "error", { stretch: H }, { disabled: w }, { focus: Z }, `textAreaWrapperV2--${J}`), n[4] = w, n[5] = Z, n[6] = Y, n[7] = H, n[8] = J, n[9] = ae) : ae = n[9];
	let oe = ae, se;
	n[10] !== U || n[11] !== W ? (se = f("field", { noResize: U }, W && !U && "verticalResizeOnly"), n[10] = U, n[11] = W, n[12] = se) : se = n[12];
	let ce = se, le = u(null), ue;
	n[13] === Symbol.for("react.memo_cache_sentinel") ? (ue = () => {
		let e = le.current;
		if (e) {
			e.style.height = "auto";
			let t = e.scrollHeight;
			t > 0 && (e.style.height = `${t}px`);
		}
	}, n[13] = ue) : ue = n[13];
	let de = ue, fe;
	n[14] === q ? fe = n[15] : (fe = () => {
		q && de();
	}, n[14] = q, n[15] = fe);
	let pe;
	n[16] !== q || n[17] !== te ? (pe = [q, te], n[16] = q, n[17] = te, n[18] = pe) : pe = n[18], c(fe, pe);
	let me;
	n[19] !== q || n[20] !== r || n[21] !== V ? (me = (e) => {
		let { target: t } = e, { value: n } = t;
		ne(n), V && V({
			id: r,
			value: n
		}), q && de();
	}, n[19] = q, n[20] = r, n[21] = V, n[22] = me) : me = n[22];
	let he = me, ge;
	n[23] !== r || n[24] !== V || n[25] !== te ? (ge = () => {
		let e = le.current?.value || te;
		V && V({
			id: r,
			value: e
		});
	}, n[23] = r, n[24] = V, n[25] = te, n[26] = ge) : ge = n[26];
	let _e = ge, ve, ye;
	n[27] === B ? (ve = n[28], ye = n[29]) : (ve = () => {
		ne(B);
	}, ye = [B], n[27] = B, n[28] = ve, n[29] = ye), o(ve, ye);
	let be, xe;
	n[30] !== K || n[31] !== i || n[32] !== L || n[33] !== te ? (be = () => {
		X(L && !te ? `Enter ${i ?? "a value"}` : K);
	}, xe = [
		K,
		i,
		L,
		te
	], n[30] = K, n[31] = i, n[32] = L, n[33] = te, n[34] = be, n[35] = xe) : (be = n[34], xe = n[35]), o(be, xe);
	let Se;
	n[36] !== R || n[37] !== r || n[38] !== i || n[39] !== M || n[40] !== z || n[41] !== P ? (Se = !z && /* @__PURE__ */ h(Ne, {
		gap: "spacing-2xl",
		alignItems: "alignCenter",
		justifyContent: "space-between",
		fill: !0,
		children: [i && /* @__PURE__ */ h(Ne, {
			gap: "spacing-xs",
			alignItems: "alignCenter",
			children: [/* @__PURE__ */ m(Q, {
				id: `agx-${r}Required`,
				type: "label",
				size: "medium",
				color: "var(--text-primary)",
				dataTestId: `agx-${r}Required`,
				children: i
			}), /* @__PURE__ */ m(Q, {
				id: `labelHint-${r}`,
				type: "caption",
				size: "medium",
				color: "var(--text-tertiary)",
				children: M
			})]
		}), !R && /* @__PURE__ */ m(Q, {
			id: `optionalText-${r}`,
			type: "caption",
			size: "medium",
			color: "var(--text-tertiary)",
			children: P
		})]
	}), n[36] = R, n[37] = r, n[38] = i, n[39] = M, n[40] = z, n[41] = P, n[42] = Se) : Se = n[42];
	let Ce;
	n[43] === Symbol.for("react.memo_cache_sentinel") ? (Ce = () => ee(!0), n[43] = Ce) : Ce = n[43];
	let we = `agx-input-${r}`, Te;
	n[44] === _e ? Te = n[45] : (Te = () => {
		ee(!1), _e();
	}, n[44] = _e, n[45] = Te);
	let Ee;
	n[46] !== w || n[47] !== r || n[48] !== C || n[49] !== S || n[50] !== he || n[51] !== F || n[52] !== I || n[53] !== G || n[54] !== we || n[55] !== Te || n[56] !== ce || n[57] !== te ? (Ee = /* @__PURE__ */ m("textarea", {
		className: ce,
		id: r,
		onFocus: Ce,
		"data-testid": we,
		onBlur: Te,
		onChange: he,
		placeholder: F,
		value: te,
		required: I,
		minLength: S,
		maxLength: C,
		disabled: w,
		rows: G,
		ref: le
	}), n[46] = w, n[47] = r, n[48] = C, n[49] = S, n[50] = he, n[51] = F, n[52] = I, n[53] = G, n[54] = we, n[55] = Te, n[56] = ce, n[57] = te, n[58] = Ee) : Ee = n[58];
	let De;
	n[59] !== Ee || n[60] !== oe ? (De = /* @__PURE__ */ m("div", {
		className: oe,
		"data-version": "v2",
		children: Ee
	}), n[59] = Ee, n[60] = oe, n[61] = De) : De = n[61];
	let Oe;
	n[62] !== N || n[63] !== r || n[64] !== Y ? (Oe = N && !Y && /* @__PURE__ */ m(Q, {
		id: `description-${r}`,
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		"data-testid": `hintText-${r}`,
		children: N
	}), n[62] = N, n[63] = r, n[64] = Y, n[65] = Oe) : Oe = n[65];
	let ke;
	n[66] !== w || n[67] !== r || n[68] !== Y ? (ke = Y && !w && /* @__PURE__ */ h(Ne, {
		gap: "spacing-sm",
		alignItems: "alignCenter",
		children: [/* @__PURE__ */ m(Ti, { type: "danger" }), /* @__PURE__ */ m(Q, {
			id: `agx-${r}error`,
			type: "form_error",
			size: "small",
			dataTestId: `agx-${r}error`,
			color: "var(--text-error)",
			children: Y
		})]
	}), n[66] = w, n[67] = r, n[68] = Y, n[69] = ke) : ke = n[69];
	let Ae;
	return n[70] !== ie || n[71] !== Se || n[72] !== De || n[73] !== Oe || n[74] !== ke ? (Ae = /* @__PURE__ */ h("div", {
		className: ie,
		children: [
			Se,
			De,
			Oe,
			ke
		]
	}), n[70] = ie, n[71] = Se, n[72] = De, n[73] = Oe, n[74] = ke, n[75] = Ae) : Ae = n[75], Ae;
}, Uc = "yes", Wc = "no", Gc = (e, t) => e ?? t, Kc = (t) => {
	let n = e(72), { id: r, onValueChanged: i, defaultValue: a, label: s, placeholder: c, subDescription: l, required: u, readonly: f, disabled: p, inputType: g, yesLabel: _, noLabel: v, reverseLabelOrder: y, maxLength: b, minLength: x, showTextInputOnYesSelection: S, noTextInputValue: C, flexibleHeight: w, validate: T } = t, E = u === void 0 ? !1 : u, D = f === void 0 ? !1 : f, O = p === void 0 ? !1 : p, k = g === void 0 ? "Text" : g, A = _ === void 0 ? "Yes" : _, j = v === void 0 ? "No" : v, M = y === void 0 ? !1 : y, N = x === void 0 ? 0 : x, P = S === void 0 ? !1 : S, F = C === void 0 ? "No" : C, I = w === void 0 ? !1 : w, L = T === void 0 ? !1 : T, R;
	n[0] !== a || n[1] !== F ? (R = Gc(a, F), n[0] = a, n[1] = F, n[2] = R) : R = n[2];
	let [z, B] = d(R), V, H;
	n[3] !== a || n[4] !== F ? (V = () => {
		B(Gc(a, F));
	}, H = [a, F], n[3] = a, n[4] = F, n[5] = V, n[6] = H) : (V = n[5], H = n[6]), o(V, H);
	let U = z !== F, W = U ? Uc : Wc, G = P && U || !P && !U, K = E && L && U && !z, q;
	if (n[7] !== j || n[8] !== M || n[9] !== A) {
		let e = [{
			label: A,
			value: Uc
		}, {
			label: j,
			value: Wc
		}];
		q = M ? [...e].reverse() : e, n[7] = j, n[8] = M, n[9] = A, n[10] = q;
	} else q = n[10];
	let J = q, Y;
	n[11] !== r || n[12] !== i ? (Y = (e) => {
		B(e), i({
			id: r,
			value: e
		});
	}, n[11] = r, n[12] = i, n[13] = Y) : Y = n[13];
	let X = Y, Z;
	n[14] !== F || n[15] !== X ? (Z = (e) => {
		X(e === Wc ? F : "");
	}, n[14] = F, n[15] = X, n[16] = Z) : Z = n[16];
	let ee = Z, te;
	bb0: {
		if (!G) {
			te = null;
			break bb0;
		}
		if (k === "TextArea") {
			let e;
			n[17] === X ? e = n[18] : (e = (e) => {
				let { value: t } = e;
				return X(t);
			}, n[17] = X, n[18] = e);
			let t = O || D, i = K ? `Enter ${s}` : void 0, a;
			n[19] !== I || n[20] !== r || n[21] !== s || n[22] !== b || n[23] !== N || n[24] !== c || n[25] !== E || n[26] !== l || n[27] !== e || n[28] !== t || n[29] !== i || n[30] !== L || n[31] !== z ? (a = /* @__PURE__ */ m(Hc, {
				id: r,
				defaultValue: z,
				label: s,
				placeholder: c,
				onInputValueChange: e,
				stretch: !0,
				noResize: !0,
				rows: 3,
				disabled: t,
				required: E,
				validate: L,
				minLength: N,
				maxLength: b,
				hideOptionalText: !0,
				noHeader: !0,
				hintText: l,
				flexibleHeight: I,
				error: i
			}), n[19] = I, n[20] = r, n[21] = s, n[22] = b, n[23] = N, n[24] = c, n[25] = E, n[26] = l, n[27] = e, n[28] = t, n[29] = i, n[30] = L, n[31] = z, n[32] = a) : a = n[32], te = a;
			break bb0;
		}
		let e = `${r}-subInput`, t = k === "Email" ? "email" : k === "Phone" ? "phone" : k === "Currency" ? "currency" : "text", i;
		n[33] === X ? i = n[34] : (i = (e) => {
			let { value: t } = e;
			return X(t);
		}, n[33] = X, n[34] = i);
		let a = K ? `Enter ${s}` : "", o;
		n[35] !== O || n[36] !== s || n[37] !== b || n[38] !== N || n[39] !== c || n[40] !== D || n[41] !== E || n[42] !== l || n[43] !== e || n[44] !== t || n[45] !== i || n[46] !== a || n[47] !== z ? (o = /* @__PURE__ */ m(qs, {
			id: e,
			type: t,
			label: s,
			placeholder: c,
			required: E,
			onInputValueChange: i,
			readonly: D,
			disabled: O,
			stretch: !0,
			defaultValue: z,
			hintText: l,
			minLength: N,
			maxLength: b,
			hideOptionalText: !0,
			noHeader: !0,
			errorText: a
		}), n[35] = O, n[36] = s, n[37] = b, n[38] = N, n[39] = c, n[40] = D, n[41] = E, n[42] = l, n[43] = e, n[44] = t, n[45] = i, n[46] = a, n[47] = z, n[48] = o) : o = n[48], te = o;
	}
	let ne = te, re = `${r}-label`, ie;
	n[49] !== s || n[50] !== re ? (ie = /* @__PURE__ */ m(Q, {
		id: re,
		type: "label",
		size: "medium",
		color: "var(--text-primary)",
		children: s
	}), n[49] = s, n[50] = re, n[51] = ie) : ie = n[51];
	let ae;
	n[52] !== r || n[53] !== G || n[54] !== l ? (ae = l && !G && /* @__PURE__ */ m(Q, {
		id: `${r}-subDescription`,
		dataTestId: `agx-yesNoQuestion-${r}SubDescription`,
		type: "caption",
		size: "medium",
		color: "var(--text-tertiary)",
		children: l
	}), n[52] = r, n[53] = G, n[54] = l, n[55] = ae) : ae = n[55];
	let oe;
	n[56] !== ie || n[57] !== ae ? (oe = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-xs",
		fill: !0,
		children: [ie, ae]
	}), n[56] = ie, n[57] = ae, n[58] = oe) : oe = n[58];
	let se = `${r}-${W}`, ce = O || D, le;
	n[59] !== ee || n[60] !== r || n[61] !== J || n[62] !== E || n[63] !== W || n[64] !== se || n[65] !== ce || n[66] !== L ? (le = /* @__PURE__ */ m(bs, {
		id: r,
		layout: "vertical",
		options: J,
		value: W,
		onChange: ee,
		disabled: ce,
		required: E,
		validate: L,
		errorText: ""
	}, se), n[59] = ee, n[60] = r, n[61] = J, n[62] = E, n[63] = W, n[64] = se, n[65] = ce, n[66] = L, n[67] = le) : le = n[67];
	let ue;
	return n[68] !== ne || n[69] !== oe || n[70] !== le ? (ue = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-sm",
		fill: !0,
		children: [
			oe,
			le,
			ne
		]
	}), n[68] = ne, n[69] = oe, n[70] = le, n[71] = ue) : ue = n[71], ue;
}, qc = (e, t) => {
	if (!t) return e;
	let n = Array.isArray(t) ? t : [t];
	return e.map((e) => ({
		...e,
		selected: n.includes(e.value)
	}));
}, Jc = Ei, Yc = Di, Xc = (t) => {
	let n = e(34), { id: r, label: i, onSelect: a, defaultSelection: s, dataTestId: c, size: l, type: g, options: _, searchPlaceHolder: v, align: y, placement: b, onReset: x, maxLabels: S, hideFooter: C, variant: w, tooltip: T, hideSelectAll: E } = t, D = l === void 0 ? "medium" : l, O = g === void 0 ? "multi-select" : g, k = _ === void 0 ? [] : _, A = y === void 0 ? "left" : y, j = b === void 0 ? "bottom" : b, M = S === void 0 ? 1 : S, N = C === void 0 ? !1 : C, P = w === void 0 ? "chip" : w, F = E === void 0 ? !1 : E, [I, L] = d(!1), [R, z] = d(), B = u(null), [V, H] = d(""), U;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (U = [], n[0] = U) : U = n[0];
	let [W, G] = d(U), [K, q] = d(() => qc(k, s)), J;
	n[1] === Symbol.for("react.memo_cache_sentinel") ? (J = (e) => {
		B.current && !B.current.contains(e.target) && L(!1);
	}, n[1] = J) : J = n[1];
	let Y = J, X = (e, t) => {
		let n = K.map((n) => n.label === e ? {
			...n,
			selected: t === void 0 ? !0 : t
		} : {
			...n,
			selected: t === void 0 ? !1 : n.selected
		});
		q([...n]), ee(n), a?.(n.filter(Zc));
	}, Z;
	n[2] === M ? Z = n[3] : (Z = (e) => {
		let t = e.filter(Qc).map($c);
		t.length > M ? G([`${t.length}`]) : t.length > 0 ? G(t) : G([]);
	}, n[2] = M, n[3] = Z);
	let ee = Z;
	o(() => {
		let e = qc(k, s);
		q(e), ee(e);
	}, [
		k,
		s,
		ee
	]);
	let te = ee, ne;
	n[4] !== a || n[5] !== R || n[6] !== te ? (ne = [
		a,
		R,
		q,
		te
	], n[4] = a, n[5] = R, n[6] = te, n[7] = ne) : ne = n[7], o(() => {
		R !== void 0 && q(R ? (e) => {
			let t = e.map(el);
			return ee(t), a?.(t), t;
		} : (e) => {
			let t = e.map(tl);
			return ee(t), a?.(t), t;
		});
	}, ne);
	let re, ie;
	n[8] === Symbol.for("react.memo_cache_sentinel") ? (re = () => (document.addEventListener("mousedown", Y), () => document.removeEventListener("mousedown", Y)), ie = [], n[8] = re, n[9] = ie) : (re = n[8], ie = n[9]), o(re, ie);
	let ae;
	n[10] === K ? ae = n[11] : (ae = K.find(nl), n[10] = K, n[11] = ae);
	let oe = ae, se;
	n[12] === V ? se = n[13] : (se = (e) => e.label.toLowerCase().includes(V.toLowerCase()), n[12] = V, n[13] = se);
	let ce = K.filter(se), le = () => {
		H(""), z(void 0);
		let e = qc(k, s);
		q(e), ee(e), x?.();
	}, ue = c ?? r, de;
	n[14] !== r || n[15] !== oe?.icon || n[16] !== D || n[17] !== T || n[18] !== P ? (de = P === "icon" && /* @__PURE__ */ m(Kl, {
		id: `btn-${r}`,
		text: "",
		variant: "image",
		leftIcon: oe?.icon ?? /* @__PURE__ */ m(Ci, {
			type: "User",
			iconColor: "grey",
			height: D === "small" ? 25 : 32,
			width: D === "small" ? 25 : 32
		}),
		onClick: () => L(rl),
		tooltip: T
	}), n[14] = r, n[15] = oe?.icon, n[16] = D, n[17] = T, n[18] = P, n[19] = de) : de = n[19];
	let fe;
	n[20] !== r || n[21] !== I || n[22] !== i || n[23] !== D || n[24] !== W || n[25] !== T || n[26] !== P ? (fe = P === "chip" && /* @__PURE__ */ m(Kl, {
		id: `btn-${r}`,
		text: i,
		size: D,
		variant: "selectChip",
		onClick: () => L(il),
		tags: W,
		rightIcon: /* @__PURE__ */ m(Jc, {
			color: "var(--fg-brand-accent)",
			width: D === "large" ? 20 : 18,
			height: D === "large" ? 20 : 18,
			direction: I ? "up" : "down"
		}),
		wrap: !0,
		tooltip: T
	}), n[20] = r, n[21] = I, n[22] = i, n[23] = D, n[24] = W, n[25] = T, n[26] = P, n[27] = fe) : fe = n[27];
	let pe = I && /* @__PURE__ */ m("div", {
		"data-version": "v2",
		className: f("dropdown-menu", `align${A}`, `place${j}`),
		children: /* @__PURE__ */ h($, {
			direction: "vertical",
			fill: !0,
			padding: {
				top: "spacing-xxs",
				bottom: "spacing-xxs"
			},
			children: [
				v && /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m($, {
					fill: !0,
					children: /* @__PURE__ */ m(qs, {
						style: "naked",
						defaultValue: V,
						size: "large",
						id: "txtsearch",
						type: "text",
						noHeader: !0,
						placeholder: v,
						onChange: H,
						leftIcon: /* @__PURE__ */ m(Yc, { color: "var(--fg-tertiary)" })
					})
				}), /* @__PURE__ */ m(Ja, { variant: "horizontal" })] }),
				/* @__PURE__ */ m($, {
					direction: "vertical",
					className: "selectChip_listContainer",
					padding: "spacing-sm",
					children: /* @__PURE__ */ h("ul", {
						className: "selectChip_ul",
						children: [O === "multi-select" && !F && /* @__PURE__ */ m("li", { children: /* @__PURE__ */ m(Q, {
							id: "checkbox-label-container",
							type: "label",
							size: "medium",
							children: /* @__PURE__ */ m(Ne, {
								padding: "spacing-sm",
								children: /* @__PURE__ */ m(os, {
									id: "check-all",
									checked: !!R,
									label: "Select all",
									onChange: z
								})
							})
						}) }, "selectall"), ce.map((e) => /* @__PURE__ */ m("li", { children: /* @__PURE__ */ h(Q, {
							id: "checkbox-label-container",
							type: "label",
							size: "medium",
							children: [O === "multi-select" && /* @__PURE__ */ m(Ne, {
								padding: "spacing-sm",
								children: /* @__PURE__ */ m(os, {
									id: `check-${e.label}`,
									checked: !!e.selected,
									label: e.label,
									onChange: (t) => X(e.label, t)
								})
							}), O === "single-select" && /* @__PURE__ */ h($, {
								direction: "horizontal",
								className: f("agx-selectChip-option", e.selected && "selected"),
								onClick: () => {
									X(e.label), L(!I);
								},
								padding: "spacing-md",
								fill: !0,
								contentJustification: "space-between",
								contentAlignment: "center",
								gap: "spacing-md",
								children: [/* @__PURE__ */ h($, {
									direction: "horizontal",
									gap: "spacing-md",
									contentAlignment: "center",
									fill: !0,
									children: [e.icon, /* @__PURE__ */ m(Q, {
										id: `${r}-${e.value}`,
										type: "body_ui",
										size: "small",
										color: "var(--text-primary)",
										children: e.label
									})]
								}), e.selected && /* @__PURE__ */ m(Ki, { color: "var(--text-primary)" })]
							}, e.value)]
						}) }, e.value))]
					})
				}),
				!N && /* @__PURE__ */ h($, {
					direction: "vertical",
					fill: !0,
					children: [/* @__PURE__ */ m(Ja, { variant: "horizontal" }), /* @__PURE__ */ m($, {
						direction: "horizontal",
						fill: !0,
						contentAlignment: "center",
						contentJustification: "end",
						padding: {
							top: "spacing-md",
							bottom: "spacing-md",
							right: "spacing-lg",
							left: "spacing-lg"
						},
						children: /* @__PURE__ */ m(Kl, {
							id: "btn-reset",
							text: "Reset",
							variant: "link",
							onClick: le
						})
					})]
				})
			]
		})
	}), me;
	return n[28] !== r || n[29] !== ue || n[30] !== de || n[31] !== fe || n[32] !== pe ? (me = /* @__PURE__ */ h("div", {
		id: r,
		"data-testid": ue,
		className: "dropdown",
		ref: B,
		"data-version": "v2",
		children: [
			de,
			fe,
			pe
		]
	}), n[28] = r, n[29] = ue, n[30] = de, n[31] = fe, n[32] = pe, n[33] = me) : me = n[33], me;
};
function Zc(e) {
	return e.selected;
}
function Qc(e) {
	return e.selected;
}
function $c(e) {
	return e.label;
}
function el(e) {
	return {
		...e,
		selected: !0
	};
}
function tl(e) {
	return {
		...e,
		selected: !1
	};
}
function nl(e) {
	return e.selected;
}
function rl(e) {
	return !e;
}
function il(e) {
	return !e;
}
//#endregion
//#region src/components/inputs/ToggleSwitch/toggleSwitch.tsx
var al = (t) => {
	let n = e(22), { checked: r, onChange: i, disabled: a, onLabel: o, offLabel: s, id: c } = t, l = o === void 0 ? "" : o, u = s === void 0 ? "" : s, d = `testId-${c}`, p;
	n[0] === i ? p = n[1] : (p = (e) => i(e.target.checked), n[0] = i, n[1] = p);
	let g;
	n[2] !== r || n[3] !== a || n[4] !== p ? (g = /* @__PURE__ */ m("input", {
		type: "checkbox",
		checked: r,
		disabled: a,
		onChange: p
	}), n[2] = r, n[3] = a, n[4] = p, n[5] = g) : g = n[5];
	let _;
	n[6] !== r || n[7] !== a || n[8] !== u || n[9] !== l ? (_ = f("switch", { checked: r }, { disabled: a }, { noLabelStyle: !l && !u }), n[6] = r, n[7] = a, n[8] = u, n[9] = l, n[10] = _) : _ = n[10];
	let v = r ? l : u, y;
	n[11] === v ? y = n[12] : (y = /* @__PURE__ */ m(Q, {
		type: "caption",
		size: "medium",
		id: "switchLabel",
		children: v
	}), n[11] = v, n[12] = y);
	let b;
	n[13] === Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ m("span", { className: "thumb" }), n[13] = b) : b = n[13];
	let x;
	n[14] !== _ || n[15] !== y ? (x = /* @__PURE__ */ h("div", {
		className: _,
		children: [y, b]
	}), n[14] = _, n[15] = y, n[16] = x) : x = n[16];
	let S;
	return n[17] !== c || n[18] !== x || n[19] !== d || n[20] !== g ? (S = /* @__PURE__ */ h("label", {
		id: c,
		"data-testid": d,
		"data-version": "v2",
		className: "toggle-switch",
		children: [g, x]
	}), n[17] = c, n[18] = x, n[19] = d, n[20] = g, n[21] = S) : S = n[21], S;
};
//#endregion
//#region src/hooks/useDebouncedState/useDebouncedState.ts
function ol(t, n) {
	let r = e(6), i = n === void 0 ? 300 : n, [a, s] = d(t), [c, l] = d(t), u, f;
	r[0] !== i || r[1] !== a ? (u = () => {
		let e = setTimeout(() => {
			l(a);
		}, i);
		return () => {
			clearTimeout(e);
		};
	}, f = [a, i], r[0] = i, r[1] = a, r[2] = u, r[3] = f) : (u = r[2], f = r[3]), o(u, f);
	let p;
	return r[4] === c ? p = r[5] : (p = [c, s], r[4] = c, r[5] = p), p;
}
//#endregion
//#region src/components/inputs/GlobalSearch/SearchResultType.tsx
var sl = /* @__PURE__ */ function(e) {
	return e.ActiveCampaign = "Active Campaign", e.ArchivedCampaign = "Archived Campaign", e;
}({}), cl = (e, t, n) => {
	let [r, i] = d(e), [a, s] = d(void 0);
	o(() => {
		e !== r && (i(e), s(void 0));
	}, [e]);
	let { data: c, isPending: l } = me(r, n, a, t), { data: u, isPending: f } = y(t);
	return {
		campaigns: (c?.results || []).map((e) => {
			let t = u?.find((t) => t.id === e.agencyId);
			return {
				...e,
				agencyName: t?.name
			};
		}),
		isPending: (l || f) && t,
		loadNextCampaignsPage: a ? () => {
			c?.continuationToken && s(c.continuationToken);
		} : void 0,
		hasMore: !!c?.continuationToken
	};
}, ll = 3, ul = () => Array.from({ length: ll }).map((e, t) => /* @__PURE__ */ h($, {
	className: "globalSearchLoader",
	gap: "spacing-sm",
	fill: !0,
	direction: "horizontal",
	children: [
		/* @__PURE__ */ m("div", { className: "globalSearchLoaderImage" }),
		/* @__PURE__ */ h($, {
			direction: "vertical",
			gap: "spacing-xxs",
			fill: !0,
			children: [/* @__PURE__ */ m("div", {
				className: "globalSearchLoaderDetailsText",
				style: { width: "100%" }
			}), /* @__PURE__ */ m("div", {
				className: "globalSearchLoaderDetailsText",
				style: { width: "50%" }
			})]
		}),
		/* @__PURE__ */ m("div", { className: "globalSearchLoaderTag" })
	]
}, `global-search-loader-${t}`)), dl = (t) => {
	let n = e(3), { imageUrl: r } = t;
	if (!r) {
		let e;
		return n[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("div", {
			className: "globalSearchResultImage",
			style: { background: "lightgray 50% / cover no-repeat" }
		}), n[0] = e) : e = n[0], e;
	}
	let i;
	return n[1] === r ? i = n[2] : (i = /* @__PURE__ */ m("img", {
		src: r,
		alt: "Global Search Result",
		className: "globalSearchResultImage"
	}), n[1] = r, n[2] = i), i;
}, fl = ({ detailResults: e }) => !e || e.length === 0 ? null : e.map((e, t) => e.match ? /* @__PURE__ */ m(Q, {
	id: `matched-${t}`,
	type: "body_ui_strong",
	size: "small",
	color: "var(--text-primary)",
	children: e.detail
}, t) : /* @__PURE__ */ m("span", { children: e.detail }, t)), pl = (e) => {
	switch (e) {
		case L.AgreementDraft: return {
			color: "blue",
			text: "Agreement Draft"
		};
		case L.AgreementVendorSigning: return {
			color: "blue",
			text: "Agreement Vendor Signing"
		};
		case L.AgreementAgentSigning: return {
			color: "blue",
			text: "Agreement Agent Signing"
		};
		case L.AgreementSignedByAllParties: return {
			color: "blue",
			text: "Agreement Signed By All Parties"
		};
		case L.AgreementSubmissionIncomplete: return {
			color: "blue",
			text: "Agreement Submission Incomplete"
		};
		case L.ListingCurrent: return {
			color: "orange",
			text: "Listing Current"
		};
		case L.ListingUnderContract: return {
			color: "orange",
			text: "Listing Under Contract"
		};
		case L.ListingWithdrawn: return {
			color: "red",
			text: "Listing Withdrawn"
		};
		default: return {
			color: "grey",
			text: void 0
		};
	}
}, ml = (t) => {
	let n = e(25), { result: r } = t, { campaignId: i, propertyImageUrl: a, addressMatches: o, stage: s, agencyName: c } = r, l;
	n[0] === s ? l = n[1] : (l = pl(s), n[0] = s, n[1] = l);
	let { color: u, text: d } = l, f;
	n[2] === a ? f = n[3] : (f = /* @__PURE__ */ m(dl, { imageUrl: a }), n[2] = a, n[3] = f);
	let p;
	n[4] === Symbol.for("react.memo_cache_sentinel") ? (p = { top: "spacing-xs" }, n[4] = p) : p = n[4];
	let g = `campaign-${i}-title`, _;
	n[5] === o ? _ = n[6] : (_ = /* @__PURE__ */ m(fl, { detailResults: o }), n[5] = o, n[6] = _);
	let v;
	n[7] !== g || n[8] !== _ ? (v = /* @__PURE__ */ m(Q, {
		id: g,
		type: "body_ui",
		size: "small",
		color: "var(--text-secondary)",
		overflowEllipsis: !0,
		children: _
	}), n[7] = g, n[8] = _, n[9] = v) : v = n[9];
	let y = `campaign-${i}-agency`, b;
	n[10] !== c || n[11] !== y ? (b = /* @__PURE__ */ m(Q, {
		id: y,
		type: "caption",
		size: "medium",
		color: "var(--text-tertiary)",
		overflowEllipsis: !0,
		children: c
	}), n[10] = c, n[11] = y, n[12] = b) : b = n[12];
	let x;
	n[13] !== v || n[14] !== b ? (x = /* @__PURE__ */ h($, {
		direction: "vertical",
		contentAlignment: "start",
		fill: !0,
		padding: p,
		gap: "spacing-xxs",
		hideOverflow: !0,
		children: [v, b]
	}), n[13] = v, n[14] = b, n[15] = x) : x = n[15];
	let S;
	n[16] !== x || n[17] !== f ? (S = /* @__PURE__ */ h($, {
		direction: "horizontal",
		contentAlignment: "start",
		gap: "spacing-sm",
		fill: !0,
		hideOverflow: !0,
		children: [f, x]
	}), n[16] = x, n[17] = f, n[18] = S) : S = n[18];
	let C;
	n[19] !== u || n[20] !== d ? (C = /* @__PURE__ */ m(_o, {
		type: "colourfill",
		text: d,
		size: "sm",
		colour: u
	}), n[19] = u, n[20] = d, n[21] = C) : C = n[21];
	let w;
	return n[22] !== S || n[23] !== C ? (w = /* @__PURE__ */ h($, {
		direction: "horizontal",
		fill: !0,
		contentAlignment: "start",
		children: [S, C]
	}), n[22] = S, n[23] = C, n[24] = w) : w = n[24], w;
}, hl = (t) => {
	let n = e(19), { type: r, result: i, highlighted: a, onItemSelected: o } = t, s;
	n[0] !== o || n[1] !== i || n[2] !== r ? (s = () => {
		o(r, i);
	}, n[0] = o, n[1] = i, n[2] = r, n[3] = s) : s = n[3];
	let c = s, l = a && "highlighted", u;
	n[4] === l ? u = n[5] : (u = f("searchResultItem", l), n[4] = l, n[5] = u);
	let d = u, g;
	n[6] !== i || n[7] !== r ? (g = r === sl.ActiveCampaign && /* @__PURE__ */ m(ml, { result: i }), n[6] = i, n[7] = r, n[8] = g) : g = n[8];
	let _;
	n[9] !== i || n[10] !== r ? (_ = r === sl.ArchivedCampaign && /* @__PURE__ */ m(ml, { result: i }), n[9] = i, n[10] = r, n[11] = _) : _ = n[11];
	let v;
	n[12] !== g || n[13] !== _ ? (v = /* @__PURE__ */ h(p, { children: [g, _] }), n[12] = g, n[13] = _, n[14] = v) : v = n[14];
	let y;
	return n[15] !== d || n[16] !== c || n[17] !== v ? (y = /* @__PURE__ */ m($, {
		className: d,
		onClick: c,
		direction: "horizontal",
		contentAlignment: "start",
		padding: "spacing-md",
		gap: "spacing-md",
		fill: !0,
		children: v
	}), n[15] = d, n[16] = c, n[17] = v, n[18] = y) : y = n[18], y;
}, gl = (t) => {
	let n = e(15), { type: r, results: i, highlightedItem: a, onItemSelected: o } = t;
	if (i.length === 0) return null;
	let s;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (s = {
		top: "spacing-xs",
		bottom: "spacing-xs"
	}, n[0] = s) : s = n[0];
	let c;
	n[1] === r ? c = n[2] : (c = /* @__PURE__ */ m($, {
		padding: s,
		fill: !0,
		contentAlignment: "center",
		direction: "horizontal",
		children: /* @__PURE__ */ m(Q, {
			id: "active-campaigns-title",
			type: "body_ui_strong",
			size: "small",
			color: "var(--text-secondary)",
			children: r
		})
	}), n[1] = r, n[2] = c);
	let l;
	if (n[3] !== a || n[4] !== o || n[5] !== i || n[6] !== r) {
		let e;
		n[8] !== a || n[9] !== o || n[10] !== r ? (e = (e, t) => /* @__PURE__ */ m(hl, {
			type: r,
			result: e,
			highlighted: a?.type === r && t === a.index,
			onItemSelected: o
		}, `search-result-${e.campaignId}-${r}`), n[8] = a, n[9] = o, n[10] = r, n[11] = e) : e = n[11], l = i.map(e), n[3] = a, n[4] = o, n[5] = i, n[6] = r, n[7] = l;
	} else l = n[7];
	let u;
	return n[12] !== c || n[13] !== l ? (u = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-xs",
		children: [c, l]
	}), n[12] = c, n[13] = l, n[14] = u) : u = n[14], u;
}, _l = (e, t) => {
	if (!e.current || !t.current) return;
	let n = e.current.offsetWidth, r = window.getComputedStyle(t.current);
	return n - ((parseFloat(r.paddingLeft) || 0) + (parseFloat(r.paddingRight) || 0));
}, vl = (e, t) => {
	if (!t || t.length === 0) return;
	if (!e) {
		let e = t[t.length - 1];
		return !e || e.results.length === 0 ? void 0 : {
			type: e.type,
			index: e.results.length - 1
		};
	}
	let n = {
		...e,
		index: e.index - 1
	};
	if (t.find((t) => t.type === e.type)) {
		if (n.index < 0) {
			let r = t[(t.findIndex((t) => t.type === e.type) + 1) % t.length];
			n = {
				type: r.type,
				index: r.results.length - 1
			};
		}
		return n;
	}
}, yl = (e, t) => {
	if (!t || t.length === 0) return;
	if (!e) {
		let e = t[0];
		return !e || e.results.length === 0 ? void 0 : {
			type: e.type,
			index: 0
		};
	}
	let n = {
		...e,
		index: e.index + 1
	}, r = t.find((t) => t.type === e.type);
	if (r) return n.index >= r.results.length && (n = {
		type: t[(t.findIndex((t) => t.type === e.type) + 1) % t.length].type,
		index: 0
	}), n;
}, bl = () => {
	let t = e(2), n;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = {
		top: "spacing-3xl",
		bottom: "spacing-3xl",
		left: "spacing-lg",
		right: "spacing-lg"
	}, t[0] = n) : n = t[0];
	let r;
	return t[1] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ m(Me, {
		fill: !0,
		padding: n,
		gap: "spacing-md",
		alignItems: "alignCenter",
		justifyContent: "center",
		children: /* @__PURE__ */ m(ao, {
			glyphType: "search",
			label: "We couldn't find anything matching your search",
			variant: "advanced",
			actionButtons: []
		})
	}), t[1] = r) : r = t[1], r;
}, xl = (t) => {
	let n = e(41), { searchForCampaigns: r, searchForArchivedCampaigns: i, onItemSelected: a } = t, s = r === void 0 ? !1 : r, c = i === void 0 ? !1 : i, [l, f] = ol(""), g = u(null), _ = u(null), [v, y] = d(!1), [b, x] = d(void 0), S;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (S = () => {
		let e = _l(g, _);
		!_.current || e === void 0 || (_.current.style.width = `${e}px`, _.current.style.maxWidth = `${e}px`);
	}, n[0] = S) : S = n[0];
	let C = S, w, T;
	n[1] === Symbol.for("react.memo_cache_sentinel") ? (w = () => (C(), window.addEventListener("resize", C), () => window.removeEventListener("resize", C)), T = [], n[1] = w, n[2] = T) : (w = n[1], T = n[2]), o(w, T);
	let E;
	n[3] === Symbol.for("react.memo_cache_sentinel") ? (E = (e) => {
		e.key === "Escape" && (e.preventDefault(), y(!1), x(void 0));
	}, n[3] = E) : E = n[3];
	let D = E, O;
	n[4] === Symbol.for("react.memo_cache_sentinel") ? (O = (e) => {
		e === "outside" && (y(!1), x(void 0));
	}, n[4] = O) : O = n[4], xs(_, O);
	let { campaigns: k, isPending: A } = cl(l, s && l.length > 0, !1), { campaigns: j, isPending: M } = cl(l, c && l.length > 0, !0), N;
	n[5] !== k || n[6] !== s ? (N = {
		type: sl.ActiveCampaign,
		results: k,
		active: s
	}, n[5] = k, n[6] = s, n[7] = N) : N = n[7];
	let P;
	n[8] !== j || n[9] !== c ? (P = {
		type: sl.ArchivedCampaign,
		results: j,
		active: c
	}, n[8] = j, n[9] = c, n[10] = P) : P = n[10];
	let F;
	n[11] !== N || n[12] !== P ? (F = [N, P].filter(Sl), n[11] = N, n[12] = P, n[13] = F) : F = n[13];
	let I = F, L = A || M, R = k.length === 0 && j.length === 0, z;
	n[14] === l.length ? z = n[15] : (z = () => {
		y(l.length > 0);
	}, n[14] = l.length, n[15] = z);
	let B;
	n[16] === l ? B = n[17] : (B = [l], n[16] = l, n[17] = B), o(z, B);
	let V;
	n[18] === Symbol.for("react.memo_cache_sentinel") ? (V = () => {
		C();
	}, n[18] = V) : V = n[18];
	let H;
	n[19] === v ? H = n[20] : (H = [v], n[19] = v, n[20] = H), o(V, H);
	let U;
	n[21] !== b || n[22] !== I || n[23] !== a ? (U = (e) => {
		if (I.length !== 0) {
			if (e.key === "ArrowDown") e.preventDefault(), x(yl(b, I));
			else if (e.key === "ArrowUp") e.preventDefault(), x(vl(b, I));
			else if (e.key === "Enter") {
				if (e.preventDefault(), b === void 0) return;
				let t = I.find((e) => e.type === b.type);
				if (!t) return;
				let n = t.results[b.index];
				if (!n) return;
				a(b.type, n), y(!1), x(void 0);
			}
		}
	}, n[21] = b, n[22] = I, n[23] = a, n[24] = U) : U = n[24];
	let W = U, G;
	n[25] === a ? G = n[26] : (G = (e, t) => {
		a(e, t), y(!1), x(void 0);
	}, n[25] = a, n[26] = G);
	let K = G, q;
	n[27] === Symbol.for("react.memo_cache_sentinel") ? (q = /* @__PURE__ */ m(Di, {
		color: "var(--fg-tertiary, #B9B9B9)",
		height: 15,
		width: 15
	}), n[27] = q) : q = n[27];
	let J;
	n[28] !== W || n[29] !== f ? (J = /* @__PURE__ */ m(qs, {
		id: "global-search",
		type: "text",
		placeholder: "Search",
		border: "rounded",
		hideOptionalText: !0,
		leftIcon: q,
		onChange: f,
		ref: g,
		minWidth: "400px",
		onKeyUp: D,
		onKeyDown: W,
		noHeader: !0
	}), n[28] = W, n[29] = f, n[30] = J) : J = n[30];
	let Y;
	n[31] !== L || n[32] !== b || n[33] !== I || n[34] !== R || n[35] !== K || n[36] !== v ? (Y = v && /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-lg",
		padding: "spacing-md",
		className: "searchResults",
		ref: _,
		children: [
			!L && !R && /* @__PURE__ */ m(p, { children: I.map((e) => {
				let { type: t, results: n } = e;
				return /* @__PURE__ */ m(gl, {
					type: t,
					results: n,
					highlightedItem: b,
					onItemSelected: K
				}, t);
			}) }),
			L && /* @__PURE__ */ m(ul, {}),
			!L && R && /* @__PURE__ */ m(bl, {})
		]
	}), n[31] = L, n[32] = b, n[33] = I, n[34] = R, n[35] = K, n[36] = v, n[37] = Y) : Y = n[37];
	let X;
	return n[38] !== J || n[39] !== Y ? (X = /* @__PURE__ */ h("div", {
		className: "globalSearch",
		children: [J, Y]
	}), n[38] = J, n[39] = Y, n[40] = X) : X = n[40], X;
};
function Sl(e) {
	return e.active && e.results.length > 0;
}
//#endregion
//#region src/components/inputs/Name/Name.tsx
var Cl = (e) => Ea(e.split(" ")[0].toLowerCase()), wl = (t) => {
	let n = e(73), { id: r, label: i, labelHintText: a, value: o, onChange: s, hideMiddleName: c, readonly: l, validate: u, required: d, preferredNameRequired: f, hidePreferredName: g, nameIsUpperCase: _, stretch: v } = t, y = c === void 0 ? !1 : c, b = l === void 0 ? !1 : l, x = u === void 0 ? !1 : u, S = d === void 0 ? !0 : d, C = f === void 0 ? !1 : f, w = g === void 0 ? !1 : g, T = _ === void 0 ? !1 : _, E = v === void 0 ? !0 : v, D;
	n[0] === o ? D = n[1] : (D = o ?? {}, n[0] = o, n[1] = D);
	let O = D, k;
	n[2] !== O.firstName || n[3] !== O.preferredName ? (k = O.preferredName ?? Cl(O.firstName ?? ""), n[2] = O.firstName, n[3] = O.preferredName, n[4] = k) : k = n[4];
	let A = k, j;
	n[5] !== w || n[6] !== T || n[7] !== O || n[8] !== s ? (j = (e) => {
		let t = O.firstName?.toLowerCase(), n = O.preferredName?.toLowerCase(), r = e.toLowerCase();
		s({
			...O,
			firstName: T ? e.toUpperCase() : e,
			preferredName: !w && (!n && r !== t || t === n && r !== n) ? Cl(e) : O.preferredName
		});
	}, n[5] = w, n[6] = T, n[7] = O, n[8] = s, n[9] = j) : j = n[9];
	let M = j, N = `${r}-label`, P;
	n[10] !== i || n[11] !== N ? (P = /* @__PURE__ */ m(Q, {
		id: N,
		type: "label",
		size: "medium",
		color: "var(--text-primary)",
		children: i
	}), n[10] = i, n[11] = N, n[12] = P) : P = n[12];
	let F;
	n[13] !== r || n[14] !== S ? (F = S && /* @__PURE__ */ m(Q, {
		id: `${r}-required`,
		type: "label",
		size: "medium",
		color: "var(--text-brand-accent)",
		children: "*"
	}), n[13] = r, n[14] = S, n[15] = F) : F = n[15];
	let I;
	n[16] !== r || n[17] !== a ? (I = a && /* @__PURE__ */ m(Q, {
		id: `${r}-hint`,
		type: "caption",
		size: "medium",
		color: "var(--text-tertiary)",
		children: a
	}), n[16] = r, n[17] = a, n[18] = I) : I = n[18];
	let L;
	n[19] !== P || n[20] !== F || n[21] !== I ? (L = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-xs",
		contentAlignment: "center",
		children: [
			P,
			F,
			I
		]
	}), n[19] = P, n[20] = F, n[21] = I, n[22] = L) : L = n[22];
	let R = `${r}-firstName`, z = O.firstName ?? "", B;
	n[23] === M ? B = n[24] : (B = (e) => {
		let { value: t } = e;
		return M(t);
	}, n[23] = M, n[24] = B);
	let V = T ? "uppercase" : "normal", H = x && S && !O.firstName ? "Enter first name" : void 0, U;
	n[25] !== b || n[26] !== S || n[27] !== R || n[28] !== z || n[29] !== B || n[30] !== V || n[31] !== H ? (U = /* @__PURE__ */ m($, {
		fill: !0,
		children: /* @__PURE__ */ m(qs, {
			id: R,
			type: "text",
			placeholder: "First Name",
			defaultValue: z,
			onInputValueChange: B,
			textFormat: V,
			readonly: b,
			disabled: b,
			required: S,
			noHeader: !0,
			stretch: !0,
			errorText: H
		})
	}), n[25] = b, n[26] = S, n[27] = R, n[28] = z, n[29] = B, n[30] = V, n[31] = H, n[32] = U) : U = n[32];
	let W;
	n[33] !== y || n[34] !== r || n[35] !== T || n[36] !== O || n[37] !== s || n[38] !== b ? (W = !y && /* @__PURE__ */ m($, {
		fill: !0,
		children: /* @__PURE__ */ m(qs, {
			id: `${r}-middleName`,
			type: "text",
			placeholder: "Middle Name",
			defaultValue: O.middleName ?? "",
			onInputValueChange: (e) => {
				let { value: t } = e;
				return s({
					...O,
					middleName: T ? t.toUpperCase() : t
				});
			},
			textFormat: T ? "uppercase" : "normal",
			readonly: b,
			disabled: b,
			noHeader: !0,
			stretch: !0
		})
	}), n[33] = y, n[34] = r, n[35] = T, n[36] = O, n[37] = s, n[38] = b, n[39] = W) : W = n[39];
	let G = `${r}-lastName`, K = O.lastName ?? "", q;
	n[40] !== T || n[41] !== O || n[42] !== s ? (q = (e) => {
		let { value: t } = e;
		return s({
			...O,
			lastName: T ? t.toUpperCase() : t
		});
	}, n[40] = T, n[41] = O, n[42] = s, n[43] = q) : q = n[43];
	let J = T ? "uppercase" : "normal", Y = x && S && !O.lastName ? "Enter last name" : void 0, X;
	n[44] !== b || n[45] !== S || n[46] !== G || n[47] !== K || n[48] !== q || n[49] !== J || n[50] !== Y ? (X = /* @__PURE__ */ m($, {
		fill: !0,
		children: /* @__PURE__ */ m(qs, {
			id: G,
			type: "text",
			placeholder: "Last Name",
			defaultValue: K,
			onInputValueChange: q,
			textFormat: J,
			readonly: b,
			disabled: b,
			required: S,
			noHeader: !0,
			stretch: !0,
			errorText: Y
		})
	}), n[44] = b, n[45] = S, n[46] = G, n[47] = K, n[48] = q, n[49] = J, n[50] = Y, n[51] = X) : X = n[51];
	let Z;
	n[52] !== E || n[53] !== U || n[54] !== W || n[55] !== X ? (Z = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "lg",
		fill: E,
		children: [
			U,
			W,
			X
		]
	}), n[52] = E, n[53] = U, n[54] = W, n[55] = X, n[56] = Z) : Z = n[56];
	let ee;
	n[57] !== E || n[58] !== L || n[59] !== Z ? (ee = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-sm",
		fill: E,
		children: [L, Z]
	}), n[57] = E, n[58] = L, n[59] = Z, n[60] = ee) : ee = n[60];
	let te;
	n[61] !== w || n[62] !== r || n[63] !== a || n[64] !== O || n[65] !== s || n[66] !== C || n[67] !== A || n[68] !== x ? (te = !w && /* @__PURE__ */ m(qs, {
		id: `${r}-preferredName`,
		type: "text",
		label: "Preferred Name",
		labelHintText: a,
		defaultValue: A,
		onInputValueChange: (e) => {
			let { value: t } = e;
			return s({
				...O,
				preferredName: t
			});
		},
		required: C,
		hideOptionalText: C,
		stretch: !0,
		errorText: x && C && !O.preferredName ? "Enter preferred name" : void 0
	}), n[61] = w, n[62] = r, n[63] = a, n[64] = O, n[65] = s, n[66] = C, n[67] = A, n[68] = x, n[69] = te) : te = n[69];
	let ne;
	return n[70] !== ee || n[71] !== te ? (ne = /* @__PURE__ */ h(p, { children: [ee, te] }), n[70] = ee, n[71] = te, n[72] = ne) : ne = n[72], ne;
}, Tl = (t) => {
	let n = e(26), { id: r, labelHintText: i, value: a, registeredOwnerNames: o, selectedLegalNames: s, readOnly: c, validate: l, onChange: u } = t, d;
	n[0] === o ? d = n[1] : (d = o === void 0 ? [] : o, n[0] = o, n[1] = d);
	let f = d, p = s === void 0 ? [] : s, h = c === void 0 ? !1 : c, g = l === void 0 ? !1 : l, _ = !!a, v = f.length > 0, y = !!(a && p.includes(a));
	if (v && !_) {
		let e;
		n[2] === f ? e = n[3] : (e = f.map(El), n[2] = f, n[3] = e);
		let t;
		n[4] !== u || n[5] !== h ? (t = (e) => !h && u?.(e), n[4] = u, n[5] = h, n[6] = t) : t = n[6];
		let o = g ? "Select correct legal name" : void 0, s;
		return n[7] !== r || n[8] !== i || n[9] !== h || n[10] !== e || n[11] !== t || n[12] !== o || n[13] !== a ? (s = /* @__PURE__ */ m(Ec, {
			id: r,
			label: "Legal Name",
			labelHintText: i,
			options: e,
			selected: a,
			onChange: t,
			placeholder: "Select Legal name",
			disabled: h,
			required: !0,
			hideOptionalText: !0,
			stretch: !0,
			errorText: o
		}), n[7] = r, n[8] = i, n[9] = h, n[10] = e, n[11] = t, n[12] = o, n[13] = a, n[14] = s) : s = n[14], s;
	}
	let b = a ?? "", x;
	n[15] !== u || n[16] !== h ? (x = (e) => {
		let { value: t } = e;
		return !h && u?.(t);
	}, n[15] = u, n[16] = h, n[17] = x) : x = n[17];
	let S = h || _, C = h || _, w = g && !a ? "Enter legal name" : y ? "Legal name already selected" : void 0, T;
	return n[18] !== r || n[19] !== i || n[20] !== w || n[21] !== b || n[22] !== x || n[23] !== S || n[24] !== C ? (T = /* @__PURE__ */ m(qs, {
		id: r,
		type: "text",
		label: "Legal Name",
		labelHintText: i,
		defaultValue: b,
		onInputValueChange: x,
		readonly: S,
		disabled: C,
		required: !0,
		hideOptionalText: !0,
		stretch: !0,
		textFormat: "uppercase",
		errorText: w
	}), n[18] = r, n[19] = i, n[20] = w, n[21] = b, n[22] = x, n[23] = S, n[24] = C, n[25] = T) : T = n[25], T;
};
function El(e) {
	return {
		label: e,
		value: e
	};
}
//#endregion
//#region src/components/display/Notes/NotesComposer.tsx
var Dl = ({ inputId: e, saveId: t, staffAddNotePending: n, isOpen: r, onSave: i, maxNoteLength: a = 2e3 }) => {
	let [s, c] = d(""), [l, f] = d(0), [p, g] = d(!1), _ = u(null);
	o(() => {
		r && _.current?.querySelector("textarea")?.focus();
	}, [r]);
	let v = s.trim().length > 0, y = async () => {
		let e = s.trim();
		if (e) try {
			g(!0), await i(e), c(""), f((e) => e + 1);
		} finally {
			g(!1);
		}
	};
	return /* @__PURE__ */ h($, {
		className: "agx-notes__composer",
		direction: "vertical",
		gap: "sm",
		padding: "md",
		children: [/* @__PURE__ */ m($, {
			className: "agx-notes-input",
			ref: _,
			children: /* @__PURE__ */ m(Hc, {
				id: e,
				placeholder: "Add a note...",
				defaultValue: s,
				onInputValueChange: ({ value: e }) => c(e),
				noHeader: !0,
				noResize: !0,
				flexibleHeight: !0,
				stretch: !0,
				maxLength: a,
				variant: "hollow"
			}, l)
		}), /* @__PURE__ */ m($, {
			direction: "horizontal",
			fill: !0,
			contentJustification: "end",
			children: /* @__PURE__ */ m(Kl, {
				id: t,
				dataTestId: "agx-notes-save",
				variant: "dark",
				size: "medium",
				text: "Save",
				disabled: !v || n || p,
				onClick: () => void y()
			})
		})]
	});
}, Ol = (t) => {
	let n = e(109), { catalogueId: r, catalogueType: i, maxNoteLength: s } = t, c = i === void 0 ? E.Campaign : i, l = s === void 0 ? 2e3 : s, u = a(C)?.userAccount?.agent || "", f;
	n[0] === c ? f = n[1] : (f = ns(c), n[0] = c, n[1] = f);
	let g;
	n[2] === r ? g = n[3] : (g = ns(r), n[2] = r, n[3] = g);
	let v = `agx-notes-${f}-${g}`, y = `${v}-input`, b = `${v}-close`, x = `${v}-save`, [S, N] = d(!1), [P, F] = d(null), I = O(), { data: L, isPending: R, isError: z } = j(c, r), B;
	n[4] !== r || n[5] !== c || n[6] !== I ? (B = () => {
		I(c, r);
	}, n[4] = r, n[5] = c, n[6] = I, n[7] = B) : B = n[7];
	let V = B, H;
	n[8] === V ? H = n[9] : (H = {
		onSuccess: V,
		onError: kl
	}, n[8] = V, n[9] = H);
	let { staffAddNote: U, staffAddNotePending: W } = k(H), G;
	n[10] === V ? G = n[11] : (G = {
		onSuccess: V,
		onError: Al
	}, n[10] = V, n[11] = G);
	let { staffDeleteNote: K, staffDeleteNotePending: q } = A(G), J;
	n[12] === V ? J = n[13] : (J = {
		onSuccess: V,
		onError: jl
	}, n[12] = V, n[13] = J);
	let { staffToggleNotePin: Y, staffToggleNotePinPending: X } = M(J), Z;
	n[14] === L ? Z = n[15] : (Z = L ?? [], n[14] = L, n[15] = Z);
	let ee = Z, te = ee.length, ne;
	n[16] === Symbol.for("react.memo_cache_sentinel") ? (ne = () => {
		N(!1), F(null);
	}, n[16] = ne) : ne = n[16];
	let re;
	n[17] !== r || n[18] !== c ? (re = [r, c], n[17] = r, n[18] = c, n[19] = re) : re = n[19], o(ne, re);
	let ie, ae;
	n[20] === S ? (ie = n[21], ae = n[22]) : (ie = () => {
		S || F(null);
	}, ae = [S], n[20] = S, n[21] = ie, n[22] = ae), o(ie, ae);
	let oe, se;
	n[23] !== r || n[24] !== c || n[25] !== I || n[26] !== S ? (oe = () => {
		S && I(c, r);
	}, se = [
		r,
		c,
		I,
		S
	], n[23] = r, n[24] = c, n[25] = I, n[26] = S, n[27] = oe, n[28] = se) : (oe = n[27], se = n[28]), o(oe, se);
	let ce;
	n[29] !== r || n[30] !== c || n[31] !== l || n[32] !== U ? (ce = async (e) => {
		let t = e.trim();
		t && await U({
			catalogueType: w[c],
			catalogueId: r,
			text: t.slice(0, l)
		});
	}, n[29] = r, n[30] = c, n[31] = l, n[32] = U, n[33] = ce) : ce = n[33];
	let le = ce, ue;
	n[34] !== r || n[35] !== c || n[36] !== P || n[37] !== K ? (ue = async () => {
		P?.noteId && (await K({
			catalogueType: T[c],
			catalogueId: r,
			noteId: P.noteId
		}), F(null));
	}, n[34] = r, n[35] = c, n[36] = P, n[37] = K, n[38] = ue) : ue = n[38];
	let de = ue, fe;
	n[39] !== r || n[40] !== c || n[41] !== Y ? (fe = async (e) => {
		e && await Y({
			catalogueType: D[c],
			catalogueId: r,
			noteId: e
		});
	}, n[39] = r, n[40] = c, n[41] = Y, n[42] = fe) : fe = n[42];
	let pe = fe, me = !S && te > 0, he;
	n[43] === Symbol.for("react.memo_cache_sentinel") ? (he = document.getElementById("root") ?? document.getElementById("storybook-root") ?? document.body, n[43] = he) : he = n[43];
	let ge = he, _e;
	n[44] === Symbol.for("react.memo_cache_sentinel") ? (_e = () => {
		N(!1), F(null);
	}, n[44] = _e) : _e = n[44];
	let ve = _e, ye;
	n[45] === S ? ye = n[46] : (ye = () => {
		S ? ve() : N(!0);
	}, n[45] = S, n[46] = ye);
	let be;
	n[47] === Symbol.for("react.memo_cache_sentinel") ? (be = /* @__PURE__ */ m(Pi, {
		height: 24,
		width: 24,
		color: "var(--text-white)"
	}), n[47] = be) : be = n[47];
	let xe;
	n[48] === ye ? xe = n[49] : (xe = /* @__PURE__ */ m("button", {
		type: "button",
		className: "agx-notes__fab",
		"data-testid": "agx-notes-fab",
		"aria-label": "Open notes",
		onClick: ye,
		children: be
	}), n[48] = ye, n[49] = xe);
	let Se;
	n[50] !== v || n[51] !== te || n[52] !== me ? (Se = me && /* @__PURE__ */ m("div", {
		className: "agx-notes__badge",
		children: /* @__PURE__ */ m(Q, {
			id: `${v}-note-count`,
			type: "tag",
			size: "small",
			color: "var(--text-white)",
			children: te
		})
	}), n[50] = v, n[51] = te, n[52] = me, n[53] = Se) : Se = n[53];
	let Ce;
	n[54] !== xe || n[55] !== Se ? (Ce = /* @__PURE__ */ h("div", {
		className: "agx-notes__fab-wrapper",
		children: [xe, Se]
	}), n[54] = xe, n[55] = Se, n[56] = Ce) : Ce = n[56];
	let we, Te;
	n[57] === Symbol.for("react.memo_cache_sentinel") ? (we = {
		base: "agx-notes__modal",
		afterOpen: "agx-notes__modal--open",
		beforeClose: "agx-notes__modal--close"
	}, Te = {
		base: "agx-notes__overlay",
		afterOpen: "agx-notes__overlay--open",
		beforeClose: "agx-notes__overlay--close"
	}, n[57] = we, n[58] = Te) : (we = n[57], Te = n[58]);
	let Ee = `${v}-title`, De;
	n[59] === pe ? De = n[60] : (De = (e) => void pe(e), n[59] = pe, n[60] = De);
	let Oe;
	n[61] === Symbol.for("react.memo_cache_sentinel") ? (Oe = (e) => F(e), n[61] = Oe) : Oe = n[61];
	let ke;
	n[62] !== b || n[63] !== u || n[64] !== z || n[65] !== R || n[66] !== ee || n[67] !== q || n[68] !== X || n[69] !== Ee || n[70] !== De ? (ke = /* @__PURE__ */ m(is, {
		titleId: Ee,
		closeId: b,
		onClose: ve,
		currentUserId: u,
		notes: ee,
		isPending: R,
		isError: z,
		staffDeleteNotePending: q,
		staffToggleNotePinPending: X,
		onTogglePin: De,
		onRequestDelete: Oe
	}), n[62] = b, n[63] = u, n[64] = z, n[65] = R, n[66] = ee, n[67] = q, n[68] = X, n[69] = Ee, n[70] = De, n[71] = ke) : ke = n[71];
	let Ae;
	n[72] !== le || n[73] !== y || n[74] !== S || n[75] !== l || n[76] !== x || n[77] !== W ? (Ae = /* @__PURE__ */ m(Dl, {
		inputId: y,
		saveId: x,
		staffAddNotePending: W,
		isOpen: S,
		onSave: le,
		maxNoteLength: l
	}), n[72] = le, n[73] = y, n[74] = S, n[75] = l, n[76] = x, n[77] = W, n[78] = Ae) : Ae = n[78];
	let je;
	n[79] !== ke || n[80] !== Ae ? (je = /* @__PURE__ */ h($, {
		className: "agx-notes__panel",
		"data-testid": "agx-notes-panel",
		direction: "vertical",
		gap: "2xs",
		children: [ke, Ae]
	}), n[79] = ke, n[80] = Ae, n[81] = je) : je = n[81];
	let Me = !!P, Ne;
	n[82] === Symbol.for("react.memo_cache_sentinel") ? (Ne = (e) => {
		e || F(null);
	}, n[82] = Ne) : Ne = n[82];
	let Pe;
	n[83] === Symbol.for("react.memo_cache_sentinel") ? (Pe = {
		bottom: "md",
		left: "xl",
		right: "xl"
	}, n[83] = Pe) : Pe = n[83];
	let Fe = `${v}-delete-confirm`, Ie;
	n[84] === Fe ? Ie = n[85] : (Ie = /* @__PURE__ */ m($, {
		direction: "vertical",
		gap: "sm",
		padding: Pe,
		children: /* @__PURE__ */ m(Q, {
			id: Fe,
			type: "body_ui",
			size: "small",
			color: "var(--text-primary)",
			children: "Are you sure you want to delete this note? This cannot be undone."
		})
	}), n[84] = Fe, n[85] = Ie);
	let Le = `${v}-cancel-delete`, Re;
	n[86] === Symbol.for("react.memo_cache_sentinel") ? (Re = () => F(null), n[86] = Re) : Re = n[86];
	let ze;
	n[87] === Le ? ze = n[88] : (ze = /* @__PURE__ */ m(Kl, {
		id: Le,
		variant: "dark",
		size: "medium",
		text: "Cancel",
		onClick: Re
	}), n[87] = Le, n[88] = ze);
	let Be = `${v}-confirm-delete`, Ve;
	n[89] === de ? Ve = n[90] : (Ve = () => void de(), n[89] = de, n[90] = Ve);
	let He;
	n[91] !== q || n[92] !== Be || n[93] !== Ve ? (He = /* @__PURE__ */ m(Kl, {
		id: Be,
		variant: "primary",
		danger: !0,
		size: "medium",
		disabled: q,
		text: "Delete",
		onClick: Ve
	}), n[91] = q, n[92] = Be, n[93] = Ve, n[94] = He) : He = n[94];
	let Ue;
	n[95] !== ze || n[96] !== He ? (Ue = /* @__PURE__ */ h(p, { children: [ze, He] }), n[95] = ze, n[96] = He, n[97] = Ue) : Ue = n[97];
	let We;
	n[98] !== Me || n[99] !== Ie || n[100] !== Ue ? (We = /* @__PURE__ */ m(Ya, {
		title: "Delete note?",
		type: "single",
		variant: "withoutDivider",
		actionButtonContainerStyle: "withoutDivider",
		minWidth: "420px",
		isOpen: Me,
		setIsDialogOpen: Ne,
		content: Ie,
		actionButtons: Ue
	}), n[98] = Me, n[99] = Ie, n[100] = Ue, n[101] = We) : We = n[101];
	let Ge;
	n[102] !== S || n[103] !== je || n[104] !== We ? (Ge = /* @__PURE__ */ h(_, {
		isOpen: S,
		onRequestClose: ve,
		shouldCloseOnOverlayClick: !0,
		shouldCloseOnEsc: !0,
		className: we,
		overlayClassName: Te,
		bodyOpenClassName: "modal-open-body",
		appElement: ge,
		children: [je, We]
	}), n[102] = S, n[103] = je, n[104] = We, n[105] = Ge) : Ge = n[105];
	let Ke;
	return n[106] !== Ce || n[107] !== Ge ? (Ke = /* @__PURE__ */ h("div", {
		className: "agx-notes",
		children: [Ce, Ge]
	}), n[106] = Ce, n[107] = Ge, n[108] = Ke) : Ke = n[108], Ke;
};
function kl(e) {
	return console.error("Failed to add note:", e);
}
function Al(e) {
	return console.error("Failed to delete note:", e);
}
function jl(e) {
	return console.error("Failed to toggle note pin:", e);
}
var Ml = {
	v: "5.9.0",
	fr: 25,
	ip: 0,
	op: 58,
	w: 1080,
	h: 1080,
	nm: "Settings",
	ddd: 0,
	assets: [],
	layers: [
		{
			ddd: 0,
			ind: 2,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 3,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						-1.494,
						86.102,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						696.389,
						465.9,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [[0, 0], [0, 0]],
								o: [[0, 0], [0, 0]],
								v: [[0, -1.941], [0, 1.941]],
								c: !1
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.811764705882,
								.662745098039,
								.529411764706,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [718.724, 465.9],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}, {
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [[0, 0], [0, 0]],
								o: [[0, 0], [0, 0]],
								v: [[0, -1.941], [0, 1.941]],
								c: !1
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.811764705882,
								.662745098039,
								.529411764706,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [674.054, 465.9],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 3,
			ty: 4,
			nm: "secondaryAnimationClass",
			parent: 6,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [{
						i: {
							x: [.833],
							y: [.833]
						},
						o: {
							x: [.167],
							y: [.167]
						},
						t: 0,
						s: [0]
					}, {
						t: 58.3330078125,
						s: [-360]
					}],
					ix: 10
				},
				p: {
					a: 0,
					k: [
						144.133,
						-60.947,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-2.456,
						9.745,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[25.987, 0],
									[0, 26.396],
									[-25.987, 0],
									[0, -26.396]
								],
								o: [
									[-25.987, 0],
									[0, -26.396],
									[25.987, 0],
									[0, 26.396]
								],
								v: [
									[-2.098, 56.767],
									[-49.158, 9.002],
									[-2.098, -38.798],
									[44.926, 9.002]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[0, 0],
									[0, 10.882],
									[2.793, 10.271],
									[0, 0],
									[0, 0],
									[0, 0],
									[18.491, 5.315],
									[0, 0],
									[0, 0],
									[0, 0],
									[14.213, -14.293],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, -9.876],
									[-2.793, -10.271],
									[0, 0],
									[0, 0],
									[0, 0],
									[-18.421, -5.351],
									[0, 0],
									[0, 0],
									[0, 0],
									[-13.718, 13.108],
									[0, 0],
									[0, 0]
								],
								o: [
									[2.652, -10.02],
									[0, -11.169],
									[0, 0],
									[0, 0],
									[0, 0],
									[-13.683, -12.929],
									[0, 0],
									[0, 0],
									[0, 0],
									[-19.764, 5.674],
									[0, 0],
									[0, 0],
									[0, 0],
									[-2.192, 9.194],
									[0, 11.169],
									[0, 0],
									[0, 0],
									[0, 0],
									[13.648, 12.893],
									[0, 0],
									[0, 0],
									[0, 0],
									[18.633, -5.387],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[113.448, 40.427],
									[117.514, 9.002],
									[113.236, -23.248],
									[143.289, -45.011],
									[112.316, -96.906],
									[79.328, -80.027],
									[30.465, -107.968],
									[27.849, -143.629],
									[-31.904, -143.629],
									[-34.626, -108.003],
									[-86.282, -77.333],
									[-118.421, -93.063],
									[-148.439, -40.594],
									[-118.386, -19.656],
									[-121.745, 9.002],
									[-117.467, 41.217],
									[-147.343, 63.016],
									[-116.371, 114.911],
									[-83.56, 97.96],
									[-34.874, 125.901],
									[-31.904, 164.831],
									[27.849, 164.831],
									[30.713, 125.865],
									[79.859, 97.493],
									[114.119, 114.408],
									[144.137, 61.939]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.811764705882,
								.662745098039,
								.529411764706,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 4,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 5,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						.406,
						-66.555,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						434.268,
						534.768,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [[0, 0], [0, 0]],
								o: [[0, 0], [0, 0]],
								v: [[0, -1.941], [0, 1.941]],
								c: !1
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [456.603, 534.768],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}, {
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [[0, 0], [0, 0]],
								o: [[0, 0], [0, 0]],
								v: [[0, -1.941], [0, 1.941]],
								c: !1
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [411.933, 534.768],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 5,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 6,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [{
						i: {
							x: [.833],
							y: [.833]
						},
						o: {
							x: [.167],
							y: [.167]
						},
						t: 0,
						s: [0]
					}, {
						t: 58.3330078125,
						s: [360]
					}],
					ix: 10
				},
				p: {
					a: 0,
					k: [
						-127.679,
						13.198,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-1,
						-2.5,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[23.132, 0],
									[0, 23.132],
									[-23.099, 0],
									[0, -23.099]
								],
								o: [
									[-23.099, 0],
									[0, -23.099],
									[23.132, 0],
									[0, 23.132]
								],
								v: [
									[0, 41.226],
									[-41.847, -.622],
									[0, -42.469],
									[41.847, -.622]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ind: 1,
						ty: "sh",
						ix: 2,
						ks: {
							a: 0,
							k: {
								i: [
									[0, 0],
									[0, 11.222],
									[4.352, 11.615],
									[0, 0],
									[0, 0],
									[0, 0],
									[21.758, 4.384],
									[0, 0],
									[0, 0],
									[0, 0],
									[15.116, -17.603],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, -11.222],
									[-4.613, -11.877],
									[0, 0],
									[0, 0],
									[0, 0],
									[-21.332, -4.352],
									[0, 0],
									[0, 0],
									[0, 0],
									[-15.116, 17.57],
									[0, 0],
									[0, 0]
								],
								o: [
									[3.206, -10.143],
									[0, -13.153],
									[0, 0],
									[0, 0],
									[0, 0],
									[-14.756, -15.476],
									[0, 0],
									[0, 0],
									[0, 0],
									[-23.623, 4.744],
									[0, 0],
									[0, 0],
									[0, 0],
									[-3.206, 10.143],
									[0, 13.513],
									[0, 0],
									[0, 0],
									[0, 0],
									[14.625, 15.051],
									[0, 0],
									[0, 0],
									[0, 0],
									[23.59, -4.777],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[101.493, 31.541],
									[106.434, -.622],
									[99.693, -37.986],
									[123.186, -55.458],
									[102.834, -87.62],
									[77.085, -74.009],
									[21.234, -104.928],
									[19.108, -133.754],
									[-18.977, -133.754],
									[-21.202, -104.928],
									[-80.749, -69.952],
									[-107.546, -82.353],
									[-126.065, -49.111],
									[-101.493, -32.817],
									[-106.434, -.622],
									[-99.301, 37.725],
									[-123.186, 55.458],
									[-102.802, 87.62],
									[-76.3, 73.584],
									[-21.333, 103.685],
									[-19.075, 133.754],
									[18.977, 133.754],
									[21.3, 103.685],
									[80.749, 68.742],
									[107.546, 81.142],
									[126.065, 47.867]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 2",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 6,
			ty: 3,
			nm: "Null 168",
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 0,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 0,
							s: [.637]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 4.167,
							s: [0]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 31.25,
							s: [10]
						},
						{
							t: 58.3330078125,
							s: [.637]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 0,
							s: [
								538,
								594,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 27.083,
							s: [
								538,
								620,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							t: 58.3330078125,
							s: [
								538,
								594,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						0,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		}
	],
	markers: []
}, Nl = {
	v: "5.9.0",
	fr: 25,
	ip: 0,
	op: 58,
	w: 1080,
	h: 1080,
	nm: "Mail 2",
	ddd: 0,
	assets: [],
	layers: [
		{
			ddd: 0,
			ind: 1,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 11,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: -.344,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						553.636,
						492.566,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						14,
						-54,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						174.967,
						174.967,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[26.208, -40],
									[.057, -12.552],
									[-26.095, -40],
									[-48.261, -40],
									[-11.111, -.837],
									[-50, 40],
									[-27.834, 40],
									[-.112, 10.822],
									[27.553, 40],
									[50, 40],
									[11.11, -.892],
									[48.26, -40]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [12.25, -56.75],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [72, 72],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 9,
			op: 55,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 2,
			ty: 3,
			nm: "Null 167",
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 0,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 2.083,
							s: [0]
						},
						{
							i: {
								x: [.3],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 6.25,
							s: [-2]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 12.5,
							s: [3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 18.75,
							s: [-1]
						},
						{
							t: 22.9169921875,
							s: [0]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 0,
							s: [
								540,
								736,
								0
							],
							to: [
								0,
								2.5,
								0
							],
							ti: [
								0,
								4,
								0
							]
						},
						{
							i: {
								x: .18,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 4.167,
							s: [
								540,
								751,
								0
							],
							to: [
								0,
								-4,
								0
							],
							ti: [
								0,
								2.5,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .42,
								y: 0
							},
							t: 12.5,
							s: [
								540,
								712,
								0
							],
							to: [
								0,
								-2.5,
								0
							],
							ti: [
								0,
								-4,
								0
							]
						},
						{
							i: {
								x: .667,
								y: .667
							},
							o: {
								x: .167,
								y: .167
							},
							t: 16.667,
							s: [
								540,
								736,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .18,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 41.667,
							s: [
								540,
								736,
								0
							],
							to: [
								0,
								-4,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .42,
								y: 0
							},
							t: 45.833,
							s: [
								540,
								712,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								-4,
								0
							]
						},
						{
							t: 52.0830078125,
							s: [
								540,
								736,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						0,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 4,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 2,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						7.568,
						-252.333,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-1,
						-93,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 1,
					k: [{
						i: {
							x: [
								.833,
								.833,
								.833
							],
							y: [
								.833,
								.833,
								.833
							]
						},
						o: {
							x: [
								.167,
								.167,
								.167
							],
							y: [
								.167,
								.167,
								.167
							]
						},
						t: 6.25,
						s: [
							100,
							100,
							100
						]
					}, {
						t: 6.66666666666667,
						s: [
							100,
							-100,
							100
						]
					}],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 0,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[223.064, -42.39],
											[11.065, 90.216],
											[-11.065, 90.216],
											[-223.064, -42.39],
											[-233.139, -57.742],
											[-233.139, -76.656],
											[-217.156, -93.178],
											[217.156, -93.178],
											[233.139, -76.656],
											[233.139, -57.742]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 4.167,
									s: [{
										i: [
											[6.083, -2.502],
											[38.343, -9.887],
											[10.216, 4.417],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.562, 1.692],
											[-38.426, -16.614],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[223.064, -42.39],
											[10.698, 106.216],
											[-12.397, 104.199],
											[-223.064, -42.39],
											[-233.139, -57.742],
											[-233.139, -76.656],
											[-217.156, -93.178],
											[217.156, -93.178],
											[233.139, -76.656],
											[233.139, -57.742]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .19,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 6.25,
									s: [{
										i: [
											[6.064, -1.351],
											[0, 0],
											[6.827, 2.133],
											[0, 0],
											[0, 3.655],
											[0, 0],
											[-8.801, 0],
											[0, 0],
											[0, -4.929],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.827, 2.133],
											[0, 0],
											[-6.064, -1.351],
											[0, 0],
											[0, -4.929],
											[0, 0],
											[8.801, 0],
											[0, 0],
											[0, 3.655]
										],
										v: [
											[222.514, -71.929],
											[10.748, -46.3],
											[-11.314, -46.3],
											[-222.27, -71.929],
											[-232.315, -80.221],
											[-232.441, -84.938],
											[-216.506, -93.863],
											[216.497, -93.863],
											[232.432, -84.938],
											[232.559, -80.221]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .65,
										y: 0
									},
									t: 10.417,
									s: [{
										i: [
											[5.975, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.671, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-5.975, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.671, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[219.114, -42.39],
											[10.698, 120.216],
											[-11.432, 120.216],
											[-219.107, -42.39],
											[-229.003, -57.742],
											[-228.582, -112.656],
											[-212.882, -129.178],
											[213.732, -129.178],
											[229.432, -112.656],
											[229.011, -57.742]
										],
										c: !0
									}]
								},
								{
									t: 14.5836588541667,
									s: [{
										i: [
											[5.908, -4.479],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 12.118],
											[0, 0],
											[-8.573, 0],
											[0, 0],
											[0, -16.34],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-5.908, -4.479],
											[0, 0],
											[0, -16.34],
											[0, 0],
											[8.573, 0],
											[0, 0],
											[0, 12.118]
										],
										v: [
											[216.647, -42.39],
											[11.065, 90.216],
											[-11.065, 90.216],
											[-216.647, -42.39],
											[-226.432, -69.88],
											[-226.432, -103.748],
											[-210.908, -133.333],
											[210.908, -133.333],
											[226.432, -103.748],
											[226.432, -69.88]
										],
										c: !0
									}]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}, {
				ty: "tm",
				s: {
					a: 1,
					k: [{
						i: {
							x: [.833],
							y: [.833]
						},
						o: {
							x: [.167],
							y: [.167]
						},
						t: 7.084,
						s: [0]
					}, {
						t: 10.4166666666667,
						s: [0]
					}],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 6.25,
							s: [100]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 6.667,
							s: [55.8]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 7.084,
							s: [56]
						},
						{
							t: 10.4166666666667,
							s: [58]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [{
						i: {
							x: [.833],
							y: [.833]
						},
						o: {
							x: [.167],
							y: [.167]
						},
						t: 7.084,
						s: [-14]
					}, {
						t: 10.4166666666667,
						s: [-20]
					}],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: !1
			}],
			ip: 0,
			op: 8.33333333333333,
			st: 4.16666666666667,
			bm: 0
		},
		{
			ddd: 0,
			ind: 6,
			ty: 4,
			nm: "end top fill 2",
			td: 1,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						547.568,
						483.667,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-1,
						-93,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: .833,
										y: 1
									},
									o: {
										x: .167,
										y: 0
									},
									t: 0,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[224.834, -39.39],
											[10.834, 84.216],
											[-11.296, 84.216],
											[-225.295, -37.39],
											[-235.37, -52.742],
											[-235.37, -71.656],
											[-219.387, -88.178],
											[218.925, -90.178],
											[234.908, -73.656],
											[234.908, -54.742]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: .833
									},
									o: {
										x: .167,
										y: 0
									},
									t: 4.166,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[224.834, -39.39],
											[39.834, 107.216],
											[-27.296, 114.216],
											[-225.295, -37.39],
											[-235.37, -52.742],
											[-235.37, -71.656],
											[-219.387, -88.178],
											[218.925, -90.178],
											[234.908, -73.656],
											[234.908, -54.742]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: .833
									},
									o: {
										x: .167,
										y: .167
									},
									t: 4.583,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[8.749, 21.687],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[-47.751, -.313],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[223.519, -40.639],
											[36.032, 91.496],
											[-20.817, 89.646],
											[-225.168, -48.34],
											[-235.242, -63.692],
											[-235.242, -82.606],
											[-219.259, -99.128],
											[218.779, -100.991],
											[234.762, -84.469],
											[234.762, -65.555]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: .833
									},
									o: {
										x: .167,
										y: .167
									},
									t: 5,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[7.798, 12.818],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[-23.876, -.157],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[221.645, -51.08],
											[27.726, 52.73],
											[-25.084, 58.633],
											[-224.986, -63.945],
											[-235.061, -79.297],
											[-235.061, -98.211],
											[-219.077, -114.733],
											[218.57, -116.401],
											[234.554, -99.879],
											[234.554, -80.965]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: 1
									},
									o: {
										x: .167,
										y: .167
									},
									t: 5.416,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[219.771, -61.522],
											[19.42, 13.964],
											[-2.352, 19.62],
											[-224.804, -79.549],
											[-234.879, -94.901],
											[-234.879, -113.815],
											[-218.895, -130.337],
											[218.362, -131.81],
											[234.346, -115.288],
											[234.346, -96.374]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: 1
									},
									o: {
										x: .167,
										y: 0
									},
									t: 8.333,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[222.697, -197.39],
											[11.698, -170.784],
											[-10.432, -170.784],
											[-223.431, -197.39],
											[-233.506, -212.742],
											[-233.506, -231.656],
											[-217.523, -248.178],
											[216.789, -248.178],
											[232.772, -231.656],
											[232.772, -212.742]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: .833
									},
									o: {
										x: .167,
										y: 0
									},
									t: 52.083,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[222.697, -197.39],
											[11.698, -170.784],
											[-10.432, -170.784],
											[-223.431, -197.39],
											[-233.506, -212.742],
											[-233.506, -231.656],
											[-217.523, -248.178],
											[216.789, -248.178],
											[232.772, -231.656],
											[232.772, -212.742]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: .833
									},
									o: {
										x: .167,
										y: .167
									},
									t: 54.166,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[222.986, -75.554],
											[9.2, -42.628],
											[-12.929, -42.628],
											[-223.143, -75.554],
											[-233.218, -90.906],
											[-233.218, -109.82],
											[-217.234, -126.342],
											[217.077, -126.342],
											[233.061, -109.82],
											[233.061, -90.906]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: .833
									},
									o: {
										x: .167,
										y: .167
									},
									t: 55,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[222.986, -75.554],
											[9.2, -42.628],
											[-12.929, -42.628],
											[-223.143, -75.554],
											[-233.218, -90.906],
											[-233.218, -109.82],
											[-217.234, -126.342],
											[217.077, -126.342],
											[233.061, -109.82],
											[233.061, -90.906]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .28,
										y: 1
									},
									o: {
										x: .167,
										y: .167
									},
									t: 55.416,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[223.024, -59.361],
											[9.611, 14.235],
											[-12.519, 14.235],
											[-223.105, -59.361],
											[-233.179, -74.713],
											[-233.179, -93.627],
											[-217.196, -110.149],
											[217.116, -110.149],
											[233.099, -93.627],
											[233.099, -74.713]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 56.666,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[223.064, -42.39],
											[11.065, 90.216],
											[-11.065, 90.216],
											[-223.064, -42.39],
											[-233.139, -57.742],
											[-233.139, -76.656],
											[-217.156, -93.178],
											[217.156, -93.178],
											[233.139, -76.656],
											[233.139, -57.742]
										],
										c: !0
									}]
								},
								{
									t: 68.7503255208333,
									s: [{
										i: [
											[5.908, -4.479],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 12.118],
											[0, 0],
											[-8.573, 0],
											[0, 0],
											[0, -16.34],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-5.908, -4.479],
											[0, 0],
											[0, -16.34],
											[0, 0],
											[8.573, 0],
											[0, 0],
											[0, 12.118]
										],
										v: [
											[216.647, -42.39],
											[11.065, 90.216],
											[-11.065, 90.216],
											[-216.647, -42.39],
											[-226.432, -69.88],
											[-226.432, -103.748],
											[-210.908, -133.333],
											[210.908, -133.333],
											[226.432, -103.748],
											[226.432, -69.88]
										],
										c: !0
									}]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.176470592618,
								.219607844949,
								.286274522543,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 0,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}, {
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 0,
					k: -14,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 58.3333333333333,
			bm: 0
		},
		{
			ddd: 0,
			ind: 7,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 2,
			tt: 2,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						9.859,
						-76.193,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						0,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 0,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[7.626, -4.206],
											[2.161, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[-7.682, -4.103],
											[-47.161, 26.007],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[9.771, -73.102],
											[-14.757, -72.946],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 4.167,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[7.626, -4.206],
											[2.161, 0],
											[0, 0],
											[-12.755, 0],
											[-196.63, 29.941],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[-7.682, -4.103],
											[-47.161, 26.007],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[17.5, -2.665],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[9.771, -73.102],
											[-14.757, -72.946],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 12.5,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[7.499, -4.206],
											[2.125, 0],
											[0, 0],
											[-12.541, 0],
											[-229.958, -6.179],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[-7.554, -4.103],
											[-46.37, 26.007],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[14.176, -.448],
											[0, 0]
										],
										v: [
											[227.961, 45.493],
											[9.607, -73.102],
											[-14.509, -72.946],
											[-230.459, 45.593],
											[-230.459, 53.146],
											[-205.253, 76.14],
											[205.253, 76.14],
											[227.961, 53.045]
										],
										c: !0
									}]
								},
								{
									t: 22.9169921875,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[7.626, -4.206],
											[2.161, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[-7.682, -4.103],
											[-47.161, 26.007],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[9.771, -73.102],
											[-14.757, -72.946],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 8,
			ty: 4,
			nm: "frnt fill",
			parent: 2,
			td: 1,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						9.859,
						-76.193,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						0,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 0,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[3.102, -42.139],
											[0, 0],
											[.995, 1.991],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.682, -4.103],
											[-.783, 10.635],
											[0, 0],
											[-67.301, 37.037],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[84.95, -32.676],
											[229.64, -135.059],
											[226.771, -170.602],
											[-234.757, -168.946],
											[-232.673, -130.562],
											[-78.854, -37.798],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: .833
									},
									o: {
										x: .333,
										y: 0
									},
									t: 4.167,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[3.102, -42.139],
											[0, 0],
											[.995, 1.991],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.682, -4.103],
											[-.783, 10.635],
											[0, 0],
											[-67.301, 37.037],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[90.88, -28.572],
											[229.64, -135.059],
											[226.771, -170.602],
											[-234.757, -168.946],
											[-232.673, -130.562],
											[-90.974, -31.008],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .167,
										y: .167
									},
									t: 5.417,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[1.297, 16.188],
											[3.102, -42.139],
											[0, 0],
											[-38.124, 2.616],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-4.002, -17.632],
											[-.783, 10.635],
											[0, 0],
											[23.455, 17.048],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[8.127, -75.734],
											[225.187, -144.31],
											[229.685, -170.501],
											[-234.757, -168.946],
											[-232.097, -147.076],
											[-10.003, -94.349],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 6.25,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[2.002, 24.981],
											[3.102, -42.139],
											[0, 0],
											[.995, 1.991],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-2.002, -24.981],
											[-.783, 10.635],
											[0, 0],
											[-14.334, 104.069],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[.988, -76.238],
											[164.082, -148.855],
											[231.268, -170.445],
											[-234.757, -168.946],
											[-231.783, -156.047],
											[8.58, -131.095],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 6.667,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[7.499, -4.206],
											[2.993, -1.671],
											[16.142, -8.949],
											[1.624, 0],
											[0, 0],
											[-12.541, 0],
											[-229.958, -6.179],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.554, -4.103],
											[-2.389, 1.34],
											[-10.709, 5.981],
											[-66.904, 37.091],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[14.176, -.448],
											[0, 0]
										],
										v: [
											[227.961, 45.493],
											[25.776, -64.32],
											[14.373, -70.514],
											[9.607, -73.102],
											[-14.509, -72.946],
											[-22.602, -68.418],
											[-63.776, -45.525],
											[-230.459, 45.593],
											[-230.459, 53.146],
											[-205.253, 76.14],
											[205.253, 76.14],
											[227.961, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 8.333,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[7.499, -4.206],
											[2.993, -1.671],
											[16.142, -8.949],
											[1.624, 0],
											[0, 0],
											[-12.541, 0],
											[-229.958, -6.179],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.554, -4.103],
											[-2.389, 1.34],
											[-10.709, 5.981],
											[-66.904, 37.091],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[14.176, -.448],
											[0, 0]
										],
										v: [
											[227.961, 45.493],
											[25.776, -64.32],
											[14.373, -70.514],
											[9.607, -73.102],
											[-14.509, -72.946],
											[-22.602, -68.418],
											[-63.776, -45.525],
											[-230.459, 45.593],
											[-230.459, 53.146],
											[-205.253, 76.14],
											[205.253, 76.14],
											[227.961, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 22.917,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[7.626, -4.206],
											[3.031, -1.671],
											[16.249, -8.943],
											[1.651, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.682, -4.103],
											[-2.43, 1.34],
											[-10.846, 5.979],
											[-67.345, 37.064],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[26.216, -64.32],
											[14.618, -70.514],
											[9.771, -73.102],
											[-14.757, -72.946],
											[-22.968, -68.419],
											[-64.506, -45.539],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 53.75,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[7.626, -4.206],
											[3.031, -1.671],
											[16.249, -8.943],
											[1.651, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.682, -4.103],
											[-2.43, 1.34],
											[-10.846, 5.979],
											[-67.345, 37.064],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[26.216, -64.32],
											[14.618, -70.514],
											[9.771, -73.102],
											[-14.757, -72.946],
											[-22.968, -68.419],
											[-64.506, -45.539],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 54.167,
									s: [{
										i: [
											[0, 0],
											[-.191, 2.631],
											[0, 0],
											[0, 0],
											[3.102, -42.139],
											[0, 0],
											[.995, 1.991],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[.191, -2.631],
											[0, 0],
											[-7.682, -4.103],
											[-2.102, 20.139],
											[0, 0],
											[-67.301, 37.037],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[-42.05, -104.176],
											[231.64, -157.059],
											[226.771, -170.602],
											[-234.757, -168.946],
											[-166.173, -146.562],
											[-.354, -83.298],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 54.583,
									s: [{
										i: [
											[0, 0],
											[-.191, 2.631],
											[0, 0],
											[0, 0],
											[3.102, -42.139],
											[0, 0],
											[.995, 1.991],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[.191, -2.631],
											[0, 0],
											[-7.682, -4.103],
											[-2.102, 20.139],
											[0, 0],
											[-67.301, 37.037],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[-42.05, -104.176],
											[231.64, -157.059],
											[226.771, -170.602],
											[-234.757, -168.946],
											[-166.173, -146.562],
											[-.354, -83.298],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 55,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[3.102, -42.139],
											[0, 0],
											[.995, 1.991],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.682, -4.103],
											[-.783, 10.635],
											[0, 0],
											[-67.301, 37.037],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[67.95, -38.676],
											[229.64, -150.559],
											[226.771, -170.602],
											[-234.757, -168.946],
											[-226.173, -147.562],
											[-78.854, -37.798],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 55.417,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[3.102, -42.139],
											[0, 0],
											[.995, 1.991],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.682, -4.103],
											[-.783, 10.635],
											[0, 0],
											[-67.301, 37.037],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[67.95, -38.676],
											[231.64, -152.059],
											[226.771, -170.602],
											[-234.757, -168.946],
											[-229.173, -145.062],
											[-78.854, -37.798],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								},
								{
									t: 56.25,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[3.102, -42.139],
											[0, 0],
											[.995, 1.991],
											[1.64, 0],
											[0, 0],
											[-12.755, 0],
											[0, 0],
											[0, 12.755]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[-7.682, -4.103],
											[-.783, 10.635],
											[0, 0],
											[-67.301, 37.037],
											[0, 0],
											[0, 12.755],
											[0, 0],
											[12.755, 0],
											[0, 0]
										],
										v: [
											[231.849, 45.493],
											[84.95, -32.676],
											[229.64, -135.059],
											[226.771, -170.602],
											[-234.757, -168.946],
											[-232.673, -130.562],
											[-78.854, -37.798],
											[-231.849, 45.493],
											[-231.849, 53.045],
											[-208.753, 76.14],
											[208.753, 76.14],
											[231.849, 53.045]
										],
										c: !0
									}]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.176470592618,
								.219607844949,
								.286274522543,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 0,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 9,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 2,
			tt: 2,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						8.568,
						-118.325,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						0,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 0,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										v: [
											[227.962, 96.715],
											[227.492, -123.715],
											[32.325, -23.404],
											[-32.406, -23.404],
											[-228.432, -122.429],
											[-227.962, 96.715],
											[-3.568, 96.715]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .25,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 4.167,
									s: [{
										i: [
											[-6.301, 8.39],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[-17.302, -25.084],
											[-108.535, .893]
										],
										o: [
											[19.653, -43.929],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[8.516, 12.346],
											[111.987, -.921]
										],
										v: [
											[227.962, 96.715],
											[227.492, -123.715],
											[32.325, -23.404],
											[-32.406, -23.404],
											[-228.432, -122.429],
											[-227.962, 96.715],
											[-3.342, 112.363]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 12.5,
									s: [{
										i: [
											[-1.809, 2.229],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[23.564, -107.427],
											[-110.097, .41]
										],
										o: [
											[-25.436, -95.208],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[6.697, 3.996],
											[113.598, -.423]
										],
										v: [
											[227.962, 96.715],
											[226.744, -145.706],
											[32.325, -23.404],
											[-32.406, -23.404],
											[-229.18, -144.42],
											[-227.962, 96.715],
											[-1.485, 101.426]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 16.667,
									s: [{
										i: [
											[-6.301, 8.39],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[-14.632, -18.239],
											[-108.325, .736]
										],
										o: [
											[10.422, -53.549],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[9.385, 11.698],
											[111.77, -.759]
										],
										v: [
											[227.962, 96.715],
											[227.492, -123.715],
											[32.325, -23.404],
											[-32.406, -23.404],
											[-228.432, -122.429],
											[-227.962, 96.715],
											[-2.669, 111.862]
										],
										c: !0
									}]
								},
								{
									t: 22.9169921875,
									s: [{
										i: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										o: [
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0],
											[0, 0]
										],
										v: [
											[227.962, 96.715],
											[227.492, -123.715],
											[32.325, -23.404],
											[-32.406, -23.404],
											[-228.432, -122.429],
											[-227.962, 96.715],
											[-5.352, 96.715]
										],
										c: !0
									}]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}, {
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 2,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 11,
			ty: 3,
			nm: "smile",
			parent: 12,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 10.417,
							s: [
								-2.086,
								-8.572,
								0
							],
							to: [
								.165,
								-4.856,
								0
							],
							ti: [
								.008,
								-1,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 14.583,
							s: [
								-1.097,
								-37.71,
								0
							],
							to: [
								-.008,
								1,
								0
							],
							ti: [
								.165,
								-4.856,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 18.75,
							s: [
								-2.136,
								-2.572,
								0
							],
							to: [
								-.165,
								4.856,
								0
							],
							ti: [
								-.008,
								1,
								0
							]
						},
						{
							i: {
								x: .667,
								y: .667
							},
							o: {
								x: .167,
								y: .167
							},
							t: 22.917,
							s: [
								-2.086,
								-8.572,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 45.833,
							s: [
								-2.086,
								-8.572,
								0
							],
							to: [
								.165,
								-4.856,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 50,
							s: [
								-1.097,
								-37.71,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								.165,
								-4.856,
								0
							]
						},
						{
							t: 56.25,
							s: [
								-2.086,
								-8.572,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						551.208,
						504.728,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			ip: 8.33333333333333,
			op: 54.1666666666667,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 12,
			ty: 4,
			nm: "secondaryAnimationClass",
			parent: 2,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 8.333,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 14.583,
							s: [2]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 20.833,
							s: [0]
						},
						{
							t: 43.75,
							s: [0]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .452,
								y: .874
							},
							o: {
								x: .351,
								y: 0
							},
							t: 8.333,
							s: [
								13.294,
								-222.701,
								0
							],
							to: [
								-.064,
								-14.021,
								0
							],
							ti: [
								.05,
								10.34,
								0
							]
						},
						{
							i: {
								x: .645,
								y: 1
							},
							o: {
								x: .313,
								y: .649
							},
							t: 12,
							s: [
								12.883,
								-313.345,
								0
							],
							to: [
								-.005,
								-.967,
								0
							],
							ti: [
								0,
								-.1,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 12.5,
							s: [
								12.875,
								-314.69,
								0
							],
							to: [
								0,
								1.167,
								0
							],
							ti: [
								-.07,
								-15.332,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 16.667,
							s: [
								13.294,
								-215.701,
								0
							],
							to: [
								.07,
								15.332,
								0
							],
							ti: [
								0,
								1.167,
								0
							]
						},
						{
							i: {
								x: .667,
								y: .667
							},
							o: {
								x: .333,
								y: .333
							},
							t: 20.833,
							s: [
								13.294,
								-222.701,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .41,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 43.75,
							s: [
								13.294,
								-222.701,
								0
							],
							to: [
								-.07,
								-8.832,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 47.917,
							s: [
								12.875,
								-275.69,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								-.07,
								-8.832,
								0
							]
						},
						{
							t: 54.1669921875,
							s: [
								13.294,
								-222.701,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						0,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			hasMask: !0,
			masksProperties: [{
				inv: !1,
				mode: "a",
				pt: {
					a: 1,
					k: [
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 8.333,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.357, -218.303],
									[-201.443, -10.224],
									[-1.165, 86.316],
									[202.928, -22.262],
									[225.666, -199.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 9.583,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.357, -218.303],
									[-208.319, 7.305],
									[-1.016, 131.316],
									[205.665, -1.065],
									[225.666, -199.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 10.417,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.357, -218.303],
									[-217.29, 35.829],
									[-.916, 161.316],
									[208.1, 29.721],
									[225.666, -199.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 11.667,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.357, -218.303],
									[-205.547, 68.281],
									[.982, 166.583],
									[206.313, 55.107],
									[225.666, -199.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 12.5,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.357, -218.303],
									[-214.322, 67.695],
									[2.248, 170.095],
									[211.068, 61.587],
									[225.666, -199.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 14.583,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.357, -218.303],
									[-217.29, 35.829],
									[-.916, 161.316],
									[205.276, 17.888],
									[225.666, -199.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 16.667,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.357, -218.303],
									[-201.443, -10.224],
									[-1.165, 86.316],
									[202.928, -22.262],
									[225.666, -199.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 20.833,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.377, -207.303],
									[-201.463, .777],
									[-1.185, 97.316],
									[202.908, -11.262],
									[225.645, -188.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 43.75,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.377, -207.303],
									[-201.463, .777],
									[-1.185, 97.316],
									[202.908, -11.262],
									[225.645, -188.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 45.833,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.284, -201.803],
									[-209.293, 29.303],
									[-.968, 140.316],
									[204.175, 23.313],
									[218.738, -216.999]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 47.917,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.357, -218.303],
									[-217.29, 35.829],
									[-.916, 161.316],
									[207.276, 36.888],
									[225.666, -199.499]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 52.083,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.066, -221.803],
									[-209.076, 9.303],
									[-.75, 120.316],
									[204.392, 3.313],
									[218.956, -236.999]
								],
								c: !0
							}]
						},
						{
							t: 53.75,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[-190.066, -221.803],
									[-202.076, -1.697],
									[-1.75, 104.316],
									[203.392, -11.687],
									[218.956, -236.999]
								],
								c: !0
							}]
						}
					],
					ix: 1
				},
				o: {
					a: 0,
					k: 100,
					ix: 3
				},
				x: {
					a: 0,
					k: 0,
					ix: 4
				},
				nm: "Mask 1"
			}],
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[177.473, 182.933],
									[-177.473, 182.933],
									[-177.473, -182.933],
									[177.473, -182.933]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.811764705882,
								.662745098039,
								.529411764706,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 8.33333333333333,
			op: 54.1666666666667,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 13,
			ty: 4,
			nm: "paper fill",
			parent: 2,
			td: 1,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 8.333,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 14.583,
							s: [2]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 20.833,
							s: [0]
						},
						{
							t: 43.75,
							s: [0]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .41,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 8.333,
							s: [
								13.294,
								-222.701,
								0
							],
							to: [
								-.07,
								-15.332,
								0
							],
							ti: [
								0,
								-1.167,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 12.5,
							s: [
								12.875,
								-314.69,
								0
							],
							to: [
								0,
								1.167,
								0
							],
							ti: [
								-.07,
								-15.332,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 16.667,
							s: [
								13.294,
								-215.701,
								0
							],
							to: [
								.07,
								15.332,
								0
							],
							ti: [
								0,
								1.167,
								0
							]
						},
						{
							i: {
								x: .667,
								y: .667
							},
							o: {
								x: .333,
								y: .333
							},
							t: 20.833,
							s: [
								13.294,
								-222.701,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .41,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 43.75,
							s: [
								13.294,
								-222.701,
								0
							],
							to: [
								-.07,
								-8.832,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 47.917,
							s: [
								12.875,
								-275.69,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								-.07,
								-8.832,
								0
							]
						},
						{
							t: 54.1669921875,
							s: [
								13.294,
								-222.701,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						0,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[177.473, 182.933],
									[-177.473, 182.933],
									[-177.473, -182.933],
									[177.473, -182.933]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.713725507259,
								.776470601559,
								.858823537827,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 0,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 8.33333333333333,
			op: 54.1666666666667,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 14,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 2,
			tt: 2,
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [{
						i: {
							x: [.833],
							y: [.833]
						},
						o: {
							x: [.167],
							y: [.167]
						},
						t: 53.75,
						s: [100]
					}, {
						t: 54.1666666666667,
						s: [0]
					}],
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						7.568,
						-252.333,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-1,
						-93,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 6.25,
							s: [
								100,
								100,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 8.334,
							s: [
								100,
								-100,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 53.75,
							s: [
								100,
								-100,
								100
							]
						},
						{
							t: 54.1666666666667,
							s: [
								100,
								100,
								100
							]
						}
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 4.167,
									s: [{
										i: [
											[6.083, -2.502],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 6.767],
											[0, 0],
											[-8.827, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.083, -2.502],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.827, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[223.064, -42.39],
											[11.065, 90.216],
											[-11.065, 90.216],
											[-223.064, -42.39],
											[-233.139, -57.742],
											[-233.139, -76.656],
											[-217.156, -93.178],
											[217.156, -93.178],
											[233.139, -76.656],
											[233.139, -57.742]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .19,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 6.25,
									s: [{
										i: [
											[6.064, -1.351],
											[0, 0],
											[6.827, 2.133],
											[0, 0],
											[0, 3.655],
											[0, 0],
											[-8.801, 0],
											[0, 0],
											[0, -4.929],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.827, 2.133],
											[0, 0],
											[-6.064, -1.351],
											[0, 0],
											[0, -4.929],
											[0, 0],
											[8.801, 0],
											[0, 0],
											[0, 3.655]
										],
										v: [
											[222.514, -71.929],
											[10.748, -46.3],
											[-11.314, -46.3],
											[-222.27, -71.929],
											[-232.315, -80.221],
											[-232.441, -84.938],
											[-216.506, -93.863],
											[216.497, -93.863],
											[232.432, -84.938],
											[232.559, -80.221]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .833,
										y: .833
									},
									o: {
										x: .65,
										y: 0
									},
									t: 10.417,
									s: [{
										i: [
											[6.533, -5.441],
											[0, 0],
											[6.848, 3.949],
											[6.645, 6.179],
											[0, 6.767],
											[0, 0],
											[-8.671, 0],
											[0, 0],
											[0, -9.125],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-6.645, -6.179],
											[0, 0],
											[0, -9.125],
											[0, 0],
											[8.671, 0],
											[0, 0],
											[0, 6.767]
										],
										v: [
											[212.792, -35.16],
											[10.698, 120.216],
											[-11.432, 120.216],
											[-219.216, -39.892],
											[-229.003, -57.742],
											[-222.132, -111.372],
											[-206.431, -127.895],
											[213.732, -129.178],
											[221.177, -107.011],
											[224.318, -53.443]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .167,
										y: .167
									},
									t: 12.5,
									s: [{
										i: [
											[5.955, -3.086],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 8.347],
											[0, 0],
											[-8.642, 0],
											[0, 0],
											[0, -11.256],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-5.955, -3.086],
											[0, 0],
											[0, -11.256],
											[0, 0],
											[8.642, 0],
											[0, 0],
											[0, 8.347]
										],
										v: [
											[218.385, -42.39],
											[10.806, 111.355],
											[-11.323, 111.355],
											[-218.38, -42.39],
											[-228.244, -61.327],
											[-221.903, -110.709],
											[-212.299, -130.405],
											[212.898, -130.405],
											[222.449, -108.341],
											[228.249, -61.327]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 14.584,
									s: [{
										i: [
											[5.908, -4.479],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 12.118],
											[0, 0],
											[-8.573, 0],
											[0, 0],
											[0, -16.34],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-5.908, -4.479],
											[0, 0],
											[0, -16.34],
											[0, 0],
											[8.573, 0],
											[0, 0],
											[0, 12.118]
										],
										v: [
											[216.647, -42.39],
											[11.065, 90.216],
											[-11.065, 90.216],
											[-216.647, -42.39],
											[-226.432, -69.88],
											[-226.432, -103.748],
											[-210.908, -133.333],
											[210.908, -133.333],
											[226.432, -103.748],
											[226.432, -69.88]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 50,
									s: [{
										i: [
											[5.908, -4.479],
											[0, 0],
											[6.848, 3.949],
											[0, 0],
											[0, 12.118],
											[0, 0],
											[-8.573, 0],
											[0, 0],
											[0, -16.34],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.848, 3.949],
											[0, 0],
											[-5.908, -4.479],
											[0, 0],
											[0, -16.34],
											[0, 0],
											[8.573, 0],
											[0, 0],
											[0, 12.118]
										],
										v: [
											[216.647, -42.39],
											[11.065, 90.216],
											[-11.065, 90.216],
											[-216.647, -42.39],
											[-226.432, -69.88],
											[-226.432, -103.748],
											[-210.908, -133.333],
											[210.908, -133.333],
											[226.432, -103.748],
											[226.432, -69.88]
										],
										c: !0
									}]
								},
								{
									t: 54.1666666666667,
									s: [{
										i: [
											[6.064, -1.351],
											[0, 0],
											[6.827, 2.133],
											[0, 0],
											[0, 3.655],
											[0, 0],
											[-8.801, 0],
											[0, 0],
											[0, -4.929],
											[0, 0]
										],
										o: [
											[0, 0],
											[-6.827, 2.133],
											[0, 0],
											[-6.064, -1.351],
											[0, 0],
											[0, -4.929],
											[0, 0],
											[8.801, 0],
											[0, 0],
											[0, 3.655]
										],
										v: [
											[222.514, -71.929],
											[10.748, -46.3],
											[-11.314, -46.3],
											[-222.27, -71.929],
											[-232.315, -80.221],
											[-232.441, -84.938],
											[-216.506, -93.863],
											[216.497, -93.863],
											[232.432, -84.938],
											[232.559, -80.221]
										],
										c: !0
									}]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}, {
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 8.334,
							s: [0]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 10.417,
							s: [1]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 12.5,
							s: [0]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 50,
							s: [0]
						},
						{
							t: 52.0836588541667,
							s: [0]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 6.25,
							s: [100]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 8.334,
							s: [54]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 10.417,
							s: [56]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 50,
							s: [56]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 52.084,
							s: [54]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 53.75,
							s: [54]
						},
						{
							t: 54.1666666666667,
							s: [100]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 8.334,
							s: [-14]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 10.417,
							s: [-20]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 50,
							s: [-20]
						},
						{
							t: 52.0836588541667,
							s: [-14]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: !1
			}],
			ip: 8.33333333333333,
			op: 58,
			st: 4.16666666666667,
			bm: 0
		}
	],
	markers: []
}, Pl = {
	v: "5.9.0",
	fr: 25,
	ip: 0,
	op: 58,
	w: 1080,
	h: 1080,
	nm: "Paper",
	ddd: 0,
	assets: [],
	layers: [
		{
			ddd: 0,
			ind: 1,
			ty: 4,
			nm: "secondaryAnimationClass",
			parent: 9,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: -1109.603,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						724.389,
						718.744,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-5,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						69.058,
						69.058,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[26.208, -40],
									[.057, -12.552],
									[-26.095, -40],
									[-48.261, -40],
									[-11.111, -.837],
									[-50, 40],
									[-27.834, 40],
									[-.112, 10.822],
									[27.553, 40],
									[50, 40],
									[11.11, -.892],
									[48.26, -40]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								.811764765721,
								.662745098039,
								.529411764706,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [12.25, -56.75],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [72, 72],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 3,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 9,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 0,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 4.167,
							s: [-3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 6.25,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 10.417,
							s: [-3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 16.667,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 20.833,
							s: [-10]
						},
						{
							t: 29.1669921875,
							s: [0]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .649,
								y: 1
							},
							o: {
								x: .302,
								y: 0
							},
							t: 0,
							s: [
								491.61,
								519.121,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .671,
								y: .976
							},
							o: {
								x: .334,
								y: 0
							},
							t: 4.167,
							s: [
								499.86,
								530.121,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .676,
								y: .815
							},
							o: {
								x: .341,
								y: .118
							},
							t: 6.25,
							s: [
								522.956,
								499.416,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .675,
								y: .494
							},
							o: {
								x: .34,
								y: .126
							},
							t: 10.417,
							s: [
								530.583,
								513.673,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								5.315,
								-1.989,
								0
							]
						},
						{
							i: {
								x: .821,
								y: 1
							},
							o: {
								x: .441,
								y: .323
							},
							t: 12,
							s: [
								521.73,
								516.878,
								0
							],
							to: [
								-17.781,
								6.652,
								0
							],
							ti: [
								-8.334,
								-7.297,
								0
							]
						},
						{
							i: {
								x: .16,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 16.667,
							s: [
								474.61,
								546.121,
								0
							],
							to: [
								37.5,
								32.833,
								0
							],
							ti: [
								8,
								48.167,
								0
							]
						},
						{
							i: {
								x: .16,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 29.167,
							s: [
								554.86,
								499.871,
								0
							],
							to: [
								-.107,
								-.944,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .833,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 54.167,
							s: [
								554.86,
								499.871,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							t: 58.3330078125,
							s: [
								491.61,
								519.121,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						554.11,
						501.621,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [-14.936, -18.982]],
									o: [[0, 0], [14.936, 18.982]],
									v: [[-20.759, -7.828], [20.759, 8.021]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [569.836, 466.575],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 1",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									o: [
										[-7.024, -6.59],
										[0, 0],
										[0, 0]
									],
									v: [
										[7.024, -3.269],
										[-7.024, -9.859],
										[-7.024, 9.859]
									],
									c: !0
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "fl",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 4
							},
							o: {
								a: 0,
								k: 100,
								ix: 5
							},
							r: 1,
							bm: 0,
							nm: "Fill 1",
							mn: "ADBE Vector Graphic - Fill",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [562.812, 491.608],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 2",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[-27.148, -11.081],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-10.922, -10.088]
									],
									o: [
										[0, 0],
										[27.148, 11.081],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[12.748, 11.774]
									],
									v: [
										[34.219, -134.613],
										[67.354, -154.44],
										[75.68, -119.814],
										[-40.515, 126.975],
										[-74.889, 156.839],
										[-82.033, 111.126],
										[34.219, -134.613],
										[63.64, -125.406]
									],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [631.11, 347.621],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 3",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 4,
			ty: 4,
			nm: "pencil matte",
			parent: 9,
			td: 1,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 0,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 4.167,
							s: [-3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 6.25,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 10.417,
							s: [-3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 16.667,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 20.833,
							s: [-10]
						},
						{
							t: 29.1669921875,
							s: [0]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .649,
								y: 1
							},
							o: {
								x: .302,
								y: 0
							},
							t: 0,
							s: [
								491.61,
								519.121,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .671,
								y: .976
							},
							o: {
								x: .334,
								y: 0
							},
							t: 4.167,
							s: [
								499.86,
								530.121,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .676,
								y: .815
							},
							o: {
								x: .341,
								y: .118
							},
							t: 6.25,
							s: [
								522.956,
								499.416,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .833,
								y: 1
							},
							o: {
								x: .431,
								y: .087
							},
							t: 10.417,
							s: [
								530.583,
								513.673,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								-10.825,
								-9.478,
								0
							]
						},
						{
							i: {
								x: .16,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 16.667,
							s: [
								474.61,
								546.121,
								0
							],
							to: [
								37.5,
								32.833,
								0
							],
							ti: [
								8,
								48.167,
								0
							]
						},
						{
							i: {
								x: .16,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 29.167,
							s: [
								554.86,
								499.871,
								0
							],
							to: [
								-.107,
								-.944,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .833,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 54.167,
							s: [
								554.86,
								499.871,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							t: 58.3330078125,
							s: [
								491.61,
								519.121,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						554.11,
						501.621,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [-14.936, -18.982]],
									o: [[0, 0], [14.936, 18.982]],
									v: [[-20.759, -7.828], [20.759, 8.021]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [569.836, 466.575],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 1",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									o: [
										[-7.024, -6.59],
										[0, 0],
										[0, 0]
									],
									v: [
										[7.024, -3.269],
										[-7.024, -9.859],
										[-7.024, 9.859]
									],
									c: !0
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "fl",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 4
							},
							o: {
								a: 0,
								k: 100,
								ix: 5
							},
							r: 1,
							bm: 0,
							nm: "Fill 1",
							mn: "ADBE Vector Graphic - Fill",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [562.812, 491.608],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 2",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[-27.148, -11.081],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-10.922, -10.088]
									],
									o: [
										[0, 0],
										[27.148, 11.081],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[12.748, 11.774]
									],
									v: [
										[34.219, -134.613],
										[67.354, -154.44],
										[75.68, -119.814],
										[-40.515, 126.975],
										[-74.889, 156.839],
										[-82.033, 111.126],
										[34.219, -134.613],
										[63.64, -125.406]
									],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "fl",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 4
							},
							o: {
								a: 0,
								k: 100,
								ix: 5
							},
							r: 1,
							bm: 0,
							nm: "Fill 1",
							mn: "ADBE Vector Graphic - Fill",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [631.11, 347.621],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 3",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 5,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 9,
			tt: 2,
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [{
						i: {
							x: [.833],
							y: [.833]
						},
						o: {
							x: [.167],
							y: [.167]
						},
						t: 52.083,
						s: [100]
					}, {
						t: 58.3330078125,
						s: [0]
					}],
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						517.173,
						534.658,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						517.173,
						534.658,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[-33.264, 18.315],
										[0, 0]
									],
									o: [
										[0, 0],
										[33.264, -18.315],
										[0, 0]
									],
									v: [
										[-41.284, 13.23],
										[16.971, 21.615],
										[39.7, -28.034]
									],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "tm",
							s: {
								a: 1,
								k: [{
									i: {
										x: [.667],
										y: [1]
									},
									o: {
										x: [.333],
										y: [0]
									},
									t: 16.667,
									s: [0]
								}, {
									t: 25,
									s: [100]
								}],
								ix: 1
							},
							e: {
								a: 0,
								k: 0,
								ix: 2
							},
							o: {
								a: 0,
								k: 0,
								ix: 3
							},
							m: 1,
							ix: 2,
							nm: "Trim Paths 1",
							mn: "ADBE Vector Filter - Trim",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [517.173, 534.658],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 1",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[-3.443, -5.548], [3.443, 5.548]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "tm",
							s: {
								a: 1,
								k: [
									{
										i: {
											x: [.833],
											y: [.833]
										},
										o: {
											x: [.167],
											y: [.167]
										},
										t: 6.25,
										s: [0]
									},
									{
										i: {
											x: [.833],
											y: [.833]
										},
										o: {
											x: [.167],
											y: [.167]
										},
										t: 8.333,
										s: [29]
									},
									{
										t: 10.4169921875,
										s: [100]
									}
								],
								ix: 1
							},
							e: {
								a: 0,
								k: 0,
								ix: 2
							},
							o: {
								a: 0,
								k: 0,
								ix: 3
							},
							m: 1,
							ix: 2,
							nm: "Trim Paths 1",
							mn: "ADBE Vector Filter - Trim",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [528.883, 512.172],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 2",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[-3.27, -5.27], [3.27, 5.27]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "tm",
							s: {
								a: 1,
								k: [{
									i: {
										x: [.833],
										y: [.833]
									},
									o: {
										x: [.167],
										y: [.167]
									},
									t: 0,
									s: [0]
								}, {
									t: 4.1669921875,
									s: [100]
								}],
								ix: 1
							},
							e: {
								a: 0,
								k: 0,
								ix: 2
							},
							o: {
								a: 0,
								k: 0,
								ix: 3
							},
							m: 1,
							ix: 2,
							nm: "Trim Paths 1",
							mn: "ADBE Vector Filter - Trim",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [497.354, 528.422],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 3",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 6,
			ty: 4,
			nm: "pencil matte 3",
			parent: 9,
			td: 1,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 0,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 4.167,
							s: [-3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 6.25,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 10.417,
							s: [-3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 16.667,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 20.833,
							s: [-10]
						},
						{
							t: 29.1669921875,
							s: [0]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .649,
								y: 1
							},
							o: {
								x: .302,
								y: 0
							},
							t: 0,
							s: [
								491.61,
								519.121,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .671,
								y: .976
							},
							o: {
								x: .334,
								y: 0
							},
							t: 4.167,
							s: [
								499.86,
								530.121,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .676,
								y: .815
							},
							o: {
								x: .341,
								y: .118
							},
							t: 6.25,
							s: [
								522.956,
								499.416,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .833,
								y: 1
							},
							o: {
								x: .431,
								y: .087
							},
							t: 10.417,
							s: [
								530.583,
								513.673,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								-10.825,
								-9.478,
								0
							]
						},
						{
							i: {
								x: .16,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 16.667,
							s: [
								474.61,
								546.121,
								0
							],
							to: [
								37.5,
								32.833,
								0
							],
							ti: [
								8,
								48.167,
								0
							]
						},
						{
							i: {
								x: .16,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 29.167,
							s: [
								554.86,
								499.871,
								0
							],
							to: [
								-.107,
								-.944,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .833,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 54.167,
							s: [
								554.86,
								499.871,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							t: 58.3330078125,
							s: [
								491.61,
								519.121,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						554.11,
						501.621,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [-14.936, -18.982]],
									o: [[0, 0], [14.936, 18.982]],
									v: [[-20.759, -7.828], [20.759, 8.021]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [569.836, 466.575],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 1",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									o: [
										[-7.024, -6.59],
										[0, 0],
										[0, 0]
									],
									v: [
										[7.024, -3.269],
										[-7.024, -9.859],
										[-7.024, 9.859]
									],
									c: !0
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "fl",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 4
							},
							o: {
								a: 0,
								k: 100,
								ix: 5
							},
							r: 1,
							bm: 0,
							nm: "Fill 1",
							mn: "ADBE Vector Graphic - Fill",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [562.812, 491.608],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 2",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[-27.148, -11.081],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-10.922, -10.088]
									],
									o: [
										[0, 0],
										[27.148, 11.081],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[12.748, 11.774]
									],
									v: [
										[34.219, -134.613],
										[67.354, -154.44],
										[75.68, -119.814],
										[-40.515, 126.975],
										[-74.889, 156.839],
										[-82.033, 111.126],
										[34.219, -134.613],
										[63.64, -125.406]
									],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "fl",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 4
							},
							o: {
								a: 0,
								k: 100,
								ix: 5
							},
							r: 1,
							bm: 0,
							nm: "Fill 1",
							mn: "ADBE Vector Graphic - Fill",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [631.11, 347.621],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 3",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 7,
			ty: 4,
			nm: "secondaryAnimationClass",
			parent: 9,
			tt: 2,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						542.769,
						573.407,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						542.769,
						573.407,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[-81.069, 44.621], [21.609, -10.777]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [634.376, 708.9],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 1",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[-85.768, 41.412], [85.768, -41.412]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [583.006, 638.345],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 2",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[-87.834, 41.412], [87.834, -41.412]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [539.836, 570.208],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 3",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[-87.834, 41.412], [87.834, -41.412]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [495.172, 498.516],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 4",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 4,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[-87.834, 41.412], [87.834, -41.412]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [456.427, 434.715],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 5",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 5,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 8,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 9,
			td: 1,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 0,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 4.167,
							s: [-3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 6.25,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 10.417,
							s: [-3]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 16.667,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 20.833,
							s: [-10]
						},
						{
							t: 29.1669921875,
							s: [0]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .649,
								y: 1
							},
							o: {
								x: .302,
								y: 0
							},
							t: 0,
							s: [
								491.61,
								519.121,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .671,
								y: .976
							},
							o: {
								x: .334,
								y: 0
							},
							t: 4.167,
							s: [
								499.86,
								530.121,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .676,
								y: .815
							},
							o: {
								x: .341,
								y: .118
							},
							t: 6.25,
							s: [
								522.956,
								499.416,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .833,
								y: 1
							},
							o: {
								x: .431,
								y: .087
							},
							t: 10.417,
							s: [
								530.583,
								513.673,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								-10.825,
								-9.478,
								0
							]
						},
						{
							i: {
								x: .16,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 16.667,
							s: [
								474.61,
								546.121,
								0
							],
							to: [
								37.5,
								32.833,
								0
							],
							ti: [
								8,
								48.167,
								0
							]
						},
						{
							i: {
								x: .16,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 29.167,
							s: [
								554.86,
								499.871,
								0
							],
							to: [
								-.107,
								-.944,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .833,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 54.167,
							s: [
								554.86,
								499.871,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							t: 58.3330078125,
							s: [
								491.61,
								519.121,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						554.11,
						501.621,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [-14.936, -18.982]],
									o: [[0, 0], [14.936, 18.982]],
									v: [[-20.759, -7.828], [20.759, 8.021]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [569.836, 466.575],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 1",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									o: [
										[-7.024, -6.59],
										[0, 0],
										[0, 0]
									],
									v: [
										[7.024, -3.269],
										[-7.024, -9.859],
										[-7.024, 9.859]
									],
									c: !0
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "fl",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 4
							},
							o: {
								a: 0,
								k: 100,
								ix: 5
							},
							r: 1,
							bm: 0,
							nm: "Fill 1",
							mn: "ADBE Vector Graphic - Fill",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [562.812, 491.608],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 2",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[-27.148, -11.081],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[-10.922, -10.088]
									],
									o: [
										[0, 0],
										[27.148, 11.081],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
										[12.748, 11.774]
									],
									v: [
										[34.219, -134.613],
										[67.354, -154.44],
										[75.68, -119.814],
										[-40.515, 126.975],
										[-74.889, 156.839],
										[-82.033, 111.126],
										[34.219, -134.613],
										[63.64, -125.406]
									],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.176470592618,
									.219607844949,
									.286274522543,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "fl",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 4
							},
							o: {
								a: 0,
								k: 100,
								ix: 5
							},
							r: 1,
							bm: 0,
							nm: "Fill 1",
							mn: "ADBE Vector Graphic - Fill",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [631.11, 347.621],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 3",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 9,
			ty: 4,
			nm: "primaryAnimationClass",
			tt: 2,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 1,
					k: [
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 0,
							s: [-.397]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 4.167,
							s: [0]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 18.75,
							s: [-2]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 33.333,
							s: [0]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.333],
								y: [0]
							},
							t: 47.917,
							s: [-2]
						},
						{
							i: {
								x: [.667],
								y: [1]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 58.333,
							s: [-.397]
						},
						{
							t: 62.5,
							s: [0]
						}
					],
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .667,
								y: .738
							},
							o: {
								x: .333,
								y: 0
							},
							t: 0,
							s: [
								525.047,
								592.531,
								0
							],
							to: [
								0,
								3.09,
								0
							],
							ti: [
								0,
								-4.947,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: .621
							},
							t: 12,
							s: [
								525.047,
								613.618,
								0
							],
							to: [
								0,
								1.191,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 14.583,
							s: [
								525.047,
								615.531,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 29.167,
							s: [
								525.047,
								592.531,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 43.75,
							s: [
								525.047,
								615.531,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								3.833,
								0
							]
						},
						{
							t: 58.3330078125,
							s: [
								525.047,
								592.531,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						525.047,
						592.531,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[10.258, -5.745], [-11.489, 4.924]],
									o: [[-10.258, 5.745], [11.489, -4.924]],
									v: [[-4.45, -9.132], [4.167, 9.333]],
									c: !0
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [501.852, 788.603],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 1",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[10.258, -5.745], [-11.489, 4.924]],
									o: [[-10.258, 5.745], [11.489, -4.924]],
									v: [[-4.45, -9.132], [4.167, 9.333]],
									c: !0
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [416.666, 654.099],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 2",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[10.258, -5.745], [-11.489, 4.924]],
									o: [[-10.258, 5.745], [11.489, -4.924]],
									v: [[-4.45, -9.132], [4.167, 9.333]],
									c: !0
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [329.965, 515.765],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 3",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[-104.301, -165.188], [104.301, 165.188]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [430.954, 630.779],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 4",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 4,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0]
									],
									v: [
										[-256.661, -127.308],
										[-16.361, 262.285],
										[256.661, 107.879],
										[17.383, -262.285]
									],
									c: !0
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 8,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [525.047, 592.531],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 5",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 5,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 58,
			st: 0,
			bm: 0
		}
	],
	markers: []
}, Fl = {
	v: "5.9.0",
	fr: 25,
	ip: 0,
	op: 56,
	w: 1080,
	h: 1080,
	nm: "Champagne ",
	ddd: 0,
	assets: [],
	layers: [
		{
			ddd: 0,
			ind: 2,
			ty: 4,
			nm: "primaryAnimationClass",
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 27.084,
							s: [0]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 28.125,
							s: [100]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 34.375,
							s: [100]
						},
						{
							t: 35.4166666666667,
							s: [0]
						}
					],
					ix: 11
				},
				r: {
					a: 0,
					k: 2.371,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						593.001,
						268.924,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-66.831,
						-7.998,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 1,
					k: [{
						i: {
							x: [
								.667,
								.667,
								.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								.167,
								.167,
								.167
							],
							y: [
								.167,
								.167,
								0
							]
						},
						t: 28.125,
						s: [
							43.403,
							43.403,
							100
						]
					}, {
						t: 34.3746744791667,
						s: [
							84.132,
							84.132,
							100
						]
					}],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [117.697, 117.697],
							ix: 2
						},
						p: {
							a: 0,
							k: [0, 0],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.713725490196,
								.776470588235,
								.858823529412,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 1,
							k: [{
								i: {
									x: [.833],
									y: [.833]
								},
								o: {
									x: [.39],
									y: [.292]
								},
								t: 28.125,
								s: [18]
							}, {
								t: 34.3746744791667,
								s: [10]
							}],
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 0,
									k: 0,
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 0,
									k: 62,
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 0,
									k: 0,
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [-66.806, -2.095],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 16.6666666666667,
			op: 35.4166666666667,
			st: 13.5416666666667,
			bm: 0
		},
		{
			ddd: 0,
			ind: 3,
			ty: 4,
			nm: "primaryAnimationClass",
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 19.792,
							s: [0]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 20.834,
							s: [100]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 28.125,
							s: [100]
						},
						{
							t: 29.1666666666667,
							s: [0]
						}
					],
					ix: 11
				},
				r: {
					a: 0,
					k: 2.371,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						208.001,
						474.924,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-66.831,
						-7.998,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 1,
					k: [{
						i: {
							x: [
								.667,
								.667,
								.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								.167,
								.167,
								.167
							],
							y: [
								.167,
								.167,
								0
							]
						},
						t: 20.834,
						s: [
							43.403,
							43.403,
							100
						]
					}, {
						t: 28.1246744791667,
						s: [
							84.132,
							84.132,
							100
						]
					}],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [117.697, 117.697],
							ix: 2
						},
						p: {
							a: 0,
							k: [0, 0],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 1,
							k: [{
								i: {
									x: [.833],
									y: [.833]
								},
								o: {
									x: [.39],
									y: [.341]
								},
								t: 20.834,
								s: [18]
							}, {
								t: 28.1246744791667,
								s: [10]
							}],
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 0,
									k: 0,
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 0,
									k: 62,
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 0,
									k: 0,
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [-66.806, -2.095],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 10.4166666666667,
			op: 29.1666666666667,
			st: 7.29166666666667,
			bm: 0
		},
		{
			ddd: 0,
			ind: 4,
			ty: 4,
			nm: "secondaryAnimationClass",
			parent: 12,
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 12,
							s: [0]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 14,
							s: [100]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 17.708,
							s: [100]
						},
						{
							t: 18.75,
							s: [0]
						}
					],
					ix: 11
				},
				r: {
					a: 0,
					k: 46.371,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						170.404,
						-855.928,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-66.831,
						-7.998,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 1,
					k: [{
						i: {
							x: [
								.667,
								.667,
								.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								.167,
								.167,
								.167
							],
							y: [
								.167,
								.167,
								0
							]
						},
						t: 10.417,
						s: [
							43.403,
							43.403,
							100
						]
					}, {
						t: 17.7080078125,
						s: [
							84.132,
							84.132,
							100
						]
					}],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [117.697, 117.697],
							ix: 2
						},
						p: {
							a: 0,
							k: [0, 0],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.811764705882,
								.662745098039,
								.529411764706,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 1,
							k: [{
								i: {
									x: [.833],
									y: [.833]
								},
								o: {
									x: [.39],
									y: [.341]
								},
								t: 10.417,
								s: [18]
							}, {
								t: 17.7080078125,
								s: [10]
							}],
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						d: [
							{
								n: "d",
								nm: "dash",
								v: {
									a: 0,
									k: 0,
									ix: 1
								}
							},
							{
								n: "g",
								nm: "gap",
								v: {
									a: 0,
									k: 62,
									ix: 2
								}
							},
							{
								n: "o",
								nm: "offset",
								v: {
									a: 0,
									k: 0,
									ix: 7
								}
							}
						],
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [-66.806, -2.095],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 18.75,
			st: -3.125,
			bm: 0
		},
		{
			ddd: 0,
			ind: 5,
			ty: 4,
			nm: "secondaryAnimationClass",
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						189.354,
						353.75,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						78.354,
						-155.25,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 12.5,
							s: [
								0,
								0,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 14.584,
							s: [
								100,
								100,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 43.75,
							s: [
								100,
								100,
								100
							]
						},
						{
							t: 45.8336588541667,
							s: [
								0,
								0,
								100
							]
						}
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 12.5,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 16.667,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 20.834,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 25,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 29.167,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 33.334,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 37.5,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 41.667,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 45.834,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 50,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									t: 54.1666666666667,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								.811764705882,
								.662745098039,
								.529411764706,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 56,
			st: -2.08333333333333,
			bm: 0
		},
		{
			ddd: 0,
			ind: 6,
			ty: 4,
			nm: "primaryAnimationClass",
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						618.354,
						384.75,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						78.354,
						-155.25,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 14.583,
							s: [
								0,
								0,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 16.667,
							s: [
								100,
								100,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 45.833,
							s: [
								100,
								100,
								100
							]
						},
						{
							t: 47.9169921875,
							s: [
								0,
								0,
								100
							]
						}
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 14.583,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 18.75,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 22.917,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 27.083,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 31.25,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 35.417,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 39.583,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 43.75,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 47.917,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								},
								{
									i: {
										x: .667,
										y: 1
									},
									o: {
										x: .333,
										y: 0
									},
									t: 52.083,
									s: [{
										i: [
											[0, 0],
											[10.095, -16.574],
											[-17.463, -16.133],
											[-.675, 1.327]
										],
										o: [
											[0, 0],
											[1.997, -.65],
											[-5.458, -22.698],
											[-15.314, 5.205]
										],
										v: [
											[60.153, -179.301],
											[59.826, -139.327],
											[93.278, -129.726],
											[96.888, -165.342]
										],
										c: !0
									}]
								},
								{
									t: 56.25,
									s: [{
										i: [
											[0, 0],
											[7.5, -12.5],
											[-13.25, -12],
											[-.5, 1]
										],
										o: [
											[0, 0],
											[1.5, -.5],
											[-4.25, -17],
											[-11.5, 4]
										],
										v: [
											[64.5, -173],
											[64.5, -143],
											[89.75, -136],
											[92.25, -162.75]
										],
										c: !0
									}]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [0, 0],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 56,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 7,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 12,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 50,
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: 0,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 10.417,
							s: [
								44.127,
								-468.05,
								0
							],
							to: [
								6.285,
								-68.71,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: 0,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 16.667,
							s: [
								81.839,
								-880.307,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								.393,
								-4.486,
								0
							]
						},
						{
							i: {
								x: 0,
								y: 0
							},
							o: {
								x: .167,
								y: .167
							},
							t: 18.75,
							s: [
								79.48,
								-853.392,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: .833,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 41.667,
							s: [
								79.48,
								-853.392,
								0
							],
							to: [
								-5.892,
								64.224,
								0
							],
							ti: [
								5.892,
								-64.224,
								0
							]
						},
						{
							t: 47.9169921875,
							s: [
								44.127,
								-468.05,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						330.357,
						285.91,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			hasMask: !0,
			masksProperties: [{
				inv: !1,
				mode: "a",
				pt: {
					a: 1,
					k: [
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 10.417,
							s: [{
								i: [
									[0, 0],
									[-6.995, -1.296],
									[.016, 9.853],
									[0, 0]
								],
								o: [
									[0, 0],
									[6.995, 1.296],
									[-.016, -9.853],
									[0, 0]
								],
								v: [
									[254.395, 240.984],
									[306.908, 286.936],
									[335.999, 266.605],
									[316.82, 200.484]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 12.5,
							s: [{
								i: [
									[0, 0],
									[-6.995, -1.296],
									[.016, 9.853],
									[0, 0]
								],
								o: [
									[0, 0],
									[6.995, 1.296],
									[-.016, -9.853],
									[0, 0]
								],
								v: [
									[254.395, 240.984],
									[313.944, 310.832],
									[362.169, 276.423],
									[316.82, 200.484]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 45.833,
							s: [{
								i: [
									[0, 0],
									[-6.995, -1.296],
									[.016, 9.853],
									[0, 0]
								],
								o: [
									[0, 0],
									[6.995, 1.296],
									[-.016, -9.853],
									[0, 0]
								],
								v: [
									[254.395, 240.984],
									[313.944, 310.832],
									[362.169, 276.423],
									[316.82, 200.484]
								],
								c: !0
							}]
						},
						{
							t: 47.9169921875,
							s: [{
								i: [
									[0, 0],
									[-6.995, -1.296],
									[.016, 9.853],
									[0, 0]
								],
								o: [
									[0, 0],
									[6.995, 1.296],
									[-.016, -9.853],
									[0, 0]
								],
								v: [
									[254.395, 240.984],
									[306.908, 286.936],
									[335.999, 266.605],
									[316.82, 200.484]
								],
								c: !0
							}]
						}
					],
					ix: 1
				},
				o: {
					a: 0,
					k: 100,
					ix: 3
				},
				x: {
					a: 0,
					k: 0,
					ix: 4
				},
				nm: "Mask 1"
			}],
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [[0, 0], [-8.453, 7.461]],
								o: [[0, 0], [0, 0]],
								v: [[-7.575, 1.082], [7.575, -2.231]],
								c: !1
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [285.709, 246.774],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}, {
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[0, 0],
									[3.627, 3.834],
									[0, 0],
									[-7.843, 6.035],
									[-1.898, -1.898]
								],
								o: [
									[-.495, 16.563],
									[0, 0],
									[0, 0],
									[7.843, -6.035],
									[1.898, 1.898]
								],
								v: [
									[30.463, 12.785],
									[7.706, 30.446],
									[-30.223, -13.055],
									[-24.422, -27.169],
									[-7.614, -30.15]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 11,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [308.357, 260.91],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [100, 100],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 56,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 8,
			ty: 4,
			nm: "secondaryAnimationClass",
			parent: 11,
			sr: 1,
			ks: {
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 11,
							s: [0]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 12,
							s: [100]
						},
						{
							i: {
								x: [.833],
								y: [.833]
							},
							o: {
								x: [.167],
								y: [.167]
							},
							t: 45.833,
							s: [100]
						},
						{
							t: 47.9169921875,
							s: [0]
						}
					],
					ix: 11
				},
				r: {
					a: 0,
					k: 0,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						462.034,
						454.113,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						-77.966,
						-86.887,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 14.583,
										s: [{
											i: [[4.24, -3.23], [-4.038, 3.634]],
											o: [[-4.239, 3.23], [4.038, -3.634]],
											v: [[-244.512, -287.712], [-239.465, -281.656]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 18.75,
										s: [{
											i: [[7.582, -5.193], [-7.221, 5.842]],
											o: [[-7.582, 5.193], [7.221, -5.842]],
											v: [[-246.422, -289.675], [-237.396, -279.939]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 22.917,
										s: [{
											i: [[4.24, -3.23], [-4.038, 3.634]],
											o: [[-4.239, 3.23], [4.038, -3.634]],
											v: [[-244.512, -287.712], [-239.465, -281.656]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 27.083,
										s: [{
											i: [[7.582, -5.193], [-7.221, 5.842]],
											o: [[-7.582, 5.193], [7.221, -5.842]],
											v: [[-246.422, -289.675], [-237.396, -279.939]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 31.25,
										s: [{
											i: [[4.24, -3.23], [-4.038, 3.634]],
											o: [[-4.239, 3.23], [4.038, -3.634]],
											v: [[-244.512, -287.712], [-239.465, -281.656]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 35.417,
										s: [{
											i: [[7.582, -5.193], [-7.221, 5.842]],
											o: [[-7.582, 5.193], [7.221, -5.842]],
											v: [[-246.422, -289.675], [-237.396, -279.939]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 39.583,
										s: [{
											i: [[4.24, -3.23], [-4.038, 3.634]],
											o: [[-4.239, 3.23], [4.038, -3.634]],
											v: [[-244.512, -287.712], [-239.465, -281.656]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 43.75,
										s: [{
											i: [[7.582, -5.193], [-7.221, 5.842]],
											o: [[-7.582, 5.193], [7.221, -5.842]],
											v: [[-246.422, -289.675], [-237.396, -279.939]],
											c: !0
										}]
									},
									{
										t: 47.9169921875,
										s: [{
											i: [[4.24, -3.23], [-4.038, 3.634]],
											o: [[-4.239, 3.23], [4.038, -3.634]],
											v: [[-244.512, -287.712], [-239.465, -281.656]],
											c: !0
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 1,
							lj: 1,
							ml: 4,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [28.57, 90.656],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [99.954, 99.928],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Shape 4",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 12.5,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 16.667,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 20.833,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 25,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 29.167,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 33.333,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 37.5,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 41.667,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										t: 45.8330078125,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 1,
							lj: 1,
							ml: 4,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [-240.07, -65.707],
								ix: 2
							},
							a: {
								a: 0,
								k: [-229.883, -263.457],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Shape 8",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 14.583,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 18.75,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 22.917,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 27.083,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 31.25,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 35.417,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 39.583,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 43.75,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										t: 47.9169921875,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 1,
							lj: 1,
							ml: 4,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [-83.234, -372.533],
								ix: 2
							},
							a: {
								a: 0,
								k: [-229.883, -263.457],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Shape 7",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 8.333,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 12.5,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 16.667,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 20.833,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 25,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 29.167,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 33.333,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 37.5,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 41.667,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 45.833,
										s: [{
											i: [[3.071, -2.34], [-2.925, 2.632]],
											o: [[-3.071, 2.34], [2.925, -2.632]],
											v: [[-230.255, -265.34], [-226.599, -260.953]],
											c: !0
										}]
									},
									{
										t: 50,
										s: [{
											i: [[10.5, -8], [-10, 9]],
											o: [[-10.5, 8], [10, -9]],
											v: [[-234.5, -271], [-222, -256]],
											c: !0
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 1,
							lj: 1,
							ml: 4,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [-5.477, -9.82],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Shape 3",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 4,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 18.75,
										s: [{
											i: [[5.616, -7.489], [-4.581, 6.788]],
											o: [[-5.616, 7.489], [5.07, -7.511]],
											v: [[-100.599, -228.016], [-89.187, -220.709]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 22.917,
										s: [{
											i: [[7.328, -10.261], [-5.978, 9.301]],
											o: [[-7.328, 10.261], [6.615, -10.292]],
											v: [[-102.255, -229.239], [-87.365, -219.226]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 27.083,
										s: [{
											i: [[5.616, -7.489], [-4.581, 6.788]],
											o: [[-5.616, 7.489], [5.07, -7.511]],
											v: [[-100.599, -228.016], [-89.187, -220.709]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 31.25,
										s: [{
											i: [[7.328, -10.261], [-5.978, 9.301]],
											o: [[-7.328, 10.261], [6.615, -10.292]],
											v: [[-102.255, -229.239], [-87.365, -219.226]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 35.417,
										s: [{
											i: [[5.616, -7.489], [-4.581, 6.788]],
											o: [[-5.616, 7.489], [5.07, -7.511]],
											v: [[-100.599, -228.016], [-89.187, -220.709]],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 39.583,
										s: [{
											i: [[7.328, -10.261], [-5.978, 9.301]],
											o: [[-7.328, 10.261], [6.615, -10.292]],
											v: [[-102.255, -229.239], [-87.365, -219.226]],
											c: !0
										}]
									},
									{
										t: 43.75,
										s: [{
											i: [[5.616, -7.489], [-4.581, 6.788]],
											o: [[-5.616, 7.489], [5.07, -7.511]],
											v: [[-100.599, -228.016], [-89.187, -220.709]],
											c: !0
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 1,
							lj: 1,
							ml: 4,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [0, 0],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Shape 2",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 5,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 11.667,
										s: [{
											i: [
												[-11.218, -1.123],
												[-4.339, 12.597],
												[6.395, -9.564],
												[12.105, -3.266],
												[0, 0],
												[8.907, -5.365],
												[0, 0],
												[-4.796, -13.53],
												[-1.993, -.293]
											],
											o: [
												[1.227, .123],
												[10.04, -29.144],
												[-.228, .233],
												[-11.501, 3.103],
												[0, 0],
												[-8.907, 5.365],
												[0, 0],
												[4.796, 13.53],
												[20.996, 3.088]
											],
											v: [
												[-76.19, -88.813],
												[-63.98, -124.203],
												[-86.01, -146.665],
												[-102.065, -161.425],
												[-113.189, -146.531],
												[-133.725, -150.561],
												[-129.719, -129.768],
												[-137.379, -103.873],
												[-82.47, -85.898]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .833,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 14.583,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[31.341, -18.879],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-31.341, 18.879],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-40.767, -256.943],
												[-108.413, -300.145],
												[-162.74, -411.509],
												[-204.045, -306.711],
												[-315.659, -371.318],
												[-258.692, -258.284],
												[-327.517, -194.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 16.667,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[27.341, -24.314],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-36.341, 32.318],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-50.267, -216.943],
												[-109.413, -288.145],
												[-174.74, -375.509],
												[-209.545, -315.211],
												[-296.659, -342.318],
												[-262.192, -243.284],
												[-299.017, -174.298],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .833,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 18.75,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[53.74, -14.491],
												[0, 0],
												[32.341, -37.818],
												[0, 0],
												[-15.517, -34.798],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.471, 10.913],
												[0, 0],
												[-32.341, 37.818],
												[0, 0],
												[15.517, 34.798],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-44.767, -220.943],
												[-96.913, -300.145],
												[-180.74, -385.509],
												[-199.045, -318.711],
												[-303.659, -335.318],
												[-280.692, -230.284],
												[-308.517, -191.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 20.833,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[35.659, -28.682],
												[0, 0],
												[-15.192, -48.171],
												[-50.043, -29.675]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-60.444, 48.618],
												[0, 0],
												[19.017, 60.298],
												[64.229, 38.088]
											],
											v: [
												[-73.857, -96.585],
												[-43.267, -208.943],
												[-107.413, -291.145],
												[-174.74, -375.509],
												[-189.545, -306.211],
												[-304.659, -344.318],
												[-253.192, -222.284],
												[-309.017, -161.298],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 22.917,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[26.413, -30.855],
												[42.592, -11.491],
												[0, 0],
												[41.659, -28.682],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-62.163, 42.799],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-54.767, -214.943],
												[-103.413, -291.145],
												[-161.74, -390.509],
												[-198.045, -327.711],
												[-305.659, -344.318],
												[-261.692, -224.284],
												[-304.517, -180.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .833,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 25,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[31.341, -18.879],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-31.341, 18.879],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-53.767, -236.943],
												[-108.413, -300.145],
												[-180.74, -385.509],
												[-204.045, -306.711],
												[-295.659, -354.318],
												[-258.692, -258.284],
												[-308.517, -191.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 27.083,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[27.341, -24.314],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-36.341, 32.318],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-50.267, -216.943],
												[-109.413, -288.145],
												[-174.74, -375.509],
												[-209.545, -315.211],
												[-296.659, -342.318],
												[-262.192, -243.284],
												[-299.017, -174.298],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .833,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 29.167,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[53.74, -14.491],
												[0, 0],
												[32.341, -37.818],
												[0, 0],
												[-15.517, -34.798],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.471, 10.913],
												[0, 0],
												[-32.341, 37.818],
												[0, 0],
												[15.517, 34.798],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-44.767, -220.943],
												[-96.913, -300.145],
												[-180.74, -385.509],
												[-199.045, -318.711],
												[-303.659, -335.318],
												[-280.692, -230.284],
												[-308.517, -191.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 31.25,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[35.659, -28.682],
												[0, 0],
												[-15.192, -48.171],
												[-50.043, -29.675]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-60.444, 48.618],
												[0, 0],
												[19.017, 60.298],
												[64.229, 38.088]
											],
											v: [
												[-73.857, -96.585],
												[-43.267, -208.943],
												[-107.413, -291.145],
												[-174.74, -375.509],
												[-189.545, -306.211],
												[-304.659, -344.318],
												[-253.192, -222.284],
												[-309.017, -161.298],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 33.333,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[26.413, -30.855],
												[42.592, -11.491],
												[0, 0],
												[41.659, -28.682],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-62.163, 42.799],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-54.767, -214.943],
												[-103.413, -291.145],
												[-161.74, -390.509],
												[-198.045, -327.711],
												[-305.659, -344.318],
												[-261.692, -224.284],
												[-304.517, -180.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .833,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 35.417,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[31.341, -18.879],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-31.341, 18.879],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-53.767, -236.943],
												[-108.413, -300.145],
												[-180.74, -385.509],
												[-204.045, -306.711],
												[-295.659, -354.318],
												[-258.692, -258.284],
												[-308.517, -191.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 37.5,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[27.341, -24.314],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-36.341, 32.318],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-50.267, -216.943],
												[-109.413, -288.145],
												[-174.74, -375.509],
												[-209.545, -315.211],
												[-296.659, -342.318],
												[-262.192, -243.284],
												[-299.017, -174.298],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .833,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 39.583,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[53.74, -14.491],
												[0, 0],
												[32.341, -37.818],
												[0, 0],
												[-15.517, -34.798],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.471, 10.913],
												[0, 0],
												[-32.341, 37.818],
												[0, 0],
												[15.517, 34.798],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-44.767, -220.943],
												[-96.913, -300.145],
												[-180.74, -385.509],
												[-199.045, -318.711],
												[-303.659, -335.318],
												[-280.692, -230.284],
												[-308.517, -191.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 41.667,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[22.502, -33.653],
												[42.592, -11.491],
												[0, 0],
												[35.659, -28.682],
												[0, 0],
												[-15.192, -48.171],
												[-50.043, -29.675]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-60.444, 48.618],
												[0, 0],
												[19.017, 60.298],
												[64.229, 38.088]
											],
											v: [
												[-73.857, -96.585],
												[-43.267, -208.943],
												[-107.413, -291.145],
												[-174.74, -375.509],
												[-189.545, -306.211],
												[-304.659, -344.318],
												[-253.192, -222.284],
												[-309.017, -161.298],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .14,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 43.75,
										s: [{
											i: [
												[9.242, 38.578],
												[-15.269, 44.324],
												[26.413, -30.855],
												[42.592, -11.491],
												[0, 0],
												[41.659, -28.682],
												[0, 0],
												[-16.876, -47.607],
												[-54.647, -50.89]
											],
											o: [
												[-9.242, -38.578],
												[35.326, -102.547],
												[-.804, .821],
												[-40.47, 10.919],
												[0, 0],
												[-62.163, 42.799],
												[0, 0],
												[16.876, 47.607],
												[54.647, 50.89]
											],
											v: [
												[-73.857, -96.585],
												[-54.767, -214.943],
												[-103.413, -291.145],
												[-161.74, -390.509],
												[-198.045, -327.711],
												[-305.659, -344.318],
												[-261.692, -224.284],
												[-304.517, -180.798],
												[-95.957, -86.325]
											],
											c: !1
										}]
									},
									{
										t: 45.8330078125,
										s: [{
											i: [
												[-11.218, -1.123],
												[-4.339, 12.597],
												[6.395, -9.564],
												[12.105, -3.266],
												[0, 0],
												[8.907, -5.365],
												[0, 0],
												[-4.796, -13.53],
												[-1.993, -.293]
											],
											o: [
												[1.227, .123],
												[10.04, -29.144],
												[-.228, .233],
												[-11.501, 3.103],
												[0, 0],
												[-8.907, 5.365],
												[0, 0],
												[4.796, 13.53],
												[20.996, 3.088]
											],
											v: [
												[-76.19, -88.813],
												[-63.98, -124.203],
												[-86.01, -146.665],
												[-102.065, -161.425],
												[-113.189, -146.531],
												[-133.725, -150.561],
												[-129.719, -129.768],
												[-137.379, -103.873],
												[-82.47, -85.898]
											],
											c: !1
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									.811764705882,
									.662745098039,
									.529411764706,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [-1.219, 4.229],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Shape 1",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 6,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 56,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 9,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 11,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: -39.063,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						641.136,
						685.566,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						14,
						-54,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 3,
							s: [
								96.63,
								96.63,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 9,
							s: [
								115,
								96.63,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 15,
							s: [
								85,
								96.63,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 19,
							s: [
								96.6,
								96.63,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 40,
							s: [
								96.6,
								96.63,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 43,
							s: [
								85,
								96.63,
								100
							]
						},
						{
							i: {
								x: [
									.833,
									.833,
									.833
								],
								y: [
									.833,
									.833,
									.833
								]
							},
							o: {
								x: [
									.167,
									.167,
									.167
								],
								y: [
									.167,
									.167,
									.167
								]
							},
							t: 48,
							s: [
								115,
								96.63,
								100
							]
						},
						{
							t: 55,
							s: [
								96.6,
								96.63,
								100
							]
						}
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			shapes: [{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[26.208, -40],
									[.057, -12.552],
									[-26.095, -40],
									[-48.261, -40],
									[-11.111, -.837],
									[-50, 40],
									[-27.834, 40],
									[-.112, 10.822],
									[27.553, 40],
									[50, 40],
									[11.11, -.892],
									[48.26, -40]
								],
								c: !0
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: !1
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: !1
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [12.25, -56.75],
							ix: 2
						},
						a: {
							a: 0,
							k: [0, 0],
							ix: 1
						},
						s: {
							a: 0,
							k: [72, 72],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: !1
			}],
			ip: 0,
			op: 56,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 11,
			ty: 4,
			nm: "primaryAnimationClass",
			parent: 12,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11
				},
				r: {
					a: 0,
					k: 44,
					ix: 10
				},
				p: {
					a: 0,
					k: [
						23.241,
						-235.66,
						0
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						619.015,
						650.336,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			hasMask: !0,
			masksProperties: [{
				inv: !0,
				mode: "a",
				pt: {
					a: 1,
					k: [
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 0,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[431.925, 438.104],
									[452.425, 453.567],
									[465.605, 444.067],
									[459.105, 423.104]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 10.417,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[431.925, 438.104],
									[452.425, 453.567],
									[465.605, 444.067],
									[459.105, 423.104]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 12.5,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[431.925, 438.104],
									[447.175, 430.067],
									[457.605, 424.317],
									[459.105, 423.104]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 43.75,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[431.925, 438.104],
									[447.175, 430.067],
									[457.605, 424.317],
									[459.105, 423.104]
								],
								c: !0
							}]
						},
						{
							i: {
								x: .833,
								y: .833
							},
							o: {
								x: .167,
								y: .167
							},
							t: 45.833,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[431.925, 438.104],
									[452.425, 453.567],
									[465.605, 444.067],
									[459.105, 423.104]
								],
								c: !0
							}]
						},
						{
							t: 58.3330078125,
							s: [{
								i: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								o: [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								v: [
									[431.925, 438.104],
									[452.425, 453.567],
									[465.605, 444.067],
									[459.105, 423.104]
								],
								c: !0
							}]
						}
					],
					ix: 1
				},
				o: {
					a: 0,
					k: 100,
					ix: 3
				},
				x: {
					a: 0,
					k: 0,
					ix: 4
				},
				nm: "Mask 1"
			}],
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 2.083,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[509, 576.5],
												[564, 580.5],
												[568.5, 532]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 10.417,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[519.5, 588],
												[574.5, 592],
												[579, 543.5]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 14.583,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[505, 580],
												[560, 584],
												[564, 537]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 18.75,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[509, 576.5],
												[564, 580.5],
												[568.5, 532]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 39.583,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[509, 576.5],
												[564, 580.5],
												[568.5, 532]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 43.75,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[505, 580],
												[560, 584],
												[564, 537]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 47.917,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[519.5, 588],
												[574.5, 592],
												[579, 543.5]
											],
											c: !1
										}]
									},
									{
										t: 54.1669921875,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[509, 576.5],
												[564, 580.5],
												[568.5, 532]
											],
											c: !1
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [0, 0],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Shape 2",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 2.083,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[505.5, 560],
												[548.5, 563],
												[553, 527.5]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 10.417,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[516, 571.5],
												[559, 574.5],
												[563.5, 539]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 14.583,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[506, 565],
												[544.5, 566.5],
												[548.5, 534.5]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 18.75,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[505.5, 560],
												[548.5, 563],
												[553, 527.5]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 39.583,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[505.5, 560],
												[548.5, 563],
												[553, 527.5]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 43.75,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[506, 565],
												[544.5, 566.5],
												[548.5, 534.5]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 47.917,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[516, 571.5],
												[559, 574.5],
												[563.5, 539]
											],
											c: !1
										}]
									},
									{
										t: 54.1669921875,
										s: [{
											i: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0]
											],
											v: [
												[505.5, 560],
												[548.5, 563],
												[553, 527.5]
											],
											c: !1
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [0, 0],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Shape 1",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 2,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [0, 0]],
									o: [[0, 0], [0, 0]],
									v: [[0, 0], [0, 0]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [719.086, 836.596],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 1",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 3,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [[0, 0], [-11.844, 13.663]],
									o: [[0, 0], [0, 0]],
									v: [[-11.844, 5.344], [11.844, -5.57]],
									c: !1
								},
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [461.498, 457.218],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 2",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 4,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 2.083,
										s: [{
											i: [
												[0, 0],
												[-4.342, -1.086],
												[-8.6, 4.987]
											],
											o: [
												[0, 0],
												[3.257, .814],
												[0, 0]
											],
											v: [
												[-45.933, -35.243],
												[24.712, 35.043],
												[45.933, 29.242]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 10.417,
										s: [{
											i: [
												[0, 0],
												[-4.342, -1.086],
												[-8.6, 4.987]
											],
											o: [
												[0, 0],
												[3.257, .814],
												[0, 0]
											],
											v: [
												[-55.933, -25.743],
												[12.712, 41.043],
												[42.933, 32.242]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 14.583,
										s: [{
											i: [
												[-22.273, -21.847],
												[-4.343, -1.086],
												[-8.6, 4.987]
											],
											o: [
												[22.273, 21.847],
												[3.257, .814],
												[0, 0]
											],
											v: [
												[-36.433, -40.743],
												[24.713, 35.043],
												[45.933, 29.242]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 18.75,
										s: [{
											i: [
												[0, 0],
												[-4.343, -1.086],
												[-8.6, 4.987]
											],
											o: [
												[0, 0],
												[3.257, .814],
												[0, 0]
											],
											v: [
												[-45.933, -35.243],
												[24.713, 35.043],
												[45.933, 29.242]
											],
											c: !1
										}]
									},
									{
										i: {
											x: 0,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 39.583,
										s: [{
											i: [
												[0, 0],
												[-4.343, -1.086],
												[-8.6, 4.987]
											],
											o: [
												[0, 0],
												[3.257, .814],
												[0, 0]
											],
											v: [
												[-45.933, -35.243],
												[24.713, 35.043],
												[45.933, 29.242]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 43.75,
										s: [{
											i: [
												[-22.273, -21.847],
												[-4.343, -1.086],
												[-8.6, 4.987]
											],
											o: [
												[22.273, 21.847],
												[3.257, .814],
												[0, 0]
											],
											v: [
												[-36.433, -40.743],
												[24.713, 35.043],
												[45.933, 29.242]
											],
											c: !1
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 47.917,
										s: [{
											i: [
												[0, 0],
												[-4.343, -1.086],
												[-8.6, 4.987]
											],
											o: [
												[0, 0],
												[3.257, .814],
												[0, 0]
											],
											v: [
												[-55.933, -25.743],
												[12.713, 41.043],
												[42.933, 32.242]
											],
											c: !1
										}]
									},
									{
										t: 54.1669921875,
										s: [{
											i: [
												[0, 0],
												[-4.343, -1.086],
												[-8.6, 4.987]
											],
											o: [
												[0, 0],
												[3.257, .814],
												[0, 0]
											],
											v: [
												[-45.933, -35.243],
												[24.713, 35.043],
												[45.933, 29.242]
											],
											c: !1
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [661.66, 813.395],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 3",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 5,
					mn: "ADBE Vector Group",
					hd: !1
				},
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 1,
								k: [
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 2.083,
										s: [{
											i: [
												[0, 0],
												[-11.142, -10.478],
												[-51.059, -66.871],
												[0, 0],
												[43.425, -33.111],
												[0, 0],
												[50.481, 67.308],
												[7.057, 13.57],
												[0, 0],
												[-31.505, 22.741]
											],
											o: [
												[0, 0],
												[11.142, 10.478],
												[51.059, 66.871],
												[0, 0],
												[-43.425, 33.111],
												[0, 0],
												[-50.481, -67.308],
												[-7.057, -13.57],
												[0, 0],
												[31.505, -22.741]
											],
											v: [
												[-130.855, -203.39],
												[-68.653, -126.04],
												[74.432, -53.491],
												[183.09, 121.015],
												[137.38, 187.789],
												[55.416, 217.644],
												[-83.001, 65.657],
												[-113.941, -91.758],
												[-171.479, -172.637],
												[-168.177, -208.874]
											],
											c: !0
										}]
									},
									{
										i: {
											x: .833,
											y: .833
										},
										o: {
											x: .333,
											y: 0
										},
										t: 10.417,
										s: [{
											i: [
												[0, 0],
												[-11.142, -10.478],
												[-51.059, -66.871],
												[0, 0],
												[43.425, -33.111],
												[0, 0],
												[50.481, 67.308],
												[7.057, 13.57],
												[0, 0],
												[-31.505, 22.741]
											],
											o: [
												[0, 0],
												[11.142, 10.478],
												[51.059, 66.871],
												[0, 0],
												[-43.425, 33.111],
												[0, 0],
												[-50.481, -67.308],
												[-7.057, -13.57],
												[0, 0],
												[31.505, -22.741]
											],
											v: [
												[-130.855, -203.39],
												[-58.653, -115.04],
												[91.432, -54.491],
												[188.09, 112.015],
												[137.38, 187.789],
												[46.416, 223.644],
												[-89.001, 87.657],
												[-103.941, -80.758],
												[-171.479, -172.637],
												[-168.177, -208.874]
											],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .167,
											y: .167
										},
										t: 14.583,
										s: [{
											i: [
												[0, 0],
												[-35.735, -35.49],
												[-40.193, -73.857],
												[0, 0],
												[43.425, -33.111],
												[0, 0],
												[72.846, 65.119],
												[6.05, 15.752],
												[0, 0],
												[-31.505, 22.741]
											],
											o: [
												[0, 0],
												[10.853, 10.778],
												[46.771, 86.172],
												[0, 0],
												[-43.425, 33.111],
												[0, 0],
												[-62.587, -56.105],
												[-16.559, -43.111],
												[0, 0],
												[31.505, -22.741]
											],
											v: [
												[-130.855, -203.39],
												[-75.781, -118.846],
												[65.741, -47.831],
												[181.43, 117.724],
												[137.38, 187.789],
												[54.979, 217.935],
												[-82.34, 59.112],
												[-112.956, -93.725],
												[-171.479, -172.637],
												[-168.177, -208.874]
											],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .167,
											y: 0
										},
										t: 18.75,
										s: [{
											i: [
												[0, 0],
												[-11.142, -10.478],
												[-51.059, -66.871],
												[0, 0],
												[43.425, -33.111],
												[0, 0],
												[50.481, 67.308],
												[7.057, 13.57],
												[0, 0],
												[-31.505, 22.741]
											],
											o: [
												[0, 0],
												[11.142, 10.478],
												[51.059, 66.871],
												[0, 0],
												[-43.425, 33.111],
												[0, 0],
												[-50.481, -67.308],
												[-7.057, -13.57],
												[0, 0],
												[31.505, -22.741]
											],
											v: [
												[-130.855, -203.39],
												[-68.653, -126.04],
												[74.432, -53.491],
												[183.09, 121.015],
												[137.38, 187.789],
												[55.416, 217.644],
												[-83.001, 65.657],
												[-113.941, -91.758],
												[-171.479, -172.637],
												[-168.177, -208.874]
											],
											c: !0
										}]
									},
									{
										i: {
											x: .833,
											y: .833
										},
										o: {
											x: .167,
											y: 0
										},
										t: 39.583,
										s: [{
											i: [
												[0, 0],
												[-11.142, -10.478],
												[-51.059, -66.871],
												[0, 0],
												[43.425, -33.111],
												[0, 0],
												[50.481, 67.308],
												[7.057, 13.57],
												[0, 0],
												[-31.505, 22.741]
											],
											o: [
												[0, 0],
												[11.142, 10.478],
												[51.059, 66.871],
												[0, 0],
												[-43.425, 33.111],
												[0, 0],
												[-50.481, -67.308],
												[-7.057, -13.57],
												[0, 0],
												[31.505, -22.741]
											],
											v: [
												[-130.855, -203.39],
												[-68.653, -126.04],
												[74.432, -53.491],
												[183.09, 121.015],
												[137.38, 187.789],
												[55.416, 217.644],
												[-83.001, 65.657],
												[-113.941, -91.758],
												[-171.479, -172.637],
												[-168.177, -208.874]
											],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .167,
											y: .167
										},
										t: 43.75,
										s: [{
											i: [
												[0, 0],
												[-35.734, -35.49],
												[-40.193, -73.857],
												[0, 0],
												[43.425, -33.111],
												[0, 0],
												[72.846, 65.119],
												[6.05, 15.752],
												[0, 0],
												[-31.505, 22.741]
											],
											o: [
												[0, 0],
												[10.853, 10.778],
												[46.771, 86.172],
												[0, 0],
												[-43.425, 33.111],
												[0, 0],
												[-62.587, -56.105],
												[-16.559, -43.111],
												[0, 0],
												[31.505, -22.741]
											],
											v: [
												[-130.855, -203.39],
												[-75.781, -118.846],
												[65.741, -47.831],
												[181.43, 117.724],
												[137.38, 187.789],
												[54.979, 217.935],
												[-82.34, 59.112],
												[-112.956, -93.725],
												[-171.479, -172.637],
												[-168.177, -208.874]
											],
											c: !0
										}]
									},
									{
										i: {
											x: .667,
											y: 1
										},
										o: {
											x: .333,
											y: 0
										},
										t: 47.917,
										s: [{
											i: [
												[0, 0],
												[-11.142, -10.478],
												[-51.059, -66.871],
												[0, 0],
												[43.425, -33.111],
												[0, 0],
												[50.481, 67.308],
												[7.057, 13.57],
												[0, 0],
												[-31.505, 22.741]
											],
											o: [
												[0, 0],
												[11.142, 10.478],
												[51.059, 66.871],
												[0, 0],
												[-43.425, 33.111],
												[0, 0],
												[-50.481, -67.308],
												[-7.057, -13.57],
												[0, 0],
												[31.505, -22.741]
											],
											v: [
												[-130.855, -203.39],
												[-58.653, -115.04],
												[91.432, -54.491],
												[188.09, 112.015],
												[137.38, 187.789],
												[46.416, 223.644],
												[-89.001, 87.657],
												[-103.941, -80.758],
												[-171.479, -172.637],
												[-168.177, -208.874]
											],
											c: !0
										}]
									},
									{
										t: 54.1669921875,
										s: [{
											i: [
												[0, 0],
												[-11.142, -10.478],
												[-51.059, -66.871],
												[0, 0],
												[43.425, -33.111],
												[0, 0],
												[50.481, 67.308],
												[7.057, 13.57],
												[0, 0],
												[-31.505, 22.741]
											],
											o: [
												[0, 0],
												[11.142, 10.478],
												[51.059, 66.871],
												[0, 0],
												[-43.425, 33.111],
												[0, 0],
												[-50.481, -67.308],
												[-7.057, -13.57],
												[0, 0],
												[31.505, -22.741]
											],
											v: [
												[-130.855, -203.39],
												[-68.653, -126.04],
												[74.432, -53.491],
												[183.09, 121.015],
												[137.38, 187.789],
												[55.416, 217.644],
												[-83.001, 65.657],
												[-113.941, -91.758],
												[-171.479, -172.637],
												[-168.177, -208.874]
											],
											c: !0
										}]
									}
								],
								ix: 2
							},
							nm: "Path 1",
							mn: "ADBE Vector Shape - Group",
							hd: !1
						},
						{
							ty: "st",
							c: {
								a: 0,
								k: [
									1,
									1,
									1,
									1
								],
								ix: 3
							},
							o: {
								a: 0,
								k: 100,
								ix: 4
							},
							w: {
								a: 0,
								k: 11,
								ix: 5
							},
							lc: 2,
							lj: 2,
							bm: 0,
							nm: "Stroke 1",
							mn: "ADBE Vector Graphic - Stroke",
							hd: !1
						},
						{
							ty: "tr",
							p: {
								a: 0,
								k: [619.015, 650.336],
								ix: 2
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3
							},
							r: {
								a: 0,
								k: 0,
								ix: 6
							},
							o: {
								a: 0,
								k: 100,
								ix: 7
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5
							},
							nm: "Transform"
						}
					],
					nm: "Group 4",
					np: 2,
					cix: 2,
					bm: 0,
					ix: 6,
					mn: "ADBE Vector Group",
					hd: !1
				}
			],
			ip: 0,
			op: 56,
			st: 0,
			bm: 0
		},
		{
			ddd: 0,
			ind: 12,
			ty: 3,
			nm: "Null 169",
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 0,
					ix: 11
				},
				r: {
					a: 0,
					k: -44,
					ix: 10
				},
				p: {
					a: 1,
					k: [
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 0,
							s: [
								810,
								894,
								0
							],
							to: [
								4,
								4.333,
								0
							],
							ti: [
								3.167,
								3.167,
								0
							]
						},
						{
							i: {
								x: 0,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 8.333,
							s: [
								834,
								920,
								0
							],
							to: [
								-3.167,
								-3.167,
								0
							],
							ti: [
								4,
								4.333,
								0
							]
						},
						{
							i: {
								x: 0,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 14.583,
							s: [
								791,
								875,
								0
							],
							to: [
								-4,
								-4.333,
								0
							],
							ti: [
								-3.167,
								-3.167,
								0
							]
						},
						{
							i: {
								x: 0,
								y: 0
							},
							o: {
								x: .167,
								y: .167
							},
							t: 18.75,
							s: [
								810,
								894,
								0
							],
							to: [
								0,
								0,
								0
							],
							ti: [
								0,
								0,
								0
							]
						},
						{
							i: {
								x: 0,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 39.583,
							s: [
								810,
								894,
								0
							],
							to: [
								-3.167,
								-3.167,
								0
							],
							ti: [
								-4,
								-4.333,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .167,
								y: 0
							},
							t: 43.75,
							s: [
								791,
								875,
								0
							],
							to: [
								4,
								4.333,
								0
							],
							ti: [
								-3.167,
								-3.167,
								0
							]
						},
						{
							i: {
								x: .667,
								y: 1
							},
							o: {
								x: .333,
								y: 0
							},
							t: 50,
							s: [
								834,
								920,
								0
							],
							to: [
								3.167,
								3.167,
								0
							],
							ti: [
								4,
								4.333,
								0
							]
						},
						{
							t: 54.1669921875,
							s: [
								810,
								894,
								0
							]
						}
					],
					ix: 2,
					l: 2
				},
				a: {
					a: 0,
					k: [
						0,
						0,
						0
					],
					ix: 1,
					l: 2
				},
				s: {
					a: 0,
					k: [
						100,
						100,
						100
					],
					ix: 6,
					l: 2
				}
			},
			ao: 0,
			ip: 0,
			op: 56,
			st: 0,
			bm: 0
		}
	],
	markers: []
}, Il = /* @__PURE__ */ function(e) {
	return e.Settings = "Settings", e.Mail = "Mail", e.Paper = "Paper", e.Champagne = "Champagne", e;
}({}), Ll = (e) => {
	let t = e.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*([\d.]+))?\s*\)/);
	if (!t) return;
	let [, n, r, i, a] = t, o = a === void 0 ? 1 : Number.parseFloat(a);
	if (!([
		n,
		r,
		i
	].some((e) => Number.isNaN(Number.parseFloat(e))) || Number.isNaN(o))) return [
		Number.parseFloat(n) / 255,
		Number.parseFloat(r) / 255,
		Number.parseFloat(i) / 255,
		o
	];
}, Rl = (e) => {
	if (!e) return;
	let t = e.trim();
	if (t.startsWith("rgb")) return Ll(t);
	let n = t.replace("#", ""), r = n.length === 3 || n.length === 4, i = n.length === 6 || n.length === 8;
	if (!r && !i) return;
	let a = r ? n.split("").map((e) => `${e}${e}`).join("") : n, o = a.length === 8, s = Number.parseInt(a.slice(0, 2), 16), c = Number.parseInt(a.slice(2, 4), 16), l = Number.parseInt(a.slice(4, 6), 16), u = o ? Number.parseInt(a.slice(6, 8), 16) / 255 : 1;
	if (!([
		s,
		c,
		l
	].some((e) => Number.isNaN(e)) || Number.isNaN(u))) return [
		s / 255,
		c / 255,
		l / 255,
		u
	];
}, zl = (e) => {
	if (!e || typeof document > "u" || !e.includes("var(")) return e;
	let t = document.createElement("div");
	t.style.color = e, t.style.display = "none", document.body.appendChild(t);
	let n = window.getComputedStyle(t).color;
	return document.body.removeChild(t), n || e;
}, Bl = (e, t) => {
	e.forEach((e) => {
		e.ty === "gr" && Array.isArray(e.it) && Bl(e.it, t), (e.ty === "st" || e.ty === "fl") && e.c?.a === 0 && (e.c.k = t);
	});
}, Vl = (e, t, n) => {
	let r = Rl(zl(n));
	if (!r) return e;
	let i = JSON.parse(JSON.stringify(e));
	return i.layers?.forEach((e) => {
		e.nm !== t || !Array.isArray(e.shapes) || Bl(e.shapes, r);
	}), i;
}, Hl = (t) => {
	let n = e(13), { icon: r, loop: i, primaryColor: a, secondaryColor: o } = t, s = i === void 0 ? !0 : i, c = a ?? "var(--border-on-brand-main)", l = o ?? "var(--border-brand-accent)", u;
	bb0: switch (r) {
		case Il.Settings:
			u = Ml;
			break bb0;
		case Il.Mail:
			u = Nl;
			break bb0;
		case Il.Paper:
			u = Pl;
			break bb0;
		case Il.Champagne:
			u = Fl;
			break bb0;
		default: u = null;
	}
	let d = u, f;
	bb1: {
		if (!d) {
			f = null;
			break bb1;
		}
		let e;
		n[0] !== d || n[1] !== c || n[2] !== l ? (e = Vl(Vl(d, "primaryAnimationClass", c), "secondaryAnimationClass", l), n[0] = d, n[1] = c, n[2] = l, n[3] = e) : e = n[3], f = e;
	}
	let p = f;
	if (!p) return;
	let h;
	n[4] !== c || n[5] !== l ? (h = {
		width: "400px",
		height: "400px",
		"--animation-primary-color": c,
		"--animation-secondary-color": l
	}, n[4] = c, n[5] = l, n[6] = h) : h = n[6];
	let g = h, _;
	n[7] !== p || n[8] !== s ? (_ = /* @__PURE__ */ m(he, {
		data: p,
		autoplay: !0,
		width: "100%",
		height: "100%",
		loop: s
	}), n[7] = p, n[8] = s, n[9] = _) : _ = n[9];
	let v;
	return n[10] !== g || n[11] !== _ ? (v = /* @__PURE__ */ m("div", {
		style: g,
		children: _
	}), n[10] = g, n[11] = _, n[12] = v) : v = n[12], v;
}, Ul = (t) => {
	let n = e(16), { id: r, content: i, children: a, placement: o, disabled: s, className: c, contentClassName: l } = t, u = o === void 0 ? "bottom" : o, p = s === void 0 ? !1 : s, [g, _] = d(!1), v = !p && !!i && g, y;
	n[0] === c ? y = n[1] : (y = f("agx-tooltip-anchor", c), n[0] = c, n[1] = y);
	let b, x, S, C;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (b = () => _(!0), x = () => _(!1), S = () => _(!0), C = () => _(!1), n[2] = b, n[3] = x, n[4] = S, n[5] = C) : (b = n[2], x = n[3], S = n[4], C = n[5]);
	let w;
	n[6] !== i || n[7] !== l || n[8] !== r || n[9] !== u || n[10] !== v ? (w = v && /* @__PURE__ */ m("div", {
		className: f("agx-tooltip-content", `agx-tooltip-content--${u}`, l),
		role: "tooltip",
		children: typeof i == "string" ? /* @__PURE__ */ m(Q, {
			id: `${r}-tooltip`,
			type: "caption",
			size: "medium",
			color: "var(--text-brand-main)",
			children: i
		}) : i
	}), n[6] = i, n[7] = l, n[8] = r, n[9] = u, n[10] = v, n[11] = w) : w = n[11];
	let T;
	return n[12] !== a || n[13] !== y || n[14] !== w ? (T = /* @__PURE__ */ h("div", {
		className: y,
		onMouseEnter: b,
		onMouseLeave: x,
		onFocus: S,
		onBlur: C,
		children: [a, w]
	}), n[12] = a, n[13] = y, n[14] = w, n[15] = T) : T = n[15], T;
}, Wl = (t) => {
	let n = e(16), { options: r, onChange: i } = t, [a, s] = d(""), c;
	n[0] === i ? c = n[1] : (c = (e) => {
		s(e.label), i && i(e);
	}, n[0] = i, n[1] = c);
	let l = c, u, p;
	n[2] === r ? (u = n[3], p = n[4]) : (u = () => {
		if (r && r.length > 0) {
			let e = r.find(Gl);
			s(e ? e.label : r[0].label);
		}
	}, p = [r], n[2] = r, n[3] = u, n[4] = p), o(u, p);
	let g;
	if (n[5] !== i || n[6] !== l || n[7] !== r || n[8] !== a) {
		let e;
		n[10] !== i || n[11] !== l || n[12] !== a ? (e = (e, t) => /* @__PURE__ */ m("div", {
			className: f("tab", a === e.label ? "activeTab" : "normalTab"),
			onClick: () => l(e),
			children: /* @__PURE__ */ h(Ne, {
				alignItems: "alignCenter",
				onClick: () => i && i(e),
				gap: "spacing-lg",
				padding: {
					top: "spacing-md",
					bottom: "spacing-md",
					left: "spacing-lg",
					right: "spacing-lg"
				},
				children: [/* @__PURE__ */ m("div", {
					className: "tabTextContainer",
					children: /* @__PURE__ */ m(Q, {
						color: a === e.label ? "var(--text-primary)" : "var(--text-tertiary)",
						id: `tabLbl-${e.label}`,
						type: "body_ui_strong",
						size: "small",
						children: e.label
					})
				}), e.tag && /* @__PURE__ */ m(jo, {
					id: "tab-tags",
					size: "small",
					children: e.tag
				})]
			}, e.label)
		}, `tab-${t}`), n[10] = i, n[11] = l, n[12] = a, n[13] = e) : e = n[13], g = r.map(e), n[5] = i, n[6] = l, n[7] = r, n[8] = a, n[9] = g;
	} else g = n[9];
	let _;
	return n[14] === g ? _ = n[15] : (_ = /* @__PURE__ */ m("div", {
		className: "tabContainer",
		children: g
	}), n[14] = g, n[15] = _), _;
};
function Gl(e) {
	return e.selected;
}
//#endregion
//#region src/components/action/Button/Button.tsx
var Kl = (t) => {
	let n = e(49), { id: r, text: i, dataTestId: a, onClick: o, onMouseEnter: s, onMouseLeave: c, variant: l, size: u, disabled: p, leftIcon: g, rightIcon: _, danger: v, stretch: y, tags: b, wrap: x, tooltip: S } = t, C = i === void 0 ? "" : i, w = a === void 0 ? r : a, T = o === void 0 ? ql : o, E = s === void 0 ? void 0 : s, D = c === void 0 ? void 0 : c, O = l === void 0 ? "primary" : l, k = u === void 0 ? "medium" : u, A = p === void 0 ? !1 : p, j = v === void 0 ? !1 : v, M = y === void 0 ? !1 : y, N;
	n[0] === b ? N = n[1] : (N = b === void 0 ? [] : b, n[0] = b, n[1] = N);
	let P = N, F = x === void 0 ? !1 : x, [I, L] = d(!1), R = `${O}`, z = `${k}`, B = `${P.length > 0 ? "withTags" : ""}`, V = j && "danger", H = A && "disabled", U = M && "stretch", W;
	n[2] !== R || n[3] !== z || n[4] !== B || n[5] !== V || n[6] !== H || n[7] !== U ? (W = f("agx-button-v2", R, z, B, V, H, U), n[2] = R, n[3] = z, n[4] = B, n[5] = V, n[6] = H, n[7] = U, n[8] = W) : W = n[8];
	let G = W, K;
	n[9] !== E || n[10] !== S ? (K = (e) => {
		S && L(!0), E?.();
	}, n[9] = E, n[10] = S, n[11] = K) : K = n[11];
	let q = K, J;
	n[12] !== D || n[13] !== S ? (J = (e) => {
		S && L(!1), D?.();
	}, n[12] = D, n[13] = S, n[14] = J) : J = n[14];
	let Y = J, X = `agx-button-wrapper ${k}`, Z;
	n[15] !== M || n[16] !== X ? (Z = f(X, { stretch: M }), n[15] = M, n[16] = X, n[17] = Z) : Z = n[17];
	let ee = w ?? r, te;
	n[18] === Symbol.for("react.memo_cache_sentinel") ? (te = { opacity: 1 }, n[18] = te) : te = n[18];
	let ne;
	n[19] === T ? ne = n[20] : (ne = (e) => {
		e.stopPropagation(), T();
	}, n[19] = T, n[20] = ne);
	let re;
	n[21] !== k || n[22] !== P ? (re = P?.map((e, t) => /* @__PURE__ */ m(jo, {
		id: "btn-tags",
		size: k === "small" ? "small" : "medium",
		children: e
	}, `tag-${t}`)), n[21] = k, n[22] = P, n[23] = re) : re = n[23];
	let ie;
	n[24] === _ ? ie = n[25] : (ie = _ && /* @__PURE__ */ m($, { children: _ }), n[24] = _, n[25] = ie);
	let ae;
	n[26] !== g || n[27] !== re || n[28] !== ie || n[29] !== C || n[30] !== F ? (ae = /* @__PURE__ */ h(Ne, {
		gap: "spacing-xs",
		alignItems: "alignCenter",
		justifyContent: "center",
		wrap: F,
		children: [
			g,
			C,
			re,
			ie
		]
	}), n[26] = g, n[27] = re, n[28] = ie, n[29] = C, n[30] = F, n[31] = ae) : ae = n[31];
	let oe;
	n[32] !== G || n[33] !== A || n[34] !== q || n[35] !== Y || n[36] !== r || n[37] !== ee || n[38] !== ne || n[39] !== ae ? (oe = /* @__PURE__ */ m("button", {
		id: r,
		"data-testid": ee,
		className: G,
		disabled: A,
		style: te,
		onClick: ne,
		onMouseEnter: q,
		onMouseLeave: Y,
		type: "button",
		children: ae
	}), n[32] = G, n[33] = A, n[34] = q, n[35] = Y, n[36] = r, n[37] = ee, n[38] = ne, n[39] = ae, n[40] = oe) : oe = n[40];
	let se;
	n[41] !== Z || n[42] !== oe ? (se = /* @__PURE__ */ m("div", {
		className: Z,
		children: oe
	}), n[41] = Z, n[42] = oe, n[43] = se) : se = n[43];
	let ce = se;
	if (S) {
		let e = `${r}-tooltip`, t = !I, i;
		return n[44] !== ce || n[45] !== e || n[46] !== t || n[47] !== S ? (i = /* @__PURE__ */ m(Ul, {
			id: e,
			content: S,
			disabled: t,
			children: ce
		}), n[44] = ce, n[45] = e, n[46] = t, n[47] = S, n[48] = i) : i = n[48], i;
	}
	return ce;
};
function ql() {}
//#endregion
//#region src/components/action/SaveChangesButton/Spinner.tsx
var Jl = (t) => {
	let n = e(8), { size: r, color: i, className: a } = t, o = r === void 0 ? 16 : r, s = i === void 0 ? "currentColor" : i, c = a === void 0 ? "" : a, l;
	n[0] === s ? l = n[1] : (l = (e) => {
		let t = e * 360 / 8 * Math.PI / 180;
		return /* @__PURE__ */ m("line", {
			x1: 12 + Math.cos(t) * 7,
			y1: 12 + Math.sin(t) * 7,
			x2: 12 + Math.cos(t) * 10,
			y2: 12 + Math.sin(t) * 10,
			stroke: s,
			strokeWidth: "2",
			strokeLinecap: "round",
			className: "spinner-spike",
			style: { animationDelay: `${e * 100 / 8}ms` }
		}, e);
	}, n[0] = s, n[1] = l);
	let u = l, d = `spinner ${c}`, f;
	n[2] === u ? f = n[3] : (f = Array.from({ length: 8 }, (e, t) => u(t)), n[2] = u, n[3] = f);
	let p;
	return n[4] !== o || n[5] !== d || n[6] !== f ? (p = /* @__PURE__ */ m("svg", {
		width: o,
		height: o,
		viewBox: "0 0 24 24",
		fill: "none",
		className: d,
		xmlns: "http://www.w3.org/2000/svg",
		children: f
	}), n[4] = o, n[5] = d, n[6] = f, n[7] = p) : p = n[7], p;
}, Yl = /* @__PURE__ */ function(e) {
	return e.SAVED = "saved", e.UNSAVED = "unsaved", e.ERROR = "error", e.SAVING = "saving", e;
}({}), Xl = (t) => {
	let n = e(18), r, i;
	if (n[0] === t ? (r = n[1], i = n[2]) : ({state: i, ...r} = t, n[0] = t, n[1] = r, n[2] = i), i === Yl.SAVED) {
		let e = r.size === "small" ? 18 : 20, t = r.size === "small" ? 18 : 20, i;
		n[3] !== e || n[4] !== t ? (i = /* @__PURE__ */ m(Ki, {
			height: e,
			width: t
		}), n[3] = e, n[4] = t, n[5] = i) : i = n[5];
		let a;
		n[6] === r.size ? a = n[7] : (a = /* @__PURE__ */ m(Q, {
			type: "body",
			size: r.size,
			id: "save-changes-btn-saved",
			children: "Changes Saved"
		}), n[6] = r.size, n[7] = a);
		let o;
		return n[8] !== i || n[9] !== a ? (o = /* @__PURE__ */ h(Ne, {
			gap: "spacing-sm",
			alignItems: "alignCenter",
			children: [i, a]
		}), n[8] = i, n[9] = a, n[10] = o) : o = n[10], o;
	}
	if (i === Yl.SAVING) {
		let e;
		n[11] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m(Jl, {
			size: 18,
			color: "currentColor"
		}), n[11] = e) : e = n[11];
		let t;
		return n[12] === r ? t = n[13] : (t = /* @__PURE__ */ m(Kl, {
			...r,
			text: "Saving...",
			leftIcon: e,
			disabled: !0
		}), n[12] = r, n[13] = t), t;
	}
	if (i === Yl.ERROR) {
		let e;
		return n[14] === r ? e = n[15] : (e = /* @__PURE__ */ m(Kl, {
			...r,
			disabled: !0
		}), n[14] = r, n[15] = e), e;
	}
	let a;
	return n[16] === r ? a = n[17] : (a = /* @__PURE__ */ m(Kl, { ...r }), n[16] = r, n[17] = a), a;
}, Zl = (t) => {
	let n = e(12), { id: r, title: i, xsTitle: a, size: o, fill: s, isSelected: c, onSelect: l } = t, u = o === void 0 ? "medium" : o, d = s === void 0 ? !1 : s, p = Na(), h = c && "selected", g;
	n[0] !== d || n[1] !== h ? (g = f("segment-picker-item", h, { fill: d }), n[0] = d, n[1] = h, n[2] = g) : g = n[2];
	let _ = g, v = `${r}-title`, y = p === Aa.Mobile && a || i, b;
	n[3] !== u || n[4] !== v || n[5] !== y ? (b = /* @__PURE__ */ m(Q, {
		id: v,
		size: u,
		type: "hyperlink",
		children: y
	}), n[3] = u, n[4] = v, n[5] = y, n[6] = b) : b = n[6];
	let x;
	return n[7] !== _ || n[8] !== r || n[9] !== l || n[10] !== b ? (x = /* @__PURE__ */ m("div", {
		id: r,
		className: _,
		"data-testid": r,
		onClick: l,
		children: b
	}), n[7] = _, n[8] = r, n[9] = l, n[10] = b, n[11] = x) : x = n[11], x;
};
//#endregion
//#region src/components/action/SegmentPicker/SegmentPicker.tsx
function Ql({ id: e, segments: t, defaultValue: n, size: r = "medium", label: i, labelAlignment: a = "left", fill: c = !1, onChange: l }) {
	let u = s();
	e ??= `segment-picker-${u}`;
	let [p, g] = d(n || t[0]?.value || null);
	if (o(() => {
		p && l && l(p);
	}, [l, p]), !t || t.length === 0) return null;
	let _ = a === "left" ? "flex-start" : a === "center" ? "alignCenter" : "flex-end";
	return /* @__PURE__ */ m("div", {
		id: e,
		className: f("segment-picker-style", { fill: c }),
		"data-testid": e,
		children: /* @__PURE__ */ h(Me, {
			gap: "spacing-md",
			fill: c,
			alignItems: _,
			children: [i && /* @__PURE__ */ m(Q, {
				id: "segment-picker-label",
				type: "label",
				size: r,
				children: i
			}), /* @__PURE__ */ m("div", {
				className: f("segment-picker-container", { fill: c }, `segment-picker-${r}`),
				children: /* @__PURE__ */ m(Ne, {
					alignItems: "stretch",
					fill: c,
					justifyContent: "center",
					children: t.map((t) => {
						let { title: n, xsTitle: i, value: a } = t, o = `${e}-segment-${a}`;
						return /* @__PURE__ */ m(Zl, {
							id: o,
							title: n,
							xsTitle: i,
							size: r,
							fill: c,
							isSelected: p === a,
							onSelect: () => g(a)
						}, o);
					})
				})
			})]
		})
	});
}
//#endregion
//#region src/components/statistics/PartnershipIndicator/types/PartnershipLevelBrackets.ts
var $l = {
	[g.Bronze]: 0,
	[g.Silver]: 25e4,
	[g.Gold]: 5e5,
	[g.Platinum]: 1e6,
	[g.XPartner]: 2e6
}, eu = (e, t) => {
	if (t === 0 || e === 0) return 0;
	let n = e / t * 100;
	return Math.floor(Fe(n, 0, 100));
}, tu = (e, t, n) => ({
	partnershipLevel: e,
	targetCommission: n,
	commissionRemainingToHitTarget: Math.max(n - t, 0),
	percentageCompletionToTarget: eu(t, n),
	goalMet: t >= n
}), nu = (e) => {
	let t = (0, So.default)(e).startOf("day"), n = (0, So.default)().startOf("day");
	return t.diff(n, "day");
}, ru = (e) => {
	switch (e) {
		case g.Bronze: return g.Silver;
		case g.Silver: return g.Gold;
		case g.Gold: return g.Platinum;
		case g.Platinum: return g.XPartner;
		case g.XPartner: return;
		default: throw Error("Invalid partnership level");
	}
}, iu = (e) => {
	switch (e) {
		case g.XPartner: return "X";
		default: return g[e];
	}
}, au = (e, t, n, r) => {
	let i = [], a = tu(e, t, $l[e] + (n ?? 0));
	if (e !== g.Bronze) {
		let { commissionRemainingToHitTarget: t, percentageCompletionToTarget: n, goalMet: r } = a, o = {
			currentPartnershipLevel: e,
			goalLabel: "Current goal",
			goalText: r ? e === g.XPartner ? "You've reached the top!" : "You've reached your goal!" : `Maintain ${iu(e)} Partnership`,
			goalNumberLabel: r ? "Goal reached! 🎉" : Ss(t),
			goalNumberText: r ? void 0 : "to maintain",
			percentageCompletion: n
		};
		i.push(o);
	}
	let o = ru(e), s;
	if (o !== void 0) {
		s = tu(o, t, $l[o]);
		let { commissionRemainingToHitTarget: n, percentageCompletionToTarget: r, goalMet: a } = s, c, l, u, d;
		a ? (c = e === g.Bronze ? "Current goal" : "Congratulations! You've leveled up!", l = e === g.Bronze ? "Congratulations! You've leveled up!" : a ? void 0 : "Next goal", u = "You've leveled up! 🎉", d = void 0) : (c = "Next goal", l = `Level up to ${g[o]} Partner`, u = Ss(n), d = "to level up");
		let f = {
			currentPartnershipLevel: e,
			goalLabel: c,
			goalText: l,
			goalNumberLabel: u,
			goalNumberText: d,
			percentageCompletion: r
		};
		i.push(f);
	}
	if (e === g.XPartner || e === g.Bronze) {
		let t = nu(r), n, o;
		e !== g.Bronze && a.goalMet ? (n = "Congratulations!", o = void 0) : t >= 0 && !s?.goalMet && (n = "Days left", o = `${t} days`);
		let c = {
			currentPartnershipLevel: e,
			goalLabel: n,
			goalText: o
		};
		return i.push(c), i;
	}
	return i;
}, ou = {
	[g.Bronze]: "var(--partnership-color-bronze)",
	[g.Silver]: "var(--partnership-color-silver)",
	[g.Gold]: "var(--partnership-color-gold)",
	[g.Platinum]: "var(--partnership-color-platinum)",
	[g.XPartner]: "var(--partnership-color-x-white)"
}, su = (t) => {
	let n = e(29), { id: r, partnershipLevel: i, reviewDate: a } = t, o = r === void 0 ? "partnership-level-display" : r, s;
	n[0] === a ? s = n[1] : (s = (0, So.default)(a).format("D MMM YYYY"), n[0] = a, n[1] = s);
	let c = s, l = `${o}-partnership-level-display`, u = `${o}-partnership-currentLevel`, d;
	n[2] === u ? d = n[3] : (d = /* @__PURE__ */ m(Q, {
		id: u,
		type: "body_ui",
		size: "small",
		color: "var(--text-white)",
		opacityPercent: 60,
		children: "Current level"
	}), n[2] = u, n[3] = d);
	let f = `${o}-partnership-levelName`, p;
	n[4] === i ? p = n[5] : (p = iu(i), n[4] = i, n[5] = p);
	let g;
	n[6] !== f || n[7] !== p ? (g = /* @__PURE__ */ h(Q, {
		id: f,
		type: "heading",
		size: "large",
		color: "var(--text-white)",
		children: [p, " Partner"]
	}), n[6] = f, n[7] = p, n[8] = g) : g = n[8];
	let _;
	n[9] === i ? _ = n[10] : (_ = /* @__PURE__ */ m(Ui, { partnershipLevel: i }), n[9] = i, n[10] = _);
	let v;
	n[11] !== g || n[12] !== _ ? (v = /* @__PURE__ */ h(Ne, {
		gap: "spacing-sm",
		alignItems: "alignCenter",
		children: [g, _]
	}), n[11] = g, n[12] = _, n[13] = v) : v = n[13];
	let y;
	n[14] === Symbol.for("react.memo_cache_sentinel") ? (y = { top: "spacing-xs" }, n[14] = y) : y = n[14];
	let b = `${o}-partnership-review`, x;
	n[15] === b ? x = n[16] : (x = /* @__PURE__ */ m(Q, {
		id: b,
		type: "caption",
		size: "medium",
		color: "var(--text-white)",
		opacityPercent: 60,
		children: "Next partnership review"
	}), n[15] = b, n[16] = x);
	let S = `${o}-partnership-review-date`, C = ou[i], w;
	n[17] !== c || n[18] !== S || n[19] !== C ? (w = /* @__PURE__ */ m(Q, {
		id: S,
		type: "caption",
		size: "medium",
		color: C,
		children: c
	}), n[17] = c, n[18] = S, n[19] = C, n[20] = w) : w = n[20];
	let T;
	n[21] !== x || n[22] !== w ? (T = /* @__PURE__ */ h(Ne, {
		gap: "spacing-xs",
		alignItems: "alignCenter",
		padding: y,
		children: [x, w]
	}), n[21] = x, n[22] = w, n[23] = T) : T = n[23];
	let E;
	return n[24] !== v || n[25] !== T || n[26] !== l || n[27] !== d ? (E = /* @__PURE__ */ h(Me, {
		gap: "spacing-xs",
		id: l,
		children: [
			d,
			v,
			T
		]
	}), n[24] = v, n[25] = T, n[26] = l, n[27] = d, n[28] = E) : E = n[28], E;
}, cu = (t) => {
	let n = e(15), { id: r, currentPartnershipLevel: i, goals: a } = t, o = r === void 0 ? "partnership-goal-display" : r, [s, c] = a, l = `${o}-partnership-goal-display`, u;
	n[0] !== o || n[1] !== s ? (u = s?.goalLabel && /* @__PURE__ */ m(Q, {
		id: `${o}-partnership-current-goal-label`,
		type: "body_ui",
		size: "small",
		color: "var(--text-white)",
		opacityPercent: 60,
		children: s.goalLabel
	}), n[0] = o, n[1] = s, n[2] = u) : u = n[2];
	let d;
	n[3] !== o || n[4] !== s ? (d = s?.goalText && /* @__PURE__ */ m(Q, {
		id: `${o}-partnership-goalName`,
		type: "heading",
		size: "large",
		color: "var(--text-white)",
		children: s.goalText
	}), n[3] = o, n[4] = s, n[5] = d) : d = n[5];
	let f;
	n[6] !== i || n[7] !== o || n[8] !== c ? (f = (c?.goalLabel || c?.goalText) && /* @__PURE__ */ h(Ne, {
		gap: "spacing-xs",
		alignItems: "alignCenter",
		padding: { top: "spacing-xs" },
		children: [c?.goalLabel && /* @__PURE__ */ m(Q, {
			id: `${o}-partnership-goal-next-goal-label`,
			type: "caption",
			size: "medium",
			color: "var(--text-white)",
			opacityPercent: 60,
			children: c.goalLabel
		}), c?.goalText && /* @__PURE__ */ m(Q, {
			id: `${o}-partnership-goal-next-goal-text`,
			type: "caption",
			size: "medium",
			color: ou[i],
			children: c.goalText
		})]
	}), n[6] = i, n[7] = o, n[8] = c, n[9] = f) : f = n[9];
	let p;
	return n[10] !== l || n[11] !== u || n[12] !== d || n[13] !== f ? (p = /* @__PURE__ */ h(Me, {
		gap: "spacing-xs",
		id: l,
		children: [
			u,
			d,
			f
		]
	}), n[10] = l, n[11] = u, n[12] = d, n[13] = f, n[14] = p) : p = n[14], p;
}, lu = (t) => {
	let n = e(4), { goals: r } = t;
	if (!r || r.length === 0) return;
	let i;
	n[0] === r ? i = n[1] : (i = r.map(uu), n[0] = r, n[1] = i);
	let a;
	return n[2] === i ? a = n[3] : (a = /* @__PURE__ */ m(Me, {
		gap: "spacing-xs",
		justifyContent: "center",
		id: "partnership-progress-display",
		children: i
	}), n[2] = i, n[3] = a), a;
};
function uu(e, n) {
	return /* @__PURE__ */ h(t.Fragment, { children: [/* @__PURE__ */ h(Ne, {
		id: `partnership-goal-${n}`,
		gap: "spacing-xs",
		alignItems: "alignCenter",
		children: [e.goalNumberLabel && /* @__PURE__ */ m(Q, {
			id: `partnership-progress-amount-${n}`,
			type: "label",
			size: "medium",
			color: "var(--text-white)",
			children: e.goalNumberLabel
		}), e.goalNumberText && /* @__PURE__ */ m(Q, {
			id: `partnership-progress-label-${n}`,
			type: "caption",
			size: "medium",
			color: "var(--text-white)",
			opacityPercent: 60,
			children: e.goalNumberText
		})]
	}), e.percentageCompletion !== void 0 && /* @__PURE__ */ m(Re, {
		id: `progress-${n}`,
		progress: e.percentageCompletion,
		variant: "thick",
		mode: "light"
	})] }, `goalProgress-${n}`);
}
//#endregion
//#region src/components/statistics/PartnershipIndicator/PartnershipIndicator.tsx
var du = (t) => {
	let n = e(24), { partnershipLevel: r, reviewDate: i, currentCommission: a, commissionTargetAdjustment: o } = t, s;
	n[0] !== o || n[1] !== a || n[2] !== r || n[3] !== i ? (s = au(r, a, o, i), n[0] = o, n[1] = a, n[2] = r, n[3] = i, n[4] = s) : s = n[4];
	let c = s, l = Na(), u;
	n[5] !== r || n[6] !== i ? (u = /* @__PURE__ */ m(su, {
		partnershipLevel: r,
		reviewDate: i
	}), n[5] = r, n[6] = i, n[7] = u) : u = n[7];
	let d = l === Aa.Mobile ? "horizontal" : "vertical", f;
	n[8] === d ? f = n[9] : (f = /* @__PURE__ */ m("div", {
		className: "dividerContainer",
		children: /* @__PURE__ */ m(Ja, {
			variant: d,
			opacityPercent: 20,
			id: "partnership-divider-1",
			color: "var(--text-white)"
		})
	}), n[8] = d, n[9] = f);
	let p;
	n[10] !== c || n[11] !== r || n[12] !== i ? (p = /* @__PURE__ */ m(cu, {
		currentPartnershipLevel: r,
		partnershipReviewDate: i,
		goals: c
	}), n[10] = c, n[11] = r, n[12] = i, n[13] = p) : p = n[13];
	let g = l === Aa.Desktop || l === Aa.Laptop || l == Aa.Tablet_Landscape ? "vertical" : "horizontal", _;
	n[14] === g ? _ = n[15] : (_ = /* @__PURE__ */ m("div", {
		className: "dividerContainer",
		children: /* @__PURE__ */ m(Ja, {
			variant: g,
			opacityPercent: 20,
			id: "partnership-divider-2",
			color: "var(--text-white)"
		})
	}), n[14] = g, n[15] = _);
	let v;
	n[16] === c ? v = n[17] : (v = /* @__PURE__ */ m(lu, { goals: c }), n[16] = c, n[17] = v);
	let y;
	return n[18] !== u || n[19] !== f || n[20] !== p || n[21] !== _ || n[22] !== v ? (y = /* @__PURE__ */ h("div", {
		className: "partnershipIndicator",
		"data-testid": "partnership-indicator",
		children: [
			u,
			f,
			p,
			_,
			v
		]
	}), n[18] = u, n[19] = f, n[20] = p, n[21] = _, n[22] = v, n[23] = y) : y = n[23], y;
}, fu = (t) => {
	let n = e(5), { centerJustified: r, children: i } = t, a = (r === void 0 ? !1 : r) && "centerJustified", o;
	n[0] === a ? o = n[1] : (o = f("AgxCard", a), n[0] = a, n[1] = o);
	let s;
	return n[2] !== i || n[3] !== o ? (s = /* @__PURE__ */ m("div", {
		className: o,
		children: i
	}), n[2] = i, n[3] = o, n[4] = s) : s = n[4], s;
}, pu = (t) => {
	let n = e(16), { index: r, title: i, value: a, goal: o, titleSize: s, goalSize: c } = t, l = `stat-card-item-${r}`, u;
	n[0] === i ? u = n[1] : (u = /* @__PURE__ */ m(Q, {
		id: "title",
		type: "body_ui",
		size: "medium",
		color: "var(--text-tertiary)",
		children: i
	}), n[0] = i, n[1] = u);
	let d = s === "large" ? "2x-large" : s === "medium" ? "medium" : "small", f;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (f = { margin: 0 }, n[2] = f) : f = n[2];
	let g;
	n[3] !== d || n[4] !== a ? (g = /* @__PURE__ */ m(Q, {
		id: "value",
		type: "heading",
		size: d,
		style: f,
		children: a
	}), n[3] = d, n[4] = a, n[5] = g) : g = n[5];
	let _;
	n[6] !== o || n[7] !== c ? (_ = !!o && /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m("div", {
		style: { height: "18px" },
		children: /* @__PURE__ */ m(Ja, { variant: "vertical" })
	}), /* @__PURE__ */ m(Q, {
		id: "goal",
		type: "heading",
		size: c === "large" ? "x-small" : c === "medium" ? "2x-small" : "small",
		style: {
			margin: 0,
			color: "var(--text-tertiary)"
		},
		children: o
	})] }), n[6] = o, n[7] = c, n[8] = _) : _ = n[8];
	let v;
	n[9] !== g || n[10] !== _ ? (v = /* @__PURE__ */ h(Ne, {
		gap: "spacing-md",
		alignItems: "alignCenter",
		children: [g, _]
	}), n[9] = g, n[10] = _, n[11] = v) : v = n[11];
	let y;
	return n[12] !== l || n[13] !== u || n[14] !== v ? (y = /* @__PURE__ */ h(Me, {
		fill: !0,
		gap: "spacing-md",
		children: [u, v]
	}, l), n[12] = l, n[13] = u, n[14] = v, n[15] = y) : y = n[15], y;
}, mu = (t) => {
	let n = e(9), { statAboveTarget: r, isAboveTarget: i, align: a } = t, o = a || "left", s = i ? "var(--text-success)" : "var(--text-error)", c = r ?? "- - -", l;
	n[0] !== s || n[1] !== c ? (l = /* @__PURE__ */ m(Q, {
		id: "status",
		type: "tag",
		size: "medium",
		color: s,
		children: c
	}), n[0] = s, n[1] = c, n[2] = l) : l = n[2];
	let u = i ? "above target" : "below target", d;
	n[3] === u ? d = n[4] : (d = /* @__PURE__ */ m(Q, {
		id: "above-below-target",
		type: "caption",
		size: "medium",
		color: "var(--text-tertiary)",
		children: u
	}), n[3] = u, n[4] = d);
	let f;
	return n[5] !== o || n[6] !== l || n[7] !== d ? (f = /* @__PURE__ */ h(Ne, {
		gap: "spacing-xs",
		fill: !0,
		alignItems: "alignCenter",
		justifyContent: o,
		children: [l, d]
	}), n[5] = o, n[6] = l, n[7] = d, n[8] = f) : f = n[8], f;
}, hu = (e) => "0" + (e ? "." : "") + "0".repeat(e), gu = (e, t = 0) => {
	let n = Number(e);
	return e == null || Number.isNaN(n) || Number.isNaN(n) ? hu(t) : n.toLocaleString(void 0, {
		minimumFractionDigits: t,
		maximumFractionDigits: t
	});
}, _u = (e) => {
	let { value: t, isCurrency: n, isPercentage: r, decimalPoints: i = 0 } = e, a = vu(e.statAboveTarget === null || e.statAboveTarget === void 0 ? void 0 : Math.abs(e.statAboveTarget), n, r, i), o = e.statAboveTarget !== null && e.statAboveTarget !== void 0 && e.statAboveTarget > 0, s = e.goal !== null && e.goal !== void 0 && e.statAboveTarget !== void 0 && Number(a) !== 0;
	return {
		value: vu(t, n, r, i),
		goal: vu(e.goal, n, r, i),
		statAboveTarget: a,
		isAboveTarget: o,
		hasGoal: s
	};
}, vu = (e, t, n, r = 0) => e == null ? "- - -" : t ? Ss(e, r) : n ? `${gu((e * 100).toLocaleString(), r)}%` : gu(e.toString(), r), yu = (t) => {
	let n = e(12), { data: r, loading: i, centerJustified: a } = t, o;
	n[0] === r ? o = n[1] : (o = r === void 0 ? [] : r, n[0] = r, n[1] = o);
	let s = o, c = i === void 0 ? !1 : i, l = a === void 0 ? !0 : a;
	if (c) {
		let e;
		return n[2] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m(fu, { children: "loading..." }), n[2] = e) : e = n[2], e;
	}
	if (l) {
		let e;
		n[3] === s ? e = n[4] : (e = s.map(bu), n[3] = s, n[4] = e);
		let t;
		return n[5] === e ? t = n[6] : (t = /* @__PURE__ */ m(p, { children: e }), n[5] = e, n[6] = t), t;
	}
	let u;
	n[7] === s ? u = n[8] : (u = s.map(xu), n[7] = s, n[8] = u);
	let d;
	return n[9] !== l || n[10] !== u ? (d = /* @__PURE__ */ m(fu, {
		centerJustified: l,
		children: u
	}), n[9] = l, n[10] = u, n[11] = d) : d = n[11], d;
};
function bu(e, t) {
	let { value: n, goal: r, statAboveTarget: i, isAboveTarget: a, hasGoal: o } = _u(e);
	return /* @__PURE__ */ h(fu, { children: [/* @__PURE__ */ h(Me, {
		fill: !0,
		gap: "spacing-md",
		children: [/* @__PURE__ */ m(pu, {
			index: t,
			title: e.title,
			value: n,
			goal: r,
			titleSize: "large",
			goalSize: "large"
		}), o && /* @__PURE__ */ m(mu, {
			statAboveTarget: i,
			isAboveTarget: a,
			align: "left"
		})]
	}), o ? /* @__PURE__ */ m(Re, {
		id: "progress-bar",
		progress: e.value != null && e.goal ? Math.round(e.value / e.goal * 100) : 0,
		variant: "thick",
		mode: "dark"
	}) : /* @__PURE__ */ m(p, {})] }, `stat-card-row-${t}`);
}
function xu(e, t) {
	let { value: n, goal: r, statAboveTarget: i, isAboveTarget: a, hasGoal: o } = _u(e);
	return /* @__PURE__ */ h(Ne, {
		fill: !0,
		gap: "spacing-lg",
		alignItems: "flex-end",
		justifyContent: "space-between",
		children: [/* @__PURE__ */ m(pu, {
			index: t,
			title: e.title,
			value: n,
			goal: r,
			titleSize: "medium",
			goalSize: "medium"
		}), o && /* @__PURE__ */ m(mu, {
			align: "right",
			statAboveTarget: i,
			isAboveTarget: a
		})]
	}, `stat-card-row-${t}`);
}
//#endregion
//#region src/components/Reporting/EntityStatistics/EntityStatistics.tsx
var Su = (t) => {
	let n = e(52), { loading: r, personalStatistics: i } = t, a = i?.statistics?.salesVolume, o = i?.statsAboveTarget?.salesVolume, s = i?.goals?.salesVolume, c;
	n[0] !== a || n[1] !== o || n[2] !== s ? (c = [{
		title: "Sales Volume",
		value: a,
		statAboveTarget: o,
		goal: s,
		isCurrency: !0
	}], n[0] = a, n[1] = o, n[2] = s, n[3] = c) : c = n[3];
	let l;
	n[4] !== r || n[5] !== c ? (l = /* @__PURE__ */ m(yu, {
		data: c,
		loading: r
	}), n[4] = r, n[5] = c, n[6] = l) : l = n[6];
	let u = i?.statistics?.grossCommissionIncome, d = i?.statsAboveTarget?.grossCommissionIncome, f = i?.goals?.grossCommissionIncome, p;
	n[7] !== u || n[8] !== d || n[9] !== f ? (p = [{
		title: "GCI",
		value: u,
		statAboveTarget: d,
		goal: f,
		isCurrency: !0
	}], n[7] = u, n[8] = d, n[9] = f, n[10] = p) : p = n[10];
	let g;
	n[11] !== r || n[12] !== p ? (g = /* @__PURE__ */ m(yu, {
		data: p,
		loading: r
	}), n[11] = r, n[12] = p, n[13] = g) : g = n[13];
	let _ = i?.statistics?.numberOfListings, v = i?.statsAboveTarget?.numberOfListings, y = i?.goals?.numberOfListings, b;
	n[14] !== _ || n[15] !== v || n[16] !== y ? (b = {
		title: "Listing",
		value: _,
		statAboveTarget: v,
		goal: y
	}, n[14] = _, n[15] = v, n[16] = y, n[17] = b) : b = n[17];
	let x = i?.statistics?.totalSales, S = i?.statsAboveTarget?.totalSales, C = i?.goals?.totalSales, w;
	n[18] !== x || n[19] !== S || n[20] !== C ? (w = {
		title: "Sale",
		value: x,
		statAboveTarget: S,
		goal: C
	}, n[18] = x, n[19] = S, n[20] = C, n[21] = w) : w = n[21];
	let T = i?.statistics?.conversionRate, E = i?.statsAboveTarget?.conversionRate, D = i?.goals?.conversionRate, O;
	n[22] !== T || n[23] !== E || n[24] !== D ? (O = {
		title: "List:sell Ratio",
		value: T,
		statAboveTarget: E,
		goal: D,
		isPercentage: !0
	}, n[22] = T, n[23] = E, n[24] = D, n[25] = O) : O = n[25];
	let k;
	n[26] !== b || n[27] !== w || n[28] !== O ? (k = [
		b,
		w,
		O
	], n[26] = b, n[27] = w, n[28] = O, n[29] = k) : k = n[29];
	let A;
	n[30] !== r || n[31] !== k ? (A = /* @__PURE__ */ m(yu, {
		data: k,
		loading: r,
		centerJustified: !1
	}), n[30] = r, n[31] = k, n[32] = A) : A = n[32];
	let j = i?.statistics?.averageSalePrice, M = i?.statsAboveTarget?.averageSalePrice, N = i?.goals?.averageSalePrice, P;
	n[33] !== j || n[34] !== M || n[35] !== N ? (P = {
		title: "Average Sale Price",
		value: j,
		statAboveTarget: M,
		goal: N,
		isCurrency: !0
	}, n[33] = j, n[34] = M, n[35] = N, n[36] = P) : P = n[36];
	let F = i?.statistics?.averageCommissionRate, I = i?.statsAboveTarget?.averageCommissionRate, L = i?.goals?.averageCommissionRate, R;
	n[37] !== F || n[38] !== I || n[39] !== L ? (R = {
		title: "Average Comm Rate",
		value: F,
		statAboveTarget: I,
		goal: L,
		isPercentage: !0,
		decimalPoints: 1
	}, n[37] = F, n[38] = I, n[39] = L, n[40] = R) : R = n[40];
	let z;
	n[41] !== P || n[42] !== R ? (z = [P, R], n[41] = P, n[42] = R, n[43] = z) : z = n[43];
	let B;
	n[44] !== r || n[45] !== z ? (B = /* @__PURE__ */ m(yu, {
		data: z,
		loading: r,
		centerJustified: !1
	}), n[44] = r, n[45] = z, n[46] = B) : B = n[46];
	let V;
	return n[47] !== g || n[48] !== A || n[49] !== B || n[50] !== l ? (V = /* @__PURE__ */ h("div", {
		className: "reportCards",
		children: [
			l,
			g,
			A,
			B
		]
	}), n[47] = g, n[48] = A, n[49] = B, n[50] = l, n[51] = V) : V = n[51], V;
}, Cu = (t) => {
	let n = e(24), { title: r, metric: i, variant: a, action: o } = t, [s, c] = d(!1), l = a === "positive" ? "var(--text-success)" : a === "negative" ? "var(--text-error)" : "var(--text-primary)", u = !!o && "hasAction", p = s && "pressed", g;
	n[0] !== u || n[1] !== p ? (g = f("metric", u, p), n[0] = u, n[1] = p, n[2] = g) : g = n[2];
	let _ = g, v;
	n[3] === Symbol.for("react.memo_cache_sentinel") ? (v = (e) => {
		e.preventDefault(), c(!0);
	}, n[3] = v) : v = n[3];
	let y;
	n[4] === o ? y = n[5] : (y = (e) => {
		e.preventDefault(), c(!1), o?.onClick();
	}, n[4] = o, n[5] = y);
	let b = `metric-${r}`, x;
	n[6] !== b || n[7] !== r ? (x = /* @__PURE__ */ m(Q, {
		id: b,
		type: "body_ui",
		size: "medium",
		color: "var(--text-tertiary)",
		children: r
	}), n[6] = b, n[7] = r, n[8] = x) : x = n[8];
	let S = `metric-value-${r}`, C;
	n[9] !== i || n[10] !== l || n[11] !== S ? (C = /* @__PURE__ */ m(Q, {
		id: S,
		type: "heading",
		size: "2x-large",
		color: l,
		children: i
	}), n[9] = i, n[10] = l, n[11] = S, n[12] = C) : C = n[12];
	let w;
	n[13] !== o || n[14] !== r ? (w = o && /* @__PURE__ */ m("div", {
		className: "metric-action",
		children: /* @__PURE__ */ m(Kl, {
			variant: "link",
			size: "small",
			id: `metric-action-${r}`,
			text: o.label,
			rightIcon: /* @__PURE__ */ m(Ei, {
				direction: "right",
				width: 14,
				height: 14
			})
		})
	}), n[13] = o, n[14] = r, n[15] = w) : w = n[15];
	let T;
	n[16] !== w || n[17] !== C ? (T = /* @__PURE__ */ h($, {
		direction: "horizontal",
		contentJustification: "space-between",
		contentAlignment: "end",
		children: [C, w]
	}), n[16] = w, n[17] = C, n[18] = T) : T = n[18];
	let E;
	return n[19] !== _ || n[20] !== T || n[21] !== y || n[22] !== x ? (E = /* @__PURE__ */ h($, {
		direction: "vertical",
		padding: "md",
		gap: "lg",
		contentJustification: "space-between",
		className: _,
		onMouseDown: v,
		onMouseUp: y,
		children: [x, T]
	}), n[19] = _, n[20] = T, n[21] = y, n[22] = x, n[23] = E) : E = n[23], E;
}, wu = (t) => {
	let n = e(14), { percentageCompletion: r } = t, i = 2 * Math.PI * 40, a = i * r / 100, o = i - a, s = i * .25, c, l;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (c = {
		position: "relative",
		width: "164px",
		height: "164px"
	}, l = { position: "absolute" }, n[0] = c, n[1] = l) : (c = n[0], l = n[1]);
	let u;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ m("circle", {
		cx: 50,
		cy: 50,
		r: 40,
		fill: "none",
		stroke: "var(--fg-black)",
		opacity: .08,
		strokeWidth: 18
	}), n[2] = u) : u = n[2];
	let d = `${a} ${o}`, f;
	n[3] === d ? f = n[4] : (f = /* @__PURE__ */ m("circle", {
		cx: 50,
		cy: 50,
		r: 40,
		fill: "none",
		stroke: "url(#paint0_linear_26480_213655)",
		strokeWidth: 18,
		strokeDasharray: d,
		strokeDashoffset: s,
		strokeLinecap: "round"
	}), n[3] = d, n[4] = f);
	let p;
	n[5] === Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ h("linearGradient", {
		id: "paint0_linear_26480_213655",
		x1: "78.3311",
		y1: "-1.03027",
		x2: "78.3311",
		y2: "162.97",
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ m("stop", { stopColor: "#49FF6A" }), /* @__PURE__ */ m("stop", {
			offset: "1",
			stopColor: "#6AD3C5"
		})]
	}) }), n[5] = p) : p = n[5];
	let g;
	n[6] === f ? g = n[7] : (g = /* @__PURE__ */ h("svg", {
		style: l,
		width: 164,
		height: 164,
		viewBox: "0 0 100 100",
		children: [
			u,
			f,
			p
		]
	}), n[6] = f, n[7] = g);
	let _;
	n[8] === Symbol.for("react.memo_cache_sentinel") ? (_ = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)"
	}, n[8] = _) : _ = n[8];
	let v;
	n[9] === r ? v = n[10] : (v = /* @__PURE__ */ h(Q, {
		id: "progressImage-percentage",
		type: "heading",
		size: "2x-large",
		color: "var(--text-primary)",
		style: _,
		children: [r, "%"]
	}), n[9] = r, n[10] = v);
	let y;
	return n[11] !== g || n[12] !== v ? (y = /* @__PURE__ */ h("div", {
		style: c,
		children: [g, v]
	}), n[11] = g, n[12] = v, n[13] = y) : y = n[13], y;
}, Tu = (t) => {
	let n = e(30), r, i, a, o, s, c;
	n[0] === t ? (r = n[1], i = n[2], a = n[3], o = n[4], s = n[5], c = n[6]) : ({id: i, title: s, currentMetric: r, totalMetric: c, metricLabel: a, ...o} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = c);
	let l = c > 0 ? Math.floor(Math.min(r / c * 100, 100)) : 0, u = `progressChart-${i}`, d;
	n[7] !== u || n[8] !== s ? (d = /* @__PURE__ */ m(Q, {
		id: u,
		type: "body_ui",
		size: "medium",
		color: "var(--text-tertiary)",
		children: s
	}), n[7] = u, n[8] = s, n[9] = d) : d = n[9];
	let f;
	n[10] === l ? f = n[11] : (f = /* @__PURE__ */ m(wu, { percentageCompletion: l }), n[10] = l, n[11] = f);
	let p = `progressChart-metric-${i}-current}`, g;
	n[12] !== r || n[13] !== p ? (g = /* @__PURE__ */ m(Q, {
		id: p,
		type: "caption",
		size: "medium",
		color: "var(--text-success)",
		children: r
	}), n[12] = r, n[13] = p, n[14] = g) : g = n[14];
	let _ = `progressChart-metric-${i}-total}`, v;
	n[15] !== a || n[16] !== _ || n[17] !== c ? (v = /* @__PURE__ */ h(Q, {
		id: _,
		type: "caption",
		size: "medium",
		color: "var(--text-tertiary)",
		children: [
			"/",
			c,
			" ",
			a
		]
	}), n[15] = a, n[16] = _, n[17] = c, n[18] = v) : v = n[18];
	let y;
	n[19] !== g || n[20] !== v ? (y = /* @__PURE__ */ h("span", { children: [g, v] }), n[19] = g, n[20] = v, n[21] = y) : y = n[21];
	let b;
	n[22] !== f || n[23] !== y ? (b = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-md",
		contentAlignment: "center",
		fill: !0,
		children: [f, y]
	}), n[22] = f, n[23] = y, n[24] = b) : b = n[24];
	let x;
	return n[25] !== i || n[26] !== o || n[27] !== d || n[28] !== b ? (x = /* @__PURE__ */ h($, {
		id: i,
		direction: "vertical",
		className: "progressChart",
		padding: "spacing-3xl",
		gap: "spacing-xl",
		...o,
		children: [d, b]
	}), n[25] = i, n[26] = o, n[27] = d, n[28] = b, n[29] = x) : x = n[29], x;
}, Eu = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("div", {
		className: "loadingState",
		children: /* @__PURE__ */ m(Q, {
			id: "loadingStateText",
			type: "body",
			size: "small",
			color: "var(--text-tertiary)",
			children: "Loading..."
		})
	}), t[0] = n) : n = t[0], n;
}, Du = (e) => e?.fullName ?? [
	e?.firstName,
	e?.middleName,
	e?.lastName
].filter(Boolean).join(" "), Ou = /* @__PURE__ */ function(e) {
	return e.Flat = "Flat", e.Tiered = "Tiered", e.VendorChoice = "VendorChoice", e.Other = "Other", e;
}({}), ku = (e) => {
	if (!e) return;
	let t = Number(e);
	return Number.isNaN(t) ? void 0 : t;
}, Au = (e) => {
	if (e == null) return;
	let t = parseFloat(e);
	return t != null && t != null && Number.isNaN(t) ? void 0 : t;
}, ju = (e) => {
	if (e == null || e === "") return "";
	let t = parseFloat(e);
	return !t || t === 0 ? "" : t;
}, Mu = [{
	value: q.Percentage,
	label: "Percentage"
}, {
	value: q.FlatFee,
	label: "Flat Fee"
}], Nu = (t) => {
	let n = e(57), { id: r, onValueChanged: i, defaultValue: a, required: s, onValidateStatusChange: c } = t, l = c === void 0 ? Pu : c, u;
	n[0] === a?.flatCommissionType ? u = n[1] : (u = () => a?.flatCommissionType ?? q.Percentage, n[0] = a?.flatCommissionType, n[1] = u);
	let [f, p] = d(u), g;
	n[2] === a?.amount ? g = n[3] : (g = () => a?.amount, n[2] = a?.amount, n[3] = g);
	let [_, v] = d(g), y;
	n[4] !== _ || n[5] !== f || n[6] !== a?.amount || n[7] !== a?.flatCommissionType || n[8] !== r || n[9] !== i ? (y = () => {
		f === a?.flatCommissionType && _ === a?.amount || i({
			id: r,
			value: {
				flatCommissionType: f,
				amount: _ || 0
			}
		});
	}, n[4] = _, n[5] = f, n[6] = a?.amount, n[7] = a?.flatCommissionType, n[8] = r, n[9] = i, n[10] = y) : y = n[10];
	let b = a?.flatCommissionType, x = a?.amount, S;
	n[11] !== _ || n[12] !== f || n[13] !== r || n[14] !== i || n[15] !== b || n[16] !== x ? (S = [
		r,
		i,
		_,
		f,
		b,
		x
	], n[11] = _, n[12] = f, n[13] = r, n[14] = i, n[15] = b, n[16] = x, n[17] = S) : S = n[17], o(y, S);
	let C;
	n[18] === f ? C = n[19] : (C = (e) => {
		e !== f && (p(e), v(void 0));
	}, n[18] = f, n[19] = C);
	let w = C, T;
	n[20] === Symbol.for("react.memo_cache_sentinel") ? (T = (e) => {
		if (Number.isNaN(Number(e.replace(/[^0-9.-]+/g, "")))) {
			v(void 0);
			return;
		}
		v(Number(e.replaceAll(",", "")));
	}, n[20] = T) : T = n[20];
	let E = T, D;
	n[21] !== _ || n[22] !== s ? (D = s && !ju(_?.toString().replaceAll(",", "")), n[21] = _, n[22] = s, n[23] = D) : D = n[23];
	let O = D, k, A;
	n[24] !== O || n[25] !== l ? (k = () => {
		l(!O);
	}, A = [O, l], n[24] = O, n[25] = l, n[26] = k, n[27] = A) : (k = n[26], A = n[27]), o(k, A);
	let j = `${r}-standardCommission`, M = `${r}-label`, N;
	n[28] === M ? N = n[29] : (N = /* @__PURE__ */ m(Q, {
		id: M,
		type: "label",
		size: "medium",
		color: "var(--text-primary)",
		children: "Commission Rate"
	}), n[28] = M, n[29] = N);
	let P = `${r}-inputRow`, F;
	n[30] === w ? F = n[31] : (F = (e) => w(e), n[30] = w, n[31] = F);
	let I;
	n[32] !== f || n[33] !== r || n[34] !== F ? (I = /* @__PURE__ */ m(Ec, {
		id: r,
		options: Mu,
		onChange: F,
		selected: f,
		noHeader: !0,
		required: !0
	}), n[32] = f, n[33] = r, n[34] = F, n[35] = I) : I = n[35];
	let L = `${r}-input-${f}`, R = `${r}-input`, z = f === q.FlatFee ? "currency" : "percent", B;
	n[36] === _ ? B = n[37] : (B = _?.toString(), n[36] = _, n[37] = B);
	let V = O ? "Enter commission rate" : void 0, H = f === q.FlatFee, U;
	n[38] !== s || n[39] !== L || n[40] !== R || n[41] !== z || n[42] !== B || n[43] !== V || n[44] !== H ? (U = /* @__PURE__ */ m(qs, {
		id: R,
		type: z,
		onChange: E,
		noHeader: !0,
		defaultValue: B,
		required: s,
		stretch: !0,
		errorText: V,
		noDecimalPoints: H
	}, L), n[38] = s, n[39] = L, n[40] = R, n[41] = z, n[42] = B, n[43] = V, n[44] = H, n[45] = U) : U = n[45];
	let W;
	n[46] !== P || n[47] !== I || n[48] !== U ? (W = /* @__PURE__ */ h(Ne, {
		id: P,
		gap: "spacing-lg",
		alignItems: "baseline",
		fill: !0,
		children: [I, U]
	}), n[46] = P, n[47] = I, n[48] = U, n[49] = W) : W = n[49];
	let G;
	n[50] !== N || n[51] !== W ? (G = /* @__PURE__ */ h(Me, {
		gap: "spacing-lg",
		fill: !0,
		children: [N, W]
	}), n[50] = N, n[51] = W, n[52] = G) : G = n[52];
	let K;
	n[53] === Symbol.for("react.memo_cache_sentinel") ? (K = /* @__PURE__ */ m(Q, {
		type: "body_ui",
		size: "small",
		id: "standardCommissionSubLabel",
		color: "var(--text-tertiary)",
		children: "Including GST"
	}), n[53] = K) : K = n[53];
	let J;
	return n[54] !== j || n[55] !== G ? (J = /* @__PURE__ */ h(Me, {
		id: j,
		gap: "spacing-xl",
		fill: !0,
		children: [G, K]
	}), n[54] = j, n[55] = G, n[56] = J) : J = n[56], J;
};
function Pu(e) {}
//#endregion
//#region src/formElements/ErrorLabel/ErrorLabel.tsx
var Fu = (t) => {
	let n = e(4), { id: r, errorText: i } = t;
	if (!i) return null;
	let a;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ m(Ti, {
		type: "danger",
		width: 16,
		height: 16
	}), n[0] = a) : a = n[0];
	let o = `error-${r}`, s;
	return n[1] !== i || n[2] !== o ? (s = /* @__PURE__ */ h(Ne, {
		gap: "spacing-sm",
		alignItems: "alignCenter",
		children: [a, /* @__PURE__ */ m(Q, {
			dataTestId: o,
			id: "",
			type: "form_error",
			size: "small",
			children: i
		})]
	}), n[1] = i, n[2] = o, n[3] = s) : s = n[3], s;
}, Iu = (t) => {
	let n = e(78), { row: r, rowNumber: i, numberOfRows: a, updateRowUpperBound: s, updateRowPercentage: c, deleteRow: l, onValidateStatusChange: u, required: d, error: g } = t, _ = u === void 0 ? Lu : u, { id: v, lowerBound: y, upperBound: b, percentageWithinBound: x } = r, S = i > 0 && i === a - 1, C = i <= 1, w = Na() === Aa.Mobile, T = v && g && g[v], E = ju(b?.toString()) === "" && !S ? "Upper Bound must be a valid number." : void 0, D = ju(x?.toString()) === "" ? "Percentage must be a valid number." : void 0, O, k;
	n[0] !== _ || n[1] !== D || n[2] !== T || n[3] !== E ? (O = () => {
		_(!(T || E || D));
	}, k = [
		T,
		E,
		D,
		_
	], n[0] = _, n[1] = D, n[2] = T, n[3] = E, n[4] = O, n[5] = k) : (O = n[4], k = n[5]), o(O, k);
	let A = `tieredCommission-${i}-lowerBound`, j = i === 0 && "Up to and including", M;
	n[6] !== y || n[7] !== a || n[8] !== i ? (M = i > 0 && /* @__PURE__ */ h(p, { children: [
		Ss(Number(y) + 1),
		" ",
		i < a - 1 && "to",
		i === a - 1 && "or more"
	] }), n[6] = y, n[7] = a, n[8] = i, n[9] = M) : M = n[9];
	let N;
	n[10] !== A || n[11] !== j || n[12] !== M ? (N = /* @__PURE__ */ h(Q, {
		id: A,
		type: "body_ui",
		size: "medium",
		children: [j, M]
	}), n[10] = A, n[11] = j, n[12] = M, n[13] = N) : N = n[13];
	let P = N, F;
	n[14] !== S || n[15] !== w || n[16] !== T || n[17] !== d || n[18] !== i || n[19] !== s || n[20] !== b || n[21] !== E ? (F = S ? null : /* @__PURE__ */ m(qs, {
		id: `UpperBound-${i + 1}`,
		type: "currency",
		noDecimalPoints: !0,
		noHeader: !0,
		onChange: (e) => s(i, e ?? void 0),
		defaultValue: b?.toString(),
		errorText: T ?? E,
		required: d,
		hideErrorDescription: !w,
		stretch: !0
	}, i), n[14] = S, n[15] = w, n[16] = T, n[17] = d, n[18] = i, n[19] = s, n[20] = b, n[21] = E, n[22] = F) : F = n[22];
	let I = F, L = `tieredCommission-${i}-at`, R;
	n[23] === L ? R = n[24] : (R = /* @__PURE__ */ m(Q, {
		id: L,
		type: "body_ui",
		size: "medium",
		children: "at"
	}), n[23] = L, n[24] = R);
	let z = R, B = `PercentageWithinBound-${i + 1}`, V;
	n[25] !== i || n[26] !== c ? (V = (e) => {
		c(i, e);
	}, n[25] = i, n[26] = c, n[27] = V) : V = n[27];
	let H;
	n[28] === x ? H = n[29] : (H = ju(x?.toString())?.toString() ?? "", n[28] = x, n[29] = H);
	let U;
	n[30] !== D || n[31] !== d || n[32] !== B || n[33] !== V || n[34] !== H ? (U = /* @__PURE__ */ m(qs, {
		id: B,
		noHeader: !0,
		type: "percent",
		onChange: V,
		defaultValue: H,
		required: d,
		errorText: D,
		hideErrorDescription: !0,
		size: "small"
	}), n[30] = D, n[31] = d, n[32] = B, n[33] = V, n[34] = H, n[35] = U) : U = n[35];
	let W = U, G;
	n[36] !== l || n[37] !== C || n[38] !== i ? (G = !C && /* @__PURE__ */ m(Kl, {
		id: `deleteRow-${i}`,
		onClick: () => l(i),
		variant: "naked",
		text: "",
		leftIcon: /* @__PURE__ */ m(Xi, {}),
		size: "small",
		minimal: !0
	}), n[36] = l, n[37] = C, n[38] = i, n[39] = G) : G = n[39];
	let K = G, q = S && "lastRow", J = w && "mobile", Y;
	n[40] !== q || n[41] !== J ? (Y = f("tiered-row-grid", q, J), n[40] = q, n[41] = J, n[42] = Y) : Y = n[42];
	let X;
	n[43] !== z || n[44] !== K || n[45] !== P || n[46] !== I || n[47] !== w || n[48] !== W ? (X = !w && /* @__PURE__ */ h(p, { children: [
		P,
		I,
		z,
		W,
		K
	] }), n[43] = z, n[44] = K, n[45] = P, n[46] = I, n[47] = w, n[48] = W, n[49] = X) : X = n[49];
	let Z;
	n[50] !== z || n[51] !== K || n[52] !== P || n[53] !== I || n[54] !== w || n[55] !== W ? (Z = w && /* @__PURE__ */ h(p, { children: [
		/* @__PURE__ */ h(Ne, {
			gap: "spacing-md",
			fill: !0,
			justifyContent: "space-between",
			alignItems: "alignCenter",
			children: [P, K]
		}),
		I,
		/* @__PURE__ */ h(Ne, {
			gap: "spacing-md",
			fill: !0,
			justifyContent: "space-between",
			alignItems: "alignCenter",
			children: [z, W]
		})
	] }), n[50] = z, n[51] = K, n[52] = P, n[53] = I, n[54] = w, n[55] = W, n[56] = Z) : Z = n[56];
	let ee;
	n[57] !== Y || n[58] !== X || n[59] !== Z ? (ee = /* @__PURE__ */ h("div", {
		className: Y,
		children: [X, Z]
	}), n[57] = Y, n[58] = X, n[59] = Z, n[60] = ee) : ee = n[60];
	let te;
	n[61] !== w || n[62] !== T || n[63] !== v || n[64] !== E ? (te = !w && !E && T && /* @__PURE__ */ m(Fu, {
		id: `tieredCommission-${v}-error`,
		errorText: T
	}), n[61] = w, n[62] = T, n[63] = v, n[64] = E, n[65] = te) : te = n[65];
	let ne;
	n[66] !== w || n[67] !== v || n[68] !== E ? (ne = !w && E && /* @__PURE__ */ m(Fu, {
		id: `tieredCommission-${v}-upperBound-error`,
		errorText: E
	}), n[66] = w, n[67] = v, n[68] = E, n[69] = ne) : ne = n[69];
	let re;
	n[70] !== D || n[71] !== v ? (re = D && /* @__PURE__ */ m(Fu, {
		id: `tieredCommission-${v}-percentage-error`,
		errorText: D
	}), n[70] = D, n[71] = v, n[72] = re) : re = n[72];
	let ie;
	return n[73] !== ee || n[74] !== te || n[75] !== ne || n[76] !== re ? (ie = /* @__PURE__ */ h(p, { children: [
		ee,
		te,
		ne,
		re
	] }), n[73] = ee, n[74] = te, n[75] = ne, n[76] = re, n[77] = ie) : ie = n[77], ie;
};
function Lu(e) {}
//#endregion
//#region src/formElements/Commission/CommissionPlan/TieredCommission/TieredCommission.tsx
var Ru = (e, t, n, r, i) => e ? `${i} of the actual sale price for a result achieved up to and including ${r}` : t ? `${i} of the actual sale price for any result achieved above ${n}` : `${i} of the actual sale price for a result achieved between ${n} and ${r}`, zu = (e, t, n, r, i) => e ? `${i} of the actual sale price for a result achieved up to and including ${r}` : t ? `A performance bonus of ${i} on any amount achieved over ${n}` : `${i} of any amount achieved between ${n} and ${r} inclusive`, Bu = [{
	label: "Single rate",
	value: se.SingleRate
}, {
	label: "Multi-rate",
	value: se.MultiRate
}], Vu = (e, t) => {
	if (!(t.length < 1)) return t.map((n, r) => {
		let { lowerBound: i, upperBound: a, percentageWithinBound: o } = n, s = r === 0, c = r === t.length - 1, l = i ? Ss(Number(i) + 1) : "$0.00", u = a ? Ss(a) : "$0.00", d = o ? `${Number(o).toFixed(2).replace(/\.?0+$/, "")}%` : "0%";
		return e === se.SingleRate ? Ru(s, c, l, u, d) : zu(s, c, l, u, d);
	});
}, Hu = [{
	lowerBound: 0,
	upperBound: 0,
	percentageWithinBound: 0,
	order: 0
}, {
	lowerBound: 0,
	upperBound: 0,
	percentageWithinBound: 0,
	order: 1
}], Uu = (e) => (e ?? Hu).map((e) => ({
	...e,
	id: S()
})), Wu = (e) => {
	let t = {};
	return e.forEach((e, n) => (n > 0 && e.upperBound && e.lowerBound && Number(e.upperBound) <= e.lowerBound && (t = {
		...t,
		[e.id ?? `row-${n}`]: `Value must be greater than ${e.lowerBound}`
	}), null)), t;
}, Gu = (t) => {
	let r = e(72), { id: i, onValueChanged: a, defaultValue: s, onValidateStatusChange: c, required: l, formName: u } = t, f = c === void 0 ? Ku : c, [p, g] = d(s?.tieredSystemType ?? se.SingleRate), _;
	r[0] === s?.rows ? _ = r[1] : (_ = () => Uu(s?.rows), r[0] = s?.rows, r[1] = _);
	let [v, y] = d(_), b;
	r[2] === Symbol.for("react.memo_cache_sentinel") ? (b = {}, r[2] = b) : b = r[2];
	let [x, C] = d(b), w;
	r[3] === Symbol.for("react.memo_cache_sentinel") ? (w = {}, r[3] = w) : w = r[3];
	let [T, E] = d(w), D, O;
	r[4] === v ? (D = r[5], O = r[6]) : (D = () => {
		C(Wu(v));
	}, O = [v, C], r[4] = v, r[5] = D, r[6] = O), o(D, O);
	let k;
	r[7] === x ? k = r[8] : (k = Object.keys(x), r[7] = x, r[8] = k);
	let A = k.length > 0, j = Object.values(T).some(qu), M = A || j, N, P;
	r[9] !== M || r[10] !== f ? (N = () => {
		f(!M);
	}, P = [M, f], r[9] = M, r[10] = f, r[11] = N, r[12] = P) : (N = r[11], P = r[12]), o(N, P);
	let F;
	r[13] !== s?.rows || r[14] !== s?.tieredSystemType || r[15] !== M || r[16] !== i || r[17] !== a || r[18] !== p || r[19] !== v ? (F = () => {
		M || s?.tieredSystemType === p && s?.rows?.length === v.length && s?.rows?.every((e, t) => e.lowerBound === v[t].lowerBound && e.upperBound === v[t].upperBound && e.percentageWithinBound === v[t].percentageWithinBound && e.order === v[t].order) || a({
			id: i,
			value: {
				rows: v.map(Ju),
				tieredSystemType: p
			}
		});
	}, r[13] = s?.rows, r[14] = s?.tieredSystemType, r[15] = M, r[16] = i, r[17] = a, r[18] = p, r[19] = v, r[20] = F) : F = r[20];
	let I;
	r[21] !== s || r[22] !== M || r[23] !== i || r[24] !== a || r[25] !== p || r[26] !== v ? (I = [
		i,
		a,
		v,
		p,
		M,
		s
	], r[21] = s, r[22] = M, r[23] = i, r[24] = a, r[25] = p, r[26] = v, r[27] = I) : I = r[27], o(F, I);
	let L;
	r[28] === v ? L = r[29] : (L = (e, t) => {
		let n = Number(t?.replaceAll(",", "") ?? 0), r = [...v];
		r[e] = {
			...r[e],
			upperBound: n
		}, r.length >= e + 2 && (r[e + 1] = {
			...r[e + 1],
			lowerBound: n ?? 0,
			upperBound: r[e + 1].upperBound
		}), y(r);
	}, r[28] = v, r[29] = L);
	let R = L, z;
	r[30] === v ? z = r[31] : (z = (e, t) => {
		let n = t !== void 0 && t !== "" ? parseFloat(t) : void 0, r = [...v];
		r[e] = {
			...r[e],
			percentageWithinBound: n ?? 0
		}, y(r);
	}, r[30] = v, r[31] = z);
	let B = z, V;
	r[32] === v ? V = r[33] : (V = () => {
		let e = v[v.length - 1], t = {
			id: S(),
			lowerBound: v.length === 1 ? Number(e.upperBound) : 0,
			upperBound: void 0,
			percentageWithinBound: 0,
			order: v.length
		};
		y([...v, t]);
	}, r[32] = v, r[33] = V);
	let H = V, U;
	r[34] === v ? U = r[35] : (U = (e) => {
		let t = [...v];
		t.splice(e, 1), t.length > 1 && (t[t.length - 1] = {
			...t[t.length - 1],
			upperBound: void 0
		}), y(t);
	}, r[34] = v, r[35] = U);
	let W = U, G;
	if (r[36] !== H || r[37] !== W || r[38] !== x || r[39] !== u || r[40] !== i || r[41] !== l || r[42] !== p || r[43] !== v || r[44] !== B || r[45] !== R) {
		let e = Vu(p, v), t = `${i}-commission-structure`, a;
		r[47] === t ? a = r[48] : (a = /* @__PURE__ */ m(Q, {
			id: t,
			type: "label",
			size: "medium",
			color: "var(--text-primary)",
			children: "Commission Structure"
		}), r[47] = t, r[48] = a);
		let o;
		r[49] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m(Ja, { variant: "horizontal" }), r[49] = o) : o = r[49];
		let s;
		if (r[50] !== W || r[51] !== x || r[52] !== l || r[53] !== v || r[54] !== B || r[55] !== R) {
			let e;
			r[57] !== W || r[58] !== x || r[59] !== l || r[60] !== v.length || r[61] !== B || r[62] !== R ? (e = (e, t) => /* @__PURE__ */ h(n, { children: [/* @__PURE__ */ m(Iu, {
				row: e,
				rowNumber: t,
				numberOfRows: v.length,
				updateRowUpperBound: R,
				updateRowPercentage: B,
				deleteRow: W,
				required: l,
				error: x,
				onValidateStatusChange: (n) => {
					E((r) => {
						let i = e.id ?? `row-${t}`;
						return r[i] === n ? r : {
							...r,
							[i]: n
						};
					});
				}
			}, e.id), t !== v.length - 1 && /* @__PURE__ */ m(Ja, { variant: "horizontal" })] }, e.id), r[57] = W, r[58] = x, r[59] = l, r[60] = v.length, r[61] = B, r[62] = R, r[63] = e) : e = r[63], s = v.map(e), r[50] = W, r[51] = x, r[52] = l, r[53] = v, r[54] = B, r[55] = R, r[56] = s;
		} else s = r[56];
		let c;
		r[64] === Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m(Ja, { variant: "horizontal" }), r[64] = c) : c = r[64];
		let d;
		r[65] === H ? d = r[66] : (d = /* @__PURE__ */ m(Kl, {
			id: "addrowbutton",
			text: "Add row",
			onClick: H,
			variant: "primary",
			size: "medium"
		}), r[65] = H, r[66] = d);
		let f;
		r[67] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ m(Ja, { variant: "horizontal" }), r[67] = f) : f = r[67];
		let _ = `${i}-tierType`, y;
		r[68] === Symbol.for("react.memo_cache_sentinel") ? (y = (e) => g(e), r[68] = y) : y = r[68];
		let b;
		r[69] !== _ || r[70] !== p ? (b = /* @__PURE__ */ m(bs, {
			id: _,
			layout: "vertical",
			options: Bu,
			value: p,
			onChange: y,
			label: "Tier System"
		}), r[69] = _, r[70] = p, r[71] = b) : b = r[71], G = /* @__PURE__ */ h(Me, {
			gap: "spacing-xl",
			fill: !0,
			children: [
				a,
				o,
				s,
				c,
				d,
				f,
				b,
				e && /* @__PURE__ */ h(Me, {
					gap: "spacing-sm",
					children: [
						/* @__PURE__ */ m(Q, {
							id: "example-text",
							type: "body_ui",
							size: "small",
							color: "var(--text-tertiary)",
							children: `This will appear on the ${u} as:`
						}),
						/* @__PURE__ */ m("br", {}),
						e.map(Yu)
					]
				})
			]
		}), r[36] = H, r[37] = W, r[38] = x, r[39] = u, r[40] = i, r[41] = l, r[42] = p, r[43] = v, r[44] = B, r[45] = R, r[46] = G;
	} else G = r[46];
	return G;
};
function Ku(e) {}
function qu(e) {
	return !e;
}
function Ju(e, t) {
	return {
		...e,
		lowerBound: e.lowerBound === void 0 ? 0 : e.lowerBound,
		upperBound: e.upperBound === void 0 ? 0 : e.upperBound,
		percentageWithinBound: e.percentageWithinBound === void 0 ? 0 : e.percentageWithinBound,
		order: t
	};
}
function Yu(e, t) {
	return /* @__PURE__ */ m(Q, {
		id: "example-text",
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: e
	}, `caption-${t}`);
}
//#endregion
//#region src/formElements/Commission/CommissionPlan/VendorChoice/VendorChoice.tsx
var Xu = [{
	label: ce.Percentage,
	value: ce.Percentage
}, {
	label: ce.Dollar,
	value: ce.Dollar
}], Zu = (e, t) => {
	if (!e && !t) return "Min and Max Commission must not be empty";
	if (!e && t) return "Min Commission must not be empty";
	if (e && t && t <= e) return "Max commission must be greater than Min commission";
}, Qu = ({ id: e, onValueChanged: t, defaultValue: n, showCommissionRangeDisclaimer: r, onValidateStatusChange: i = (e) => {} }) => {
	let a = Na() === Aa.Mobile, [s, c] = d(() => n?.minCommission), [l, u] = d(() => n?.maxCommission), [f, g] = d(void 0);
	o(() => {
		i(!f);
	}, [f, i]);
	let [_, v] = d(() => n?.valueType ?? ce.Dollar), y = (e) => {
		let t = e;
		t !== _ && (v(t), s !== void 0 && c(void 0), l !== void 0 && u(void 0));
	};
	o(() => {
		g(Zu(s, l));
	}, [s, l]), o(() => {
		f || (n?.minCommission ?? 0) === (s ?? 0) && (n?.maxCommission ?? 0) === (l ?? 0) && (n?.valueType ?? 0) === (_ ?? 0) || t({
			id: e,
			value: {
				minCommission: s || 0,
				maxCommission: l || 0,
				valueType: _
			}
		});
	}, [
		s,
		l,
		_,
		f,
		e,
		t,
		n
	]);
	let b = /* @__PURE__ */ m(Ec, {
		options: Xu,
		id: `select-${e}`,
		selected: _,
		onChange: y,
		label: "Dollar/Percentage",
		required: !0,
		hideOptionalText: !0
	}), x = /* @__PURE__ */ m(qs, {
		type: _ === ce.Dollar ? "currency" : "percent",
		id: "minCommission",
		hideOptionalText: !0,
		label: "Min Commission",
		onChange: (e) => {
			let t = ju(e.replaceAll(",", "")), n = t === "" ? 0 : t;
			n !== s && c(n);
		},
		defaultValue: s?.toString() ?? "",
		errorText: f,
		hideErrorDescription: !0,
		stretch: !0,
		noDecimalPoints: _ === ce.Dollar
	}, `min-${e}-${_ === ce.Dollar ? "dollar" : "percent"}`), S = /* @__PURE__ */ m(Me, {
		alignItems: "alignCenter",
		children: /* @__PURE__ */ m(Q, {
			id: `commission-structure-${e}-to-label`,
			type: "body_ui",
			size: "medium",
			color: "var(--text-primary)",
			style: { transform: a ? "translateY(var(--spacing-5xl))" : "translateY(calc(-1 * var(--spacing-md)))" },
			children: "to"
		})
	}), C = /* @__PURE__ */ m(qs, {
		type: _ === ce.Dollar ? "currency" : "percent",
		id: "maxCommission",
		hideOptionalText: !0,
		label: "Max Commission",
		onChange: (e) => {
			let t = ju(e.replaceAll(",", "")), n = t === "" ? 0 : t;
			n !== l && u(n);
		},
		defaultValue: l?.toString() ?? "",
		errorText: f,
		hideErrorDescription: !0,
		stretch: !0,
		noDecimalPoints: _ === ce.Dollar
	}, `max-${e}-${_ === ce.Dollar ? "dollar" : "percent"}`);
	return /* @__PURE__ */ m(p, { children: /* @__PURE__ */ h(Me, {
		fill: !0,
		gap: "spacing-xl",
		children: [
			/* @__PURE__ */ m(Q, {
				id: `commission-structure-${e}-label`,
				type: "label",
				size: "medium",
				color: "var(--text-primary)",
				children: "Commission Structure"
			}),
			/* @__PURE__ */ m(Ja, { variant: "horizontal" }),
			!a && /* @__PURE__ */ h(Ne, {
				gap: "spacing-md",
				alignItems: "flex-end",
				fill: !0,
				children: [
					b,
					x,
					S,
					C
				]
			}),
			a && /* @__PURE__ */ h(Me, {
				gap: "spacing-xl",
				fill: !0,
				children: [b, /* @__PURE__ */ h(Ne, {
					gap: "spacing-md",
					alignItems: "baseline",
					fill: !0,
					children: [
						x,
						S,
						C
					]
				})]
			}),
			f && /* @__PURE__ */ m(Fu, {
				errorText: f,
				id: `error-${e}`
			}),
			r && /* @__PURE__ */ m(Q, {
				id: `commission-structure-${e}-disclaimer`,
				type: "body_ui",
				size: "small",
				color: "var(--text-tertiary)",
				children: `A fee range of between ${_ === ce.Dollar ? Ss(s ?? 0) : `${gu((s ?? 0).toString())}%`} and ${_ === ce.Dollar ? Ss(l ?? 0) : `${gu((l ?? 0).toString())}%`} inclusive of GST to be determined by you once the sale contract has become unconditional. It is to be based on your level of satisfaction with the level of service experience and result we achieve.`
			})
		]
	}) });
}, $u = [
	{
		label: "Standard",
		value: Ou.Flat
	},
	{
		label: "Tiered Commission",
		value: Ou.Tiered
	},
	{
		label: "Vendor Choice",
		value: Ou.VendorChoice
	},
	{
		label: "Other",
		value: Ou.Other
	}
], ed = (e) => {
	if (e?.flatCommission !== void 0) return Ou.Flat;
	if (e?.tieredCommission !== void 0) return Ou.Tiered;
	if (e?.vendorChoice !== void 0) return Ou.VendorChoice;
}, td = (t) => {
	let n = e(53), { id: r, commissionTypes: i, onValueChanged: a, defaultValue: s, required: c, formName: l, showCommissionRangeDisclaimer: u, onValidateStatusChange: f } = t, p = c === void 0 ? !1 : c, g = u === void 0 ? !1 : u, _ = f === void 0 ? nd : f, v;
	n[0] === i ? v = n[1] : (v = $u.filter((e) => i.includes(e.value)), n[0] = i, n[1] = v);
	let y = v, b;
	n[2] === s ? b = n[3] : (b = () => ed(s), n[2] = s, n[3] = b);
	let [x, S] = d(b), C;
	n[4] === s ? C = n[5] : (C = () => s ?? {}, n[4] = s, n[5] = C);
	let [w, T] = d(C), E, D;
	n[6] !== w || n[7] !== r || n[8] !== a || n[9] !== x ? (E = () => {
		let e = {};
		bb25: switch (x) {
			case Ou.Flat:
				e.flatCommission = w.flatCommission;
				break bb25;
			case Ou.Tiered:
				e.tieredCommission = w.tieredCommission;
				break bb25;
			case Ou.VendorChoice: e.vendorChoice = w.vendorChoice;
		}
		a({
			id: r,
			value: e
		});
	}, D = [
		r,
		a,
		w,
		x
	], n[6] = w, n[7] = r, n[8] = a, n[9] = x, n[10] = E, n[11] = D) : (E = n[10], D = n[11]), o(E, D);
	let O;
	n[12] === x ? O = n[13] : (O = (e) => {
		e !== x && S(e);
	}, n[12] = x, n[13] = O);
	let k = O, [A, j] = d(!0), M, N;
	n[14] !== A || n[15] !== _ ? (M = () => {
		_(A);
	}, N = [A, _], n[14] = A, n[15] = _, n[16] = M, n[17] = N) : (M = n[16], N = n[17]), o(M, N);
	let P;
	n[18] === Symbol.for("react.memo_cache_sentinel") ? (P = (e) => {
		T((t) => ({
			...t,
			flatCommission: e?.value
		}));
	}, n[18] = P) : P = n[18];
	let F = P, I;
	n[19] === Symbol.for("react.memo_cache_sentinel") ? (I = (e) => {
		T((t) => ({
			...t,
			tieredCommission: e?.value
		}));
	}, n[19] = I) : I = n[19];
	let L = I, R;
	n[20] === Symbol.for("react.memo_cache_sentinel") ? (R = (e) => {
		T((t) => ({
			...t,
			vendorChoice: e?.value
		}));
	}, n[20] = R) : R = n[20];
	let z = R, B, V;
	n[21] === Symbol.for("react.memo_cache_sentinel") ? (B = /* @__PURE__ */ m(Q, {
		type: "body_ui_strong",
		size: "medium",
		id: "commissionPlanLabel",
		color: "var(--text-primary)",
		children: "Commission Plan"
	}), V = /* @__PURE__ */ m(Q, {
		type: "body_ui",
		size: "small",
		id: "commissionPlanSubLabel",
		color: "var(--text-tertiary)",
		children: "All percentages and figures are inclusive of GST"
	}), n[21] = B, n[22] = V) : (B = n[21], V = n[22]);
	let H = x ?? "", U;
	n[23] === Symbol.for("react.memo_cache_sentinel") ? (U = {
		top: "spacing-2xl",
		bottom: "spacing-2xl",
		left: "spacing-lg",
		right: "spacing-lg"
	}, n[23] = U) : U = n[23];
	let W;
	n[24] !== w || n[25] !== r || n[26] !== p || n[27] !== x ? (W = x === Ou.Flat && /* @__PURE__ */ m(Nu, {
		id: `${r}-standardCommission`,
		onValueChanged: F,
		defaultValue: w.flatCommission,
		required: p,
		onValidateStatusChange: (e) => j(e)
	}, `${r}-standardCommission`), n[24] = w, n[25] = r, n[26] = p, n[27] = x, n[28] = W) : W = n[28];
	let G;
	n[29] !== w || n[30] !== l || n[31] !== r || n[32] !== p || n[33] !== x ? (G = x === Ou.Tiered && /* @__PURE__ */ m(Gu, {
		id: `${r}-tieredCommission`,
		onValueChanged: L,
		defaultValue: w.tieredCommission,
		required: p,
		formName: l,
		onValidateStatusChange: (e) => j(e)
	}, `${r}-tieredCommission`), n[29] = w, n[30] = l, n[31] = r, n[32] = p, n[33] = x, n[34] = G) : G = n[34];
	let K;
	n[35] !== w || n[36] !== r || n[37] !== p || n[38] !== x || n[39] !== g ? (K = x === Ou.VendorChoice && /* @__PURE__ */ m(Qu, {
		id: `${r}-vendorChoiceCommission`,
		onValueChanged: z,
		defaultValue: w.vendorChoice,
		required: p,
		showCommissionRangeDisclaimer: g,
		onValidateStatusChange: (e) => j(e)
	}, `${r}-vendorChoiceCommission`), n[35] = w, n[36] = r, n[37] = p, n[38] = x, n[39] = g, n[40] = K) : K = n[40];
	let q;
	n[41] !== W || n[42] !== G || n[43] !== K ? (q = /* @__PURE__ */ h(Me, {
		padding: U,
		fill: !0,
		children: [
			W,
			G,
			K
		]
	}, "planTypeContent"), n[41] = W, n[42] = G, n[43] = K, n[44] = q) : q = n[44];
	let J;
	n[45] !== y || n[46] !== k || n[47] !== H || n[48] !== q ? (J = /* @__PURE__ */ m(bs, {
		id: "commissionPlanRadioGroup",
		layout: "vertical",
		options: y,
		value: H,
		onChange: k,
		subContent: q
	}), n[45] = y, n[46] = k, n[47] = H, n[48] = q, n[49] = J) : J = n[49];
	let Y;
	return n[50] !== r || n[51] !== J ? (Y = /* @__PURE__ */ h(Me, {
		gap: "spacing-ml",
		id: r,
		fill: !0,
		children: [
			B,
			V,
			J
		]
	}), n[50] = r, n[51] = J, n[52] = Y) : Y = n[52], Y;
};
function nd(e) {}
//#endregion
//#region src/formElements/Commission/common.tsx
var rd = {
	Flat: {
		Percentage: "Standard - Percentage",
		Flat: "Standard - Flat Rate"
	},
	Tiered: {
		Single: "Tiered Commission - Single rate",
		Multi: "Tiered Commission - Multi-rate"
	},
	VendorChoice: { Default: "Vendor Choice" }
}, id = (e, t) => !e || e.length === 0 || !t ? [] : e.length === 1 ? e.map((e) => `${e.percentageWithinBound}%`) : e.map(({ lowerBound: n = 0, upperBound: r = 0, percentageWithinBound: i = 0 }, a) => {
	if (a === 0) return `Tier ${a + 1}: Up to and including ${Ss(r, 0)} at ${i}%`;
	if (a === e.length - 1) {
		if (t === se.SingleRate) return `Tier ${a + 1}: ${Ss(n, 0)} or more at ${i}%`;
		if (t === se.MultiRate) return `Bonus: For every amount over ${Ss(n ?? 0, 0)} - ${i}% bonus`;
	}
	return `Tier ${a + 1}: ${Ss(n, 0)} to ${Ss(r, 0)} at ${i}%`;
}), ad = (t) => {
	let n = e(27);
	if (!t) {
		let e;
		return n[0] === Symbol.for("react.memo_cache_sentinel") ? (e = [void 0, void 0], n[0] = e) : e = n[0], e;
	}
	let { flatCommission: r, tieredCommission: i, vendorChoice: a } = t;
	if (r) {
		if (r.flatCommissionType === q.Percentage) {
			let e = `${r.amount}% (inc GST)`, t;
			return n[1] === e ? t = n[2] : (t = [rd.Flat.Percentage, e], n[1] = e, n[2] = t), t;
		}
		if (r.flatCommissionType === q.FlatFee) {
			let e;
			n[3] === r.amount ? e = n[4] : (e = r.amount ? `${Ss(r.amount, 0)} (inc GST)` : "-", n[3] = r.amount, n[4] = e);
			let t;
			return n[5] === e ? t = n[6] : (t = [rd.Flat.Flat, e], n[5] = e, n[6] = t), t;
		}
	}
	if (i) {
		let { tieredSystemType: e, rows: t } = i, r, a, o;
		if (n[7] !== t || n[8] !== e) {
			let i = t === void 0 ? [] : t;
			o = e === se.SingleRate ? rd.Tiered.Single : e === se.MultiRate ? rd.Tiered.Multi : void 0;
			let s = id(i, e);
			r = od, a = s.map(sd), n[7] = t, n[8] = e, n[9] = r, n[10] = a, n[11] = o;
		} else r = n[9], a = n[10], o = n[11];
		let s;
		n[12] !== r || n[13] !== a ? (s = /* @__PURE__ */ m(r, { children: a }), n[12] = r, n[13] = a, n[14] = s) : s = n[14];
		let c = s, l;
		return n[15] !== c || n[16] !== o ? (l = [o, c], n[15] = c, n[16] = o, n[17] = l) : l = n[17], l;
	}
	if (a) {
		if (a.valueType === ce.Percentage) {
			let e = `${a.minCommission}% to ${a.maxCommission}% (inc GST)`, t;
			return n[18] === e ? t = n[19] : (t = ["Vendor Choice", e], n[18] = e, n[19] = t), t;
		}
		if (a.valueType === ce.Dollar) {
			let e = a.minCommission ?? 0, t;
			n[20] === e ? t = n[21] : (t = Ss(e, 0), n[20] = e, n[21] = t);
			let r = a.maxCommission ?? 0, i;
			n[22] === r ? i = n[23] : (i = Ss(r, 0), n[22] = r, n[23] = i);
			let o = `${t} to ${i} (inc GST)`, s;
			return n[24] === o ? s = n[25] : (s = ["Vendor Choice", o], n[24] = o, n[25] = s), s;
		}
	}
	let o;
	return n[26] === Symbol.for("react.memo_cache_sentinel") ? (o = [void 0, void 0], n[26] = o) : o = n[26], o;
}, od = (t) => {
	let n = e(2), { children: r } = t, i;
	return n[0] === r ? i = n[1] : (i = /* @__PURE__ */ m("ul", {
		className: "bulletList",
		children: r
	}), n[0] = r, n[1] = i), i;
};
function sd(e, t) {
	return /* @__PURE__ */ m("li", { children: e }, t);
}
//#endregion
//#region src/formElements/Commission/CommissionTableView/CommissionTableView.tsx
var cd = (e) => {
	let [t, n] = ad(e);
	return {
		Type: t || "Commission not set",
		Rate: n || "-"
	};
}, ld = (t) => {
	let n = e(12), { currentCommissionDetails: r } = t, i;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (i = [{ name: "Type" }, { name: "Rate" }], n[0] = i) : i = n[0];
	let a = i, o;
	n[1] === r ? o = n[2] : (o = cd(r), n[1] = r, n[2] = o);
	let s = o, c;
	n[3] === s.Type ? c = n[4] : (c = /* @__PURE__ */ m(Q, {
		id: "type",
		type: "body_ui",
		size: "small",
		color: "var(--text-primary)",
		children: s.Type
	}), n[3] = s.Type, n[4] = c);
	let l;
	n[5] === s.Rate ? l = n[6] : (l = /* @__PURE__ */ m(Q, {
		id: "rate",
		type: "body_ui",
		size: "small",
		color: "var(--text-secondary)",
		children: s.Rate
	}), n[5] = s.Rate, n[6] = l);
	let u;
	n[7] !== c || n[8] !== l ? (u = {
		noHover: !0,
		Type: c,
		Rate: l
	}, n[7] = c, n[8] = l, n[9] = u) : u = n[9];
	let d = u, f;
	return n[10] === d ? f = n[11] : (f = /* @__PURE__ */ m(to, {
		variant: "minimal",
		tableStyle: "rounded",
		headerBg: "var(--bg-tag-light-grey)",
		bodyBg: "var(--bg-primary)",
		columns: a,
		rows: [d]
	}), n[10] = d, n[11] = f), f;
}, ud = (t) => {
	let n = e(15), { currentServiceFeeDetails: r, partnershipLevel: i } = t, a;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (a = [{ name: "Partnership_Tier" }, { name: "UX_Service_Fee" }], n[0] = a) : a = n[0];
	let o = a, s = i || g.Bronze, c;
	n[1] === s ? c = n[2] : (c = /* @__PURE__ */ m(Ui, {
		partnershipLevel: s,
		color: "var(--text-primary)",
		height: 16,
		width: 16
	}), n[1] = s, n[2] = c);
	let l = i || g.Bronze, u;
	n[3] === l ? u = n[4] : (u = /* @__PURE__ */ m(Q, {
		id: "type",
		type: "body_ui",
		size: "small",
		color: "var(--text-primary)",
		children: l
	}), n[3] = l, n[4] = u);
	let d;
	n[5] !== c || n[6] !== u ? (d = /* @__PURE__ */ h(Ne, {
		gap: "spacing-sm",
		alignItems: "alignCenter",
		fill: !0,
		children: [c, u]
	}), n[5] = c, n[6] = u, n[7] = d) : d = n[7];
	let f = r?.serviceFeePercentage ?? "10", p;
	n[8] === f ? p = n[9] : (p = /* @__PURE__ */ h(Q, {
		id: "rate",
		type: "body_ui",
		size: "small",
		color: "var(--text-secondary)",
		children: [f, "%"]
	}), n[8] = f, n[9] = p);
	let _;
	n[10] !== d || n[11] !== p ? (_ = {
		noHover: !0,
		Partnership_Tier: d,
		UX_Service_Fee: p
	}, n[10] = d, n[11] = p, n[12] = _) : _ = n[12];
	let v = _, y;
	return n[13] === v ? y = n[14] : (y = /* @__PURE__ */ m(to, {
		variant: "minimal",
		tableStyle: "rounded",
		headerBg: "var(--bg-tag-light-grey)",
		bodyBg: "var(--bg-primary)",
		columns: o,
		rows: [v]
	}), n[13] = v, n[14] = y), y;
}, dd = (t) => {
	let n = e(29), { variant: r, updatedBy: i, updatedAt: a, updateReason: o, children: s } = t, c;
	n[0] === a ? c = n[1] : (c = a ? (0, So.default)(a).format("h:mmA, D/MM/YYYY") : "-", n[0] = a, n[1] = c);
	let l = c, u = Ia(), d = r === "current" ? "green" : "grey", f = r === "current" ? "Current" : "Previous", p;
	n[2] !== d || n[3] !== f ? (p = /* @__PURE__ */ m(_o, {
		size: "md",
		type: "colourfill",
		colour: d,
		text: f
	}), n[2] = d, n[3] = f, n[4] = p) : p = n[4];
	let g;
	n[5] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ m(Ja, { variant: "horizontal" }), n[5] = g) : g = n[5];
	let _;
	n[6] === Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ m(Q, {
		id: "submissionDetailUpdatedByTitle",
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: "Updated by"
	}), n[6] = _) : _ = n[6];
	let v;
	n[7] !== u || n[8] !== i ? (v = u(i)?.name?.fullName || "-", n[7] = u, n[8] = i, n[9] = v) : v = n[9];
	let y = i || "-", b;
	n[10] === y ? b = n[11] : (b = /* @__PURE__ */ h(Q, {
		id: "submissionDetailUpdatedBy",
		type: "body_ui",
		color: "var(--text-tertiary)",
		size: "small",
		children: [
			"(",
			y,
			")"
		]
	}), n[10] = y, n[11] = b);
	let x;
	n[12] !== v || n[13] !== b ? (x = /* @__PURE__ */ h(Q, {
		id: "submissionDetailUpdatedBy",
		type: "body_ui",
		color: "var(--text-primary)",
		size: "small",
		children: [
			v,
			" ",
			b
		]
	}), n[12] = v, n[13] = b, n[14] = x) : x = n[14];
	let S;
	n[15] === l ? S = n[16] : (S = /* @__PURE__ */ m(Q, {
		id: "submissionDetailUpdatedAt",
		type: "caption",
		color: "var(--text-primary)",
		size: "medium",
		children: l
	}), n[15] = l, n[16] = S);
	let C;
	n[17] !== x || n[18] !== S ? (C = /* @__PURE__ */ h(Me, {
		gap: "spacing-ml",
		fill: !0,
		children: [_, /* @__PURE__ */ h(Ne, {
			gap: "spacing-ml",
			alignItems: "alignCenter",
			justifyContent: "space-between",
			fill: !0,
			children: [x, S]
		})]
	}), n[17] = x, n[18] = S, n[19] = C) : C = n[19];
	let w;
	n[20] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ m(Ja, { variant: "horizontal" }), n[20] = w) : w = n[20];
	let T;
	n[21] === Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ m(Q, {
		id: "submissionDetailReasonTitle",
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: "Reason"
	}), n[21] = T) : T = n[21];
	let E = o || "-", D;
	n[22] === E ? D = n[23] : (D = /* @__PURE__ */ h(Me, {
		gap: "spacing-ml",
		fill: !0,
		children: [T, /* @__PURE__ */ m(Q, {
			id: "submissionDetailReason",
			type: "body_ui",
			color: "var(--text-primary)",
			size: "small",
			children: E
		})]
	}), n[22] = E, n[23] = D);
	let O;
	return n[24] !== s || n[25] !== C || n[26] !== D || n[27] !== p ? (O = /* @__PURE__ */ h("div", {
		className: "submissionDetail",
		children: [
			p,
			s,
			g,
			C,
			w,
			D
		]
	}), n[24] = s, n[25] = C, n[26] = D, n[27] = p, n[28] = O) : O = n[28], O;
}, fd = (e, t) => {
	switch (e) {
		case R.AgentSpecified: return "Agent Specified";
		case R.CommissionReduction: return "Commission Reduction";
		case R.Other: return t || "Other";
		default: return "N/A";
	}
}, pd = (t) => {
	let n = e(23), { currentCommissionDetails: r, isCurrent: i } = t, a = i === void 0 ? !1 : i, o = r?.changeInfo, s = o?.changedAt, c = o?.changedByUserId, l = o?.changeType, u = o?.reason || "", d;
	n[0] !== l || n[1] !== u ? (d = fd(l, u), n[0] = l, n[1] = u, n[2] = d) : d = n[2];
	let f = d, p;
	n[3] === r?.commissionDetails ? p = n[4] : (p = r?.commissionDetails || {}, n[3] = r?.commissionDetails, n[4] = p);
	let g;
	n[5] === p ? g = n[6] : (g = ad(p), n[5] = p, n[6] = g);
	let [_, v] = g, y;
	n[7] === s ? y = n[8] : (y = (0, So.default)(s), n[7] = s, n[8] = y);
	let b = y, x = a ? "current" : "previous", S;
	n[9] === Symbol.for("react.memo_cache_sentinel") ? (S = /* @__PURE__ */ m(Q, {
		id: "currentCommissionTypeTitle",
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: "Type"
	}), n[9] = S) : S = n[9];
	let C;
	n[10] === _ ? C = n[11] : (C = /* @__PURE__ */ h(Me, {
		gap: "spacing-ml",
		fill: !0,
		children: [S, /* @__PURE__ */ m(Q, {
			id: "currentCommissionType",
			type: "body_ui_strong",
			color: "var(--text-primary)",
			size: "medium",
			children: _
		})]
	}), n[10] = _, n[11] = C);
	let w;
	n[12] === Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ m(Ja, { variant: "horizontal" }), n[12] = w) : w = n[12];
	let T;
	n[13] === Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ m(Q, {
		id: "currentCommissionRateTitle",
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: "Rate"
	}), n[13] = T) : T = n[13];
	let E;
	n[14] === v ? E = n[15] : (E = /* @__PURE__ */ h(Me, {
		gap: "spacing-ml",
		fill: !0,
		children: [T, /* @__PURE__ */ m(Q, {
			id: "currentCommissionRate",
			type: "body_ui",
			color: "var(--text-primary)",
			size: "medium",
			children: v
		})]
	}), n[14] = v, n[15] = E);
	let D;
	return n[16] !== f || n[17] !== c || n[18] !== E || n[19] !== x || n[20] !== C || n[21] !== b ? (D = /* @__PURE__ */ h(dd, {
		variant: x,
		updateReason: f,
		updatedAt: b,
		updatedBy: c,
		children: [
			C,
			w,
			E
		]
	}), n[16] = f, n[17] = c, n[18] = E, n[19] = x, n[20] = C, n[21] = b, n[22] = D) : D = n[22], D;
}, md = (t) => {
	let n = e(9), { commission: r } = t, i;
	n[0] === r ? i = n[1] : (i = r || {}, n[0] = r, n[1] = i);
	let { currentCommissionDetails: a, historicalCommissionDetails: o } = i, s;
	n[2] === a ? s = n[3] : (s = a && /* @__PURE__ */ m(pd, {
		currentCommissionDetails: a,
		isCurrent: !0
	}), n[2] = a, n[3] = s);
	let c;
	n[4] === o ? c = n[5] : (c = o?.map(hd), n[4] = o, n[5] = c);
	let l;
	return n[6] !== s || n[7] !== c ? (l = /* @__PURE__ */ h(Me, {
		gap: "spacing-xl",
		fill: !0,
		children: [s, c]
	}), n[6] = s, n[7] = c, n[8] = l) : l = n[8], l;
};
function hd(e, t) {
	return /* @__PURE__ */ m(pd, { currentCommissionDetails: e }, t);
}
//#endregion
//#region src/formElements/Commission/ServiceFeePanel/ServiceFeePanel.tsx
var gd = (e, t) => {
	switch (e) {
		case re.UrbanXError: return "UrbanX Error";
		case re.FreeSale: return "Free Sale";
		case re.Other: return t || "Other";
		default: return "N/A";
	}
}, _d = (t) => {
	let n = e(14), { currentServiceFeeDetails: r, isCurrent: i } = t, a = i === void 0 ? !1 : i, o = r?.changeInfo, s = o?.changedAt, c = o?.changedByUserId, l = o?.changeType, u = o?.reason || "", d;
	n[0] !== l || n[1] !== u ? (d = gd(l, u), n[0] = l, n[1] = u, n[2] = d) : d = n[2];
	let f = d, p;
	n[3] === s ? p = n[4] : (p = (0, So.default)(s), n[3] = s, n[4] = p);
	let g = p, _ = a ? "current" : "previous", v;
	n[5] === Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ m(Q, {
		id: "currentCommissionTypeTitle",
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: "Service Fee Percentage"
	}), n[5] = v) : v = n[5];
	let y = r?.serviceFeePercentage ?? "0", b;
	n[6] === y ? b = n[7] : (b = /* @__PURE__ */ h(Me, {
		gap: "spacing-ml",
		fill: !0,
		children: [v, /* @__PURE__ */ h(Q, {
			id: "currentCommissionType",
			type: "body_ui_strong",
			color: "var(--text-primary)",
			size: "medium",
			children: [y, "%"]
		})]
	}), n[6] = y, n[7] = b);
	let x;
	return n[8] !== f || n[9] !== c || n[10] !== _ || n[11] !== b || n[12] !== g ? (x = /* @__PURE__ */ m(dd, {
		variant: _,
		updateReason: f,
		updatedAt: g,
		updatedBy: c,
		children: b
	}), n[8] = f, n[9] = c, n[10] = _, n[11] = b, n[12] = g, n[13] = x) : x = n[13], x;
}, vd = (t) => {
	let n = e(9), { serviceFee: r } = t, i;
	n[0] === r ? i = n[1] : (i = r || {}, n[0] = r, n[1] = i);
	let { currentServiceFeeDetails: a, historicalServiceFeeDetails: o } = i, s;
	n[2] === a ? s = n[3] : (s = a && /* @__PURE__ */ m(_d, {
		currentServiceFeeDetails: a,
		isCurrent: !0
	}), n[2] = a, n[3] = s);
	let c;
	n[4] === o ? c = n[5] : (c = o?.map(yd), n[4] = o, n[5] = c);
	let l;
	return n[6] !== s || n[7] !== c ? (l = /* @__PURE__ */ h(Me, {
		gap: "spacing-xl",
		fill: !0,
		children: [s, c]
	}), n[6] = s, n[7] = c, n[8] = l) : l = n[8], l;
};
function yd(e, t) {
	return /* @__PURE__ */ m(_d, { currentServiceFeeDetails: e }, t);
}
//#endregion
//#region src/formElements/Commission/CommissionSplit/CommissionSplit.tsx
var bd = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}(bd || {}), xd = (t) => {
	let n = e(54), { id: r, commissionSplitWithSecondaryAgent: i, leadAgentId: a, secondAgentId: s, agents: c, required: l, disabled: u, validate: f, onChange: p } = t, g = c === void 0 ? [] : c, _ = f === void 0 ? !0 : f, [v, y] = d(i?.leadAgentSplit), [b, x] = d(i?.secondAgentSplit), [S, C] = d(i?.splittingWithSecondaryAgent), [w, T] = d(void 0), E = a ? g.find((e) => e.id === a) : void 0, D = s ? g.find((e) => e.id === s) : void 0, O, k;
	n[0] !== v || n[1] !== p || n[2] !== b || n[3] !== S ? (O = () => {
		p && p({
			leadAgentSplit: v,
			secondAgentSplit: b,
			splittingWithSecondaryAgent: S
		});
	}, k = [
		v,
		b,
		S,
		p
	], n[0] = v, n[1] = p, n[2] = b, n[3] = S, n[4] = O, n[5] = k) : (O = n[4], k = n[5]), o(O, k), o(() => {
		if (S !== !0) {
			y(void 0), x(void 0);
			return;
		}
		E?.id && y((e) => e?.agentId === E.id ? e : {
			...e,
			agentId: E.id
		}), D?.id && x((e) => e?.agentId === D.id ? e : {
			...e,
			agentId: D.id
		});
	}, [
		S,
		E?.id,
		D?.id
	]);
	let A;
	n[6] !== v?.agentId || n[7] !== v?.percentage || n[8] !== l || n[9] !== b?.agentId || n[10] !== b?.percentage || n[11] !== S ? (A = () => {
		if (l && S === void 0) {
			T("Commission split is required");
			return;
		}
		if (S !== !0) {
			T(void 0);
			return;
		}
		let e = !!v?.agentId, t = !!b?.agentId, n = e && v?.percentage !== void 0, r = t && b?.percentage !== void 0;
		if (!e || !t) {
			!e && !t ? T("Select lead and second agent") : e ? t || T("Select second agent") : T("Select lead agent");
			return;
		}
		if (!n || !r) {
			!n && !r ? T("Percentage required") : n ? r || T("Second agent percentage required") : T("Lead agent percentage required");
			return;
		}
		if (n && r) {
			let e = (v?.percentage ?? 0) + (b?.percentage ?? 0);
			Math.abs(e - 100) > 1e-4 ? T("Total commission percentage should be exactly 100%") : T(void 0);
			return;
		}
	}, n[6] = v?.agentId, n[7] = v?.percentage, n[8] = l, n[9] = b?.agentId, n[10] = b?.percentage, n[11] = S, n[12] = A) : A = n[12];
	let j = v?.agentId, M = v?.percentage, N = b?.agentId, P = b?.percentage, F;
	n[13] !== l || n[14] !== S || n[15] !== j || n[16] !== M || n[17] !== N || n[18] !== P ? (F = [
		S,
		l,
		j,
		M,
		N,
		P
	], n[13] = l, n[14] = S, n[15] = j, n[16] = M, n[17] = N, n[18] = P, n[19] = F) : F = n[19], o(A, F);
	let I = (E ? [E] : g).filter((e) => E ? !0 : e.id !== b?.agentId).map(Sd), L = (D ? [D] : g).filter((e) => D ? !0 : e.id !== v?.agentId).map(Cd), R = E ? I : [{
		label: "None",
		value: ""
	}, ...I], z = D ? L : [{
		label: "None",
		value: ""
	}, ...L], B = _ && v?.agentId && (v?.percentage === void 0 || b?.agentId && b?.percentage !== void 0 && Math.abs((v?.percentage ?? 0) + (b?.percentage ?? 0) - 100) > 1e-4) ? w : void 0, V = _ && S === !0 && b?.agentId && (b?.percentage === void 0 || v?.agentId && v?.percentage !== void 0 && Math.abs((v?.percentage ?? 0) + (b?.percentage ?? 0) - 100) > 1e-4) ? w : void 0, H;
	n[20] === C ? H = n[21] : (H = (e) => {
		C(e ? e === bd.Yes : void 0);
	}, n[20] = C, n[21] = H);
	let U = H, W = `${r}-commission-split`, G;
	n[22] === Symbol.for("react.memo_cache_sentinel") ? (G = [{
		label: bd.No,
		value: bd.No
	}, {
		label: bd.Yes,
		value: bd.Yes
	}], n[22] = G) : G = n[22];
	let K = S === void 0 ? void 0 : S ? bd.Yes : bd.No, q;
	n[23] !== u || n[24] !== w || n[25] !== r || n[26] !== v?.agentId || n[27] !== v?.percentage || n[28] !== R || n[29] !== B || n[30] !== l || n[31] !== b?.agentId || n[32] !== b?.percentage || n[33] !== z || n[34] !== V || n[35] !== y || n[36] !== x || n[37] !== S || n[38] !== _ ? (q = S === !0 ? /* @__PURE__ */ h($, {
		fill: !0,
		direction: "vertical",
		padding: "spacing-2xl",
		gap: "spacing-xl",
		children: [/* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "xs",
			children: [/* @__PURE__ */ m(Ec, {
				id: `${r}-lead-agent-dropdown`,
				label: "Lead Agent",
				options: R,
				selected: v?.agentId || "",
				errorText: _ && !v?.agentId ? w : void 0,
				onChange: (e) => y((t) => ({
					...t,
					agentId: e || void 0,
					percentage: e ? t?.percentage : void 0
				})),
				hideOptionalText: !0,
				disabled: u,
				required: l,
				hideErrorDescription: !0
			}), /* @__PURE__ */ m(qs, {
				id: `${r}-lead-agent-commission`,
				label: "Percentage",
				defaultValue: v?.percentage?.toString() || "",
				type: "percent",
				disabled: v?.agentId === void 0 || u,
				errorText: B,
				onChange: (e) => y((t) => ({
					...t,
					percentage: Au(e)
				})),
				hideOptionalText: !0,
				size: "medium",
				required: l,
				hideErrorDescription: !0
			})]
		}), /* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "xs",
			children: [/* @__PURE__ */ m(Ec, {
				id: `${r}-second-agent-dropdown`,
				label: "Second Agent",
				options: z,
				selected: b?.agentId || "",
				errorText: _ && !b?.agentId ? w : void 0,
				onChange: (e) => x((t) => ({
					...t,
					agentId: e || void 0,
					percentage: e ? t?.percentage : void 0
				})),
				hideOptionalText: !0,
				disabled: u,
				required: l,
				hideErrorDescription: !0
			}), /* @__PURE__ */ m(qs, {
				id: `${r}-second-agent-commission`,
				label: "Percentage",
				defaultValue: b?.percentage?.toString() || "",
				type: "percent",
				disabled: b?.agentId === void 0 || u,
				errorText: V,
				onChange: (e) => x((t) => ({
					...t,
					percentage: Au(e)
				})),
				hideOptionalText: !0,
				size: "medium",
				required: l,
				hideErrorDescription: !0
			})]
		})]
	}) : void 0, n[23] = u, n[24] = w, n[25] = r, n[26] = v?.agentId, n[27] = v?.percentage, n[28] = R, n[29] = B, n[30] = l, n[31] = b?.agentId, n[32] = b?.percentage, n[33] = z, n[34] = V, n[35] = y, n[36] = x, n[37] = S, n[38] = _, n[39] = q) : q = n[39];
	let J;
	n[40] !== u || n[41] !== U || n[42] !== l || n[43] !== W || n[44] !== K || n[45] !== q ? (J = /* @__PURE__ */ m(bs, {
		id: W,
		layout: "stacked",
		label: "Commission split with a secondary agent?",
		disabled: u,
		required: l,
		options: G,
		value: K,
		onChange: U,
		subContent: q
	}), n[40] = u, n[41] = U, n[42] = l, n[43] = W, n[44] = K, n[45] = q, n[46] = J) : J = n[46];
	let Y;
	n[47] !== w || n[48] !== r || n[49] !== _ ? (Y = _ && w && /* @__PURE__ */ m(Fu, {
		errorText: w,
		id: `${r}-commission-split`
	}), n[47] = w, n[48] = r, n[49] = _, n[50] = Y) : Y = n[50];
	let X;
	return n[51] !== J || n[52] !== Y ? (X = /* @__PURE__ */ h($, {
		gap: "sm",
		children: [J, Y]
	}), n[51] = J, n[52] = Y, n[53] = X) : X = n[53], X;
};
function Sd(e) {
	return {
		label: e.name?.fullName || "",
		value: e.id || ""
	};
}
function Cd(e) {
	return {
		label: e.name?.fullName || "",
		value: e.id || ""
	};
}
//#endregion
//#region src/formElements/LegalDescription/LegalDescription.tsx
var wd = (e) => !e || !e.parcels || e.parcels.length === 0 ? !1 : e.parcels.some((e) => !e.lotNumber || !e.planType || !e.planNumber) || e.parcels.every((e) => !e.isPrimaryPlan), Td = (t) => {
	let n = e(34), { id: r, label: i, hasInvalidTitleReference: a, readonly: o, legalDescription: s, onChangeParcel: c, onRemoveParcel: l, onAddNewParcel: u, required: d, validate: f } = t, p = a === void 0 ? !1 : a, g = o === void 0 ? !1 : o, _;
	n[0] === s ? _ = n[1] : (_ = wd(s), n[0] = s, n[1] = _);
	let v = !g || _, y = (s?.parcels?.length ?? 0) > 1 && !g, b;
	n[2] !== c || n[3] !== g || n[4] !== d || n[5] !== f ? (b = (e, t, n) => {
		let r = e[t];
		return g && r ? r : /* @__PURE__ */ m(qs, {
			id: `txt${t}-${n}`,
			type: "text",
			stretch: !0,
			onInputValueChange: (r) => {
				let { value: i } = r;
				g || i !== e[t] && c(n, {
					...e,
					[t]: i
				});
			},
			hideOptionalText: !0,
			noHeader: !0,
			hideErrorDescription: !0,
			defaultValue: e[t] ?? "",
			errorText: f && d && !e[t] ? "Required" : ""
		});
	}, n[2] = c, n[3] = g, n[4] = d, n[5] = f, n[6] = b) : b = n[6];
	let x = b, S;
	n[7] !== p || n[8] !== c || n[9] !== g || n[10] !== d || n[11] !== f ? (S = (e, t) => !p && e.titleReference && g ? e.titleReference : /* @__PURE__ */ m(qs, {
		id: `txtTitleReference-${t}`,
		type: "text",
		stretch: !0,
		onInputValueChange: (n) => {
			let { value: r } = n;
			!p && g || r !== e.titleReference && c(t, {
				...e,
				titleReference: r
			});
		},
		hideOptionalText: !0,
		noHeader: !0,
		defaultValue: e.titleReference ?? "",
		errorText: f && d && !e.titleReference ? "Required" : ""
	}), n[7] = p, n[8] = c, n[9] = g, n[10] = d, n[11] = f, n[12] = S) : S = n[12];
	let C = S, w;
	n[13] === Symbol.for("react.memo_cache_sentinel") ? (w = [
		"Lot Number",
		"Plan Type",
		"Plan Number",
		"Title Reference",
		{
			name: "Remove Button",
			shrink: !0,
			hideHeader: !0
		}
	], n[13] = w) : w = n[13];
	let T = w, E;
	n[14] !== s?.parcels || n[15] !== l || n[16] !== x || n[17] !== y || n[18] !== C ? (E = s?.parcels?.map((e, t) => ({
		"Lot Number": x(e, "lotNumber", t),
		"Plan Type": x(e, "planType", t),
		"Plan Number": x(e, "planNumber", t),
		"Title Reference": C(e, t),
		"Remove Button": y ? /* @__PURE__ */ m("div", {
			id: `btnRemove-${t}`,
			onClick: () => l(t),
			children: /* @__PURE__ */ m(Xi, {})
		}) : void 0
	})) ?? [], n[14] = s?.parcels, n[15] = l, n[16] = x, n[17] = y, n[18] = C, n[19] = E) : E = n[19];
	let D = E, O;
	n[20] === i ? O = n[21] : (O = /* @__PURE__ */ m(Q, {
		id: "legal-description-label",
		type: "label",
		size: "large",
		children: i
	}), n[20] = i, n[21] = O);
	let k;
	n[22] === D ? k = n[23] : (k = /* @__PURE__ */ m(to, {
		columns: T,
		rows: D
	}), n[22] = D, n[23] = k);
	let A;
	n[24] !== v || n[25] !== u ? (A = v && /* @__PURE__ */ m(Kl, {
		id: "add-new-lot-button",
		variant: "primary",
		size: "small",
		onClick: u,
		"data-testid": "add-new-parcel-button",
		text: "Add Lot"
	}), n[24] = v, n[25] = u, n[26] = A) : A = n[26];
	let j;
	n[27] !== A || n[28] !== O || n[29] !== k ? (j = /* @__PURE__ */ h(Me, {
		gap: "spacing-lg",
		fill: !0,
		children: [
			O,
			k,
			A
		]
	}), n[27] = A, n[28] = O, n[29] = k, n[30] = j) : j = n[30];
	let M;
	return n[31] !== r || n[32] !== j ? (M = /* @__PURE__ */ m("div", {
		id: r,
		className: "legalDescription2",
		"data-testid": r,
		children: j
	}), n[31] = r, n[32] = j, n[33] = M) : M = n[33], M;
}, Ed = [{
	value: K.Percentage,
	label: "Percentage"
}, {
	value: K.FlatFee,
	label: "Flat Fee"
}];
function Dd(t) {
	let n = e(59), { id: r, value: i, setValue: a } = t, o = `${r}-agxExternalConjunctionSearch`, s = `${r}-agxExternalConjunctionSearch`, c = i?.conjunctingCompanyName, l;
	n[0] === a ? l = n[1] : (l = (e) => {
		a((t) => ({
			...t,
			conjunctingCompanyName: e?.name || void 0,
			conjunctingAgentPhone: e?.formattedPhoneNumber || void 0
		}));
	}, n[0] = a, n[1] = l);
	let u;
	n[2] !== o || n[3] !== s || n[4] !== c || n[5] !== l ? (u = /* @__PURE__ */ m(Xs, {
		id: s,
		label: "Agency name",
		onlySearchForBusinessAddresses: !0,
		onlyDisplayBusinessName: !0,
		allowManualAddressEntry: !1,
		stretch: !0,
		validate: !1,
		defaultValue: c,
		onAddressChange: l
	}, o), n[2] = o, n[3] = s, n[4] = c, n[5] = l, n[6] = u) : u = n[6];
	let d = `${r}-agent-name`, f = `${r}-agent-name`, p = i?.conjunctingAgentName ?? "", g;
	n[7] === a ? g = n[8] : (g = (e) => a((t) => ({
		...t,
		conjunctingAgentName: e || void 0
	})), n[7] = a, n[8] = g);
	let _;
	n[9] !== d || n[10] !== f || n[11] !== p || n[12] !== g ? (_ = /* @__PURE__ */ m(qs, {
		id: d,
		type: "text",
		label: "Agent name",
		defaultValue: p,
		onChange: g,
		hideOptionalText: !0,
		stretch: !0
	}, f), n[9] = d, n[10] = f, n[11] = p, n[12] = g, n[13] = _) : _ = n[13];
	let v = `${r}-agent-email`, y = `${r}-agent-email`, b = i?.conjunctingAgentEmail ?? "", x;
	n[14] === a ? x = n[15] : (x = (e) => a((t) => ({
		...t,
		conjunctingAgentEmail: e || void 0
	})), n[14] = a, n[15] = x);
	let S;
	n[16] !== v || n[17] !== y || n[18] !== b || n[19] !== x ? (S = /* @__PURE__ */ m(qs, {
		id: v,
		type: "email",
		label: "Email",
		defaultValue: b,
		onChange: x,
		hideOptionalText: !0,
		stretch: !0
	}, y), n[16] = v, n[17] = y, n[18] = b, n[19] = x, n[20] = S) : S = n[20];
	let C = `${r}-agent-phone`, w = `${r}-agent-phone`, T = i?.conjunctingAgentPhone ?? "", E;
	n[21] === a ? E = n[22] : (E = (e) => a((t) => ({
		...t,
		conjunctingAgentPhone: e || void 0
	})), n[21] = a, n[22] = E);
	let D;
	n[23] !== C || n[24] !== w || n[25] !== T || n[26] !== E ? (D = /* @__PURE__ */ m(qs, {
		id: C,
		type: "text",
		label: "Phone",
		defaultValue: T,
		onChange: E,
		hideOptionalText: !0,
		stretch: !0
	}, w), n[23] = C, n[24] = w, n[25] = T, n[26] = E, n[27] = D) : D = n[27];
	let O = `label-${r}`, k;
	n[28] === O ? k = n[29] : (k = /* @__PURE__ */ m(Q, {
		id: O,
		type: "label",
		size: "medium",
		color: "var(--text-primary)",
		children: "Conjunction/referral fee"
	}), n[28] = O, n[29] = k);
	let A = `${r}-conjunction-fee-selection`, j = `${r}-conjunction-fee-selection`, M = i?.conjunctionFeeType ?? K.Percentage, N;
	n[30] === a ? N = n[31] : (N = (e) => a((t) => ({
		...t,
		conjunctionFeeType: e
	})), n[30] = a, n[31] = N);
	let P;
	n[32] !== A || n[33] !== j || n[34] !== M || n[35] !== N ? (P = /* @__PURE__ */ m(Ec, {
		id: A,
		options: Ed,
		selected: M,
		onChange: N,
		hideOptionalText: !0,
		hintText: "Including GST"
	}, j), n[32] = A, n[33] = j, n[34] = M, n[35] = N, n[36] = P) : P = n[36];
	let F = `${r}-conjunction-fee`, I = `${r}-conjunction-fee`, L = i?.conjunctionFeeType === K.FlatFee ? "currency" : "percent", R;
	n[37] === i?.conjunctionFee ? R = n[38] : (R = i?.conjunctionFee?.toString() ?? "", n[37] = i?.conjunctionFee, n[38] = R);
	let z;
	n[39] === a ? z = n[40] : (z = (e) => {
		let { value: t } = e;
		return a((e) => ({
			...e,
			conjunctionFeeType: e?.conjunctionFeeType ?? K.Percentage,
			conjunctionFee: t ? Au(t) : void 0
		}));
	}, n[39] = a, n[40] = z);
	let B;
	n[41] !== F || n[42] !== I || n[43] !== L || n[44] !== R || n[45] !== z ? (B = /* @__PURE__ */ m(qs, {
		id: F,
		type: L,
		defaultValue: R,
		onInputValueChange: z,
		hideOptionalText: !0,
		stretch: !0
	}, I), n[41] = F, n[42] = I, n[43] = L, n[44] = R, n[45] = z, n[46] = B) : B = n[46];
	let V;
	n[47] !== P || n[48] !== B ? (V = /* @__PURE__ */ h($, {
		gap: "spacing-xs",
		fill: !0,
		direction: "horizontal",
		contentAlignment: "baseline",
		children: [P, B]
	}), n[47] = P, n[48] = B, n[49] = V) : V = n[49];
	let H;
	n[50] !== k || n[51] !== V ? (H = /* @__PURE__ */ h($, {
		fill: !0,
		children: [k, V]
	}), n[50] = k, n[51] = V, n[52] = H) : H = n[52];
	let U;
	return n[53] !== _ || n[54] !== S || n[55] !== D || n[56] !== H || n[57] !== u ? (U = /* @__PURE__ */ h($, {
		gap: "spacing-xl",
		fill: !0,
		padding: "spacing-xl",
		children: [
			u,
			_,
			S,
			D,
			H
		]
	}), n[53] = _, n[54] = S, n[55] = D, n[56] = H, n[57] = u, n[58] = U) : U = n[58], U;
}
//#endregion
//#region src/formElements/ExternalConjunction/ExternalConjunction.tsx
var Od = /* @__PURE__ */ function(e) {
	return e.Yes = "Yes", e.No = "No", e;
}(Od || {}), kd = (t) => {
	let n = e(15), { id: r, defaultValue: i, onValueChange: a } = t, s;
	n[0] === i ? s = n[1] : (s = () => i, n[0] = i, n[1] = s);
	let [c, l] = d(s), u, f;
	n[2] !== a || n[3] !== c ? (u = () => {
		!c || !a || a(c);
	}, f = [c, a], n[2] = a, n[3] = c, n[4] = u, n[5] = f) : (u = n[4], f = n[5]), o(u, f);
	let p;
	n[6] === Symbol.for("react.memo_cache_sentinel") ? (p = (e) => {
		if (e === Od.Yes) {
			l(Ad);
			return;
		} else e === Od.No && l(jd);
	}, n[6] = p) : p = n[6];
	let h = p, g = `${r}-external-conjunction`, _;
	n[7] === Symbol.for("react.memo_cache_sentinel") ? (_ = [{
		label: Od.No,
		value: Od.No
	}, {
		label: Od.Yes,
		value: Od.Yes
	}], n[7] = _) : _ = n[7];
	let v = c ? c.isExternalConjunctionOrReferral ? Od.Yes : Od.No : void 0, y;
	n[8] !== r || n[9] !== c ? (y = c?.isExternalConjunctionOrReferral ? /* @__PURE__ */ m(Dd, {
		id: r,
		value: c,
		setValue: l
	}) : void 0, n[8] = r, n[9] = c, n[10] = y) : y = n[10];
	let b;
	return n[11] !== g || n[12] !== v || n[13] !== y ? (b = /* @__PURE__ */ m(bs, {
		id: g,
		layout: "stacked",
		label: "Is there an external conjunction agent or a referral fee payable?",
		options: _,
		value: v,
		onChange: h,
		subContent: y
	}), n[11] = g, n[12] = v, n[13] = y, n[14] = b) : b = n[14], b;
};
function Ad(e) {
	return {
		...e ?? {},
		isExternalConjunctionOrReferral: !0,
		conjunctionFeeType: e?.conjunctionFeeType ?? K.Percentage
	};
}
function jd(e) {
	return {
		...e ?? {},
		isExternalConjunctionOrReferral: !1
	};
}
//#endregion
//#region src/components/action/AddButton/AddButton.tsx
var Md = (e, t) => {
	if (e && !t) return "var(--fg-brand-main)";
	if (e && t) return "var(--fg-secondary)";
	if (!e && !t) return "var(--fg-brand-accent-darker)";
	if (!e && t) return "var(--fg-disabled)";
}, Nd = (t) => {
	let n = e(28), { id: r, checked: i, onClick: a, disabled: o } = t, s = o === void 0 ? !1 : o, [c, l] = d(!1), u;
	n[0] !== s || n[1] !== a ? (u = (e) => {
		e.preventDefault(), e.stopPropagation(), !s && a();
	}, n[0] = s, n[1] = a, n[2] = u) : u = n[2];
	let p = u, g;
	n[3] === s ? g = n[4] : (g = (e) => {
		e.preventDefault(), !s && l(!0);
	}, n[3] = s, n[4] = g);
	let _ = g, v;
	n[5] === s ? v = n[6] : (v = (e) => {
		e.preventDefault(), !s && l(!1);
	}, n[5] = s, n[6] = v);
	let y = v, b = i && "checked", x = s && "disabled", S = c && "pressed", C;
	n[7] !== b || n[8] !== x || n[9] !== S ? (C = f("addButton", b, x, S), n[7] = b, n[8] = x, n[9] = S, n[10] = C) : C = n[10];
	let w = C, T;
	n[11] !== i || n[12] !== s ? (T = Md(i, s), n[11] = i, n[12] = s, n[13] = T) : T = n[13];
	let E = T, D;
	n[14] !== i || n[15] !== E ? (D = i && /* @__PURE__ */ m(Ki, {
		width: 12,
		height: 12,
		color: E
	}), n[14] = i, n[15] = E, n[16] = D) : D = n[16];
	let O;
	n[17] !== i || n[18] !== E ? (O = !i && /* @__PURE__ */ m(Mi, {
		width: 12,
		height: 12,
		color: E
	}), n[17] = i, n[18] = E, n[19] = O) : O = n[19];
	let k;
	return n[20] !== w || n[21] !== r || n[22] !== p || n[23] !== _ || n[24] !== y || n[25] !== D || n[26] !== O ? (k = /* @__PURE__ */ h("button", {
		id: r,
		onClick: p,
		onMouseDown: _,
		onMouseUp: y,
		onMouseLeave: y,
		className: w,
		children: [D, O]
	}), n[20] = w, n[21] = r, n[22] = p, n[23] = _, n[24] = y, n[25] = D, n[26] = O, n[27] = k) : k = n[27], k;
}, Pd = (t) => {
	let n = e(10), { expanded: r, children: i } = t, a = r ? "slide-out-content-expanded" : "slide-out-content-collapsed", o = r ? "1fr" : "0fr", s = r ? "var(--spacing-xl)" : "0", c;
	n[0] !== o || n[1] !== s ? (c = {
		display: "grid",
		gridTemplateRows: o,
		marginTop: s,
		transition: "grid-template-rows 150ms ease-out, margin-top 150ms ease-out"
	}, n[0] = o, n[1] = s, n[2] = c) : c = n[2];
	let l;
	n[3] === Symbol.for("react.memo_cache_sentinel") ? (l = { overflow: "hidden" }, n[3] = l) : l = n[3];
	let u;
	n[4] === i ? u = n[5] : (u = /* @__PURE__ */ m("div", {
		style: l,
		children: i
	}), n[4] = i, n[5] = u);
	let d;
	return n[6] !== a || n[7] !== c || n[8] !== u ? (d = /* @__PURE__ */ m("div", {
		"data-testid": a,
		style: c,
		children: u
	}), n[6] = a, n[7] = c, n[8] = u, n[9] = d) : d = n[9], d;
}, Fd = (t) => {
	let n = e(42), { selectionType: r, clauseIdSelected: i, clause: a, onToggle: o } = t, [s, c] = d(!1), l = i !== void 0 && i === a?.id, u;
	n[0] !== a?.clauses || n[1] !== i || n[2] !== l ? (u = l || (a?.clauses?.some((e) => i !== void 0 && e?.clauseId === i) ?? !1), n[0] = a?.clauses, n[1] = i, n[2] = l, n[3] = u) : u = n[3];
	let f = u, p = a?.clauses !== void 0 && a.clauses.length > 0, g;
	n[4] === Symbol.for("react.memo_cache_sentinel") ? (g = () => c(Id), n[4] = g) : g = n[4];
	let _ = `expandable-clause-selector-${a?.id ?? a?.position ?? "unknown"}`, v = f ? "var(--bg-secondary-hover)" : void 0, y;
	n[5] === v ? y = n[6] : (y = {
		background: v,
		borderRadius: "var(--radius-xl)",
		border: "1px solid var(--border-secondary)",
		transition: "300ms"
	}, n[5] = v, n[6] = y);
	let b = s ? "up" : "down", x = p ? "var(--fg-brand-accent-darker)" : "transparent", S;
	n[7] !== b || n[8] !== x ? (S = /* @__PURE__ */ m(Ei, {
		direction: b,
		color: x
	}), n[7] = b, n[8] = x, n[9] = S) : S = n[9];
	let C = a?.position, w = a?.title, T;
	n[10] !== w || n[11] !== C ? (T = /* @__PURE__ */ h(Q, {
		id: "specialCondition-expando-title",
		type: "title",
		size: "large",
		color: "var(--text-primary)",
		children: [
			C,
			" ",
			w
		]
	}), n[10] = w, n[11] = C, n[12] = T) : T = n[12];
	let E;
	n[13] !== T || n[14] !== S ? (E = /* @__PURE__ */ h($, {
		direction: "horizontal",
		contentAlignment: "center",
		gap: "spacing-xl",
		children: [S, T]
	}), n[13] = T, n[14] = S, n[15] = E) : E = n[15];
	let D;
	n[16] !== f || n[17] !== a?.id || n[18] !== o || n[19] !== r ? (D = r === "condition" && /* @__PURE__ */ m(Nd, {
		id: `selectSpecialCondition-selector-${a?.id}`,
		checked: f,
		onClick: () => o(a?.id)
	}), n[16] = f, n[17] = a?.id, n[18] = o, n[19] = r, n[20] = D) : D = n[20];
	let O;
	n[21] !== a?.id || n[22] !== i || n[23] !== o || n[24] !== r ? (O = r === "clause" && /* @__PURE__ */ m(vs, {
		id: "selectSpecialCondition-radio-selector",
		value: a?.id?.toString() ?? "",
		checked: i !== void 0 && a?.id === i,
		onChange: () => o(a?.id),
		size: "medium"
	}), n[21] = a?.id, n[22] = i, n[23] = o, n[24] = r, n[25] = O) : O = n[25];
	let k;
	n[26] !== E || n[27] !== D || n[28] !== O ? (k = /* @__PURE__ */ h($, {
		direction: "horizontal",
		contentJustification: "space-between",
		contentAlignment: "center",
		gap: "spacing-xl",
		children: [
			E,
			D,
			O
		]
	}), n[26] = E, n[27] = D, n[28] = O, n[29] = k) : k = n[29];
	let A;
	n[30] !== a || n[31] !== i || n[32] !== s || n[33] !== p || n[34] !== o || n[35] !== r ? (A = p && /* @__PURE__ */ m(Pd, {
		expanded: s,
		children: /* @__PURE__ */ m($, {
			direction: "vertical",
			gap: "spacing-xl",
			children: a.clauses?.map((e) => /* @__PURE__ */ h($, {
				direction: "horizontal",
				fill: !0,
				gap: "spacing-md",
				children: [
					/* @__PURE__ */ m(Q, {
						id: `specialCondition-clause-${e.clauseId}`,
						type: "caption",
						size: "medium",
						color: "var(--text-secondary)",
						style: {
							textAlign: "center",
							minWidth: "24px"
						},
						children: e.clausePosition?.replace(/^[^.]+\./, a?.position ?? "")
					}),
					/* @__PURE__ */ m(Q, {
						id: "specialCondition-clause-1",
						type: "caption",
						size: "medium",
						color: "var(--text-secondary)",
						style: { flexGrow: 1 },
						children: e.clauseText
					}),
					r === "clause" && /* @__PURE__ */ m(vs, {
						id: `selectSpecialCondition-radio-selector-${e.clauseId}`,
						value: e.clauseId?.toString() ?? "",
						checked: i !== void 0 && e.clauseId === i,
						onChange: () => o(e.clauseId),
						size: "medium"
					})
				]
			}, `clause-${e.clauseId}`))
		})
	}), n[30] = a, n[31] = i, n[32] = s, n[33] = p, n[34] = o, n[35] = r, n[36] = A) : A = n[36];
	let j;
	return n[37] !== k || n[38] !== A || n[39] !== _ || n[40] !== y ? (j = /* @__PURE__ */ h($, {
		direction: "vertical",
		padding: "spacing-xl",
		onClick: g,
		"data-testid": _,
		style: y,
		children: [k, A]
	}), n[37] = k, n[38] = A, n[39] = _, n[40] = y, n[41] = j) : j = n[41], j;
};
function Id(e) {
	return !e;
}
//#endregion
//#region src/formElements/SpecialConditions/SpecialConditionsPicker/Components/ExpandableSelectors/ExpandableSpecialConditionSelector/ExpandableSpecialConditionSelector.tsx
var Ld = (t) => {
	let n = e(12), { selected: r, onToggle: i, conditionTemplate: a, clausePosition: o } = t, s = `${o === void 0 ? 1 : o}.`, c = a.conditionType ?? te.Custom, l;
	n[0] === a.clauses ? l = n[1] : (l = a.clauses?.map(Rd), n[0] = a.clauses, n[1] = l);
	let u;
	n[2] !== a.conditionType || n[3] !== a.title || n[4] !== s || n[5] !== c || n[6] !== l ? (u = {
		id: a.conditionType,
		title: a.title,
		position: s,
		conditionType: c,
		clauses: l
	}, n[2] = a.conditionType, n[3] = a.title, n[4] = s, n[5] = c, n[6] = l, n[7] = u) : u = n[7];
	let d = u, f = r ? a.conditionType : void 0, p;
	return n[8] !== d || n[9] !== i || n[10] !== f ? (p = /* @__PURE__ */ m(Fd, {
		selectionType: "condition",
		clause: d,
		onToggle: i,
		clauseIdSelected: f
	}), n[8] = d, n[9] = i, n[10] = f, n[11] = p) : p = n[11], p;
};
function Rd(e) {
	return {
		clauseId: e.id,
		clauseText: e.bodyText,
		clausePosition: e.position
	};
}
//#endregion
//#region src/formElements/SpecialConditions/SpecialConditionsPicker/Components/SpecialConditionsPickerAddModal/SpecialConditionsPickerAddModal.tsx
var zd = (t) => {
	let n = e(73), { selectedSpecialConditions: r, onChange: i, specialConditionTemplates: a, show: s, setShowModal: c } = t, [l, u] = d(r), f;
	n[0] !== l || n[1] !== r ? (f = () => {
		P(l, r) || u(r);
	}, n[0] = l, n[1] = r, n[2] = f) : f = n[2];
	let p;
	n[3] === r ? p = n[4] : (p = [r], n[3] = r, n[4] = p), o(f, p);
	let g;
	n[5] !== l || n[6] !== a ? (g = (e) => {
		let t = l.some((t) => t.conditionType === e), n;
		if (t) n = l.filter((t) => t.conditionType !== e);
		else {
			let t = a?.find((t) => t.conditionType === e);
			if (!t) return;
			let r = t.clauses ?? [], i = {
				id: t.conditionType?.toString() ?? "",
				conditionType: e,
				clauses: r.map(Vd)
			};
			n = [...l, i];
		}
		u(n);
	}, n[5] = l, n[6] = a, n[7] = g) : g = n[7];
	let _ = g, v;
	n[8] !== r || n[9] !== c ? (v = () => {
		c(!1), u(r);
	}, n[8] = r, n[9] = c, n[10] = v) : v = n[10];
	let y = v, b;
	n[11] !== l || n[12] !== i || n[13] !== c ? (b = () => {
		c(!1), i(l);
	}, n[11] = l, n[12] = i, n[13] = c, n[14] = b) : b = n[14];
	let x = b, [S, C] = d(""), w, T, E, D, O, k, A, j, M, N, F, I, L, R, z, B, V, H, U;
	if (n[15] !== l || n[16] !== _ || n[17] !== S || n[18] !== s || n[19] !== a) {
		let e = a?.filter((e) => e.title?.toLowerCase().includes(S.toLowerCase()));
		E = Ya, N = "single", F = "716px", I = "withoutDivider", L = "Select conditions to add", R = "withDivider", z = s, T = $, D = "vertical", O = "md", k = !0, A = "xl", j = "special-conditions-picker-add-modal", n[39] === Symbol.for("react.memo_cache_sentinel") ? (M = /* @__PURE__ */ m(qs, {
			id: "specialConditions-Search",
			type: "text",
			placeholder: "Search",
			border: "rounded",
			hideOptionalText: !0,
			leftIcon: /* @__PURE__ */ m(Di, {
				color: "var(--fg-tertiary, #B9B9B9)",
				height: 15,
				width: 15
			}),
			onChange: C,
			stretch: !0
		}), n[39] = M) : M = n[39], w = $, B = "vertical", V = "spacing-lg", H = !0, U = e?.map((e, t) => /* @__PURE__ */ m(Ld, {
			selected: l.some((t) => t.conditionType === e.conditionType),
			onToggle: () => _(e.conditionType),
			conditionTemplate: e,
			clausePosition: t + 1
		}, `special-condition-template-${e.conditionType}`)), n[15] = l, n[16] = _, n[17] = S, n[18] = s, n[19] = a, n[20] = w, n[21] = T, n[22] = E, n[23] = D, n[24] = O, n[25] = k, n[26] = A, n[27] = j, n[28] = M, n[29] = N, n[30] = F, n[31] = I, n[32] = L, n[33] = R, n[34] = z, n[35] = B, n[36] = V, n[37] = H, n[38] = U;
	} else w = n[20], T = n[21], E = n[22], D = n[23], O = n[24], k = n[25], A = n[26], j = n[27], M = n[28], N = n[29], F = n[30], I = n[31], L = n[32], R = n[33], z = n[34], B = n[35], V = n[36], H = n[37], U = n[38];
	let W;
	n[40] !== w || n[41] !== B || n[42] !== V || n[43] !== H || n[44] !== U ? (W = /* @__PURE__ */ m(w, {
		direction: B,
		gap: V,
		fill: H,
		children: U
	}), n[40] = w, n[41] = B, n[42] = V, n[43] = H, n[44] = U, n[45] = W) : W = n[45];
	let G;
	n[46] !== T || n[47] !== D || n[48] !== O || n[49] !== k || n[50] !== A || n[51] !== j || n[52] !== M || n[53] !== W ? (G = /* @__PURE__ */ h(T, {
		direction: D,
		gap: O,
		fill: k,
		padding: A,
		"data-testid": j,
		children: [M, W]
	}), n[46] = T, n[47] = D, n[48] = O, n[49] = k, n[50] = A, n[51] = j, n[52] = M, n[53] = W, n[54] = G) : G = n[54];
	let K;
	n[55] === y ? K = n[56] : (K = /* @__PURE__ */ m(Kl, {
		id: "specialConditionsModal-cancel",
		text: "Cancel",
		variant: "hollow",
		onClick: y
	}, "specialConditionsModal-cancel"), n[55] = y, n[56] = K);
	let q;
	n[57] === x ? q = n[58] : (q = /* @__PURE__ */ m(Kl, {
		id: "specialConditionsModal-confirm",
		text: "Confirm",
		variant: "primary",
		onClick: x
	}, "specialConditionsModal-confirm"), n[57] = x, n[58] = q);
	let J;
	n[59] !== K || n[60] !== q ? (J = [K, q], n[59] = K, n[60] = q, n[61] = J) : J = n[61];
	let Y;
	return n[62] !== E || n[63] !== c || n[64] !== N || n[65] !== F || n[66] !== I || n[67] !== L || n[68] !== R || n[69] !== z || n[70] !== G || n[71] !== J ? (Y = /* @__PURE__ */ m(E, {
		type: N,
		maxWidth: F,
		variant: I,
		title: L,
		actionButtonContainerStyle: R,
		isOpen: z,
		content: G,
		setIsDialogOpen: c,
		actionButtons: J
	}), n[62] = E, n[63] = c, n[64] = N, n[65] = F, n[66] = I, n[67] = L, n[68] = R, n[69] = z, n[70] = G, n[71] = J, n[72] = Y) : Y = n[72], Y;
};
function Bd(e) {
	return {
		dataPointId: e.id,
		model: e.model ?? {}
	};
}
function Vd(e) {
	return {
		clauseId: e.id,
		dataPoints: e.dataPoints?.map(Bd)
	};
}
//#endregion
//#region src/components/action/CloseButton/CloseButton.tsx
var Hd = (t) => {
	let n = e(6), { onClick: r, id: i } = t, a = i ? `${i}-close-button` : void 0, o, s;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (o = { flexBasis: "fit-content" }, s = /* @__PURE__ */ m(Xi, {
		width: 20,
		height: 20,
		color: "var(--fg-brand-accent)"
	}), n[0] = o, n[1] = s) : (o = n[0], s = n[1]);
	let c;
	return n[2] !== a || n[3] !== i || n[4] !== r ? (c = /* @__PURE__ */ m($, {
		id: i,
		"data-testid": a,
		direction: "horizontal",
		contentAlignment: "center",
		contentJustification: "center",
		className: "closeButtonV2",
		onClick: r,
		style: o,
		children: s
	}), n[2] = a, n[3] = i, n[4] = r, n[5] = c) : c = n[5], c;
}, Ud = (t) => {
	let n = e(16), { specialConditionData: r, position: i, campaignId: a } = t, { pushToast: s } = Ro(), c;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (c = [], n[0] = c) : c = n[0];
	let [l, u] = d(c), f;
	n[1] === Symbol.for("react.memo_cache_sentinel") ? (f = (e) => {
		u(e ?? []);
	}, n[1] = f) : f = n[1];
	let p;
	n[2] === s ? p = n[3] : (p = {
		onSuccess: f,
		onError: (e) => {
			s({
				type: "error",
				message: "Error constructing clause text"
			}), u([]), console.error("Error constructing clause text:", e);
		}
	}, n[2] = s, n[3] = p);
	let { constructConditionClauseText: h, constructConditionClauseTextPending: g } = fe(p), _;
	n[4] !== a || n[5] !== h || n[6] !== i || n[7] !== r ? (_ = () => {
		h({
			clausePosition: i,
			model: [r],
			campaignId: a
		});
	}, n[4] = a, n[5] = h, n[6] = i, n[7] = r, n[8] = _) : _ = n[8];
	let v;
	if (n[9] !== a || n[10] !== i || n[11] !== r ? (v = [
		r,
		a,
		i
	], n[9] = a, n[10] = i, n[11] = r, n[12] = v) : v = n[12], o(_, v), g) {
		let e;
		return n[13] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m(Eu, {}), n[13] = e) : e = n[13], e;
	}
	let y;
	return n[14] === l ? y = n[15] : (y = l?.map(Wd), n[14] = l, n[15] = y), y;
};
function Wd(e) {
	return /* @__PURE__ */ h(t.Fragment, { children: [/* @__PURE__ */ h(Q, {
		id: `clause-text-title-${e.id}`,
		size: "medium",
		type: "body_ui_strong",
		color: "var(--text-primary)",
		children: [
			e.position,
			". ",
			e.title
		]
	}), e.clauses?.map((t) => /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-md",
		fill: !0,
		children: [/* @__PURE__ */ m(Q, {
			id: `clause-position-${t.clauseId}`,
			size: "medium",
			type: "caption",
			color: "var(--text-secondary)",
			children: t.clausePosition
		}), /* @__PURE__ */ m(Q, {
			id: `clause-body-${t.clauseId}`,
			size: "medium",
			type: "caption",
			color: "var(--text-secondary)",
			children: t.clauseText
		})]
	}, `rendered-sub-clause-${e.id}-${t.clauseId}`))] }, `rendered-clause-${e.id}`);
}
//#endregion
//#region src/formElements/SpecialConditions/SpecialConditionsPicker/Components/SpecialConditionDisplay/Components/ClauseDataPointDisplay/Components/AddressCondition/getAddressDataFromAddress.tsx
var Gd = (e) => {
	if (e) return {
		unitNumber: e.unitNumber,
		streetAddress: e.streetAddress ?? "",
		suburb: e.suburb ?? "",
		country: e.country ?? "",
		state: e.state ?? "",
		postCode: e.postalCode ?? "",
		formattedAddress: za(e)
	};
}, Kd = (e) => {
	if (e) return {
		unitNumber: e.unitNumber,
		streetAddress: e.streetAddress ?? "",
		suburb: e.suburb ?? "",
		country: e.country ?? "",
		state: e.state ?? "",
		postalCode: e.postCode ?? ""
	};
}, qd = (t) => {
	let n = e(12), { id: r, config: i, defaultValue: a, onChange: o, validate: s } = t, c = r === void 0 ? "address-condition" : r, l;
	n[0] === a ? l = n[1] : (l = Gd(a), n[0] = a, n[1] = l);
	let u = l, d;
	n[2] !== u || n[3] !== o ? (d = (e) => {
		let t = Kd(e);
		P(t, u) || o(t);
	}, n[2] = u, n[3] = o, n[4] = d) : d = n[4];
	let f = d, h = `${c}-address`, g = s && !u ? "Please enter a valid address" : void 0, _;
	return n[5] !== i.label || n[6] !== u || n[7] !== f || n[8] !== h || n[9] !== g || n[10] !== s ? (_ = /* @__PURE__ */ m(p, { children: /* @__PURE__ */ m(Xs, {
		id: h,
		onAddressChange: f,
		allowManualAddressEntry: !1,
		defaultValue: u,
		label: i.label,
		stretch: !0,
		errorText: g,
		validate: s
	}) }), n[5] = i.label, n[6] = u, n[7] = f, n[8] = h, n[9] = g, n[10] = s, n[11] = _) : _ = n[11], _;
}, Jd = (t) => {
	let n = e(9), { id: r, config: i, defaultValue: a, onChange: o } = t, s = r === void 0 ? "check-question-condition" : r, c;
	n[0] !== a || n[1] !== o ? (c = (e) => {
		e !== a && o(e);
	}, n[0] = a, n[1] = o, n[2] = c) : c = n[2];
	let l = c, u = `${s}-checkbox`, d = `${s}-checkbox`, f = a ?? !1, p;
	return n[3] !== i.label || n[4] !== l || n[5] !== u || n[6] !== d || n[7] !== f ? (p = /* @__PURE__ */ m(os, {
		id: u,
		dataTestId: d,
		label: i.label,
		onChange: l,
		checked: f
	}), n[3] = i.label, n[4] = l, n[5] = u, n[6] = d, n[7] = f, n[8] = p) : p = n[8], p;
}, Yd = (t) => {
	let n = e(16), { id: r, defaultValue: i, onChange: a, config: o, disabled: s, errorText: c, validate: l } = t, u = r === void 0 ? "number-input-condition" : r, d;
	n[0] !== o.numberDecimalPlaces || n[1] !== i || n[2] !== a ? (d = (e) => {
		let { value: t } = e, n;
		if (t === void 0) n = void 0;
		else if (o.numberDecimalPlaces && o.numberDecimalPlaces > 0) {
			let e = parseFloat(t);
			n = isNaN(e) ? void 0 : parseFloat(e.toFixed(o.numberDecimalPlaces));
		} else {
			let e = parseInt(t);
			n = isNaN(e) ? void 0 : e;
		}
		n !== i && a(n);
	}, n[0] = o.numberDecimalPlaces, n[1] = i, n[2] = a, n[3] = d) : d = n[3];
	let f = d, p = `${u}-number-input`, h;
	n[4] === i ? h = n[5] : (h = i?.toString() || "", n[4] = i, n[5] = h);
	let g = !s, _ = o.numberDecimalPlaces === 0, v = c ?? (l && !i && !s ? "Please enter a value" : void 0), y;
	return n[6] !== o.numberLabel || n[7] !== o.numberPostHintText || n[8] !== s || n[9] !== f || n[10] !== p || n[11] !== h || n[12] !== g || n[13] !== _ || n[14] !== v ? (y = /* @__PURE__ */ m(qs, {
		id: p,
		label: o.numberLabel,
		type: "number",
		defaultValue: h,
		onInputValueChange: f,
		hideOptionalText: !0,
		size: "small",
		textAlign: "center",
		required: g,
		postHintText: o.numberPostHintText,
		noDecimalPoints: _,
		disabled: s,
		errorText: v
	}), n[6] = o.numberLabel, n[7] = o.numberPostHintText, n[8] = s, n[9] = f, n[10] = p, n[11] = h, n[12] = g, n[13] = _, n[14] = v, n[15] = y) : y = n[15], y;
}, Xd = (t) => {
	let n = e(11), { id: r, defaultValue: i, config: a, errorText: o, validate: s, onChange: c, minDate: l } = t, u = r === void 0 ? "date-input-condition" : r, d;
	n[0] !== i || n[1] !== c ? (d = (e) => {
		e !== (i ?? null) && c(e ?? void 0);
	}, n[0] = i, n[1] = c, n[2] = d) : d = n[2];
	let f = d, p = `${u}-date-picker`, h = i ?? null, g;
	return n[3] !== a.label || n[4] !== o || n[5] !== l || n[6] !== f || n[7] !== p || n[8] !== h || n[9] !== s ? (g = /* @__PURE__ */ m(fc, {
		id: p,
		label: a.label,
		required: !0,
		value: h,
		onChange: f,
		optionalText: "",
		validate: s,
		errorText: o,
		minDate: l
	}), n[3] = a.label, n[4] = o, n[5] = l, n[6] = f, n[7] = p, n[8] = h, n[9] = s, n[10] = g) : g = n[10], g;
}, Zd = /* @__PURE__ */ function(e) {
	return e.Number = "# days from....", e.Date = "on..", e;
}({}), Qd = [{
	value: Zd.Number,
	title: Zd.Number
}, {
	value: Zd.Date,
	title: Zd.Date
}], $d = (t) => {
	let n = e(33), { id: r, defaultValue: i, config: a, validate: o, numberErrorText: s, dateErrorText: c, onChange: l, minDate: u } = t, f = r === void 0 ? "number-or-date-condition" : r, p;
	n[0] === i?.dateInput ? p = n[1] : (p = () => i?.dateInput ? Zd.Date : Zd.Number, n[0] = i?.dateInput, n[1] = p);
	let [g, _] = d(p), v;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (v = (e) => {
		_(e);
	}, n[2] = v) : v = n[2];
	let y = v, b;
	n[3] !== l || n[4] !== g ? (b = (e) => {
		g === Zd.Number && l({
			numberInput: e,
			dateInput: void 0
		});
	}, n[3] = l, n[4] = g, n[5] = b) : b = n[5];
	let x = b, S;
	n[6] !== l || n[7] !== g ? (S = (e) => {
		g === Zd.Date && l({
			numberInput: void 0,
			dateInput: e
		});
	}, n[6] = l, n[7] = g, n[8] = S) : S = n[8];
	let C = S, w = `${f}-segment-picker`, T;
	n[9] !== g || n[10] !== w ? (T = /* @__PURE__ */ m(Ql, {
		segments: Qd,
		defaultValue: g,
		id: w,
		onChange: y,
		size: "medium"
	}), n[9] = g, n[10] = w, n[11] = T) : T = n[11];
	let E;
	n[12] !== a || n[13] !== i?.numberInput || n[14] !== f || n[15] !== s || n[16] !== x || n[17] !== g || n[18] !== o ? (E = g === Zd.Number && a.numberInputConfig && /* @__PURE__ */ m(Yd, {
		id: `${f}-number-option`,
		onChange: x,
		config: a.numberInputConfig,
		defaultValue: i?.numberInput,
		validate: o,
		errorText: s
	}), n[12] = a, n[13] = i?.numberInput, n[14] = f, n[15] = s, n[16] = x, n[17] = g, n[18] = o, n[19] = E) : E = n[19];
	let D;
	n[20] !== a || n[21] !== c || n[22] !== i?.dateInput || n[23] !== f || n[24] !== u || n[25] !== C || n[26] !== g || n[27] !== o ? (D = g === Zd.Date && a.dateInputConfig && /* @__PURE__ */ m(Xd, {
		config: a.dateInputConfig,
		id: `${f}-date-option`,
		onChange: C,
		defaultValue: i?.dateInput,
		validate: o,
		minDate: u,
		errorText: c
	}), n[20] = a, n[21] = c, n[22] = i?.dateInput, n[23] = f, n[24] = u, n[25] = C, n[26] = g, n[27] = o, n[28] = D) : D = n[28];
	let O;
	return n[29] !== T || n[30] !== E || n[31] !== D ? (O = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-xl",
		fill: !0,
		children: [
			T,
			E,
			D
		]
	}), n[29] = T, n[30] = E, n[31] = D, n[32] = O) : O = n[32], O;
}, ef = (e, t) => {
	if (e?.numberInput !== void 0) {
		if (!t) return;
		let n = new Date(t);
		return n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + e.numberInput), n;
	}
	if (e?.dateInput) return e.dateInput;
}, tf = ({ currentType: e, currentValues: t, contractDate: n }) => {
	if (e === void 0) return;
	let r = ef(t.find((e) => e.contractDateType === B.Contract)?.model, n), i = ef(t.find((e) => e.contractDateType === B.Unconditional)?.model, n), a = ef(t.find((e) => e.contractDateType === B.Settlement)?.model, n);
	switch (e) {
		case B.Contract: return;
		case B.Unconditional: return !i || !r ? void 0 : i <= r ? "Unconditional date must be greater than contract date" : void 0;
		case B.Settlement: return !a || !i && !r ? void 0 : i && a <= i ? "Settlement date must be greater than unconditional date" : r && a <= r ? "Settlement date must be greater than contract date" : void 0;
		default: return;
	}
}, nf = ({ id: e = "contract-dates-condition", config: t, defaultValue: n, validate: r, contractDate: i = /* @__PURE__ */ new Date(), currentValues: a, onChange: o }) => {
	let s = tf({
		currentType: t.contractDateType,
		currentValues: a,
		contractDate: i
	}), c = r ? s : void 0;
	return /* @__PURE__ */ m($d, {
		id: e,
		defaultValue: n,
		validate: r,
		onChange: o,
		numberErrorText: c,
		dateErrorText: c,
		config: {
			numberInputConfig: {
				numberLabel: t.label,
				numberPostHintText: "days from Contract date",
				numberDecimalPlaces: 0
			},
			dateInputConfig: { label: t.label }
		},
		minDate: i
	});
}, rf = (t) => {
	let n = e(10), { id: r, defaultValue: i, onChange: a, config: o, validate: s } = t, c = r === void 0 ? "free-text-input-condition" : r, l;
	n[0] !== i || n[1] !== a ? (l = (e) => {
		let { value: t } = e, n = t === "" ? void 0 : t;
		n !== i && a(n);
	}, n[0] = i, n[1] = a, n[2] = l) : l = n[2];
	let u = l, d = `${c}-free-text`, f = s && !i ? "Please enter a value" : void 0, p;
	return n[3] !== o.label || n[4] !== o.placeholder || n[5] !== i || n[6] !== u || n[7] !== d || n[8] !== f ? (p = /* @__PURE__ */ m(qs, {
		id: d,
		label: o.label,
		type: "text",
		defaultValue: i,
		onInputValueChange: u,
		hideOptionalText: !0,
		placeholder: o.placeholder,
		required: !0,
		stretch: !0,
		errorText: f
	}), n[3] = o.label, n[4] = o.placeholder, n[5] = i, n[6] = u, n[7] = d, n[8] = f, n[9] = p) : p = n[9], p;
}, af = (t) => {
	let n = e(21), { id: r, defaultValue: i, config: a, validate: o, onChange: s } = t, c = r === void 0 ? "number-or-question-condition" : r, l;
	n[0] !== i?.numberInput || n[1] !== s ? (l = (e) => {
		e !== i?.numberInput && s({ numberInput: e });
	}, n[0] = i?.numberInput, n[1] = s, n[2] = l) : l = n[2];
	let u = l, d;
	n[3] !== i?.questionInput || n[4] !== s ? (d = (e) => {
		e !== i?.questionInput && s({ questionInput: e });
	}, n[3] = i?.questionInput, n[4] = s, n[5] = d) : d = n[5];
	let f = d, p = `${c}-number`, g = i?.numberInput, _ = i?.questionInput, v;
	n[6] !== a || n[7] !== u || n[8] !== p || n[9] !== g || n[10] !== _ || n[11] !== o ? (v = /* @__PURE__ */ m(Yd, {
		id: p,
		onChange: u,
		config: a,
		defaultValue: g,
		disabled: _,
		validate: o
	}), n[6] = a, n[7] = u, n[8] = p, n[9] = g, n[10] = _, n[11] = o, n[12] = v) : v = n[12];
	let y = `${c}-checkbox`, b = i?.questionInput || !1, x;
	n[13] !== a.questionLabel || n[14] !== f || n[15] !== y || n[16] !== b ? (x = /* @__PURE__ */ m(os, {
		id: y,
		checked: b,
		onChange: f,
		label: a.questionLabel
	}), n[13] = a.questionLabel, n[14] = f, n[15] = y, n[16] = b, n[17] = x) : x = n[17];
	let S;
	return n[18] !== x || n[19] !== v ? (S = /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		gap: "spacing-xl",
		children: [v, x]
	}), n[18] = x, n[19] = v, n[20] = S) : S = n[20], S;
}, of = (e) => e.flatMap((e) => {
	if (!e.id) return [];
	let t = e.legalName ?? e.individual?.name?.fullName ?? e.powerOfAttorney?.principalName?.fullName ?? e.company?.companyName ?? e.deceasedEstate?.name?.fullName;
	return t ? [{
		label: t,
		value: e.id
	}] : [];
}).sort((e, t) => e.label.localeCompare(t.label)), sf = (t) => {
	let n = e(15), { id: r, vendors: i, defaultValue: a, config: o, onChange: s, validate: c } = t, l = r === void 0 ? "vendor-selector-condition" : r, u;
	n[0] === a ? u = n[1] : (u = a === void 0 ? [] : a, n[0] = a, n[1] = u);
	let d = u, f;
	n[2] === i ? f = n[3] : (f = of(i), n[2] = i, n[3] = f);
	let p = f, h;
	n[4] !== d || n[5] !== s ? (h = (e) => {
		typeof e == "string" && (e = [e]), !P(e, d) && s(e.length > 0 ? e : void 0);
	}, n[4] = d, n[5] = s, n[6] = h) : h = n[6];
	let g = h, _ = `${l}-vendor-selector`, v = o.placeholder ?? "Select vendors", y = c && (!d || d.length === 0) ? "Please select a vendor" : void 0, b;
	return n[7] !== o.label || n[8] !== d || n[9] !== p || n[10] !== g || n[11] !== _ || n[12] !== v || n[13] !== y ? (b = /* @__PURE__ */ m(Ec, {
		id: _,
		onChange: g,
		options: p,
		type: "multi",
		label: o.label,
		optionalText: "",
		required: !0,
		selected: d,
		placeholder: v,
		errorText: y
	}), n[7] = o.label, n[8] = d, n[9] = p, n[10] = g, n[11] = _, n[12] = v, n[13] = y, n[14] = b) : b = n[14], b;
}, cf = (t) => {
	let n = e(83), { id: r, clauseId: i, dataPoint: a, config: o, validate: s, onChange: c, vendors: l, contractDate: u, contractDateConditionValues: d } = t, { dataPointId: f, model: p } = a, h = r ?? `clause-${i}-data-point-${f}`, g;
	n[0] === o ? g = n[1] : (g = o ?? {}, n[0] = o, n[1] = g);
	let { numberOrQuestionConfig: _, numberInputConditionConfig: v, freeTextInputConfig: y, vendorSelectorConfig: b, dateInputConfig: x, numberOrDateConfig: S, addressConfig: C, checkQuestionConditionConfig: w, contractDatesConditionConfig: T } = g, E;
	n[2] === p ? E = n[3] : (E = p ?? {}, n[2] = p, n[3] = E);
	let { numberOrQuestion: D, numberInput: O, textInput: k, vendorIds: A, dateInput: j, numberOrDate: M, address: N, checkQuestion: F } = E, I;
	n[4] !== i || n[5] !== f || n[6] !== p || n[7] !== c ? (I = (e) => {
		if (!i || !f) return;
		let t = {
			...p,
			...e
		};
		P(t, p) || c(i, f, t);
	}, n[4] = i, n[5] = f, n[6] = p, n[7] = c, n[8] = I) : I = n[8];
	let L = I;
	if (_) {
		let e;
		n[9] === L ? e = n[10] : (e = (e) => {
			L({ numberOrQuestion: e });
		}, n[9] = L, n[10] = e);
		let t;
		return n[11] !== D || n[12] !== _ || n[13] !== e || n[14] !== h || n[15] !== s ? (t = /* @__PURE__ */ m(af, {
			id: h,
			onChange: e,
			config: _,
			defaultValue: D,
			validate: s
		}), n[11] = D, n[12] = _, n[13] = e, n[14] = h, n[15] = s, n[16] = t) : t = n[16], t;
	}
	if (v) {
		let e;
		n[17] === L ? e = n[18] : (e = (e) => {
			L({ numberInput: e });
		}, n[17] = L, n[18] = e);
		let t;
		return n[19] !== O || n[20] !== v || n[21] !== e || n[22] !== h || n[23] !== s ? (t = /* @__PURE__ */ m(Yd, {
			id: h,
			onChange: e,
			config: v,
			defaultValue: O,
			disabled: !1,
			validate: s
		}), n[19] = O, n[20] = v, n[21] = e, n[22] = h, n[23] = s, n[24] = t) : t = n[24], t;
	}
	if (y) {
		let e;
		n[25] === L ? e = n[26] : (e = (e) => {
			L({ textInput: e });
		}, n[25] = L, n[26] = e);
		let t;
		return n[27] !== y || n[28] !== e || n[29] !== h || n[30] !== k || n[31] !== s ? (t = /* @__PURE__ */ m(rf, {
			id: h,
			onChange: e,
			config: y,
			defaultValue: k,
			validate: s
		}), n[27] = y, n[28] = e, n[29] = h, n[30] = k, n[31] = s, n[32] = t) : t = n[32], t;
	}
	if (b) {
		let e;
		n[33] === L ? e = n[34] : (e = (e) => {
			L({ vendorIds: e });
		}, n[33] = L, n[34] = e);
		let t;
		return n[35] !== e || n[36] !== h || n[37] !== s || n[38] !== A || n[39] !== b || n[40] !== l ? (t = /* @__PURE__ */ m(sf, {
			id: h,
			onChange: e,
			config: b,
			defaultValue: A,
			vendors: l,
			validate: s
		}), n[35] = e, n[36] = h, n[37] = s, n[38] = A, n[39] = b, n[40] = l, n[41] = t) : t = n[41], t;
	}
	if (S) {
		let e;
		n[42] === L ? e = n[43] : (e = (e) => {
			L({ numberOrDate: e });
		}, n[42] = L, n[43] = e);
		let t;
		return n[44] !== M || n[45] !== S || n[46] !== e || n[47] !== h || n[48] !== s ? (t = /* @__PURE__ */ m($d, {
			id: h,
			onChange: e,
			config: S,
			defaultValue: M,
			validate: s
		}), n[44] = M, n[45] = S, n[46] = e, n[47] = h, n[48] = s, n[49] = t) : t = n[49], t;
	}
	if (T) {
		let e;
		n[50] === L ? e = n[51] : (e = (e) => {
			L({ numberOrDate: e });
		}, n[50] = L, n[51] = e);
		let t;
		return n[52] !== u || n[53] !== d || n[54] !== T || n[55] !== M || n[56] !== e || n[57] !== h || n[58] !== s ? (t = /* @__PURE__ */ m(nf, {
			id: h,
			onChange: e,
			config: T,
			defaultValue: M,
			validate: s,
			contractDate: u,
			currentValues: d
		}), n[52] = u, n[53] = d, n[54] = T, n[55] = M, n[56] = e, n[57] = h, n[58] = s, n[59] = t) : t = n[59], t;
	}
	if (C) {
		let e;
		n[60] === L ? e = n[61] : (e = (e) => {
			L({ address: e });
		}, n[60] = L, n[61] = e);
		let t;
		return n[62] !== N || n[63] !== C || n[64] !== e || n[65] !== h || n[66] !== s ? (t = /* @__PURE__ */ m(qd, {
			id: h,
			onChange: e,
			config: C,
			defaultValue: N,
			validate: s
		}), n[62] = N, n[63] = C, n[64] = e, n[65] = h, n[66] = s, n[67] = t) : t = n[67], t;
	}
	if (w) {
		let e;
		n[68] === L ? e = n[69] : (e = (e) => {
			L({ checkQuestion: e });
		}, n[68] = L, n[69] = e);
		let t;
		return n[70] !== F || n[71] !== w || n[72] !== e || n[73] !== h ? (t = /* @__PURE__ */ m(Jd, {
			id: h,
			onChange: e,
			config: w,
			defaultValue: F
		}), n[70] = F, n[71] = w, n[72] = e, n[73] = h, n[74] = t) : t = n[74], t;
	}
	if (x) {
		let e;
		n[75] === L ? e = n[76] : (e = (e) => {
			L({ dateInput: e });
		}, n[75] = L, n[76] = e);
		let t;
		return n[77] !== j || n[78] !== x || n[79] !== e || n[80] !== h || n[81] !== s ? (t = /* @__PURE__ */ m(Xd, {
			id: h,
			onChange: e,
			config: x,
			defaultValue: j,
			validate: s
		}), n[77] = j, n[78] = x, n[79] = e, n[80] = h, n[81] = s, n[82] = t) : t = n[82], t;
	}
}, lf = (t) => {
	let n = e(53), { id: r, position: i, campaignId: a, contractDate: o, specialConditionTemplate: s, specialConditionData: c, validate: l, onConditionRemove: u, onConditionsChange: g, vendors: _ } = t, v = r ?? `special-condition-display-${c.conditionType ?? i}`, y;
	n[0] !== g || n[1] !== c ? (y = (e, t, n) => {
		let r = c.clauses?.map((r) => {
			if (r.clauseId !== e) return r;
			let i = r.dataPoints?.map((e) => e.dataPointId === t ? {
				...e,
				model: {
					...e.model,
					...n
				}
			} : e) ?? [];
			return {
				...r,
				dataPoints: i
			};
		});
		P(c.clauses, r) || g({
			...c,
			clauses: r
		});
	}, n[0] = g, n[1] = c, n[2] = y) : y = n[2];
	let b = y, [x, S] = d(!1), C;
	n[3] === Symbol.for("react.memo_cache_sentinel") ? (C = () => {
		S(!0);
	}, n[3] = C) : C = n[3];
	let w = C, T;
	n[4] !== u || n[5] !== c.conditionType ? (T = () => {
		u(c.conditionType);
	}, n[4] = u, n[5] = c.conditionType, n[6] = T) : T = n[6];
	let E = T, D = Na(), O;
	n[7] === Symbol.for("react.memo_cache_sentinel") ? (O = f("specialConditionDisplay"), n[7] = O) : O = n[7];
	let k = O, A;
	if (n[8] !== o || n[9] !== b || n[10] !== E || n[11] !== i || n[12] !== c.clauses || n[13] !== c.conditionType || n[14] !== s.clauses || n[15] !== s.title || n[16] !== v || n[17] !== l || n[18] !== _ || n[19] !== D) {
		let e = s.clauses?.flatMap(uf) ?? [], t = c.clauses?.flatMap((t) => t ? t.dataPoints?.map((n) => {
			if (!n) return;
			let r = e?.find((e) => e.clauseId === t.clauseId && e.dataPointId === n.dataPointId);
			if (!(!r && c.conditionType !== ie.Custom)) return {
				dataPoint: n,
				clauseId: t.clauseId,
				config: r?.config
			};
		}) : [])?.filter(df) ?? [], r = t.flatMap(ff).filter(pf), a = D === Aa.Mobile ? "medium" : "large", u = +(D === Aa.Mobile), d = `${v}-title`, f;
		n[21] !== i || n[22] !== s.title || n[23] !== a || n[24] !== u || n[25] !== d ? (f = /* @__PURE__ */ h(Q, {
			id: "specialConditionTitleText",
			type: "label",
			size: a,
			color: "var(--text-primary)",
			flexShrink: u,
			dataTestId: d,
			children: [
				i,
				". ",
				s.title
			]
		}), n[21] = i, n[22] = s.title, n[23] = a, n[24] = u, n[25] = d, n[26] = f) : f = n[26];
		let p = `viewClauseButton-${c.conditionType ?? i}`, g = `${v}-view-clause`, y;
		n[27] !== p || n[28] !== g ? (y = /* @__PURE__ */ m(Kl, {
			id: p,
			dataTestId: g,
			text: "View clause",
			size: "small",
			variant: "hollow",
			onClick: w
		}), n[27] = p, n[28] = g, n[29] = y) : y = n[29];
		let x = `${v}-close-button`, S;
		n[30] !== E || n[31] !== x ? (S = /* @__PURE__ */ m(Hd, {
			onClick: E,
			id: x
		}), n[30] = E, n[31] = x, n[32] = S) : S = n[32];
		let C;
		n[33] !== y || n[34] !== S ? (C = /* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "sm",
			contentAlignment: "center",
			contentJustification: "end",
			flexShrink: 0,
			children: [y, S]
		}), n[33] = y, n[34] = S, n[35] = C) : C = n[35];
		let T;
		n[36] !== C || n[37] !== f ? (T = /* @__PURE__ */ h($, {
			fill: !0,
			direction: "horizontal",
			padding: "spacing-xl",
			className: "specialConditionTitle",
			contentJustification: "space-between",
			contentAlignment: "center",
			gap: "sm",
			children: [f, C]
		}), n[36] = C, n[37] = f, n[38] = T) : T = n[38], A = /* @__PURE__ */ h($, {
			direction: "vertical",
			fill: !0,
			className: k,
			"data-testid": v,
			children: [T, t.length > 0 && /* @__PURE__ */ m($, {
				direction: "vertical",
				padding: {
					top: "lg",
					right: "xl",
					bottom: "lg",
					left: "xl"
				},
				gap: "spacing-xl",
				className: "specialConditionConditions",
				children: t.map((e) => /* @__PURE__ */ m(cf, {
					clauseId: e?.clauseId ?? "",
					dataPoint: e?.dataPoint ?? {
						dataPointId: "",
						model: {}
					},
					config: e?.config ?? {},
					onChange: b,
					validate: l,
					vendors: _,
					contractDate: o,
					contractDateConditionValues: r,
					id: `${v}-clause-${e?.clauseId ?? "unknown"}-data-point-${e?.dataPoint?.dataPointId ?? "unknown"}`
				}, `clause-datapoint-display-${e?.clauseId}-${e?.dataPoint?.dataPointId}`))
			})]
		}), n[8] = o, n[9] = b, n[10] = E, n[11] = i, n[12] = c.clauses, n[13] = c.conditionType, n[14] = s.clauses, n[15] = s.title, n[16] = v, n[17] = l, n[18] = _, n[19] = D, n[20] = A;
	} else A = n[20];
	let j = `${v}-close-view-clause-modal`, M;
	n[39] === Symbol.for("react.memo_cache_sentinel") ? (M = () => S(!1), n[39] = M) : M = n[39];
	let N;
	n[40] === j ? N = n[41] : (N = [/* @__PURE__ */ m(Kl, {
		id: "closeViewClauseModal",
		dataTestId: j,
		text: "Close",
		variant: "primary",
		onClick: M
	}, "closeViewClauseModal")], n[40] = j, n[41] = N);
	let F;
	n[42] !== a || n[43] !== i || n[44] !== c ? (F = /* @__PURE__ */ m($, {
		direction: "vertical",
		fill: !0,
		gap: "md",
		padding: "xl",
		children: /* @__PURE__ */ m(Ud, {
			specialConditionData: c,
			position: i,
			campaignId: a
		})
	}), n[42] = a, n[43] = i, n[44] = c, n[45] = F) : F = n[45];
	let I;
	n[46] !== N || n[47] !== F || n[48] !== x ? (I = /* @__PURE__ */ m(Ya, {
		type: "single",
		variant: "withoutDivider",
		actionButtonContainerStyle: "withDivider",
		actionButtons: N,
		content: F,
		isOpen: x,
		setIsDialogOpen: S,
		maxWidth: "600px",
		maxHeight: "90vh"
	}), n[46] = N, n[47] = F, n[48] = x, n[49] = I) : I = n[49];
	let L;
	return n[50] !== I || n[51] !== A ? (L = /* @__PURE__ */ h(p, { children: [A, I] }), n[50] = I, n[51] = A, n[52] = L) : L = n[52], L;
};
function uf(e) {
	return (e.dataPoints ?? []).map((t) => ({
		clauseId: e.id,
		dataPointId: t.id,
		config: t.config
	}));
}
function df(e) {
	return e !== void 0;
}
function ff(e) {
	let t = e?.config?.contractDatesConditionConfig;
	return t ? [{
		contractDateType: t.contractDateType,
		label: t.label,
		model: e?.dataPoint?.model?.numberOrDate
	}] : [];
}
function pf(e) {
	return e.contractDateType !== void 0;
}
//#endregion
//#region src/formElements/SpecialConditions/SpecialConditionsPicker/Components/CustomSpecialConditions/Components/CustomSpecialCondition/CustomSpecialConditionLine/CustomSpecialConditionLine.tsx
var mf = (t) => {
	let n = e(23), { id: r, clausePosition: i, clauseText: a, onClauseTextChange: s, onClauseRemoved: c, isClause: l } = t, [u, f] = d(a), p;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (p = (e) => {
		f(e.value);
	}, n[0] = p) : p = n[0];
	let g = p, _;
	n[1] !== a || n[2] !== u || n[3] !== s ? (_ = () => {
		a !== u && s(u);
	}, n[1] = a, n[2] = u, n[3] = s, n[4] = _) : _ = n[4];
	let v;
	n[5] === u ? v = n[6] : (v = [u], n[5] = u, n[6] = v), o(_, v);
	let y = `${r}-line`, b = `customClause-${i}`, x = `${r}-position`, S;
	n[7] !== i || n[8] !== b || n[9] !== x ? (S = /* @__PURE__ */ m(Q, {
		id: b,
		type: "body_ui",
		size: "medium",
		color: "var(--text-primary)",
		dataTestId: x,
		children: i
	}), n[7] = i, n[8] = b, n[9] = x, n[10] = S) : S = n[10];
	let C = `${r}-text`, w = l ? "Clause" : "Special Condition", T;
	n[11] !== u || n[12] !== C || n[13] !== w ? (T = /* @__PURE__ */ m(Hc, {
		id: C,
		defaultValue: u,
		placeholder: w,
		onInputValueChange: g,
		noHeader: !0,
		stretch: !0,
		flexibleHeight: !0,
		verticalResizeOnly: !0
	}), n[11] = u, n[12] = C, n[13] = w, n[14] = T) : T = n[14];
	let E = `${r}-close-button`, D;
	n[15] !== c || n[16] !== E ? (D = /* @__PURE__ */ m(Hd, {
		onClick: c,
		id: E
	}), n[15] = c, n[16] = E, n[17] = D) : D = n[17];
	let O;
	return n[18] !== T || n[19] !== D || n[20] !== y || n[21] !== S ? (O = /* @__PURE__ */ h($, {
		direction: "horizontal",
		contentAlignment: "center",
		gap: "xs",
		"data-testid": y,
		children: [
			S,
			T,
			D
		]
	}), n[18] = T, n[19] = D, n[20] = y, n[21] = S, n[22] = O) : O = n[22], O;
}, hf = (t) => {
	let n = e(38), { clausePosition: r, condition: i, onConditionChange: a, onConditionRemove: o, showSimpleDisplay: s } = t, c = s === void 0 ? !1 : s, l = i.customCondition, u;
	n[0] !== i || n[1] !== l || n[2] !== a ? (u = (e) => {
		if (!l) return;
		let t = {
			...i,
			customCondition: {
				...l ?? {},
				textInput: e
			}
		};
		P(t, i) || a(t);
	}, n[0] = i, n[1] = l, n[2] = a, n[3] = u) : u = n[3];
	let d = u, f;
	n[4] !== i || n[5] !== l || n[6] !== a ? (f = (e, t) => {
		if (!l) return;
		let n = {
			...i,
			customCondition: {
				...l ?? {},
				subClauses: l?.subClauses?.map((n) => n.clauseId === t ? {
					...n,
					textInput: e
				} : n)
			}
		};
		P(n, i) || a(n);
	}, n[4] = i, n[5] = l, n[6] = a, n[7] = f) : f = n[7];
	let p = f, g;
	n[8] !== i || n[9] !== l || n[10] !== a ? (g = (e) => {
		l && a({
			...i,
			customCondition: {
				...l ?? {},
				subClauses: l?.subClauses?.filter((t) => t.clauseId !== e)
			}
		});
	}, n[8] = i, n[9] = l, n[10] = a, n[11] = g) : g = n[11];
	let _ = g, v;
	n[12] !== i.id || n[13] !== o ? (v = () => {
		o(i.id ?? "");
	}, n[12] = i.id, n[13] = o, n[14] = v) : v = n[14];
	let y = v, b;
	n[15] !== i || n[16] !== l || n[17] !== a ? (b = () => {
		l && a({
			...i,
			customCondition: {
				...l ?? {},
				subClauses: [...l?.subClauses || [], {
					clauseId: S(),
					textInput: "",
					subClauses: []
				}]
			}
		});
	}, n[15] = i, n[16] = l, n[17] = a, n[18] = b) : b = n[18];
	let x = b;
	if (!l) return null;
	let C;
	n[19] === Symbol.for("react.memo_cache_sentinel") ? (C = {
		top: "lg",
		bottom: "lg",
		left: "xl",
		right: "xl"
	}, n[19] = C) : C = n[19];
	let w = `custom-special-condition-${i.id ?? r}`, T = `${r}.`, E = l?.textInput ?? "", D = `custom-special-condition-${i.id ?? r}-primary`, O;
	n[20] !== y || n[21] !== d || n[22] !== E || n[23] !== D || n[24] !== T ? (O = /* @__PURE__ */ m(mf, {
		clausePosition: T,
		clauseText: E,
		onClauseTextChange: d,
		onClauseRemoved: y,
		isClause: !1,
		id: D
	}), n[20] = y, n[21] = d, n[22] = E, n[23] = D, n[24] = T, n[25] = O) : O = n[25];
	let k;
	n[26] !== r || n[27] !== i.id || n[28] !== l?.subClauses || n[29] !== x || n[30] !== _ || n[31] !== p || n[32] !== c ? (k = !c && /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "xs",
		fill: !0,
		padding: { left: "2xl" },
		"data-testid": `custom-special-condition-subclauses-${i.id ?? r}`,
		children: [l?.subClauses?.map((e, t) => /* @__PURE__ */ m(mf, {
			clausePosition: `${r}.${t + 1}`,
			clauseText: e.textInput ?? "",
			onClauseTextChange: (t) => p(t, e.clauseId ?? ""),
			onClauseRemoved: () => _(e.clauseId ?? ""),
			isClause: !0,
			id: `custom-special-condition-${i.id ?? r}-subclause-${e.clauseId ?? t + 1}`
		}, `custom-subclause-${e.clauseId}`)), /* @__PURE__ */ m(Nd, {
			id: `addSubClause-${r}`,
			checked: !1,
			onClick: x
		})]
	}), n[26] = r, n[27] = i.id, n[28] = l?.subClauses, n[29] = x, n[30] = _, n[31] = p, n[32] = c, n[33] = k) : k = n[33];
	let A;
	return n[34] !== O || n[35] !== k || n[36] !== w ? (A = /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		padding: C,
		gap: "xs",
		className: "customSpecialCondition",
		"data-testid": w,
		children: [O, k]
	}), n[34] = O, n[35] = k, n[36] = w, n[37] = A) : A = n[37], A;
}, gf = () => ({
	id: S(),
	conditionType: ie.Custom,
	customCondition: {
		textInput: "",
		subClauses: []
	}
}), _f = (t) => {
	let n = e(36), { startClausePosition: r, selectedCustomConditions: i, onCustomConditionsChanged: a, showSimpleDisplay: o } = t, s = o === void 0 ? !1 : o, c;
	n[0] !== a || n[1] !== i ? (c = (e, t) => {
		let n = i.map((n) => n.id === e ? { ...t } : n);
		P(i, n) || a(n);
	}, n[0] = a, n[1] = i, n[2] = c) : c = n[2];
	let l = c, u;
	n[3] !== a || n[4] !== i ? (u = (e) => {
		a(i.filter((t) => t.id !== e));
	}, n[3] = a, n[4] = i, n[5] = u) : u = n[5];
	let d = u, f;
	n[6] !== a || n[7] !== i ? (f = () => {
		a([...i, gf()]);
	}, n[6] = a, n[7] = i, n[8] = f) : f = n[8];
	let p = f, g, _;
	n[9] === Symbol.for("react.memo_cache_sentinel") ? (g = {
		top: "md",
		bottom: "md",
		left: "xl",
		right: "xl"
	}, _ = { borderBottom: "1px solid var(--border-secondary, rgba(0, 0, 0, 0.1))" }, n[9] = g, n[10] = _) : (g = n[9], _ = n[10]);
	let v = s ? "Special Conditions" : "Add your own Special Conditions", y;
	n[11] === v ? y = n[12] : (y = /* @__PURE__ */ m(Q, {
		id: "customSpecialConditionTitle",
		type: "body_ui_strong",
		size: "medium",
		color: "var(--text-primary)",
		children: v
	}), n[11] = v, n[12] = y);
	let b = s ? "Please note the special conditions to be inserted into the Contract:" : "Any other exact wording you would like to appear on the Contract under special conditions. We recommend this is provided by a Solicitor.", x;
	n[13] === b ? x = n[14] : (x = /* @__PURE__ */ m(Q, {
		id: "customSpecialConditionBodyNote",
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: b
	}), n[13] = b, n[14] = x);
	let S;
	n[15] !== x || n[16] !== y ? (S = /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		gap: "spacing-lg",
		padding: g,
		style: _,
		children: [y, x]
	}), n[15] = x, n[16] = y, n[17] = S) : S = n[17];
	let C;
	if (n[18] !== l || n[19] !== d || n[20] !== i || n[21] !== s || n[22] !== r) {
		let e;
		n[24] !== l || n[25] !== d || n[26] !== s || n[27] !== r ? (e = (e, t) => /* @__PURE__ */ m(hf, {
			clausePosition: r + t + 1,
			condition: e,
			onConditionChange: (t) => l(e.id ?? "", t),
			onConditionRemove: d,
			showSimpleDisplay: s
		}, `custom-special-condition-${e.id}`), n[24] = l, n[25] = d, n[26] = s, n[27] = r, n[28] = e) : e = n[28], C = i.map(e), n[18] = l, n[19] = d, n[20] = i, n[21] = s, n[22] = r, n[23] = C;
	} else C = n[23];
	let w;
	n[29] === Symbol.for("react.memo_cache_sentinel") ? (w = {
		top: "md",
		bottom: "md",
		left: "xl",
		right: "xl"
	}, n[29] = w) : w = n[29];
	let T;
	n[30] === p ? T = n[31] : (T = /* @__PURE__ */ m($, {
		fill: !0,
		gap: "spacing-lg",
		padding: w,
		className: "addSpecialConditionSection",
		children: /* @__PURE__ */ m(Kl, {
			id: "addCustomSpecialConditionButton",
			text: "Add Special Condition",
			variant: "hollow",
			onClick: p
		})
	}), n[30] = p, n[31] = T);
	let E;
	return n[32] !== S || n[33] !== C || n[34] !== T ? (E = /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		className: "customSpecialConditions",
		"data-testid": "custom-special-conditions",
		children: [
			S,
			C,
			T
		]
	}), n[32] = S, n[33] = C, n[34] = T, n[35] = E) : E = n[35], E;
}, vf = (t) => {
	let n = e(22), { id: r, campaignId: i, contractDate: a, selectedSpecialConditions: o, displayPredefinedConditions: s, validate: c, onValueChanged: l, vendors: u } = t, f = o === void 0 ? [] : o, g = s === void 0 ? !0 : s, { data: _, isPending: v } = pe(), y = f.filter(yf), b = f.filter(bf), x = (e) => {
		let t = y.map((t) => t.conditionType === e.conditionType ? { ...e } : t);
		P(y, t) || l({
			id: r,
			value: [...t, ...b]
		});
	}, S = (e) => {
		l({
			id: r,
			value: [...f.filter((t) => t.conditionType !== e)]
		});
	}, C = (e) => {
		l({
			id: r,
			value: [...e, ...b]
		});
	}, w = (e) => {
		P(b, e) || l({
			id: r,
			value: [...y, ...e]
		});
	}, [T, E] = d(!1);
	if (v) {
		let e;
		return n[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m(Eu, {}), n[0] = e) : e = n[0], e;
	}
	let D = $, O = `special-conditions-picker-${r}`, k = g && /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		children: [/* @__PURE__ */ m($, {
			direction: "horizontal",
			contentAlignment: "center",
			contentJustification: "center",
			fill: !0,
			padding: {
				right: "xl",
				left: "xl"
			},
			children: /* @__PURE__ */ m(Kl, {
				id: "searchSpecialConditions",
				dataTestId: `special-conditions-picker-open-modal-${r}`,
				text: "Search Special Conditions",
				variant: "primary",
				onClick: () => E(!0),
				stretch: !0
			})
		}), /* @__PURE__ */ m($, {
			direction: "vertical",
			fill: !0,
			className: "specialConditionsList",
			"data-testid": `special-conditions-list-${r}`,
			children: y.map((e, t) => {
				let n = _?.find((t) => t.conditionType === e.conditionType);
				return /* @__PURE__ */ m(lf, {
					specialConditionTemplate: n ?? {},
					specialConditionData: e,
					onConditionRemove: S,
					onConditionsChange: x,
					position: t + 1,
					campaignId: i,
					contractDate: a,
					validate: c,
					vendors: u,
					id: `special-condition-${e.conditionType ?? t}`
				}, e.conditionType);
			})
		})]
	}), A = !g, j;
	n[1] !== w || n[2] !== b || n[3] !== y.length || n[4] !== A ? (j = /* @__PURE__ */ m(_f, {
		selectedCustomConditions: b,
		onCustomConditionsChanged: w,
		startClausePosition: y.length,
		showSimpleDisplay: A
	}), n[1] = w, n[2] = b, n[3] = y.length, n[4] = A, n[5] = j) : j = n[5];
	let M;
	n[6] !== D || n[7] !== O || n[8] !== k || n[9] !== j ? (M = /* @__PURE__ */ h(D, {
		direction: "vertical",
		className: "specialConditionsPicker",
		"data-testid": O,
		children: [k, j]
	}), n[6] = D, n[7] = O, n[8] = k, n[9] = j, n[10] = M) : M = n[10];
	let N;
	n[11] === _ ? N = n[12] : (N = _ || [], n[11] = _, n[12] = N);
	let F;
	n[13] !== C || n[14] !== y || n[15] !== E || n[16] !== T || n[17] !== N ? (F = /* @__PURE__ */ m(zd, {
		selectedSpecialConditions: y,
		onChange: C,
		specialConditionTemplates: N,
		show: T,
		setShowModal: E
	}), n[13] = C, n[14] = y, n[15] = E, n[16] = T, n[17] = N, n[18] = F) : F = n[18];
	let I;
	return n[19] !== F || n[20] !== M ? (I = /* @__PURE__ */ h(p, { children: [M, F] }), n[19] = F, n[20] = M, n[21] = I) : I = n[21], I;
};
function yf(e) {
	return e.conditionType !== ie.Custom;
}
function bf(e) {
	return e.conditionType === ie.Custom;
}
//#endregion
//#region src/formElements/SpecialConditions/SpecialConditionsPicker/Components/SpecialConditionsPickerSelectModal/SpecialConditionsPickerSelectModal.tsx
var xf = (t) => {
	let n = e(71), { selectedClauseId: r, onChange: i, show: a, setShowModal: s, renderedConditions: c } = t, [l, u] = d(r), f;
	n[0] !== l || n[1] !== r ? (f = () => {
		P(l, r) || u(r);
	}, n[0] = l, n[1] = r, n[2] = f) : f = n[2];
	let p;
	n[3] === r ? p = n[4] : (p = [r], n[3] = r, n[4] = p), o(f, p);
	let g;
	n[5] !== r || n[6] !== s ? (g = () => {
		s(!1), u(r);
	}, n[5] = r, n[6] = s, n[7] = g) : g = n[7];
	let _ = g, v;
	n[8] !== l || n[9] !== i || n[10] !== s ? (v = () => {
		s(!1), i(l);
	}, n[8] = l, n[9] = i, n[10] = s, n[11] = v) : v = n[11];
	let y = v, [b, x] = d(""), S, C, w, T, E, D, O, k, A, j, M, N, F, I, L, R, z, B;
	if (n[12] !== l || n[13] !== c || n[14] !== b || n[15] !== a) {
		let e;
		n[34] === b ? e = n[35] : (e = (e) => {
			if (!b || b.length === 0) return e;
			let t = b.toLowerCase();
			if (e.title?.toLowerCase().includes(b.toLowerCase())) return e;
			let n = e.clauses?.filter((e) => e?.clauseText?.toLowerCase().includes(t));
			if (n && n.length > 0) return {
				...e,
				clauses: n
			};
		}, n[34] = b, n[35] = e);
		let t = c.map(e).filter(Sf);
		w = Ya, A = "single", j = "withoutDivider", M = "Select conditions to add", N = "withDivider", F = a, C = $, B = "vertical", T = "md", E = !0, D = "xl", O = "special-conditions-picker-select-modal", n[36] === Symbol.for("react.memo_cache_sentinel") ? (k = /* @__PURE__ */ m(qs, {
			id: "specialConditions-Search",
			type: "text",
			placeholder: "Search",
			border: "rounded",
			hideOptionalText: !0,
			leftIcon: /* @__PURE__ */ m(Di, {
				color: "var(--fg-tertiary, #B9B9B9)",
				height: 15,
				width: 15
			}),
			onChange: x,
			stretch: !0
		}), n[36] = k) : k = n[36], S = $, I = "vertical", L = "spacing-lg", R = !0;
		let r;
		n[37] === l ? r = n[38] : (r = (e) => /* @__PURE__ */ m(Fd, {
			selectionType: "clause",
			clauseIdSelected: l,
			clause: e,
			onToggle: u
		}, `special-condition-template-${e?.id ?? ""}`), n[37] = l, n[38] = r), z = t.map(r), n[12] = l, n[13] = c, n[14] = b, n[15] = a, n[16] = S, n[17] = C, n[18] = w, n[19] = T, n[20] = E, n[21] = D, n[22] = O, n[23] = k, n[24] = A, n[25] = j, n[26] = M, n[27] = N, n[28] = F, n[29] = I, n[30] = L, n[31] = R, n[32] = z, n[33] = B;
	} else S = n[16], C = n[17], w = n[18], T = n[19], E = n[20], D = n[21], O = n[22], k = n[23], A = n[24], j = n[25], M = n[26], N = n[27], F = n[28], I = n[29], L = n[30], R = n[31], z = n[32], B = n[33];
	let V;
	n[39] !== S || n[40] !== I || n[41] !== L || n[42] !== R || n[43] !== z ? (V = /* @__PURE__ */ m(S, {
		direction: I,
		gap: L,
		fill: R,
		children: z
	}), n[39] = S, n[40] = I, n[41] = L, n[42] = R, n[43] = z, n[44] = V) : V = n[44];
	let H;
	n[45] !== C || n[46] !== T || n[47] !== E || n[48] !== D || n[49] !== O || n[50] !== k || n[51] !== V || n[52] !== B ? (H = /* @__PURE__ */ h(C, {
		direction: B,
		gap: T,
		fill: E,
		padding: D,
		"data-testid": O,
		children: [k, V]
	}), n[45] = C, n[46] = T, n[47] = E, n[48] = D, n[49] = O, n[50] = k, n[51] = V, n[52] = B, n[53] = H) : H = n[53];
	let U;
	n[54] === _ ? U = n[55] : (U = /* @__PURE__ */ m(Kl, {
		id: "specialConditionsModal-cancel",
		text: "Cancel",
		variant: "hollow",
		onClick: _
	}, "specialConditionsModal-cancel"), n[54] = _, n[55] = U);
	let W;
	n[56] === y ? W = n[57] : (W = /* @__PURE__ */ m(Kl, {
		id: "specialConditionsModal-confirm",
		text: "Confirm",
		variant: "primary",
		onClick: y
	}, "specialConditionsModal-confirm"), n[56] = y, n[57] = W);
	let G;
	n[58] !== U || n[59] !== W ? (G = [U, W], n[58] = U, n[59] = W, n[60] = G) : G = n[60];
	let K;
	return n[61] !== w || n[62] !== s || n[63] !== A || n[64] !== j || n[65] !== M || n[66] !== N || n[67] !== F || n[68] !== H || n[69] !== G ? (K = /* @__PURE__ */ m(w, {
		type: A,
		variant: j,
		title: M,
		actionButtonContainerStyle: N,
		isOpen: F,
		content: H,
		setIsDialogOpen: s,
		actionButtons: G
	}), n[61] = w, n[62] = s, n[63] = A, n[64] = j, n[65] = M, n[66] = N, n[67] = F, n[68] = H, n[69] = G, n[70] = K) : K = n[70], K;
};
function Sf(e) {
	return e !== void 0;
}
//#endregion
//#region src/formElements/Conditions/ConditionDueOn/SatisfactionOfSpecialCondition.tsx
var Cf = (t) => {
	let n = e(35), { id: r, specialConditions: i, selectedClauseId: a, campaignId: s, onChange: c, validationTriggered: l, onIsValidChange: u } = t, [f, g] = d(!1), { pushToast: _ } = Ro(), v;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (v = [], n[0] = v) : v = n[0];
	let [y, b] = d(v), x;
	n[1] === Symbol.for("react.memo_cache_sentinel") ? (x = (e) => {
		b(e ?? []);
	}, n[1] = x) : x = n[1];
	let S;
	n[2] === _ ? S = n[3] : (S = {
		onSuccess: x,
		onError: (e) => {
			_({
				type: "error",
				message: "Error constructing clause text"
			}), b([]), console.error("Error constructing clause text:", e);
		}
	}, n[2] = _, n[3] = S);
	let { constructConditionClauseText: C, constructConditionClauseTextPending: w } = fe(S), T;
	n[4] !== s || n[5] !== C || n[6] !== i ? (T = () => {
		C({
			model: i,
			campaignId: s
		});
	}, n[4] = s, n[5] = C, n[6] = i, n[7] = T) : T = n[7];
	let E;
	n[8] !== s || n[9] !== i ? (E = [i, s], n[8] = s, n[9] = i, n[10] = E) : E = n[10], o(T, E);
	let D, O;
	if (n[11] !== y || n[12] !== a) {
		let e;
		n[15] === a ? e = n[16] : (e = (e) => e.id === a, n[15] = a, n[16] = e), D = y.flatMap(Tf).find(e), O = (D?.text?.length ?? 0) > 50 ? D?.text?.slice(0, 50) + "..." : D?.text, n[11] = y, n[12] = a, n[13] = D, n[14] = O;
	} else D = n[13], O = n[14];
	let k = O, A = w ? "Loading..." : D ? `${D.position} ${k}` : "Please select a special condition clause", j;
	n[17] !== c || n[18] !== u ? (j = (e) => {
		c(e), u && u(!!e);
	}, n[17] = c, n[18] = u, n[19] = j) : j = n[19];
	let M = j, N;
	n[20] === Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ m(Ei, { direction: "down" }), n[20] = N) : N = n[20];
	let P;
	n[21] === Symbol.for("react.memo_cache_sentinel") ? (P = () => g(!0), n[21] = P) : P = n[21];
	let F = l && !a ? "Special condition clause is required" : "", I;
	n[22] !== w || n[23] !== r || n[24] !== A || n[25] !== F ? (I = /* @__PURE__ */ m(qs, {
		id: r,
		defaultValue: A,
		disabled: w,
		readonly: !0,
		rightIcon: N,
		stretch: !0,
		type: "text",
		noHeader: !0,
		onClick: P,
		overflowEllipsis: !0,
		errorText: F
	}), n[22] = w, n[23] = r, n[24] = A, n[25] = F, n[26] = I) : I = n[26];
	let L;
	n[27] !== M || n[28] !== y || n[29] !== a || n[30] !== f ? (L = /* @__PURE__ */ m(xf, {
		renderedConditions: y,
		onChange: M,
		show: f,
		setShowModal: g,
		selectedClauseId: a
	}), n[27] = M, n[28] = y, n[29] = a, n[30] = f, n[31] = L) : L = n[31];
	let R;
	return n[32] !== I || n[33] !== L ? (R = /* @__PURE__ */ h(p, { children: [I, L] }), n[32] = I, n[33] = L, n[34] = R) : R = n[34], R;
};
function wf(e) {
	return {
		id: e?.clauseId,
		position: e?.clausePosition,
		text: e?.clauseText
	};
}
function Tf(e) {
	return [{
		id: e.id,
		text: e.title,
		position: e.position
	}, ...e.clauses?.map(wf) ?? []];
}
//#endregion
//#region src/formElements/SpecialConditions/OnOrDaysFrom/onOrDaysFromSegments.ts
var Ef = (e) => {
	let t = [{
		title: "# days from...",
		xsTitle: "# days from...",
		value: H.NDaysFrom
	}, {
		title: "on...",
		xsTitle: "on...",
		value: H.On
	}];
	return e ? t.reverse() : t;
}, Df = [{
	label: "day(s)",
	value: V.Days
}, {
	label: "business day(s)",
	value: V.BusinessDays
}], Of = /* @__PURE__ */ function(e) {
	return e.ContractDate = "Contract date", e.UnconditionalDate = "unconditional date", e;
}({}), kf = [
	{
		value: z.OnSpecificDate,
		label: "specific date"
	},
	{
		value: z.FinanceBeingSatisfied,
		label: "finance being satisfied"
	},
	{
		value: z.BuildingAndPestBeingSatisfied,
		label: "building and pest being satisfied"
	},
	{
		value: z.UponSatisfactionOfSpecialCondition,
		label: "satisfaction of special condition"
	}
], Af = (e, t) => {
	let n;
	t === Of.ContractDate ? n = {
		value: z.OnDate,
		label: Of.ContractDate
	} : t === Of.UnconditionalDate && (n = {
		value: z.OnDate,
		label: Of.UnconditionalDate
	});
	let r = kf.filter((t) => e?.includes(t.value) ?? !1);
	return [n, ...r].filter(Boolean);
}, jf = (t) => {
	let n = e(77), { id: r, invertSegmentOrder: i, condition: a, defaultCondition: s, conditionsToIncludeInDaysFrom: c, includeContractDateTypeInDaysFromOptions: l, conditionsToIncludeInOn: u, includeContractDateTypeInOnOptions: f, specialConditions: g, campaignId: _, validate: v, contractDateType: y, onChange: b, onIsValidChange: x, label: S } = t, C = i === void 0 ? !1 : i, w = c === void 0 ? [] : c, T = l === void 0 ? !0 : l, E;
	n[0] === u ? E = n[1] : (E = u === void 0 ? [] : u, n[0] = u, n[1] = E);
	let D = E, O = f === void 0 ? !0 : f, k;
	n[2] === C ? k = n[3] : (k = Ef(C), n[2] = C, n[3] = k);
	let A = k, j = Af(w, T ? y : void 0).filter(Mf), M = O ? y : void 0, N;
	n[4] !== D || n[5] !== M ? (N = Af(D, M), n[4] = D, n[5] = M, n[6] = N) : N = n[6];
	let F = N, I;
	n[7] === a.depositPayable ? I = n[8] : (I = () => a.depositPayable ?? H.NDaysFrom, n[7] = a.depositPayable, n[8] = I);
	let [L, R] = d(I), B;
	n[9] !== a || n[10] !== s || n[11] !== F?.[0]?.value ? (B = () => {
		let e = a.depositPayable ?? H.NDaysFrom, t = a.condition ?? s ?? (e === H.On ? F?.[0]?.value : z.NdaysFromDate);
		return {
			...a,
			condition: t,
			dayType: a.dayType ?? V.Days,
			depositPayable: e
		};
	}, n[9] = a, n[10] = s, n[11] = F?.[0]?.value, n[12] = B) : B = n[12];
	let [U, W] = d(B), G, K;
	n[13] !== a || n[14] !== U || n[15] !== b ? (G = () => {
		P(a, U) || b(U);
	}, K = [
		a,
		U,
		b
	], n[13] = a, n[14] = U, n[15] = b, n[16] = G, n[17] = K) : (G = n[16], K = n[17]), o(G, K);
	let q;
	n[18] === L ? q = n[19] : (q = (e) => {
		let t = e;
		t !== L && (R(t), W((e) => ({
			...e,
			condition: t === H.On ? z.OnSpecificDate : z.NdaysFromDate,
			depositPayable: t,
			daysFromDate: void 0,
			referenceDate: void 0,
			dayType: V.Days,
			specialConditionId: void 0
		})));
	}, n[18] = L, n[19] = q);
	let J = q, Y;
	n[20] !== U.condition || n[21] !== U.specialConditionId ? (Y = (e) => {
		let t = e;
		t !== U.condition && W((e) => ({
			...e,
			condition: t,
			specialConditionId: t === z.UponSatisfactionOfSpecialCondition ? U.specialConditionId : void 0
		}));
	}, n[20] = U.condition, n[21] = U.specialConditionId, n[22] = Y) : Y = n[22];
	let X = Y, Z;
	n[23] === Symbol.for("react.memo_cache_sentinel") ? (Z = (e) => {
		W((t) => ({
			...t,
			referenceDate: e ?? void 0
		}));
	}, n[23] = Z) : Z = n[23];
	let ee = Z, te;
	n[24] === Symbol.for("react.memo_cache_sentinel") ? (te = (e) => {
		W((t) => ({
			...t,
			specialConditionId: e
		}));
	}, n[24] = te) : te = n[24];
	let ne = te, re;
	n[25] === Symbol.for("react.memo_cache_sentinel") ? (re = (e) => {
		let { value: t } = e, n = parseInt(t, 10);
		W((e) => ({
			...e,
			daysFromDate: Number.isNaN(n) ? void 0 : n
		}));
	}, n[25] = re) : re = n[25];
	let ie = re, ae;
	n[26] === Symbol.for("react.memo_cache_sentinel") ? (ae = (e) => {
		let t = e;
		W((e) => ({
			...e,
			dayType: t
		}));
	}, n[26] = ae) : ae = n[26];
	let oe = ae, se = j.map(Nf), ce = U.condition && se.includes(U.condition) ? U.condition : j?.[0]?.value, le = L === H.NDaysFrom && !!U.daysFromDate || L === H.On, ue = U.condition === z.OnSpecificDate && !!U.referenceDate || U.condition !== z.OnSpecificDate, de = U.condition === z.UponSatisfactionOfSpecialCondition && !!U.specialConditionId || U.condition !== z.UponSatisfactionOfSpecialCondition, fe, pe;
	n[27] !== le || n[28] !== de || n[29] !== ue || n[30] !== x ? (fe = () => {
		x(le && ue && de);
	}, pe = [
		le,
		ue,
		de,
		x
	], n[27] = le, n[28] = de, n[29] = ue, n[30] = x, n[31] = fe, n[32] = pe) : (fe = n[31], pe = n[32]), o(fe, pe);
	let me = Na(), he = `on-or-days-from-${r}`, ge = `on-or-days-from-segment-${r}`, _e;
	n[33] === J ? _e = n[34] : (_e = (e) => J(e), n[33] = J, n[34] = _e);
	let ve;
	n[35] !== S || n[36] !== A || n[37] !== L || n[38] !== ge || n[39] !== _e ? (ve = /* @__PURE__ */ m(Ql, {
		id: ge,
		label: S,
		segments: A,
		defaultValue: L,
		onChange: _e
	}), n[35] = S, n[36] = A, n[37] = L, n[38] = ge, n[39] = _e, n[40] = ve) : ve = n[40];
	let ye;
	n[41] !== U.condition || n[42] !== U.referenceDate || n[43] !== X || n[44] !== r || n[45] !== F || n[46] !== ee || n[47] !== L || n[48] !== v ? (ye = L === H.On && /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(Ec, {
		options: F,
		id: `onselect-${r}`,
		selected: U.condition,
		onChange: X,
		noHeader: !0,
		required: !0
	}), U.condition === z.OnSpecificDate && /* @__PURE__ */ m(fc, {
		id: `conditionOnSpecificDate-${r}`,
		dataTestId: `conditionOnSpecificDate-${r}`,
		onChange: ee,
		required: !0,
		noHeader: !0,
		value: U.referenceDate,
		stretch: !0,
		validate: v
	}, `conditionOnSpecificDate-${r}`)] }), n[41] = U.condition, n[42] = U.referenceDate, n[43] = X, n[44] = r, n[45] = F, n[46] = ee, n[47] = L, n[48] = v, n[49] = ye) : ye = n[49];
	let be;
	n[50] !== U.dayType || n[51] !== U.daysFromDate || n[52] !== ce || n[53] !== j || n[54] !== X || n[55] !== r || n[56] !== le || n[57] !== oe || n[58] !== ie || n[59] !== L || n[60] !== v || n[61] !== me ? (be = L === H.NDaysFrom && /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "xs",
		fill: !0,
		children: [/* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "xs",
			fill: !0,
			contentAlignment: "baseline",
			"data-testid": `on-or-days-from-days-section-${r}`,
			children: [
				/* @__PURE__ */ m(qs, {
					id: `numberOfDays-${r}`,
					type: "number",
					noHeader: !0,
					maxLength: 2,
					defaultValue: U.daysFromDate?.toString() ?? "",
					onInputValueChange: ie,
					errorText: v && !le ? "Enter days" : "",
					size: "medium",
					textAlign: "center"
				}),
				/* @__PURE__ */ m(Ec, {
					options: Df,
					id: `ondaysselect-${r}`,
					selected: U.dayType,
					onChange: oe,
					noHeader: !0,
					required: !0,
					minWidth: "140px"
				}),
				/* @__PURE__ */ m(Q, {
					type: "body_ui",
					id: `financeConditionPayable-from-${r}`,
					size: "small",
					color: "var(--text-primary)",
					children: "from"
				}),
				me !== Aa.Mobile && /* @__PURE__ */ m(Ec, {
					options: j,
					id: `onselect-${r}`,
					selected: ce,
					onChange: X,
					noHeader: !0,
					required: !0,
					type: "single"
				})
			]
		}), me === Aa.Mobile && /* @__PURE__ */ m(Ec, {
			options: j,
			id: `onselect-${r}`,
			selected: ce,
			onChange: X,
			noHeader: !0,
			required: !0,
			type: "single",
			stretch: !0
		})]
	}), n[50] = U.dayType, n[51] = U.daysFromDate, n[52] = ce, n[53] = j, n[54] = X, n[55] = r, n[56] = le, n[57] = oe, n[58] = ie, n[59] = L, n[60] = v, n[61] = me, n[62] = be) : be = n[62];
	let xe;
	n[63] !== _ || n[64] !== U.condition || n[65] !== U.specialConditionId || n[66] !== r || n[67] !== ne || n[68] !== g || n[69] !== v ? (xe = U.condition === z.UponSatisfactionOfSpecialCondition && /* @__PURE__ */ m(Cf, {
		id: `conditionSpecialClause-satisfactionOfSpecialCondition-${r}`,
		specialConditions: g,
		onChange: ne,
		campaignId: _,
		selectedClauseId: U.specialConditionId,
		validationTriggered: v
	}), n[63] = _, n[64] = U.condition, n[65] = U.specialConditionId, n[66] = r, n[67] = ne, n[68] = g, n[69] = v, n[70] = xe) : xe = n[70];
	let Se;
	return n[71] !== he || n[72] !== ve || n[73] !== ye || n[74] !== be || n[75] !== xe ? (Se = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "md",
		fill: !0,
		"data-testid": he,
		children: [
			ve,
			ye,
			be,
			xe
		]
	}), n[71] = he, n[72] = ve, n[73] = ye, n[74] = be, n[75] = xe, n[76] = Se) : Se = n[76], Se;
};
function Mf(e) {
	return e.value !== z.OnSpecificDate;
}
function Nf(e) {
	return e.value;
}
//#endregion
//#region src/formElements/Launch/NoLaunchDateReason.tsx
var Pf = /* @__PURE__ */ function(e) {
	return e.ToBeConfirmed = "ToBeConfirmed", e.OffMarket = "OffMarket", e;
}({}), Ff = {
	reaPayOnSale: "REA Pay on Sale",
	reaDowngrade: "REA Downgrade",
	reaUpgrade: "REA Upgrade",
	domainDowngrade: "Domain Downgrade",
	domainUpgrade: "Domain Upgrade"
}, If = [{
	label: "Launch date confirmed",
	value: X.Confirmed
}, {
	label: "No launch date set",
	value: "no-launch-date"
}], Lf = [{
	label: "To be confirmed with Vendor",
	value: Pf.ToBeConfirmed
}, {
	label: "Off market listing",
	value: Pf.OffMarket
}], Rf = Object.entries(Ff).map(([e, t]) => ({
	label: t,
	value: e
})), zf = /* @__PURE__ */ new Date();
zf.setHours(0, 0, 0, 0);
var Bf = (t) => {
	let n = e(27), { id: r, onValueChanged: i, defaultValue: a, validate: s } = t, c;
	n[0] === a ? c = n[1] : (c = () => ({
		...a ?? {},
		status: a?.status ?? X.Confirmed
	}), n[0] = a, n[1] = c);
	let [l, u] = d(c), f;
	n[2] !== l || n[3] !== r || n[4] !== i ? (f = () => {
		i({
			id: r,
			value: l
		});
	}, n[2] = l, n[3] = r, n[4] = i, n[5] = f) : f = n[5];
	let p;
	n[6] === l ? p = n[7] : (p = [l], n[6] = l, n[7] = p), o(f, p);
	let g = l.status === X.Confirmed || l.status === X.ToBeConfirmed, _;
	n[8] === Symbol.for("react.memo_cache_sentinel") ? (_ = Object.entries(Ff), n[8] = _) : _ = n[8];
	let v;
	n[9] === l ? v = n[10] : (v = _.filter((e) => {
		let [t] = e;
		return !!l[t];
	}).map(Vf), n[9] = l, n[10] = v);
	let y = v, b = Hf, x = `${r}-launch-date-selection`, S = l.status === X.Confirmed ? X.Confirmed : "no-launch-date", C;
	n[11] === Symbol.for("react.memo_cache_sentinel") ? (C = (e) => {
		u((t) => {
			let n = e === "no-launch-date" ? t.status === X.ToBeConfirmed || t.status === X.OffMarket ? t.status : void 0 : e, r = {
				...t,
				status: n,
				launchDate: n === X.Confirmed ? t.launchDate : void 0
			};
			return n !== X.Confirmed && n !== X.ToBeConfirmed && (r = b(r)), P(t, r) ? t : r;
		});
	}, n[11] = C) : C = n[11];
	let w;
	n[12] !== l || n[13] !== r || n[14] !== s ? (w = l.status === X.Confirmed ? /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		gap: "spacing-sm",
		padding: {
			top: "spacing-2xl",
			bottom: "spacing-2xl",
			left: "spacing-lg",
			right: "spacing-lg"
		},
		children: [/* @__PURE__ */ m(fc, {
			id: `${r}-launch-date`,
			value: l.launchDate,
			onChange: (e) => u((t) => ({
				...t,
				launchDate: e ?? void 0
			})),
			label: "Launch Date",
			required: !0,
			optionalText: "",
			stretch: !0,
			minDate: zf
		}), s && (!("launchDate" in l) || l.launchDate === void 0) && /* @__PURE__ */ m("div", {
			className: "error",
			children: /* @__PURE__ */ m(Q, {
				id: `${r}-launch-date-error`,
				type: "form_error",
				size: "small",
				color: "var(--text-error)",
				children: "Enter launch date"
			})
		})]
	}) : /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		gap: "spacing-sm",
		padding: {
			top: "spacing-2xl",
			bottom: "spacing-2xl",
			left: "spacing-lg",
			right: "spacing-lg"
		},
		children: [/* @__PURE__ */ m(bs, {
			id: `${r}-launch-date-reason`,
			layout: "stacked",
			label: "Reason",
			required: !0,
			options: Lf,
			value: l.status === X.ToBeConfirmed ? Pf.ToBeConfirmed : l.status === X.OffMarket ? Pf.OffMarket : "no-launch-date-reason",
			onChange: (e) => {
				let t = e, n = t === Pf.ToBeConfirmed ? X.ToBeConfirmed : t === Pf.OffMarket ? X.OffMarket : void 0;
				n !== l.status && u((e) => {
					let r = {
						...e,
						status: n
					};
					return t !== Pf.ToBeConfirmed && (r = b(r)), P(e, r) ? e : r;
				});
			}
		}), s && (!("status" in l) || l.status === void 0) && /* @__PURE__ */ m("div", {
			className: "error",
			children: /* @__PURE__ */ h($, {
				direction: "horizontal",
				gap: "spacing-sm",
				padding: { top: "spacing-sm" },
				contentAlignment: "center",
				children: [/* @__PURE__ */ m(ki, {
					width: 16,
					height: 16,
					type: "Danger"
				}), /* @__PURE__ */ m(Q, {
					id: `${r}-launch-date-reason-error`,
					type: "form_error",
					size: "small",
					color: "var(--text-error)",
					children: "Select a reason"
				})]
			})
		})]
	}), n[12] = l, n[13] = r, n[14] = s, n[15] = w) : w = n[15];
	let T;
	n[16] !== x || n[17] !== S || n[18] !== w ? (T = /* @__PURE__ */ m(bs, {
		id: x,
		layout: "stacked",
		label: "Launch Date",
		options: If,
		value: S,
		required: !0,
		onChange: C,
		subContent: w
	}), n[16] = x, n[17] = S, n[18] = w, n[19] = T) : T = n[19];
	let E;
	n[20] !== r || n[21] !== y || n[22] !== g ? (E = g && /* @__PURE__ */ m(_s, {
		id: `${r}-launch-boolean-fields`,
		layout: "vertical",
		label: "Select any of the below that apply",
		options: Rf,
		value: y,
		onChange: (e) => {
			u((t) => {
				let n = new Set(e), r = { ...t };
				return Object.keys(Ff).forEach((e) => {
					r[e] = n.has(e);
				}), P(t, r) ? t : r;
			});
		}
	}), n[20] = r, n[21] = y, n[22] = g, n[23] = E) : E = n[23];
	let D;
	return n[24] !== T || n[25] !== E ? (D = /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		gap: "spacing-5xl",
		children: [T, E]
	}), n[24] = T, n[25] = E, n[26] = D) : D = n[26], D;
};
function Vf(e) {
	let [t] = e;
	return String(t);
}
function Hf(e) {
	let t = { ...e };
	return Object.keys(Ff).forEach((e) => {
		t[e] = !1;
	}), t;
}
//#endregion
//#region src/formElements/AuctionDetails/helpers.ts
var Uf = /^([01]\d|2[0-3]):([0-5]\d)$/, Wf = (e, t) => (0, So.default)(e).hour(t.hour()).minute(t.minute()), Gf = (e, t) => {
	let n = Uf.exec(e);
	if (!n) return;
	let [, r, i] = n;
	return t.hour(Number(r)).minute(Number(i));
}, Kf = (e) => Uf.test(e), qf = /* @__PURE__ */ Ee((/* @__PURE__ */ Ce(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r;
				if (o === 0) return this.utc(i);
				var s = this.clone();
				if (i) return s.$offset = o, s.$u = !1, s;
				var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
				return (s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c, s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
})))(), 1);
So.default.extend(qf.default);
var Jf = (e) => {
	if (!e) return (0, So.default)().startOf("day");
	let t = So.default.utc(e);
	return t.isValid() ? t.local() : (0, So.default)().startOf("day");
}, Yf = (e) => e.second(0).millisecond(0).toISOString(), Xf = "00:00", Zf = ({ id: e, validate: t, required: n, onValueChanged: r, defaultValue: i }) => {
	let a = u(r);
	a.current = r;
	let [s, c] = d({
		auctionDate: Jf(i?.auctionDate),
		location: i?.location ?? ""
	}), [l, f] = d(!!i?.auctionDate), { auctionDate: p, location: g } = s, [_, v] = d(p.format("HH:mm")), [y, b] = d(""), [x, S] = d(0);
	return o(() => {
		a.current({
			id: e,
			value: {
				...s,
				auctionDate: l ? Yf(p) : void 0
			}
		}), v(p.format("HH:mm"));
	}, [
		s,
		l,
		e
	]), /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [/* @__PURE__ */ h($, {
			direction: "horizontal",
			gap: "lg",
			fill: !0,
			contentAlignment: "start",
			children: [/* @__PURE__ */ m(fc, {
				id: `${e}-date`,
				label: "Auction Date",
				required: !0,
				value: l ? p.toDate() : void 0,
				onChange: (e) => {
					if (!e) {
						f(!1);
						return;
					}
					let t = Wf(e, p);
					t.isValid() && (f(!0), c((e) => ({
						...e,
						auctionDate: t
					})));
				},
				stretch: !0,
				errorText: t && !l ? "Enter a date" : void 0
			}, `${e}-date`), /* @__PURE__ */ m(zc, {
				id: `${e}-time`,
				label: "Auction Time",
				required: n,
				value: _,
				onChange: (e) => {
					if (!e) {
						b(""), v(Xf), S((e) => e + 1), c((e) => ({
							...e,
							auctionDate: Gf(Xf, p) ?? p
						}));
						return;
					}
					if (!Kf(e)) {
						b("Enter a valid time");
						return;
					}
					let t = Gf(e, p);
					t?.isValid() && (b(""), v(t.format("HH:mm")), c((e) => ({
						...e,
						auctionDate: t
					})));
				},
				errorText: y,
				stretch: !0
			}, `${e}-time-${x}`)]
		}), /* @__PURE__ */ m(qs, {
			id: `${e}-location`,
			label: "Location",
			type: "text",
			required: n,
			onInputValueChange: ({ value: e }) => {
				c((t) => ({
					...t,
					location: e
				}));
			},
			stretch: !0,
			defaultValue: g
		})]
	}, e);
}, Qf = /* @__PURE__ */ function(e) {
	return e.JointTenants = "JointTenants", e.TenantsInCommon = "TenantsInCommon", e;
}({}), $f = (t) => {
	let n = e(11), { id: r, defaultValue: i, onValueChanged: a } = t, [s, c] = d(i ?? null), l, u;
	n[0] === i ? (l = n[1], u = n[2]) : (l = () => {
		c(i ?? null);
	}, u = [i], n[0] = i, n[1] = l, n[2] = u), o(l, u);
	let f;
	n[3] !== r || n[4] !== a ? (f = (e) => {
		let t = e === Qf.JointTenants ? Qf.JointTenants : e === Qf.TenantsInCommon ? Qf.TenantsInCommon : null;
		c(t), a?.({
			id: r,
			value: t
		});
	}, n[3] = r, n[4] = a, n[5] = f) : f = n[5];
	let p = f, h = `${r}-ownership-structure`, g;
	n[6] === Symbol.for("react.memo_cache_sentinel") ? (g = [{
		label: "Joint Tenants",
		value: Qf.JointTenants
	}, {
		label: "Tenants In Common",
		value: Qf.TenantsInCommon
	}], n[6] = g) : g = n[6];
	let _ = s ?? void 0, v;
	return n[7] !== p || n[8] !== h || n[9] !== _ ? (v = /* @__PURE__ */ m(bs, {
		id: h,
		layout: "stacked",
		label: "Ownership structure",
		options: g,
		value: _,
		onChange: p
	}), n[7] = p, n[8] = h, n[9] = _, n[10] = v) : v = n[10], v;
}, ep = {
	House: "House",
	UnitApartment: "Unit/Apartment",
	Townhouse: "Townhouse",
	Villa: "Villa",
	ResidentialLand: "Residential Land",
	Rural: "Rural",
	Retirement: "Retirement"
}, tp = {
	PropertyType: "PropertyType",
	RuralType: "RuralType",
	BuiltOnOrVacantLandType: "BuiltOnOrVacantLandType",
	NumberOfBeds: "NumberOfBeds",
	NumberOfBathrooms: "NumberOfBathrooms",
	NumberOfCarSpaces: "NumberOfCarSpaces",
	TotalLandArea: "TotalLandArea",
	TotalLandAreaType: "TotalLandAreaType",
	InternalArea: "InternalArea"
}, np = [
	{
		label: "m²",
		value: Y.SquareMetres
	},
	{
		label: "ha",
		value: Y.Hectares
	},
	{
		label: "acre",
		value: Y.Acres
	}
], rp = (t) => {
	let n = e(44), { id: r, landAreaDetails: i, onChange: a, canHideAttributes: o, hidePropertyAttributes: s, required: c, validate: l } = t, u = o === void 0 ? !1 : o, d;
	n[0] === s ? d = n[1] : (d = s === void 0 ? [] : s, n[0] = s, n[1] = d);
	let f = d, p = c === void 0 ? !1 : c, g = l === void 0 ? !1 : l, _;
	n[2] === i ? _ = n[3] : (_ = i ?? {}, n[2] = i, n[3] = _);
	let v = _, y;
	n[4] !== u || n[5] !== f ? (y = u && f.includes(tp.InternalArea), n[4] = u, n[5] = f, n[6] = y) : y = n[6];
	let b = y, x = g && p && !v.totalLandArea, S = `${r}-land-area`, C = `${r}-total-land-area`, w;
	n[7] === v.totalLandArea ? w = n[8] : (w = v.totalLandArea?.toString() ?? "", n[7] = v.totalLandArea, n[8] = w);
	let T;
	n[9] !== v || n[10] !== r || n[11] !== a ? (T = (e) => a({
		id: r,
		value: {
			...v,
			totalLandArea: ku(e)
		}
	}), n[9] = v, n[10] = r, n[11] = a, n[12] = T) : T = n[12];
	let E = x ? "Enter Land size" : "", D = `${r}-total-land-area-icon`, O;
	n[13] === D ? O = n[14] : (O = /* @__PURE__ */ m(pa, {
		width: 20,
		height: 20,
		"data-testid": D,
		color: "var(--fg-tertiary)"
	}), n[13] = D, n[14] = O);
	let k;
	n[15] !== p || n[16] !== w || n[17] !== T || n[18] !== E || n[19] !== O || n[20] !== C ? (k = /* @__PURE__ */ m($, {
		gap: "spacing-sm",
		fill: !0,
		children: /* @__PURE__ */ m(qs, {
			label: "Land Size",
			id: C,
			type: "number",
			stretch: !0,
			hideOptionalText: !0,
			placeholder: "Enter land size",
			defaultValue: w,
			onChange: T,
			errorText: E,
			required: p,
			leftIcon: O
		})
	}), n[15] = p, n[16] = w, n[17] = T, n[18] = E, n[19] = O, n[20] = C, n[21] = k) : k = n[21];
	let A = `${r}-total-land-area-type`, j = v.totalLandAreaType ?? Y.SquareMetres, M;
	n[22] !== v || n[23] !== r || n[24] !== a ? (M = (e) => a({
		id: r,
		value: {
			...v,
			totalLandAreaType: e
		}
	}), n[22] = v, n[23] = r, n[24] = a, n[25] = M) : M = n[25];
	let N;
	n[26] !== p || n[27] !== A || n[28] !== j || n[29] !== M ? (N = /* @__PURE__ */ m(Ec, {
		id: A,
		label: "Unit",
		lineHeight: "20px",
		options: np,
		selected: j,
		onChange: M,
		placeholder: "Select unit",
		hideOptionalText: !0,
		stretch: !0,
		required: p
	}), n[26] = p, n[27] = A, n[28] = j, n[29] = M, n[30] = N) : N = n[30];
	let P;
	n[31] !== k || n[32] !== N ? (P = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-lg",
		fill: !0,
		children: [k, N]
	}), n[31] = k, n[32] = N, n[33] = P) : P = n[33];
	let F;
	n[34] !== v || n[35] !== b || n[36] !== r || n[37] !== a || n[38] !== p ? (F = !b && /* @__PURE__ */ h($, {
		gap: "spacing-sm",
		fill: !0,
		children: [/* @__PURE__ */ m($, {
			direction: "horizontal",
			gap: "spacing-xs",
			contentAlignment: "center"
		}), /* @__PURE__ */ m(qs, {
			id: `${r}-internal-area`,
			required: p,
			label: "Internal area",
			type: "number",
			stretch: !0,
			leftIcon: /* @__PURE__ */ m(ma, {
				width: 20,
				height: 20,
				"data-testid": `${r}-internal-area-icon`,
				color: "var(--fg-tertiary)"
			}),
			hideOptionalText: !0,
			placeholder: "Enter internal area",
			defaultValue: v.internalArea?.toString() ?? "",
			onChange: (e) => a({
				id: r,
				value: {
					...v,
					internalArea: ku(e)
				}
			})
		})]
	}), n[34] = v, n[35] = b, n[36] = r, n[37] = a, n[38] = p, n[39] = F) : F = n[39];
	let I;
	return n[40] !== P || n[41] !== F || n[42] !== S ? (I = /* @__PURE__ */ h($, {
		gap: "spacing-xl",
		fill: !0,
		"data-testid": S,
		children: [P, F]
	}), n[40] = P, n[41] = F, n[42] = S, n[43] = I) : I = n[43], I;
}, ip = [
	{
		label: "House",
		value: ep.House
	},
	{
		label: "Unit/Apartment",
		value: ep.UnitApartment
	},
	{
		label: "Townhouse",
		value: ep.Townhouse
	},
	{
		label: "Villa",
		value: ep.Villa
	},
	{
		label: "Residential Land",
		value: ep.ResidentialLand
	},
	{
		label: "Rural",
		value: ep.Rural
	},
	{
		label: "Retirement",
		value: ep.Retirement
	}
], ap = [
	{
		label: "Lifestyle",
		value: ne.Lifestyle
	},
	{
		label: "Mixed Farming",
		value: ne.MixedFarming
	},
	{
		label: "Farmlet",
		value: ne.Farmlet
	},
	{
		label: "Livestock",
		value: ne.Livestock
	},
	{
		label: "Other",
		value: ne.Other
	}
], op = [{
	label: "Built on",
	value: I.BuiltOn
}, {
	label: "Vacant Land",
	value: I.VacantLand
}], sp = Array.from({ length: 21 }, (e, t) => ({
	label: t.toString(),
	value: t.toString()
})), cp = (t) => {
	let n = e(13), { id: r, label: i, selected: a, icon: o, errorText: s, onChange: c, placeholder: l, required: u } = t, d = u === void 0 ? !1 : u, f;
	n[0] === a ? f = n[1] : (f = a?.toString(), n[0] = a, n[1] = f);
	let p;
	n[2] === c ? p = n[3] : (p = (e) => {
		let t = Number(e);
		c(Number.isNaN(t) ? void 0 : t);
	}, n[2] = c, n[3] = p);
	let h;
	return n[4] !== s || n[5] !== o || n[6] !== r || n[7] !== i || n[8] !== l || n[9] !== d || n[10] !== f || n[11] !== p ? (h = /* @__PURE__ */ m(Ec, {
		id: r,
		"data-testid": r,
		options: sp,
		selected: f,
		onChange: p,
		placeholder: l,
		errorText: s,
		hideOptionalText: !0,
		stretch: !0,
		leftIcon: o,
		required: d,
		label: i
	}), n[4] = s, n[5] = o, n[6] = r, n[7] = i, n[8] = l, n[9] = d, n[10] = f, n[11] = p, n[12] = h) : h = n[12], h;
}, lp = (t) => {
	let n = e(68), { id: r, label: i, hidePropertyAttributes: a, defaultValue: o, onChange: s, required: c, isLandAreaRequired: l, validate: u } = t, f = i === void 0 ? "Property Attributes" : i, p;
	n[0] === a ? p = n[1] : (p = a === void 0 ? [] : a, n[0] = a, n[1] = p);
	let g = p, _ = c === void 0 ? !1 : c, v = l === void 0 ? !1 : l, y = u === void 0 ? !1 : u, [b, x] = d(o), S = b?.propertyType === ep.ResidentialLand || b?.propertyType === ep.Rural && b?.builtOnOrVacantLandType === I.VacantLand, C;
	n[2] !== r || n[3] !== s ? (C = (e) => {
		x((t) => {
			let n = e(t);
			return s({
				id: r,
				value: n
			}), n;
		});
	}, n[2] = r, n[3] = s, n[4] = C) : C = n[4];
	let w = C, T;
	n[5] === w ? T = n[6] : (T = (e, t) => {
		w((n) => ({
			...n,
			[e]: t
		}));
	}, n[5] = w, n[6] = T);
	let E = T, D = `${r}-label`, O;
	n[7] !== f || n[8] !== D ? (O = /* @__PURE__ */ m(Q, {
		id: D,
		type: "label",
		size: "large",
		color: "var(--text-primary)",
		children: f
	}), n[7] = f, n[8] = D, n[9] = O) : O = n[9];
	let k;
	n[10] !== S || n[11] !== g || n[12] !== r || n[13] !== b?.propertyType || n[14] !== _ || n[15] !== w || n[16] !== y ? (k = !(S && g.includes(tp.PropertyType)) && /* @__PURE__ */ m(Ec, {
		id: `${r}-property-type`,
		label: "Property Type",
		options: ip,
		selected: b?.propertyType,
		onChange: (e) => w((t) => ({
			...t,
			propertyType: e,
			ruralType: void 0,
			builtOnOrVacantLandType: void 0
		})),
		placeholder: "Select property type",
		errorText: y && _ && !b?.propertyType ? "Select property type" : "",
		hideOptionalText: !0,
		stretch: !0,
		required: !0
	}), n[10] = S, n[11] = g, n[12] = r, n[13] = b?.propertyType, n[14] = _, n[15] = w, n[16] = y, n[17] = k) : k = n[17];
	let A;
	n[18] !== S || n[19] !== g || n[20] !== r || n[21] !== b || n[22] !== w || n[23] !== y ? (A = !(S && g.includes(tp.RuralType)) && b?.propertyType === ep.Rural && /* @__PURE__ */ h($, {
		gap: "spacing-xl",
		fill: !0,
		children: [/* @__PURE__ */ m(Ec, {
			id: `${r}-rural-type`,
			label: "Sub Category",
			options: ap,
			selected: b.ruralType,
			onChange: (e) => w((t) => ({
				...t,
				ruralType: e
			})),
			placeholder: "Select sub category",
			errorText: y && !b?.ruralType ? "Select a sub-category for property type" : "",
			hideOptionalText: !0,
			stretch: !0,
			required: !0
		}), !(S && g.includes(tp.BuiltOnOrVacantLandType)) && /* @__PURE__ */ m(Ec, {
			id: `${r}-built-on-or-vacant-land`,
			label: "Built on or Vacant Land",
			options: op,
			selected: b.builtOnOrVacantLandType,
			onChange: (e) => w((t) => ({
				...t,
				builtOnOrVacantLandType: e
			})),
			placeholder: "Select type",
			errorText: y && !b?.builtOnOrVacantLandType ? "Select Built on or Vacant Land" : "",
			hideOptionalText: !0,
			stretch: !0,
			required: !0
		})]
	}), n[18] = S, n[19] = g, n[20] = r, n[21] = b, n[22] = w, n[23] = y, n[24] = A) : A = n[24];
	let j;
	n[25] !== S || n[26] !== g || n[27] !== r || n[28] !== b?.numberOfBeds || n[29] !== E || n[30] !== y ? (j = !(S && g.includes(tp.NumberOfBeds)) && /* @__PURE__ */ m(cp, {
		id: `${r}-beds`,
		label: "Bed",
		required: !0,
		selected: b?.numberOfBeds,
		icon: /* @__PURE__ */ m(ua, {
			width: 20,
			height: 20,
			"data-testid": `${r}-beds-icon`,
			color: "var(--fg-tertiary)"
		}),
		errorText: y && !b?.numberOfBeds ? "Minimum is 1" : void 0,
		onChange: (e) => E("numberOfBeds", e)
	}), n[25] = S, n[26] = g, n[27] = r, n[28] = b?.numberOfBeds, n[29] = E, n[30] = y, n[31] = j) : j = n[31];
	let M;
	n[32] !== S || n[33] !== g || n[34] !== r || n[35] !== b?.numberOfBathrooms || n[36] !== E || n[37] !== y ? (M = !(S && g.includes(tp.NumberOfBathrooms)) && /* @__PURE__ */ m(cp, {
		id: `${r}-bathrooms`,
		required: !0,
		label: "Bath",
		selected: b?.numberOfBathrooms,
		icon: /* @__PURE__ */ m(da, {
			width: 20,
			height: 20,
			"data-testid": `${r}-bathrooms-icon`,
			color: "var(--fg-tertiary)"
		}),
		errorText: y && !b?.numberOfBathrooms ? "Minimum is 1" : void 0,
		onChange: (e) => E("numberOfBathrooms", e)
	}), n[32] = S, n[33] = g, n[34] = r, n[35] = b?.numberOfBathrooms, n[36] = E, n[37] = y, n[38] = M) : M = n[38];
	let N;
	n[39] !== S || n[40] !== g || n[41] !== r || n[42] !== b?.numberOfCarSpaces || n[43] !== E ? (N = !(S && g.includes(tp.NumberOfCarSpaces)) && /* @__PURE__ */ m(cp, {
		id: `${r}-car-spaces`,
		label: "Car",
		selected: b?.numberOfCarSpaces,
		icon: /* @__PURE__ */ m(fa, {
			width: 20,
			height: 20,
			"data-testid": `${r}-car-spaces-icon`,
			color: "var(--fg-tertiary)"
		}),
		onChange: (e) => E("numberOfCarSpaces", e)
	}), n[39] = S, n[40] = g, n[41] = r, n[42] = b?.numberOfCarSpaces, n[43] = E, n[44] = N) : N = n[44];
	let P;
	n[45] !== j || n[46] !== M || n[47] !== N ? (P = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-lg",
		fill: !0,
		children: [
			j,
			M,
			N
		]
	}), n[45] = j, n[46] = M, n[47] = N, n[48] = P) : P = n[48];
	let F = `${r}-land-area`, L;
	n[49] === w ? L = n[50] : (L = (e) => {
		let { value: t } = e;
		return w((e) => ({
			...e,
			landAreaDetails: t
		}));
	}, n[49] = w, n[50] = L);
	let R = b?.landAreaDetails, z;
	n[51] !== S || n[52] !== g || n[53] !== v || n[54] !== F || n[55] !== L || n[56] !== R || n[57] !== y ? (z = /* @__PURE__ */ m(rp, {
		id: F,
		onChange: L,
		landAreaDetails: R,
		canHideAttributes: S,
		hidePropertyAttributes: g,
		validate: y,
		required: v
	}), n[51] = S, n[52] = g, n[53] = v, n[54] = F, n[55] = L, n[56] = R, n[57] = y, n[58] = z) : z = n[58];
	let B;
	n[59] !== O || n[60] !== k || n[61] !== A || n[62] !== P || n[63] !== z ? (B = /* @__PURE__ */ h($, {
		gap: "spacing-xl",
		fill: !0,
		children: [
			O,
			k,
			A,
			P,
			z
		]
	}), n[59] = O, n[60] = k, n[61] = A, n[62] = P, n[63] = z, n[64] = B) : B = n[64];
	let V;
	return n[65] !== r || n[66] !== B ? (V = /* @__PURE__ */ m("div", {
		id: r,
		"data-testid": r,
		children: B
	}), n[65] = r, n[66] = B, n[67] = V) : V = n[67], V;
}, up = /* @__PURE__ */ function(e) {
	return e.Individual = "individual", e.PowerOfAttorney = "powerOfAttorney", e.Company = "company", e.DeceasedEstate = "deceasedEstate", e;
}({}), dp = (e, t) => ({
	...e,
	individual: void 0,
	powerOfAttorney: void 0,
	company: void 0,
	...t === oe.Vendor ? { deceasedEstate: void 0 } : {}
}), fp = (e, t, n) => {
	switch (t) {
		case up.Individual: return {
			name: e.individual?.name,
			address: e.individual?.address,
			trustDetails: e.individual?.trustDetails
		};
		case up.PowerOfAttorney: return {
			name: e.powerOfAttorney?.principalName,
			address: e.powerOfAttorney?.address
		};
		case up.Company: return {
			address: e.company?.address,
			trustDetails: e.company?.trustDetails
		};
		case up.DeceasedEstate: return n === oe.Vendor ? { name: e.deceasedEstate?.name } : {};
	}
}, pp = (e, t) => {
	switch (e) {
		case up.Individual: return {
			name: t.name ?? {},
			address: t.address ?? { sameAddress: !0 },
			trustDetails: t.trustDetails ?? {}
		};
		case up.PowerOfAttorney: return {
			principalName: t.name ?? {},
			address: t.address ?? { sameAddress: !0 },
			attorneys: [{
				name: {},
				email: "",
				phoneNumber: ""
			}]
		};
		case up.Company: return {
			address: t.address ?? { sameAddress: !0 },
			signatories: [{
				name: {},
				email: "",
				phoneNumber: ""
			}],
			trustDetails: t.trustDetails ?? {}
		};
		case up.DeceasedEstate: return {
			name: t.name ?? {},
			executors: [{
				name: {},
				email: "",
				phoneNumber: ""
			}]
		};
	}
}, mp = (e) => ({
	individual: pp(up.Individual, {}),
	...e === oe.Vendor ? { legalName: "" } : {}
}), hp = "Retired", gp = (e) => !e || !e.verificationMethod ? !1 : e.verificationMethod === de.Biometric ? !0 : e.verificationMethod === de.Unavailable ? !!e.unableToVerifyReason : !e.dateOfBirth || !e.documentSightedBy || !e.documentSighted || !e.documentNumber || !e.expiryDate ? !1 : e.documentSighted === J.DriversLicense ? !!(e.cardNumber && e.placeOfIssue) : (e.documentSighted === J.AustralianPassport || e.documentSighted === J.NonAustralianPassport) && !e.dateOfIssue ? !1 : e.documentSighted === J.NonAustralianPassport ? !!e.otherPlaceOfIssue : !0, _p = (e) => e?.reasonForTransaction ? e.reasonForTransaction !== ee.Other || !!e.reasonForTransactionOther : !1, vp = (e) => e?.employmentStatus ? e.employmentStatus === G.FullTime || e.employmentStatus === G.PartTime || e.employmentStatus === G.Casual ? !!(e.occupationType && e.occupationCategory) : e.employmentStatus === G.SoleTrader ? !!(e.australianBusinessNumber?.number && e.associatedBusinessNames && e.associatedBusinessAddress?.streetAddress && e.mainIndustryClientCooperatesIn && e.goodsOrServicesClientsProvides) : e.employmentStatus === G.Unemployed || e.employmentStatus === "Retired" : !1, yp = (e, t, n) => gp(e) && _p(t) && vp(n), bp = [
	{
		label: "Driver's licence",
		value: J.DriversLicense
	},
	{
		label: "Australian passport",
		value: J.AustralianPassport
	},
	{
		label: "Non-Australian passport",
		value: J.NonAustralianPassport
	}
], xp = [
	{
		label: "In person / via video call",
		value: de.InPerson
	},
	{
		label: "Biometric verification required",
		value: de.Biometric
	},
	{
		label: "Unable to verify client",
		value: de.Unavailable
	}
], Sp = [
	{
		label: "ACT",
		value: Z.AustralianCapitalTerritory
	},
	{
		label: "NSW",
		value: Z.NewSouthWales
	},
	{
		label: "NT",
		value: Z.NorthernTerritory
	},
	{
		label: "QLD",
		value: Z.Queensland
	},
	{
		label: "SA",
		value: Z.SouthAustralia
	},
	{
		label: "TAS",
		value: Z.Tasmania
	},
	{
		label: "VIC",
		value: Z.Victoria
	},
	{
		label: "WA",
		value: Z.WesternAustralia
	},
	{
		label: "Other",
		value: Z.Other
	}
], Cp = (e) => e?.trim().toLowerCase().replace(/[^a-z]/g, ""), wp = (e) => !!Cp(e), Tp = (e) => {
	let t = Cp(e);
	return t === "australia" || t === "au" || t === "aus";
}, Ep = (e) => {
	switch (Cp(e)) {
		case "act":
		case "australiancapitalterritory": return Z.AustralianCapitalTerritory;
		case "nsw":
		case "newsouthwales": return Z.NewSouthWales;
		case "nt":
		case "northernterritory": return Z.NorthernTerritory;
		case "qld":
		case "queensland": return Z.Queensland;
		case "sa":
		case "southaustralia": return Z.SouthAustralia;
		case "tas":
		case "tasmania": return Z.Tasmania;
		case "vic":
		case "victoria": return Z.Victoria;
		case "wa":
		case "westernaustralia": return Z.WesternAustralia;
		default: return;
	}
}, Dp = (e, t) => !e || e.sameAddress ? t : e.alternate ?? e.address ?? t, Op = (e, t) => {
	if (e) {
		if (e === J.AustralianPassport) return !wp(t?.country) || Tp(t?.country) ? Z.Australia : Z.Other;
		if (e === J.NonAustralianPassport) return wp(t?.country) && Tp(t?.country) ? Z.Australia : Z.Other;
		if (e === J.DriversLicense) return wp(t?.country) && !Tp(t?.country) ? Z.Other : Ep(t?.state);
	}
}, kp = [
	{
		label: "Downsizing",
		value: ee.Downsizing
	},
	{
		label: "Upsizing",
		value: ee.Upsizing
	},
	{
		label: "Relocating",
		value: ee.Relocating
	},
	{
		label: "Other",
		value: ee.Other
	}
], Ap = [
	{
		label: "Full time",
		value: G.FullTime
	},
	{
		label: "Part time",
		value: G.PartTime
	},
	{
		label: "Casual",
		value: G.Casual
	},
	{
		label: "Sole Trader",
		value: G.SoleTrader
	},
	{
		label: "Unemployed",
		value: G.Unemployed
	},
	{
		label: "Retired",
		value: hp
	}
], jp = [
	{
		label: "Employee",
		value: "Employee"
	},
	{
		label: "Business owner",
		value: "BusinessOwner"
	},
	{
		label: "Contractor",
		value: "Contractor"
	},
	{
		label: "Other",
		value: "Other"
	}
], Mp = [
	{
		label: "Administration",
		value: "Administration"
	},
	{
		label: "Construction",
		value: "Construction"
	},
	{
		label: "Education",
		value: "Education"
	},
	{
		label: "Finance",
		value: "Finance"
	},
	{
		label: "Healthcare",
		value: "Healthcare"
	},
	{
		label: "Professional services",
		value: "ProfessionalServices"
	},
	{
		label: "Retail",
		value: "Retail"
	},
	{
		label: "Other",
		value: "Other"
	}
], Np = (e) => e === G.FullTime || e === G.PartTime || e === G.Casual, Pp = (e) => e === G.SoleTrader, Fp = {
	documentSighted: void 0,
	documentNumber: void 0,
	cardNumber: void 0,
	dateOfIssue: void 0,
	expiryDate: void 0,
	placeOfIssue: void 0,
	otherPlaceOfIssue: void 0
}, Ip = (t) => {
	let n = e(43), { id: r, value: i, onChange: s, vendorBuyerName: c, defaultPlaceOfIssueAddress: l, validate: u, onValidateReset: d } = t, f = u === void 0 ? !1 : u, g = i.documentSighted, _ = i.verificationMethod, y = g === J.DriversLicense || g === J.AustralianPassport || g === J.NonAustralianPassport, b = _ === de.InPerson, x = !!_, S = g === J.DriversLicense ? "Licence Number" : "Passport Number", w = c.firstName ?? "Client", T = a(C)?.userAccount?.agent, { data: E } = v(), D;
	n[0] === E ? D = n[1] : (D = E?.flatMap(Lp) ?? [], n[0] = E, n[1] = D);
	let O = D, k, A;
	n[2] !== E || n[3] !== T || n[4] !== b || n[5] !== s || n[6] !== y || n[7] !== i ? (k = () => {
		if (!b || !y || i.documentSightedBy || !T || !E || E.length === 0) return;
		let e = E.find((e) => e.id === T && e.name?.fullName);
		e && s({
			...i,
			documentSightedBy: e.id
		});
	}, A = [
		E,
		T,
		b,
		s,
		y,
		i
	], n[2] = E, n[3] = T, n[4] = b, n[5] = s, n[6] = y, n[7] = i, n[8] = k, n[9] = A) : (k = n[8], A = n[9]), o(k, A);
	let j = `${r}-verification-method`, M = _ ? void 0 : "Select a verification method", N;
	n[10] !== w || n[11] !== r || n[12] !== s || n[13] !== f || n[14] !== i || n[15] !== _ ? (N = _ === de.Biometric ? /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-sm",
		fill: !0,
		padding: "sm",
		children: [/* @__PURE__ */ m(Ti, {
			type: "information",
			height: 18,
			width: 18
		}), /* @__PURE__ */ h(Q, {
			id: `${r}-biometric-body`,
			type: "body",
			size: "small",
			color: "var(--text-primary)",
			children: [w, " will receive an email to complete a Biometric ID verification. This option should only be used if you are unable to have a face to face meeting with the client."]
		})]
	}) : _ === de.Unavailable ? /* @__PURE__ */ m($, {
		direction: "horizontal",
		gap: "spacing-sm",
		fill: !0,
		padding: "sm",
		children: /* @__PURE__ */ m(Hc, {
			id: `${r}-unable-to-verify-reason`,
			label: "Provide reason",
			defaultValue: i.unableToVerifyReason ?? "",
			required: !0,
			hideOptionalText: !0,
			validate: f,
			error: f && !i.unableToVerifyReason ? "Provide reason is required" : void 0,
			stretch: !0,
			rows: 3,
			onInputValueChange: (e) => {
				let { value: t } = e;
				return s({
					...i,
					unableToVerifyReason: t
				});
			}
		})
	}) : void 0, n[10] = w, n[11] = r, n[12] = s, n[13] = f, n[14] = i, n[15] = _, n[16] = N) : N = n[16];
	let P;
	n[17] !== s || n[18] !== i ? (P = (e) => s({
		...i,
		verificationMethod: e,
		unableToVerifyReason: e === de.Unavailable ? i.unableToVerifyReason : void 0,
		...Fp
	}), n[17] = s, n[18] = i, n[19] = P) : P = n[19];
	let F;
	n[20] !== j || n[21] !== M || n[22] !== N || n[23] !== P || n[24] !== f || n[25] !== _ ? (F = /* @__PURE__ */ m(bs, {
		id: j,
		layout: "vertical",
		label: "Select a verification method:",
		required: !0,
		validate: f,
		errorText: M,
		options: xp,
		value: _,
		subContent: N,
		onChange: P
	}), n[20] = j, n[21] = M, n[22] = N, n[23] = P, n[24] = f, n[25] = _, n[26] = F) : F = n[26];
	let I;
	n[27] !== O || n[28] !== l || n[29] !== S || n[30] !== g || n[31] !== x || n[32] !== r || n[33] !== b || n[34] !== s || n[35] !== d || n[36] !== y || n[37] !== f || n[38] !== i ? (I = x && /* @__PURE__ */ m(p, { children: b && /* @__PURE__ */ m(bs, {
		id: `${r}-document-sighted`,
		layout: "vertical",
		label: "Select type of ID sighted",
		required: !0,
		validate: f,
		errorText: "Select an ID type.",
		options: bp,
		value: g,
		subContent: y ? /* @__PURE__ */ h($, {
			direction: "vertical",
			gap: "spacing-xl",
			fill: !0,
			padding: "sm",
			children: [
				/* @__PURE__ */ m(qs, {
					id: `${r}-document-number`,
					type: "text",
					label: S,
					defaultValue: i.documentNumber ?? "",
					required: !0,
					hideOptionalText: !0,
					stretch: !0,
					errorText: f && !i.documentNumber ? `Enter ${S.toLowerCase()}` : void 0,
					onInputValueChange: (e) => {
						let { value: t } = e;
						return s({
							...i,
							documentNumber: t
						});
					}
				}),
				g === J.DriversLicense && /* @__PURE__ */ m(qs, {
					id: `${r}-card-number`,
					type: "text",
					label: "Card Number",
					defaultValue: i.cardNumber ?? "",
					required: !0,
					hideOptionalText: !0,
					stretch: !0,
					errorText: f && !i.cardNumber ? "Enter card number" : void 0,
					onInputValueChange: (e) => {
						let { value: t } = e;
						return s({
							...i,
							cardNumber: t
						});
					}
				}),
				(g === J.AustralianPassport || g === J.NonAustralianPassport) && /* @__PURE__ */ h($, {
					direction: "horizontal",
					gap: "spacing-lg",
					fill: !0,
					children: [/* @__PURE__ */ m(fc, {
						id: `${r}-date-of-issue`,
						label: "Date of Issue",
						value: i.dateOfIssue,
						onChange: (e) => s({
							...i,
							dateOfIssue: e ?? void 0
						}),
						required: !0,
						validate: f,
						errorText: f && !i.dateOfIssue ? "Enter date of issue" : void 0,
						stretch: !0
					}), /* @__PURE__ */ m(fc, {
						id: `${r}-expiry-date`,
						label: "Expiry Date",
						value: i.expiryDate,
						onChange: (e) => s({
							...i,
							expiryDate: e ?? void 0
						}),
						required: !0,
						validate: f,
						errorText: f && !i.expiryDate ? "Enter expiry date" : void 0,
						stretch: !0
					})]
				}),
				g === J.DriversLicense && /* @__PURE__ */ h($, {
					direction: "horizontal",
					gap: "spacing-lg",
					fill: !0,
					children: [/* @__PURE__ */ m(fc, {
						id: `${r}-expiry-date`,
						label: "Expiry Date",
						value: i.expiryDate,
						onChange: (e) => s({
							...i,
							expiryDate: e ?? void 0
						}),
						required: !0,
						validate: f,
						errorText: f && !i.expiryDate ? "Enter expiry date" : void 0,
						stretch: !0
					}), /* @__PURE__ */ m(Ec, {
						id: `${r}-place-of-issue`,
						label: "State/Territory",
						options: Sp,
						selected: i.placeOfIssue,
						onChange: (e) => s({
							...i,
							placeOfIssue: e
						}),
						placeholder: "Select",
						required: !0,
						errorText: f && !i.placeOfIssue ? "Select state/territory" : void 0,
						hideOptionalText: !0,
						stretch: !0
					})]
				}),
				g === J.NonAustralianPassport && /* @__PURE__ */ m(qs, {
					id: `${r}-country-of-issue`,
					type: "text",
					label: "Country of Issue",
					defaultValue: i.otherPlaceOfIssue ?? "",
					required: !0,
					hideOptionalText: !0,
					stretch: !0,
					errorText: f && !i.otherPlaceOfIssue ? "Enter country of issue" : void 0,
					onInputValueChange: (e) => {
						let { value: t } = e;
						return s({
							...i,
							placeOfIssue: Z.Other,
							otherPlaceOfIssue: t
						});
					}
				}),
				/* @__PURE__ */ m(fc, {
					id: `${r}-date-of-birth`,
					label: "Date of Birth",
					value: i.dateOfBirth,
					maxDate: /* @__PURE__ */ new Date(),
					onChange: (e) => s({
						...i,
						dateOfBirth: e ?? void 0
					}),
					required: !0,
					validate: f,
					errorText: f && !i.dateOfBirth ? "Enter date of birth" : void 0,
					stretch: !0
				}),
				/* @__PURE__ */ m(Ec, {
					id: `${r}-document-sighted-by`,
					label: "Sighted By",
					options: O,
					selected: i.documentSightedBy,
					onChange: (e) => s({
						...i,
						documentSightedBy: e
					}),
					placeholder: "Select",
					searchPlaceholder: "Search agents",
					searchable: !0,
					required: !0,
					errorText: f && !i.documentSightedBy ? "Select sighted by" : void 0,
					hideOptionalText: !0,
					stretch: !0
				})
			]
		}) : void 0,
		onChange: (e) => {
			d?.(), s({
				...i,
				documentSighted: e,
				documentNumber: void 0,
				cardNumber: void 0,
				dateOfIssue: void 0,
				expiryDate: void 0,
				placeOfIssue: Op(e, l),
				otherPlaceOfIssue: void 0
			});
		}
	}) }), n[27] = O, n[28] = l, n[29] = S, n[30] = g, n[31] = x, n[32] = r, n[33] = b, n[34] = s, n[35] = d, n[36] = y, n[37] = f, n[38] = i, n[39] = I) : I = n[39];
	let L;
	return n[40] !== I || n[41] !== F ? (L = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-2xl",
		fill: !0,
		children: [F, I]
	}), n[40] = I, n[41] = F, n[42] = L) : L = n[42], L;
};
function Lp(e) {
	return !e.id || !e.name?.fullName ? [] : [{
		label: e.name.fullName,
		value: e.id
	}];
}
//#endregion
//#region src/formElements/VendorBuyer/IdentityVerification/IdentityVerificationStep2.tsx
var Rp = (t) => {
	let n = e(26), { id: r, stakeholderType: i, value: a, onChange: o, validate: s } = t, c = s === void 0 ? !1 : s, l = i === oe.Buyer ? "buying" : "selling", u = `${r}-reason-for-transaction`, d = `Reason for ${l}`, f = `Select reason for ${l}.`, p;
	n[0] !== o || n[1] !== a ? (p = (e) => o({
		...a,
		reasonForTransaction: e,
		reasonForTransactionOther: e === ee.Other ? a.reasonForTransactionOther : void 0
	}), n[0] = o, n[1] = a, n[2] = p) : p = n[2];
	let g;
	n[3] !== u || n[4] !== d || n[5] !== f || n[6] !== p || n[7] !== c || n[8] !== a.reasonForTransaction ? (g = /* @__PURE__ */ m(bs, {
		id: u,
		layout: "vertical",
		label: d,
		required: !0,
		validate: c,
		errorText: f,
		options: kp,
		value: a.reasonForTransaction,
		onChange: p
	}), n[3] = u, n[4] = d, n[5] = f, n[6] = p, n[7] = c, n[8] = a.reasonForTransaction, n[9] = g) : g = n[9];
	let _;
	n[10] !== r || n[11] !== o || n[12] !== c || n[13] !== a ? (_ = a.reasonForTransaction === ee.Other && /* @__PURE__ */ m(qs, {
		id: `${r}-reason-for-transaction-other`,
		type: "text",
		label: "Provide reason",
		defaultValue: a.reasonForTransactionOther ?? "",
		onInputValueChange: (e) => {
			let { value: t } = e;
			return o({
				...a,
				reasonForTransactionOther: t
			});
		},
		required: !0,
		hideOptionalText: !0,
		stretch: !0,
		errorText: c && !a.reasonForTransactionOther ? "Enter reason for transaction" : void 0
	}), n[10] = r, n[11] = o, n[12] = c, n[13] = a, n[14] = _) : _ = n[14];
	let v = `${r}-is-politically-exposed-person`, y = a.politicallyExposedPerson === void 0 ? void 0 : a.politicallyExposedPerson ? Bc.Yes : Bc.No, b;
	n[15] !== o || n[16] !== a ? (b = (e) => {
		let { value: t } = e;
		return o({
			...a,
			politicallyExposedPerson: t === Bc.Yes
		});
	}, n[15] = o, n[16] = a, n[17] = b) : b = n[17];
	let x;
	n[18] !== b || n[19] !== v || n[20] !== y ? (x = /* @__PURE__ */ m(Vc, {
		id: v,
		label: "Is the stakeholder a politically exposed person?",
		defaultValue: y,
		onValueChanged: b
	}), n[18] = b, n[19] = v, n[20] = y, n[21] = x) : x = n[21];
	let S;
	return n[22] !== x || n[23] !== g || n[24] !== _ ? (S = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-xl",
		fill: !0,
		children: [
			g,
			_,
			x
		]
	}), n[22] = x, n[23] = g, n[24] = _, n[25] = S) : S = n[25], S;
}, zp = (e) => {
	if (!(!e?.streetAddress || !e.suburb || !e.state || !e.postalCode)) return {
		unitNumber: e.unitNumber,
		streetAddress: e.streetAddress,
		suburb: e.suburb,
		state: e.state,
		postCode: e.postalCode,
		country: e.country ?? "Australia",
		formattedAddress: [
			e.unitNumber,
			e.streetAddress,
			e.suburb,
			e.state,
			e.postalCode
		].filter(Boolean).join(", ")
	};
}, Bp = (e) => {
	if (e) return {
		unitNumber: e.unitNumber,
		streetAddress: e.streetAddress,
		suburb: e.suburb,
		state: e.state,
		postalCode: e.postCode,
		country: e.country
	};
}, Vp = (e) => !!(e?.streetAddress && e.suburb && e.state && e.postalCode), Hp = (t) => {
	let n = e(24), { id: r, value: i, onChange: a, validate: o } = t, s = o === void 0 ? !1 : o, c = i.employmentStatus, l = `${r}-employment-status`, u;
	n[0] !== a || n[1] !== i ? (u = (e) => a({
		...i,
		employmentStatus: e,
		occupationType: Np(e) ? i.occupationType : void 0,
		occupationCategory: Np(e) ? i.occupationCategory : void 0
	}), n[0] = a, n[1] = i, n[2] = u) : u = n[2];
	let d = s && !c ? "Select employment status." : void 0, f;
	n[3] !== c || n[4] !== l || n[5] !== u || n[6] !== d ? (f = /* @__PURE__ */ m(Ec, {
		id: l,
		label: "Employment Status",
		options: Ap,
		selected: c,
		onChange: u,
		placeholder: "Select",
		required: !0,
		errorText: d,
		hideOptionalText: !0,
		stretch: !0
	}), n[3] = c, n[4] = l, n[5] = u, n[6] = d, n[7] = f) : f = n[7];
	let g;
	n[8] !== c || n[9] !== r || n[10] !== a || n[11] !== s || n[12] !== i ? (g = Np(c) && /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(Ec, {
		id: `${r}-occupation-type`,
		label: "Occupation Type",
		options: jp,
		selected: i.occupationType,
		onChange: (e) => a({
			...i,
			occupationType: e
		}),
		placeholder: "Select",
		required: !0,
		errorText: s && !i.occupationType ? "Select occupation type." : void 0,
		hideOptionalText: !0,
		stretch: !0
	}), /* @__PURE__ */ m(Ec, {
		id: `${r}-occupation-category`,
		label: "Occupation Category",
		options: Mp,
		selected: i.occupationCategory,
		onChange: (e) => a({
			...i,
			occupationCategory: e
		}),
		placeholder: "Select",
		required: !0,
		errorText: s && !i.occupationCategory ? "Select occupation category." : void 0,
		hideOptionalText: !0,
		stretch: !0
	})] }), n[8] = c, n[9] = r, n[10] = a, n[11] = s, n[12] = i, n[13] = g) : g = n[13];
	let _;
	n[14] !== c || n[15] !== r || n[16] !== a || n[17] !== s || n[18] !== i ? (_ = Pp(c) && /* @__PURE__ */ h(p, { children: [
		/* @__PURE__ */ m(qs, {
			id: `${r}-abn`,
			type: "text",
			label: "ABN",
			defaultValue: i.australianBusinessNumber?.number ?? "",
			onInputValueChange: (e) => {
				let { value: t } = e;
				return a({
					...i,
					australianBusinessNumber: { number: t }
				});
			},
			required: !0,
			hideOptionalText: !0,
			stretch: !0,
			errorText: s && !i.australianBusinessNumber?.number ? "Enter ABN" : void 0
		}),
		/* @__PURE__ */ m(qs, {
			id: `${r}-associated-business-names`,
			type: "text",
			label: "Associated business names",
			defaultValue: i.associatedBusinessNames ?? "",
			onInputValueChange: (e) => {
				let { value: t } = e;
				return a({
					...i,
					associatedBusinessNames: t
				});
			},
			required: !0,
			hideOptionalText: !0,
			stretch: !0,
			errorText: s && !i.associatedBusinessNames ? "Enter associated business names" : void 0
		}),
		/* @__PURE__ */ m(Xs, {
			id: `${r}-associated-business-address`,
			label: "Address of principal place of business",
			defaultValue: zp(i.associatedBusinessAddress),
			onAddressChange: (e) => a({
				...i,
				associatedBusinessAddress: Bp(e)
			}),
			placeholderText: "Search...",
			errorText: s && !i.associatedBusinessAddress?.streetAddress ? "Enter principal place of business" : void 0,
			stretch: !0,
			validate: s
		}),
		/* @__PURE__ */ m(qs, {
			id: `${r}-main-industry`,
			type: "text",
			label: "Main industry client operates in",
			defaultValue: i.mainIndustryClientCooperatesIn ?? "",
			onInputValueChange: (e) => {
				let { value: t } = e;
				return a({
					...i,
					mainIndustryClientCooperatesIn: t
				});
			},
			required: !0,
			hideOptionalText: !0,
			stretch: !0,
			errorText: s && !i.mainIndustryClientCooperatesIn ? "Enter main industry" : void 0
		}),
		/* @__PURE__ */ m(qs, {
			id: `${r}-goods-or-services`,
			type: "text",
			label: "Specific goods or services client provides",
			defaultValue: i.goodsOrServicesClientsProvides ?? "",
			onInputValueChange: (e) => {
				let { value: t } = e;
				return a({
					...i,
					goodsOrServicesClientsProvides: t
				});
			},
			required: !0,
			hideOptionalText: !0,
			stretch: !0,
			errorText: s && !i.goodsOrServicesClientsProvides ? "Enter goods or services" : void 0
		})
	] }), n[14] = c, n[15] = r, n[16] = a, n[17] = s, n[18] = i, n[19] = _) : _ = n[19];
	let v;
	return n[20] !== f || n[21] !== g || n[22] !== _ ? (v = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-xl",
		fill: !0,
		children: [
			f,
			g,
			_
		]
	}), n[20] = f, n[21] = g, n[22] = _, n[23] = v) : v = n[23], v;
}, Up = (t) => {
	let n = e(2), { currentStep: r } = t, i;
	return n[0] === r ? i = n[1] : (i = /* @__PURE__ */ m($, {
		contentAlignment: "center",
		children: /* @__PURE__ */ m(ha, {
			totalLevels: 3,
			currentLevel: r,
			size: "small",
			showLines: !0
		})
	}), n[0] = r, n[1] = i), i;
}, Wp = /* @__PURE__ */ function(e) {
	return e[e.IdentityVerification = 1] = "IdentityVerification", e[e.RiskAssessment = 2] = "RiskAssessment", e[e.EmploymentDetails = 3] = "EmploymentDetails", e;
}(Wp || {}), Gp = (t) => {
	let n = e(88), { id: r, isOpen: i, setIsOpen: a, identityVerification: s, riskAssessment: c, employmentDetails: l, stakeholderType: f, vendorBuyerName: p, defaultPlaceOfIssueAddress: g, onUpdateIdentityVerificationForm: _ } = t, [v, y] = d(Wp.IdentityVerification), [b, x] = d(!1), S;
	n[0] === s ? S = n[1] : (S = s ?? {}, n[0] = s, n[1] = S);
	let [C, w] = d(S), T;
	n[2] === c ? T = n[3] : (T = c ?? {}, n[2] = c, n[3] = T);
	let [E, D] = d(T), O;
	n[4] === l ? O = n[5] : (O = l ?? {}, n[4] = l, n[5] = O);
	let [k, A] = d(O), j = u(!1), M, N;
	n[6] !== g || n[7] !== l || n[8] !== s || n[9] !== i || n[10] !== c ? (M = () => {
		let e = i && !j.current;
		j.current = i, e && (y(1), x(!1), w({
			...s ?? {},
			placeOfIssue: s?.placeOfIssue ?? Op(s?.documentSighted, g)
		}), D(c ?? {}), A(l ?? {}));
	}, N = [
		g,
		l,
		s,
		i,
		c
	], n[6] = g, n[7] = l, n[8] = s, n[9] = i, n[10] = c, n[11] = M, n[12] = N) : (M = n[11], N = n[12]), o(M, N);
	let P;
	n[13] !== k || n[14] !== C || n[15] !== E || n[16] !== v ? (P = v === Wp.IdentityVerification ? gp(C) : v === Wp.RiskAssessment ? _p(E) : vp(k), n[13] = k, n[14] = C, n[15] = E, n[16] = v, n[17] = P) : P = n[17];
	let F = P, I;
	n[18] === p ? I = n[19] : (I = Du(p) || "this client", n[18] = p, n[19] = I);
	let L = I, R;
	n[20] !== L || n[21] !== v ? (R = v === Wp.IdentityVerification ? {
		title: "Step 1: Identity Verification",
		description: `Select ID method for ${L}`
	} : v === Wp.RiskAssessment ? {
		title: "Step 2: Risk Assessment",
		description: `Complete risk assessment questionnaire for ${L}.`
	} : {
		title: "Step 3: Employment Details",
		description: `Complete the employment details for ${L}.`
	}, n[20] = L, n[21] = v, n[22] = R) : R = n[22];
	let z = R, B;
	n[23] === F ? B = n[24] : (B = () => {
		if (!F) {
			x(!0);
			return;
		}
		x(!1), y(Kp);
	}, n[23] = F, n[24] = B);
	let V = B, H;
	n[25] !== F || n[26] !== k || n[27] !== C || n[28] !== _ || n[29] !== E || n[30] !== a ? (H = () => {
		if (!F) {
			x(!0);
			return;
		}
		_({
			identityVerification: C,
			riskAssessment: E,
			employmentDetails: k
		}), a(!1);
	}, n[25] = F, n[26] = k, n[27] = C, n[28] = _, n[29] = E, n[30] = a, n[31] = H) : H = n[31];
	let U = H, W = `${r}-modal`, G = `${r}-modal-title`, K;
	n[32] !== z.title || n[33] !== G ? (K = /* @__PURE__ */ m(Q, {
		id: G,
		type: "body_ui_strong",
		size: "medium",
		color: "var(--text-primary)",
		children: z.title
	}), n[32] = z.title, n[33] = G, n[34] = K) : K = n[34];
	let q = `${r}-modal-description`, J;
	n[35] !== z.description || n[36] !== q ? (J = /* @__PURE__ */ m(Q, {
		id: q,
		type: "body_ui",
		size: "small",
		color: "var(--text-secondary)",
		children: z.description
	}), n[35] = z.description, n[36] = q, n[37] = J) : J = n[37];
	let Y;
	n[38] !== K || n[39] !== J ? (Y = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-lg",
		contentAlignment: "center",
		fill: !0,
		children: [K, J]
	}), n[38] = K, n[39] = J, n[40] = Y) : Y = n[40];
	let X;
	n[41] === v ? X = n[42] : (X = /* @__PURE__ */ m(Up, { currentStep: v }), n[41] = v, n[42] = X);
	let Z;
	n[43] !== Y || n[44] !== X ? (Z = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-2xl",
		contentAlignment: "center",
		fill: !0,
		children: [Y, X]
	}), n[43] = Y, n[44] = X, n[45] = Z) : Z = n[45];
	let ee;
	n[46] !== g || n[47] !== r || n[48] !== C || n[49] !== v || n[50] !== b || n[51] !== p ? (ee = v === Wp.IdentityVerification && /* @__PURE__ */ m(Ip, {
		id: `${r}-step-1`,
		value: C,
		onChange: w,
		vendorBuyerName: p,
		defaultPlaceOfIssueAddress: g,
		validate: b,
		onValidateReset: () => x(!1)
	}), n[46] = g, n[47] = r, n[48] = C, n[49] = v, n[50] = b, n[51] = p, n[52] = ee) : ee = n[52];
	let te;
	n[53] !== r || n[54] !== E || n[55] !== f || n[56] !== v || n[57] !== b ? (te = v === Wp.RiskAssessment && /* @__PURE__ */ m(Rp, {
		id: `${r}-step-2`,
		stakeholderType: f,
		value: E,
		onChange: D,
		validate: b
	}), n[53] = r, n[54] = E, n[55] = f, n[56] = v, n[57] = b, n[58] = te) : te = n[58];
	let ne;
	n[59] !== k || n[60] !== r || n[61] !== v || n[62] !== b ? (ne = v === Wp.EmploymentDetails && /* @__PURE__ */ m(Hp, {
		id: `${r}-step-3`,
		value: k,
		onChange: A,
		validate: b
	}), n[59] = k, n[60] = r, n[61] = v, n[62] = b, n[63] = ne) : ne = n[63];
	let re;
	n[64] !== ee || n[65] !== te || n[66] !== ne ? (re = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-2xl",
		padding: "md",
		fill: !0,
		children: [
			ee,
			te,
			ne
		]
	}), n[64] = ee, n[65] = te, n[66] = ne, n[67] = re) : re = n[67];
	let ie = `${r}-back`, ae = v === Wp.IdentityVerification, oe;
	n[68] === v ? oe = n[69] : (oe = () => {
		v !== Wp.IdentityVerification && (x(!1), y(qp));
	}, n[68] = v, n[69] = oe);
	let se;
	n[70] !== ie || n[71] !== ae || n[72] !== oe ? (se = /* @__PURE__ */ m($, {
		fill: !0,
		children: /* @__PURE__ */ m(Kl, {
			id: ie,
			text: "Back",
			variant: "hollow",
			size: "large",
			stretch: !0,
			disabled: ae,
			onClick: oe
		})
	}), n[70] = ie, n[71] = ae, n[72] = oe, n[73] = se) : se = n[73];
	let ce = `${r}-${v === Wp.EmploymentDetails ? "save" : "next"}`, le = v === Wp.EmploymentDetails ? "Save" : "Next", ue = v === Wp.EmploymentDetails ? U : V, de;
	n[74] !== ce || n[75] !== le || n[76] !== ue ? (de = /* @__PURE__ */ m($, {
		fill: !0,
		children: /* @__PURE__ */ m(Kl, {
			id: ce,
			text: le,
			variant: "primary",
			size: "large",
			stretch: !0,
			onClick: ue
		})
	}), n[74] = ce, n[75] = le, n[76] = ue, n[77] = de) : de = n[77];
	let fe;
	n[78] !== se || n[79] !== de ? (fe = /* @__PURE__ */ h($, {
		direction: "horizontal",
		contentJustification: "center",
		gap: "spacing-sm",
		fill: !0,
		children: [se, de]
	}), n[78] = se, n[79] = de, n[80] = fe) : fe = n[80];
	let pe;
	return n[81] !== i || n[82] !== a || n[83] !== W || n[84] !== Z || n[85] !== re || n[86] !== fe ? (pe = /* @__PURE__ */ m(Ya, {
		id: W,
		type: "single",
		variant: "withoutDivider",
		actionButtonContainerStyle: "withDivider",
		secondaryTitle: Z,
		isOpen: i,
		setIsDialogOpen: a,
		minWidth: "600px",
		maxWidth: "600px",
		content: re,
		actionButtons: fe
	}), n[81] = i, n[82] = a, n[83] = W, n[84] = Z, n[85] = re, n[86] = fe, n[87] = pe) : pe = n[87], pe;
};
function Kp(e) {
	return e + 1;
}
function qp(e) {
	return e - 1;
}
//#endregion
//#region src/formElements/VendorBuyer/IdentityVerification/IdentityVerificationButtons.tsx
var Jp = (t) => {
	let n = e(10), { id: r, variant: i, text: a, className: o } = t, s;
	n[0] === i ? s = n[1] : (s = i === "success" ? /* @__PURE__ */ m(Bi, {
		color: "var(--text-success)",
		width: 16,
		height: 16
	}) : /* @__PURE__ */ m(ki, {
		type: "Danger",
		width: 16,
		height: 16
	}), n[0] = i, n[1] = s);
	let c = i === "success" ? "var(--text-success)" : "var(--text-error)", l;
	n[2] !== r || n[3] !== c || n[4] !== a ? (l = /* @__PURE__ */ m(Q, {
		id: r,
		type: "body_ui",
		size: "small",
		color: c,
		children: a
	}), n[2] = r, n[3] = c, n[4] = a, n[5] = l) : l = n[5];
	let u;
	return n[6] !== o || n[7] !== s || n[8] !== l ? (u = /* @__PURE__ */ h($, {
		className: o,
		direction: "horizontal",
		gap: "spacing-xs",
		contentAlignment: "center",
		children: [s, l]
	}), n[6] = o, n[7] = s, n[8] = l, n[9] = u) : u = n[9], u;
}, Yp = (t) => {
	let n = e(46), { id: r, identityVerification: i, riskAssessment: a, employmentDetails: o, stakeholderType: s, vendorBuyerName: c, labelHintText: l, validate: u, required: f, formEmailed: g, defaultPlaceOfIssueAddress: _, onUpdateIdentityVerificationForm: v } = t, y = u === void 0 ? !1 : u, b = f === void 0 ? !0 : f, x = g === void 0 ? !1 : g, [S, C] = d(!1), w;
	n[0] !== o || n[1] !== i || n[2] !== a ? (w = yp(i, a, o), n[0] = o, n[1] = i, n[2] = a, n[3] = w) : w = n[3];
	let T = w, E = y && b && !T, D = `${r}-complete-form`, O = T ? "Review Form" : "Complete Form", k;
	n[4] === Symbol.for("react.memo_cache_sentinel") ? (k = () => C(!0), n[4] = k) : k = n[4];
	let A;
	n[5] !== D || n[6] !== O ? (A = /* @__PURE__ */ m($, {
		direction: "horizontal",
		gap: "spacing-md",
		children: /* @__PURE__ */ m(Kl, {
			id: D,
			text: O,
			variant: "primary",
			size: "medium",
			onClick: k
		})
	}), n[5] = D, n[6] = O, n[7] = A) : A = n[7];
	let j = A, M = `${r}-identity-verification-label`, N;
	n[8] === M ? N = n[9] : (N = /* @__PURE__ */ m(Q, {
		id: M,
		type: "label",
		size: "medium",
		color: "var(--text-primary)",
		children: "ID and Risk Assessment"
	}), n[8] = M, n[9] = N);
	let P = `${r}-identity-verification-required`, F;
	n[10] === P ? F = n[11] : (F = /* @__PURE__ */ m(Q, {
		id: P,
		type: "label",
		size: "medium",
		color: "var(--text-brand-accent)",
		children: "*"
	}), n[10] = P, n[11] = F);
	let I;
	n[12] !== r || n[13] !== l ? (I = l && /* @__PURE__ */ m(Q, {
		id: `${r}-identity-verification-hint`,
		type: "caption",
		size: "medium",
		color: "var(--text-tertiary)",
		children: l
	}), n[12] = r, n[13] = l, n[14] = I) : I = n[14];
	let L;
	n[15] !== N || n[16] !== F || n[17] !== I ? (L = /* @__PURE__ */ h($, {
		direction: "horizontal",
		gap: "spacing-xs",
		contentAlignment: "center",
		children: [
			N,
			F,
			I
		]
	}), n[15] = N, n[16] = F, n[17] = I, n[18] = L) : L = n[18];
	let R = !x && j, z;
	n[19] !== x || n[20] !== r || n[21] !== T ? (z = (T || x) && /* @__PURE__ */ m(Jp, {
		id: `${r}-identity-verification-complete`,
		variant: "success",
		text: "Completed"
	}), n[19] = x, n[20] = r, n[21] = T, n[22] = z) : z = n[22];
	let B;
	n[23] !== r || n[24] !== b || n[25] !== E || n[26] !== y ? (B = E && /* @__PURE__ */ m(Jp, {
		id: `${r}-identity-verification-validation`,
		variant: "error",
		text: "Complete ID & Risk Assessment Questionnaire",
		className: y && b ? "error" : void 0
	}), n[23] = r, n[24] = b, n[25] = E, n[26] = y, n[27] = B) : B = n[27];
	let V;
	n[28] !== L || n[29] !== R || n[30] !== z || n[31] !== B ? (V = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-sm",
		children: [
			L,
			R,
			z,
			B
		]
	}), n[28] = L, n[29] = R, n[30] = z, n[31] = B, n[32] = V) : V = n[32];
	let H;
	n[33] !== _ || n[34] !== o || n[35] !== r || n[36] !== i || n[37] !== v || n[38] !== a || n[39] !== S || n[40] !== s || n[41] !== c ? (H = /* @__PURE__ */ m(Gp, {
		id: r,
		isOpen: S,
		setIsOpen: C,
		identityVerification: i,
		riskAssessment: a,
		employmentDetails: o,
		stakeholderType: s,
		vendorBuyerName: c,
		defaultPlaceOfIssueAddress: _,
		onUpdateIdentityVerificationForm: v
	}), n[33] = _, n[34] = o, n[35] = r, n[36] = i, n[37] = v, n[38] = a, n[39] = S, n[40] = s, n[41] = c, n[42] = H) : H = n[42];
	let U;
	return n[43] !== V || n[44] !== H ? (U = /* @__PURE__ */ h(p, { children: [V, H] }), n[43] = V, n[44] = H, n[45] = U) : U = n[45], U;
}, Xp = (t) => {
	let n = e(58), { id: r, index: i, stakeholderType: a, value: o, onChange: s, onDelete: c, canDelete: l, validate: u, vendorBuyerConfig: d, defaultPlaceOfIssueAddress: f, readOnly: p } = t, g = l === void 0 ? !0 : l, _ = u === void 0 ? !1 : u, v = p === void 0 ? !1 : p, y;
	n[0] === o ? y = n[1] : (y = o ?? {
		name: {},
		email: "",
		phoneNumber: ""
	}, n[0] = o, n[1] = y);
	let b = y, x = `Signatory ${i + 1}`, S;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (S = {
		top: "spacing-xl",
		bottom: "spacing-xl",
		left: "spacing-2xl",
		right: "spacing-2xl"
	}, n[2] = S) : S = n[2];
	let C;
	n[3] !== g || n[4] !== r || n[5] !== c ? (C = g ? /* @__PURE__ */ m(Kl, {
		id: `${r}-delete`,
		text: /* @__PURE__ */ m(sa, {}),
		variant: "naked",
		size: "small",
		onClick: c
	}) : void 0, n[3] = g, n[4] = r, n[5] = c, n[6] = C) : C = n[6];
	let w = `${r}-name`, T = `(Signatory ${i + 1})`, E;
	n[7] !== s || n[8] !== b ? (E = (e) => s({
		...b,
		name: e
	}), n[7] = s, n[8] = b, n[9] = E) : E = n[9];
	let D;
	n[10] !== v || n[11] !== b.name || n[12] !== E || n[13] !== w || n[14] !== T || n[15] !== _ || n[16] !== d.excludeMiddleName || n[17] !== d.preferredNameRequired ? (D = /* @__PURE__ */ m(wl, {
		id: w,
		label: "Signatory's Name",
		labelHintText: T,
		value: b.name,
		onChange: E,
		hideMiddleName: d.excludeMiddleName,
		validate: _,
		preferredNameRequired: d.preferredNameRequired,
		nameIsUpperCase: !0,
		readonly: v
	}), n[10] = v, n[11] = b.name, n[12] = E, n[13] = w, n[14] = T, n[15] = _, n[16] = d.excludeMiddleName, n[17] = d.preferredNameRequired, n[18] = D) : D = n[18];
	let O = `${r}-email`, k = `(Signatory ${i + 1})`, A = b.email ?? "", j;
	n[19] !== s || n[20] !== b ? (j = (e) => {
		let { value: t } = e;
		return s({
			...b,
			email: t
		});
	}, n[19] = s, n[20] = b, n[21] = j) : j = n[21];
	let M = _ && d.emailRequired && !b.email ? "Enter email" : void 0, N;
	n[22] !== O || n[23] !== k || n[24] !== A || n[25] !== j || n[26] !== M || n[27] !== d.emailRequired ? (N = /* @__PURE__ */ m(qs, {
		id: O,
		type: "email",
		label: "Email",
		labelHintText: k,
		defaultValue: A,
		onInputValueChange: j,
		required: d.emailRequired,
		hideOptionalText: d.emailRequired,
		stretch: !0,
		errorText: M
	}), n[22] = O, n[23] = k, n[24] = A, n[25] = j, n[26] = M, n[27] = d.emailRequired, n[28] = N) : N = n[28];
	let P = `${r}-phone`, F = `(Signatory ${i + 1})`, I = b.phoneNumber ?? "", L;
	n[29] !== s || n[30] !== b ? (L = (e) => {
		let { value: t } = e;
		return s({
			...b,
			phoneNumber: t
		});
	}, n[29] = s, n[30] = b, n[31] = L) : L = n[31];
	let R = _ && d.phoneNumberRequired && !b.phoneNumber ? "Enter phone number" : void 0, z;
	n[32] !== P || n[33] !== F || n[34] !== I || n[35] !== L || n[36] !== R || n[37] !== d.phoneNumberRequired ? (z = /* @__PURE__ */ m(qs, {
		id: P,
		type: "phone",
		label: "Phone",
		labelHintText: F,
		defaultValue: I,
		onInputValueChange: L,
		required: d.phoneNumberRequired,
		hideOptionalText: d.phoneNumberRequired,
		stretch: !0,
		errorText: R
	}), n[32] = P, n[33] = F, n[34] = I, n[35] = L, n[36] = R, n[37] = d.phoneNumberRequired, n[38] = z) : z = n[38];
	let B;
	n[39] !== f || n[40] !== r || n[41] !== i || n[42] !== s || n[43] !== b || n[44] !== a || n[45] !== _ || n[46] !== d.hideIdentityVerification || n[47] !== d.identityVerificationRequired ? (B = !d.hideIdentityVerification && /* @__PURE__ */ m(Yp, {
		id: r,
		identityVerification: b.identityVerification,
		riskAssessment: b.riskAssessment,
		employmentDetails: b.employmentDetails,
		stakeholderType: a,
		vendorBuyerName: b.name ?? {},
		labelHintText: `(Signatory ${i + 1})`,
		validate: _,
		required: d.identityVerificationRequired ?? !0,
		defaultPlaceOfIssueAddress: f,
		onUpdateIdentityVerificationForm: (e) => {
			let { identityVerification: t, riskAssessment: n, employmentDetails: r } = e;
			return s({
				...b,
				identityVerification: t,
				riskAssessment: n,
				employmentDetails: r
			});
		}
	}), n[39] = f, n[40] = r, n[41] = i, n[42] = s, n[43] = b, n[44] = a, n[45] = _, n[46] = d.hideIdentityVerification, n[47] = d.identityVerificationRequired, n[48] = B) : B = n[48];
	let V;
	n[49] !== D || n[50] !== N || n[51] !== z || n[52] !== B ? (V = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [
			D,
			N,
			z,
			B
		]
	}), n[49] = D, n[50] = N, n[51] = z, n[52] = B, n[53] = V) : V = n[53];
	let H;
	return n[54] !== V || n[55] !== x || n[56] !== C ? (H = /* @__PURE__ */ m(ka, {
		title: x,
		open: !0,
		enableToggle: !0,
		variant: "withDivider",
		iconPosition: "left",
		backgroundColor: "lightGrey",
		headerPadding: S,
		contentPadding: "spacing-2xl",
		actionContent: C,
		showBorder: !0,
		content: V
	}), n[54] = V, n[55] = x, n[56] = C, n[57] = H) : H = n[57], H;
}, Zp = 2, Qp = () => ({
	name: {},
	email: "",
	phoneNumber: ""
}), $p = (t) => {
	let n = e(25), { id: r, stakeholderType: i, signatories: a, onChange: s, validate: c, vendorBuyerConfig: l, defaultPlaceOfIssueAddress: u, readOnly: d } = t, f = c === void 0 ? !1 : c, p = d === void 0 ? !1 : d, g;
	n[0] === a ? g = n[1] : (g = a?.length ? a : [Qp()], n[0] = a, n[1] = g);
	let _ = g, v;
	n[2] !== s || n[3] !== a?.length ? (v = () => {
		a?.length || s([Qp()]);
	}, n[2] = s, n[3] = a?.length, n[4] = v) : v = n[4];
	let y = a?.length, b;
	n[5] !== s || n[6] !== y ? (b = [s, y], n[5] = s, n[6] = y, n[7] = b) : b = n[7], o(v, b);
	let x;
	n[8] !== u || n[9] !== r || n[10] !== _ || n[11] !== s || n[12] !== p || n[13] !== i || n[14] !== f || n[15] !== l ? (x = _.map((e, t) => /* @__PURE__ */ m(Xp, {
		id: `${r}-${t + 1}`,
		index: t,
		stakeholderType: i,
		value: e,
		onChange: (e) => s(_.map((n, r) => r === t ? e : n)),
		onDelete: () => {
			p || _.length <= 1 || s(_.filter((e, n) => n !== t));
		},
		canDelete: !p && _.length > 1,
		validate: f,
		vendorBuyerConfig: l,
		defaultPlaceOfIssueAddress: u,
		readOnly: p
	}, e?.id ?? `${r}-${t}`)), n[8] = u, n[9] = r, n[10] = _, n[11] = s, n[12] = p, n[13] = i, n[14] = f, n[15] = l, n[16] = x) : x = n[16];
	let S;
	n[17] !== r || n[18] !== _ || n[19] !== s || n[20] !== p ? (S = !p && _.length < Zp && /* @__PURE__ */ m(Kl, {
		id: `${r}-add`,
		text: "Add Signatory",
		variant: "hollow",
		size: "small",
		leftIcon: /* @__PURE__ */ m(Mi, {}),
		onClick: () => s([..._, Qp()])
	}), n[17] = r, n[18] = _, n[19] = s, n[20] = p, n[21] = S) : S = n[21];
	let C;
	return n[22] !== x || n[23] !== S ? (C = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [x, S]
	}), n[22] = x, n[23] = S, n[24] = C) : C = n[24], C;
}, em = ({ id: e, stakeholderType: t, index: n, value: r, onChange: i, propertyAddress: a, readOnlyName: o = !1, readOnly: s = !1, validate: c = !1, required: l = !1, vendorBuyerConfig: d, companyConfig: f, displayLegalName: p = !1, registeredOwnerNames: g = [], selectedLegalNames: _ = [], legalName: v, setLegalName: y }) => {
	let b = t === oe.Vendor ? "Vendor" : "Buyer", x = u(r?.companyName ?? ""), S = o && !!x.current, C = !r?.acn && !r?.abn, w = c && f.requireAcnOrAbn && C ? "Enter ABN or ACN" : void 0, T = r?.trustDetails?.hasTrust === void 0 ? void 0 : r.trustDetails.hasTrust ? Bc.Yes : Bc.No, E = c && l && r?.trustDetails?.hasTrust && !r?.trustDetails?.trustName ? "Input name of trust." : void 0;
	return /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [
			/* @__PURE__ */ m(qs, {
				id: `${e}-companyName`,
				type: "text",
				label: "Company Name",
				defaultValue: r?.companyName ?? "",
				onInputValueChange: ({ value: e }) => i({
					...r,
					companyName: e
				}),
				readonly: S,
				disabled: S,
				required: !0,
				stretch: !0,
				errorText: c && !r?.companyName ? "Enter company name" : void 0
			}),
			t === oe.Vendor && p && /* @__PURE__ */ m(Tl, {
				id: `${e}-legalName`,
				labelHintText: `(${b} ${n})`,
				value: v,
				registeredOwnerNames: g,
				selectedLegalNames: _,
				validate: c,
				onChange: y
			}),
			(!f.hideAcn || !f.hideAbn) && /* @__PURE__ */ h($, {
				direction: "horizontal",
				gap: "lg",
				fill: !0,
				children: [!f.hideAcn && /* @__PURE__ */ m($, {
					fill: !0,
					children: /* @__PURE__ */ m(qs, {
						id: `${e}-acn`,
						type: "acn",
						label: "ACN",
						defaultValue: r?.acn ?? "",
						onInputValueChange: ({ value: e }) => i({
							...r,
							acn: e
						}),
						stretch: !0,
						required: f.hideAbn,
						hideOptionalText: f.requireAcnOrAbn || f.hideAbn,
						hideErrorDescription: !!w,
						errorText: w ?? (c && f.hideAbn && !r?.acn ? "Enter ACN" : void 0)
					})
				}), !f.hideAbn && /* @__PURE__ */ m($, {
					fill: !0,
					children: /* @__PURE__ */ m(qs, {
						id: `${e}-abn`,
						type: "abn",
						label: "ABN",
						defaultValue: r?.abn ?? "",
						onInputValueChange: ({ value: e }) => i({
							...r,
							abn: e
						}),
						required: f.hideAcn,
						hideOptionalText: f.requireAcnOrAbn || f.hideAcn,
						stretch: !0,
						errorText: w ?? (c && f.hideAcn && !r?.abn ? "Enter ABN" : void 0)
					})
				})]
			}),
			!f.hideRegisteredForGst && /* @__PURE__ */ m(os, {
				id: `${e}-registeredForGst`,
				checked: !!r?.registeredForGST,
				onChange: (e) => i({
					...r,
					registeredForGST: e
				}),
				label: "Registered for GST"
			}),
			/* @__PURE__ */ m(Vc, {
				id: `${e}-corporateTrustee`,
				label: "Is Company a Corporate Trustee?",
				defaultValue: T,
				required: l,
				errorText: "Select a option.",
				validate: c,
				showOptionalLabel: !l,
				onValueChanged: ({ value: e }) => i({
					...r,
					trustDetails: {
						...r?.trustDetails,
						hasTrust: e === Bc.Yes,
						trustName: e === Bc.Yes ? r?.trustDetails?.trustName : void 0
					}
				}),
				yesSubContent: /* @__PURE__ */ m($, {
					padding: {
						top: "spacing-2xl",
						bottom: "spacing-2xl",
						left: "spacing-lg",
						right: "spacing-lg"
					},
					fill: !0,
					children: /* @__PURE__ */ m(qs, {
						id: `${e}-trustName`,
						type: "text",
						label: "Name of Trust",
						defaultValue: r?.trustDetails?.trustName,
						required: l,
						hideOptionalText: l,
						stretch: !0,
						errorText: E,
						onInputValueChange: ({ value: e }) => i({
							...r,
							trustDetails: {
								...r?.trustDetails,
								trustName: e
							}
						})
					})
				})
			}),
			/* @__PURE__ */ m(rc, {
				id: `${e}-address`,
				label: `${b}'s Address`,
				comparisonAddress: a,
				comparisonAddressLabel: "Same as Property",
				alternateAddressLabel: "Other",
				defaultValue: r?.address,
				onValueChanged: ({ value: e }) => i({
					...r,
					address: e
				}),
				validate: c,
				required: d.addressRequired,
				globalAddress: !0,
				placeHolderText: "Search address"
			}),
			/* @__PURE__ */ h($, {
				direction: "vertical",
				gap: "spacing-lg",
				fill: !0,
				children: [/* @__PURE__ */ m(Q, {
					id: `${e}-signatories-title`,
					type: "body_ui_strong",
					size: "medium",
					children: "Signatories"
				}), /* @__PURE__ */ m($p, {
					id: `${e}-signatories`,
					stakeholderType: t,
					signatories: r?.signatories,
					onChange: (e) => i({
						...r,
						signatories: e
					}),
					validate: c,
					vendorBuyerConfig: d,
					defaultPlaceOfIssueAddress: Dp(r?.address, a),
					readOnly: s
				})]
			})
		]
	});
}, tm = (t) => {
	let n = e(68), { id: r, index: i, stakeholderType: a, value: o, onChange: s, onDelete: c, canDelete: l, validate: u, vendorBuyerConfig: d, readOnly: f } = t, p = l === void 0 ? !0 : l, g = u === void 0 ? !1 : u, _ = f === void 0 ? !1 : f, v = `Executor ${i + 1}`, y;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (y = {
		top: "spacing-xl",
		bottom: "spacing-xl",
		left: "spacing-2xl",
		right: "spacing-2xl"
	}, n[0] = y) : y = n[0];
	let b;
	n[1] !== p || n[2] !== r || n[3] !== c ? (b = p ? /* @__PURE__ */ m(Kl, {
		id: `${r}-delete`,
		text: /* @__PURE__ */ m(sa, {}),
		variant: "naked",
		size: "small",
		onClick: c
	}) : void 0, n[1] = p, n[2] = r, n[3] = c, n[4] = b) : b = n[4];
	let x = `${r}-name`, S = `(Executor ${i + 1})`, C;
	n[5] !== s || n[6] !== o ? (C = (e) => s({
		...o,
		name: e
	}), n[5] = s, n[6] = o, n[7] = C) : C = n[7];
	let w;
	n[8] !== _ || n[9] !== x || n[10] !== S || n[11] !== C || n[12] !== g || n[13] !== o.name || n[14] !== d.excludeMiddleName || n[15] !== d.preferredNameRequired ? (w = /* @__PURE__ */ m(wl, {
		id: x,
		label: "Executor's Name",
		labelHintText: S,
		value: o.name,
		onChange: C,
		hideMiddleName: d.excludeMiddleName,
		validate: g,
		preferredNameRequired: d.preferredNameRequired,
		nameIsUpperCase: !0,
		readonly: _
	}), n[8] = _, n[9] = x, n[10] = S, n[11] = C, n[12] = g, n[13] = o.name, n[14] = d.excludeMiddleName, n[15] = d.preferredNameRequired, n[16] = w) : w = n[16];
	let T = `${r}-address`, E;
	n[17] === o.address ? E = n[18] : (E = zp(o.address), n[17] = o.address, n[18] = E);
	let D;
	n[19] !== s || n[20] !== o ? (D = (e) => s({
		...o,
		address: Bp(e)
	}), n[19] = s, n[20] = o, n[21] = D) : D = n[21];
	let O = !d.addressRequired, k = g && d.addressRequired && !Vp(o.address) ? "Enter address" : void 0, A;
	n[22] !== T || n[23] !== E || n[24] !== D || n[25] !== O || n[26] !== k || n[27] !== g ? (A = /* @__PURE__ */ m(Xs, {
		id: T,
		label: "Address",
		defaultValue: E,
		onAddressChange: D,
		validate: g,
		optional: O,
		errorText: k,
		stretch: !0,
		placeholderText: "Search address"
	}), n[22] = T, n[23] = E, n[24] = D, n[25] = O, n[26] = k, n[27] = g, n[28] = A) : A = n[28];
	let j = `${r}-email`, M = `(Executor ${i + 1})`, N = o.email ?? "", P;
	n[29] !== s || n[30] !== o ? (P = (e) => {
		let { value: t } = e;
		return s({
			...o,
			email: t
		});
	}, n[29] = s, n[30] = o, n[31] = P) : P = n[31];
	let F = g && d.emailRequired && !o.email ? "Enter email" : void 0, I;
	n[32] !== j || n[33] !== M || n[34] !== N || n[35] !== P || n[36] !== F || n[37] !== d.emailRequired ? (I = /* @__PURE__ */ m(qs, {
		id: j,
		type: "email",
		label: "Email",
		labelHintText: M,
		defaultValue: N,
		onInputValueChange: P,
		required: d.emailRequired,
		hideOptionalText: d.emailRequired,
		stretch: !0,
		errorText: F
	}), n[32] = j, n[33] = M, n[34] = N, n[35] = P, n[36] = F, n[37] = d.emailRequired, n[38] = I) : I = n[38];
	let L = `${r}-phone`, R = `(Executor ${i + 1})`, z = o.phoneNumber ?? "", B;
	n[39] !== s || n[40] !== o ? (B = (e) => {
		let { value: t } = e;
		return s({
			...o,
			phoneNumber: t
		});
	}, n[39] = s, n[40] = o, n[41] = B) : B = n[41];
	let V = g && d.phoneNumberRequired && !o.phoneNumber ? "Enter phone number" : void 0, H;
	n[42] !== L || n[43] !== R || n[44] !== z || n[45] !== B || n[46] !== V || n[47] !== d.phoneNumberRequired ? (H = /* @__PURE__ */ m(qs, {
		id: L,
		type: "phone",
		label: "Phone",
		labelHintText: R,
		defaultValue: z,
		onInputValueChange: B,
		required: d.phoneNumberRequired,
		hideOptionalText: d.phoneNumberRequired,
		stretch: !0,
		errorText: V
	}), n[42] = L, n[43] = R, n[44] = z, n[45] = B, n[46] = V, n[47] = d.phoneNumberRequired, n[48] = H) : H = n[48];
	let U;
	n[49] !== r || n[50] !== i || n[51] !== s || n[52] !== a || n[53] !== g || n[54] !== o || n[55] !== d.hideIdentityVerification || n[56] !== d.identityVerificationRequired ? (U = !d.hideIdentityVerification && /* @__PURE__ */ m(Yp, {
		id: r,
		identityVerification: o?.identityVerification,
		riskAssessment: o?.riskAssessment,
		employmentDetails: o?.employmentDetails,
		stakeholderType: a,
		vendorBuyerName: o?.name ?? {},
		labelHintText: `(Executor ${i + 1})`,
		validate: g,
		required: d.identityVerificationRequired ?? !0,
		defaultPlaceOfIssueAddress: o.address,
		onUpdateIdentityVerificationForm: (e) => {
			let { identityVerification: t, riskAssessment: n, employmentDetails: r } = e;
			return s({
				...o,
				identityVerification: t,
				riskAssessment: n,
				employmentDetails: r
			});
		}
	}), n[49] = r, n[50] = i, n[51] = s, n[52] = a, n[53] = g, n[54] = o, n[55] = d.hideIdentityVerification, n[56] = d.identityVerificationRequired, n[57] = U) : U = n[57];
	let W;
	n[58] !== w || n[59] !== A || n[60] !== I || n[61] !== H || n[62] !== U ? (W = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [
			w,
			A,
			I,
			H,
			U
		]
	}), n[58] = w, n[59] = A, n[60] = I, n[61] = H, n[62] = U, n[63] = W) : W = n[63];
	let G;
	return n[64] !== W || n[65] !== v || n[66] !== b ? (G = /* @__PURE__ */ m(ka, {
		title: v,
		open: !0,
		enableToggle: !0,
		variant: "withDivider",
		iconPosition: "left",
		backgroundColor: "lightGrey",
		headerPadding: y,
		contentPadding: "spacing-2xl",
		actionContent: b,
		showBorder: !0,
		content: W
	}), n[64] = W, n[65] = v, n[66] = b, n[67] = G) : G = n[67], G;
}, nm = 2, rm = () => ({
	name: {},
	email: "",
	phoneNumber: ""
}), im = (t) => {
	let n = e(24), { id: r, stakeholderType: i, executors: a, onChange: s, validate: c, vendorBuyerConfig: l, readOnly: u } = t, d = c === void 0 ? !1 : c, f = u === void 0 ? !1 : u, p;
	n[0] === a ? p = n[1] : (p = a?.length ? a : [rm()], n[0] = a, n[1] = p);
	let g = p, _;
	n[2] !== a?.length || n[3] !== s ? (_ = () => {
		a?.length || s([rm()]);
	}, n[2] = a?.length, n[3] = s, n[4] = _) : _ = n[4];
	let v = a?.length, y;
	n[5] !== s || n[6] !== v ? (y = [v, s], n[5] = s, n[6] = v, n[7] = y) : y = n[7], o(_, y);
	let b;
	n[8] !== r || n[9] !== g || n[10] !== s || n[11] !== f || n[12] !== i || n[13] !== d || n[14] !== l ? (b = g.map((e, t) => /* @__PURE__ */ m(tm, {
		id: `${r}-${t + 1}`,
		index: t,
		stakeholderType: i,
		value: e ?? rm(),
		onChange: (e) => s(g.map((n, r) => r === t ? e : n)),
		onDelete: () => {
			f || g.length <= 1 || s(g.filter((e, n) => n !== t));
		},
		canDelete: !f && g.length > 1,
		validate: d,
		vendorBuyerConfig: l,
		readOnly: f
	}, e?.id ?? `${r}-${t}`)), n[8] = r, n[9] = g, n[10] = s, n[11] = f, n[12] = i, n[13] = d, n[14] = l, n[15] = b) : b = n[15];
	let x;
	n[16] !== r || n[17] !== g || n[18] !== s || n[19] !== f ? (x = !f && g.length < nm && /* @__PURE__ */ m(Kl, {
		id: `${r}-add`,
		text: "Add Executor",
		variant: "hollow",
		size: "small",
		leftIcon: /* @__PURE__ */ m(Mi, {}),
		onClick: () => s([...g, rm()])
	}), n[16] = r, n[17] = g, n[18] = s, n[19] = f, n[20] = x) : x = n[20];
	let S;
	return n[21] !== b || n[22] !== x ? (S = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [b, x]
	}), n[21] = b, n[22] = x, n[23] = S) : S = n[23], S;
}, am = (t) => {
	let n = e(44), { id: r, stakeholderType: i, index: a, value: o, onChange: s, readOnlyName: c, readOnly: l, validate: u, vendorBuyerConfig: d, displayLegalName: f, registeredOwnerNames: p, selectedLegalNames: g, legalName: _, setLegalName: v } = t, y = c === void 0 ? !1 : c, b = l === void 0 ? !1 : l, x = u === void 0 ? !1 : u, S = f === void 0 ? !1 : f, C;
	n[0] === p ? C = n[1] : (C = p === void 0 ? [] : p, n[0] = p, n[1] = C);
	let w = C, T;
	n[2] === g ? T = n[3] : (T = g === void 0 ? [] : g, n[2] = g, n[3] = T);
	let E = T, D = `${r}-name`, O = `(Vendor ${a})`, k = o?.name, A;
	n[4] !== s || n[5] !== o ? (A = (e) => s({
		...o,
		name: e
	}), n[4] = s, n[5] = o, n[6] = A) : A = n[6];
	let j = y || b, M;
	n[7] !== O || n[8] !== k || n[9] !== A || n[10] !== j || n[11] !== D || n[12] !== x || n[13] !== d.excludeMiddleName ? (M = /* @__PURE__ */ m(wl, {
		id: D,
		label: "Deceased Vendor's Name",
		labelHintText: O,
		value: k,
		onChange: A,
		hideMiddleName: d.excludeMiddleName,
		readonly: j,
		validate: x,
		hidePreferredName: !0,
		nameIsUpperCase: !0
	}), n[7] = O, n[8] = k, n[9] = A, n[10] = j, n[11] = D, n[12] = x, n[13] = d.excludeMiddleName, n[14] = M) : M = n[14];
	let N;
	n[15] !== S || n[16] !== r || n[17] !== a || n[18] !== _ || n[19] !== w || n[20] !== E || n[21] !== v || n[22] !== x ? (N = S && /* @__PURE__ */ m(Tl, {
		id: `${r}-legalName`,
		labelHintText: `(Vendor ${a})`,
		value: _,
		registeredOwnerNames: w,
		selectedLegalNames: E,
		validate: x,
		onChange: v
	}), n[15] = S, n[16] = r, n[17] = a, n[18] = _, n[19] = w, n[20] = E, n[21] = v, n[22] = x, n[23] = N) : N = n[23];
	let P = `${r}-executors-title`, F;
	n[24] === P ? F = n[25] : (F = /* @__PURE__ */ m(Q, {
		id: P,
		type: "body_ui_strong",
		size: "medium",
		children: "Executors"
	}), n[24] = P, n[25] = F);
	let I = `${r}-executors`, L = o?.executors, R;
	n[26] !== s || n[27] !== o ? (R = (e) => s({
		...o,
		executors: e
	}), n[26] = s, n[27] = o, n[28] = R) : R = n[28];
	let z;
	n[29] !== b || n[30] !== i || n[31] !== I || n[32] !== L || n[33] !== R || n[34] !== x || n[35] !== d ? (z = /* @__PURE__ */ m(im, {
		id: I,
		stakeholderType: i,
		executors: L,
		onChange: R,
		validate: x,
		vendorBuyerConfig: d,
		readOnly: b
	}), n[29] = b, n[30] = i, n[31] = I, n[32] = L, n[33] = R, n[34] = x, n[35] = d, n[36] = z) : z = n[36];
	let B;
	n[37] !== F || n[38] !== z ? (B = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-lg",
		fill: !0,
		children: [F, z]
	}), n[37] = F, n[38] = z, n[39] = B) : B = n[39];
	let V;
	return n[40] !== M || n[41] !== N || n[42] !== B ? (V = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [
			M,
			N,
			B
		]
	}), n[40] = M, n[41] = N, n[42] = B, n[43] = V) : V = n[43], V;
}, om = 2, sm = (t) => {
	let n = e(26), { id: r, value: i, onChange: a, validate: o } = t, s;
	n[0] === i ? s = n[1] : (s = i === void 0 ? [] : i, n[0] = i, n[1] = s);
	let c = s, l = o === void 0 ? !1 : o, u = c, d;
	n[2] !== u || n[3] !== a ? (d = (e, t) => {
		a(u.map((n, r) => r === e ? t : n));
	}, n[2] = u, n[3] = a, n[4] = d) : d = n[4];
	let f = d, p;
	n[5] !== u || n[6] !== a ? (p = (e) => {
		a(u.filter((t, n) => n !== e));
	}, n[5] = u, n[6] = a, n[7] = p) : p = n[7];
	let g = p, _;
	if (n[8] !== r || n[9] !== u || n[10] !== g || n[11] !== f || n[12] !== l) {
		let e;
		n[14] !== r || n[15] !== g || n[16] !== f || n[17] !== l ? (e = (e, t) => /* @__PURE__ */ h($, {
			className: "additional-cc-email",
			fill: !0,
			children: [/* @__PURE__ */ m("div", {
				className: "additional-cc-email__remove",
				children: /* @__PURE__ */ m(Kl, {
					id: `${r}-${t + 1}-remove`,
					text: /* @__PURE__ */ m(Xi, {
						width: 16,
						height: 16
					}),
					variant: "naked",
					size: "small",
					onClick: () => g(t)
				})
			}), /* @__PURE__ */ m(qs, {
				id: `${r}-${t + 1}`,
				type: "email",
				label: "CC",
				defaultValue: e,
				onInputValueChange: (e) => {
					let { value: n } = e;
					return f(t, n);
				},
				hideOptionalText: !0,
				stretch: !0,
				errorText: l && !e ? "Enter CC" : void 0
			})]
		}, `${r}-${t}`), n[14] = r, n[15] = g, n[16] = f, n[17] = l, n[18] = e) : e = n[18], _ = u.map(e), n[8] = r, n[9] = u, n[10] = g, n[11] = f, n[12] = l, n[13] = _;
	} else _ = n[13];
	let v;
	n[19] !== r || n[20] !== u || n[21] !== a ? (v = u.length < om && /* @__PURE__ */ m(Kl, {
		id: `${r}-add`,
		text: "Add CC",
		variant: "primary",
		size: "medium",
		onClick: () => a([...u, ""])
	}), n[19] = r, n[20] = u, n[21] = a, n[22] = v) : v = n[22];
	let y;
	return n[23] !== _ || n[24] !== v ? (y = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [_, v]
	}), n[23] = _, n[24] = v, n[25] = y) : y = n[25], y;
}, cm = (t) => {
	let n = e(104), { id: r, stakeholderType: i, index: a, value: o, onChange: s, propertyAddress: c, readOnlyName: l, readOnly: u, validate: d, required: f, vendorBuyerConfig: p, displayLegalName: g, registeredOwnerNames: _, selectedLegalNames: v, legalName: y, setLegalName: b } = t, x = l === void 0 ? !1 : l, S = u === void 0 ? !1 : u, C = d === void 0 ? !1 : d, w = f === void 0 ? !1 : f, T = g === void 0 ? !1 : g, E;
	n[0] === _ ? E = n[1] : (E = _ === void 0 ? [] : _, n[0] = _, n[1] = E);
	let D = E, O;
	n[2] === v ? O = n[3] : (O = v === void 0 ? [] : v, n[2] = v, n[3] = O);
	let k = O, A = i === oe.Vendor ? "Vendor" : "Buyer", j = o?.trustDetails?.hasTrust === void 0 ? void 0 : o.trustDetails.hasTrust ? Bc.Yes : Bc.No, M = C && w && o?.trustDetails?.hasTrust && !o.trustDetails?.trustName ? "Input name of trust." : void 0, N = `${r}-name`, P = `${A}'s Name`, F = `(${A} ${a})`, I = o?.name, L;
	n[4] !== s || n[5] !== o ? (L = (e) => s({
		...o,
		name: e
	}), n[4] = s, n[5] = o, n[6] = L) : L = n[6];
	let R = x || S, z;
	n[7] !== N || n[8] !== P || n[9] !== F || n[10] !== I || n[11] !== L || n[12] !== R || n[13] !== C || n[14] !== p.excludeMiddleName || n[15] !== p.preferredNameRequired ? (z = /* @__PURE__ */ m(wl, {
		id: N,
		label: P,
		labelHintText: F,
		value: I,
		onChange: L,
		hideMiddleName: p.excludeMiddleName,
		readonly: R,
		validate: C,
		preferredNameRequired: p.preferredNameRequired,
		nameIsUpperCase: !0
	}), n[7] = N, n[8] = P, n[9] = F, n[10] = I, n[11] = L, n[12] = R, n[13] = C, n[14] = p.excludeMiddleName, n[15] = p.preferredNameRequired, n[16] = z) : z = n[16];
	let B;
	n[17] !== T || n[18] !== r || n[19] !== a || n[20] !== y || n[21] !== D || n[22] !== k || n[23] !== b || n[24] !== A || n[25] !== i || n[26] !== C ? (B = i === oe.Vendor && T && /* @__PURE__ */ m(Tl, {
		id: `${r}-legalName`,
		labelHintText: `(${A} ${a})`,
		value: y,
		registeredOwnerNames: D,
		selectedLegalNames: k,
		validate: C,
		onChange: b
	}), n[17] = T, n[18] = r, n[19] = a, n[20] = y, n[21] = D, n[22] = k, n[23] = b, n[24] = A, n[25] = i, n[26] = C, n[27] = B) : B = n[27];
	let V = `${r}-trust`, H = !w, U;
	n[28] !== s || n[29] !== o ? (U = (e) => {
		let { value: t } = e;
		return s({
			...o,
			trustDetails: {
				...o?.trustDetails,
				hasTrust: t === Bc.Yes,
				trustName: t === Bc.Yes ? o?.trustDetails?.trustName : void 0
			}
		});
	}, n[28] = s, n[29] = o, n[30] = U) : U = n[30];
	let W;
	n[31] === Symbol.for("react.memo_cache_sentinel") ? (W = {
		top: "spacing-2xl",
		bottom: "spacing-2xl",
		left: "spacing-lg",
		right: "spacing-lg"
	}, n[31] = W) : W = n[31];
	let G = `${r}-trustName`, K = o?.trustDetails?.trustName, q;
	n[32] !== s || n[33] !== o ? (q = (e) => {
		let { value: t } = e;
		return s({
			...o,
			trustDetails: {
				...o?.trustDetails,
				trustName: t
			}
		});
	}, n[32] = s, n[33] = o, n[34] = q) : q = n[34];
	let J;
	n[35] !== w || n[36] !== G || n[37] !== K || n[38] !== q || n[39] !== M ? (J = /* @__PURE__ */ m($, {
		padding: W,
		fill: !0,
		children: /* @__PURE__ */ m(qs, {
			id: G,
			type: "text",
			label: "Name of Trust",
			defaultValue: K,
			required: w,
			hideOptionalText: w,
			stretch: !0,
			errorText: M,
			onInputValueChange: q
		})
	}), n[35] = w, n[36] = G, n[37] = K, n[38] = q, n[39] = M, n[40] = J) : J = n[40];
	let Y;
	n[41] !== w || n[42] !== V || n[43] !== H || n[44] !== U || n[45] !== J || n[46] !== j || n[47] !== C ? (Y = /* @__PURE__ */ m(Vc, {
		id: V,
		label: "Is the property owned in a trust?",
		defaultValue: j,
		required: w,
		errorText: "Select a option.",
		validate: C,
		showOptionalLabel: H,
		onValueChanged: U,
		yesSubContent: J
	}), n[41] = w, n[42] = V, n[43] = H, n[44] = U, n[45] = J, n[46] = j, n[47] = C, n[48] = Y) : Y = n[48];
	let X = `${r}-address`, Z = `${A}'s Address`, ee = o?.address, te;
	n[49] !== s || n[50] !== o ? (te = (e) => {
		let { value: t } = e;
		return s({
			...o,
			address: t
		});
	}, n[49] = s, n[50] = o, n[51] = te) : te = n[51];
	let ne;
	n[52] !== c || n[53] !== X || n[54] !== Z || n[55] !== ee || n[56] !== te || n[57] !== C || n[58] !== p.addressRequired ? (ne = /* @__PURE__ */ m(rc, {
		id: X,
		label: Z,
		comparisonAddress: c,
		comparisonAddressLabel: "Same as Property",
		alternateAddressLabel: "Other",
		defaultValue: ee,
		onValueChanged: te,
		validate: C,
		required: p.addressRequired,
		globalAddress: !0,
		placeHolderText: "Search address"
	}), n[52] = c, n[53] = X, n[54] = Z, n[55] = ee, n[56] = te, n[57] = C, n[58] = p.addressRequired, n[59] = ne) : ne = n[59];
	let re = `${r}-email`, ie = o?.email ?? "", ae;
	n[60] !== s || n[61] !== o ? (ae = (e) => {
		let { value: t } = e;
		return s({
			...o,
			email: t
		});
	}, n[60] = s, n[61] = o, n[62] = ae) : ae = n[62];
	let se = C && p.emailRequired && !o?.email ? "Enter email" : void 0, ce;
	n[63] !== re || n[64] !== ie || n[65] !== ae || n[66] !== se || n[67] !== p.emailRequired ? (ce = /* @__PURE__ */ m(qs, {
		id: re,
		type: "email",
		label: "Email",
		defaultValue: ie,
		onInputValueChange: ae,
		required: p.emailRequired,
		hideOptionalText: p.emailRequired,
		stretch: !0,
		errorText: se
	}), n[63] = re, n[64] = ie, n[65] = ae, n[66] = se, n[67] = p.emailRequired, n[68] = ce) : ce = n[68];
	let le = `${r}-phone`, ue = o?.phoneNumber ?? "", de;
	n[69] !== s || n[70] !== o ? (de = (e) => {
		let { value: t } = e;
		return s({
			...o,
			phoneNumber: t
		});
	}, n[69] = s, n[70] = o, n[71] = de) : de = n[71];
	let fe = C && p.phoneNumberRequired && !o?.phoneNumber ? "Enter phone number" : void 0, pe;
	n[72] !== le || n[73] !== ue || n[74] !== de || n[75] !== fe || n[76] !== p.phoneNumberRequired ? (pe = /* @__PURE__ */ m(qs, {
		id: le,
		type: "phone",
		label: "Phone",
		defaultValue: ue,
		onInputValueChange: de,
		required: p.phoneNumberRequired,
		hideOptionalText: p.phoneNumberRequired,
		stretch: !0,
		errorText: fe
	}), n[72] = le, n[73] = ue, n[74] = de, n[75] = fe, n[76] = p.phoneNumberRequired, n[77] = pe) : pe = n[77];
	let me;
	n[78] !== r || n[79] !== s || n[80] !== C || n[81] !== o || n[82] !== p.displayAddCc ? (me = p.displayAddCc && /* @__PURE__ */ m(sm, {
		id: `${r}-additional-cc`,
		value: o?.additionalCcEmails,
		onChange: (e) => s({
			...o,
			additionalCcEmails: e
		}),
		validate: C
	}), n[78] = r, n[79] = s, n[80] = C, n[81] = o, n[82] = p.displayAddCc, n[83] = me) : me = n[83];
	let he;
	n[84] !== r || n[85] !== a || n[86] !== s || n[87] !== c || n[88] !== A || n[89] !== i || n[90] !== C || n[91] !== o || n[92] !== p.hideIdentityVerification || n[93] !== p.identityVerificationRequired ? (he = !p.hideIdentityVerification && /* @__PURE__ */ m(Yp, {
		id: r,
		identityVerification: o?.identityVerification,
		riskAssessment: o?.riskAssessment,
		employmentDetails: o?.employmentDetails,
		stakeholderType: i,
		vendorBuyerName: o?.name ?? {},
		labelHintText: `(${A} ${a})`,
		validate: C,
		required: p.identityVerificationRequired ?? !0,
		defaultPlaceOfIssueAddress: Dp(o?.address, c),
		onUpdateIdentityVerificationForm: (e) => {
			let { identityVerification: t, riskAssessment: n, employmentDetails: r } = e;
			return s({
				...o,
				identityVerification: t,
				riskAssessment: n,
				employmentDetails: r
			});
		}
	}), n[84] = r, n[85] = a, n[86] = s, n[87] = c, n[88] = A, n[89] = i, n[90] = C, n[91] = o, n[92] = p.hideIdentityVerification, n[93] = p.identityVerificationRequired, n[94] = he) : he = n[94];
	let ge;
	return n[95] !== z || n[96] !== B || n[97] !== Y || n[98] !== ne || n[99] !== ce || n[100] !== pe || n[101] !== me || n[102] !== he ? (ge = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [
			z,
			B,
			Y,
			ne,
			ce,
			pe,
			me,
			he
		]
	}), n[95] = z, n[96] = B, n[97] = Y, n[98] = ne, n[99] = ce, n[100] = pe, n[101] = me, n[102] = he, n[103] = ge) : ge = n[103], ge;
}, lm = (t) => {
	let n = e(68), { id: r, index: i, stakeholderType: a, value: o, onChange: s, onDelete: c, canDelete: l, validate: u, vendorBuyerConfig: d, readOnly: f } = t, p = l === void 0 ? !0 : l, g = u === void 0 ? !1 : u, _ = f === void 0 ? !1 : f, v = `Attorney ${i + 1}`, y;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (y = {
		top: "spacing-xl",
		bottom: "spacing-xl",
		left: "spacing-2xl",
		right: "spacing-2xl"
	}, n[0] = y) : y = n[0];
	let b;
	n[1] !== p || n[2] !== r || n[3] !== c ? (b = p ? /* @__PURE__ */ m(Kl, {
		id: `${r}-delete`,
		text: /* @__PURE__ */ m(sa, {}),
		variant: "naked",
		size: "small",
		onClick: c
	}) : void 0, n[1] = p, n[2] = r, n[3] = c, n[4] = b) : b = n[4];
	let x = `${r}-name`, S = `(Attorney ${i + 1})`, C;
	n[5] !== s || n[6] !== o ? (C = (e) => s({
		...o,
		name: e
	}), n[5] = s, n[6] = o, n[7] = C) : C = n[7];
	let w;
	n[8] !== _ || n[9] !== x || n[10] !== S || n[11] !== C || n[12] !== g || n[13] !== o.name || n[14] !== d.excludeMiddleName || n[15] !== d.preferredNameRequired ? (w = /* @__PURE__ */ m(wl, {
		id: x,
		label: "Attorney's Name",
		labelHintText: S,
		value: o.name,
		onChange: C,
		hideMiddleName: d.excludeMiddleName,
		validate: g,
		preferredNameRequired: d.preferredNameRequired,
		nameIsUpperCase: !0,
		readonly: _
	}), n[8] = _, n[9] = x, n[10] = S, n[11] = C, n[12] = g, n[13] = o.name, n[14] = d.excludeMiddleName, n[15] = d.preferredNameRequired, n[16] = w) : w = n[16];
	let T = `${r}-address`, E;
	n[17] === o.address ? E = n[18] : (E = zp(o.address), n[17] = o.address, n[18] = E);
	let D;
	n[19] !== s || n[20] !== o ? (D = (e) => s({
		...o,
		address: Bp(e)
	}), n[19] = s, n[20] = o, n[21] = D) : D = n[21];
	let O = !d.addressRequired, k = g && d.addressRequired && !Vp(o.address) ? "Enter address" : void 0, A;
	n[22] !== T || n[23] !== E || n[24] !== D || n[25] !== O || n[26] !== k || n[27] !== g ? (A = /* @__PURE__ */ m(Xs, {
		id: T,
		label: "Address",
		defaultValue: E,
		onAddressChange: D,
		validate: g,
		optional: O,
		errorText: k,
		stretch: !0,
		placeholderText: "Search address"
	}), n[22] = T, n[23] = E, n[24] = D, n[25] = O, n[26] = k, n[27] = g, n[28] = A) : A = n[28];
	let j = `${r}-email`, M = `(Attorney ${i + 1})`, N = o.email ?? "", P;
	n[29] !== s || n[30] !== o ? (P = (e) => {
		let { value: t } = e;
		return s({
			...o,
			email: t
		});
	}, n[29] = s, n[30] = o, n[31] = P) : P = n[31];
	let F = g && d.emailRequired && !o.email ? "Enter email" : void 0, I;
	n[32] !== j || n[33] !== M || n[34] !== N || n[35] !== P || n[36] !== F || n[37] !== d.emailRequired ? (I = /* @__PURE__ */ m(qs, {
		id: j,
		type: "email",
		label: "Email",
		labelHintText: M,
		defaultValue: N,
		onInputValueChange: P,
		required: d.emailRequired,
		hideOptionalText: d.emailRequired,
		stretch: !0,
		errorText: F
	}), n[32] = j, n[33] = M, n[34] = N, n[35] = P, n[36] = F, n[37] = d.emailRequired, n[38] = I) : I = n[38];
	let L = `${r}-phone`, R = `(Attorney ${i + 1})`, z = o.phoneNumber ?? "", B;
	n[39] !== s || n[40] !== o ? (B = (e) => {
		let { value: t } = e;
		return s({
			...o,
			phoneNumber: t
		});
	}, n[39] = s, n[40] = o, n[41] = B) : B = n[41];
	let V = g && d.phoneNumberRequired && !o.phoneNumber ? "Enter phone number" : void 0, H;
	n[42] !== L || n[43] !== R || n[44] !== z || n[45] !== B || n[46] !== V || n[47] !== d.phoneNumberRequired ? (H = /* @__PURE__ */ m(qs, {
		id: L,
		type: "phone",
		label: "Phone",
		labelHintText: R,
		defaultValue: z,
		onInputValueChange: B,
		required: d.phoneNumberRequired,
		hideOptionalText: d.phoneNumberRequired,
		stretch: !0,
		errorText: V
	}), n[42] = L, n[43] = R, n[44] = z, n[45] = B, n[46] = V, n[47] = d.phoneNumberRequired, n[48] = H) : H = n[48];
	let U;
	n[49] !== r || n[50] !== i || n[51] !== s || n[52] !== a || n[53] !== g || n[54] !== o || n[55] !== d.hideIdentityVerification || n[56] !== d.identityVerificationRequired ? (U = !d.hideIdentityVerification && /* @__PURE__ */ m(Yp, {
		id: r,
		identityVerification: o?.identityVerification,
		riskAssessment: o?.riskAssessment,
		employmentDetails: o?.employmentDetails,
		stakeholderType: a,
		vendorBuyerName: o?.name ?? {},
		labelHintText: `(Attorney ${i + 1})`,
		validate: g,
		required: d.identityVerificationRequired ?? !0,
		defaultPlaceOfIssueAddress: o.address,
		onUpdateIdentityVerificationForm: (e) => {
			let { identityVerification: t, riskAssessment: n, employmentDetails: r } = e;
			return s({
				...o,
				identityVerification: t,
				riskAssessment: n,
				employmentDetails: r
			});
		}
	}), n[49] = r, n[50] = i, n[51] = s, n[52] = a, n[53] = g, n[54] = o, n[55] = d.hideIdentityVerification, n[56] = d.identityVerificationRequired, n[57] = U) : U = n[57];
	let W;
	n[58] !== w || n[59] !== A || n[60] !== I || n[61] !== H || n[62] !== U ? (W = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [
			w,
			A,
			I,
			H,
			U
		]
	}), n[58] = w, n[59] = A, n[60] = I, n[61] = H, n[62] = U, n[63] = W) : W = n[63];
	let G;
	return n[64] !== W || n[65] !== v || n[66] !== b ? (G = /* @__PURE__ */ m(ka, {
		title: v,
		open: !0,
		enableToggle: !0,
		variant: "withDivider",
		iconPosition: "left",
		backgroundColor: "lightGrey",
		headerPadding: y,
		contentPadding: "spacing-2xl",
		actionContent: b,
		showBorder: !0,
		content: W
	}), n[64] = W, n[65] = v, n[66] = b, n[67] = G) : G = n[67], G;
}, um = 2, dm = () => ({
	name: {},
	email: "",
	phoneNumber: ""
}), fm = (t) => {
	let n = e(24), { id: r, stakeholderType: i, attorneys: a, onChange: s, validate: c, vendorBuyerConfig: l, readOnly: u } = t, d = c === void 0 ? !1 : c, f = u === void 0 ? !1 : u, p;
	n[0] === a ? p = n[1] : (p = a?.length ? a : [dm()], n[0] = a, n[1] = p);
	let g = p, _;
	n[2] !== a?.length || n[3] !== s ? (_ = () => {
		a?.length || s([dm()]);
	}, n[2] = a?.length, n[3] = s, n[4] = _) : _ = n[4];
	let v = a?.length, y;
	n[5] !== s || n[6] !== v ? (y = [v, s], n[5] = s, n[6] = v, n[7] = y) : y = n[7], o(_, y);
	let b;
	n[8] !== r || n[9] !== g || n[10] !== s || n[11] !== f || n[12] !== i || n[13] !== d || n[14] !== l ? (b = g.map((e, t) => /* @__PURE__ */ m(lm, {
		id: `${r}-${t + 1}`,
		index: t,
		stakeholderType: i,
		value: e ?? dm(),
		onChange: (e) => s(g.map((n, r) => r === t ? e : n)),
		onDelete: () => {
			f || g.length <= 1 || s(g.filter((e, n) => n !== t));
		},
		canDelete: !f && g.length > 1,
		validate: d,
		vendorBuyerConfig: l,
		readOnly: f
	}, e?.id ?? `${r}-${t}`)), n[8] = r, n[9] = g, n[10] = s, n[11] = f, n[12] = i, n[13] = d, n[14] = l, n[15] = b) : b = n[15];
	let x;
	n[16] !== r || n[17] !== g || n[18] !== s || n[19] !== f ? (x = !f && g.length < um && /* @__PURE__ */ m(Kl, {
		id: `${r}-add`,
		text: "Add Power Of Attorney",
		variant: "hollow",
		size: "small",
		leftIcon: /* @__PURE__ */ m(Mi, {}),
		onClick: () => s([...g, dm()])
	}), n[16] = r, n[17] = g, n[18] = s, n[19] = f, n[20] = x) : x = n[20];
	let S;
	return n[21] !== b || n[22] !== x ? (S = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [b, x]
	}), n[21] = b, n[22] = x, n[23] = S) : S = n[23], S;
}, pm = (t) => {
	let n = e(66), { id: r, stakeholderType: i, index: a, value: o, onChange: s, propertyAddress: c, readOnlyName: l, readOnly: u, validate: d, vendorBuyerConfig: f, powerOfAttorneyConfig: p, displayLegalName: g, registeredOwnerNames: _, selectedLegalNames: v, legalName: y, setLegalName: b, renderDocumentationUpload: x } = t, S = l === void 0 ? !1 : l, C = u === void 0 ? !1 : u, w = d === void 0 ? !1 : d, T = g === void 0 ? !1 : g, E;
	n[0] === _ ? E = n[1] : (E = _ === void 0 ? [] : _, n[0] = _, n[1] = E);
	let D = E, O;
	n[2] === v ? O = n[3] : (O = v === void 0 ? [] : v, n[2] = v, n[3] = O);
	let k = O, A = i === oe.Vendor ? "Vendor" : "Buyer", j = !p.hideDocumentationUpload, M = `${r}-name`, N = `${A}'s Name`, P = `(${A} ${a})`, F = o?.principalName, I;
	n[4] !== s || n[5] !== o ? (I = (e) => s({
		...o,
		principalName: e
	}), n[4] = s, n[5] = o, n[6] = I) : I = n[6];
	let L = S || C, R;
	n[7] !== N || n[8] !== P || n[9] !== F || n[10] !== I || n[11] !== L || n[12] !== M || n[13] !== w || n[14] !== f.excludeMiddleName ? (R = /* @__PURE__ */ m(wl, {
		id: M,
		label: N,
		labelHintText: P,
		value: F,
		onChange: I,
		hideMiddleName: f.excludeMiddleName,
		readonly: L,
		validate: w,
		hidePreferredName: !0,
		nameIsUpperCase: !0
	}), n[7] = N, n[8] = P, n[9] = F, n[10] = I, n[11] = L, n[12] = M, n[13] = w, n[14] = f.excludeMiddleName, n[15] = R) : R = n[15];
	let z;
	n[16] !== T || n[17] !== r || n[18] !== a || n[19] !== y || n[20] !== D || n[21] !== k || n[22] !== b || n[23] !== A || n[24] !== i || n[25] !== w ? (z = i === oe.Vendor && T && /* @__PURE__ */ m(Tl, {
		id: `${r}-legalName`,
		labelHintText: `(${A} ${a})`,
		value: y,
		registeredOwnerNames: D,
		selectedLegalNames: k,
		validate: w,
		onChange: b
	}), n[16] = T, n[17] = r, n[18] = a, n[19] = y, n[20] = D, n[21] = k, n[22] = b, n[23] = A, n[24] = i, n[25] = w, n[26] = z) : z = n[26];
	let B = `${r}-address`, V = `${A}'s Address`, H = o?.address, U;
	n[27] !== s || n[28] !== o ? (U = (e) => {
		let { value: t } = e;
		return s({
			...o,
			address: t
		});
	}, n[27] = s, n[28] = o, n[29] = U) : U = n[29];
	let W;
	n[30] !== c || n[31] !== B || n[32] !== V || n[33] !== H || n[34] !== U || n[35] !== w || n[36] !== f.addressRequired ? (W = /* @__PURE__ */ m(rc, {
		id: B,
		label: V,
		comparisonAddress: c,
		comparisonAddressLabel: "Same as Property",
		alternateAddressLabel: "Other",
		defaultValue: H,
		onValueChanged: U,
		validate: w,
		required: f.addressRequired,
		globalAddress: !0,
		placeHolderText: "Search address"
	}), n[30] = c, n[31] = B, n[32] = V, n[33] = H, n[34] = U, n[35] = w, n[36] = f.addressRequired, n[37] = W) : W = n[37];
	let G;
	n[38] !== r || n[39] !== s || n[40] !== x || n[41] !== j || n[42] !== o ? (G = j && x?.({
		id: `${r}-documentation`,
		value: o?.documentation,
		onChange: (e) => s({
			...o,
			documentation: e
		})
	}), n[38] = r, n[39] = s, n[40] = x, n[41] = j, n[42] = o, n[43] = G) : G = n[43];
	let K = `${r}-attorneys-title`, q;
	n[44] === K ? q = n[45] : (q = /* @__PURE__ */ m(Q, {
		id: K,
		type: "body_ui_strong",
		size: "medium",
		children: "Attorneys"
	}), n[44] = K, n[45] = q);
	let J = `${r}-attorneys`, Y = o?.attorneys, X;
	n[46] !== s || n[47] !== o ? (X = (e) => s({
		...o,
		attorneys: e
	}), n[46] = s, n[47] = o, n[48] = X) : X = n[48];
	let Z;
	n[49] !== C || n[50] !== i || n[51] !== J || n[52] !== Y || n[53] !== X || n[54] !== w || n[55] !== f ? (Z = /* @__PURE__ */ m(fm, {
		id: J,
		stakeholderType: i,
		attorneys: Y,
		onChange: X,
		validate: w,
		vendorBuyerConfig: f,
		readOnly: C
	}), n[49] = C, n[50] = i, n[51] = J, n[52] = Y, n[53] = X, n[54] = w, n[55] = f, n[56] = Z) : Z = n[56];
	let ee;
	n[57] !== q || n[58] !== Z ? (ee = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "spacing-lg",
		fill: !0,
		children: [q, Z]
	}), n[57] = q, n[58] = Z, n[59] = ee) : ee = n[59];
	let te;
	return n[60] !== R || n[61] !== z || n[62] !== W || n[63] !== G || n[64] !== ee ? (te = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [
			R,
			z,
			W,
			G,
			ee
		]
	}), n[60] = R, n[61] = z, n[62] = W, n[63] = G, n[64] = ee, n[65] = te) : te = n[65], te;
}, mm = [
	up.Individual,
	up.PowerOfAttorney,
	up.Company
], hm = [
	up.Individual,
	up.PowerOfAttorney,
	up.DeceasedEstate,
	up.Company
], gm = {
	[up.Individual]: {
		title: "Individual",
		xsTitle: "Individual"
	},
	[up.PowerOfAttorney]: {
		title: "Power Of Attorney",
		xsTitle: "P.O.A"
	},
	[up.Company]: {
		title: "Company",
		xsTitle: "Company"
	},
	[up.DeceasedEstate]: {
		title: "Deceased Estate",
		xsTitle: "Deceased"
	}
}, _m = (t) => {
	let n = e(104), { id: r, stakeholderType: i, index: a, value: o, onChange: s, propertyAddress: c, visibleTypes: l, readOnlyName: u, readOnly: d, validate: f, required: p, vendorBuyerConfig: g, companyConfig: _, powerOfAttorneyConfig: v, displayLegalName: y, registeredOwnerNames: b, selectedLegalNames: x, renderPowerOfAttorneyDocumentationUpload: S } = t, C = u === void 0 ? !1 : u, w = d === void 0 ? !1 : d, T = f === void 0 ? !1 : f, E = p === void 0 ? !1 : p, D = y === void 0 ? !1 : y, O;
	n[0] === b ? O = n[1] : (O = b === void 0 ? [] : b, n[0] = b, n[1] = O);
	let k = O, A;
	n[2] === x ? A = n[3] : (A = x === void 0 ? [] : x, n[2] = x, n[3] = A);
	let j = A, M = i === oe.Buyer ? mm : hm, N, P;
	if (n[4] !== M || n[5] !== i || n[6] !== o || n[7] !== l) {
		let e = (l?.filter((e) => M.includes(e)) ?? M).filter(vm);
		N = i === oe.Vendor && o.deceasedEstate ? up.DeceasedEstate : o.company ? up.Company : o.powerOfAttorney ? up.PowerOfAttorney : up.Individual, P = e.map(ym), n[4] = M, n[5] = i, n[6] = o, n[7] = l, n[8] = N, n[9] = P;
	} else N = n[8], P = n[9];
	let F = P, I = i === oe.Vendor ? o.legalName : void 0, L;
	n[10] !== s || n[11] !== i || n[12] !== o ? (L = (e) => {
		i === oe.Vendor && s({
			...o,
			legalName: e
		});
	}, n[10] = s, n[11] = i, n[12] = o, n[13] = L) : L = n[13];
	let R = L, z;
	n[14] !== N || n[15] !== s || n[16] !== i || n[17] !== o ? (z = (e) => {
		if (e === N) return;
		let t = fp(o, N, i);
		s({
			...dp(o, i),
			[e]: pp(e, t)
		});
	}, n[14] = N, n[15] = s, n[16] = i, n[17] = o, n[18] = z) : z = n[18];
	let B = z, V;
	n[19] !== N || n[20] !== B || n[21] !== r || n[22] !== F ? (V = F.length > 1 && /* @__PURE__ */ m(Ql, {
		id: `${r}-variant`,
		segments: F,
		defaultValue: N,
		fill: !0,
		onChange: (e) => B(e)
	}, `${r}-${N}`), n[19] = N, n[20] = B, n[21] = r, n[22] = F, n[23] = V) : V = n[23];
	let H;
	n[24] !== N || n[25] !== D || n[26] !== r || n[27] !== a || n[28] !== I || n[29] !== s || n[30] !== c || n[31] !== w || n[32] !== C || n[33] !== k || n[34] !== E || n[35] !== j || n[36] !== R || n[37] !== i || n[38] !== T || n[39] !== o || n[40] !== g ? (H = N === up.Individual && /* @__PURE__ */ m(cm, {
		id: `${r}-individual`,
		stakeholderType: i,
		index: a,
		value: o.individual,
		onChange: (e) => s({
			...o,
			individual: e
		}),
		propertyAddress: c,
		readOnlyName: C,
		readOnly: w,
		validate: T,
		required: E,
		vendorBuyerConfig: g,
		displayLegalName: D,
		registeredOwnerNames: k,
		selectedLegalNames: j,
		legalName: I,
		setLegalName: R
	}), n[24] = N, n[25] = D, n[26] = r, n[27] = a, n[28] = I, n[29] = s, n[30] = c, n[31] = w, n[32] = C, n[33] = k, n[34] = E, n[35] = j, n[36] = R, n[37] = i, n[38] = T, n[39] = o, n[40] = g, n[41] = H) : H = n[41];
	let U;
	n[42] !== N || n[43] !== D || n[44] !== r || n[45] !== a || n[46] !== I || n[47] !== s || n[48] !== v || n[49] !== c || n[50] !== w || n[51] !== C || n[52] !== k || n[53] !== S || n[54] !== E || n[55] !== j || n[56] !== R || n[57] !== i || n[58] !== T || n[59] !== o || n[60] !== g ? (U = N === up.PowerOfAttorney && /* @__PURE__ */ m(pm, {
		id: `${r}-power-of-attorney`,
		stakeholderType: i,
		index: a,
		value: o.powerOfAttorney,
		onChange: (e) => s({
			...o,
			powerOfAttorney: e
		}),
		propertyAddress: c,
		readOnlyName: C,
		readOnly: w,
		validate: T,
		required: E,
		vendorBuyerConfig: g,
		powerOfAttorneyConfig: v,
		displayLegalName: D,
		registeredOwnerNames: k,
		selectedLegalNames: j,
		legalName: I,
		setLegalName: R,
		renderDocumentationUpload: S
	}), n[42] = N, n[43] = D, n[44] = r, n[45] = a, n[46] = I, n[47] = s, n[48] = v, n[49] = c, n[50] = w, n[51] = C, n[52] = k, n[53] = S, n[54] = E, n[55] = j, n[56] = R, n[57] = i, n[58] = T, n[59] = o, n[60] = g, n[61] = U) : U = n[61];
	let W;
	n[62] !== N || n[63] !== _ || n[64] !== D || n[65] !== r || n[66] !== a || n[67] !== I || n[68] !== s || n[69] !== c || n[70] !== w || n[71] !== C || n[72] !== k || n[73] !== E || n[74] !== j || n[75] !== R || n[76] !== i || n[77] !== T || n[78] !== o || n[79] !== g ? (W = N === up.Company && /* @__PURE__ */ m(em, {
		id: `${r}-company`,
		stakeholderType: i,
		index: a,
		value: o.company,
		onChange: (e) => s({
			...o,
			company: e
		}),
		propertyAddress: c,
		readOnlyName: C,
		readOnly: w,
		validate: T,
		required: E,
		vendorBuyerConfig: g,
		companyConfig: _,
		displayLegalName: D,
		registeredOwnerNames: k,
		selectedLegalNames: j,
		legalName: I,
		setLegalName: R
	}), n[62] = N, n[63] = _, n[64] = D, n[65] = r, n[66] = a, n[67] = I, n[68] = s, n[69] = c, n[70] = w, n[71] = C, n[72] = k, n[73] = E, n[74] = j, n[75] = R, n[76] = i, n[77] = T, n[78] = o, n[79] = g, n[80] = W) : W = n[80];
	let G;
	n[81] !== N || n[82] !== D || n[83] !== r || n[84] !== a || n[85] !== I || n[86] !== s || n[87] !== w || n[88] !== C || n[89] !== k || n[90] !== E || n[91] !== j || n[92] !== R || n[93] !== i || n[94] !== T || n[95] !== o || n[96] !== g ? (G = N === up.DeceasedEstate && i === oe.Vendor && /* @__PURE__ */ m(am, {
		id: `${r}-deceased-estate`,
		stakeholderType: i,
		index: a,
		value: o.deceasedEstate,
		onChange: (e) => s({
			...o,
			deceasedEstate: e
		}),
		readOnlyName: C,
		readOnly: w,
		validate: T,
		required: E,
		vendorBuyerConfig: g,
		displayLegalName: D,
		registeredOwnerNames: k,
		selectedLegalNames: j,
		legalName: I,
		setLegalName: R
	}), n[81] = N, n[82] = D, n[83] = r, n[84] = a, n[85] = I, n[86] = s, n[87] = w, n[88] = C, n[89] = k, n[90] = E, n[91] = j, n[92] = R, n[93] = i, n[94] = T, n[95] = o, n[96] = g, n[97] = G) : G = n[97];
	let K;
	return n[98] !== V || n[99] !== H || n[100] !== U || n[101] !== W || n[102] !== G ? (K = /* @__PURE__ */ h($, {
		direction: "vertical",
		gap: "lg",
		fill: !0,
		children: [
			V,
			H,
			U,
			W,
			G
		]
	}), n[98] = V, n[99] = H, n[100] = U, n[101] = W, n[102] = G, n[103] = K) : K = n[103], K;
};
function vm(e, t, n) {
	return n.indexOf(e) === t;
}
function ym(e) {
	return {
		title: gm[e].title,
		xsTitle: gm[e].xsTitle,
		value: e
	};
}
//#endregion
//#region src/formElements/VendorBuyer/VendorBuyers.tsx
var bm = (e) => {
	switch (e) {
		case ue.PowerOfAttorney: return up.PowerOfAttorney;
		case ue.Company: return up.Company;
		case ue.DeceasedEstate: return up.DeceasedEstate;
		case ue.Individual:
		default: return up.Individual;
	}
}, xm = (t) => {
	let n = e(61), { id: r, propertyAddress: i, defaultValue: a, editScope: o, stakeholderType: s, startCollapsed: c, vendorBuyerTypes: l, companyVendorBuyerTypes: u, vendorBuyerConfig: d, companyConfig: f, powerOfAttorneyConfig: p, validate: g, required: _, campaignId: v, agents: y, leadAgentId: b, displayLegalName: x, registeredOwnerNames: S, renderPowerOfAttorneyDocumentationUpload: C, onChange: w } = t, T = o === void 0 ? W.PartialEdit : o, E = s === void 0 ? oe.Vendor : s, D;
	n[0] === l ? D = n[1] : (D = l === void 0 ? [] : l, n[0] = l, n[1] = D);
	let O = D, k;
	n[2] === u ? k = n[3] : (k = u === void 0 ? [] : u, n[2] = u, n[3] = k);
	let A = k, j;
	n[4] === d ? j = n[5] : (j = d === void 0 ? {} : d, n[4] = d, n[5] = j);
	let M = j, N;
	n[6] === f ? N = n[7] : (N = f === void 0 ? {} : f, n[6] = f, n[7] = N);
	let P = N, F;
	n[8] === p ? F = n[9] : (F = p === void 0 ? {} : p, n[8] = p, n[9] = F);
	let I = F, L = g === void 0 ? !1 : g, R = _ === void 0 ? !1 : _, z = x === void 0 ? !1 : x, B;
	n[10] === S ? B = n[11] : (B = S === void 0 ? [] : S, n[10] = S, n[11] = B);
	let V = B, H;
	n[12] !== a || n[13] !== E ? (H = a?.length ? a : [mp(E)], n[12] = a, n[13] = E, n[14] = H) : H = n[14];
	let U = H, G = E === oe.Vendor ? "Vendor" : "Buyer", K = E === oe.Vendor ? "vendor" : "buyer", q = T === W.ReadOnly, J = T !== W.FullEdit, Y;
	n[15] !== G || n[16] !== E ? (Y = (e, t) => {
		let n = e.individual?.name ?? e.powerOfAttorney?.principalName ?? (E === oe.Vendor ? e.deceasedEstate?.name : void 0), r = [
			n?.firstName,
			n?.middleName,
			n?.lastName
		].filter(Sm).join(" "), i = e.company?.companyName ?? r;
		return `${G} ${t + 1}${i ? ` - ${i?.toUpperCase()}` : ""}`;
	}, n[15] = G, n[16] = E, n[17] = Y) : Y = n[17];
	let X = Y, Z;
	n[18] !== r || n[19] !== U || n[20] !== w || n[21] !== E ? (Z = () => {
		w({
			id: r,
			value: [...U, mp(E)]
		});
	}, n[18] = r, n[19] = U, n[20] = w, n[21] = E, n[22] = Z) : Z = n[22];
	let ee = Z, te;
	n[23] !== T || n[24] !== r || n[25] !== U || n[26] !== w ? (te = (e) => {
		T !== W.FullEdit || U?.length <= 1 || w({
			id: r,
			value: U.filter((t, n) => n !== e)
		});
	}, n[23] = T, n[24] = r, n[25] = U, n[26] = w, n[27] = te) : te = n[27];
	let ne = te, re;
	n[28] !== y || n[29] !== v || n[30] !== P || n[31] !== A || n[32] !== z || n[33] !== T || n[34] !== X || n[35] !== ne || n[36] !== r || n[37] !== q || n[38] !== U || n[39] !== b || n[40] !== w || n[41] !== I || n[42] !== i || n[43] !== J || n[44] !== V || n[45] !== C || n[46] !== R || n[47] !== E || n[48] !== c || n[49] !== L || n[50] !== M || n[51] !== O ? (re = U.map((e, t) => {
		let n = T === W.FullEdit && U?.length > 1, a = (e.company ? up.Company : e.powerOfAttorney ? up.PowerOfAttorney : E === oe.Vendor && e.deceasedEstate ? up.DeceasedEstate : up.Individual) === up.Company ? A?.map(bm) : O?.map(bm), o = U.filter((e, n) => n !== t).map((e) => E === oe.Vendor ? e.legalName : void 0).filter(Cm);
		return /* @__PURE__ */ m(ka, {
			title: X(e, t),
			open: !c,
			enableToggle: !0,
			variant: "withDivider",
			iconPosition: "right",
			headerPadding: { bottom: "md" },
			contentPadding: {
				top: "md",
				bottom: "md"
			},
			backgroundColor: "none",
			actionContent: n ? /* @__PURE__ */ m(Kl, {
				id: `${r}-${t + 1}-delete`,
				text: /* @__PURE__ */ m(sa, {}),
				variant: "naked",
				size: "small",
				onClick: () => ne(t)
			}) : void 0,
			dividerContent: /* @__PURE__ */ m(Ja, {
				variant: "horizontal",
				pushMargin: "spacing-5xl"
			}),
			content: /* @__PURE__ */ m(_m, {
				id: `${r}-${t + 1}`,
				stakeholderType: E,
				index: t + 1,
				value: e,
				onChange: (e) => w({
					id: r,
					value: U.map((n, r) => r === t ? e : n)
				}),
				propertyAddress: i,
				visibleTypes: T === W.FullEdit ? a : a ?? [],
				readOnlyName: J,
				readOnly: q,
				validate: L,
				required: R,
				vendorBuyerConfig: M,
				companyConfig: P,
				powerOfAttorneyConfig: I,
				displayLegalName: z,
				registeredOwnerNames: V,
				selectedLegalNames: o,
				campaignId: v,
				agents: y,
				leadAgentId: b,
				renderPowerOfAttorneyDocumentationUpload: C
			})
		}, e.id ?? `${r}-${t}`);
	}), n[28] = y, n[29] = v, n[30] = P, n[31] = A, n[32] = z, n[33] = T, n[34] = X, n[35] = ne, n[36] = r, n[37] = q, n[38] = U, n[39] = b, n[40] = w, n[41] = I, n[42] = i, n[43] = J, n[44] = V, n[45] = C, n[46] = R, n[47] = E, n[48] = c, n[49] = L, n[50] = M, n[51] = O, n[52] = re) : re = n[52];
	let ie;
	n[53] !== T || n[54] !== ee || n[55] !== r || n[56] !== K ? (ie = T === W.FullEdit && /* @__PURE__ */ m(Kl, {
		id: `${r}-add`,
		text: `Add additional ${K}`,
		variant: "primary",
		size: "medium",
		onClick: ee
	}), n[53] = T, n[54] = ee, n[55] = r, n[56] = K, n[57] = ie) : ie = n[57];
	let ae;
	return n[58] !== re || n[59] !== ie ? (ae = /* @__PURE__ */ h($, {
		direction: "vertical",
		fill: !0,
		children: [re, ie]
	}), n[58] = re, n[59] = ie, n[60] = ae) : ae = n[60], ae;
};
function Sm(e) {
	return e;
}
function Cm(e) {
	return !!e;
}
//#endregion
//#region src/formElements/AgreementDetails/types.ts
var wm = /* @__PURE__ */ function(e) {
	return e.Exclusive = "Exclusive", e.Open = "Open", e.Sole = "Sole", e;
}({}), Tm = /* @__PURE__ */ function(e) {
	return e.ThirtyDays = "30", e.SixtyDays = "60", e.NinetyDays = "90", e.OneHundredTwentyDays = "120", e.SpecificDate = "specificDate", e;
}({}), Em = {
	[Tm.ThirtyDays]: 30,
	[Tm.SixtyDays]: 60,
	[Tm.NinetyDays]: 90,
	[Tm.OneHundredTwentyDays]: 120
}, Dm = (e, t) => e.clone().add(t - 1, "days").format(To), Om = (e, t) => {
	if (!e || !t) return;
	let n = t.format(To);
	return Object.entries(Em).find(([, t]) => n === Dm(e, t))?.[0] ?? Tm.SpecificDate;
}, km = (e, t, n, r) => {
	if (e == null || n === wm.Open) return null;
	if (t === Tm.SpecificDate) return r;
	let i = Em[t];
	return i === void 0 ? null : Dm((0, So.default)(e, To), i);
}, Am = (e, t, n) => {
	if (!(!e || !n || !t?.length)) return (0, So.default)(Dm((0, So.default)(n, To), Math.max(...t.map(Number))), To).toDate();
}, jm = (e, t) => {
	let n = t?.map((e) => e.toString()) ?? [], r = [...n, Tm.SpecificDate];
	return e && r.includes(e) ? e : n.includes(Tm.NinetyDays) ? Tm.NinetyDays : n[0] ?? Tm.SpecificDate;
}, Mm = (t) => {
	let n = e(27), { onLengthOfAgreementChange: r, specificDateChange: i, defaultLengthOfAgreement: a, defaultSpecificDate: s, days: c, validate: l, restrictDuration: u, startDate: f } = t, p = a === void 0 ? void 0 : a, h = s === void 0 ? void 0 : s, g;
	n[0] !== c || n[1] !== p ? (g = jm(p, c), n[0] = c, n[1] = p, n[2] = g) : g = n[2];
	let [_, v] = d(g), y, b;
	n[3] !== r || n[4] !== _ ? (y = () => {
		r(_);
	}, b = [r, _], n[3] = r, n[4] = _, n[5] = y, n[6] = b) : (y = n[5], b = n[6]), o(y, b);
	let x;
	n[7] === h ? x = n[8] : (x = Oo(h), n[7] = h, n[8] = x);
	let [S, C] = d(x), w, T;
	n[9] !== S || n[10] !== i ? (w = () => {
		i(S);
	}, T = [S, i], n[9] = S, n[10] = i, n[11] = w, n[12] = T) : (w = n[11], T = n[12]), o(w, T);
	let E;
	if (n[13] !== c) {
		let e;
		n[15] === Symbol.for("react.memo_cache_sentinel") ? (e = {
			label: "Specific end date",
			value: Tm.SpecificDate
		}, n[15] = e) : e = n[15], E = [...c?.map(Nm) ?? [], e], n[13] = c, n[14] = E;
	} else E = n[14];
	let D = E, O;
	n[16] !== c || n[17] !== u || n[18] !== _ || n[19] !== S || n[20] !== f || n[21] !== l ? (O = _ === Tm.SpecificDate ? /* @__PURE__ */ m($, {
		direction: "vertical",
		fill: !0,
		padding: "sm",
		children: /* @__PURE__ */ m(fc, {
			id: "LengthOfAgreementSpecificDate",
			onChange: (e) => C(Oo(e)),
			value: S,
			required: !0,
			noHeader: !0,
			stretch: !0,
			maxDate: Am(u, c, f),
			validate: l,
			errorText: l && (!S || S === "Invalid date") ? "Enter specific end date" : void 0,
			optionalText: ""
		})
	}) : void 0, n[16] = c, n[17] = u, n[18] = _, n[19] = S, n[20] = f, n[21] = l, n[22] = O) : O = n[22];
	let k;
	return n[23] !== D || n[24] !== _ || n[25] !== O ? (k = /* @__PURE__ */ m(bs, {
		id: "agreementLength",
		label: "Length of Appointment",
		layout: "vertical",
		options: D,
		value: _,
		onChange: v,
		subContent: O
	}), n[23] = D, n[24] = _, n[25] = O, n[26] = k) : k = n[26], k;
};
function Nm(e) {
	return {
		label: `${e} days`,
		value: e.toString()
	};
}
//#endregion
//#region src/formElements/AgreementDetails/AgreementDetails.tsx
var Pm = "NSW", Fm = ({ id: e, onValueChanged: t, defaultValue: n, validate: r, state: i, days: a, restrictDuration: s }) => {
	let c = u(t);
	c.current = t;
	let l = i === Pm, f = (n?.startDate ? (0, So.default)(n.startDate) : void 0) ?? (0, So.default)(), [p, h] = d(n?.agreementType ?? wm.Exclusive), [g, _] = d(f.format(To)), v = Om(f, n?.endDate ? (0, So.default)(n.endDate) : void 0), y = a?.map((e) => e.toString()) ?? [], b = v === Tm.SpecificDate || v && y.includes(v) ? v : n?.endDate ? Tm.SpecificDate : void 0, [x, S] = d(b), [C, w] = d(b === Tm.SpecificDate && n?.endDate ? n.endDate : void 0), [T, E] = d(n?.continueToOpenListingOnExpiration ?? !0);
	o(() => {
		c.current({
			id: e,
			value: {
				agreementType: p,
				startDate: (0, So.default)(g, To).format(To),
				endDate: km(g, x, p, C),
				continueToOpenListingOnExpiration: T
			}
		});
	}, [
		x,
		p,
		T,
		e,
		C,
		g
	]);
	let D = g ? (0, So.default)(g, To, !0).isValid() : !1, O = /* @__PURE__ */ m(fc, {
		id: `${e}-agreement-start-date`,
		onChange: (e) => _(Oo(e) ?? ""),
		required: !0,
		label: "Start Date",
		value: g,
		stretch: !0,
		validate: r,
		errorText: r && !D ? "Start Date must be completed" : void 0,
		optionalText: ""
	}, `${e}-agreement-start-date`), k = /* @__PURE__ */ m(Mm, {
		specificDateChange: w,
		onLengthOfAgreementChange: S,
		defaultLengthOfAgreement: x,
		defaultSpecificDate: C,
		days: a,
		validate: r,
		restrictDuration: s,
		startDate: g
	}, `${e}-agreement-length`), A = /* @__PURE__ */ m(os, {
		id: `${e}-continue-open-listing`,
		label: "Continue as an open listing upon expiration",
		onChange: E,
		required: !0,
		checked: T
	}, `${e}-continue-open-listing`), j = [{
		label: wm.Exclusive,
		value: wm.Exclusive
	}, ...l ? [] : [{
		label: wm.Open,
		value: wm.Open
	}, {
		label: wm.Sole,
		value: wm.Sole
	}]], M = p === wm.Exclusive ? [
		O,
		k,
		l ? null : A
	] : p === wm.Open ? [O] : [
		O,
		k,
		A
	];
	return /* @__PURE__ */ m($, {
		direction: "vertical",
		gap: "spacing-lg",
		fill: !0,
		children: /* @__PURE__ */ m(bs, {
			id: `${e}-agreement-type`,
			label: "Agreement Type",
			layout: "vertical",
			options: j,
			value: p,
			onChange: (e) => h(e),
			subContent: !!M && /* @__PURE__ */ m($, {
				fill: !0,
				padding: "md",
				gap: "sm",
				children: M
			})
		})
	});
}, Im = /* @__PURE__ */ function(e) {
	return e.UponSettlement = "UponSettlement", e.OnSpecificDate = "OnSpecificDate", e.NoSignboardInstalled = "NoSignboardInstalled", e;
}({}), Lm = [
	{
		label: "Upon settlement",
		value: Im.UponSettlement
	},
	{
		label: "On specific date",
		value: Im.OnSpecificDate
	},
	{
		label: "No signboard installed",
		value: Im.NoSignboardInstalled
	}
], Rm = ({ id: e, onValueChanged: t, defaultValue: n, validate: r }) => {
	let i = u(t);
	i.current = t;
	let [a, s] = d({
		removalType: n?.removalType ?? Im.UponSettlement,
		...n?.removalType === Im.OnSpecificDate ? { specificDate: n.specificDate } : {}
	}), { removalType: c, specificDate: l } = a;
	return o(() => {
		i.current({
			id: e,
			value: a
		});
	}, [e, a]), /* @__PURE__ */ m(bs, {
		id: e,
		label: "When would you like the signboard removed?",
		layout: "vertical",
		options: Lm,
		value: c,
		onChange: (e) => {
			let t = e;
			s((e) => t === Im.OnSpecificDate ? {
				removalType: t,
				specificDate: e.specificDate
			} : { removalType: t });
		},
		subContent: c === Im.OnSpecificDate ? /* @__PURE__ */ m($, {
			direction: "vertical",
			padding: "md",
			fill: !0,
			children: /* @__PURE__ */ m(fc, {
				id: `${e}-specificDate`,
				required: !0,
				validate: r,
				onChange: (e) => s((t) => ({
					...t,
					specificDate: Oo(e)
				})),
				noHeader: !0,
				value: l,
				errorText: r && !l ? "Enter a date" : void 0
			})
		}) : void 0
	});
};
//#endregion
export { Tm as AgreementLength, wm as AgreementType, Fm as AgxAgreementDetails, ba as AgxAlerts, rc as AgxAlternateAddressSearch, Zf as AgxAuctionDetails, Xs as AgxAutoCompleteAddressSearch, Go as AgxAvatar, Bo as AgxAvatarGroup, Yo as AgxAvatarLabelGroup, _o as AgxBadge, Kl as AgxButton, os as AgxCheckbox, _s as AgxCheckboxGroup, ka as AgxCollapsible, Me as AgxColumn, md as AgxCommissionHistoryView, td as AgxCommissionPlan, xd as AgxCommissionSplit, ld as AgxCommissionTableView, Kc as AgxConditionalTextInput, pd as AgxCurrentCommissionView, _d as AgxCurrentServiceFeeView, hf as AgxCustomSpecialCondition, fc as AgxDatePicker, hc as AgxDateRangeSelector, Ja as AgxDivider, Ec as AgxDropdown, ao as AgxEmptyState, Su as AgxEntityStatistics, Fu as AgxErrorLabel, Xo as AgxExpandableText, kd as AgxExternalConjunction, xl as AgxGlobalSearch, qn as AgxGlyph, Ci as AgxIconTask, Oc as AgxImageUploader, Bf as AgxLaunchDateDetails, Td as AgxLegalDescription, Tl as AgxLegalName, Mm as AgxLengthOfAgreement, Mm as LengthOfAgreement, Eu as AgxLoadingState, Cu as AgxMetric, Ya as AgxModal, wl as AgxName, Ol as AgxNotes, Mo as AgxNotificationBox, jf as AgxOnOrDaysFrom, $f as AgxOwnershipStructure, du as AgxPartnershipIndicator, Xa as AgxPortal, Re as AgxProgressBar, Tu as AgxProgressChart, lp as AgxPropertyAttributes, vs as AgxRadioButton, bs as AgxRadioGroup, Ne as AgxRow, Cf as AgxSatisfactionOfSpecialCondition, Xl as AgxSaveChangesButton, Ql as AgxSegmentPicker, Xc as AgxSelectChip, vd as AgxServiceFeeHistoryView, ud as AgxServiceFeeTableView, Rm as AgxSignboardRemoval, $ as AgxSpacer, vf as AgxSpecialConditionsPicker, ha as AgxStepsIndicator, dd as AgxSubmissionDetail, Wl as AgxTab, to as AgxTable, jo as AgxTag, Ao as AgxTaskCard, Hc as AgxTextArea, qs as AgxTextInput, zc as AgxTimePicker, Lo as AgxToasts, al as AgxToggleSwitch, Ul as AgxTooltip, Q as AgxTypography, xm as AgxVendorBuyers, Vc as AgxYesNoQuestion, ja as BreakpointOrder, Aa as Breakpoints, Ou as CommissionTypes, Of as ContractDateType, To as DATE_ONLY_FORMAT, U as EditScope, xi as IconTaskTypes, Ti as Icon_AlertCircle, ki as Icon_AlertCircleOutline, Wi as Icon_Arrow, da as Icon_Bath, ua as Icon_Bed, qi as Icon_CalendarOutline, fa as Icon_Car, Bi as Icon_CheckmarkCircleOutline, Vi as Icon_CheckmarkCircleOutlineBig, Ki as Icon_CheckmarkOutline, Ei as Icon_Chevron, ia as Icon_Clock, Xi as Icon_CloseCircle, ea as Icon_CloseCircleOutline, Gi as Icon_CloseOutline, Ii as Icon_Converted, na as Icon_DashedLine, Oi as Icon_Delete, Ji as Icon_Dollar, Fi as Icon_Edit2Outline, Pi as Icon_EditOutline, Ni as Icon_Email, wi as Icon_FeaturedIcon, la as Icon_FileTextOutline, Qi as Icon_GridOutline, ca as Icon_HomeOutline, ma as Icon_InternalArea, pa as Icon_LandSizeOutline, Zi as Icon_Link, ta as Icon_LoaderOutline, Di as Icon_MagnifyingGlass, ra as Icon_MapPin, Ri as Icon_Navigation2Outline, Li as Icon_Obtained, Ui as Icon_PartnershipLevel, Ui as Icon_PartnershipLevelIcon, Yi as Icon_Percentage, aa as Icon_PersonOutline, oa as Icon_Pin, $i as Icon_PlusCircleOutline, Mi as Icon_PlusOutline, ji as Icon_Refresh, zi as Icon_Stars, sa as Icon_TrashOutline, Ai as Icon_Upload, tp as PropertyAttributeField, ep as PropertyType, Qf as RegisteredOwnerType, Hl as RenderAnimation, Il as RenderAnimationType, Yl as SAVE_BUTTON_STATES, sl as SearchResultType, Im as SignboardRemovalType, Jl as Spinner, ae as StakeholderType, No as ToastContext, le as VendorBuyerType, Bc as YesNo, mo as applyTheme, Ba as cleanFullAddress, za as formatAddressObject, Ra as formatAddressWithLongStreetName, Ss as formatCurrency, Do as formatDate, Oo as formatDateOnly, Du as formatName, La as formattedAddressWithoutCountry, Eo as getDateStatus, ko as getDateString, io as toRowData, Cs as trimValue, Ia as useGetUserInformation, qa as useGoogleMapsPlacesSearch, Ro as useToast, Na as useWindowSize };
